webpackJsonp([0],Array(109).concat([
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/module-name */
angular.module('zc.agencies', ['ngResource', 'zc.commonApi', 'zc.core', 'zc.projects']);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* globals h337 */


var _d = __webpack_require__(301);

var d3 = _interopRequireWildcard(_d);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Heatmap = function () {
  function Heatmap(element, Services, showLayers, filters) {
    _classCallCheck(this, Heatmap);

    this.element = element;
    this.Services = Services;
    this.projectId = 1109;
    this.url = 'http://www.mtgec.jp/shop/default.aspx';
    this.heatmapScroll = undefined;
    this.heatmapClicks = undefined;
    this.heatmapMovements = undefined;
    this.currentScroll = 0;
    this.windowWidth = $(document).width(); // eslint-disable-line
    this.showLayers = showLayers;
    this.filters = filters;

    this.initialize();
  }

  _createClass(Heatmap, [{
    key: 'initialize',
    value: function initialize() {
      var _this = this;

      var container = this.element;
      var scrollContainer = $(this.element).parent().find('.heatmap-scroll-container');

      // const $iframeContainer = $('<div class="iframe-container"></div>');
      // const $iframe = $(`<iframe src="${this.url}" scrolling="no"></iframe>`);
      // $($iframeContainer).append($iframe);
      // $(container).prepend($iframeContainer);
      // this.$iframe = $iframe;
      // this.$iframeContainer = $iframeContainer;

      var heatmapScroll = h337.create({
        container: scrollContainer[0]
      });
      this.heatmapScroll = heatmapScroll;
      scrollContainer.css('position', 'absolute');

      var heatmapClicks = h337.create({
        container: container,
        onExtremaChange: function onExtremaChange(changes) {
          _this.updateControls(changes);
        }
      });
      this.heatmapClicks = heatmapClicks;

      function handleError(a, b, error) {
        console.error(a, b, error);
      }

      var urls = {
        // heatmap: '/assets/mtgec-heatmap.json',
        // maxScrollmap: '/assets/mtgec-max-scrollmap.json',
        // scrollmap: '/assets/mtgec-scrollmap.json',
        heatmap: 'https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtgec-heatmap.json',
        maxScrollmap: 'https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtgec-max-scrollmap.json',
        scrollmap: 'https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtgec-scrollmap.json'
      };

      // TODO: change this url to come from S3 or so
      $.getJSON(urls.heatmap, {}).error(handleError).success(function (heatmap) {
        _this.heatmap = heatmap;
        _.each(_this.heatmap, function (d) {
          d.x = d.x + _this.windowWidth / 2;
        });

        // $.getJSON('/assets/mtgec-scrollmap.json', {})
        // .error(handleError)
        // .success(scrollmap => {
        //   this.scrollmap = scrollmap;

        $.getJSON(urls.maxScrollmap, {}).error(handleError).success(function (maxScrollmap) {
          _this.maxScrollmap = maxScrollmap;
          var uniqSessions = _.uniq(_.map(_this.heatmap, '_usid'));
          _this.uniqSessions = uniqSessions;
          console.log('heatmap length: ', _this.heatmap.length, 'uniq: ', uniqSessions.length);

          //.text(`${uniqSessions}セッションのデータを表示してます`);
          $(_this.element).find('canvas').css({ opacity: 0.9 });
          _this.createHeatmap();
        });
        // });
      });
    }
  }, {
    key: 'updateControls',
    value: function updateControls(changes) {
      var $controls = $(this.element).parent().find('.controls');
      $controls.html('');

      var createdAts = _.map(this.currentHeatmapData, function (d) {
        return moment(d.created_at).toDate();
      });
      var min = moment(_.min(createdAts)).format('YYYY-MM-DD');
      var max = moment(_.max(createdAts)).format('YYYY-MM-DD');

      $controls.append($('\n      <div>\n      \u671F\u9593\uFF1A' + min + ' ~ ' + max + '\n      </div>'));

      $controls.append('<div class="how-many"></div>');
      $controls.find('.how-many').text(this.uniqSessions.length + '\u306EPC\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u3046\u3061\u306E\u6CE8\u76EE\u5EA6');
      _.each([1, 0.85, 0.55, 0.25], function (k) {
        var clicks = Math.round(k * 100 / 15);
        $controls.append($('\n        <div>\n          <span style="opacity: 0.8; margin-right: 10px; background-color: ' + changes.gradient[k] + '; display: inline-block; width: 15px; height: 15px;"></span>\n          ' + clicks + '%\n        </div>'));
      });
    }
  }, {
    key: 'redraw',
    value: function redraw() {
      this.createHeatmap();
    }
  }, {
    key: 'createScrollPercentages',
    value: function createScrollPercentages() {
      d3.select(this.element).selectAll('div.scroll-percentage').data(this.maxScrollmap).enter().append('div').attr('class', 'scroll-percentage').text(function (d) {
        return Math.round(d.value * 100) + '%';
      }).style('position', 'absolute').style('color', 'black').style('top', function (d) {
        return d.y + 'px';
      }).style('left', '170px');
    }
  }, {
    key: 'createHeatmap',
    value: function createHeatmap(type) {
      var _this2 = this;

      var heatmapData = _.chain(this.heatmap).reject(function (d) {
        if (!_this2.showLayers.clicks) {
          return d.is_click;
        }
        return false;
      }).reject(function (d) {
        if (!_this2.showLayers.mouseMovement) {
          return !d.is_click;
        }
        return false;
      }).filter(function (d) {
        if (_this2.filters.convertedUsers) {
          return d.cv_user;
        }
        return true;
      }).filter(function (d) {
        if (_this2.filters.newUsers) {
          return d.segment_new;
        }
        return true;
      }).value();
      this.currentHeatmapData = heatmapData;

      var uniqSessions = _.uniq(_.map(this.currentHeatmapData, '_usid'));
      this.uniqSessions = uniqSessions;

      // this.heatmapClicks.clear();
      this.heatmapClicks.setData({
        max: this.uniqSessions.length / 15,
        data: heatmapData
      });

      this.heatmapScroll.setData({
        max: 2,
        data: this.maxScrollmap
      });

      this.createScrollPercentages();
    }
  }]);

  return Heatmap;
}();

exports.default = Heatmap;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/module-name */
angular.module('zc.projects.heatmap', ['ngResource', 'zc.commonApi', 'zc.core', 'zc.projects']);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/module-name,angular/file-name */
angular.module('zc.master.zcliteAgencyInvoices', ['zc.master']);

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: move this file to common api!
angular.module('zc.commonApi').factory('Agency', Agency);

Agency.$inject = ['$q', 'Api'];
function Agency($q, Api) {
  var service = {
    all: all,
    get: get,
    update: update,
    getAgencyColor: getAgencyColor,
    getAgencyName: getAgencyName
  };

  return service;

  function all() {
    return Api.get('/api/agencies', {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.agencies;
    });
  }

  function get(name) {
    return Api.get('/api/agencies/' + name, {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.agency;
    });
  }

  function update(params) {
    return Api.patch('/api/agencies/name:' + params.name, params, { cache: false });
  }

  function getAgencyColor(id) {
    return 'list-item-avatar' + id % 15;
  }

  function getAgencyName(agencyName) {
    return agencyName;
  }
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('DashboardChartPositions', DashboardChartPositions);

DashboardChartPositions.$inject = ['$q', '$state', 'Api'];
function DashboardChartPositions($q, $state, Api) {
  var projectId = $state.params.projectId;

  var API_URL = '/api/projects/' + projectId + '/dashboard_chart_positions';
  return {
    create: create,
    get: get,
    update: update
  };

  function get() {
    return Api.get(API_URL, {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data;
    });
  }

  function create(positions) {
    return Api.post(API_URL, { positions: positions }, { cache: false });
  }

  function update(positions) {
    return Api.patch(API_URL, { positions: positions }, { cache: false });
  }
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-undef */
// import { ApolloClient } from 'apollo-client';
// import { ApolloLink } from 'apollo-link';
// import { onError } from 'apollo-link-error';
// import { HttpLink } from 'apollo-link-http';
// import { InMemoryCache } from 'apollo-cache-inmemory';

// const ApolloClient = require('apollo-client');
// const ApolloLink = require('apollo-link');
// const ApolloOnError = require('apollo-link-error');
// const HttpLink = require('apollo-link-http');
// const InMemoryCache = require('apollo-cache-inmemory');

var ApolloClient = __webpack_require__(561).ApolloClient;
var ApolloLink = __webpack_require__(37).ApolloLink;
var ApolloOnError = __webpack_require__(565).onError;
var HttpLink = __webpack_require__(568).HttpLink;
var InMemoryCache = __webpack_require__(554).InMemoryCache;
var setContext = __webpack_require__(463).setContext;

angular.module('zc.commonApi').factory('Apollo', Apollo);

Apollo.$inject = ['$q', 'Devise'];
function Apollo($q, Devise) {
  var service = {
    query: query,
    masterQuery: masterQuery,
    mutate: mutate
  };

  function createGraphQLClientForUrl(uri) {
    var httpLink = new HttpLink({
      uri: uri,
      batchInterval: 5,
      batchMax: 5,
      credentials: 'same-origin',
      mode: 'cors'
    });

    var authLink = setContext(function () {
      return Devise.getCurrentUser().then(function () {
        if (!Devise.currentUser) return;

        return {
          headers: {
            'X-LOGIN-TOKEN': Devise.currentUser.login_token
          }
        };
      });
    });

    var errorLink = ApolloOnError(function (_ref) {
      var graphQLErrors = _ref.graphQLErrors,
          networkError = _ref.networkError;

      if (graphQLErrors) {
        graphQLErrors.map(function (_ref2) {
          var message = _ref2.message,
              locations = _ref2.locations,
              path = _ref2.path;

          alertify.error(message, 0);
          // eslint-disable-next-line
          console.error('[GraphQL error]: Message: ' + message + ', Location: ' + JSON.stringify(locations, null, 2) + ', Path: ' + path);
          return null;
        });
      }

      if (networkError) {
        // eslint-disable-next-line
        console.error('[Network error]: ' + networkError);
      }
    });

    var link = ApolloLink.from([authLink, errorLink, httpLink]);

    // Create the apollo client
    var apolloClient = new ApolloClient({
      link: link,
      cache: new InMemoryCache(),
      connectToDevTools: true
    });
    return apolloClient;
  }

  var apolloClient = createGraphQLClientForUrl(ZC_CONFIG.GRAPHQL_URL_APP);
  var masterApolloClient = createGraphQLClientForUrl(ZC_CONFIG.GRAPHQL_URL_MASTER);

  return service;

  function query(_query, _variables) {
    var q = { query: _query };
    if (_variables) {
      q.variables = _variables;
    }

    return $q(function (resolve, reject) {
      apolloClient.query(q).then(function (res) {
        return void resolve(res.data);
      }).catch(function (error) {
        return void reject(error);
      });
    });
  }

  function masterQuery(_query, _variables) {
    return $q(function (resolve, reject) {
      if (Devise.isCommonUser()) return resolve(null);

      var q = { query: _query };
      if (_variables) {
        q.variables = _variables;
      }

      masterApolloClient.query(q).then(function (res) {
        return void resolve(res.data);
      }).catch(function (error) {
        return void reject(error);
      });
    });
  }

  function mutate(mutationOptions) {
    return $q(function (resolve, reject) {
      apolloClient.mutate(mutationOptions).then(function (res) {
        return void resolve(res.data);
      }).catch(function (error) {
        return void reject(error);
      });
    });
  }
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.commonApi').factory('CampaignConversionData', campaignConversionDataFactory);

function campaignConversionDataFactory(FacadeV2) {
  return function () {
    function CampaignConversionData() {
      _classCallCheck(this, CampaignConversionData);
    }

    _createClass(CampaignConversionData, null, [{
      key: 'find',
      value: function find(paths, params) {
        return FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_conversion_data/find', { params: params }).then(function (res) {
          return res.data;
        });
      }
    }]);

    return CampaignConversionData;
  }();
}
campaignConversionDataFactory.$inject = ['FacadeV2'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('CampaignSegmentStats', CampaignSegmentStatsService);

CampaignSegmentStatsService.$inject = ['$q', 'FacadeV2'];
function CampaignSegmentStatsService($q, FacadeV2) {
  return {
    find: find,
    aggregate: aggregate
  };

  function find() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg = 'No dimension';
        console.error(_errorMsg);
        return reject(_errorMsg);
      }

      return FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_segment_stats/' + paths.dimension + '/find', {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign segment stats'));
        } else {
          resolve(transformData(res.data));
        }
      });
    });
  }

  function aggregate() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg2 = 'No dimension';
        console.error(_errorMsg2);
        return reject(_errorMsg2);
      }

      return FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_segment_stats/' + paths.dimension + '/aggregate', {
        params: {
          match: query.match,
          pipeline: query.pipeline
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign segment stats'));
        } else {
          resolve(res.data);
        }
      });
    });
  }

  function transformData(campaignSegmentStats) {
    _.each(campaignSegmentStats, function (stats) {
      if (stats.start_at) {
        stats.start_at = new Date(stats.start_at).valueOf();
      }
      if (stats.end_at) {
        stats.end_at = new Date(stats.end_at).valueOf();
      }
    });
    return _.sortBy(campaignSegmentStats, function (stats) {
      return stats.start_at;
    });
  }
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('CampaignStatsV2', CampaignStatsV2Service);

CampaignStatsV2Service.$inject = ['$q', 'FacadeV2'];
function CampaignStatsV2Service($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg = 'No dimension';
        console.error(_errorMsg);
        return reject(_errorMsg);
      }

      var promise = FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_stats/' + paths.dimension + '/find', {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign stats'));
        } else {
          resolve(res.data);
        }
      });

      return promise;
    });
  }
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('InterestWidgetItem', InterestWidgetItem);

var ITEM_COUNT_THRESHOLD = 5;
var ITEM_AGGREGATION_LIMIT = 5000;

InterestWidgetItem.$inject = ['FacadeV2'];
function InterestWidgetItem(FacadeV2) {
  return { aggregate: aggregate, aggregateByFilters: aggregateByFilters, rankByFilters: rankByFilters };

  function aggregate(paths, params) {
    return FacadeV2.request('/apikeys/' + paths.apikey + '/interest_widget_items/daily/aggregate', { params: params }).then(function (res) {
      return res.data;
    });
  }

  function aggregateByFilters(apikey, filters, pipeline) {
    return aggregate({ apikey: apikey }, {
      match: {
        device: filters.device,
        campaign_segment_id: filters.campaign_segment_id,
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).endOf('day').toDate()
        }
      },
      pipeline: pipeline,
      limit: ITEM_AGGREGATION_LIMIT
    });
  }

  function rankByFilters(apikey, filters) {
    return aggregateByFilters(apikey, filters, [{
      $group: {
        _id: '$url',
        thumbnail_url: { $last: '$thumbnail_url' },
        title: { $last: '$title' },
        price: { $last: '$price' },
        item_count: { $sum: '$item_count' },
        iw_item_count: { $sum: '$iw_item_count' }
      }
    }, {
      $match: {
        item_count: { $gte: ITEM_COUNT_THRESHOLD }
      }
    }, {
      $project: {
        _id: 0,
        url: '$_id',
        thumbnail_url: 1,
        title: 1,
        price: 1,
        item_count: 1,
        iw_item_count: 1,
        iw_item_rate: { $divide: ['$iw_item_count', '$item_count'] }
      }
    }, {
      $sort: {
        iw_item_rate: -1,
        item_count: -1
      }
    }]);
  }
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('InterestWidgetStats', InterestWidgetStats);

var FIELD_NAMES = ['all', 'iw_click_item', 'iw_started', 'iw_use', 'no_iw_use'];

InterestWidgetStats.$inject = ['FacadeV2', 'lib'];
function InterestWidgetStats(FacadeV2, lib) {
  return { find: find, findByFilters: findByFilters, transform: transform };

  function find(paths, params) {
    return FacadeV2.request('/apikeys/' + paths.apikey + '/interest_widget_stats/daily/find', { params: params }).then(function (res) {
      return res.data;
    }).then(function (stats) {
      return _sumByStartAt(stats);
    });
  }

  function findByFilters(apikey, filters) {
    return find({ apikey: apikey }, {
      match: {
        device: filters.device,
        campaign_segment_id: null,
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).endOf('day').toDate()
        }
      }
    });
  }

  function transform(stat) {
    if (_.keys(stat).length === 0) return stat;
    FIELD_NAMES.forEach(function (fieldName) {
      var field = stat[fieldName];
      if (field.session_count !== 0) {
        field.conversion_rate = field.conversion_count / field.session_count * 100;
        field.cart_button_click_rate = field.cart_button_click_count / field.session_count * 100;
        field.nocv_session_rate = field.nocv_session_count / field.session_count * 100;
        field.onecv_session_rate = field.onecv_session_count / field.session_count * 100;
        field.loyal_session_rate = field.loyal_session_count / field.session_count * 100;
        field.average_item_count = field.item_count / field.session_count;
      } else {
        field.conversion_rate = field.cart_button_click_rate = field.nocv_session_rate = field.onecv_session_rate = field.loyal_session_rate = field.average_item_count = 0;
      }
      field.average_conversion_price = field.conversion_count !== 0 ? field.conversion_price / field.conversion_count : 0;
      field.conversion_price_with_campaign_rate = field.conversion_price !== 0 ? field.conversion_price_with_campaign / field.conversion_price * 100 : 0;
      field.utm_medium_rate_map = {};
      _.keys(field.utm_medium_count_map).forEach(function (key) {
        field.utm_medium_rate_map[key] = field.session_count !== 0 ? field.utm_medium_count_map[key] / field.session_count * 100 : 0;
      });
    });
    stat.sales_rate = stat.all.conversion_price !== 0 ? stat.iw_click_item.conversion_price / stat.all.conversion_price * 100 : 0;
    stat.iw_started_rate = stat.all.session_count !== 0 ? stat.iw_started.session_count / stat.all.session_count * 100 : 0;
    stat.iw_use_rate = stat.iw_started.session_count !== 0 ? stat.iw_use.session_count / stat.iw_started.session_count * 100 : 0;
    stat.conversion_up_rate = stat.no_iw_use.conversion_rate !== 0 ? stat.iw_use.conversion_rate / stat.no_iw_use.conversion_rate * 100 : 0;
    return stat;
  }

  // NOTE:
  // combine the counts per day
  // because there might be results for multiple devices per day (PC+tablet)
  function _sumByStartAt(stats) {
    return _.chain(stats).groupBy('start_at').map(function (val) {
      return lib.sumCountMap(val);
    }).value();
  }
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('MongoCampaignInterestWidgetStatsWithoutBounces', MongoCampaignInterestWidgetStatsWithoutBounces);

MongoCampaignInterestWidgetStatsWithoutBounces.$inject = ['$q', 'FacadeV2'];
function MongoCampaignInterestWidgetStatsWithoutBounces($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find(paths) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!paths.apikey) {
      console.error('No apikey in query');
      return $q.reject('No apikey in query');
    }

    if (!paths.dimension) {
      console.error('No dimension defined');
      return $q.reject('No dimension defined');
    }

    if (!query.start_at) {
      console.error('No start_at in query');
      return $q.reject('No start_at in query');
    }

    var promise = FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_interest_widget_stats_without_bounces/' + paths.dimension + '/find', {
      params: {
        match: query,
        sort: options.sort,
        limit: options.limit || 1000
      }
    }).then(function (res) {
      if (res.status !== 200 || res.data.error) {
        $q.reject(res.data.error);
      } else {
        return res.data;
      }
    });

    return promise;
  }
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.commonApi').factory('ZcsCampaignStats', ZcsCampaignStats);

ZcsCampaignStats.$inject = ['$q', 'FacadeV2'];
function ZcsCampaignStats($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg = 'No dimension';
        console.error(_errorMsg);
        return reject(_errorMsg);
      }

      var promise = FacadeV2.request('/apikeys/' + paths.apikey + '/zcs_campaign_stats/' + paths.dimension + '/find', {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching zcs campaign stats'));
        } else {
          resolve(res.data);
        }
      });

      return promise;
    });
  }
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').filter('overallCampaignCvrIncreaseRate', function () {
  return function (campaigns, includeHiddenAb) {
    campaigns = _.filter(campaigns, function (campaign) {
      return (!campaign.is_secret_ab || includeHiddenAb) && !campaign.is_information_campaign && !!campaign.campaign_control_percent;
    });

    var totalExperimentalConversionCount = _.sumBy(campaigns, 'stats.experimental.conversion_count');
    var weightedDenominator = _.sumBy(campaigns, function (campaign) {
      var experimentalDeliveryCount = _.get(campaign, 'stats.experimental.delivery_count', 0);
      var controlConversionCount = _.get(campaign, 'stats.control.conversion_count', 0);
      var controlDeliveryCount = _.get(campaign, 'stats.control.delivery_count', 0);
      var controlCVR = controlDeliveryCount === 0 ? 0 : controlConversionCount / controlDeliveryCount;
      return experimentalDeliveryCount * controlCVR;
    });

    if (weightedDenominator === 0) return null;

    return totalExperimentalConversionCount / weightedDenominator;
  };
});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('Services', Services);

Services.$inject = ['$q', 'AccessStats', 'Campaign', 'MongoHistory', 'MongoRaw', 'MongoSession', 'Project', 'Report'];
function Services($q, AccessStats, Campaign, MongoHistory, MongoRaw, MongoSession, Project, Report) {
  var service = {
    $q: $q,
    AccessStats: AccessStats,
    Campaign: Campaign,
    MongoHistory: MongoHistory,
    MongoRaw: MongoRaw,
    MongoSession: MongoSession,
    Project: Project,
    Report: Report
  };

  return service;
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcApiPublicFileDownloader', {
  templateUrl: '/templates/core/components/api_public_file_downloader/api_public_file_downloader.html',
  bindings: {
    text: '=',
    filepath: '='
  },
  controller: clearanceSampleSetDownloader,
  controllerAs: 'vm'
});

clearanceSampleSetDownloader.$inject = ['Api'];
function clearanceSampleSetDownloader(Api) {
  var _this = this;

  var vm = this;

  vm.$onInit = function () {
    vm.text = _this.text;
    vm.href = Api.path(_this.filepath);
  };
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcBillingRepresentatives', {
  templateUrl: '/templates/core/components/billing_representatives/billing_representatives.html',
  bindings: {
    representatives: '='
  },
  controller: billingRepresentatives,
  controllerAs: 'vm'
});

billingRepresentatives.$inject = ['Devise'];
function billingRepresentatives(Devise) {
  var vm = this;
  var REPRESENTATIVE_LIMIT = 5;
  var REPRESENTATIVE_FIELDS = ['full_name', 'email'];

  function isRepresentativesObjectCompletelyEmpty() {
    // has more than one representative field
    if (vm.representatives.length > 1) {
      return false;
    }

    var theOnlyRepresentative = vm.representatives[0];
    var isAllFieldsEmpty = !_.some(theOnlyRepresentative);
    return isAllFieldsEmpty;
  }

  function isRepresentativeLimitReached() {
    return vm.representatives.length >= REPRESENTATIVE_LIMIT;
  }

  function addNewRepresentative(representativeIndex) {
    if (isRepresentativeLimitReached()) {
      return;
    }

    vm.representatives.push(_.zipObject(REPRESENTATIVE_FIELDS));
  }

  function removeRepresentative(representativeIndex) {
    var representative = vm.representatives[representativeIndex];
    if (!representative) {
      return;
    }

    if (vm.representatives.length === 1) {
      vm.representatives = [_.zipObject(REPRESENTATIVE_FIELDS)];
      return;
    }

    vm.representatives.splice(representativeIndex, 1);
  }

  vm.$onInit = function () {
    // Create empty representative object array
    // from representative fields if there's no representatives
    if (!vm.representatives || vm.representatives.length === 0) {
      vm.representatives = [_.zipObject(REPRESENTATIVE_FIELDS)];
    }

    vm.isRepresentativesObjectCompletelyEmpty = isRepresentativesObjectCompletelyEmpty;
    vm.isRepresentativeLimitReached = isRepresentativeLimitReached;
    vm.addNewRepresentative = addNewRepresentative;
    vm.removeRepresentative = removeRepresentative;
  };
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcIncreaseOrDecreasePercentage', {
  templateUrl: '/templates/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html',
  bindings: {
    from: '<',
    to: '<'
  },
  controller: IncreaseOrDecreasePercentageController
});

IncreaseOrDecreasePercentageController.$inject = ['$filter'];
function IncreaseOrDecreasePercentageController($filter) {
  var vm = this;

  vm.$onInit = function () {
    vm.percentage = null;
    vm.showValue = null;
    showValue();
  };

  function showValue() {
    if (!vm.from) {
      vm.percentage = null;
      vm.showValue = null;
      return;
    }
    vm.percentage = (vm.to / vm.from - 1) * 100;
    if (vm.percentage === 0) {
      vm.showValue = '±0';
    } else if (vm.percentage > 0) {
      vm.showValue = '+' + $filter('number')(vm.percentage, 0) + '%';
    } else {
      vm.showValue = '-' + $filter('number')(-vm.percentage, 0) + '%';
    }
  }
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcMonthChooser', {
  // <zc-month-chooser> assumes that the month is handled by $stateParams
  // and the state parameter's format should be 'YYYY-MM'
  templateUrl: '/templates/core/components/month_chooser/month_chooser.html',
  bindings: {
    // stateParam can be used to overwrite which $stateParam is used.
    // Default value is 'month'
    stateParam: '@',
    // minDate should be date and can be any day of month.
    // If it's for example 2016-09-15, 2016-09 will be allowed month
    minDate: '<'
  },
  controller: monthChooserController
});

monthChooserController.$inject = ['$location', '$state', '$stateParams'];
function monthChooserController($location, $state, $stateParams) {
  var vm = this;
  var currentState = $state.current.name;

  // variables
  vm.$state = $state;

  // actions
  vm.goToNext = goToNext;
  vm.goToPrev = goToPrev;

  this.$onInit = function () {
    vm.currentMonth = moment(getStateParam(), 'YYYY-MM').toDate();

    if (nextMonthExists()) {
      vm.nextMonth = moment(getStateParam(), 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    } else {
      vm.nextMonth = null;
    }

    if (prevMonthExists()) {
      vm.prevMonth = moment(getStateParam(), 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
    } else {
      vm.prevMonth = null;
    }
  };

  function goToNext() {
    if (nextMonthExists()) {
      $state.go(currentState, getNextMonthParams());
    }
  }

  function goToPrev() {
    if (prevMonthExists()) {
      $state.go(currentState, getPrevMonthParams());
    }
  }

  function nextMonthExists() {
    var currentParamMonth = moment(getStateParam(), 'YYYY-MM').startOf('month');
    var currentMonth = moment().startOf('month');
    if (moment(currentParamMonth).isAfter(currentMonth) || moment(currentParamMonth).isSame(currentMonth)) {
      return false;
    }
    return true;
  }

  function prevMonthExists() {
    if (!vm.minDate) return true;

    var currentParamMonth = moment(getStateParam(), 'YYYY-MM').startOf('month');
    var minMonth = moment(vm.minDate).startOf('month');
    if (moment(currentParamMonth).isBefore(minMonth) || moment(currentParamMonth).isSame(minMonth)) {
      return false;
    }
    return true;
  }

  function getNextMonthParams() {
    var newParams = {};
    newParams[getParamName()] = vm.nextMonth;
    return _.merge({}, $stateParams, newParams);
  }

  function getPrevMonthParams() {
    var newParams = {};
    newParams[getParamName()] = vm.prevMonth;
    return _.merge({}, $stateParams, newParams);
  }

  function getParamName() {
    return vm.stateParam || 'month';
  }

  function getStateParam() {
    return $stateParams[getParamName()];
  }
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcSessionPredictionDistribution', {
  templateUrl: '/templates/core/components/session_prediction_distribution/session_prediction_distribution.html',
  bindings: {
    campaign: '<',
    sessions: '<',
    disabled: '<',
    field: '@'
  },
  controller: sessionPredictionDistributionController
});

sessionPredictionDistributionController.$inject = ['$rootScope', '$scope', '$translate', 'ChartV2', 'columnChartV2Config'];
function sessionPredictionDistributionController($rootScope, $scope, $translate, ChartV2, columnChartV2Config) {
  var vm = this;

  var RANDOM_DIGIT = 10;
  var MIN = 0;
  var MAX = 100;
  var STEP = 1;
  var PLOT_BANDS_COLOR = 'rgba(68, 170, 213, .2)';

  var ranges = _.range(MIN, MAX, STEP);
  var chart = new ChartV2(columnChartV2Config, {
    xAxis: {
      categories: getCategories(),
      labels: { enabled: false },
      tickLength: 0,
      crosshair: true
    },
    yAxis: {
      min: 0,
      labels: { enabled: false }
    },
    options: {
      plotOptions: {
        column: { stacking: 'normal' }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1,
        shared: true
      }
    }
  });

  var deregisterStateChangeStart = void 0;

  vm.$onInit = function () {
    if (vm.field === 'predictions_max_before_cart.global_conversion_rate') {
      vm.threshold = 'predictions_max_threshold';
    } else {
      vm.threshold = 'predictions_min_threshold';
    }
    vm.chartConfig = chart.getConfig();
    vm.sliderConfig = {
      floor: MIN,
      ceil: MAX,
      step: STEP,
      disabled: vm.disabled,
      showSelectionBar: true,
      translate: function translate(value) {
        return value + '%';
      }
    };
    vm.modalId = 'modal-' + Math.floor(Math.random() * RANDOM_DIGIT);
    vm.resizeFull = resizeFull;
    vm.resizeSmall = resizeSmall;
    plotBands(vm.campaign[vm.threshold]);
    $scope.$watch('$ctrl.sessions', addSeries);
    $scope.$watch('$ctrl.campaign.' + vm.threshold, plotBands);
    deregisterStateChangeStart = $rootScope.$on('$stateChangeSuccess', fixResizeProblem);
  };

  vm.$onDestroy = function () {
    if (deregisterStateChangeStart) deregisterStateChangeStart();
  };

  function addSeries(sessions) {
    var totalSessionCount = sessions.length;
    var nocvSessions = _.filter(sessions, function (session) {
      return session.conversion_count === 0;
    });
    var cvSessions = _.filter(sessions, function (session) {
      return session.conversion_count >= 1;
    });
    chart.resetSeries();
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPredictionDistribution.konbaajonnashi_no_wariai'),
      data: getDistributions(nocvSessions, totalSessionCount)
    });
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPredictionDistribution.konbaajonari_no_wariai'),
      data: getDistributions(cvSessions, totalSessionCount)
    });
  }

  function getCategories() {
    return _.map(ranges, function (range) {
      return range + '-' + (range + STEP) + '%';
    });
  }

  function getDistributions(sessions, totalSessionCount) {
    var countByMin = _.countBy(sessions, function (session) {
      return Math.floor(_.get(session, vm.field) * 100);
    });
    return _.map(ranges, function (range) {
      var count = countByMin[range] || 0;
      return count / totalSessionCount * 100;
    });
  }

  function plotBands(threshold) {
    if (vm.threshold === 'predictions_max_threshold') {
      vm.chartConfig.xAxis.plotBands = [{
        from: MIN,
        to: threshold,
        color: PLOT_BANDS_COLOR
      }];
    } else {
      vm.chartConfig.xAxis.plotBands = [{
        from: threshold,
        to: MAX,
        color: PLOT_BANDS_COLOR
      }];
    }
  }

  function resizeFull() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('show');
    // NOTE:
    // Need to call fixResizeProblem once modal has been shown.
    // It does not work before the modal is completely shown.
    $modal.on('shown.bs.modal', function () {
      fixResizeProblem();
    });
  }

  function resizeSmall() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('hide');
  }

  function fixResizeProblem() {
    // NOTE:
    // There is a bug that Highcharts is not sizing correctly when dynamically changing the screen.
    // Calling the highchartsng.reflow event solves the problem.
    // See https://github.com/pablojim/highcharts-ng/issues/550
    $scope.$broadcast('highchartsng.reflow');
    // NOTE:
    // There is a bug that Angularjs-Slider is not sizing correctly when dynamically changing the screen
    // (OMG, don't give me the same SPA shit in a one day...).
    // Calling the rzSliderForceRender event solves the problem.
    // See https://github.com/angular-slider/angularjs-slider/issues/79
    $scope.$broadcast('rzSliderForceRender');
  }
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.core').component('zcSessionPriceDistribution', {
  templateUrl: '/templates/core/components/session_price_distribution/session_price_distribution.html',
  bindings: {
    project: '<',
    campaign: '<',
    sessions: '<',
    disabled: '<',
    field: '@'
  },
  controller: sessionPriceDistributionController
});

sessionPriceDistributionController.$inject = ['$rootScope', '$scope', '$timeout', '$translate', 'ChartV2', 'columnChartV2Config', 'currencies'];
function sessionPriceDistributionController($rootScope, $scope, $timeout, $translate, ChartV2, columnChartV2Config, currencies) {
  var vm = this;

  var RANDOM_DIGIT = 10;
  var MIN = 0;
  var STEP = 1000;
  var NORMAL_RANGE = 0.95;
  var PLOT_BANDS_COLOR = 'rgba(68, 170, 213, .2)';

  var ranges = [];
  var deregisterStateChangeStart = null;

  var chart = new ChartV2(columnChartV2Config, {
    xAxis: {
      categories: getCategories(),
      labels: { enabled: false },
      tickLength: 0,
      tickWidth: 0,
      crosshair: true
    },
    yAxis: {
      min: 0,
      labels: { enabled: false }
    },
    options: {
      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1,
        shared: true
      }
    }
  });

  vm.$onInit = function () {
    vm.currency = currencies[vm.project.currency];
    vm.chartConfig = chart.getConfig();
    vm.sliderConfig = {
      disabled: vm.disabled,
      floor: MIN,
      step: STEP,
      translate: function translate(value) {
        return '' + vm.currency.symbol + value + vm.currency.suffix;
      }
    };
    vm.modalId = 'modal-' + Math.floor(Math.random() * RANDOM_DIGIT);
    vm.resizeFull = resizeFull;
    vm.resizeSmall = resizeSmall;
    $scope.$watch('$ctrl.sessions', addSeries);
    $scope.$watchGroup(['$ctrl.campaign.price_max_threshold', '$ctrl.campaign.price_min_threshold'], plotBands);
    deregisterStateChangeStart = $rootScope.$on('$stateChangeSuccess', fixResizeProblem);
  };

  vm.$onDestroy = function () {
    deregisterStateChangeStart();
  };

  function addSeries(sessions) {
    var totalSessionCount = sessions.length;
    var prices = getPrices(sessions);
    var max = _.max(prices);
    ranges = _.range(MIN, max, STEP);
    vm.chartConfig.xAxis.categories = getCategories();
    chart.resetSeries();
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPriceDistribution.wariai'),
      data: getDistributions(prices, totalSessionCount)
    });
    $timeout(function () {
      vm.sliderConfig.ceil = _.last(ranges);
      plotBands([vm.campaign.price_max_threshold, vm.campaign.price_min_threshold]);
    }, 0);
  }

  function getPrices(conversions) {
    var prices = _.chain(conversions).map(vm.field).compact().sortBy().value();
    return prices.slice(0, prices.length * NORMAL_RANGE);
  }

  function getCategories() {
    return _.map(ranges, function (range) {
      return '' + vm.currency.symbol + range + '-' + (range + STEP) + vm.currency.suffix;
    });
  }

  function getDistributions(prices, totalConversionCount) {
    var countByMin = _.countBy(prices, function (price) {
      return Math.floor(price / 1000) * 1000;
    });
    return _.map(ranges, function (range) {
      var count = countByMin[range] || 0;
      return count / totalConversionCount * 100;
    });
  }

  function plotBands(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        min = _ref2[0],
        max = _ref2[1];

    vm.chartConfig.xAxis.plotBands = [{
      from: _.indexOf(ranges, min),
      to: _.indexOf(ranges, max),
      color: PLOT_BANDS_COLOR
    }];
  }

  function resizeFull() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('show');
    // NOTE:
    // Need to call fixResizeProblem once modal has been shown.
    // It does not work before the modal is completely shown.
    $modal.on('shown.bs.modal', function () {
      fixResizeProblem();
    });
  }

  function resizeSmall() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('hide');
  }

  function fixResizeProblem() {
    // NOTE:
    // There is a bug that Highcharts is not sizing correctly
    // when dynamically changing the screen size until calling reflow.
    // See https://github.com/pablojim/highcharts-ng/issues/550
    $scope.$broadcast('highchartsng.reflow');
    // NOTE:
    // There is a bug that Angularjs-Slider is not sizing correctly when dynamically changing the screen
    // (OMG, don't give me the same SPA shit in a one day...).
    // Calling the rzSliderForceRender event solves the problem.
    // See https://github.com/angular-slider/angularjs-slider/issues/79
    $scope.$broadcast('rzSliderForceRender');
  }
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcSessionUpliftModelingClassification', {
  templateUrl: '/templates/core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html',
  bindings: {
    campaign: '<',
    sessions: '<',
    field: '@'
  },
  controller: sessionUpliftModelingClassificationController
});

sessionUpliftModelingClassificationController.$inject = ['$scope'];
function sessionUpliftModelingClassificationController($scope) {
  var vm = this;

  var DELAY_MS = 500;

  vm.$onInit = function () {
    vm.totalSessionCount = 0;
    vm.noConversionAnywaySessionCount = 0;
    vm.conversionAnywaySessionCount = 0;
    vm.negativeImpactSessionCount = 0;
    vm.positiveImpactSessionCount = 0;
    vm.totalConversionCount = 0;
    vm.noConversionAnywayConversionCount = 0;
    vm.conversionAnywayConversionCount = 0;
    vm.negativeImpactConversionCount = 0;
    vm.positiveImpactConversionCount = 0;
    $scope.$watchGroup(['$ctrl.campaign.predictions_max_threshold', '$ctrl.campaign.predictions_min_threshold', '$ctrl.campaign.price_max_threshold', '$ctrl.campaign.price_min_threshold', '$ctrl.campaign.exclude_no_price', '$ctrl.sessions'], _.debounce(calculateSimulation, DELAY_MS), true);
  };

  function calculateSimulation() {
    if (!vm.sessions.length) return;
    var noConversionAnyway = [];
    var conversionAnyway = [];
    var negativeImpact = [];
    var positiveImpact = [];
    vm.sessions.forEach(function (session) {
      if (isNoConversionAnyway(session)) {
        noConversionAnyway.push(session);
      } else if (isConversionAnyway(session)) {
        conversionAnyway.push(session);
      } else if (isNegativeImpact(session)) {
        negativeImpact.push(session);
      } else {
        positiveImpact.push(session);
      }
    });
    vm.totalSessionCount = vm.sessions.length;
    vm.noConversionAnywaySessionCount = noConversionAnyway.length;
    vm.conversionAnywaySessionCount = conversionAnyway.length;
    vm.negativeImpactSessionCount = negativeImpact.length;
    vm.positiveImpactSessionCount = positiveImpact.length;
    vm.totalConversionCount = _.filter(vm.sessions, 'conversion_count').length;
    vm.noConversionAnywayConversionCount = _.filter(noConversionAnyway, 'conversion_count').length;
    vm.conversionAnywayConversionCount = _.filter(conversionAnyway, 'conversion_count').length;
    vm.negativeImpactConversionCount = _.filter(negativeImpact, 'conversion_count').length;
    vm.positiveImpactConversionCount = _.filter(positiveImpact, 'conversion_count').length;
  }

  function isNoConversionAnyway(session) {
    var prediction = _.get(session, 'predictions_max_before_cart.global_conversion_rate') * 100;
    if (prediction < vm.campaign.predictions_max_threshold) return true;
    return false;
  }

  function isConversionAnyway(session) {
    var prediction = _.get(session, 'predictions_min_before_cart.global_conversion_rate') * 100;
    if (prediction > vm.campaign.predictions_min_threshold) return true;
    return false;
  }

  function isNegativeImpact(session) {
    var price = _.get(session, 'average_recent5_item_price');
    if (!price && vm.campaign.exclude_no_price) return true;
    if (price && vm.campaign.price_max_threshold < price && price < vm.campaign.price_min_threshold) return true;
    return false;
  }
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcSyncContractInfoButton', {
  templateUrl: '/templates/core/components/sync_contract_info_button/sync_contract_info_button.html',
  bindings: {
    source: '=',
    syncTargetName: '@'
  },
  controller: SyncContractInfoButtonController,
  controllerAs: 'vm'
});

SyncContractInfoButtonController.$inject = ['$translate'];
function SyncContractInfoButtonController($translate) {
  var _this = this;

  var SYNC_TARGET_NAME = $translate.instant('sharedModules.core.components.syncContractInfoButton.kaisha_jouhou');

  // contractInfoField: billingInfoField
  var FIELDS_TO_BE_SYNCED = {
    company_name: 'billing_company_name',
    address: 'billing_address',
    postal_code: 'billing_postal_code',
    phone_number: 'billing_phone_number'
  };

  var ALIAS_FIELDS = {
    // agency's title field equals company_name
    company_name: 'title'
  };

  var vm = this;

  // Loop the above FIELDS_TO_BE_SYNCED and assign
  // billingInfoField's value to contractInfoField
  function syncContractInfoWithBillingInfo() {
    _.forEach(FIELDS_TO_BE_SYNCED, function (billingInfoField, contractInfoField) {

      if (!isSourceHasField(contractInfoField)) {
        var aliasField = _.get(ALIAS_FIELDS, contractInfoField);
        if (!isSourceHasField(aliasField)) {
          console.error('Source missing a field: ' + contractInfoField + '.');
          return;
        }

        contractInfoField = aliasField;
      }

      vm.source[billingInfoField] = vm.source[contractInfoField];
    });
  }

  function isSourceHasField(field) {
    return _.has(vm.source, field);
  }

  vm.$onInit = function () {
    vm.syncContractInfoWithBillingInfo = syncContractInfoWithBillingInfo;

    if (!_this.syncTargetName) {
      vm.syncTargetName = SYNC_TARGET_NAME;
    }
  };
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcTosNotification', {
  templateUrl: '/templates/core/components/tos_notification/tos_notification.html',
  bindings: {
    serviceName: '@',
    tosUrl: '@',
    updatedAt: '@'
  },
  controller: zcTosNotification,
  controllerAs: 'vm'
});

zcTosNotification.$inject = ['Devise'];
function zcTosNotification(Devise) {
  var vm = this;

  vm.$onInit = function () {
    vm.isTosSigned = true;
    vm.user = {};

    Devise.getCurrentUser().then(function (user) {
      vm.user = user;
      vm.isTosSigned = user.agreement_2020_signed_at !== null;
    });
  };

  vm.signAgreements = function () {
    Devise.getCurrentUser().then(function (user) {
      Devise.signAgreements(user).then(function () {
        vm.isTosSigned = true;
      });
    });
  };
}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').config(exceptionHandler);

exceptionHandler.$inject = ['$provide'];
function exceptionHandler($provide) {
  // exceptionHandler can also be overwritten, but
  // decorating is more future proof.
  $provide.decorator('$exceptionHandler', exceptionHandlerDecorator);
}

exceptionHandlerDecorator.$inject = ['$delegate', '$injector'];
function exceptionHandlerDecorator($delegate, $injector) {
  return function (exception, cause) {
    // This executes the original functionality ($log.error)
    $delegate(exception, cause);
  };
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').config(translations);

// Support for i18n
translations.$inject = ['$translateProvider'];
function translations($translateProvider) {
  $translateProvider.useStaticFilesLoader({
    prefix: '/assets/i18n/',
    suffix: '.json'
  }).registerAvailableLanguageKeys(['en', 'ja'], {
    'en_*': 'en',
    'ja_*': 'ja',
    '*': 'en'
  }).determinePreferredLanguage()
  // https://angular-translate.github.io/docs/#/guide/19_security
  .useSanitizeValueStrategy('sceParameters');
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').directive('autoFillSync', autoFillSync);

autoFillSync.$inject = ['$interval'];
function autoFillSync($interval) {
  return {
    require: 'ngModel',
    link: function link(scope, elem, attrs, ngModel) {
      var origVal = elem.val();
      $interval(function () {
        var newVal = elem.val();
        if (ngModel.$pristine && origVal !== newVal) {
          ngModel.$setViewValue(newVal);
          origVal = newVal;
        }
      }, 500);
    }
  };
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').directive('peTrack', peTrack);

peTrack.$inject = ['ZcTag'];
function peTrack(ZcTag) {
  return {
    restrict: 'A',
    link: link,
    scope: {
      peAttrs: '<'
    }
  };

  function link(scope, elem, attrs) {
    var minimumDuration = 500;
    var clickCount = 0;

    var t = new Date().valueOf();
    var mouseEnter = function mouseEnter(e) {
      t = new Date().valueOf();
    };
    var mouseLeave = function mouseLeave() {
      var duration = new Date().valueOf() - t;
      if (duration > minimumDuration) {
        var attribute = _.merge(scope.peAttrs || {}, { duration: duration });
        ZcTag.sendParticularEvent(attrs.peTrack + ':hover', attribute);
      }
    };
    elem.mouseenter(mouseEnter).mouseleave(mouseLeave);

    elem.click(function () {
      clickCount++;
      var attribute = _.merge(scope.peAttrs || {}, { click_count: clickCount });

      ZcTag.sendParticularEvent(attrs.peTrack + ':click', attribute);
    });
  }
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// keep this updated with the billable currency in api_rails/app/models/project.rb
var BILLABLE_CURRENCIES = ['jpy', 'usd', 'aud', 'eur', 'gbp', 'hkd', 'idr', 'krw', 'myr', 'sgd', 'thb', 'twd'];

angular.module('zc.core').filter('billable_currencies', billableCurrencies);

billableCurrencies.$inject = [];
function billableCurrencies() {
  return function (arr) {
    var project = arr[0];

    if (project.fixed_invoice_amount || project.product_line === 'zenclerk_lp') {
      return BILLABLE_CURRENCIES;
    }
    // twd has no exchange rate so it cant be billed in usd
    if (project.currency === 'twd') {
      return ['twd'];
    }
    // always gonna be like ['jpy', 'usd']
    if (!BILLABLE_CURRENCIES.includes(project.currency)) {
      return ['usd'];
    }

    // filter out duplicate if dashboard currency is usd
    var currencies = [project.currency, 'usd'].filter(function (v, i, a) {
      return a.indexOf(v) === i;
    });
    return currencies;
  };
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('byteFormat', byteFormat);

byteFormat.$inject = [];
function byteFormat() {
  return function (bytes, precision) {
    var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
    var number = Math.floor(Math.log(bytes) / Math.log(1024));

    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (angular.isUndefined(precision)) precision = 1;
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('gmtNotation', gmtNotation);

gmtNotation.$inject = [];
function gmtNotation() {
  return function (timezone) {
    var notation = {
      africa_johannesburg: 'South Africa',
      america_los_angeles: 'United States',
      america_new_york: 'United States',
      america_toronto: 'Canada',
      asia_bangkok: 'Thailand',
      asia_ho_chi_minh: 'Vietnam',
      asia_hong_kong: 'Hong Kong',
      asia_jakarta: 'Indonesia',
      asia_kolkata: 'India',
      asia_kuala_lumpur: 'Malaysia',
      asia_manila: 'Philippines',
      asia_seoul: 'Korea',
      asia_shanghai: 'China',
      asia_singapore: 'Singapore',
      asia_taipei: 'Taiwan',
      asia_tokyo: 'Japan',
      australia_sydney: 'Australia',
      europe_amsterdam: 'Netherlands',
      europe_berlin: 'Germany',
      europe_london: 'United Kingdom',
      europe_paris: 'France',
      europe_rome: 'Italy',
      europe_stockholm: 'Sweden',
      europe_zurich: 'Switzerland',
      pacific_auckland: 'New Zealand'
    };

    var offset = moment().tz(timezone).format('Z');
    return notation[timezone] + ' GMT' + offset;
  };
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('humanizeCurrency', humanizeCurrency);

humanizeCurrency.$inject = ['$translate'];
function humanizeCurrency($translate) {
  return function (currency) {
    return $translate.instant('sharedModules.core.filters.humanizeCurrency.' + currency);
  };
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('unique', unique);

unique.$inject = [];
function unique() {
  return function (arr) {
    return _.uniq(arr);
  };
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core')

/**
 * httpOnce makes sure that no multiple instances of same requests are simultaneously.
 * For example if a page has 10 components which all ask for user and project,
 * there would normally be 10 requests for user and project simultaneously.
 *
 * With httpOnce, subsequent exactly same requests get the first request's
 * promise, so only one request is sent.
 *
 * This is bit modified from:
 * http://stackoverflow.com/questions/32958046/preventing-multiple-http-requests-in-angular-is-there-a-better-way
 */
.factory('$httpOnce', $httpOnce);

$httpOnce.$inject = ['$cacheFactory', '$http'];
function $httpOnce($cacheFactory, $http) {
  // TODO: this is in zc.core, so cannot use babel+es6 yet
  var cache = $cacheFactory('$httpOnce');

  var service = function service(params, options) {
    // TODO: this is in zc.core, so cannot use babel+es6 yet
    var cacheKey = angular.toJson(params);

    // return the promise from cache if same request is already in progress
    return cache.get(cacheKey) || cache.put(cacheKey, $http(params, options)).then(function (response) {
      return response;
    }).finally(function () {
      // clear cache once we are done
      cache.remove(cacheKey);
    });
  };

  return service;
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('areaChartV2Config', areaChartV2Config);

areaChartV2Config.$inject = ['chronologicalChartV2Config'];
function areaChartV2Config(chronologicalChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'area' }
    }
  }, chronologicalChartV2Config);
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('barChartV2Config', barChartV2Config);

barChartV2Config.$inject = ['baseChartV2Config'];
function barChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'bar' }
    },
    xAxis: {
      title: { text: null },
      type: 'category'
    },
    yAxis: {
      title: { text: null },
      min: 0
    }
  }, baseChartV2Config);
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('baseChartV2Config', baseChartV2Config);

baseChartV2Config.$inject = [];
function baseChartV2Config() {
  return {
    options: {
      title: { text: null },
      legend: { enabled: false },
      credits: { enabled: false }
    },
    series: []
  };
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.core').factory('ChartV2', ChartV2);

ChartV2.$inject = [];
function ChartV2() {
  var Chart = function () {
    function Chart(config, customConfig) {
      _classCallCheck(this, Chart);

      this.config = _.merge({
        options: { rand: Math.random() }
      }, config, customConfig);
    }

    _createClass(Chart, [{
      key: 'getConfig',
      value: function getConfig() {
        return this.config;
      }
    }, {
      key: 'resetSeries',
      value: function resetSeries() {
        this.config.series = [];
      }
    }, {
      key: 'addSeries',
      value: function addSeries(series) {
        this.config.series.push(series);
      }
    }]);

    return Chart;
  }();

  return Chart;
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('chronologicalChartV2Config', chronologicalChartV2Config);

chronologicalChartV2Config.$inject = ['$translate', '$window', 'baseChartV2Config'];
function chronologicalChartV2Config($translate, $window, baseChartV2Config) {
  return angular.merge({
    options: {
      colors: ['#26c9ff', '#666666'],
      tooltip: {
        shared: true,
        crosshairs: true,
        dateTimeLabelFormats: {
          hour: $translate.instant('sharedModules.dateTimeFormats.chart.monthDayHour'),
          day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
          week: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay')
        }
      },
      plotOptions: {
        series: {
          marker: {
            symbol: 'circle',
            enabled: false
          }
        }
      }
    },
    xAxis: {
      title: { text: null },
      type: 'datetime',
      dateTimeLabelFormats: {
        hour: $translate.instant('sharedModules.dateTimeFormats.chart.hour'),
        day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
        week: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay')
      }
    },
    yAxis: {
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          var suffix = void 0,
              valueDecimals = void 0;
          suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
          valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
          return $window.Highcharts.numberFormat(this.value, valueDecimals) + suffix;
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('columnChartV2Config', columnChartV2Config);

columnChartV2Config.$inject = ['$window', 'baseChartV2Config'];
function columnChartV2Config($window, baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'column' },
      colors: ['#26c9ff', '#666666']
    },
    xAxis: {
      title: { text: null },
      type: 'category'
    },
    yAxis: {
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          var suffix = void 0,
              valueDecimals = void 0;
          suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
          valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
          return $window.Highcharts.numberFormat(this.value, valueDecimals) + suffix;
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('funnelChartV2Config', funnelChartV2Config);

funnelChartV2Config.$inject = ['baseChartV2Config'];
function funnelChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: {
        type: 'funnel',
        width: 300,
        height: 120
      },
      plotOptions: {
        series: {
          dataLabels: {
            distance: 0,
            formatter: function formatter() {
              // NOTE: Squaring values which is stored as rooted
              var total = Math.round(Math.pow(this.series.yData[0], 2));
              var y = Math.round(Math.pow(this.y, 2));
              var percent = Math.round(y / total * 100);
              return this.key + ' (' + percent + '%)';
            }
          },
          enableMouseTracking: false,
          width: 180,
          neckWidth: '0%',
          neckHeight: '0%'
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('lineChartV2Config', lineChartV2Config);

lineChartV2Config.$inject = ['chronologicalChartV2Config'];
function lineChartV2Config(chronologicalChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'line' }
    }
  }, chronologicalChartV2Config);
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('pieChartV2Config', pieChartV2Config);

pieChartV2Config.$inject = ['baseChartV2Config'];
function pieChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'pie' },
      tooltip: { pointFormat: '<b>{point.percentage:.1f}%</b>' },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -60,
            style: {
              fontWeight: 'bold',
              color: 'white',
              textShadow: '0px 1px 2px black'
            }
          }
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('ZcTag', ZcTag);

ZcTag.$inject = ['$location', '$state', '$window', 'Devise', 'Environment'];
function ZcTag($location, $state, $window, Devise, Environment) {
  var EVENT_PREFIX = ZC_CONFIG.ZC_TAG_EVENT_PREFIX || 'zc';
  var service = {};
  var environment = void 0;
  service.initialized = false;

  Environment.get().then(function (res) {
    environment = res;
  });

  service.initialize = function () {
    if (ZC_CONFIG.ZC_APIKEY && !service.initialized) {
      var zcTag = $('\n      <script type="text/javascript" src="' + $location.protocol() + '://f1.zenclerk.com/publish/' + ZC_CONFIG.ZC_APIKEY + '.js"></script>\n      ');
      $('body').append(zcTag);
      service.initialized = true;
    }
  };

  service.sendParticularEvent = function (name, attributes) {
    if (angular.isUndefined(environment)) {
      return;
    }

    var userId = void 0;
    if (Devise.currentUser) userId = Devise.currentUser.id;

    attributes = _.merge(attributes || {}, { user_id: userId, state: $state.current.name });
    name = EVENT_PREFIX + ':' + name;

    // show log on dev/staging env so that it's easy to test
    if (environment === 'staging' || environment === 'development') {
      console.log('[DEV] Would send particular event', name, attributes);
    }

    // do not allow sending anything else than plain objects (or undefineds)
    if (angular.isDefined(attributes) && !_.isPlainObject(attributes)) {
      console.warn('Tried to send non-object as particular event', attributes);
      return;
    }

    if (angular.isUndefined($window.__zc)) {
      return;
    }

    $window.__zc.ParticularEventController.send($window.__zc.socket, name, attributes);
  };

  return service;
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').controller('TosController', TosController);

TosController.$inject = ['$rootScope'];
function TosController($rootScope) {
  var vm = this;

  vm.$onInit = function () {
    vm.selectedLanguage = null;

    // Select TOS based on the language selected in TosHeaderController
    var deregistrationCallback = $rootScope.$on('languageSelected', function (_, selectedLanguage) {
      vm.selectedLanguage = selectedLanguage;
    });

    $rootScope.$on('$destroy', deregistrationCallback);

    $rootScope.$emit('selectDefaultLanguage');
  };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').controller('TosHeaderController', TosHeaderController);

TosHeaderController.$inject = ['$location', '$rootScope', '$translate', 'Devise', 'languages'];
function TosHeaderController($location, $rootScope, $translate, Devise, languages) {
  var vm = this;

  vm.$onInit = function () {
    vm.selectedLanguage = null;

    if (languages) {
      vm.languages = languages;
    } else {
      throw new Error('Please specify available languages for TosHeaderController in router');
    }

    var FALLBACK_LANGUAGE = vm.languages[0];

    vm.selectLanguage = function (selectedLanguage) {
      vm.selectedLanguage = selectedLanguage;
      $rootScope.$emit('languageSelected', selectedLanguage);
    };

    var selectDefaultLanguage = function selectDefaultLanguage() {
      Devise.getCurrentUserLanguage().then(function (currentUserLanguage) {
        var id = $location.search().lang || currentUserLanguage || $translate.preferredLanguage();
        var defaultLanguage = _.find(vm.languages, {
          id: id
        }) || FALLBACK_LANGUAGE;

        vm.selectLanguage(defaultLanguage);
      });
    };

    var deregistrationCallback = $rootScope.$on('selectDefaultLanguage', selectDefaultLanguage);
    $rootScope.$on('$destroy', deregistrationCallback);
  };
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.agencies').config(routerConfig);

routerConfig.$inject = ['$stateProvider'];
function routerConfig($stateProvider) {
  $stateProvider.state('admin.agencies', {
    abstract: true,
    url: '/agencies/{agencyName}',
    resolve: {
      agency: function agency(Agency, $stateParams) {
        return Agency.get('name:' + $stateParams.agencyName);
      }
    }
  }).state('admin.agencies.settings', {
    url: '/settings',
    views: {
      'content@': {
        template: '<zc-agency-settings agency="$resolve.agency"></zc-agency-settings>',
        resolve: {}
      }
    }
  });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.agencies').component('zcAgencySettings', {
  templateUrl: '/templates/agencies/settings/agency_settings.html',
  bindings: {
    agency: '<'
  },
  controller: ZcAgencySettingsController
});

ZcAgencySettingsController.$inject = ['Agency'];
function ZcAgencySettingsController(Agency) {
  var vm = this;

  vm.save = function (updatedAgency) {
    return Agency.update(updatedAgency);
  };
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('zc.projects').controller('CampaignBulkEditModalController', CampaignBulkEditModalController);

CampaignBulkEditModalController.$inject = ['$filter', '$modalInstance', '$q', '$state', '$window', 'Campaign', 'campaigns', 'incentives', 'project'];
function CampaignBulkEditModalController($filter, $modalInstance, $q, $state, $window, Campaign, campaigns, incentives, project) {
  var vm = this;

  vm.campaigns = campaigns;
  vm.incentives = incentives;
  vm.project = project;
  vm.selectedIncentive = null;
  vm.selectedIncentives = [];
  vm.addIncentive = addIncentive;
  vm.removeIncentive = removeIncentive;
  vm.cancel = cancel;
  vm.save = save;
  vm.isValid = isValid;
  vm.enoughInput = enoughInput;
  vm.isSaving = false;
  vm.incentiveRegistrationUrl = $state.href('admin.projects.incentives', { projectId: vm.project.id }, { absolute: true });
  vm.region = project.region;
  vm.gmtOffset = '(' + moment().tz(vm.region).format('Z') + ')';
  vm.endDate = null;
  vm.endTime = null;

  sortIncentives();

  _.forEach(vm.incentives, function (incentive) {
    if (incentive.incentive_type === 'api_url') {
      incentive.example = ' [' + incentive.api_url + ']';
    } else if (incentive.incentive_type === 'coupon_url') {
      incentive.example = ' [' + incentive.pc_base_url + ']';
    } else {
      incentive.example = ' [' + incentive.coupon_code + ']';
    }
  });

  function addIncentive(selectedIncentive) {
    vm.selectedIncentive = null;
    vm.selectedIncentives.push(selectedIncentive);
    vm.incentives = _.reject(vm.incentives, function (incentive) {
      return incentive.id === selectedIncentive.id;
    });
    sortSelectedIncentives();
  }

  function removeIncentive(incentive) {
    vm.selectedIncentives = _.reject(vm.selectedIncentives, function (selectedIncentive) {
      return selectedIncentive.id === incentive.id;
    });
    vm.incentives.push(incentive);
    sortIncentives();
  }

  function cancel() {
    $modalInstance.close();
  }

  function save() {
    if (vm.isSaving) return;
    vm.isSaving = true;
    var incentivePromises = [];
    if (vm.selectedIncentives.length > 0) {
      var incentiveIds = _.map(vm.selectedIncentives, 'id');
      incentivePromises = _.map(vm.campaigns, function (campaign) {
        return Campaign.addIncentives({
          project_id: vm.project.id,
          campaign_id: campaign.id,
          incentive_ids: incentiveIds
        });
      });
    }

    var datePromises = [];
    if (vm.endDate && vm.endTime) {
      datePromises = _.map(vm.campaigns, function (campaign) {
        var updatedCampaign = _.cloneDeep(campaign);
        updatedCampaign.end_at = moment(vm.endDate + ' ' + vm.endTime, 'YYYY/MM/DD hh:mm').toDate();
        updatedCampaign.end_at_obj = $filter('dateToDateObj')(updatedCampaign.end_at);
        updatedCampaign.is_infinite = false;
        return Campaign.update({
          projectId: vm.project.id,
          campaignId: campaign.id
        }, updatedCampaign);
      });
    }

    $q.all([].concat(_toConsumableArray(incentivePromises), _toConsumableArray(datePromises))).then(function () {
      return $window.location.reload();
    });
  }

  function sortIncentives() {
    vm.incentives = _.sortBy(vm.incentives, function (incentive) {
      return -new Date(incentive.updated_at).valueOf();
    });
  }

  function sortSelectedIncentives() {
    vm.selectedIncentives = _.sortBy(vm.selectedIncentives, function (selectedIncentive) {
      return -new Date(selectedIncentive.updated_at).valueOf();
    });
  }

  function isValid() {
    var allRequiresIncentives = _.every(vm.campaigns, function (campaign) {
      return campaign.requires_incentives;
    });
    if (!allRequiresIncentives && vm.selectedIncentives.length) return false;
    return true;
  }

  function enoughInput() {
    var dateOnly = vm.selectedIncentives.length === 0 && vm.endDate && vm.endTime;
    var incentiveOnly = vm.selectedIncentives.length && !vm.endDate && !vm.endTime;
    var bothChange = vm.selectedIncentives.length && vm.endDate && vm.endTime;
    if (dateOnly || incentiveOnly || bothChange) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').component('zcCampaignArmsList', {
  templateUrl: '/templates/projects.campaigns/components/campaign_arms_list.html',
  bindings: {
    project: '<',
    campaign: '<'
  },
  controller: CampaignArmsList,
  controllerAs: 'vm'
});

CampaignArmsList.$inject = ['Apollo'];
function CampaignArmsList(Apollo) {
  var vm = this;

  vm.activeCampaignArms = [];
  vm.isBanditActive = false;
  vm.isDisplayTable = false;
  vm.isLoaded = false;
  vm.timingSettingsURL = ZC_CONFIG.AIDEAL_URL + '/site/' + vm.project.apikey + '/campaigns/' + vm.campaign.id + '/timing';

  function getCampaignArms() {
    var GET_CAMPAIGN_ARMS = gql('\n      query GetCampaignArms(\n        $apikey: String\n        $campaignId: ID\n        $isActive: Boolean\n        $campaignArmsIsActive: Boolean\n      ) {\n        project(apikey: $apikey) {\n          campaign(id: $campaignId) {\n            is_bandit_active\n            automators(is_active: $isActive) {\n              campaignArms(is_active: $campaignArmsIsActive) {\n                id\n                aiModel {\n                  algo\n                }\n                ratio\n                threshold\n              }\n            }\n          }\n        }\n      }');

    return Apollo.query(GET_CAMPAIGN_ARMS, {
      apikey: vm.project.apikey,
      campaignId: vm.campaign.id,
      isActive: true,
      campaignArmsIsActive: true
    });
  }

  vm.$onInit = function () {
    getCampaignArms().then(function (res) {
      vm.isBanditActive = _.get(res, 'project.campaign.is_bandit_active', false);
      vm.activeCampaignArms = _.cloneDeep(_.flatMap(res.project.campaign.automators, function (x) {
        return x.campaignArms;
      }));
      vm.isLoaded = true;
    });
  };
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').component('zcCampaignSummary', {
  templateUrl: '/templates/projects.campaigns/components/campaign_summary.html',
  bindings: {
    campaigns: '<',
    filters: '<',
    isAb: '<',
    showHiddenAb: '<',
    project: '<'
  },
  controller: campaignSummary,
  controllerAs: 'vm'
});

campaignSummary.$inject = ['$filter', '$scope', 'AccessStats', 'CampaignStats', 'currencies', 'Devise'];
function campaignSummary($filter, $scope, AccessStats, CampaignStats, currencies, Devise) {
  var vm = this;

  vm.currency = currencies[vm.project.currency];
  vm.Devise = Devise;

  vm.$onInit = function () {
    return vm.updateData();
  };

  vm.updateData = function () {
    vm.getCampaignStats().then(function () {
      vm.siteSessionCount = 0;
      vm.totalDeliveryCount = _.sumBy(vm.campaigns, 'stats.experimental.delivery_count');
      vm.totalConversionCount = _.sumBy(vm.campaigns, 'stats.experimental.conversion_count');
      var couponCodeCampaigns = _.filter(vm.campaigns, function (campaign) {
        var currentIncentive = campaign.current_incentive;
        return currentIncentive && ['coupon_code', 'unique_coupon_code'].includes(currentIncentive.incentive_type);
      });
      var campaignCouponCodeUsedCount = _.sumBy(couponCodeCampaigns, 'stats.experimental.campaign_coupon_used_count');
      var couponCodeCampaignsTotalConversionCount = _.sumBy(couponCodeCampaigns, 'stats.experimental.conversion_count');
      if (couponCodeCampaignsTotalConversionCount > 0 && campaignCouponCodeUsedCount > 0) {
        vm.totalCouponUsedRate = $filter('number')(campaignCouponCodeUsedCount / couponCodeCampaignsTotalConversionCount * 100, 2);
      } else {
        vm.totalCouponUsedRate = '- '; // display - % when no coupon code used count stat
      }

      var nonAovCampaigns = _.filter(vm.campaigns, { is_aov_campaign: false });
      vm.totalConversionValue = _.sumBy(nonAovCampaigns, 'stats.experimental.conversion_price');
      vm.conversion_up_rate = $filter('overallCampaignCvrIncreaseRate')(nonAovCampaigns, vm.showHiddenAb);

      var abTestCampaigns = _.reject(vm.campaigns, { campaign_control_percent: 0 });
      vm.totalRevenueGrowth = _.sumBy(abTestCampaigns, 'stats.contribution_price');

      AccessStats.aggregateByFilter({
        apikey: vm.project.apikey,
        dimension: 'daily'
      }, vm.filters).then(function (accessStats) {
        vm.siteSessionCount = accessStats[0].session_count;
      });
    });
  };

  vm.getCampaignStats = function () {
    if (vm.campaigns.length === 0) return Promise.resolve();

    return CampaignStats.aggregate({
      dimension: 'daily',
      apikey: vm.project.apikey,
      campaign_ids: _.map(vm.campaigns, 'id'),
      start_at: vm.filters.start_at,
      end_at: vm.filters.end_at
    }).then(function (campaignStats) {
      var statsById = CampaignStats.groupById(campaignStats);
      _.each(vm.campaigns, function (campaign) {
        campaign.stats = statsById[campaign.id];
        var calculatedInvoiceAmount = CampaignStats.calculateInvoiceAmount(vm.project, campaign, campaign.stats);
        _.assign(campaign.stats, {
          invoice_amount: calculatedInvoiceAmount
        });
      });
    });
  };

  $scope.$watch('vm.filters', vm.updateData, true);
  $scope.$watch('vm.campaigns', vm.updateData, true);
  $scope.$watch('vm.showHiddenAb', vm.updateData, true);
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').component('zcCampaignNote', {
  templateUrl: selectTemplateUrl,
  bindings: {
    campaign: '=',
    colMd: '<',
    note: '@',
    compact: '<'
  },
  controller: ZcCampaignNoteController,
  controllerAs: 'vm'
}).factory('noteOptions', noteConstants);

noteConstants.$inject = ['$filter'];
function noteConstants($filter) {
  return {
    ELEMENT_MAX_WIDTH: 12,
    MAX_CHARACTER_LENGTH: 2000,
    MAX_CHARACTERS_PER_ROW: 80,
    NOTES: {
      base: '',
      template: '',
      incentive: '',
      policy: '',
      timing: '',
      schedule: ''
    },
    NOTES_EXCLUDED_FROM_VALIDATION: ['all'],
    NOTE_NAMES_TRANSLATED: {
      base: $filter('translate')('projectsCampaigns.directives.campaignNote.base'),
      template: $filter('translate')('projectsCampaigns.directives.campaignNote.template'),
      botbonnie: 'botbonnie',
      incentive: $filter('translate')('projectsCampaigns.directives.campaignNote.incentive'),
      policy: $filter('translate')('projectsCampaigns.directives.campaignNote.policy'),
      timing: $filter('translate')('projectsCampaigns.directives.campaignNote.timing'),
      schedule: $filter('translate')('projectsCampaigns.directives.campaignNote.schedule')
    }
  };
}

function selectTemplateUrl($attrs) {
  var MODES = {
    display: '/templates/projects.campaigns/views/directives/campaign_note.html',
    edit: '/templates/projects.campaigns/views/directives/campaign_note_editor.html',
    list: '/templates/projects.campaigns/views/directives/campaign_notes.html'
  };

  var validModes = _.keys(MODES);
  if (!_.includes(validModes, $attrs.mode)) {
    $attrs.mode = MODES.display;
  }

  return MODES[$attrs.mode];
}

ZcCampaignNoteController.$inject = ['noteOptions'];
function ZcCampaignNoteController(noteOptions) {
  var vm = this;
  vm.$onInit = onInit;
  vm.$doCheck = doCheck;

  function onInit() {
    validateNote(vm.note);

    // variables
    vm.maxCharacterLength = noteOptions.MAX_CHARACTER_LENGTH;
    vm.isMultiline = false;

    // make sure campaign has the notes object
    vm.campaign.notes_json = _.defaults(vm.campaign.notes_json, noteOptions.NOTES);

    // functions
    vm.getColMdClass = getColMdClass;
    vm.getTextareaClasses = getTextareaClasses;
    vm.getNotes = getNotes;
    vm.translateNoteName = translateNoteName;
  }

  // used to keep track of note values changes
  var tempNoteValue = void 0;
  function doCheck() {
    var noteText = getNote();
    if (tempNoteValue !== noteText) {
      tempNoteValue = noteText;
      vm.isMultiline = isMultiline();
      vm.noteLength = tempNoteValue.length;

      if (!vm.isMultiline && noteOptions.MAX_CHARACTERS_PER_ROW < vm.noteLength) {
        vm.isMultiline = true;
      }
    }
  }

  function validateNote(note) {
    var noteParameters = _.keys(noteOptions.NOTES);
    var noteParametersList = noteParameters.sort().join('\n  ');

    if (!_.includes(noteParameters, note) && !_.includes(noteOptions.NOTES_EXCLUDED_FROM_VALIDATION, note)) {
      throw new Error('Invalid note parameter "' + note + '" given.\n Valid notes parameters are:\n\u21B3 ' + noteParametersList);
    }
  }

  // Returns an object like {'col-md-12': true}
  // which is used for setting elements width
  function getColMdClass() {
    var colMd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noteOptions.ELEMENT_MAX_WIDTH;

    if (colMd > noteOptions.ELEMENT_MAX_WIDTH) {
      colMd = noteOptions.ELEMENT_MAX_WIDTH;
    }

    var colMdObj = {};
    colMdObj['col-md-' + colMd] = true;

    return colMdObj;
  }

  function getTextareaClasses() {
    var textareaClasses = {};
    _.assign(textareaClasses, getColMdClass(vm.colMd));
    return textareaClasses;
  }

  function getNote() {
    return _.get(vm.campaign.notes_json, vm.note, '');
  }

  function getNotes() {
    return _.get(vm.campaign, 'notes_json', {});
  }

  function isMultiline() {
    return getNote().indexOf('\n') > -1;
  }

  function translateNoteName(noteName) {
    return _.get(noteOptions.NOTE_NAMES_TRANSLATED, noteName, noteName);
  }
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDashboardCampaignCountChart', {
  templateUrl: '/templates/projects.dashboard/campaign_count_chart.html',
  bindings: {
    project: '<',
    chart: '<'
  },
  controller: zcDashboardCampaignCountChartController
});

zcDashboardCampaignCountChartController.$inject = ['$scope', '$filter', 'ChartV2', 'campaignStatusTexts', 'pieChartV2Config'];

function zcDashboardCampaignCountChartController($scope, $filter, ChartV2, campaignStatusTexts, pieChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var totalCampaignCount = vm.project.campaigns.length;
    var campaignCountByStatus = _.countBy(vm.project.campaigns, function (campaign) {
      return $filter('currentStatus')(campaign);
    });
    var campaigns = _.map(campaignCountByStatus, function (count, status) {
      return [campaignStatusTexts[status], count];
    });
    var chart = new ChartV2(pieChartV2Config);

    chart.addSeries({
      type: 'pie',
      name: $filter('translate')('projectsDashboard.campaignCountChart.campaignCount'),
      innerSize: '50%',
      data: campaigns
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height
      },
      title: {
        align: 'center',
        layout: 'vertical',
        verticalAlign: 'middle',
        y: -30,
        text: '\n          <span class="u-color-babyblue o-type-xl">\n            ' + (campaignCountByStatus.active || 0) + '\n          </span>\n          <span class="u-color-babyblue o-type-l">\n            / ' + totalCampaignCount + '\n          </span>\n          <p>' + $filter('translate')('projectsDashboard.campaignCountChart.duringDelivery') + '</p>',
        useHTML: true
      },
      legend: {
        enabled: true
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      }
    });
  }
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDashboardConversionPriceChart', {
  templateUrl: '/templates/projects.dashboard/conversion_price_chart.html',
  bindings: {
    project: '<',
    chart: '<'
  },
  controller: zcDashboardConversionPriceChartController
});

zcDashboardConversionPriceChartController.$inject = ['$scope', '$translate', '$window', 'ChartV2', 'lineChartV2Config'];

function zcDashboardConversionPriceChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var campaignConversionPrices = [];
    var campaignConversionPriceRates = [];

    _.each(vm.project.dailyStats, function (stat) {
      var startAtUnixTime = moment(stat.start_at).valueOf();
      var conversionCountRatio = stat.all_campaign.conversion_price / stat.all_access.conversion_price * 100;

      campaignConversionPrices.push([startAtUnixTime, stat.all_campaign.conversion_price]);

      campaignConversionPriceRates.push([startAtUnixTime, conversionCountRatio]);
    });

    var chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: {
          formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 0) + ' \u5186';
          }
        }
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: {
          formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 2) + ' %';
          }
        }
      }]
    });

    chart.addSeries({
      type: 'column',
      name: $translate.instant('projectsDashboard.conversionPriceChart.campaignConversionPrices'),
      data: campaignConversionPrices,
      tooltip: {
        valueDecimals: 0
      },
      yAxis: 0
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.conversionPriceChart.campaignConversionPriceRates'),
      data: campaignConversionPriceRates,
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      yAxis: 1
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height
      }
    });
  }
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FORMAT = 'YYYY-MM';
var MIN_GRID_COL_WIDTH = 450;
var MIN_GRID_COL_HEIGHT = 360;
var GRID_HEADER_HEIGHT = 40;
var CHART_HEIGHT = MIN_GRID_COL_HEIGHT - GRID_HEADER_HEIGHT;
var TEXT_HEIGHT_ABOVE_INVOICE_CHART = 85;
var CHARTS_PER_ROW = 3;
var DEFAULT_CHART_POSITIONS = ['invoice', 'delivery', 'reaction', 'campaign-count', 'device-distribution', 'conversion-price'].map(function (name, index) {
  index += 1;
  var row = Math.ceil(index / CHARTS_PER_ROW);
  var col = index % CHARTS_PER_ROW === 0 ? CHARTS_PER_ROW : index % CHARTS_PER_ROW;

  var chart = {
    name: name,
    row: row,
    col: col,
    size_x: 1,
    size_y: 1,
    chart_width: MIN_GRID_COL_WIDTH,
    chart_height: CHART_HEIGHT
  };

  // The invoice chart has some text above itself so
  // We need to reduce the text's height in order to
  // Fit the chart within it's grid
  if (name === 'invoice') {
    chart.chart_height -= TEXT_HEIGHT_ABOVE_INVOICE_CHART;
  }

  return chart;
});

angular.module('zc').component('zcDashboard', {
  templateUrl: '/templates/projects.dashboard/dashboard.html',
  bindings: { project: '<' },
  controller: zcDashboardController
});

zcDashboardController.$inject = ['$timeout', '$translate', 'Apollo', 'DashboardChartPositions', 'Page', 'Project'];

function zcDashboardController($timeout, $translate, Apollo, DashboardChartPositions, Page, Project) {
  var vm = this;
  var thisMonthStartAt = moment().tz(Project.getRegion()).startOf('month').toDate();
  var thisMonthEndAt = moment(thisMonthStartAt).add(1, 'month').toDate();
  var lastMonthStartAt = moment(thisMonthStartAt).subtract(1, 'month').toDate();
  var lastYearStartAt = moment(thisMonthStartAt).subtract(1, 'year').toDate();

  var gridster = void 0;

  Page.setBodyClass('');
  $translate('projectsDashboard.dashboard.dashboard').then(function (translation) {
    Page.setTitle(translation);
  });

  vm.$onInit = function () {
    getProject().then(function (project) {
      vm.project = _.assignIn({}, vm.project, project);
    }).then(function () {
      return DashboardChartPositions.get();
    }).then(function (chart) {
      vm.hasSavedChartPositions = chart.positions !== null;
      vm.chartPositions = vm.hasSavedChartPositions ? chart.positions : DEFAULT_CHART_POSITIONS;
    });
  };

  function getChart($widget) {
    var chartScope = angular.element($widget.find('.chart-component')).scope();

    return _.get(chartScope, '$$childHead.config').getHighcharts();
  }

  vm.initGrid = function () {
    // XXX: Wait for the dashboard.html to render completely,
    // because all the data-XXX attribute values must be set before initializing gridster
    $timeout(function () {
      gridster = $('.gridster ul').gridster({
        widget_base_dimensions: [MIN_GRID_COL_WIDTH, MIN_GRID_COL_HEIGHT],

        // Custom function for serializing the charts. Created in order to
        // add the name parameter to keep track which chart is moved where
        serialize_params: function serialize_params($widget, wgd) {
          var chart = getChart($widget);
          return {
            name: $widget.attr('id'),
            col: wgd.col,
            row: wgd.row,
            size_x: wgd.size_x,
            size_y: wgd.size_y,
            chart_width: chart.chartWidth,
            chart_height: chart.chartHeight
          };
        },

        draggable: {
          stop: function stop(e, ui, $widget) {
            saveGrid();
          }
        },

        resize: {
          enabled: true,
          max_size: [2, 2],
          min_size: [1, 1],
          // Resize a chart and save the changes to DB
          stop: function stop(e, ui, $widget) {
            var isWidgetResized = this.resize_initial_sizex !== this.resize_last_sizex || this.resize_initial_sizey !== this.resize_last_sizey;

            if (!isWidgetResized) {
              return;
            }

            var chart = getChart($widget);

            var newWidth = MIN_GRID_COL_WIDTH * this.resize_last_sizex;
            var newHeight = MIN_GRID_COL_HEIGHT * this.resize_last_sizey;
            newHeight -= chart.container.offsetTop;

            chart.setSize(newWidth, newHeight);

            saveGrid();
          }
        }
      }).data('gridster');
    });
  };

  function saveGrid() {
    var grid = gridster.serialize();

    if (vm.hasSavedChartPositions) {
      DashboardChartPositions.update(grid);
    } else {
      DashboardChartPositions.create(grid);
      vm.hasSavedChartPositions = true;
    }
  }

  function getProject() {
    return Apollo.query(gql('{\n      project(apikey: "' + vm.project.apikey + '") {\n        minimum_charge\n        product_line\n        campaigns(start_at: {lt: "' + thisMonthEndAt.toISOString() + '"}, end_at: {gte: "' + thisMonthStartAt.toISOString() + '"}) {\n          id\n          status\n          start_at\n          end_at\n        }\n        invoices(start_at: {gte: "' + lastYearStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          invoice_price_tax_excluded\n          start_at\n        }\n        zcs_invoices(start_at: {gte: "' + lastYearStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          invoice_price_tax_excluded\n          month\n        }\n        dailyCampaignEventStats(start_at: {gte: "' + thisMonthStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          count\n          start_at\n        }\n        monthlyStats: monthlySiteReportStats(start_at: {gte: "' + lastYearStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          all_campaign {\n            session_count\n            conversion_price\n          }\n          devices {\n            device\n            session_count\n          }\n          start_at\n        }\n        dailyReportStats: dailyReportStats(start_at: {gte: "' + thisMonthStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          start_at\n          invoice_amount\n        }\n        dailyStats: dailySiteReportStats(start_at: {gte: "' + thisMonthStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          start_at\n          all_access {\n            session_count\n            conversion_price\n          }\n          all_campaign {\n            reaction_count\n            session_count\n            conversion_price\n          }\n        }\n      }\n    }')).then(function (res) {
      return res.project;
    }).then(reduceProject);
  }

  function reduceProject(project) {
    project = _.cloneDeep(project);

    project.thisMonthStat = _.find(project.monthlyStats, { start_at: thisMonthStartAt.toISOString() });
    project.lastMonthStat = _.find(project.monthlyStats, { start_at: lastMonthStartAt.toISOString() });
    if (project.product_line === 'zenclerk_s') {
      project.thisMonthInvoice = _.find(project.zcs_invoices, { month: moment(thisMonthStartAt).format(FORMAT) });
      project.lastMonthInvoice = _.find(project.zcs_invoices, { month: moment(lastMonthStartAt).format(FORMAT) });
    } else {
      project.thisMonthInvoice = _.find(project.invoices, { start_at: thisMonthStartAt.toISOString() });
      project.lastMonthInvoice = _.find(project.invoices, { start_at: lastMonthStartAt.toISOString() });
    }

    return project;
  }
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').directive('zcDashboardChartLoader', zcDashboardChartLoader);

zcDashboardChartLoader.$inject = ['$compile'];

function zcDashboardChartLoader($compile) {
  return {
    scope: {
      chart: '<',
      project: '<'
    },
    controller: function controller($element, $scope, $rootScope) {
      var vm = this;
      vm.$onInit = function () {
        var tag = 'zc-dashboard-' + $scope.chart.name + '-chart';
        var component = '<' + tag + '\n          project="$ctrl.project"\n          chart="$ctrl.chart"\n        ></' + tag + '>';

        var newScope = angular.extend($rootScope.$new(), {
          $ctrl: {
            project: $scope.project,
            chart: $scope.chart
          }
        });

        $element.append($compile(component)(newScope));
      };
    }
  };
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDashboardDeliveryChart', {
  templateUrl: '/templates/projects.dashboard/delivery_chart.html',
  bindings: {
    project: '<',
    chart: '<'
  },
  controller: zcDashboardDeliveryChartController
});

zcDashboardDeliveryChartController.$inject = ['$scope', '$translate', '$window', 'ChartV2', 'lineChartV2Config'];

function zcDashboardDeliveryChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var deliveryCounts = [];
    var deliveryCountRatios = [];

    _.each(vm.project.dailyStats, function (stat) {
      var startAtUnixTime = moment(stat.start_at).valueOf();
      var deliveryCountRatio = stat.all_campaign.session_count / stat.all_access.session_count * 100;

      deliveryCounts.push([startAtUnixTime, stat.all_campaign.session_count]);

      deliveryCountRatios.push([startAtUnixTime, deliveryCountRatio]);
    });

    var chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: {
          formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 0) + ' ' + $translate.instant('projectsDashboard.deliveryChart.deliveryCounts');
          }
        }
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: {
          formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 2) + ' %';
          }
        }
      }]
    });

    chart.addSeries({
      type: 'column',
      name: $translate.instant('projectsDashboard.deliveryChart.deliveryCounts'),
      data: deliveryCounts,
      tooltip: {
        valueDecimals: 0
      },
      yAxis: 0
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.deliveryChart.deliveryCountRatios'),
      data: deliveryCountRatios,
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      yAxis: 1
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height
      }
    });
  }
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDashboardDeviceDistributionChart', {
  templateUrl: '/templates/projects.dashboard/device_distribution_chart.html',
  bindings: {
    project: '<',
    chart: '<'
  },
  controller: zcDashboardDeviceDistributionChartController
});

zcDashboardDeviceDistributionChartController.$inject = ['$scope', '$translate', '$window', 'ChartV2', 'pieChartV2Config'];

function zcDashboardDeviceDistributionChartController($scope, $translate, $window, ChartV2, pieChartV2Config) {
  var vm = this;
  vm.deliveryRates = {
    pc: 0,
    sp: 0,
    tablet: 0
  };

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var totalSessionCount = vm.project.thisMonthStat.all_campaign.session_count;

    _.each(vm.project.thisMonthStat.devices, function (deviceStats) {
      vm.deliveryRates[deviceStats.device] = deviceStats.session_count / totalSessionCount * 100;
    });

    var devices = [[$translate.instant('projectsDashboard.deviceDistributionChart.pc'), vm.deliveryRates.pc], [$translate.instant('projectsDashboard.deviceDistributionChart.sp'), vm.deliveryRates.sp], [$translate.instant('projectsDashboard.deviceDistributionChart.tablet'), vm.deliveryRates.tablet]];

    var chart = new ChartV2(pieChartV2Config);

    chart.addSeries({
      type: 'pie',
      name: $translate.instant('projectsDashboard.deviceDistributionChart.device'),
      innerSize: '50%',
      data: devices
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height
      },
      legend: {
        enabled: true,
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle',
        itemMarginTop: 15,
        labelFormatter: function labelFormatter() {
          var percentage = $window.Highcharts.numberFormat(this.percentage, 2);
          return '<div style="margin-top: -12px;">\n            ' + this.name + ' <span class="u-color-babyblue o-type-xl">' + percentage + '</span> %\n          </div>';
        },

        useHTML: true
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false
          },
          showInLegend: true,
          tooltip: {
            valueSuffix: ' %',
            valueDecimals: 1
          }
        }
      }
    });
  }
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDashboardInvoiceChart', {
  templateUrl: '/templates/projects.dashboard/invoice_chart.html',
  bindings: {
    project: '<',
    chart: '<'
  },
  controller: zcDashboardInvoiceChartController
});

zcDashboardInvoiceChartController.$inject = ['$scope', '$translate', '$window', 'ChartV2', 'lineChartV2Config'];
function zcDashboardInvoiceChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    vm.simulation = calculateSimulation();
    vm.predictionAchievementRate = calculatePredictionAchievementRate();
    setChartConfig();
  });

  function calculatePredictionAchievementRate() {
    var thisMonthsInvoicePrice = _.get($scope.$ctrl.project, 'thisMonthInvoice.invoice_price_tax_excluded', 0);
    return thisMonthsInvoicePrice / (thisMonthsInvoicePrice * vm.simulation) * 100;
  }

  function calculateSimulation() {
    var today = moment().add(1, 'day').startOf('day');
    var monthFrom = moment(vm.project.thisMonthStat.start_at).startOf('month');
    var monthTo = moment(vm.project.thisMonthStat.start_at).add(1, 'month').startOf('month');
    var monthDays = monthTo.diff(monthFrom, 'days');
    var currentFrom = moment(vm.project.thisMonthStat.start_at).startOf('day');
    var currentTo = moment.min(monthTo, today);
    var currentDays = currentTo.diff(currentFrom, 'days');
    if (currentDays <= 0) return null;
    return monthDays / currentDays;
  }

  function setChartConfig() {
    var allInvoiceAmounts = [];
    var maxInvoice = [];
    var minimumCharge = [];

    vm.project.dailyReportStats.forEach(function (stat) {
      var startAt = moment(stat.start_at).valueOf();

      allInvoiceAmounts.push([startAt, stat.invoice_amount]);
      maxInvoice.push([startAt, vm.project.max_invoice]);
      minimumCharge.push([startAt, vm.project.minimum_charge]);
    });

    var chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        labels: { formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 0) + ' \u5186';
          } }
      }]
    });

    chart.addSeries({
      type: 'area',
      name: $translate.instant('projectsDashboard.invoiceChart.allInvoiceAmounts'),
      data: allInvoiceAmounts,
      tooltip: {
        valueSuffix: ' 円',
        valueDecimals: 0
      }
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.invoiceChart.maxInvoice'),
      data: maxInvoice,
      tooltip: {
        valueSuffix: ' 円',
        valueDecimals: 0
      }
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.invoiceChart.minimunCharge'),
      data: minimumCharge,
      tooltip: {
        valueSuffix: ' 円',
        valueDecimals: 0
      }
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height
      },
      plotOptions: {
        line: {
          color: '#FF0000',
          dashStyle: 'ShortDash'
        }
      }
    });
  }
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDashboardReactionChart', {
  templateUrl: '/templates/projects.dashboard/reaction_chart.html',
  bindings: {
    project: '<',
    chart: '<'
  },
  controller: zcDashboardReactionChartController
});

zcDashboardReactionChartController.$inject = ['$scope', '$translate', '$window', 'ChartV2', 'lineChartV2Config'];

function zcDashboardReactionChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var reactionCounts = [];
    var reactionCountRatios = [];

    _.each(vm.project.dailyStats, function (stat) {
      var sessionCount = stat.all_access.session_count || 0;
      var reactionCount = stat.all_campaign.reaction_count || 0;
      var reactionCountRatio = reactionCount / sessionCount * 100;
      var startAtUnixTime = moment(stat.start_at).valueOf();

      reactionCounts.push([startAtUnixTime, reactionCount]);

      reactionCountRatios.push([startAtUnixTime, reactionCountRatio]);
    });

    var chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: {
          formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 0) + ' ' + $translate.instant('projectsDashboard.reactionChart.reactionCounts');
          }
        }
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: {
          formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 2) + ' %';
          }
        }
      }]
    });

    chart.addSeries({
      type: 'column',
      name: $translate.instant('projectsDashboard.reactionChart.reactionCounts'),
      data: reactionCounts,
      tooltip: {
        valueDecimals: 0
      },
      yAxis: 0
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.reactionChart.reactionCountRatios'),
      data: reactionCountRatios,
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      yAxis: 1
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height
      }
    });
  }
}

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects.campaigns').config(routerConfig);

routerConfig.$inject = ['$stateProvider'];

function routerConfig($stateProvider) {
  $stateProvider.state('admin.projects.dashboard', {
    url: '/dashboard',
    views: {
      'content@': {
        template: '<zc-dashboard project="$resolve.currentProject"></zc-dashboard>'
      }
    }
  });
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _heatmap = __webpack_require__(110);

var _heatmap2 = _interopRequireDefault(_heatmap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('zc.projects.heatmap').component('zcHeatmap', {
  templateUrl: '/templates/projects.heatmap/heatmap.html',
  bindings: {
    project: '<'
  },
  controller: zcHeatmapController
});

zcHeatmapController.$inject = ['$element', '$stateParams', 'Services'];
function zcHeatmapController($element, $stateParams, Services) {
  var vm = this;
  var heatmap = null; // eslint-disable-line
  var heatmapUrls = {
    1: 'http://www.mtgec.jp/shop/default.aspx'
  };

  vm.$onInit = function () {
    // TODO: HACK! figure out how to properly encode url
    vm.url = heatmapUrls[$stateParams.url];
    vm.showLayers = {
      clicks: true,
      mouseMovement: true,
      outsideBoundaries: false,
      insights: true
    };

    vm.insights = [{
      x: 215,
      y: 259,
      message: 'バナーが注目されない為、画像変更、または削除をお勧めいたします。'
    }, {
      x: 615,
      y: 1159,
      message: '隣のボタンがよりクリックが少ない為、文言変更をお勧めいたします。'
    }, {
      x: 74,
      y: 2251,
      message: '注目度が高い為、上に上げることをお勧めいたします。'
    }, {
      x: 400,
      y: 4250,
      message: '注目度が高い為、上に上げることをお勧めいたします。'
    }, {
      x: 89,
      y: 4421,
      message: '注目度が高い為、上に上げることをお勧めいたします。'
    }, {
      x: 400,
      y: 6150,
      message: '注目度が高い為、上に上げることをお勧めいたします。'
    }];

    vm.filters = {
      convertedUsers: false,
      newUsers: false
    };

    vm.redraw = redraw;

    initializeHeatmap(vm.url);
  };

  function initializeHeatmap(url) {
    var element = $element.find('.svg-container-main')[0];
    vm.heatmap = new _heatmap2.default(element, Services, vm.showLayers, vm.filters);
  }

  function redraw() {
    vm.heatmap.redraw();
  }
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects.heatmap').component('zcHeatmapList', {
  templateUrl: '/templates/projects.heatmap/heatmap_list.html',
  controller: function controller($scope) {
    $scope.pages = [{
      id: 1,
      url: 'http://www.mtgec.jp/shop/default.aspx',
      name: 'http://www.mtgec.jp/shop/default.aspx'
    }];
  },
  bindings: {
    project: '<'
  }
});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects.heatmap').config(heatmapRouterConfig);

heatmapRouterConfig.$inject = ['$stateProvider'];
function heatmapRouterConfig($stateProvider) {

  $stateProvider.state('admin.projects.heatmap', {
    url: '/heatmap',
    views: {
      'content@': {
        template: '<zc-heatmap-list project="$resolve.project"></zc-heatmap-list>',
        resolve: {}
      }
    }
  }).state('admin.projects.heatmap.show', {
    url: '/:url',
    views: {
      'content@': {
        template: '<zc-heatmap></zc-heatmap>',
        resolve: {}
      }
    }
  });
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').controller('uniqueCouponCodeCSVUploadController', uniqueCouponCodeCSVUploadController);

uniqueCouponCodeCSVUploadController.$inject = ['$scope', '$state', '$translate', 'UniqueCouponCode'];
function uniqueCouponCodeCSVUploadController($scope, $state, $translate, UniqueCouponCode) {
  $scope.$on('flow::fileAdded', function (event, $flow, flowFile) {
    event.preventDefault();
    UniqueCouponCode.upload({
      projectId: $state.params.projectId,
      incentiveId: $state.params.incentiveId
    }, {
      file: flowFile.file
    }).then(function (res) {
      if (res.excluded.length > 0) {
        var excludedCodes = $translate.instant('projectsIncentives.controllers.uniqueCouponCodeCsvUpload.jogai_saretakuuponkoodo', {
          list: res.excluded.join(', ')
        });
        // eslint-disable-next-line no-undef
        alertify.error(excludedCodes, 0);
      }
      $state.reload();
    });
  });
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').directive('zcUniqueCouponCodeList', zcUniqueCouponCodeList);

zcUniqueCouponCodeList.$inject = ['$translate', 'UniqueCouponCode'];
function zcUniqueCouponCodeList($translate, UniqueCouponCode) {
  return {
    restrict: 'E',
    scope: {
      incentive: '=',
      project: '='
    },
    templateUrl: '/templates/projects.incentives/unique_coupon_code_list.html',
    link: function link(scope) {
      scope.visibleItemCount = scope.countPerLoad = 10;
      scope.uniqueCouponCodes = [];

      scope.csvFileName = [scope.project.apikey, 'incentive' + scope.incentive.id, moment().format('YYYYMMDD')].join('-') + '.csv';

      scope.getCSV = function () {
        var csvData = _.map(scope.uniqueCouponCodes, function (couponCode) {
          var delivered = 'no';
          var deliveryDate = null;
          if (couponCode.assigned_at) {
            delivered = 'yes';
            deliveryDate = moment(new Date(couponCode.assigned_at)).format('YYYY/MM/DD HH:mm:ss');
          }

          return [couponCode.coupon_code, delivered, deliveryDate];
        });

        csvData.unshift([$translate.instant('projectsIncentives.uniqueCouponCodeList.code'), $translate.instant('projectsIncentives.uniqueCouponCodeList.delivered'), $translate.instant('projectsIncentives.uniqueCouponCodeList.deliveryDate')]);

        return csvData;
      };

      UniqueCouponCode.all({
        projectId: scope.incentive.project_id,
        incentiveId: scope.incentive.id
      }).then(function (uniqueCouponCodes) {
        scope.uniqueCouponCodes = _.sortBy(uniqueCouponCodes, 'assigned_at');
      });
    }
  };
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwConversionPrice', {
  templateUrl: '/templates/projects.iw/iw_conversion_price.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwConversionPriceController
});

zcIwConversionPriceController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'areaChartV2Config', 'iwGraphOptions', 'currencies', 'lib'];
function zcIwConversionPriceController($scope, $translate, InterestWidgetStats, ChartV2, areaChartV2Config, iwGraphOptions, currencies, lib) {
  var vm = this;

  var currency = currencies[vm.project.currency];
  var tooltip = {
    valueSuffix: currency.suffix,
    valueDecimals: currency.fractionSize
  };

  var chart = new ChartV2(areaChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      var conversionPriceData = [];
      var conversionPriceWithCampaignData = [];
      lib.accumulateCountMap(stats).forEach(function (stat) {
        stat = InterestWidgetStats.transform(stat);
        conversionPriceData.push([stat.start_at.valueOf(), stat.iw_click_item.conversion_price]);
        conversionPriceWithCampaignData.push([stat.start_at.valueOf(), stat.iw_click_item.conversion_price_with_campaign]);
      });
      chart.resetSeries();
      chart.addSeries({ name: $translate.instant('projectsIw.conversionPrice.conversionPriceData'), data: conversionPriceData, tooltip: tooltip });
      chart.addSeries({ name: $translate.instant('projectsIw.conversionPrice.conversionPriceWithCampaignData'), data: conversionPriceWithCampaignData, tooltip: tooltip });
    });
  }
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwConversionRate', {
  templateUrl: '/templates/projects.iw/iw_conversion_rate.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwConversionRateController
});

zcIwConversionRateController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'columnChartV2Config', 'iwGraphOptions', 'lib'];
function zcIwConversionRateController($scope, $translate, InterestWidgetStats, ChartV2, columnChartV2Config, iwGraphOptions, lib) {
  var vm = this;

  var graphOption = iwGraphOptions[0];
  var tooltip = {
    valueSuffix: graphOption.unit,
    valueDecimals: graphOption.decimal
  };

  var chart = new ChartV2(columnChartV2Config, {
    xAxis: { categories: [$translate.instant('projectsIw.conversionRate.iwUse'), $translate.instant('projectsIw.conversionRate.noIwUse')] }
  });
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      chart.resetSeries();
      var data = stats.length ? [vm.total.iw_use.conversion_rate, vm.total.no_iw_use.conversion_rate] : [0, 0];
      chart.addSeries({
        colorByPoint: true,
        name: graphOption.label,
        data: data,
        tooltip: tooltip
      });
    });
  }
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').factory('iwGraphOptions', iwGraphOptions);

iwGraphOptions.$inject = ['$filter'];
function iwGraphOptions($filter) {
  return [{
    name: 'conversion_rate',
    label: $filter('translate')('projectsIw.graphOptions.conversionRate'),
    unit: ' %',
    decimal: 1
  }, {
    name: 'cart_button_click_rate',
    label: $filter('translate')('projectsIw.graphOptions.cartButtonClickRate'),
    unit: ' %',
    decimal: 1 }, {
    name: 'average_item_count',
    label: $filter('translate')('projectsIw.graphOptions.averageItemCount'),
    unit: ' PV',
    decimal: 1
  }, {
    name: 'average_conversion_price',
    label: $filter('translate')('projectsIw.graphOptions.averageConversionPrice'),
    unit: ' 円',
    decimal: 0
  }];
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwItems', {
  templateUrl: '/templates/projects.iw/iw_items.html',
  bindings: {
    project: '<'
  },
  controller: zcIwItemsController
});

zcIwItemsController.$inject = ['$scope', '$translate', 'Page', 'SearchFilter', 'InterestWidgetItem'];
function zcIwItemsController($scope, $translate, Page, SearchFilter, InterestWidgetItem) {
  var vm = this;

  var CSV_HEADERS = [{ name: 'title', title: $translate.instant('projectsIw.items.title') }, { name: 'url', title: $translate.instant('projectsIw.items.url') }, { name: 'thumbnail_url', title: $translate.instant('projectsIw.items.thumbnailUrl') }, { name: 'price', title: $translate.instant('projectsIw.items.price') }, { name: 'item_count', title: $translate.instant('projectsIw.items.itemCount') }, { name: 'iw_item_count', title: $translate.instant('projectsIw.items.iwItemCount') }, { name: 'iw_item_rate', title: $translate.instant('projectsIw.items.iwItemRate') }];

  Page.setBodyClass('');
  $translate('projectsIw.items.deliveryStatus').then(function (translation) {
    Page.setTitle(translation);
  });

  vm.filters = SearchFilter.resolveFromLocation({
    start_at: moment().startOf('month'),
    end_at: moment().endOf('day')
  });

  vm.csvHeaders = _.map(CSV_HEADERS, 'title');
  vm.csvHeaderNames = _.map(CSV_HEADERS, 'name');

  vm.page = 1;
  vm.itemsPerPage = 10;
  vm.beginItem = 0;

  vm.pageChanged = pageChanged;
  vm.getCSV = getCSV;
  vm.updateFilters = updateFilters;
  vm.resetFilters = resetFilters;

  vm.$onInit = function () {
    vm.updateFilters();
    $scope.$on('destroy', destroy);
  };

  function updateFilters() {
    var device = vm.filters.device_value ? vm.filters.device_value.name : null;
    if (device === 'pc') {
      device = { $in: ['pc', 'tablet'] };
    } else if (device === 'sp') {
      device = 'sp';
    }
    var campaignSegmentId = vm.filters.campaign_segment_value ? vm.filters.campaign_segment_value.id : null;
    _.merge(vm.filters, {
      device: device,
      campaign_segment_id: campaignSegmentId,
      start_at: vm.filters.start_at,
      end_at: vm.filters.end_at
    });
    SearchFilter.set(vm.filters);
    updateData();
  }

  function pageChanged() {
    vm.beginItem = (vm.page - 1) * vm.itemsPerPage;
  }

  function getCSV() {
    return _.map(vm.items, function (item) {
      return _.pick(item, vm.csvHeaderNames);
    });
  }

  function updateData() {
    SearchFilter.updateComponentDefaults('zcIwItems');
    InterestWidgetItem.rankByFilters(vm.project.apikey, vm.filters).then(function (items) {
      vm.items = items;
    });
  }

  function resetFilters() {
    SearchFilter.resetComponentDefaults('zcIwItems');
  }

  function destroy() {
    SearchFilter.removeComponentDefaults('zcIwItems');
  }
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwMainComparison', {
  templateUrl: '/templates/projects.iw/iw_main_comparison.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwMainComparisonController
});

zcIwMainComparisonController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'SearchFilter', 'ChartV2', 'lineChartV2Config', 'iwGraphOptions', 'currencies', 'lib'];
function zcIwMainComparisonController($scope, $translate, InterestWidgetStats, SearchFilter, ChartV2, lineChartV2Config, iwGraphOptions, currencies, lib) {
  var vm = this;

  vm.currency = currencies[vm.project.currency];
  vm.iwGraphOptions = iwGraphOptions;
  vm.updateData = updateData;

  var chart = new ChartV2(lineChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
    $scope.$on('filtersReset', reset);
    $scope.$on('destroy', destroy);
  };

  SearchFilter.setComponentDefaults('zcIwReport', {
    iw_graph_option: {
      default: vm.iwGraphOptions[0].name,
      keyProperty: 'name',
      getter: function getter(name) {
        return _.find(vm.iwGraphOptions, function (opt) {
          return opt.name === name;
        });
      }
    }
  });

  function updateData() {
    SearchFilter.updateComponentDefaults('zcIwReport');
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      var iwUseData = [];
      var noIwUseData = [];
      stats.forEach(function (stat) {
        stat = InterestWidgetStats.transform(stat);
        iwUseData.push([stat.start_at.valueOf(), stat.iw_use[vm.filters.iw_graph_option_value.name]]);
        noIwUseData.push([stat.start_at.valueOf(), stat.no_iw_use[vm.filters.iw_graph_option_value.name]]);
      });
      var tooltip = getTooltip();
      chart.resetSeries();
      chart.addSeries({ name: $translate.instant('projectsIw.mainComparison.iwUseData'), data: iwUseData, tooltip: tooltip });
      chart.addSeries({ name: $translate.instant('projectsIw.mainComparison.noIwUseData'), data: noIwUseData, tooltip: tooltip });
    });
  }

  function getTooltip() {
    if (vm.filters.iw_graph_option_value.name === 'average_conversion_price') {
      return {
        valueSuffix: vm.currency.suffix,
        valueDecimals: vm.currency.fractionSize
      };
    }
    return {
      valueSuffix: vm.filters.iw_graph_option_value.unit,
      valueDecimals: vm.filters.iw_graph_option_value.decimal
    };
  }

  function reset() {
    SearchFilter.resetComponentDefaults('zcIwReport');
  }

  function destroy() {
    SearchFilter.removeComponentDefaults('zcIwReport');
  }
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwNavigation', {
  templateUrl: '/templates/projects.iw/iw_navigation.html',
  bindings: {
    project: '<'
  }
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwReport', {
  templateUrl: '/templates/projects.iw/iw_report.html',
  bindings: {
    project: '<'
  },
  controller: zcIwReportController
});

zcIwReportController.$inject = ['$scope', '$translate', '$q', 'Page', 'SearchFilter', 'InterestWidgetStats', 'lib'];
function zcIwReportController($scope, $translate, $q, Page, SearchFilter, InterestWidgetStats, lib) {
  var vm = this;

  var RELEASED_AT = moment('2017/08/01', 'YYYY/MM/DD').toDate();

  Page.setBodyClass('');
  $translate('projectsIw.report.deliveryStatus').then(function (translation) {
    Page.setTitle(translation);
  });

  vm.filters = SearchFilter.resolveFromLocation({
    start_at: moment().startOf('month'),
    end_at: moment().endOf('day')
  });

  vm.showBetaAlert = false;
  vm.updateFilters = updateFilters;
  vm.resetFilters = resetFilters;

  vm.$onInit = function () {
    vm.updateFilters();
  };

  function updateFilters() {
    vm.showBetaAlert = moment(vm.filters.start_at).isBefore(RELEASED_AT);
    var device = vm.filters.device_value ? vm.filters.device_value.name : null;
    if (device === 'pc') {
      device = { $in: ['pc', 'tablet'] };
      vm.iwFixedMonthlyInvoiceAmount = vm.project.iw_fixed_monthly_invoice_amount_for_pc;
    } else if (device === 'sp') {
      vm.iwFixedMonthlyInvoiceAmount = vm.project.iw_fixed_monthly_invoice_amount_for_sp;
    } else {
      vm.iwFixedMonthlyInvoiceAmount = vm.project.iw_fixed_monthly_invoice_amount_for_pc + vm.project.iw_fixed_monthly_invoice_amount_for_sp;
    }
    _.merge(vm.filters, {
      device: device,
      start_at: vm.filters.start_at,
      end_at: vm.filters.end_at
    });
    SearchFilter.set(vm.filters);
    $scope.$broadcast('filtersUpdated');
    updateData();
  }

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      if (stats.length) {
        vm.current_billing = getCurrentBilling();
        vm.costEffectiveness = vm.current_billing !== 0 ? vm.total.iw_click_item.conversion_price / vm.current_billing * 100 : 0;
        vm.costRate = vm.total.iw_click_item.conversion_price !== 0 ? vm.current_billing / vm.total.iw_click_item.conversion_price * 100 : 0;
      } else {
        vm.current_billing = vm.costEffectiveness = vm.costRate = 0;
      }
    });
  }

  function resetFilters() {
    $scope.$broadcast('filtersReset');
  }

  function getCurrentBilling() {
    var totalBillingFrom = moment(vm.filters.start_at).startOf('month');
    var totalBillingTo = moment(vm.filters.end_at).add(1, 'month').startOf('month');
    var totalBillingMonths = totalBillingTo.diff(totalBillingFrom, 'months');
    var totalBillingDays = totalBillingTo.diff(totalBillingFrom, 'days');
    var currentBillingFrom = moment(vm.filters.start_at).startOf('day');
    var currentBillingTo = moment(vm.filters.end_at).add(1, 'day').startOf('day');
    var currentBillingDays = currentBillingTo.diff(currentBillingFrom, 'days');
    return vm.iwFixedMonthlyInvoiceAmount * totalBillingMonths * (currentBillingDays / totalBillingDays);
  }
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwSegmentRate', {
  templateUrl: '/templates/projects.iw/iw_segment_rate.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwSegmentRateController
});

zcIwSegmentRateController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'pieChartV2Config', 'lib'];
function zcIwSegmentRateController($scope, $translate, InterestWidgetStats, ChartV2, pieChartV2Config, lib) {
  var vm = this;

  var chart = new ChartV2(pieChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      var data = [];
      if (vm.total.iw_use.nocv_session_rate) {
        data.push([$translate.instant('projectsIw.segmentRate.nocvSessionRate'), vm.total.iw_use.nocv_session_rate]);
      }
      if (vm.total.iw_use.onecv_session_rate) {
        data.push([$translate.instant('projectsIw.segmentRate.onecvSessionRate'), vm.total.iw_use.onecv_session_rate]);
      }
      if (vm.total.iw_use.loyal_session_rate) {
        data.push([$translate.instant('projectsIw.segmentRate.loyalSessionRate'), vm.total.iw_use.loyal_session_rate]);
      }
      chart.resetSeries();
      chart.addSeries({ data: data });
    });
  }
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwStartedRate', {
  templateUrl: '/templates/projects.iw/iw_started_rate.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwStartedRateController
});

zcIwStartedRateController.$inject = ['$scope', '$filter', '$window', 'InterestWidgetStats', 'ChartV2', 'lineChartV2Config', 'lib'];
function zcIwStartedRateController($scope, $filter, $window, InterestWidgetStats, ChartV2, lineChartV2Config, lib) {
  var vm = this;

  var chart = new ChartV2(lineChartV2Config, {
    yAxis: [{
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          return $window.Highcharts.numberFormat(this.value, 0) + ' ' + $filter('translate')('sharedModules.common.unit.session');
        }
      }
    }, {
      opposite: true,
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          return $window.Highcharts.numberFormat(this.value, 2) + ' %';
        }
      }
    }]
  });
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      var iwStartedStats = [];
      var iwStartedRateStats = [];
      stats.forEach(function (stat) {
        stat = InterestWidgetStats.transform(stat);
        iwStartedStats.push([stat.start_at.valueOf(), stat.iw_started.session_count]);
        iwStartedRateStats.push([stat.start_at.valueOf(), stat.iw_started_rate]);
      });
      chart.resetSeries();
      chart.addSeries({
        type: 'column',
        name: $filter('translate')('projectsIw.startedRate.deliverySessionCount'),
        data: iwStartedStats,
        tooltip: {
          valueSuffix: $filter('translate')('projectsIw.startedRate.session'),
          valueDecimals: 0
        },
        yAxis: 0
      });
      chart.addSeries({
        type: 'line',
        name: $filter('translate')('projectsIw.startedRate.deliveryRate'),
        data: iwStartedRateStats,
        tooltip: {
          valueSuffix: '%',
          valueDecimals: 1
        },
        yAxis: 1
      });
    });
  }
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwUseRate', {
  templateUrl: '/templates/projects.iw/iw_use_rate.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwUseRateController
});

zcIwUseRateController.$inject = ['$scope', '$filter', '$window', 'InterestWidgetStats', 'ChartV2', 'lineChartV2Config', 'lib'];
function zcIwUseRateController($scope, $filter, $window, InterestWidgetStats, ChartV2, lineChartV2Config, lib) {
  var vm = this;

  var chart = new ChartV2(lineChartV2Config, {
    yAxis: [{
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          return $window.Highcharts.numberFormat(this.value, 0) + ' ' + $filter('translate')('sharedModules.common.unit.session');
        }
      }
    }, {
      opposite: true,
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          return $window.Highcharts.numberFormat(this.value, 2) + ' %';
        }
      }
    }]
  });
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      var iwUseStats = [];
      var iwUseRateStats = [];
      stats.forEach(function (stat) {
        stat = InterestWidgetStats.transform(stat);
        iwUseStats.push([stat.start_at.valueOf(), stat.iw_use.session_count]);
        iwUseRateStats.push([stat.start_at.valueOf(), stat.iw_use_rate]);
      });
      chart.resetSeries();
      chart.addSeries({
        type: 'column',
        name: $filter('translate')('projectsIw.useRate.deliverySessionCount'),
        data: iwUseStats,
        tooltip: {
          valueSuffix: $filter('translate')('projectsIw.useRate.deliverySessionCount'),
          valueDecimals: 0
        },
        yAxis: 0
      });
      chart.addSeries({
        type: 'line',
        name: $filter('translate')('projectsIw.useRate.deliverySessionCount'),
        data: iwUseRateStats,
        tooltip: {
          valueSuffix: '%',
          valueDecimals: 1
        },
        yAxis: 1
      });
    });
  }
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcIwUtmMediumRate', {
  templateUrl: '/templates/projects.iw/iw_utm_medium_rate.html',
  bindings: {
    project: '<',
    filters: '<'
  },
  controller: zcIwUtmMediumRateController
});

zcIwUtmMediumRateController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'pieChartV2Config', 'lib'];
function zcIwUtmMediumRateController($scope, $translate, InterestWidgetStats, ChartV2, pieChartV2Config, lib) {
  var vm = this;

  var chart = new ChartV2(pieChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = function () {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters).then(function (stats) {
      vm.utmMediumData = getUtmMediumData(stats);
      chart.resetSeries();
      chart.addSeries({ data: getChartData(vm.utmMediumData) });
    });
  }

  function getUtmMediumData(stats) {
    var data = [];
    var otherCount = 0;
    var otherRate = 0;
    if (stats.length) {
      var total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      data = _.chain(total.iw_use.utm_medium_count_map).keys().map(function (key) {
        return {
          key: _.truncate(key, { length: 14, omission: '…' }),
          count: total.iw_use.utm_medium_count_map[key],
          rate: total.iw_use.utm_medium_rate_map[key]
        };
      }).sortBy('rate').reverse().value();
      otherCount = total.iw_use.session_count - _.sumBy(data, 'count');
      otherRate = total.iw_use.session_count !== 0 ? otherCount / total.iw_use.session_count * 100 : 0;
    }
    data.push({ key: $translate.instant('projectsIw.utmMediumRate.other'), count: otherCount, rate: otherRate });
    return data;
  }

  function getChartData(data) {
    if (_.sumBy(data, 'count') >= 1) {
      return data.map(function (datum) {
        return [datum.key, datum.rate];
      });
    }
    return [];
  }
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').controller('zcNoPublishPageTypeCsvController', zcNoPublishPageTypeCsvController);

zcNoPublishPageTypeCsvController.$inject = ['$scope', 'Project'];
function zcNoPublishPageTypeCsvController($scope, Project) {
  $scope.$on('flow::fileAdded', function (event, $flow, flowFile) {
    event.preventDefault();
    Project.uploadPageTypes({
      projectId: $scope.project.id,
      page_type: 'no_publish'
    }, {
      file: flowFile.file
    }).then(function (pageTypesResponse) {
      var pageTypes = _.filter(pageTypesResponse, { page_type: 'no_publish' });
      $scope.$emit('uploadedPageTypes', pageTypes);
    });
  });
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').component('zcNoPublishPageForm', {
  bindings: {
    project: '=',
    pageType: '=',
    onDestroy: '&'
  },
  templateUrl: '/templates/projects.settings/campaign/no_publish_page_type_form.html',
  controllerAs: 'vm',
  controller: zcNoPublishPageFormController
});

zcNoPublishPageFormController.$inject = ['$scope', '$timeout', '$translate', 'PageType'];
function zcNoPublishPageFormController($scope, $timeout, $translate, PageType) {
  var vm = this;

  vm.matchTypes = [{ name: $translate.instant('projectsSettings.campaign.noPublishPageTypeForm.prefix'), value: 'prefix' }, { name: $translate.instant('projectsSettings.campaign.noPublishPageTypeForm.full'), value: 'full' }, { name: $translate.instant('projectsSettings.campaign.noPublishPageTypeForm.partial'), value: 'partial' }];

  vm.isDestroying = false;
  vm.isSaving = false;

  vm.savePageType = function () {
    vm.isSaving = true;

    if (vm.pageType.id) {
      PageType.update({ projectId: vm.project.id, id: vm.pageType.id }, { page_type: vm.pageType }).then(mergePageType);
    } else {
      PageType.create({ projectId: vm.project.id }, { page_type: vm.pageType }).then(mergePageType);
    }
  };

  vm.destroyPageType = function () {
    if (!vm.pageType.id) {
      // Apply digest loop by $timeout after destroying the page type
      $timeout(function () {
        return vm.onDestroy({ pageType: vm.pageType });
      });
    } else {
      vm.isDestroying = true;
      PageType.destroy(vm.pageType).then(function (res) {
        vm.onDestroy({ pageType: vm.pageType });
        vm.isDestroying = false;
      });
    }
  };

  function mergePageType(res) {
    vm.pageType = _.merge(vm.pageType, res);
    vm.isSaving = false;
    $scope.noPublishPageForm.$setPristine();
  }
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').controller('MenuController', MenuController);

MenuController.$inject = ['Devise', 'currentProject'];
function MenuController(Devise, currentProject) {
  var vm = this;

  vm.showsExcludePageType = currentProject.shows_no_publish_page_type;
  vm.enableServiceLens = currentProject.enable_service_lens;
  vm.isMaster = Devise.isMaster();
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').directive('zcItemListPriceConfirm', zcItemListPriceConfirm);

zcItemListPriceConfirm.$inject = ['$filter', 'BaseProjectConfirm'];
function zcItemListPriceConfirm($filter, BaseProjectConfirm) {
  var confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.itemListPriceConfirm.productList'), ['item_list_price']);
  return confirm.createDirective(confirm.requestRecentHistories);
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').component('zcInternalUserTable', {
  templateUrl: '/templates/projects.settings/users/internal_user_table.html',
  bindings: {
    project: '<'
  },
  controller: InternalUserTable,
  controllerAs: 'vm'
});

InternalUserTable.$inject = ['Apollo', 'Devise'];
function InternalUserTable(Apollo, Devise) {
  var vm = this;

  vm.internalUsers = [];
  vm.isCommonUser = Devise.isCommonUser();
  vm.userManagementURL = ZC_CONFIG.AIDEAL_URL + '/site/' + vm.project.apikey + '/settings/general/users';

  function getInternalUsers() {
    var GET_INTERNAL_USERS = gql('\n      query GetInternalUsers($apikey: String, $role: UserRole) {\n        project(apikey: $apikey) {\n          users(role: $role) {\n            full_name\n            email\n          }\n        }\n      }');

    return Apollo.masterQuery(GET_INTERNAL_USERS, {
      apikey: vm.project.apikey,
      role: 'internal'
    });
  }

  vm.$onInit = function () {
    getInternalUsers().then(function (res) {
      vm.internalUsers = _.cloneDeep(_.get(res, 'project.users', []));
    });
  };
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CATEGORIES = ['配信数', '経由売上', '獲得売上'];
var FIELDS = ['session_count', 'conversion_price', 'contribution_price'];

angular.module('zc').component('zcSiteReportCampaignSegment', {
  templateUrl: '/templates/projects.site_reports/campaign_segment.html',
  bindings: { project: '<' },
  controller: zcSiteReportCampaignSegment
});

zcSiteReportCampaignSegment.$inject = ['$scope', 'ChartV2', 'barChartV2Config'];
function zcSiteReportCampaignSegment($scope, ChartV2, barChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var categories = void 0;
    var fields = void 0;
    if (vm.project.is_abtest) {
      categories = CATEGORIES;
      fields = FIELDS;
    } else {
      categories = CATEGORIES.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    var chart = new ChartV2(barChartV2Config, { xAxis: { categories: categories } });
    vm.chartConfig = chart.getConfig();
    var segments = _.sortBy(vm.project.campaigns, function (segment) {
      if (!segment.name) return -1; // Move to the last
      return segment.session_count;
    });
    _.each(segments, function (segment) {
      var name = segment.name || '不明';
      var data = _.map(fields, function (field) {
        return _.get(segment, field);
      });
      chart.addSeries({ stacking: 'percent', name: name, data: data });
    });
  }
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HEADERS = ['ID', 'デバイス', 'キャンペーン', '開始日時', '終了日時', '配信数', 'コンバージョン率', '経由売上', '平均単価', 'カートボタンクリック率', 'コンバージョン上昇率', '平均単価上昇率', '非表示率'];

var FIELDS = ['id', 'device', 'name', 'start_at', 'end_at', 'delivery_count', 'conversion_rate', 'conversion_price', 'average_conversion_price', 'cart_button_click_rate', 'conversion_up_rate', 'conversion_price_up_rate', 'control_percent'];

var FORMAT = 'YYYYMM';

angular.module('zc').component('zcSiteReportCampaignTable', {
  templateUrl: '/templates/projects.site_reports/campaign_table.html',
  bindings: { project: '<' },
  controller: zcSiteReportCampaignTableController
});

zcSiteReportCampaignTableController.$inject = ['$scope', 'ChartV2', 'funnelChartV2Config'];
function zcSiteReportCampaignTableController($scope, ChartV2, currencies, funnelChartV2Config) {
  var vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / Math.pow(10, $scope.currency.fractionSize);

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.campaigns) return;
    vm.getCSV = getCSV;
    vm.filename = getFilename();
    vm.project.campaigns.forEach(function (campaign) {
      campaign.banner = campaign.element.message.banner;
      setChartConfig(campaign);
    });
  });

  function setChartConfig(campaign) {
    var data = _.sortBy([
    // NOTE: Rooting values in order to balance each data in view
    ['配信', Math.sqrt(campaign.session_count)], ['カートボタンクリック', Math.sqrt(campaign.cart_button_click_count)], ['コンバージョン', Math.sqrt(campaign.conversion_count)]], function (i) {
      return -i[1];
    });
    var chart = new ChartV2(funnelChartV2Config);
    campaign.chartConfig = chart.getConfig();
    chart.addSeries({ name: '訪問数', data: data });
  }

  function getFilename() {
    var yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return 'campaigns-table-' + vm.project.apikey + '-' + yearMonth + '.csv';
  }

  function getCSV() {
    if (!vm.project.campaigns) return;
    var result = [];
    result.push(HEADERS);
    vm.project.campaigns.forEach(function (campaign) {
      var row = FIELDS.map(function (field) {
        return _.get(campaign, field);
      });
      result.push(row);
    });
    return result;
  }
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HEADERS = ['日付', '経由売上', 'サイト月商', '配信カバー率'];

var FIELDS = ['start_at', 'all_campaign.conversion_price', 'all_access.conversion_price', 'conversion_cover_rate'];

var FORMAT = 'YYYYMM';

angular.module('zc').component('zcSiteReportConversionCover', {
  templateUrl: '/templates/projects.site_reports/conversion_cover.html',
  bindings: { project: '<' },
  controller: zcSiteReportConversionCover
});

zcSiteReportConversionCover.$inject = ['$scope', '$window', 'Apollo', 'ChartV2', 'lineChartV2Config'];
function zcSiteReportConversionCover($scope, $window, Apollo, ChartV2, currencies, lineChartV2Config) {
  var vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / Math.pow(10, $scope.currency.fractionSize);

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.dailyStats) return;
    vm.filename = getFilename();
    vm.getCSV = getCSV;
    setChartConfig();
  });

  function getFilename() {
    var yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return 'conversion-cover-' + vm.project.apikey + '-' + yearMonth + '.csv';
  }

  function getCSV() {
    if (!vm.project.dailyStats) return;
    var result = [];
    result.push(HEADERS);
    vm.project.dailyStats.forEach(function (stat) {
      var row = FIELDS.map(function (field) {
        return _.get(stat, field);
      });
      result.push(row);
    });
    return result;
  }

  function setChartConfig() {
    var allAccesses = [];
    var allCampaigns = [];
    vm.project.dailyStats.forEach(function (stat) {
      if (!stat.conversion_cover_rate) return;
      var startAt = moment(stat.start_at).valueOf();
      allAccesses.push([startAt, stat.all_access.conversion_price]);
      allCampaigns.push([startAt, stat.conversion_cover_rate * 100]);
    });
    var chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: { formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 0) + ' \u5186';
          } }
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: { formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 2) + ' %';
          } }
      }]
    });
    vm.chartConfig = chart.getConfig();
    chart.addSeries({
      type: 'column',
      name: '経由売上',
      data: allAccesses,
      tooltip: {
        valueSuffix: '円',
        valueDecimals: 0
      },
      yAxis: 0
    });
    chart.addSeries({
      type: 'line',
      name: '売上カバー率',
      data: allCampaigns,
      tooltip: {
        valueSuffix: '%',
        valueDecimals: 1
      },
      yAxis: 1
    });
  }
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HEADERS = ['日付', 'サイト月商', '経由売上', '伸ばした売上'];

var FIELDS = ['start_at', 'all_access.conversion_price', 'all_campaign.conversion_price', 'contribution_price'];

var FORMAT = 'YYYYMM';

angular.module('zc').component('zcSiteReportConversionPrice', {
  templateUrl: '/templates/projects.site_reports/conversion_price.html',
  bindings: { project: '<' },
  controller: zcSiteReportConversionPriceController
});

zcSiteReportConversionPriceController.$inject = ['$scope', 'ChartV2', 'areaChartV2Config'];
function zcSiteReportConversionPriceController($scope, ChartV2, currencies, areaChartV2Config) {
  var vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / Math.pow(10, $scope.currency.fractionSize);

  var tooltip = { valueSuffix: $scope.currency.symbol ? $scope.currency.symbol : $scope.currency.suffix };

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.cumulativeDailyStats) return;
    vm.filename = getFilename();
    vm.getCSV = getCSV;
    setChartConfig();
  });

  function getFilename() {
    var yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return 'conversion-price-' + vm.project.apikey + '-' + yearMonth + '.csv';
  }

  function getCSV() {
    if (!vm.project.cumulativeDailyStats) return;
    var headers = void 0;
    var fields = void 0;
    if (vm.project.is_abtest) {
      headers = HEADERS;
      fields = FIELDS;
    } else {
      headers = HEADERS.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    var result = [];
    result.push(headers);
    vm.project.cumulativeDailyStats.forEach(function (stat) {
      var row = fields.map(function (field) {
        return _.get(stat, field);
      });
      result.push(row);
    });
    return result;
  }

  function setChartConfig() {
    var allAccesses = [];
    var allCampaigns = [];
    var allContributions = [];
    _.each(vm.project.cumulativeDailyStats, function (stat) {
      var startAt = moment(stat.start_at).valueOf();
      allAccesses.push([startAt, stat.all_access.conversion_price]);
      allCampaigns.push([startAt, stat.all_campaign.conversion_price]);
      allContributions.push([startAt, stat.contribution_price]);
    });
    var chart = new ChartV2(areaChartV2Config);
    vm.chartConfig = chart.getConfig();
    chart.addSeries({ name: 'サイト月商', data: allAccesses, tooltip: tooltip });
    chart.addSeries({ name: '経由売上', data: allCampaigns, tooltip: tooltip });
    if (!vm.project.is_abtest) return;
    chart.addSeries({ name: '伸ばした売上', data: allContributions, tooltip: tooltip });
  }
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CATEGORIES = ['配信数', '経由売上', '獲得売上'];
var FIELDS = ['session_count', 'conversion_price', 'contribution_price'];
var SEGMENTS = {
  no_cv: '未購入',
  one_cv: '一回購入',
  loyal: '二回以上購入',
  unknown: '不明'
};

angular.module('zc').component('zcSiteReportConversionSegment', {
  templateUrl: '/templates/projects.site_reports/conversion_segment.html',
  bindings: { project: '<' },
  controller: zcSiteReportConversionSegment
});

zcSiteReportConversionSegment.$inject = ['$scope', 'ChartV2', 'barChartV2Config'];
function zcSiteReportConversionSegment($scope, ChartV2, barChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var categories = void 0;
    var fields = void 0;
    if (vm.project.is_abtest) {
      categories = CATEGORIES;
      fields = FIELDS;
    } else {
      categories = CATEGORIES.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    var chart = new ChartV2(barChartV2Config, { xAxis: { categories: categories } });
    vm.chartConfig = chart.getConfig();
    var segments = _.sortBy(vm.project.thisMonthStat.conversion_segments, function (segment) {
      if (!segment.conversion_segments.conversion_count) return -1; // Move to the last
      return segment.session_count;
    });
    _.each(segments, function (segment) {
      var name = SEGMENTS[segment.conversion_segments.conversion_count] || '不明';
      var data = _.map(fields, function (field) {
        return _.get(segment, field);
      });
      chart.addSeries({ stacking: 'percent', name: name, data: data });
    });
  }
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CATEGORIES = ['配信数', '経由売上', '獲得売上'];
var FIELDS = ['session_count', 'conversion_price', 'contribution_price'];
var SEGMENTS = {
  pc: 'PC',
  sp: 'スマートフォン',
  tablet: 'タブレット'
};

angular.module('zc').component('zcSiteReportDeviceSegment', {
  templateUrl: '/templates/projects.site_reports/device_segment.html',
  bindings: { project: '<' },
  controller: zcSiteReportDeviceSegment
});

zcSiteReportDeviceSegment.$inject = ['$scope', 'ChartV2', 'barChartV2Config'];
function zcSiteReportDeviceSegment($scope, ChartV2, barChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var categories = void 0;
    var fields = void 0;
    if (vm.project.is_abtest) {
      categories = CATEGORIES;
      fields = FIELDS;
    } else {
      categories = CATEGORIES.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    var chart = new ChartV2(barChartV2Config, { xAxis: { categories: categories } });
    vm.chartConfig = chart.getConfig();
    var segments = _.sortBy(vm.project.thisMonthStat.devices, function (segment) {
      if (!segment.device) return -1; // Move to the last
      return segment.session_count;
    });
    _.each(segments, function (segment) {
      var name = SEGMENTS[segment.device] || '不明';
      var data = _.map(fields, function (field) {
        return _.get(segment, field);
      });
      chart.addSeries({ stacking: 'percent', name: name, data: data });
    });
  }
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcSiteReportGlossary', {
  templateUrl: '/templates/projects.site_reports/glossary.html'
});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcSiteReportKpiBox', {
  templateUrl: '/templates/projects.site_reports/kpi_box.html',
  bindings: { project: '<' },
  controller: zcSiteReportKpiBoxController
});

zcSiteReportKpiBoxController.$inject = ['$scope'];
function zcSiteReportKpiBoxController($scope) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project) return;
    vm.invoicePrice = project.thisMonthInvoice ? project.thisMonthInvoice.invoice_price_tax_excluded : 0;
    vm.budget = project.max_invoice || project.budget;
    if (vm.budget) vm.achievementRate = vm.invoicePrice / vm.budget;
  });
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcSiteReportKpiSummary', {
  templateUrl: '/templates/projects.site_reports/kpi_summary.html',
  bindings: { project: '<' },
  controller: zcSiteReportKpiSummaryController
});

zcSiteReportKpiSummaryController.$inject = ['$scope'];
function zcSiteReportKpiSummaryController($scope, currencies) {
  var _this = this;

  var vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / Math.pow(10, $scope.currency.fractionSize);

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.thisMonthStat) return;
    _this.simulation = calculateSimulation();
  });

  function calculateSimulation() {
    var today = moment().add(1, 'day').startOf('day');
    var monthFrom = moment(vm.project.thisMonthStat.start_at).startOf('month');
    var monthTo = moment(vm.project.thisMonthStat.start_at).add(1, 'month').startOf('month');
    var monthDays = monthTo.diff(monthFrom, 'days');
    var currentFrom = moment(vm.project.thisMonthStat.start_at).startOf('day');
    var currentTo = moment.min(monthTo, today);
    var currentDays = currentTo.diff(currentFrom, 'days');
    if (currentDays <= 0) return null;
    return monthDays / currentDays;
  }
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcSiteReportNavigation', {
  templateUrl: '/templates/projects.site_reports/navigation.html',
  bindings: { project: '<' },
  controller: zcSiteReportNavigationController
});

zcSiteReportNavigationController.$inject = ['$state', '$stateParams'];
function zcSiteReportNavigationController($state, $stateParams) {
  var vm = this;

  var FORMAT = 'YYYY-MM';
  var OLDEST_MONTH = moment('2018-05', FORMAT);
  var LATEST_MONTH = moment().startOf('month');
  var THIS_MONTH = moment($stateParams.month, FORMAT);
  var PREV_MONTH = moment($stateParams.month, FORMAT).subtract(1, 'month').format(FORMAT);
  var NEXT_MONTH = moment($stateParams.month, FORMAT).add(1, 'month').format(FORMAT);
  var CURRENT_STATE = $state.current.name;

  vm.thisMonth = $stateParams.month;
  vm.startAt = THIS_MONTH.toDate();
  vm.isOldest = isOldest;
  vm.isLatest = isLatest;
  vm.goBack = goBack;
  vm.goNext = goNext;

  function isOldest() {
    return THIS_MONTH.isSame(OLDEST_MONTH) || THIS_MONTH.isBefore(OLDEST_MONTH);
  }

  function isLatest() {
    return THIS_MONTH.isSame(LATEST_MONTH) || THIS_MONTH.isAfter(LATEST_MONTH);
  }

  function goBack() {
    if (isOldest()) return;
    $state.go(CURRENT_STATE, {
      projectId: vm.project.id,
      month: PREV_MONTH
    });
  }

  function goNext() {
    if (isLatest()) return;
    $state.go(CURRENT_STATE, {
      projectId: vm.project.id,
      month: NEXT_MONTH
    });
  }
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HEADERS = ['日付', '配信数', 'サイト訪問数', '配信カバー率'];

var FIELDS = ['start_at', 'all_campaign.session_count', 'all_access.session_count', 'session_cover_rate'];

var FORMAT = 'YYYYMM';

angular.module('zc').component('zcSiteReportSessionCover', {
  templateUrl: '/templates/projects.site_reports/session_cover.html',
  bindings: { project: '<' },
  controller: zcSiteReportSessionCover
});

zcSiteReportSessionCover.$inject = ['$scope', '$window', 'Apollo', 'ChartV2', 'lineChartV2Config'];
function zcSiteReportSessionCover($scope, $window, Apollo, ChartV2, lineChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project || !project.dailyStats) return;
    vm.filename = getFilename();
    vm.getCSV = getCSV;
    setChartConfig();
  });

  function getFilename() {
    var yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return 'session-cover-' + vm.project.apikey + '-' + yearMonth + '.csv';
  }

  function getCSV() {
    if (!vm.project.dailyStats) return;
    var result = [];
    result.push(HEADERS);
    vm.project.dailyStats.forEach(function (stat) {
      var row = FIELDS.map(function (field) {
        return _.get(stat, field);
      });
      result.push(row);
    });
    return result;
  }

  function setChartConfig() {
    var allAccesses = [];
    var allCampaigns = [];
    vm.project.dailyStats.forEach(function (stat) {
      if (!stat.session_cover_rate) return;
      var startAt = moment(stat.start_at).valueOf();
      allAccesses.push([startAt, stat.all_access.session_count]);
      allCampaigns.push([startAt, stat.session_cover_rate * 100]);
    });
    var chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: { formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 0) + ' \u30BB\u30C3\u30B7\u30E7\u30F3';
          } }
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: { formatter: function formatter() {
            return $window.Highcharts.numberFormat(this.value, 2) + ' %';
          } }
      }]
    });
    vm.chartConfig = chart.getConfig();
    chart.addSeries({
      type: 'column',
      name: '配信数',
      data: allAccesses,
      tooltip: {
        valueSuffix: 'セッション',
        valueDecimals: 0
      },
      yAxis: 0
    });
    chart.addSeries({
      type: 'line',
      name: '配信カバー率',
      data: allCampaigns,
      tooltip: {
        valueSuffix: '%',
        valueDecimals: 1
      },
      yAxis: 1
    });
  }
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FORMAT = 'YYYY-MM';

angular.module('zc').component('zcSummarySiteReport', {
  templateUrl: '/templates/projects.site_reports/summary.html',
  bindings: { project: '<' },
  controller: zcSummarySiteReportController
});

zcSummarySiteReportController.$inject = ['$filter', '$state', '$stateParams', 'Page', 'Devise', 'Apollo'];
function zcSummarySiteReportController($filter, $state, $stateParams, Page, Devise, Apollo) {
  var vm = this;

  var thisMonthStartAt = $filter('changeDatetimeFrom')('localToRegion', moment($stateParams.month, FORMAT).toDate());
  var thisMonthEndAt = moment(thisMonthStartAt).add(1, 'month').toDate();
  var lastMonthStartAt = moment(thisMonthStartAt).subtract(1, 'month').toDate();
  var lastYearStartAt = moment(thisMonthStartAt).subtract(1, 'year').toDate();

  if (!Devise.isMaster() && !vm.project.shows_site_report) {
    $state.go('admin.projects.campaigns.list', { projectId: vm.project.id });
    return;
  }

  Page.setBodyClass('');
  Page.setTitle('サマリーレポート');

  vm.$onInit = function () {
    getProject().then(function (project) {
      vm.project = _.extend({}, vm.project, project);
    });
  };

  function getProject() {
    return Apollo.query(gql('{\n      project(apikey: "' + vm.project.apikey + '") {\n        title\n        budget\n        max_invoice\n        pc_control_percent\n        sp_control_percent\n        product_line\n        campaigns(start_at: {lt: "' + thisMonthEndAt.toISOString() + '"}, end_at: {gte: "' + thisMonthStartAt.toISOString() + '"}) {\n          id\n          name\n          custom_css\n          campaign_type\n          template_type\n          campaign_device\n          start_at\n          end_at\n          campaign_control_percent\n          element {\n            message\n          }\n          segment {\n            id\n            name\n            description\n          }\n        }\n        invoices(start_at: {gte: "' + lastYearStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          invoice_price_tax_excluded\n          start_at\n        }\n        zcs_invoices(start_at: {gte: "' + lastYearStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          invoice_price_tax_excluded\n          month\n        }\n        monthlyStats: monthlySiteReportStats(start_at: {gte: "' + lastYearStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          all_access {\n            session_count\n            conversion_price\n          }\n          all_campaign {\n            session_count\n            conversion_price\n          }\n          campaigns {\n            campaign_id\n            session_count\n            conversion_price\n            conversion_count\n            conversion_rate\n            average_conversion_price\n            cart_button_click_count\n            cart_button_click_rate\n            contribution_price\n            conversion_up_rate\n            conversion_price_up_rate\n          }\n          devices {\n            device\n            session_count\n            conversion_price\n            contribution_price\n          }\n          conversion_segments {\n            conversion_segments\n            session_count\n            conversion_price\n            contribution_price\n          }\n          utm_mediums {\n            utm_medium\n            session_count\n            conversion_price\n            contribution_price\n          }\n          session_cover_rate\n          conversion_cover_rate\n          contribution_price\n          contribution_rate\n          start_at\n        }\n        dailyStats: dailySiteReportStats(start_at: {gte: "' + thisMonthStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          all_access {\n            session_count\n            conversion_price\n          }\n          all_campaign {\n            session_count\n            conversion_price\n          }\n          session_cover_rate\n          conversion_cover_rate\n          start_at\n        }\n        cumulativeDailyStats: cumulativeDailySiteReportStats(start_at: {gte: "' + thisMonthStartAt.toISOString() + '", lt: "' + thisMonthEndAt.toISOString() + '"}) {\n          all_access {\n            conversion_price\n          }\n          all_campaign {\n            conversion_price\n          }\n          contribution_price\n          contribution_rate\n          start_at\n        }\n      }\n    }')).then(function (res) {
      return res.project;
    }).then(reduceProject);
  }

  function reduceProject(project) {
    project = _.cloneDeep(project);
    project.thisMonthStat = _.find(project.monthlyStats, { start_at: thisMonthStartAt.toISOString() });
    project.lastMonthStat = _.find(project.monthlyStats, { start_at: lastMonthStartAt.toISOString() });
    project.lastYearStat = _.find(project.monthlyStats, { start_at: lastYearStartAt.toISOString() });
    if (project.product_line === 'zenclerk_s') {
      project.thisMonthInvoice = _.find(project.zcs_invoices, { month: moment(thisMonthStartAt).format(FORMAT) });
      project.lastMonthInvoice = _.find(project.zcs_invoices, { month: moment(lastMonthStartAt).format(FORMAT) });
      project.lastYearInvoice = _.find(project.zcs_invoices, { month: moment(lastYearStartAt).format(FORMAT) });
    } else {
      project.thisMonthInvoice = _.find(project.invoices, { start_at: thisMonthStartAt.toISOString() });
      project.lastMonthInvoice = _.find(project.invoices, { start_at: lastMonthStartAt.toISOString() });
      project.lastYearInvoice = _.find(project.invoices, { start_at: lastYearStartAt.toISOString() });
    }
    project.campaigns = reduceCampaigns(project);
    project.is_abtest = _.every(project.campaigns, function (campaign) {
      return campaign.control_percent >= 1;
    });
    project.is_loaded = true;
    return project;
  }

  function reduceCampaigns(project) {
    if (!project.thisMonthStat) return project.campaigns;
    return project.campaigns.reduce(function (memo, campaign) {
      // NOTE: GraphQL ID is treated only as string, so the type mismatch happens between Mongo and SQL
      var stat = _.find(project.thisMonthStat.campaigns, { campaign_id: parseInt(campaign.id) });
      if (!stat || !stat.session_count) return memo;
      memo.push(_.extend({ control_percent: getControlPercent(project, campaign) }, campaign, stat));
      return memo;
    }, []);
  }

  function getControlPercent(project, campaign) {
    if (campaign.campaign_control_percent !== null) return campaign.campaign_control_percent;
    return campaign.campaign_device === 'pc' ? project.pc_control_percent : project.sp_control_percent; // sp, iphone, tablet
  }
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CATEGORIES = ['配信数', '経由売上', '獲得売上'];
var FIELDS = ['session_count', 'conversion_price', 'contribution_price'];

angular.module('zc').component('zcSiteReportUtmMediumSegment', {
  templateUrl: '/templates/projects.site_reports/utm_medium_segment.html',
  bindings: { project: '<' },
  controller: zcSiteReportUtmMediumSegment
});

zcSiteReportUtmMediumSegment.$inject = ['$scope', 'ChartV2', 'barChartV2Config'];
function zcSiteReportUtmMediumSegment($scope, ChartV2, barChartV2Config) {
  var vm = this;

  $scope.$watch('$ctrl.project', function (project) {
    if (!project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    var categories = void 0;
    var fields = void 0;
    if (vm.project.is_abtest) {
      categories = CATEGORIES;
      fields = FIELDS;
    } else {
      categories = CATEGORIES.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    var chart = new ChartV2(barChartV2Config, { xAxis: { categories: categories } });
    vm.chartConfig = chart.getConfig();
    var segments = _.sortBy(vm.project.thisMonthStat.utm_mediums, function (segment) {
      if (!segment.utm_medium) return -1; // Move to the last
      return segment.session_count;
    });
    _.each(segments, function (segment) {
      var data = _.map(fields, function (field) {
        return _.get(segment, field);
      });
      var name = segment.utm_medium || '不明';
      chart.addSeries({ stacking: 'percent', name: name, data: data });
    });
  }
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcDomainSampler', {
  templateUrl: '/templates/projects/components/domain_sampler/domain_sampler.html',
  bindings: { project: '<' },
  controller: zcDomainSampler
});

zcDomainSampler.$inject = ['$filter', '$scope', '$window', 'MongoHistory'];
function zcDomainSampler($filter, $scope, $window, MongoHistory) {
  var vm = this;

  vm.from = moment().subtract(1, 'day').toDate();
  vm.to = moment().subtract(1, 'hour').toDate();
  vm.tableRows = [];
  vm.devices = [{ name: $filter('translate')('projects.components.domainSampler.allDevice'), value: 'all' }, { name: $filter('translate')('projects.components.domainSampler.pc'), value: 'pc' }, { name: $filter('translate')('projects.components.domainSampler.sp'), value: 'sp' }];
  if (vm.project.enable_app) {
    vm.devices.push({ name: $filter('translate')('projects.components.domainSampler.app'), value: 'app' });
  }
  vm.device = vm.devices[0];
  vm.$onInit = function () {
    $scope.$watch('$ctrl.device.value', onChangeDevice);
  };

  function onChangeDevice(device) {
    var query = buildQuery(device);
    MongoHistory.find(query).then(function (histories) {
      var historyCount = histories.length;
      vm.tableRows = _.chain(histories).groupBy(function (history) {
        return getHost(history.url);
      }).map(function (matchHistories, domain) {
        var matchCount = matchHistories.length;
        var matchRate = historyCount ? matchCount / historyCount * 100 : 0;
        return { domain: domain, matchCount: matchCount, matchRate: matchRate };
      }).sortBy(function (row) {
        return -row.matchCount;
      }).value();
    });
  }

  function buildQuery(device) {
    var query = {
      apikey: vm.project.apikey,
      opened_at: { $gte: vm.from, $lt: vm.to },
      is_exclude: false
    };
    if (device === 'pc') {
      query.device = { $in: ['pc', 'tablet'] };
    } else if (device === 'sp') {
      query.device = 'sp';
    } else if (device === 'app') {
      query.device = 'app';
    }
    return query;
  }

  function getHost(url) {
    var anchor = $window.document.createElement('a');
    anchor.href = url;
    return anchor.host;
  }
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc').component('zcSessionSampler', {
  templateUrl: '/templates/projects/components/session_sampler/session_sampler.html',
  bindings: {
    project: '<',
    title: '@',
    indicator: '@'
  },
  controller: zcSessionSampler
});

zcSessionSampler.$inject = ['$filter', '$scope', 'MongoSession', 'MongoHistory'];
function zcSessionSampler($filter, $scope, MongoSession, MongoHistory) {
  var vm = this;

  vm.from = moment().subtract(1, 'day').toDate();
  vm.to = moment().subtract(1, 'hour').toDate();
  vm.totalCount = 0;
  vm.matchedCount = 0;
  vm.matchedPercentage = 0;
  vm.devices = [{ name: $filter('translate')('projects.components.sessionSampler.allDevice'), value: 'all' }, { name: $filter('translate')('projects.components.sessionSampler.pc'), value: 'pc' }, { name: $filter('translate')('projects.components.sessionSampler.sp'), value: 'sp' }];
  if (vm.project.enable_app) {
    vm.devices.push({ name: $filter('translate')('projects.components.sessionSampler.app'), value: 'app' });
  }
  vm.device = vm.devices[0];
  vm.$onInit = function () {
    $scope.$watch('$ctrl.device.value', onChangeDevice);
  };

  function onChangeDevice(device) {
    if (vm.indicator === 'page_types_cover_rate') {
      findHistories(device);
    } else {
      findSessions(device);
    }
  }

  function findSessions(device) {
    var query = buildQuery(device);
    MongoSession.find(query).then(function (sessions) {
      vm.totalCount = sessions.length;
      vm.matchedCount = filterSessions(sessions).length;
      vm.matchedPercentage = calculateMatchedPercentage(vm.totalCount, vm.matchedCount);
    });
  }

  function findHistories(device) {
    var query = buildQuery(device);
    MongoHistory.find(query).then(function (histories) {
      vm.totalCount = histories.length;
      vm.matchedCount = _.filter(histories, function (history) {
        return history.page_types.length;
      }).length;
      vm.matchedPercentage = calculateMatchedPercentage(vm.totalCount, vm.matchedCount);
    });
  }

  function buildQuery(device) {
    var query = {
      apikey: vm.project.apikey,
      opened_at: { $gte: vm.from, $lt: vm.to },
      is_exclude: false
    };
    if (device === 'pc') {
      query.device = { $in: ['pc', 'tablet'] };
    } else if (device === 'sp') {
      query.device = 'sp';
    } else if (device === 'app') {
      query.device = 'app';
    }
    return query;
  }

  function filterSessions(sessions) {
    var filter = void 0;
    switch (vm.indicator) {
      case 'google_analytics_cover_rate':
        filter = function filter(session) {
          return _.get(session, 'google_analytics.first_visit_at');
        };
        break;
      case 'cart_button_click_rate':
        filter = function filter(session) {
          return _.get(session, 'cart_button_click_count') >= 1;
        };
        break;
      case 'login_rate':
        filter = function filter(session) {
          return _.get(session, 'is_login');
        };
        break;
      case 'item_price_found_rate':
        filter = function filter(session) {
          return _.get(session, 'total_item_price') >= 1;
        };
        break;
      case 'item_list_price_found_rate':
        filter = function filter(session) {
          return _.get(session, 'average_recent5_first_item_list_price') >= 1;
        };
        break;
      case 'cart_price_found_rate':
        filter = function filter(session) {
          return _.get(session, 'cart_price') >= 1;
        };
        break;
      default:
        throw new Error('Unknown indicator! ' + vm.indicator);
    }
    return _.filter(sessions, filter);
  }

  function calculateMatchedPercentage(totalCount, matchedCount) {
    return totalCount ? matchedCount / totalCount * 100 : 0;
  }
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.projects').directive('zcCurrencyFormatter', zcCurrencyFormatter);

zcCurrencyFormatter.$inject = ['Project', 'currencies'];
function zcCurrencyFormatter(Project, currencies) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elem, attrs, ngModel) {
      scope.currentProject = Project.currentProject;
      var currency = scope.currentProject ? currencies[Project.currentProject.currency] : null;
      var currencyMultiplier = currency ? Math.pow(10, currency.fractionSize) : 1;
      var formatter = function formatter(value) {
        return value / currencyMultiplier;
      };
      var parser = function parser(value) {
        return currencyMultiplier * value;
      };
      ngModel.$setValidity('currency', currency != null);
      ngModel.$parsers.push(parser);
      ngModel.$formatters.push(formatter);
    }
  };
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.master.zcliteInvoices').controller('MasterZcliteAgencyInvoicesListController', MasterZcliteAgencyInvoicesListController);

MasterZcliteAgencyInvoicesListController.$inject = ['$scope', '$translate', 'Page', 'SearchFilter', 'agencies', 'invoices'];
function MasterZcliteAgencyInvoicesListController($scope, $translate, Page, SearchFilter, agencies, invoices) {
  var vm = this;
  var maxPeriod = moment().format('YYYY-MM');

  Page.setBodyClass('');
  $translate('masterZclite.agencyInvoices.list.liteAgencyList').then(function (translation) {
    return Page.setTitle(translation);
  });

  vm.agencies = agencies;
  vm.invoices = invoices;

  vm.getInvoiceSites = getInvoiceSites;
  vm.isCreatedBeforeCurrentMonth = isCreatedBeforeCurrentMonth;
  vm.isViewingLatestMonth = isViewingLatestMonth;
  vm.nextMonth = nextMonth;
  vm.prevMonth = prevMonth;
  vm.setSortProp = setSortProp;

  vm.filters = SearchFilter.resolveFromLocation();
  SearchFilter.setComponentDefaults('masterZcliteAgencyInvoices', {
    sort_prop: {
      default: 'currentMonthInvoice.invoice_price'
    },
    sort_direction: {
      default: 'desc'
    },
    current_month: {
      // month of search
      default: moment().format('YYYY-MM')
    }
  });

  $scope.$on('$destroy', function () {
    SearchFilter.removeComponentDefaults('masterZcliteAgencyInvoices');
  });

  // TODO: move to ngInit but this is not a component so cant...
  updateData();

  // ========== functions ============

  function updateData() {
    _.each(vm.agencies, function (agency) {
      agency.invoices = _.filter(vm.invoices, function (monthlyInvoices) {
        return monthlyInvoices[0].agency_name === agency.name;
      })[0];
      agency.currentMonthInvoice = getInvoiceForMonth(agency.invoices, vm.filters.current_month);

      var hoursInDay = 24;
      var currentElapsedHoursInMonth = (moment().date() - 1) * hoursInDay + moment().hour();
      var totalHoursInMonth = moment().daysInMonth() * hoursInDay;
      var restOfMonthMultiplier = 1 / currentElapsedHoursInMonth * totalHoursInMonth;
      if (isViewingLatestMonth()) {
        agency.currentMonthInvoice.projectedInvoicePrice = _.sumBy(agency.currentMonthInvoice.sites, function (site) {
          var projectedAmount = site.invoice_price * restOfMonthMultiplier;
          // Take the maximum invoice amount into account
          return _.min([projectedAmount, site.max_invoice]);
        });
      }
    });

    sortData();
    calculateTotals();
  }

  function sortData() {
    // do the sorting
    var sortDirectionReverse = vm.filters.sort_direction === 'desc';

    vm.agencies = _.sortBy(vm.agencies, function (d) {
      return _.get(d, vm.filters.sort_prop);
    });
    if (sortDirectionReverse) {
      vm.agencies.reverse();
    }

    SearchFilter.updateComponentDefaults('masterZcliteAgencyInvoices');
  }

  // calculate totals
  function calculateTotals() {
    vm.totalInvoicePrice = _.sumBy(vm.agencies, function (agency) {
      return agency.currentMonthInvoice.invoice_price;
    });
    vm.totalInvoicePriceTaxExcluded = _.sumBy(vm.agencies, function (agency) {
      return agency.currentMonthInvoice.invoice_price_tax_excluded;
    });
    vm.totalInvoiceSites = _.sumBy(vm.agencies, function (agency) {
      return getInvoiceSites(agency.currentMonthInvoice.sites).length;
    });
    vm.totalSites = _.sumBy(vm.agencies, function (agency) {
      return agency.currentMonthInvoice.sites.length;
    });
    vm.projectedInvoicePrice = _.sumBy(vm.agencies, function (agency) {
      return agency.currentMonthInvoice.projectedInvoicePrice;
    });
  }

  function setSortProp(key) {
    if (vm.filters.sort_prop === key) {
      if (vm.filters.sort_direction === 'desc') {
        vm.filters.sort_direction = 'asc';
      } else {
        vm.filters.sort_direction = 'desc';
      }
    } else {
      vm.filters.sort_prop = key;
      vm.filters.sort_direction = 'desc';
    }
    updateData();
  }

  function getInvoiceForMonth(agencyInvoices, monthToGet) {
    var invoice = _.find(agencyInvoices, function (d) {
      return d.month === monthToGet;
    });
    if (!invoice) {
      invoice = {
        invoice_price: 0,
        invoice_price_tax_excluded: 0,
        sites: []
      };
    }
    return invoice;
  }

  function getInvoiceSites(agencySites) {
    return _.filter(agencySites, function (site) {
      return site.invoice_price > 0;
    });
  }

  function isCreatedBeforeCurrentMonth(agency) {
    return moment(agency.created_at).isBefore(moment(vm.filters.current_month));
  }

  function isViewingLatestMonth() {
    return moment(vm.filters.current_month).isSame(moment().startOf('month'));
  }

  function nextMonth() {
    if (vm.filters.current_month >= maxPeriod) return;
    vm.filters.current_month = moment(vm.filters.current_month, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    updateData();
  }

  function prevMonth() {
    vm.filters.current_month = moment(vm.filters.current_month, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
    updateData();
  }
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.master.zcliteAgencyInvoices').config(zcliteAgencyInvoiceRoutes);

zcliteAgencyInvoiceRoutes.$inject = ['$stateProvider'];
function zcliteAgencyInvoiceRoutes($stateProvider) {
  $stateProvider.state('admin.master.zcliteAgencyInvoices', {
    url: '/zclite_agency_invoices',
    views: {
      'content@': {
        templateUrl: '/templates/master.zclite_agency_invoices/list.html',
        controller: 'MasterZcliteAgencyInvoicesListController',
        controllerAs: '$ctrl',
        resolve: {
          agencies: function agencies(MasterAgency) {
            return MasterAgency.all();
          },
          invoices: function invoices($q, agencies, ZcsAgencyInvoice) {
            var promises = _.map(agencies, function (agency) {
              var allAndCurrentPromises = $q.all({
                all: ZcsAgencyInvoice.all(agency.name),
                current: ZcsAgencyInvoice.find(agency.name, moment().format('YYYY-MM'))
              }).then(function (_ref) {
                var all = _ref.all,
                    current = _ref.current;

                var allInvoices = all.concat(current);
                return allInvoices;
              });
              return allAndCurrentPromises;
            });
            return $q.all(promises);
          }
        }
      }
    }
  });
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.master').component('zcCampaignBadges', {
  templateUrl: '/templates/master/components/campaign_badges.html',
  bindings: {
    campaigns: '<'
  },
  controller: zcCampaignBadges,
  controllerAs: 'vm'
});

zcCampaignBadges.$inject = ['$scope', 'campaignStatuses'];
function zcCampaignBadges($scope, campaignStatuses) {
  var vm = this;
  vm.campaignStatuses = campaignStatuses;

  vm.$onInit = function () {
    return vm.updateData();
  };
  vm.updateData = function () {
    vm.secretAbCampaignCount = _.filter(vm.campaigns, { is_secret_ab: true }).length;
    vm.unfinishedCampaigns = _.filter(vm.campaigns, function (campaign) {
      return !['finished', 'terminated'].includes(campaign.current_status);
    });
    vm.undeliveredCampaignCount = _.filter(vm.unfinishedCampaigns, function (campaign) {
      return !campaign.is_fired;
    }).length;
    vm.campaignCountByStatus = _.countBy(_.sortBy(vm.campaigns, 'current_status'), function (campaign) {
      return campaign.current_status;
    });
  };

  $scope.$watch('vm.campaigns', vm.updateData);
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.master').component('zcLogisticRegressionCoefficients', {
  templateUrl: '/templates/master/components/logistic_regression_coefficients/logistic_regression_coefficients.html',
  bindings: {
    apikey: '<',
    preferredDevice: '<'
  },
  controller: logisticRegressionCoefficientsController
});

logisticRegressionCoefficientsController.$inject = ['$scope', '$filter', 'MasterMongoLogisticRegressionCoefficients'];
function logisticRegressionCoefficientsController($scope, $filter, MasterMongoLogisticRegressionCoefficients) {
  var vm = this;

  var FIELD_DICTIONARY = {
    session_history_count: $filter('translate')('sessionHistoryCount'),
    session_interest_count: $filter('translate')('sessionInterestCount'),
    session_cart_button_click_count: $filter('translate')('sessionCartButtonClickCount'),
    session_repeat_item_count: $filter('translate')('sessionRepeatItemCount'),
    session_page_types_counts_category: $filter('translate')('sessionPageTypesCountsCategory'),
    session_page_types_counts_feature: $filter('translate')('sessionPageTypesCountsFeature'),
    session_page_types_counts_item: $filter('translate')('sessionPageTypesCountsItem'),
    session_page_types_counts_sale: $filter('translate')('sessionPageTypesCountsSale'),
    session_page_types_counts_search: $filter('translate')('sessionPageTypesCountsSearch'),
    session_page_types_counts_top: $filter('translate')('sessionPageTypesCountsTop'),
    session_second_page_types: $filter('translate')('sessionSecondPageTypes'),
    session_landing_page_types: $filter('translate')('sessionLandingPageTypes'),
    session_average_interest_item_price: $filter('translate')('sessionAverageInterestItemPrice'),
    session_is_login: $filter('translate')('sessionIsLogin'),
    session_is_advertising: $filter('translate')('sessionIsAdvertising'),
    session_is_newsletter: $filter('translate')('sessionIsNewsletter'),
    session_segment_total_conversion_count: $filter('translate')('sessionSegmentTotalConversionCount'),
    session_segment_session_count: $filter('translate')('sessionSegmentSessionCount'),
    session_segment_has_been_login: $filter('translate')('sessionSegmentHasBeenLogin'),
    session_segment_is_cart_abandoned: $filter('translate')('sessionSegmentIsCart_abandoned'),
    session_segment_is_interest_dropped: $filter('translate')('sessionSegmentIsInterestDropped'),
    session_user_agent_os_name: $filter('translate')('sessionUserAgentOsName'),
    session_user_agent_browser_name: $filter('translate')('sessionUserAgentBrowserName')
  };

  vm.$onInit = function () {
    vm.limit = 10;
    vm.sortProp = 'value';
    vm.sortDirection = 'desc';
    vm.device = 'pc';
    if (vm.preferredDevice === 'pc' || vm.preferredDevice === 'sp') {
      vm.device = vm.preferredDevice;
    }
    vm.coefficients = [];
    vm.currentCoefficients = null;
    vm.createdAt = null;
    vm.partials = null;
    vm.changeLimit = changeLimit;
    vm.sortBy = sortBy;
    $scope.$watch('$ctrl.device', setCurrentCoefficients);
    findCoefficients();
  };

  function findCoefficients() {
    MasterMongoLogisticRegressionCoefficients.find({
      match: {
        apikey: vm.apikey,
        is_active: true
      },
      fields: ['device', 'partial', 'created_at']
    }).then(function (coefficients) {
      vm.coefficients = coefficients;
      setCurrentCoefficients();
    });
  }

  function setCurrentCoefficients() {
    var current = _.find(vm.coefficients, { device: vm.device });
    if (current) {
      vm.partials = getOrderedPartials(current.partial);
      vm.createdAt = current.created_at;
    } else {
      vm.partials = null;
      vm.createdAt = null;
    }
  }

  function getOrderedPartials(partials) {
    var reverse = vm.sortDirection === 'desc';
    partials = _.map(partials, function (value, key) {
      return {
        key: key,
        label: translate(key),
        value: value
      };
    });
    partials = _.reject(partials, function (partial) {
      return partial.value === 0;
    });
    partials = $filter('orderBy')(partials, vm.sortProp, reverse);
    partials = $filter('emptyToEnd')(partials, vm.sortProp, reverse);
    return _.take(partials, vm.limit);
  }

  function changeLimit(limit) {
    vm.limit = limit;
    setCurrentCoefficients();
  }

  function sortBy(key) {
    if (vm.sortProp === key) {
      if (vm.sortDirection === 'desc') {
        vm.sortDirection = 'asc';
      } else {
        vm.sortDirection = 'desc';
      }
    } else {
      vm.sortProp = key;
      vm.sortDirection = 'desc';
    }
    setCurrentCoefficients();
  }

  function translate(from) {
    var to = '';
    for (var key in FIELD_DICTIONARY) {
      if (_.startsWith(from, key)) {
        from = from.replace(key, '');
        to += FIELD_DICTIONARY[key];
        break;
      }
    }
    var words = from.replace(/_+/, '').split(/_+/);
    if (_.endsWith(from, 'eq')) {
      to += $filter('translate')('eq', { words: words[0] });
    } else if (_.endsWith(from, 'in_range')) {
      to += $filter('translate')('inRange', { words0: words[0], words1: words[1] });
    } else if (_.endsWith(from, 'isin')) {
      to += $filter('translate')('isin', { words: words[0] });
    } else if (_.endsWith(from, 'log1p')) {
      to += $filter('translate')('log1p');
    } else if (_.endsWith(from, 'min')) {
      to += $filter('translate')('min', { words: words[0] });
    }
    return to;
  }
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.master').component('zcMasterHome', {
  templateUrl: '/templates/master/components/master_home/master_home.html',
  bindings: {
    projects: '<'
  },
  controller: zcMasterHome
});

zcMasterHome.$inject = ['$scope', '$q', '$filter', 'Devise', 'SearchFilter', 'CampaignStats', 'MasterCampaign', 'MasterCampaignStats', 'MasterAccessStats', 'MasterCampaignSegmentStats', 'currencies'];
function zcMasterHome($scope, $q, $filter, Devise, SearchFilter, CampaignStats, MasterCampaign, MasterCampaignStats, MasterAccessStats, MasterCampaignSegmentStats, currencies) {

  var vm = this;

  vm.starredApikeyMap = _.reduce(Devise.currentUser.projects, function (memo, project) {
    memo[project.apikey] = true;
    return memo;
  }, {});

  vm.alertProjects = [];
  vm.reportProjects = [];
  vm.reportCampaigns = [];
  vm.updateFilters = updateFilters;
  vm.updateReports = updateReports;
  vm.resetFilters = resetFilters;
  vm.sortReports = sortReports;

  vm.$onInit = function () {
    _.each(vm.projects, function (project) {
      project.currencyObj = currencies[project.currency];
    });
    vm.filters = SearchFilter.resolveFromLocation();

    SearchFilter.setComponentDefaults('home', {
      expanded_alert: { default: false },
      all_alert: { default: false },
      expanded_report: { default: false },
      flat_report: { default: false },
      all_report: { default: false },
      column_report: { default: 'kgi' },
      sort_prop: { default: 'project.id' },
      sort_direction: { default: 'asc' },
      include_hidden_ab_test: { default: false }
    });
  };

  function updateFilters() {
    _.merge(vm.filters, {
      start_at: moment(vm.filters.start_at).toDate(),
      end_at: moment(vm.filters.end_at).endOf('day').toDate()
    });
    SearchFilter.set(vm.filters);
    $scope.$broadcast('filtersUpdated');
    vm.updateReports();
  }

  function resetFilters() {
    $scope.$broadcast('filtersReset');
  }

  function updateReports() {
    $q.all([getCampaigns(), getCampaignStats(), getAccessStats(), getCampaignSegmentStats()]).then(function (res) {
      var _res = _slicedToArray(res, 4),
          campaigns = _res[0],
          campaignStats = _res[1],
          accessStats = _res[2],
          campaignSegmentStats = _res[3];

      vm.reportProjects = _.filter(vm.projects, function (project) {
        return _.includes(['zenclerk', 'zenclerk_lp'], project.product_line);
      });
      vm.reportCampaigns = [];
      _.each(vm.reportProjects, function (project) {
        project.starred = vm.starredApikeyMap[project.apikey];
        project.expanded_alert = vm.filters.expanded_alert;
        project.expanded_report = vm.filters.expanded_report;
        project.campaigns = _.filter(campaigns, { project_id: project.id, is_information_campaign: false });
        var nonAovCampaigns = _.filter(project.campaigns, { is_aov_campaign: false });
        vm.reportCampaigns = vm.reportCampaigns.concat(project.campaigns);
        project.stats = getDefaultStats();
        if (project.campaigns.length === 0) return;
        var filteredStats = _.filter(campaignStats, { apikey: project.apikey });
        var statsById = MasterCampaignStats.statsById(filteredStats);
        var conversionCount = _.get(accessStats, project.apikey + '.conversion_count', 0);
        _.each(project.campaigns, function (campaign) {
          campaign.project = project;
          campaign.stats = statsById[campaign.id];
          if (campaign.stats) {
            MasterCampaignStats.calculate(campaign.stats);
            campaign.stats.invoice_amount = CampaignStats.calculateInvoiceAmount(project, campaign, campaign.stats);
            campaign.stats.invoice_amount_simulation = campaign.stats.invoice_amount * calculateSimulation();
            campaign.stats.conversion_price = campaign.stats.experimental.conversion_price;
            campaign.stats.revenue_simulation = campaign.stats.experimental.conversion_price * calculateSimulation();
            campaign.stats.conversion_count = conversionCount;
            campaign.stats.conversion_cover_rate = conversionCount >= 1 ? campaign.stats.experimental.conversion_count / conversionCount : null;
          } else {
            campaign.stats = getDefaultStats();
          }
          var campaignSegmentStat = _.find(campaignSegmentStats, { apikey: project.apikey, campaign_id: campaign.id });
          campaign.stats.coupon_applicable_rate = campaignSegmentStat && campaignSegmentStat.conversion_count >= 1 ? campaignSegmentStat.coupon_applicable_conversion_count / campaignSegmentStat.conversion_count : null;
          campaign.alerts = judgeAlerts(project, campaign.stats);
        });
        project.stats = {
          experimental: {
            delivery_count: _.sumBy(project.campaigns, 'stats.experimental.delivery_count'),
            conversion_count: _.sumBy(project.campaigns, 'stats.experimental.conversion_count')
          },
          control: {
            delivery_count: _.sumBy(project.campaigns, 'stats.control.delivery_count'),
            conversion_count: _.sumBy(project.campaigns, 'stats.control.conversion_count')
          },
          conversion_up_rate: $filter('overallCampaignCvrIncreaseRate')(nonAovCampaigns, vm.filters.include_hidden_ab_test),
          total_conversion_value: _.sumBy(nonAovCampaigns, 'stats.experimental.conversion_price'),
          invoice_amount: _.sumBy(project.campaigns, 'stats.invoice_amount'),
          invoice_amount_simulation: _.sumBy(project.campaigns, 'stats.invoice_amount_simulation'),
          revenue_simulation: _.sumBy(project.campaigns, 'stats.revenue_simulation'),
          conversion_count: conversionCount
        };
        project.stats.conversion_cover_rate = conversionCount >= 1 ? project.stats.experimental.conversion_count / conversionCount : null;
        project.alerts = judgeAlerts(project, project.stats);
        if (_.find(project.campaigns, function (campaign) {
          return campaign.alerts.includes('coupon_applicable_rate');
        })) {
          project.alerts.push('coupon_applicable_rate');
        }
      });
      sortReports();
      filterAlerts();
    });
  }

  function filterAlerts() {
    vm.alertProjects = [];
    _.each(vm.reportProjects, function (project) {
      _.each(project.alerts, function (alert) {
        vm.alertProjects.push(_.merge({}, project, { alert: alert }));
      });
    });
  }

  function sortReports() {
    var reverse = vm.filters.sort_direction === 'desc';
    vm.reportProjects = $filter('orderBy')(vm.reportProjects, vm.filters.sort_prop, reverse);
    vm.reportProjects = $filter('emptyToEnd')(vm.reportProjects, vm.filters.sort_prop, reverse);
    vm.reportCampaigns = $filter('orderBy')(vm.reportCampaigns, vm.filters.sort_prop, reverse);
    vm.reportCampaigns = $filter('emptyToEnd')(vm.reportCampaigns, vm.filters.sort_prop, reverse);
  }

  function getCampaigns() {
    return MasterCampaign.all({
      fast: true,
      start_at: moment(vm.filters.start_at).valueOf(),
      end_at: moment(vm.filters.end_at).endOf('day').valueOf()
    });
  }

  function getCampaignStats() {
    return new MasterCampaignStats('daily').aggregate({
      start_at: moment(vm.filters.start_at).toDate(),
      end_at: moment(vm.filters.end_at).endOf('day').toDate()
    });
  }

  function getAccessStats() {
    return MasterAccessStats.aggregate({
      dimension: 'daily'
    }, {
      match: {
        device: null,
        is_control: null,
        campaign_segment_id: null,
        start_at: {
          $gte: moment(vm.filters.start_at).toDate(),
          $lt: moment(vm.filters.end_at).endOf('day').toDate()
        }
      },
      pipeline: [{
        $group: {
          _id: '$apikey',
          conversion_count: {
            $sum: '$conversion_count'
          }
        }
      }]
    }).then(function (stats) {
      return _.reduce(stats, function (obj, stat) {
        obj[stat._id] = stat;
        return obj;
      }, {});
    });
  }

  function getCampaignSegmentStats() {
    return MasterCampaignSegmentStats.aggregate({
      dimension: 'daily'
    }, {
      match: {
        start_at: {
          $gte: moment(vm.filters.start_at).toDate(),
          $lt: moment(vm.filters.end_at).endOf('day').toDate()
        }
      },
      pipeline: [{
        $group: {
          _id: {
            apikey: '$apikey',
            campaign_id: '$campaign_id'
          },
          coupon_applicable_conversion_count: {
            $sum: '$coupon_applicable_conversion_count'
          },
          conversion_count: {
            $sum: '$conversion_count'
          }
        }
      }]
    }).then(function (stats) {
      return _.map(stats, function (stat) {
        return _.merge({}, stat, stat._id);
      });
    });
  }

  function getDefaultStats() {
    return {
      experimental: { delivery_count: 0 },
      control: { delivery_count: 0 },
      contribution_price: 0,
      contribution_count: 0,
      invoice_amount: 0,
      invoice_amount_simulation: 0,
      revenue_simulation: 0,
      conversion_up_rate: null,
      conversion_count: 0,
      conversion_cover_rate: null
    };
  }

  function calculateSimulation() {
    var today = moment().add(1, 'day').startOf('day');
    var monthFrom = moment(vm.filters.start_at).startOf('month');
    var monthTo = moment(vm.filters.end_at).add(1, 'month').startOf('month');
    var months = monthTo.diff(monthFrom, 'months');
    var monthDays = monthTo.diff(monthFrom, 'days');
    var currentFrom = moment(vm.filters.start_at).startOf('day');
    var currentTo = moment.min(moment(vm.filters.end_at).add(1, 'day').startOf('day'), today);
    var currentDays = currentTo.diff(currentFrom, 'days');
    return monthDays / months / currentDays;
  }

  function judgeAlerts(project, stats) {
    var alerts = [];
    if (stats.conversion_up_rate && project.conversion_up_rate_threshold && stats.conversion_up_rate * 100 < project.conversion_up_rate_threshold) {
      alerts.push('conversion_up_rate');
    }
    if (stats.invoice_amount_simulation && project.invoice_amount_threshold && stats.invoice_amount_simulation < project.invoice_amount_threshold) {
      alerts.push('invoice_amount_simulation');
    }
    if (stats.invoice_amount_simulation && project.invoice_amount_upper_threshold && stats.invoice_amount_simulation >= project.invoice_amount_upper_threshold) {
      alerts.push('invoice_amount_upper_simulation');
    }
    if (stats.revenue_simulation && project.revenue_min_threshold && stats.revenue_simulation < project.revenue_min_threshold) {
      alerts.push('revenue_min_threshold');
    }
    if (stats.revenue_simulation && project.revenue_max_threshold && stats.revenue_simulation >= project.revenue_max_threshold) {
      alerts.push('revenue_max_threshold');
    }
    if (stats.coupon_applicable_rate !== null && project.coupon_applicable_rate_threshold && stats.coupon_applicable_rate * 100 < project.coupon_applicable_rate_threshold) {
      alerts.push('coupon_applicable_rate');
    }
    return alerts;
  }
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.master').component('zcMasterHomeAlert', {
  templateUrl: '/templates/master/components/master_home_alert/master_home_alert.html',
  bindings: {
    projects: '<',
    filters: '<'
  },
  controller: zcMasterHomeAlert
});

zcMasterHomeAlert.$inject = ['Devise', 'SearchFilter', 'MasterProject', '$scope'];
function zcMasterHomeAlert(Devise, SearchFilter, MasterProject, $scope) {
  var vm = this;

  vm.searchTerm = '';
  vm.filterProjects = filterProjects;
  vm.toggleExpandedAlert = toggleExpandedAlert;
  vm.toggleAllAlert = toggleAllAlert;
  vm.star = star;
  vm.unstar = unstar;

  function filterProjects(project) {
    if (!vm.filters.all_alert && !project.starred) return false;
    if (vm.searchTerm === '') return true;
    if (project.title.indexOf(vm.searchTerm) >= 0) return true;
    if (project.apikey.indexOf(vm.searchTerm) >= 0) return true;
    return false;
  }

  function toggleExpandedAlert() {
    vm.filters.expanded_alert = !vm.filters.expanded_alert;
    _.each(vm.projects, function (project) {
      project.expanded_alert = vm.filters.expanded_alert;
    });
    SearchFilter.updateComponentDefaults('home');
  }

  function toggleAllAlert() {
    vm.filters.all_alert = !vm.filters.all_alert;
    SearchFilter.updateComponentDefaults('home');
  }

  function star(project) {
    MasterProject.assign({ projectId: project.id }, { userId: Devise.currentUser.id }).then(function (res) {
      if (res.data.success) {
        _.each(vm.projects, function (p) {
          if (project.apikey === p.apikey) {
            p.starred = true;
          }
        });

        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = true;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }

  function unstar(project) {
    MasterProject.unassign({ projectId: project.id }, { userId: Devise.currentUser.id }).then(function (res) {
      if (res.data.success) {
        _.each(vm.projects, function (p) {
          if (project.apikey === p.apikey) {
            p.starred = false;
          }
        });

        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = false;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.master').component('zcMasterHomeReport', {
  templateUrl: '/templates/master/components/master_home_report/master_home_report.html',
  bindings: {
    projects: '<',
    campaigns: '<',
    filters: '<',
    sortReports: '&'
  },
  controller: zcMasterHomeReport
});

zcMasterHomeReport.$inject = ['$scope', 'Devise', 'SearchFilter', 'MasterProject'];
function zcMasterHomeReport($scope, Devise, SearchFilter, MasterProject) {
  var vm = this;

  vm.searchTerm = '';
  vm.filterProjects = filterProjects;
  vm.filterCampaigns = filterCampaigns;
  vm.toggleExpandedReport = toggleExpandedReport;
  vm.toggleFlatReport = toggleFlatReport;
  vm.setColumnReport = setColumnReport;
  vm.toggleAllReport = toggleAllReport;
  vm.sortBy = sortBy;
  vm.star = star;
  vm.unstar = unstar;

  function filterProjects(project) {
    if (!vm.filters.all_report && !project.starred) return false;
    if (vm.searchTerm === '') return true;
    if (project.title.indexOf(vm.searchTerm) >= 0) return true;
    if (project.apikey.indexOf(vm.searchTerm) >= 0) return true;
    return false;
  }

  function filterCampaigns(campaign) {
    if (!vm.filters.all_report && !campaign.project.starred) return false;
    if (vm.searchTerm === '') return true;
    if (campaign.project.title.indexOf(vm.searchTerm) >= 0) return true;
    if (campaign.project.apikey.indexOf(vm.searchTerm) >= 0) return true;
    if (campaign.name && campaign.name.indexOf(vm.searchTerm) >= 0) return true;
    return false;
  }

  function toggleExpandedReport() {
    vm.filters.expanded_report = !vm.filters.expanded_report;
    _.each(vm.projects, function (project) {
      project.expanded_report = vm.filters.expanded_report;
    });
    SearchFilter.updateComponentDefaults('home');
  }

  function toggleFlatReport() {
    vm.filters.flat_report = !vm.filters.flat_report;
    SearchFilter.updateComponentDefaults('home');
  }

  function setColumnReport(column) {
    vm.filters.column_report = column;
    SearchFilter.updateComponentDefaults('home');
  }

  function toggleAllReport() {
    vm.filters.all_report = !vm.filters.all_report;
    SearchFilter.updateComponentDefaults('home');
  }

  function sortBy(key) {
    if (vm.filters.sort_prop === key) {
      if (vm.filters.sort_direction === 'desc') {
        vm.filters.sort_direction = 'asc';
      } else {
        vm.filters.sort_direction = 'desc';
      }
    } else {
      vm.filters.sort_prop = key;
      vm.filters.sort_direction = 'desc';
    }
    vm.sortReports();
    SearchFilter.updateComponentDefaults('home');
  }

  function star(project) {
    MasterProject.assign({ projectId: project.id }, { userId: Devise.currentUser.id }).then(function (res) {
      if (res.data.success) {
        project.starred = true;
        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = true;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }

  function unstar(project) {
    MasterProject.unassign({ projectId: project.id }, { userId: Devise.currentUser.id }).then(function (res) {
      if (res.data.success) {
        project.starred = false;
        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = false;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.masterApi').factory('MasterMongoLogisticRegressionCoefficients', MasterMongoLogisticRegressionCoefficients);

MasterMongoLogisticRegressionCoefficients.$inject = ['FacadeV2'];
function MasterMongoLogisticRegressionCoefficients(FacadeV2) {
  return { find: find };

  function find(params) {
    return FacadeV2.request('/master/logistic_regression_coefficients', { params: params }).then(function (res) {
      return res.data;
    });
  }
}

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */
/***/ (function(module, exports) {

angular.module('zc.commonApi', []);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

angular.module('zc.core', ['ui.router', 'pascalprecht.translate', 'LocalStorageModule']);


/***/ }),
/* 445 */
/***/ (function(module, exports) {

angular.module('zc.projects.campaigns', ['zc.core', 'zc.users', 'zc.projects', 'zc.commonApi']);


/***/ }),
/* 446 */
/***/ (function(module, exports) {

angular.module('zc.projects.reports', ['zc.projects', 'zc.projects.campaigns', 'zc.commonApi']);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

angular.module('zc.projects', ['ngResource', 'flow', 'highcharts-ng', 'zc.core', 'zc.users', 'zc.projects.campaigns', 'zc.commonApi']);


/***/ }),
/* 448 */
/***/ (function(module, exports) {

angular.module('zc.users.pages', ['zc.core', 'zc.users']);


/***/ }),
/* 449 */
/***/ (function(module, exports) {

angular.module('zc.users', ['zc.core']);


/***/ }),
/* 450 */
/***/ (function(module, exports) {

angular.module('zc.master.campaigns', ['zc.master']);


/***/ }),
/* 451 */
/***/ (function(module, exports) {

angular.module('zc.master.projects', ['zc.master', 'zc.projects', 'flow']);


/***/ }),
/* 452 */
/***/ (function(module, exports) {

angular.module('zc.master.reports', ['zc.master']);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

angular.module('zc.master.users', ['zc.master']);


/***/ }),
/* 454 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteInvoices', ['zc.master']);


/***/ }),
/* 455 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteKpi', ['zc.master']);


/***/ }),
/* 456 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteProjects', ['zc.master']);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteProjectsForReview', ['zc.master']);


/***/ }),
/* 458 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteReports', ['zc.master']);


/***/ }),
/* 459 */
/***/ (function(module, exports) {

angular.module('zc.master', ['zc.core', 'zc.users', 'zc.projects', 'zc.commonApi', 'zc.masterApi']);


/***/ }),
/* 460 */
/***/ (function(module, exports) {

angular.module('zc.masterApi', []);


/***/ }),
/* 461 */,
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var AngularIntegration, Integrations, Sentry, app, enableSentry, i, j, k, key, len, len1, len2, moduleReq, ref, ref1, ref2;

__webpack_require__(571);

__webpack_require__(793);

__webpack_require__(794);

__webpack_require__(817);

__webpack_require__(810);

__webpack_require__(813);

__webpack_require__(814);

__webpack_require__(812);

__webpack_require__(808);

__webpack_require__(807);

__webpack_require__(811);

__webpack_require__(816);

__webpack_require__(809);

__webpack_require__(815);

__webpack_require__(806);

__webpack_require__(805);

__webpack_require__(444);

__webpack_require__(443);

__webpack_require__(449);

__webpack_require__(448);

__webpack_require__(447);

__webpack_require__(445);

__webpack_require__(446);

__webpack_require__(111);

__webpack_require__(109);

__webpack_require__(459);

__webpack_require__(460);

__webpack_require__(450);

__webpack_require__(451);

__webpack_require__(452);

__webpack_require__(453);

__webpack_require__(454);

__webpack_require__(112);

__webpack_require__(455);

__webpack_require__(456);

__webpack_require__(457);

__webpack_require__(458);

window.ZC_CONFIG = __webpack_require__(570);

__webpack_require__(264);

Sentry = __webpack_require__(468);

Integrations = __webpack_require__(513).Integrations;

AngularIntegration = __webpack_require__(496).Angular;

enableSentry = !['development', 'test'].includes(window.ZC_CONFIG.ENV);

if (enableSentry) {
  Sentry.init({
    dsn: window.ZC_CONFIG.SENTRY_DSN,
    integrations: [
      new AngularIntegration(), new Integrations.BrowserTracing({
        tracingOrigins: ['localhost', 'aideal-admin.appier.com', 'aideal-admin-pre.appier.com', 'admin-stg.aideal.arepa.appier.co']
      })
    ],
    tracesSampleRate: 0.01,
    sendClientReports: false,
    environment: window.ZC_CONFIG.ENV
  });
}

app = angular.module('zc', ['ui.router', 'ngResource', 'ngAnimate', 'ngMessages', 'ngCsv', 'ngCookies', 'highcharts-ng', 'pascalprecht.translate', 'LocalStorageModule', 'ui.bootstrap', 'ui.bootstrap.dropdown', 'ui.bootstrap.typeahead', 'ui.bootstrap.datetimepicker', 'xeditable', 'zc.core', 'zc.users', 'zc.commonApi', 'zc.users.pages', 'zc.projects', 'zc.projects.campaigns', 'zc.projects.reports', 'zc.projects.heatmap', 'zc.agencies', 'zc.master', 'zc.masterApi', 'zc.master.campaigns', 'zc.master.users', 'zc.master.projects', 'zc.master.reports', 'zc.master.zcliteProjects', 'zc.master.zcliteKpi', 'zc.master.zcliteProjectsForReview', 'zc.master.zcliteInvoices', 'zc.master.zcliteAgencyInvoices', 'zc.master.zcliteReports', 'colorpicker.module', 'ngclipboard', 'hljs', 'rzModule', 'ngSentry']);

moduleReq = __webpack_require__(464);

ref = moduleReq.keys();
for (i = 0, len = ref.length; i < len; i++) {
  key = ref[i];
  if (!key.match(/\.test(\.js|\.coffee)?$/)) {
    moduleReq(key);
  }
}

moduleReq = __webpack_require__(465);

ref1 = moduleReq.keys();
for (j = 0, len1 = ref1.length; j < len1; j++) {
  key = ref1[j];
  if (!key.match(/\.test(\.js|\.coffee)?$/)) {
    moduleReq(key);
  }
}

moduleReq = __webpack_require__(1662);

ref2 = moduleReq.keys();
for (k = 0, len2 = ref2.length; k < len2; k++) {
  key = ref2[k];
  if (!key.match(/\.test(\.js|\.coffee)?$/)) {
    moduleReq(key);
  }
}

app.config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('404', {
    url: '/404',
    views: {
      'header@': {
        templateUrl: '/templates/users/views/devise_header.html'
      },
      'content@': {
        templateUrl: '/templates/core/views/404.html'
      }
    }
  }).state('500', {
    url: '/500',
    views: {
      'header@': {
        templateUrl: '/templates/users/views/devise_header.html'
      },
      'content@': {
        templateUrl: '/templates/core/views/500.html'
      }
    }
  }).state('terms_of_service', {
    url: '/admin/tos',
    controller: 'TosController',
    controllerAs: 'vm',
    views: {
      'header@': {
        templateUrl: '/templates/core/views/tos_header.html',
        controller: 'TosHeaderController',
        controllerAs: 'vm',
        resolve: {
          languages: function() {
            return [
              {
                id: 'en',
                label: 'English'
              }, {
                id: 'ja',
                label: '日本語'
              }, {
                id: 'zh',
                label: '中文'
              }
            ];
          }
        }
      },
      'content@': {
        templateUrl: '/templates/core/views/tos.html',
        controller: 'TosController',
        controllerAs: 'vm'
      }
    }
  }).state('privacy_policy', {
    url: '/admin/privacy_policy',
    views: {
      'header@': {
        templateUrl: '/templates/users/views/devise_header.html'
      },
      'content@': {
        templateUrl: '/templates/core/views/privacy_policy.html',
        controller: 'PrivacyPolicyCtrl'
      }
    }
  });
}]);

app.value('$anchorScroll', angular.noop);

app.config(["$uiViewScrollProvider", function($uiViewScrollProvider) {
  return $uiViewScrollProvider.useAnchorScroll();
}]);

app.service("afterLoginHandler", ["$location", "$cookies", "$state", "Environment", "Project", "returnUrl", function($location, $cookies, $state, Environment, Project, returnUrl) {
  var AfterLoginHandler;
  return AfterLoginHandler = (function() {
    function AfterLoginHandler() {}

    AfterLoginHandler.handle = function(currentUser) {
      if (!currentUser) {
        return;
      }
      Environment.get().then((function(_this) {
        return function(env) {
          return $cookies.put('__zc_admin', "user_id=" + currentUser.id, {
            path: '/',
            expires: moment().add(1, 'years').toDate(),
            secure: (env === 'production' || env === 'preprod' || env === 'staging')
          });
        };
      })(this));
      if (returnUrl.get()) {
        $location.url(returnUrl.get());
        returnUrl.set(null);
        return;
      }
      return $state.go('admin.home');
    };

    return AfterLoginHandler;

  })();
}]);

app.run(["$rootScope", "$state", "$window", "Devise", "Page", "Project", "ZcTag", "afterLoginHandler", "lib", function($rootScope, $state, $window, Devise, Page, Project, ZcTag, afterLoginHandler, lib) {
  $rootScope.Page = Page;
  ZcTag.initialize();
  $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
    if (!toState) {
      return;
    }
    if (toState.name === 'users.invitation.accept') {
      return;
    }
    if (toState.name === 'users.invitation.complete') {
      return;
    }
    if (toState.name === 'users.password.reset') {
      return;
    }
    if (toState.name === 'privacy_policy') {
      return;
    }
    if (toState.name === 'terms_of_service') {
      return;
    }
    return Devise.getCurrentUser().then(function(user) {
      var projectId, ref3, ref4;
      if (!user) {
        return;
      }
      $window.document.documentElement.lang = user.lang;
      if (user && toState.name === 'users.signIn') {
        event.preventDefault();
        return afterLoginHandler.handle(user);
      }
      if (toState.name === 'admin.pricing') {
        return;
      }
      lib.setHighChartOptions();
      if (!Devise.isMaster() && (((ref3 = toState.name) != null ? typeof ref3.indexOf === "function" ? ref3.indexOf('admin.projects.') : void 0 : void 0) === 0 && ((ref4 = toState.name) != null ? typeof ref4.indexOf === "function" ? ref4.indexOf('admin.projects.settings') : void 0 : void 0) !== 0 && typeof toParams.projectId !== "undefined")) {
        projectId = toParams.projectId;
        return Project.get(projectId).then(function(project) {
          if (project.tracking_tag_confirmed_at && (project.is_wevnal || project.conversion_tag_confirmed_at)) {
            return;
          }
          event.preventDefault();
          return $state.go('admin.projects.settings.installation', {
            projectId: projectId
          });
        });
      }
    });
  });
  return $rootScope.$on('$stateChangeError', function(event, toState, toStateParams, fromState, fromStateParams, errors) {
    console.log("Error changing state", errors, "FROM", fromState.name, "TO", toState.name, toStateParams);
    if (!Devise.currentUser) {
      return $state.go('users.signIn');
    }
  });
}]);

if (window.ZC_CONFIG.USE_WEBPACK_DEV_SERVER) {
  $.getScript("/webpack-dev-server.js");
}


/***/ }),
/* 463 */,
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./common_api/api/advertising.service.coffee": 997,
	"./common_api/api/agency.service": 161,
	"./common_api/api/agency.service.js": 161,
	"./common_api/api/badge_position_adjustments.service.coffee": 998,
	"./common_api/api/breadcrumb_selector.service.coffee": 999,
	"./common_api/api/campaign.service.js.coffee": 1000,
	"./common_api/api/campaign_policy_set.service.coffee": 1001,
	"./common_api/api/campaign_segment.service.coffee": 1002,
	"./common_api/api/campaign_template.service.coffee": 1003,
	"./common_api/api/cart_button.service.coffee": 1004,
	"./common_api/api/cart_price.service.coffee": 1005,
	"./common_api/api/clearance_item_set.service.coffee": 1006,
	"./common_api/api/cookie.service.coffee": 1007,
	"./common_api/api/dashboard_chart_positions.service": 162,
	"./common_api/api/dashboard_chart_positions.service.js": 162,
	"./common_api/api/deleted_item_detectors.coffee": 1008,
	"./common_api/api/exclude_ips.service.coffee": 1009,
	"./common_api/api/image_service.js.coffee": 1010,
	"./common_api/api/incentive.service.coffee": 1011,
	"./common_api/api/inquiry_service.js.coffee": 1012,
	"./common_api/api/installation_service.js.coffee": 1013,
	"./common_api/api/invoice_adjustments.service.coffee": 1014,
	"./common_api/api/ip.service.coffee": 1015,
	"./common_api/api/item_list_price.service.coffee": 1016,
	"./common_api/api/item_price.service.coffee": 1017,
	"./common_api/api/login_evaluator.service.coffee": 1018,
	"./common_api/api/meta_service.js.coffee": 1019,
	"./common_api/api/newsletter_parameter.service.coffee": 1020,
	"./common_api/api/page_type_sample_url_service.js.coffee": 1021,
	"./common_api/api/page_type_service.js.coffee": 1022,
	"./common_api/api/particular_event.service.coffee": 1023,
	"./common_api/api/project_request.transformer.js.coffee": 1024,
	"./common_api/api/project_response.transformer.js.coffee": 1025,
	"./common_api/api/project_service.js.coffee": 1026,
	"./common_api/api/segment_cookie.service.coffee": 1027,
	"./common_api/api/template_service.js.coffee": 1028,
	"./common_api/api/thumbnail_selector.service.coffee": 1029,
	"./common_api/api/title_selector.service.coffee": 1030,
	"./common_api/api/unique_coupon_code.service.coffee": 1031,
	"./common_api/api/untrack_page_type_service.js.coffee": 1032,
	"./common_api/api/user.service.coffee": 1033,
	"./common_api/api/visitor_segment.service.coffee": 1034,
	"./common_api/apollo/apollo.service": 163,
	"./common_api/apollo/apollo.service.js": 163,
	"./common_api/base_project_crud.service.js.coffee": 1035,
	"./common_api/facade/access_stats_service.js.coffee": 1036,
	"./common_api/facade/campaign_conversion_data.service": 164,
	"./common_api/facade/campaign_conversion_data.service.js": 164,
	"./common_api/facade/campaign_event_stats.service.coffee": 1037,
	"./common_api/facade/campaign_segment_stats.service": 165,
	"./common_api/facade/campaign_segment_stats.service.js": 165,
	"./common_api/facade/campaign_stats.service.js.coffee": 1038,
	"./common_api/facade/campaign_stats_v2.service": 166,
	"./common_api/facade/campaign_stats_v2.service.js": 166,
	"./common_api/facade/campaign_users.service.coffee": 1039,
	"./common_api/facade/installation_checker.js.coffee": 1040,
	"./common_api/facade/interest_trees.service.coffee": 1041,
	"./common_api/facade/interest_widget_item.service": 167,
	"./common_api/facade/interest_widget_item.service.js": 167,
	"./common_api/facade/interest_widget_stats.service": 168,
	"./common_api/facade/interest_widget_stats.service.js": 168,
	"./common_api/facade/mongo_campaign.service.coffee": 1042,
	"./common_api/facade/mongo_campaign_interest_widget_stats_without_bounces.service": 169,
	"./common_api/facade/mongo_campaign_interest_widget_stats_without_bounces.service.js": 169,
	"./common_api/facade/mongo_conversion.service.coffee": 1043,
	"./common_api/facade/mongo_history.service.coffee": 1044,
	"./common_api/facade/mongo_particular_event.service.coffee": 1045,
	"./common_api/facade/mongo_raw.service.coffee": 1046,
	"./common_api/facade/mongo_session.service.coffee": 1047,
	"./common_api/facade/project_stats_service.js.coffee": 1048,
	"./common_api/facade/report_campaign_stats.service.coffee": 1049,
	"./common_api/facade/report_service.js.coffee": 1050,
	"./common_api/facade/report_stats_response_transformer.coffee": 1051,
	"./common_api/facade/tag_non_existing_urls.service.js.coffee": 1052,
	"./common_api/facade/zcs_agency_invoice.service.coffee": 1053,
	"./common_api/facade/zcs_campaign_stats.service": 170,
	"./common_api/facade/zcs_campaign_stats.service.js": 170,
	"./common_api/filters/campaign_filter.js.coffee": 1054,
	"./common_api/filters/campaign_text_filter.js.coffee": 1055,
	"./common_api/filters/current_status.coffee": 1056,
	"./common_api/filters/device_filter.js.coffee": 1057,
	"./common_api/filters/overall_campaign_cvr_increase_rate": 171,
	"./common_api/filters/overall_campaign_cvr_increase_rate.js": 171,
	"./common_api/filters/project_text_filter.js.coffee": 1058,
	"./common_api/index.coffee": 443,
	"./common_api/misc/campaign_graph_options.coffee": 1059,
	"./common_api/misc/campaign_statuses.constant.coffee": 1060,
	"./common_api/misc/report_range.service.coffee": 1061,
	"./common_api/misc/segment_estimator.service.coffee": 1062,
	"./common_api/misc/segment_matcher.service.coffee": 1063,
	"./common_api/page_description.service.coffee": 1064,
	"./common_api/services.service": 172,
	"./common_api/services.service.js": 172,
	"./core/components/api_public_file_downloader/api_public_file_downloader": 173,
	"./core/components/api_public_file_downloader/api_public_file_downloader.html": 1356,
	"./core/components/api_public_file_downloader/api_public_file_downloader.js": 173,
	"./core/components/billing_representatives/billing_representatives": 174,
	"./core/components/billing_representatives/billing_representatives.html": 1357,
	"./core/components/billing_representatives/billing_representatives.js": 174,
	"./core/components/billing_representatives/billing_representatives.scss": 795,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage": 175,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html": 1358,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.js": 175,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.scss": 796,
	"./core/components/month_chooser/month_chooser": 176,
	"./core/components/month_chooser/month_chooser.html": 1359,
	"./core/components/month_chooser/month_chooser.js": 176,
	"./core/components/session_prediction_distribution/session_prediction_distribution": 177,
	"./core/components/session_prediction_distribution/session_prediction_distribution.html": 1360,
	"./core/components/session_prediction_distribution/session_prediction_distribution.js": 177,
	"./core/components/session_price_distribution/session_price_distribution": 178,
	"./core/components/session_price_distribution/session_price_distribution.html": 1361,
	"./core/components/session_price_distribution/session_price_distribution.js": 178,
	"./core/components/session_uplift_modeling_classification/session_uplift_modeling_classification": 179,
	"./core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html": 1362,
	"./core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.js": 179,
	"./core/components/sync_contract_info_button/sync_contract_info_button": 180,
	"./core/components/sync_contract_info_button/sync_contract_info_button.html": 1363,
	"./core/components/sync_contract_info_button/sync_contract_info_button.js": 180,
	"./core/components/tos_notification/tos_notification": 181,
	"./core/components/tos_notification/tos_notification.html": 1364,
	"./core/components/tos_notification/tos_notification.js": 181,
	"./core/config/zc.core.exceptions": 182,
	"./core/config/zc.core.exceptions.js": 182,
	"./core/config/zc.core.routes.js.coffee": 1065,
	"./core/config/zc.core.settings.js.coffee": 1066,
	"./core/config/zc.core.translations": 183,
	"./core/config/zc.core.translations.js": 183,
	"./core/constants/cron_hours.coffee": 1067,
	"./core/constants/currencies.coffee": 1068,
	"./core/controllers/admin_header.js.coffee": 1069,
	"./core/controllers/mainnav_controller.js.coffee": 1070,
	"./core/directives/admin.directive.coffee": 1071,
	"./core/directives/auto_fill_sync.directive": 184,
	"./core/directives/auto_fill_sync.directive.js": 184,
	"./core/directives/confirm_modal.js.coffee": 1072,
	"./core/directives/date_range.directive.coffee": 1073,
	"./core/directives/date_time_picker.js.coffee": 1074,
	"./core/directives/dirty_form_dialog.directive.coffee": 1075,
	"./core/directives/download_campaign_data_button.directive.coffee": 1076,
	"./core/directives/fixed-on-scroll.directive.coffee": 1077,
	"./core/directives/footer.directive.coffee": 1078,
	"./core/directives/loading.js.coffee": 1079,
	"./core/directives/pe_track.directive": 185,
	"./core/directives/pe_track.directive.js": 185,
	"./core/directives/positive_or_negative.js.coffee": 1080,
	"./core/directives/zc_date_time_picker.js.coffee": 1081,
	"./core/filters/billable_currencies": 186,
	"./core/filters/billable_currencies.js": 186,
	"./core/filters/byte_format.filter": 187,
	"./core/filters/byte_format.filter.js": 187,
	"./core/filters/change_datetime_from.filter.coffee": 1082,
	"./core/filters/date_obj_to_date.filter.js.coffee": 1083,
	"./core/filters/date_to_date_obj.filter.js.coffee": 1084,
	"./core/filters/day_of_week.js.coffee": 1085,
	"./core/filters/elapse_time_filter.js.coffee": 1086,
	"./core/filters/empty_to_end.js.coffee": 1087,
	"./core/filters/gmt_notation.filter": 188,
	"./core/filters/gmt_notation.filter.js": 188,
	"./core/filters/hour_of_day.js.coffee": 1088,
	"./core/filters/humanize_currency": 189,
	"./core/filters/humanize_currency.js": 189,
	"./core/filters/search_project.filter.coffee": 1089,
	"./core/filters/segment_value_format.filter.coffee": 1090,
	"./core/filters/show_element.filter.coffee": 1091,
	"./core/filters/unique_array": 190,
	"./core/filters/unique_array.js": 190,
	"./core/filters/zc_currency.coffee": 1092,
	"./core/filters/zc_date.coffee": 1093,
	"./core/filters/zeros_for_missing_time.coffee": 1094,
	"./core/index.js.coffee": 444,
	"./core/interceptors/error_interceptor.js.coffee": 1095,
	"./core/interceptors/notification_interceptor.js.coffee": 1096,
	"./core/interceptors/session_recoverer.coffee": 1097,
	"./core/modal_selector.controller.js.coffee": 1098,
	"./core/services/$http_once.service": 191,
	"./core/services/$http_once.service.js": 191,
	"./core/services/api.service.coffee": 1099,
	"./core/services/area_chart_v2_config.service": 192,
	"./core/services/area_chart_v2_config.service.js": 192,
	"./core/services/bar_chart_v2_config.service": 193,
	"./core/services/bar_chart_v2_config.service.js": 193,
	"./core/services/base_chart_v2_config.service": 194,
	"./core/services/base_chart_v2_config.service.js": 194,
	"./core/services/chart_v2.service": 195,
	"./core/services/chart_v2.service.js": 195,
	"./core/services/chronological_chart_v2_config.service": 196,
	"./core/services/chronological_chart_v2_config.service.js": 196,
	"./core/services/column_chart_v2_config.service": 197,
	"./core/services/column_chart_v2_config.service.js": 197,
	"./core/services/environment.service.coffee": 1100,
	"./core/services/facade_service.js.coffee": 1101,
	"./core/services/facade_v2_service.js.coffee": 1102,
	"./core/services/funnel_chart_v2_config.service": 198,
	"./core/services/funnel_chart_v2_config.service.js": 198,
	"./core/services/interest_widget.service.coffee": 1103,
	"./core/services/lib.coffee": 1104,
	"./core/services/line_chart_v2_config.service": 199,
	"./core/services/line_chart_v2_config.service.js": 199,
	"./core/services/notification_channel_service.js.coffee": 1105,
	"./core/services/page_layout.service.coffee": 1106,
	"./core/services/page_service.js.coffee": 1107,
	"./core/services/pie_chart_v2_config.service": 200,
	"./core/services/pie_chart_v2_config.service.js": 200,
	"./core/services/return_url.service.coffee": 1108,
	"./core/services/search_filter_service.js.coffee": 1109,
	"./core/services/zc_tag.service": 201,
	"./core/services/zc_tag.service.js": 201,
	"./core/views/404.html": 1365,
	"./core/views/500.html": 1366,
	"./core/views/admin.html": 1367,
	"./core/views/admin_header.html": 1368,
	"./core/views/admin_header_logout_only.html": 1369,
	"./core/views/data_processing_addendum.coffee": 1110,
	"./core/views/data_processing_addendum.html": 1370,
	"./core/views/directives/footer.html": 1371,
	"./core/views/directives/zc_date_time_picker.html": 1372,
	"./core/views/emptynav.html": 1373,
	"./core/views/mainnav.html": 1374,
	"./core/views/privacy_policy.html": 1375,
	"./core/views/privacy_policy.js.controller.coffee": 1111,
	"./core/views/terms_of_service_appier_inc.directive.coffee": 1112,
	"./core/views/terms_of_service_appier_inc.html": 1376,
	"./core/views/terms_of_service_appier_jp.directive.coffee": 1113,
	"./core/views/terms_of_service_appier_jp.html": 1377,
	"./core/views/terms_of_service_appier_others.directive.coffee": 1114,
	"./core/views/terms_of_service_appier_others.html": 1378,
	"./core/views/tos": 202,
	"./core/views/tos.html": 1379,
	"./core/views/tos.js": 202,
	"./core/views/tos_header": 203,
	"./core/views/tos_header.html": 1380,
	"./core/views/tos_header.js": 203
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./agencies/routes": 204,
	"./agencies/routes.js": 204,
	"./agencies/settings/agency_settings.component": 205,
	"./agencies/settings/agency_settings.component.js": 205,
	"./agencies/settings/agency_settings.html": 1381,
	"./agencies/zc.agencies.module": 109,
	"./agencies/zc.agencies.module.js": 109,
	"./projects.analytics/directives/main_chart.js.coffee": 1115,
	"./projects.analytics/directives/pie_chart.js.coffee": 1116,
	"./projects.analytics/directives/total_stats.js.coffee": 1117,
	"./projects.analytics/main_chart_items.coffee": 1118,
	"./projects.analytics/show.controller.coffee": 1119,
	"./projects.analytics/views/directives/main_chart.html": 1382,
	"./projects.analytics/views/directives/pie_chart.html": 1383,
	"./projects.analytics/views/directives/total_stats.html": 1384,
	"./projects.analytics/views/show.html": 1385,
	"./projects.campaigns/add_coupons.controller.js.coffee": 1120,
	"./projects.campaigns/add_coupons.html": 1386,
	"./projects.campaigns/add_coupons_modal.controller.js.coffee": 1121,
	"./projects.campaigns/add_coupons_modal.html": 1387,
	"./projects.campaigns/campaign_bulk_edit_modal": 206,
	"./projects.campaigns/campaign_bulk_edit_modal.html": 1388,
	"./projects.campaigns/campaign_bulk_edit_modal.js": 206,
	"./projects.campaigns/campaign_status_texts.constant.coffee": 1122,
	"./projects.campaigns/components/campaign_arms_list": 207,
	"./projects.campaigns/components/campaign_arms_list.html": 1389,
	"./projects.campaigns/components/campaign_arms_list.js": 207,
	"./projects.campaigns/components/campaign_check_status.js.coffee": 1123,
	"./projects.campaigns/components/campaign_summary": 208,
	"./projects.campaigns/components/campaign_summary.html": 1390,
	"./projects.campaigns/components/campaign_summary.js": 208,
	"./projects.campaigns/confirm.controller.coffee": 1124,
	"./projects.campaigns/confirm.html": 1391,
	"./projects.campaigns/directives/base_campaign_interest_widget_graph.coffee": 1125,
	"./projects.campaigns/directives/campaign_base_step.coffee": 1126,
	"./projects.campaigns/directives/campaign_botbonnie_step.coffee": 1127,
	"./projects.campaigns/directives/campaign_chisq_test.coffee": 1128,
	"./projects.campaigns/directives/campaign_confirm_step.coffee": 1129,
	"./projects.campaigns/directives/campaign_control_percent_labels.js.coffee": 1130,
	"./projects.campaigns/directives/campaign_coupon_applicable_rate.directive.coffee": 1131,
	"./projects.campaigns/directives/campaign_coupon_data.directive.coffee": 1132,
	"./projects.campaigns/directives/campaign_creatives.coffee": 1133,
	"./projects.campaigns/directives/campaign_dynamic_view.coffee": 1134,
	"./projects.campaigns/directives/campaign_events.coffee": 1135,
	"./projects.campaigns/directives/campaign_filter_view.js.coffee": 1136,
	"./projects.campaigns/directives/campaign_graph.js.coffee": 1137,
	"./projects.campaigns/directives/campaign_groups.coffee": 1138,
	"./projects.campaigns/directives/campaign_incentive_error.directive.coffee": 1139,
	"./projects.campaigns/directives/campaign_incentive_list.js.coffee": 1140,
	"./projects.campaigns/directives/campaign_incentive_step.coffee": 1141,
	"./projects.campaigns/directives/campaign_incentive_table.directive.coffee": 1142,
	"./projects.campaigns/directives/campaign_incentive_warning.directive.coffee": 1143,
	"./projects.campaigns/directives/campaign_interest_widget_cart_button_click_rate_graph.coffee": 1144,
	"./projects.campaigns/directives/campaign_interest_widget_cart_button_click_rate_ratio_graph.coffee": 1145,
	"./projects.campaigns/directives/campaign_interest_widget_click_rate_graph.coffee": 1146,
	"./projects.campaigns/directives/campaign_interest_widget_conversion_price_graph.coffee": 1147,
	"./projects.campaigns/directives/campaign_interest_widget_conversion_rate_graph.coffee": 1148,
	"./projects.campaigns/directives/campaign_interest_widget_conversion_rate_ratio_graph.coffee": 1149,
	"./projects.campaigns/directives/campaign_interest_widget_delivery_graph.coffee": 1150,
	"./projects.campaigns/directives/campaign_interest_widget_event.directive.coffee": 1151,
	"./projects.campaigns/directives/campaign_interest_widget_item_graph.coffee": 1152,
	"./projects.campaigns/directives/campaign_interest_widget_swipe_rate_graph.coffee": 1153,
	"./projects.campaigns/directives/campaign_kpi_view.js.coffee": 1154,
	"./projects.campaigns/directives/campaign_list_view.js.coffee": 1155,
	"./projects.campaigns/directives/campaign_moment_graph.coffee": 1156,
	"./projects.campaigns/directives/campaign_navigator.coffee": 1157,
	"./projects.campaigns/directives/campaign_note": 209,
	"./projects.campaigns/directives/campaign_note.js": 209,
	"./projects.campaigns/directives/campaign_panels.coffee": 1158,
	"./projects.campaigns/directives/campaign_policy_step.coffee": 1159,
	"./projects.campaigns/directives/campaign_price_districution.coffee": 1160,
	"./projects.campaigns/directives/campaign_range.coffee": 1161,
	"./projects.campaigns/directives/campaign_recent_segment_table.directive.coffee": 1162,
	"./projects.campaigns/directives/campaign_schedule_step.coffee": 1163,
	"./projects.campaigns/directives/campaign_segment_flag.coffee": 1164,
	"./projects.campaigns/directives/campaign_segment_graph.coffee": 1165,
	"./projects.campaigns/directives/campaign_segment_panels.coffee": 1166,
	"./projects.campaigns/directives/campaign_segment_summary.coffee": 1167,
	"./projects.campaigns/directives/campaign_steps.coffee": 1168,
	"./projects.campaigns/directives/campaign_table.js.coffee": 1169,
	"./projects.campaigns/directives/campaign_table_row.js.coffee": 1170,
	"./projects.campaigns/directives/campaign_template_item.coffee": 1171,
	"./projects.campaigns/directives/campaign_template_setting.coffee": 1172,
	"./projects.campaigns/directives/campaign_template_step.coffee": 1173,
	"./projects.campaigns/directives/campaign_timing_step.directive.coffee": 1174,
	"./projects.campaigns/directives/graph_dimension_select.js.coffee": 1175,
	"./projects.campaigns/directives/heatmap_table.directive.coffee": 1176,
	"./projects.campaigns/directives/label_campaign_device.js.coffee": 1177,
	"./projects.campaigns/directives/label_campaign_segment.js.coffee": 1178,
	"./projects.campaigns/directives/label_campaign_status.js.coffee": 1179,
	"./projects.campaigns/directives/page_type_selector.coffee": 1180,
	"./projects.campaigns/directives/segment_condition_table.js.coffee": 1181,
	"./projects.campaigns/directives/zc_aggregate_type.directive.coffee": 1182,
	"./projects.campaigns/directives/zc_label_clearance.directive.coffee": 1183,
	"./projects.campaigns/edit.controller.js.coffee": 1184,
	"./projects.campaigns/edit.html": 1392,
	"./projects.campaigns/index.js.coffee": 445,
	"./projects.campaigns/list.controller.js.coffee": 1185,
	"./projects.campaigns/list.html": 1393,
	"./projects.campaigns/routes.js.coffee": 1186,
	"./projects.campaigns/segment_relevant_headers.filter.coffee": 1187,
	"./projects.campaigns/show.controller.js.coffee": 1188,
	"./projects.campaigns/show.html": 1394,
	"./projects.campaigns/show_clearance.html": 1395,
	"./projects.campaigns/show_creative.html": 1396,
	"./projects.campaigns/show_incentive.html": 1397,
	"./projects.campaigns/show_interest_widget.html": 1398,
	"./projects.campaigns/show_moment.html": 1399,
	"./projects.campaigns/show_notes.html": 1400,
	"./projects.campaigns/show_segment.html": 1401,
	"./projects.campaigns/show_stats.html": 1402,
	"./projects.campaigns/views/directives/campaign_base_step.html": 1403,
	"./projects.campaigns/views/directives/campaign_botbonnie_step.html": 1404,
	"./projects.campaigns/views/directives/campaign_chisq_test.html": 1405,
	"./projects.campaigns/views/directives/campaign_confirm_step.html": 1406,
	"./projects.campaigns/views/directives/campaign_control_percent_labels.html": 1407,
	"./projects.campaigns/views/directives/campaign_coupon_applicable_rate.html": 1408,
	"./projects.campaigns/views/directives/campaign_coupon_data.html": 1409,
	"./projects.campaigns/views/directives/campaign_creatives.html": 1410,
	"./projects.campaigns/views/directives/campaign_dynamic_view.html": 1411,
	"./projects.campaigns/views/directives/campaign_events.html": 1412,
	"./projects.campaigns/views/directives/campaign_filter.html": 1413,
	"./projects.campaigns/views/directives/campaign_graph.html": 1414,
	"./projects.campaigns/views/directives/campaign_groups.html": 1415,
	"./projects.campaigns/views/directives/campaign_incentive_list.html": 1416,
	"./projects.campaigns/views/directives/campaign_incentive_step.html": 1417,
	"./projects.campaigns/views/directives/campaign_incentive_table.html": 1418,
	"./projects.campaigns/views/directives/campaign_interest_widget_event.html": 1419,
	"./projects.campaigns/views/directives/campaign_list.html": 1420,
	"./projects.campaigns/views/directives/campaign_moment_graph.html": 1421,
	"./projects.campaigns/views/directives/campaign_navigator.html": 1422,
	"./projects.campaigns/views/directives/campaign_note.html": 1423,
	"./projects.campaigns/views/directives/campaign_note_editor.html": 1424,
	"./projects.campaigns/views/directives/campaign_notes.html": 1425,
	"./projects.campaigns/views/directives/campaign_panels.html": 1426,
	"./projects.campaigns/views/directives/campaign_policy_step.html": 1427,
	"./projects.campaigns/views/directives/campaign_range.html": 1428,
	"./projects.campaigns/views/directives/campaign_recent_segment_table.html": 1429,
	"./projects.campaigns/views/directives/campaign_schedule_step.html": 1430,
	"./projects.campaigns/views/directives/campaign_segment_flag.html": 1431,
	"./projects.campaigns/views/directives/campaign_segment_graph.html": 1432,
	"./projects.campaigns/views/directives/campaign_segment_panels.html": 1433,
	"./projects.campaigns/views/directives/campaign_segment_summary.html": 1434,
	"./projects.campaigns/views/directives/campaign_steps.html": 1435,
	"./projects.campaigns/views/directives/campaign_table.html": 1436,
	"./projects.campaigns/views/directives/campaign_table_row.css.scss": 797,
	"./projects.campaigns/views/directives/campaign_table_row.html": 1437,
	"./projects.campaigns/views/directives/campaign_template_item.css.scss": 798,
	"./projects.campaigns/views/directives/campaign_template_item.html": 1438,
	"./projects.campaigns/views/directives/campaign_template_setting.html": 1439,
	"./projects.campaigns/views/directives/campaign_template_step.html": 1440,
	"./projects.campaigns/views/directives/campaign_timing_step.html": 1441,
	"./projects.campaigns/views/directives/graph_dimension_select.html": 1442,
	"./projects.campaigns/views/directives/label_campaign_status.html": 1443,
	"./projects.campaigns/views/directives/segment_condition_table.html": 1444,
	"./projects.campaigns/views/directives/segment_condition_table_vertical.html": 1445,
	"./projects.campaigns/views/image_browser.html": 1446,
	"./projects.clearance/clearance_download_button.directive.coffee": 1189,
	"./projects.clearance/clearance_item_list.directive.coffee": 1190,
	"./projects.clearance/clearance_item_list.html": 1447,
	"./projects.clearance/clearance_set_show.controller.coffee": 1191,
	"./projects.clearance/clearance_set_show.html": 1448,
	"./projects.clearance/routes.coffee": 1192,
	"./projects.dashboard/campaign_count_chart.controller": 210,
	"./projects.dashboard/campaign_count_chart.controller.js": 210,
	"./projects.dashboard/campaign_count_chart.html": 1449,
	"./projects.dashboard/conversion_price_chart.controller": 211,
	"./projects.dashboard/conversion_price_chart.controller.js": 211,
	"./projects.dashboard/conversion_price_chart.html": 1450,
	"./projects.dashboard/dashboard.controller": 212,
	"./projects.dashboard/dashboard.controller.js": 212,
	"./projects.dashboard/dashboard.html": 1451,
	"./projects.dashboard/dashboard.scss": 799,
	"./projects.dashboard/dashboard_chart_loader": 213,
	"./projects.dashboard/dashboard_chart_loader.js": 213,
	"./projects.dashboard/delivery_chart.controller": 214,
	"./projects.dashboard/delivery_chart.controller.js": 214,
	"./projects.dashboard/delivery_chart.html": 1452,
	"./projects.dashboard/device_distribution_chart.controller": 215,
	"./projects.dashboard/device_distribution_chart.controller.js": 215,
	"./projects.dashboard/device_distribution_chart.html": 1453,
	"./projects.dashboard/invoice_chart.controller": 216,
	"./projects.dashboard/invoice_chart.controller.js": 216,
	"./projects.dashboard/invoice_chart.html": 1454,
	"./projects.dashboard/reaction_chart.controller": 217,
	"./projects.dashboard/reaction_chart.controller.js": 217,
	"./projects.dashboard/reaction_chart.html": 1455,
	"./projects.dashboard/routes": 218,
	"./projects.dashboard/routes.js": 218,
	"./projects.heatmap/heatmap": 110,
	"./projects.heatmap/heatmap.component": 219,
	"./projects.heatmap/heatmap.component.js": 219,
	"./projects.heatmap/heatmap.html": 1456,
	"./projects.heatmap/heatmap.js": 110,
	"./projects.heatmap/heatmap.scss": 800,
	"./projects.heatmap/heatmap_list.component": 220,
	"./projects.heatmap/heatmap_list.component.js": 220,
	"./projects.heatmap/heatmap_list.html": 1457,
	"./projects.heatmap/routes": 221,
	"./projects.heatmap/routes.js": 221,
	"./projects.heatmap/views/directives/heatmap_table.html": 1458,
	"./projects.heatmap/zc.projects.heatmap.module": 111,
	"./projects.heatmap/zc.projects.heatmap.module.js": 111,
	"./projects.incentives/edit.controller.coffee": 1193,
	"./projects.incentives/edit.html": 1459,
	"./projects.incentives/incentive_code.directive.coffee": 1194,
	"./projects.incentives/incentive_detail.directive.coffee": 1195,
	"./projects.incentives/incentive_detail.html": 1460,
	"./projects.incentives/incentive_status.directive.coffee": 1196,
	"./projects.incentives/incentive_table.directive.coffee": 1197,
	"./projects.incentives/incentive_table.html": 1461,
	"./projects.incentives/list.controller.coffee": 1198,
	"./projects.incentives/list.html": 1462,
	"./projects.incentives/routes.coffee": 1199,
	"./projects.incentives/show.controller.coffee": 1200,
	"./projects.incentives/show.html": 1463,
	"./projects.incentives/unique_coupon_code_csv_upload.controller": 222,
	"./projects.incentives/unique_coupon_code_csv_upload.controller.js": 222,
	"./projects.incentives/unique_coupon_code_list.directive": 223,
	"./projects.incentives/unique_coupon_code_list.directive.js": 223,
	"./projects.incentives/unique_coupon_code_list.html": 1464,
	"./projects.iw/iw_conversion_price": 224,
	"./projects.iw/iw_conversion_price.html": 1465,
	"./projects.iw/iw_conversion_price.js": 224,
	"./projects.iw/iw_conversion_rate": 225,
	"./projects.iw/iw_conversion_rate.html": 1466,
	"./projects.iw/iw_conversion_rate.js": 225,
	"./projects.iw/iw_graph_options.constant": 226,
	"./projects.iw/iw_graph_options.constant.js": 226,
	"./projects.iw/iw_items": 227,
	"./projects.iw/iw_items.html": 1467,
	"./projects.iw/iw_items.js": 227,
	"./projects.iw/iw_main_comparison": 228,
	"./projects.iw/iw_main_comparison.html": 1468,
	"./projects.iw/iw_main_comparison.js": 228,
	"./projects.iw/iw_navigation": 229,
	"./projects.iw/iw_navigation.html": 1469,
	"./projects.iw/iw_navigation.js": 229,
	"./projects.iw/iw_report": 230,
	"./projects.iw/iw_report.html": 1470,
	"./projects.iw/iw_report.js": 230,
	"./projects.iw/iw_segment_rate": 231,
	"./projects.iw/iw_segment_rate.html": 1471,
	"./projects.iw/iw_segment_rate.js": 231,
	"./projects.iw/iw_started_rate": 232,
	"./projects.iw/iw_started_rate.html": 1472,
	"./projects.iw/iw_started_rate.js": 232,
	"./projects.iw/iw_use_rate": 233,
	"./projects.iw/iw_use_rate.html": 1473,
	"./projects.iw/iw_use_rate.js": 233,
	"./projects.iw/iw_utm_medium_rate": 234,
	"./projects.iw/iw_utm_medium_rate.html": 1474,
	"./projects.iw/iw_utm_medium_rate.js": 234,
	"./projects.reports/client_report_csv_creator.service.coffee": 1201,
	"./projects.reports/download_monthly_report_button.directive.coffee": 1202,
	"./projects.reports/index.js.coffee": 446,
	"./projects.reports/list.controller.js.coffee": 1203,
	"./projects.reports/list.html": 1475,
	"./projects.reports/report_graph.directive.coffee": 1204,
	"./projects.reports/report_graph.html": 1476,
	"./projects.reports/routes.js.coffee": 1205,
	"./projects.reports/show.controller.js.coffee": 1206,
	"./projects.reports/show.html": 1477,
	"./projects.segments/campaign_segment_edit_all.html": 1478,
	"./projects.segments/campaign_segment_edit_common.html": 1479,
	"./projects.segments/campaign_segment_edit_custom.html": 1480,
	"./projects.segments/campaign_segment_edit_cv_users.html": 1481,
	"./projects.segments/campaign_segment_edit_inactive.html": 1482,
	"./projects.segments/campaign_segment_edit_new.html": 1483,
	"./projects.segments/campaign_segment_edit_new_inverse.html": 1484,
	"./projects.segments/campaign_segment_editor.directive.js.coffee": 1207,
	"./projects.segments/campaign_segment_editor.html": 1485,
	"./projects.segments/campaign_segment_list.directive.coffee": 1208,
	"./projects.segments/campaign_segment_list.html": 1486,
	"./projects.segments/campaign_segment_options.directive.coffee": 1209,
	"./projects.segments/campaign_segment_options.html": 1487,
	"./projects.segments/campaign_segment_row.directive.coffee": 1210,
	"./projects.segments/campaign_segment_row.html": 1488,
	"./projects.segments/campaign_segment_show.directive.coffee": 1211,
	"./projects.segments/campaign_segment_show.html": 1489,
	"./projects.segments/campaign_segment_show_all.html": 1490,
	"./projects.segments/campaign_segment_show_common.html": 1491,
	"./projects.segments/campaign_segment_show_custom.html": 1492,
	"./projects.segments/campaign_segment_show_cv_users.html": 1493,
	"./projects.segments/campaign_segment_show_inactive.html": 1494,
	"./projects.segments/campaign_segment_show_new.html": 1495,
	"./projects.segments/campaign_segment_show_new_inverse.html": 1496,
	"./projects.segments/campaign_segment_table_brief.directive.coffee": 1212,
	"./projects.segments/campaign_segment_table_brief.html": 1497,
	"./projects.segments/country_code_selector.coffee": 1213,
	"./projects.segments/edit.controller.coffee": 1214,
	"./projects.segments/edit.html": 1498,
	"./projects.segments/list.controller.coffee": 1215,
	"./projects.segments/list.html": 1499,
	"./projects.segments/routes.coffee": 1216,
	"./projects.segments/show.controller.coffee": 1217,
	"./projects.segments/show.html": 1500,
	"./projects.segments/titles_by_segment_type.coffee": 1218,
	"./projects.segments/visitor_segment_selector.coffee": 1219,
	"./projects.settings/base_project_confirm.directive.coffee": 1220,
	"./projects.settings/base_project_confirm.html": 1501,
	"./projects.settings/base_project_crud_editor.coffee": 1221,
	"./projects.settings/basic/basic.html": 1502,
	"./projects.settings/basic/control_percent.html": 1503,
	"./projects.settings/basic/index.html": 1504,
	"./projects.settings/basic/project_status.html": 1505,
	"./projects.settings/basic/remove_apikey.html": 1506,
	"./projects.settings/basic/sales_management.html": 1507,
	"./projects.settings/basic/submenu.html": 1508,
	"./projects.settings/billing/billing_information.html": 1509,
	"./projects.settings/billing/billing_representatives.html": 1510,
	"./projects.settings/billing/index.html": 1511,
	"./projects.settings/billing/invoice_information.html": 1512,
	"./projects.settings/billing/iw_information.html": 1513,
	"./projects.settings/billing/lens_information.html": 1514,
	"./projects.settings/billing/submenu.html": 1515,
	"./projects.settings/billing/zc_information.html": 1516,
	"./projects.settings/campaign/advertising.html": 1517,
	"./projects.settings/campaign/advertising_editor.directive.coffee": 1222,
	"./projects.settings/campaign/advertising_editor.html": 1518,
	"./projects.settings/campaign/campaign_policy_set.controller.coffee": 1223,
	"./projects.settings/campaign/dm_upload.html": 1519,
	"./projects.settings/campaign/newsletter.html": 1520,
	"./projects.settings/campaign/newsletter_parameter_editor.directive.coffee": 1224,
	"./projects.settings/campaign/newsletter_parameter_editor.html": 1521,
	"./projects.settings/campaign/no_publish_page_type.html": 1522,
	"./projects.settings/campaign/no_publish_page_type_csv.controller": 235,
	"./projects.settings/campaign/no_publish_page_type_csv.controller.js": 235,
	"./projects.settings/campaign/no_publish_page_type_form": 236,
	"./projects.settings/campaign/no_publish_page_type_form.html": 1523,
	"./projects.settings/campaign/no_publish_page_type_form.js": 236,
	"./projects.settings/campaign/segment_cookie.directive.coffee": 1225,
	"./projects.settings/campaign/segment_cookie.html": 1524,
	"./projects.settings/campaign/segment_cookie_editor.html": 1525,
	"./projects.settings/campaign/submenu.html": 1526,
	"./projects.settings/campaign/timing.html": 1527,
	"./projects.settings/index.controller.coffee": 1226,
	"./projects.settings/index.html": 1528,
	"./projects.settings/initialization/cart_button.html": 1529,
	"./projects.settings/initialization/cart_button_editor.directive.coffee": 1227,
	"./projects.settings/initialization/cart_button_editor.html": 1530,
	"./projects.settings/initialization/cart_price.html": 1531,
	"./projects.settings/initialization/cart_price_confirm.controller.coffee": 1228,
	"./projects.settings/initialization/cart_price_editor.directive.coffee": 1229,
	"./projects.settings/initialization/cart_price_editor.html": 1532,
	"./projects.settings/initialization/cookie_editor.directive.coffee": 1230,
	"./projects.settings/initialization/cookie_editor.html": 1533,
	"./projects.settings/initialization/cookie_server_setting.html": 1534,
	"./projects.settings/initialization/cross_domain.html": 1535,
	"./projects.settings/initialization/distinguish_direct_indirect_cv.html": 1536,
	"./projects.settings/initialization/exclude_ip.html": 1537,
	"./projects.settings/initialization/exclude_ip_editor.directive.coffee": 1231,
	"./projects.settings/initialization/exclude_ip_editor.html": 1538,
	"./projects.settings/initialization/ga_tag_tracking.controller.coffee": 1232,
	"./projects.settings/initialization/ga_tag_tracking.html": 1539,
	"./projects.settings/initialization/index.html": 1540,
	"./projects.settings/initialization/item_list_price.html": 1541,
	"./projects.settings/initialization/item_list_price_editor.directive.coffee": 1233,
	"./projects.settings/initialization/item_list_price_editor.html": 1542,
	"./projects.settings/initialization/item_price.html": 1543,
	"./projects.settings/initialization/item_price_editor.directive.coffee": 1234,
	"./projects.settings/initialization/item_price_editor.html": 1544,
	"./projects.settings/initialization/login_evaluator.html": 1545,
	"./projects.settings/initialization/login_evaluator_editor.directive.coffee": 1235,
	"./projects.settings/initialization/login_evaluator_editor.html": 1546,
	"./projects.settings/initialization/page_type.html": 1547,
	"./projects.settings/initialization/page_type_editor.directive.coffee": 1236,
	"./projects.settings/initialization/page_type_editor.html": 1548,
	"./projects.settings/initialization/page_type_sample.directive.coffee": 1237,
	"./projects.settings/initialization/page_type_sample.html": 1549,
	"./projects.settings/initialization/page_type_single.directive.coffee": 1238,
	"./projects.settings/initialization/page_type_single.html": 1550,
	"./projects.settings/initialization/session_count_evaluator.html": 1551,
	"./projects.settings/initialization/submenu.html": 1552,
	"./projects.settings/installation/conversion_tag.controller.coffee": 1239,
	"./projects.settings/installation/conversion_tag.html": 1553,
	"./projects.settings/installation/conversion_url.html": 1554,
	"./projects.settings/installation/domain.html": 1555,
	"./projects.settings/installation/exclude_ip.html": 1556,
	"./projects.settings/installation/index.html": 1557,
	"./projects.settings/installation/login_evaluator_memo.html": 1558,
	"./projects.settings/installation/newsletter_parameter_memo.html": 1559,
	"./projects.settings/installation/submenu.html": 1560,
	"./projects.settings/installation/test_conversion.html": 1561,
	"./projects.settings/installation/tracking_tag.controller.coffee": 1240,
	"./projects.settings/installation/tracking_tag.html": 1562,
	"./projects.settings/menu.controller": 237,
	"./projects.settings/menu.controller.js": 237,
	"./projects.settings/menu.html": 1563,
	"./projects.settings/other/app.html": 1564,
	"./projects.settings/other/badge_position_adjustment_editor.directive.coffee": 1241,
	"./projects.settings/other/badge_position_adjustment_editor.html": 1565,
	"./projects.settings/other/breadcrumb.html": 1566,
	"./projects.settings/other/breadcrumb_selector.directive.coffee": 1242,
	"./projects.settings/other/breadcrumb_selector.html": 1567,
	"./projects.settings/other/data_management.html": 1568,
	"./projects.settings/other/deleted_item_detector.directive.coffee": 1243,
	"./projects.settings/other/deleted_item_detector.html": 1569,
	"./projects.settings/other/description_confirm.directive.coffee": 1244,
	"./projects.settings/other/index.html": 1570,
	"./projects.settings/other/interest_widget_tree_confirm.directive.coffee": 1245,
	"./projects.settings/other/item_list_price_confirm.directive": 238,
	"./projects.settings/other/item_list_price_confirm.directive.js": 238,
	"./projects.settings/other/item_price_confirm.directive.coffee": 1246,
	"./projects.settings/other/iw.html": 1571,
	"./projects.settings/other/page_description.directive.coffee": 1247,
	"./projects.settings/other/page_description.html": 1572,
	"./projects.settings/other/particular_event.html": 1573,
	"./projects.settings/other/particular_event_editor.directive.coffee": 1248,
	"./projects.settings/other/particular_event_editor.html": 1574,
	"./projects.settings/other/publish_domain.html": 1575,
	"./projects.settings/other/review_link_confirm.directive.coffee": 1249,
	"./projects.settings/other/review_link_editor.directive.coffee": 1250,
	"./projects.settings/other/review_link_editor.html": 1576,
	"./projects.settings/other/submenu.html": 1577,
	"./projects.settings/other/thumbnail_selector.directive.coffee": 1251,
	"./projects.settings/other/thumbnail_selector.html": 1578,
	"./projects.settings/other/thumbnail_selector_confirm.directive.coffee": 1252,
	"./projects.settings/other/title_selector.directive.coffee": 1253,
	"./projects.settings/other/title_selector.html": 1579,
	"./projects.settings/other/title_selector_confirm.directive.coffee": 1254,
	"./projects.settings/other/zcs.html": 1580,
	"./projects.settings/routes.coffee": 1255,
	"./projects.settings/setting_status.coffee": 1256,
	"./projects.settings/setting_status.service.coffee": 1257,
	"./projects.settings/users/index.controller.coffee": 1258,
	"./projects.settings/users/index.html": 1581,
	"./projects.settings/users/internal_user_table": 239,
	"./projects.settings/users/internal_user_table.html": 1582,
	"./projects.settings/users/internal_user_table.js": 239,
	"./projects.settings/users/invite.controller.coffee": 1259,
	"./projects.settings/users/invite.html": 1583,
	"./projects.settings/users/label_user_invitation.directive.coffee": 1260,
	"./projects.settings/users/submenu.html": 1584,
	"./projects.site_reports/campaign_segment.controller": 240,
	"./projects.site_reports/campaign_segment.controller.js": 240,
	"./projects.site_reports/campaign_segment.html": 1585,
	"./projects.site_reports/campaign_table.controller": 241,
	"./projects.site_reports/campaign_table.controller.js": 241,
	"./projects.site_reports/campaign_table.html": 1586,
	"./projects.site_reports/campaing_table.scss": 801,
	"./projects.site_reports/conversion_cover.controller": 242,
	"./projects.site_reports/conversion_cover.controller.js": 242,
	"./projects.site_reports/conversion_cover.html": 1587,
	"./projects.site_reports/conversion_price.controller": 243,
	"./projects.site_reports/conversion_price.controller.js": 243,
	"./projects.site_reports/conversion_price.html": 1588,
	"./projects.site_reports/conversion_segment.controller": 244,
	"./projects.site_reports/conversion_segment.controller.js": 244,
	"./projects.site_reports/conversion_segment.html": 1589,
	"./projects.site_reports/device_segment.controller": 245,
	"./projects.site_reports/device_segment.controller.js": 245,
	"./projects.site_reports/device_segment.html": 1590,
	"./projects.site_reports/glossary.controller": 246,
	"./projects.site_reports/glossary.controller.js": 246,
	"./projects.site_reports/glossary.html": 1591,
	"./projects.site_reports/index.scss": 802,
	"./projects.site_reports/kpi_box.controller": 247,
	"./projects.site_reports/kpi_box.controller.js": 247,
	"./projects.site_reports/kpi_box.html": 1592,
	"./projects.site_reports/kpi_summary.controller": 248,
	"./projects.site_reports/kpi_summary.controller.js": 248,
	"./projects.site_reports/kpi_summary.html": 1593,
	"./projects.site_reports/navigation.controller": 249,
	"./projects.site_reports/navigation.controller.js": 249,
	"./projects.site_reports/navigation.html": 1594,
	"./projects.site_reports/session_cover.controller": 250,
	"./projects.site_reports/session_cover.controller.js": 250,
	"./projects.site_reports/session_cover.html": 1595,
	"./projects.site_reports/summary.controller": 251,
	"./projects.site_reports/summary.controller.js": 251,
	"./projects.site_reports/summary.html": 1596,
	"./projects.site_reports/utm_medium_segment.controller": 252,
	"./projects.site_reports/utm_medium_segment.controller.js": 252,
	"./projects.site_reports/utm_medium_segment.html": 1597,
	"./projects/components/domain_sampler/domain_sampler": 253,
	"./projects/components/domain_sampler/domain_sampler.html": 1598,
	"./projects/components/domain_sampler/domain_sampler.js": 253,
	"./projects/components/session_sampler/session_sampler": 254,
	"./projects/components/session_sampler/session_sampler.html": 1599,
	"./projects/components/session_sampler/session_sampler.js": 254,
	"./projects/constants/chart_config.js.coffee": 1261,
	"./projects/controllers/clearance_item_set_upload.controller.coffee": 1262,
	"./projects/controllers/detail_controller.js.coffee": 1263,
	"./projects/controllers/edit_controller.js.coffee": 1264,
	"./projects/controllers/home.controller.coffee": 1265,
	"./projects/controllers/images/image_browser_controller.js.coffee": 1266,
	"./projects/controllers/images/index.js.coffee": 1267,
	"./projects/controllers/images/new_controller.js.coffee": 1268,
	"./projects/controllers/invitation/new.js.coffee": 1269,
	"./projects/controllers/new_controller.js.coffee": 1270,
	"./projects/controllers/visitor_id_for_dm_upload.controller.coffee": 1271,
	"./projects/directives/project_notification.html": 1600,
	"./projects/directives/project_notification.js.coffee": 1272,
	"./projects/directives/projects/advertisings_list.directive.coffee": 1273,
	"./projects/directives/projects/advertisings_list.html": 1601,
	"./projects/directives/projects/currency_formatter.directive": 255,
	"./projects/directives/projects/currency_formatter.directive.js": 255,
	"./projects/directives/projects/login_evaluators_list.directive.coffee": 1274,
	"./projects/directives/projects/login_evaluators_list.html": 1602,
	"./projects/directives/projects/newsletter_parameters_list.directive.coffee": 1275,
	"./projects/directives/projects/newsletter_parameters_list.html": 1603,
	"./projects/directives/projects/project_apikey_menu.directive.coffee": 1276,
	"./projects/directives/projects/project_exclude_ips.js.coffee": 1277,
	"./projects/directives/projects/project_list.directive.coffee": 1278,
	"./projects/directives/projects/project_page_types.js.coffee": 1279,
	"./projects/directives/projects/project_search.coffee": 1280,
	"./projects/directives/projects/projects_menu.js.coffee": 1281,
	"./projects/directives/projects/projects_menu_search.coffee": 1282,
	"./projects/directives/projects/zc_label_project_status.js.coffee": 1283,
	"./projects/directives/projects/zc_label_report_status.coffee": 1284,
	"./projects/index.js.coffee": 447,
	"./projects/routes.js.coffee": 1285,
	"./projects/services/chart_service.js.coffee": 1286,
	"./projects/views/detail.html": 1604,
	"./projects/views/directives/kpi_view.html": 1605,
	"./projects/views/directives/project_apikey_menu.html": 1606,
	"./projects/views/directives/project_list.html": 1607,
	"./projects/views/directives/project_search.html": 1608,
	"./projects/views/directives/project_search_single.html": 1609,
	"./projects/views/directives/projects_menu.html": 1610,
	"./projects/views/directives/projects_menu_search.html": 1611,
	"./projects/views/edit.html": 1612,
	"./projects/views/home.html": 1613,
	"./projects/views/images/index.html": 1614,
	"./projects/views/maintenance.html": 1615,
	"./users.pages/directives/footer_links_directive.js.coffee": 1287,
	"./users.pages/index.js.coffee": 448,
	"./users.pages/routes.js.coffee": 1288,
	"./users.pages/views/pricing.html": 1616,
	"./users/controllers/edit_controller.js.coffee": 1289,
	"./users/controllers/invitation/accept.js.coffee": 1290,
	"./users/controllers/password/edit_password_controller.js.coffee": 1291,
	"./users/controllers/password/new_controller.js.coffee": 1292,
	"./users/controllers/password/reset_password_controller.js.coffee": 1293,
	"./users/controllers/sign_in_controller.js.coffee": 1294,
	"./users/directives/language_select_header_directive.js.coffee": 1295,
	"./users/directives/master_only.directive.coffee": 1296,
	"./users/directives/user_menu_directive.js.coffee": 1297,
	"./users/index.js.coffee": 449,
	"./users/inquiry.html": 1617,
	"./users/inquiry_controller.js.coffee": 1298,
	"./users/routes.js.coffee": 1299,
	"./users/services/devise_service.js.coffee": 1300,
	"./users/user_sidebar.controller.js.coffee": 1301,
	"./users/user_sidebar.html": 1618,
	"./users/views/devise_header.html": 1619,
	"./users/views/directives/language_select_header.html": 1620,
	"./users/views/directives/user_menu.html": 1621,
	"./users/views/edit.html": 1622,
	"./users/views/invitation/accept.html": 1623,
	"./users/views/password/edit.html": 1624,
	"./users/views/password/forgot.html": 1625,
	"./users/views/password/reset.html": 1626,
	"./users/views/sign_in.html": 1627
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;

/***/ }),
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  RAILS_API_URL: 'https://aideal-api.appier.com',
  RAILS_API_PORT: 443,
  FACADE_API_URL: 'https://facade.zenclerk.com',
  FACADE_API_PORT: 443,
  ZC_APIKEY: 'emin-zc',
  ZC_TAG_EVENT_PREFIX: 'zc',
  AIDEAL_URL: 'https://aideal-app.appier.com',
  GRAPHQL_URL_APP: 'https://aideal-graphql.appier.com/graphql',
  GRAPHQL_URL_MASTER: 'https://aideal-graphql.appier.com/mgraphql',
  SENTRY_DSN: 'https://1ff4c3da9a49c5c5cded3a2d290bdde4@sentry.zenclerk.com/14',
  CONFIG_ENV: 'production',
  ENABLE_AUTH0: true
};

/***/ }),
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */,
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5330aaa5ee12e76fd844eb3004656f7.svg";

/***/ }),
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("ProjectAdvertising", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectAdvertising;
  ProjectAdvertising = (function(superClass) {
    extend(ProjectAdvertising, superClass);

    function ProjectAdvertising() {
      return ProjectAdvertising.__super__.constructor.apply(this, arguments);
    }

    return ProjectAdvertising;

  })(BaseProjectCrudService);
  return new ProjectAdvertising($resource, $q, "/api/projects/:projectId/advertisings/:id", "advertising", "advertisings");
}]);


/***/ }),
/* 998 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectBadgePositionAdjustment', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectBadgePositionAdjustment;
  ProjectBadgePositionAdjustment = (function(superClass) {
    extend(ProjectBadgePositionAdjustment, superClass);

    function ProjectBadgePositionAdjustment() {
      return ProjectBadgePositionAdjustment.__super__.constructor.apply(this, arguments);
    }

    return ProjectBadgePositionAdjustment;

  })(BaseProjectCrudService);
  return new ProjectBadgePositionAdjustment($resource, $q, '/api/master/projects/:projectId/badge_position_adjustments/:id', 'badge_position_adjustment', 'badge_position_adjustments');
}]);


/***/ }),
/* 999 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectBreadcrumb', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectBreadcrumb;
  ProjectBreadcrumb = (function(superClass) {
    extend(ProjectBreadcrumb, superClass);

    function ProjectBreadcrumb() {
      return ProjectBreadcrumb.__super__.constructor.apply(this, arguments);
    }

    return ProjectBreadcrumb;

  })(BaseProjectCrudService);
  return new ProjectBreadcrumb($resource, $q, '/api/master/projects/:projectId/breadcrumbs/:id', 'breadcrumb', 'breadcrumbs');
}]);


/***/ }),
/* 1000 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').factory("Campaign", ["$http", "$injector", "$q", "$resource", "$translate", "Api", "CampaignConversionData", "FacadeV2", "Meta", "MongoSession", "Project", "campaignServiceRequestTransformer", "campaignServiceResponseTransformer", function($http, $injector, $q, $resource, $translate, Api, CampaignConversionData, FacadeV2, Meta, MongoSession, Project, campaignServiceRequestTransformer, campaignServiceResponseTransformer) {
  var Campaign, getCSVData, getCampaignConversionData, getConversionCSVData, service;
  Campaign = $resource(Api.path("/api/projects/:projectId/campaigns/:campaignId"), {
    projectId: this.projectId,
    campaignId: this.id
  }, {
    get: {
      method: 'GET',
      transformResponse: campaignServiceResponseTransformer
    },
    query: {
      method: 'GET',
      transformResponse: campaignServiceResponseTransformer,
      isArray: false
    },
    update: {
      method: 'PUT',
      transformRequest: campaignServiceRequestTransformer,
      transformResponse: campaignServiceResponseTransformer
    },
    create: {
      method: 'POST',
      transformRequest: campaignServiceRequestTransformer,
      transformResponse: campaignServiceResponseTransformer
    }
  });
  getCSVData = function(conversionData, csvHeaders, fractionSize) {
    var conversion, header, i, len, results;
    if (fractionSize == null) {
      fractionSize = 0;
    }
    results = [];
    for (i = 0, len = conversionData.length; i < len; i++) {
      conversion = conversionData[i];
      results.push((function() {
        var j, len1, results1;
        results1 = [];
        for (j = 0, len1 = csvHeaders.length; j < len1; j++) {
          header = csvHeaders[j];
          if (header === 'created_at') {
            results1.push(moment(conversion.conversion_at).format('YYYY/MM/DD HH:mm:ss'));
          } else if (header === 'usid_overlap') {
            results1.push(conversion[header] || '');
          } else if (header === 'is_control') {
            results1.push(+conversion[header]);
          } else if (header === 'price') {
            results1.push(conversion[header] / Math.pow(10, fractionSize));
          } else {
            results1.push(conversion[header]);
          }
        }
        return results1;
      })());
    }
    return results;
  };
  getCampaignConversionData = function(params) {
    var match;
    match = {
      apikey: params.apikey,
      campaign_id: params.campaignId,
      start_at: {
        $gte: moment(params.filters.start_at).toDate(),
        $lt: moment(params.filters.end_at).toDate()
      }
    };
    if (params.isSecretAb) {
      match.is_control = false;
    }
    return CampaignConversionData.find({
      apikey: params.apikey
    }, {
      match: match
    }).then(function(conversions) {
      var chunks, promises;
      if (_.every(conversions, function(conversion) {
        return _.has(conversion, 'landing_page');
      })) {
        return conversions;
      }
      chunks = _.chunk(_.map(conversions, '_usid'), 50);
      promises = _.map(chunks, function(chunk) {
        return MongoSession.find({
          apikey: params.apikey,
          _id: {
            $in: chunk
          }
        }, {
          fields: ['landing_page']
        });
      });
      return $q.all(promises).then(function(sessions) {
        sessions = _.flatten(sessions);
        return _.map(conversions, function(conversion) {
          var conversionSession;
          conversionSession = _.find(sessions, {
            _id: conversion._usid
          });
          conversion.landing_page = _.get(conversionSession, 'landing_page') || null;
          return conversion;
        });
      });
    });
  };
  getConversionCSVData = function(params) {
    return getCampaignConversionData(params).then(function(conversionData) {
      var conversion, csvHeaders, cvIdConversions, data, filteredConversionData, i, len, noCvIdConversions;
      csvHeaders = [];
      csvHeaders.push('_uuid');
      csvHeaders.push('_usid');
      if (!params.isSecretAb) {
        csvHeaders.push('is_control');
      }
      csvHeaders.push('id');
      csvHeaders.push('price');
      csvHeaders.push('currency');
      csvHeaders.push('url');
      csvHeaders.push('landing_page');
      csvHeaders.push('created_at');
      csvHeaders.push('usid_overlap');
      for (i = 0, len = conversionData.length; i < len; i++) {
        conversion = conversionData[i];
        conversion['conversion_at_str'] = moment(conversion.conversion_at).format('YYYY/MM/DD HH:mm:ss');
      }
      _.sortBy(conversionData, ['is_control', 'conversion_at_str']);
      noCvIdConversions = _.filter(conversionData, function(cv) {
        return cv.id === 'undefined';
      });
      cvIdConversions = _.filter(conversionData, function(cv) {
        return cv.id !== 'undefined';
      });
      filteredConversionData = _.uniqBy(cvIdConversions, 'id');
      filteredConversionData = _.concat(filteredConversionData, noCvIdConversions);
      data = getCSVData(filteredConversionData, csvHeaders, params.fractionSize);
      data.unshift(csvHeaders);
      if (!params.isSecretAb) {
        data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.notDisplayAb')]);
      }
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.multipleCvOneSession')]);
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.conversionManagement')]);
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.conversionNotMatch')]);
      return data;
    });
  };
  service = {
    getCSV: function(params) {
      if (params.csvType === 'conversions') {
        return getConversionCSVData(params);
      } else {
        throw new Error("Unknown csvType: " + params.csvType);
      }
    },
    pastCampaignFilters: function() {
      return {
        interest_widget_id: null,
        $or: [
          {
            end_at: {
              $lt: moment().toDate()
            },
            status: {
              $nin: ['incomplete', 'preview', 'pending']
            }
          }, {
            status: 'terminated'
          }
        ]
      };
    },
    activeFilters: function() {
      return {
        interest_widget_id: null,
        end_at: {
          $gte: moment().toDate()
        },
        status: {
          $nin: ['incomplete', 'preview', 'pending', 'terminated']
        }
      };
    },
    activeFiltersThisMonth: function() {
      return {
        interest_widget_id: null,
        end_at: {
          $gte: moment().startOf('month').toDate()
        },
        status: {
          $nin: ['incomplete', 'preview', 'pending', 'terminated']
        }
      };
    },
    incompleteFilters: function() {
      return {
        interest_widget_id: null,
        status: {
          $in: ['incomplete']
        }
      };
    },
    isWidget: function(campaign) {
      return Meta.getInterestWidgetTemplates().then(function(templates) {
        var ref;
        return ref = campaign.template_type, indexOf.call(templates, ref) >= 0;
      });
    },
    previewUrl: function(base_url, campaign) {
      var coupon_code, id_param, ref, ref1, ref2, ref3;
      coupon_code = '';
      if (((ref = campaign.current_incentive) != null ? ref.incentive_type : void 0) === 'unique_coupon_code') {
        coupon_code = 'UNIQUE CODE';
      }
      if (((ref1 = campaign.current_incentive) != null ? ref1.coupon_code : void 0) != null) {
        coupon_code = (ref2 = campaign.current_incentive) != null ? ref2.coupon_code : void 0;
      } else if (((ref3 = campaign.incentives[0]) != null ? ref3.coupon_code : void 0) != null) {
        coupon_code = campaign.incentives[0].coupon_code;
      }
      id_param = campaign.interest_widget_id ? 'zc_widget_id' : 'zc_element_id';
      base_url += base_url.match(/\?/) ? '&' : '?';
      base_url += id_param + "=" + campaign.element.id + "&zc_control=0&zc_force_connection=1";
      if (coupon_code) {
        base_url += "&zc_coupon_code=" + coupon_code;
      }
      if (campaign.is_widget) {
        base_url += '&zc_console=1';
      }
      return base_url;
    },
    showsAllParams: function(campaign) {
      var md5;
      md5 = $injector.get('md5');
      return "zc_mmcp=" + (md5.createHash(campaign.element.id.toString()));
    },
    showsAllUrl: function(base_url, campaign) {
      var params;
      params = this.showsAllParams(campaign);
      if (base_url.match(/\?/)) {
        return base_url + "&" + params;
      } else {
        return base_url + "?" + params;
      }
    },
    adminUrl: function(params, campaign) {
      return "https://zenclerk.com/admin/projects/" + params + "/campaigns/" + campaign.id + "/creative";
    },
    toggleActive: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/active", {
        campaign: {
          state: params.state
        }
      });
    },
    finish: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/finished");
    },
    activate: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/activated");
    },
    preview: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/preview");
    },
    terminate: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/terminated");
    },
    incomplete: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/incomplete");
    },
    copy: function(params) {
      return Api.post("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/copy", {
        transformResponse: campaignServiceResponseTransformer
      });
    },
    destroy: function(params) {
      return Api["delete"]("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId);
    },
    getTemplate: function(params) {
      var d;
      d = $q.defer();
      Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/template").then(function(res) {
        return d.resolve(res.data.template);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    all: function(params) {
      var d;
      d = $q.defer();
      Campaign.query(params).$promise.then(function(res) {
        return d.resolve(res.campaigns);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    get: function(params) {
      return $q(function(resolve, reject) {
        return Campaign.get(params).$promise.then(function(res) {
          return resolve(res.campaign);
        }, function(err) {
          return reject(err);
        });
      });
    },
    update: function(params, campaign) {
      return $q(function(resolve, reject) {
        return Campaign.update(params, campaign).$promise.then(function(res) {
          if (res.success) {
            return resolve(res);
          } else {
            return reject(res);
          }
        });
      });
    },
    create: function(params, campaign) {
      var d;
      d = $q.defer();
      Api.post("/api/projects/" + params.projectId + "/campaigns", {
        campaign: {}
      }).then(function(res) {
        return d.resolve(res.data);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    createFromParams: function(paths, params) {
      var d;
      d = $q.defer();
      Campaign.create({
        projectId: paths.projectId
      }, params).$promise.then(function(res) {
        return d.resolve(res.data);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    campaignEventOrder: function(params) {
      var d;
      d = $q.defer();
      Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/event_order").then(function(res) {
        return d.resolve(res.data.event_order);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    campaignEventNotices: function(params) {
      var d;
      d = $q.defer();
      Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/event_notices").then(function(res) {
        return d.resolve(res.data.event_notices);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    githubUrl: function(params) {
      return $q(function(resolve, reject) {
        return Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/github_url").then(function(res) {
          return resolve(res.data.github_url);
        }, function(err) {
          return reject(err);
        });
      });
    },
    publish: function(params) {
      return $q(function(resolve, reject) {
        return FacadeV2.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/publish/" + params._usid, {
          method: 'POST',
          transformResponse: $http.defaults.transformResponse,
          params: params
        }).then(function(res) {
          if (!res.data.success) {
            return reject(res.data.error);
          }
          return resolve(res.data);
        });
      });
    },
    addCouponCode: function(params) {
      return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/add_coupon_code_to_campaign", params).then(function(res) {
        if (res.data.success) {
          return res.data.agency;
        } else {
          return $q.reject(res);
        }
      });
    },
    addIncentives: function(params) {
      return Api.patch("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/add_incentives", params).then(function(res) {
        if (res.data.success) {
          return res.data.incentives;
        } else {
          return $q.reject(res);
        }
      });
    },
    canAddIncentive: function(campaign) {
      if (campaign.current_status === 'terminated') {
        return false;
      }
      if (campaign.is_widget) {
        return false;
      }
      return true;
    },
    hideBadgeConfigItem: function(item, campaign) {
      var ref;
      if (((ref = item.name) === 'badge_position' || ref === 'badge_icon' || ref === 'countdown_lang' || ref === 'offer_hint' || ref === 'offer_hint_display_until' || ref === 'notice' || ref === 'present_hint' || ref === 'reload_button_text') && campaign.element.message.enables_badge === false) {
        return true;
      }
      return false;
    },
    hideCodeLabelConfigItem: function(item, campaign) {
      var ref;
      if (((ref = item.name) === 'code_name') && campaign.element.message.enables_code_offer_view === false) {
        return true;
      }
      return false;
    }
  };
  return service;
}]).factory('campaignServiceResponseTransformer', ["$filter", "currencies", "lib", function($filter, currencies, lib) {
  var doTransform;
  doTransform = function(campaign) {
    var campaign_obj, current_status, element, end_at, err, i, incentive, len, pageTypeFields, ref, start_at;
    try {
      start_at = null;
      if (campaign.start_at) {
        start_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'string', campaign.region);
      }
      start_at = $filter('dateToDateObj')(start_at);
      end_at = null;
      if (campaign.end_at) {
        end_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'string', campaign.region);
      }
      end_at = $filter('dateToDateObj')(end_at);
      element = {};
      element.message = {};
      if (campaign.elements && campaign.elements.length > 0) {
        element.id = campaign.elements[0].id;
        element.message = angular.fromJson(campaign.elements[0].message);
        pageTypeFields = ['reject_pagetypes', 'receive_page_types', 'ignore_pagetype', 'limit_pagetypes'];
        _.each(pageTypeFields, function(pageTypeField) {
          if (_.isString(element.message[pageTypeField])) {
            return element.message[pageTypeField] = lib.stringToArray(element.message[pageTypeField]);
          }
        });
      }
      current_status = $filter('currentStatus')(campaign);
      if (campaign.incentives) {
        ref = campaign.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.start_at) {
            incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.start_at, 'date', campaign.region);
          }
          if (incentive.end_at) {
            incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.end_at, 'date', campaign.region);
          }
        }
      }
      campaign_obj = {
        id: campaign.id,
        name: campaign.name,
        fee_rate: campaign.fee_rate,
        fee_calculation_type: campaign.fee_calculation_type,
        notes_json: campaign.notes_json,
        apikey: campaign.apikey,
        api_version: campaign.api_version,
        currency: currencies[campaign.project_currency],
        project_id: campaign.project_id,
        project_name: campaign.project_name,
        memo: campaign.memo,
        custom_css: campaign.custom_css,
        control_percent: campaign.control_percent,
        campaign_device: campaign.campaign_device,
        campaign_target: campaign.campaign_target,
        campaign_policy_set: campaign.campaign_policy_set,
        campaign_policy_set_id: campaign.campaign_policy_set_id,
        is_fired: campaign.is_fired,
        clearance_item_set_id: campaign.clearance_item_set_id,
        has_been_started: campaign.has_been_started,
        project_base_url: campaign.project_base_url,
        project_product_line: campaign.project_product_line,
        project_users: campaign.project_users,
        template_type: campaign.template_type,
        campaign_type: campaign.campaign_type,
        status: campaign.status,
        days_since_last_received: campaign.days_since_last_received,
        days_since_last_received_conversion: campaign.days_since_last_received_conversion,
        is_information_campaign: campaign.is_information_campaign,
        is_aov_campaign: campaign.is_aov_campaign,
        is_secret_ab: campaign.is_secret_ab,
        current_status: current_status,
        region: campaign.region,
        start_at: campaign.start_at ? $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'date', campaign.region) : void 0,
        end_at: campaign.end_at ? $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'date', campaign.region) : void 0,
        start_at_obj: start_at,
        end_at_obj: end_at,
        referrer_type: (!campaign.referrer_type ? 0 : campaign.referrer_type),
        segment: campaign.segment,
        segment_id: campaign.segment_id,
        exclude_logged_in: campaign.exclude_logged_in,
        element: element,
        incentives: campaign.incentives,
        incentive_ids: _.map(campaign.incentives, 'id'),
        requires_incentives: campaign.requires_incentives,
        current_incentive: campaign.current_incentive,
        aggregate_type: campaign.aggregate_type,
        created_at: moment(campaign.created_at).tz("Asia/Tokyo").toDate(),
        updated_at: moment(campaign.updated_at).tz("Asia/Tokyo").toDate(),
        interest_widget_id: campaign.interest_widget_id,
        is_widget: campaign.is_widget,
        is_supported_by_widget: campaign.is_supported_by_widget,
        is_infinite: campaign.is_infinite,
        auto_restart: campaign.auto_restart,
        target_conversion_name: campaign.target_conversion_name,
        incentive_draft: campaign.incentive_draft,
        campaign_control_percent: campaign.campaign_control_percent,
        was_activated_before: campaign.was_activated_before,
        cost_per_acquisition: campaign.cost_per_acquisition,
        predictions_max_threshold: campaign.predictions_max_threshold,
        predictions_min_threshold: campaign.predictions_min_threshold,
        exclude_cart_button_click: campaign.exclude_cart_button_click,
        price_min_threshold: campaign.price_min_threshold,
        price_max_threshold: campaign.price_max_threshold,
        exclude_no_price: campaign.exclude_no_price,
        configuration_type: campaign.configuration_type,
        score_threshold: campaign.score_threshold,
        auto_configuration: campaign.auto_configuration,
        model_names: campaign.model_names,
        testing_unit: campaign.testing_unit,
        ai_model_names: campaign.ai_model_names,
        sampling_range: campaign.sampling_range,
        sampling_score_threshold: campaign.sampling_score_threshold,
        enable_botbonnie_integration: campaign.enable_botbonnie_integration,
        botbonnie_trigger_rules: campaign.botbonnie_trigger_rules,
        enable_botbonnie_open_chatroom: campaign.enable_botbonnie_open_chatroom
      };
      _.each(['notes_json', 'incentive_draft', 'model_names'], function(parameter) {
        var err;
        try {
          if (campaign_obj[parameter]) {
            return campaign_obj[parameter] = JSON.parse(campaign_obj[parameter]);
          } else {
            return campaign_obj[parameter] = {};
          }
        } catch (error) {
          err = error;
          throw new Error('Invalid JSON value', campaign[parameter]);
        }
      });
      return campaign_obj;
    } catch (error) {
      err = error;
      return {};
    }
  };
  return function(data, headers, status) {
    var campaigns, obj;
    try {
      data = angular.fromJson(data);
    } catch (error) {
      if (status === 406 && data.match(/UnknownFormat/)) {

      } else {
        console.log("Failed to parse campaign");
      }
      data = {
        campaigns: []
      };
    }
    if (_.get(data, 'campaigns')) {
      campaigns = data.campaigns;
      if (_.isArray(campaigns)) {
        if (campaigns.length > 0) {
          return _.assignIn(data, {
            campaigns: _.map(campaigns, doTransform)
          });
        }
        return _.assignIn(data, {
          campaigns: []
        });
      }
    } else if (_.get(data, 'campaign')) {
      obj = data.campaign;
      obj.elements = data.elements;
      return _.assignIn(data, {
        campaign: doTransform(obj)
      });
    }
    return _.assignIn(data, {
      campaigns: []
    });
  };
}]).factory('campaignServiceRequestTransformer', ["$filter", function($filter) {
  var doTransform;
  doTransform = function(elem) {
    var pageTypeFields;
    elem = $.extend(true, {}, elem);
    elem.start_at = $filter('dateObjToDate')(elem.start_at_obj);
    elem.start_at = $filter('changeDatetimeFrom')('localToRegion', elem.start_at, 'string', elem.region);
    elem.end_at = $filter('dateObjToDate')(elem.end_at_obj);
    elem.end_at = $filter('changeDatetimeFrom')('localToRegion', elem.end_at, 'string', elem.region);
    elem.updated_at = moment().tz("Asia/Tokyo").toDate();
    if (elem.incentive_draft) {
      if (elem.incentive_draft.is_infinite) {
        elem.end_at = moment('2100-12-31').toDate();
      }
      elem.incentive_draft = angular.toJson(elem.incentive_draft);
    }
    if (elem.notes_json) {
      elem.notes_json = angular.toJson(elem.notes_json);
    }
    if (elem.elements) {
      elem.elements = [elem.elements[0]];
    } else {
      elem.elements = [elem.element];
    }
    pageTypeFields = ['reject_pagetypes', 'receive_page_types', 'ignore_pagetype', 'limit_pagetypes'];
    if (elem.elements[0] && elem.elements[0].message) {
      _.each(pageTypeFields, function(pageTypeField) {
        if (_.isArray(elem.elements[0].message[pageTypeField])) {
          return elem.elements[0].message[pageTypeField] = elem.elements[0].message[pageTypeField].join(',');
        } else if (elem.elements[0].message[pageTypeField] === null) {
          return elem.elements[0].message[pageTypeField] = '';
        }
      });
    }
    return elem;
  };
  return function(data) {
    if (data.campaign) {
      data.campaign = doTransform(data.campaign);
    } else {
      data = {
        campaign: doTransform(data)
      };
    }
    data.element = data.campaign.elements[0];
    return JSON.stringify(data);
  };
}]);


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignPolicySet', ["$resource", "$q", "Api", function($resource, $q, Api) {
  var CampaignPolicySet, URL, service;
  URL = '/api/projects/:projectId/campaign_policy_sets/:id';
  CampaignPolicySet = $resource(Api.path(URL), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    save: {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    },
    destroy: {
      method: 'DELETE'
    }
  });
  service = {
    all: function(params) {
      return $q(function(resolve, reject) {
        return CampaignPolicySet.query(params, function(res) {
          return resolve(res.campaign_policy_sets);
        });
      });
    },
    create: function(params, set) {
      return $q(function(resolve, reject) {
        var campaign_policy_set;
        campaign_policy_set = new CampaignPolicySet(set);
        return campaign_policy_set.$save(params).then(function(res) {
          return resolve(res.campaign_policy_set);
        });
      });
    },
    destroy: function(params) {
      return $q(function(resolve, reject) {
        return CampaignPolicySet.destroy(params).$promise.then(function(res) {
          return resolve(res);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("CampaignSegment", ["$resource", "$q", "BaseProjectCrudService", "Api", "campaignSegmentResponseTransformer", "campaignSegmentRequestTransformer", function($resource, $q, BaseProjectCrudService, Api, campaignSegmentResponseTransformer, campaignSegmentRequestTransformer) {
  var CampaignSegment;
  CampaignSegment = (function(superClass) {
    extend(CampaignSegment, superClass);

    function CampaignSegment() {
      return CampaignSegment.__super__.constructor.apply(this, arguments);
    }

    CampaignSegment.prototype.toZcRuleCollection = function(name, collection) {
      var column, f, ret, v;
      ret = {};
      for (f in collection) {
        v = collection[f];
        if (!f || f === 'apikey') {
          continue;
        }
        column = name + "#" + f;
        if (!(_.isBoolean(v) || _.isPlainObject(v)) && /^(is_)|(syncd)/.test(f)) {
          throw {
            message: column + " should be boolean or object "
          };
        }
        if (_.isPlainObject(v) && v['$not'] && v['$not']['$regex']) {
          throw {
            message: "{$not: {$regex: 'xxx'}} is not allowed in MongoDB"
          };
        }
        ret[column] = v;
      }
      return ret;
    };

    CampaignSegment.prototype.toZcRule = function(campaignSegment) {
      var err, jsonObj;
      jsonObj = {};
      try {
        if (campaignSegment.visitor) {
          eval("var visitorQuery = " + campaignSegment.visitor + ";");
          _.assignIn(jsonObj, this.toZcRuleCollection('Visitor', visitorQuery));
        }
        if (campaignSegment.session) {
          eval("var sessionQuery = " + campaignSegment.session + ";");
          _.assignIn(jsonObj, this.toZcRuleCollection('Session', sessionQuery));
        }
        campaignSegment.raw = JSON.stringify({
          visitor: campaignSegment.visitor,
          session: campaignSegment.session
        });
        campaignSegment.message = '';
      } catch (error) {
        err = error;
        campaignSegment.message = err.message;
        null;
      }
      return jsonObj;
    };

    CampaignSegment.prototype.checkZcRule = function(campaignSegment) {
      var f, ref, v;
      if (!campaignSegment) {
        return;
      }
      campaignSegment.rule = this.toZcRule(campaignSegment);
      campaignSegment.ruleView = '';
      if (campaignSegment.rule) {
        ref = campaignSegment.rule;
        for (f in ref) {
          v = ref[f];
          campaignSegment.ruleView += f + ", " + (JSON.stringify(v)) + "\n";
        }
        return campaignSegment.json = JSON.stringify(campaignSegment.rule);
      }
    };

    CampaignSegment.prototype.getMongoQuery = function(campaignSegment) {
      var segment;
      segment = _.merge({}, campaignSegment);
      if (segment.conditions_json.limit_to_landing_page_types && (_.isEmpty(segment.conditions_json.limit_to_landing_page_types) || segment.conditions_json.limit_to_landing_page_types[0] === "NOT_SELECTED")) {
        delete segment.conditions_json.limit_to_landing_page_types;
      }
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + campaignSegment.project_id + "/campaign_segments/mongo_query", {
          campaign_segment: segment
        }).then(function(res) {
          return resolve(res.data.mongo_query);
        });
      });
    };

    return CampaignSegment;

  })(BaseProjectCrudService);
  return new CampaignSegment($resource, $q, "/api/projects/:projectId/campaign_segments/:id", "campaign_segment", "campaign_segments", {
    response: campaignSegmentResponseTransformer,
    request: campaignSegmentRequestTransformer
  });
}]).factory("campaignSegmentRequestTransformer", function() {
  var doTransform;
  doTransform = function(elem) {
    if (elem.conditions_json.limit_to_landing_page_types && elem.conditions_json.limit_to_landing_page_types.length && elem.conditions_json.limit_to_landing_page_types[0] === 'NOT_SELECTED') {
      elem.conditions_json.limit_to_landing_page_types[0] = "";
    }
    return elem;
  };
  return function(data) {
    var dataObj;
    dataObj = _.merge({}, data);
    if (dataObj.campaign_segment) {
      dataObj.campaign_segment = doTransform(dataObj.campaign_segment);
    }
    return angular.toJson(dataObj);
  };
}).factory("campaignSegmentResponseTransformer", function() {
  var doTransform;
  doTransform = function(elem) {
    var raw;
    raw = angular.fromJson(elem.raw);
    if (raw) {
      elem.visitor = raw.visitor;
      return elem.session = raw.session;
    }
  };
  return function(data) {
    var campaign_segment, i, len, ref;
    if (!data) {
      return;
    }
    data = angular.fromJson(data);
    if (data.campaign_segment) {
      doTransform(data.campaign_segment);
    } else {
      ref = data.campaign_segments;
      for (i = 0, len = ref.length; i < len; i++) {
        campaign_segment = ref[i];
        doTransform(campaign_segment);
      }
    }
    return data;
  };
});


/***/ }),
/* 1003 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignTemplate', ["$q", "Api", function($q, Api) {
  var CampaignTemplate;
  return CampaignTemplate = (function() {
    function CampaignTemplate() {}

    CampaignTemplate.views = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/views", params).then(function(res) {
          return resolve(res.data.views);
        }, function(err) {
          return reject(err);
        });
      });
    };

    CampaignTemplate.css = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/css", params).then(function(res) {
          return resolve(res.data.css);
        }, function(err) {
          return reject(err);
        });
      });
    };

    CampaignTemplate.confirmCss = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/confirm_css", params).then(function(res) {
          return resolve(res.data.css);
        }, function(err) {
          return reject(err);
        });
      });
    };

    CampaignTemplate.confirmJs = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/confirm_js", params).then(function(res) {
          return resolve(res.data.js);
        }, function(err) {
          return reject(err);
        });
      });
    };

    return CampaignTemplate;

  })();
}]);


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectCartButton', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectCartButton;
  ProjectCartButton = (function(superClass) {
    extend(ProjectCartButton, superClass);

    function ProjectCartButton() {
      return ProjectCartButton.__super__.constructor.apply(this, arguments);
    }

    return ProjectCartButton;

  })(BaseProjectCrudService);
  return new ProjectCartButton($resource, $q, '/api/projects/:projectId/cart_buttons/:id', 'cart_button', 'cart_buttons');
}]);


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectCartPrice', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectCartPrice;
  ProjectCartPrice = (function(superClass) {
    extend(ProjectCartPrice, superClass);

    function ProjectCartPrice() {
      return ProjectCartPrice.__super__.constructor.apply(this, arguments);
    }

    return ProjectCartPrice;

  })(BaseProjectCrudService);
  return new ProjectCartPrice($resource, $q, '/api/projects/:projectId/cart_prices/:id', 'cart_price', 'cart_prices');
}]);


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ClearanceItemSet', ["$resource", "$q", "Api", function($resource, $q, Api) {
  var ClearanceItemSet, URL, service;
  URL = '/api/projects/:projectId/clearance_item_sets/:id';
  ClearanceItemSet = $resource(Api.path(URL), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    save: {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    },
    destroy: {
      method: 'DELETE'
    },
    update: {
      method: 'PATCH'
    },
    items: {
      method: 'GET',
      url: (Api.path(URL)) + "/items"
    }
  });
  service = {
    all: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.query(params, function(res) {
          return resolve(res.clearance_item_sets);
        }, function(err) {
          return reject(err);
        });
      });
    },
    find: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.query(params, function(res) {
          return resolve(res.clearance_item_set);
        }, function(err) {
          return reject(err);
        });
      });
    },
    getItems: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.items(params, function(res) {
          return resolve(res.clearance_items);
        }, function(err) {
          return reject(err);
        });
      });
    },
    create: function(params, set) {
      return $q(function(resolve, reject) {
        var clearance_item_set;
        clearance_item_set = new ClearanceItemSet(set);
        return clearance_item_set.$save(params).then(function(res) {
          return resolve(res.clearance_item_set);
        }, function(err) {
          return reject(err);
        });
      });
    },
    destroy: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.destroy({
          projectId: params.project_id,
          id: params.id
        }).$promise.then(function(res) {
          return resolve(res);
        }, function(err) {
          return reject(err);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectCookie', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectCookie;
  ProjectCookie = (function(superClass) {
    extend(ProjectCookie, superClass);

    function ProjectCookie() {
      return ProjectCookie.__super__.constructor.apply(this, arguments);
    }

    return ProjectCookie;

  })(BaseProjectCrudService);
  return new ProjectCookie($resource, $q, '/api/projects/:projectId/cookies/:id', 'cookie', 'cookies');
}]);


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectDeletedItemDetector', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectDeletedItemDetector;
  ProjectDeletedItemDetector = (function(superClass) {
    extend(ProjectDeletedItemDetector, superClass);

    function ProjectDeletedItemDetector() {
      return ProjectDeletedItemDetector.__super__.constructor.apply(this, arguments);
    }

    return ProjectDeletedItemDetector;

  })(BaseProjectCrudService);
  return new ProjectDeletedItemDetector($resource, $q, '/api/master/projects/:projectId/deleted_item_detectors/:id', 'deleted_item_detector', 'deleted_item_detectors');
}]);


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectExcludeIp', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectExcludeIp;
  ProjectExcludeIp = (function(superClass) {
    extend(ProjectExcludeIp, superClass);

    function ProjectExcludeIp() {
      return ProjectExcludeIp.__super__.constructor.apply(this, arguments);
    }

    return ProjectExcludeIp;

  })(BaseProjectCrudService);
  return new ProjectExcludeIp($resource, $q, '/api/projects/:projectId/exclude_ips/:id', 'exclude_ip', 'exclude_ips');
}]);


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("Image", ["$resource", "$q", "Api", function($resource, $q, Api) {
  var Image, service;
  Image = $resource(Api.path("/api/projects/:projectId/images/:imageId"), {
    projectId: this.projectId,
    imageId: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    destroy: {
      method: 'DELETE'
    }
  });
  service = {
    all: function(params) {
      var d;
      d = $q.defer();
      Image.query(params).$promise.then(function(res) {
        return d.resolve(res.images);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    get: function(params) {
      var d;
      d = $q.defer();
      Image.get(params).$promise.then(function(res) {
        return d.resolve(res.images);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    markAsUnselectable: function(params) {
      var d;
      d = $q.defer();
      d.promise;
      Image.destroy({
        projectId: params.project_id,
        imageId: params.id
      }).$promise.then(function(res) {
        return d.resolve(res.images);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    }
  };
  return service;
}]);


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('Incentive', ["$filter", "$q", "$resource", "BaseProjectCrudService", function($filter, $q, $resource, BaseProjectCrudService) {
  var Incentive;
  Incentive = (function(superClass) {
    extend(Incentive, superClass);

    function Incentive() {
      return Incentive.__super__.constructor.apply(this, arguments);
    }

    return Incentive;

  })(BaseProjectCrudService);
  return new Incentive($resource, $q, "/api/projects/:projectId/incentives/:id", "incentive", "incentives", {
    request: function(data) {
      var i, incentive, len, ref;
      if (data.incentives) {
        ref = data.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.start_at) {
            incentive.start_at = $filter('changeDatetimeFrom')('localToRegion', incentive.start_at);
          }
          if (incentive.end_at) {
            incentive.end_at = $filter('changeDatetimeFrom')('localToRegion', incentive.end_at);
          }
        }
      } else if (data.incentive) {
        if (data.incentive.start_at) {
          data.incentive.start_at = $filter('changeDatetimeFrom')('localToRegion', data.incentive.start_at);
        }
        if (data.incentive.end_at) {
          data.incentive.end_at = $filter('changeDatetimeFrom')('localToRegion', data.incentive.end_at);
        }
      }
      return angular.toJson(data);
    },
    response: function(data) {
      var i, incentive, len, ref;
      data = angular.fromJson(data);
      if (data.incentives) {
        ref = data.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.start_at) {
            incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.start_at);
          }
          if (incentive.end_at) {
            incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.end_at);
          }
        }
      } else if (data.incentive) {
        if (data.incentive.start_at) {
          data.incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', data.incentive.start_at);
        }
        if (data.incentive.end_at) {
          data.incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', data.incentive.end_at);
        }
      }
      return data;
    }
  });
}]);


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Inquiry', ["$resource", "Api", "$q", "$injector", function($resource, Api, $q, $injector) {
  var Inquiry, service;
  Inquiry = $resource(Api.path("/api/inquiry/"));
  service = {
    reasons: null,
    create: function(projectId, message, reason) {
      var NotificationChannel, d, inquiry;
      NotificationChannel = $injector.get('NotificationChannel');
      NotificationChannel.requestStarted();
      inquiry = new Inquiry({
        message: message,
        reason: reason
      });
      d = $q.defer();
      inquiry.$save().then(function(res) {
        return d.resolve(res.inquiry);
      });
      return d.promise;
    },
    getReasons: function() {
      var d;
      if (service.reasons) {
        return $q.when(service.reasons);
      } else {
        d = $q.defer();
        Api.get('/api/inquiry/reasons').then(function(res) {
          service.reasons = res.data.reasons;
          return d.resolve(service.reasons);
        });
        return d.promise;
      }
    }
  };
  return service;
}]);


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('installationApi', ["$resource", "Api", "$q", "$stateParams", function($resource, Api, $q, $stateParams) {
  var _baseapi, _project_id, _urlapi, getDelegate, service, setDelegate;
  _project_id = $stateParams.projectId;
  _baseapi = $resource(Api.path("/api/projects/:project_id/installation/:id"), {
    project_id: '@project_id',
    id: '@id'
  });
  _urlapi = $resource(Api.path("/api/projects/:project_id/installation/:id/set"), {
    project_id: '@project_id',
    id: '@id',
    step: '@step'
  });
  getDelegate = function(param) {
    var d;
    param['project_id'] = _project_id;
    d = $q.defer();
    _baseapi.get(param).$promise.then(function(res) {
      return d.resolve(res.result);
    }, function(err) {
      return d.reject(err);
    });
    return d.promise;
  };
  setDelegate = function(param) {
    var _postm, d;
    param['project_id'] = _project_id;
    _postm = new _urlapi(param);
    d = $q.defer();
    _postm.$save().then(function(res) {
      return d.resolve(res.result);
    });
    return d.promise;
  };
  service = {
    getTrackingStatus: function() {
      return getDelegate({
        id: 'statelist'
      });
    },
    getTrackingState: function(state) {
      return getDelegate({
        id: 'status',
        state: state
      });
    },
    getTrackingPageLists: function() {
      return getDelegate({
        id: 'trackingpagelist'
      });
    },
    getTrackingPageTypes: function() {
      return getDelegate({
        id: 'trackingpagetype'
      });
    },
    setTrackingPage: function(urlobj) {
      return setDelegate({
        id: 'trackingpage',
        url: urlobj
      });
    },
    deleteTrackingPage: function(urlobj) {
      return setDelegate({
        id: 'deletetrackingpage',
        url: urlobj
      });
    },
    getConversionStatus: function() {
      return getDelegate({
        id: 'conversionstateus'
      });
    },
    getSettingDomain: function() {
      return getDelegate({
        id: 'settingdomain'
      });
    },
    setSettingDomain: function(domain) {
      return setDelegate({
        id: 'settingdomain',
        domain: domain
      });
    },
    deleteSettingDomain: function(domain) {
      return setDelegate({
        id: 'deletedomain',
        domain: domain
      });
    },
    getSiteAnalysisList: function() {
      return getDelegate({
        id: 'siteanalysislist'
      });
    },
    getSiteAnalysisState: function() {
      return getDelegate({
        id: 'siteanalysisstate'
      });
    },
    putSiteAnalysis: function(site) {
      return setDelegate({
        id: 'siteanalysis',
        site: site
      });
    },
    getIpAddresss: function() {
      return getDelegate({
        id: 'ipaddress'
      });
    },
    setIpAddress: function(address) {
      return setDelegate({
        id: 'ipaddress',
        address: address
      });
    },
    deleteIpAdress: function(address) {
      return setDelegate({
        id: 'deleteipaddress',
        address: address
      });
    },
    putinviteuser: function(mail) {
      return setDelegate({
        id: 'inviteuser',
        mail: mail
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("InvoiceAdjustments", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var InvoiceAdjustments;
  InvoiceAdjustments = (function(superClass) {
    extend(InvoiceAdjustments, superClass);

    function InvoiceAdjustments() {
      return InvoiceAdjustments.__super__.constructor.apply(this, arguments);
    }

    return InvoiceAdjustments;

  })(BaseProjectCrudService);
  return new InvoiceAdjustments($resource, $q, "/api/projects/:projectId/invoice_adjustments/:id", "invoice_adjustment", "invoice_adjustments");
}]);


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Ip', ["$q", "Api", function($q, Api) {
  var Ip;
  return Ip = (function() {
    function Ip() {}

    Ip.get = function() {
      return Api.get("/api/ip/").then(function(res) {
        if (res.data.success) {
          return res.data.ip;
        } else {
          return $q.reject(res);
        }
      });
    };

    return Ip;

  })();
}]);


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectItemListPrice', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectItemListPrice;
  ProjectItemListPrice = (function(superClass) {
    extend(ProjectItemListPrice, superClass);

    function ProjectItemListPrice() {
      return ProjectItemListPrice.__super__.constructor.apply(this, arguments);
    }

    return ProjectItemListPrice;

  })(BaseProjectCrudService);
  return new ProjectItemListPrice($resource, $q, '/api/projects/:projectId/item_list_prices/:id', 'item_list_price', 'item_list_prices');
}]);


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectItemPrice', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectItemPrice;
  ProjectItemPrice = (function(superClass) {
    extend(ProjectItemPrice, superClass);

    function ProjectItemPrice() {
      return ProjectItemPrice.__super__.constructor.apply(this, arguments);
    }

    return ProjectItemPrice;

  })(BaseProjectCrudService);
  return new ProjectItemPrice($resource, $q, '/api/projects/:projectId/item_prices/:id', 'item_price', 'item_prices');
}]);


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("ProjectLoginEvaluator", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectLoginEvaluator;
  ProjectLoginEvaluator = (function(superClass) {
    extend(ProjectLoginEvaluator, superClass);

    function ProjectLoginEvaluator() {
      return ProjectLoginEvaluator.__super__.constructor.apply(this, arguments);
    }

    return ProjectLoginEvaluator;

  })(BaseProjectCrudService);
  return new ProjectLoginEvaluator($resource, $q, "/api/projects/:projectId/login_evaluators/:id", "login_evaluator", "login_evaluators");
}]);


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Meta', ["Api", "$q", function(Api, $q) {
  var factory;
  factory = [];
  _.each(["devices", "segments", "referrer_types", "project_campaign_statuses", "session_count_evaluators", "particular_event_page_types", "particular_event_names", "cart_price_page_types", "cart_button_page_types", "advertising_match_types", "newsletter_parameter_match_types", "login_evaluator_match_types", "login_evaluator_evaluation_types", "project_domain_link_types", "project_ranks", "product_lines", "currencies", "regions", "sales_entities", "campaign_segment_allowed_conditions", "page_types", "page_type_match_types", "trial_invoice_calculation_types", "incentive_discount_types", "contract_statuses", "shopping_cart_asps", "invoice_calculation_types", "payment_methods", "invoice_issue_days", "invoice_due_days", "invoice_payment_days", "invoice_payment_months", "services", "interest_widget", "interest_widget_templates", "badge_position_adjustment_devices", "pricing_types", "google_analytics_event_labels", "opt_targets", "configuration_types", "testing_units", "sampling_ranges", "lite_sampling_ranges", "country_codes"], function(meta) {
    var camelized;
    camelized = _.upperFirst(_.camelCase(meta));
    return factory["get" + camelized] = function() {
      var d;
      d = $q.defer();
      Api.get("/api/meta/" + meta).then(function(res) {
        if (res.data.success) {
          return d.resolve(res.data[meta]);
        } else {
          return d.reject([]);
        }
      });
      return d.promise;
    };
  });
  return factory;
}]);


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("ProjectNewsletterParameter", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectNewsletterParameter;
  ProjectNewsletterParameter = (function(superClass) {
    extend(ProjectNewsletterParameter, superClass);

    function ProjectNewsletterParameter() {
      return ProjectNewsletterParameter.__super__.constructor.apply(this, arguments);
    }

    return ProjectNewsletterParameter;

  })(BaseProjectCrudService);
  return new ProjectNewsletterParameter($resource, $q, "/api/projects/:projectId/newsletter_parameters/:id", "newsletter_parameter", "newsletter_parameters");
}]);


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("PageTypeSampleUrl", ["$resource", "$q", "pageTypeSampleUrlServiceRequestTransformer", "PageType", "Api", function($resource, $q, pageTypeSampleUrlServiceRequestTransformer, PageType, Api) {
  var PageTypeSampleUrl, service;
  PageTypeSampleUrl = $resource(Api.path("/api/projects/:projectId/page_type_sample_urls/:id"), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    create: {
      method: 'POST'
    },
    update: {
      method: 'PATCH',
      transformRequest: pageTypeSampleUrlServiceRequestTransformer
    },
    destroy: {
      method: 'DELETE'
    },
    options: {
      method: 'GET',
      cache: true
    }
  });
  service = {
    create: function(params, obj) {
      return $q(function(resolve, reject) {
        var page_type_sample_url;
        page_type_sample_url = new PageTypeSampleUrl(obj);
        return page_type_sample_url.$save({
          projectId: params.projectId
        }).then(function(res) {
          if (res.success) {
            return resolve(res.page_type_sample_url);
          } else {
            return reject(res);
          }
        });
      });
    },
    update: function(params, update) {
      return $q(function(resolve, reject) {
        return PageTypeSampleUrl.update(params, update).$promise.then(function(res) {
          if (res.success) {
            return resolve(res.page_type_sample_url);
          } else {
            return reject(res);
          }
        });
      });
    },
    all: function(projectId) {
      return $q(function(resolve, reject) {
        return PageTypeSampleUrl.query({
          projectId: projectId
        }, function(res) {
          return resolve(res.page_type_sample_urls);
        });
      });
    },
    destroy: function(pageType) {
      return $q(function(resolve, reject) {
        return PageTypeSampleUrl.destroy({
          projectId: pageType.project_id,
          id: pageType.id
        }).$promise.then(function(res) {
          if (res.success) {
            return resolve(res);
          } else {
            return reject();
          }
        }, function(err) {
          return reject(err);
        });
      });
    },
    "new": function(options) {
      var DEFAULT_OPTIONS, page_type_options;
      DEFAULT_OPTIONS = {
        required_device: 'both',
        page_type: '',
        types: []
      };
      page_type_options = DEFAULT_OPTIONS;
      if (options) {
        page_type_options = angular.extend(page_type_options, options);
      }
      return new PageTypeSampleUrl(page_type_options);
    },
    getPageTypeOptions: function(projectId) {
      return PageType.getPageTypeOptions(projectId);
    },
    getDevices: function(projectId) {
      return PageType.getDevices(projectId);
    }
  };
  return service;
}]).factory('pageTypeSampleUrlServiceRequestTransformer', function() {
  var doTransform;
  doTransform = function(elem) {
    elem = _.assignIn({}, elem);
    delete elem["id"];
    delete elem["isOk"];
    delete elem["types"];
    return elem;
  };
  return function(data) {
    if (data.page_type_sample_url) {
      data.page_type_sample_url = doTransform(data.page_type_sample_url);
    }
    return angular.toJson(data);
  };
});


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').factory("PageType", ["$resource", "$q", "Api", "pageTypeServiceRequestTransformer", function($resource, $q, Api, pageTypeServiceRequestTransformer) {
  var PageType, URL, service;
  URL = "/api/projects/:projectId/page_types/:id";
  PageType = $resource(Api.path(URL), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    create: {
      method: 'POST',
      transformRequest: pageTypeServiceRequestTransformer
    },
    createMany: {
      method: 'POST',
      url: Api.path("/api/projects/:projectId/page_types/create_many"),
      headers: {
        'Content-Type': 'application/json'
      }
    },
    update: {
      method: 'PATCH',
      transformRequest: pageTypeServiceRequestTransformer
    },
    updateMany: {
      method: 'PATCH',
      url: Api.path("/api/projects/:projectId/page_types/update_many"),
      headers: {
        'Content-Type': 'application/json'
      }
    },
    destroy: {
      method: 'DELETE'
    },
    options: {
      method: 'GET',
      cache: true
    },
    save: {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    }
  });
  service = {
    CUSTOM_PAGE_TYPE: '_custom_',
    transformCustomPageType: function(page_type_options, page_type) {
      var i, len, options, page_type_option, ref;
      for (i = 0, len = page_type_options.length; i < len; i++) {
        page_type_option = page_type_options[i];
        page_type_option[1];
      }
      options = (function() {
        var j, len1, results;
        results = [];
        for (j = 0, len1 = page_type_options.length; j < len1; j++) {
          page_type_option = page_type_options[j];
          results.push(page_type_option[1]);
        }
        return results;
      })();
      if (ref = page_type.page_type, indexOf.call(options, ref) < 0) {
        page_type.custom_name = page_type.page_type;
        page_type.page_type = service.CUSTOM_PAGE_TYPE;
      }
      return page_type;
    },
    create: function(params, obj) {
      return $q.all([
        service.getPageTypeOptions(params.projectId), PageType.create({
          projectId: params.projectId
        }, obj).$promise
      ]).then(function(arg) {
        var page_type_options, res;
        page_type_options = arg[0], res = arg[1];
        if (res.success) {
          return service.transformCustomPageType(page_type_options, res.page_type);
        } else {
          return $q.defer().reject(res);
        }
      });
    },
    createMany: function(params, obj) {
      return PageType.createMany({
        projectId: params.projectId
      }, {
        page_types: obj
      }).$promise;
    },
    update: function(params, update) {
      return $q.all([service.getPageTypeOptions(params.projectId), PageType.update(params, update).$promise]).then(function(arg) {
        var page_type_options, res;
        page_type_options = arg[0], res = arg[1];
        if (res.success) {
          return service.transformCustomPageType(page_type_options, res.page_type);
        } else {
          return $q.defer().reject(res);
        }
      });
    },
    updateMany: function(params, update) {
      return PageType.updateMany({
        projectId: params.projectId
      }, {
        page_types: update
      }).$promise;
    },
    all: function(projectId) {
      return $q.all([
        service.getPageTypeOptions(projectId), PageType.query({
          projectId: projectId
        }).$promise
      ]).then(function(arg) {
        var page_type_options, page_types, res;
        page_type_options = arg[0], res = arg[1];
        page_types = res.page_types.map(function(page_type) {
          return service.transformCustomPageType(page_type_options, page_type);
        });
        return page_types;
      });
    },
    destroy: function(pageType) {
      return $q(function(resolve, reject) {
        return PageType.destroy({
          projectId: pageType.project_id,
          id: pageType.id
        }).$promise.then(function(res) {
          if (res.success) {
            return resolve(res);
          } else {
            return reject();
          }
        }, function(err) {
          return reject(err);
        });
      });
    },
    "new": function(options) {
      var DEFAULT_OPTIONS, page_type_options;
      DEFAULT_OPTIONS = {
        required_device: 'both',
        evaluator: 'url',
        page_type: '',
        match_type: '',
        custom_name: ''
      };
      page_type_options = DEFAULT_OPTIONS;
      if (options) {
        page_type_options = angular.extend(page_type_options, options);
      }
      return new PageType(page_type_options);
    },
    PageTypeOptions: {},
    getPageTypeOptions: function(projectId) {
      return $q(function(resolve, reject) {
        if (service.PageTypeOptions[projectId]) {
          return resolve(service.PageTypeOptions[projectId]);
        }
        return PageType.options({
          projectId: projectId,
          id: "page_type_options"
        }, function(res) {
          if (!res.success) {
            return reject(null);
          }
          service.PageTypeOptions[projectId] = res.page_types;
          return resolve(res.page_types);
        });
      });
    },
    getMatchTypes: function(projectId) {
      return $q(function(resolve, reject) {
        return PageType.options({
          projectId: projectId,
          id: "match_types"
        }, function(res) {
          if (!res.success) {
            return reject(null);
          }
          return resolve(res.match_types);
        });
      });
    },
    getDevices: function(projectId) {
      return $q(function(resolve, reject) {
        return PageType.options({
          projectId: projectId,
          id: "devices"
        }, function(res) {
          if (!res.success) {
            return reject(null);
          }
          return resolve(res.devices);
        });
      });
    },
    isCustomPageType: function(page_type) {
      return page_type.page_type === service.CUSTOM_PAGE_TYPE;
    }
  };
  return service;
}]).factory('pageTypeServiceRequestTransformer', ["$injector", function($injector) {
  var doTransform;
  doTransform = function(elem) {
    var PageType;
    elem = _.assignIn({}, elem);
    delete elem["id"];
    delete elem["isOk"];
    PageType = $injector.get("PageType");
    if (elem.page_type === PageType.CUSTOM_PAGE_TYPE) {
      elem.page_type = elem.custom_name;
    }
    return elem;
  };
  return function(data) {
    if (data.page_type) {
      data.page_type = doTransform(data.page_type);
    }
    return angular.toJson(data);
  };
}]);


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectParticularEvent', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectParticularEvent;
  ProjectParticularEvent = (function(superClass) {
    extend(ProjectParticularEvent, superClass);

    function ProjectParticularEvent() {
      return ProjectParticularEvent.__super__.constructor.apply(this, arguments);
    }

    return ProjectParticularEvent;

  })(BaseProjectCrudService);
  return new ProjectParticularEvent($resource, $q, '/api/projects/:projectId/particular_events/:id', 'particular_event', 'particular_events');
}]);


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('projectServiceRequestTransformer', ["$filter", function($filter) {
  var doTransform;
  doTransform = function(project) {
    project = _.assignIn({}, project);
    if (project.installed_at) {
      project.installed_at = $filter('changeDatetimeFrom')('localToRegion', project.installed_at, 'string');
    }
    if (project.contracted_at) {
      project.contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.contracted_at, 'string');
    }
    if (project.terminated_at) {
      project.terminated_at = $filter('changeDatetimeFrom')('localToRegion', project.terminated_at, 'string');
    }
    if (project.trial_started_at) {
      project.trial_started_at = $filter('changeDatetimeFrom')('localToRegion', project.trial_started_at, 'string');
    }
    if (project.trial_end_at) {
      project.trial_end_at = $filter('changeDatetimeFrom')('localToRegion', project.trial_end_at, 'string');
    }
    if (project.lens_contracted_at) {
      project.lens_contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.lens_contracted_at, 'string');
    }
    if (project.lens_cancelled_at) {
      project.lens_cancelled_at = $filter('changeDatetimeFrom')('localToRegion', project.lens_cancelled_at, 'string');
    }
    if (project.iw_trial_started_at) {
      project.iw_trial_started_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_trial_started_at, 'string');
    }
    if (project.iw_trial_end_at) {
      project.iw_trial_end_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_trial_end_at, 'string');
    }
    if (project.iw_cancelled_at) {
      project.iw_cancelled_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_cancelled_at, 'string');
    }
    if (project.iw_contracted_at) {
      project.iw_contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_contracted_at, 'string');
    }
    return project;
  };
  return function(data) {
    if (data.project) {
      data.project = doTransform(data.project);
    }
    return JSON.stringify(data);
  };
}]);


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('projectServiceResponseTransformer', ["$filter", function($filter) {
  var doTransform;
  doTransform = function(project) {
    var campaign, i, len, ref;
    project.installed_at = $filter('changeDatetimeFrom')('regionToLocal', project.installed_at, 'date', project.region);
    project.companyinfo_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.companyinfo_confirmed_at, 'date', project.region);
    project.siteinfo_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.siteinfo_confirmed_at, 'date', project.region);
    project.tracking_tag_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.tracking_tag_confirmed_at, 'date', project.region);
    project.conversion_tag_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.conversion_tag_confirmed_at, 'date', project.region);
    project.first_campaign_start_at = $filter('changeDatetimeFrom')('regionToLocal', project.first_campaign_start_at, 'date', project.region);
    project.contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.contracted_at, 'date', project.region);
    project.terminated_at = $filter('changeDatetimeFrom')('regionToLocal', project.terminated_at, 'date', project.region);
    project.lens_contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.lens_contracted_at, 'date', project.region);
    project.lens_cancelled_at = $filter('changeDatetimeFrom')('regionToLocal', project.lens_cancelled_at, 'date', project.region);
    project.iw_cancelled_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_cancelled_at, 'date', project.region);
    project.iw_contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_contracted_at, 'date', project.region);
    project.iw_trial_started_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_trial_started_at, 'date', project.region);
    project.iw_trial_end_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_trial_end_at, 'date', project.region);
    project.trial_started_at = $filter('changeDatetimeFrom')('regionToLocal', project.trial_started_at, 'date', project.region);
    project.trial_end_at = $filter('changeDatetimeFrom')('regionToLocal', project.trial_end_at, 'date', project.region);
    if (project.started_campaigns) {
      ref = project.started_campaigns;
      for (i = 0, len = ref.length; i < len; i++) {
        campaign = ref[i];
        campaign.start_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'date', project.region);
        campaign.end_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'date', project.region);
      }
    }
    return project;
  };
  return function(data) {
    var i, len, obj, project, ref;
    try {
      obj = angular.fromJson(data);
      if (obj.project) {
        doTransform(obj.project);
      }
      if (obj.projects) {
        ref = obj.projects;
        for (i = 0, len = ref.length; i < len; i++) {
          project = ref[i];
          doTransform(project);
        }
      }
      return obj;
    } catch (error) {
      return {};
    }
  };
}]);


/***/ }),
/* 1026 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Project', ["$resource", "$q", "$state", "Api", "projectServiceResponseTransformer", "projectServiceRequestTransformer", function($resource, $q, $state, Api, projectServiceResponseTransformer, projectServiceRequestTransformer) {
  var Project, URL, doGet, service;
  URL = "/api/projects/:projectId";
  Project = $resource(Api.path(URL), {
    get: {
      projectId: '@id',
      transformResponse: projectServiceResponseTransformer
    }
  }, {
    query: {
      method: 'GET',
      transformResponse: projectServiceResponseTransformer,
      isArray: false,
      cache: true
    },
    update: {
      method: 'PATCH',
      transformRequest: projectServiceRequestTransformer,
      transformResponse: projectServiceResponseTransformer
    },
    'delete': {
      method: 'DELETE'
    },
    removePageTypes: {
      method: 'DELETE',
      url: Api.path(URL + "/remove_page_types/:page_type")
    },
    visitorIdsForDM: {
      method: 'GET',
      url: Api.path(URL + "/visitor_ids_for_dm")
    },
    uploadVisitorIdsForDM: {
      method: 'PATCH',
      url: Api.path(URL + "/upload_visitor_ids_for_dm"),
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    },
    uploadPageTypes: {
      method: 'PATCH',
      url: Api.path(URL + "/upload_page_types/:page_type"),
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    }
  });
  doGet = function(selector, params) {
    return $q(function(resolve, reject) {
      return Project.get(angular.extend(selector, params)).$promise.then(function(res) {
        var response;
        if (res.project) {
          response = projectServiceResponseTransformer(res);
          return resolve(response.project);
        } else {
          return reject();
        }
      }, function(err) {
        return reject(err);
      });
    });
  };
  service = {
    currentProject: null,
    create: function(params) {
      return $q(function(resolve, reject) {
        return Project.save({
          project: params
        }).$promise.then(function(res) {
          return resolve(res.project);
        });
      });
    },
    update: function(params, update) {
      return $q(function(resolve, reject) {
        return Project.update(params, update).$promise.then(function(res) {
          if (!res.success) {
            return reject({});
          } else {
            return resolve(res.project);
          }
        });
      });
    },
    removePageTypes: function(params) {
      return Project.removePageTypes(params).$promise;
    },
    remove: function(params) {
      return Project["delete"](params).$promise;
    },
    all: function() {
      return Project.query().$promise.then(function(res) {
        service.projects = res.projects;
        return res.projects;
      });
    },
    get: function(projectId, params) {
      if (params == null) {
        params = {};
      }
      return doGet({
        projectId: projectId
      }, params);
    },
    getByApikey: function(apikey, params) {
      if (params == null) {
        params = {};
      }
      return doGet({
        projectId: "apikey:" + apikey
      }, params);
    },
    getVisitorIdsForDM: function(params) {
      return $q(function(resolve, reject) {
        return Project.visitorIdsForDM(params).$promise.then(function(res) {
          return resolve(res.visitor_ids_for_dm);
        });
      });
    },
    uploadVisitorIdsForDM: function(params, update) {
      return $q(function(resolve, reject) {
        return Project.uploadVisitorIdsForDM(params, update).$promise.then(function(res) {
          return resolve(res.visitor_ids_for_dm);
        });
      });
    },
    uploadPageTypes: function(params, update) {
      return $q(function(resolve, reject) {
        return Project.uploadPageTypes(params, update).$promise.then(function(res) {
          return resolve(res.page_types);
        });
      });
    },
    getCurrent: function(projectId) {
      return $q(function(resolve, reject) {
        if (projectId) {
          return service.get(projectId).then(function(project) {
            service.currentProject = project;
            return resolve(project);
          });
        } else {
          service.currentProject = null;
          return resolve(null);
        }
      });
    },
    goHome: function(project) {
      service.currentProject = project;
      return $state.go('admin.projects.campaigns.list', {
        projectId: project.id
      });
    },
    getRegion: function() {
      var ref;
      return (ref = service.currentProject) != null ? ref.region : void 0;
    },
    isZenClerk: function() {
      var ref;
      return ((ref = service.currentProject) != null ? ref.product_line : void 0) === 'zenclerk';
    },
    isZenClerkS: function() {
      var ref;
      return ((ref = service.currentProject) != null ? ref.product_line : void 0) === 'zenclerk_s';
    },
    isZenClerkLP: function() {
      var ref;
      return ((ref = service.currentProject) != null ? ref.product_line : void 0) === 'zenclerk_lp';
    }
  };
  return service;
}]);


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectSegmentCookie', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectSegmentCookie;
  ProjectSegmentCookie = (function(superClass) {
    extend(ProjectSegmentCookie, superClass);

    function ProjectSegmentCookie() {
      return ProjectSegmentCookie.__super__.constructor.apply(this, arguments);
    }

    return ProjectSegmentCookie;

  })(BaseProjectCrudService);
  return new ProjectSegmentCookie($resource, $q, '/api/projects/:projectId/segment_cookies/:id', 'segment_cookie', 'segment_cookies');
}]);


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("Template", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var Template;
  Template = (function(superClass) {
    extend(Template, superClass);

    function Template() {
      return Template.__super__.constructor.apply(this, arguments);
    }

    return Template;

  })(BaseProjectCrudService);
  return new Template($resource, $q, "/api/projects/:projectId/templates", "template", "templates");
}]);


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectThumbnailSelector', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectThumbnailSelector;
  ProjectThumbnailSelector = (function(superClass) {
    extend(ProjectThumbnailSelector, superClass);

    function ProjectThumbnailSelector() {
      return ProjectThumbnailSelector.__super__.constructor.apply(this, arguments);
    }

    return ProjectThumbnailSelector;

  })(BaseProjectCrudService);
  return new ProjectThumbnailSelector($resource, $q, '/api/master/projects/:projectId/thumbnail_selectors/:id', 'thumbnail_selector', 'thumbnail_selectors');
}]);


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectTitleSelector', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectTitleSelector;
  ProjectTitleSelector = (function(superClass) {
    extend(ProjectTitleSelector, superClass);

    function ProjectTitleSelector() {
      return ProjectTitleSelector.__super__.constructor.apply(this, arguments);
    }

    return ProjectTitleSelector;

  })(BaseProjectCrudService);
  return new ProjectTitleSelector($resource, $q, '/api/master/projects/:projectId/title_selectors/:id', 'title_selector', 'title_selectors');
}]);


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('UniqueCouponCode', ["$resource", "$q", "Api", function($resource, $q, Api) {
  var URL, UniqueCouponCode, service;
  URL = '/api/projects/:projectId/incentives/:incentiveId/unique_coupon_codes';
  UniqueCouponCode = $resource(Api.path(URL), {
    projectId: this.projectId,
    incentiveId: this.incentiveId
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    count: {
      method: 'GET',
      url: Api.path(URL + "/count")
    },
    upload: {
      method: 'PATCH',
      url: Api.path(URL + "/upload"),
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    }
  });
  service = {
    all: function(params) {
      return $q(function(resolve, reject) {
        return UniqueCouponCode.query(params, function(res) {
          return resolve(res.unique_coupon_codes);
        });
      });
    },
    count: function(params) {
      return $q(function(resolve, reject) {
        return UniqueCouponCode.count(params, function(res) {
          return resolve(res.count);
        });
      });
    },
    upload: function(params, update) {
      return $q(function(resolve, reject) {
        return UniqueCouponCode.upload(params, update).$promise.then(function(res) {
          return resolve(res);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("UntrackPageType", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var UntrackPageType;
  UntrackPageType = (function(superClass) {
    extend(UntrackPageType, superClass);

    function UntrackPageType() {
      return UntrackPageType.__super__.constructor.apply(this, arguments);
    }

    return UntrackPageType;

  })(BaseProjectCrudService);
  return new UntrackPageType($resource, $q, "/api/projects/:projectId/untrack_page_types/:id", "untrack_page_type", "untrack_page_types");
}]);


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectUser', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectUser;
  ProjectUser = (function(superClass) {
    extend(ProjectUser, superClass);

    function ProjectUser() {
      return ProjectUser.__super__.constructor.apply(this, arguments);
    }

    return ProjectUser;

  })(BaseProjectCrudService);
  return new ProjectUser($resource, $q, '/api/projects/:projectId/users/:id', 'user', 'users');
}]);


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectVisitorSegment', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectVisitorSegment;
  ProjectVisitorSegment = (function(superClass) {
    extend(ProjectVisitorSegment, superClass);

    function ProjectVisitorSegment() {
      return ProjectVisitorSegment.__super__.constructor.apply(this, arguments);
    }

    return ProjectVisitorSegment;

  })(BaseProjectCrudService);
  return new ProjectVisitorSegment($resource, $q, '/api/projects/:projectId/visitor_segments/:id', 'visitor_segment', 'visitor_segments');
}]);


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("BaseProjectCrudService", ["Api", function(Api) {
  var BaseProjectCrudService;
  return BaseProjectCrudService = (function() {
    function BaseProjectCrudService($resource, $q, url, obj_name, obj_name_plural, transformers) {
      var options;
      this.$q = $q;
      this.url = url;
      this.obj_name = obj_name;
      this.obj_name_plural = obj_name_plural;
      options = {
        get: {
          method: 'GET'
        },
        query: {
          method: 'GET',
          isArray: false
        },
        create: {
          method: 'POST',
          isArray: false
        },
        update: {
          method: 'PATCH',
          isArray: false
        }
      };
      if (transformers) {
        if (transformers.response) {
          options.get.transformResponse = transformers.response;
        }
        if (transformers.response) {
          options.query.transformResponse = transformers.response;
        }
        if (transformers.request) {
          options.create.transformRequest = transformers.request;
        }
        if (transformers.request) {
          options.update.transformRequest = transformers.request;
        }
      }
      this.Resource = $resource(Api.path(this.url), {}, options);
    }

    BaseProjectCrudService.prototype.all = function(projectId, params) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.query(angular.extend({
            projectId: projectId
          }, params), function(res) {
            return resolve(res[_this.obj_name_plural]);
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype.get = function(projectId, id) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.get({
            projectId: projectId,
            id: id
          }, function(res) {
            return resolve(res[_this.obj_name]);
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype.create = function(params, newObject) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.create(params, newObject).$promise.then(function(res) {
            if (res.success) {
              return resolve(res[_this.obj_name]);
            } else {
              return reject({});
            }
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype.update = function(params, newObject) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.update(params, newObject).$promise.then(function(res) {
            if (res.success) {
              return resolve(res[_this.obj_name]);
            } else {
              return reject({});
            }
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype["delete"] = function(projectId, id) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource["delete"]({
            projectId: projectId,
            id: id
          }).$promise.then(function(res) {
            if (res.success) {
              return resolve(id);
            } else {
              return reject({});
            }
          });
        };
      })(this));
    };

    return BaseProjectCrudService;

  })();
}]);


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("AccessStats", ["$q", "FacadeV2", function($q, FacadeV2) {
  var AccessStats;
  AccessStats = (function() {
    var emptyToNull, filtersToMatch;

    function AccessStats() {}

    AccessStats.handleCampaignDevice = function(campaign_device) {
      switch (campaign_device) {
        case 'pc':
          return {
            $in: ['pc', 'tablet']
          };
        case 'sp':
        case 'iphone':
          return 'sp';
        case 'devicefree':
          return {
            $in: ['pc', 'tablet', 'sp']
          };
        default:
          return null;
      }
    };

    AccessStats.fields = ['session_count', 'history_count', 'interest_count', 'conversion_count', 'conversion_price', 'cart_button_click_count', 'referrer_count', 'dwell', 'repeat_session_count', 'mobile_session_count', 'tablet_session_count', 'pc_session_count', 'other_device_session_count'];

    AccessStats.aggregate = function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/access_stats/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    AccessStats.aggregateDefault = function(paths, match) {
      var field, group, i, j, len, len1, project, query, ref, ref1, ref2, ref3;
      query = {
        match: match
      };
      query.pipeline = [];
      group = {
        total_found: {
          $sum: 1
        }
      };
      if ((ref = paths.dimension) === 'hour_of_day' || ref === 'day_of_week') {
        group._id = {};
        group._id[paths.dimension] = "$" + paths.dimension;
      } else {
        group._id = null;
      }
      ref1 = this.fields;
      for (i = 0, len = ref1.length; i < len; i++) {
        field = ref1[i];
        group[field] = {
          $sum: "$" + field
        };
      }
      query.pipeline.push({
        $group: group
      });
      query.pipeline.push({
        $sort: {
          _id: 1
        }
      });
      project = {
        total_found: 1
      };
      if ((ref2 = paths.dimension) === 'hour_of_day' || ref2 === 'day_of_week') {
        project[paths.dimension] = "$_id." + paths.dimension;
      }
      ref3 = this.fields;
      for (j = 0, len1 = ref3.length; j < len1; j++) {
        field = ref3[j];
        project[field] = 1;
      }
      query.pipeline.push({
        $project: project
      });
      paths = _.assignIn({}, paths);
      if (paths.dimension === 'hour_of_day') {
        paths.dimension = 'hourly';
      }
      if (paths.dimension === 'day_of_week') {
        paths.dimension = 'daily';
      }
      return this.aggregate(paths, query).then((function(_this) {
        return function(data) {
          var dummy, k, len2, ref4;
          if (data.length) {
            data = _this.transformResults(data);
          } else {
            dummy = {
              total_found: 0
            };
            ref4 = _this.fields;
            for (k = 0, len2 = ref4.length; k < len2; k++) {
              field = ref4[k];
              data[field] = 0;
            }
            data = [dummy];
          }
          return data;
        };
      })(this));
    };

    AccessStats.aggregateByFilter = function(paths, filters) {
      var match;
      match = filtersToMatch(filters);
      return this.aggregateDefault(paths, match);
    };

    AccessStats.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/access_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    AccessStats.findDefault = function(paths, match) {
      var query;
      query = {
        match: match,
        limit: 10000,
        fields: this.fields.concat('end_at').concat(_.keys(match))
      };
      return this.find(paths, query).then((function(_this) {
        return function(data) {
          var base, base1, base2, doc, field, i, j, len, len1, name, ref, sumByStartAt;
          if (data.length) {
            sumByStartAt = {};
            for (i = 0, len = data.length; i < len; i++) {
              doc = data[i];
              sumByStartAt[name = doc.start_at] || (sumByStartAt[name] = {});
              (base = sumByStartAt[doc.start_at])['start_at'] || (base['start_at'] = doc['start_at']);
              (base1 = sumByStartAt[doc.start_at])['end_at'] || (base1['end_at'] = doc['end_at']);
              ref = _this.fields;
              for (j = 0, len1 = ref.length; j < len1; j++) {
                field = ref[j];
                (base2 = sumByStartAt[doc.start_at])[field] || (base2[field] = 0);
                sumByStartAt[doc.start_at][field] += doc[field];
              }
            }
            data = _.values(sumByStartAt);
            data = _this.transformResults(data);
          } else {
            data = [];
          }
          return data;
        };
      })(this));
    };

    AccessStats.findByFilter = function(paths, filters) {
      var match;
      match = filtersToMatch(filters);
      return this.findDefault(paths, match);
    };

    filtersToMatch = function(filters) {
      return {
        device: emptyToNull(filters.device),
        campaign_segment_id: emptyToNull(filters.campaign_segment),
        is_control: emptyToNull(filters.is_control),
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).toDate()
        }
      };
    };

    emptyToNull = function(val) {
      if (val === '') {
        return null;
      } else {
        return val;
      }
    };

    AccessStats.transformResults = function(access_stats) {
      var i, len, stats;
      for (i = 0, len = access_stats.length; i < len; i++) {
        stats = access_stats[i];
        if (stats.session_count) {
          stats.conversion_rate = stats.conversion_count / stats.session_count;
          stats.cart_button_click_rate = stats.cart_button_click_count / stats.session_count;
          stats.average_dwell = stats.dwell / stats.session_count;
          stats.average_history_count = stats.history_count / stats.session_count;
          stats.average_interest_count = stats.interest_count / stats.session_count;
          stats.mobile_session_rate = stats.mobile_session_count / stats.session_count;
          stats.repeat_session_rate = stats.repeat_session_count / stats.session_count;
        } else {
          stats.conversion_rate = 0;
          stats.cart_button_click_rate = 0;
          stats.average_dwell = 0;
          stats.average_history_count = 0;
          stats.average_interest_count = 0;
          stats.mobile_session_rate = 0;
          stats.repeat_session_rate = 0;
        }
        if (stats.conversion_count) {
          stats.average_conversion_price = stats.conversion_price / stats.conversion_count;
        } else {
          stats.average_conversion_price = 0;
        }
        if (stats.start_at) {
          stats.start_at = new Date(stats.start_at).valueOf();
        }
        if (stats.end_at) {
          stats.end_at = new Date(stats.end_at).valueOf();
        }
      }
      return access_stats;
    };

    return AccessStats;

  })();
  return AccessStats;
}]);


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignEventStats', ["FacadeV2", function(FacadeV2) {
  var CampaignEventStats;
  return CampaignEventStats = (function() {
    function CampaignEventStats() {}

    CampaignEventStats.aggregate = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_event_stats/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    CampaignEventStats.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_event_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return CampaignEventStats;

  })();
}]);


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').factory('CampaignStats', ["$filter", "$q", "Facade", "FacadeV2", "campaignGraphOptions", "lib", function($filter, $q, Facade, FacadeV2, campaignGraphOptions, lib) {
  var BASE_ITEMS, SIGNIFICANCE_LEVEL, ZC_COST_RATE, service;
  BASE_ITEMS = ['conversion_count', 'conversion_price', 'delivery_count', 'dwell', 'cart_button_click_count', 'history_count', 'interest_count'];
  SIGNIFICANCE_LEVEL = 0.1;
  ZC_COST_RATE = 0.1;
  service = {
    ZC_COST_RATE: ZC_COST_RATE,
    find: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/campaign_stats/" + params.dimension, {
        params: {
          json: params
        },
        transformResponse: this.campaignStatsResponseTransformer
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.campaign_stats : void 0;
      });
    },
    aggregate: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/campaign_stats/" + params.dimension + "/aggregate", {
        params: {
          json: params
        },
        transformResponse: this.campaignStatsResponseTransformer
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.campaign_stats : void 0;
      });
    },
    getCampaignStats: function(params, callback) {
      params.dimension || (params.dimension = 'hourly');
      return Facade.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/stats/" + params.dimension + "/aggregate", {
        params: params
      }).then((function(_this) {
        return function(res) {
          var ref;
          return _this.groupCampaigns((ref = res.data) != null ? ref.stats : void 0);
        };
      })(this));
    },
    getCampaignEventStats: function(params, callback) {
      params.dimension || (params.dimension = 'hourly');
      return Facade.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/event_stats/" + params.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.event_stats : void 0;
      });
    },
    getHourlyConversionPriceDistribution: function(params, callback) {
      params.dimension || (params.dimension = 'hourly');
      return Facade.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/conversion_price_distribution/" + params.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.conversion_price_distribution : void 0;
      });
    },
    getHourlyDwellDistribution: function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_dwell_distribution/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    },
    getHourlyHistoryCountDistribution: function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_history_count_distribution/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    },
    getInterestWidgetItemDistribution: function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_interest_widget_item_distribution/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    },
    groupCampaigns: function(res) {
      var cid, data, j, len, single;
      if (!res) {
        return {};
      }
      data = {};
      for (j = 0, len = res.length; j < len; j++) {
        single = res[j];
        cid = single.campaign_id;
        if (!data[cid]) {
          data[cid] = {
            ctrl: [],
            exp: []
          };
        }
        if (single.is_control) {
          data[cid].ctrl.push(single);
        } else {
          data[cid].exp.push(single);
        }
      }
      return data;
    },
    sum: function(funcName, campaigns) {
      return _.reduce(campaigns, function(memo, campaign) {
        return memo += service[funcName](campaign);
      }, 0);
    },
    totalVisitors: function(campaign) {
      var ref, ref1, ref2, ref3;
      return (((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.delivery_count : void 0 : void 0) + ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.ctrl) != null ? ref3.delivery_count : void 0 : void 0)) || 0;
    },
    totalConversions: function(campaign) {
      var ref, ref1, ref2, ref3;
      return (((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_count : void 0 : void 0) + ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.ctrl) != null ? ref3.conversion_count : void 0 : void 0)) || 0;
    },
    totalConversionPrice: function(campaign) {
      var ref, ref1, ref2, ref3;
      return (((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_price : void 0 : void 0) + ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.ctrl) != null ? ref3.conversion_price : void 0 : void 0)) || 0;
    },
    totalDeliveryCount: function(campaign) {
      var ref, ref1;
      return ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.delivery_count : void 0 : void 0) || 0;
    },
    liftRate: function(campaign) {
      var ctrlConversionRate, expConversionRate, liftRate, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
      expConversionRate = ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_count : void 0 : void 0) / ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.exp) != null ? ref3.delivery_count : void 0 : void 0) || 1;
      ctrlConversionRate = ((ref4 = campaign.cumulative) != null ? (ref5 = ref4.ctrl) != null ? ref5.conversion_count : void 0 : void 0) / ((ref6 = campaign.cumulative) != null ? (ref7 = ref6.ctrl) != null ? ref7.delivery_count : void 0 : void 0) || 0;
      liftRate = (expConversionRate - ctrlConversionRate) / expConversionRate;
      return liftRate;
    },
    liftedConversionCount: function(campaign) {
      var ref, ref1;
      return ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_count : void 0 : void 0) * service.liftRate(campaign) || 0;
    },
    liftedConversionPrice: function(campaign) {
      var ref, ref1;
      return ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_price : void 0 : void 0) * service.liftRate(campaign) || 0;
    },
    bootstrapData: function(campaign_cumulative) {
      var bootstrap, conversion_rate, create_bootstrap_data, create_histogram_data, delivery_count, hist, n_boot, n_rank;
      n_boot = 500;
      n_rank = 10;
      create_bootstrap_data = function(delivery_count, conversion_rate, n_boot) {
        var boot, j, result, results;
        boot = (function() {
          results = [];
          for (var j = 0; 0 <= n_boot ? j <= n_boot : j >= n_boot; 0 <= n_boot ? j++ : j--){ results.push(j); }
          return results;
        }).apply(this);
        result = _.map(boot, function(item) {
          var i, k, ref, sum;
          if (delivery_count === 0) {
            return 0;
          }
          sum = 0;
          for (i = k = 1, ref = delivery_count; 1 <= ref ? k <= ref : k >= ref; i = 1 <= ref ? ++k : --k) {
            if (Math.random() < conversion_rate) {
              sum += 1;
            }
          }
          return sum / delivery_count;
        });
        return result;
      };
      create_histogram_data = function(data, n_rank) {
        var i, interval, j, k, max, min, ranks, ref, ref1, ref2, ref3, results;
        min = _.min(data);
        max = _.max(data);
        interval = (max - min) / n_rank;
        if (interval === 0) {
          return [0, 0];
        }
        ranks = [];
        for (i = j = ref = min, ref1 = max, ref2 = interval; ref2 > 0 ? j <= ref1 : j >= ref1; i = j += ref2) {
          ranks.push((function() {
            results = [];
            for (var k = i, ref3 = i + interval; i <= ref3 ? k <= ref3 : k >= ref3; i <= ref3 ? k++ : k--){ results.push(k); }
            return results;
          }).apply(this));
        }
        return _.map(ranks, function(rank) {
          var count, mean;
          mean = (rank[0] + rank[rank.length - 1]) / 2 * 100;
          mean = Math.round(mean * 100) / 100;
          count = _.reduce(data, function(memo, d) {
            if (rank.indexOf(d) !== -1) {
              memo += 1;
            }
            return memo;
          }, 0);
          return [mean, count];
        });
      };
      delivery_count = campaign_cumulative.delivery_count;
      conversion_rate = (campaign_cumulative.conversion_count / campaign_cumulative.history_count) || 0;
      bootstrap = create_bootstrap_data(delivery_count, conversion_rate, n_boot);
      hist = create_histogram_data(bootstrap, n_rank);
      return hist;
    },
    campaignStatsResponseTransformer: function(data) {
      var j, len, ref, stats;
      try {
        data = angular.fromJson(data);
        ref = data.campaign_stats;
        for (j = 0, len = ref.length; j < len; j++) {
          stats = ref[j];
          if (stats.delivery_count) {
            stats.average_dwell = stats.dwell / stats.delivery_count;
            stats.average_history_count = stats.history_count / stats.delivery_count;
            stats.cart_button_click_rate = stats.cart_button_click_count / stats.delivery_count;
            stats.conversion_rate = stats.conversion_count / stats.delivery_count;
            if (stats.conversion_count > 0) {
              stats.campaign_coupon_used_rate = stats.campaign_coupon_used_count / stats.conversion_count;
            } else {
              stats.campaign_coupon_used_rate = 0;
            }
          } else {
            stats.average_dwell = 0;
            stats.average_history_count = 0;
            stats.cart_button_click_rate = 0;
            stats.conversion_rate = 0;
            stats.campaign_coupon_used_rate = 0;
          }
          if (stats.cart_button_click_count) {
            stats.cart_through_rate = stats.conversion_count / stats.cart_button_click_count;
          }
          if (stats.conversion_count) {
            stats.average_conversion_price = stats.conversion_price / stats.conversion_count;
          } else {
            stats.average_conversion_price = 0;
          }
          stats.start_at = $filter('changeDatetimeFrom')('regionToLocal', stats.start_at, 'integer', stats.region);
          stats.end_at = $filter('changeDatetimeFrom')('regionToLocal', stats.end_at, 'integer', stats.region);
        }
        return data;
      } catch (error) {
        return {};
      }
    },
    groupById: function(campaign_stats) {
      var campaign_id, control_conversion_rate, conversion, conversion_string, j, k, len, len1, stats, statsById, sum_conversions;
      statsById = {};
      for (j = 0, len = campaign_stats.length; j < len; j++) {
        stats = campaign_stats[j];
        if (stats.original_conversions) {
          sum_conversions = lib.sumOriginalConversions(stats);
          conversion_string = '';
          for (k = 0, len1 = sum_conversions.length; k < len1; k++) {
            conversion = sum_conversions[k];
            conversion_string += conversion.price_decimal + " " + (conversion.currency.toUpperCase()) + "\n";
          }
          stats.original_conversions_string = conversion_string;
        }
        if (!statsById[stats.campaign_id]) {
          statsById[stats.campaign_id] = {
            control: {},
            experimental: {}
          };
        }
        if (stats.is_control) {
          statsById[stats.campaign_id].control = stats;
        } else {
          statsById[stats.campaign_id].experimental = stats;
        }
      }
      for (campaign_id in statsById) {
        stats = statsById[campaign_id];
        if (stats.control.conversion_rate) {
          stats.conversion_up_rate = stats.experimental.conversion_rate / stats.control.conversion_rate;
        } else {
          stats.conversion_up_rate = 0;
        }
        if (stats.experimental.conversion_rate) {
          control_conversion_rate = stats.control.conversion_rate || 0;
          stats.conversion_lift_rate = (stats.experimental.conversion_rate - control_conversion_rate) / stats.experimental.conversion_rate;
        } else {
          stats.conversion_lift_rate = 0;
        }
        if (stats.experimental.conversion_price) {
          stats.contribution_price = lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_price);
        } else {
          stats.contribution_price = 0;
        }
        if (stats.experimental.conversion_count) {
          stats.contribution_count = lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_count);
        } else {
          stats.contribution_count = 0;
        }
        if (new Date('2017-02-01T00:00:00+0900') <= new Date()) {
          stats.contribution_price = _.max([0, stats.contribution_price]);
          stats.contribution_count = _.max([0, stats.contribution_count]);
        }
      }
      return statsById;
    },
    forChart: function(campaign_stats) {
      var j, len, stats;
      for (j = 0, len = campaign_stats.length; j < len; j++) {
        stats = campaign_stats[j];
        stats.conversion_rate = stats.conversion_rate * 100;
        stats.average_dwell = stats.average_dwell / (1000 * 60);
        stats.cart_button_click_rate = stats.cart_button_click_rate * 100;
      }
      return campaign_stats;
    },
    calculateCumulatives: function(stats, start_at) {
      var first;
      stats = _.chain(stats).filter(function(d) {
        return d.start_at >= start_at;
      }).sortBy('startAt').value();
      first = stats.splice(0, 1)[0];
      _.each(stats, function(d) {
        var chartNames;
        _.each(BASE_ITEMS, function(name) {
          return d[name] = d[name] - first[name];
        });
        chartNames = _.chain(campaignGraphOptions).map('name').reject(function(d) {
          return indexOf.call(BASE_ITEMS, d) >= 0;
        }).value();
        return _.each(chartNames, function(name) {
          d[name] = 0;
          switch (name) {
            case 'average_history_count':
              if (d.delivery_count) {
                return d[name] = d.history_count / d.delivery_count;
              }
              break;
            case 'average_dwell':
              if (d.delivery_count) {
                return d[name] = d.dwell / d.delivery_count / (1000 * 60);
              }
              break;
            case 'average_conversion_price':
              if (d.conversion_count) {
                return d[name] = d.conversion_price / d.conversion_count;
              }
              break;
            case 'conversion_rate':
              if (d.delivery_count) {
                return d[name] = d.conversion_count / d.delivery_count * 100;
              }
              break;
            case 'cart_button_click_rate':
              if (d.delivery_count) {
                return d[name] = d.cart_button_click_count / d.delivery_count * 100;
              }
              break;
            case 'cart_through_rate':
              if (d.cart_button_click_count) {
                return d[name] = d.conversion_count / d.cart_button_click_count * 100;
              }
          }
        });
      });
      return stats;
    },
    chisqTest: function(stats) {
      return this.chisqP(stats) < SIGNIFICANCE_LEVEL;
    },
    chisqP: function(stats) {
      return ZCStats.chisqdist(1, this.chisq(stats));
    },
    chisq: function(stats) {
      var control, control_expectation, experimental, experimental_expectation, total_conversion_rate, total_delivery_count;
      if (!stats) {
        return 0;
      }
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count;
      if (total_delivery_count === 0) {
        return 0;
      }
      total_conversion_rate = (stats.experimental.conversion_count + stats.control.conversion_count) / total_delivery_count;
      experimental_expectation = stats.experimental.delivery_count * total_conversion_rate;
      if (experimental_expectation === 0) {
        return 0;
      }
      control_expectation = stats.control.delivery_count * total_conversion_rate;
      if (control_expectation === 0) {
        return 0;
      }
      experimental = (Math.pow(stats.experimental.conversion_count - experimental_expectation, 2)) / experimental_expectation;
      control = (Math.pow(stats.control.conversion_count - control_expectation, 2)) / control_expectation;
      return experimental + control;
    },
    calculateInvoiceAmount: function(project, campaign, stats) {
      var contribution_count, contribution_price;
      if (stats === void 0) {
        return null;
      }
      if (campaign.fee_calculation_type === 'contribution') {
        contribution_price = stats.contribution_price;
        contribution_count = stats.contribution_count;
      } else if (campaign.fee_calculation_type === 'conversion') {
        contribution_price = stats.experimental.conversion_price;
        contribution_count = stats.experimental.conversion_count;
      } else {
        throw "Unknown fee calculation type: " + campaign.fee_calculation_type + "! apikey: " + project.apikey;
      }
      switch (project.product_line) {
        case 'zenclerk':
          return contribution_price * (campaign.fee_rate || ZC_COST_RATE);
        case 'zenclerk_lp':
          if (!campaign.cost_per_acquisition) {
            return null;
          }
          return campaign.cost_per_acquisition * contribution_count;
        case 'zenclerk_s':
          return null;
        default:
          throw new Error("Unexpected product line! apikey: " + project.apikey + ", product_line: " + project.product_line);
      }
    },
    transformReport: function(json) {
      var data, report, transformed;
      try {
        data = angular.fromJson(json);
        report = data.report_stats[0];
        if (report) {
          transformed = {
            exp: {
              conversion_count: report.experimental.conversion_count,
              conversion_price: report.experimental.conversion_price,
              delivery_count: report.experimental.delivery_count
            },
            ctrl: {
              conversion_count: report.control.conversion_count,
              conversion_price: report.control.conversion_price,
              delivery_count: report.control.delivery_count
            },
            contribution_count: report.contribution_count,
            contribution_price: report.contribution_price
          };
        } else {
          transformed = {
            exp: {
              conversion_count: 0,
              conversion_price: 0,
              delivery_count: 0
            },
            ctrl: {
              conversion_count: 0,
              conversion_price: 0,
              delivery_count: 0
            },
            contribution_count: 0,
            contribution_price: 0
          };
        }
        transformed.exp.average_conversion_price = transformed.exp.conversion_price / transformed.exp.conversion_count || 0;
        transformed.ctrl.average_conversion_price = transformed.ctrl.conversion_price / transformed.ctrl.conversion_count || 0;
        transformed.exp.conversion_rate = transformed.exp.conversion_count / transformed.exp.delivery_count || 0;
        transformed.ctrl.conversion_rate = transformed.ctrl.conversion_count / transformed.ctrl.delivery_count || 0;
        if (transformed.exp.conversion_rate === 0) {
          transformed.lift_rate = 0;
        } else {
          transformed.lift_rate = (transformed.exp.conversion_rate - transformed.ctrl.conversion_rate) / transformed.exp.conversion_rate || 0;
        }
        if (transformed.ctrl.conversion_rate === 0) {
          transformed.up_rate = 0;
        } else {
          transformed.up_rate = (transformed.exp.conversion_rate / transformed.ctrl.conversion_rate) || 0;
        }
        return transformed;
      } catch (error) {
        return {};
      }
    }
  };
  return service;
}]);


/***/ }),
/* 1039 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignUsers', ["FacadeV2", function(FacadeV2) {
  var CampaignUsers;
  return CampaignUsers = (function() {
    function CampaignUsers() {}

    CampaignUsers.aggregate = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_users/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    CampaignUsers.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_users/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    CampaignUsers.findConversions = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_users/" + paths.dimension + "/find_conversions", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return CampaignUsers;

  })();
}]);


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("installationChecker", ["$q", "Facade", function($q, Facade) {
  var service;
  service = {
    checkTrackingCode: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/setup/check_tracking_code", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    getLatestConversions: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/conversions/latest", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data.conversions;
      });
    },
    checkPageTypes: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_page_types", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    checkConversionTag: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_conversion_tag", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    checkDomains: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_domains", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    checkSessionCountEvaluator: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_session_count_evaluator", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('InterestTree', ["$q", "FacadeV2", function($q, FacadeV2) {
  var InterestTree;
  InterestTree = (function() {
    function InterestTree() {}

    InterestTree.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/interest_trees", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return InterestTree;

  })();
  return InterestTree;
}]);


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoCampaign", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoCampaign;
  MongoCampaign = (function() {
    function MongoCampaign() {}

    MongoCampaign.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        if (!(query._id || query._sid || query._uuid || query._usid || query.campaign_id || query.created_at)) {
          return reject("no _id or _sid or _uuid or _usid or campaign_id");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/campaigns", {
          params: {
            match: query,
            sort: options.sort,
            fields: options.fields,
            limit: options.limit || 1000
          }
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoCampaign;

  })();
  return MongoCampaign;
}]);


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoConversion", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoConversion;
  MongoConversion = (function() {
    function MongoConversion() {}

    MongoConversion.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/conversions", {
          params: {
            match: query,
            sort: options.sort,
            fields: options.fields,
            limit: options.limit || 1000
          },
          cache: false
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoConversion;

  })();
  return MongoConversion;
}]);


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoHistory", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoHistory;
  MongoHistory = (function() {
    function MongoHistory() {}

    MongoHistory.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/histories", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000,
            fields: options.fields
          },
          cache: false
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    MongoHistory.aggregate = function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      params.limit = query.limit || 1000;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/histories/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return MongoHistory;

  })();
  return MongoHistory;
}]);


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoParticularEvent", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoParticularEvent;
  MongoParticularEvent = (function() {
    function MongoParticularEvent() {}

    MongoParticularEvent.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/particular_events", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000
          },
          cache: false
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoParticularEvent;

  })();
  return MongoParticularEvent;
}]);


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoRaw", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoRaw;
  MongoRaw = (function() {
    function MongoRaw() {}

    MongoRaw.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        if (!(query._id || query._sid)) {
          return reject("no _id or _sid");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/raws", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000
          }
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoRaw;

  })();
  return MongoRaw;
}]);


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoSession", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoSession;
  MongoSession = (function() {
    function MongoSession() {}

    MongoSession.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        var params;
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        if (!(query._id || query._uuid || query.opened_at || (options.sort && options.sort.indexOf("opened_at") >= 0))) {
          return reject("no _id or apikey/opened_at provided");
        }
        params = {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000,
            fields: options.fields,
            t: options.t ? options.t : void 0
          },
          ignoreLoadingBar: options.ignoreLoadingBar ? options.ignoreLoadingBar : void 0
        };
        return FacadeV2.request("/apikeys/" + query.apikey + "/sessions", params).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoSession;

  })();
  return MongoSession;
}]);


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("ProjectStats", ["$q", "FacadeV2", "AccessStats", function($q, FacadeV2, AccessStats) {
  var ProjectStats;
  return ProjectStats = (function() {
    function ProjectStats() {}

    ProjectStats.getDailyProjectStats = function(match, callback) {
      var dimension, field, group, i, len, params, query, ref;
      dimension = 'daily';
      query = {
        match: match
      };
      query.match = _.assignIn({}, match, {
        device: null,
        campaign_segment_id: null,
        is_control: {
          $ne: null
        }
      });
      query.pipeline = [];
      group = {
        _id: {
          apikey: "$apikey",
          is_control: "$is_control"
        }
      };
      ref = AccessStats.fields;
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        group[field] = {
          $sum: "$" + field
        };
      }
      query.pipeline.push({
        $group: group
      });
      params = {};
      params.match = FacadeV2.encode({}, query.match);
      params.pipeline = FacadeV2.encode([], query.pipeline);
      return FacadeV2.request("/master/access_stats/" + dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        var apikey, base, f, j, len1, name, ref1, safeDiv, stat, stats, v;
        safeDiv = function(a, b) {
          if (b) {
            return a / b;
          } else {
            return 0;
          }
        };
        stats = {};
        ref1 = res.data;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          stat = ref1[j];
          stat.apikey = stat._id.apikey;
          stats[name = stat.apikey] || (stats[name] = {
            total_conversion_price: 0
          });
          for (f in stat) {
            v = stat[f];
            (base = stats[stat.apikey])[f] || (base[f] = 0);
            stats[stat.apikey][f] += v;
            if (f === 'conversion_price') {
              stats[stat.apikey]['total_conversion_price'] += v;
            }
          }
          if (stat._id.is_control) {
            stats[stat.apikey].ctl_conversion_rate = safeDiv(stat.conversion_count, stat.session_count);
            stats[stat.apikey].ctl_cart_button_click_rate = safeDiv(stat.cart_button_click_count, stat.session_count);
          } else {
            stats[stat.apikey].exp_conversion_rate = safeDiv(stat.conversion_count, stat.session_count);
            stats[stat.apikey].exp_cart_button_click_rate = safeDiv(stat.cart_button_click_count, stat.session_count);
          }
        }
        for (apikey in stats) {
          stat = stats[apikey];
          stat.avg_history_count = safeDiv(stat.history_count, stat.session_count);
          stat.avg_interest_count = safeDiv(stat.interest_count, stat.session_count);
        }
        return stats;
      });
    };

    return ProjectStats;

  })();
}]);


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("ReportCampaignStats", ["$q", "FacadeV2", function($q, FacadeV2) {
  var ReportCampaignStats;
  ReportCampaignStats = (function() {
    function ReportCampaignStats() {}

    ReportCampaignStats.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/report_campaign_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return ReportCampaignStats.transformReport(res.data);
      });
    };

    ReportCampaignStats.transformReport = function(data) {
      var cumulatives, i, len, stats;
      try {
        for (i = 0, len = data.length; i < len; i++) {
          stats = data[i];
          cumulatives = {
            experimental: {
              conversion_count: stats.experimental.conversion_count,
              conversion_price: stats.experimental.conversion_price,
              delivery_count: stats.experimental.delivery_count
            },
            control: {
              conversion_count: stats.control.conversion_count,
              conversion_price: stats.control.conversion_price,
              delivery_count: stats.control.delivery_count
            },
            contribution_count: stats.contribution_count,
            contribution_price: stats.contribution_price
          };
          cumulatives.experimental.average_conversion_price = cumulatives.experimental.conversion_price / cumulatives.experimental.conversion_count || 0;
          cumulatives.control.average_conversion_price = cumulatives.control.conversion_price / cumulatives.control.conversion_count || 0;
          cumulatives.experimental.conversion_rate = cumulatives.experimental.conversion_count / cumulatives.experimental.delivery_count || 0;
          cumulatives.control.conversion_rate = cumulatives.control.conversion_count / cumulatives.control.delivery_count || 0;
          if (cumulatives.control.conversion_rate === 0) {
            cumulatives.conversion_up_rate = 0;
          } else {
            cumulatives.conversion_up_rate = (cumulatives.experimental.conversion_rate / cumulatives.control.conversion_rate) || 0;
          }
          angular.extend(stats, cumulatives);
        }
        return data;
      } catch (error) {
        return {};
      }
    };

    return ReportCampaignStats;

  })();
  return ReportCampaignStats;
}]);


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Report', ["$q", "FacadeV2", "Project", function($q, FacadeV2, Project) {
  var Report;
  return Report = (function() {
    function Report() {}

    Report.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/report_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    Report.findOne = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/report_stats/" + paths.dimension + "/find_one", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return Report;

  })();
}]);


/***/ }),
/* 1051 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('reportStatsResponseTransformer', function() {
  return function(data) {
    var i, len, ref, stats;
    try {
      data = angular.fromJson(data);
      ref = data.report_stats;
      for (i = 0, len = ref.length; i < len; i++) {
        stats = ref[i];
        if (stats.start_at) {
          stats.start_at = moment(stats.start_at).valueOf();
        }
        if (stats.end_at) {
          stats.end_at = moment(stats.end_at).valueOf();
        }
      }
      return data;
    } catch (error) {
      return {};
    }
  };
});


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('TagNonExistingUrls', ["FacadeV2", function(FacadeV2) {
  var TagNonExistingUrls;
  return TagNonExistingUrls = (function() {
    function TagNonExistingUrls() {}

    TagNonExistingUrls.findOne = function(paths) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/tag_non_existing_urls", {
        params: {
          match: {}
        }
      }).then(function(results) {
        var ref;
        return (ref = results.data) != null ? ref[0] : void 0;
      });
    };

    return TagNonExistingUrls;

  })();
}]);


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ZcsAgencyInvoice', ["$q", "FacadeV2", function($q, FacadeV2) {
  var ZcsAgencyInvoice;
  return ZcsAgencyInvoice = (function() {
    function ZcsAgencyInvoice() {}

    ZcsAgencyInvoice.all = function(agency_id) {
      return FacadeV2.request("/agencies/" + agency_id + "/zcs_agency_invoices/").then(function(res) {
        return _.map(res.data, function(d) {
          d.invoice_price = parseInt(d.invoice_price);
          d.invoice_price_tax_excluded = parseInt(d.invoice_price_tax_excluded);
          return d;
        });
      });
    };

    ZcsAgencyInvoice.find = function(agency_id, month) {
      return FacadeV2.request("/agencies/" + agency_id + "/zcs_agency_invoices/" + month, {}).then(function(res) {
        res.data.invoice_price = parseInt(res.data.invoice_price);
        res.data.invoice_price_tax_excluded = parseInt(res.data.invoice_price_tax_excluded);
        return res.data;
      });
    };

    ZcsAgencyInvoice.findAgencyApikeyMaxInvoice = function(agency_id, month) {
      return FacadeV2.request("/agencies/" + agency_id + "/zcs_agency_invoices/" + month + "/apikeyMaxInvoice", {}).then(function(res) {
        var max_invoice_by_apikey;
        max_invoice_by_apikey = {};
        _.each(res.data, function(d) {
          return max_invoice_by_apikey[d.apikey] = d.max_invoice;
        });
        return max_invoice_by_apikey;
      });
    };

    return ZcsAgencyInvoice;

  })();
}]);


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('campaign', function() {
  return function(campaigns, filters) {
    var result;
    result = _.filter(campaigns, function(campaign) {
      if (filters) {
        if (filters.start_at && filters.end_at && campaign.start_at && campaign.end_at) {
          if (moment(campaign.start_at).startOf("day").valueOf() > filters.end_at) {
            return false;
          }
          if (campaign.end_at.valueOf() < filters.start_at) {
            return false;
          }
        }
        if (filters.device_value && filters.device_value.name && filters.device_value.name !== campaign.campaign_device) {
          return false;
        }
        if (filters.campaign_segment_value && filters.campaign_segment_value.id && filters.campaign_segment_value.id !== _.get(campaign, 'segment.id', -1)) {
          return false;
        }
        if (filters.referrer_type && filters.referrer_type.name && filters.referrer_type.name !== campaign.referrer_type) {
          return false;
        }
      }
      if (filters.status) {
        if (campaign.current_status !== filters.status) {
          return false;
        }
      }
      return true;
    });
    return result;
  };
});


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('campaignText', function() {
  return function(campaigns, search) {
    var result;
    result = _.filter(campaigns, function(campaign) {
      var conditions, keywords, ref, ref1, ref2;
      if (!search) {
        return true;
      }
      conditions = [campaign.project_name, campaign.apikey, campaign.status, campaign.campaign_device, campaign.name, campaign.id, (ref = campaign.elements) != null ? (ref1 = ref[0]) != null ? ref1.id : void 0 : void 0, campaign.template_type, campaign.campaign_target, (ref2 = campaign.campaign_policy_set) != null ? ref2.name : void 0];
      keywords = search.split(/\s/);
      return _.every(keywords, function(keyword) {
        return _.some(conditions, function(condition) {
          if (typeof condition !== 'string') {
            condition = condition + '';
          }
          if (condition && condition.indexOf(keyword) > -1) {
            return true;
          }
          return false;
        });
      });
    });
    return result;
  };
});


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('currentStatus', function() {
  return function(campaign) {
    var current_status, hasActiveIncentives, hasEnded, hasIncentives, hasNotStartedYet, hasPendingIncentives, isRunning;
    isRunning = function(campaign) {
      return moment(campaign.start_at).diff(moment()) < 0 && moment(campaign.end_at).diff(moment()) > 0;
    };
    hasNotStartedYet = function(campaign) {
      return moment(campaign.start_at).diff(moment()) > 0;
    };
    hasEnded = function(campaign) {
      return moment(campaign.end_at).diff(moment()) < 0;
    };
    hasIncentives = function(campaign) {
      return _.get(campaign, 'incentives', []).length > 0;
    };
    hasActiveIncentives = function(campaign) {
      if (!hasIncentives(campaign)) {
        return false;
      }
      return typeof _.find(campaign.incentives, {
        current_status: 'active'
      }) !== 'undefined';
    };
    hasPendingIncentives = function(campaign) {
      if (!hasIncentives(campaign)) {
        return false;
      }
      return typeof _.find(campaign.incentives, {
        current_status: 'pending'
      }) !== 'undefined';
    };
    current_status = campaign.status;
    if (current_status === 'activated') {
      if (isRunning(campaign)) {
        if (!campaign.requires_incentives || hasActiveIncentives(campaign)) {
          return 'active';
        }
        if (hasPendingIncentives(campaign)) {
          return 'pending';
        }
        return 'no_incentives';
      }
      if (hasNotStartedYet(campaign)) {
        return 'pending';
      }
      if (hasEnded(campaign)) {
        return 'terminated';
      }
    }
    if (current_status === 'blocked') {
      if (hasEnded(campaign)) {
        return 'terminated';
      }
    }
    return current_status;
  };
});


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').filter('device', function() {
  return function(templates, device) {
    return _.filter(templates, function(template) {
      return indexOf.call(template.support_devices, device) >= 0;
    });
  };
});


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('projectText', function() {
  return function(projects, filterText) {
    var result;
    result = _.filter(projects, function(project) {
      var conditions, keywords;
      if (!filterText) {
        return true;
      }
      conditions = [project.title, project.apikey, project.base_url, project.id];
      keywords = filterText.split(/\s/);
      return _.every(keywords, function(keyword) {
        return _.some(conditions, function(condition) {
          if (typeof condition !== 'string') {
            condition = condition + '';
          }
          if (condition && condition.indexOf(keyword) > -1) {
            return true;
          }
          return false;
        });
      });
    });
    return result;
  };
});


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').service('campaignGraphOptions', ["$filter", function($filter) {
  return [
    {
      name: 'delivery_count',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.deliveryCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.visit'),
      decimal: 0
    }, {
      name: 'conversion_count',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversionCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversion'),
      decimal: 0
    }, {
      name: 'conversion_rate',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversion_rate'),
      unit: ' %',
      decimal: 1
    }, {
      name: 'cvr_increase_rate',
      isMasterOnly: true,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cvrIncreaseRate'),
      unit: ' %',
      decimal: 1
    }, {
      name: 'cart_button_click_rate',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cartButtonClickRate'),
      unit: ' %',
      decimal: 1
    }, {
      name: 'cart_through_rate',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cartThroughRate'),
      unit: ' %',
      decimal: 2
    }, {
      name: 'average_history_count',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageHistoryCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.pageView'),
      decimal: 1
    }, {
      name: 'average_dwell',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageDwell'),
      unit: $filter('translate')('sharedModules.dateTimeFormats.minute'),
      decimal: 1
    }, {
      name: 'average_conversion_price',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageConversionPrice'),
      unit: '',
      decimal: 0
    }, {
      name: 'conversion_price',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversionPrice'),
      unit: '',
      decimal: 0
    }
  ];
}]);


/***/ }),
/* 1060 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').service('campaignStatuses', ["$filter", function($filter) {
  return {
    incomplete: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.incomplete'),
      statusClass: 'label status-notset'
    },
    preview: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.preview'),
      statusClass: 'label status-waiting'
    },
    active: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.active'),
      statusClass: 'label status-active'
    },
    finished: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.finished'),
      statusClass: 'label status-finished'
    },
    terminated: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.terminated'),
      statusClass: 'label status-finished'
    },
    pending: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.pending'),
      statusClass: 'label status-waiting'
    },
    no_incentives: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.no_incentives'),
      statusClass: 'label status-waiting'
    },
    blocked: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.blocked'),
      statusClass: 'label status-stop'
    }
  };
}]);


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ReportRange', ["cronHours", "Project", function(cronHours, Project) {
  var ReportRange;
  return ReportRange = (function() {
    var baseTime;

    function ReportRange() {}

    ReportRange.isLatest = function(begin_at) {
      return moment(begin_at).tz(Project.getRegion()).isSame(baseTime(), 'month');
    };

    ReportRange.hasLatest = function() {
      return baseTime().date() > 1;
    };

    ReportRange.getLatest = function() {
      var _baseTime;
      _baseTime = baseTime();
      return {
        begin_at: moment(_baseTime).startOf('month').toDate(),
        start_at: moment(_baseTime).subtract(1, 'days').startOf('day').toDate(),
        end_at: moment(_baseTime).startOf('day').toDate()
      };
    };

    baseTime = function() {
      return moment().tz(Project.getRegion()).subtract(cronHours.dailyReport, 'hours');
    };

    return ReportRange;

  })();
}]);


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').service("SegmentEstimator", ["MasterMongoSession", "MasterMongoVisitor", "MasterAccessStats", "SegmentMatcher", "$q", function(MasterMongoSession, MasterMongoVisitor, MasterAccessStats, SegmentMatcher, $q) {
  var SegmentEstimator;
  return SegmentEstimator = (function() {
    var buildQueryWithTiming;

    function SegmentEstimator() {}

    buildQueryWithTiming = function(combinedQuery, timingSegments) {
      var base, i, j, len, len1, originalSessionOr, originalVisitorOr, query, ref, ref1, timingSessionsQueries, timingVisitorsQueries;
      originalSessionOr = combinedQuery['$or'] || [];
      originalVisitorOr = combinedQuery['visitor']['$or'] || [];
      if (!_.isEmpty(originalSessionOr)) {
        delete combinedQuery['$or'];
      }
      if (!_.isEmpty(originalVisitorOr)) {
        delete combinedQuery['visitor']['$or'];
      }
      timingSessionsQueries = _.chain(timingSegments).map(SegmentMatcher.createSegmentQuery).compact().filter(function(x) {
        return !_.isEmpty(x);
      }).value();
      timingVisitorsQueries = _.chain(timingSegments).map(SegmentMatcher.createVisitorQuery).compact().filter(function(x) {
        return !_.isEmpty(x);
      }).value();
      if (!(_.isEmpty(originalSessionOr) && _.isEmpty(timingSessionsQueries))) {
        combinedQuery['$and'] || (combinedQuery['$and'] = []);
      }
      ref = [originalSessionOr, timingSessionsQueries];
      for (i = 0, len = ref.length; i < len; i++) {
        query = ref[i];
        if (!_.isEmpty(query)) {
          combinedQuery['$and'] = combinedQuery['$and'].concat([
            {
              '$or': query
            }
          ]);
        }
      }
      if (!(_.isEmpty(originalVisitorOr) || _.isEmpty(timingVisitorsQueries))) {
        (base = combinedQuery['visitor'])['$and'] || (base['$and'] = []);
      }
      ref1 = [originalVisitorOr, timingVisitorsQueries];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        query = ref1[j];
        if (!_.isEmpty(query)) {
          combinedQuery['visitor']['$and'] = combinedQuery['visitor']['$and'].concat([
            {
              '$or': query
            }
          ]);
        }
      }
      return combinedQuery;
    };

    SegmentEstimator.filterSessionsBySegmentQuery = function(mongo_query, device, sessions, timingSegments) {
      var combinedQuery, deviceQuery, deviceSessions, matchedSessions, segmentQuery, visitorQuery;
      segmentQuery = SegmentMatcher.createSegmentQuery(mongo_query);
      visitorQuery = SegmentMatcher.createVisitorQuery(mongo_query);
      combinedQuery = segmentQuery;
      combinedQuery.visitor = visitorQuery;
      if (timingSegments) {
        combinedQuery = buildQueryWithTiming(combinedQuery, timingSegments);
      }
      deviceSessions = sessions;
      if (device !== 'all') {
        combinedQuery.device = device;
        deviceQuery = {
          device: device
        };
        deviceSessions = SegmentMatcher.matchSessions(deviceQuery, sessions);
      }
      matchedSessions = SegmentMatcher.matchSessions(combinedQuery, sessions);
      return {
        matchedSessions: matchedSessions,
        deviceSessions: deviceSessions
      };
    };

    SegmentEstimator.getSessions = function(apikey, timeLimitDate) {
      var CHUNK_SIZE, SESSIONS_TO_GET, query, sessions;
      SESSIONS_TO_GET = 1000;
      CHUNK_SIZE = 100;
      sessions = [];
      query = {
        apikey: apikey
      };
      if (timeLimitDate) {
        _.merge(query, {
          opened_at: {
            $lt: timeLimitDate
          }
        });
      }
      return MasterMongoSession.find(query, {
        limit: SESSIONS_TO_GET,
        sort: "-opened_at"
      }).then(function(_sessions) {
        var chunks, promises, uuids;
        sessions = _sessions;
        uuids = _.chain(sessions).map('_uuid').uniq().value();
        chunks = _.chunk(uuids, CHUNK_SIZE);
        promises = _.map(chunks, function(chunk) {
          return MasterMongoVisitor.find({
            _id: {
              $in: chunk
            }
          });
        });
        return $q.all(promises);
      }).then(function(visitors) {
        visitors = _.flatten(visitors);
        _.each(sessions, function(session) {
          return _.each(visitors, function(visitor) {
            if (visitor._id === session._uuid) {
              return session.visitor = visitor;
            }
          });
        });
        return sessions;
      });
    };

    SegmentEstimator.getAccessStats = function(apikey, start_at, segment_id) {
      return MasterAccessStats.find({
        apikey: apikey,
        start_at: start_at,
        is_control: null,
        is_after_installed_at: null,
        total_conversion_count: null,
        campaign_segment_id: {
          $in: [null, segment_id]
        }
      }).then(function(res) {
        var accessStatsEnd, accessStatsMatchedCounts, accessStatsStart, accessStatsTotalCounts;
        accessStatsTotalCounts = {
          all: 0
        };
        accessStatsMatchedCounts = {
          all: 0
        };
        accessStatsStart = null;
        accessStatsEnd = null;
        _.chain(res).groupBy(function(d) {
          return d.campaign_segment_id;
        }).each(function(grouped) {
          return _.each(grouped, function(stat) {
            if (stat.campaign_segment_id === null) {
              accessStatsTotalCounts[stat.device || "all"] = stat.session_count;
            } else if (stat.campaign_segment_id === segment_id) {
              accessStatsMatchedCounts[stat.device || "all"] = stat.session_count;
            }
            accessStatsStart = stat.start_at;
            return accessStatsEnd = stat.end_at;
          });
        }).value();
        return {
          accessStatsTotalCounts: accessStatsTotalCounts,
          accessStatsMatchedCounts: accessStatsMatchedCounts,
          accessStatsStart: accessStatsStart,
          accessStatsEnd: accessStatsEnd
        };
      });
    };

    return SegmentEstimator;

  })();
}]);


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("SegmentMatcher", function() {
  var service;
  service = {
    getCombinedDeviceCondition: function(device) {
      switch (device) {
        case 'pc':
          return {
            $in: ['pc', 'tablet']
          };
        case 'sp':
        case 'iphone':
          return 'sp';
        default:
          return {
            $exists: true
          };
      }
    },
    isDateString: function(str) {
      return !(_.isNaN(Date.parse(str)) || /^\d\.?\d*$/.test(str));
    },
    recursivelyReplaceZcVariables: function(query) {
      var found, k, key, keys, results, v;
      results = [];
      for (k in query) {
        v = query[k];
        if (_.isObject(v)) {
          found = false;
          keys = Object.keys(v);
          if (keys.length === 1) {
            key = keys[0];
            switch (key) {
              case '$zcDaysFromNow':
                query[k] = moment().add(v[key], "days").toDate();
                found = true;
                break;
              case '$zcSecondsFromNow':
                query[k] = moment().add(v[key], 'seconds').toDate();
                found = true;
            }
          }
          if (!found) {
            results.push(service.recursivelyReplaceZcVariables(v));
          } else {
            results.push(void 0);
          }
        } else if (service.isDateString(v)) {
          results.push(query[k] = new Date(v));
        } else {
          results.push(void 0);
        }
      }
      return results;
    },
    createSegmentQuery: function(query) {
      var k, segmentQuery, v;
      segmentQuery = {};
      for (k in query) {
        v = query[k];
        if (_.startsWith(k, 'Session#')) {
          segmentQuery[k.slice('Session#'.length)] = v;
        }
      }
      return segmentQuery;
    },
    createHistoryQuery: function(query) {
      var k, segmentQuery, v;
      segmentQuery = {};
      for (k in query) {
        v = query[k];
        if (_.startsWith(k, 'History#')) {
          segmentQuery[k.slice('History#'.length)] = v;
        }
      }
      return segmentQuery;
    },
    createVisitorQuery: function(query) {
      var k, v, visitorQuery;
      visitorQuery = {};
      for (k in query) {
        v = query[k];
        if (_.startsWith(k, 'Visitor#')) {
          visitorQuery[k.slice('Visitor#'.length)] = v;
        }
      }
      return visitorQuery;
    },
    matchSessions: function(query, sessions) {
      query = _.merge({}, query);
      service.recursivelyReplaceZcVariables(query);
      return sift(query, sessions);
    }
  };
  return service;
});


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ProjectPageDescription', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  return new BaseProjectCrudService($resource, $q, '/api/master/projects/:projectId/page_descriptions/:id', 'page_description', 'page_descriptions');
}]);


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

angular.module('zc.core').config(["$urlRouterProvider", function($urlRouterProvider) {
  return $urlRouterProvider.rule(function($injector, $location) {
    var path;
    path = $location.url();
    if (path[path.length - 1] === "/") {
      return path.slice(0, -1);
    }
    if (path.indexOf("/?") > -1) {
      return path.replace("/?", "?");
    }
  });
}]).config(["$urlRouterProvider", function($urlRouterProvider) {
  return $urlRouterProvider.otherwise(function($injector, $location) {
    var $state, Devise;
    $state = $injector.get('$state');
    Devise = $injector.get('Devise');
    if (!Devise.currentUser && ($location.path() === '/' || $location.path() === '')) {
      $state.go('users.signIn', null, {});
    } else if (Devise.currentUser && ($location.path() === '/' || $location.path() === '')) {
      $state.go('admin.home');
    } else {
      $state.go('404', null, {
        location: false
      });
    }
  });
}]);


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

angular.module('zc.core').config(["$locationProvider", function($locationProvider) {
  return $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  }).hashPrefix('!');
}]).config(["$httpProvider", function($httpProvider) {
  var authToken;
  authToken = $('meta[name="csrf-token"]').attr('content');
  $httpProvider.defaults.headers.common['X-CSRF-TOKEN'] = authToken;
  return $httpProvider.defaults.withCredentials = true;
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.interceptors.push('SessionRecoverer');
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.interceptors.push('errorInterceptor');
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.interceptors.push('notificationInterceptor');
}]).config(["localStorageServiceProvider", function(localStorageServiceProvider) {
  return localStorageServiceProvider.setPrefix('zc');
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.defaults.headers.patch = {
    'Content-Type': 'application/json;charset=utf-8'
  };
}]).config(["$sceDelegateProvider", function($sceDelegateProvider) {
  return $sceDelegateProvider.resourceUrlWhitelist(['self', 'http://**', 'https://**']);
}]);


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

angular.module('zc.core').constant('cronHours', {
  dailyReport: 5
});


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

angular.module('zc.core').constant('currencies', {
  jpy: {
    symbol: '',
    fractionSize: 0,
    suffix: '円'
  },
  usd: {
    symbol: '',
    fractionSize: 2,
    suffix: 'USD'
  },
  aud: {
    symbol: '',
    fractionSize: 2,
    suffix: 'AUD'
  },
  cad: {
    symbol: 'C$',
    fractionSize: 2,
    suffix: ''
  },
  chf: {
    symbol: 'CHF',
    fractionSize: 2,
    suffix: ''
  },
  cny: {
    symbol: '',
    fractionSize: 2,
    suffix: 'Yuan'
  },
  eur: {
    symbol: '€',
    fractionSize: 2,
    suffix: ''
  },
  gbp: {
    symbol: '£',
    fractionSize: 2,
    suffix: ''
  },
  hkd: {
    symbol: '',
    fractionSize: 2,
    suffix: 'HKD'
  },
  idr: {
    symbol: 'Rp',
    fractionSize: 0,
    suffix: ''
  },
  inr: {
    symbol: '₹',
    fractionSize: 0,
    suffix: ''
  },
  krw: {
    symbol: '₩',
    fractionSize: 0,
    suffix: ''
  },
  myr: {
    symbol: 'RM',
    fractionSize: 2,
    suffix: ''
  },
  nzd: {
    symbol: 'NZ$',
    fractionSize: 2,
    suffix: ''
  },
  php: {
    symbol: '₱',
    fractionSize: 2,
    suffix: ''
  },
  sgd: {
    symbol: '',
    fractionSize: 2,
    suffix: 'SGD'
  },
  sek: {
    symbol: '',
    fractionSize: 0,
    suffix: 'kr'
  },
  thb: {
    symbol: '฿',
    fractionSize: 2,
    suffix: ''
  },
  twd: {
    symbol: 'NT$',
    fractionSize: 0,
    suffix: ''
  },
  vnd: {
    symbol: '',
    fractionSize: 0,
    suffix: '₫'
  },
  zar: {
    symbol: 'R',
    fractionSize: 2,
    suffix: ''
  },
  clp: {
    symbol: '$',
    fractionSize: 2,
    suffix: ''
  },
  cop: {
    symbol: '$',
    fractionSize: 2,
    suffix: ''
  }
});


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

angular.module('zc.core').controller('AdminHeaderCtrl', ["$scope", "currentUser", "Project", "Environment", function($scope, currentUser, Project, Environment) {
  $scope.currentUser = currentUser;
  $scope.Project = Project;
  $scope.notification = true;
  $scope.switchNotification = function() {
    return $scope.notification = !$scope.notification;
  };
  $scope.environment = 'production';
  return Environment.get().then(function(env) {
    return $scope.environment = env;
  });
}]);


/***/ }),
/* 1070 */
/***/ (function(module, exports) {

angular.module('zc.core').controller('MainnavCtrl', ["$scope", "Project", "Devise", "currentUser", function($scope, Project, Devise, currentUser) {
  $scope.Project = Project;
  $scope.isMaster = Devise.isMaster();
  $scope.isInternalUser = Devise.isInternalUser();
  $scope.currentUser = currentUser;
  $scope.isDisplayAajsWarningMsg = false;
  return $scope.$watch('Project.currentProject', function(newValue, oldValue) {
    $scope.projectId = newValue != null ? newValue.id : void 0;
    $scope.thisMonth = moment().format('YYYY-MM');
    if (newValue) {
      $scope.aiReportURL = ZC_CONFIG.AIDEAL_URL + "/site/" + newValue.apikey + "/report?period=" + $scope.thisMonth;
      return $scope.isDisplayAajsWarningMsg = newValue.enable_aajs && _.some([newValue.site_id, newValue.tracking_id, newValue.scope_id], (function(_this) {
        return function(item) {
          return !(item && item.length > 0);
        };
      })(this));
    }
  });
}]);


/***/ }),
/* 1071 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcAdmin', ["$rootScope", "$location", "PageLayout", function($rootScope, $location, PageLayout) {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/admin.html',
    link: function(scope, elem, attrs) {
      return $rootScope.$on('$stateChangeSuccess', function() {
        if ($location.path().indexOf('/admin/master') === 0) {
          return PageLayout.showFooter = false;
        } else {
          return PageLayout.showFooter = true;
        }
      });
    }
  };
}]);


/***/ }),
/* 1072 */
/***/ (function(module, exports) {

angular.module('zc.core').directive("confirmModal", ["$translate", "$window", function($translate, $window) {
  return {
    scope: {
      suppressConfirm: '=',
      confirmClick: '&'
    },
    link: function(scope, element, attr) {
      return element.bind("click", function(event) {
        var isElementDisabled, msg;
        msg = attr.confirmModal || $translate.instant('sharedModules.core.directives.confirmModal');
        isElementDisabled = _.get(attr, 'disabled', false) === "true" || element[0].classList.contains('disabled');
        if (isElementDisabled) {
          return;
        }
        if (scope.suppressConfirm) {
          return scope.confirmClick();
        } else {
          if ($window.confirm(msg)) {
            return scope.confirmClick();
          }
        }
      });
    }
  };
}]);


/***/ }),
/* 1073 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDateRange', ["$filter", function($filter) {
  return {
    restrict: "E",
    scope: {
      startAt: '=',
      endAt: '=',
      isInfinite: '=',
      displayTime: '='
    },
    template: "{{ startAt | zcDate: { smart: isUseSmart, dateOnly: !displayTime } }}\n-\n{{ isInfinite\n  ? ('projectsCampaignsViews.directives.campaignRange.kigen_nashi' | translate)\n  : ( endAt | zcDate: { smart: isUseSmart, dateOnly: !displayTime } ) }}",
    link: function(scope) {
      return scope.isUseSmart = moment(scope.startAt).isSame(moment(scope.endAt), 'year');
    }
  };
}]);


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('dateTimePicker', ["$filter", function($filter) {
  return {
    restrict: 'EA',
    scope: {
      data: '=?ngModel',
      date: '=?',
      isRequired: '=?',
      region: '<',
      productLine: '<',
      interval: '<'
    },
    template: '<div class="row clearfix">\n  <div class="col-md-6">\n    <div class="date input-group input-group-lg">\n      <span class="input-group-addon">\n        <i class="fa fa-calendar"></i>\n      </span>\n      <input\n        class="form-control form_datepick"\n        ng-class="{\n          \'ng-invalid\': isRequired && !data.date\n        }"\n        ng-style="{\n          \'border\': borderStyle\n        }"\n        datepick\n        size="16"\n        type="text"\n        date="data.date"\n        ng-required="isRequired"/>\n    </div>\n  </div>\n  <div class="col-md-6">\n    <div class="time input-group input-group-lg">\n      <span class="input-group-addon">\n        <i class="glyphicon glyphicon-time"></i>\n      </span>\n      <input\n        class="form-control form_timepick"\n        ng-class="{\n          \'ng-invalid\': isRequired && !data.time && data.time !== 0\n        }"\n        ng-style="{\n          \'border\': borderStyle\n        }"\n        timepick\n        size="16"\n        type="text"\n        time="data.time"\n        interval="interval"\n        ng-required="isRequired"/>\n        <span\n          class="input-group-addon"\n          tooltip="{{ region | gmtNotation }}">\n          {{ gmtOffset }}\n        </span>\n    </div>\n  </div>\n</div>',
    link: function(scope, element, attrs) {
      var region;
      region = scope.region ? scope.region : 'Asia/Tokyo';
      scope.gmtOffset = "(" + (moment().tz(region).format('Z')) + ")";
      scope.isNotLite = scope.productLine && scope.productLine !== 'zenclerk_s';
      scope.borderStyle = scope.isNotLite ? 'solid 1px #ccc' : 'auto';
      scope.$watch('date', function(newValue) {
        if (!newValue) {
          return;
        }
        return scope.data = $filter('dateToDateObj')(newValue);
      }, true);
      return scope.$watch('data', function(newValue) {
        if (!newValue) {
          return;
        }
        return scope.date = $filter('dateObjToDate')(newValue);
      }, true);
    }
  };
}]).directive('timepick', [
  '$timeout', function($timeout) {
    return {
      restrict: 'A',
      require: '?time',
      scope: {
        time: '=',
        interval: '='
      },
      link: function(scope, element, attrs) {
        var $input, picker, processChange;
        processChange = function(ev) {
          if (typeof ev.select === 'undefined') {
            return scope.$apply(function(scope) {
              return scope.time = void 0;
            });
          } else {
            return scope.$apply(function(scope) {
              return scope.time = ev.select;
            });
          }
        };
        $input = element.pickatime({
          onSet: processChange,
          format: 'HH:i',
          formatSubmit: 'HH:i',
          interval: scope.interval
        });
        picker = $input.pickatime('picker');
        if (scope.time || scope.time === 0) {
          $timeout(function() {
            return picker.set('select', scope.time);
          });
        }
        scope.$watch('time', function(newValue) {
          if (typeof newValue !== 'undefined') {
            return $timeout(function() {
              return picker.set('select', newValue);
            });
          }
        });
        return $input.off('focus');
      }
    };
  }
]).directive('datepick', [
  '$timeout', '$filter', function($timeout, $filter) {
    return {
      restrict: 'A',
      require: '?date',
      scope: {
        date: '=',
        min: '=',
        max: '='
      },
      link: function(scope, element, attrs) {
        var $input, picker, processChange, updateDate, updateMax, updateMin;
        updateDate = function(newValue, oldValue) {
          if (newValue === oldValue) {
            return;
          }
          if (newValue) {
            return picker.set('select', moment(newValue).format());
          } else {
            return picker.clear();
          }
        };
        updateMin = function(newValue) {
          var min;
          min = newValue ? moment(newValue).startOf('day').toDate() : false;
          return picker.set('min', min);
        };
        updateMax = function(newValue) {
          var max;
          max = newValue ? moment(newValue).endOf('day').toDate() : false;
          return picker.set('max', max);
        };
        processChange = function(ev) {
          if (scope.$$phase || scope.$root.$$phase) {
            return;
          }
          if (typeof ev.select === 'undefined') {
            return scope.$apply(function(scope) {
              return scope.date = null;
            });
          } else {
            return scope.$apply(function(scope) {
              return scope.date = moment(ev.select).startOf('day').format();
            });
          }
        };
        $input = element.pickadate({
          onSet: processChange,
          format: $filter('translate')('sharedModules.dateTimeFormats.dateTimePicker.format'),
          formatSubmit: $filter('translate')('sharedModules.dateTimeFormats.dateTimePicker.format')
        });
        picker = $input.pickadate('picker');
        $input.off('focus');
        updateDate(scope.date);
        updateMin(scope.min);
        updateMax(scope.max);
        scope.$watch('date', updateDate, true);
        scope.$watch('min', updateMin, true);
        return scope.$watch('max', updateMax, true);
      }
    };
  }
]);


/***/ }),
/* 1075 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDirtyFormDialog', ["$translate", "NotificationChannel", function($translate, NotificationChannel) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var doPrompt, isDirty;
      isDirty = function() {
        var form;
        form = scope[element.attr('name')];
        return form && form.$pristine === false;
      };
      doPrompt = function() {
        if (isDirty()) {
          return $translate.instant('sharedModules.core.directives.dirtyFormDialog');
        }
        return void 0;
      };
      $(window).bind('beforeunload', doPrompt);
      element.bind('$destroy', function() {
        return $(window).unbind('beforeunload', doPrompt);
      });
      return scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        var prompt;
        if (fromState === toState) {
          return;
        }
        prompt = doPrompt();
        if (prompt && !confirm(prompt)) {
          event.preventDefault();
          return NotificationChannel.requestEnded();
        }
      });
    }
  };
}]);


/***/ }),
/* 1076 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDownloadCampaignDataButton', ["$q", "clientReportCsvCreator", "CampaignStats", function($q, clientReportCsvCreator, CampaignStats) {
  return {
    restrict: 'E',
    scope: {
      filters: '=',
      project: '=',
      campaigns: '=',
      isAb: '='
    },
    template: "<button\n  class=\"btn btn-sm pull-right btn-default\"\n  ng-csv=\"getCSV()\"\n  add-bom=\"true\"\n  charset=\"utf-16\"\n  field-separator=\"\\t\"\n  filename=\"report_{{project.apikey}}_{{date}}.csv\">\n  <i class=\"fa fa-cloud-download\"></i> {{ 'sharedModules.core.directives.download_campaign_data_button' | translate }}\n</button>",
    link: function(scope, element, attrs) {
      scope.date = moment().format('YYYYMMDD');
      scope.prepareCampaigns = function(campaigns) {
        return $q(function(resolve) {
          var c, campaign, end_at, i, len, ref, result, start_at;
          result = [];
          campaigns = _.sortBy(campaigns, function(campaign) {
            return campaign.id;
          });
          for (i = 0, len = campaigns.length; i < len; i++) {
            campaign = campaigns[i];
            start_at = new Date(scope.filters.start_at);
            end_at = moment(scope.filters.end_at).endOf('day').toDate();
            if (new Date(campaign.start_at) > start_at) {
              start_at = new Date(campaign.start_at);
            }
            if (new Date(campaign.end_at) < end_at) {
              end_at = new Date(campaign.end_at);
            }
            c = _.assignIn({}, campaign);
            c.start_at = start_at;
            c.end_at = end_at;
            if ((ref = c.stats) != null) {
              ref.invoice_amount = CampaignStats.calculateInvoiceAmount(scope.project, c, c.stats);
            }
            result.push(c);
          }
          return resolve(result);
        });
      };
      return scope.getCSV = function() {
        return $q(function(resolve) {
          return scope.prepareCampaigns(scope.campaigns).then(function(campaignsWithStats) {
            return clientReportCsvCreator.createCsv(scope.project, campaignsWithStats, scope.isAb);
          }).then(function(res) {
            return resolve(res);
          });
        });
      };
    }
  };
}]);


/***/ }),
/* 1077 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('fixedOnScroll', ["$document", function($document) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var DEFAULT_OFFSET, el, handleScroll, initialPosition, offset, offsetTop;
      DEFAULT_OFFSET = 10;
      try {
        if (attrs.offsetTop) {
          offsetTop = parseInt(attrs.offsetTop);
        } else {
          offsetTop = DEFAULT_OFFSET;
        }
      } catch (error) {
        offsetTop = DEFAULT_OFFSET;
      }
      el = angular.element(element);
      offset = el.offset();
      initialPosition = el.css('position') || "static";
      handleScroll = function(ev) {
        var scrollTop;
        scrollTop = $document.scrollTop();
        if (scrollTop > offset.top - offsetTop) {
          el.css('position', 'fixed');
          return el.css('top', offsetTop);
        } else {
          return el.css('position', initialPosition);
        }
      };
      $document.on('scroll', handleScroll);
      return scope.$on('$destroy', function() {
        return $document.off('scroll', handleScroll);
      });
    }
  };
}]);


/***/ }),
/* 1078 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcFooter', ["PageLayout", function(PageLayout) {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/directives/footer.html',
    link: function(scope, elem, attrs) {
      scope.PageLayout = PageLayout;
      scope.$watch('PageLayout.showFooter', function(newval) {
        if (newval === false) {
          elem.addClass('hidden');
          return $("#wrapper").addClass('no-padding');
        } else {
          elem.removeClass('hidden');
          return $("#wrapper").removeClass('no-padding');
        }
      });
      return scope.thisYear = moment().year();
    }
  };
}]);


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('loading', ["NotificationChannel", function(NotificationChannel) {
  var directive;
  directive = {
    restrict: "A",
    link: function(scope, element) {
      var endRequestHandler, startRequestHandler;
      element.addClass("all-filter-remove");
      startRequestHandler = function() {
        return element.removeClass("all-filter-remove");
      };
      endRequestHandler = function() {
        return element.addClass("all-filter-remove");
      };
      NotificationChannel.onRequestStarted(scope, startRequestHandler);
      return NotificationChannel.onRequestEnded(scope, endRequestHandler);
    }
  };
  return directive;
}]);


/***/ }),
/* 1080 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('positiveOrNegative', ["$filter", function($filter) {
  var directive;
  directive = {
    restrict: "A",
    require: '?value',
    scope: {
      zero: "@",
      type: "@",
      positivePrefix: "@",
      zeroIsNegative: "@",
      showsZero: '<',
      fractionSize: '<',
      value: "=value"
    },
    template: "<span class=\"positive-or-negative label\" ng-class=\"statusClass\" ng-if=\"shows\">{{prefix}}{{showValue}}</span>",
    link: function(scope, element, attrs) {
      scope.value || (scope.value = 0);
      scope.statusClass = "";
      scope.prefix = "";
      return scope.$watch('value', function(oldValue, newValue) {
        var fractionSize;
        if (typeof scope.type === "undefined") {
          scope.type = "number";
        }
        if (typeof scope.positivePrefix === 'undefined') {
          scope.positivePrefix = "+";
        }
        if (typeof scope.zeroIsNegative === 'undefined') {
          scope.zeroIsNegative = true;
        }
        if (typeof scope.showsZero === 'undefined') {
          scope.showsZero = true;
        }
        if (typeof scope.fractionSize === 'undefined') {
          fractionSize = 0;
        } else {
          fractionSize = scope.fractionSize;
        }
        scope.zero || (scope.zero = 0);
        if (scope.value < scope.zero || (scope.zeroIsNegative && scope.value === scope.zero)) {
          scope.statusClass = "negative";
          scope.prefix = "";
          scope.type;
        } else {
          scope.statusClass = "positive";
          if (scope.positivePrefix) {
            scope.prefix = scope.positivePrefix;
          }
        }
        if (!scope.value && scope.value !== 0) {
          scope.showValue = "";
          scope.prefix = "";
        } else if (scope.type === "percentage") {
          scope.showValue = $filter('number')(scope.value * 100, fractionSize) + "%";
        } else {
          scope.showValue = $filter('number')(scope.value, fractionSize);
        }
        if (scope.showsZero) {
          return scope.shows = true;
        } else if (scope.value === scope.zero) {
          return scope.shows = false;
        } else {
          return scope.shows = true;
        }
      });
    }
  };
  return directive;
}]);


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDateTimePicker', ["$filter", function($filter) {
  return {
    restrict: 'E',
    scope: {
      pickerId: '@',
      data: '=?ngModel',
      isRequired: '=?',
      minView: '@'
    },
    templateUrl: '/templates/core/views/directives/zc_date_time_picker.html'
  };
}]);


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('changeDatetimeFrom', ["Project", function(Project) {
  return function(from, date, returnType, region) {
    var datetimeInBrowser, datetimeInRegion, targetDatetime;
    if (returnType == null) {
      returnType = 'date';
    }
    if (!['localToRegion', 'regionToLocal'].includes(from)) {
      throw new TypeError("Please provide a valid 'from' value. " + from);
    }
    if (!date) {
      return null;
    }
    if (new Date(date).toString() === 'Invalid Date') {
      throw new TypeError('Please provide a date');
    }
    region || (region = Project.getRegion());
    if (!region) {
      throw new TypeError('Please provide a region');
    }
    if (from === 'localToRegion') {
      datetimeInBrowser = moment(date).format('YYYY-MM-DD HH:mm:ss');
      targetDatetime = moment.tz(datetimeInBrowser, region);
    } else {
      datetimeInRegion = moment(date).tz(region).format('YYYY-MM-DD HH:mm:ss');
      targetDatetime = moment(datetimeInRegion, 'YYYY-MM-DD HH:mm:ss');
    }
    if (returnType === 'moment') {
      return targetDatetime;
    }
    if (returnType === 'string') {
      return targetDatetime.format();
    }
    if (returnType === 'integer') {
      return targetDatetime.valueOf();
    }
    return targetDatetime.toDate();
  };
}]);


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('dateObjToDate', ["$filter", function($filter) {
  return function(date_obj) {
    var date;
    date = null;
    if (date_obj && date_obj.date && (date_obj.time || date_obj.time === 0)) {
      date = moment(date_obj.date).add(date_obj.time, 'minutes').format();
    }
    return date;
  };
}]);


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('dateToDateObj', ["$filter", "$translate", function($filter, $translate) {
  return function(date) {
    var date_obj;
    date_obj = {};
    if (date) {
      date_obj.date = moment(date).startOf('day').valueOf();
      date_obj.time = moment(date).diff(moment(date_obj.date)) / 60 / 1000;
      date_obj.date_raw = moment(date_obj.date).format($translate.instant('sharedModules.dateTimeFormats.filters.dateToDateObj.format'));
      date_obj.time_raw = moment().startOf('day').add(date_obj.time, 'minutes').format('HH:mm');
    } else {
      date_obj.date = null;
      date_obj.time = null;
    }
    return date_obj;
  };
}]);


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("dayOfWeek", ["$filter", function($filter) {
  return function(day) {
    var date;
    date = moment().day(day).toDate();
    return $filter('date')(date, 'EEEE');
  };
}]);


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("elapseTime", ["$filter", function($filter) {
  var A_DAY;
  A_DAY = 1000 * 60 * 60 * 24;
  return function(milliseconds) {
    if ((0 <= milliseconds && milliseconds < A_DAY)) {
      return $filter('date')(milliseconds, 'HH:mm:ss', 'UTC');
    } else if (A_DAY <= milliseconds) {
      return '(data too big)';
    } else {
      return "-" + $filter('date')(-milliseconds, 'HH:mm:ss', 'UTC');
    }
  };
}]);


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("emptyToEnd", ["$parse", function($parse) {
  return function(array, key, reverse) {
    var empty, keyFn, present;
    if (!angular.isArray(array)) {
      return;
    }
    keyFn = $parse(key);
    empty = [];
    present = [];
    angular.forEach(array, function(item) {
      var val;
      val = keyFn(item);
      if (angular.isUndefined(val) || val === null) {
        return empty.push(item);
      } else {
        return present.push(item);
      }
    });
    if (reverse) {
      return present.concat(empty);
    } else {
      return empty.concat(present);
    }
  };
}]);


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('hourOfDay', ["$filter", "$translate", function($filter, $translate) {
  return function(hour) {
    var date;
    date = moment().hour(hour).toDate();
    return $filter('date')(date, $translate.instant('sharedModules.dateTimeFormats.filters.hourOfDay.format'));
  };
}]);


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('searchProject', function() {
  return function(projects, filter) {
    if (!filter) {
      return projects;
    }
    return projects.filter(function(project) {
      return _.includes(project.title, filter) || _.includes(project.apikey, filter);
    });
  };
});


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("segmentValueFormat", ["$parse", function($parse) {
  return function(value) {
    if (angular.isString(value)) {
      return "\"" + value + "\"";
    } else if (_.isNull(value)) {
      return "null";
    } else {
      return value;
    }
  };
}]);


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("showElement", ["$sce", function($sce) {
  return function(message, column) {
    var html, value;
    value = message[column.name];
    if (value) {
      html = (function() {
        switch (column.type) {
          case "image":
            return "<div><image src=\"" + value + "\"></div>";
          case "color":
            return "<div><div style=\"background-color:" + value + "; width: 24px; height:24px; display:inline-block\"></div> <span>" + value + "</span></div>";
          case "url":
            return "<div style=\"background-color:" + value + ";\"><a href=\"" + value + "\" target=\"_blank\">" + value + "</a></div>";
          case "duration":
            return "<div>" + value + "min</div>";
          default:
            return "<div>" + value + "</div>";
        }
      })();
      return $sce.trustAsHtml(html);
    } else {
      return "empty";
    }
  };
}]);


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("zcCurrency", ["$filter", function($filter) {
  return function(currency, symbol, fractionSize, suffix) {
    var string;
    currency = currency / (Math.pow(10, fractionSize));
    string = $filter('currency')(currency, symbol, fractionSize);
    if (suffix) {
      string += suffix;
    }
    return string;
  };
}]);


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('zcDate', ["$filter", function($filter) {
  var HM_FORMAT, LONG_FORMAT, SHORT_FORMAT;
  SHORT_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.shortFormat');
  LONG_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.longFormat');
  HM_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.timeFormat');
  return function(date, options) {
    var long_format, short_format;
    if (options == null) {
      options = {};
    }
    if (!date) {
      return '';
    }
    if (options.dateOnly) {
      short_format = SHORT_FORMAT;
      long_format = LONG_FORMAT;
    } else {
      short_format = SHORT_FORMAT + " " + HM_FORMAT;
      long_format = LONG_FORMAT + " " + HM_FORMAT;
    }
    if (options.smart) {
      if (moment().isSame(date, 'year')) {
        return $filter('date')(date, short_format);
      } else {
        return $filter('date')(date, long_format);
      }
    } else if (options.format) {
      return $filter('date')(date, options.format);
    } else if (options.short) {
      return $filter('date')(date, short_format);
    } else {
      return $filter('date')(date, long_format);
    }
  };
}]);


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("zerosForMissingTime", ["$filter", function($filter) {
  var DAILY_INTERVAL, HOURLY_INTERVAL, dimensions;
  DAILY_INTERVAL = 24 * 60 * 60 * 1000;
  HOURLY_INTERVAL = 60 * 60 * 1000;
  dimensions = {
    hourly: {
      singular: 'hour',
      plural: 'hours',
      interval: HOURLY_INTERVAL
    },
    daily: {
      singular: 'day',
      plural: 'days',
      interval: DAILY_INTERVAL
    }
  };
  return function(array, dimension, opts) {
    var addZerosForPeriod, afterEndAt, allKeys, beforeStartAt, convertTo, createObj, currentDimension, i, lastDate, len, obj, toBeAdded;
    if (opts == null) {
      opts = {};
    }
    opts = _.merge({
      start_at_key: 'start_at',
      end_at_key: 'end_at'
    }, opts);
    if (array.length == null) {
      return array;
    }
    if (array.length === 0) {
      return array;
    }
    if (!_.has(dimensions, dimension)) {
      return array;
    }
    currentDimension = dimensions[dimension];
    array = _.sortBy(array, function(o) {
      return o[opts.start_at_key];
    });
    toBeAdded = [];
    lastDate = void 0;
    convertTo = 'date';
    if (typeof array[0][opts.start_at_key] === 'number') {
      convertTo = 'number';
    }
    allKeys = _.chain(array).map(function(obj) {
      return Object.getOwnPropertyNames(obj);
    }).flatten().union().value();
    createObj = function(start_at, end_at) {
      var i, key, len, newObj;
      newObj = {};
      for (i = 0, len = allKeys.length; i < len; i++) {
        key = allKeys[i];
        newObj[key] = 0;
      }
      newObj[opts.start_at_key] = start_at;
      newObj[opts.end_at_key] = end_at;
      return newObj;
    };
    addZerosForPeriod = function(start_at, end_at) {
      var diffInMilliseconds, diffInTimeUnits, endAt, i, ref, results, startAt, timeCounter;
      diffInMilliseconds = moment(end_at).valueOf() - moment(start_at).valueOf();
      if (diffInMilliseconds > currentDimension.interval) {
        diffInTimeUnits = diffInMilliseconds / currentDimension.interval;
        results = [];
        for (timeCounter = i = 1, ref = diffInTimeUnits - 1; 1 <= ref ? i <= ref : i >= ref; timeCounter = 1 <= ref ? ++i : --i) {
          startAt = moment(start_at).add(timeCounter, currentDimension.plural).valueOf();
          endAt = moment(startAt).endOf(currentDimension.singular).valueOf();
          results.push(toBeAdded.push(createObj(startAt, endAt)));
        }
        return results;
      }
    };
    for (i = 0, len = array.length; i < len; i++) {
      obj = array[i];
      if (lastDate) {
        addZerosForPeriod(lastDate, obj[opts.start_at_key]);
      }
      lastDate = obj[opts.start_at_key];
    }
    if (opts.start_at) {
      beforeStartAt = moment(opts.start_at).diff(moment(array[0][opts.start_at_key]));
      if (beforeStartAt !== 0) {
        addZerosForPeriod(moment(opts.start_at).subtract(1, currentDimension.plural), moment(array[0][opts.start_at_key]));
      }
    }
    if (opts.end_at) {
      afterEndAt = moment(moment(array[0][opts.end_at_key])).diff(opts.end_at);
      if (afterEndAt !== 0) {
        if (dimension === 'hourly' && moment().startOf('day').isSame(moment(opts.end_at).startOf('day'))) {
          addZerosForPeriod(moment(array[array.length - 1][opts.end_at_key]).startOf(currentDimension.singular), moment(opts.end_at).hour(moment().hour()).startOf(currentDimension.singular));
        } else {
          addZerosForPeriod(moment(array[array.length - 1][opts.end_at_key]).startOf(currentDimension.singular), moment(opts.end_at).add(1, currentDimension.singular).startOf(currentDimension.singular));
        }
      }
    }
    array = _.chain(array).union(toBeAdded).sortBy(function(o) {
      return o[opts.start_at_key];
    }).map(function(o) {
      if (convertTo === 'date') {
        o[opts.start_at_key] = new Date(o[opts.start_at_key]);
        o[opts.end_at_key] = new Date(o[opts.end_at_key]);
      }
      return o;
    }).value();
    return array;
  };
}]);


/***/ }),
/* 1095 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('errorInterceptor', ["$location", "$q", "$injector", "$translate", "returnUrl", function($location, $q, $injector, $translate, returnUrl) {
  var _createBetterErrorsModal, createBetterErrorsModal, error, success, translateErrorKeyName;
  _createBetterErrorsModal = function(res) {
    var Environment;
    Environment = $injector.get('Environment');
    return Environment.get().then(function(environment) {
      var betterErrors;
      if (environment !== 'development') {
        return;
      }
      if ($("#better-errors-modal").length === 0) {
        betterErrors = "<div class=\"modal fade\" id=\"better-errors-modal\" tabindex=\"-1\" role=\"dialog\">\n  <div class=\"modal-dialog\" style=\"width: 80%\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n        <h4 class=\"modal-title\">500 Error</h4>\n      </div>\n      <div class=\"modal-body\">\n        <iframe src=\"\" style=\"width: 100%; height: 60vh\"></iframe>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n      </div>\n    </div><!-- /.modal-content -->\n  </div><!-- /.modal-dialog -->\n</div><!-- /.modal -->";
        $("body").append(betterErrors);
      } else {
        $('#better-errors-modal .modal-body iframe').attr("src", "");
      }
      $('#better-errors-modal').on('shown.bs.modal', function() {
        return $('#better-errors-modal .modal-body iframe').attr("src", ZC_CONFIG.RAILS_API_URL + ":" + ZC_CONFIG.RAILS_API_PORT + "/__better_errors");
      });
      return $('#better-errors-modal').modal();
    });
  };
  createBetterErrorsModal = _.debounce(_createBetterErrorsModal, 500);
  success = function(res) {
    var ref;
    if ((ref = res.data) != null ? ref.message : void 0) {
      alertify.success(res.data.message);
    }
    return res;
  };
  translateErrorKeyName = function(res, keyName) {
    var anchorElement, apiPath, qualifiedKeyName, translatedKeyName;
    translatedKeyName = $translate.instant(keyName);
    if (translatedKeyName !== keyName) {
      return translatedKeyName;
    } else {
      anchorElement = document.createElement('a');
      anchorElement.href = res.config.url;
      apiPath = anchorElement.pathname;
      if (!apiPath) {
        return keyName;
      }
      apiPath = _(apiPath.replace(/\d+/g, '').replace('//', '/').split('/')).compact().join(".");
      qualifiedKeyName = apiPath + "." + keyName;
      return $translate.instant(qualifiedKeyName);
    }
  };
  error = function(res) {
    var $state, Devise, ref, ref1;
    if (res != null ? (ref = res.data) != null ? ref.error_message : void 0 : void 0) {
      alertify.error(res.data.error_message, 0);
    }
    $state = $injector.get('$state');
    switch (res.status) {
      case 401:
        if ($state.current.name.length > 0 && $state.current.name.indexOf('users') !== 0) {
          Devise = $injector.get('Devise');
          Devise.signOut();
        }
        break;
      case 406:
        if ($state.current.name.indexOf('users') !== 0) {
          if ($location.path() !== $state.href('users.signIn', {})) {
            returnUrl.set($location.url());
          }
          $state.transitionTo('users.signIn');
        }
        break;
      case 404:
        $state.go('404', null, {
          location: false
        });
        break;
      case 422:
        _.each(res.data.errors, function(errors, key) {
          return _.each(errors, function(error) {
            return alertify.error("" + (translateErrorKeyName(res, key)) + error, 0);
          });
        });
        break;
      case 500:
        alertify.error("500 Error: " + res.data.error, 0);
        if ((ref1 = res.data) != null ? ref1.show_better_errors : void 0) {
          createBetterErrorsModal(res);
        }
    }
    return $q.reject(res);
  };
  return {
    response: success,
    responseError: error
  };
}]);


/***/ }),
/* 1096 */
/***/ (function(module, exports) {

angular.module('zc.core').factory("notificationInterceptor", ["$q", "$injector", function($q, $injector) {
  var NotificationChannel, error, request, success;
  NotificationChannel = void 0;
  success = function(res) {
    var $http;
    $http = $http || $injector.get("$http");
    if ($http.pendingRequests.length < 1) {
      NotificationChannel = NotificationChannel || $injector.get("NotificationChannel");
      NotificationChannel.requestEnded();
    }
    return res;
  };
  error = function(res) {
    var $http;
    $http = $http || $injector.get("$http");
    if ($http.pendingRequests.length < 1) {
      NotificationChannel = NotificationChannel || $injector.get("NotificationChannel");
      NotificationChannel.requestEnded();
    }
    return $q.reject(res);
  };
  request = function(config) {
    NotificationChannel = NotificationChannel || $injector.get("NotificationChannel");
    NotificationChannel.requestStarted();
    return config;
  };
  return {
    request: request,
    response: success,
    responseError: error
  };
}]);


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('SessionRecoverer', ["$q", "$injector", "$location", "$timeout", "$window", "localStorageService", function($q, $injector, $location, $timeout, $window, localStorageService) {
  var PREFLIGHT_TIMEOUT_MINUTES, _environmentRequestDone, _lastRequestTime, _preflightInProgress, preflightRequest, success, updateRememberUserToken;
  PREFLIGHT_TIMEOUT_MINUTES = 30;
  _lastRequestTime = moment();
  _preflightInProgress = false;
  _environmentRequestDone = false;
  updateRememberUserToken = function() {
    var Devise;
    if (_preflightInProgress) {
      return _preflightInProgress;
    }
    Devise = $injector.get('Devise');
    return _preflightInProgress = Devise.getCurrentUser({
      force: true,
      isPreflight: true
    }).then(function(res) {
      _preflightInProgress = false;
      return res;
    })["catch"](function(err) {
      _preflightInProgress = false;
      return $q.reject(err);
    });
  };
  preflightRequest = function(config) {
    var Environment, preflightTimeoutMinutes;
    Environment = $injector.get('Environment');
    if (!_environmentRequestDone) {
      if (/\/api\/environment/.test(config.url)) {
        return config;
      } else if (/\/templates\/.*\.html$/.test(config.url) || /\/i18n\/locale-ja\.json/.test(config.url)) {
        return config;
      } else {
        return Environment.get().then(function() {
          _environmentRequestDone = true;
          return config;
        });
      }
    }
    if (config.isPreflight && /\/users\/show_current/.test(config.url)) {
      return config;
    }
    preflightTimeoutMinutes = localStorageService.get('_zc_preflight_timeout_minutes') || PREFLIGHT_TIMEOUT_MINUTES;
    if (_lastRequestTime.isAfter(moment().subtract(preflightTimeoutMinutes, 'minutes'))) {
      return config;
    }
    return updateRememberUserToken().then(function(res) {
      return config;
    });
  };
  success = function(response, req) {
    var $httpOnce, Devise, ref;
    Devise = $injector.get('Devise');
    $httpOnce = $injector.get('$httpOnce');
    _lastRequestTime = moment();
    if ((ref = response.data) != null ? ref.login_expired : void 0) {
      return Devise.getCurrentUser({
        force: true
      }).then(function(user) {
        var $state, config;
        config = _.assignIn({}, response.config);
        config.headers["X-LOGIN-TOKEN"] = user.login_token;
        config.cache = false;
        config.repeatCounter || (config.repeatCounter = 0);
        config.repeatCounter++;
        if (config.repeatCounter < 2) {
          return $httpOnce(config);
        } else {
          $state = $injector.get('$state');
          return $window.location = $state.href("users.signIn", {
            absolute: true
          });
        }
      })["catch"](function(err) {
        return $window.location.href = "/users/sign_in";
      });
    } else {
      return response;
    }
  };
  return {
    request: preflightRequest,
    response: success
  };
}]);


/***/ }),
/* 1098 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('BaseModalSelectorCtrl', function() {
  var BaseModalSelectorCtrl;
  return BaseModalSelectorCtrl = (function() {
    function BaseModalSelectorCtrl($scope, $modalInstance, items) {
      $scope.items = items;
      $scope.selected = {
        item: $scope.items[0]
      };
      $scope.ok = function() {
        return $modalInstance.close($scope.selected.item);
      };
      $scope.cancel = function() {
        return $modalInstance.dismiss('cancel');
      };
    }

    return BaseModalSelectorCtrl;

  })();
}).controller('ModalSelectorCtrl', ["$scope", "$modalInstance", "items", "BaseModalSelectorCtrl", function($scope, $modalInstance, items, BaseModalSelectorCtrl) {
  return new BaseModalSelectorCtrl($scope, $modalInstance, items);
}]);


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Api', ["$httpOnce", function($httpOnce) {
  var Api;
  Api = (function() {
    function Api() {}

    Api.basePath = (typeof ZC_CONFIG !== "undefined" && ZC_CONFIG !== null ? ZC_CONFIG.RAILS_API_URL : void 0) && (typeof ZC_CONFIG !== "undefined" && ZC_CONFIG !== null ? ZC_CONFIG.RAILS_API_PORT : void 0) ? ZC_CONFIG.RAILS_API_URL + ":" + ZC_CONFIG.RAILS_API_PORT : "";

    Api.setBasePath = function(path) {
      return this.basePath = path;
    };

    Api.path = function(endpoint) {
      return "" + this.basePath + endpoint;
    };

    Api.post = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'POST';
      return this.request(path, data, opts);
    };

    Api.get = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'GET';
      return this.request(path, data, opts);
    };

    Api.put = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'PUT';
      return this.request(path, data, opts);
    };

    Api.patch = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'PATCH';
      return this.request(path, data, opts);
    };

    Api["delete"] = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'DELETE';
      return this.request(path, data, opts);
    };

    Api.request = function(path, data, opts) {
      var reqParams;
      if (opts == null) {
        opts = {};
      }
      reqParams = _.assignIn({}, {
        url: Api.path(path),
        data: data
      }, opts);
      return $httpOnce(reqParams);
    };

    return Api;

  })();
  return Api;
}]);


/***/ }),
/* 1100 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Environment', ["$q", "Api", function($q, Api) {
  var Environment;
  return Environment = (function() {
    function Environment() {}

    Environment.environment = void 0;

    Environment.get = function() {
      if (this.environment) {
        return $q.when(this.environment);
      }
      return Api.get("/api/environment", {}).then((function(_this) {
        return function(res) {
          if (res.data.success) {
            return _this.environment = res.data.environment;
          } else {
            return $q.reject(res);
          }
        };
      })(this));
    };

    return Environment;

  })();
}]);


/***/ }),
/* 1101 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Facade', ["$filter", "$httpOnce", "Devise", "Project", function($filter, $httpOnce, Devise, Project) {
  var service;
  service = {
    _forPath: function(endpoint) {
      return ZC_CONFIG.FACADE_API_URL + ":" + ZC_CONFIG.FACADE_API_PORT + "/api/v1" + endpoint;
    },
    request: function(path, opts) {
      if (opts == null) {
        opts = {};
      }
      return Devise.getCurrentUser().then(function() {
        var ref, ref1, reqParams;
        reqParams = _.assignIn({}, {
          method: 'GET',
          url: service._forPath(path),
          cache: true,
          withCredentials: false,
          headers: {
            'X-LOGIN-TOKEN': Devise != null ? (ref = Devise.currentUser) != null ? ref.login_token : void 0 : void 0
          }
        }, opts);
        if (reqParams != null ? (ref1 = reqParams.params) != null ? ref1.json : void 0 : void 0) {
          reqParams.params.json = service.transformDatesInRequest(reqParams.params.json);
        }
        return $httpOnce(reqParams);
      });
    },
    transformDatesInRequest: function(obj) {
      var isUnixTimestampIsh, json, key, region, value;
      json = _.assignIn({}, obj);
      for (key in obj) {
        value = obj[key];
        if (!key || !key.endsWith('_at')) {
          continue;
        }
        isUnixTimestampIsh = _.isNumber(value) && new Date(value).toString() !== 'Invalid Date';
        if (_.isDate(value) || isUnixTimestampIsh) {
          region = Project.getRegion();
          region || (region = 'Asia/Tokyo');
          json[key] = $filter('changeDatetimeFrom')('localToRegion', value, 'integer', region);
        }
      }
      return json;
    },
    setLoginToken: function(login_token) {
      return service.login_token = login_token;
    }
  };
  return service;
}]);


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('FacadeV2', ["$filter", "$httpOnce", "$translate", "Devise", "Project", function($filter, $httpOnce, $translate, Devise, Project) {
  var FacadeV2;
  FacadeV2 = (function() {
    var login_token;

    function FacadeV2() {}

    login_token = void 0;

    FacadeV2.requestTransformer = function(data) {
      data.match = FacadeV2.encode({}, data.match);
      data.pipeline = FacadeV2.encode({}, data.pipeline);
      return {
        json: JSON.stringify(data)
      };
    };

    FacadeV2.responseTransformer = function(data) {
      var doc, i, len, ref, res, ret;
      res = angular.fromJson(data);
      if (!res || res.error || res.login_expired) {
        return res;
      } else if (_.isArray(res.data)) {
        try {
          ret = [];
          ref = res.data;
          for (i = 0, len = ref.length; i < len; i++) {
            doc = ref[i];
            ret.push(FacadeV2.decode({}, doc));
          }
          return ret;
        } catch (error) {
          alertify.error($translate.instant('sharedModules.core.services.facade_v2_service.badResponse'));
          return [];
        }
      } else {
        try {
          if (res.data) {
            return FacadeV2.decode({}, res.data);
          } else {
            return res.data;
          }
        } catch (error) {
          alertify.error($translate.instant('sharedModules.core.services.facade_v2_service.badResponse'));
          return {};
        }
      }
    };

    FacadeV2.setLoginToken = function(login_token) {
      return this.login_token = login_token;
    };

    FacadeV2._forPath = function(endpoint) {
      return ZC_CONFIG.FACADE_API_URL + ":" + ZC_CONFIG.FACADE_API_PORT + "/api/v2" + endpoint;
    };

    FacadeV2.request = function(path, opts) {
      if (opts == null) {
        opts = {};
      }
      return Devise.getCurrentUser().then(function() {
        var ref, reqParams;
        reqParams = _.assignIn({}, {
          method: 'GET',
          url: FacadeV2._forPath(path),
          transformResponse: FacadeV2.responseTransformer,
          cache: true,
          withCredentials: false,
          headers: {
            'X-LOGIN-TOKEN': Devise != null ? (ref = Devise.currentUser) != null ? ref.login_token : void 0 : void 0
          }
        }, opts);
        if (reqParams.params) {
          reqParams.params = FacadeV2.requestTransformer(reqParams.params);
        }
        return $httpOnce(reqParams);
      });
    };

    FacadeV2.decode = function(obj, json) {
      var f, region, v;
      for (f in json) {
        v = json[f];
        if (_.isNull(v)) {
          obj[f] = v;
        } else if (v['.T'] === 'D') {
          region = Project.getRegion();
          region || (region = 'Asia/Tokyo');
          obj[f] = $filter('changeDatetimeFrom')('regionToLocal', v['.V'], 'date', region);
        } else if (_.isString(v)) {
          obj[f] = v;
        } else if (_.isNumber(v)) {
          obj[f] = v;
        } else if (_.isBoolean(v)) {
          obj[f] = v;
        } else if (_.isArray(v)) {
          obj[f] = [];
          this.decode(obj[f], v);
        } else {
          obj[f] = {};
          this.decode(obj[f], v);
        }
      }
      return obj;
    };

    FacadeV2.dateObject = function(date) {
      var dateObject;
      dateObject = {};
      if (Project.getRegion()) {
        dateObject['.V'] = $filter('changeDatetimeFrom')('localToRegion', date, 'integer');
      } else {
        dateObject['.V'] = date.valueOf();
      }
      dateObject['.T'] = 'D';
      return dateObject;
    };

    FacadeV2.encode = function(json, obj) {
      var f, v;
      for (f in obj) {
        v = obj[f];
        if (_.isNull(v) || _.isUndefined(v)) {
          json[f] = null;
        } else if (_.isDate(v)) {
          json[f] = FacadeV2.dateObject(v);
        } else if (_.isString(v)) {
          json[f] = v;
        } else if (_.isNumber(v)) {
          json[f] = v;
        } else if (_.isBoolean(v)) {
          json[f] = v;
        } else if (_.isArray(v)) {
          json[f] = [];
          FacadeV2.encode(json[f], v);
        } else {
          json[f] = {};
          FacadeV2.encode(json[f], v);
        }
      }
      return json;
    };

    return FacadeV2;

  })();
  return FacadeV2;
}]);


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('InterestWidget', ["$q", "$translate", "Api", "Campaign", function($q, $translate, Api, Campaign) {
  var InterestWidget;
  return InterestWidget = (function() {
    var AB_DELIVERY, COMPLETE_DELIVERY, DUMMY_ID;

    function InterestWidget() {}

    DUMMY_ID = -1;

    AB_DELIVERY = {
      id: 'ab_delivery',
      name: $translate.instant('sharedModules.core.services.interestWidget.abDelivery')
    };

    COMPLETE_DELIVERY = {
      id: 'complete_delivery',
      name: $translate.instant('sharedModules.core.services.interestWidget.completeDelivery')
    };

    InterestWidget.all = function(apikey) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.get("/api/projects/apikey:" + apikey + "/interest_widgets", {}, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widgets;
      });
    };

    InterestWidget.get = function(apikey, id) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.get("/api/projects/apikey:" + apikey + "/interest_widgets/" + id, {}, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.create = function(apikey, interest_widget) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.post("/api/projects/apikey:" + apikey + "/interest_widgets/", {
        interest_widget: interest_widget
      }, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.update = function(apikey, id, interest_widget) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.patch("/api/projects/apikey:" + apikey + "/interest_widgets/" + id, {
        interest_widget: interest_widget
      }, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.remove = function(apikey, id, interest_widget) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api["delete"]("/api/projects/apikey:" + apikey + "/interest_widgets/" + id, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.updateCampaignWithInterestWidget = function(campaign) {
      return Campaign.isWidget(campaign).then(function(isWidget) {
        var ref, ref1;
        campaign.is_coupon_campaign = !isWidget;
        if (campaign.is_coupon_campaign) {
          campaign.available_delivery_type_options = [AB_DELIVERY];
        } else {
          campaign.available_delivery_type_options = [AB_DELIVERY, COMPLETE_DELIVERY];
          campaign.days_since_last_received = 0;
        }
        if (((ref = campaign.delivery_type_option) != null ? ref.id : void 0) === 'complete_delivery') {
          if (!campaign.interest_widget_id) {
            campaign.interest_widget_id = DUMMY_ID;
          }
        } else if (((ref1 = campaign.delivery_type_option) != null ? ref1.id : void 0) === 'ab_delivery') {
          if (campaign.interest_widget_id) {
            campaign.interest_widget_id = 0;
          }
        }
        if (campaign.interest_widget_id && !campaign.is_coupon_campaign) {
          return campaign.delivery_type_option = COMPLETE_DELIVERY;
        } else {
          campaign.delivery_type_option = AB_DELIVERY;
          return campaign.interest_widget_id = 0;
        }
      });
    };

    return InterestWidget;

  })();
}]);


/***/ }),
/* 1104 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('lib', ["$filter", "$location", "Project", function($filter, $location, Project) {
  return {
    getField: function(data, field) {
      var get;
      if (!field) {
        return data;
      }
      get = function(d, f) {
        var c, k;
        k = f.shift();
        c = d[k];
        if (!f.length) {
          return c;
        }
        return get(c, f);
      };
      return get(data, field.split('\.'));
    },
    stringToArray: function(string, separator) {
      var error;
      if (separator == null) {
        separator = ',';
      }
      if (_.isArray(string)) {
        return string;
      }
      if (_.isString(string) && string.length === 0) {
        return [];
      }
      try {
        return string.split(separator);
      } catch (error1) {
        error = error1;
        return [];
      }
    },
    setHighChartOptions: function() {
      return Highcharts.setOptions({
        global: {
          useUTC: true,
          getTimezoneOffset: function(timestamp) {
            var isMidnight, localDate, localUtcOffset, regionDate, regionUtcOffset;
            if (!timestamp) {
              return 0;
            }
            localDate = $filter('changeDatetimeFrom')('regionToLocal', timestamp, 'moment');
            regionDate = moment.tz(localDate.format(), Project.getRegion());
            localUtcOffset = -localDate.utcOffset();
            regionUtcOffset = regionDate.utcOffset();
            isMidnight = moment(timestamp).format('HH:mm') === '00:00';
            if (regionDate.isDST() && regionUtcOffset === 60 && !isMidnight) {
              localUtcOffset -= regionUtcOffset;
            }
            return localUtcOffset;
          }
        },
        lang: {
          months: moment.monthsShort()
        }
      });
    },
    copyName: function(oldName) {
      var match, newName, number;
      newName = "";
      match = oldName.match(/\s\((\d+)\)$/);
      if (match) {
        number = parseInt(match[1]);
        newName = oldName.replace(match[0], " (" + (number + 1) + ")");
      } else {
        newName = oldName + " (2)";
      }
      return newName;
    },
    truncateFraction: function(number) {
      if (number > 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    },
    removeFromLocationSearch: function(itemName) {
      var oldSearch;
      oldSearch = $location.search();
      delete oldSearch[itemName];
      return $location.search(oldSearch);
    },
    iterateCountMaps: function(countMaps, baseMap, accumulatedCountMaps) {
      var countMap, j, key, keyMap, len, val;
      keyMap = {};
      for (j = 0, len = countMaps.length; j < len; j++) {
        countMap = countMaps[j];
        for (key in countMap) {
          val = countMap[key];
          if (_.isNumber(val)) {
            baseMap[key] || (baseMap[key] = 0);
            baseMap[key] += val;
          } else if (_.isDate(val) || _.isString(val) || _.isBoolean(val)) {
            baseMap[key] = val;
          } else if (_.isArray(val)) {
            throw 'Array is not supported!';
          } else if (_.isObject(val)) {
            baseMap[key] || (baseMap[key] = {});
            keyMap[key] = true;
          }
        }
        if (accumulatedCountMaps) {
          accumulatedCountMaps.push(_.cloneDeep(baseMap));
        }
      }
      return keyMap;
    },
    sumCountMap: function(countMaps, baseMap) {
      var j, key, keyMap, len, ref, vals;
      if (baseMap == null) {
        baseMap = {};
      }
      keyMap = this.iterateCountMaps(countMaps, baseMap);
      ref = Object.keys(keyMap);
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        vals = _.map(countMaps, key);
        this.sumCountMap(vals, baseMap[key]);
      }
      return baseMap;
    },
    accumulateCountMap: function(countMaps, baseMap) {
      var accumulatedCountMaps, j, key, keyMap, len, ref, vals;
      if (baseMap == null) {
        baseMap = {};
      }
      accumulatedCountMaps = [];
      keyMap = this.iterateCountMaps(countMaps, baseMap, accumulatedCountMaps);
      ref = Object.keys(keyMap);
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        vals = _.map(countMaps, key);
        vals = this.accumulateCountMap(vals, baseMap[key]);
        accumulatedCountMaps.forEach(function(map, i) {
          return map[key] = vals[i];
        });
      }
      return accumulatedCountMaps;
    },
    sumOriginalConversions: function(stats) {
      var flattenedConversions;
      flattenedConversions = _.flatten(stats.original_conversions);
      return _.reduce(flattenedConversions, function(sumHourlyOriginalConversions, conversion) {
        var conversionPriceDecimal, originalConversion;
        conversionPriceDecimal = new Decimal(conversion.price_decimal.$numberDecimal.toString());
        originalConversion = _.find(sumHourlyOriginalConversions, {
          currency: conversion.currency
        });
        if (originalConversion) {
          originalConversion.price += conversion.price;
          originalConversion.price_decimal = originalConversion.price_decimal.plus(conversionPriceDecimal);
        } else {
          sumHourlyOriginalConversions.push({
            price: conversion.price,
            price_decimal: conversionPriceDecimal,
            currency: conversion.currency
          });
        }
        return sumHourlyOriginalConversions;
      }, []);
    }
  };
}]);


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('NotificationChannel', ["$rootScope", function($rootScope) {
  var service;
  service = {
    requestStarted: function() {
      return $rootScope.$broadcast('$stateChangeStart');
    },
    requestEnded: function() {
      return $rootScope.$broadcast('$stateChangeSuccess');
    },
    onRequestStarted: function($scope, handler) {
      return $scope.$on('$stateChangeStart', function(event) {
        return handler();
      });
    },
    onRequestEnded: function($scope, handler) {
      return $scope.$on('$stateChangeSuccess', function(event) {
        return handler();
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('PageLayout', function() {
  return {
    showFooter: false
  };
});


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Page', ["Environment", function(Environment) {
  var bodyClass, env, page, title;
  title = 'AiDeal';
  bodyClass = '';
  env = '';
  Environment.get().then(function(res) {
    return env = res;
  });
  page = {
    title: function() {
      if (env === 'production') {
        return title;
      } else {
        return "[" + env + "] " + title;
      }
    },
    setTitle: function(newTitle) {
      if (newTitle) {
        return title = newTitle + " - AiDeal";
      } else {
        return title = 'AiDeal';
      }
    },
    bodyClass: function() {
      return bodyClass;
    },
    setBodyClass: function(newBodyClass) {
      return bodyClass = newBodyClass;
    }
  };
  return page;
}]);


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('returnUrl', function() {
  var ReturnUrl;
  return ReturnUrl = (function() {
    function ReturnUrl() {}

    ReturnUrl._url = null;

    ReturnUrl.set = function(url) {
      return this._url = url;
    };

    ReturnUrl.get = function() {
      return this._url;
    };

    return ReturnUrl;

  })();
});


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('SearchFilter', ["$rootScope", "$location", "Meta", "lib", function($rootScope, $location, Meta, lib) {
  var SearchFilter;
  SearchFilter = (function() {
    function SearchFilter() {}

    SearchFilter._normalDefaults = {
      search_term: '',
      start_at: moment().startOf('month').valueOf(),
      end_at: moment().endOf('day').valueOf()
    };

    SearchFilter.pageDefaults = {};

    SearchFilter.componentDefaults = {};

    SearchFilter._filters = {
      search_term: '',
      start_at: moment().startOf('month').valueOf(),
      end_at: moment().endOf('day').valueOf()
    };

    SearchFilter.get = function() {
      return SearchFilter._filters;
    };

    SearchFilter.getDateFilterValue = function(propertyName, pageDefaults) {
      var momentDate, search;
      if (!_.includes(['start_at', 'end_at'], propertyName)) {
        throw new Error('Invalid property name given!');
      }
      search = $location.search();
      if (search[propertyName]) {
        momentDate = moment(search[propertyName]);
        if (propertyName === 'start_at') {
          return momentDate.startOf('day').valueOf();
        }
        return momentDate.endOf('day').valueOf();
      }
      return _.get(pageDefaults, propertyName, SearchFilter._filters[propertyName]);
    };

    SearchFilter.getDefaultReportFilters = function(reportId) {
      var reportDate;
      reportDate = moment(parseInt(reportId));
      return {
        start_at: reportDate.startOf('month').valueOf(),
        end_at: reportDate.endOf('month').valueOf(),
        device: null,
        device_value: null,
        campaign_segment: null,
        campaign_segment_value: null
      };
    };

    SearchFilter.set = function(searchFilters) {
      searchFilters.start_at || (searchFilters.start_at = SearchFilter._normalDefaults.start_at);
      searchFilters.start_at = moment(searchFilters.start_at).startOf('day').valueOf();
      searchFilters.end_at || (searchFilters.end_at = SearchFilter._normalDefaults.end_at);
      searchFilters.end_at = moment(searchFilters.end_at).endOf('day').valueOf();
      SearchFilter._filters = searchFilters;
      return SearchFilter.updateLocationSearch();
    };

    SearchFilter.reset = function(baseObject) {
      return SearchFilter._filters = _.merge(baseObject, SearchFilter.pageDefaults);
    };

    SearchFilter.setComponentDefaults = function(componentName, params) {
      if (SearchFilter.componentDefaults[componentName]) {
        return;
      }
      SearchFilter.componentDefaults[componentName] = {};
      return _.each(params, function(v, k) {
        if (SearchFilter.componentDefaults[componentName][k]) {
          console.warn("Trying to register SearchFilter value twice for " + k + " in " + componentName);
          return;
        }
        SearchFilter.componentDefaults[componentName][k] = v;
        if (v.getter != null) {
          SearchFilter._filters[k] = $location.search()[k] || v["default"];
          SearchFilter._filters[k + '_value'] = v.getter($location.search()[k]) || v.getter(v["default"]);
        } else {
          SearchFilter._filters[k] = $location.search()[k] || v["default"];
        }
      });
    };

    SearchFilter.removeComponentDefaults = function(componentName) {
      _.each(SearchFilter.componentDefaults[componentName], function(v, k) {
        return delete SearchFilter.componentDefaults[componentName][k];
      });
      return delete SearchFilter.componentDefaults[componentName];
    };

    SearchFilter.resetComponentDefaults = function(componentName) {
      return _.each(SearchFilter.componentDefaults[componentName], function(v, k) {
        SearchFilter._filters[k] = v["default"];
        if (v.getter != null) {
          SearchFilter._filters[k + '_value'] = v.getter(v["default"]);
        }
        return lib.removeFromLocationSearch(k);
      });
    };

    SearchFilter.updateComponentDefaults = function(componentName) {
      return _.each(SearchFilter.componentDefaults[componentName], function(v, k) {
        if ((v.getter != null) && SearchFilter._filters[k + '_value']) {
          SearchFilter._filters[k] = SearchFilter._filters[k + '_value'][v.keyProperty];
        }
        if (SearchFilter._filters[k] === v["default"]) {
          return lib.removeFromLocationSearch(k);
        } else {
          return $location.search(k, SearchFilter._filters[k]);
        }
      });
    };

    SearchFilter.updateLocationSearch = function() {
      if (moment(SearchFilter._filters.start_at).isSame(SearchFilter.pageDefaults.start_at)) {
        lib.removeFromLocationSearch('start_at');
      } else {
        $location.search('start_at', moment(SearchFilter._filters.start_at).format('YYYY-MM-DD'));
      }
      if (moment(SearchFilter._filters.end_at).endOf('day').isSame(SearchFilter.pageDefaults.end_at)) {
        lib.removeFromLocationSearch('end_at');
      } else {
        $location.search('end_at', moment(SearchFilter._filters.end_at).startOf('day').format('YYYY-MM-DD'));
      }
      if (SearchFilter._filters.search_term === SearchFilter.pageDefaults.search_term) {
        return lib.removeFromLocationSearch('search_term');
      } else {
        return $location.search('search_term', SearchFilter._filters.search_term);
      }
    };

    SearchFilter.resolveFromLocation = function(pageDefaults) {
      var search;
      if (pageDefaults == null) {
        pageDefaults = {};
      }
      SearchFilter.pageDefaults = _.merge({}, SearchFilter._normalDefaults, pageDefaults);
      search = $location.search();
      return SearchFilter._filters = _.merge(SearchFilter._filters, SearchFilter.pageDefaults, {
        search_term: search.search_term ? search.search_term : void 0,
        start_at: moment(SearchFilter.getDateFilterValue('start_at', pageDefaults)).valueOf(),
        end_at: moment(SearchFilter.getDateFilterValue('end_at', pageDefaults)).valueOf()
      });
    };

    return SearchFilter;

  })();
  return SearchFilter;
}]);


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDataProcessingAddendum', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/data_processing_addendum.html'
  };
});


/***/ }),
/* 1111 */
/***/ (function(module, exports) {

angular.module('zc.core').controller('PrivacyPolicyCtrl', ["$rootScope", "$scope", "$translate", "Page", function($rootScope, $scope, $translate, Page) {
  var deregistrationCallback;
  Page.setBodyClass('');
  $translate('usersPages.views.privacyPolicy.title').then(function(translation) {
    return Page.setTitle(translation);
  });
  deregistrationCallback = $rootScope.$on('languageSelected', function(_, language) {
    if (language.id) {
      return $scope.currentLang = language.id;
    } else {
      return $scope.currentLang = language;
    }
  });
  $rootScope.$on('$destroy', deregistrationCallback);
  return $rootScope.$emit('selectDefaultLanguage');
}]);


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcTermsOfServiceAppierInc', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/terms_of_service_appier_inc.html'
  };
});


/***/ }),
/* 1113 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcTermsOfServiceAppierJp', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/terms_of_service_appier_jp.html'
  };
});


/***/ }),
/* 1114 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcTermsOfServiceAppierOthers', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/terms_of_service_appier_others.html'
  };
});


/***/ }),
/* 1115 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('mainChart', ["$filter", "$location", "$translate", "AccessStats", "Chart", "SearchFilter", "currencies", "lib", "mainChartItems", function($filter, $location, $translate, AccessStats, Chart, SearchFilter, currencies, lib, mainChartItems) {
  return {
    restrict: 'E',
    require: '?filters',
    templateUrl: '/templates/projects.analytics/views/directives/main_chart.html',
    scope: {
      filters: '=',
      project: '='
    },
    link: function(scope, element, attrs) {
      var DEFAULT_DIMENSION, DEFAULT_ITEM, addSeries, addYAxis, refreshOptions, statsForChart, tooltip;
      scope.currency = currencies[scope.project.currency];
      scope.chartConfig = Chart.getChartConfig('main');
      scope.mainChartItems = mainChartItems;
      DEFAULT_ITEM = 0;
      DEFAULT_DIMENSION = 'hourly';
      SearchFilter.setComponentDefaults('mainChart', {
        chart_item1: {
          "default": scope.mainChartItems[DEFAULT_ITEM].name,
          keyProperty: 'name',
          getter: function(name) {
            return _.find(scope.mainChartItems, function(d) {
              return d.name === name;
            });
          }
        },
        chart_item2: {
          "default": void 0,
          keyProperty: 'name',
          getter: function(name) {
            return _.find(scope.mainChartItems, function(d) {
              return d.name === name;
            });
          }
        },
        chart_dimension: {
          "default": DEFAULT_DIMENSION
        }
      });
      scope.$on('$destroy', function() {
        return SearchFilter.removeComponentDefaults('mainChart');
      });
      scope.setDimension = function(dimension) {
        scope.filters.chart_dimension = dimension;
        return scope.update();
      };
      addSeries = function(type, item, i, data) {
        return Chart.addSeries(scope.chartConfig, {
          type: type,
          name: item.label,
          data: data,
          tooltip: tooltip(item),
          yAxis: i
        });
      };
      addYAxis = function(item, i) {
        var _tooltip;
        _tooltip = tooltip(item);
        return scope.chartConfig.options.yAxis.push({
          gridLineDashStyle: 'dot',
          min: 0,
          labels: {
            formatter: function() {
              return _tooltip.valuePrefix + Highcharts.numberFormat(this.value, _tooltip.valueDecimals) + _tooltip.valueSuffix;
            }
          },
          title: {
            text: item.label
          },
          opposite: i === 1 ? true : void 0
        });
      };
      tooltip = function(item) {
        var ref;
        if ((ref = item.name) === 'average_conversion_price' || ref === 'conversion_price') {
          return {
            valuePrefix: scope.currency.symbol,
            valueSuffix: scope.currency.suffix,
            valueDecimals: scope.currency.fractionSize
          };
        } else {
          return item.tooltip;
        }
      };
      statsForChart = function(access_stats) {
        var j, len, stats;
        for (j = 0, len = access_stats.length; j < len; j++) {
          stats = access_stats[j];
          stats.conversion_rate = stats.conversion_rate * 100;
          stats.cart_button_click_rate = stats.cart_button_click_rate * 100;
          stats.average_dwell = stats.average_dwell / (1000 * 60);
          stats.average_conversion_price = stats.average_conversion_price / (Math.pow(10, scope.currency.fractionSize));
          stats.conversion_price = stats.conversion_price / (Math.pow(10, scope.currency.fractionSize));
        }
        access_stats = $filter('zerosForMissingTime')(access_stats, scope.filters.chart_dimension, {
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        });
        return access_stats;
      };

      /*
      NOTE: Need to make change to options for highcharts-ng to understand it
      Because of the stupid behavior of highcharts-ng,
      you need to make change to options even when series and axes change.
      see https://zenclerk.qiita.com/yujiosaka/items/d8a80106d5914eea6164
       */
      refreshOptions = function() {
        return scope.chartConfig.options.rand = Math.random();
      };
      scope.reset = function() {
        return SearchFilter.resetComponentDefaults('mainChart');
      };
      scope._update = function() {
        var paths, ref;
        SearchFilter.updateComponentDefaults('mainChart');
        paths = {
          apikey: scope.project.apikey,
          dimension: scope.filters.chart_dimension
        };
        if ((ref = scope.filters.chart_dimension) === 'hourly' || ref === 'daily') {
          return AccessStats.findByFilter(paths, scope.filters).then(function(access_stats) {
            var data, i, item, j, len, ref1, results, stats;
            access_stats = statsForChart(access_stats);
            scope.chartConfig.series = [];
            scope.chartConfig.options.yAxis = [];
            scope.chartConfig.options.xAxis = {
              type: 'datetime',
              tickInterval: scope.filters.chart_dimension === "daily" ? 24 * 3600 * 1000 : void 0,
              dateTimeLabelFormats: {
                hour: $translate.instant('sharedModules.dateTimeFormats.chart.hour'),
                day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay')
              }
            };
            ref1 = [scope.filters.chart_item1_value, scope.filters.chart_item2_value];
            results = [];
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              item = ref1[i];
              if (!item) {
                continue;
              }
              data = (function() {
                var k, len1, results1;
                results1 = [];
                for (k = 0, len1 = access_stats.length; k < len1; k++) {
                  stats = access_stats[k];
                  results1.push([stats.start_at.valueOf(), stats[item.name]]);
                }
                return results1;
              })();
              addSeries('line', item, i, data);
              addYAxis(item, i);
              results.push(refreshOptions());
            }
            return results;
          });
        } else {
          return AccessStats.aggregateByFilter(paths, scope.filters).then(function(access_stats) {
            var categories, data, i, item, j, len, ref1, results, stats;
            access_stats = statsForChart(access_stats);
            categories = (function() {
              var j, len, results;
              results = [];
              for (j = 0, len = access_stats.length; j < len; j++) {
                stats = access_stats[j];
                results.push($filter(_.camelCase(scope.filters.chart_dimension))(stats[scope.filters.chart_dimension]));
              }
              return results;
            })();
            scope.chartConfig.series = [];
            scope.chartConfig.options.yAxis = [];
            scope.chartConfig.options.xAxis = {
              categories: categories
            };
            ref1 = [scope.filters.chart_item1_value, scope.filters.chart_item2_value];
            results = [];
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              item = ref1[i];
              if (!item) {
                continue;
              }
              data = (function() {
                var k, len1, results1;
                results1 = [];
                for (k = 0, len1 = access_stats.length; k < len1; k++) {
                  stats = access_stats[k];
                  results1.push(stats[item.name]);
                }
                return results1;
              })();
              addSeries('column', item, i, data);
              addYAxis(item, i);
              results.push(refreshOptions());
            }
            return results;
          });
        }
      };
      scope.update = _.debounce(scope._update, 500);
      scope.update();
      scope.$on('filtersUpdated', scope.update);
      return scope.$on('filtersReset', scope.reset);
    }
  };
}]);


/***/ }),
/* 1116 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('pieChart', ["$translate", "AccessStats", "Chart", function($translate, AccessStats, Chart) {
  return {
    restrict: 'E',
    require: '?filters',
    templateUrl: '/templates/projects.analytics/views/directives/pie_chart.html',
    scope: {
      filters: '=',
      project: '='
    },
    link: function(scope, element, attrs) {
      var setSeries, update;
      scope.deviceConfig = Chart.getChartConfig('pie', {
        title: {
          text: $translate.instant('projectsAnalytics.directives.pieChart.device')
        }
      });
      scope.newSessionConfig = Chart.getChartConfig('pie', {
        title: {
          text: $translate.instant('projectsAnalytics.directives.pieChart.newExisting')
        }
      });
      setSeries = function(chartConfig, data) {

        /*
        NOTE: Need to make change to options for highcharts-ng to understand it
        Because of the stupid behavior of highcharts-ng,
        you need to make change to options even when series and axes change.
        see https://zenclerk.qiita.com/yujiosaka/items/d8a80106d5914eea6164
         */
        chartConfig.options.rand = Math.random();
        return chartConfig.series = [
          {
            type: 'pie',
            innerSize: '50%',
            data: data
          }
        ];
      };
      update = function() {
        return AccessStats.aggregateByFilter({
          apikey: scope.project.apikey,
          dimension: 'daily'
        }, scope.filters).then(function(access_stats) {
          setSeries(scope.deviceConfig, [[$translate.instant('projectsAnalytics.directives.pieChart.pc'), 1 - access_stats[0].mobile_session_rate], [$translate.instant('projectsAnalytics.directives.pieChart.sp'), access_stats[0].mobile_session_rate]]);
          return setSeries(scope.newSessionConfig, [[$translate.instant('projectsAnalytics.directives.pieChart.newVisit'), 1 - access_stats[0].repeat_session_rate], [$translate.instant('projectsAnalytics.directives.pieChart.repeatVisit'), access_stats[0].repeat_session_rate]]);
        });
      };
      update();
      return scope.$on('filtersUpdated', update);
    }
  };
}]);


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('totalStats', ["AccessStats", "Devise", "currencies", function(AccessStats, Devise, currencies) {
  return {
    restrict: 'E',
    require: '?filters',
    templateUrl: '/templates/projects.analytics/views/directives/total_stats.html',
    scope: {
      filters: '=',
      project: '='
    },
    link: function(scope, element, attrs) {
      var update;
      scope.Devise = Devise;
      update = function() {
        scope.currency = currencies[scope.project.currency];
        return AccessStats.aggregateByFilter({
          apikey: scope.project.apikey,
          dimension: 'daily'
        }, scope.filters).then(function(access_stats) {
          return scope.stats = access_stats[0];
        });
      };
      update();
      return scope.$on('filtersUpdated', update);
    }
  };
}]);


/***/ }),
/* 1118 */
/***/ (function(module, exports) {

angular.module('zc.projects').service('mainChartItems', ["$filter", function($filter) {
  return [
    {
      name: 'session_count',
      label: $filter('translate')('projectsAnalytics.mainChartItems.sessionCount'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.visit'),
        valueDecimals: 0
      }
    }, {
      name: 'conversion_count',
      label: $filter('translate')('projectsAnalytics.mainChartItems.conversionCount'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.visit'),
        valueDecimals: 0
      }
    }, {
      name: 'conversion_rate',
      label: $filter('translate')('projectsAnalytics.mainChartItems.conversionRate'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' %',
        valueDecimals: 2
      }
    }, {
      name: 'conversion_price',
      label: $filter('translate')('projectsAnalytics.mainChartItems.conversionPrice'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' 円',
        valueDecimals: 0
      }
    }, {
      name: 'cart_button_click_rate',
      label: $filter('translate')('projectsAnalytics.mainChartItems.cartButtonClickRate'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' %',
        valueDecimals: 2
      }
    }, {
      name: 'average_conversion_price',
      label: $filter('translate')('projectsAnalytics.mainChartItems.averageConversionPrice'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' 円',
        valueDecimals: 0
      }
    }, {
      name: 'average_dwell',
      label: $filter('translate')('projectsAnalytics.mainChartItems.averageDwell'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.minute'),
        valueDecimals: 2
      }
    }, {
      name: 'average_history_count',
      label: $filter('translate')('projectsAnalytics.mainChartItems.averageHistoryCount'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.pageView'),
        valueDecimals: 2
      }
    }, {
      name: 'history_count',
      label: $filter('translate')('projectsAnalytics.mainChartItems.historyCount'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.pageView'),
        valueDecimals: 0
      }
    }, {
      name: 'average_interest_count',
      label: $filter('translate')('projectsAnalytics.mainChartItems.averageInterestCount'),
      tooltip: {
        valuePrefix: '',
        valueSuffix: ' ' + $filter('translate')('projectsAnalytics.mainChartItems.pageView'),
        valueDecimals: 2
      }
    }
  ];
}]);


/***/ }),
/* 1119 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('AnalyticsProjectCtrl', ["$scope", "$translate", "currentProject", "Page", "SearchFilter", function($scope, $translate, currentProject, Page, SearchFilter) {
  Page.setBodyClass('');
  $translate('projectsAnalytics.showController.siteData').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.filters = SearchFilter.resolveFromLocation();
  $scope.currentProject = currentProject;
  $scope.updateFilters = function() {
    var campaign_segment_id, device, ref;
    device = (function() {
      var ref;
      switch ((ref = $scope.filters.device_value) != null ? ref.name : void 0) {
        case 'pc':
          return {
            $in: ['pc', 'tablet']
          };
        case 'sp':
        case 'iphone':
          return 'sp';
        case 'app':
          return 'app';
        default:
          return '';
      }
    })();
    campaign_segment_id = (ref = $scope.filters.campaign_segment_value) != null ? ref.id : void 0;
    $scope.updatedFilters = _.merge($scope.filters, {
      device: device,
      campaign_segment_id: campaign_segment_id,
      is_control: '',
      start_at: moment($scope.filters.start_at).startOf('day').valueOf(),
      end_at: moment($scope.filters.end_at).endOf('day').valueOf()
    });
    SearchFilter.set($scope.filters);
    return $scope.$broadcast('filtersUpdated');
  };
  $scope.resetFilters = function() {
    return $scope.$broadcast('filtersReset');
  };
  return $scope.updateFilters();
}]);


/***/ }),
/* 1120 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('AddCouponsCtrl', ["$scope", "$filter", "$state", "$translate", "$modal", "Page", "Campaign", "Devise", "currentProject", "campaigns", function($scope, $filter, $state, $translate, $modal, Page, Campaign, Devise, currentProject, campaigns) {
  var filterActiveCampaigns;
  Page.setBodyClass('');
  $translate('projectsCampaigns.addCouponsController.campaignList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.Devise = Devise;
  $scope.currentProject = currentProject;
  filterActiveCampaigns = function(campaigns) {
    return $scope.activeCampaigns = _.chain(campaigns).filter(function(campaign) {
      var ref;
      return (ref = campaign.current_status) === 'active' || ref === 'blocked';
    }).filter(function(campaign) {
      return campaign.incentives.length > 0;
    }).value();
  };
  filterActiveCampaigns(campaigns);
  $scope.openModal = function(campaign) {
    var modalInstance;
    return modalInstance = $modal.open({
      templateUrl: '/templates/projects.campaigns/add_coupons_modal.html',
      controller: 'AddCouponsModalCtrl',
      resolve: {
        campaign: function() {
          return campaign;
        },
        parentController: function() {
          return $scope;
        }
      }
    });
  };
  $scope.refreshCampaign = function() {
    return Campaign.all({
      projectId: currentProject.id
    }).then(function(campaigns) {
      return filterActiveCampaigns(campaigns);
    });
  };
  return $scope.removeIncentive = function(campaign, id) {
    campaign.incentive_ids = _.without(campaign.incentive_ids, id);
    return Campaign.update({
      projectId: campaign.project_id,
      campaignId: campaign.id
    }, campaign).then(function(res) {
      return $scope.refreshCampaign();
    });
  };
}]);


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('AddCouponsModalCtrl', ["$scope", "$state", "$modalInstance", "Campaign", "campaign", "parentController", function($scope, $state, $modalInstance, Campaign, campaign, parentController) {
  $scope.campaign = campaign;
  $scope.incentive = {};
  return $scope.createIncentive = function() {
    return Campaign.addCouponCode({
      project_id: campaign.project_id,
      campaign_id: campaign.id,
      incentive: $scope.incentive
    }).then(function() {
      parentController.refreshCampaign();
      return $modalInstance.close();
    });
  };
}]);


/***/ }),
/* 1122 */
/***/ (function(module, exports) {

angular.module('zc.projects').service('campaignStatusTexts', ["$filter", function($filter) {
  return {
    incomplete: $filter('translate')('projectsCampaigns.campaignCheckStatus.incomplete'),
    preview: $filter('translate')('projectsCampaigns.campaignCheckStatus.preview'),
    active: $filter('translate')('projectsCampaigns.campaignCheckStatus.active'),
    finished: $filter('translate')('projectsCampaigns.campaignCheckStatus.finished'),
    terminated: $filter('translate')('projectsCampaigns.campaignCheckStatus.terminated'),
    pending: $filter('translate')('projectsCampaigns.campaignCheckStatus.pending'),
    blocked: $filter('translate')('projectsCampaigns.campaignCheckStatus.blocked')
  };
}]);


/***/ }),
/* 1123 */
/***/ (function(module, exports) {

angular.module('zc.projects').component('campaignCheckStatus', {
  bindings: {
    campaign: '<'
  },
  template: "<i\n  tooltip=\"{{ 'projectsCampaigns.components.campaignCheckStatus.confirmDelivery' | translate }}\"\n  ng-if=\"$ctrl.campaign.is_fired && $ctrl.campaign.current_status === \'active\'\"\n  class=\"fa fa-check-circle\"\n  zc-master-only>\n</i>"
});


/***/ }),
/* 1124 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('ConfirmCampaignCtrl', ["$scope", "$translate", "Page", "Campaign", "campaign", "currentProject", "templates", function($scope, $translate, Page, Campaign, campaign, currentProject, templates) {
  var template;
  Page.setBodyClass('');
  $translate('projectsCampaigns.confirmController.campaignSetting').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.campaign = campaign;
  if ($scope.campaign.template_type) {
    template = _.find(templates, {
      name: $scope.campaign.template_type
    });
    if (template) {
      $scope.campaign.template = template;
    }
  }
  return $scope.previewUrl = Campaign.previewUrl(currentProject.base_url, campaign);
}]);


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

angular.module('zc.projects').factory('BaseCampaignInterestWidgetGraph', ["CampaignStats", "CampaignEventStats", "AccessStats", "Chart", function(CampaignStats, CampaignEventStats, AccessStats, Chart) {
  var BaseCampaignInterestWidgetGraph;
  return BaseCampaignInterestWidgetGraph = (function() {
    BaseCampaignInterestWidgetGraph.prototype.start_event_name = 'iw_started';

    function BaseCampaignInterestWidgetGraph(dimension) {
      this.dimension = dimension;
    }

    BaseCampaignInterestWidgetGraph.prototype.baseLink = function(scope, elem, attrs) {
      scope.path = (function(_this) {
        return function() {
          return {
            apikey: scope.campaign.apikey,
            dimension: _this.dimension
          };
        };
      })(this);
      scope.range = function() {
        return {
          $gte: _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()]),
          $lt: _.min([scope.campaign.end_at, moment(scope.filters.end_at).add(1, 'days').startOf('day').toDate()])
        };
      };
      scope.getCampaignEventStats = function(name) {
        return CampaignEventStats.find(scope.path(), {
          match: {
            name: name,
            element_id: scope.campaign.element.id,
            start_at: scope.range()
          }
        });
      };
      scope.getAccessStats = function() {
        var ref;
        return AccessStats.findDefault(scope.path(), {
          device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device),
          campaign_segment_id: ((ref = scope.campaign.segment) != null ? ref.id : void 0) || null,
          is_control: null,
          start_at: {
            $gte: _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()]),
            $lt: _.min([scope.campaign.end_at, moment(scope.filters.end_at).add(1, 'days').startOf('day').toDate()])
          }
        });
      };
      scope.getInterestWidgetItemDistribution = function(is_cart_button_click) {
        return CampaignStats.getInterestWidgetItemDistribution(scope.path(), {
          match: {
            is_cart_button_click: is_cart_button_click,
            element_id: scope.campaign.element.id,
            start_at: scope.range()
          },
          pipeline: [
            {
              $group: {
                _id: {
                  from: "$from",
                  to: "$to"
                },
                count: {
                  $sum: "$count"
                }
              }
            }, {
              $project: {
                from: "$_id.from",
                to: "$_id.to",
                count: "$count"
              }
            }, {
              $sort: {
                from: 1
              }
            }
          ]
        });
      };
      return scope.updateData = function() {
        scope.getChartConfig();
        return scope.getStats().then(function(stats) {
          return scope.addChartConfig(stats);
        });
      };
    };

    BaseCampaignInterestWidgetGraph.prototype.watchFilters = function(scope, elem, attrs) {
      return scope.$watch('filters', scope.updateData, true);
    };

    BaseCampaignInterestWidgetGraph.prototype.createDirective = function() {
      return {
        restrict: 'E',
        require: '?filters',
        scope: {
          project: '=',
          campaign: '=',
          filters: '='
        },
        template: '<highchart config="chartConfig"></highchart>',
        link: (function(_this) {
          return function(scope, elem, attrs) {
            _this.baseLink(scope, elem, attrs);
            if (_this.link) {
              _this.link(scope, elem, attrs);
            }
            return _this.watchFilters(scope, elem, attrs);
          };
        })(this)
      };
    };

    return BaseCampaignInterestWidgetGraph;

  })();
}]);


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignBaseStep', function() {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      basicForm: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_base_step.html',
    controller: ["$scope", "Meta", "currencies", function($scope, Meta, currencies) {
      $scope.campaignDevices = [];
      $scope.currency = currencies[$scope.project.currency];
      if ($scope.campaign.fee_rate === null) {
        $scope.campaign.fee_rate = $scope.project.fee_rate;
      }
      Meta.getDevices().then(function(devices) {
        return $scope.campaignDevices = devices.filter(function(device) {
          return $scope.project.enable_app || device.name !== 'app';
        });
      });
      return $scope.$watch('campaign.campaign_device', function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        $scope.campaign.template_type = null;
        return $scope.campaign.template = null;
      });
    }]
  };
});


/***/ }),
/* 1127 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignBotbonnieStep', ["Campaign", "$translate", function(Campaign, $translate) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      botbonnieForm: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_botbonnie_step.html',
    link: function(scope, element, attrs) {
      scope.triggers = [
        {
          name: $translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.triggers.timing'),
          value: 'timing'
        }, {
          name: $translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.triggers.conversion'),
          value: 'conversion'
        }
      ];
      scope.triggerRulesMaxLength = 5;
      scope.triggerErrors = [];
      scope.disableBotbonnieForm = function() {
        var supportedTemplates;
        supportedTemplates = ['timesale_ver5_pc', 'timesale_ver5_sp', 'timesale_ver5_devicefree', 'timesale_ver5_devicefree_1step'];
        return !supportedTemplates.includes(scope.campaign.template_type);
      };
      scope.addRule = function() {
        var base;
        (base = scope.campaign).botbonnie_trigger_rules || (base.botbonnie_trigger_rules = []);
        return scope.campaign.botbonnie_trigger_rules.push({});
      };
      scope.deleteRule = function(rule) {
        _.remove(scope.campaign.botbonnie_trigger_rules, function(t) {
          return t.$$hashKey === rule.$$hashKey;
        });
        return scope.validateTriggerRules();
      };
      return scope.validateTriggerRules = function() {
        var conversionRulesCount, duplicateMinutes, formErrors, i, len, limit, minutesUndefined, overLimit, ref, timingRules, trigger;
        scope.botbonnieForm.$error = {};
        scope.triggerErrors = [];
        formErrors = {};
        limit = scope.campaign.element.message.limit;
        conversionRulesCount = 0;
        timingRules = [];
        if (scope.campaign.enable_botbonnie_integration && (scope.campaign.botbonnie_trigger_rules.length === 0 || scope.campaign.botbonnie_trigger_rules === void 0)) {
          formErrors.triggerUndefined = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.triggers_undefined'));
        }
        ref = scope.campaign.botbonnie_trigger_rules;
        for (i = 0, len = ref.length; i < len; i++) {
          trigger = ref[i];
          if (trigger.module === void 0 || trigger.module === "") {
            formErrors.moduleUndefined = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.module_undefined'));
          } else if (trigger.trigger === 'conversion') {
            conversionRulesCount += 1;
            if (conversionRulesCount > 1) {
              formErrors.multipleConversion = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.multiple_conversion'));
            }
          } else if (trigger.trigger === 'timing' || trigger.trigger === null) {
            timingRules.push(trigger);
            if (trigger.minutes > limit) {
              overLimit = true;
              formErrors.overLimit = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.over_limit', {
                limit: limit
              }));
            } else if (trigger.minutes === void 0) {
              minutesUndefined = true;
              formErrors.minutesUndefined = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.minutes_undefined'));
            }
          }
        }
        duplicateMinutes = _.find(Object.values(_.countBy(timingRules, function(t) {
          return t.minutes;
        })), function(t) {
          return t > 1;
        });
        if (duplicateMinutes) {
          formErrors.duplicateMinutes = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.duplicated_minutes'));
        }
        if (Object.keys(formErrors).length > 0) {
          scope.botbonnieForm.$setValidity('triggers', false);
          scope.triggerErrors = Object.values(formErrors);
          return;
        }
        return scope.botbonnieForm.$valid = true;
      };
    }
  };
}]);


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignChisqTest', ["CampaignStats", function(CampaignStats) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_chisq_test.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.chisq_test = true;
      updateData = function() {
        return CampaignStats.aggregate({
          dimension: 'daily',
          campaign_id: scope.campaign.id,
          apikey: scope.campaign.apikey,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          var stats;
          stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
          return scope.chisq_test = CampaignStats.chisqTest(stats);
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignConfirmStep', ["$state", "$translate", "Project", "InterestWidget", "AccessStats", "currencies", function($state, $translate, Project, InterestWidget, AccessStats, currencies) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      allValid: '=',
      basicForm: '=',
      templateForm: '=',
      incentiveForm: '=',
      botbonnieForm: '=',
      policyForm: '=',
      scheduleForm: '=',
      changeStatus: '&',
      changeInterestWidgetStatus: '&'
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_confirm_step.html',
    link: function(scope, element, attrs) {
      Project.get(scope.campaign.project_id).then(function(project) {
        scope.project = project;
        scope.currency = currencies[project.currency];
        scope.campaign_segments = project.campaign_segments;
        scope.campaign_policy_sets = project.campaign_policy_sets;
        scope.segment_access_stats = {
          session_count: 0,
          conversion_count: 0,
          history_count: 0
        };
        scope.campaign_policy_sets.unshift({
          id: null,
          name: $translate.instant('projectsCampaigns.directives.campaignConfirmStep.unspecified')
        });
        scope.campaign_segments.unshift({
          id: null,
          name: $translate.instant('projectsCampaigns.directives.campaignConfirmStep.unspecified')
        });
        return InterestWidget.all(project.apikey).then(function(interestWidgets) {
          var interestWidget;
          interestWidget = _.find(interestWidgets, function(iw) {
            return iw.campaign.id === scope.campaign.id;
          });
          if (interestWidget) {
            return scope.campaign.iw_status = interestWidget.status;
          }
        });
      });
      return scope.$watch('campaign.start_at_obj.date', function(startAt) {
        return scope.is_start_at_before_today = scope.campaign.start_at_obj.date < moment().startOf('day').valueOf();
      });
    }
  };
}]);


/***/ }),
/* 1130 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignControlPercentLabels', ["CampaignStats", "Devise", function(CampaignStats, Devise) {
  return {
    restrict: 'E',
    scope: {
      campaign: '<'
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_control_percent_labels.html'
  };
}]);


/***/ }),
/* 1131 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignCouponApplicableRate', ["CampaignSegmentStats", "Devise", function(CampaignSegmentStats, Devise) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_coupon_applicable_rate.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.Devise = Devise;
      updateData = function() {
        return CampaignSegmentStats.aggregate({
          apikey: scope.project.apikey,
          dimension: 'daily'
        }, {
          match: {
            campaign_id: scope.campaign.id,
            start_at: {
              $gte: moment(scope.filters.start_at).toDate(),
              $lt: moment(scope.filters.end_at).endOf('day').toDate()
            }
          },
          pipeline: [
            {
              $group: {
                _id: null,
                conversion_count: {
                  $sum: '$conversion_count'
                },
                coupon_applicable_conversion_count: {
                  $sum: '$coupon_applicable_conversion_count'
                }
              }
            }
          ]
        }).then(function(stats) {
          var stat;
          stat = stats[0];
          if (stat && stat.conversion_count > 0) {
            return scope.coupon_applicable_rate = stat.coupon_applicable_conversion_count / stat.conversion_count;
          } else {
            return scope.coupon_applicable_rate = null;
          }
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignCouponData', ["CampaignStats", "Devise", "$filter", function(CampaignStats, Devise, $filter) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_coupon_data.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.Devise = Devise;
      updateData = function() {
        return CampaignStats.aggregate({
          dimension: 'daily',
          campaign_id: scope.campaign.id,
          apikey: scope.campaign.apikey,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          var current_incentive, is_coupon_code_type, ref;
          scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
          current_incentive = scope.campaign.current_incentive;
          is_coupon_code_type = current_incentive && ((ref = current_incentive.incentive_type) === 'coupon_code' || ref === 'unique_coupon_code');
          return scope.rate_to_display = is_coupon_code_type && scope.stats.experimental.campaign_coupon_used_rate > 0 ? $filter('number')(scope.stats.experimental.campaign_coupon_used_rate * 100, 2) : '- ';
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignCreatives', ["Campaign", function(Campaign) {
  return {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_creatives.html',
    link: function(scope, element, attrs) {
      return Campaign.getTemplate({
        projectId: scope.campaign.project_id,
        campaignId: scope.campaign.id
      }).then(function(template) {
        return scope.template = template;
      });
    }
  };
}]);


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

var slice = [].slice;

angular.module('zc.projects').directive('campaignDynamicView', ["$q", "$sce", "CampaignTemplate", function($q, $sce, CampaignTemplate) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      form: '=',
      viewClass: '@'
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_dynamic_view.html',
    link: function(scope, element, attrs) {
      var setTemplateValid, updateView;
      setTemplateValid = function(valid) {
        if (!scope.form) {
          return;
        }
        return scope.form.$setValidity('template', valid);
      };
      updateView = function() {
        var params, promises;
        if (!scope.campaign.template_type) {
          return;
        }
        params = {
          project_id: scope.campaign.project_id,
          campaign_id: scope.campaign.id,
          incentive_ids: scope.campaign.incentives.map(function(incentive) {
            return incentive.id;
          }),
          template_type: scope.campaign.template_type,
          message: scope.campaign.element.message,
          campaign_type: scope.campaign.campaign_type
        };
        promises = [CampaignTemplate.views(angular.extend(params)), CampaignTemplate.confirmJs(params), CampaignTemplate.css(angular.extend(params)), CampaignTemplate.confirmCss(params)];
        return $q.all(promises).then(function(arg) {
          var $view, coupon_code, csss, diff, i, incentive, j, js, len, len1, nearest_diff, now, ref, ref1, ref2, view, views;
          views = arg[0], js = arg[1], csss = 3 <= arg.length ? slice.call(arg, 2) : [];
          $view = $('<div>');
          for (i = 0, len = views.length; i < len; i++) {
            view = views[i];
            $view.append(view.view);
          }
          coupon_code = ((ref = scope.campaign.current_incentive) != null ? ref.coupon_code : void 0) || 'COUPON CODE';
          if (((ref1 = scope.campaign.current_incentive) != null ? ref1.incentive_type : void 0) === 'unique_coupon_code') {
            coupon_code = 'UNIQUE CODE';
          }
          if ((scope.campaign.current_incentive == null) && (scope.campaign.incentives != null)) {
            now = new Date();
            nearest_diff = Number.MAX_VALUE;
            ref2 = scope.campaign.incentives;
            for (j = 0, len1 = ref2.length; j < len1; j++) {
              incentive = ref2[j];
              diff = Math.abs(incentive.start_at - now);
              if (diff < nearest_diff) {
                coupon_code = incentive.coupon_code;
                nearest_diff = diff;
              }
            }
          }
          $view.find('.zc_code_insert_code').text(coupon_code);
          scope.view = $sce.trustAsHtml($view.html());
          scope.js = $sce.trustAsHtml("<script data-random=\"" + (Math.random()) + "\">" + js + "</script>");
          scope.css = csss.join('\n');
          scope.hasError = false;
          return setTemplateValid(true);
        }, function(err) {
          scope.hasError = true;
          return setTemplateValid(false);
        });
      };
      scope.$watch('campaign.element', updateView, true);
      return scope.$watch('campaign.incentives', updateView, true);
    }
  };
}]);


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignEvents', ["$q", "$translate", "CampaignStats", "Devise", "SearchFilter", function($q, $translate, CampaignStats, Devise, SearchFilter) {
  return {
    campaign_event_statstrict: 'E',
    scope: {
      campaign: '=',
      filters: '=',
      campaignEventOrder: '=',
      campaignEventNotices: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_events.html',
    link: function(scope, element, attrs) {
      var setNotices;
      scope.Devise = Devise;
      scope.viewOptions = {
        details: false
      };
      scope.filters = SearchFilter.resolveFromLocation();
      SearchFilter.setComponentDefaults('campaignEventsList', {
        sort_prop: {
          "default": 'predefined'
        },
        sort_direction: {
          "default": 'desc'
        }
      });
      scope.$on('$destroy', function() {
        return SearchFilter.removeComponentDefaults('campaignEventsList');
      });
      scope.setSortProp = function(key) {
        if (scope.filters.sort_prop === key) {
          if (scope.filters.sort_direction === 'desc') {
            scope.filters.sort_direction = 'asc';
          } else {
            scope.filters.sort_direction = 'desc';
          }
        } else {
          scope.filters.sort_prop = key;
          scope.filters.sort_direction = 'desc';
        }
        return scope.updateData();
      };
      setNotices = function(campaign_events) {
        var event, i, is_notify, j, k, len, len1, len2, match, message, msg, notice, notices, op, ref, ref1, ref2, unit, value;
        notices = [];
        ref = scope.campaign_events;
        for (i = 0, len = ref.length; i < len; i++) {
          event = ref[i];
          ref1 = scope.campaignEventNotices;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            notice = ref1[j];
            if (event.id !== notice.name) {
              continue;
            }
            is_notify = true;
            message = event.name;
            value = event.count;
            unit = '';
            if (notice.unit_type === 'percent') {
              message += $translate.instant('projects.campaignsDirectivesCampaignEvents.no_wariai');
              value = value / scope.stats.experimental.delivery_count * 100;
              unit = '%';
            }
            message += $translate.instant('projects.campaignsDirectivesCampaignEvents.ga');
            ref2 = ['gte', 'lte', 'gt', 'lt', 'eq'];
            for (k = 0, len2 = ref2.length; k < len2; k++) {
              op = ref2[k];
              if (notice[op]) {
                switch (op) {
                  case 'gte':
                    match = notice.gte <= value;
                    msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.ijou', {
                      op: "" + notice.gte + unit
                    });
                    break;
                  case 'lte':
                    match = notice.lte >= value;
                    msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.ika', {
                      op: "" + notice.lte + unit
                    });
                    break;
                  case 'gt':
                    match = notice.gt < value;
                    msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.wo_chouka', {
                      op: "" + notice.gt + unit
                    });
                    break;
                  case 'lt':
                    match = notice.lt > value;
                    msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.miman', {
                      op: "" + notice.lt + unit
                    });
                    break;
                  case 'eq':
                    match = notice.eq === value;
                    msg = $translate.instant('projects.campaignsDirectivesCampaignEvents.to_douchi', {
                      op: "" + notice.eq + unit
                    });
                }
                if (match) {
                  message += msg;
                } else {
                  is_notify = false;
                }
              }
            }
            message += $translate.instant('projects.campaignsDirectivesCampaignEvents.ninatteimasu');
            if (is_notify) {
              notices.push(message);
            }
          }
        }
        return notices;
      };
      scope.updateData = function() {
        return $q.all([
          CampaignStats.getCampaignEventStats({
            apikey: scope.campaign.apikey,
            campaign_id: scope.campaign.id,
            element_id: scope.campaign.element.id,
            dimension: 'hourly',
            start_at: scope.filters.start_at,
            end_at: moment(scope.filters.end_at).endOf('day').valueOf()
          }), CampaignStats.aggregate({
            dimension: 'daily',
            campaign_id: scope.campaign.id,
            apikey: scope.campaign.apikey,
            start_at: scope.filters.start_at,
            end_at: moment(scope.filters.end_at).endOf('day').valueOf()
          })
        ]).then(function(arg) {
          var campaign_event, campaign_event_stat, campaign_event_stat_by_id, campaign_event_stats, campaign_stats, eventOrder, i, id, j, k, len, len1, len2, name, ref, ref1;
          campaign_event_stats = arg[0], campaign_stats = arg[1];
          campaign_event_stat_by_id = {};
          scope.campaign_events = [];
          scope.campaign_events_by_id = {};
          scope.campaign_events_action = {};
          for (i = 0, len = campaign_event_stats.length; i < len; i++) {
            campaign_event_stat = campaign_event_stats[i];
            campaign_event_stat.conversion_rate = campaign_event_stat.count > 0 ? 100 * campaign_event_stat.conversion_count / campaign_event_stat.count : 0;
            if (_.endsWith(campaign_event_stat._id, '_click')) {
              name = campaign_event_stat._id.replace('_click', '');
              if (!scope.campaign_events_action[name]) {
                scope.campaign_events_action[name] = {};
              }
              scope.campaign_events_action[name]['click'] = campaign_event_stat.count;
            } else if (_.endsWith(campaign_event_stat._id, '_hover')) {
              name = campaign_event_stat._id.replace('_hover', '');
              if (!scope.campaign_events_action[name]) {
                scope.campaign_events_action[name] = {};
              }
              scope.campaign_events_action[name]['hover'] = campaign_event_stat.count;
            } else if (_.endsWith(campaign_event_stat._id, '_hold')) {
              name = campaign_event_stat._id.replace('_hold', '');
              if (!scope.campaign_events_action[name]) {
                scope.campaign_events_action[name] = {};
              }
              scope.campaign_events_action[name]['hold'] = campaign_event_stat.count;
            } else if (_.endsWith(campaign_event_stat._id, '_show')) {
              name = campaign_event_stat._id.replace('_show', '');
              if (!scope.campaign_events_action[name]) {
                scope.campaign_events_action[name] = {};
              }
              scope.campaign_events_action[name]['show'] = campaign_event_stat.count;
            } else {
              campaign_event_stat_by_id[campaign_event_stat._id] = campaign_event_stat;
            }
          }
          ref = scope.campaignEventOrder;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            eventOrder = ref[j];
            for (id in eventOrder) {
              name = eventOrder[id];
              campaign_event_stat = campaign_event_stat_by_id[id];
              if (campaign_event_stat) {
                campaign_event_stat.id = id;
                delete campaign_event_stat_by_id[id];
                campaign_event_stat.name = name;
                scope.campaign_events.push(campaign_event_stat);
              }
            }
          }
          for (id in campaign_event_stat_by_id) {
            campaign_event_stat = campaign_event_stat_by_id[id];
            campaign_event_stat.name = id;
            scope.campaign_events.push(campaign_event_stat);
          }
          if (scope.filters.sort_prop !== 'predefined') {
            scope.campaign_events = _.sortBy(scope.campaign_events, scope.filters.sort_prop);
            if (scope.filters.sort_direction === 'desc') {
              scope.campaign_events.reverse();
            }
          }
          ref1 = scope.campaign_events;
          for (k = 0, len2 = ref1.length; k < len2; k++) {
            campaign_event = ref1[k];
            scope.campaign_events_by_id[campaign_event.id] = campaign_event;
          }
          scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
          return scope.notices = setNotices(scope.campaign_events);
        });
      };
      return scope.$watch('filters', scope.updateData, true);
    }
  };
}]);


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignFilterView', ["$filter", "$location", "$q", "$state", "$timeout", "$translate", "Meta", "CampaignSegment", "SearchFilter", "lib", function($filter, $location, $q, $state, $timeout, $translate, Meta, CampaignSegment, SearchFilter, lib) {
  return {
    restrict: 'E',
    require: '?filters',
    scope: {
      filters: '=',
      project: '=',
      hideDevice: '=',
      hideCampaignSegmentId: '=',
      hideSearchTerm: '=',
      hideReset: '=',
      showHiddenAbTestToggle: '=',
      update: '&',
      reset: '&'
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_filter.html',
    link: function(scope, element, attrs) {
      var activate, ref, resetDateFilterFields;
      scope.devices = [
        {
          label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noDeviceSetting'),
          name: null
        }
      ];
      scope.campaign_segments = [
        {
          label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noSegmentSetting'),
          id: null
        }
      ];
      scope.selected = {
        device: scope.devices[0],
        campaign_segment: scope.campaign_segments[0]
      };
      if (((ref = scope.filters.device_value) != null ? ref.name : void 0) === 'app' && !scope.project.enable_app) {
        scope.filters.device_value = scope.devices[0];
        scope.filters.device = scope.devices[0].name;
      }
      activate = function() {
        var promises, timeout;
        promises = [];
        if (!scope.hideDevice) {
          promises.push(Meta.getDevices().then(function(devices) {
            devices = devices.filter(function(device) {
              var ref1;
              return ((ref1 = device.name) === 'pc' || ref1 === 'sp') || (device.name === 'app' && scope.project.enable_app);
            });
            return scope.devices = [
              {
                label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noDeviceSetting'),
                name: null
              }
            ].concat(devices);
          }));
        }
        if (!scope.hideCampaignSegmentId) {
          promises.push(CampaignSegment.all(scope.project.id).then(function(campaign_segments) {
            var segment;
            campaign_segments = (function() {
              var i, len, results;
              results = [];
              for (i = 0, len = campaign_segments.length; i < len; i++) {
                segment = campaign_segments[i];
                if (segment.segment_type !== 'custom_old') {
                  results.push({
                    label: segment.name,
                    id: segment.id
                  });
                }
              }
              return results;
            })();
            campaign_segments = campaign_segments.reverse();
            return scope.campaign_segments = [
              {
                label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noSegmentSetting'),
                id: null
              }
            ].concat(campaign_segments);
          }));
        }
        if (!promises.length) {
          timeout = $timeout((function() {}), 0);
          promises.push(timeout);
        }
        return $q.all(promises).then(function(res) {
          SearchFilter.setComponentDefaults('campaignFilter', {
            device: {
              "default": null,
              keyProperty: 'name',
              getter: function(name) {
                return _.find(scope.devices, function(d) {
                  return d.name === name;
                });
              }
            },
            campaign_segment: {
              "default": void 0,
              keyProperty: 'id',
              getter: function(id) {
                return _.find(scope.campaign_segments, function(d) {
                  return d.id === parseInt(id);
                });
              }
            }
          });
          scope.selected.start_at = scope.filters.start_at;
          scope.selected.end_at = scope.filters.end_at;
          if (scope.filters.device_value) {
            scope.selected.device = _.find(scope.devices, function(d) {
              return d.name === scope.filters.device_value.name;
            });
          } else {
            scope.selected.device = scope.devices[0];
          }
          if (scope.filters.campaign_segment_value) {
            scope.selected.campaign_segment = _.find(scope.campaign_segments, function(d) {
              return d.id === scope.filters.campaign_segment_value.id;
            });
            if (!scope.selected.campaign_segment) {
              scope.selected.campaign_segment = scope.campaign_segments[0];
            }
          } else {
            scope.selected.campaign_segment = scope.campaign_segments[0];
          }
          return scope.updateData();
        });
      };
      scope.segmentNameFor = function(id) {
        var segment;
        if (!id) {
          return scope.campaign_segments[0].label;
        }
        segment = _.find(scope.campaign_segments, {
          id: id
        });
        return segment.label;
      };
      scope.updateData = function() {
        scope.filters.start_at = scope.selected.start_at;
        scope.filters.end_at = scope.selected.end_at;
        if (!scope.hideDevice) {
          if (scope.selected.device) {
            scope.filters.device = scope.selected.device.name;
            scope.filters.device_value = scope.selected.device;
          } else {
            scope.filters.device = scope.devices[0].name;
            scope.filters.device_value = scope.devices[0];
          }
        }
        if (!scope.hideCampaignSegmentId) {
          scope.filters.campaign_segment = scope.selected.campaign_segment.id;
          scope.filters.campaign_segment_value = scope.selected.campaign_segment;
        }
        if (!scope.hideSearchTerm) {
          scope.filters.search_term = scope.selected.search_term;
        }
        if (scope.campaignFilter) {
          scope.campaignFilter.$setPristine();
        }
        SearchFilter.set(scope.filters);
        SearchFilter.updateComponentDefaults('campaignFilter');
        return scope.update();
      };
      resetDateFilterFields = function() {
        if (moment(scope.selected.end_at).isBefore(SearchFilter.pageDefaults.start_at)) {
          scope.selected.end_at = SearchFilter.pageDefaults.end_at;
          return $timeout(function() {
            return scope.selected.start_at = SearchFilter.pageDefaults.start_at;
          }, 0);
        } else {
          scope.selected.start_at = SearchFilter.pageDefaults.start_at;
          return $timeout(function() {
            return scope.selected.end_at = SearchFilter.pageDefaults.end_at;
          }, 0);
        }
      };
      scope.resetFilters = function() {
        scope.filters.start_at = SearchFilter.pageDefaults.start_at;
        scope.filters.end_at = SearchFilter.pageDefaults.end_at;
        scope.filters.device = scope.devices[0].name;
        scope.filters.device_value = scope.devices[0];
        scope.filters.campaign_segment = scope.campaign_segments[0].id;
        scope.filters.campaign_segment_value = scope.campaign_segments[0];
        scope.filters.search_term = '';
        if (scope.showHiddenAbTestToggle) {
          scope.filters.include_hidden_ab_test = false;
        }
        resetDateFilterFields();
        scope.selected.device = scope.devices[0];
        scope.selected.campaign_segment = scope.campaign_segments[0];
        scope.selected.search_term = '';
        scope.filters = SearchFilter.reset(scope.filters);
        SearchFilter.resetComponentDefaults('campaignFilter');
        if (scope.campaignFilter) {
          scope.campaignFilter.$setPristine();
        }
        scope.reset();
        return scope.update();
      };
      return activate();
    }
  };
}]);


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignGraph', ["$filter", "$location", "$q", "$translate", "CampaignStats", "Chart", "Devise", "SearchFilter", "campaignGraphOptions", "currencies", "lib", function($filter, $location, $q, $translate, CampaignStats, Chart, Devise, SearchFilter, campaignGraphOptions, currencies, lib) {
  return {
    restrict: 'E',
    require: '?filters',
    scope: {
      project: '=',
      campaign: '=',
      filters: '=',
      isAb: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_graph.html',
    link: function(scope, element, attrs) {
      var DEFAULT_CHART_ITEM_VALUE, DEFAULT_DIMENSION, addSeries, addYAxis, chartNames, createChartDataForCVRIncreaseRate, createChartForCVRIncreaseRate, tooltip;
      DEFAULT_DIMENSION = 'daily';
      DEFAULT_CHART_ITEM_VALUE = campaignGraphOptions[0].name;
      scope.currency = currencies[scope.project.currency];
      scope.chartOptions = _.filter(campaignGraphOptions, function(option) {
        if (Devise.isMaster()) {
          if (option.name === 'cvr_increase_rate') {
            return scope.isAb;
          }
          return true;
        }
        if (Devise.isInternalUser()) {
          if (option.name === 'cvr_increase_rate') {
            return scope.isAb;
          }
        }
        return !option.isMasterOnly;
      });
      chartNames = _.map(campaignGraphOptions, 'name');
      SearchFilter.setComponentDefaults('campaignGraph', {
        campaign_graph: {
          "default": DEFAULT_CHART_ITEM_VALUE,
          keyProperty: 'name',
          getter: function(name) {
            return _.find(scope.chartOptions, function(d) {
              return d.name === name;
            });
          }
        },
        campaign_graph_dimension: {
          "default": DEFAULT_DIMENSION
        }
      });
      tooltip = function(option) {
        var ref;
        if (option && ((ref = option.name) === 'average_conversion_price' || ref === 'conversion_price')) {
          return {
            valuePrefix: scope.currency.symbol,
            valueSuffix: scope.currency.suffix,
            valueDecimals: scope.currency.fractionSize
          };
        }
        return {
          valuePrefix: '',
          valueSuffix: scope.filters.campaign_graph_value.unit,
          valueDecimals: scope.filters.campaign_graph_value.decimal
        };
      };
      addSeries = function(arg) {
        var color, data, name, option, yAxis;
        color = arg.color, data = arg.data, name = arg.name, option = arg.option, yAxis = arg.yAxis;
        return Chart.addSeries(scope.chartConfig, {
          color: color,
          data: data,
          name: name,
          tooltip: tooltip(option),
          yAxis: yAxis
        });
      };
      scope.$on('$destroy', function() {
        return SearchFilter.removeComponentDefaults('campaignGraph');
      });
      scope.reset = function() {
        return SearchFilter.resetComponentDefaults('campaignGraph');
      };
      addYAxis = function(arg) {
        var _tooltip, isOpposite, option;
        option = arg.option, isOpposite = arg.isOpposite;
        _tooltip = tooltip(option);
        return scope.chartConfig.options.yAxis.push({
          gridLineDashStyle: 'dot',
          min: 0,
          labels: {
            formatter: function() {
              return "" + _tooltip.valuePrefix + (Highcharts.numberFormat(this.value, _tooltip.valueDecimals)) + _tooltip.valueSuffix;
            }
          },
          title: {
            text: option.label
          },
          opposite: isOpposite
        });
      };
      scope.updateGraphDropdown = function(event, isAb) {
        scope.isAb = isAb;
        if (scope.filters.campaign_graph_value.name === 'cvr_increase_rate') {
          scope.filters.campaign_graph_value = campaignGraphOptions[0];
        }
        scope.chartOptions = _.filter(campaignGraphOptions, function(option) {
          if (Devise.isMaster()) {
            if (option.name === 'cvr_increase_rate') {
              return scope.isAb;
            }
            return true;
          }
          if (Devise.isInternalUser()) {
            if (option.name === 'cvr_increase_rate') {
              return scope.isAb;
            }
          }
          return !option.isMasterOnly;
        });
        return scope.updateData();
      };
      scope.updateData = function() {
        var start_at;
        SearchFilter.updateComponentDefaults('campaignGraph');
        if (scope.filters.campaign_graph_dimension === 'cumulative_hourly') {
          start_at = moment(scope.filters.start_at).subtract(1, 'hours').valueOf();
        } else if (scope.filters.campaign_graph_dimension === 'cumulative_daily') {
          start_at = moment(scope.filters.start_at).subtract(1, 'days').valueOf();
        } else {
          start_at = moment(scope.filters.start_at).valueOf();
        }
        return CampaignStats.find({
          dimension: scope.filters.campaign_graph_dimension,
          campaign_id: scope.campaign.id,
          apikey: scope.campaign.apikey,
          start_at: start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          var control, experiment, field, i, len, options, ref, ref1, stats;
          scope.stats_for_chart = CampaignStats.forChart(campaign_stats, scope.filters.campaign_graph_dimension);
          control = [];
          experiment = [];
          ref = scope.stats_for_chart;
          for (i = 0, len = ref.length; i < len; i++) {
            stats = ref[i];
            stats.average_conversion_price = stats.average_conversion_price / (Math.pow(10, scope.currency.fractionSize));
            stats.conversion_price = stats.conversion_price / (Math.pow(10, scope.currency.fractionSize));
            if (stats.is_control) {
              control.push(stats);
            } else {
              experiment.push(stats);
            }
          }
          control = $filter('zerosForMissingTime')(control, scope.filters.campaign_graph_dimension, {
            start_at: scope.filters.start_at,
            end_at: scope.filters.end_at
          });
          experiment = $filter('zerosForMissingTime')(experiment, scope.filters.campaign_graph_dimension, {
            start_at: scope.filters.start_at,
            end_at: scope.filters.end_at
          });
          if (_.startsWith(scope.filters.campaign_graph_dimension, 'cumulative_') && scope.filters.start_at !== moment(scope.campaign.start_at).valueOf()) {
            ref1 = _.map([control, experiment], function(groupStats) {
              return groupStats = CampaignStats.calculateCumulatives(groupStats, start_at);
            }), control = ref1[0], experiment = ref1[1];
          }
          field = scope.filters.campaign_graph_value.name;
          if (field === 'cvr_increase_rate') {
            field = 'conversion_rate';
          }
          control = _.map(control, function(o) {
            return [o.start_at, o[field]];
          });
          experiment = _.map(experiment, function(o) {
            return [o.start_at, o[field]];
          });
          options = scope.isAb ? {} : {
            options: {
              legend: false,
              colors: ['#26c9ff']
            }
          };
          scope.chartConfig = Chart.getChartConfig('line', options);
          scope.chartConfig.series = [];
          if (scope.filters.campaign_graph_value.name === 'cvr_increase_rate') {
            return createChartForCVRIncreaseRate(experiment, control);
          } else {
            addSeries({
              name: $translate.instant('projectsCampaigns.directives.campaignGraph.displayGroup'),
              data: experiment,
              option: scope.filters.campaign_graph_value
            });
            if (scope.isAb) {
              return addSeries({
                name: $translate.instant('projectsCampaigns.directives.campaignGraph.hiddenGroup'),
                data: control,
                option: scope.filters.campaign_graph_value
              });
            }
          }
        });
      };
      createChartDataForCVRIncreaseRate = function(experiment, control) {
        return _.map(experiment, function(arg, index) {
          var control_conversion_rate, experimental_conversion_rate, start_at;
          start_at = arg[0], experimental_conversion_rate = arg[1];
          control_conversion_rate = control[index] ? control[index][1] : 0;
          if (!control_conversion_rate) {
            return [start_at, 0];
          }
          return [start_at, (experimental_conversion_rate / control_conversion_rate) * 100];
        });
      };
      createChartForCVRIncreaseRate = function(experiment, control) {
        var conversion_rate_option, cvr_increase_rate;
        cvr_increase_rate = createChartDataForCVRIncreaseRate(experiment, control);
        conversion_rate_option = _.find(campaignGraphOptions, {
          name: 'conversion_rate'
        });
        addSeries({
          name: $translate.instant('sharedModules.commonApi.misc.campaignGraphOptions.cvrIncreaseRate'),
          data: cvr_increase_rate,
          option: scope.filters.campaign_graph_value,
          yAxis: 0,
          color: '#cccccc'
        });
        addSeries({
          name: $translate.instant('projectsCampaigns.directives.campaignGraph.displayGroupCVR'),
          data: experiment,
          option: conversion_rate_option,
          yAxis: 1,
          color: '#26c9ff'
        });
        addSeries({
          name: $translate.instant('projectsCampaigns.directives.campaignGraph.hiddenGroupCVR'),
          data: control,
          option: conversion_rate_option,
          yAxis: 1,
          color: '#666666'
        });
        scope.chartConfig.options.yAxis = [];
        addYAxis({
          option: scope.filters.campaign_graph_value,
          isOpposite: false
        });
        return addYAxis({
          option: conversion_rate_option,
          isOpposite: true
        });
      };
      scope.updateData();
      scope.$on('filtersUpdated', scope.updateData);
      scope.$on('filtersReset', scope.reset);
      return scope.$on('isAbChanged', scope.updateGraphDropdown);
    }
  };
}]);


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignGroups', ["CampaignStats", "Project", "currencies", function(CampaignStats, Project, currencies) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_groups.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.Project = Project;
      scope.currency = currencies[scope.project.currency];
      updateData = function() {
        return CampaignStats.aggregate({
          dimension: 'daily',
          campaign_id: scope.campaign.id,
          apikey: scope.campaign.apikey,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          return scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignIncentiveError', ["$translate", "maxIncentiveInterval", function($translate, maxIncentiveInterval) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=?',
      isValid: '=?'
    },
    template: "<div\n  style=\"font-size: 1.2em;\"\n  class=\"alert alert-danger\"\n  role=\"alert\"\n  ng-repeat=\"message in messages\">\n  <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n  {{message}}\n</div>",
    link: function(scope, element, attrs) {
      var checkErrors;
      scope.messages = [];
      checkErrors = function() {
        var i, incentive, incentiveEndBeforeCampaignStart, j, len, prev_incentive, ref;
        if (!(scope.campaign.incentives && scope.campaign.start_at_obj && scope.campaign.end_at_obj)) {
          return;
        }
        scope.messages = [];
        incentiveEndBeforeCampaignStart = false;
        ref = scope.campaign.incentives;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          incentive = ref[i];
          prev_incentive = scope.campaign.incentives[i - 1];
          if (scope.campaign.start_at_obj && incentive.end_at < new Date(scope.campaign.start_at_obj.date)) {
            incentiveEndBeforeCampaignStart = true;
          }
        }
        if (incentiveEndBeforeCampaignStart) {
          scope.messages.push($translate.instant('projectsCampaigns.directives.campaignIncentiveError.errorIncentiveTiming'));
        }
        return scope.isValid = !scope.messages.length && (!scope.campaign.requires_incentives || scope.campaign.incentive_ids.length > 0);
      };
      checkErrors();
      return scope.$watch('campaign', checkErrors, true);
    }
  };
}]);


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignIncentiveList', function() {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_incentive_list.html',
    link: function(scope, element, attrs) {
      return scope.haveActiveIncentive = function(campaign) {
        var i, incentive, len, ref;
        ref = campaign.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.current_status === 'active') {
            return true;
          }
        }
      };
    }
  };
});


/***/ }),
/* 1141 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignIncentiveStep', ["$state", function($state) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      incentives: '=',
      incentiveForm: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_incentive_step.html',
    link: function(scope, element, attrs) {
      scope.isValid = false;
      scope.filteredIncentives = [];
      scope.incentiveRegistrationUrl = $state.href('admin.projects.incentives', {
        projectId: scope.campaign.project_id
      });
      scope.checkFormValidity = function() {
        return scope.isValid = !scope.campaign.requires_incentives || scope.campaign.incentive_ids.length > 0;
      };
      scope.filterIncentives = function() {
        scope.filteredIncentives = _.reject(scope.incentives, function(incentive) {
          return _.find(scope.campaign.incentives, {
            id: incentive.id
          });
        });
        angular.forEach(scope.filteredIncentives, function(incentive) {
          if (incentive.incentive_type === 'api_url') {
            return incentive.example = " [" + incentive.api_url + "]";
          } else if (incentive.incentive_type === 'coupon_url') {
            return incentive.example = " [" + incentive.pc_base_url + "]";
          } else if (incentive.incentive_type === 'botbonnie_short_url') {
            return incentive.example = " [" + incentive.botbonnie_short_url + "]";
          } else {
            return incentive.example = " [" + incentive.coupon_code + "]";
          }
        });
        return scope.checkFormValidity();
      };
      scope.add = function(incentive) {
        scope.campaign.incentives = _.sortBy(scope.campaign.incentives.concat(incentive), function(d) {
          return new Date('start_at');
        });
        scope.campaign.incentive_ids = _.map(scope.campaign.incentives, 'id');
        return scope.filterIncentives();
      };
      scope.$watch('campaign.requires_incentives', function(requiresIncentives, previousValue) {
        if (previousValue === requiresIncentives) {
          return;
        }
        if (previousValue && scope.campaign.is_infinite) {
          scope.campaign.is_infinite = false;
        }
        return scope.checkFormValidity();
      });
      scope.$watch('campaign.incentives', function(currentIncentiveList, previousIncentiveList) {
        var isIncentiveRemoved;
        isIncentiveRemoved = currentIncentiveList.length < previousIncentiveList.length;
        if (isIncentiveRemoved) {
          return scope.filterIncentives();
        }
      });
      scope.$watch('isValid', function(isValid) {
        return scope.incentiveForm.$setValidity('campaign.incentives', isValid);
      });
      return scope.filterIncentives();
    }
  };
}]);


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignIncentiveTable', function() {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      showsAction: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_incentive_table.html',
    link: function(scope, element, attrs) {
      return scope.remove = function(incentive) {
        scope.campaign.incentives = _.reject(scope.campaign.incentives, incentive, 'id');
        return scope.campaign.incentive_ids = _.map(scope.campaign.incentives, 'id');
      };
    }
  };
});


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

angular.module('zc.projects').constant('maxIncentiveInterval', 1).directive('zcCampaignIncentiveWarning', ["$translate", "maxIncentiveInterval", function($translate, maxIncentiveInterval) {
  return {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    template: "<div\n  style=\"font-size: 1.2em;\"\n  class=\"alert alert-warning\"\n  role=\"alert\"\n  ng-repeat=\"message in messages\">\n  <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n  {{message}}\n</div>",
    link: function(scope, element, attrs) {
      var checkWarnings;
      scope.messages = [];
      checkWarnings = function(newval) {
        var i, incentive, j, len, long_interval, prev_incentive, ref, ref1;
        if (!newval) {
          return;
        }
        scope.messages = [];
        if (((ref = scope.campaign.delivery_type_option) != null ? ref.id : void 0) === 'complete_delivery') {
          scope.messages.push($translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.canNotEditIncentiveSetting'));
          return;
        }
        if (!scope.campaign.requires_incentives) {
          return;
        }
        if (scope.campaign.incentives.length === 0) {
          scope.messages.push($translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.noIncentiveRegistered'));
          return;
        }
        if (scope.campaign.start_at_obj && moment(scope.campaign.incentives[0].start_at).diff(moment(scope.campaign.start_at_obj.date), 'days') >= maxIncentiveInterval) {
          scope.messages.push($translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.startDaysAppartCampaignAndIncentive', {
            maxIncentiveInterval: maxIncentiveInterval
          }));
        }
        if (scope.campaign.end_at_obj && !scope.campaign.is_infinite && moment(scope.campaign.end_at_obj.date).diff(moment(scope.campaign.incentives[scope.campaign.incentives.length - 1].end_at), 'days') >= maxIncentiveInterval) {
          scope.messages.push($translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.endDaysAppartCampaignAndIncentive', {
            maxIncentiveInterval: maxIncentiveInterval
          }));
        }
        long_interval = false;
        ref1 = scope.campaign.incentives.slice(1);
        for (i = j = 0, len = ref1.length; j < len; i = ++j) {
          incentive = ref1[i];
          prev_incentive = scope.campaign.incentives[i];
          if (moment(incentive.start_at).diff(moment(prev_incentive.end_at), 'days') >= maxIncentiveInterval) {
            long_interval = true;
          }
        }
        if (long_interval) {
          return scope.messages.push($translate.instant('projectsCampaigns.directives.campaignIncentiveWarning.incentiveDeliveryInterval', {
            maxIncentiveInterval: maxIncentiveInterval
          }));
        }
      };
      checkWarnings();
      return scope.$watch('campaign', checkWarnings, true);
    }
  };
}]);


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetCartButtonClickRateGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries;
      addSeries = function(interest_widget_cart_button_click_rate_stats, no_interest_widget_cart_button_click_rate_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetCartButtonClickRateGraph.iwUsers'),
            data: interest_widget_cart_button_click_rate_stats
          }, {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetCartButtonClickRateGraph.wholeSite'),
            data: no_interest_widget_cart_button_click_rate_stats
          }
        ];
      };
      scope.getStats = (function(_this) {
        return function() {
          return $q.all([scope.getCampaignEventStats(_this.start_event_name), scope.getAccessStats()]);
        };
      })(this);
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            legend: false,
            yAxis: [
              {
                min: 0,
                labels: {
                  formatter: function() {
                    return Highcharts.numberFormat(this.value, 2) + '%';
                  }
                },
                title: {
                  text: null
                }
              }
            ]
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var access_stat, access_stats, access_stats_by_start_at, campaign_event_stats, event_stat, i, interest_widget_cart_button_click_rate, interest_widget_cart_button_click_rate_stats, j, len, len1, no_interest_widget_cart_button_click_count, no_interest_widget_cart_button_click_rate, no_interest_widget_cart_button_click_rate_stats, no_interest_widget_session_count, start_at, stats;
        campaign_event_stats = arg[0], access_stats = arg[1];
        access_stats_by_start_at = {};
        for (i = 0, len = access_stats.length; i < len; i++) {
          stats = access_stats[i];
          start_at = stats.start_at.valueOf();
          access_stats_by_start_at[start_at] = stats;
        }
        interest_widget_cart_button_click_rate_stats = [];
        no_interest_widget_cart_button_click_rate_stats = [];
        for (j = 0, len1 = campaign_event_stats.length; j < len1; j++) {
          event_stat = campaign_event_stats[j];
          start_at = event_stat.start_at.valueOf();
          access_stat = access_stats_by_start_at[start_at];
          if (!access_stat) {
            continue;
          }
          no_interest_widget_session_count = access_stat.session_count - event_stat.count;
          no_interest_widget_cart_button_click_count = access_stat.cart_button_click_count - event_stat.cart_button_click_count;
          interest_widget_cart_button_click_rate = event_stat.count ? event_stat.cart_button_click_count / event_stat.count * 100 : 0;
          no_interest_widget_cart_button_click_rate = no_interest_widget_session_count ? no_interest_widget_cart_button_click_count / no_interest_widget_session_count * 100 : 0;
          interest_widget_cart_button_click_rate_stats.push([start_at, interest_widget_cart_button_click_rate]);
          no_interest_widget_cart_button_click_rate_stats.push([start_at, no_interest_widget_cart_button_click_rate]);
        }
        return addSeries(interest_widget_cart_button_click_rate_stats, no_interest_widget_cart_button_click_rate_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetCartButtonClickRateRatioGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries;
      addSeries = function(vs_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetCartButtonClickRateRatioGraph.iwUserWholeSite'),
            data: vs_stats
          }
        ];
      };
      scope.getStats = (function(_this) {
        return function() {
          return $q.all([scope.getCampaignEventStats(_this.start_event_name), scope.getAccessStats()]);
        };
      })(this);
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            tooltip: {
              valueSuffix: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetCartButtonClickRateRatioGraph.double'),
              valueDecimals: 2
            },
            legend: false,
            yAxis: [
              {
                min: 0,
                labels: {
                  formatter: function() {
                    return Highcharts.numberFormat(this.value, 2) + '%';
                  }
                },
                title: {
                  text: null
                }
              }
            ]
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var access_stat, access_stats, access_stats_by_start_at, campaign_event_stats, event_stat, i, interest_widget_cart_button_click_rate, j, len, len1, no_interest_widget_cart_button_click_count, no_interest_widget_cart_button_click_rate, no_interest_widget_session_count, start_at, stats, vs_stats;
        campaign_event_stats = arg[0], access_stats = arg[1];
        access_stats_by_start_at = {};
        for (i = 0, len = access_stats.length; i < len; i++) {
          stats = access_stats[i];
          start_at = stats.start_at.valueOf();
          access_stats_by_start_at[start_at] = stats;
        }
        vs_stats = [];
        for (j = 0, len1 = campaign_event_stats.length; j < len1; j++) {
          event_stat = campaign_event_stats[j];
          start_at = event_stat.start_at.valueOf();
          access_stat = access_stats_by_start_at[start_at];
          if (!access_stat) {
            continue;
          }
          no_interest_widget_session_count = access_stat.session_count - event_stat.count;
          no_interest_widget_cart_button_click_count = access_stat.cart_button_click_count - event_stat.cart_button_click_count;
          interest_widget_cart_button_click_rate = event_stat.count ? event_stat.cart_button_click_count / event_stat.count * 100 : 0;
          no_interest_widget_cart_button_click_rate = no_interest_widget_session_count ? no_interest_widget_cart_button_click_count / no_interest_widget_session_count * 100 : 0;
          vs_stats.push([start_at, no_interest_widget_cart_button_click_rate && interest_widget_cart_button_click_rate ? interest_widget_cart_button_click_rate / no_interest_widget_cart_button_click_rate : 0]);
        }
        return addSeries(vs_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1146 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetClickRateGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries;
      addSeries = function(click_item_rate_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetClickRateGraph.productClick'),
            data: click_item_rate_stats
          }
        ];
      };
      scope.getStats = function() {
        return $q.all([scope.getCampaignEventStats('click_badge'), scope.getCampaignEventStats('click_item')]);
      };
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            legend: false
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var badge_click_stat, badge_click_stats, click_item_count, click_item_count_by_start_at, click_item_rate, click_item_rate_stats, click_item_stat, click_item_stats, i, j, len, len1, start_at;
        badge_click_stats = arg[0], click_item_stats = arg[1];
        click_item_count_by_start_at = {};
        for (i = 0, len = click_item_stats.length; i < len; i++) {
          click_item_stat = click_item_stats[i];
          start_at = click_item_stat.start_at.valueOf();
          click_item_count_by_start_at[start_at] = click_item_stat.count;
        }
        click_item_rate_stats = [];
        for (j = 0, len1 = badge_click_stats.length; j < len1; j++) {
          badge_click_stat = badge_click_stats[j];
          start_at = badge_click_stat.start_at.valueOf();
          click_item_count = click_item_count_by_start_at[start_at] || 0;
          click_item_rate = badge_click_stat.count ? click_item_count / badge_click_stat.count * 100 : 0;
          click_item_rate_stats.push([start_at, click_item_rate]);
        }
        return addSeries(click_item_rate_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1147 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetConversionPriceGraph', ["$translate", "BaseCampaignInterestWidgetGraph", "Chart", "currencies", function($translate, BaseCampaignInterestWidgetGraph, Chart, currencies) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries;
      scope.currency = currencies[scope.project.currency];
      addSeries = function(cumulative_conversion_price_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetConversionPriceGraph.acquisitionAmount'),
            data: cumulative_conversion_price_stats
          }
        ];
      };
      scope.getStats = function() {
        return scope.getCampaignEventStats('click_item');
      };
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('segment', {
          options: {
            tooltip: {
              valueSuffix: scope.currency.suffix,
              valueDecimals: scope.currency.fractionSize
            },
            legend: false
          }
        });
      };
      return scope.addChartConfig = function(campaign_event_stats) {
        var cumulative_conversion_price, cumulative_conversion_price_stats, i, len, stats;
        if (!campaign_event_stats || campaign_event_stats.length === 0) {
          return;
        }
        cumulative_conversion_price = 0;
        cumulative_conversion_price_stats = [[campaign_event_stats[0].start_at.valueOf(), 0]];
        for (i = 0, len = campaign_event_stats.length; i < len; i++) {
          stats = campaign_event_stats[i];
          cumulative_conversion_price += stats.conversion_price;
          cumulative_conversion_price_stats.push([stats.end_at.valueOf(), cumulative_conversion_price]);
        }
        return addSeries(cumulative_conversion_price_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1148 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetConversionRateGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries, addYAxis;
      addYAxis = function() {
        return scope.chartConfig.options.yAxis = [
          {
            min: 0,
            labels: {
              formatter: function() {
                return Highcharts.numberFormat(this.value, 2) + '%';
              }
            },
            title: {
              text: null
            }
          }
        ];
      };
      addSeries = function(interest_widget_conversion_rate_stats, no_interest_widget_conversion_rate_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetConversionRateGraph.iwUsers'),
            data: interest_widget_conversion_rate_stats
          }, {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetConversionRateGraph.wholeSite'),
            data: no_interest_widget_conversion_rate_stats
          }
        ];
      };
      scope.getStats = (function(_this) {
        return function() {
          return $q.all([scope.getCampaignEventStats(_this.start_event_name), scope.getAccessStats()]);
        };
      })(this);
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            legend: false
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var access_stat, access_stats, access_stats_by_start_at, campaign_event_stats, event_stat, i, interest_widget_conversion_rate, interest_widget_conversion_rate_stats, j, len, len1, no_interest_widget_conversion_count, no_interest_widget_conversion_rate, no_interest_widget_conversion_rate_stats, no_interest_widget_session_count, start_at, stats;
        campaign_event_stats = arg[0], access_stats = arg[1];
        access_stats_by_start_at = {};
        for (i = 0, len = access_stats.length; i < len; i++) {
          stats = access_stats[i];
          start_at = stats.start_at.valueOf();
          access_stats_by_start_at[start_at] = stats;
        }
        interest_widget_conversion_rate_stats = [];
        no_interest_widget_conversion_rate_stats = [];
        for (j = 0, len1 = campaign_event_stats.length; j < len1; j++) {
          event_stat = campaign_event_stats[j];
          start_at = event_stat.start_at.valueOf();
          access_stat = access_stats_by_start_at[start_at];
          if (!access_stat) {
            continue;
          }
          no_interest_widget_session_count = access_stat.session_count - event_stat.count;
          no_interest_widget_conversion_count = access_stat.conversion_count - event_stat.conversion_count;
          interest_widget_conversion_rate = event_stat.count ? event_stat.conversion_count / event_stat.count * 100 : 0;
          no_interest_widget_conversion_rate = no_interest_widget_session_count ? no_interest_widget_conversion_count / no_interest_widget_session_count * 100 : 0;
          interest_widget_conversion_rate_stats.push([start_at, interest_widget_conversion_rate]);
          no_interest_widget_conversion_rate_stats.push([start_at, no_interest_widget_conversion_rate]);
        }
        addYAxis();
        return addSeries(interest_widget_conversion_rate_stats, no_interest_widget_conversion_rate_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1149 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetConversionRateRatioGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries;
      addSeries = function(vs_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetConversionRateRatioGraph.iwUserWholeSite'),
            data: vs_stats
          }
        ];
      };
      scope.getStats = (function(_this) {
        return function() {
          return $q.all([scope.getCampaignEventStats(_this.start_event_name), scope.getAccessStats()]);
        };
      })(this);
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            tooltip: {
              valueSuffix: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetConversionRateRatioGraph.double'),
              valueDecimals: 2
            },
            legend: false,
            yAxis: [
              {
                min: 0,
                labels: {
                  formatter: function() {
                    return Highcharts.numberFormat(this.value, 2) + '%';
                  }
                },
                title: {
                  text: null
                }
              }
            ]
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var access_stat, access_stats, access_stats_by_start_at, campaign_event_stats, event_stat, i, interest_widget_conversion_rate, j, len, len1, no_interest_widget_conversion_count, no_interest_widget_conversion_rate, no_interest_widget_session_count, start_at, stats, vs_stats;
        campaign_event_stats = arg[0], access_stats = arg[1];
        access_stats_by_start_at = {};
        for (i = 0, len = access_stats.length; i < len; i++) {
          stats = access_stats[i];
          start_at = stats.start_at.valueOf();
          access_stats_by_start_at[start_at] = stats;
        }
        vs_stats = [];
        for (j = 0, len1 = campaign_event_stats.length; j < len1; j++) {
          event_stat = campaign_event_stats[j];
          start_at = event_stat.start_at.valueOf();
          access_stat = access_stats_by_start_at[start_at];
          if (!access_stat) {
            continue;
          }
          no_interest_widget_session_count = access_stat.session_count - event_stat.count;
          no_interest_widget_conversion_count = access_stat.conversion_count - event_stat.conversion_count;
          interest_widget_conversion_rate = event_stat.count ? event_stat.conversion_count / event_stat.count * 100 : 0;
          no_interest_widget_conversion_rate = no_interest_widget_session_count ? no_interest_widget_conversion_count / no_interest_widget_session_count * 100 : 0;
          vs_stats.push([start_at, no_interest_widget_conversion_rate && interest_widget_conversion_rate ? interest_widget_conversion_rate / no_interest_widget_conversion_rate : 0]);
        }
        return addSeries(vs_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1150 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetDeliveryGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries, addYAxis;
      addYAxis = function() {
        return scope.chartConfig.options.yAxis = [
          {
            min: 0,
            labels: {
              formatter: function() {
                return Highcharts.numberFormat(this.value, 0) + $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.session');
              }
            },
            title: {
              text: null
            }
          }, {
            min: 0,
            labels: {
              formatter: function() {
                return Highcharts.numberFormat(this.value, 2) + '%';
              }
            },
            title: {
              text: null
            },
            opposite: true
          }
        ];
      };
      addSeries = function(delivery_count_stats, delivery_rate_stats) {
        return scope.chartConfig.series = [
          {
            type: 'column',
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.sessionCount'),
            data: delivery_count_stats,
            tooltip: {
              valueSuffix: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.session'),
              valueDecimals: 0
            },
            yAxis: 0
          }, {
            type: 'line',
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.distributionRatio'),
            data: delivery_rate_stats,
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            yAxis: 1
          }
        ];
      };
      scope.getStats = (function(_this) {
        return function() {
          return $q.all([scope.getCampaignEventStats(_this.start_event_name), scope.getAccessStats()]);
        };
      })(this);
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            legend: false
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var access_stats, campaign_event_stats, delivery_count_stats, delivery_rate, delivery_rate_stats, i, j, len, len1, session_count, session_count_by_start_at, start_at, stats;
        campaign_event_stats = arg[0], access_stats = arg[1];
        session_count_by_start_at = {};
        for (i = 0, len = access_stats.length; i < len; i++) {
          stats = access_stats[i];
          start_at = stats.start_at.valueOf();
          session_count_by_start_at[start_at] = stats.session_count;
        }
        delivery_count_stats = [];
        delivery_rate_stats = [];
        for (j = 0, len1 = campaign_event_stats.length; j < len1; j++) {
          stats = campaign_event_stats[j];
          start_at = stats.start_at.valueOf();
          session_count = session_count_by_start_at[start_at];
          if (!session_count) {
            continue;
          }
          delivery_rate = session_count ? stats.count / session_count * 100 : 0;
          delivery_count_stats.push([start_at, stats.count]);
          delivery_rate_stats.push([start_at, delivery_rate]);
        }
        addYAxis();
        return addSeries(delivery_count_stats, delivery_rate_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignInterestWidgetEvent', ["$q", "CampaignStats", "Devise", "SearchFilter", function($q, CampaignStats, Devise, SearchFilter) {
  return {
    campaign_event_statstrict: 'E',
    scope: {
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_interest_widget_event.html',
    link: function(scope, element, attrs) {
      scope.filters = SearchFilter.resolveFromLocation();
      SearchFilter.setComponentDefaults('campaignEventsList', {
        sort_prop: {
          "default": 'predefined'
        },
        sort_direction: {
          "default": 'desc'
        }
      });
      scope.$on('$destroy', function() {
        return SearchFilter.removeComponentDefaults('campaignEventsList');
      });
      scope.setSortProp = function(key) {
        if (scope.filters.sort_prop === key) {
          if (scope.filters.sort_direction === 'desc') {
            scope.filters.sort_direction = 'asc';
          } else {
            scope.filters.sort_direction = 'desc';
          }
        } else {
          scope.filters.sort_prop = key;
          scope.filters.sort_direction = 'desc';
        }
        return scope.updateData();
      };
      scope.updateData = function() {
        return CampaignStats.getCampaignEventStats({
          apikey: scope.campaign.apikey,
          campaign_id: scope.campaign.id,
          element_id: scope.campaign.element.id,
          dimension: 'hourly',
          start_at: scope.filters.start_at,
          end_at: moment(scope.filters.end_at).endOf('day').valueOf()
        }).then(function(campaign_event_stats) {
          var campaign_event_stat_by_id, i, len, stat;
          campaign_event_stat_by_id = {};
          scope.campaign_events = [];
          scope.iw_started_count = scope.iw_started_conversion_count = 0;
          for (i = 0, len = campaign_event_stats.length; i < len; i++) {
            stat = campaign_event_stats[i];
            stat.name = stat._id;
            stat.conversion_rate = stat.count > 0 ? 100 * stat.conversion_count / stat.count : 0;
            if (stat.name === 'iw_started') {
              scope.iw_started_count = stat.count;
              scope.iw_started_conversion_count = stat.conversion_count;
            }
            scope.campaign_events.push(stat);
          }
          if (scope.filters.sort_prop !== 'predefined') {
            scope.campaign_events = _.sortBy(scope.campaign_events, scope.filters.sort_prop);
            if (scope.filters.sort_direction === 'desc') {
              return scope.campaign_events.reverse();
            }
          }
        });
      };
      return scope.$watch('filters', scope.updateData, true);
    }
  };
}]);


/***/ }),
/* 1152 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetItemGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      scope.getStats = function() {
        return $q.all([scope.getInterestWidgetItemDistribution(true), scope.getInterestWidgetItemDistribution(false)]);
      };
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('campaignInterestWidgetItembution', {
          options: {
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            legend: false
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var cart_button_click_count, cart_button_click_stats, i, j, k, len, len1, no_cart_button_click_count, no_cart_button_click_stats, stat;
        cart_button_click_stats = arg[0], no_cart_button_click_stats = arg[1];
        no_cart_button_click_count = 0;
        for (j = 0, len = no_cart_button_click_stats.length; j < len; j++) {
          stat = no_cart_button_click_stats[j];
          no_cart_button_click_count += stat.count;
        }
        cart_button_click_count = 0;
        for (k = 0, len1 = cart_button_click_stats.length; k < len1; k++) {
          stat = cart_button_click_stats[k];
          cart_button_click_count += stat.count;
        }
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetItemGraph.userWhoNotAddCartItems'),
            data: (function() {
              var l, len2, results;
              results = [];
              for (l = 0, len2 = no_cart_button_click_stats.length; l < len2; l++) {
                i = no_cart_button_click_stats[l];
                results.push([i.from, i.count / no_cart_button_click_count * 100]);
              }
              return results;
            })()
          }, {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetItemGraph.userWhoAddCartItems'),
            data: (function() {
              var l, len2, results;
              results = [];
              for (l = 0, len2 = cart_button_click_stats.length; l < len2; l++) {
                i = cart_button_click_stats[l];
                results.push([i.from, i.count / cart_button_click_count * 100]);
              }
              return results;
            })()
          }
        ];
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('hourly').createDirective();
}]);


/***/ }),
/* 1153 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCampaignInterestWidgetSwipeRateGraph', ["$q", "$translate", "BaseCampaignInterestWidgetGraph", "Chart", function($q, $translate, BaseCampaignInterestWidgetGraph, Chart) {
  var Graph;
  Graph = (function(superClass) {
    extend(Graph, superClass);

    function Graph() {
      return Graph.__super__.constructor.apply(this, arguments);
    }

    Graph.prototype.link = function(scope, element, attrs) {
      var addSeries;
      addSeries = function(swipe_rate_stats) {
        return scope.chartConfig.series = [
          {
            name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetSwipeRateGraph.productSwipe'),
            data: swipe_rate_stats
          }
        ];
      };
      scope.getStats = function() {
        return $q.all([
          scope.getCampaignEventStats('click_badge'), scope.getCampaignEventStats({
            $in: ['interest_item_swiped', 'view_content_scrolled']
          })
        ]);
      };
      scope.getChartConfig = function() {
        return scope.chartConfig = Chart.getChartConfig('line', {
          options: {
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            legend: false
          }
        });
      };
      return scope.addChartConfig = function(arg) {
        var badge_click_stat, badge_click_stats, i, interest_item_swiped_stat, interest_item_swiped_stats, j, len, len1, start_at, swipe_count, swipe_count_by_start_at, swipe_rate, swipe_rate_stats;
        badge_click_stats = arg[0], interest_item_swiped_stats = arg[1];
        swipe_count_by_start_at = {};
        for (i = 0, len = interest_item_swiped_stats.length; i < len; i++) {
          interest_item_swiped_stat = interest_item_swiped_stats[i];
          start_at = interest_item_swiped_stat.start_at.valueOf();
          swipe_count_by_start_at[start_at] = interest_item_swiped_stat.count;
        }
        swipe_rate_stats = [];
        for (j = 0, len1 = badge_click_stats.length; j < len1; j++) {
          badge_click_stat = badge_click_stats[j];
          start_at = badge_click_stat.start_at.valueOf();
          swipe_count = swipe_count_by_start_at[start_at] || 0;
          swipe_rate = badge_click_stat.count ? swipe_count / badge_click_stat.count * 100 : 0;
          swipe_rate_stats.push([start_at, swipe_rate]);
        }
        return addSeries(swipe_rate_stats);
      };
    };

    return Graph;

  })(BaseCampaignInterestWidgetGraph);
  return new Graph('daily').createDirective();
}]);


/***/ }),
/* 1154 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignKpiView', [
  "$state", "Campaign", function($state, Campaign) {
    return {
      restrict: 'A',
      require: '?ngModel',
      scope: {
        cumulativeData: "=ngModel"
      },
      templateUrl: '/templates/projects.campaigns/views/directives/kpi_view.html',
      compile: function(tElem, attrs) {
        return function(scope, element, attrs) {
          return scope.Campaign = Campaign;
        };
      }
    };
  }
]);


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignListView', [
  "$state", "Campaign", "Devise", function($state, Campaign, Devise) {
    return {
      restrict: 'A',
      require: '?ngModel',
      scope: {
        showsButtons: "=showsButtons",
        campaign: "=ngModel",
        onCopy: "&",
        onDestroy: "&",
        filters: "=",
        project: "="
      },
      templateUrl: '/templates/projects.campaigns/views/directives/campaign_list.html',
      compile: function(tElem, attrs) {
        return function(scope, element, attrs) {
          scope.Campaign = Campaign;
          scope.Devise = Devise;
          scope.showCampaign = function(campaignId) {
            return $state.go('admin.projects.campaigns.show.stats', {
              projectId: $state.params.projectId,
              campaignId: campaignId
            });
          };
          scope.editCampaign = function(campaignId) {
            return $state.go('admin.projects.campaigns.edit', {
              projectId: $state.params.projectId,
              campaignId: campaignId
            });
          };
          scope.copyCampaign = function() {
            return scope.onCopy(scope.campaign);
          };
          return scope.destroyCampaign = function() {
            return scope.onDestroy(scope.campaign);
          };
        };
      }
    };
  }
]);


/***/ }),
/* 1156 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignMomentGraph', ["$q", "$translate", "CampaignStats", "Chart", function($q, $translate, CampaignStats, Chart) {
  return {
    restrict: 'E',
    require: '?filters',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_moment_graph.html',
    controller: ["$scope", function($scope) {
      var createPaths, createQuery, updateCampaignDwellData, updateData, updateHistoryCountData;
      createPaths = function() {
        return {
          apikey: $scope.campaign.apikey,
          dimension: 'hourly'
        };
      };
      createQuery = function() {
        return {
          match: {
            campaign_id: $scope.campaign.id,
            start_at: {
              $gte: new Date($scope.filters.start_at),
              $lt: new Date($scope.filters.end_at)
            }
          },
          pipeline: [
            {
              $group: {
                _id: {
                  from: "$from",
                  to: "$to"
                },
                count: {
                  $sum: "$count"
                }
              }
            }, {
              $project: {
                from: "$_id.from",
                to: "$_id.to",
                count: "$count"
              }
            }, {
              $sort: {
                from: 1
              }
            }
          ]
        };
      };
      updateCampaignDwellData = function(paths, query) {
        return CampaignStats.getHourlyDwellDistribution(paths, query).then(function(res) {
          var i;
          $scope.campaignDwellConfig = Chart.getChartConfig('campaignDwell');
          return Chart.addSeries($scope.campaignDwellConfig, {
            name: $translate.instant('projectsCampaigns.directives.campaignMomentGraph.sessionCount'),
            data: (function() {
              var j, len, results;
              results = [];
              for (j = 0, len = res.length; j < len; j++) {
                i = res[j];
                results.push([i.from, i.count]);
              }
              return results;
            })()
          });
        });
      };
      updateHistoryCountData = function(paths, query) {
        return CampaignStats.getHourlyHistoryCountDistribution(paths, query).then(function(res) {
          var i;
          $scope.campaignHistoryCountConfig = Chart.getChartConfig('campaignHistoryCount');
          return Chart.addSeries($scope.campaignHistoryCountConfig, {
            name: $translate.instant('projectsCampaigns.directives.campaignMomentGraph.sessionCount'),
            data: (function() {
              var j, len, results;
              results = [];
              for (j = 0, len = res.length; j < len; j++) {
                i = res[j];
                results.push([i.from, i.count]);
              }
              return results;
            })()
          });
        });
      };
      updateData = function() {
        var paths, query;
        paths = createPaths();
        query = createQuery();
        updateCampaignDwellData(paths, query);
        return updateHistoryCountData(paths, query);
      };
      return $scope.$watch('filters', updateData, true);
    }]
  };
}]);


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignNavigator', ["$state", "Campaign", function($state, Campaign) {
  return {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_navigator.html',
    link: function(scope, element, attrs) {
      scope.$state = $state;
      scope.nextState = function(activeStep) {
        switch ($state.current.name) {
          case 'admin.projects.campaigns.edit.base':
            return $state.go('admin.projects.campaigns.edit.template');
          case 'admin.projects.campaigns.edit.template':
            return $state.go('admin.projects.campaigns.edit.incentive');
          case 'admin.projects.campaigns.edit.incentive':
            return $state.go('admin.projects.campaigns.edit.policy');
          case 'admin.projects.campaigns.edit.policy':
            return $state.go('admin.projects.campaigns.edit.schedule');
          case 'admin.projects.campaigns.edit.schedule':
            return $state.go('admin.projects.campaigns.edit.confirm');
        }
      };
      return scope.prevState = function(activeStep) {
        switch ($state.current.name) {
          case 'admin.projects.campaigns.edit.template':
            return $state.go('admin.projects.campaigns.edit.base');
          case 'admin.projects.campaigns.edit.policy':
            return $state.go('admin.projects.campaigns.edit.incentive');
          case 'admin.projects.campaigns.edit.incentive':
            return $state.go('admin.projects.campaigns.edit.template');
          case 'admin.projects.campaigns.edit.schedule':
            return $state.go('admin.projects.campaigns.edit.policy');
          case 'admin.projects.campaigns.edit.confirm':
            return $state.go('admin.projects.campaigns.edit.schedule');
        }
      };
    }
  };
}]);


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignPanels', ["Devise", "CampaignStats", "Project", "currencies", function(Devise, CampaignStats, Project, currencies) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '=',
      isAb: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_panels.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.Devise = Devise;
      scope.Project = Project;
      scope.currency = currencies[scope.project.currency];
      updateData = function() {
        return CampaignStats.aggregate({
          dimension: 'daily',
          campaign_id: scope.campaign.id,
          apikey: scope.campaign.apikey,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          var calculatedInvoiceAmount;
          scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
          calculatedInvoiceAmount = CampaignStats.calculateInvoiceAmount(scope.project, scope.campaign, scope.stats);
          return _.assign(scope.stats, {
            invoice_amount: calculatedInvoiceAmount
          });
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1159 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignPolicyStep', ["$q", "$translate", "CampaignSegment", "InterestWidget", "Meta", function($q, $translate, CampaignSegment, InterestWidget, Meta) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      policyForm: '=',
      clearanceItemSets: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_policy_step.html',
    link: function(scope, element, attrs) {
      var findSegment, isSavedInterestWidget;
      scope.campaign_segments = [];
      scope.availableTestingUnits = [];
      scope.days_since_last_received_enabled = scope.campaign.days_since_last_received >= 1;
      scope.days_since_last_received_conversion_enabled = scope.campaign.days_since_last_received_conversion >= 1;
      isSavedInterestWidget = function(campaign) {
        return campaign.interest_widget_id >= 1 && !campaign.is_coupon_campaign && campaign.delivery_type_option && campaign.delivery_type_option.id === 'complete_delivery';
      };
      scope.isSavedInterestWidget = isSavedInterestWidget(scope.campaign);
      CampaignSegment.all(scope.campaign.project_id).then(function(res) {
        var i, len, ref, segment, segment_found;
        scope.campaign_segments = res;
        scope.campaign_segments.unshift({
          id: null,
          name: $translate.instant('projectsCampaigns.directives.campaignPolicyStep.unspecified')
        });
        segment_found = false;
        ref = scope.campaign_segments;
        for (i = 0, len = ref.length; i < len; i++) {
          segment = ref[i];
          if (segment.id === scope.campaign.segment_id) {
            segment_found = true;
            break;
          }
        }
        if (!segment_found) {
          scope.campaign.segment = null;
          scope.campaign.segment_id = null;
        }
        scope.campaign_segments = _.chain(res).filter(function(d) {
          return d.segment_type !== 'custom_old' || d.id === scope.campaign.segment_id;
        }).filter(function(d) {
          return !d.deprecated;
        }).sortBy(function(d) {
          return -new Date(d.created_at);
        }).value();
        return findSegment(scope.campaign.segment_id);
      });
      findSegment = function(segment_id) {
        return scope.campaign.segment = _.find(scope.campaign_segments, {
          id: segment_id
        });
      };
      Meta.getTestingUnits().then(function(testingUnits) {
        return scope.availableTestingUnits = testingUnits;
      });
      scope.$watch('campaign.segment_id', function(segment_id) {
        return findSegment(segment_id);
      });
      scope.$watch('campaign.delivery_type_option', function(_new, _old, newScope) {
        return InterestWidget.updateCampaignWithInterestWidget(newScope.campaign).then(function() {
          return scope.isSavedInterestWidget = isSavedInterestWidget(newScope.campaign);
        });
      }, true);
      scope.setCampaignControlPercentToZero = function() {
        return scope.campaign.campaign_control_percent = 0;
      };
      scope.toggleDaysSinceLastReceived = function() {
        scope.days_since_last_received_enabled = !scope.days_since_last_received_enabled;
        if (scope.campaign.days_since_last_received != null) {
          return scope.campaign.days_since_last_received = null;
        } else {
          return scope.campaign.days_since_last_received = 3;
        }
      };
      return scope.toggleDaysSinceLastReceivedConversion = function() {
        scope.days_since_last_received_conversion_enabled = !scope.days_since_last_received_conversion_enabled;
        if (scope.campaign.days_since_last_received_conversion != null) {
          return scope.campaign.days_since_last_received_conversion = null;
        } else {
          return scope.campaign.days_since_last_received_conversion = 14;
        }
      };
    }
  };
}]);


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignPriceDistribution', ["$translate", "CampaignStats", "Chart", function($translate, CampaignStats, Chart) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      filters: '='
    },
    template: '<highchart config="chartConfig"></highchart>',
    link: function(scope, element, attrs) {
      var updateData;
      updateData = function() {
        return CampaignStats.getHourlyConversionPriceDistribution({
          apikey: scope.campaign.apikey,
          campaign_id: scope.campaign.id,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(data) {
          var chartData, datum;
          scope.chartConfig = Chart.getChartConfig('campaignPriceDistribution');
          chartData = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = data.length; i < len; i++) {
              datum = data[i];
              results.push([datum.price_from, datum.count]);
            }
            return results;
          })();
          return Chart.addSeries(scope.chartConfig, {
            name: $translate.instant('projectsCampaigns.directives.campaignPriceDistricution.campaignConversionCount'),
            data: chartData
          });
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignRange', function() {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      dateOnly: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_range.html',
    link: function(scope, element, attrs) {}
  };
});


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignRecentSegmentTable', ["AccessStats", function(AccessStats) {
  return {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_recent_segment_table.html',
    link: function(scope, element, attrs) {
      var updateSegmentAccessStats;
      updateSegmentAccessStats = function() {
        var campaign_segment_id, device, ref;
        campaign_segment_id = ((ref = scope.campaign.segment) != null ? ref.id : void 0) || null;
        device = AccessStats.handleCampaignDevice(scope.campaign.campaign_device);
        return AccessStats.aggregate({
          apikey: scope.campaign.apikey,
          dimension: 'minutely'
        }, {
          match: {
            start_at: {
              $gte: moment().subtract(1, 'hour').toDate()
            },
            device: device,
            campaign_segment_id: campaign_segment_id,
            is_control: null
          },
          pipeline: [
            {
              $group: {
                _id: null,
                session_count: {
                  $sum: '$session_count'
                },
                conversion_count: {
                  $sum: '$conversion_count'
                }
              }
            }
          ]
        }).then(function(access_stats) {
          return scope.segment = access_stats[0];
        });
      };
      return scope.$watchGroup(['campaign.segment.name', 'campaign.campaign_device', 'campaign.campaign_target'], updateSegmentAccessStats);
    }
  };
}]);


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignScheduleStep', ["$filter", function($filter) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      scheduleForm: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_schedule_step.html',
    link: function(scope, element, attrs) {
      scope.setToNow = function(date_obj, region) {
        date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).startOf('day').valueOf());
        return date_obj.time = moment().tz(region).hours() * 60;
      };
      scope.setToBeginningOfNextMonth = function(date_obj, region) {
        date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'days').startOf('month').valueOf());
        return date_obj.time = 0;
      };
      scope.setToBeginningOfNextNextMonth = function(date_obj, region) {
        date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'months').add(15, 'days').startOf('month').valueOf());
        return date_obj.time = 0;
      };
      scope.setToEndOfMonth = function(date_obj, region) {
        date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').startOf('day').valueOf());
        return date_obj.time = 23 * 60;
      };
      scope.setToEndOfNextMonth = function(date_obj, region) {
        date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'days').endOf('month').startOf('day').valueOf());
        return date_obj.time = 23 * 60;
      };
      scope.setToEndOfNextNextMonth = function(date_obj, region) {
        date_obj.date = $filter('changeDatetimeFrom')('regionToLocal', moment().tz(region).endOf('month').add(1, 'months').add(15, 'days').endOf('month').startOf('day').valueOf());
        return date_obj.time = 23 * 60;
      };
      scope.setToInfiniteCampaign = function() {
        scope.campaign.is_infinite = true;
        scope.campaign.end_at_obj.date = null;
        return scope.campaign.end_at_obj.time = null;
      };
      scope.setToFiniteCampaign = function() {
        return scope.campaign.is_infinite = false;
      };
      scope.checkInfiniteCampaign = function() {
        return scope.campaign.is_infinite;
      };
      scope.$watch('campaign.start_at_obj.date', function(startAt) {
        scope.scheduleForm.$setValidity('startAt', !!startAt, window);
        if (scope.campaign.status === 'preview' && !scope.campaign.was_activated_before) {
          scope.is_start_at_before_today = scope.campaign.start_at_obj.date < moment().startOf('day').valueOf();
          return scope.scheduleForm.$setValidity('startAt', !scope.is_start_at_before_today, window);
        }
      });
      scope.$watch('campaign.end_at_obj.date', function(endAt) {
        return scope.scheduleForm.$setValidity('endAt', !!endAt || (!endAt && scope.campaign.is_infinite), window);
      });
      return scope.$watch('campaign.is_infinite', function(newValue, oldValue) {
        if (newValue === false && oldValue === true) {
          scope.setToNow(scope.campaign.end_at_obj, scope.campaign.region);
        }
        if (newValue === true && oldValue === false) {
          return scope.scheduleForm.$setValidity('endAt', scope.campaign.is_infinite, window);
        }
      });
    }
  };
}]);


/***/ }),
/* 1164 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentFlag', ["$translate", "Devise", function($translate, Devise) {
  return {
    restrict: 'E',
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_flag.html',
    replace: true,
    scope: {
      segment: "=",
      short: "@"
    },
    link: function(scope, element, attrs) {
      scope.getSegmentType = function(segment) {
        if (segment) {
          return segment.segment_type;
        } else {
          return 'custom_old';
        }
      };
      scope.hasExcludableConditions = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.advertising || scope.segment.conditions_json.newsletter || scope.segment.conditions_json.logged_in || scope.segment.conditions_json.target_regions || scope.segment.conditions_json.private_browsing || scope.hasValidLimitToLandingPageTypesCondition() || scope.hasValidExcludeLandingPageTypesCondition() || scope.hasValidLimitToOfferPageTypesCondition() || scope.hasValidExcludeOfferPageTypesCondition() || scope.hasValidLimitToSessionsWhoVisitCondition() || scope.hasValidExcludeSessionsWhoVisitCondition() || scope.hasValidTriggersCondition();
      };
      scope.hasValidLimitToLandingPageTypesCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.limit_to_landing_page_types && scope.segment.conditions_json.limit_to_landing_page_types.length && scope.segment.conditions_json.limit_to_landing_page_types[0] !== 'NOT_SELECTED';
      };
      scope.hasValidExcludeLandingPageTypesCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.exclude_landing_page_types && scope.segment.conditions_json.exclude_landing_page_types.length && scope.segment.conditions_json.exclude_landing_page_types[0] !== 'NOT_SELECTED';
      };
      scope.hasValidLimitToOfferPageTypesCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.limit_to_offer_page_types && scope.segment.conditions_json.limit_to_offer_page_types.length && scope.segment.conditions_json.limit_to_offer_page_types[0] !== 'NOT_SELECTED';
      };
      scope.hasValidExcludeOfferPageTypesCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.exclude_offer_page_types && scope.segment.conditions_json.exclude_offer_page_types.length && scope.segment.conditions_json.exclude_offer_page_types[0] !== 'NOT_SELECTED';
      };
      scope.hasValidLimitToSessionsWhoVisitCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.limit_to_sessions_who_visit && scope.segment.conditions_json.limit_to_sessions_who_visit.length && scope.segment.conditions_json.limit_to_sessions_who_visit[0] !== 'NOT_SELECTED';
      };
      scope.hasValidExcludeSessionsWhoVisitCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.exclude_sessions_who_visit && scope.segment.conditions_json.exclude_sessions_who_visit.length && scope.segment.conditions_json.exclude_sessions_who_visit[0] !== 'NOT_SELECTED';
      };
      scope.hasValidTriggersCondition = function() {
        if (!scope.segment || !scope.segment.conditions_json) {
          return false;
        }
        return scope.segment.conditions_json.triggers && scope.segment.conditions_json.triggers.length && scope.segment.conditions_json.triggers[0] !== 'NOT_SELECTED';
      };
      scope.hasAdditionalCustom = function() {
        if (!scope.segment || scope.segment.segment_type === 'custom') {
          return false;
        }
        return scope.segment.json !== '{}';
      };
      scope.Devise = Devise;
      return scope.$watch('segment', function(newVal, oldVal) {
        var typeText;
        if (newVal && newVal.segment_type) {
          typeText = (function() {
            switch (newVal.segment_type) {
              case 'new':
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.new');
              case 'cv_users':
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.cvUsers');
              case 'new_inverse':
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.newInverse');
              case 'inactive':
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.inactive');
              case 'custom':
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.custom');
              case 'all':
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.all');
              default:
                return $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.custom');
            }
          })();
        } else {
          typeText = $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.custom');
        }
        return scope.typeText = typeText;
      });
    }
  };
}]);


/***/ }),
/* 1165 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentGraph', ["$q", "$translate", "AccessStats", "CampaignStats", "Chart", "currencies", function($q, $translate, AccessStats, CampaignStats, Chart, currencies) {
  return {
    restrict: 'E',
    require: '?filters',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_graph.html',
    link: function(scope, element, attrs) {
      var addAccessStats, addCampaignSeries, addCampaignStats, addSessionSeries, currency;
      currency = currencies[scope.project.currency];
      addSessionSeries = function(name, data) {
        return Chart.addSeries(scope.sessionChartConfig, {
          name: name,
          data: data,
          tooltip: {
            valueSuffix: $translate.instant('projectsCampaigns.directives.campaignSegmentGraph.session'),
            valueDecimals: 0
          }
        });
      };
      addCampaignSeries = function(name, data) {
        return Chart.addSeries(scope.conversionChartConfig, {
          name: name,
          data: data,
          tooltip: {
            valueSuffix: currency.suffix,
            valueDecimals: currency.fractionSize
          }
        });
      };
      addCampaignStats = function(campaign_stats) {
        var cumulative_delivery_conversion_price, cumulative_delivery_conversion_price_stats, cumulative_delivery_count, cumulative_delivery_count_stats, i, len, stats;
        if (!campaign_stats || campaign_stats.length === 0) {
          return;
        }
        cumulative_delivery_count = 0;
        cumulative_delivery_conversion_price = 0;
        cumulative_delivery_count_stats = [[campaign_stats[0].start_at, 0]];
        cumulative_delivery_conversion_price_stats = [[campaign_stats[0].start_at, 0]];
        for (i = 0, len = campaign_stats.length; i < len; i++) {
          stats = campaign_stats[i];
          if (stats.is_control) {
            continue;
          }
          cumulative_delivery_count += stats.delivery_count;
          cumulative_delivery_conversion_price += stats.conversion_price;
          cumulative_delivery_count_stats.push([stats.start_at, cumulative_delivery_count]);
          cumulative_delivery_conversion_price_stats.push([stats.start_at, cumulative_delivery_conversion_price]);
        }
        addSessionSeries($translate.instant('projectsCampaigns.directives.campaignSegmentGraph.deliveryCount'), cumulative_delivery_count_stats);
        return addCampaignSeries($translate.instant('projectsCampaigns.directives.campaignSegmentGraph.distributionTargetSales'), cumulative_delivery_conversion_price_stats);
      };
      addAccessStats = function(access_stats) {
        var cumulative_conversion_price, cumulative_conversion_price_stats, cumulative_session_count, cumulative_session_count_stats, i, len, stats;
        if (!access_stats || access_stats.length === 0) {
          return;
        }
        cumulative_session_count = 0;
        cumulative_conversion_price = 0;
        cumulative_session_count_stats = [[access_stats[0].start_at, 0]];
        cumulative_conversion_price_stats = [[access_stats[0].start_at, 0]];
        for (i = 0, len = access_stats.length; i < len; i++) {
          stats = access_stats[i];
          cumulative_session_count += stats.session_count;
          cumulative_conversion_price += stats.conversion_price;
          cumulative_session_count_stats.push([stats.start_at, cumulative_session_count]);
          cumulative_conversion_price_stats.push([stats.start_at, cumulative_conversion_price]);
        }
        addSessionSeries($translate.instant('projectsCampaigns.directives.campaignSegmentGraph.segmentSessionCount'), cumulative_session_count_stats);
        return addCampaignSeries($translate.instant('projectsCampaigns.directives.campaignSegmentGraph.segmentSales'), cumulative_conversion_price_stats);
      };
      scope.updateData = function() {
        var from, ref, to;
        from = _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()]);
        from = moment(from).startOf('day').toDate();
        to = _.min([scope.campaign.end_at, moment(scope.filters.end_at).toDate()]);
        to = moment(to).add(1, 'days').startOf('day').toDate();
        return $q.all([
          CampaignStats.find({
            dimension: 'daily',
            campaign_id: scope.campaign.id,
            apikey: scope.campaign.apikey,
            start_at: from.valueOf(),
            end_at: to.valueOf()
          }), AccessStats.findDefault({
            apikey: scope.campaign.apikey,
            dimension: 'daily'
          }, {
            device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device),
            campaign_segment_id: ((ref = scope.campaign.segment) != null ? ref.id : void 0) || null,
            is_control: null,
            start_at: {
              $gte: from,
              $lt: to
            }
          })
        ]).then(function(arg) {
          var access_stats, campaign_stats;
          campaign_stats = arg[0], access_stats = arg[1];
          scope.sessionChartConfig = Chart.getChartConfig('segment');
          scope.conversionChartConfig = Chart.getChartConfig('segment');
          scope.sessionChartConfig.series = [];
          scope.conversionChartConfig.series = [];
          addAccessStats(access_stats);
          return addCampaignStats(campaign_stats);
        });
      };
      return scope.$watch('filters', scope.updateData, true);
    }
  };
}]);


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignSegmentPanels', ["$q", "CampaignStats", "AccessStats", "currencies", function($q, CampaignStats, AccessStats, currencies) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_panels.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.currency = currencies[scope.project.currency];
      updateData = function() {
        var from, ref, to;
        from = _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()]);
        from = moment(from).startOf('day').toDate();
        to = _.min([scope.campaign.end_at, moment(scope.filters.end_at).toDate()]);
        to = moment(to).add(1, 'days').startOf('day').toDate();
        return $q.all([
          CampaignStats.aggregate({
            dimension: 'daily',
            campaign_id: scope.campaign.id,
            apikey: scope.campaign.apikey,
            start_at: from.valueOf(),
            end_at: to.valueOf()
          }), AccessStats.aggregateDefault({
            apikey: scope.campaign.apikey,
            dimension: 'daily'
          }, {
            device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device),
            campaign_segment_id: ((ref = scope.campaign.segment) != null ? ref.id : void 0) || null,
            is_control: null,
            start_at: {
              $gte: from,
              $lt: to
            }
          })
        ]).then(function(arg) {
          var access_stats, campaign_stats;
          campaign_stats = arg[0], access_stats = arg[1];
          scope.campaign_stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
          return scope.access_stats = access_stats[0];
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentSummary', ["$q", "CampaignStats", "CampaignSegmentStats", "AccessStats", "currencies", function($q, CampaignStats, CampaignSegmentStats, AccessStats, currencies) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      filters: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_summary.html',
    link: function(scope, element, attrs) {
      var updateData;
      scope.currency = currencies[scope.project.currency];
      updateData = function() {
        var from, ref, ref1, to;
        from = _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()]);
        from = moment(from).startOf('day').toDate();
        to = _.min([scope.campaign.end_at, moment(scope.filters.end_at).toDate()]);
        to = moment(to).add(1, 'days').startOf('day').toDate();
        return $q.all([
          CampaignStats.aggregate({
            dimension: 'daily',
            campaign_id: scope.campaign.id,
            apikey: scope.campaign.apikey,
            start_at: from.valueOf(),
            end_at: to.valueOf()
          }), AccessStats.aggregateDefault({
            apikey: scope.campaign.apikey,
            dimension: 'daily'
          }, {
            device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device),
            campaign_segment_id: ((ref = scope.campaign.segment) != null ? ref.id : void 0) || null,
            is_control: null,
            start_at: {
              $gte: from,
              $lt: to
            }
          }), CampaignSegmentStats.aggregate({
            apikey: scope.campaign.apikey,
            dimension: 'daily'
          }, {
            match: {
              campaign_id: scope.campaign.id,
              campaign_segment_id: ((ref1 = scope.campaign.segment) != null ? ref1.id : void 0) || null,
              start_at: {
                $gte: from,
                $lt: to
              }
            },
            pipeline: [
              {
                $group: {
                  _id: null,
                  session_count: {
                    $sum: "$session_count"
                  }
                }
              }
            ]
          })
        ]).then(function(arg) {
          var access_stats, campaign_segment_stats, campaign_stats;
          campaign_stats = arg[0], access_stats = arg[1], campaign_segment_stats = arg[2];
          scope.campaign_stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
          scope.access_stats = access_stats[0];
          return scope.campaign_segment_stats = campaign_segment_stats[0];
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1168 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignSteps', ["$state", function($state) {
  return {
    restrict: 'E',
    scope: {
      allValid: '=',
      basicForm: '=',
      templateForm: '=',
      incentiveForm: '=',
      botbonnieForm: '=',
      policyForm: '=',
      timingForm: '=',
      scheduleForm: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_steps.html',
    link: function(scope, element, attrs) {
      return scope.$state = $state;
    }
  };
}]);


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignTable', ["$state", "$filter", "$q", "Project", "Campaign", "CampaignStats", "ReportCampaignStats", "ReportRange", "Devise", function($state, $filter, $q, Project, Campaign, CampaignStats, ReportCampaignStats, ReportRange, Devise) {
  return {
    restrict: 'A',
    scope: {
      project: '=',
      campaigns: '=',
      filters: '=',
      showActions: '=',
      showStats: '=',
      showCampaignDetail: '=',
      showControlPercent: '=',
      showClearanceSettings: '=',
      showHiddenAb: '=',
      hasHiddenAb: '=',
      isAb: '=',
      isReport: '=',
      status: '=',
      onUpdate: '&',
      canShowInvoiceAmount: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_table.html',
    link: function(scope, element, attrs) {
      var getCampaignStats, getReportCampaignStats;
      scope.Devise = Devise;
      scope.pagination = {
        itemsPerPage: 25,
        currentPage: 1
      };
      scope.Project = Project;
      scope.sortedCampaigns = [];
      scope.canAddIncentive = false;
      scope.vm = {
        id: Math.floor(Math.random() * 10),
        selected: false
      };
      scope.pageChanged = function() {
        var begin, end;
        begin = scope.pagination.itemsPerPage * (scope.pagination.currentPage - 1);
        end = begin + scope.pagination.itemsPerPage;
        scope.sortedCampaigns = _.orderBy(scope.campaigns, ['current_status', 'id'], ['asc', 'desc']);
        scope.pagedCampaigns = scope.sortedCampaigns.slice(begin, end);
        scope.canAddIncentive = Devise.isMaster() && _.some(scope.sortedCampaigns, function(campaign) {
          return Campaign.canAddIncentive(campaign);
        });
        if (scope.showStats) {
          if (scope.isReport) {
            return getReportCampaignStats();
          } else {
            return getCampaignStats();
          }
        }
      };
      getCampaignStats = function() {
        var apikey, campaign, campaign_ids;
        if (!scope.pagedCampaigns.length) {
          return;
        }
        apikey = scope.pagedCampaigns[0].apikey;
        campaign_ids = (function() {
          var i, len, ref, results;
          ref = scope.pagedCampaigns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            campaign = ref[i];
            results.push(campaign.id);
          }
          return results;
        })();
        return CampaignStats.aggregate({
          dimension: 'daily',
          apikey: apikey,
          campaign_ids: campaign_ids,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          var calculatedInvoiceAmount, i, len, ref, results, statsById;
          statsById = CampaignStats.groupById(campaign_stats);
          ref = scope.pagedCampaigns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            campaign = ref[i];
            campaign.stats = statsById[campaign.id];
            calculatedInvoiceAmount = CampaignStats.calculateInvoiceAmount(scope.project, campaign, campaign.stats);
            results.push(_.assign(campaign.stats, {
              invoice_amount: calculatedInvoiceAmount
            }));
          }
          return results;
        });
      };
      getReportCampaignStats = function() {
        var apikey;
        if (!scope.pagedCampaigns.length) {
          return;
        }
        apikey = scope.pagedCampaigns[0].apikey;
        return ReportCampaignStats.find({
          apikey: apikey,
          dimension: scope.filters.dimension
        }, {
          match: {
            status: scope.status,
            begin_at: scope.filters.begin_at,
            start_at: scope.filters.start_at ? scope.filters.start_at : void 0
          }
        }).then(function(report_campaign_stats) {
          var campaign, i, len, ref, results, statsById;
          statsById = _.keyBy(report_campaign_stats, 'campaign_id');
          ref = scope.pagedCampaigns;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            campaign = ref[i];
            results.push(campaign.stats = statsById[campaign.id]);
          }
          return results;
        });
      };
      scope.$watchCollection('campaigns', function(newValue) {
        if (!newValue) {
          return;
        }
        scope.campaigns = newValue;
        return scope.pageChanged();
      });
      scope.$watch('filters', function(newValue) {
        if (!newValue) {
          return;
        }
        scope.filters = newValue;
        return scope.pageChanged();
      });
      scope.$watch('vm', function(vm) {
        return scope.sortedCampaigns.forEach(function(campaign) {
          if (Campaign.canAddIncentive(campaign)) {
            return campaign.selected = vm.selected;
          }
        });
      }, true);
      return scope.$watch('sortedCampaigns', function(newCampaigns) {
        var deselected, selectable, selected;
        selectable = _.filter(newCampaigns, function(campaign) {
          return Campaign.canAddIncentive(campaign);
        });
        selected = _.every(selectable, function(campaign) {
          return campaign.selected;
        });
        if (selected) {
          scope.vm.selected = true;
          return;
        }
        deselected = _.every(selectable, function(campaign) {
          return !campaign.selected;
        });
        if (deselected) {
          scope.vm.selected = false;
        }
      }, true);
    }
  };
}]);


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignTableRow', ["$state", "$translate", "Project", "Campaign", "CampaignStats", "ClearanceItemSet", "Devise", "currencies", function($state, $translate, Project, Campaign, CampaignStats, ClearanceItemSet, Devise, currencies) {
  return {
    restrict: 'A',
    require: ['?campaign', '?filters'],
    scope: {
      project: '=',
      campaign: '=',
      filters: '=',
      showActions: '=',
      showStats: '=',
      showCampaignDetail: '=',
      showControlPercent: '=',
      showClearanceSettings: '=',
      showHiddenAb: '=',
      hasHiddenAb: '=',
      isAb: '=',
      onUpdate: '&',
      canShowInvoiceAmount: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_table_row.html',
    link: function(scope, element, attrs) {
      var isMasterAndWidgetDisabled, ref, ref1, ref2;
      scope.Project = Project;
      scope.Devise = Devise;
      scope.currency = currencies[scope.project.currency];
      scope.previewUrl = Campaign.previewUrl(scope.campaign.project_base_url, scope.campaign);
      scope.canShow = (ref = scope.campaign.current_status) !== 'incomplete' && ref !== 'preview' && ref !== 'pending';
      scope.canEdit = (ref1 = scope.campaign.current_status) === 'incomplete' || ref1 === 'preview' || ref1 === 'pending';
      scope.canDestroy = (ref2 = scope.campaign.status) === 'incomplete' || ref2 === 'preview';
      scope.adminUrl = Campaign.adminUrl(scope.project.id, scope.campaign);
      scope.canAddIncentive = Devise.isMaster() && Campaign.canAddIncentive(scope.campaign);
      scope.isV1 = scope.campaign.api_version === 1;
      if (scope.campaign.clearance_item_set_id) {
        ClearanceItemSet.find({
          projectId: scope.campaign.project_id,
          id: scope.campaign.clearance_item_set_id
        }).then(function(res) {
          return scope.clearanceItemSet = res;
        });
      }
      scope.isMaster = Devise.isMaster();
      scope.showEnabledIw = scope.campaign.iw_current_status === 'enable';
      scope.isNoControlGroupCampaign = scope.campaign.campaign_control_percent === 0 || scope.campaign.is_secret_ab;
      scope.canToggleActive = _.includes(['active', 'blocked'], scope.campaign.current_status);
      scope.canFinish = !scope.showEnabledIw && _.includes(['active', 'pending', 'blocked'], scope.campaign.current_status);
      isMasterAndWidgetDisabled = scope.isMaster && !scope.showEnabledIw;
      scope.canGoPreview = isMasterAndWidgetDisabled && scope.campaign.current_status === 'pending';
      scope.canGoIncomplete = isMasterAndWidgetDisabled && scope.campaign.current_status === 'preview';
      scope.canDestroy = isMasterAndWidgetDisabled && _.includes(['incomplete', 'preview'], scope.campaign.current_status);
      if (scope.campaign.was_activated_before) {
        scope.destroyConfirmMessage = $translate.instant('projectsCampaigns.directives.campaignTableRow.confirmDeleteStartedCampaign');
      } else {
        scope.destroyConfirmMessage = $translate.instant('projectsCampaigns.directives.campaignTableRow.confirmDeleteCampaign');
      }
      scope.chisq_test = true;
      scope.$watch('campaign.stats', function(stats) {
        if (!stats) {
          return;
        }
        return scope.chisq_test = CampaignStats.chisqTest(scope.campaign.stats);
      }, true);
      scope.githubUrl = '';
      scope.fetchGithubUrl = function() {
        if (scope.githubUrl !== '') {
          return Promise.resolve();
        }
        return Campaign.githubUrl({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id
        }).then(function(githubUrl) {
          return scope.githubUrl = githubUrl;
        });
      };
      scope.copy = function() {
        return Campaign.copy({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id
        }).then(scope.onUpdate);
      };
      scope.destroy = function() {
        return Campaign.destroy({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id
        }).then(scope.onUpdate);
      };
      scope.finish = function() {
        return Campaign.finish({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id
        }).then(scope.onUpdate);
      };
      scope.goToShow = function() {
        return $state.go('admin.projects.campaigns.show.stats', {
          campaignId: scope.campaign.id
        });
      };
      scope.goToEdit = function(step) {
        var state;
        if (scope.isV1) {
          state = 'admin.projects.campaigns.edit';
          if (step) {
            state += "." + step;
          }
          return $state.go(state, {
            campaignId: scope.campaign.id
          });
        }
      };
      scope.goToConfirm = function() {
        return $state.go('admin.projects.campaigns.confirm', {
          campaignId: scope.campaign.id
        });
      };
      scope.goPreview = function() {
        return Campaign.preview({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id
        }).then(scope.onUpdate);
      };
      scope.goIncomplete = function() {
        return Campaign.incomplete({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id
        }).then(scope.onUpdate);
      };
      scope.toggleActive = function() {
        return Campaign.toggleActive({
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id,
          state: scope.campaign.status === 'blocked'
        }).then(scope.onUpdate);
      };
      scope.getCSV = function() {
        return Campaign.getCSV({
          csvType: 'conversions',
          apikey: scope.campaign.apikey,
          campaignId: scope.campaign.id,
          isSecretAb: scope.campaign.is_secret_ab,
          filters: scope.filters,
          fractionSize: scope.currency.fractionSize
        });
      };
      return scope.getFileName = function() {
        var end_at, start_at;
        start_at = moment(scope.filters.start_at).format('YYYYMMDD');
        end_at = moment(scope.filters.end_at).format('YYYYMMDD');
        return scope.filename = "campaign_" + scope.campaign.id + "_" + start_at + "_" + end_at + ".csv";
      };
    }
  };
}]);


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignTemplateItem', ["$modal", "$translate", "Image", "lib", function($modal, $translate, Image, lib) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      item: '=',
      disabled: "@"
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_template_item.html',
    link: function(scope, element, attrs) {
      return scope.browseImages = function(elemName) {
        return $modal.open({
          templateUrl: '/templates/projects.campaigns/views/image_browser.html',
          controller: "ImageBrowserController",
          size: 'lg',
          resolve: {
            images: function() {
              return Image.all({
                projectId: scope.campaign.project_id
              });
            },
            currentImageUrl: function() {
              return scope.campaign.element.message[elemName];
            }
          }
        }).result.then(function(selectedItem) {
          return scope.campaign.element.message[elemName] = selectedItem.image_url;
        });
      };
    }
  };
}]);


/***/ }),
/* 1172 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignTemplateSetting', function() {
  return {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_template_setting.html',
    link: function(scope, element, attrs) {
      return scope.viewOptions = {
        details: false
      };
    }
  };
});


/***/ }),
/* 1173 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignTemplateStep', ["InterestWidget", "Campaign", "$filter", function(InterestWidget, Campaign, $filter) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      templates: '=',
      templateForm: '=',
      pageTypes: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_template_step.html',
    link: function(scope, element, attrs) {
      var template;
      InterestWidget.updateCampaignWithInterestWidget(scope.campaign);
      scope.Campaign = Campaign;
      scope.choosingTemplate = true;
      if (scope.campaign.template_type) {
        template = _.find(scope.templates, {
          name: scope.campaign.template_type
        });
        if (template) {
          scope.campaign.campaign_type = template.campaign_type;
          scope.campaign.template = template;
          scope.choosingTemplate = false;
        }
      }
      scope.hasOptionType = function(option_category) {
        var i, len, ref;
        if (!scope.campaign.template) {
          return void 0;
        }
        ref = scope.campaign.template.template;
        for (i = 0, len = ref.length; i < len; i++) {
          element = ref[i];
          if (element.option_category === option_category) {
            return true;
          }
        }
      };
      scope.chooseTemplate = function(template) {
        scope.choosingTemplate = false;
        if (scope.campaign.template_type === template.name) {
          return;
        }
        scope.campaign.campaign_type = template.campaign_type;
        scope.campaign.template_type = template.name;
        scope.campaign.template = template;
        InterestWidget.updateCampaignWithInterestWidget(scope.campaign);
        if (!scope.campaign.template_type) {
          return scope.setDefault();
        } else {
          return scope.mergeElement();
        }
      };
      scope.mergeElement = function() {
        var i, len, originalElement, ref, temp;
        originalElement = scope.campaign.element.message;
        temp = {
          message: {}
        };
        ref = scope.campaign.template.template;
        for (i = 0, len = ref.length; i < len; i++) {
          element = ref[i];
          if (element.name in originalElement) {
            temp.message[element.name] = originalElement[element.name];
          } else if ("default" in element) {
            if (typeof element["default"] === 'string') {
              temp.message[element.name] = $filter('translate')(element["default"]);
            } else {
              temp.message[element.name] = element["default"];
            }
          } else {
            temp.message[element.name] = "";
          }
        }
        return scope.campaign.element = temp;
      };
      scope.setDefault = function() {
        var i, len, ref, results;
        scope.campaign.custom_css = '';
        scope.campaign.element = {
          message: {}
        };
        ref = scope.campaign.template.template;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          element = ref[i];
          if ("default" in element) {
            if (typeof element["default"] === 'string') {
              results.push(scope.campaign.element.message[element.name] = $filter('translate')(element["default"]));
            } else {
              results.push(scope.campaign.element.message[element.name] = element["default"]);
            }
          } else {
            results.push(scope.campaign.element.message[element.name] = "");
          }
        }
        return results;
      };
      scope.hideModalTemplateConfigItem = function(item) {
        var ref, ref1, ref2;
        if ((ref = scope.campaign.template_type) !== 'bannar_and_link_pc' && ref !== 'bannar_and_link_sp') {
          return false;
        }
        if (item.option_category !== 'view1') {
          return false;
        }
        switch (scope.campaign.element.message['btn_click_action_offer']) {
          case 'close_modal':
            if ((ref1 = item.name) === 'coupon_code_copied_text_offer' || ref1 === 'linkage_url_offer' || ref1 === 'exclude_url_offer' || ref1 === 'remove_target_blank' || ref1 === 'banner_click_action') {
              return true;
            } else {
              return false;
            }
            break;
          case 'open_link':
            if (item.name === 'coupon_code_copied_text_offer') {
              return true;
            } else {
              return false;
            }
            break;
          case 'copy_coupon_code':
            if ((ref2 = item.name) === 'linkage_url_offer' || ref2 === 'exclude_url_offer' || ref2 === 'remove_target_blank') {
              return true;
            } else {
              return false;
            }
            break;
          default:
            return false;
        }
      };
      scope.hideCodeIncentiveConfigItem = function(item) {
        var incentive, ref, ref1, ref2;
        if (!/^timesale_ver5/.test(scope.campaign.template_type)) {
          return false;
        }
        incentive = scope.campaign.incentives[0];
        if (!incentive) {
          return false;
        }
        if ((ref = incentive.incentive_type) !== 'coupon_url' && ref !== 'api_url') {
          return false;
        }
        if ((ref1 = item.name) === 'code_name' || ref1 === 'code_copy' || ref1 === 'enable_coupon_clipboard' || ref1 === 'code_condition') {
          return true;
        }
        if (incentive.incentive_type === 'api_url' && ((ref2 = item.name) === 'linkage_url' || ref2 === 'remove_target_blank_present')) {
          return true;
        }
        return false;
      };
      scope.showCouponBaseUrlHint = function(item) {
        var incentive, ref, ref1;
        incentive = scope.campaign.incentives[0];
        if (!incentive) {
          return false;
        }
        if ((ref = incentive.incentive_type) !== 'coupon_url' && ref !== 'botbonnie_short_url') {
          return false;
        }
        if ((ref1 = item.name) === 'linkage_url' || ref1 === 'linkage_url_offer') {
          return true;
        }
        return false;
      };
      return scope.hideTimerConfigItem = function(item) {
        if (item.name === 'enables_banner_timer' && !scope.campaign.element.message.enables_timer) {
          return true;
        }
        return false;
      };
    }
  };
}]);


/***/ }),
/* 1174 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignTimingStep', ["$state", "$q", "$translate", "CampaignSegment", "Project", "Meta", "MongoSession", "SegmentMatcher", "$filter", function($state, $q, $translate, CampaignSegment, Project, Meta, MongoSession, SegmentMatcher, $filter) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      campaign: '=',
      timingForm: '=',
      configurationTypes: '='
    },
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_timing_step.html',
    link: function(scope, element, attrs) {
      var DATE_FROM, DATE_UNTIL, SAMPLE_DATE_FROM, checkTimingSegmentOverlap, confirmTotalQuery, findCampaignPolicySet, findSessions, setValidity;
      DATE_UNTIL = moment().subtract(1, 'hours').toDate();
      DATE_FROM = moment(DATE_UNTIL).subtract(2, 'week').toDate();
      SAMPLE_DATE_FROM = moment(DATE_UNTIL).subtract(1, 'day').toDate();
      scope.campaign_policy_has_errors = false;
      scope.timing_overrides_segment = false;
      scope.sampleSessionSize = 500;
      scope.sessions = [];
      scope.adminProjectsDetailUrl = $state.href('admin.projects.detail', {
        projectId: scope.campaign.project_id
      });
      scope.timingSettingsURL = ZC_CONFIG.AIDEAL_URL + "/site/" + scope.project.apikey + "/campaigns/" + scope.campaign.id + "/timing";
      scope.sampling_ranges = {};
      Meta.getSamplingRanges().then(function(res) {
        return scope.sampling_ranges = res;
      });
      Project.get(scope.campaign.project_id, {
        with_campaign_policies: true
      }).then(function(project) {
        var i, len, policy_set_found, ref, set;
        scope.campaign_policy_sets = project.campaign_policy_sets;
        scope.campaign_policy_sets.unshift({
          id: null,
          name: $translate.instant('projectsCampaigns.directives.campaignTimingStep.unspecified')
        });
        policy_set_found = false;
        ref = scope.campaign_policy_sets;
        for (i = 0, len = ref.length; i < len; i++) {
          set = ref[i];
          if (set.id === scope.campaign.campaign_policy_set_id) {
            policy_set_found = true;
            break;
          }
        }
        if (!policy_set_found) {
          scope.campaign.campaign_policy_set = null;
          scope.campaign.campaign_policy_set_id = null;
        }
        findCampaignPolicySet(scope.campaign.campaign_policy_set_id);
        return scope.$watchGroup(['campaign.segment_id', 'campaign.campaign_policy_set_id'], checkTimingSegmentOverlap, true);
      });
      confirmTotalQuery = function() {
        var promises;
        scope.campaign_policy_has_errors = false;
        promises = _.map(scope.campaign.campaign_policy_set.campaign_policies, function(campaign_policy) {
          return $q(function(resolve, reject) {
            var sessionQuery;
            sessionQuery = SegmentMatcher.createSegmentQuery(campaign_policy);
            sessionQuery = _.assignIn(sessionQuery, {
              apikey: scope.project.apikey,
              opened_at: {
                $gte: moment().subtract(1, 'hours').toDate()
              }
            });
            return MongoSession.find(sessionQuery, {
              limit: 1
            })["catch"](function(error) {
              return reject(error);
            });
          });
        });
        promises = promises.concat(_.map(scope.campaign.campaign_policy_set.campaign_policies, function(campaign_policy) {
          return $q(function(resolve, reject) {
            var historyQuery;
            historyQuery = SegmentMatcher.createHistoryQuery(campaign_policy);
            historyQuery = _.assignIn(historyQuery, {
              apikey: scope.project.apikey,
              opened_at: {
                $gte: moment().subtract(1, 'hours').toDate()
              }
            });
            return MongoSession.find(historyQuery, {
              limit: 1
            })["catch"](function(error) {
              return reject(error);
            });
          });
        }));
        promises = promises.concat(_.map(scope.campaign.campaign_policy_set.campaign_policies, function(campaign_policy) {
          return $q(function(resolve, reject) {
            var visitorQuery;
            visitorQuery = SegmentMatcher.createVisitorQuery(campaign_policy);
            visitorQuery = _.assignIn(visitorQuery, {
              apikey: scope.project.apikey,
              opened_at: {
                $gte: moment().subtract(1, 'hours').toDate()
              }
            });
            return MongoSession.find(visitorQuery, {
              limit: 1
            })["catch"](function(error) {
              return reject(error);
            });
          });
        }));
        return $q.all(promises)["catch"](function(errors) {
          alertify.error($translate.instant('projectsCampaigns.directives.campaignTimingStep.errorTiming'));
          return scope.campaign_policy_has_errors = true;
        });
      };
      findCampaignPolicySet = function(campaign_policy_set_id) {
        scope.campaign.campaign_policy_set = _.find(scope.campaign_policy_sets, {
          id: campaign_policy_set_id
        });
        if (scope.campaign.campaign_policy_set) {
          return confirmTotalQuery();
        }
      };
      findSessions = function(query) {
        var device;
        query = SegmentMatcher.createSegmentQuery(query);
        device = SegmentMatcher.getCombinedDeviceCondition(scope.campaign.campaign_device);
        return MongoSession.find(_.assignIn(query, {
          apikey: scope.project.apikey,
          device: device,
          opened_at: {
            $gte: SAMPLE_DATE_FROM,
            $lt: DATE_UNTIL
          }
        }), {
          limit: 1,
          fields: ['_id']
        }).then(function(found) {
          if (!found) {
            return [];
          }
          return MongoSession.find(_.assignIn(query, {
            apikey: scope.project.apikey,
            device: device,
            opened_at: {
              $gte: DATE_FROM,
              $lt: DATE_UNTIL
            }
          }), {
            sort: '-opened_at',
            limit: scope.sampleSessionSize,
            fields: ['conversion_count', 'predictions_min_before_cart.global_conversion_rate', 'predictions_max_before_cart.global_conversion_rate', 'average_recent5_item_price']
          });
        });
      };
      scope.getSegmentData = function() {
        if (!scope.campaign.segment) {
          return;
        }
        if (!scope.campaign.segment.conditions_json) {
          return;
        }
        return CampaignSegment.getMongoQuery(scope.campaign.segment).then(function(query) {
          return findSessions(query);
        }).then(function(sessions) {
          return scope.sessions = sessions;
        });
      };
      setValidity = function(segmentId) {
        return scope.timingForm.$setValidity('segmentId', !!segmentId, window);
      };
      checkTimingSegmentOverlap = function() {
        var segment_mongo_query_keys, selected_policy_set, selected_segment;
        scope.timing_overrides_segment = false;
        selected_segment = _.find(scope.project.campaign_segments, {
          id: scope.campaign.segment_id
        });
        if (!selected_segment) {
          return;
        }
        selected_policy_set = _.find(scope.campaign_policy_sets, {
          id: scope.campaign.campaign_policy_set_id
        });
        if (!selected_policy_set) {
          return;
        }
        segment_mongo_query_keys = _.keys(selected_segment.mongo_query);
        return _.each(selected_policy_set.campaign_policies, function(policy) {
          var timing_mongo_query_keys;
          timing_mongo_query_keys = $filter('segmentRelevantHeaders')([policy]);
          if (_.intersection(segment_mongo_query_keys, timing_mongo_query_keys).length) {
            scope.timing_overrides_segment = true;
          }
        });
      };
      scope.$watch('campaign.campaign_policy_set_id', findCampaignPolicySet);
      scope.$watch('campaign.segment_id', setValidity);
      scope.$watchGroup(['campaign.campaign_device', 'campaign.segment', 'sampleSessionSize'], scope.getSegmentData, true);
      return scope.$watch('campaign.configuration_type', function() {
        var ref;
        if (((ref = scope.campaign.configuration_type) !== 'ai_model' && ref !== 'uplift_modeling') && scope.campaign.score_threshold !== 0.5) {
          scope.campaign.score_threshold = 0.5;
        }
        if (scope.campaign.configuration_type !== 'ai_model' && scope.campaign.auto_configuration) {
          scope.campaign.auto_configuration = false;
        }
        if (scope.campaign.configuration_type !== 'conversion_prediction' && scope.campaign.exclude_cart_button_click) {
          scope.campaign.exclude_cart_button_click = false;
        }
        if (scope.campaign.configuration_type !== 'conversion_prediction' && scope.campaign.exclude_no_price) {
          scope.campaign.exclude_no_price = false;
        }
        if (scope.campaign.configuration_type !== 'csv_upload' && scope.campaign.campaign_policy_set_id !== null) {
          scope.campaign.campaign_policy_set_id = null;
        }
        if (scope.campaign.configuration_type !== 'sampling' && scope.campaign.sampling_range !== null) {
          return scope.campaign.sampling_range = null;
        }
      });
    }
  };
}]);


/***/ }),
/* 1175 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('graphDimensionSelect', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    require: ['?dimension', '?onUpdate'],
    scope: {
      dimension: "=dimension",
      onUpdate: "&onUpdate"
    },
    templateUrl: '/templates/projects.campaigns/views/directives/graph_dimension_select.html',
    link: function(scope, elem, attrs) {
      if (!scope.dimension) {
        scope.dimension = 'daily';
      }
      return scope.setDimension = function(dim) {
        scope.dimension = dim;
        return $timeout(function() {
          scope.$apply();
          return scope.onUpdate();
        });
      };
    }
  };
}]);


/***/ }),
/* 1176 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcHeatmapTable', function() {
  return {
    restrict: 'E',
    scope: {
      pages: '='
    },
    templateUrl: '/templates/projects.heatmap/views/directives/heatmap_table.html'
  };
});


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('campaignDevice', ["$translate", function($translate) {
  var directive;
  directive = {
    restrict: "A",
    require: '?ngModel',
    scope: {
      campaign: "=ngModel"
    },
    link: function(scope, element, attrs) {
      var deviceClass, txt;
      $(element).addClass("label");
      deviceClass = "";
      txt = "";
      switch (scope.campaign.campaign_device) {
        case "pc":
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.pc');
          deviceClass = "device-desktop";
          break;
        case "sp":
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.sp');
          deviceClass = "device-mobile";
          break;
        case "iphone":
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.iphone');
          deviceClass = "device-iphone";
          break;
        case "devicefree":
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignDevice.devicefree');
          deviceClass = "device-devicefree";
      }
      $(element).addClass(deviceClass);
      return $(element).html(txt);
    }
  };
  return directive;
}]);


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcLabelCampaignSegment', ["$translate", function($translate) {
  var directive;
  directive = {
    restrict: 'A',
    require: '?ngModel',
    scope: {
      campaign: '=ngModel'
    },
    link: function(scope, element, attrs) {
      var segmentClass, txt;
      $(element).addClass('label');
      segmentClass = '';
      txt = '';
      switch (scope.campaign.campaign_target) {
        case 'new_user':
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.newUser');
          segmentClass = 'segment-new';
          break;
        case 'repeat':
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.repeat');
          segmentClass = 'segment-repeat';
          break;
        case 'no_cv':
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.noCv');
          segmentClass = 'segment-no';
          break;
        case 'one_cv':
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.oneCv');
          segmentClass = 'segment-one_cv';
          break;
        case 'loyal_user':
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.loyalUser');
          segmentClass = 'segment-loyal_user';
          break;
        case 'all':
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.all');
          segmentClass = 'segment-all';
          break;
      }
      $(element).addClass(segmentClass);
      return $(element).text(txt);
    }
  };
  return directive;
}]);


/***/ }),
/* 1179 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignStatus', ["$q", "$translate", "campaignStatuses", "UniqueCouponCode", function($q, $translate, campaignStatuses, UniqueCouponCode) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      showIcon: '=?',
      suppressErrorMessage: '<'
    },
    templateUrl: '/templates/projects.campaigns/views/directives/label_campaign_status.html',
    link: function(scope, element, attrs) {
      var hasActiveIncentives, hasIncentives, query, ref, selectStatusClass, selectStatusText;
      $(element).addClass('campaign-status');
      hasIncentives = function(campaign) {
        return _.get(campaign, 'incentives', []).length > 0;
      };
      hasActiveIncentives = function(campaign) {
        if (!hasIncentives(campaign)) {
          return false;
        }
        return typeof _.find(campaign.incentives, {
          current_status: 'active'
        }) !== 'undefined';
      };
      selectStatusText = function(campaign) {
        if (campaign.iw_current_status === 'preview') {
          return campaignStatuses['preview'].text + " " + ($translate.instant('projectsCampaigns.directives.labelCampaignStatus.wholeDelivery'));
        } else if (campaign.iw_current_status === 'enable') {
          return campaignStatuses['active'].text + " " + ($translate.instant('projectsCampaigns.directives.labelCampaignStatus.wholeDelivery'));
        } else if (campaign.iw_current_status === 'disable') {
          return campaignStatuses['terminated'].text + " " + ($translate.instant('projectsCampaigns.directives.labelCampaignStatus.wholeDelivery'));
        } else if (campaign.iw_current_status === 'incomplete_setting') {
          return campaignStatuses['incomplete'].text + " " + ($translate.instant('projectsCampaigns.directives.labelCampaignStatus.generalDelivery'));
        } else {
          return campaignStatuses[campaign.current_status].text;
        }
      };
      selectStatusClass = function(campaign) {
        if (campaign.iw_current_status === 'preview') {
          return campaignStatuses['preview'].statusClass;
        } else if (campaign.iw_current_status === 'enable') {
          return campaignStatuses['active'].statusClass;
        } else if (campaign.iw_current_status === 'disable') {
          return campaignStatuses['terminated'].statusClass;
        } else {
          return campaignStatuses[campaign.current_status].statusClass;
        }
      };
      if (scope.campaign.current_status === 'active' && ((ref = scope.campaign.current_incentive) != null ? ref.incentive_type : void 0) === 'unique_coupon_code') {
        query = {
          projectId: scope.campaign.project_id,
          incentiveId: scope.campaign.current_incentive.id
        };
        return $q.all([
          UniqueCouponCode.count(query), UniqueCouponCode.count(_.assignIn({
            assigned: 1
          }, query))
        ]).then(function(arg) {
          var assignedCount, totalCount, unassignedCount;
          totalCount = arg[0], assignedCount = arg[1];
          unassignedCount = totalCount - assignedCount;
          scope.text = selectStatusText(scope.campaign);
          scope.statusClass = selectStatusClass(scope.campaign);
          if (!hasActiveIncentives(scope.campaign)) {
            return scope.errorMessage = $translate.instant('projectsCampaigns.directives.labelCampaignStatus.codeExpired');
          } else if (unassignedCount === 0) {
            return scope.errorMessage = $translate.instant('projectsCampaigns.directives.labelCampaignStatus.codeSnip');
          }
        });
      } else {
        scope.text = selectStatusText(scope.campaign);
        scope.statusClass = selectStatusClass(scope.campaign);
        if (!scope.suppressErrorMessage) {
          if (scope.campaign.current_status === 'blocked' && scope.campaign.auto_restart) {
            return scope.errorMessage = $translate.instant('projectsCampaigns.directives.labelCampaignStatus.budgetLimitStop');
          }
        }
      }
    }
  };
}]);


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('pageTypeSelector', ["$modal", "$translate", "Image", "lib", function($modal, $translate, Image, lib) {
  return {
    restrict: 'E',
    scope: {
      pageTypes: '=',
      item: '=',
      disabled: '='
    },
    template: "<select\n  class=\"multi-select\"\n  style=\"width: 100%\"\n  ng-model=\"pageTypes\"\n  name=\"{{ scope.item.name }}\"\n  ng-required=\"scope.item.required\"\n  multiple=\"true\"\n></select>",
    link: function(scope, element, attrs) {
      var data, pageTypes, ref;
      element = element.children('select');
      if ((ref = scope.disabled) === 'true' || ref === true) {
        pageTypes = scope.pageTypes;
        element.prop('disabled', true);
      } else {
        pageTypes = scope.$parent.$parent.$parent.pageTypes;
        scope.pageTypes = _.filter(scope.pageTypes, function(pageType) {
          return _.includes(pageTypes, pageType);
        });
      }
      data = _.map(pageTypes, function(pageType) {
        return {
          id: pageType,
          text: pageType,
          selected: _.includes(scope.pageTypes, pageType)
        };
      });
      return element.select2({
        data: data,
        placeholder: $translate.instant(scope.item.placeholder)
      });
    }
  };
}]);


/***/ }),
/* 1181 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('segmentConditionTable', ["$filter", function($filter) {
  var directive;
  return directive = {
    restrict: "E",
    scope: {
      segments: "=",
      multiple: "=",
      vertical: "@",
      showTitle: "="
    },
    templateUrl: function(elem, attr) {
      if (attr.vertical === "true") {
        return "/templates/projects.campaigns/views/directives/segment_condition_table_vertical.html";
      } else {
        return "/templates/projects.campaigns/views/directives/segment_condition_table.html";
      }
    },
    link: function(scope, elem, attrs) {
      var updateHeaders;
      updateHeaders = function(newval, oldval) {
        if (!newval) {
          return;
        }
        if (scope.multiple) {
          scope.headers = $filter('segmentRelevantHeaders')(scope.segments);
        } else {
          scope.headers = $filter('segmentRelevantHeaders')([scope.segments]);
        }
        return scope.headers = _.sortBy(scope.headers, function(h) {
          return h;
        }).reverse();
      };
      scope.getSegmentHeader = function(segments, header) {
        var result;
        result = void 0;
        if (segments) {
          if (segments.mongo_query && typeof segments.mongo_query[header] !== 'undefined') {
            result = segments.mongo_query[header];
          }
          if (typeof segments[header] !== 'undefined' && segments[header] !== "") {
            result = segments[header];
          }
        }
        return result;
      };
      scope.$watch('segments', updateHeaders, true);
      return updateHeaders();
    }
  };
}]);


/***/ }),
/* 1182 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcAggregateType', function() {
  var directive;
  directive = {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    template: "<div class=\"aggregate_type_new\" ng-if=\"campaign.aggregate_type == 'new'\">NEW</div>\n<div class=\"aggregate_type_repeat\" ng-if=\"campaign.aggregate_type == 'repeat'\">REPEAT</div>\n<div class=\"aggregate_type_spot\" ng-if=\"campaign.aggregate_type == 'spot'\">SPOT</div>",
    link: function(scope, element, attrs) {}
  };
  return directive;
});


/***/ }),
/* 1183 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcLabelClearance', function() {
  var directive;
  directive = {
    restrict: 'E',
    scope: {
      campaign: '='
    },
    template: "<span\n  class=\"small label label-warning\"\n  ng-show=\"isClearance\">\n  CLEARANCE\n</span>",
    link: function(scope, element, attrs) {
      return scope.isClearance = scope.campaign.clearance_item_set_id != null;
    }
  };
  return directive;
});


/***/ }),
/* 1184 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.projects').controller('EditCampaignCtrl', ["$state", "$scope", "Campaign", "InterestWidget", "campaign", "configurationTypes", "currentProject", "incentives", "pageTypes", "templates", function($state, $scope, Campaign, InterestWidget, campaign, configurationTypes, currentProject, incentives, pageTypes, templates) {
  var returnToCampaigns;
  $scope.campaign = campaign;
  $scope.currentProject = currentProject;
  $scope.templates = templates;
  $scope.incentives = incentives;
  $scope.InterestWidget = InterestWidget;
  $scope.configurationTypes = configurationTypes;
  $scope.$state = $state;
  $scope.pageTypes = pageTypes;
  $scope.showsExitPreventionNotification = false;
  $scope.handleSave = function(campaign) {
    var oldCampaign;
    if (campaign) {
      oldCampaign = angular.extend({}, $scope.campaign);
      $scope.campaign = campaign;
      $scope.handleSaveForInterestWidget(oldCampaign);
      if ($scope.campaign.template_type) {
        $scope.campaign.template = _.find($scope.templates, {
          name: $scope.campaign.template_type
        });
      }
      if ($scope.campaign.segment_id) {
        return $scope.campaign.segment = _.find($scope.campaign_segments, {
          id: $scope.campaign.segment_id
        });
      }
    }
  };
  $scope.handleSaveForInterestWidget = function(oldCampaign) {
    return InterestWidget.all(currentProject.apikey).then(function(interestWidgets) {
      var interestWidget;
      interestWidget = _.find(interestWidgets, function(iw) {
        return iw.campaign.id === $scope.campaign.id;
      });
      if (oldCampaign.delivery_type_option.id === 'ab_delivery') {
        if (interestWidget) {
          return InterestWidget.remove(currentProject.apikey, interestWidget.id).then(function(res) {
            delete $scope.campaign.interest_widget_id;
            delete $scope.campaign.delivery_type_option;
            return InterestWidget.updateCampaignWithInterestWidget($scope.campaign);
          });
        } else {
          return InterestWidget.updateCampaignWithInterestWidget($scope.campaign);
        }
      } else {
        if (!interestWidget) {
          interestWidget = {
            name: $scope.campaign.name,
            campaign_id: $scope.campaign.id,
            status: 'incomplete_setting'
          };
          return InterestWidget.create(currentProject.apikey, interestWidget).then(function(res) {
            $scope.campaign.interest_widget_id = res.id;
            delete $scope.campaign.delivery_type_option;
            $scope.campaign.iw_status = 'incomplete_setting';
            return InterestWidget.updateCampaignWithInterestWidget($scope.campaign);
          });
        } else {
          return InterestWidget.updateCampaignWithInterestWidget($scope.campaign);
        }
      }
    });
  };
  $scope.updateCanSaveCampaign = function() {
    return $scope.canSaveCampaign = (function() {
      var ref;
      switch ($scope.campaign.status) {
        case 'incomplete':
          return true;
        case 'preview':
          return (ref = $scope.templateForm) != null ? ref.$valid : void 0;
        case 'activated':
        case 'blocked':
        case 'terminated':
          return $scope.allValid;
        default:
          throw "Unknown status! " + $scope.campaign.status;
      }
    })();
  };
  $scope.saveCampaign = function() {
    return Campaign.update({
      projectId: $state.params.projectId,
      campaignId: $scope.campaign.id
    }, $scope.campaign).then(function(res) {
      return $scope.handleSave(res.campaign);
    });
  };
  $scope.saveCampaignAndReturn = function() {
    return $scope.saveCampaign().then(returnToCampaigns);
  };
  $scope.changeStatus = function(status) {
    return Campaign.update({
      projectId: $state.params.projectId,
      campaignId: $scope.campaign.id
    }, _.assignIn({}, $scope.campaign, {
      status: status
    })).then(function(res) {
      return $scope.handleSave(res.campaign);
    }).then(returnToCampaigns);
  };
  $scope.changeInterestWidgetStatus = function(status) {
    if (status !== 'incomplete_setting' && status !== 'preview' && status !== 'enable') {
      alertify.error("Unknown status! " + status);
      return;
    }
    return InterestWidget.all(currentProject.apikey).then(function(interestWidgets) {
      var interestWidget;
      interestWidget = _.find(interestWidgets, function(iw) {
        return iw.campaign.id === $scope.campaign.id;
      });
      interestWidget.status = status;
      return InterestWidget.update(currentProject.apikey, interestWidget.id, interestWidget).then(returnToCampaigns);
    });
  };
  returnToCampaigns = function() {
    return $state.go("admin.projects.campaigns.list", {
      projectId: $state.params.projectId
    }, {
      reload: true
    });
  };
  $scope.$watchGroup(['campaign.campaign_control_percent', 'campaign.segment.conditions_json.triggers'], function(arg) {
    var control_percent, triggers;
    control_percent = arg[0], triggers = arg[1];
    triggers || (triggers = []);
    return $scope.showsExitPreventionNotification = control_percent >= 1 && indexOf.call(triggers, 'history_back') >= 0;
  });
  $scope.$watchGroup(['basicForm.$valid', 'templateForm.$valid', 'incentiveForm.$valid', 'policyForm.$valid', 'botbonnieForm.$valid', 'timingForm.$valid', 'scheduleForm.$valid'], function(arg) {
    var basicFormValid, botbonnieFormValid, incentiveForm, policyFormValid, scheduleFormValid, templateFormValid, timingFormValid;
    basicFormValid = arg[0], templateFormValid = arg[1], incentiveForm = arg[2], policyFormValid = arg[3], botbonnieFormValid = arg[4], timingFormValid = arg[5], scheduleFormValid = arg[6];
    $scope.allValid = basicFormValid && templateFormValid && incentiveForm && policyFormValid && botbonnieFormValid && timingFormValid && scheduleFormValid;
    return $scope.updateCanSaveCampaign();
  });
  return $scope.$on('$stateChangeSuccess', function() {
    if ($state.current.name === 'admin.projects.campaigns.edit') {
      return $state.go('admin.projects.campaigns.edit.base');
    }
  });
}]);


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('CampaignsCtrl', ["$filter", "$scope", "$state", "$translate", "$modal", "Campaign", "Devise", "InterestWidget", "Page", "SearchFilter", "campaigns", "currentProject", "currentUser", "incentives", "interestWidgets", function($filter, $scope, $state, $translate, $modal, Campaign, Devise, InterestWidget, Page, SearchFilter, campaigns, currentProject, currentUser, incentives, interestWidgets) {
  var findInterestWidget, hideInvoiceAmount;
  Page.setBodyClass('');
  $translate('projectsCampaigns.listController.campaignList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.interestWidgets = interestWidgets;
  $scope.Devise = Devise;
  $scope.currentProject = currentProject;
  $scope.currentUser = currentUser;
  $scope.loginBeforePR = moment(currentUser.last_sign_in_at) < moment.tz('2019-10-15', 'Asia/Tokyo') && currentUser.lang === 'ja';
  $scope.incentives = incentives;
  $scope.filters = SearchFilter.resolveFromLocation();
  $scope.isCampaignSelected = false;
  $scope.allCampaigns = [];
  hideInvoiceAmount = currentProject.product_line === 'zenclerk_lp' && currentProject.pricing_type === 'minimum_charge';
  $scope.canShowInvoiceAmount = Devise.isCommonUser() || hideInvoiceAmount ? false : true;
  $scope.newCampaign = function() {
    return Campaign.create({
      projectId: currentProject.id
    }).then(function(res) {
      return $state.go('admin.projects.campaigns.edit', {
        projectId: currentProject.id,
        campaignId: res.campaign.id
      });
    });
  };
  $scope.newInterestWidget = function() {
    return $state.go('admin.projects.interestWidget.new');
  };
  $scope.editWidget = function(interestWidget) {
    return $state.go('admin.projects.interestWidget.show', {
      id: interestWidget.id
    });
  };
  $scope.reload = function() {
    return $state.reload();
  };
  $scope.openModal = function() {
    return $modal.open({
      templateUrl: '/templates/projects.campaigns/campaign_bulk_edit_modal.html',
      controller: 'CampaignBulkEditModalController',
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        project: function() {
          return $scope.currentProject;
        },
        incentives: function() {
          return $scope.incentives;
        },
        campaigns: function() {
          return _.filter($scope.allCampaigns, {
            selected: true
          });
        }
      }
    });
  };
  findInterestWidget = function(campaign) {
    return _.find(interestWidgets, function(iw) {
      return iw.campaign.id === campaign.id;
    });
  };
  $scope.isAb = false;
  $scope.hasHiddenAb = false;
  $scope.showHiddenAb = false;
  $scope.iwDevices = [];
  $scope.multiIncentiveDevices = [];
  $scope.filterCampaigns = function() {
    var campaign, i, iw, len, ref, ref1, ref2;
    $scope.allCampaigns = [];
    $scope.previewCampaigns = [];
    $scope.incompleteCampaigns = [];
    $scope.filteredCampaigns = [];
    for (i = 0, len = campaigns.length; i < len; i++) {
      campaign = campaigns[i];
      if ($scope.filters.search_term && campaign.name && campaign.name.indexOf($scope.filters.search_term) === -1) {
        continue;
      }
      iw = findInterestWidget(campaign);
      if (iw && Devise.isMaster()) {
        campaign.iw_current_status = iw.status;
        if (campaign.iw_current_status === 'preview') {
          $scope.previewCampaigns.push(campaign);
        } else if (campaign.iw_current_status !== 'enable' && campaign.iw_current_status !== 'disable') {
          $scope.incompleteCampaigns.push(campaign);
        } else {
          $scope.filteredCampaigns.push(campaign);
        }
        if ((ref = campaign.iw_current_status) === 'preview' || ref === 'enable') {
          $scope.iwDevices.push(campaign.campaign_device);
        }
      } else {
        $scope.allCampaigns.push(campaign);
        if (campaign.current_status === 'preview') {
          $scope.previewCampaigns.push(campaign);
        } else if (campaign.current_status === 'incomplete') {
          $scope.incompleteCampaigns.push(campaign);
        } else {
          $scope.filteredCampaigns.push(campaign);
        }
      }
      if (((ref1 = campaign.template_type) === 'multi_incentive' || ref1 === 'multi_incentive_sp') && ((ref2 = campaign.current_status) === 'preview' || ref2 === 'active')) {
        $scope.multiIncentiveDevices.push(campaign.campaign_device);
      }
    }
    $scope.iwDevices = _.uniq($scope.iwDevices);
    $scope.multiIncentiveDevices = _.uniq($scope.multiIncentiveDevices);
    $scope.filteredCampaigns = $filter('campaign')($scope.filteredCampaigns, $scope.filters);
    $scope.isAb = _.some($scope.filteredCampaigns, function(campaign) {
      return campaign.campaign_control_percent !== 0 && !campaign.is_secret_ab;
    });
    $scope.hasHiddenAb = _.some($scope.filteredCampaigns, function(campaign) {
      return campaign.campaign_control_percent !== 0 && campaign.is_secret_ab;
    });
    $scope.updatedFilters = {
      start_at: moment($scope.filters.start_at).startOf('day').valueOf(),
      end_at: moment($scope.filters.end_at).endOf('day').valueOf()
    };
    return SearchFilter.set($scope.filters);
  };
  $scope.resetFilters = function() {
    return $scope.filterCampaigns();
  };
  $scope.filterCampaigns();
  return $scope.$watch('allCampaigns', function(allCampaigns) {
    return $scope.isCampaignSelected = _.some(allCampaigns, {
      selected: true
    });
  }, true);
}]);


/***/ }),
/* 1186 */
/***/ (function(module, exports) {

angular.module('zc.projects.campaigns').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.projects.campaigns', {
    url: '/campaigns',
    abstract: true,
    resolve: {
      project: ["Project", "Devise", "$state", "$stateParams", function(Project, Devise, $state, $stateParams) {
        return Project.getCurrent($stateParams.projectId).then(function(project) {
          if (project.is_maintenance && !Devise.isMaster()) {
            $state.go('admin.projects.maintenance', {
              projectId: $stateParams.projectId
            });
          }
          return project;
        });
      }],
      incentives: ["Project", "Incentive", "$stateParams", function(Project, Incentive, $stateParams) {
        return Project.getCurrent($stateParams.projectId).then(function(project) {
          return Incentive.all($stateParams.projectId, {
            before_end: true
          });
        });
      }]
    }
  }).state('admin.projects.campaigns.list', {
    url: '',
    views: {
      'content@': {
        templateUrl: '/templates/projects.campaigns/list.html',
        controller: 'CampaignsCtrl'
      }
    },
    resolve: {
      campaigns: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
        return Campaign.all({
          projectId: $stateParams.projectId
        });
      }],
      interestWidgets: ["InterestWidget", "project", function(InterestWidget, project) {
        return InterestWidget.all(project.apikey);
      }]
    }
  }).state('admin.projects.campaigns.add_coupons', {
    url: '/add_coupons',
    views: {
      'content@': {
        templateUrl: '/templates/projects.campaigns/add_coupons.html',
        controller: 'AddCouponsCtrl',
        resolve: {
          campaigns: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.all({
              projectId: $stateParams.projectId
            });
          }],
          project: ["Project", "Devise", "$state", "$stateParams", function(Project, Devise, $state, $stateParams) {
            return Project.getCurrent($stateParams.projectId).then(function(project) {
              if (project.is_maintenance && !Devise.isMaster()) {
                return $state.go('admin.projects.maintenance');
              }
            });
          }]
        }
      }
    }
  }).state('admin.projects.campaigns.show', {
    url: '/{campaignId:int}',
    views: {
      'content@': {
        templateUrl: '/templates/projects.campaigns/show.html',
        controller: 'CampaignCtrl',
        resolve: {
          campaign: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.get({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }],
          campaignEventOrder: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.campaignEventOrder({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }],
          campaignEventNotices: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.campaignEventNotices({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }],
          githubUrl: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.githubUrl({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }],
          interestWidgets: ["InterestWidget", "project", function(InterestWidget, project) {
            return InterestWidget.all(project.apikey);
          }]
        }
      }
    }
  }).state('admin.projects.campaigns.show.stats', {
    url: '/stats',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_stats.html'
      }
    }
  }).state('admin.projects.campaigns.show.creative', {
    url: '/creative',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_creative.html'
      }
    }
  }).state('admin.projects.campaigns.show.segment', {
    url: '/segment',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_segment.html'
      }
    }
  }).state('admin.projects.campaigns.show.incentive', {
    url: '/incentive',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_incentive.html'
      }
    }
  }).state('admin.projects.campaigns.show.clearance', {
    url: '/clearance',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_clearance.html'
      }
    }
  }).state('admin.projects.campaigns.show.moment', {
    url: '/moment',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_moment.html'
      }
    }
  }).state('admin.projects.campaigns.show.interestWidget', {
    url: '/interest_widget',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_interest_widget.html'
      }
    }
  }).state('admin.projects.campaigns.show.notes', {
    url: '/notes',
    views: {
      'campaignView@admin.projects.campaigns.show': {
        templateUrl: '/templates/projects.campaigns/show_notes.html'
      }
    }
  }).state('admin.projects.campaigns.edit', {
    url: '/{campaignId:int}/edit',
    views: {
      'content@': {
        templateUrl: '/templates/projects.campaigns/edit.html',
        controller: 'EditCampaignCtrl',
        resolve: {
          campaign: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.get({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }],
          pageTypes: ["$stateParams", "PageType", function($stateParams, PageType) {
            return PageType.all($stateParams.projectId).then(function(pageTypes) {
              return _.uniq(_.map(pageTypes, function(pageType) {
                if (pageType.page_type === '_custom_') {
                  return pageType.custom_name;
                }
                return pageType.page_type;
              }));
            });
          }],
          templates: ["Template", "$stateParams", function(Template, $stateParams) {
            return Template.all($stateParams.projectId, {
              active: true
            });
          }],
          incentives: ["Incentive", "$stateParams", function(Incentive, $stateParams) {
            return Incentive.all($stateParams.projectId, {
              before_end: true
            });
          }],
          interestWidget: ["$stateParams", "InterestWidget", "project", function($stateParams, InterestWidget, project) {
            return {};
          }],
          configurationTypes: ["Meta", function(Meta) {
            return Meta.getConfigurationTypes();
          }]
        }
      }
    }
  }).state('admin.projects.campaigns.edit.base', {
    url: '/base'
  }).state('admin.projects.campaigns.edit.template', {
    url: '/template'
  }).state('admin.projects.campaigns.edit.botbonnie', {
    url: '/botbonnie'
  }).state('admin.projects.campaigns.edit.incentive', {
    url: '/incentive'
  }).state('admin.projects.campaigns.edit.policy', {
    url: '/policy'
  }).state('admin.projects.campaigns.edit.timing', {
    url: '/timing'
  }).state('admin.projects.campaigns.edit.schedule', {
    url: '/schedule'
  }).state('admin.projects.campaigns.edit.confirm', {
    url: '/confirm'
  }).state('admin.projects.campaigns.confirm', {
    url: '/{campaignId:int}/confirm',
    views: {
      'content@': {
        templateUrl: '/templates/projects.campaigns/confirm.html',
        controller: 'ConfirmCampaignCtrl',
        resolve: {
          campaign: ["Campaign", "$stateParams", function(Campaign, $stateParams) {
            return Campaign.get({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }],
          templates: ["Template", "$stateParams", function(Template, $stateParams) {
            return Template.all($stateParams.projectId);
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1187 */
/***/ (function(module, exports) {

angular.module('zc.projects').filter('segmentRelevantHeaders', function() {
  var IGNORED_HEADERS;
  IGNORED_HEADERS = ['id', 'name', 'description', 'updated_at', 'created_at', 'segment_type', 'message', 'ruleView', 'raw', 'mongo_query', 'creator', 'last_updater', 'updated_at', 'created_at', 'campaign_ids', 'campaign_policy_set_id', 'project_id', '$$hashKey'];
  return function(policies) {
    return _.chain(policies).map(function(policy) {
      var key, mongo_query_headers, nonempty, ref, val;
      nonempty = [];
      for (key in policy) {
        val = policy[key];
        if (typeof val !== 'undefined') {
          nonempty.push(key);
        }
      }
      if (policy && policy.mongo_query) {
        mongo_query_headers = [];
        ref = policy.mongo_query;
        for (key in ref) {
          val = ref[key];
          mongo_query_headers.push(key);
        }
        nonempty = _.assignIn(nonempty, mongo_query_headers);
      }
      return nonempty;
    }).flatten().uniq().remove(function(h) {
      return IGNORED_HEADERS.indexOf(h) < 0;
    }).value();
  };
});


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('CampaignCtrl', ["$scope", "$state", "$translate", "Devise", "Page", "PageType", "Project", "Campaign", "SearchFilter", "Template", "ClearanceItemSet", "CampaignSegment", "SegmentMatcher", "MongoSession", "MongoConversion", "MongoHistory", "campaign", "currentProject", "campaignEventOrder", "campaignEventNotices", "githubUrl", "InterestWidget", "interestWidgets", function($scope, $state, $translate, Devise, Page, PageType, Project, Campaign, SearchFilter, Template, ClearanceItemSet, CampaignSegment, SegmentMatcher, MongoSession, MongoConversion, MongoHistory, campaign, currentProject, campaignEventOrder, campaignEventNotices, githubUrl, InterestWidget, interestWidgets) {
  var DATE_UNTIL, checkOfferExists, findInterestWidget, findSessions, iw, matchPageType, ref, replacePrefix, unJankRegEx;
  DATE_UNTIL = moment().subtract(1, 'hours').toDate();
  $scope.sampleSessionSize = 500;
  $scope.historySize = 5;
  $scope.historyTime = 30;
  $scope.sessions = [];
  $scope.lpUrls = [];
  $scope.isAb = campaign.campaign_control_percent !== 0 && !campaign.is_secret_ab;
  Page.setBodyClass('');
  $translate('projectsCampaigns.showController.campaignDetail').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.Project = Project;
  $scope.currentProject = currentProject;
  findInterestWidget = function(campaign) {
    return _.find(interestWidgets, function(iw) {
      return iw.campaign.id === campaign.id;
    });
  };
  iw = findInterestWidget(campaign);
  if (iw) {
    campaign.iw_current_status = iw.status;
  }
  $scope.campaign = campaign;
  $scope.isV1 = campaign.api_version === 1;
  $scope.Campaign = Campaign;
  $scope.Devise = Devise;
  $scope.filters = SearchFilter.resolveFromLocation();
  $scope.previewUrl = Campaign.previewUrl(currentProject.base_url, campaign);
  $scope.adminUrl = Campaign.adminUrl(currentProject.id, campaign);
  Campaign.all({
    projectId: currentProject.id
  }).then(function(allCampaigns) {
    var c, i, len, ref, ref1, results;
    $scope.otherCampaigns = [];
    results = [];
    for (i = 0, len = allCampaigns.length; i < len; i++) {
      c = allCampaigns[i];
      if ((ref = c.campaign_device) !== $scope.campaign.campaign_device && ref !== 'devicefree') {
        continue;
      }
      if ((ref1 = c.current_status) !== 'active' && ref1 !== 'pending' && ref1 !== 'blocked' && ref1 !== 'preview') {
        continue;
      }
      if (!c.is_supported_by_widget) {
        continue;
      }
      c.previewUrl = (Campaign.previewUrl(currentProject.base_url, c)) + "&zc_widget_id=" + $scope.campaign.element.id;
      results.push($scope.otherCampaigns.push(c));
    }
    return results;
  });
  $scope.campaignEventOrder = campaignEventOrder;
  $scope.campaignEventNotices = campaignEventNotices;
  $scope.githubUrl = githubUrl;
  $scope.$on('$stateChangeSuccess', function(ev, toState, toParams, fromState, fromParams) {
    if ((fromState != null ? fromState.name : void 0) === 'admin.projects.reports.show') {
      if (!_.get(fromParams, 'reportId')) {
        return;
      }
      $scope.filters = SearchFilter.getDefaultReportFilters(fromParams.reportId);
      $scope.updateFilters();
    }
    if ((toState != null ? toState.name : void 0) === 'admin.projects.campaigns.show') {
      return $state.go('admin.projects.campaigns.show.stats', toParams);
    }
  });
  if ($scope.campaign.clearance_item_set_id) {
    ClearanceItemSet.find({
      projectId: $scope.currentProject.id,
      id: $scope.campaign.clearance_item_set_id
    }).then(function(res) {
      return $scope.clearanceItemSet = res;
    });
  }
  $scope.active = $scope.campaign.status === "activated" ? true : false;
  if ($scope.campaign.end_at > new Date() && $scope.campaign.status !== "terminated") {
    $scope.current = true;
  } else {
    $scope.current = false;
  }
  $scope.canDestroy = (ref = campaign.current_status) === 'incomplete' || ref === 'preview';
  $scope.hasIw = !!iw;
  $scope.updateIwStatus = function(status) {
    iw.status = status;
    return InterestWidget.update($scope.campaign.apikey, iw.id, iw).then(function(res) {
      return $state.go('admin.projects.campaigns.list', {
        projectId: $state.params.projectId
      }, {
        reload: true
      });
    });
  };
  Template.all($scope.currentProject.id).then(function(templates) {
    var template;
    if ($scope.campaign.template_type) {
      template = _.find(templates, {
        name: $scope.campaign.template_type
      });
      if (template) {
        return $scope.campaign.template = template;
      }
    }
  });
  $scope.isActiveState = function(state) {
    return $state.current.name === state;
  };
  $scope.terminate = function() {
    $scope.current = false;
    return Campaign.terminate({
      projectId: $state.params.projectId,
      campaignId: $state.params.campaignId
    });
  };
  $scope.destroy = function() {
    return Campaign.destroy({
      projectId: $state.params.projectId,
      campaignId: $state.params.campaignId
    }).then(function() {
      return $state.go('admin.projects.campaigns.list', {
        projectId: $state.params.projectId
      }, {
        reload: true
      });
    });
  };
  $scope.updateFilters = function() {
    $scope.updatedFilters = {
      start_at: moment($scope.filters.start_at).startOf('day').valueOf(),
      end_at: moment($scope.filters.end_at).add(1, 'day').valueOf()
    };
    SearchFilter.set($scope.filters);
    return $scope.$broadcast('filtersUpdated');
  };
  $scope.resetFilters = function() {
    return $scope.$broadcast('filtersReset');
  };
  $scope.destroy = function() {
    return Campaign.destroy({
      projectId: $scope.campaign.project_id,
      campaignId: $scope.campaign.id
    }).then($scope.onUpdate);
  };
  $scope.goToShow = function() {
    return $state.go('admin.projects.campaigns.show.stats', {
      campaignId: $scope.campaign.id
    });
  };
  $scope.goToEdit = function(step) {
    var state;
    state = 'admin.projects.campaigns.edit';
    if (step) {
      state += "." + step;
    }
    return $state.go(state, {
      campaignId: $scope.campaign.id
    });
  };
  $scope.hasOptionType = function(option_category) {
    var element, i, len, ref1;
    if (!$scope.campaign.template) {
      return void 0;
    }
    ref1 = $scope.campaign.template.template;
    for (i = 0, len = ref1.length; i < len; i++) {
      element = ref1[i];
      if (element.option_category === option_category) {
        return true;
      }
    }
  };
  $scope.publish = function(_usid) {
    return Campaign.publish({
      apikey: $scope.campaign.apikey,
      campaign_id: $scope.campaign.id,
      _usid: _usid
    }).then(function() {
      $scope._usid = null;
      return alertify.success(_usid + " " + ($translate.instant('projectsCampaigns.showController.campaignDetail')));
    }, function(err) {
      $scope._usid = null;
      return alertify.error(err);
    });
  };
  $scope.updateFilters();
  $scope.$watch('filters', function() {
    var end_at, start_at;
    start_at = moment($scope.filters.start_at).format('YYYYMMDD');
    end_at = moment($scope.filters.end_at).format('YYYYMMDD');
    return $scope.filename = "campaign_" + $scope.campaign.id + "_" + start_at + "_" + end_at + ".csv";
  }, true);
  $scope.showInterestWidgetData = false;
  Campaign.isWidget(campaign).then(function(isWidget) {
    return $scope.showInterestWidgetData = isWidget;
  });
  findSessions = function(query) {
    if (!$scope.campaign.segment) {
      return;
    }
    return CampaignSegment.get($scope.campaign.project_id, $scope.campaign.segment_id).then(function(segment) {
      $scope.generateLPLinks(segment);
      return CampaignSegment.getMongoQuery(segment);
    }).then(function(query) {
      query = SegmentMatcher.createSegmentQuery(query);
      return MongoSession.find(_.assignIn(query, {
        apikey: $scope.currentProject.apikey,
        device: SegmentMatcher.getCombinedDeviceCondition($scope.campaign.campaign_device),
        opened_at: {
          $gte: moment(DATE_UNTIL).subtract(1, 'day').toDate(),
          $lt: DATE_UNTIL
        }
      }), {
        sort: '-opened_at',
        limit: $scope.sampleSessionSize,
        fields: ['conversion_count', 'predictions_min_before_cart.global_conversion_rate', 'predictions_max_before_cart.global_conversion_rate', 'average_recent5_item_price']
      });
    }).then(function(sessions) {
      return $scope.sessions = sessions;
    });
  };
  $scope.$watch('sampleSessionSize', findSessions);
  $scope.toggleShowAB = function() {
    $scope.isAb = !$scope.isAb;
    return $scope.$broadcast('isAbChanged', $scope.isAb);
  };
  $scope.hideCodeIncentiveConfigItem = function(item) {
    var incentive, ref1, ref2, ref3;
    if (!/^timesale_ver5/.test($scope.campaign.template_type)) {
      return false;
    }
    incentive = $scope.campaign.incentives[0];
    if (!incentive) {
      return false;
    }
    if ((ref1 = incentive.incentive_type) !== 'coupon_url' && ref1 !== 'api_url') {
      return false;
    }
    if ((ref2 = item.name) === 'code_name' || ref2 === 'code_copy' || ref2 === 'enable_coupon_clipboard' || ref2 === 'code_condition') {
      return true;
    }
    if (incentive.incentive_type === 'api_url' && ((ref3 = item.name) === 'linkage_url' || ref3 === 'remove_target_blank_present')) {
      return true;
    }
    return false;
  };
  $scope.hideTimerConfigItem = function(item) {
    if (item.name === 'enables_banner_timer' && !$scope.campaign.element.message.enables_timer) {
      return true;
    }
    return false;
  };
  unJankRegEx = function(regex) {
    var re;
    re = regex;
    if (regex.charAt(0) === '^') {
      re = regex.substr(1);
    }
    re.replace('//', '/');
    return re;
  };
  checkOfferExists = function(offer) {
    return offer && offer !== 'NOT_SELECTED';
  };
  replacePrefix = function(prefix) {
    var match_pattern;
    match_pattern = prefix.match_pattern;
    match_pattern = match_pattern.replaceAll('/', '\\/');
    match_pattern = match_pattern.replaceAll('.', '\\.');
    match_pattern = match_pattern.replaceAll('?', '\\?');
    return match_pattern;
  };
  matchPageType = function(pageTypes, offerName, offerType, matchQuery) {
    var matchedPages, prefixes;
    matchQuery.url || (matchQuery.url = {});
    matchedPages = _.filter(pageTypes, function(pageType) {
      return [pageType.page_type, pageType.custom_name].includes(offerName);
    });
    if (matchedPages.length === 0) {
      return;
    }
    $scope.lpSegmentSet = true;
    prefixes = _.filter(matchedPages, {
      match_type: 'prefix'
    });
    if (offerType === 'limit') {
      if (prefixes) {
        return matchQuery.url.$regex = _.map(prefixes, replacePrefix).join('|');
      } else {
        return matchQuery.url.$regex = unJankRegEx(matchedPages[0].match_pattern);
      }
    } else {
      return matchQuery.url.$not = unJankRegEx(matchedPages[0].match_pattern);
    }
  };
  return $scope.generateLPLinks = function(segment) {
    var endAt, match, pipeline, startAt;
    startAt = moment().subtract($scope.historyTime, 'minutes').toDate();
    endAt = new Date();
    match = {
      apikey: $scope.currentProject.apikey,
      device: SegmentMatcher.getCombinedDeviceCondition($scope.campaign.campaign_device),
      opened_at: {
        $gte: startAt
      },
      closed_at: {
        $lt: endAt
      }
    };
    pipeline = [
      {
        $project: {
          url: '$url'
        }
      }, {
        $sortByCount: '$url'
      }
    ];
    return PageType.all($scope.currentProject.id).then(function(pageTypes) {
      var offerExclude, offerLimit, offerSession;
      offerLimit = _.get(segment, ['conditions_json', 'limit_to_landing_page_types', '0']);
      if (checkOfferExists(offerLimit)) {
        matchPageType(pageTypes, offerLimit, 'limit', match);
      }
      offerExclude = _.get(segment, ['conditions_json', 'exclude_landing_page_types', '0']);
      if (checkOfferExists(offerExclude)) {
        matchPageType(pageTypes, offerExclude, 'exclude', match);
      }
      offerSession = _.get(segment, ['conditions_json', 'limit_to_sessions_who_visit', '0']);
      if (checkOfferExists(offerSession)) {
        matchPageType(pageTypes, offerSession, 'limit', match);
      }
      return MongoHistory.aggregate({
        apikey: $scope.currentProject.apikey
      }, {
        match: match,
        pipeline: pipeline,
        limit: $scope.historySize
      });
    }).then(function(urls) {
      if (urls !== void 0) {
        return $scope.lpUrls = _.map(urls, function(url) {
          return Campaign.previewUrl(url._id, $scope.campaign);
        });
      }
    });
  };
}]);


/***/ }),
/* 1189 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('clearanceDownloadButton', ["$q", function($q) {
  return {
    restrict: 'E',
    scope: {
      clearanceItemSet: '=',
      clearanceItemSetItems: '='
    },
    template: "<button\n  type=\"button\"\n  class=\"btn btn-sm btn-default pull-right\"\n  ng-csv=\"getCSV()\"\n  csv-header=\"csvheader\"\n  filename=\"{{filename}}\"\n  add-bom=\"true\"\n  charset=\"utf-16\"\n  field-separator=\"\\t\">\n  <i class=\"fa fa-cloud-download\"></i> {{ projectsClearance.clearanceDownloadButton.downloadCsv | translate }}\n</button>",
    link: function(scope, element, attrs) {
      scope.filename = scope.clearanceItemSet.name + ".csv";
      scope.csvheader = ['match_type', 'path', 'title', 'base_price', 'text_base_price', 'sale_url', 'image_url'];
      return scope.getCSV = function() {
        return _.map(scope.clearanceItemSetItems, function(num) {
          return _.pick(num, scope.csvheader);
        });
      };
    }
  };
}]);


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcClearanceItemList', ["$stateParams", "Campaign", "Devise", "ClearanceItemSet", function($stateParams, Campaign, Devise, ClearanceItemSet) {
  return {
    restrict: "E",
    scope: {
      project: "=",
      clearanceItemSet: "="
    },
    templateUrl: "/templates/projects.clearance/clearance_item_list.html",
    link: function(scope, element, attrs) {
      scope.clearanceItemSetItems = [];
      scope.countPerLoad = scope.visibleItemCount = 30;
      scope.Devise = Devise;
      ClearanceItemSet.getItems({
        projectId: scope.project.id,
        id: scope.clearanceItemSet.id
      }).then(function(res) {
        return scope.clearanceItemSetItems = res;
      });
      return Campaign.all({
        projectId: scope.project.id,
        clearance_item_set_id: scope.clearanceItemSet.id
      }).then(function(campaigns) {
        return scope.clearanceItemSet.clearanceCampaigns = campaigns;
      });
    }
  };
}]);


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('ClearanceSetShowCtrl', ["$scope", "$translate", "Page", "clearanceItemSet", "currentProject", function($scope, $translate, Page, clearanceItemSet, currentProject) {
  Page.setBodyClass('');
  $translate('projectsClearance.clearanceSetShow.campaignSettingDetail').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.project = currentProject;
  return $scope.clearanceItemSet = clearanceItemSet;
}]);


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

angular.module('zc.projects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.projects.clearanceSet', {
    url: '/clearance_set',
    abstract: true
  }).state('admin.projects.clearanceSet.show', {
    url: '/{clearanceItemSetId:int}',
    views: {
      'content@': {
        templateUrl: '/templates/projects.clearance/clearance_set_show.html',
        controller: 'ClearanceSetShowCtrl',
        resolve: {
          clearanceItemSet: ["$stateParams", "ClearanceItemSet", function($stateParams, ClearanceItemSet) {
            return ClearanceItemSet.find({
              projectId: $stateParams.projectId,
              id: $stateParams.clearanceItemSetId
            }).then(function(clearance_item_set) {
              return clearance_item_set;
            });
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1193 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('IncentiveEditCtrl', ["$scope", "$state", "$translate", "$filter", "Page", "Incentive", "Devise", "currentProject", "discountTypes", "incentive", "currencies", "environment", function($scope, $state, $translate, $filter, Page, Incentive, Devise, currentProject, discountTypes, incentive, currencies, environment) {
  var setPristine;
  Page.setBodyClass('');
  $translate('projectsIncentives.edit.insentibu_henshuu').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.incentive = incentive;
  $scope.currentProject = currentProject;
  $scope.discountTypes = discountTypes;
  $scope.Devise = Devise;
  $scope.start_at_obj = $filter('dateToDateObj')($scope.incentive.start_at);
  $scope.end_at_obj = $filter('dateToDateObj')($scope.incentive.end_at);
  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / Math.pow(10, $scope.currency.fractionSize);
  $scope.priceInputs = {
    discount_price: $scope.incentive.discount_price ? $scope.incentive.discount_price * $scope.currencyStep : 0,
    minimum_price: $scope.incentive.minimum_price ? $scope.incentive.minimum_price * $scope.currencyStep : null
  };
  $scope.environment = environment;
  $scope.giftUrlParameter = $translate.instant('projectsIncentives.edit.giftUrlParameter', {
    parameter: 'zc_gift={{gift_parameter}}'
  });
  setPristine = function() {
    $scope.incentiveEditForm.$setPristine();
    return $scope.goToList();
  };
  $scope.goToList = function() {
    return $state.go('admin.projects.incentives', {
      projectId: currentProject.id
    });
  };
  $scope.save = function() {
    $scope.incentive.start_at = $filter('dateObjToDate')($scope.start_at_obj, $scope.currentProject.region);
    $scope.incentive.end_at = $filter('dateObjToDate')($scope.end_at_obj, $scope.currentProject.region);
    if ($scope.incentive.id) {
      return Incentive.update({
        projectId: $scope.currentProject.id,
        id: $scope.incentive.id
      }, {
        incentive: $scope.incentive
      }).then(setPristine);
    } else {
      return Incentive.create({
        projectId: $scope.currentProject.id
      }, {
        incentive: $scope.incentive
      }).then(setPristine);
    }
  };
  $scope.updatePriceByApplyingCurrency = function(attribute) {
    return $scope.incentive[attribute] = $scope.priceInputs[attribute] / $scope.currencyStep;
  };
  return $scope.$watchGroup(['incentive.discount_type', 'incentive.is_novelty', 'incentive.is_free_shipping'], function(arg) {
    var discount_type, is_free_shipping, is_novelty, valid;
    discount_type = arg[0], is_novelty = arg[1], is_free_shipping = arg[2];
    if (!$scope.incentiveEditForm.discount_type) {
      return;
    }
    valid = (discount_type !== 'none') || !!is_novelty || !!is_free_shipping;
    return $scope.incentiveEditForm.discount_type.$setValidity('should_be_set_if_is_novelty_and_is_free_shipping_are_not_set', valid);
  });
}]);


/***/ }),
/* 1194 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcIncentiveCode', ["$translate", function($translate) {
  return {
    restrict: 'E',
    scope: {
      incentive: '='
    },
    template: "<span ng-class=\"codeClass\">{{text}}</span>\n<i tooltip=\"{{tooltipText}}\" class=\"fa fa-exclamation-circle\" ng-class=\"tooltipClass\" ng-if=\"tooltipText\"></i>",
    link: function(scope, element, attrs) {
      if (scope.incentive.incentive_type === 'coupon_code') {
        scope.codeClass = '';
        return scope.text = scope.incentive.coupon_code;
      } else if (scope.incentive.incentive_type === 'unique_coupon_code') {
        scope.codeClass = 'unique_coupon';
        return scope.text = $translate.instant('projectsIncentives.incentiveCode.yuniikukuupon_houshiki');
      }
    }
  };
}]);


/***/ }),
/* 1195 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcIncentiveDetail', function() {
  return {
    restrict: 'E',
    templateUrl: "/templates/projects.incentives/incentive_detail.html",
    scope: {
      incentive: "="
    }
  };
});


/***/ }),
/* 1196 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcIncentiveStatus', ["$translate", "$q", "UniqueCouponCode", function($translate, $q, UniqueCouponCode) {
  return {
    restrict: 'E',
    require: '?ngModel',
    scope: {
      incentive: '='
    },
    template: '<span ng-class="statusClass" tooltip="{{text}}"></span>',
    link: function(scope, element, attrs) {
      var COUNT_THRESHOLD, query;
      COUNT_THRESHOLD = 1 / 5;
      if (!scope.incentive) {
        return;
      }
      if (scope.incentive.incentive_type === 'unique_coupon_code') {
        query = {
          projectId: scope.incentive.project_id,
          incentiveId: scope.incentive.id
        };
        return $q.all([
          UniqueCouponCode.count(query), UniqueCouponCode.count(_.assignIn({
            assigned: 1
          }, query))
        ]).then(function(arg) {
          var assignedCount, totalCount, unassignedCount;
          totalCount = arg[0], assignedCount = arg[1];
          unassignedCount = totalCount - assignedCount;
          if (scope.incentive.current_status === 'finished') {
            scope.statusClass = 'fa fa-minus-circle';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.kigengire');
          } else if (totalCount === 0) {
            scope.statusClass = 'fa text-danger fa-exclamation-circle';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.kuuponkoodo_ga_touroku');
          } else if (unassignedCount === 0) {
            scope.statusClass = 'fa text-danger fa-times-circle';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.subete_no_kuuponkoodo');
          } else if (unassignedCount / totalCount < COUNT_THRESHOLD) {
            scope.statusClass = 'fa text-warning fa-exclamation-circle';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.kuuponkoodo_ga_nokori');
          } else {
            scope.statusClass = 'fa text-success fa-check-circle';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.koodo_wa_seijou');
          }
        });
      } else {
        switch (scope.incentive.current_status) {
          case 'active':
            scope.statusClass = "fa fa-check-circle text-success";
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.yuukou');
          case 'pending':
            scope.statusClass = 'fa fa-exclamation-circle text-warning';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.kigen_saki');
          case 'finished':
            scope.statusClass = 'fa fa-minus-circle';
            return scope.text = $translate.instant('projectsIncentives.incentiveStatus.kigengire');
          default:
            throw new Error("Invalid status! start_at: " + scope.incentive.start_at + " end_at: " + scope.incentive.end_at);
        }
      }
    }
  };
}]);


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcIncentiveTable', ["Incentive", "Devise", "CampaignStats", "lib", function(Incentive, Devise, CampaignStats, lib) {
  return {
    restrict: 'E',
    templateUrl: '/templates/projects.incentives/incentive_table.html',
    scope: {
      project: '=',
      incentives: '=',
      campaign: '=',
      filters: '=',
      onUpdate: '=',
      showsDetail: '='
    },
    link: function(scope, element, attrs) {
      var updateData;
      scope.Devise = Devise;
      scope.copy = function(incentive) {
        var newIncentive;
        newIncentive = _.assignIn({}, incentive);
        newIncentive.id = void 0;
        newIncentive.name = lib.copyName(incentive.name);
        return Incentive.create({
          projectId: scope.project.id
        }, newIncentive).then(scope.onUpdate);
      };
      scope.remove = function(incentive) {
        return Incentive["delete"](scope.project.id, incentive.id).then(scope.onUpdate);
      };
      updateData = function() {
        if (!(scope.campaign && scope.filters)) {
          return;
        }
        return CampaignStats.aggregate({
          dimension: 'daily',
          campaign_id: scope.campaign.id,
          apikey: scope.campaign.apikey,
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        }).then(function(campaign_stats) {
          return scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id];
        });
      };
      return scope.$watch('filters', updateData, true);
    }
  };
}]);


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('IncentiveListCtrl', ["$scope", "$state", "$translate", "Page", "Incentive", "currentProject", "Devise", function($scope, $state, $translate, Page, Incentive, currentProject, Devise) {
  Page.setBodyClass('');
  $translate('projectsIncentives.list.incentiveList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.currentProject = currentProject;
  $scope.isMaster = Devise.isMaster();
  $scope.getAllIncentives = function() {
    return Incentive.all($scope.currentProject.id).then(function(incentives) {
      return $scope.incentives = incentives;
    });
  };
  return $scope.getAllIncentives();
}]);


/***/ }),
/* 1199 */
/***/ (function(module, exports) {

var redirectNewDashboard;

angular.module('zc.projects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.projects.incentives', {
    url: '/incentives',
    views: {
      'content@': {
        templateUrl: '/templates/projects.incentives/list.html',
        controller: 'IncentiveListCtrl'
      }
    }
  }).state('admin.projects.incentives.new', {
    url: '/new',
    views: {
      'content@': {
        templateUrl: '/templates/projects.incentives/edit.html',
        controller: 'IncentiveEditCtrl',
        resolve: {
          discountTypes: ["Meta", function(Meta) {
            return Meta.getIncentiveDiscountTypes();
          }],
          incentive: ["Incentive", "currentProject", function(Incentive, currentProject) {
            return {
              incentive_type: 'coupon_code',
              discount_type: 'none',
              has_usage_limit: true,
              has_member_only_limit: true,
              maximum_usage: 1
            };
          }],
          environment: ["Environment", function(Environment) {
            return Environment.get();
          }]
        }
      }
    }
  }).state('admin.projects.incentives.edit', {
    url: '/{incentiveId:int}/edit',
    resolve: {
      redirect: ["Project", "Incentive", "$stateParams", "$window", function(Project, Incentive, $stateParams, $window) {
        return redirectNewDashboard(Project, Incentive, $stateParams, $window);
      }]
    },
    views: {
      'content@': {
        templateUrl: '/templates/projects.incentives/edit.html',
        controller: 'IncentiveEditCtrl',
        resolve: {
          discountTypes: ["Meta", function(Meta) {
            return Meta.getIncentiveDiscountTypes();
          }],
          incentive: ["Incentive", "$stateParams", function(Incentive, $stateParams) {
            return Incentive.get($stateParams.projectId, $stateParams.incentiveId);
          }],
          environment: ["Environment", function(Environment) {
            return Environment.get();
          }]
        }
      }
    }
  }).state('admin.projects.incentives.show', {
    url: '/{incentiveId:int}',
    views: {
      'content@': {
        templateUrl: '/templates/projects.incentives/show.html',
        controller: 'IncentiveShowCtrl',
        resolve: {
          currentProject: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.get($stateParams.projectId);
          }],
          discountTypes: ["Meta", function(Meta) {
            return Meta.getIncentiveDiscountTypes();
          }],
          incentive: ["Incentive", "$stateParams", function(Incentive, $stateParams) {
            return Incentive.get($stateParams.projectId, $stateParams.incentiveId);
          }]
        }
      }
    }
  });
}]);

redirectNewDashboard = function(Project, Incentive, $stateParams, $window) {
  return Project.getCurrent($stateParams.projectId).then(function(project) {
    return Incentive.get($stateParams.projectId, $stateParams.incentiveId).then(function(incentive) {
      var hasIncentiveCoupons;
      hasIncentiveCoupons = incentive.coupons.length > 0;
      if (hasIncentiveCoupons) {
        return $window.location.href = ZC_CONFIG.AIDEAL_URL + "/site/" + project.apikey + "/campaigns/incentives/" + incentive.id + "/edit";
      }
    });
  });
};


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('IncentiveShowCtrl', ["$scope", "$state", "$translate", "$filter", "$q", "Page", "Incentive", "UniqueCouponCode", "currentProject", "discountTypes", "incentive", "currencies", function($scope, $state, $translate, $filter, $q, Page, Incentive, UniqueCouponCode, currentProject, discountTypes, incentive, currencies) {
  var query;
  Page.setBodyClass('');
  $translate('projectsIncentives.show.incentiveDetails').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.incentive = incentive;
  $scope.currentProject = currentProject;
  $scope.discountTypes = discountTypes;
  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / Math.pow(10, $scope.currency.fractionSize);
  if ($scope.incentive.discount_price) {
    $scope.discount_price = $scope.incentive.discount_price * $scope.currencyStep;
  }
  if ($scope.incentive.minimum_price) {
    $scope.minimum_price = $scope.incentive.minimum_price * $scope.currencyStep;
  }
  if (incentive.incentive_type === 'unique_coupon_code') {
    $scope.totalUniqueCouponCodeCount = 0;
    $scope.assignedUniqueCouponCodeCount = 0;
    query = {
      projectId: $scope.incentive.project_id,
      incentiveId: $scope.incentive.id
    };
    return $q.all([
      UniqueCouponCode.count(query), UniqueCouponCode.count(_.assignIn({
        assigned: 1
      }, query))
    ]).then(function(arg) {
      var assignedUniqueCouponCodeCount, totalUniqueCouponCodeCount;
      totalUniqueCouponCodeCount = arg[0], assignedUniqueCouponCodeCount = arg[1];
      $scope.totalUniqueCouponCodeCount = totalUniqueCouponCodeCount;
      return $scope.assignedUniqueCouponCodeCount = assignedUniqueCouponCodeCount;
    });
  }
}]);


/***/ }),
/* 1201 */
/***/ (function(module, exports) {

angular.module('zc.projects.reports').factory('clientReportCsvCreator', ["$filter", "$q", "$translate", "campaignStatusTexts", "CampaignStats", "currencies", function($filter, $q, $translate, campaignStatusTexts, CampaignStats, currencies) {
  var applyCurrency;
  applyCurrency = function(value, currency) {
    return $filter('zcCurrency')(value, '', currency.fractionSize, '');
  };
  return {
    createCsv: function(project, campaignsWithStats, isAb) {
      var currency;
      currency = currencies[project.currency];
      return $q(function(resolve, reject) {
        var campaign, csvData, ctrRecord, dateFilter, device, expRecord, headers, i, len, stat, total_delivery_count;
        csvData = [];
        headers = [];
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.id'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.suteetasu'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kyanpeen_na'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kyanpeen_tesuuryou_ritsu'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kaishibi'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.shuuryoubi'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.debaisu'));
        if (isAb) {
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.moment_kazu'));
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.ab_hiritsu'));
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.guruupu'));
        }
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.haishin_kazu'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cv_ritsu'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cv_kazu'));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.heikin_cv_kingaku', {
          currency: currency.symbol || currency.suffix
        }));
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.goukei_cv_kingaku', {
          currency: currency.symbol || currency.suffix
        }));
        if (project.product_line === 'zenclerk_lp') {
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cpa_kingaku', {
            currency: currency.symbol || currency.suffix
          }));
        }
        if (isAb) {
          if (project.product_line === 'zenclerk_lp') {
            headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kakutoku_cv_kazu'));
          }
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cv_joushouritsu'));
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kakutoku_kingaku', {
            currency: currency.symbol || currency.suffix
          }));
        }
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.zc_kosuto', {
          currency: currency.symbol || currency.suffix
        }));
        csvData.push(headers);
        for (i = 0, len = campaignsWithStats.length; i < len; i++) {
          campaign = campaignsWithStats[i];
          if (campaign.stats) {
            stat = campaign.stats;
          } else {
            stat = {
              experimental: {
                delivery_count: 0,
                conversion_rate: 0,
                conversion_count: 0,
                average_conversion_price: 0,
                conversion_price: 0
              },
              control: {
                delivery_count: 0,
                conversion_rate: 0,
                conversion_count: 0,
                average_conversion_price: 0,
                conversion_price: 0
              }
            };
          }
          dateFilter = $filter('date');
          device = (function() {
            switch (campaign.campaign_device) {
              case 'pc':
                return 'PC/iPad';
              case 'sp':
                return 'sp';
              case 'iphone':
                return 'iPhone';
              default:
                return '';
            }
          })();
          total_delivery_count = stat.control.delivery_count + stat.experimental.delivery_count;
          expRecord = [];
          expRecord.push(campaign.id);
          expRecord.push(campaignStatusTexts[campaign.current_status]);
          expRecord.push(campaign.name);
          expRecord.push(campaign.fee_rate || CampaignStats.ZC_COST_RATE);
          expRecord.push("" + (dateFilter(campaign.start_at.valueOf(), 'yyyy/MM/dd')));
          expRecord.push("" + (dateFilter(campaign.end_at.valueOf(), 'yyyy/MM/dd')));
          expRecord.push(device);
          if (isAb) {
            if (!campaign.is_secret_ab && campaign.campaign_control_percent !== 0) {
              expRecord.push(total_delivery_count);
              expRecord.push(stat.experimental.delivery_count / total_delivery_count);
              expRecord.push($translate.instant('projectsReports.services.clientReportCsvCreator.hyouji_guruupu'));
            } else {
              expRecord.push(0);
              expRecord.push(0);
              expRecord.push('');
            }
          }
          expRecord.push(stat.experimental.delivery_count);
          expRecord.push(stat.experimental.conversion_rate);
          expRecord.push(stat.experimental.conversion_count);
          expRecord.push(applyCurrency(stat.experimental.average_conversion_price, currency));
          expRecord.push(applyCurrency(stat.experimental.conversion_price, currency));
          if (project.product_line === 'zenclerk_lp') {
            expRecord.push(applyCurrency(campaign.cost_per_acquisition, currency));
          }
          if (isAb) {
            if (!campaign.is_secret_ab && campaign.campaign_control_percent !== 0) {
              if (project.product_line === 'zenclerk_lp') {
                expRecord.push(stat.contribution_count);
              }
              expRecord.push(stat.conversion_up_rate);
              expRecord.push(applyCurrency(stat.contribution_price, currency));
            } else {
              if (project.product_line === 'zenclerk_lp') {
                expRecord.push(0);
              }
              expRecord.push(0);
              expRecord.push(0);
            }
          }
          expRecord.push(applyCurrency(stat.invoice_amount, currency));
          csvData.push(expRecord);
          if (isAb && !campaign.is_secret_ab && campaign.campaign_control_percent !== 0) {
            ctrRecord = ['', '', '', '', '', '', '', '', stat.control.delivery_count / total_delivery_count, $translate.instant('projectsReports.services.clientReportCsvCreator.hihyouji_guruupu'), stat.control.delivery_count, stat.control.conversion_rate, stat.control.conversion_count, applyCurrency(stat.control.average_conversion_price, currency), applyCurrency(stat.control.conversion_price, currency), '', '', ''];
            if (project.product_line === 'zenclerk_lp') {
              ctrRecord.push('');
              ctrRecord.push('');
            }
            csvData.push(ctrRecord);
          }
        }
        return resolve(csvData);
      });
    }
  };
}]);


/***/ }),
/* 1202 */
/***/ (function(module, exports) {

angular.module('zc.projects.reports').directive('zcDownloadMonthlyReportButton', ["$q", "$translate", "ReportCampaignStats", "Meta", "$filter", "campaignStatusTexts", "clientReportCsvCreator", function($q, $translate, ReportCampaignStats, Meta, $filter, campaignStatusTexts, clientReportCsvCreator) {
  return {
    restrict: 'E',
    scope: {
      filters: '=',
      project: '=',
      campaigns: '=',
      status: '=',
      isLatest: '=',
      isAb: '='
    },
    template: "<button\n  class=\"btn btn-sm btn-default\"\n  ng-csv=\"getCSV()\"\n  add-bom=\"true\"\n  charset=\"utf-16\"\n  field-separator=\"\\t\"\n  filename=\"{{filename}}\">\n  <i class=\"fa fa-download\"></i> {{ 'projectsReports.directives.downloadMonthlyReportButton.csv_keishiki_de_daunroodo' | translate }}\n</button>",
    link: function(scope, element, attrs) {
      scope.prepareCampaigns = function(campaigns) {
        return $q(function(resolve) {
          var campaign_child, promises;
          promises = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = campaigns.length; i < len; i++) {
              campaign_child = campaigns[i];
              results.push(ReportCampaignStats.find({
                apikey: scope.project.apikey,
                dimension: scope.isLatest ? 'daily' : 'monthly'
              }, {
                match: {
                  status: scope.status,
                  campaign_id: campaign_child.id,
                  begin_at: scope.filters.begin_at,
                  start_at: scope.filters.start_at ? scope.filters.start_at : void 0
                },
                sort: {
                  end_at: -1
                }
              }));
            }
            return results;
          })();
          return $q.all(promises).then(function(res) {
            var campaign, campaignStatArray, end_at, i, j, len, len1, start_at, stat;
            campaigns = [];
            for (i = 0, len = res.length; i < len; i++) {
              campaignStatArray = res[i];
              for (j = 0, len1 = campaignStatArray.length; j < len1; j++) {
                stat = campaignStatArray[j];
                campaign = _.chain(scope.campaigns).filter(function(c) {
                  return c.id === stat.campaign_id;
                }).head().value();
                campaign = _.assignIn({}, campaign);
                campaign.stats = stat;
                start_at = new Date(scope.filters.begin_at);
                end_at = moment(scope.filters.begin_at).add(1, 'day').endOf('month').toDate();
                if (new Date(campaign.start_at) > start_at) {
                  start_at = new Date(campaign.start_at);
                }
                if (new Date(campaign.end_at) < end_at) {
                  end_at = new Date(campaign.end_at);
                }
                campaign.start_at = start_at;
                campaign.end_at = end_at;
                campaigns.push(campaign);
              }
            }
            return resolve(campaigns);
          });
        });
      };
      return scope.getCSV = function() {
        scope.filename = "report_" + scope.project.apikey + "_" + (moment(scope.filters.begin_at).format('YYYYMMDD')) + ".csv";
        return $q(function(resolve) {
          return scope.prepareCampaigns(scope.campaigns).then(function(campaignsWithStats) {
            return clientReportCsvCreator.createCsv(scope.project, campaignsWithStats, scope.isAb);
          }).then(function(res) {
            if (scope.isLatest) {
              res.unshift([
                $translate.instant('projectsReports.directives.downloadMonthlyReportButton.csv_header_preliminary', {
                  yearmonth: moment(scope.filters.start_at).format($filter('translate')('sharedModules.dateTimeFormats.yearMonth')),
                  yearmonthday: moment(scope.filters.start_at).format($filter('translate')('sharedModules.dateTimeFormats.yearMonthDay'))
                })
              ]);
            } else {
              res.unshift([
                $translate.instant('projectsReports.directives.downloadMonthlyReportButton.csv_header', {
                  yearmonth: moment(scope.filters.start_at).format($filter('translate')('sharedModules.dateTimeFormats.yearMonth'))
                })
              ]);
            }
            return resolve(res);
          });
        });
      };
    }
  };
}]);


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

angular.module('zc.projects.reports').controller('ReportsCtrl', ["$scope", "$state", "$q", "$translate", "Devise", "Project", "Campaign", "Page", "Report", "ReportCampaignStats", "ReportRange", "currentProject", "currencies", function($scope, $state, $q, $translate, Devise, Project, Campaign, Page, Report, ReportCampaignStats, ReportRange, currentProject, currencies) {
  var CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM, checkAb, getReportCampaignStats, matchQuery, promises, status;
  Page.setBodyClass('');
  $translate('projectsReports.controllers.list.repooto_ichiran').then(function(translation) {
    return Page.setTitle(translation);
  });
  CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM = moment('2017/05/01', 'YYYY/MM/DD');
  $scope.Devise = Devise;
  $scope.Project = Project;
  $scope.currency = currencies[currentProject.currency];
  $scope.Report = Report;
  $scope.currentProject = currentProject;
  $scope.isAb = false;
  $scope.canShowInvoiceAmount = function(begin_at) {
    return moment(begin_at).isSameOrAfter(CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM) || currentProject.product_line !== 'zenclerk_lp';
  };
  getReportCampaignStats = function(report, dimension, status) {
    return ReportCampaignStats.find({
      apikey: currentProject.apikey,
      dimension: dimension,
      campaign_id: {
        '$in': report.campaign_ids
      }
    }, {
      match: {
        status: status,
        begin_at: report.begin_at,
        start_at: report.start_at ? report.start_at : void 0,
        end_at: report.end_at
      }
    });
  };
  if (ReportRange.hasLatest()) {
    promises = (function() {
      var i, len, ref, results;
      ref = ['trial', 'contracted'];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        status = ref[i];
        matchQuery = {
          target: null,
          device: null,
          status: status,
          begin_at: {
            $gte: ReportRange.getLatest().begin_at
          }
        };
        if (status === 'contracted' && !currentProject.contracted_at) {
          break;
        }
        if (status === 'trial' && currentProject.contracted_at) {
          matchQuery.start_at = {
            $lt: currentProject.contracted_at
          };
        }
        results.push(Report.findOne({
          apikey: currentProject.apikey,
          dimension: 'daily'
        }, {
          match: matchQuery,
          sort: {
            end_at: -1
          }
        }));
      }
      return results;
    })();
    $q.all(promises).then(function(arg) {
      var contracted_report_stats, trial_report_stats;
      trial_report_stats = arg[0], contracted_report_stats = arg[1];
      return checkAb(trial_report_stats, contracted_report_stats).then(function() {
        return $scope.daily_reports = {
          trial: trial_report_stats,
          contracted: contracted_report_stats
        };
      });
    });
  }
  promises = (function() {
    var i, len, ref, results;
    ref = ['trial', 'contracted'];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      status = ref[i];
      results.push(Report.find({
        apikey: currentProject.apikey,
        dimension: 'monthly'
      }, {
        match: {
          target: null,
          device: null,
          status: status
        },
        sort: {
          begin_at: -1
        }
      }).then(function(monthly_reports) {
        return _.each(monthly_reports, function(report) {
          return getReportCampaignStats(report, 'monthly', status).then(function(report_campaigns) {
            if (_.has(report_campaigns, '0.all_experimental')) {
              return report;
            }
            report.all_experimental = {
              conversion_price: _.sumBy(report_campaigns, 'experimental.conversion_price'),
              conversion_count: _.sumBy(report_campaigns, 'experimental.conversion_count')
            };
            return report;
          });
        });
      }));
    }
    return results;
  })();
  $q.all(promises).then(function(arg) {
    var contracted_report_stats, trial_report_stats;
    trial_report_stats = arg[0], contracted_report_stats = arg[1];
    return checkAb(trial_report_stats, contracted_report_stats).then(function() {
      return $scope.monthly_reports = {
        trial: trial_report_stats,
        contracted: contracted_report_stats
      };
    });
  });
  $scope.showReport = function(report) {
    var reportId;
    reportId = moment(report.begin_at).tz(currentProject.region).valueOf();
    return $state.go('admin.projects.reports.show', {
      projectId: $state.params.projectId,
      reportId: reportId,
      status: report.status
    });
  };
  return checkAb = function(trial_report_stats, contracted_report_stats) {
    var campaign_ids, i, len, stat, stats, trialReportStats;
    if (trial_report_stats == null) {
      trial_report_stats = [];
    }
    if (contracted_report_stats == null) {
      contracted_report_stats = [];
    }
    trialReportStats = trial_report_stats;
    if (!_.isArray(trialReportStats)) {
      trialReportStats = [trial_report_stats];
    }
    stats = trialReportStats.concat(contracted_report_stats);
    campaign_ids = [];
    for (i = 0, len = stats.length; i < len; i++) {
      stat = stats[i];
      campaign_ids = campaign_ids.concat(stat.campaign_ids);
    }
    campaign_ids = _.uniq(campaign_ids);
    return $q.all(_.map(campaign_ids, function(campaign_id) {
      return Campaign.get({
        projectId: $state.params.projectId,
        campaignId: campaign_id
      });
    })).then(function(campaigns) {
      return $scope.isAb = _.some(campaigns, function(campaign) {
        return campaign.campaign_control_percent !== 0 && !campaign.is_secret_ab;
      });
    });
  };
}]);


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcReportGraph', ["$filter", "$translate", "Report", "Chart", "currencies", function($filter, $translate, Report, Chart, currencies) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      filters: '=',
      isLatest: '='
    },
    templateUrl: '/templates/projects.reports/report_graph.html',
    link: function(scope, element, attrs) {
      var BILLING_RATE, MAX_SCALE_RATE, currency;
      BILLING_RATE = 10;
      MAX_SCALE_RATE = 1.1;
      currency = currencies[scope.project.currency];
      return Report.find({
        apikey: scope.project.apikey,
        dimension: 'daily'
      }, {
        match: {
          device: null,
          target: null,
          status: scope.filters.status,
          begin_at: scope.filters.begin_at
        },
        sort: {
          start_at: 1
        }
      }).then(function(report_stats) {
        var contributionPriceLimit, stats;
        scope.chartConfig = Chart.getChartConfig('report');
        if (scope.project.budget && scope.isLatest) {
          contributionPriceLimit = scope.project.budget * BILLING_RATE;
          scope.chartConfig.options.yAxis.plotLines = [
            {
              value: contributionPriceLimit,
              color: 'red',
              dashStyle: 'shortdash',
              width: 2,
              label: {
                text: $translate.instant('projectsReports.directives.reportGraph.yosanjou_kiri_kingaku'),
                y: 15
              }
            }
          ];
        }
        scope.chartConfig.series = [];
        return Chart.addSeries(scope.chartConfig, {
          name: $translate.instant('projectsReports.directives.reportGraph.kakutoku_uriage'),
          data: (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = report_stats.length; i < len; i++) {
              stats = report_stats[i];
              results.push([stats.start_at.valueOf(), stats.contribution_price]);
            }
            return results;
          })(),
          tooltip: {
            valuePrefix: currency.symbol,
            valueSuffix: currency.suffix,
            valueDecimals: currency.fractionSize
          }
        });
      });
    }
  };
}]);


/***/ }),
/* 1205 */
/***/ (function(module, exports) {

angular.module('zc.projects.reports').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.projects.reports', {
    url: '/reports',
    views: {
      'content@': {
        templateUrl: '/templates/projects.reports/list.html',
        controller: 'ReportsCtrl'
      }
    }
  }).state('admin.projects.reports.show', {
    url: '/{reportId:int}/:status',
    views: {
      'content@': {
        templateUrl: '/templates/projects.reports/show.html',
        controller: 'ReportCtrl'
      }
    }
  });
}]);


/***/ }),
/* 1206 */
/***/ (function(module, exports) {

angular.module('zc.projects.reports').controller('ReportCtrl', ["$scope", "$state", "$q", "$translate", "Project", "Page", "Report", "ReportCampaignStats", "Campaign", "ReportRange", "Devise", "currentProject", "currencies", function($scope, $state, $q, $translate, Project, Page, Report, ReportCampaignStats, Campaign, ReportRange, Devise, currentProject, currencies) {
  var CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM, begin_at, dimension;
  Page.setBodyClass('');
  $translate('projectsReports.controllers.show.repooto_shousai').then(function(translation) {
    return Page.setTitle(translation);
  });
  CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM = moment('2017/05/01', 'YYYY/MM/DD');
  $scope.Project = Project;
  $scope.Devise = Devise;
  $scope.Report = Report;
  $scope.currentProject = currentProject;
  $scope.currency = currencies[currentProject.currency];
  $scope.campaigns = [];
  $scope.isAb = false;
  begin_at = new Date(parseInt($state.params.reportId));
  $scope.status = $state.params.status;
  $scope.can_show_zenclerk_lp_invoice_amount = moment(begin_at).isSameOrAfter(CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM);
  $scope.showList = function() {
    return $state.go('admin.projects.reports', {
      projectId: $state.params.projectId
    });
  };
  $scope.prevMonth = moment(begin_at).tz(currentProject.region).subtract(1, 'month').toDate();
  $scope.showPrevMonth = function() {
    var reportId;
    reportId = $scope.prevMonth.valueOf();
    return $state.go('admin.projects.reports.show', {
      projectId: $state.params.projectId,
      reportId: reportId
    });
  };
  $scope.nextMonth = moment(begin_at).tz(currentProject.region).add(1, 'month').toDate();
  $scope.showNextMonth = function() {
    var reportId;
    reportId = $scope.nextMonth.valueOf();
    return $state.go('admin.projects.reports.show', {
      projectId: $state.params.projectId,
      reportId: reportId
    });
  };
  if (ReportRange.isLatest(begin_at)) {
    $scope.isLatest = true;
    dimension = 'daily';
  } else {
    $scope.isLatest = false;
    dimension = 'monthly';
  }
  return Report.findOne({
    apikey: currentProject.apikey,
    dimension: dimension
  }, {
    match: {
      target: null,
      device: null,
      status: $scope.status,
      begin_at: begin_at
    },
    sort: {
      end_at: -1
    }
  }).then(function(report_stats) {
    var campaign_id, promises;
    if (!report_stats) {
      return;
    }
    ReportCampaignStats.find({
      apikey: currentProject.apikey,
      dimension: dimension,
      campaign_id: {
        '$in': report_stats.campaign_ids
      }
    }, {
      match: {
        status: $scope.status,
        begin_at: new Date(report_stats.begin_at),
        start_at: report_stats.start_at ? new Date(report_stats.start_at) : void 0,
        end_at: new Date(report_stats.end_at)
      }
    }).then(function(report_campaigns) {
      if (_.has(report_campaigns, '0.all_experimental')) {
        return;
      }
      return report_stats.all_experimental = {
        conversion_price: _.sumBy(report_campaigns, 'experimental.conversion_price'),
        conversion_count: _.sumBy(report_campaigns, 'experimental.conversion_count')
      };
    });
    $scope.report = report_stats;
    $scope.filters = {
      dimension: dimension,
      begin_at: begin_at,
      status: $scope.status,
      start_at: report_stats.start_at
    };
    promises = (function() {
      var i, len, ref, results;
      ref = $scope.report.campaign_ids;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        campaign_id = ref[i];
        results.push(Campaign.get({
          projectId: currentProject.id,
          campaignId: campaign_id
        }));
      }
      return results;
    })();
    return $q.all(promises).then(function(campaigns) {
      $scope.campaigns = campaigns;
      return $scope.isAb = _.some($scope.campaigns, function(campaign) {
        return campaign.campaign_control_percent !== 0 && !campaign.is_secret_ab;
      });
    });
  });
}]);


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentEditor', ["CampaignSegment", function(CampaignSegment) {
  return {
    templateUrl: '/templates/projects.segments/campaign_segment_editor.html',
    scope: {
      project: "=",
      campaignSegment: "=",
      readOnly: "@"
    },
    link: function(scope, element, attrs) {
      scope.CampaignSegment = CampaignSegment;
      return scope.CampaignSegment.checkZcRule(scope.campaignSegment);
    }
  };
}]);


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentList', ["$injector", "$state", "$translate", "CampaignSegment", "Meta", "Devise", "lib", function($injector, $state, $translate, CampaignSegment, Meta, Devise, lib) {
  return {
    restrict: 'E',
    templateUrl: "/templates/projects.segments/campaign_segment_list.html",
    replace: true,
    scope: {
      currentProject: '='
    },
    link: function(scope, element, attrs) {
      scope.Devise = Devise;
      scope.campaign_segments = [];
      if (scope.Devise.isMaster()) {
        scope.masterFeaturesAllowed = true;
      }
      scope.updateCampaignSegments = function() {
        return CampaignSegment.all(scope.currentProject.id).then(function(res) {
          return scope.campaign_segments = _.chain(res).filter(function(d) {
            return d.segment_type !== 'custom_old';
          }).filter(function(d) {
            return !d.deprecated;
          }).sortBy(function(d) {
            return -new Date(d.created_at);
          }).value();
        });
      };
      scope.copySegment = function(campaignSegment) {
        var newSegment;
        if (campaignSegment.segment_type === 'custom_old') {
          alertify.error($translate.instant('projectsSegments.directives.campaignSegmentList.furui_shikumi_no'));
          return;
        }
        newSegment = _.assignIn({}, campaignSegment, newSegment);
        newSegment.id = void 0;
        newSegment.name = lib.copyName(newSegment.name);
        return CampaignSegment.create({
          projectId: scope.currentProject.id
        }, newSegment).then(function(res) {
          return scope.updateCampaignSegments();
        });
      };
      scope.removeSegment = function(campaignSegment) {
        return CampaignSegment["delete"](scope.currentProject.id, campaignSegment.id).then(function(res) {
          return scope.updateCampaignSegments();
        });
      };
      scope.invalidateSegment = function(campaignSegment) {
        return CampaignSegment.update({
          projectId: scope.currentProject.id,
          id: campaignSegment.id
        }, {
          deprecated: true
        }).then(function(res) {
          return scope.updateCampaignSegments();
        });
      };
      return scope.updateCampaignSegments();
    }
  };
}]);


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentOptions', ["$translate", "Meta", "ProjectAdvertising", "ProjectNewsletterParameter", "ProjectLoginEvaluator", "PageType", function($translate, Meta, ProjectAdvertising, ProjectNewsletterParameter, ProjectLoginEvaluator, PageType) {
  return {
    restrict: 'E',
    templateUrl: '/templates/projects.segments/campaign_segment_options.html',
    replace: true,
    scope: {
      project: '=',
      segment: '=',
      showOnly: '='
    },
    link: function(scope, element, attrs) {
      scope.allowedConditionsByType = {};
      scope.isAllowedCondition = function(condition) {
        return false;
      };
      scope.advertisings = [];
      scope.newsletterParameters = [];
      scope.loginEvaluators = [];
      scope.pageTypes = [];
      scope.allPageTypes = [];
      scope.allCountryCodes = [];
      scope.currentLimitPageTypes = [];
      scope.currentExcludePageTypes = [];
      scope.currentLimitToSessionsWhoVisit = [];
      scope.currentExcludeSessionsWhoVisit = [];
      scope.currentLimitOfferPageTypes = [];
      scope.currentExcludeOfferPageTypes = [];
      ProjectAdvertising.all(scope.project.id).then(function(res) {
        return scope.advertisings = res;
      });
      ProjectNewsletterParameter.all(scope.project.id).then(function(res) {
        return scope.newsletterParameters = res;
      });
      ProjectLoginEvaluator.all(scope.project.id).then(function(res) {
        return scope.loginEvaluators = res;
      });
      scope.filterPageTypes = function(segment) {
        if (segment && segment.conditions_json.limit_to_landing_page_types) {
          scope.currentLimitPageTypes = _.filter(scope.allPageTypes, function(d) {
            return _.includes([d.page_type, d.custom_name], segment.conditions_json.limit_to_landing_page_types[0]);
          });
        }
        if (segment && segment.conditions_json.exclude_landing_page_types) {
          scope.currentExcludePageTypes = _.filter(scope.allPageTypes, function(d) {
            return _.includes([d.page_type, d.custom_name], segment.conditions_json.exclude_landing_page_types[0]);
          });
        }
        if (segment && segment.conditions_json.limit_to_sessions_who_visit) {
          scope.currentLimitToSessionsWhoVisit = _.filter(scope.allPageTypes, function(d) {
            return _.includes([d.page_type, d.custom_name], segment.conditions_json.limit_to_sessions_who_visit[0]);
          });
        }
        if (segment && segment.conditions_json.exclude_sessions_who_visit) {
          scope.currentExcludeSessionsWhoVisit = _.filter(scope.allPageTypes, function(d) {
            return _.includes([d.page_type, d.custom_name], segment.conditions_json.exclude_sessions_who_visit[0]);
          });
        }
        if (segment && segment.conditions_json.limit_to_offer_page_types) {
          scope.currentLimitOfferPageTypes = _.filter(scope.allPageTypes, function(d) {
            return _.includes([d.page_type, d.custom_name], segment.conditions_json.limit_to_offer_page_types[0]);
          });
        }
        if (segment && segment.conditions_json.exclude_offer_page_types) {
          return scope.currentExcludeOfferPageTypes = _.filter(scope.allPageTypes, function(d) {
            return _.includes([d.page_type, d.custom_name], segment.conditions_json.exclude_offer_page_types[0]);
          });
        }
      };
      Promise.all([Meta.getCampaignSegmentAllowedConditions(), PageType.all(scope.project.id), Meta.getPageTypes(), Meta.getCountryCodes()]).then(function(arg) {
        var allCountryCodes, allPageTypes, allowedConditionsByType, base, base1, base10, base11, base12, base2, base3, base4, base5, base6, base7, base8, base9, customPageTypes, notIncludedIndex, pageTypes;
        allowedConditionsByType = arg[0], allPageTypes = arg[1], pageTypes = arg[2], allCountryCodes = arg[3];
        scope.allowedConditionsByType = allowedConditionsByType;
        scope.allPageTypes = allPageTypes;
        scope.allCountryCodes = allCountryCodes;
        pageTypes = _.filter(pageTypes, function(pageType) {
          return pageType.name !== '_custom_';
        });
        customPageTypes = _.chain(allPageTypes).filter({
          page_type: '_custom_'
        }).uniqBy('custom_name').map(function(page_type) {
          return {
            label: $translate.instant('projectsSegments.directives.campaignSegmentOptions.kasutamu', {
              customname: page_type.custom_name
            }),
            name: page_type.custom_name
          };
        }).value();
        scope.pageTypes = customPageTypes.concat(pageTypes);
        scope.isAllowedCondition = function(condition) {
          if (!scope.segment) {
            return false;
          }
          if (!scope.allowedConditionsByType[scope.segment.segment_type]) {
            return false;
          }
          return scope.allowedConditionsByType[scope.segment.segment_type].indexOf(condition) >= 0;
        };
        scope.toggleTrigger = function(trigger) {
          var idx;
          idx = scope.segment.conditions_json.triggers.indexOf(trigger);
          if (idx >= 0) {
            return scope.segment.conditions_json.triggers.splice(idx, 1);
          } else {
            return scope.segment.conditions_json.triggers.push(trigger);
          }
        };
        scope.hasDetails = function() {
          var condition, i, len, ref;
          if (!scope.segment) {
            return false;
          }
          ref = scope.allowedConditionsByType[scope.segment.segment_type];
          for (i = 0, len = ref.length; i < len; i++) {
            condition = ref[i];
            if (_.includes(_.keys(scope.segment.conditions_json), condition)) {
              return true;
            }
          }
          return false;
        };
        if (scope.isAllowedCondition('limit_to_landing_page_types')) {
          (base = scope.segment.conditions_json).limit_to_landing_page_types || (base.limit_to_landing_page_types = []);
          (base1 = scope.segment.conditions_json.limit_to_landing_page_types)[0] || (base1[0] = 'NOT_SELECTED');
        }
        if (scope.isAllowedCondition('exclude_landing_page_types')) {
          (base2 = scope.segment.conditions_json).exclude_landing_page_types || (base2.exclude_landing_page_types = []);
          (base3 = scope.segment.conditions_json.exclude_landing_page_types)[0] || (base3[0] = 'NOT_SELECTED');
        }
        if (scope.isAllowedCondition('limit_to_sessions_who_visit')) {
          (base4 = scope.segment.conditions_json).limit_to_sessions_who_visit || (base4.limit_to_sessions_who_visit = []);
          (base5 = scope.segment.conditions_json.limit_to_sessions_who_visit)[0] || (base5[0] = 'NOT_SELECTED');
        }
        if (scope.isAllowedCondition('exclude_sessions_who_visit')) {
          (base6 = scope.segment.conditions_json).exclude_sessions_who_visit || (base6.exclude_sessions_who_visit = []);
          (base7 = scope.segment.conditions_json.exclude_sessions_who_visit)[0] || (base7[0] = 'NOT_SELECTED');
        }
        if (scope.isAllowedCondition('limit_to_offer_page_types')) {
          (base8 = scope.segment.conditions_json).limit_to_offer_page_types || (base8.limit_to_offer_page_types = []);
          (base9 = scope.segment.conditions_json.limit_to_offer_page_types)[0] || (base9[0] = 'NOT_SELECTED');
        }
        if (scope.isAllowedCondition('exclude_offer_page_types')) {
          (base10 = scope.segment.conditions_json).exclude_offer_page_types || (base10.exclude_offer_page_types = []);
          (base11 = scope.segment.conditions_json.exclude_offer_page_types)[0] || (base11[0] = 'NOT_SELECTED');
        }
        if (scope.isAllowedCondition('triggers')) {
          (base12 = scope.segment.conditions_json).triggers || (base12.triggers = []);
          notIncludedIndex = scope.segment.conditions_json.triggers.indexOf('NOT_SELECTED');
          if (notIncludedIndex !== -1) {
            scope.segment.conditions_json.triggers.splice(notIncludedIndex, 1);
          }
        }
        return scope.filterPageTypes(scope.segment);
      });
      scope.$watchCollection('segment.conditions_json.limit_to_landing_page_types', function(newval) {
        if (newval) {
          return scope.filterPageTypes(scope.segment);
        }
      });
      scope.$watchCollection('segment.conditions_json.exclude_landing_page_types', function(newval) {
        if (newval) {
          return scope.filterPageTypes(scope.segment);
        }
      });
      scope.$watchCollection('segment.conditions_json.limit_to_sessions_who_visit', function(newval) {
        if (newval) {
          return scope.filterPageTypes(scope.segment);
        }
      });
      scope.$watchCollection('segment.conditions_json.exclude_sessions_who_visit', function(newval) {
        if (newval) {
          return scope.filterPageTypes(scope.segment);
        }
      });
      scope.$watchCollection('segment.conditions_json.limit_to_offer_page_types', function(newval) {
        if (newval) {
          return scope.filterPageTypes(scope.segment);
        }
      });
      return scope.$watchCollection('segment.conditions_json.exclude_offer_page_types', function(newval) {
        if (newval) {
          return scope.filterPageTypes(scope.segment);
        }
      });
    }
  };
}]);


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentRow', ["CampaignSegment", "Meta", "$state", "lib", function(CampaignSegment, Meta, $state, lib) {
  return {
    restrict: 'E',
    templateUrl: "/templates/projects.segments/campaign_segment_row.html",
    replace: true,
    scope: {
      campaign: "="
    },
    link: function(scope, element, attrs) {}
  };
}]);


/***/ }),
/* 1211 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentShow', ["CampaignSegment", "Devise", "titlesBySegmentType", function(CampaignSegment, Devise, titlesBySegmentType) {
  return {
    restrict: 'E',
    templateUrl: "/templates/projects.segments/campaign_segment_show.html",
    replace: true,
    scope: {
      project: "=",
      segmentId: "="
    },
    link: function(scope, element, attrs) {
      scope.Devise = Devise;
      scope.detailsVisible = false;
      CampaignSegment.get(scope.project.id, scope.segmentId).then(function(res) {
        return scope.segment = res;
      });
      scope.getPageTitle = function(segment_type) {
        return titlesBySegmentType[segment_type];
      };
      return scope.getTemplateUrl = function() {
        var type;
        if (!scope.segment) {
          return;
        }
        type = (function() {
          switch (scope.segment.segment_type) {
            case 'custom_old':
              return 'custom';
            default:
              return scope.segment.segment_type;
          }
        })();
        return "/templates/projects.segments/campaign_segment_show_" + type + ".html";
      };
    }
  };
}]);


/***/ }),
/* 1212 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCampaignSegmentTableBrief', ["CampaignSegment", "Meta", "$state", "lib", function(CampaignSegment, Meta, $state, lib) {
  return {
    restrict: 'E',
    templateUrl: "/templates/projects.segments/campaign_segment_table_brief.html",
    replace: true,
    scope: {
      segment: "="
    },
    link: function(scope, element, attrs) {}
  };
}]);


/***/ }),
/* 1213 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('countryCodeSelector', ["$modal", "$translate", "Image", "lib", function($modal, $translate, Image, lib) {
  return {
    restrict: 'E',
    scope: {
      countryCodes: '=',
      disabled: '='
    },
    template: "<select\n  class=\"multi-select\"\n  style=\"width: 100%\"\n  ng-model=\"countryCodes\"\n  name=\"country_code_selector\"\n  multiple=\"true\">\n</select>",
    link: function(scope, element, attrs) {
      var availableCountryCodes, data, ref;
      element = element.children('select');
      if ((ref = scope.disabled) === 'true' || ref === true) {
        availableCountryCodes = scope.countryCodes;
        element.prop('disabled', true);
      } else {
        availableCountryCodes = scope.$parent.allCountryCodes;
      }
      data = _.map(availableCountryCodes, function(countryCode) {
        return {
          id: countryCode,
          text: countryCode,
          selected: _.includes(scope.countryCodes, countryCode)
        };
      });
      return element.select2({
        data: data
      });
    }
  };
}]);


/***/ }),
/* 1214 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('SegmentEditCtrl', ["$scope", "$state", "$translate", "Page", "CampaignSegment", "Devise", "currentProject", "segment", "titlesBySegmentType", function($scope, $state, $translate, Page, CampaignSegment, Devise, currentProject, segment, titlesBySegmentType) {
  var IGNORED_PARAMETERS, QUERY_INTERVAL_MS, isIgnoredParameterChanged;
  Page.setBodyClass('');
  $translate('projectsSegments.controllers.edit.segumento_henshuu').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.Devise = Devise;
  $scope.project = currentProject;
  $scope.segment = segment;
  $scope.detailsVisible = false;
  CampaignSegment.toZcRule($scope.segment);
  QUERY_INTERVAL_MS = 300;
  IGNORED_PARAMETERS = ['name'];
  isIgnoredParameterChanged = function(newParams, oldParams) {
    return _.some(IGNORED_PARAMETERS, function(param) {
      var newValue, oldValue;
      newValue = _.get(newParams, param);
      oldValue = _.get(oldParams, param);
      return !_.isEqual(newValue, oldValue);
    });
  };
  $scope.getPageTitle = function(segment_type) {
    return titlesBySegmentType[segment_type];
  };
  $scope.getTemplateUrl = function() {
    var type;
    type = (function() {
      switch ($scope.segment.segment_type) {
        case 'custom_old':
          return 'custom';
        default:
          return $scope.segment.segment_type;
      }
    })();
    return "/templates/projects.segments/campaign_segment_edit_" + type + ".html";
  };
  $scope.save = function() {
    var promise, ref;
    if ((ref = $scope.segment.segment_type) === 'custom' || ref === 'custom_old') {
      CampaignSegment.toZcRule($scope.segment);
      if ($scope.segment.message) {
        alertify.error($translate.instant('projectsSegments.controllers.edit.invalid_format'));
        return;
      }
    }
    if ($scope.segment.id) {
      promise = CampaignSegment.update({
        projectId: $scope.project.id,
        id: $scope.segment.id
      }, {
        campaign_segment: $scope.segment
      });
    } else {
      promise = CampaignSegment.create({
        projectId: $scope.project.id
      }, {
        campaign_segment: $scope.segment
      });
    }
    return promise.then(function(res) {
      if (res.id) {
        alertify.success($translate.instant('projectsSegments.controllers.edit.hozon_shimashita'));
        return $state.go('admin.projects.segments', {
          projectId: $scope.project.id
        });
      } else {
        return alertify.error($translate.instant('projectsSegments.controllers.edit.hozon_ga_shippai'));
      }
    });
  };
  return $scope.$watch('segment', _.debounce(function(newObject, oldObject) {
    if (!newObject) {
      return;
    }
    if (isIgnoredParameterChanged(newObject, oldObject)) {
      return;
    }
    return CampaignSegment.getMongoQuery(newObject).then(function(res) {
      return $scope.segment.mongo_query = res;
    });
  }, QUERY_INTERVAL_MS), true);
}]);


/***/ }),
/* 1215 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('SegmentListCtrl', ["$scope", "$state", "$translate", "Page", "currentProject", function($scope, $state, $translate, Page, currentProject) {
  Page.setBodyClass('');
  $translate('projectsSegments.controllers.list.segumento_ichiran').then(function(translation) {
    return Page.setTitle(translation);
  });
  return $scope.currentProject = currentProject;
}]);


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

angular.module('zc.projects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.projects.segments', {
    url: '/segments',
    views: {
      'content@': {
        templateUrl: '/templates/projects.segments/list.html',
        controller: 'SegmentListCtrl'
      }
    }
  }).state('admin.projects.segments.new', {
    url: '/new/:segmentType',
    views: {
      'content@': {
        templateUrl: '/templates/projects.segments/edit.html',
        controller: 'SegmentEditCtrl',
        resolve: {
          segment: ["$stateParams", function($stateParams) {
            var segment;
            segment = {
              project_id: $stateParams.projectId,
              segment_type: $stateParams.segmentType,
              name: "",
              description: "",
              raw: "{}",
              json: "{}",
              conditions_json: {}
            };
            if ($stateParams.segmentType === 'inactive') {
              segment.conditions_json = {
                days_since_last_conversion: 30
              };
            }
            segment.conditions_json.history_back_trigger_option = 'any_domain';
            return segment;
          }]
        }
      }
    }
  }).state('admin.projects.segments.show', {
    url: '/{segmentId:int}',
    views: {
      'content@': {
        templateUrl: '/templates/projects.segments/show.html',
        controller: 'SegmentShowCtrl',
        resolve: {
          segment: ["CampaignSegment", "$stateParams", "currentProject", function(CampaignSegment, $stateParams, currentProject) {
            return CampaignSegment.get(currentProject.id, $stateParams.segmentId);
          }]
        }
      }
    }
  }).state('admin.projects.segments.edit', {
    url: '/{segmentId:int}/edit',
    views: {
      'content@': {
        templateUrl: '/templates/projects.segments/edit.html',
        controller: 'SegmentEditCtrl',
        resolve: {
          segment: ["CampaignSegment", "$stateParams", "currentProject", function(CampaignSegment, $stateParams, currentProject) {
            return CampaignSegment.get(currentProject.id, $stateParams.segmentId);
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('SegmentShowCtrl', ["$scope", "$state", "$translate", "Page", "currentProject", "segment", function($scope, $state, $translate, Page, currentProject, segment) {
  Page.setBodyClass('');
  $translate('projectsSegments.controllers.show.segumento_shousai').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.project = currentProject;
  return $scope.segment = segment;
}]);


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

angular.module('zc.projects').service('titlesBySegmentType', ["$filter", function($filter) {
  return {
    "new": $filter('translate')('projectsSegments.titlesBySegmentType.hitsuji_kounyuu'),
    all: $filter('translate')('projectsSegments.titlesBySegmentType.zentai'),
    new_inverse: $filter('translate')('projectsSegments.titlesBySegmentType.hitsuji_kounyuu_igai'),
    cv_users: $filter('translate')('projectsSegments.titlesBySegmentType.ikkai_ijou_kounyuu'),
    inactive: $filter('translate')('projectsSegments.titlesBySegmentType.kyuumin_yuuzaa'),
    custom: $filter('translate')('projectsSegments.titlesBySegmentType.tokushu'),
    custom_old: $filter('translate')('projectsSegments.titlesBySegmentType.tokushu_nasegumento_kyuu')
  };
}]);


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('visitorSegmentSelector', ["$modal", "$translate", "Image", "ProjectVisitorSegment", "lib", function($modal, $translate, Image, ProjectVisitorSegment, lib) {
  return {
    restrict: 'E',
    scope: {
      visitorSegmentIds: '=',
      disabled: '='
    },
    template: "<select\n  class=\"multi-select\"\n  style=\"width: 100%\"\n  ng-model=\"visitorSegmentIds\"\n  name=\"visitor_segment_selector\"\n  multiple=\"true\">\n</select>",
    link: function(scope, element, attrs) {
      element = element.children('select');
      return ProjectVisitorSegment.all(scope.$parent.project.id).then(function(res) {
        var allSegmentIds, allSegments, availableVisitorSegmentIds, data, ref;
        allSegments = res;
        allSegmentIds = _.map(allSegments, function(visitorSegment) {
          return visitorSegment.id.toString();
        });
        if ((ref = scope.disabled) === 'true' || ref === true) {
          availableVisitorSegmentIds = scope.visitorSegmentIds;
          element.prop('disabled', true);
        } else {
          availableVisitorSegmentIds = allSegmentIds;
        }
        data = _.map(availableVisitorSegmentIds, function(visitorSegmentId) {
          return {
            id: visitorSegmentId,
            text: _.find(allSegments, {
              id: parseInt(visitorSegmentId)
            }).name,
            selected: _.includes(scope.visitorSegmentIds, visitorSegmentId)
          };
        });
        return element.select2({
          data: data
        });
      });
    }
  };
}]);


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.projects').factory('BaseProjectConfirm', ["$q", "MongoHistory", "MongoSession", function($q, MongoHistory, MongoSession) {
  var BaseProjectConfirm;
  return BaseProjectConfirm = (function() {
    function BaseProjectConfirm(resourceName, fields) {
      this.resourceName = resourceName;
      this.fields = fields;
    }

    BaseProjectConfirm.prototype.requestRecentHistories = function(scope, elem, attrs) {
      var device, promises;
      promises = (function() {
        var i, len, ref, results;
        ref = ['pc', 'sp'];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          device = ref[i];
          results.push(MongoHistory.find({
            apikey: scope.apikey,
            page_types: 'item',
            device: device,
            opened_at: {
              $gte: moment().subtract(1, 'hour').toDate()
            }
          }, {
            limit: 20
          }));
        }
        return results;
      })();
      return $q.all(promises).then(function(arg) {
        var pc, sp;
        pc = arg[0], sp = arg[1];
        return pc.concat(sp);
      });
    };

    BaseProjectConfirm.prototype.requestRecentCartSessions = function(scope, elem, attrs) {
      var device, promises;
      promises = (function() {
        var i, len, ref, results;
        ref = ['pc', 'sp'];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          device = ref[i];
          results.push(MongoSession.find({
            apikey: scope.apikey,
            'page_types_counts.cart': {
              $gte: 1
            },
            'cart_button_click_count': {
              $gte: 1
            },
            device: device,
            opened_at: {
              $gte: moment().subtract(1, 'day').toDate(),
              $lt: moment().subtract(1, 'hour').toDate()
            }
          }, {
            limit: 20
          }));
        }
        return results;
      })();
      return $q.all(promises).then(function(arg) {
        var pc, sp;
        pc = arg[0], sp = arg[1];
        return pc.concat(sp);
      });
    };

    BaseProjectConfirm.prototype.createDirective = function(request) {
      return {
        restrict: 'E',
        scope: {
          apikey: '=',
          showAlertDevices: '='
        },
        templateUrl: '/templates/projects.settings/base_project_confirm.html',
        link: (function(_this) {
          return function(scope, elem, attrs) {
            scope.resourceName = _this.resourceName;
            return request(scope, elem, attrs).then(function(items) {
              var field, i, item, j, len, len1, ref, val;
              scope.showPC = false;
              scope.showSP = false;
              scope.foundPC = false;
              scope.foundSP = false;
              scope.itemsPC = [];
              scope.itemsSP = [];
              for (i = 0, len = items.length; i < len; i++) {
                item = items[i];
                val = null;
                ref = _this.fields;
                for (j = 0, len1 = ref.length; j < len1; j++) {
                  field = ref[j];
                  val = item[field];
                  if (val) {
                    break;
                  }
                }
                if (!val) {
                  continue;
                }
                if (item.device === 'pc') {
                  scope.foundPC = true;
                  scope.itemsPC.push(val);
                }
                if (item.device === 'sp') {
                  scope.foundSP = true;
                  scope.itemsSP.push(val);
                }
              }
              if (scope.showAlertDevices) {
                if (indexOf.call(scope.showAlertDevices, 'pc') >= 0 && !scope.foundPC) {
                  scope.showPC = true;
                }
                if (indexOf.call(scope.showAlertDevices, 'sp') >= 0 && !scope.foundSP) {
                  return scope.showSP = true;
                }
              } else {
                scope.showPC = true;
                return scope.showSP = true;
              }
            });
          };
        })(this)
      };
    };

    return BaseProjectConfirm;

  })();
}]);


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

angular.module('zc.projects').factory('BaseProjectCrudEditor', function() {
  var BaseProjectCrudEditor;
  return BaseProjectCrudEditor = (function() {
    function BaseProjectCrudEditor(Resource, Meta, templateUrl) {
      this.Resource = Resource;
      this.Meta = Meta;
      this.templateUrl = templateUrl;
      this.baseLink = bind(this.baseLink, this);
    }

    BaseProjectCrudEditor.prototype.getNewItem = function() {
      return {};
    };

    BaseProjectCrudEditor.prototype.baseLink = function(scope, elem, attrs) {
      scope.items = [];
      scope.newItem = this.getNewItem();
      this.Resource.all(scope.projectId).then(function(res) {
        return scope.items = res;
      });
      scope.add = (function(_this) {
        return function() {
          return _this.Resource.create({
            projectId: scope.projectId
          }, scope.newItem).then(function(res) {
            scope.items.push(res);
            return scope.newItem = _this.getNewItem();
          });
        };
      })(this);
      return scope.remove = (function(_this) {
        return function(id) {
          return _this.Resource["delete"](scope.projectId, id).then(function(res) {
            return scope.items = _.reject(scope.items, function(pe) {
              return pe.id === id;
            });
          });
        };
      })(this);
    };

    BaseProjectCrudEditor.prototype.createDirective = function(extScope) {
      var scope;
      if (extScope == null) {
        extScope = {};
      }
      scope = _.assignIn({
        projectId: '='
      }, extScope);
      return {
        restrict: 'E',
        require: '?projectId',
        scope: scope,
        templateUrl: this.templateUrl,
        link: (function(_this) {
          return function(scope, elem, attrs) {
            _this.baseLink(scope, elem, attrs);
            if (_this.link) {
              return _this.link(scope, elem, attrs);
            }
          };
        })(this)
      };
    };

    return BaseProjectCrudEditor;

  })();
});


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcAdvertisingEditor', ["ProjectAdvertising", "Meta", "BaseProjectCrudEditor", function(ProjectAdvertising, Meta, BaseProjectCrudEditor) {
  var AdvertisingEditor, editor;
  AdvertisingEditor = (function(superClass) {
    extend(AdvertisingEditor, superClass);

    function AdvertisingEditor() {
      return AdvertisingEditor.__super__.constructor.apply(this, arguments);
    }

    AdvertisingEditor.prototype.link = function(scope, element, attrs) {
      scope.matchTypes = {};
      return Meta.getAdvertisingMatchTypes().then(function(res) {
        return scope.matchTypes = res;
      });
    };

    return AdvertisingEditor;

  })(BaseProjectCrudEditor);
  editor = new AdvertisingEditor(ProjectAdvertising, Meta, '/templates/projects.settings/campaign/advertising_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('CampaignPolicySetCtrl', ["$scope", "$stateParams", "$window", "CampaignPolicySet", "Api", function($scope, $stateParams, $window, CampaignPolicySet, Api) {
  $scope.campaignPolicySets = [];
  $scope.campaignPolicySet = {
    name: '',
    description: ''
  };
  CampaignPolicySet.all({
    projectId: $stateParams.projectId
  }).then(function(campaignPolicySets) {
    return $scope.campaignPolicySets = campaignPolicySets;
  });
  $scope.removeCampaignPolicySet = function(id) {
    return CampaignPolicySet.destroy({
      projectId: $stateParams.projectId,
      id: id
    }).then(function() {
      return $scope.campaignPolicySets = _.reject($scope.campaignPolicySets, function(set) {
        return set.id === id;
      });
    });
  };
  $scope.downloadCampaignPolicySet = function(id) {
    var endpoint, url;
    endpoint = "/api/projects/" + $stateParams.projectId + "/campaign_policy_sets/" + id + ".csv";
    url = Api.path(endpoint);
    return $window.location = url;
  };
  $scope.campaignPolicySetUploadUrl = "/api/projects/" + $stateParams.projectId + "/campaign_policy_sets";
  return $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    var base;
    event.preventDefault();
    (base = $scope.campaignPolicySet).name || (base.name = flowFile.name.slice(0, -'.csv'.length));
    return CampaignPolicySet.create({
      projectId: $stateParams.projectId
    }, {
      file: flowFile.file,
      name: $scope.campaignPolicySet.name,
      description: $scope.campaignPolicySet.description
    }).then(function(campaignPolicySet) {
      $scope.campaignPolicySets.push(campaignPolicySet);
      return $scope.campaignPolicySet = {
        name: '',
        description: ''
      };
    });
  });
}]);


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcNewsletterParameterEditor', ["ProjectNewsletterParameter", "Meta", "BaseProjectCrudEditor", function(ProjectNewsletterParameter, Meta, BaseProjectCrudEditor) {
  var NewsletterParameterEditor, editor;
  NewsletterParameterEditor = (function(superClass) {
    extend(NewsletterParameterEditor, superClass);

    function NewsletterParameterEditor() {
      return NewsletterParameterEditor.__super__.constructor.apply(this, arguments);
    }

    NewsletterParameterEditor.prototype.link = function(scope, element, attrs) {
      scope.matchTypes = {};
      return Meta.getNewsletterParameterMatchTypes().then(function(res) {
        return scope.matchTypes = res;
      });
    };

    return NewsletterParameterEditor;

  })(BaseProjectCrudEditor);
  editor = new NewsletterParameterEditor(ProjectNewsletterParameter, Meta, '/templates/projects.settings/campaign/newsletter_parameter_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcSegmentCookieEditor', ["ProjectSegmentCookie", "Meta", "BaseProjectCrudEditor", function(ProjectSegmentCookie, Meta, BaseProjectCrudEditor) {
  var SegmentCookieEditor, editor;
  SegmentCookieEditor = (function(superClass) {
    extend(SegmentCookieEditor, superClass);

    function SegmentCookieEditor() {
      return SegmentCookieEditor.__super__.constructor.apply(this, arguments);
    }

    SegmentCookieEditor.prototype.link = function(scope, element, attrs) {};

    return SegmentCookieEditor;

  })(BaseProjectCrudEditor);
  editor = new SegmentCookieEditor(ProjectSegmentCookie, Meta, '/templates/projects.settings/campaign/segment_cookie_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('SettingsCtrl', ["$filter", "$injector", "$scope", "$state", "$stateParams", "$translate", "Page", "Devise", "Project", "PageType", "SettingStatus", "ProjectExcludeIp", "currentProject", "invoiceCalculationTypes", "paymentMethods", "invoiceIssueDays", "invoiceDueDays", "invoicePaymentDays", "invoicePaymentMonths", "excludeIps", "contractStatuses", "trialInvoiceCalculationTypes", "sessionCountEvaluators", "domainLinkTypes", "projectRanks", "productLines", "currencies", "regions", "optTargets", "pricingTypes", "ip", "noPublishPageTypes", "masterUsers", "FacadeV2", function($filter, $injector, $scope, $state, $stateParams, $translate, Page, Devise, Project, PageType, SettingStatus, ProjectExcludeIp, currentProject, invoiceCalculationTypes, paymentMethods, invoiceIssueDays, invoiceDueDays, invoicePaymentDays, invoicePaymentMonths, excludeIps, contractStatuses, trialInvoiceCalculationTypes, sessionCountEvaluators, domainLinkTypes, projectRanks, productLines, currencies, regions, optTargets, pricingTypes, ip, noPublishPageTypes, masterUsers, FacadeV2) {
  var CLIENT_CHANNEL_PREFIX_LENGTH, DEFAULT_TIER_PRICING_FEE_RATE, MAXIMUM_APIKEY_LENGTH, MAX_CHANNEL_NAME_LENGTH, SUB_KPI_OPTS_ZENCLERK, SUB_KPI_OPTS_ZENCLERK_LP, parser, updateMinChargeTierPricingTable, updateMinimumCharge, updateProject;
  MAX_CHANNEL_NAME_LENGTH = 21;
  CLIENT_CHANNEL_PREFIX_LENGTH = 2;
  MAXIMUM_APIKEY_LENGTH = MAX_CHANNEL_NAME_LENGTH - CLIENT_CHANNEL_PREFIX_LENGTH;
  DEFAULT_TIER_PRICING_FEE_RATE = 0.04;
  SUB_KPI_OPTS_ZENCLERK = ['display_cv_value', 'acquired_cv_value'];
  SUB_KPI_OPTS_ZENCLERK_LP = ['display_cv_count', 'acquired_cv_count'];
  $scope.maximumApikeyLength = MAXIMUM_APIKEY_LENGTH;
  $scope.ip = ip;
  $scope.SettingStatus = SettingStatus;
  $scope.project = currentProject;
  $scope.contractStatuses = contractStatuses;
  $scope.trialInvoiceCalculationTypes = trialInvoiceCalculationTypes;
  $scope.invoiceCalculationTypes = invoiceCalculationTypes;
  $scope.paymentMethods = paymentMethods;
  $scope.invoiceIssueDays = invoiceIssueDays;
  $scope.invoiceDueDays = invoiceDueDays;
  $scope.invoicePaymentDays = invoicePaymentDays;
  $scope.invoicePaymentMonths = invoicePaymentMonths;
  $scope.sessionCountEvaluators = sessionCountEvaluators;
  $scope.domainLinkTypes = domainLinkTypes;
  $scope.projectRanks = projectRanks;
  $scope.masterUsers = _.cloneDeep(masterUsers);
  $scope.currencies = currencies;
  $scope.currency = $injector.get('currencies')[currentProject.currency];
  $scope.regions = regions;
  $scope.optTargets = optTargets;
  $scope.productLines = productLines;
  $scope.pricingTypes = pricingTypes;
  $scope.noPublishPageTypes = noPublishPageTypes;
  $scope.isMaster = Devise.isMaster();
  $scope.isCommon = Devise.isCommonUser();
  $scope.appUrl = ZC_CONFIG.AIDEAL_URL;
  $scope.project.is_reviewed = !!currentProject.reviewed_at;
  $scope.project.is_suspended = !!currentProject.suspended_at;
  $scope.project.is_region_set = !!currentProject.region;
  $scope.noPublishPageTypeLimit = 5000;
  $scope.noPublishPageTypesVisibleLimit = 50;
  $scope.minChargeTierPricingTable = null;
  $scope.isMinChargeShouldChanged = false;
  Page.setBodyClass('');
  $translate('projectsSettings.index.editSiteSetting').then(function(translation) {
    return Page.setTitle(translation);
  });
  SettingStatus.updateProjectStatus(currentProject);
  SettingStatus.updateExcludeIpStatus(excludeIps);
  $scope.completeInitialization = function(project) {
    return Project.update({
      projectId: project.id
    }, {
      project: {
        installed_at: moment().startOf('day').toDate()
      }
    }).then(updateProject);
  };
  $scope.completeInstallation = function(project) {
    return Project.update({
      projectId: project.id
    }, {
      project: {
        campaign_status: 'completed'
      }
    }).then(function(project) {
      updateProject(project);
      return $state.go('admin.projects.campaigns.list', {
        projectId: currentProject.id
      });
    });
  };
  $scope.save = function(project) {
    return Project.update({
      projectId: project.id
    }, {
      project: project
    }).then(updateProject);
  };
  $scope.remove = function(project) {
    return Project.remove({
      projectId: project.id
    }).then(function() {
      return $state.go('admin.users.edit');
    })["catch"](function(err) {
      return alertify.error(err.data.message);
    });
  };
  updateProject = function(project) {
    $scope.project = project;
    SettingStatus.updateProjectStatus($scope.project);
    $scope.project.is_reviewed = !!project.reviewed_at;
    $scope.project.is_suspended = !!project.suspended_at;
    return $scope.project.is_region_set = !!currentProject.region;
  };
  $scope.updateSuspendedAt = function() {
    if ($scope.project.is_suspended) {
      return $scope.project.suspended_at = $filter('changeDatetimeFrom')('localToRegion', moment().startOf('day').toDate(), 'string');
    } else {
      return $scope.project.suspended_at = null;
    }
  };
  $scope.addNoPublishPageType = function() {
    return $scope.noPublishPageTypes.push(PageType["new"]({
      project_id: currentProject.id,
      page_type: 'no_publish',
      match_pattern: '/',
      match_type: null
    }));
  };
  $scope.onDestroyNoPublishPageType = function(pageType) {
    var index;
    if (!pageType) {
      return;
    }
    index = $scope.noPublishPageTypes.indexOf(pageType);
    return $scope.noPublishPageTypes.splice(index, 1);
  };
  $scope.$on('uploadedPageTypes', function(event, pageTypes) {
    return $scope.noPublishPageTypes = _.filter(pageTypes, {
      page_type: 'no_publish'
    });
  });
  parser = window.document.createElement('a');
  parser.href = $scope.project.base_url;
  $scope.baseUrl = parser.origin;
  $scope.setNoPublishPageTypesVisibleLimit = function(limit) {
    return $scope.noPublishPageTypesVisibleLimit = limit;
  };
  $scope.removePageTypes = function() {
    return Project.removePageTypes({
      projectId: $scope.project.id,
      page_type: 'no_publish'
    }).then(function(res) {
      return $scope.noPublishPageTypes = [];
    });
  };
  $scope.$watch('project.product_line', function() {
    if ($scope.project.product_line !== 'zenclerk' && $scope.project.pricing_type === 'tiered') {
      $scope.project.pricing_type = 'volume';
    }
    if ($scope.project.product_line === 'zenclerk') {
      $scope.optTargets = _.filter(optTargets, function(opt) {
        return SUB_KPI_OPTS_ZENCLERK.includes(opt.name);
      });
      if (!SUB_KPI_OPTS_ZENCLERK.includes($scope.project.opt_target)) {
        return $scope.project.opt_target = null;
      }
    } else if ($scope.project.product_line === 'zenclerk_lp') {
      $scope.optTargets = _.filter(optTargets, function(opt) {
        return SUB_KPI_OPTS_ZENCLERK_LP.includes(opt.name);
      });
      if (!SUB_KPI_OPTS_ZENCLERK_LP.includes($scope.project.opt_target)) {
        return $scope.project.opt_target = null;
      }
    } else {
      return $scope.project.opt_target = null;
    }
  });
  $scope.$watch('project.pricing_type', function(newValue, oldValue) {
    if (oldValue === 'volume' && newValue === 'tiered') {
      return $scope.project.fee_rate = DEFAULT_TIER_PRICING_FEE_RATE;
    }
  });
  $scope.$watch('project.cookie_server_enabled', function() {
    if (!$scope.project.cookie_server_enabled) {
      $scope.project.cookie_server_client_fqdn = null;
      return $scope.project.cookie_server_aiqua_fqdn = null;
    }
  });
  updateMinimumCharge = function() {
    var pricingTable, targetedTier;
    if ($scope.project.pricing_type === 'minimum_charge' && !!$scope.project.minimum_charge && $scope.isMinChargeShouldChanged) {
      pricingTable = $scope.minChargeTierPricingTable.slice(0, -1);
      if ($scope.project.minimum_charge < Number(pricingTable[0].fee)) {
        targetedTier = pricingTable[0];
      } else {
        targetedTier = _.find(pricingTable.reverse(), function(tier) {
          return $scope.project.minimum_charge >= Number(tier.fee);
        });
      }
      $scope.project.minimum_usage = Number(targetedTier.to);
      return $scope.isMinChargeShouldChanged = false;
    }
  };
  updateMinChargeTierPricingTable = function() {
    return FacadeV2.request("/master/min_charge_tier_pricing_table?cpa=" + $scope.project.base_cpa + "&currency=" + $scope.project.currency, {}).then(function(res) {
      if (res.data) {
        $scope.minChargeTierPricingTable = res.data.pricing_table;
        return $scope.isMinChargeShouldChanged = true;
      }
    });
  };
  $scope.$watch('project.base_cpa', function(newValue, oldValue) {
    if (!!(newValue - oldValue) && $scope.project.pricing_type === 'minimum_charge' && !!$scope.project.base_cpa) {
      updateMinChargeTierPricingTable();
      return updateMinimumCharge();
    }
  });
  return $scope.$watch('project.minimum_charge', function(newValue, oldValue) {
    if (!!(newValue - oldValue)) {
      $scope.isMinChargeShouldChanged = true;
      return updateMinimumCharge();
    }
  });
}]);


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCartButtonEditor', ["ProjectCartButton", "Meta", "BaseProjectCrudEditor", function(ProjectCartButton, Meta, BaseProjectCrudEditor) {
  var CartButtonEditor, editor;
  CartButtonEditor = (function(superClass) {
    extend(CartButtonEditor, superClass);

    function CartButtonEditor() {
      return CartButtonEditor.__super__.constructor.apply(this, arguments);
    }

    CartButtonEditor.prototype.link = function(scope, element, attrs) {
      scope.cartButtonPageTypes = [];
      return Meta.getCartButtonPageTypes().then(function(res) {
        return scope.cartButtonPageTypes = res;
      });
    };

    return CartButtonEditor;

  })(BaseProjectCrudEditor);
  editor = new CartButtonEditor(ProjectCartButton, Meta, '/templates/projects.settings/initialization/cart_button_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1228 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcCartPriceConfirm', ["$filter", "BaseProjectConfirm", function($filter, BaseProjectConfirm) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.initialization.cartPriceConfirm.cartAmount'), ['cart_price']);
  return confirm.createDirective(confirm.requestRecentCartSessions);
}]);


/***/ }),
/* 1229 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCartPriceEditor', ["ProjectCartPrice", "Meta", "BaseProjectCrudEditor", function(ProjectCartPrice, Meta, BaseProjectCrudEditor) {
  var CartPriceEditor, editor;
  CartPriceEditor = (function(superClass) {
    extend(CartPriceEditor, superClass);

    function CartPriceEditor() {
      return CartPriceEditor.__super__.constructor.apply(this, arguments);
    }

    CartPriceEditor.prototype.link = function(scope, element, attrs) {
      scope.cartPricePageTypes = [];
      return Meta.getCartPricePageTypes().then(function(res) {
        return scope.cartPricePageTypes = res;
      });
    };

    return CartPriceEditor;

  })(BaseProjectCrudEditor);
  editor = new CartPriceEditor(ProjectCartPrice, Meta, '/templates/projects.settings/initialization/cart_price_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcCookieEditor', ["ProjectCookie", "Meta", "BaseProjectCrudEditor", function(ProjectCookie, Meta, BaseProjectCrudEditor) {
  var CookieEditor, editor;
  CookieEditor = (function(superClass) {
    extend(CookieEditor, superClass);

    function CookieEditor() {
      return CookieEditor.__super__.constructor.apply(this, arguments);
    }

    CookieEditor.prototype.link = function(scope, element, attrs) {
      return scope.pageTypes = {};
    };

    return CookieEditor;

  })(BaseProjectCrudEditor);
  editor = new CookieEditor(ProjectCookie, Meta, '/templates/projects.settings/initialization/cookie_editor.html');
  return editor.createDirective({
    domainLinkType: '='
  });
}]);


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcExcludeIpEditor', ["ProjectExcludeIp", "Meta", "BaseProjectCrudEditor", "SettingStatus", "Devise", function(ProjectExcludeIp, Meta, BaseProjectCrudEditor, SettingStatus, Devise) {
  var ExcludeIpEditor, editor;
  ExcludeIpEditor = (function(superClass) {
    extend(ExcludeIpEditor, superClass);

    function ExcludeIpEditor() {
      return ExcludeIpEditor.__super__.constructor.apply(this, arguments);
    }

    ExcludeIpEditor.prototype.getNewItem = function() {
      return {
        ip: '',
        match_type: 'full'
      };
    };

    ExcludeIpEditor.prototype.link = function(scope, element, attrs) {
      scope.pageTypes = {};
      scope.newItem = this.getNewItem();
      scope.isMaster = Devise.isMaster();
      return scope.$watch('items', function(excludeIps) {
        return SettingStatus.updateExcludeIpStatus(excludeIps);
      }, true);
    };

    return ExcludeIpEditor;

  })(BaseProjectCrudEditor);
  editor = new ExcludeIpEditor(ProjectExcludeIp, Meta, '/templates/projects.settings/initialization/exclude_ip_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('GaTagTrackingCtrl', ["$scope", "Project", "currentProject", "googleAnalyticsEventLabels", function($scope, Project, currentProject, googleAnalyticsEventLabels) {
  $scope.project = currentProject;
  $scope.googleAnalyticsEventLabels = googleAnalyticsEventLabels;
  $scope.save = function(project) {
    return Project.update({
      projectId: project.id
    }, {
      project: _.merge({}, project, {
        google_analytics_event_enable: !$scope.project.google_analytics_event_enable
      })
    }).then(function(updatedProject) {
      return $scope.project = updatedProject;
    });
  };
  return $scope.$watch('project.google_analytics_event_action_control_enable', function() {
    if ($scope.project.google_analytics_event_action_control_enable) {
      if (!$scope.project.google_analytics_event_action_control) {
        return $scope.project.google_analytics_event_action_control = 'hidden';
      }
    } else {
      return $scope.project.google_analytics_event_action_control = '';
    }
  });
}]);


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcItemListPriceEditor', ["ProjectItemListPrice", "Meta", "BaseProjectCrudEditor", function(ProjectItemListPrice, Meta, BaseProjectCrudEditor) {
  var ItemListPriceEditor, editor;
  ItemListPriceEditor = (function(superClass) {
    extend(ItemListPriceEditor, superClass);

    function ItemListPriceEditor() {
      return ItemListPriceEditor.__super__.constructor.apply(this, arguments);
    }

    ItemListPriceEditor.prototype.link = function(scope, element, attrs) {};

    return ItemListPriceEditor;

  })(BaseProjectCrudEditor);
  editor = new ItemListPriceEditor(ProjectItemListPrice, Meta, '/templates/projects.settings/initialization/item_list_price_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcItemPriceEditor', ["ProjectItemPrice", "Meta", "BaseProjectCrudEditor", function(ProjectItemPrice, Meta, BaseProjectCrudEditor) {
  var ItemPriceEditor, editor;
  ItemPriceEditor = (function(superClass) {
    extend(ItemPriceEditor, superClass);

    function ItemPriceEditor() {
      return ItemPriceEditor.__super__.constructor.apply(this, arguments);
    }

    ItemPriceEditor.prototype.link = function(scope, element, attrs) {};

    return ItemPriceEditor;

  })(BaseProjectCrudEditor);
  editor = new ItemPriceEditor(ProjectItemPrice, Meta, '/templates/projects.settings/initialization/item_price_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcLoginEvaluatorEditor', ["ProjectLoginEvaluator", "Meta", "BaseProjectCrudEditor", function(ProjectLoginEvaluator, Meta, BaseProjectCrudEditor) {
  var LoginEvaluatorEditor, editor;
  LoginEvaluatorEditor = (function(superClass) {
    extend(LoginEvaluatorEditor, superClass);

    function LoginEvaluatorEditor() {
      return LoginEvaluatorEditor.__super__.constructor.apply(this, arguments);
    }

    LoginEvaluatorEditor.prototype.link = function(scope, element, attrs) {
      scope.matchTypes = {};
      scope.evalutionTypes = {};
      Meta.getLoginEvaluatorEvaluationTypes().then(function(res) {
        return scope.evaluationTypes = res;
      });
      return Meta.getLoginEvaluatorMatchTypes().then(function(res) {
        return scope.matchTypes = res;
      });
    };

    return LoginEvaluatorEditor;

  })(BaseProjectCrudEditor);
  editor = new LoginEvaluatorEditor(ProjectLoginEvaluator, Meta, '/templates/projects.settings/initialization/login_evaluator_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1236 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcPageTypeEditor', ["PageType", "PageTypeSampleUrl", function(PageType, PageTypeSampleUrl) {
  return {
    restrict: 'E',
    scope: {
      projectId: '='
    },
    templateUrl: '/templates/projects.settings/initialization/page_type_editor.html',
    link: function(scope, element, attrs) {
      var checkMatch, checkSampleMatchesPatternByPageType, getSampleUrlAfterPathname;
      scope.pageTypes = [];
      scope.pageTypeSampleUrls = [];
      PageTypeSampleUrl.all(scope.projectId).then(function(pageTypeSampleUrls) {
        scope.pageTypeSampleUrls = pageTypeSampleUrls;
        return PageType.all(scope.projectId).then(function(pageTypes) {
          scope.pageTypes = _.reject(pageTypes, {
            page_type: 'no_publish'
          });
          return scope.checkAllSampleMatchesPattern();
        });
      });
      scope.addPageType = function() {
        return scope.pageTypes.push(PageType["new"]({
          project_id: scope.projectId
        }));
      };
      scope.addPageTypeSampleUrl = function() {
        return scope.pageTypeSampleUrls.push(PageTypeSampleUrl["new"]({
          project_id: scope.projectId
        }));
      };
      scope.onDestroy = function(pageType) {
        if (!pageType) {
          return;
        }
        return scope.pageTypes.splice(scope.pageTypes.indexOf(pageType), 1);
      };
      scope.onDestroySampleUrl = function(pageTypeSampleUrl) {
        if (!pageTypeSampleUrl) {
          return;
        }
        return scope.pageTypeSampleUrls.splice(scope.pageTypeSampleUrls.indexOf(pageTypeSampleUrl), 1);
      };
      getSampleUrlAfterPathname = function(url) {
        var parser, sampleUrlAfterPathname;
        parser = document.createElement('a');
        parser.href = url;
        return sampleUrlAfterPathname = parser.pathname + parser.search + parser.hash;
      };
      checkMatch = function(val, match_type, match_pattern) {
        if (!(val && match_type && match_pattern)) {
          return false;
        }
        switch (match_type) {
          case 'prefix':
            if (val.indexOf(match_pattern) === 0) {
              return true;
            }
            break;
          case 'regexp':
            if (val.match(match_pattern)) {
              return true;
            }
            break;
          case 'full':
            if (val === match_pattern) {
              return true;
            }
            break;
          case 'partial':
            if (val.indexOf(match_pattern) >= 0) {
              return true;
            }
        }
        return false;
      };
      checkSampleMatchesPatternByPageType = function(pageType, pageTypeSampleUrl) {
        var i, isMatch, len, ref, sampleUrl, sampleUrlAfterPathname, url;
        if (!(pageType.required_device === pageTypeSampleUrl.required_device || pageType.required_device === 'both' || pageTypeSampleUrl.required_device === 'both')) {
          return false;
        }
        sampleUrl = pageTypeSampleUrl.url;
        sampleUrlAfterPathname = getSampleUrlAfterPathname(sampleUrl);
        isMatch = false;
        ref = [sampleUrl, sampleUrlAfterPathname];
        for (i = 0, len = ref.length; i < len; i++) {
          url = ref[i];
          try {
            if (checkMatch(url, pageType.match_type, pageType.match_pattern)) {
              isMatch = true;
            }
          } catch (error) {}
        }
        return isMatch;
      };
      scope.checkSampleMatchesPattern = function(pageTypeSampleUrl) {
        var i, len, pageType, ref;
        pageTypeSampleUrl.page_types = [];
        pageTypeSampleUrl.isOk = false;
        ref = scope.pageTypes;
        for (i = 0, len = ref.length; i < len; i++) {
          pageType = ref[i];
          if (checkSampleMatchesPatternByPageType(pageType, pageTypeSampleUrl)) {
            if (pageType.page_type === '_custom_') {
              pageTypeSampleUrl.page_types.push(pageType.custom_name);
            } else {
              pageTypeSampleUrl.page_types.push(pageType.page_type);
            }
          }
        }
        if (pageTypeSampleUrl.page_types.length > 0) {
          return pageTypeSampleUrl.isOk = pageTypeSampleUrl.page_types[0] === pageTypeSampleUrl.page_type;
        }
      };
      return scope.checkAllSampleMatchesPattern = function() {
        var i, len, pageTypeSampleUrl, ref, results;
        ref = scope.pageTypeSampleUrls;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pageTypeSampleUrl = ref[i];
          results.push(scope.checkSampleMatchesPattern(pageTypeSampleUrl));
        }
        return results;
      };
    }
  };
}]);


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcPageTypeSample', ["$filter", "$q", "PageTypeSampleUrl", function($filter, $q, PageTypeSampleUrl) {
  return {
    restrict: 'A',
    scope: {
      pageTypes: '=',
      pageTypeSampleUrl: '=',
      projectId: '=',
      checkSampleMatchesPattern: '&',
      onDestroySampleUrl: '&'
    },
    templateUrl: "/templates/projects.settings/initialization/page_type_sample.html",
    replace: true,
    link: function(scope, element, attrs) {
      scope.pageTypeOptions = [];
      scope.devices = [];
      $q.all([PageTypeSampleUrl.getPageTypeOptions(scope.projectId), PageTypeSampleUrl.getDevices(scope.projectId)]).then(function(arg) {
        var device, devices, i, j, len, len1, pageType, pageTypes, results;
        pageTypes = arg[0], devices = arg[1];
        for (i = 0, len = pageTypes.length; i < len; i++) {
          pageType = pageTypes[i];
          scope.pageTypeOptions.push({
            name: pageType[0],
            value: pageType[1]
          });
        }
        results = [];
        for (j = 0, len1 = devices.length; j < len1; j++) {
          device = devices[j];
          results.push(scope.devices.push({
            name: device[0],
            value: device[1]
          }));
        }
        return results;
      });
      scope.checkSampleMatchesPattern();
      scope.isDestroying = false;
      scope.remove = function(pageTypeSampleUrl) {
        if (pageTypeSampleUrl.id) {
          scope.isDestroying = true;
          return PageTypeSampleUrl.destroy(pageTypeSampleUrl).then(function(res) {
            if (typeof scope.onDestroySampleUrl === "function") {
              scope.onDestroySampleUrl();
            }
            return scope.isDestroying = false;
          });
        } else {
          if (typeof scope.onDestroySampleUrl === "function") {
            scope.onDestroySampleUrl();
          }
          scope.$apply();
          return alertify.success($filter('translate')('projectsSettings.initialization.pageTypeSample.deleted'));
        }
      };
      scope.update = function(pageTypeSampleUrl) {
        var handler;
        handler = function(pageTypeSampleUrl) {
          angular.extend(scope.pageTypeSampleUrl, pageTypeSampleUrl);
          return scope.form.$setPristine();
        };
        if (pageTypeSampleUrl.id) {
          return PageTypeSampleUrl.update({
            projectId: pageTypeSampleUrl.project_id,
            id: pageTypeSampleUrl.id
          }, {
            page_type_sample_url: pageTypeSampleUrl
          }).then(handler);
        } else {
          return PageTypeSampleUrl.create({
            projectId: pageTypeSampleUrl.project_id
          }, {
            page_type_sample_url: pageTypeSampleUrl
          }).then(handler);
        }
      };
      if (!scope.pageTypeSampleUrl.id) {
        return scope.form.$setDirty();
      }
    }
  };
}]);


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcPageTypeSingle', ["$filter", "$q", "PageType", function($filter, $q, PageType) {
  return {
    restrict: 'A',
    scope: {
      pageType: '=',
      projectId: '=',
      checkAllSampleMatchesPattern: '&',
      onDestroy: '&'
    },
    templateUrl: "/templates/projects.settings/initialization/page_type_single.html",
    replace: true,
    link: function(scope, element, attrs) {
      scope.pageTypeOptions = [];
      scope.matchTypes = [];
      scope.devices = [];
      $q.all([PageType.getPageTypeOptions(scope.projectId), PageType.getMatchTypes(scope.projectId), PageType.getDevices(scope.projectId)]).then(function(arg) {
        var device, devices, i, j, k, len, len1, len2, matchType, matchTypes, pageType, pageTypes, results;
        pageTypes = arg[0], matchTypes = arg[1], devices = arg[2];
        for (i = 0, len = pageTypes.length; i < len; i++) {
          pageType = pageTypes[i];
          if (pageType[1] === 'no_publish') {
            continue;
          }
          scope.pageTypeOptions.push({
            name: pageType[0],
            value: pageType[1]
          });
        }
        for (j = 0, len1 = matchTypes.length; j < len1; j++) {
          matchType = matchTypes[j];
          scope.matchTypes.push({
            name: matchType[0],
            value: matchType[1]
          });
        }
        results = [];
        for (k = 0, len2 = devices.length; k < len2; k++) {
          device = devices[k];
          results.push(scope.devices.push({
            name: device[0],
            value: device[1]
          }));
        }
        return results;
      });
      scope.isDestroying = false;
      scope.remove = function(pageType) {
        if (pageType.id) {
          scope.isDestroying = true;
          return PageType.destroy(pageType).then(function(res) {
            if (typeof scope.onDestroy === "function") {
              scope.onDestroy();
            }
            return scope.isDestroying = false;
          });
        } else {
          if (typeof scope.onDestroy === "function") {
            scope.onDestroy();
          }
          scope.$apply();
          return alertify.success($filter('translate')('projectsSettings.initialization.pageTypeSingle.deleted'));
        }
      };
      scope.update = function(pageType) {
        var handler;
        handler = function(pageType) {
          angular.extend(scope.pageType, pageType);
          return scope.form.$setPristine();
        };
        if (pageType.id) {
          return PageType.update({
            projectId: pageType.project_id,
            id: pageType.id
          }, {
            page_type: pageType
          }).then(handler);
        } else {
          return PageType.create({
            projectId: pageType.project_id
          }, {
            page_type: pageType
          }).then(handler);
        }
      };
      scope.isCustomPageType = function(page_type) {
        return PageType.isCustomPageType(page_type);
      };
      if (!scope.pageType.id) {
        return scope.form.$setDirty();
      }
    }
  };
}]);


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('ConversionTagCtrl', ["$scope", "$translate", "Project", "MongoConversion", "SettingStatus", "currentProject", function($scope, $translate, Project, MongoConversion, SettingStatus, currentProject) {
  var aideal_cv_var, aideal_cv_var_used, currency, scope_id, site_id, track_id;
  $scope.conversions = [];
  $scope.foundPC = false;
  $scope.foundSP = false;
  $scope.currentProject = currentProject;
  $scope.isDisplayAajsWarningMsg = $scope.currentProject.enable_aajs && _.some([$scope.currentProject.site_id, $scope.currentProject.tracking_id, $scope.currentProject.scope_id], (function(_this) {
    return function(item) {
      return !(item && item.length > 0);
    };
  })(this));
  aideal_cv_var = '';
  aideal_cv_var_used = '';
  if ($scope.currentProject.enable_aajs) {
    scope_id = $scope.currentProject.scope_id || '[scope-id]';
    site_id = $scope.currentProject.site_id || '[site-id]';
    track_id = $scope.currentProject.tracking_id || '[track-id]';
    currency = $scope.currentProject.currency.toUpperCase() || '';
    if ($scope.currentProject.enable_direct_cv) {
      aideal_cv_var = 'var appierRtName = "aideal-cv"; // ' + $translate.instant('projectsSettings.installation.conversionTag.aideal_cv_var_comment', {
        "var": 'appierRtName'
      });
      aideal_cv_var_used = '"conversionName": appierRtName, ';
      $scope.aideal_cv_var_description1 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description1', {
        "var": 'appierRtName'
      });
      $scope.aideal_cv_var_description2 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description2', {
        "var": 'appierRtName'
      });
    }
    $scope.conversionCode = "<script>\n  var appierRtorderId = \"" + ($translate.instant('projectsSettings.installation.conversionTag.konbaajon')) + "\"; // " + ($translate.instant('projectsSettings.installation.conversionTag.conversionIdComment')) + "\n  var appierRtPrice = \"" + ($translate.instant('projectsSettings.installation.conversionTag.konbaajon_kingaku')) + "\"; // " + ($translate.instant('projectsSettings.installation.conversionTag.conversionPriceComment')) + "\n  " + aideal_cv_var + "\n  var appierRtItemList = [];\n  var appierCouponCode = \"\";\n\n  //========= " + ($translate.instant('projectsSettings.installation.conversionTag.couponCodeCommentRemoveFrom')) + " =========\n  appierCouponCode = \"REPLACED_BY_YOUR_COUPON_CODE\"; // " + ($translate.instant('projectsSettings.installation.conversionTag.couponCodeInstruction')) + "\n  //========= " + ($translate.instant('projectsSettings.installation.conversionTag.couponCodeCommentRemoveTo')) + " =========\n\n  //========= " + ($translate.instant('projectsSettings.installation.conversionTag.not_sending_product_comment_from')) + " =========\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.hitotsu_me_ikou')) + "\n  appierRtItemList.push(\n    {\n      // " + ($translate.instant('projectsSettings.installation.conversionTag.kaki_tsu_no', {
      count: 3
    })) + "\n      \"productID\": \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin')) + "\",\n      \"unit\": \"" + ($translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')) + "\",\n      \"price\": \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')) + "\" // " + ($translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')) + "\n    }\n  );\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.nitsu_me_ikou')) + "\n  appierRtItemList.push(\n    {\n      // " + ($translate.instant('projectsSettings.installation.conversionTag.kaki_tsu_no', {
      count: 3
    })) + "\n      \"productID\": \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin')) + "\",\n      \"unit\": \"" + ($translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')) + "\",\n      \"price\": \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')) + "\" // " + ($translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')) + "\n    }\n  );\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.mitsu_me_ikou')) + "\n  //========= " + ($translate.instant('projectsSettings.installation.conversionTag.not_sending_product_comment_to')) + " =========\n\n  //========= " + ($translate.instant('projectsSettings.installation.conversionTag.please_do_not_change_below')) + " =========\n  var appierRtCurrency = \"" + currency + "\";\n  window.appier_q = window.appier_q || [];\n  window.appier_q.push(\n    {\"t\": \"register\", \"content\": { \"id\": \"" + scope_id + "\", \"site\": \"" + site_id + "\" } },\n    {\"t\": \"type_purchase\",  \"itemList\": appierRtItemList, \"totalvalue\": appierRtPrice, \"currency\": appierRtCurrency, \"action_id\": \"" + site_id + "_Purchase\", \"track_id\": \"" + track_id + "\", \"couponCode\": appierCouponCode, " + aideal_cv_var_used + "\"opts\": {\"uu\": appierRtorderId, \"action_param1\" : JSON.stringify(appierRtItemList), \"action_param2\": appierRtorderId, \"total_revenue\" : appierRtPrice, \"currency\" : appierRtCurrency}}\n  );\n</script>\n<script src=\"//jscdn.appier.net/aa.js?id=" + site_id + "\" async></script>";
    $scope.conversionOutputCode = "<script>\n  var appierRtorderId = \"122321090\";\n  var appierRtPrice = \"3980\";\n  " + aideal_cv_var + "\n  var appierRtItemList = [];\n  var appierCouponCode = \"\";\n\n  appierCouponCode = \"summer10off\";\n\n  appierRtItemList.push(\n    {\n      \"productID\": \"PSR-22\",\n      \"unit\": \"1\",\n      \"price\": \"3980\"\n    }\n  );\n\n  //========= " + ($translate.instant('projectsSettings.installation.conversionTag.please_do_not_change_below')) + " =========\n  var appierRtCurrency = \"" + currency + "\";\n  window.appier_q = window.appier_q || [];\n  window.appier_q.push(\n    {\"t\": \"register\", \"content\": { \"id\": \"" + scope_id + "\", \"site\": \"" + site_id + "\" } },\n    {\"t\": \"type_purchase\",  \"itemList\": appierRtItemList, \"totalvalue\": appierRtPrice, \"currency\": appierRtCurrency, \"action_id\": \"" + site_id + "_Purchase\", \"track_id\": \"" + track_id + "\", \"couponCode\": appierCouponCode, " + aideal_cv_var_used + "\"opts\": {\"uu\": appierRtorderId, \"action_param1\" : JSON.stringify(appierRtItemList), \"action_param2\": appierRtorderId, \"total_revenue\" : appierRtPrice, \"currency\" : appierRtCurrency}}\n  );\n</script>\n<script src=\"//jscdn.appier.net/aa.js?id=" + site_id + "\" async></script>";
  } else {
    if ($scope.currentProject.enable_direct_cv) {
      aideal_cv_var = 'var zenclerk_conversion_name = "aideal-cv"; // ' + $translate.instant('projectsSettings.installation.conversionTag.aideal_cv_var_comment');
      $scope.aideal_cv_var_description1 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description1', {
        "var": 'zenclerk_conversion_name'
      });
      $scope.aideal_cv_var_description2 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description2', {
        "var": 'zenclerk_conversion_name'
      });
    }
    $scope.conversionCode = "<script type=\"text/javascript\">\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.conversionIdComment')) + "\n  var zenclerk_conversion_id = \"" + ($translate.instant('projectsSettings.installation.conversionTag.konbaajon')) + "\";\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.conversionPriceComment')) + "\n  var zenclerk_conversion_price = \"" + ($translate.instant('projectsSettings.installation.conversionTag.konbaajon_kingaku')) + "\";\n  " + aideal_cv_var + "\n\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.nini_koodokokokarakokokara_moto')) + "\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.shisutemu_mato_ni')) + "\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.dore_mo_ireru')) + "\n\n  var zenclerk_conversion_items = [];\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.hitotsu_me_ikou')) + "\n  zenclerk_conversion_items.push(\n    {\n      // " + ($translate.instant('projectsSettings.installation.conversionTag.kaki_tsu_no', {
      count: 5
    })) + "\n      id: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin')) + "\",\n      name: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhinmei')) + "\",\n      url: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhinurl')) + "\",\n      price: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')) + "\",\n      count: \"" + ($translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')) + "\" // " + ($translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')) + "\n    }\n  );\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.nitsu_me_ikou')) + "\n  zenclerk_conversion_items.push(\n    {\n      id: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin')) + "\",\n      name: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhinmei')) + "\",\n      url: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhinurl')) + "\",\n      price: \"" + ($translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')) + "\",\n      count: \"" + ($translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')) + "\" // " + ($translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')) + "\n    }\n  );\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.mitsu_me_ikou')) + "\n\n  // " + ($translate.instant('projectsSettings.installation.conversionTag.nini_koodokokomade')) + "\n</script>";
    $scope.conversionOutputCode = "<script type=\"text/javascript\">\n  var zenclerk_conversion_id = \"122321090\";\n  var zenclerk_conversion_price = \"3980\";\n  " + aideal_cv_var + "\n  var zenclerk_conversion_items = [];\n  zenclerk_conversion_items.push(\n    {\n      id: \"PSR-22\",\n      name: \"" + ($translate.instant('projectsSettings.installation.conversionTag.puriitsusukaato')) + "\",\n      url: \"http://example.com/item/PSR-22\",\n      price: \"3980\",\n      count: \"1\"  // " + ($translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')) + "\n    }\n  );\n</script>";
  }
  $scope.refresh = function() {
    return MongoConversion.find({
      apikey: currentProject.apikey
    }, {
      sort: {
        created_at: -1
      },
      limit: 10
    }).then(function(conversions) {
      var conversion, i, len, results;
      $scope.foundPC = false;
      $scope.foundSP = false;
      $scope.conversions = conversions;
      results = [];
      for (i = 0, len = conversions.length; i < len; i++) {
        conversion = conversions[i];
        if (conversion.device === 'pc') {
          $scope.foundPC = true;
        }
        if (conversion.device === 'sp') {
          results.push($scope.foundSP = true);
        } else {
          results.push(void 0);
        }
      }
      return results;
    });
  };
  $scope.refresh();
  return $scope.updateStatus = function(opts) {
    if (!$scope.foundPC && !$scope.foundSP) {
      return;
    }
    currentProject.conversion_tag_confirmed = true;
    return Project.update({
      projectId: currentProject.id
    }, {
      project: currentProject
    }).then(function(result) {
      currentProject = _.merge(currentProject, result);
      return SettingStatus.updateProjectStatus(currentProject);
    });
  };
}]);


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('TrackingTagCtrl', ["$scope", "Project", "MongoHistory", "SettingStatus", "currentProject", "TagNonExistingUrls", function($scope, Project, MongoHistory, SettingStatus, currentProject, TagNonExistingUrls) {
  var scope_id, site_id, track_id;
  $scope.histories = [];
  $scope.tag_non_existing_url_items = [];
  $scope.foundPC = false;
  $scope.foundSP = false;
  $scope.isDisplayAajsWarningMsg = currentProject.enable_aajs && _.some([currentProject.site_id, currentProject.tracking_id, currentProject.scope_id], (function(_this) {
    return function(item) {
      return !(item && item.length > 0);
    };
  })(this));
  if (currentProject.enable_aajs) {
    scope_id = currentProject.scope_id || '[scope-id]';
    site_id = currentProject.site_id || '[site-id]';
    track_id = currentProject.tracking_id || '[track-id]';
    $scope.tracking_tag_code = "<script>\n  window.appier_q = window.appier_q || [];\n  window.appier_q.push(\n    {\"t\": \"register\", \"content\": { \"id\": \"" + scope_id + "\", \"site\": \"" + site_id + "\" }},\n    {\"t\": \"pv_track\", \"action_id\": \"" + site_id + "_PageView\", \"track_id\": \"" + track_id + "\", \"isCountReload\": true, \"counter\": 0},\n    {\"t\": \"pv_track\", \"action_id\": \"" + site_id + "_ViewTwoPages\", \"track_id\": \"" + track_id + "\", \"isCountReload\": false, \"counter\": 1}\n  );\n</script>\n<script src=\"//jscdn.appier.net/aa.js?id=" + site_id + "\" async></script>";
  } else {
    $scope.tracking_tag_code = "<script type=\"text/javascript\" src=\"//" + currentProject.publish_domain + ".zenclerk.com/publish/" + currentProject.apikey + ".js\"></script>";
  }
  $scope.refresh = function() {
    TagNonExistingUrls.findOne({
      apikey: currentProject.apikey
    }).then(function(res) {
      if (!(res != null ? res.url_items : void 0)) {
        return;
      }
      return $scope.tag_non_existing_url_items = _.map(res.url_items, function(arg) {
        var count, url;
        url = arg[0], count = arg[1];
        return {
          url: url,
          count: parseInt(count)
        };
      });
    });
    return MongoHistory.find({
      apikey: currentProject.apikey
    }, {
      sort: {
        opened_at: -1
      },
      limit: 10
    }).then(function(histories) {
      var history, i, len, results;
      $scope.foundPC = false;
      $scope.foundSP = false;
      $scope.histories = histories;
      results = [];
      for (i = 0, len = histories.length; i < len; i++) {
        history = histories[i];
        if (history.device === 'pc') {
          $scope.foundPC = true;
        }
        if (history.device === 'sp') {
          results.push($scope.foundSP = true);
        } else {
          results.push(void 0);
        }
      }
      return results;
    });
  };
  $scope.refresh();
  return $scope.updateStatus = function(opts) {
    if (!$scope.foundPC && !$scope.foundSP) {
      return;
    }
    currentProject.tracking_tag_confirmed = true;
    return Project.update({
      projectId: currentProject.id
    }, {
      project: currentProject
    }).then(function(result) {
      currentProject = _.merge(currentProject, result);
      return SettingStatus.updateProjectStatus(currentProject);
    });
  };
}]);


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcBadgePositionAdjustmentEditor', ["ProjectBadgePositionAdjustment", "Meta", "BaseProjectCrudEditor", function(ProjectBadgePositionAdjustment, Meta, BaseProjectCrudEditor) {
  var BadgePositionAdjustmentEditor, editor;
  BadgePositionAdjustmentEditor = (function(superClass) {
    extend(BadgePositionAdjustmentEditor, superClass);

    function BadgePositionAdjustmentEditor() {
      return BadgePositionAdjustmentEditor.__super__.constructor.apply(this, arguments);
    }

    BadgePositionAdjustmentEditor.prototype.link = function(scope, element, attrs) {
      scope.devices = [];
      return Meta.getBadgePositionAdjustmentDevices().then(function(res) {
        return scope.devices = res;
      });
    };

    return BadgePositionAdjustmentEditor;

  })(BaseProjectCrudEditor);
  editor = new BadgePositionAdjustmentEditor(ProjectBadgePositionAdjustment, Meta, '/templates/projects.settings/other/badge_position_adjustment_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcBreadcrumbSelector', ["ProjectBreadcrumb", "Meta", "BaseProjectCrudEditor", function(ProjectBreadcrumb, Meta, BaseProjectCrudEditor) {
  var Breadcrumb, editor;
  Breadcrumb = (function(superClass) {
    extend(Breadcrumb, superClass);

    function Breadcrumb() {
      return Breadcrumb.__super__.constructor.apply(this, arguments);
    }

    Breadcrumb.prototype.link = function(scope, element, attrs) {
      return scope.page_types = ["item", "category"];
    };

    return Breadcrumb;

  })(BaseProjectCrudEditor);
  editor = new Breadcrumb(ProjectBreadcrumb, Meta, '/templates/projects.settings/other/breadcrumb_selector.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcDeletedItemDetector', ["ProjectDeletedItemDetector", "Meta", "BaseProjectCrudEditor", function(ProjectDeletedItemDetector, Meta, BaseProjectCrudEditor) {
  var DeletedItemDetector, editor;
  DeletedItemDetector = (function(superClass) {
    extend(DeletedItemDetector, superClass);

    function DeletedItemDetector() {
      return DeletedItemDetector.__super__.constructor.apply(this, arguments);
    }

    DeletedItemDetector.prototype.link = function(scope, element, attrs) {};

    return DeletedItemDetector;

  })(BaseProjectCrudEditor);
  editor = new DeletedItemDetector(ProjectDeletedItemDetector, Meta, '/templates/projects.settings/other/deleted_item_detector.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcDescriptionConfirm', ["$filter", "BaseProjectConfirm", function($filter, BaseProjectConfirm) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.descriptionConfirm.itemDescription'), ['og_description', 'description']);
  return confirm.createDirective(confirm.requestRecentHistories);
}]);


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcInterestWidgetTreeConfirm', ["$filter", "BaseProjectConfirm", "InterestTree", function($filter, BaseProjectConfirm, InterestTree) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.interestWidgetTreeConfirm.iwInterestTree'), ['_id']);
  return confirm.createDirective(function(scope, elem, attrs) {
    return InterestTree.find({
      apikey: scope.apikey
    }, {
      match: {
        name: 'random_forest_for_interest_widget_item'
      }
    });
  });
}]);


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcItemPriceConfirm', ["$filter", "BaseProjectConfirm", function($filter, BaseProjectConfirm) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.itemPriceConfirm.commodityPrice'), ['item_price']);
  return confirm.createDirective(confirm.requestRecentHistories);
}]);


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcPageDescription', ["ProjectPageDescription", "Meta", "BaseProjectCrudEditor", function(ProjectPageDescription, Meta, BaseProjectCrudEditor) {
  var editor;
  editor = new BaseProjectCrudEditor(ProjectPageDescription, Meta, '/templates/projects.settings/other/page_description.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcParticularEventEditor', ["ProjectParticularEvent", "Meta", "BaseProjectCrudEditor", function(ProjectParticularEvent, Meta, BaseProjectCrudEditor) {
  var ParticularEventEditor, editor;
  ParticularEventEditor = (function(superClass) {
    extend(ParticularEventEditor, superClass);

    function ParticularEventEditor() {
      return ParticularEventEditor.__super__.constructor.apply(this, arguments);
    }

    ParticularEventEditor.prototype.link = function(scope, element, attrs) {
      scope.particularEventPageTypes = [];
      scope.particularEventNames = [];
      Meta.getParticularEventPageTypes().then(function(res) {
        return scope.particularEventPageTypes = res;
      });
      return Meta.getParticularEventNames().then(function(res) {
        return scope.particularEventNames = res;
      });
    };

    return ParticularEventEditor;

  })(BaseProjectCrudEditor);
  editor = new ParticularEventEditor(ProjectParticularEvent, Meta, '/templates/projects.settings/other/particular_event_editor.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcReviewLinkConfirm', ["$filter", "BaseProjectConfirm", "MongoParticularEvent", function($filter, BaseProjectConfirm, MongoParticularEvent) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.reviewLinkConfirm.reviewLink'), ['_id']);
  return confirm.createDirective(function(scope, elem, attrs) {
    return MongoParticularEvent.find({
      apikey: scope.apikey,
      name: 'review_link',
      created_at: {
        $gte: moment().subtract(1, 'hour').toDate()
      }
    }, {
      limit: 20
    });
  });
}]);


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcReviewLinkEditor', ["ProjectParticularEvent", "Meta", "BaseProjectCrudEditor", function(ProjectParticularEvent, Meta, BaseProjectCrudEditor) {
  var editor;
  editor = new BaseProjectCrudEditor(ProjectParticularEvent, Meta, '/templates/projects.settings/other/review_link_editor.html');
  editor.link = function(scope, elem, attrs) {
    return scope.$watch('items', function(items) {
      if (!items) {
        return;
      }
      return scope.filteredItems = _.filter(items, {
        name: 'review_link',
        page_type: 'item'
      });
    }, true);
  };
  return editor.createDirective();
}]);


/***/ }),
/* 1251 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcThumbnailSelector', ["ProjectThumbnailSelector", "Meta", "BaseProjectCrudEditor", function(ProjectThumbnailSelector, Meta, BaseProjectCrudEditor) {
  var ThumbnailSelector, editor;
  ThumbnailSelector = (function(superClass) {
    extend(ThumbnailSelector, superClass);

    function ThumbnailSelector() {
      return ThumbnailSelector.__super__.constructor.apply(this, arguments);
    }

    ThumbnailSelector.prototype.link = function(scope, element, attrs) {};

    return ThumbnailSelector;

  })(BaseProjectCrudEditor);
  editor = new ThumbnailSelector(ProjectThumbnailSelector, Meta, '/templates/projects.settings/other/thumbnail_selector.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcThumbnailSelectorConfirm', ["$filter", "BaseProjectConfirm", function($filter, BaseProjectConfirm) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.thumbnailSelectorConfirm.thumbnailImage'), ['thumbnail_url']);
  return confirm.createDirective(confirm.requestRecentHistories);
}]);


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.projects').directive('zcTitleSelector', ["ProjectTitleSelector", "Meta", "BaseProjectCrudEditor", function(ProjectTitleSelector, Meta, BaseProjectCrudEditor) {
  var TitleSelector, editor;
  TitleSelector = (function(superClass) {
    extend(TitleSelector, superClass);

    function TitleSelector() {
      return TitleSelector.__super__.constructor.apply(this, arguments);
    }

    TitleSelector.prototype.link = function(scope, element, attrs) {};

    return TitleSelector;

  })(BaseProjectCrudEditor);
  editor = new TitleSelector(ProjectTitleSelector, Meta, '/templates/projects.settings/other/title_selector.html');
  return editor.createDirective();
}]);


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcTitleSelectorConfirm', ["$filter", "BaseProjectConfirm", function($filter, BaseProjectConfirm) {
  var confirm;
  confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.titleSelectorConfirm.pageTitle'), ['og_title', 'title']);
  return confirm.createDirective(confirm.requestRecentHistories);
}]);


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

var redirectNewDashboard;

angular.module('zc.projects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.projects.settings', {
    url: '/settings',
    controller: 'SettingsCtrl',
    views: {
      'mainnav@': {
        templateUrl: '/templates/core/views/mainnav.html',
        controller: 'MainnavCtrl'
      },
      'content@': {
        templateUrl: '/templates/projects.settings/index.html',
        controller: 'SettingsCtrl'
      },
      'menu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/menu.html',
        controller: 'MenuController',
        controllerAs: '$ctrl'
      }
    },
    resolve: {
      excludeIps: ["ProjectExcludeIp", "$stateParams", function(ProjectExcludeIp, $stateParams) {
        return ProjectExcludeIp.all($stateParams.projectId);
      }],
      contractStatuses: ["Meta", function(Meta) {
        return Meta.getContractStatuses();
      }],
      invoiceCalculationTypes: ["Meta", function(Meta) {
        return Meta.getInvoiceCalculationTypes();
      }],
      paymentMethods: ["Meta", function(Meta) {
        return Meta.getPaymentMethods();
      }],
      invoiceIssueDays: ["Meta", function(Meta) {
        return Meta.getInvoiceIssueDays();
      }],
      invoiceDueDays: ["Meta", function(Meta) {
        return Meta.getInvoiceDueDays();
      }],
      invoicePaymentDays: ["Meta", function(Meta) {
        return Meta.getInvoicePaymentDays();
      }],
      invoicePaymentMonths: ["Meta", function(Meta) {
        return Meta.getInvoicePaymentMonths();
      }],
      trialInvoiceCalculationTypes: ["Meta", function(Meta) {
        return Meta.getTrialInvoiceCalculationTypes();
      }],
      sessionCountEvaluators: ["Meta", function(Meta) {
        return Meta.getSessionCountEvaluators();
      }],
      domainLinkTypes: ["Meta", function(Meta) {
        return Meta.getProjectDomainLinkTypes();
      }],
      projectRanks: ["Meta", function(Meta) {
        return Meta.getProjectRanks();
      }],
      productLines: ["Meta", function(Meta) {
        return Meta.getProductLines();
      }],
      pricingTypes: ["Meta", function(Meta) {
        return Meta.getPricingTypes();
      }],
      currencies: ["Meta", function(Meta) {
        return Meta.getCurrencies();
      }],
      regions: ["Meta", function(Meta) {
        return Meta.getRegions();
      }],
      optTargets: ["Meta", function(Meta) {
        return Meta.getOptTargets();
      }],
      ip: ["Ip", function(Ip) {
        return Ip.get();
      }],
      noPublishPageTypes: ["PageType", "$stateParams", function(PageType, $stateParams) {
        return PageType.all($stateParams.projectId).then(function(noPublishPageTypes) {
          return _.filter(noPublishPageTypes, {
            page_type: 'no_publish'
          });
        });
      }],
      masterUsers: ["Apollo", function(Apollo) {
        return Apollo.masterQuery(gql('{ users(role: master) { data { id email } } }')).then(function(res) {
          if (!res) {
            return;
          }
          return _.flatten([
            {
              id: null,
              email: '--'
            }, _.map(_.sortBy(res.users.data, 'email'), function(user) {
              return {
                id: Number(user.id),
                email: user.email
              };
            })
          ]);
        });
      }]
    }
  }).state('admin.projects.settings.billing', {
    url: '/billing',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/invoice',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/index.html'
      }
    }
  }).state('admin.projects.settings.billing.billing_information', {
    url: '/information',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/billing_information.html'
      }
    }
  }).state('admin.projects.settings.billing.representative_information', {
    url: '/representatives',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/billing_representatives.html'
      }
    }
  }).state('admin.projects.settings.billing.zc_information', {
    url: '/settings',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/zc_information.html'
      }
    }
  }).state('admin.projects.settings.billing.lens_information', {
    url: '/lens_information',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/lens_information.html'
      }
    }
  }).state('admin.projects.settings.billing.iw_information', {
    url: '/iw_information',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/iw_information.html'
      }
    }
  }).state('admin.projects.settings.billing.invoice_information', {
    url: '/invoice_information',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/billing/invoice_information.html'
      }
    }
  }).state('admin.projects.settings.installation', {
    url: '/installation',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/submenu.html',
        controller: 'SettingsCtrl'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/index.html'
      }
    }
  }).state('admin.projects.settings.installation.tracking_tag', {
    url: '/tracking_tag',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'setup',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/tracking_tag.html',
        controller: 'TrackingTagCtrl'
      }
    }
  }).state('admin.projects.settings.installation.conversion_tag', {
    url: '/conversion_tag',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'setup',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/conversion_tag.html',
        controller: 'ConversionTagCtrl'
      }
    }
  }).state('admin.projects.settings.installation.conversion_url', {
    url: '/conversion_url',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/conversion_url.html'
      }
    }
  }).state('admin.projects.settings.installation.test_conversion', {
    url: '/test_conversion',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/test_conversion.html'
      }
    }
  }).state('admin.projects.settings.installation.exclude_ip', {
    url: '/exclude_ip',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/exclude_ip.html'
      }
    }
  }).state('admin.projects.settings.installation.domain', {
    url: '/domain',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/domain.html'
      }
    }
  }).state('admin.projects.settings.installation.login_evaluator_memo', {
    url: '/login_evaluator_memo',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/login_evaluator_memo.html'
      }
    }
  }).state('admin.projects.settings.installation.newsletter_parameter_memo', {
    url: '/newsletter_parameter_memo',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/installation/newsletter_parameter_memo.html'
      }
    }
  }).state('admin.projects.settings.users', {
    url: '/users',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/users/submenu.html'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/users/index.html',
        controller: 'UserIndexCtrl'
      }
    }
  }).state('admin.projects.settings.users.invite', {
    url: '/invite',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/users/invite.html',
        controller: 'UserInviteCtrl'
      }
    }
  }).state('admin.projects.settings.basic', {
    url: '/basic',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/submenu.html'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/index.html'
      }
    }
  }).state('admin.projects.settings.basic.basic', {
    url: '/basic',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/basic.html'
      }
    }
  }).state('admin.projects.settings.basic.sales_management', {
    url: '/sales_management',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/site',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/sales_management.html'
      }
    }
  }).state('admin.projects.settings.basic.project_status', {
    url: '/project_status',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/site',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/project_status.html'
      }
    }
  }).state('admin.projects.settings.basic.control_percent', {
    url: '/control_percent',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/site',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/control_percent.html'
      }
    }
  }).state('admin.projects.settings.basic.remove_apikey', {
    url: '/remove_apikey',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/basic/remove_apikey.html'
      }
    }
  }).state('admin.projects.settings.campaign', {
    url: '/campaign',
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/submenu.html'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/no_publish_page_type.html'
      }
    }
  }).state('admin.projects.settings.campaign.timing', {
    url: '/timing',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/timing.html'
      }
    }
  }).state('admin.projects.settings.campaign.advertising', {
    url: '/advertising',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/campaign',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/advertising.html'
      }
    }
  }).state('admin.projects.settings.campaign.newsletter', {
    url: '/newsletter',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/campaign',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/newsletter.html'
      }
    }
  }).state('admin.projects.settings.campaign.segment_cookie', {
    url: '/segment_cookie',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/campaign',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/segment_cookie.html'
      }
    }
  }).state('admin.projects.settings.campaign.dm_upload', {
    url: '/dm_upload',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/campaign/dm_upload.html',
        controller: 'DetailProjectCtrl',
        resolve: {
          visitorIdsForDM: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.getVisitorIdsForDM({
              projectId: $stateParams.projectId
            });
          }]
        }
      }
    }
  }).state('admin.projects.settings.other', {
    url: '/other',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'general/other',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/submenu.html'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/index.html'
      }
    }
  }).state('admin.projects.settings.other.publish_domain', {
    url: '/publish_domain',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/publish_domain.html'
      }
    }
  }).state('admin.projects.settings.other.data_management', {
    url: '/data_management',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/data_management.html'
      }
    }
  }).state('admin.projects.settings.other.particular_event', {
    url: '/particular_event',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/particular_event.html'
      }
    }
  }).state('admin.projects.settings.other.breadcrumb_selector', {
    url: '/breadcrumb_selector',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/breadcrumb.html'
      }
    }
  }).state('admin.projects.settings.other.zcs', {
    url: '/zcs',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/zcs.html'
      }
    }
  }).state('admin.projects.settings.other.iw', {
    url: '/iw',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/iw.html'
      }
    }
  }).state('admin.projects.settings.other.app', {
    url: '/app',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/other/app.html'
      }
    }
  }).state('admin.projects.settings.initialization', {
    url: '/initialization',
    resolve: {
      redirectNewDashboard: ["Project", "Devise", "$stateParams", "$window", function(Project, Devise, $stateParams, $window) {
        return redirectNewDashboard({
          path: 'setup',
          internalOnly: true
        }, Project, Devise, $stateParams, $window);
      }]
    },
    views: {
      'submenu@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/submenu.html'
      },
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/index.html'
      }
    }
  }).state('admin.projects.settings.initialization.session_count_evaluator', {
    url: '/session_count_evaluator',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/session_count_evaluator.html'
      }
    }
  }).state('admin.projects.settings.initialization.page_type', {
    url: '/page_type',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/page_type.html'
      }
    }
  }).state('admin.projects.settings.initialization.untrack_page_type', {
    url: '/untrack_page_type',
    views: {
      'content@admin.projects.settings': {
        template: '<zc-untrack-page-types project="project"></zc-untrack-page-types>',
        controller: ["$scope", "currentProject", function($scope, currentProject) {
          $scope.project = currentProject;
        }]
      }
    }
  }).state('admin.projects.settings.initialization.exclude_ip', {
    url: '/exclude_ip',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/exclude_ip.html'
      }
    }
  }).state('admin.projects.settings.initialization.cross_domain', {
    url: '/cross_domain',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/cross_domain.html'
      }
    }
  }).state('admin.projects.settings.initialization.ga_tag_tracking', {
    url: '/ga_tag_tracking',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/ga_tag_tracking.html',
        controller: 'GaTagTrackingCtrl',
        resolve: {
          currentProject: ["currentProject", function(currentProject) {
            return currentProject;
          }],
          googleAnalyticsEventLabels: ["Meta", function(Meta) {
            return Meta.getGoogleAnalyticsEventLabels();
          }]
        }
      }
    }
  }).state('admin.projects.settings.initialization.cart_button', {
    url: '/cart_button',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/cart_button.html'
      }
    }
  }).state('admin.projects.settings.initialization.login_evaluator', {
    url: '/login_evaluator',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/login_evaluator.html'
      }
    }
  }).state('admin.projects.settings.initialization.item_price', {
    url: '/item_price',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/item_price.html'
      }
    }
  }).state('admin.projects.settings.initialization.item_list_price', {
    url: '/item_list_price',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/item_list_price.html'
      }
    }
  }).state('admin.projects.settings.initialization.cart_price', {
    url: '/cart_price',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/cart_price.html'
      }
    }
  }).state('admin.projects.settings.initialization.distinguish_direct_indirect_cv', {
    url: '/distinguish_direct_indirect_cv',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/distinguish_direct_indirect_cv.html'
      }
    }
  }).state('admin.projects.settings.initialization.cookie_server_setting', {
    url: '/cookie_server_setting',
    views: {
      'content@admin.projects.settings': {
        templateUrl: '/templates/projects.settings/initialization/cookie_server_setting.html'
      }
    }
  });
}]);

redirectNewDashboard = function(params, Project, Devise, $stateParams, $window) {
  if (params.internalOnly && !Devise.isCommonUser()) {
    return Project.getCurrent($stateParams.projectId).then(function(project) {
      return $window.location.href = ZC_CONFIG.AIDEAL_URL + "/site/" + project.apikey + "/settings/" + params.path;
    });
  }
};


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcSettingStatus', ["SettingStatus", function(SettingStatus) {
  return {
    restrict: 'EA',
    scope: {
      status: '@'
    },
    template: "<div class=\"config-status\" ng-class=\"{'config-status-success': completed}\">\n  <i class=\"fa fa-check-circle\"></i>\n</div>",
    link: function(scope, element, attrs) {
      scope.SettingStatus = SettingStatus;
      return scope.$watch('SettingStatus.statuses', function(statuses) {
        return scope.completed = statuses[scope.status];
      }, true);
    }
  };
}]);


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

angular.module('zc.projects').factory('SettingStatus', function() {
  var service;
  service = {
    statuses: {
      installationCompleted: false,
      installationReady: false,
      trackingTag: false,
      conversionTag: false,
      conversionUrl: false,
      testConversion: false,
      excludeIp: false,
      domain: false,
      loginEvaluator: false,
      newsletterParameter: false,
      billingContractInformation: false,
      billingInformation: false,
      billingRepresentativeInformation: false,
      billingSettingsCompleted: false
    },
    updateProjectStatus: function(project) {
      this.statuses.installationCompleted = project.campaign_status === 'completed';
      this.statuses.conversionUrl = !!project.conversion_urls_memo;
      this.statuses.testConversion = !!(!project.has_test_conversion || project.test_conversion_memo);
      this.statuses.domain = !!(!project.has_multiple_domains || project.multiple_domains_memo);
      this.statuses.loginEvaluator = !!(!project.has_login_evaluator || project.login_evaluator_memo);
      this.statuses.newsletterParameter = !!(!project.has_newsletter_parameter || project.newsletter_parameter_memo);
      this.statuses.billingContractInformation = this.isBillingContractInformationComplete(project);
      this.statuses.billingInformation = this.isBillingInformationComplete(project);
      this.statuses.billingRepresentativeInformation = this.isBillingRepresentativeInformationComplete(project);
      this.statuses.billingSettingsCompleted = this.isBillingSettingsCompleted(project);
      this.statuses.trackingTag = !!(project.tracking_tag_confirmed_at || project.tracking_tag_confirmed_by);
      this.statuses.conversionTag = !!(project.conversion_tag_confirmed_at || project.conversion_tag_confirmed_by) || project.is_wevnal;
      return this.updateInstallationReady();
    },
    updateInstallationReady: function() {
      return this.statuses.installationReady = this.statuses.trackingTag && this.statuses.conversionTag && this.statuses.conversionUrl && this.statuses.testConversion && this.statuses.excludeIp && this.statuses.domain;
    },
    isBillingContractInformationComplete: function(project) {
      return (project.sales_entity_fullname === 'Appier Japan (JP)' && project.company_name && project.representative && project.postal_code && project.address && project.phone_number) || (project.sales_entity_fullname !== 'Appier Japan (JP)' && project.company_name);
    },
    isBillingInformationComplete: function(project) {
      return project.billing_company_name && project.billing_postal_code && project.billing_address && project.billing_phone_number;
    },
    isBillingRepresentativeInformationComplete: function(project) {
      return project.billing_representatives && project.billing_representatives[0] && project.billing_representatives[0].email && project.billing_representatives[0].full_name;
    },
    isBillingSettingsCompleted: function(project) {
      if (!project.is_direct_selling) {
        return this.statuses.billingContractInformation;
      }
      return this.statuses.billingContractInformation && this.statuses.billingInformation && this.statuses.billingRepresentativeInformation;
    },
    updateExcludeIpStatus: function(excludeIps) {
      this.statuses.excludeIp = !!excludeIps.length;
      return this.updateInstallationReady();
    }
  };
  return service;
});


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('UserIndexCtrl', ["$scope", "$stateParams", "ProjectUser", "currentProject", function($scope, $stateParams, ProjectUser, currentProject) {
  $scope.users = [];
  $scope.isDisplayAajsWarningMsg = currentProject.enable_aajs && _.some([currentProject.site_id, currentProject.tracking_id, currentProject.scope_id], (function(_this) {
    return function(item) {
      return !(item && item.length > 0);
    };
  })(this));
  ProjectUser.all($stateParams.projectId).then(function(users) {
    return $scope.users = users;
  });
  return $scope.remove = (function(_this) {
    return function(id) {
      return ProjectUser["delete"]($stateParams.projectId, id).then(function(res) {
        return $scope.users = _.reject($scope.users, function(user) {
          return user.id === id;
        });
      });
    };
  })(this);
}]);


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('UserInviteCtrl', ["$scope", "ProjectUser", "$state", "$stateParams", "$translate", "currentUser", "currentProject", function($scope, ProjectUser, $state, $stateParams, $translate, currentUser, currentProject) {
  $scope.availableLanguages = $translate.getAvailableLanguageKeys();
  $scope.user = {
    lang: currentUser.lang
  };
  $scope.isDisplayAajsWarningMsg = currentProject.enable_aajs && _.some([currentProject.site_id, currentProject.tracking_id, currentProject.scope_id], (function(_this) {
    return function(item) {
      return !(item && item.length > 0);
    };
  })(this));
  return $scope.invite = function(project, user) {
    return ProjectUser.create({
      projectId: project.id
    }, {
      user: user
    }).then(function(user) {
      $scope.user = {
        full_name: '',
        email: '',
        lang: currentUser.lang
      };
      return $state.go('admin.projects.settings.users', {
        projectId: $stateParams.projectId
      });
    });
  };
}]);


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcLabelUserInvitation', ["$translate", function($translate) {
  return {
    restrict: 'E',
    scope: {
      user: '='
    },
    template: "<span\n  class=\"label label-info\"\n  ng-if=\"invited && !accepted && user.valid_invitation\">\n  " + ($translate.instant('projectsSettings.users.labelUserInvitation.inviting')) + "\n</span>\n<span\n  class=\"label label-warning\"\n  ng-if=\"invited && !accepted && !user.valid_invitation\">\n  " + ($translate.instant('projectsSettings.users.labelUserInvitation.expired')) + "\n</span>",
    link: function(scope, element, attrs) {
      scope.invited = !!scope.user.invitation_created_at;
      return scope.accepted = !!scope.user.invitation_accepted_at;
    }
  };
}]);


/***/ }),
/* 1261 */
/***/ (function(module, exports) {

angular.module('zc.projects').service('chartConfig', ["$filter", function($filter) {
  return {
    main: {
      options: {
        title: {
          text: null
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          dateTimeLabelFormats: {
            hour: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDayHour'),
            day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            marker: {
              radius: 3,
              fillColor: '#FFF',
              lineWidth: 2,
              lineColor: null
            }
          }
        },
        yAxis: {
          min: 0
        }
      }
    },
    pie: {
      options: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: {
          align: 'center',
          verticalAlign: 'middle',
          y: -20
        },
        credits: {
          enabled: false
        },
        legend: {
          floating: true,
          y: -140,
          borderColor: "#fff"
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
          pie: {
            showInLegend: true,
            startAngle: -90,
            endAngle: 90,
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                fontWeight: "bold",
                color: "white",
                textShadow: "0px 1px 2px black"
              }
            }
          }
        }
      },
      series: []
    },
    line: {
      options: {
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        colors: ['#26c9ff', '#666666'],
        chart: {
          type: 'line'
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          dateTimeLabelFormats: {
            hour: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDayHour'),
            day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
          }
        },
        plotOptions: {
          series: {
            marker: {
              symbol: 'circle',
              enabled: false
            }
          }
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            hour: $filter('translate')('sharedModules.dateTimeFormats.chart.hour'),
            day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
          }
        },
        yAxis: {
          title: {
            text: null
          },
          min: 0,
          labels: {
            formatter: function() {
              var prefix, suffix, valueDecimals;
              prefix = this.chart.series[0].tooltipOptions.valuePrefix || '';
              suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
              valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
              return prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix;
            }
          }
        }
      },
      series: []
    },
    base: {
      xAxis: {
        type: 'datetime',
        minRange: 24 * 3600000
      },
      yAxis: {
        title: {
          text: ''
        },
        plotLines: [
          {
            value: 0,
            width: 1,
            color: '#808080'
          }
        ]
      },
      series: [],
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        borderWidth: 0
      }
    },
    column: {
      options: {
        title: {
          text: null
        },
        colors: ['#26c9ff'],
        chart: {
          type: 'column'
        },
        legend: false
      },
      xAxis: {
        type: 'datetime',
        minRange: 24 * 3600000
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      series: []
    },
    area: {
      options: {
        chart: {
          type: 'area'
        }
      },
      xAxis: {
        type: 'datetime',
        minRange: 24 * 3600000
      },
      yAxis: {
        title: {
          text: ''
        },
        plotLines: [
          {
            value: 0,
            width: 1,
            color: '#808080'
          }
        ]
      },
      series: [],
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        borderWidth: 0
      }
    },
    campaignPriceDistribution: {
      options: {
        title: {
          text: null
        },
        colors: ['#26c9ff'],
        chart: {
          type: 'column'
        },
        legend: false
      },
      yAxis: {
        plotLines: [
          {
            value: 0,
            color: '#808080'
          }
        ]
      },
      series: []
    },
    campaignInterestWidgetItembution: {
      options: {
        title: {
          text: null
        },
        colors: ['#26c9ff', '#666666'],
        chart: {
          type: 'column'
        },
        legend: false,
        credits: {
          enabled: false
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        labels: {
          formatter: function() {
            var prefix, suffix, valueDecimals;
            prefix = this.chart.series[0].tooltipOptions.valuePrefix || '';
            suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
            valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
            return prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix;
          }
        }
      },
      series: []
    },
    campaignDwell: {
      options: {
        title: {
          text: null
        },
        colors: ['#26c9ff'],
        chart: {
          type: 'spline'
        },
        legend: false,
        credits: {
          enabled: false
        }
      },
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          format: '{value}' + $filter('translate')('sharedModules.common.unit.minute')
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        plotLines: [
          {
            value: 0,
            color: '#808080'
          }
        ],
        labels: {
          format: '{value}' + $filter('translate')('sharedModules.common.unit.session')
        }
      },
      series: []
    },
    campaignHistoryCount: {
      options: {
        title: {
          text: null
        },
        colors: ['#26c9ff'],
        chart: {
          type: 'spline'
        },
        legend: false,
        credits: {
          enabled: false
        }
      },
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          format: '{value}' + $filter('translate')('sharedModules.common.unit.pv')
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        plotLines: [
          {
            value: 0,
            color: '#808080'
          }
        ],
        labels: {
          format: '{value}' + $filter('translate')('sharedModules.common.unit.session')
        }
      },
      series: []
    },
    report: {
      options: {
        title: {
          text: null
        },
        chart: {
          type: 'area'
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            marker: {
              symbol: 'circle',
              enabled: false
            }
          }
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
          }
        },
        yAxis: {
          title: {
            text: null
          },
          min: 0,
          labels: {
            formatter: function() {
              var prefix, suffix, valueDecimals;
              prefix = this.chart.series[0].tooltipOptions.valuePrefix || '';
              suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
              valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
              return prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix;
            }
          }
        }
      }
    },
    segment: {
      options: {
        title: {
          text: null
        },
        colors: ['#26c9ff', '#666666'],
        chart: {
          type: 'area'
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          dateTimeLabelFormats: {
            hour: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDayHour'),
            day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
          }
        },
        plotOptions: {
          series: {
            marker: {
              symbol: 'circle',
              enabled: false
            }
          }
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
          }
        },
        yAxis: {
          title: {
            text: null
          },
          min: 0,
          labels: {
            formatter: function() {
              var prefix, suffix, valueDecimals;
              prefix = this.chart.series[0].tooltipOptions.valuePrefix || '';
              suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
              valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
              return prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix;
            }
          }
        }
      }
    }
  };
}]);


/***/ }),
/* 1262 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('ClearanceItemSetUploadCtrl', ["$scope", "$stateParams", "ClearanceItemSet", function($scope, $stateParams, ClearanceItemSet) {
  var clear;
  clear = function() {
    return $scope.clearance_item_set = {
      name: '',
      description: ''
    };
  };
  clear();
  return $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    event.preventDefault();
    return ClearanceItemSet.create({
      projectId: $stateParams.projectId
    }, {
      name: $scope.clearance_item_set.name,
      description: $scope.clearance_item_set.description,
      file: flowFile.file
    }).then(function(clearance_item_set) {
      $scope.$parent.project.clearance_item_sets.push(clearance_item_set);
      return clear();
    });
  });
}]);


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('DetailProjectCtrl', ["$scope", "$translate", "Page", "Project", "Campaign", "ClearanceItemSet", "currentProject", "visitorIdsForDM", function($scope, $translate, Page, Project, Campaign, ClearanceItemSet, currentProject, visitorIdsForDM) {
  Page.setBodyClass('');
  $translate('projects.controllers.detailController.detailCampaignSetting').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.project = currentProject;
  $scope.visitorIdsForDM = visitorIdsForDM;
  $scope.removeClearanceItemSet = function(obj) {
    if (!obj) {
      return;
    }
    return ClearanceItemSet.destroy(obj).then(function() {
      var set;
      return $scope.project.clearance_item_sets = (function() {
        var i, len, ref, results;
        ref = $scope.project.clearance_item_sets;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          set = ref[i];
          if (set.id !== obj.id) {
            results.push(set);
          }
        }
        return results;
      })();
    });
  };
  return $scope.getClearanceCampaigns = function(set) {
    if (!set) {
      return;
    }
    return Campaign.all({
      projectId: $scope.project.id,
      clearance_item_set_id: set.id
    }).then(function(campaigns) {
      return set.clearanceCampaigns = campaigns;
    });
  };
}]);


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('EditProjectCtrl', ["$scope", "$translate", "Page", "Project", "currentProject", function($scope, $translate, Page, Project, currentProject) {
  Page.setBodyClass('');
  $translate('projects.controllers.editController.changeSiteInformation').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.project = currentProject;
  $scope.save = function() {
    return Project.update({
      projectId: $scope.project.id
    }, {
      project: {
        title: $scope.project.title
      }
    });
  };
  return $scope.updatePublish = function(is_publish) {
    $scope.project.is_publish = is_publish;
    return Project.update({
      projectId: $scope.project.id
    }, {
      project: {
        is_publish: is_publish
      }
    });
  };
}]);


/***/ }),
/* 1265 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('HomeCtrl', ["$state", "$translate", "Agency", "Devise", "Page", "projects", function($state, $translate, Agency, Devise, Page, projects) {
  var RECENT_PROJECT_LIMIT, vm;
  Page.setBodyClass('');
  $translate('projects.controllers.homeController.siteList').then(function(translation) {
    return Page.setTitle(translation);
  });
  RECENT_PROJECT_LIMIT = 6;
  vm = this;
  vm.$onInit = function() {
    vm.Devise = Devise;
    vm.projects = _.filter(projects, {
      is_terminated: false
    });
    vm.agencies = [];
    vm.recentProjects = _.chain(vm.projects).sortBy(function(project) {
      return -moment(project.created_at).valueOf();
    }).take(RECENT_PROJECT_LIMIT).value();
    Agency.all().then(function(agencies) {
      return vm.agencies = agencies;
    });
    return vm.goToProject = function(project) {
      return $state.go('admin.projects.campaigns.list', {
        projectId: project.id
      });
    };
  };
}]);


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('ImageBrowserController', [
  "$scope", "$modalInstance", "images", "currentImageUrl", "Image", function($scope, $modalInstance, images, currentImageUrl, Image) {
    var i, img, len, ref;
    $scope.images = images;
    $scope.Image = Image;
    $scope.selected = {};
    ref = $scope.images;
    for (i = 0, len = ref.length; i < len; i++) {
      img = ref[i];
      if (img.image_url === currentImageUrl) {
        $scope.selected.img = img;
      }
    }
    $scope.selectImage = function(img) {
      return $scope.selected.img = img;
    };
    $scope.markAsUnselectable = function(img) {
      return $scope.Image.markAsUnselectable(img).then(function(res) {
        return $scope.images = res;
      });
    };
    $scope.ok = function() {
      return $modalInstance.close($scope.selected.img);
    };
    return $scope.cancel = function() {
      return $modalInstance.dismiss('cancel');
    };
  }
]);


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('ImagesCtrl', [
  "$scope", "images", "Image", function($scope, images, Image) {
    var currentImageUrl, i, img, len, ref;
    $scope.images = images;
    $scope.selected = {};
    currentImageUrl = "";
    $scope.deleteImage = function(id) {
      var destroy;
      destroy = Image.destroy({
        imageId: id
      });
      return destroy.then(function(res) {
        return $scope.images = res.images;
      });
    };
    ref = $scope.images;
    for (i = 0, len = ref.length; i < len; i++) {
      img = ref[i];
      if (img.image_url === currentImageUrl) {
        $scope.selected.img = img;
      }
    }
    $scope.selectImage = function(img) {
      return $scope.selected.img = img;
    };
    $scope.ok = function() {
      return $modalInstance.close($scope.selected.img);
    };
    return $scope.cancel = function() {
      return $modalInstance.dismiss('cancel');
    };
  }
]);


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('NewImageCtrl', ["$scope", "$stateParams", "Api", function($scope, $stateParams, Api) {
  var base_url;
  base_url = "/api/projects/" + $stateParams.projectId;
  return $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    event.preventDefault();
    return Api.post(base_url + "/images.json", {}, {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      data: {
        image: flowFile.file
      },
      transformRequest: function(data) {
        var fd;
        fd = new FormData();
        angular.forEach(data, function(val, key) {
          return fd.append(key, val);
        });
        return fd;
      }
    }).then(function(arg) {
      var data;
      data = arg.data;
      return $scope.campaign.element.message[$scope.itemName] = data.image.image_url;
    })["catch"](function(err) {
      return console.error(err);
    });
  });
}]);


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

angular.module('zc.projects').service('theme', ["$filter", function($filter) {
  return {
    system: {
      message: ($translate.instant('projects.controllers.invitationNew.setupStep')) + "\n" + ($translate.instant('projects.controllers.invitationNew.setupInitial')) + "\n\n" + ($translate.instant('projects.controllers.invitationNew.setupTracking')) + "\n" + ($translate.instant('projects.controllers.invitationNew.setupConversion')) + "\n" + ($translate.instant('projects.controllers.invitationNew.setupPage')) + "\n" + ($translate.instant('projects.controllers.invitationNew.setupDomain')) + "\n" + ($translate.instant('projects.controllers.invitationNew.setupVisit')) + "\n" + ($translate.instant('projects.controllers.invitationNew.setupExcludedIp'))
    },
    "default": {
      message: ''
    }
  };
}]).controller('NewInvitationCtrl', ["$scope", "$state", "$translate", "$stateParams", "currentUser", "Page", "Devise", "theme", function($scope, $state, $translate, $stateParams, currentUser, Page, Devise, theme) {
  $scope.projectId = $stateParams.projectId;
  $scope.theme = $stateParams.theme;
  $scope.full_name = currentUser.full_name;
  Page.setBodyClass('');
  $translate('projects.controllers.invitationNew.inviteMembers').then(function(translation) {
    return Page.setTitle(translation);
  });
  if (theme[$scope.theme]) {
    $scope.email = {
      message: theme[$scope.theme].message
    };
  } else {
    $scope.email = {
      message: theme["default"].message
    };
  }
  return $scope.send = function(email) {
    return Devise.invite(email);
  };
}]);


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('NewProjectCtrl', ["$scope", "$translate", "$state", "Page", "Project", function($scope, $translate, $state, Page, Project) {
  Page.setBodyClass('account-bg');
  $translate('projects.controllers.newController.siteRegistration').then(function(translation) {
    return Page.setTitle(translation);
  });
  return $scope.submit = function(project) {
    return Project.create(project).then(function(project) {
      return $state.go('admin.projects.campaigns.list', {
        projectId: project.id
      });
    });
  };
}]);


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

angular.module('zc.projects').controller('VisitorIdForDMUploadCtrl', ["$scope", "$stateParams", "Project", function($scope, $stateParams, Project) {
  return $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    event.preventDefault();
    return Project.uploadVisitorIdsForDM({
      projectId: $stateParams.projectId
    }, {
      file: flowFile.file
    }).then(function(visitorIdsForDM) {
      return $scope.$parent.visitorIdsForDM = visitorIdsForDM;
    });
  });
}]);


/***/ }),
/* 1272 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcProjectNotification', ["Project", "$stateParams", "$state", "$rootScope", function(Project, $stateParams, $state, $rootScope) {
  return {
    restrict: 'E',
    templateUrl: '/templates/projects/directives/project_notification.html',
    link: function(scope, element, attrs) {
      Project.getCurrent($stateParams.projectId).then(function(project) {
        scope.project = project;
        return scope.showTimezoneAlert = moment().tz(project.region).format('Z') !== moment().tz(moment.tz.guess(true)).format('Z');
      });
      scope.isAlert = true;
      scope.removeAlert = function() {
        return scope.isAlert = !scope.isAlert;
      };
      return $rootScope.$on('$stateChangeSuccess', function() {
        var ref;
        if ((ref = $state.current.name) === 'admin.projects.campaigns.edit.schedule' || ref === 'admin.projects.campaigns.edit.confirm' || ref === 'admin.projects.incentives.new' || ref === 'admin.projects.incentives.edit') {
          scope.isAlert = true;
          return scope.isCriticalTimezoneAlert = true;
        } else {
          return scope.isCriticalTimezoneAlert = false;
        }
      });
    }
  };
}]);


/***/ }),
/* 1273 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcAdvertisingsList', ["ProjectAdvertising", function(ProjectAdvertising) {
  return {
    restrict: "E",
    scope: {
      project: "="
    },
    templateUrl: "/templates/projects/directives/projects/advertisings_list.html",
    link: function(scope, element, attrs) {
      scope.advertisings = [];
      return ProjectAdvertising.all(scope.project.id).then(function(res) {
        return scope.advertisings = res;
      });
    }
  };
}]);


/***/ }),
/* 1274 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcLoginEvaluatorsList', ["ProjectLoginEvaluator", function(ProjectLoginEvaluator) {
  return {
    restrict: "E",
    scope: {
      project: "="
    },
    templateUrl: "/templates/projects/directives/projects/login_evaluators_list.html",
    link: function(scope, element, attrs) {
      scope.login_evaluators = [];
      return ProjectLoginEvaluator.all(scope.project.id).then(function(res) {
        return scope.login_evaluators = res;
      });
    }
  };
}]);


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcNewsletterParametersList', ["ProjectNewsletterParameter", function(ProjectNewsletterParameter) {
  return {
    restrict: "E",
    scope: {
      project: "="
    },
    templateUrl: "/templates/projects/directives/projects/newsletter_parameters_list.html",
    link: function(scope, element, attrs) {
      scope.newsletter_parameters = [];
      return ProjectNewsletterParameter.all(scope.project.id).then(function(res) {
        return scope.newsletter_parameters = res;
      });
    }
  };
}]);


/***/ }),
/* 1276 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('projectApikeyMenu', ["Project", function(Project) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {},
    replace: true,
    templateUrl: '/templates/projects/views/directives/project_apikey_menu.html',
    link: function(scope) {
      return scope.Project = Project;
    }
  };
  return directive;
}]);


/***/ }),
/* 1277 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('projectExcludeIps', ["$translate", "installationApi", function($translate, installationApi) {
  var directive;
  directive = {
    restrict: "E",
    scope: {
      excludeIps: "="
    },
    template: "<section>\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <h5>" + ($translate.instant('projects.directives.projects.projectExcludeIps.currentIp')) + "</h5>\n      <table class=\"table table-bordered table-hover\">\n        <tbody>\n          <tr ng-repeat=\"excludeIp in excludeIps\">\n            <td><h2 class=\"text-danger\">{{excludeIp}}</h2></td>\n            <td><button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"remove(excludeIp)\">×</button></td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n\n  <form novalidate name=\"ipForm\">\n    <div class=\"row\">\n      <div class=\"col-md-8\">\n        <h5 class=\"text-left\">" + ($translate.instant('projects.directives.projects.projectExcludeIps.addExcludeIp')) + "</h5>\n        <div class=\"row\">\n          <div class=\"col-md-8\">\n            <input type=\"text\" class=\"form-control\" name=\"newIp\"\n                placeholder=\"xxx.xxx.xxx.xxx\"\n                ng-model=\"inputs.newIp\"\n                ng-pattern=\"ipRegexp\"\n                required>\n          </div>\n          <div class=\"col-md-4\">\n            <button type=\"submit\" class=\"btn btn-block btn-default\"\n                    ng-click=\"addIp()\"\n                    ng-disabled=\"(!ipForm) || (alreadyExists())\"\n            >" + ($translate.instant('projects.directives.projects.projectExcludeIps.register')) + "</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  <div ng-show=\"isoverlap()\" class=\"label label-danger\">" + ($translate.instant('projects.directives.projects.projectExcludeIps.noDuplicateIpAllowed')) + "</div>\n  </form>\n</section>",
    link: function(scope, element, attrs) {},
    controller: function($scope) {
      $scope.ipRegexp = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
      $scope.inputs = {
        newIp: ""
      };
      installationApi.getIpAddresss().then(function(data) {
        return angular.forEach(data, function(v, i) {
          return $scope.ips.push(v);
        });
      });
      $scope.alreadyExists = function() {
        return $scope.excludeIps.indexOf($scope.inputs.newIp) >= 0;
      };
      $scope.remove = function(excludeIp) {
        return installationApi.deleteIpAdress(excludeIp).then(function(res) {
          return $scope.excludeIps.splice($scope.excludeIps.indexOf(excludeIp), 1);
        });
      };
      return $scope.addIp = function() {
        return installationApi.setIpAddress(excludeIp).then(function(res) {
          return $scope.excludeIps.push($scope.inputs.newIp);
        });
      };
    }
  };
  return directive;
}]);


/***/ }),
/* 1278 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcProjectList', function() {
  return {
    restrict: 'EA',
    scope: {
      projects: '='
    },
    templateUrl: '/templates/projects/views/directives/project_list.html'
  };
});


/***/ }),
/* 1279 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('projectPageTypes', ["$translate", "PageType", "$timeout", function($translate, PageType, $timeout) {
  var directive;
  directive = {
    restrict: "E",
    scope: {
      requiredPageTypes: "=",
      pageTypes: "=",
      pageTypeOptions: "=",
      matchTypes: "=",
      devices: "=",
      currentProject: "="
    },
    template: "<section>\n\n  <table class=\"table table-bordered table-hover pagetype_box\">\n    <thead>\n      <tr>\n        <th>" + ($translate.instant('projects.directives.projects.projectPageTypes.device')) + "</th>\n        <th>" + ($translate.instant('projects.directives.projects.projectPageTypes.setting')) + "</th>\n        <th>" + ($translate.instant('projects.directives.projects.projectPageTypes.device')) + "</th>\n        <th></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"pageType in pageTypes\">\n        <form name=\"page_type_{{pageType.id}}\">\n        <td class=\"col-xs-2\">\n          <select class=\"form-control\" ng-model=\"pageType.required_device\" ng-options=\"pt.value as pt.name for pt in devices\"></select>\n        </td>\n        <td class=\"col-xs-3\">\n           <select class=\"form-control\" ng-model=\"pageType.page_type\" ng-options=\"pt.value as pt.name for pt in pageTypeOptions\"></select>\n\n          <select class=\"form-control\" ng-model=\"pageType.match_type\" ng-options=\"pt.value as pt.name for pt in matchTypes\" ng-change=\"check(pageType)\"></select>\n        </td>\n        <td class=\"col-xs-4\">\n\n          <div ng-if=\"pageType.match_type != 'full'\">\n            <input type=\"text\" class=\"form-control\" style=\"font-size: smaller\" ng-model=\"pageType.sample_url\" ng-change=\"check(pageType)\" placeholder=\"" + ($translate.instant('projects.directives.projects.projectPageTypes.exampleUrl')) + "\"/>\n          </div>\n          <div ng-if=\"pageType.match_type == 'full'\">\n            <input type=\"text\" class=\"form-control\" style=\"font-size: smaller\" ng-model=\"pageType.match_pattern\" ng-disabled=\"true\"placeholder=\"" + ($translate.instant('projects.directives.projects.projectPageTypes.exampleUrl')) + "\"/>\n          </div>\n           <input type=\"text\" class=\"form-control\" style=\"font-size: smaller\" ng-model=\"pageType.match_pattern\" ng-change=\"check(pageType)\" placeholder=\"" + ($translate.instant('projects.directives.projects.projectPageTypes.pattern')) + "\"/>\n            " + ($translate.instant('projects.directives.projects.projectPageTypes.regexMatch')) + "\n            <span ng-show=\"pageType.isOk\" class=\"label label-success\">" + ($translate.instant('projects.directives.projects.projectPageTypes.ok')) + "</span>\n            <span ng-hide=\"pageType.isOk\" class=\"label label-danger\">" + ($translate.instant('projects.directives.projects.projectPageTypes.not')) + "</span>\n        </td>\n\n        <td class=\"col-xs-2\">\n            <button type=\"button\" class=\"close pull-right\" aria-hidden=\"true\" ng-click=\"removePageType(pageType)\">×</button>\n          <div class=\"btn-group-vertical\">\n            <button type=\"button\" class=\"btn btn-primary save\" aria-hidden=\"true\" ng-click=\"updatePageType(pageType)\">" + ($translate.instant('projects.directives.projects.projectPageTypes.save')) + "</button>\n            <button type=\"button\" class=\"btn btn-default reset\" aria-hidden=\"true\" ng-click=\"resetPageType(pageType)\">" + ($translate.instant('projects.directives.projects.projectPageTypes.reset')) + "</button>\n          </div>\n        </td>\n        </form>\n      </tr>\n\n      <tr>\n        <td colspan=\"5\">\n          <button class=\"btn btn-large btn-primary col-sm-12\" ng-click=\"addPageType()\">" + ($translate.instant('projects.directives.projects.projectPageTypes.add')) + "</button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n</section>",
    link: function(scope, element, attrs) {},
    controller: function($scope) {
      $scope.check = function(pageType) {
        var regexp;
        if (pageType.match_type === "full") {
          return pageType.isOk = true;
        } else if (pageType.match_type === "prefix") {
          if (pageType.sample_url && pageType.sample_url.indexOf(pageType.match_pattern) === 0) {
            return pageType.isOk = true;
          } else {
            return pageType.isOk = false;
          }
        } else if (pageType.match_type === "regexp") {
          regexp = new RegExp(pageType.match_pattern);
          if (pageType.sample_url && regexp.test(pageType.sample_url)) {
            return pageType.isOk = true;
          } else {
            return pageType.isOk = false;
          }
        }
      };
      $scope.removePageType = function(pageType) {
        return PageType.destroy(pageType).then(function(res) {
          return $scope.pageTypes.splice($scope.pageTypes.indexOf(pageType), 1);
        });
      };
      $scope.addPageType = function() {
        return PageType.create($scope.currentProject.id).then(function(res) {
          return $scope.pageTypes.push(res);
        });
      };
      $scope.resetPageType = function(pageType) {
        return PageType.update({
          projectId: pageType.project_id,
          id: pageType.id
        }, {
          page_type: {
            is_found_pc: false,
            is_found_sp: false
          }
        });
      };
      $scope.updatePageType = function(pageType) {
        return PageType.update({
          projectId: pageType.project_id,
          id: pageType.id
        }, {
          page_type: pageType
        });
      };
      return $scope.$watchCollection('pageTypes', function() {
        var i, len, pt, ref, results;
        ref = $scope.pageTypes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          pt = ref[i];
          results.push($scope.check(pt));
        }
        return results;
      });
    }
  };
  return directive;
}]);


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('projectSearch', ["Project", function(Project) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {
      onSelect: "&"
    },
    replace: true,
    templateUrl: '/templates/projects/views/directives/project_search.html',
    link: function(scope, element) {
      scope.Project = Project;
      scope.projects = [];
      Project.all().then(function(projects) {
        return scope.projects = _.map(projects, function(p) {
          return {
            id: p.id,
            apikey: p.apikey,
            title: p.title,
            company_name: p.company_name
          };
        });
      });
      return scope.selectProject = function(item, model, label) {
        scope.onSelect({
          project: model
        });
        return this.selectedProject = "";
      };
    }
  };
  return directive;
}]);


/***/ }),
/* 1281 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('projectsMenu', ["$state", "$stateParams", "$timeout", "Project", function($state, $stateParams, $timeout, Project) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {},
    replace: true,
    templateUrl: '/templates/projects/views/directives/projects_menu.html',
    link: function(scope, element) {
      scope.Project = Project;
      scope.projects = [];
      Project.getCurrent($stateParams.projectId).then(function(res) {
        return scope.currentProject = res;
      });
      Project.all().then(function(projects) {
        return scope.projects = _.sortBy(projects, function(project) {
          return project.title.toLowerCase();
        });
      });
      return scope.$watch('Project.currentProject', function(newVal, oldVal) {
        return scope.currentProject = newVal;
      });
    },
    controller: function($rootScope) {
      return $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        if (toState) {
          if (toParams.projectId) {
            return Project.get(toParams.projectId).then(function(project) {
              return Project.currentProject = project;
            });
          } else {
            return Project.currentProject = void 0;
          }
        }
      });
    }
  };
  return directive;
}]);


/***/ }),
/* 1282 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('projectsMenuSearch', ["$state", "$timeout", "Project", "Devise", function($state, $timeout, Project, Devise) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {},
    replace: true,
    templateUrl: '/templates/projects/views/directives/projects_menu_search.html',
    link: function(scope, element) {
      scope.Project = Project;
      scope.Devise = Devise;
      scope.focusOnSearch = function() {
        $timeout(function() {
          var input;
          input = element.find("input.project-search");
          return input.focus();
        }, 50);
      };
      return scope.goHome = function(project) {
        return scope.Project.goHome(project);
      };
    }
  };
  return directive;
}]);


/***/ }),
/* 1283 */
/***/ (function(module, exports) {

angular.module('zc.projects').service('projectStatues', ["$filter", function($filter) {
  return {
    terminated_after_trial: {
      status: 'terminated_after_trial',
      text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.terminatedAfterTrial'),
      statusClass: 'label label-danger',
      showsDate: false
    },
    terminated_after_contract: {
      status: 'terminated_after_contract',
      text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.terminatedAfterContract'),
      statusClass: 'label label-danger',
      showsDate: false
    },
    contracted: {
      status: 'contracted',
      text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.contracted'),
      statusClass: 'label label-success',
      showsDate: true
    },
    trial: {
      status: 'trial',
      text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.trial'),
      statusClass: 'label label-warning',
      showsDate: true
    },
    before_trial: {
      status: 'before_trial',
      text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.beforeTrial'),
      statusClass: 'label label-warning',
      showsDate: true
    },
    idle: {
      status: 'idle',
      text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.idle'),
      statusClass: 'label label-info',
      showsDate: false
    }
  };
}]).directive('zcLabelProjectStatus', ["projectStatues", function(projectStatues) {
  return {
    restrict: 'E',
    scope: {
      project: '=',
      range: '='
    },
    template: "<span ng-class=\"label.statusClass\">\n  {{label.text}}\n  <span ng-if=\"label.showsDate\">\n    <span ng-if=\"label.status == 'contracted' && project.contracted_at\">\n      ({{project.contracted_at | date : 'yyyy/M/d' }})\n    </span>\n    <span ng-if=\"label.status == 'trial' && project.trial_started_at\">\n      ({{project.trial_started_at | date : 'yyyy/M/d' }})\n    </span>\n  </span>\n</span>\n<br>",
    link: function(scope, element, attrs) {
      var updateLabels;
      $(element).addClass("project-status");
      updateLabels = function(range) {
        return scope.label = projectStatues[scope.project.contract_status];
      };
      return scope.$watch('range', updateLabels);
    }
  };
}]);


/***/ }),
/* 1284 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('zcLabelReportStatus', ["$translate", function($translate) {
  return {
    restrict: 'E',
    scope: {
      report: '='
    },
    template: "<span ng-class=\"labelClass\">{{text}}</span>",
    link: function(scope, element, attrs) {
      if (scope.report.status === 'trial') {
        scope.text = $translate.instant('projects.directives.projects.zcLabelReportStatus.trial');
        return scope.labelClass = 'label label-warning';
      } else if (scope.report.status === 'contracted') {
        scope.text = $translate.instant('projects.directives.projects.zcLabelReportStatus.contracted');
        return scope.labelClass = 'label label-success';
      }
    }
  };
}]);


/***/ }),
/* 1285 */
/***/ (function(module, exports) {

angular.module('zc.projects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.home', {
    url: '/home',
    views: {
      'header@': {
        templateUrl: '/templates/core/views/admin_header.html',
        controller: 'AdminHeaderCtrl'
      },
      'mainnav@': {
        templateUrl: '/templates/core/views/emptynav.html'
      },
      'content@': {
        templateUrl: '/templates/projects/views/home.html',
        controllerAs: '$ctrl',
        controller: 'HomeCtrl'
      }
    },
    resolve: {
      projects: ["Project", "Devise", "Meta", "$q", "$state", "$window", function(Project, Devise, Meta, $q, $state, $window) {
        return $q.all([Devise.getCurrentUser(), Project.all()]).then(function(arg) {
          var lite_projects, projects, user;
          user = arg[0], projects = arg[1];
          if (!Devise.isMaster()) {
            lite_projects = projects.filter(function(project) {
              return project.product_line === 'zenclerk_s';
            });
            projects = projects.filter(function(project) {
              return project.product_line !== 'zenclerk_s';
            });
          }
          if (projects.length === 1) {
            return $state.go('admin.projects.campaigns.list', {
              projectId: projects[0].id
            });
          } else if (projects.length === 0 && (lite_projects != null ? lite_projects.length : void 0) > 0) {
            return Meta.getServices().then(function(services) {
              return $window.location.href = services.zcs;
            });
          } else {
            return projects;
          }
        });
      }]
    }
  }).state('admin.projects', {
    abstract: true,
    url: '/projects/{projectId:int}',
    views: {
      'mainnav@': {
        templateUrl: '/templates/core/views/mainnav.html',
        controller: 'MainnavCtrl'
      }
    },
    resolve: {
      currentProject: ["Project", "Devise", "Meta", "$q", "$stateParams", "$window", function(Project, Devise, Meta, $q, $stateParams, $window) {
        return $q.all([Devise.getCurrentUser(), Project.getCurrent($stateParams.projectId)]).then(function(arg) {
          var project, user;
          user = arg[0], project = arg[1];
          if (!Devise.isMaster() && project.product_line === 'zenclerk_s') {
            return Meta.getServices().then(function(services) {
              return $window.location.href = services.zcs;
            });
          } else {
            return project;
          }
        });
      }]
    }
  }).state('admin.projects.edit', {
    url: '/edit',
    views: {
      'mainnav@': {
        template: ''
      },
      'content@': {
        templateUrl: '/templates/projects/views/edit.html',
        controller: 'EditProjectCtrl'
      }
    }
  }).state('admin.projects.detail', {
    url: '/detail',
    views: {
      'content@': {
        templateUrl: '/templates/projects/views/detail.html',
        controller: 'DetailProjectCtrl',
        resolve: {
          visitorIdsForDM: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.getVisitorIdsForDM({
              projectId: $stateParams.projectId
            });
          }]
        }
      }
    }
  }).state('admin.projects.analytics', {
    url: '/analytics',
    views: {
      'content@': {
        templateUrl: '/templates/projects.analytics/views/show.html',
        controller: 'AnalyticsProjectCtrl'
      }
    }
  }).state('admin.projects.iw', {
    abstract: true,
    url: '/iw'
  }).state('admin.projects.iw.report', {
    url: '/report',
    views: {
      "content@": {
        template: '<zc-iw-report project="$resolve.currentProject"></zc-iw-report>'
      }
    }
  }).state('admin.projects.iw.items', {
    url: '/items',
    views: {
      "content@": {
        template: '<zc-iw-items project="$resolve.currentProject"></zc-iw-items>'
      }
    }
  }).state('admin.projects.site_report', {
    abstract: true,
    url: '/site_report'
  }).state('admin.projects.site_report.summary', {
    url: '/summary/:month',
    views: {
      "content@": {
        template: '<zc-summary-site-report project="$resolve.currentProject"></zc-summary-site-report>'
      }
    }
  }).state('admin.projects.images', {
    url: '/images',
    views: {
      'content@': {
        templateUrl: '/templates/projects/views/images/index.html',
        controller: 'ImagesCtrl',
        resolve: {
          images: ["Image", "$stateParams", function(Image, $stateParams) {
            return Image.all({
              projectId: $stateParams.projectId
            });
          }]
        }
      }
    }
  }).state('admin.projects.maintenance', {
    url: '/maintenance',
    views: {
      'mainnav@': {
        templateUrl: '/templates/projects/views/maintenance.html',
        controller: 'MainnavCtrl'
      }
    },
    resolve: {
      currentProject: ["Project", "$stateParams", function(Project, $stateParams) {
        return Project.getCurrent($stateParams.projectId);
      }]
    }
  });
}]);


/***/ }),
/* 1286 */
/***/ (function(module, exports) {

angular.module('zc.projects').factory('Chart', ["chartConfig", function(chartConfig) {
  var factory;
  factory = {
    getChartConfig: function(name, defaultVal) {
      var chart;
      if (defaultVal == null) {
        defaultVal = {};
      }
      if (!chartConfig[name]) {
        chart = $.extend(true, defaultVal, chartConfig['base']);
        chart.options = {
          chart: {
            type: name
          }
        };
        return chart;
      }
      return $.extend(true, defaultVal, chartConfig[name]);
    },
    addSeries: function(chartOptions, data) {
      return chartOptions.series.push(data);
    }
  };
  return factory;
}]);


/***/ }),
/* 1287 */
/***/ (function(module, exports) {

angular.module('zc.users.pages').directive('zcFooterLinks', ["$stateParams", "$rootScope", "$translate", "Project", "Environment", function($stateParams, $rootScope, $translate, Project, Environment) {
  return {
    restrict: 'E',
    templateUrl: '/templates/users.pages/views/directives/footer_links.html'
  };
}]);


/***/ }),
/* 1288 */
/***/ (function(module, exports) {

angular.module('zc.users.pages').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('users.pricing', {
    url: '/pricing',
    views: {
      'content@': {
        templateUrl: '/templates/users.pages/views/pricing.html'
      }
    }
  });
}]);


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('EditUserCtrl', ["$scope", "$stateParams", "$translate", "Environment", "Page", "Devise", "user", function($scope, $stateParams, $translate, Environment, Page, Devise, user) {
  Page.setBodyClass('');
  $translate('users.controllers.editController.updateUserInformation').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.availableLanguages = $translate.getAvailableLanguageKeys();
  $scope.user = {
    full_name: user.full_name,
    email: user.email,
    lang: user.lang
  };
  $scope.isSaving = false;
  return $scope.save = function(user) {
    $scope.isSaving = true;
    return Devise.updateInfo(user)["finally"](function() {
      $scope.isSaving = false;
      return $scope.form.$setPristine();
    });
  };
}]);


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('AcceptUserInvitationCtrl', ["$rootScope", "$scope", "$state", "$translate", "Devise", "Page", "afterLoginHandler", "user", function($rootScope, $scope, $state, $translate, Devise, Page, afterLoginHandler, user) {
  var deregistrationCallback;
  Page.setBodyClass('');
  $translate.use(user.lang);
  $translate('users.controllers.invitation.accept').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.user = user;
  $scope.isAgreeToTosAndPrivacyPolicy = false;
  deregistrationCallback = $rootScope.$on('languageSelected', function(_, selectedLanguage) {
    $scope.selectedLanguage = selectedLanguage;
    return user.lang = selectedLanguage;
  });
  $rootScope.$on('$destroy', deregistrationCallback);
  return $scope.submit = function(user) {
    if (!$scope.isAgreeToTosAndPrivacyPolicy) {
      return;
    }
    return Devise.accept(user).then(function(user) {
      return Devise.signAgreements(user);
    }).then(function(user) {
      return afterLoginHandler.handle(user);
    });
  };
}]);


/***/ }),
/* 1291 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('EditUserPasswordCtrl', ["$scope", "$stateParams", "$translate", "Page", "Devise", function($scope, $stateParams, $translate, Page, Devise) {
  Page.setBodyClass('');
  $translate('users.controllers.password.editPassword').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.user = {
    current_password: '',
    password: '',
    password_confirmation: ''
  };
  $scope.isSaving = false;
  return $scope.save = function(user) {
    $scope.isSaving = true;
    if ($scope.user.password !== $scope.user.password_confirmation) {
      alertify.error($translate.instant('users.controllers.password.passwordMismatch'));
      $scope.isSaving = false;
      $scope.form.$setPristine();
      return;
    }
    return Devise.updatePassword(user.current_password, user.password, user.password_confirmation).then(function() {
      return $scope.user = {};
    })["finally"](function() {
      $scope.isSaving = false;
      return $scope.form.$setPristine();
    });
  };
}]);


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('ForgotUserPasswordCtrl', ["$scope", "$translate", "Page", "Devise", function($scope, $translate, Page, Devise) {
  $translate('users.controllers.password.resetPassword').then(function(translation) {
    return Page.setTitle(translation);
  });
  Page.setBodyClass('account-bg');
  return $scope.submit = function(user) {
    return Devise.password(user.email);
  };
}]);


/***/ }),
/* 1293 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('ResetUserPasswordCtrl', ["$scope", "$state", "$translate", "$stateParams", "Page", "Devise", "Project", function($scope, $state, $translate, $stateParams, Page, Devise, Project) {
  $translate('users.controllers.password.resetPassword').then(function(translation) {
    return Page.setTitle(translation);
  });
  Page.setBodyClass('account-bg');
  return $scope.submit = function(user) {
    var reset_password_token;
    reset_password_token = $('meta[name="reset_password_token"]').attr('content');
    if (reset_password_token) {
      return Devise.resetPassword(reset_password_token, user.password, user.password_confirmation).then(function(res) {
        return $state.go('admin.home');
      });
    } else {
      return Devise.resetPassword($stateParams.reset_password_token, user.password, user.password_confirmation).then(function(res) {
        return Devise.signIn(res.email, user.password, true);
      }).then(function() {
        return $state.go('admin.home');
      });
    }
  };
}]);


/***/ }),
/* 1294 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('UsersSignInCtrl', ["$scope", "$state", "$translate", "Page", "Devise", "Project", "afterLoginHandler", "localStorageService", "$window", "$location", "returnUrl", function($scope, $state, $translate, Page, Devise, Project, afterLoginHandler, localStorageService, $window, $location, returnUrl) {
  $scope.user = {
    email: "",
    password: "",
    remember_me: true
  };
  $scope.enableAuth0 = $window.ZC_CONFIG.ENABLE_AUTH0;
  $scope.$on('$locationChangeSuccess', function(a) {
    if (Devise.currentUser !== void 0 && $window.location.pathname === '/users/sign_in') {
      localStorageService.clearAll();
      return $window.location.reload();
    }
  });
  $translate('users.controllers.signInController.login').then(function(translation) {
    return Page.setTitle(translation);
  });
  Page.setBodyClass('account-bg');
  return $scope.login = function(user) {
    return Devise.signIn(user.email, user.password, user.remember_me).then(function(res) {
      return afterLoginHandler.handle(res);
    });
  };
}]);


/***/ }),
/* 1295 */
/***/ (function(module, exports) {

angular.module('zc.users').directive('languageSelectHeader', ["$location", "$rootScope", "$state", "$translate", "$window", "Devise", function($location, $rootScope, $state, $translate, $window, Devise) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {},
    replace: true,
    templateUrl: '/templates/users/views/directives/language_select_header.html',
    link: function(scope, element, attrs) {
      scope.availableLanguages = $translate.getAvailableLanguageKeys();
      scope.getLanguageLabel = function(lang, forceLanguage) {
        if (!lang) {
          lang = $translate.use();
        }
        return $translate.instant("sharedModules.common.i18n.code." + lang, {}, void 0, forceLanguage);
      };
      scope.setLanguage = function(lang) {
        $translate.use(lang);
        $rootScope.$emit('languageSelected', lang);
        return $window.document.documentElement.lang = lang;
      };
      return Devise.getCurrentUserLanguage().then(function(currentUserLanguage) {
        var languageId;
        languageId = $location.search().lang || currentUserLanguage || $translate.preferredLanguage();
        return scope.setLanguage(languageId);
      });
    }
  };
  return directive;
}]);


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

angular.module('zc.users').directive('zcMasterOnly', ["Devise", function(Devise) {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      return Devise.getCurrentUser().then(function(user) {
        if (!user || !Devise.isMaster()) {
          return elem.css({
            display: 'none'
          });
        }
      });
    }
  };
}]);


/***/ }),
/* 1297 */
/***/ (function(module, exports) {

angular.module('zc.users').directive('userMenu', ["$state", "Agency", "Devise", "Project", function($state, Agency, Devise, Project) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {
      logoutOnly: "="
    },
    replace: true,
    templateUrl: '/templates/users/views/directives/user_menu.html',
    link: function(scope, element, attrs) {
      scope.Devise = Devise;
      scope.Project = Project;
      scope.agency = null;
      Agency.all().then(function(agencies) {
        return scope.agency = agencies[0];
      });
      attrs.$observe("logoutOnly", function() {
        return scope.logoutOnly = scope.$eval(attrs.logoutOnly);
      });
      scope.$watch("Project.currentProject", function(newVal, oldVal) {
        if (newVal) {
          return scope.projectId = newVal.id;
        }
      });
      Devise.getCurrentUser().then(function(res) {
        return scope.currentUser = res;
      });
      return scope.signOut = Devise.signOut;
    }
  };
  return directive;
}]);


/***/ }),
/* 1298 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('InquiryCtrl', ["$scope", "$stateParams", "$translate", "Page", "Inquiry", "reasons", function($scope, $stateParams, $translate, Page, Inquiry, reasons) {
  $scope.projectId = $stateParams.projectId;
  Page.setBodyClass('');
  $translate('users.inquiryController.contact').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.reasons = reasons;
  $scope.isSaving = false;
  return $scope.submit = function(inquiry) {
    $scope.isSaving = true;
    return Inquiry.create($scope.projectId, inquiry.message, inquiry.reason)["finally"](function() {
      $scope.isSaving = false;
      return $scope.form.$setPristine();
    });
  };
}]);


/***/ }),
/* 1299 */
/***/ (function(module, exports) {

angular.module('zc.users').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('users', {
    abstract: true,
    url: '/users',
    views: {
      'header@': {
        templateUrl: '/templates/users/views/devise_header.html'
      }
    }
  }).state('users.signIn', {
    url: '/sign_in',
    views: {
      'content@': {
        templateUrl: '/templates/users/views/sign_in.html',
        controller: 'UsersSignInCtrl'
      }
    }
  }).state('users.password', {
    abstract: true,
    url: '/password'
  }).state('users.password.forgot', {
    url: '/new',
    views: {
      'content@': {
        templateUrl: '/templates/users/views/password/forgot.html',
        controller: 'ForgotUserPasswordCtrl'
      }
    }
  }).state('users.password.reset', {
    url: '/edit?reset_password_token',
    views: {
      'content@': {
        templateUrl: '/templates/users/views/password/reset.html',
        controller: 'ResetUserPasswordCtrl'
      }
    }
  }).state('users.invitation', {
    abstract: true,
    url: '/invitation'
  }).state('users.invitation.accept', {
    url: '/accept?invitation_token',
    views: {
      'content@': {
        templateUrl: '/templates/users/views/invitation/accept.html',
        controller: 'AcceptUserInvitationCtrl'
      }
    },
    resolve: {
      user: ["$stateParams", "Devise", function($stateParams, Devise) {
        return Devise.validateInvitationToken($stateParams.invitation_token).then(function(user) {
          Devise.currentUser = user;
          return user;
        });
      }]
    }
  }).state('admin', {
    abstract: true,
    url: '/admin',
    views: {
      'header@': {
        templateUrl: '/templates/core/views/admin_header.html',
        controller: 'AdminHeaderCtrl'
      },
      'mainnav@': {
        template: ''
      }
    },
    resolve: {
      currentUser: ["Devise", function(Devise) {
        return Devise.getCurrentUser();
      }]
    }
  }).state('admin.users', {
    url: '/users',
    abstract: true
  }).state('admin.users.inquiry', {
    url: '/inquiry',
    views: {
      'content@': {
        templateUrl: '/templates/users/inquiry.html',
        controller: 'InquiryCtrl',
        resolve: {
          reasons: ["Inquiry", function(Inquiry) {
            return Inquiry.getReasons();
          }]
        }
      }
    }
  }).state('admin.users.edit', {
    url: '/edit',
    views: {
      'content@': {
        templateUrl: '/templates/users/views/edit.html',
        controller: 'EditUserCtrl',
        resolve: {
          user: ["Devise", function(Devise) {
            return Devise.getCurrentUser();
          }]
        }
      }
    }
  }).state('admin.users.password', {
    url: '/password',
    abstract: true
  }).state('admin.users.password.edit', {
    url: '/edit',
    views: {
      'content@': {
        templateUrl: '/templates/users/views/password/edit.html',
        controller: 'EditUserPasswordCtrl'
      }
    }
  });
}]);


/***/ }),
/* 1300 */
/***/ (function(module, exports) {

angular.module('zc.users').factory('Devise', ["$q", "$injector", "$location", "$translate", "$window", "$http", "Api", "returnUrl", function($q, $injector, $location, $translate, $window, $http, Api, returnUrl) {
  var service;
  service = {
    currentUser: void 0,
    signIn: function(email, password, remember_me) {
      return Api.post('/users/sign_in', {
        user: {
          email: email,
          password: password,
          remember_me: remember_me
        }
      }).then(function(res) {
        if (res.data.success) {
          $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken;
          service.currentUser = res.data.user;
          return service.currentUser;
        } else {
          alertify.error($translate.instant('users.services.deviseService.loginError'), 0);
          return $q.reject(res);
        }
      });
    },
    signOut: function() {
      if ($window.ZC_CONFIG.ENABLE_AUTH0) {
        service.currentUser = null;
        return $window.location.href = Api.basePath + "/users/auth/logout?origin=" + $window.location.origin + "/users/sign_in";
      } else {
        return Api["delete"]('/users/sign_out').then(function(res) {
          $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken;
          service.currentUser = null;
          return $window.location = '/users/sign_in';
        });
      }
    },
    updateInfo: function(user) {
      return Api.patch("/api/users/update_info", user).then(function(res) {
        var safeData;
        $translate.use(res.data.user.lang);
        moment.locale(res.data.user.lang);
        safeData = _.omit(res.data.user, ['login_token']);
        service.currentUser = _.merge(service.currentUser, safeData);
        return service.currentUser;
      });
    },
    password: function(email) {
      var NotificationChannel, d;
      NotificationChannel = $injector.get("NotificationChannel");
      NotificationChannel.requestStarted();
      d = $q.defer();
      Api.post('/users/password', {
        user: {
          email: email
        },
        locale: $translate.use()
      }).then(function(res) {
        service.currentUser = res.data.user;
        return d.resolve(service.currentUser);
      });
      return d.promise;
    },
    resetPassword: function(reset_password_token, password, password_confirmation) {
      return Api.put('/users/password', {
        user: {
          password: password,
          password_confirmation: password_confirmation,
          reset_password_token: reset_password_token
        },
        locale: $translate.use()
      }).then(function(res) {
        service.currentUser = res.data.user;
        return service.currentUser;
      });
    },
    updatePassword: function(current_password, password, password_confirmation) {
      var NotificationChannel, d;
      NotificationChannel = $injector.get("NotificationChannel");
      NotificationChannel.requestStarted();
      d = $q.defer();
      Api.patch("/api/users/update_password", {
        user: {
          current_password: current_password,
          password: password,
          password_confirmation: password_confirmation
        }
      }).then(function(res) {
        service.currentUser = res.data.user;
        return d.resolve(service.currentUser);
      }, function(res) {
        var err_cnt;
        err_cnt = _.reduce(res.data.errors, function(cnt, errors) {
          return cnt + errors.length;
        }, 0);
        if (err_cnt === 0) {
          alertify.error($translate.instant('users.services.deviseService.incorrectPassword'));
        }
        return d.reject(res);
      });
      return d.promise;
    },
    validateInvitationToken: function(invitation_token) {
      return Api.get("/users/invitation/accept?invitation_token=" + invitation_token).then(function(res) {
        var ref;
        if (res.data) {
          res.data.user.invitation_token = invitation_token;
        }
        return (ref = res.data) != null ? ref.user : void 0;
      });
    },
    accept: function(user) {
      return Api.patch("/users/invitation", {
        user: {
          full_name: user.full_name,
          email: user.email,
          password: user.password,
          password_confirmation: user.password_confirmation,
          invitation_token: user.invitation_token,
          lang: user.lang
        },
        locale: user.lang
      }).then(function(res) {
        return service.signIn(user.email, user.password, true);
      });
    },
    invite: function(email) {
      var NotificationChannel, d;
      NotificationChannel = $injector.get("NotificationChannel");
      NotificationChannel.requestStarted();
      d = $q.defer();
      Api.post('/users/invitation', email).then(function(res) {
        return d.resolve(res.result);
      });
      return d.promise;
    },
    become: function(user) {
      return Api.post("/api/master/users/" + user.id + "/become").then(function(res) {
        if (res.data.success) {
          return $window.location = '/users/sign_in';
        }
      });
    },
    getCurrentUserLanguage: function() {
      if (service.isAuthenticated()) {
        return $q.when(service.currentUser.lang);
      }
      return Api.get('/users/show_current', {}).then(function(res) {
        return _.get(res, 'data.user.lang');
      });
    },
    getCurrentUser: function(opts) {
      var promise;
      if (opts == null) {
        opts = {};
      }
      if (service.isAuthenticated() && !opts.force) {
        return $q.when(service.currentUser);
      } else {
        if (opts.force) {
          promise = Api.get("/users/show_current", {}, {
            cache: false,
            isPreflight: opts.isPreflight
          });
        } else {
          promise = Api.get("/users/show_current", {}, {
            isPreflight: opts.isPreflight
          });
        }
        return promise.then(function(res) {
          if (!res.data.success) {
            if ($window.ZC_CONFIG.ENABLE_AUTH0) {
              $window.location.href = Api.basePath + "/users/auth/login?origin=" + $window.location.href;
              return;
            }
            if (!($location.path() === "/users/sign_in" || $location.path() === "/users/password/new")) {
              returnUrl.set($location.path());
              $location.path("/users/sign_in");
            }
            return $q.reject(null);
          } else {
            $translate.use(res.data.user.lang);
            $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken;
            service.currentUser = res.data.user;
            return res.data.user;
          }
        })["catch"](function(err) {
          return $q.reject(null);
        });
      }
    },
    isAuthenticated: function() {
      return !!service.currentUser;
    },
    isCommonUser: function() {
      var ref;
      return ((ref = service.currentUser) != null ? ref.role : void 0) === 'common';
    },
    isMaster: function() {
      var ref;
      return ((ref = service.currentUser) != null ? ref.role : void 0) === 'master';
    },
    isInternalUser: function() {
      var ref;
      return ((ref = service.currentUser) != null ? ref.role : void 0) === 'internal';
    },
    signAgreements: function(user) {
      return Api.patch("/api/users/" + user.id + "/sign_agreements").then(function(res) {
        var safeData;
        safeData = _.omit(res.data.user, ['login_token']);
        service.currentUser = _.merge(service.currentUser, safeData);
        return service.currentUser;
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1301 */
/***/ (function(module, exports) {

angular.module('zc.users').controller('UserSidebarCtrl', ["$scope", "$state", "Devise", function($scope, $state, Devise) {
  $scope.Devise = Devise;
  return $scope.isActive = function(menu) {
    return _.startsWith($state.current.name, menu);
  };
}]);


/***/ }),
/* 1302 */
/***/ (function(module, exports) {

angular.module('zc.master').controller('MasterAgenciesEditCtrl', ["$scope", "$state", "$translate", "Page", "MasterAgency", "agency", "users", "shoppingCartAsps", "invoiceCalculationTypes", "invoiceIssueDays", "invoicePaymentDays", "invoicePaymentMonths", "salesEntities", function($scope, $state, $translate, Page, MasterAgency, agency, users, shoppingCartAsps, invoiceCalculationTypes, invoiceIssueDays, invoicePaymentDays, invoicePaymentMonths, salesEntities) {
  Page.setBodyClass('');
  $translate('masterAgencies.edit.editAgencies').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.agency = agency;
  $scope.shoppingCartAsps = shoppingCartAsps;
  $scope.invoiceCalculationTypes = invoiceCalculationTypes;
  $scope.invoiceIssueDays = invoiceIssueDays;
  $scope.invoicePaymentDays = invoicePaymentDays;
  $scope.invoicePaymentMonths = invoicePaymentMonths;
  $scope.salesEntities = salesEntities;
  $scope.users = users;
  return $scope.save = function(agency) {
    var promise;
    if (agency.id) {
      promise = MasterAgency.update(agency);
    } else {
      promise = MasterAgency.create(agency);
    }
    return promise.then(function() {
      return $state.go('admin.master.agencies');
    });
  };
}]);


/***/ }),
/* 1303 */
/***/ (function(module, exports) {

angular.module('zc.master').controller('MasterAgenciesCtrl', ["$scope", "$translate", "Page", "agencies", function($scope, $translate, Page, agencies) {
  Page.setBodyClass('');
  $translate('masterAgencies.list.agenciesList').then(function(translation) {
    return Page.setTitle(translation);
  });
  return $scope.agencies = agencies;
}]);


/***/ }),
/* 1304 */
/***/ (function(module, exports) {

angular.module('zc.master').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.agencies', {
    url: '/agencies',
    views: {
      'content@': {
        templateUrl: '/templates/master.agencies/list.html',
        controller: 'MasterAgenciesCtrl',
        resolve: {
          agencies: ["MasterAgency", function(MasterAgency) {
            return MasterAgency.all();
          }]
        }
      }
    }
  }).state('admin.master.agencies.new', {
    url: '/new',
    views: {
      'content@': {
        templateUrl: '/templates/master.agencies/edit.html',
        controller: 'MasterAgenciesEditCtrl',
        resolve: {
          shoppingCartAsps: ["Meta", function(Meta) {
            return Meta.getShoppingCartAsps();
          }],
          invoiceCalculationTypes: ["Meta", function(Meta) {
            return Meta.getInvoiceCalculationTypes();
          }],
          invoiceIssueDays: ["Meta", function(Meta) {
            return Meta.getInvoiceIssueDays();
          }],
          invoicePaymentDays: ["Meta", function(Meta) {
            return Meta.getInvoicePaymentDays();
          }],
          invoicePaymentMonths: ["Meta", function(Meta) {
            return Meta.getInvoicePaymentMonths();
          }],
          salesEntities: ["Meta", function(Meta) {
            return Meta.getSalesEntities();
          }],
          agency: function() {
            return {
              sales_entity: 'appier_jp',
              is_invoice_automated: true
            };
          },
          users: function() {
            return [];
          }
        }
      }
    }
  }).state('admin.master.agencies.edit', {
    url: '/{id:int}/edit',
    views: {
      'content@': {
        templateUrl: '/templates/master.agencies/edit.html',
        controller: 'MasterAgenciesEditCtrl',
        resolve: {
          shoppingCartAsps: ["Meta", function(Meta) {
            return Meta.getShoppingCartAsps();
          }],
          invoiceCalculationTypes: ["Meta", function(Meta) {
            return Meta.getInvoiceCalculationTypes();
          }],
          invoiceIssueDays: ["Meta", function(Meta) {
            return Meta.getInvoiceIssueDays();
          }],
          invoicePaymentDays: ["Meta", function(Meta) {
            return Meta.getInvoicePaymentDays();
          }],
          invoicePaymentMonths: ["Meta", function(Meta) {
            return Meta.getInvoicePaymentMonths();
          }],
          salesEntities: ["Meta", function(Meta) {
            return Meta.getSalesEntities();
          }],
          agency: ["MasterAgency", "$stateParams", function(MasterAgency, $stateParams) {
            return MasterAgency.get({
              id: $stateParams.id
            });
          }],
          users: ["$stateParams", "MasterAgencyUser", function($stateParams, MasterAgencyUser) {
            return MasterAgencyUser.all($stateParams.id);
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1305 */
/***/ (function(module, exports) {

angular.module('zc.master.campaigns').factory("DataScriptCampaignResults", ["$q", "FacadeV2", function($q, FacadeV2) {
  var DataScriptCampaignResults;
  return DataScriptCampaignResults = (function() {
    function DataScriptCampaignResults(dimension) {
      this.dimension = dimension;
    }

    DataScriptCampaignResults.prototype.find = function(params) {
      var d;
      d = $q.defer();
      FacadeV2.request("/master/data_script_campaign_results/daily", {
        "params": params
      }).then((function(_this) {
        return function(res) {
          if (res.status !== 200) {
            return reject("failed");
          }
          return d.resolve(res.data);
        };
      })(this));
      return d.promise;
    };

    return DataScriptCampaignResults;

  })();
}]);


/***/ }),
/* 1306 */
/***/ (function(module, exports) {

angular.module('zc.master.campaigns').controller('MasterCampaignsCtrl', ["$filter", "$q", "$sce", "$scope", "$timeout", "$translate", "Page", "Campaign", "DataScriptCampaignResults", "AccessStats", "MasterCampaign", "MasterCampaignStats", "SearchFilter", "templates", "currentUser", "lib", function($filter, $q, $sce, $scope, $timeout, $translate, Page, Campaign, DataScriptCampaignResults, AccessStats, MasterCampaign, MasterCampaignStats, SearchFilter, templates, currentUser, lib) {
  var calculateAll, calculateLastHour, calculateSegments, calculateStats, calculateTotals, fetchStolenCVRates, filterByCurrentStatus, filterByIsWidget, filterByProductLine, filterByUser;
  Page.setBodyClass('');
  $translate('masterCampaigns.list.campaignList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.campaigns = [];
  $scope.filteredCampaigns = [];
  $scope.pagedCampaigns = [];
  $scope.pagination = {
    itemsPerPage: 30,
    currentPage: 1
  };
  $scope.previousFilters = {};
  $scope.filters = SearchFilter.resolveFromLocation();
  SearchFilter.setComponentDefaults('masterCampaignList', {
    visible_group: {
      "default": 'stats'
    },
    campaign_scope: {
      "default": 'active'
    },
    product_line: {
      "default": 'all'
    },
    sort_prop: {
      "default": 'start_at'
    },
    sort_direction: {
      "default": 'asc'
    },
    assigned: {
      "default": false
    },
    is_widget: {
      "default": false
    }
  });
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterCampaignList');
  });
  $scope.fromNow = function(end_at) {
    return moment(end_at).fromNow(true);
  };
  $scope.getCampaigns = function() {
    SearchFilter.set($scope.filters);
    return MasterCampaign.all({
      start_at: moment($scope.filters.start_at).valueOf(),
      end_at: moment($scope.filters.end_at).add(1, 'day').valueOf()
    }).then(function(campaigns) {
      $scope.campaigns = campaigns;
      $scope.filterCampaigns();
      return $scope.previousFilters = _.merge({}, $scope.filters);
    });
  };
  $scope.getCampaigns();
  $scope.pageChanged = function() {
    var begin;
    begin = $scope.pagination.itemsPerPage * ($scope.pagination.currentPage - 1);
    return $scope.pagedCampaigns = _.filter($scope.filteredCampaigns, function(campaign, i) {
      return (begin <= i && i < begin + $scope.pagination.itemsPerPage);
    });
  };
  $scope.getTemplate = function(template) {
    var res;
    res = _.filter(templates, function(t) {
      return t.name === template;
    });
    return res[0].template;
  };
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction = 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterCampaigns();
  };
  $scope.setVisibleGroup = function(visibleGroup) {
    $scope.filters.visible_group = visibleGroup;
    if ($scope.filters.visible_group === 'segment') {
      calculateSegments();
    }
    return SearchFilter.updateComponentDefaults('masterCampaignList');
  };
  $scope.saveCampaign = function(campaign) {
    return Campaign.update({
      projectId: campaign.project_id,
      campaignId: campaign.id
    }, campaign).then(function(res) {
      return _.merge(campaign, res.campaign);
    });
  };
  $scope.filterClicked = function() {
    if ($scope.filters.start_at !== $scope.previousFilters.start_at || $scope.filters.end_at !== $scope.previousFilters.end_at) {
      return $scope.getCampaigns();
    } else {
      return $scope.filterCampaigns();
    }
  };
  $scope.filterCampaigns = function() {
    var promises, sortDirectionReverse;
    sortDirectionReverse = $scope.filters.sort_direction === 'desc';
    $scope.filteredCampaigns = filterByProductLine($scope.campaigns, $scope.filters.product_line);
    $scope.filteredCampaigns = filterByCurrentStatus($scope.filteredCampaigns, $scope.filters.campaign_scope);
    if ($scope.filters.assigned) {
      $scope.filteredCampaigns = filterByUser($scope.filteredCampaigns);
    }
    if ($scope.filters.is_widget) {
      $scope.filteredCampaigns = filterByIsWidget($scope.filteredCampaigns);
    }
    $scope.filteredCampaigns = $filter('campaignText')($scope.filteredCampaigns, $scope.filters.search_term);
    promises = [];
    if ($scope.visibleGroup === 'analytics') {
      promises.push(calculateSegments());
    } else if ($scope.filters.visible_group === 'stats') {
      promises.push(calculateStats());
    }
    return $q.all(promises).then(function() {
      $scope.filteredCampaigns = $filter('orderBy')($scope.filteredCampaigns, $scope.filters.sort_prop, sortDirectionReverse);
      $scope.filteredCampaigns = $filter('emptyToEnd')($scope.filteredCampaigns, $scope.filters.sort_prop, sortDirectionReverse);
      $scope.pagination.currentPage = 1;
      $scope.pageChanged();
      SearchFilter.set($scope.filters);
      return SearchFilter.updateComponentDefaults('masterCampaignList');
    });
  };
  $scope.resetSearchTerm = function() {
    $scope.filters.search_term = "";
    return $scope.filterCampaigns();
  };
  filterByCurrentStatus = function(campaigns, campaignScope) {
    return _.filter(campaigns, function(campaign) {
      var ref;
      switch (campaignScope) {
        case 'active':
          return (ref = campaign.current_status) === 'active' || ref === 'pending';
        case 'preview':
          return campaign.current_status === 'preview';
        case 'incomplete':
          return campaign.current_status === 'incomplete';
        default:
          return true;
      }
    });
  };
  filterByProductLine = function(campaigns, productLine) {
    return _.filter(campaigns, function(campaign) {
      if (productLine === 'all') {
        return true;
      }
      return campaign.project_product_line === productLine;
    });
  };
  filterByUser = function(campaigns) {
    if (typeof assigned !== "undefined" && assigned !== null) {
      return _.filter(campaigns, function(campaign) {
        var j, len, ref, user;
        ref = campaign.project_users;
        for (j = 0, len = ref.length; j < len; j++) {
          user = ref[j];
          if (user.id === currentUser.id) {
            return true;
          }
        }
      });
    }
  };
  filterByIsWidget = function(campaigns) {
    return _.filter(campaigns, function(campaign) {
      if (campaign.is_widget) {
        return true;
      }
    });
  };
  calculateStats = function() {
    var campaign, campaignIds;
    campaignIds = (function() {
      var j, len, ref, results;
      ref = $scope.filteredCampaigns;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        campaign = ref[j];
        results.push(campaign.id);
      }
      return results;
    })();
    return $q.all([calculateAll(campaignIds), calculateLastHour(campaignIds), fetchStolenCVRates(campaignIds)]).then(function(arg) {
      var campaign_stats, j, lastStatsById, last_campaign_stats, len, ref, statsById, stolen_conversion_rates;
      campaign_stats = arg[0], last_campaign_stats = arg[1], stolen_conversion_rates = arg[2];
      statsById = MasterCampaignStats.statsById(campaign_stats);
      lastStatsById = MasterCampaignStats.statsById(last_campaign_stats);
      ref = $scope.filteredCampaigns;
      for (j = 0, len = ref.length; j < len; j++) {
        campaign = ref[j];
        campaign.stats = statsById[campaign.id];
        campaign.stolen_conversion_rate = stolen_conversion_rates[campaign.id];
        campaign.last_stats = lastStatsById[campaign.id];
        if (campaign.stats) {
          MasterCampaignStats.calculate(campaign.stats);
          MasterCampaignStats.chisq(campaign.stats, campaign.control_percent);
        }
      }
      return calculateTotals();
    }).then(function(totals) {
      return calculateSegments();
    }).then(function(totals) {
      var i, j, len, ref, ref1, ref2, ref3, ref4, ref5, ref6, results;
      ref = $scope.filteredCampaigns;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        campaign = ref[i];
        if (!((ref1 = campaign.total_stats) != null ? ref1.session_count : void 0)) {
          campaign.segment_cover_percentage = 0;
          campaign.experimental_delivery_percentage = 0;
        } else {
          campaign.segment_cover_percentage = (campaign.access_stats.session_count || 0) / campaign.total_stats.session_count * 100;
          campaign.experimental_delivery_percentage = (((ref2 = campaign.stats) != null ? (ref3 = ref2.experimental) != null ? ref3.delivery_count : void 0 : void 0) || 0) / campaign.total_stats.session_count * 100;
        }
        if (!((ref4 = campaign.total_stats) != null ? ref4.conversion_price : void 0)) {
          results.push(campaign.experimental_conversion_price_percentage = 0);
        } else {
          results.push(campaign.experimental_conversion_price_percentage = (((ref5 = campaign.stats) != null ? (ref6 = ref5.experimental) != null ? ref6.conversion_price : void 0 : void 0) || 0) / campaign.total_stats.conversion_price * 100);
        }
      }
      return results;
    });
  };
  calculateAll = function(campaignIds) {
    var masterCampaignStats;
    masterCampaignStats = new MasterCampaignStats('daily');
    return masterCampaignStats.aggregate({
      campaign_ids: campaignIds,
      start_at: $scope.filters.start_at,
      end_at: moment($scope.filters.end_at).add(1, 'day').valueOf()
    });
  };
  calculateLastHour = function(campaignIds) {
    var masterCampaignStats;
    masterCampaignStats = new MasterCampaignStats('hourly');
    return masterCampaignStats.find({
      campaign_ids: campaignIds,
      start_at: moment().subtract(3, "hours").startOf('hour').valueOf(),
      end_at: moment().subtract(3, "hours").endOf('hour').valueOf()
    });
  };
  fetchStolenCVRates = function(campaignIds) {
    var dataScriptCampaignResults;
    dataScriptCampaignResults = new DataScriptCampaignResults;
    return dataScriptCampaignResults.find({
      match: {
        name: "stolen_conversion_rate",
        campaign_id: {
          "$in": campaignIds
        },
        start_at: {
          "$gte": moment().startOf("day").subtract(14, "days").toDate()
        }
      },
      sort: {
        start_at: -1
      }
    }).then(function(params) {
      return _.chain(params).keyBy('campaign_id').mapValues(function(value) {
        if (Array.isArray(value)) {
          return _.maxBy(value, function(x) {
            return x.start_at;
          });
        } else {
          return value;
        }
      }).value();
    });
  };
  calculateTotals = function() {
    var campaign, promises;
    promises = (function() {
      var j, len, ref, results;
      ref = $scope.filteredCampaigns;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        campaign = ref[j];
        results.push(AccessStats.aggregateDefault({
          dimension: 'hourly',
          apikey: campaign.apikey
        }, {
          device: null,
          is_control: null,
          campaign_segment_id: null,
          start_at: {
            $gte: _.max([moment(campaign.start_at).toDate(), moment($scope.filters.start_at).toDate()]),
            $lt: _.min([moment(campaign.end_at).toDate(), moment($scope.filters.end_at).add(1, 'days').toDate()])
          }
        }));
      }
      return results;
    })();
    return $q.all(promises).then(function(access_stats) {
      var i, j, len, ref, ref1, results;
      ref = $scope.filteredCampaigns;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        campaign = ref[i];
        results.push(campaign.total_stats = (ref1 = access_stats[i]) != null ? ref1[0] : void 0);
      }
      return results;
    });
  };
  return calculateSegments = function() {
    var campaign, campaign_segment_id, device, promises;
    promises = (function() {
      var j, len, ref, ref1, results;
      ref = $scope.filteredCampaigns;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        campaign = ref[j];
        device = AccessStats.handleCampaignDevice(campaign.campaign_device);
        campaign_segment_id = ((ref1 = campaign.segment) != null ? ref1.id : void 0) || null;
        results.push(AccessStats.aggregateDefault({
          dimension: 'hourly',
          apikey: campaign.apikey
        }, {
          device: device,
          is_control: null,
          campaign_segment_id: campaign_segment_id,
          start_at: {
            $gte: _.max([moment(campaign.start_at).toDate(), moment($scope.filters.start_at).toDate()]),
            $lt: _.min([moment(campaign.end_at).toDate(), moment($scope.filters.end_at).add(1, 'days').toDate()])
          }
        }));
      }
      return results;
    })();
    return $q.all(promises).then(function(access_stats) {
      var i, j, len, ref, ref1, results;
      ref = $scope.filteredCampaigns;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        campaign = ref[i];
        results.push(campaign.access_stats = (ref1 = access_stats[i]) != null ? ref1[0] : void 0);
      }
      return results;
    });
  };
}]);


/***/ }),
/* 1307 */
/***/ (function(module, exports) {

angular.module('zc.master.campaigns').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.campaigns', {
    url: '/campaigns',
    views: {
      'content@': {
        templateUrl: '/templates/master.campaigns/list.html',
        controller: 'MasterCampaignsCtrl',
        resolve: {
          templates: ["Template", "$stateParams", function(Template, $stateParams) {
            return Template.all(1);
          }],
          currentUser: ["Devise", function(Devise) {
            return Devise.getCurrentUser();
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1308 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.master.projects').controller('MasterProjectsListCtrl', ["$filter", "$q", "$scope", "$translate", "Devise", "Page", "MasterProject", "ProjectStats", "currencies", "SearchFilter", function($filter, $q, $scope, $translate, Devise, Page, MasterProject, ProjectStats, currencies, SearchFilter) {
  var filterByProductLine, filterByProjectStatus;
  Page.setBodyClass('');
  $translate('masterProjects.list.siteList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.projects = [];
  $scope.filteredProjects = [];
  $scope.filters = SearchFilter.resolveFromLocation();
  $scope.filters.product_line = 'all';
  $scope.filters.contract_status = 'all';
  $scope.project_status = {
    all: $translate.instant('masterProjects.list.all'),
    before_trial: $translate.instant('masterProjects.list.beforeTrial'),
    trial: $translate.instant('masterProjects.list.trial'),
    terminated_after_trial: $translate.instant('masterProjects.list.terminatedAfterTrial'),
    contracted: $translate.instant('masterProjects.list.contracted'),
    terminated_after_contract: $translate.instant('masterProjects.list.terminatedAfterContract'),
    idle: $translate.instant('masterProjects.list.idle')
  };
  $scope.table = false;
  SearchFilter.setComponentDefaults('masterProjectsList', {
    visible_group: {
      "default": 'settings'
    },
    sort_prop: {
      "default": 'apikey'
    },
    sort_direction: {
      "default": 'desc'
    }
  });
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterProjectsList');
  });
  $scope.setVisibleGroup = function(visibleGroup) {
    $scope.filters.visible_group = visibleGroup;
    SearchFilter.updateComponentDefaults('masterProjectsList');
    return $scope.updateData();
  };
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction = 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterProjects();
  };
  $scope.filterProjects = function() {
    var sortDirectionReverse;
    sortDirectionReverse = $scope.filters.sort_direction === 'desc';
    $scope.filteredProjects = $filter("projectText")($scope.projects, $scope.filters.search_term);
    $scope.filteredProjects = filterByProductLine($scope.filteredProjects, $scope.filters.product_line);
    $scope.filteredProjects = filterByProjectStatus($scope.filteredProjects, $scope.filters.contract_status);
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse);
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse);
    SearchFilter.set($scope.filters);
    return SearchFilter.updateComponentDefaults('masterProjectsList');
  };
  $scope.updateData = function() {
    var apikeys;
    SearchFilter.set($scope.filters);
    apikeys = _.map($scope.projects, function(p) {
      return p.apikey;
    });
    if ($scope.filters.visible_group === "stats") {
      ProjectStats.getDailyProjectStats({
        apikey: {
          $in: apikeys
        },
        start_at: {
          $gte: moment($scope.filters.start_at).toDate(),
          $lt: moment($scope.filters.end_at).add(1, 'day').toDate()
        }
      }).then(function(res) {
        var i, len, project, ref;
        ref = $scope.projects;
        for (i = 0, len = ref.length; i < len; i++) {
          project = ref[i];
          project.stats = res[project.apikey];
        }
        return $scope.filterProjects();
      });
    } else {
      $scope.filterProjects();
    }
    return _.each($scope.projects, function(project) {
      return project.currencyObj = currencies[project.currency];
    });
  };
  $scope.checkIsAssignee = function(project) {
    var ref, user;
    return ref = Devise.currentUser.email, indexOf.call((function() {
      var i, len, ref1, results;
      ref1 = project.users;
      results = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        user = ref1[i];
        results.push(user.email);
      }
      return results;
    })(), ref) >= 0;
  };
  $scope.assignCurrentUser = function(project) {
    return MasterProject.assign({
      projectId: project.id
    }, {
      userId: Devise.currentUser.id
    }).then(function() {
      project.users.push(Devise.currentUser);
      return project.isAssignee = $scope.checkIsAssignee(project);
    });
  };
  $scope.unassignCurrentUser = function(project) {
    return MasterProject.unassign({
      projectId: project.id
    }, {
      userId: Devise.currentUser.id
    }).then(function() {
      _.remove(project.users, function(user) {
        return user.email === Devise.currentUser.email;
      });
      return project.isAssignee = $scope.checkIsAssignee(project);
    });
  };
  $q.when(MasterProject.all(), function(projects) {
    return $q.when(MasterProject.addInterestTreeStatus(projects), function(projects) {
      $scope.projects = projects;
      $scope.filterProjects();
      return $scope.updateData();
    });
  });
  filterByProductLine = function(projects, productLine) {
    return _.filter(projects, function(project) {
      if (productLine === 'all') {
        return true;
      }
      return project.product_line === productLine;
    });
  };
  filterByProjectStatus = function(projects, status) {
    return _.filter(projects, function(project) {
      if (status === 'all') {
        return true;
      }
      return project.contract_status === status;
    });
  };
  return $scope.resetSearchTerm = function() {
    $scope.filters.search_term = "";
    return $scope.filterProjects();
  };
}]);


/***/ }),
/* 1309 */
/***/ (function(module, exports) {

angular.module('zc.master.projects').controller('MasterCampaignSegmentDetailCtrl', ["$scope", "$state", "$stateParams", "$translate", "Page", "FacadeV2", "MasterCampaign", "Project", "CampaignSegment", "currentCampaign", "currentProject", function($scope, $state, $stateParams, $translate, Page, FacadeV2, MasterCampaign, Project, CampaignSegment, currentCampaign, currentProject) {
  Page.setBodyClass('');
  $translate('masterProjects.masterCampaignSegmentDetail.listDeliveryConditionSettings').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.currentCampaign = currentCampaign;
  $scope.currentProject = currentProject;
  $scope.tuneSmartRandom = function() {
    return Project.update({
      projectId: $scope.currentProject.id
    }, {
      project: $scope.currentProject
    }).then(function(project) {
      $scope.currentProject = project;
      return FacadeV2.request("/apikeys/" + $scope.currentProject.apikey + "/zcs_timings/generate_smart_random", {
        method: 'POST'
      });
    }).then(function(res) {
      if (res.success) {
        console.error("failed", res);
        return;
      }
      return MasterCampaign.get({
        projectId: $scope.currentProject.id,
        campaignId: $scope.currentCampaign.id
      }).then(function(campaign) {
        console.log(campaign);
        return $scope.currentCampaign = campaign;
      });
    });
  };
  return $scope.isOldCampaign = function() {
    return !$scope.currentCampaign.segment || $scope.currentCampaign.segment.segment_type === 'custom_old';
  };
}]);


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

angular.module('zc.master.projects').controller('MasterProjectsPoliciesCtrl', ["$scope", "$state", "$stateParams", "$translate", "Page", "currentProject", "campaignPolicySets", function($scope, $state, $stateParams, $translate, Page, currentProject, campaignPolicySets) {
  Page.setBodyClass('');
  $translate('masterProjects.masterProjectsPolicies.deliveryConfirmationScreen').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.headers = [];
  $scope.currentProject = currentProject;
  $scope.campaignPolicySets = campaignPolicySets;
  $scope.currentPolicySetId = parseInt($stateParams.campaignPolicySetId);
  if (isNaN($scope.currentPolicySetId)) {
    $scope.currentPolicySetId = void 0;
  }
  $scope.goto = function() {
    if (angular.isUndefined($scope.currentPolicySetId)) {
      return;
    }
    return $state.go('admin.master.projects.policies.show', {
      projectId: $scope.currentProject.id,
      campaignPolicySetId: $scope.currentPolicySetId
    });
  };
  $scope.updatePolicies = function() {
    $scope.currentPolicySet = _.chain($scope.campaignPolicySets).filter(function(s) {
      return s.id === $scope.currentPolicySetId;
    }).head().value();
    return $scope.headers = MasterCampaignPolicy.getRelevantHeaders($scope.currentCampaignPolicySet.campaign_policies);
  };
  if (angular.isDefined($scope.currentPolicySetId)) {
    $scope.currentPolicySet = _.chain($scope.campaignPolicySets).filter(function(s) {
      return s.id === $scope.currentPolicySetId;
    }).head().value();
    if ($scope.currentPolicySet) {
      return $scope.updatePolicies();
    }
  } else {
    return $scope.currentPolicySet = void 0;
  }
}]);


/***/ }),
/* 1311 */
/***/ (function(module, exports) {

angular.module('zc.master.projects').controller('MasterProjectsNewCtrl', ["$scope", "$state", "$translate", "Agency", "Page", "project", "Project", "productLines", "MasterProject", "currencies", "regions", "salesEntities", "pricingTypes", function($scope, $state, $translate, Agency, Page, project, Project, productLines, MasterProject, currencies, regions, salesEntities, pricingTypes) {
  var CLIENT_CHANNEL_PREFIX_LENGTH, DIRECT_SELLING_ID, MAXIMUM_APIKEY_LENGTH, MAX_CHANNEL_NAME_LENGTH, getHostname, isUrl, line, setExistingProjects;
  Page.setBodyClass('');
  $translate('masterProjects.new.newSite').then(function(translation) {
    return Page.setTitle(translation);
  });
  DIRECT_SELLING_ID = 5;
  $scope.directSellingAgencyId = DIRECT_SELLING_ID;
  MAX_CHANNEL_NAME_LENGTH = 21;
  CLIENT_CHANNEL_PREFIX_LENGTH = 2;
  MAXIMUM_APIKEY_LENGTH = MAX_CHANNEL_NAME_LENGTH - CLIENT_CHANNEL_PREFIX_LENGTH;
  isUrl = function(url) {
    var containHttpandDomainExpression;
    containHttpandDomainExpression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)?\/?/gi;
    return url.match(new RegExp(containHttpandDomainExpression));
  };
  getHostname = function(url) {
    return new URL(url).hostname.replace(/^www\./, '');
  };
  setExistingProjects = function() {
    var projectHostname;
    if ($scope.project.base_url && isUrl($scope.project.base_url)) {
      projectHostname = getHostname($scope.project.base_url);
      MasterProject.generateProjectApikey($scope.project.base_url).then(function(project_apikey) {
        return $scope.project.apikey = project_apikey;
      });
      return $scope.existingProjects = _.filter($scope.projects, function(project) {
        return projectHostname === project.hostname;
      });
    }
  };
  $scope.maximumApikeyLength = MAXIMUM_APIKEY_LENGTH;
  $scope.project = project;
  $scope.productLines = (function() {
    var i, len, results;
    results = [];
    for (i = 0, len = productLines.length; i < len; i++) {
      line = productLines[i];
      if (line.name !== 'zenclerk_s') {
        results.push(line);
      }
    }
    return results;
  })();
  Project.all().then(function(projects) {
    $scope.projects = _.map(projects, function(project) {
      return {
        id: project.id,
        title: project.title,
        apikey: project.apikey,
        base_url: project.base_url,
        hostname: project.base_url ? getHostname(project.base_url) : project.base_url
      };
    });
    return setExistingProjects();
  });
  Agency.all().then(function(agencies) {
    return $scope.agencies = _.sortBy(agencies, 'name');
  });
  $scope.control_percent = null;
  $scope.currencies = currencies;
  $scope.salesEntities = salesEntities;
  $scope.regions = regions;
  $scope.pricingTypes = pricingTypes;
  $scope.existingProjects = [];
  $scope.save = (function(_this) {
    return function(project) {
      if ($scope.control_percent) {
        _.merge(project, {
          pc_control_percent: $scope.control_percent,
          sp_control_percent: $scope.control_percent
        });
      }
      return MasterProject.create(project).then(function(res) {
        return $state.go('admin.projects.settings.users.invite', {
          projectId: res.id
        });
      });
    };
  })(this);
  $scope.$watch('project.product_line', function() {
    if ($scope.project.product_line !== 'zenclerk' && $scope.project.pricing_type === 'tiered') {
      return $scope.project.pricing_type = 'volume';
    }
  });
  $scope.updateApikey = function() {
    return setExistingProjects();
  };
  return $scope.$watch('project.currency', function() {
    return $scope.invoiceCurrencies = _.compact(_.uniq([$scope.project.currency, 'usd']));
  });
}]);


/***/ }),
/* 1312 */
/***/ (function(module, exports) {

angular.module('zc.master.projects').directive('zcProductLineLabel', function() {
  return {
    restrict: "E",
    template: "<span class=\"\" ng-if=\"project.product_line === 'zenclerk'\">{{ 'masterProjects.productLineLabel.zenclerk' | translate }}</span>\n<span class=\"\" ng-if=\"project.product_line === 'zenclerk_lp'\">{{ 'masterProjects.productLineLabel.lp' | translate }}</span>\n<span class=\"\" ng-if=\"project.product_line === 'zenclerk_s'\">{{ 'masterProjects.productLineLabel.lite' | translate }}</span>",
    scope: {
      project: "="
    },
    link: function(scope, elem, attrs) {}
  };
});


/***/ }),
/* 1313 */
/***/ (function(module, exports) {

angular.module('zc.master.projects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.projects', {
    url: '/projects',
    views: {
      'content@': {
        templateUrl: '/templates/master.projects/list.html',
        controller: 'MasterProjectsListCtrl'
      }
    }
  }).state('admin.master.projects.new', {
    url: '/new',
    views: {
      'content@': {
        templateUrl: '/templates/master.projects/new.html',
        controller: 'MasterProjectsNewCtrl',
        resolve: {
          productLines: ["Meta", function(Meta) {
            return Meta.getProductLines();
          }],
          project: function() {
            return {
              product_line: 'zenclerk',
              pricing_type: 'volume'
            };
          },
          currencies: ["Meta", function(Meta) {
            return Meta.getCurrencies();
          }],
          salesEntities: ["Meta", function(Meta) {
            return Meta.getSalesEntities();
          }],
          pricingTypes: ["Meta", function(Meta) {
            return Meta.getPricingTypes();
          }],
          regions: ["Meta", function(Meta) {
            return Meta.getRegions();
          }]
        }
      }
    }
  }).state('admin.master.projects.policies', {
    url: '/{projectId:int}/campaign_policy_sets',
    views: {
      'content@': {
        templateUrl: '/templates/master.projects/master_projects_policies.html',
        controller: 'MasterProjectsPoliciesCtrl',
        resolve: {
          currentProject: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.get($stateParams.projectId);
          }],
          campaignPolicySets: ["MasterCampaignPolicySet", "$stateParams", function(MasterCampaignPolicySet, $stateParams) {
            return MasterCampaignPolicySet.all($stateParams.projectId);
          }]
        }
      }
    }
  }).state('admin.master.projects.policies.show', {
    url: '/{campaignPolicySetId:int}',
    views: {
      'content@': {
        templateUrl: '/templates/master.projects/master_projects_policies.html',
        controller: 'MasterProjectsPoliciesCtrl',
        resolve: {
          currentProject: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.get($stateParams.projectId);
          }],
          campaignPolicySets: ["MasterCampaignPolicySet", "$stateParams", function(MasterCampaignPolicySet, $stateParams) {
            return MasterCampaignPolicySet.all($stateParams.projectId);
          }]
        }
      }
    }
  }).state('admin.master.projects.campaigns', {
    url: '/{projectId:int}/campaigns',
    abstract: true
  }).state('admin.master.projects.campaigns.segment', {
    url: '/{campaignId:int}/segment',
    views: {
      'mainnav@': {
        templateUrl: '/templates/core/views/mainnav.html',
        controller: 'MainnavCtrl',
        resolve: {
          currentProject: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.get($stateParams.projectId);
          }]
        }
      },
      'content@': {
        templateUrl: '/templates/master.projects/master_campaign_segment_detail.html',
        controller: 'MasterCampaignSegmentDetailCtrl',
        resolve: {
          currentProject: ["Project", "$stateParams", function(Project, $stateParams) {
            return Project.get($stateParams.projectId);
          }],
          currentCampaign: ["MasterCampaign", "$stateParams", function(MasterCampaign, $stateParams) {
            return MasterCampaign.get({
              projectId: $stateParams.projectId,
              campaignId: $stateParams.campaignId
            });
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1314 */
/***/ (function(module, exports) {

angular.module('zc.master.reports').controller('MasterReportsCtrl', ["$q", "$scope", "$translate", "$filter", "Page", "projects", "Report", "MasterReportStats", "Campaign", "CampaignStats", "MasterProject", "SearchFilter", "cronHours", "currencies", function($q, $scope, $translate, $filter, Page, projects, Report, MasterReportStats, Campaign, CampaignStats, MasterProject, SearchFilter, cronHours, currencies) {
  var SERVER_TIMEZONE, aggregateBaseTime, filterByProductLine, filterByProjectStatus, maxPeriod;
  Page.setBodyClass('');
  $translate('masterReports.list.reportList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.MasterProject = MasterProject;
  $scope.projects = projects;
  $scope.filteredProjects = [];
  $scope.sortProps = [['report.contribution_price', true]];
  $scope.sortReverse = true;
  $scope.searchText = '';
  $scope.filters = SearchFilter.resolveFromLocation();
  $scope.filters.product_line = 'all';
  $scope.filters.contract_status = 'all';
  $scope.filters.search_term = "";
  $scope.project_status = {
    all: $translate.instant('masterReports.list.all'),
    before_trial: $translate.instant('masterReports.list.beforeTrial'),
    trial: $translate.instant('masterReports.list.trial'),
    terminated_after_trial: $translate.instant('masterReports.list.terminatedAfterTrial'),
    contracted: $translate.instant('masterReports.list.contracted'),
    terminated_after_contract: $translate.instant('masterReports.list.terminatedAfterContract'),
    idle: $translate.instant('masterReports.list.idle')
  };
  $scope.totalInvoiceAmount = 0;
  SERVER_TIMEZONE = 'Asia/Tokyo';
  aggregateBaseTime = moment().tz(SERVER_TIMEZONE).subtract(cronHours.dailyReport, 'hours');
  $scope.currentPeriod = moment(aggregateBaseTime).tz(SERVER_TIMEZONE).startOf('month').toDate();
  maxPeriod = moment(aggregateBaseTime).tz(SERVER_TIMEZONE).subtract(1, 'days').startOf('month').toDate();
  $scope.updateReportMode = function() {
    var reportTime;
    $scope.isTailPeriod = $scope.currentPeriod >= maxPeriod;
    $scope.isUnfinishedPeriod = moment($scope.currentPeriod).tz(SERVER_TIMEZONE).valueOf() === moment(aggregateBaseTime).tz(SERVER_TIMEZONE).startOf('month').valueOf();
    $scope.isNormalPeriod = !$scope.isUnfinishedPeriod;
    if ($scope.isUnfinishedPeriod) {
      if (aggregateBaseTime.date() > 1) {
        reportTime = moment(aggregateBaseTime).tz(SERVER_TIMEZONE).subtract(1, 'days');
      } else {
        reportTime = moment(aggregateBaseTime).tz(SERVER_TIMEZONE);
      }
      $scope.latestReportDay = reportTime.startOf('day').toDate();
      return $scope.beforeReportDay = reportTime.subtract(1, 'days').startOf('day').toDate();
    }
  };
  $scope.updateReportMode();
  $scope.nextMonth = function() {
    if ($scope.currentPeriod >= maxPeriod) {
      return;
    }
    $scope.currentPeriod = moment($scope.currentPeriod).tz(SERVER_TIMEZONE).add(1, 'month').toDate();
    return $scope.updateData();
  };
  $scope.prevMonth = function() {
    $scope.currentPeriod = moment($scope.currentPeriod).tz(SERVER_TIMEZONE).subtract(1, 'month').toDate();
    return $scope.updateData();
  };
  $scope.setSortProp = function(key) {
    if ($scope.sortProps[0][0] === key) {
      $scope.sortProps[0][1] = !$scope.sortProps[0][1];
    } else {
      $scope.sortProps.unshift([key, false]);
      $scope.sortProps.splice(1);
    }
    return $scope.filterProjects();
  };
  $scope.filterProjects = function() {
    $scope.filteredProjects = $filter('projectText')($scope.projects, $scope.filters.search_term);
    $scope.filteredProjects = filterByProductLine($scope.filteredProjects, $scope.filters.product_line);
    $scope.filteredProjects = filterByProjectStatus($scope.filteredProjects, $scope.filters.contract_status);
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.sortProps[0][0], $scope.sortProps[0][1]);
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.sortProps[0][0], $scope.sortProps[0][1]);
    return $scope.filteredProjects = $filter('filter')($scope.filteredProjects, {
      is_demo: false,
      product_line: '!zenclerk_s'
    }, true);
  };
  $scope.calculateTotal = function() {
    $scope.totalInvoiceAmount = 0;
    $scope.totalContributionPrice = 0;
    return _.map($scope.projects, function(p) {
      if (p.report) {
        $scope.totalContributionPrice += p.report.contribution_price;
        return $scope.totalInvoiceAmount += p.report.invoice_amount;
      }
    });
  };
  $scope.updateData = function() {
    var promises;
    $scope.updateReportMode();
    if ($scope.isUnfinishedPeriod) {
      promises = _.map($scope.projects, function(project) {
        return $q.all({
          reports: Report.find({
            apikey: project.apikey,
            dimension: 'daily'
          }, {
            match: {
              begin_at: {
                $gte: new Date($scope.currentPeriod),
                $lt: moment($scope.currentPeriod).tz(SERVER_TIMEZONE).endOf("month").add(1, "days").startOf("month").toDate()
              },
              start_at: $scope.latestReportDay,
              device: null,
              target: null
            }
          }),
          day_before: Report.find({
            apikey: project.apikey,
            dimension: 'daily'
          }, {
            match: {
              begin_at: {
                $gte: new Date($scope.currentPeriod),
                $lt: moment($scope.currentPeriod).tz(SERVER_TIMEZONE).endOf("month").add(1, "days").startOf("month").toDate()
              },
              start_at: $scope.beforeReportDay,
              device: null,
              target: null,
              status: null
            }
          })
        });
      });
      return $q.all(promises).then(function(results) {
        var i, j, len, project, ref, ref1, ref2, reports, result, results1;
        results1 = [];
        for (i = j = 0, len = results.length; j < len; i = ++j) {
          result = results[i];
          project = projects[i];
          reports = _.groupBy(result.reports, function(d) {
            return d.status;
          });
          results1.push($scope.handleResponse(project, (ref = reports[null]) != null ? ref[0] : void 0, (ref1 = reports["trial"]) != null ? ref1[0] : void 0, (ref2 = reports["contracted"]) != null ? ref2[0] : void 0, result.day_before[0]));
        }
        return results1;
      });
    } else {
      promises = _.map($scope.projects, function(project) {
        return Report.find({
          apikey: project.apikey,
          dimension: 'monthly'
        }, {
          match: {
            begin_at: {
              $gte: new Date($scope.currentPeriod),
              $lt: moment($scope.currentPeriod).tz(SERVER_TIMEZONE).endOf("month").add(1, "days").startOf("month").toDate()
            },
            device: null,
            target: null
          }
        });
      });
      return $q.all(promises).then(function(results) {
        var i, j, len, project, ref, ref1, ref2, reports, result, results1;
        results1 = [];
        for (i = j = 0, len = results.length; j < len; i = ++j) {
          result = results[i];
          project = projects[i];
          reports = _.groupBy(result, function(d) {
            return d.status;
          });
          results1.push($scope.handleResponse(project, (ref = reports[null]) != null ? ref[0] : void 0, (ref1 = reports["trial"]) != null ? ref1[0] : void 0, (ref2 = reports["contracted"]) != null ? ref2[0] : void 0));
        }
        return results1;
      });
    }
  };
  $scope.handleResponse = (function(_this) {
    return function(project, report, trial, contracted, day_before_report) {
      project.trial = trial || void 0;
      project.contracted = contracted || void 0;
      project.currencyObj = currencies[project.currency];
      if (report) {
        project.report = report;
        _.map([project.report, project.contracted, project.trial], function(report) {
          if (report) {
            MasterReportStats.calculateInvoiceAmountRate(report);
            return MasterReportStats.calculateGoalPercentage(report, project);
          }
        });
        if (day_before_report) {
          project.day_before_report = day_before_report;
          project.day_before_invoice_amount_difference = report.invoice_amount - day_before_report.invoice_amount;
        }
      } else {
        project.report = void 0;
        project.day_before_report = void 0;
      }
      $scope.filterProjects();
      return $scope.calculateTotal();
    };
  })(this);
  $scope.MasterProject.getProjectRanks().then(function(res) {
    return $scope.updateData();
  });
  $scope.$watch('currentPeriod', function(currentPeriod) {
    return $scope.range = {
      start_at: currentPeriod,
      end_at: moment(currentPeriod).tz(SERVER_TIMEZONE).add(1, 'month').toDate()
    };
  });
  filterByProductLine = function(projects, productLine) {
    if (productLine === "all") {
      return projects;
    } else {
      return _.filter(projects, function(project) {
        return project.product_line === productLine;
      });
    }
  };
  filterByProjectStatus = function(projects, contract_status) {
    if (contract_status === "all") {
      return projects;
    } else {
      return _.filter(projects, function(project) {
        return project.contract_status === contract_status;
      });
    }
  };
  $scope.resetSearchTerm = function() {
    $scope.filters.search_term = "";
    return $scope.filterProjects();
  };
  return $scope.resetData = function() {
    $scope.filters.product_line = 'all';
    $scope.filters.contract_status = 'all';
    $scope.filters.search_term = "";
    return $scope.filterProjects();
  };
}]);


/***/ }),
/* 1315 */
/***/ (function(module, exports) {

angular.module('zc.master.reports').constant('masterReportsCsvHeaders', ['title', 'apikey', 'product_line', 'contracted_at', 'trial_started_at', 'trial_end_at', 'terminated_at', 'status', 'project_rank', 'campaign_count', 'all_access.conversion_price', 'contribution_count', 'contribution_price', 'invoice_amount', 'invoice_amount_rate', 'goal_percentage', 'trial.all_access.conversion_price', 'trial.contribution_count', 'trial.contribution_price', 'trial.invoice_amount', 'contracted.all_access.conversion_price', 'contracted.contribution_count', 'contracted.contribution_price', 'contracted.invoice_amount', 'budget']);


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

angular.module('zc.projects').directive('reportDownloadButton', ["$q", "MasterReportStats", "masterReportsCsvHeaders", function($q, MasterReportStats, masterReportsCsvHeaders) {
  return {
    restrict: 'E',
    scope: {
      currentPeriod: '=',
      projects: '='
    },
    template: "<button\n  type=\"button\"\n  class=\"btn btn-default pull-right\"\n  ng-csv=\"getCSV()\"\n  filename=\"{{filename}}\"\n  add-bom=\"true\"\n  charset=\"utf-16\"\n  field-separator=\"\\t\">\n  <i class=\"fa fa-cloud-download\"></i> {{ 'masterReports.reportDownloadButton.csvDownload' | translate }}\n</button>",
    link: function(scope, element, attrs) {
      var extraHeader;
      extraHeader = function(statsForCSV) {
        return _.chain(statsForCSV).values().reduce(_.assignIn, {}).keys().filter(function(key) {
          return /\d{4,4}\/\d{1,2}\/\d{1,2}/.test(key);
        }).uniq().value();
      };
      scope.filename = "reports_" + (moment(scope.currentPeriod).format('YYYYMMDD')) + ".csv";
      return scope.getCSV = function() {
        return $q(function(resolve) {
          var end_at, start_at;
          start_at = scope.currentPeriod.valueOf();
          end_at = moment(scope.currentPeriod).endOf("month").add(1, "days").startOf("month").valueOf();
          return MasterReportStats.find({
            begin_at: {
              $gte: start_at,
              $lt: end_at
            },
            dimension: 'daily',
            device: null,
            target: null
          }).then(function(report_stats) {
            return MasterReportStats.forCSV(report_stats);
          }).then(function(statsForCSV) {
            var csvData, csvHeader, header, i, len, project, projectStats, ref, row;
            csvHeader = masterReportsCsvHeaders.concat(extraHeader(statsForCSV));
            csvData = [csvHeader];
            ref = scope.projects;
            for (i = 0, len = ref.length; i < len; i++) {
              project = ref[i];
              projectStats = statsForCSV[project.apikey] || project;
              projectStats.status = project.contract_status;
              row = (function() {
                var j, len1, results;
                results = [];
                for (j = 0, len1 = csvHeader.length; j < len1; j++) {
                  header = csvHeader[j];
                  results.push(_.get(projectStats, header));
                }
                return results;
              })();
              csvData.push(row);
            }
            return resolve(csvData);
          });
        });
      };
    }
  };
}]);


/***/ }),
/* 1317 */
/***/ (function(module, exports) {

angular.module('zc.master.reports').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.reports', {
    url: '/reports',
    views: {
      'content@': {
        templateUrl: '/templates/master.reports/list.html',
        controller: 'MasterReportsCtrl',
        resolve: {
          projects: ["MasterProject", function(MasterProject) {
            return MasterProject.all();
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

angular.module('zc.master').directive('zcSegmentEstimatedVisitors', ["$state", "$q", "$translate", "Meta", "CampaignSegment", "MasterMongoSession", "MasterMongoVisitor", "MasterAccessStats", "SegmentEstimator", "SegmentMatcher", "lib", function($state, $q, $translate, Meta, CampaignSegment, MasterMongoSession, MasterMongoVisitor, MasterAccessStats, SegmentEstimator, SegmentMatcher, lib) {
  return {
    restrict: 'E',
    templateUrl: "/templates/master.segments/segment_estimated_visitors.html",
    replace: true,
    scope: {
      segment: "=",
      project: "=",
      timingSegment: "=",
      sessionOnly: "@",
      timeDeltaHour: "@"
    },
    link: function(scope, element, attrs) {},
    controller: ["$scope", function($scope) {
      $scope.sessions = [];
      $scope.deviceSessions = [];
      $scope.matchedSessions = 0;
      $scope.totalSessionCount = 0;
      $scope.matchedSessionCount = 0;
      $scope.matchedPercentage = 0;
      $scope.accessStatsMatchedCounts = {
        all: 0
      };
      $scope.accessStatsTotalCounts = {
        all: 0
      };
      $scope.accessStatsStart = void 0;
      $scope.accessStatsEnd = void 0;
      $scope.mode = "sessions";
      $scope.devices = [
        {
          name: $translate.instant('masterSegments.segmentEstimatedVisitors.all'),
          value: "all"
        }, {
          name: $translate.instant('masterSegments.segmentEstimatedVisitors.pc'),
          value: "pc"
        }, {
          name: $translate.instant('masterSegments.segmentEstimatedVisitors.sp'),
          value: "sp"
        }, {
          name: $translate.instant('masterSegments.segmentEstimatedVisitors.tablet'),
          value: "tablet"
        }
      ];
      if ($scope.project.enable_app) {
        $scope.devices.push({
          name: $translate.instant('masterSegments.segmentEstimatedVisitors.app'),
          value: "app"
        });
      }
      $scope.filters = {
        device: $scope.devices[0]
      };
      $scope.getAccessStats = function() {
        if (!$scope.segment || $scope.sessionOnly) {
          return [];
        }
        return SegmentEstimator.getAccessStats($scope.project.apikey, moment().subtract(1, "days").startOf("day").toDate(), $scope.segment.id).then(function(accessStats) {
          var key, results, val;
          results = [];
          for (key in accessStats) {
            val = accessStats[key];
            results.push($scope[key] = val);
          }
          return results;
        });
      };
      $scope.getSessions = function() {
        var timeLimitDate;
        timeLimitDate = null;
        if ($scope.timeDeltaHour) {
          timeLimitDate = moment().subtract($scope.timeDeltaHour, 'hours').toDate();
        }
        return SegmentEstimator.getSessions($scope.project.apikey, timeLimitDate).then(function(sessions) {
          $scope.sessions = sessions;
          return $scope.handleSessions();
        });
      };
      $scope.handleSessions = function() {
        var filteredSessions, key, ref, val;
        if (!((ref = $scope.segment) != null ? ref.mongo_query : void 0) || $scope.sessions.length <= 0) {
          return;
        }
        filteredSessions = SegmentEstimator.filterSessionsBySegmentQuery($scope.segment.mongo_query, $scope.filters.device.value, $scope.sessions, $scope.timingSegment);
        for (key in filteredSessions) {
          val = filteredSessions[key];
          $scope[key] = val;
        }
        return $scope.calculatePercentage();
      };
      $scope.calculatePercentage = function() {
        if ($scope.mode === 'sessions') {
          $scope.totalSessionCount = $scope.deviceSessions.length;
          $scope.matchedSessionCount = $scope.matchedSessions.length;
        } else if ($scope.mode === 'access_stats') {
          $scope.totalSessionCount = $scope.accessStatsTotalCounts[$scope.filters.device.value];
          $scope.matchedSessionCount = $scope.accessStatsMatchedCounts[$scope.filters.device.value];
        }
        if ($scope.totalSessionsCount === 0) {
          return $scope.matchedPercentage = 0;
        } else {
          return $scope.matchedPercentage = $scope.matchedSessionCount / $scope.totalSessionCount * 100;
        }
      };
      $scope.switchMode = function(mode) {
        $scope.mode = mode;
        return $scope.calculatePercentage();
      };
      $scope.getSessions();
      $scope.accessStatsExist = function() {
        return !!$scope.accessStatsMatchedCounts.all;
      };
      $scope.isRecentlyUpdated = function(segment) {
        var date;
        if (!segment.updated_at && !segment.created_at) {
          return true;
        }
        date = segment.created_at;
        if (segment.updated_at) {
          date = segment.updated_at;
        }
        return moment(date).valueOf() > moment().startOf("day").subtract(1, "days").valueOf();
      };
      $scope.$watch('filters.device', function(newval) {
        return $scope.handleSessions();
      });
      $scope.$watch('segment', function(newval) {
        if (newval && !$scope.accessStatsExist()) {
          return $scope.getAccessStats();
        }
      });
      return $scope.$watch('segment.mongo_query', function(newval) {
        var ref;
        if ((ref = $scope.segment) != null ? ref.message : void 0) {
          $scope.matchedPercentage = 0;
          return $scope.matchedSessionCount = 0;
        } else if (newval) {
          return $scope.handleSessions();
        }
      });
    }]
  };
}]);


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

angular.module('zc.master.users').controller('MasterUsersCtrl', ["$q", "$scope", "$translate", "Devise", "MasterUser", "Page", function($q, $scope, $translate, Devise, MasterUser, Page) {
  Page.setBodyClass('');
  $translate('masterUsers.list.usersList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.filteredUsers = [];
  $scope.openProject = false;
  $scope.filters = {
    per_page: 100,
    page: 1,
    total_count: 0,
    sort_prop: 'id',
    sort_direction: 'desc',
    search_term: '',
    visible_group: 'settings'
  };
  $scope.setVisibleGroup = function(visibleGroup) {
    return $scope.filters.visible_group = visibleGroup;
  };
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction === 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterUsers();
  };
  $scope.filterUsers = function() {
    var omit_filter_attrs;
    omit_filter_attrs = ['visible_group', 'total_count'];
    if (!$scope.filters.search_term) {
      omit_filter_attrs.push('search_term');
    }
    return MasterUser.all(_.omit($scope.filters, omit_filter_attrs)).then(function(res) {
      $scope.filteredUsers = res.users;
      return $scope.filters.total_count = res.total_count;
    });
  };
  $scope.updateData = function() {
    if (!$scope.filters.search_term) {
      return;
    }
    $scope.filters.page = 1;
    return $scope.filterUsers();
  };
  $scope.becomeUser = function(id) {
    return Devise.become({
      id: id
    });
  };
  $scope.resetSearchTerm = function() {
    $scope.filters.search_term = "";
    return $scope.filterUsers();
  };
  return $scope.filterUsers();
}]);


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

angular.module('zc.master.users').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.users', {
    url: '/users',
    views: {
      'content@': {
        templateUrl: '/templates/master.users/list.html',
        controller: 'MasterUsersCtrl'
      }
    }
  });
}]);


/***/ }),
/* 1321 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteInvoices').controller('MasterZcliteInvoicesListCtrl', ["$q", "$scope", "$translate", "$filter", "Page", "projects", "SearchFilter", "ZcsInvoice", function($q, $scope, $translate, $filter, Page, projects, SearchFilter, ZcsInvoice) {
  var filterByAgency, maxPeriod, picked_for_csv, uniqueAgency;
  Page.setBodyClass('');
  $translate('masterZclite.invoices.list.liteBillingList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.projects = _.chain(projects).filter(function(p) {
    return p.product_line === 'zenclerk_s';
  }).reject(function(p) {
    return p.is_demo || p.is_test;
  }).reject(function(p) {
    return !p.pricing_confirmed_at && !p.conversion_tag_confirmed_at;
  }).value();
  $scope.filteredProjects = [];
  $scope.csvHeader = [$translate.instant('masterZclite.invoices.list.id'), $translate.instant('masterZclite.invoices.list.title'), $translate.instant('masterZclite.invoices.list.apikey'), $translate.instant('masterZclite.invoices.list.agency'), $translate.instant('masterZclite.invoices.list.contractedAt'), $translate.instant('masterZclite.invoices.list.terminatedAt'), $translate.instant('masterZclite.invoices.list.initialCost'), $translate.instant('masterZclite.invoices.list.initialCostDiscount'), $translate.instant('masterZclite.invoices.list.minimal'), $translate.instant('masterZclite.invoices.list.minimalDiscount'), $translate.instant('masterZclite.invoices.list.minimumCharge'), $translate.instant('masterZclite.invoices.list.minimumChargeDiscount'), $translate.instant('masterZclite.invoices.list.otherExpenses'), $translate.instant('masterZclite.invoices.list.otherDiscount'), $translate.instant('masterZclite.invoices.list.fixedCost'), $translate.instant('masterZclite.invoices.list.campaignDeliveryCosts'), $translate.instant('masterZclite.invoices.list.maximumAmount'), $translate.instant('masterZclite.invoices.list.fixedRateDiscount'), $translate.instant('masterZclite.invoices.list.fixedRateDiscountAmount'), $translate.instant('masterZclite.invoices.list.maximumAmountAndFractionalAdjustment'), $translate.instant('masterZclite.invoices.list.billedAmountTaxExcluded'), $translate.instant('masterZclite.invoices.list.billingAmountTaxIncluded'), $translate.instant('masterZclite.invoices.list.agencyPartitionRate'), $translate.instant('masterZclite.invoices.list.agencyBilledTaxExcluded')];
  picked_for_csv = ['id', 'title', 'apikey'];
  $scope.getCSV = function() {
    var csvData;
    csvData = _.map($scope.filteredProjects, function(project) {
      var row;
      row = _.pick(project, picked_for_csv);
      row.agency = project.agency.title;
      row.contracted_at = project.contracted_at;
      row.terminated_at = project.terminated_at;
      row.initial = $scope.getAdjustmentPrice(project.invoice.adjustments, 'initial');
      row.initial_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'initial_discount');
      row.minimal = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimal');
      row.minimal_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimal_discount');
      row.minimum_charge = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimum_charge');
      row.minimum_charge_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimum_charge_discount');
      row.other = $scope.getAdjustmentPrice(project.invoice.adjustments, 'other');
      row.other_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'other_discount');
      row.fixed_invoice_amount = project.fixed_invoice_amount;
      row.sum_details_invoice_price = project.invoice.sum_details_invoice_price;
      row.max_invoice = project.invoice.max_invoice;
      row.discount_percent = project.invoice.discount_percent;
      row.percent_discount = project.invoice.percent_discount;
      row.rounding_discount = project.invoice.rounding_discount;
      row.invoice_price_tax_excluded = project.invoice.invoice_price_tax_excluded;
      row.invoice_price = project.invoice.invoice_price;
      row.agency_net_interest_rate = _.get(project, 'agency.margin_percent') || null;
      row.agency_invoice_price_tax_excluded = $scope.calculateAgencyInvoicePriceTaxExcluded(row.agency_net_interest_rate, row.invoice_price_tax_excluded);
      return row;
    });
    return csvData;
  };
  $scope.project_status = {
    all: $filter('translate')('masterZclite.invoices.list.all'),
    before_trial: $filter('translate')('masterZclite.invoices.list.beforeTrial'),
    trial: $filter('translate')('masterZclite.invoices.list.trial'),
    terminated_after_trial: $filter('translate')('masterZclite.invoices.list.terminatedAfterTrial'),
    contracted: $filter('translate')('masterZclite.invoices.list.contracted'),
    terminated_after_contract: $filter('translate')('masterZclite.invoices.list.terminatedAfterContract')
  };
  $scope.totalInvoiceAmount = 0;
  maxPeriod = moment().format('YYYY-MM');
  $scope.filters = SearchFilter.resolveFromLocation();
  $scope.filters.agency_name = "all";
  SearchFilter.setComponentDefaults('masterZcliteInvoices', {
    sort_prop: {
      "default": 'invoice.invoice_price'
    },
    sort_direction: {
      "default": 'desc'
    },
    agency_name: {
      "default": 'all'
    },
    search_term: {
      "default": ''
    },
    current_period: {
      "default": moment().format('YYYY-MM')
    }
  });
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterZcliteInvoices');
  });
  $scope.nextMonth = function() {
    if ($scope.filters.current_period >= maxPeriod) {
      return;
    }
    $scope.filters.current_period = moment($scope.filters.current_period, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    return $scope.updateData();
  };
  $scope.prevMonth = function() {
    $scope.filters.current_period = moment($scope.filters.current_period, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
    return $scope.updateData();
  };
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction === 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterProjects();
  };
  $scope.calculateTotal = function() {
    $scope.totalInvoiceAmount = 0;
    $scope.totalInvoiceAmountTaxExcluded = 0;
    $scope.totalInitialAmount = 0;
    $scope.totalMinimalAmount = 0;
    $scope.totalFixedAmount = 0;
    $scope.totalCampaignAmount = 0;
    return _.map($scope.filteredProjects, function(p) {
      if (p.invoice) {
        $scope.totalInvoiceAmount += p.invoice.invoice_price;
        $scope.totalInvoiceAmountTaxExcluded += p.invoice.invoice_price_tax_excluded;
        $scope.totalInitialAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'initial');
        $scope.totalInitialAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'initial_discount');
        $scope.totalMinimalAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'minimal');
        $scope.totalMinimalAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'minimal_discount');
        $scope.totalFixedAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'fixed');
        return $scope.totalCampaignAmount += p.invoice.campaign_invoice_price_after_rounding_discount;
      }
    });
  };
  filterByAgency = function(projects, agency_name) {
    return _.filter(projects, function(project) {
      if (agency_name === 'all') {
        return true;
      }
      return project.agency.name === agency_name;
    });
  };
  $scope.filterProjects = function() {
    var sortDirectionReverse;
    sortDirectionReverse = $scope.filters.sort_direction === 'desc';
    $scope.filteredProjects = $filter('projectText')($scope.projects, $scope.filters.search_term);
    $scope.filteredProjects = filterByAgency($scope.filteredProjects, $scope.filters.agency_name);
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse);
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse);
    SearchFilter.updateComponentDefaults('masterZcliteInvoices');
    return $scope.calculateTotal();
  };
  $scope.filterProjects();
  $scope.updateData = function() {
    var promises;
    promises = _.map($scope.projects, function(p) {
      return ZcsInvoice.find(p.apikey, $scope.filters.current_period);
    });
    return $q.all(promises).then(function(invoices) {
      invoices = _.compact(invoices);
      $scope.totalInvoicePrice = _.sumBy(invoices, function(i) {
        return i.invoice_price;
      });
      return _.each(invoices, function(i) {
        var project;
        project = _.find($scope.projects, function(p) {
          return p.apikey === i.apikey;
        });
        project.invoice = i;
        return $scope.filterProjects();
      });
    });
  };
  $scope.updateData();
  uniqueAgency = function() {
    var uniqued_agency_project;
    $scope.agency_names = [];
    uniqued_agency_project = _.uniq($scope.projects, 'agency_id');
    _.map(uniqued_agency_project, function(p) {
      return $scope.agency_names.push(p.agency.name);
    });
    return $scope.agency_names.unshift('all');
  };
  uniqueAgency();
  $scope.resetSearchTerm = function() {
    $scope.filters.search_term = "";
    return $scope.filterProjects();
  };
  $scope.resetData = function() {
    $scope.filters.agency_name = 'all';
    $scope.filters.search_term = "";
    return $scope.filterProjects();
  };
  $scope.getAdjustmentPrice = function(adjustments, name) {
    var foundAdjustments;
    if (name === 'initial') {
      foundAdjustments = _.filter(adjustments, function(d) {
        return d.adjustment_type === 'initial' || d.adjustment_name === 'initial';
      });
    } else {
      foundAdjustments = _.filter(adjustments, function(d) {
        return d.adjustment_name === name;
      });
    }
    return _.sumBy(foundAdjustments, function(adjustment) {
      return adjustment.price;
    }) || 0;
  };
  return $scope.calculateAgencyInvoicePriceTaxExcluded = function(agencyNetInterestRate, invoicePriceTaxExcluded) {
    if (!agencyNetInterestRate || agencyNetInterestRate === 1) {
      return null;
    }
    return Math.floor(invoicePriceTaxExcluded * (100 - agencyNetInterestRate) / 100);
  };
}]);


/***/ }),
/* 1322 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteInvoices').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.zcliteInvoices', {
    url: '/zclite_invoices',
    views: {
      'content@': {
        templateUrl: '/templates/master.zclite_invoices/list.html',
        controller: 'MasterZcliteInvoicesListCtrl',
        resolve: {
          projects: ["MasterProject", function(MasterProject) {
            return MasterProject.all();
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1323 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteInvoices').factory('ZcsInvoice', ["$q", "FacadeV2", function($q, FacadeV2) {
  var ZcsInvoice;
  return ZcsInvoice = (function() {
    function ZcsInvoice() {}

    ZcsInvoice.all = function(apikey) {
      return FacadeV2.request("/apikeys/" + apikey + "/zcs_invoices/").then(function(res) {
        return res.data;
      });
    };

    ZcsInvoice.find = function(apikey, term) {
      return FacadeV2.request("/apikeys/" + apikey + "/zcs_invoices/" + term, {}).then(function(res) {
        return res.data;
      });
    };

    ZcsInvoice.generateDemoData = function() {
      return {
        new_client: true,
        consumption_tax: 680,
        discount: 2,
        fee_rate: 0.05,
        invoice_price: 9180,
        invoice_price_tax_excluded: 8500,
        max_invoice: 30000,
        monthly_total_conversion: 3924191,
        total_campaign_price: 170057,
        details: [
          {
            _id: '1234',
            conversion_count: 8,
            device: 'pc',
            invoice: 5846,
            total: 116922
          }, {
            _id: '1234',
            conversion_count: 6,
            device: 'other',
            invoice: 2656,
            total: 53135
          }
        ]
      };
    };

    return ZcsInvoice;

  })();
}]);


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.master.zcliteKpi').controller('MasterZcliteKpiCtrl', ["$scope", "$q", "$translate", "$filter", "Page", "ZcsKpi", "ZcsAgencyInvoice", "SearchFilter", "agencies", "projects", "lib", function($scope, $q, $translate, $filter, Page, ZcsKpi, ZcsAgencyInvoice, SearchFilter, agencies, projects, lib) {
  var CSV_FIELDS, CSV_HEADERS, DATE_FORMAT, DIFF_KPIS, THIS_MONTH, THIS_PERIOD, calculateDiff, filterProjectsByAgency, isTailPeriod, updateData;
  Page.setBodyClass('');
  $translate('masterZclite.kpi.list.liteKpiManagement').then(function(translation) {
    return Page.setTitle(translation);
  });
  DATE_FORMAT = 'YYYY-MM';
  THIS_MONTH = moment().format(DATE_FORMAT);
  THIS_PERIOD = moment(THIS_MONTH, DATE_FORMAT).toDate();
  CSV_HEADERS = [$translate.instant('masterZclite.kpi.list.title'), $translate.instant('masterZclite.kpi.list.currentProjectsLength'), $translate.instant('masterZclite.kpi.list.currentProjectPerformanceConversionPrice'), $translate.instant('masterZclite.kpi.list.invoicePriceTaxEcluded'), $translate.instant('masterZclite.kpi.list.retentionRate'), $translate.instant('masterZclite.kpi.list.takeRate'), $translate.instant('masterZclite.kpi.list.currentRegistered_projectsLength'), $translate.instant('masterZclite.kpi.list.currentCorrected_registered_projects_count'), $translate.instant('masterZclite.kpi.list.currentInstallationCompletionRatesSiteinfoConfirmed'), $translate.instant('masterZclite.kpi.list.currentInstallationCompletionRatesConversionTagConfirmed'), $translate.instant('masterZclite.kpi.list.currentInstallationCompletionRatesFirstCampaignStart'), $translate.instant('masterZclite.kpi.list.currentCampaignStartedProjectsLength'), $translate.instant('masterZclite.kpi.list.diffCampaignStartedProjects'), $translate.instant('masterZclite.kpi.list.currentCampaignSettingProjectsLength'), $translate.instant('masterZclite.kpi.list.diffCampaignSettingProjects'), $translate.instant('masterZclite.kpi.list.currentCampaignDeliveryRatesSetting'), $translate.instant('masterZclite.kpi.list.currentCampaignDeliveryRatesTerm'), $translate.instant('masterZclite.kpi.list.currentCampaignCurrentProjectsLength'), $translate.instant('masterZclite.kpi.list.diffCampaignCurrentProjects'), $translate.instant('masterZclite.kpi.list.currentCampaignPerformance.sessionCoverRate'), $translate.instant('masterZclite.kpi.list.currentCampaignPerformanceConversionCoverRate'), $translate.instant('masterZclite.kpi.list.currentCampaignPerformanceConversionUpRate'), $translate.instant('masterZclite.kpi.list.currentCampaignPerformanceCampaignCouponUsedRate')];
  CSV_FIELDS = ['title', 'current.projects.length', 'current.project_performance.conversion_price', 'invoice_price_tax_excluded', 'take_rate', 'retention_rate', 'current.registered_projects.length', 'current.corrected_registered_projects_count', 'current.installation_completion_rates.siteinfo_confirmed', 'current.installation_completion_rates.conversion_tag_confirmed', 'current.installation_completion_rates.first_campaign_start', 'current.campaign_started_projects.length', 'diff.campaign_started_projects', 'current.campaign_setting_projects.length', 'diff.campaign_setting_projects', 'current.campaign_delivery_rates.setting', 'current.campaign_delivery_rates.term', 'current.campaign_current_projects.length', 'diff.campaign_current_projects', 'current.campaign_performance.session_cover_rate', 'current.campaign_performance.conversion_cover_rate', 'current.campaign_performance.conversion_up_rate', 'current.campaign_performance.campaign_coupon_used_rate'];
  DIFF_KPIS = ['registered_projects.length', 'corrected_registered_projects_count', 'installation_completion_rates.siteinfo_confirmed', 'installation_completion_rates.conversion_tag_confirmed', 'installation_completion_rates.first_campaign_start', 'campaign_started_projects.length', 'campaign_setting_projects.length', 'campaign_delivery_rates.setting', 'campaign_delivery_rates.term', 'campaign_current_projects.length', 'campaign_performance.session_cover_rate', 'campaign_performance.conversion_cover_rate', 'campaign_performance.conversion_up_rate', 'campaign_performance.campaign_coupon_used_rate'];
  $scope.agencies = agencies;
  $scope.projects = _.filter(projects, function(project) {
    return project.product_line === 'zenclerk_s' && !project.is_demo && !project.is_test;
  });
  $scope.filters = SearchFilter.resolveFromLocation();
  SearchFilter.setComponentDefaults('masterZcliteKpi', {
    sort_prop: {
      "default": 'title'
    },
    sort_direction: {
      "default": 'asc'
    },
    current_month: {
      "default": THIS_MONTH
    }
  });
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterZcliteKpi');
  });
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction === 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return updateData();
  };
  $scope.nextMonth = function() {
    if ($scope.is_tail_period) {
      return;
    }
    $scope.current_period = moment($scope.current_period).add(1, 'month').toDate();
    $scope.filters.current_month = moment($scope.current_period).format(DATE_FORMAT);
    $scope.is_tail_period = isTailPeriod();
    $scope.filename = "kpi_" + (moment($scope.current_period).format('YYYYMM')) + ".csv";
    return updateData();
  };
  $scope.prevMonth = function() {
    $scope.current_period = moment($scope.current_period).subtract(1, 'month').toDate();
    $scope.filters.current_month = moment($scope.current_period).format(DATE_FORMAT);
    $scope.is_tail_period = isTailPeriod();
    $scope.filename = "kpi_" + (moment($scope.current_period).format('YYYYMM')) + ".csv";
    return updateData();
  };
  $scope.filename = "kpi_" + (moment(THIS_PERIOD).format('YYYYMM')) + ".csv";
  $scope.getCSV = function() {
    var agency, csvData, field, j, len, ref;
    csvData = [];
    csvData.push(CSV_HEADERS);
    ref = $scope.agencies;
    for (j = 0, len = ref.length; j < len; j++) {
      agency = ref[j];
      csvData.push((function() {
        var k, len1, results;
        results = [];
        for (k = 0, len1 = CSV_FIELDS.length; k < len1; k++) {
          field = CSV_FIELDS[k];
          results.push(lib.getField(agency, field));
        }
        return results;
      })());
    }
    csvData.push((function() {
      var k, len1, results;
      results = [];
      for (k = 0, len1 = CSV_FIELDS.length; k < len1; k++) {
        field = CSV_FIELDS[k];
        results.push(lib.getField($scope.total, field));
      }
      return results;
    })());
    return csvData;
  };
  isTailPeriod = function() {
    return moment($scope.current_period).isSame(THIS_PERIOD);
  };
  filterProjectsByAgency = function(agency) {
    return _.filter($scope.projects, function(project) {
      return project.agency_id === agency.id;
    });
  };
  calculateDiff = function(kpis1, kpis2) {
    var diff, diff_kpi, j, key, kpi1, kpi2, len;
    diff = {};
    for (j = 0, len = DIFF_KPIS.length; j < len; j++) {
      diff_kpi = DIFF_KPIS[j];
      key = diff_kpi.replace('.length', '');
      kpi1 = lib.getField(kpis1, diff_kpi);
      kpi2 = lib.getField(kpis2, diff_kpi);
      if ((kpi1 != null) && (kpi2 != null)) {
        diff[key] = kpi1 - kpi2;
      }
    }
    return diff;
  };
  updateData = function() {
    var agency, agency_current_kpis, agency_invoices, agency_previous_kpis, agency_projects, is_desc, j, len, previous_period, ref;
    SearchFilter.updateComponentDefaults('masterZcliteKpi');
    is_desc = $scope.filters.sort_direction === 'desc';
    $scope.agencies = $filter('orderBy')($scope.agencies, $scope.filters.sort_prop, is_desc);
    $scope.agencies = $filter('emptyToEnd')($scope.agencies, $scope.filters.sort_prop, is_desc);
    previous_period = moment($scope.current_period).subtract(1, 'month').toDate();
    agency_invoices = [];
    agency_current_kpis = [];
    agency_previous_kpis = [];
    ref = $scope.agencies;
    for (j = 0, len = ref.length; j < len; j++) {
      agency = ref[j];
      agency_projects = filterProjectsByAgency(agency);
      agency_invoices.push(ZcsAgencyInvoice.find(agency.name, $scope.filters.current_month));
      agency_current_kpis.push(new ZcsKpi(agency_projects, $scope.current_period).calculate());
      agency_previous_kpis.push(new ZcsKpi(agency_projects, previous_period).calculate());
    }
    return $q.all({
      total_current_kpi: new ZcsKpi($scope.projects, $scope.current_period).calculate(),
      total_previous_kpi: new ZcsKpi($scope.projects, previous_period).calculate(),
      agency_invoices: $q.all(agency_invoices),
      agency_current_kpis: $q.all(agency_current_kpis),
      agency_previous_kpis: $q.all(agency_previous_kpis)
    }).then(function(arg) {
      var agency_current_kpis, agency_invoices, agency_previous_kpis, current_apikeys, i, k, l, len1, len2, len3, m, project, ref1, ref2, ref3, ref4, ref5, retention_count, total_current_kpi, total_previous_kpi;
      total_current_kpi = arg.total_current_kpi, total_previous_kpi = arg.total_previous_kpi, agency_invoices = arg.agency_invoices, agency_current_kpis = arg.agency_current_kpis, agency_previous_kpis = arg.agency_previous_kpis;
      $scope.total = {
        title: $filter('translate')('masterZclite.kpi.list.entire'),
        invoice_price_tax_excluded: 0
      };
      $scope.total.current = total_current_kpi;
      $scope.total.previous = total_previous_kpi;
      $scope.total.diff = calculateDiff($scope.total.current, $scope.total.previous);
      ref1 = $scope.agencies;
      for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
        agency = ref1[i];
        agency.current = agency_current_kpis[i];
        agency.previous = agency_previous_kpis[i];
        agency.diff = calculateDiff(agency.current, agency.previous);
        agency.invoice_price_tax_excluded = parseInt(agency_invoices[i].invoice_price_tax_excluded);
        if (agency.current.project_performance.conversion_price > 0) {
          agency.take_rate = agency.invoice_price_tax_excluded / agency.current.project_performance.conversion_price;
        } else {
          agency.take_rate = null;
        }
        if (agency.previous.campaign_setting_projects.length) {
          retention_count = 0;
          current_apikeys = _.map(agency.current.campaign_setting_projects, 'apikey');
          ref2 = agency.previous.campaign_setting_projects;
          for (l = 0, len2 = ref2.length; l < len2; l++) {
            project = ref2[l];
            if (ref3 = project.apikey, indexOf.call(current_apikeys, ref3) >= 0) {
              retention_count += 1;
            }
          }
          agency.retention_rate = retention_count / agency.previous.campaign_setting_projects.length;
        } else {
          agency.retention_rate = null;
        }
        $scope.total.invoice_price_tax_excluded += agency.invoice_price_tax_excluded;
      }
      if ($scope.total.current.project_performance.conversion_price > 0) {
        $scope.total.take_rate = $scope.total.invoice_price_tax_excluded / $scope.total.current.project_performance.conversion_price;
      } else {
        $scope.total.take_rate = null;
      }
      if ($scope.total.previous.campaign_setting_projects.length) {
        retention_count = 0;
        current_apikeys = _.map($scope.total.current.campaign_setting_projects, 'apikey');
        ref4 = $scope.total.previous.campaign_setting_projects;
        for (m = 0, len3 = ref4.length; m < len3; m++) {
          project = ref4[m];
          if (ref5 = project.apikey, indexOf.call(current_apikeys, ref5) >= 0) {
            retention_count += 1;
          }
        }
        return $scope.total.retention_rate = retention_count / $scope.total.previous.campaign_setting_projects.length;
      } else {
        return $scope.total.retention_rate = null;
      }
    });
  };
  $scope.current_period = moment($scope.filters.current_month, DATE_FORMAT).toDate();
  $scope.is_tail_period = isTailPeriod();
  $scope.filename = "kpi_" + (moment($scope.current_period).format('YYYYMM')) + ".csv";
  return updateData();
}]);


/***/ }),
/* 1325 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteKpi').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.zcliteKpi', {
    url: '/zclite_kpi',
    views: {
      'content@': {
        templateUrl: '/templates/master.zclite_kpi/list.html',
        controller: 'MasterZcliteKpiCtrl',
        resolve: {
          projects: ["MasterProject", function(MasterProject) {
            return MasterProject.all();
          }],
          agencies: ["MasterAgency", function(MasterAgency) {
            return MasterAgency.all();
          }]
        }
      }
    }
  });
}]);


/***/ }),
/* 1326 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.master.zcliteProjects').controller('MasterZcliteProjectsListCtrl', ["$filter", "$q", "$scope", "$translate", "Devise", "Page", "MasterProject", "ProjectStats", "SearchFilter", "ZcsKpi", function($filter, $q, $scope, $translate, Devise, Page, MasterProject, ProjectStats, SearchFilter, ZcsKpi) {
  var PENDING_DATE, calculatePendingDate, filterByInstallStatus, filterBySellingMethod, setInstallationStatus, setOperationStatus;
  Page.setBodyClass('');
  $translate('masterZclite.projects.list.siteList').then(function(translation) {
    return Page.setTitle(translation);
  });
  PENDING_DATE = 5;
  $scope.projects = [];
  $scope.filteredProjects = [];
  $scope.install_status = {
    all: $translate.instant('masterZclite.projects.list.siteList'),
    companyinfo_confirmed_at: $translate.instant('masterZclite.projects.list.companyinfoConfirmedAt'),
    siteinfo_confirmed_at: $translate.instant('masterZclite.projects.list.siteinfoConfirmedAt'),
    tracking_tag_confirmed_at: $translate.instant('masterZclite.projects.list.trackingTagConfirmedAt'),
    conversion_tag_confirmed_at: $translate.instant('masterZclite.projects.list.conversionTagConfirmedAt'),
    complete: $translate.instant('masterZclite.projects.list.complete')
  };
  $scope.selling_methods = {
    all: $translate.instant('masterZclite.projects.list.all'),
    direct_sales: $translate.instant('masterZclite.projects.list.directSales'),
    make_repeater: 'MR',
    agencies: $translate.instant('masterZclite.projects.list.agencies')
  };
  $scope.filters = SearchFilter.resolveFromLocation();
  SearchFilter.setComponentDefaults('masterProjectsList', {
    show_demo: {
      "default": false
    },
    show_test: {
      "default": false
    },
    show_terminated: {
      "default": false
    },
    visible_group: {
      "default": 'settings'
    },
    sort_prop: {
      "default": 'apikey'
    },
    sort_direction: {
      "default": 'desc'
    },
    install_status: {
      "default": 'all'
    },
    selling_method: {
      "default": 'all'
    }
  });
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterProjectsList');
  });
  $scope.setVisibleGroup = function(visibleGroup) {
    $scope.filters.visible_group = visibleGroup;
    return SearchFilter.updateComponentDefaults('masterProjectsList');
  };
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction === 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterProjects();
  };
  $scope.filterProjects = function() {
    var sortDirectionReverse;
    sortDirectionReverse = $scope.filters.sort_direction === 'desc';
    $scope.filteredProjects = $scope.projects;
    if (!$scope.filters.show_terminated) {
      $scope.filteredProjects = _.filter($scope.filteredProjects, function(p) {
        return !p.terminated_at;
      });
    }
    if (!$scope.filters.show_demo) {
      $scope.filteredProjects = _.filter($scope.filteredProjects, function(p) {
        return p.is_demo === false;
      });
    }
    if (!$scope.filters.show_test) {
      $scope.filteredProjects = _.filter($scope.filteredProjects, function(p) {
        return p.is_test === false;
      });
    }
    $scope.filteredProjects = $filter("projectText")($scope.filteredProjects, $scope.filters.search_term);
    $scope.filteredProjects = filterByInstallStatus($scope.filteredProjects, $scope.filters.install_status);
    $scope.filteredProjects = filterBySellingMethod($scope.filteredProjects, $scope.filters.selling_method);
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse);
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse);
    SearchFilter.set($scope.filters);
    return SearchFilter.updateComponentDefaults('masterProjectsList');
  };
  filterByInstallStatus = function(projects, install_status) {
    return _.filter(projects, function(project) {
      if (install_status === 'all') {
        return true;
      }
      return project.install_status === install_status;
    });
  };
  filterBySellingMethod = function(projects, selling_method) {
    return _.filter(projects, function(project) {
      if (selling_method === 'all') {
        return true;
      }
      if (selling_method === 'direct_sales') {
        return project.agency_id === 5;
      }
      if (selling_method === 'make_repeater') {
        return project.agency_id === 9;
      }
      if (selling_method === 'agencies') {
        return project.agency_id !== 5 && project.agency_id !== 9;
      }
    });
  };
  $scope.updateData = function() {
    var apikeyChunks, apikeys, promises;
    SearchFilter.set($scope.filters);
    apikeys = _.map($scope.projects, function(p) {
      return p.apikey;
    });
    apikeyChunks = _.chunk(apikeys, 50);
    promises = _.map(apikeyChunks, function(apikeyChunk) {
      return ProjectStats.getDailyProjectStats({
        apikey: {
          $in: apikeyChunk
        },
        start_at: {
          $gte: moment($scope.filters.start_at).toDate(),
          $lt: moment($scope.filters.end_at).add(1, 'day').toDate()
        }
      });
    });
    return $q.all(promises).then(function(results) {
      var i, len, project, ref, statsByApikey;
      statsByApikey = _.reduce(results, (function(_this) {
        return function(chunk, obj) {
          return _.merge(obj, chunk);
        };
      })(this), {});
      ref = $scope.projects;
      for (i = 0, len = ref.length; i < len; i++) {
        project = ref[i];
        project.stats = statsByApikey[project.apikey];
      }
      return $scope.filterProjects();
    });
  };
  setInstallationStatus = function(project) {
    if (!project.companyinfo_confirmed_at) {
      project.install_status = "companyinfo_confirmed_at";
      return project.install_status_pending_time = calculatePendingDate(project.created_at);
    } else if (!project.siteinfo_confirmed_at) {
      project.install_status = "siteinfo_confirmed_at";
      return project.install_status_pending_time = calculatePendingDate(project.companyinfo_confirmed_at);
    } else if (!project.tracking_tag_confirmed_at) {
      project.install_status = "tracking_tag_confirmed_at";
      return project.install_status_pending_time = calculatePendingDate(project.siteinfo_confirmed_at);
    } else if (!project.conversion_tag_confirmed_at) {
      project.install_status = "conversion_tag_confirmed_at";
      return project.install_status_pending_time = calculatePendingDate(project.tracking_tag_confirmed_at);
    } else {
      return project.install_status = "complete";
    }
  };
  setOperationStatus = function(project) {
    var first_campaign_start_at, last_campaign_end_at;
    if (!project.conversion_tag_confirmed_at) {
      return;
    }
    first_campaign_start_at = ZcsKpi.firstCampaignStartAt(project.started_campaigns);
    last_campaign_end_at = ZcsKpi.lastCampaignEndAt(project.started_campaigns);
    if (!first_campaign_start_at) {
      project.operation_status = 'before_first_campaign_start';
      return project.operation_status_pending_time = calculatePendingDate(project.conversion_tag_confirmed_at);
    } else if (last_campaign_end_at.isBefore(moment())) {
      project.operation_status = 'after_last_campaign_end';
      return project.operation_status_pending_time = calculatePendingDate(last_campaign_end_at);
    } else {
      return project.operation_status = 'current_campaign_in_delivery';
    }
  };
  calculatePendingDate = function(date) {
    var from, to;
    from = moment();
    to = moment(date);
    return from.diff(to, 'days');
  };
  $scope.checkPendingDate = function(pending_date) {
    if (pending_date > PENDING_DATE) {
      return true;
    }
  };
  $scope.checkIsAssignee = function(project) {
    var ref, user;
    return ref = Devise.currentUser.email, indexOf.call((function() {
      var i, len, ref1, results1;
      ref1 = project.users;
      results1 = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        user = ref1[i];
        results1.push(user.email);
      }
      return results1;
    })(), ref) >= 0;
  };
  $scope.assignCurrentUser = function(project) {
    return MasterProject.assign({
      projectId: project.id
    }, {
      userId: Devise.currentUser.id
    }).then(function() {
      project.users.push(Devise.currentUser);
      return project.isAssignee = $scope.checkIsAssignee(project);
    });
  };
  $scope.unassignCurrentUser = function(project) {
    return MasterProject.unassign({
      projectId: project.id
    }, {
      userId: Devise.currentUser.id
    }).then(function() {
      _.remove(project.users, function(user) {
        return user.email === Devise.currentUser.email;
      });
      return project.isAssignee = $scope.checkIsAssignee(project);
    });
  };
  return MasterProject.all().then(function(allProjects) {
    var i, len, project, ref;
    $scope.projects = _.filter(allProjects, function(p) {
      return p.product_line === 'zenclerk_s';
    });
    ref = $scope.projects;
    for (i = 0, len = ref.length; i < len; i++) {
      project = ref[i];
      setOperationStatus(project);
      setInstallationStatus(project);
    }
    $scope.filterProjects();
    return $scope.updateData();
  });
}]);


/***/ }),
/* 1327 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteProjects').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.zcliteProjects', {
    url: '/zclite_projects',
    views: {
      'content@': {
        templateUrl: '/templates/master.zclite_projects/list.html',
        controller: 'MasterZcliteProjectsListCtrl'
      }
    }
  });
}]);


/***/ }),
/* 1328 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteProjectsForReview').controller('MasterZcliteProjectsListForReviewCtrl', ["$q", "$scope", "$translate", "Page", "MasterProject", "SearchFilter", function($q, $scope, $translate, Page, MasterProject, SearchFilter) {
  var updateProject;
  Page.setBodyClass('');
  $translate('masterZclite.projectsForReview.list.siteList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.projects = [];
  $scope.filteredProjects = [];
  $scope.filters = {};
  $scope.filters.sort_prop = "reviewed_at";
  $scope.filters.sort_direction = "desc";
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterProjectsList');
  });
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction === 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterProjects();
  };
  $scope.filterProjects = function() {
    $scope.filteredProjects = _.chain($scope.projects).filter({
      is_demo: false,
      is_test: false,
      is_oem: false
    }).orderBy($scope.filters.sort_prop, $scope.filters.sort_direction).value();
    return SearchFilter.updateComponentDefaults('masterProjectsList');
  };
  updateProject = function() {
    return MasterProject.all().then(function(allProjects) {
      $scope.projects = _.filter(allProjects, function(p) {
        return p.product_line === 'zenclerk_s';
      });
      return $scope.filterProjects();
    });
  };
  updateProject();
  $scope.completeReview = function(project_id) {
    return MasterProject.update({
      projectId: project_id
    }, {
      project: {
        reviewed: true
      }
    }).then(function(res) {
      return updateProject();
    });
  };
  return $scope.completeCredit = function(project_id) {
    return MasterProject.update({
      projectId: project_id
    }, {
      project: {
        credit: true
      }
    }).then(function(res) {
      return updateProject();
    });
  };
}]);


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteProjectsForReview').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.zcliteProjectsForReview', {
    url: '/zclite_projects_for_review',
    views: {
      'content@': {
        templateUrl: '/templates/master.zclite_projects_for_review/list.html',
        controller: 'MasterZcliteProjectsListForReviewCtrl'
      }
    }
  });
}]);


/***/ }),
/* 1330 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteReports').controller('MasterZcliteReportsListCtrl', ["$scope", "$translate", "Page", "SearchFilter", "MasterInvoiceAdjustment", "cronHours", function($scope, $translate, Page, SearchFilter, MasterInvoiceAdjustment, cronHours) {
  var aggregateBaseTime, getInvoiceAdjustments, maxPeriod;
  Page.setBodyClass('');
  $translate('masterZclite.reports.list.siteList').then(function(translation) {
    return Page.setTitle(translation);
  });
  $scope.projects = [];
  $scope.filteredInvoiceAdjustments = [];
  $scope.filters = [];
  $scope.filters.sort_prop = "id";
  $scope.filters.sort_direction = "desc";
  aggregateBaseTime = moment().subtract(cronHours.dailyReport, 'hours');
  $scope.currentPeriod = moment(aggregateBaseTime).startOf('month').toDate();
  maxPeriod = moment(aggregateBaseTime).subtract(1, 'days').startOf('month').toDate();
  $scope.nextMonth = function() {
    if ($scope.currentPeriod >= maxPeriod) {
      return;
    }
    $scope.currentPeriod = moment($scope.currentPeriod).add(1, 'month').toDate();
    return getInvoiceAdjustments();
  };
  $scope.prevMonth = function() {
    $scope.currentPeriod = moment($scope.currentPeriod).subtract(1, 'month').toDate();
    return getInvoiceAdjustments();
  };
  $scope.$on('$destroy', function() {
    return SearchFilter.removeComponentDefaults('masterProjectsList');
  });
  $scope.setSortProp = function(key) {
    if ($scope.filters.sort_prop === key) {
      if ($scope.filters.sort_direction === 'desc') {
        $scope.filters.sort_direction = 'asc';
      } else {
        $scope.filters.sort_direction = 'desc';
      }
    } else {
      $scope.filters.sort_prop = key;
      $scope.filters.sort_direction = 'desc';
    }
    return $scope.filterInvoiceAdjustments();
  };
  $scope.filterInvoiceAdjustments = function() {
    $scope.filteredInvoiceAdjustments = _.chain($scope.invoice_adjustments).filter(function(adjustment) {
      var ref;
      if (adjustment.project.is_test || adjustment.project.is_demo) {
        return false;
      }
      return ($scope.currentPeriod <= (ref = moment(adjustment.adjustment_date).toDate()) && ref < moment($scope.currentPeriod).add(1, 'month').toDate());
    }).orderBy($scope.filters.sort_prop, $scope.filters.sort_direction).value();
    return SearchFilter.updateComponentDefaults('masterProjectsList');
  };
  getInvoiceAdjustments = function() {
    return MasterInvoiceAdjustment.all().then(function(res) {
      $scope.invoice_adjustments = res;
      return $scope.filterInvoiceAdjustments();
    });
  };
  getInvoiceAdjustments();
  $scope.completeAudit = function(id) {
    return MasterInvoiceAdjustment.update(id, {
      invoice_adjustment: {
        audited: true
      }
    }).then(function(res) {
      return getInvoiceAdjustments();
    });
  };
  return $scope.deleteInvoiceAdjustment = function(id) {
    return MasterInvoiceAdjustment.destroy(id).then(function(res) {
      return getInvoiceAdjustments();
    });
  };
}]);


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

angular.module('zc.master.zcliteReports').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master.zcliteReports', {
    url: '/zclite_reports',
    views: {
      'content@': {
        templateUrl: '/templates/master.zclite_reports/list.html',
        controller: 'MasterZcliteReportsListCtrl'
      }
    }
  });
}]);


/***/ }),
/* 1332 */
/***/ (function(module, exports) {

angular.module('zc.master').directive('zcLabelUserAgency', ["$state", "Devise", function($state, Devise) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {
      user: '='
    },
    template: '<span\n  class="label label-warning"\n  ng-if="user.agency_id">\n  {{user.agency.title}}\n</span>'
  };
  return directive;
}]);


/***/ }),
/* 1333 */
/***/ (function(module, exports) {

angular.module('zc.master').directive('zcLabelUserRole', ["$state", "Devise", function($state, Devise) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {
      user: '='
    },
    template: '<span\n  class="label label-danger"\n  ng-if="user.role === \'master\'">\n  {{user.role}}\n</span>\n<span\n  class="label label-success"\n  ng-if="user.role === \'common\'">\n  {{user.role}}\n</span>\n<span\n  class="label label-info"\n  ng-if="user.role === \'internal\'">\n  {{user.role}}\n</span>'
  };
  return directive;
}]);


/***/ }),
/* 1334 */
/***/ (function(module, exports) {

angular.module('zc.master').directive('masterMenu', ["$state", "Devise", function($state, Devise) {
  var directive;
  directive = {
    restrict: "EA",
    scope: {},
    replace: true,
    templateUrl: '/templates/master/views/directives/master_menu.html',
    link: function(scope, elem, attrs) {
      scope.Devise = Devise;
      return scope.signOut = Devise.signOut;
    }
  };
  return directive;
}]);


/***/ }),
/* 1335 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.master').component('projectLinkTooltip', {
  require: '?value',
  bindings: {
    currentProjects: '<',
    previousProjects: '<',
    placement: '@'
  },
  transclude: true,
  template: "<span\n  ng-if=\"!$ctrl.currentProjects.length && !$ctrl.previousProjects.length\"\n  ng-transclude>\n</span>\n<a\n  tooltip-html-unsafe=\"{{$ctrl.html}}\"\n  tooltip-placement=\"{{$ctrl.placement || 'top'}}\"\n  tooltip-trigger=\"click\"\n  ng-transclude\n  ng-if=\"$ctrl.currentProjects.length || $ctrl.previousProjects.length\">\n</a>",
  controller: ["$scope", "$q", "$translate", "Meta", function($scope, $q, $translate, Meta) {
    var $ctrl, difference, generateHtml, generateProjectLink;
    $ctrl = this;
    generateHtml = function(currentProjects, previousProjects) {
      var decreased_projects, html, increased_projects, project, promises;
      html = '';
      promises = {};
      increased_projects = difference(currentProjects, previousProjects);
      if (increased_projects.length) {
        promises.increased_projects = $q.all((function() {
          var i, len, results;
          results = [];
          for (i = 0, len = increased_projects.length; i < len; i++) {
            project = increased_projects[i];
            results.push(generateProjectLink(project));
          }
          return results;
        })());
      }
      decreased_projects = difference(previousProjects, currentProjects);
      if (decreased_projects.length) {
        promises.decreased_projects = $q.all((function() {
          var i, len, results;
          results = [];
          for (i = 0, len = decreased_projects.length; i < len; i++) {
            project = decreased_projects[i];
            results.push(generateProjectLink(project));
          }
          return results;
        })());
      }
      return $q.all(promises).then(function(arg) {
        var decreased_projects, increased_projects;
        increased_projects = arg.increased_projects, decreased_projects = arg.decreased_projects;
        if (increased_projects) {
          html += "<p class=\"text-left\">\n  " + ($translate.instant('master.directives.projectsLinkTooltip.siteIncreasePreviousMonth')) + "<br>\n  " + (increased_projects.join('<br>')) + "\n</p>";
        }
        if (decreased_projects) {
          html += "<p class=\"text-left\">\n  " + ($translate.instant('master.directives.projectsLinkTooltip.siteReducedPreviousMonth')) + "<br>\n  " + (decreased_projects.join('<br>')) + "\n</p>";
        }
        return html;
      });
    };
    difference = function(projects1, projects2) {
      var diff, diff_apikeys, i, len, project, projects1_apikeys, projects2_apikeys, ref;
      projects1_apikeys = projects1.map(function(project) {
        return project.apikey;
      });
      projects2_apikeys = projects2.map(function(project) {
        return project.apikey;
      });
      diff_apikeys = _.difference(projects1_apikeys, projects2_apikeys);
      diff = [];
      for (i = 0, len = projects1.length; i < len; i++) {
        project = projects1[i];
        if (ref = project.apikey, indexOf.call(diff_apikeys, ref) < 0) {
          continue;
        }
        diff.push(project);
      }
      return diff;
    };
    generateProjectLink = function(project) {
      return Meta.getServices().then(function(services) {
        return "<a\n  href=\"" + services.zcs + "sites/" + project.apikey + "\"\n  target=\"_blank\">\n  " + project.apikey + "\n</a>";
      });
    };
    $ctrl.$onInit = function() {
      return $scope.$watchGroup(['$ctrl.currentProjects', '$ctrl.previousProjects'], function(arg) {
        var currentProjects, previousProjects;
        currentProjects = arg[0], previousProjects = arg[1];
        if (!(currentProjects && previousProjects)) {
          return;
        }
        return generateHtml(currentProjects, previousProjects).then(function(html) {
          return $ctrl.html = html;
        });
      }, true);
    };
  }]
});


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

angular.module('zc.master').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('admin.master', {
    abstract: true,
    url: '/master'
  });
}]);


/***/ }),
/* 1337 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory('MasterInvoiceAdjustment', ["$q", "Api", function($q, Api) {
  var MasterInvoiceAdjustment;
  return MasterInvoiceAdjustment = (function() {
    function MasterInvoiceAdjustment() {}

    MasterInvoiceAdjustment.all = function() {
      return Api.get('/api/master/invoice_adjustments').then(function(res) {
        if (res.data.success) {
          return res.data.invoice_adjustments;
        } else {
          return $q.reject(res);
        }
      });
    };

    MasterInvoiceAdjustment.update = function(adjustment_id, params) {
      return Api.patch("/api/master/invoice_adjustments/" + adjustment_id, params, {
        cache: false
      }).then(function(res) {
        if (res.data.success) {
          return res.data.invoice_adjustments;
        } else {
          return $q.reject(res);
        }
      });
    };

    MasterInvoiceAdjustment.destroy = function(adjustment_id, params) {
      return Api["delete"]("/api/master/invoice_adjustments/" + adjustment_id, params, {
        cache: false
      }).then(function(res) {
        if (res.data.success) {
          return res.data.invoice_adjustment;
        } else {
          return $q.reject(res);
        }
      });
    };

    return MasterInvoiceAdjustment;

  })();
}]);


/***/ }),
/* 1338 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory('MasterAgency', ["$q", "Api", function($q, Api) {
  var MasterAgency;
  return MasterAgency = (function() {
    function MasterAgency() {}

    MasterAgency.all = function() {
      return Api.get('/api/master/agencies').then(function(res) {
        if (res.data.success) {
          return res.data.agencies;
        } else {
          return $q.reject(res);
        }
      });
    };

    MasterAgency.get = function(params) {
      return Api.get("/api/master/agencies/" + params.id, {}, {
        cache: false
      }).then(function(res) {
        if (res.data.success) {
          return res.data.agency;
        } else {
          return $q.reject(res);
        }
      });
    };

    MasterAgency.update = function(params) {
      return Api.patch("/api/master/agencies/" + params.id, params, {
        cache: false
      });
    };

    MasterAgency.create = function(params) {
      return Api.post("/api/master/agencies", params, {
        cache: false
      });
    };

    return MasterAgency;

  })();
}]);


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory('MasterAgencyUser', ["$q", "Api", function($q, Api) {
  var MasterAgencyUser;
  return MasterAgencyUser = (function() {
    function MasterAgencyUser() {}

    MasterAgencyUser.all = function(agency_id) {
      return Api.get("/api/master/agencies/" + agency_id + "/users", {}, {
        cache: false
      }).then(function(res) {
        if (res.data.success) {
          return res.data.users;
        } else {
          return $q.reject(res);
        }
      });
    };

    return MasterAgencyUser;

  })();
}]);


/***/ }),
/* 1340 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterCampaign", ["$resource", "Api", "$q", "campaignServiceResponseTransformer", function($resource, Api, $q, campaignServiceResponseTransformer) {
  var MasterCampaign, service;
  MasterCampaign = $resource(Api.path("/api/master/campaigns/:campaignId"), {
    scope: this.scope
  }, {
    get: {
      campaignId: '@id'
    },
    query: {
      method: 'GET',
      transformResponse: campaignServiceResponseTransformer,
      isArray: false
    }
  });
  service = {
    all: function(params) {
      var d;
      d = $q.defer();
      MasterCampaign.query(params).$promise.then(function(res) {
        return d.resolve(res.campaigns);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    get: function(params) {
      var d;
      d = $q.defer();
      MasterCampaign.get(params).$promise.then(function(res) {
        var campaign, i, k, len, query, ref, v;
        campaign = res.campaign;
        campaign.public_api_json = res.public_api_json;
        ref = campaign.public_api_json;
        for (i = 0, len = ref.length; i < len; i++) {
          query = ref[i];
          delete query.segment;
          delete query.raw;
          for (k in query) {
            v = query[k];
            if (v === null) {
              query[k] = "null";
            }
          }
        }
        return d.resolve(campaign);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    search: function(options) {
      return $q(function(resolve, reject) {
        return Api.get("/api/master/campaigns/search", options).then(function(res) {
          if (!res.data.success) {
            return reject(null);
          } else {
            return resolve(res.data.campaigns);
          }
        }, function(err) {
          return reject(err);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterCampaignPolicySet", ["$resource", "$q", "$stateParams", "Api", function($resource, $q, $stateParams, Api) {
  var MasterCampaignPolicySet, service;
  MasterCampaignPolicySet = $resource(Api.path("/api/master/projects/:projectId/campaign_policy_sets/:campaignPolicySetId"), {
    get: {
      projectId: '@id'
    }
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    update: {
      method: 'PATCH'
    },
    destroy: {
      method: 'DELETE'
    }
  });
  service = {
    all: function(projectId) {
      var d;
      d = $q.defer();
      MasterCampaignPolicySet.query({
        projectId: projectId
      }, function(res) {
        if (res.success) {
          return d.resolve(res.campaign_policy_sets);
        } else {
          return d.reject(null);
        }
      });
      return d.promise;
    },
    destroy: function(projectId, policySetId) {
      var d;
      d = $q.defer();
      MasterCampaignPolicySet.destroy({
        projectId: projectId,
        campaignPolicySetId: policySetId
      }, function(res) {
        if (res.success) {
          return d.resolve(res);
        } else {
          return d.reject(null);
        }
      });
      return d.promise;
    }
  };
  return service;
}]);


/***/ }),
/* 1342 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterProject", ["$resource", "$q", "$stateParams", "Api", "Facade", "projectServiceResponseTransformer", "projectServiceRequestTransformer", function($resource, $q, $stateParams, Api, Facade, projectServiceResponseTransformer, projectServiceRequestTransformer) {
  var MasterProject, service;
  MasterProject = $resource(Api.path("/api/master/projects/:projectId"), {
    get: {
      projectId: '@id'
    }
  }, {
    query: {
      method: 'GET',
      transformResponse: projectServiceResponseTransformer,
      isArray: false
    },
    get: {
      transformResponse: projectServiceResponseTransformer,
      isArray: false
    },
    create: {
      method: 'POST'
    },
    update: {
      method: 'PATCH',
      transformRequest: projectServiceRequestTransformer,
      transformResponse: projectServiceResponseTransformer
    },
    'delete': {
      method: 'DELETE'
    }
  });
  service = {
    projectRanks: void 0,
    create: function(project) {
      return $q(function(resolve, reject) {
        return MasterProject.create(project).$promise.then(function(res) {
          return resolve(res.project);
        }, function(err) {
          return reject(err);
        });
      });
    },
    update: function(params, project) {
      var d;
      d = $q.defer();
      MasterProject.update(params, project).$promise.then(function(res) {
        if (res.success) {
          return d.resolve(res.project);
        } else {
          return d.reject({});
        }
      });
      return d.promise;
    },
    remove: function(params) {
      return MasterProject["delete"](params).$promise;
    },
    all: function() {
      var d;
      d = $q.defer();
      MasterProject.query().$promise.then(function(res) {
        service.projects = res.projects;
        return d.resolve(res.projects);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    addInterestTreeStatus: function(projects) {
      var d;
      d = $q.defer();
      Facade.request('/master/interest_trees/statuses').then(function(res) {
        var i, len, project, statuses;
        if (!res.data.success) {
          d.reject(projects);
        }
        statuses = res.data.statuses;
        for (i = 0, len = projects.length; i < len; i++) {
          project = projects[i];
          project.interest_tree_status = statuses[project.apikey];
        }
        return d.resolve(projects);
      });
      return d.promise;
    },
    get: function(projectId) {
      var d;
      d = $q.defer();
      MasterProject.get({
        projectId: projectId
      }).$promise.then(function(res) {
        if (res.project) {
          return d.resolve(res.project);
        } else {
          return d.reject();
        }
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    search: function(options) {
      return $q(function(resolve, reject) {
        return Api.get("/api/master/projects/search", options).then(function(res) {
          if (!res.data.success) {
            return reject(null);
          } else {
            return resolve(res.data.projects);
          }
        }, function(err) {
          return reject(err);
        });
      });
    },
    getProjectRanks: function(rank) {
      return $q(function(resolve, reject) {
        return Api.get("/api/master/projects/project_ranks", {}, {
          cache: true
        }).then(function(res) {
          service.projectRanks = res.data;
          return resolve(service.projectRanks);
        }, function(err) {
          return reject(err);
        });
      });
    },
    assign: function(params, user) {
      return Api.patch("/api/master/projects/" + params.projectId + "/assign", user);
    },
    unassign: function(params, user) {
      return Api.patch("/api/master/projects/" + params.projectId + "/unassign", user);
    },
    generateProjectApikey: function(site_url) {
      return $q(function(resolve, reject) {
        return Api.get("/api/master/projects/project_apikey?site_url=" + site_url).then(function(res) {
          if (!res.data.success) {
            return reject(null);
          } else {
            return resolve(res.data.project_apikey);
          }
        }, function(err) {
          return reject(err);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory('MasterUser', ["$q", "$resource", "Api", function($q, $resource, Api) {
  var MasterUser, service;
  MasterUser = $resource(Api.path("/api/master/users"), {}, {
    all: {
      method: 'GET',
      isArray: false
    }
  });
  service = {
    all: function(params) {
      var d;
      d = $q.defer();
      MasterUser.all(params).$promise.then(function(res) {
        return d.resolve(res);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    }
  };
  return service;
}]);


/***/ }),
/* 1344 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.masterApi').factory("MasterProjectParticularEvent", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var MasterProjectParticularEvent;
  MasterProjectParticularEvent = (function(superClass) {
    extend(MasterProjectParticularEvent, superClass);

    function MasterProjectParticularEvent() {
      return MasterProjectParticularEvent.__super__.constructor.apply(this, arguments);
    }

    return MasterProjectParticularEvent;

  })(BaseProjectCrudService);
  return new MasterProjectParticularEvent($resource, $q, "/api/master/projects/:projectId/particular_events/:id", "particular_event", "particular_events");
}]);


/***/ }),
/* 1345 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.masterApi').factory("MasterProjectSegmentCookie", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var MasterProjectSegmentCookie;
  MasterProjectSegmentCookie = (function(superClass) {
    extend(MasterProjectSegmentCookie, superClass);

    function MasterProjectSegmentCookie() {
      return MasterProjectSegmentCookie.__super__.constructor.apply(this, arguments);
    }

    return MasterProjectSegmentCookie;

  })(BaseProjectCrudService);
  return new MasterProjectSegmentCookie($resource, $q, "/api/master/projects/:projectId/segment_cookies/:id", "segment_cookie", "segment_cookies");
}]);


/***/ }),
/* 1346 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterAccessStats", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MasterAccessStats;
  MasterAccessStats = (function() {
    function MasterAccessStats() {}

    MasterAccessStats.find = function(query, opts) {
      if (opts == null) {
        opts = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!(query._id || (query.apikey && query.start_at))) {
          return reject("no _id or apikey/start_at provided");
        }
        return FacadeV2.request("/master/access_stats/daily", {
          params: {
            match: query,
            sort: '-start_at',
            limit: opts.limit || void 0
          }
        }).then(function(res) {
          if (res.status !== 200) {
            return reject(res.data.error);
          }
          return resolve(res.data);
        });
      });
    };

    MasterAccessStats.aggregate = function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/master/access_stats/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return MasterAccessStats;

  })();
  return MasterAccessStats;
}]);


/***/ }),
/* 1347 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterCampaignSegmentStats", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MasterCampaignSegmentStats;
  MasterCampaignSegmentStats = (function() {
    function MasterCampaignSegmentStats() {}

    MasterCampaignSegmentStats.find = function(query, opts) {
      if (opts == null) {
        opts = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!(query._id || (query.apikey && query.start_at))) {
          return reject("no _id or apikey/start_at provided");
        }
        return FacadeV2.request("/master/campaign_segment_stats/daily", {
          params: {
            match: query,
            sort: '-start_at',
            limit: opts.limit || void 0
          }
        }).then(function(res) {
          if (res.status !== 200) {
            return reject(res.data.error);
          }
          return resolve(res.data);
        });
      });
    };

    MasterCampaignSegmentStats.aggregate = function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/master/campaign_segment_stats/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return MasterCampaignSegmentStats;

  })();
  return MasterCampaignSegmentStats;
}]);


/***/ }),
/* 1348 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterCampaignStats", ["$q", "Facade", "CampaignStats", "lib", function($q, Facade, CampaignStats, lib) {
  var MasterCampaignStats;
  MasterCampaignStats = (function() {
    var controlPercent, controlPercentChisq, controlPercentChisqP, defaultStats;

    function MasterCampaignStats(dimension) {
      this.dimension = dimension;
    }

    MasterCampaignStats.prototype.find = function(params) {
      var d;
      d = $q.defer();
      Facade.request("/master/campaign_stats/" + this.dimension, {
        params: {
          json: params
        },
        transformResponse: this.transformCampaignStats
      }).then((function(_this) {
        return function(res) {
          return d.resolve(res.data.campaign_stats);
        };
      })(this));
      return d.promise;
    };

    MasterCampaignStats.prototype.aggregate = function(params) {
      var d;
      d = $q.defer();
      Facade.request("/master/campaign_stats/" + this.dimension + "/aggregate", {
        params: {
          json: params
        },
        transformResponse: this.transformCampaignStats
      }).then((function(_this) {
        return function(res) {
          return d.resolve(res.data.campaign_stats);
        };
      })(this));
      return d.promise;
    };

    MasterCampaignStats.prototype.transformCampaignStats = function(json) {
      var data, i, len, ref, stats;
      try {
        data = angular.fromJson(json);
        ref = data.campaign_stats;
        for (i = 0, len = ref.length; i < len; i++) {
          stats = ref[i];
          if (stats.delivery_count === 0) {
            stats.conversion_rate = 0;
          } else {
            stats.conversion_rate = stats.conversion_count / stats.delivery_count;
          }
          if (stats.conversion_count === 0) {
            stats.average_conversion_price = 0;
            stats.campaign_coupon_used_rate = 0;
          } else {
            stats.average_conversion_price = stats.conversion_price / stats.conversion_count;
            stats.campaign_coupon_used_rate = stats.campaign_coupon_used_count / stats.conversion_count;
          }
        }
        return {
          success: true,
          campaign_stats: data.campaign_stats
        };
      } catch (error) {
        return {};
      }
    };

    MasterCampaignStats.statsById = function(campaign_stats) {
      var group, i, len, stats, statsById;
      statsById = {};
      for (i = 0, len = campaign_stats.length; i < len; i++) {
        stats = campaign_stats[i];
        if (!statsById[stats.campaign_id]) {
          statsById[stats.campaign_id] = defaultStats();
        }
        group = stats.is_control ? 'control' : 'experimental';
        statsById[stats.campaign_id][group] = stats;
      }
      return statsById;
    };

    MasterCampaignStats.calculate = function(stats) {
      if (stats.experimental.conversion_rate === 0) {
        stats.conversion_lift_rate = 0;
      } else {
        stats.conversion_lift_rate = (stats.experimental.conversion_rate - stats.control.conversion_rate) / stats.experimental.conversion_rate;
      }
      if (stats.control.conversion_rate === 0) {
        stats.conversion_up_rate = 0;
      } else {
        stats.conversion_up_rate = stats.experimental.conversion_rate / stats.control.conversion_rate;
      }
      if (stats.control.average_conversion_price === 0) {
        stats.price_up_rate = 0;
      } else {
        stats.price_up_rate = stats.experimental.average_conversion_price / stats.control.average_conversion_price;
      }
      stats.contribution_price = _.max([lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_price), 0]);
      stats.contribution_count = _.max([lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_count), 0]);
      return stats.control_percent = controlPercent(stats);
    };

    MasterCampaignStats.chisq = function(stats, control_percent) {
      stats.chisq_p = CampaignStats.chisqP(stats);
      return stats.control_percent_chisq_p = controlPercentChisqP(stats, control_percent);
    };

    defaultStats = function() {
      return {
        control: {
          delivery_count: 0,
          conversion_count: 0,
          conversion_price: 0,
          conversion_rate: 0,
          average_conversion_price: 0,
          campaign_coupon_used_count: 0,
          campaign_coupon_used_rate: 0
        },
        experimental: {
          delivery_count: 0,
          conversion_count: 0,
          conversion_price: 0,
          conversion_rate: 0,
          average_conversion_price: 0,
          campaign_coupon_used_count: 0,
          campaign_coupon_used_rate: 0
        }
      };
    };

    controlPercent = function(stats) {
      var total_delivery_count;
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count;
      if (total_delivery_count === 0) {
        return 0;
      }
      return stats.control.delivery_count / total_delivery_count * 100;
    };

    controlPercentChisqP = function(stats, control_percent) {
      return ZCStats.chisqdist(1, controlPercentChisq(stats, control_percent));
    };

    controlPercentChisq = function(stats, control_percent) {
      var control, control_expectation, experimental, experimental_expectation, total_delivery_count;
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count;
      control_expectation = total_delivery_count * control_percent / 100;
      if (control_expectation === 0) {
        return 0;
      }
      experimental_expectation = total_delivery_count - control_expectation;
      if (experimental_expectation === 0) {
        return 0;
      }
      experimental = (Math.pow(stats.experimental.delivery_count - experimental_expectation, 2)) / experimental_expectation;
      control = (Math.pow(stats.control.delivery_count - control_expectation, 2)) / control_expectation;
      return experimental + control;
    };

    return MasterCampaignStats;

  })();
  return MasterCampaignStats;
}]);


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterMongoSession", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MasterMongoSession;
  MasterMongoSession = (function() {
    function MasterMongoSession() {}

    MasterMongoSession.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!(query._id || (query.apikey && query.opened_at) || (query.apikey && options.sort && options.sort.indexOf("opened_at") >= 0))) {
          return reject("no _id or apikey/opened_at provided");
        }
        return FacadeV2.request("/master/sessions", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000
          }
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          }
          return resolve(res.data);
        });
      });
    };

    return MasterMongoSession;

  })();
  return MasterMongoSession;
}]);


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory("MasterMongoVisitor", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MasterMongoVisitor;
  MasterMongoVisitor = (function() {
    function MasterMongoVisitor() {}

    MasterMongoVisitor.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query._id) {
          return reject("no _id");
        }
        return FacadeV2.request("/master/visitors", {
          params: {
            match: query,
            limit: options.limit || 1000
          }
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MasterMongoVisitor;

  })();
  return MasterMongoVisitor;
}]);


/***/ }),
/* 1351 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory('MasterReportStats', ["$q", "Facade", "MasterProject", "reportStatsResponseTransformer", function($q, Facade, MasterProject, reportStatsResponseTransformer) {
  var MasterReportStats;
  MasterReportStats = {
    find: function(params) {
      return $q(function(resolve) {
        return Facade.request("/master/report_stats/" + params.dimension, {
          params: {
            json: params
          },
          transformResponse: reportStatsResponseTransformer
        }).then((function(_this) {
          return function(res) {
            return resolve(res.data.report_stats);
          };
        })(this));
      });
    },
    forCSV: function(report_stats) {
      return $q(function(resolve, reject) {
        return MasterProject.all().then(function(projects) {
          var apikey, apikeyStats, date, i, j, last_contribution_price, len, len1, project, ref, sortedStats, stats, statsByApikey, statsByStatus, statsForCSV, status;
          statsByStatus = _.groupBy(report_stats, "status");
          statsByApikey = _.groupBy(statsByStatus[null], 'apikey');
          statsForCSV = {};
          for (apikey in statsByApikey) {
            apikeyStats = statsByApikey[apikey];
            project = _.find(projects, function(p) {
              return p.apikey === apikey;
            });
            if (!project) {
              continue;
            }
            sortedStats = _.sortBy(apikeyStats, 'start_at');
            apikeyStats = _.last(sortedStats);
            last_contribution_price = 0;
            for (i = 0, len = sortedStats.length; i < len; i++) {
              stats = sortedStats[i];
              date = moment(stats.start_at).format('YYYY/M/D');
              apikeyStats[date] = stats.contribution_price - last_contribution_price;
              last_contribution_price = stats.contribution_price;
            }
            statsForCSV[apikey] = _.merge({}, project, apikeyStats);
            statsForCSV[apikey].campaign_count = statsForCSV[apikey].campaign_ids.length;
            MasterReportStats.calculateInvoiceAmountRate(statsForCSV[apikey]);
            MasterReportStats.calculateGoalPercentage(statsForCSV[apikey], project);
          }
          for (apikey in statsForCSV) {
            stats = statsForCSV[apikey];
            ref = ["trial", "contracted"];
            for (j = 0, len1 = ref.length; j < len1; j++) {
              status = ref[j];
              stats[status] = _.chain(statsByStatus[status]).filter(function(d) {
                return d.apikey === apikey;
              }).sortBy('start_at').last().value();
            }
            if (stats[status]) {
              MasterReportStats.calculateInvoiceAmountRate(stats[status]);
            }
            if (stats[status]) {
              MasterReportStats.calculateGoalPercentage(stats[status], project);
            }
          }
          return resolve(statsForCSV);
        });
      });
    },
    calculateInvoiceAmountRate: function(report) {
      if (!report) {
        return;
      }
      if (report.access_conversion_price === 0) {
        return report.invoice_amount_rate = 0;
      } else {
        return report.invoice_amount_rate = report.invoice_amount / report.access_conversion_price;
      }
    },
    calculateGoalPercentage: function(report, project) {
      if (project.project_rank && project.project_rank !== 'unknown') {
        if ((report.access_conversion_price * MasterProject.projectRanks[project.project_rank].goal) === 0) {
          return report.goal_percentage = 0;
        } else {
          return report.goal_percentage = report.invoice_amount / (report.access_conversion_price * MasterProject.projectRanks[project.project_rank].goal) * 100;
        }
      }
    }
  };
  return MasterReportStats;
}]);


/***/ }),
/* 1352 */
/***/ (function(module, exports) {

angular.module('zc.masterApi').factory('ZcsKpi', ["$q", "MasterAccessStats", "MasterCampaignStats", function($q, MasterAccessStats, MasterCampaignStats) {
  var ZcsKpi;
  return ZcsKpi = (function() {
    var INSTALLATION_STEPS, calculateConversionCoverRate, calculateSessionCoverRate;

    INSTALLATION_STEPS = ['siteinfo_confirmed', 'conversion_tag_confirmed', 'first_campaign_start'];

    ZcsKpi.firstCampaignStartAt = function(campaigns) {
      var campaign, start_ats;
      start_ats = (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = campaigns.length; j < len; j++) {
          campaign = campaigns[j];
          results1.push(moment(campaign.start_at));
        }
        return results1;
      })();
      if (start_ats.length) {
        return moment.min(start_ats);
      } else {
        return null;
      }
    };

    ZcsKpi.lastCampaignEndAt = function(campaigns) {
      var campaign, end_ats;
      end_ats = (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = campaigns.length; j < len; j++) {
          campaign = campaigns[j];
          results1.push(moment(campaign.end_at));
        }
        return results1;
      })();
      if (end_ats.length) {
        return moment.max(end_ats);
      } else {
        return null;
      }
    };

    function ZcsKpi(projects, start_at) {
      this.start_at = moment(start_at);
      this.end_at = moment(this.start_at).add(1, 'month');
      this.projects = _.filter(projects, (function(_this) {
        return function(project) {
          return _this.isCurrentOrBefore(project.created_at);
        };
      })(this));
      this.registered_projects = _.filter(projects, (function(_this) {
        return function(project) {
          return _this.isCurrent(project.created_at);
        };
      })(this));
      this.campaign_started_projects = _.filter(projects, (function(_this) {
        return function(project) {
          return _this.getBeforeCampaigns(project).length;
        };
      })(this));
      this.campaign_current_projects = _.filter(projects, (function(_this) {
        return function(project) {
          return _this.getCurrentCampaigns(project).length;
        };
      })(this));
      this.campaign_setting_projects = _.filter(this.campaign_started_projects, (function(_this) {
        return function(project) {
          return _this.getCurrentCampaigns(project).length;
        };
      })(this));
    }

    ZcsKpi.prototype.calculate = function() {
      return $q.all([this.getProjectPerformance(), this.getCampaignPerformance()]).then((function(_this) {
        return function(arg) {
          var campaign_performance, project_performance;
          project_performance = arg[0], campaign_performance = arg[1];
          return {
            projects: _this.projects,
            registered_projects: _this.registered_projects,
            corrected_registered_projects_count: _this.getCorrectedRegisteredProjectsCount(),
            campaign_started_projects: _this.campaign_started_projects,
            campaign_current_projects: _this.campaign_current_projects,
            campaign_setting_projects: _this.campaign_setting_projects,
            project_performance: project_performance,
            installation_completion_rates: _this.getInstallationProceededRates(),
            campaign_delivery_rates: _this.getCampaignDeliveryRates(),
            campaign_performance: campaign_performance
          };
        };
      })(this));
    };

    ZcsKpi.prototype.getInstallationStepCounts = function() {
      var counts, j, k, l, len, len1, len2, project, ref, step;
      counts = {};
      for (j = 0, len = INSTALLATION_STEPS.length; j < len; j++) {
        step = INSTALLATION_STEPS[j];
        counts[step] = 0;
      }
      ref = this.registered_projects;
      for (k = 0, len1 = ref.length; k < len1; k++) {
        project = ref[k];
        project.first_campaign_start_at = ZcsKpi.firstCampaignStartAt(project.started_campaigns);
        for (l = 0, len2 = INSTALLATION_STEPS.length; l < len2; l++) {
          step = INSTALLATION_STEPS[l];
          if (this.isCurrent(project[step + "_at"])) {
            counts[step] += 1;
          }
        }
      }
      return counts;
    };

    ZcsKpi.prototype.getInstallationProceededRates = function() {
      var counts, i, installation_completion_rates, j, len, step;
      counts = this.getInstallationStepCounts();
      installation_completion_rates = {};
      for (i = j = 0, len = INSTALLATION_STEPS.length; j < len; i = ++j) {
        step = INSTALLATION_STEPS[i];
        installation_completion_rates[step] = this.registered_projects.length ? counts[step] / this.registered_projects.length : null;
      }
      return installation_completion_rates;
    };

    ZcsKpi.prototype.getCampaignDeliveryRates = function() {
      var campaigns, delivery_term, first_campaign_start_at, j, last_campaign_end_at, len, project, ref, setting, setting_count, term, term_end_at, term_start_at, total_term;
      setting_count = 0;
      delivery_term = 0;
      ref = this.campaign_started_projects;
      for (j = 0, len = ref.length; j < len; j++) {
        project = ref[j];
        campaigns = this.getCurrentCampaigns(project);
        if (campaigns.length) {
          setting_count += 1;
        }
        first_campaign_start_at = ZcsKpi.firstCampaignStartAt(campaigns);
        last_campaign_end_at = ZcsKpi.lastCampaignEndAt(campaigns);
        if (first_campaign_start_at && last_campaign_end_at) {
          term_start_at = moment.max(this.start_at, first_campaign_start_at);
          term_end_at = moment.min(this.end_at, last_campaign_end_at);
          delivery_term += term_end_at.diff(term_start_at);
        }
      }
      setting = this.campaign_started_projects.length ? setting_count / this.campaign_started_projects.length : null;
      total_term = this.end_at.diff(this.start_at) * this.campaign_started_projects.length;
      term = total_term ? delivery_term / total_term : null;
      return {
        setting: setting,
        term: term
      };
    };

    ZcsKpi.prototype.getProjectPerformance = function() {
      return this.getAccessStats(this.projects).then(function(access_stats) {
        return {
          conversion_price: access_stats.conversion_price
        };
      });
    };

    ZcsKpi.prototype.getCampaignPerformance = function() {
      return $q.all([this.getAccessStats(this.campaign_current_projects), this.getCampaignStats(this.campaign_current_projects)]).then(function(arg) {
        var access_stats, campaign_stats;
        access_stats = arg[0], campaign_stats = arg[1];
        return {
          session_cover_rate: calculateSessionCoverRate(access_stats.session_count, campaign_stats.experimental.delivery_count),
          conversion_cover_rate: calculateConversionCoverRate(access_stats.conversion_price, campaign_stats.experimental.conversion_price),
          conversion_up_rate: campaign_stats.conversion_up_rate,
          campaign_coupon_used_rate: campaign_stats.experimental.campaign_coupon_used_rate
        };
      });
    };

    ZcsKpi.prototype.isCurrent = function(date) {
      return moment(date).isSame(this.start_at) || moment(date).isBetween(this.start_at, this.end_at);
    };

    ZcsKpi.prototype.isCurrentOrBefore = function(date) {
      return moment(date).isBefore(this.end_at);
    };

    ZcsKpi.prototype.isCurrentOrAfter = function(date) {
      return moment(date).isAfter(this.start_at);
    };

    ZcsKpi.prototype.getCurrentCampaigns = function(project) {
      return _.filter(project.started_campaigns, (function(_this) {
        return function(campaign) {
          return _this.isCurrentOrBefore(campaign.start_at) && _this.isCurrentOrAfter(campaign.end_at);
        };
      })(this));
    };

    ZcsKpi.prototype.getBeforeCampaigns = function(project) {
      return _.filter(project.started_campaigns, (function(_this) {
        return function(campaign) {
          return _this.isCurrentOrBefore(campaign.start_at);
        };
      })(this));
    };

    ZcsKpi.prototype.getCampaignIds = function(projects) {
      return _.chain(projects).reduce(((function(_this) {
        return function(campaigns, project) {
          return campaigns.concat(_this.getCurrentCampaigns(project));
        };
      })(this)), []).map(function(campaign) {
        return campaign.id;
      }).value();
    };

    ZcsKpi.prototype.getCampaignStats = function(projects) {
      return new MasterCampaignStats('daily_all').aggregate({
        campaign_ids: this.getCampaignIds(projects),
        start_at: this.start_at.valueOf(),
        end_at: this.end_at.valueOf()
      }).then(function(res) {
        var campaign_stats;
        campaign_stats = MasterCampaignStats.statsById(res)['undefined'];
        MasterCampaignStats.calculate(campaign_stats);
        return campaign_stats;
      });
    };

    ZcsKpi.prototype.getAccessStats = function(projects) {
      var apikeyChunks, apikeys, promises;
      apikeys = _.map(projects, function(project) {
        return project.apikey;
      });
      apikeyChunks = _.chunk(apikeys, 50);
      promises = _.map(apikeyChunks, (function(_this) {
        return function(apikeyChunk) {
          return MasterAccessStats.aggregate({
            dimension: 'daily'
          }, {
            match: {
              apikey: {
                $in: apikeyChunk
              },
              start_at: {
                $gte: _this.start_at.toDate(),
                $lt: _this.end_at.toDate()
              },
              device: null,
              is_control: null,
              campaign_segment_id: null
            },
            pipeline: [
              {
                $group: {
                  _id: null,
                  session_count: {
                    $sum: '$session_count'
                  },
                  conversion_price: {
                    $sum: '$conversion_price'
                  }
                }
              }
            ]
          }).then(function(res) {
            if (!res.length) {
              return {
                session_count: 0,
                conversion_price: 0
              };
            }
            return res[0];
          });
        };
      })(this));
      return $q.all(promises).then(function(results) {
        var reduced;
        reduced = _.reduce(results, function(chunk, obj) {
          obj.conversion_price += chunk.conversion_price;
          obj.session_count += chunk.session_count;
          return obj;
        }, {
          conversion_price: 0,
          session_count: 0
        });
        return reduced;
      });
    };

    ZcsKpi.prototype.getCorrectedRegisteredProjectsCount = function() {
      return this.registered_projects.length * this.calculateScale();
    };

    ZcsKpi.prototype.calculateScale = function() {
      var current_hours, total_hours;
      total_hours = this.end_at.diff(this.start_at, 'hours');
      current_hours = moment.min(this.end_at, moment()).diff(this.start_at, 'hours');
      if (current_hours === 0) {
        return 0;
      }
      return total_hours / current_hours;
    };

    calculateSessionCoverRate = function(session_count, delivery_count) {
      if (session_count) {
        return delivery_count / session_count;
      } else {
        return null;
      }
    };

    calculateConversionCoverRate = function(conversion_price, campaign_conversion_price) {
      if (conversion_price) {
        return campaign_conversion_price / conversion_price;
      } else {
        return null;
      }
    };

    return ZcsKpi;

  })();
}]);


/***/ }),
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */
/***/ (function(module, exports) {

var path = '/templates/core/components/api_public_file_downloader/api_public_file_downloader.html';
var html = "<a target=_self href=\"{{ vm.href }}\" download=\"{{ vm.href }}\"><i class=\"fa fa-download\"></i> {{ vm.text }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

var path = '/templates/core/components/billing_representatives/billing_representatives.html';
var html = "<div class=billing-representatives><input type=button class=\"btn btn-sm btn-primary add-representative-btn\" ng-disabled=vm.isRepresentativeLimitReached() ng-click=vm.addNewRepresentative() value=\"+ {{ 'sharedModules.core.components.billingRepresentatives.tantousha_tsuika' | translate }}\"><div ng-if=vm.isRepresentativeLimitReached() class=\"alert alert-hint config-lead\">{{ 'sharedModules.core.components.billingRepresentatives.jougen_ni_tasshita' | translate }}</div><table class=col-xs-12><thead><tr><th>{{ 'sharedModules.core.components.billingRepresentatives.shimei_furuneemu' | translate }}</th><th>{{ 'sharedModules.core.components.billingRepresentatives.meeruadoresu' | translate }}</th><th></th></tr></thead><tbody ng-repeat=\"(representativeIndex, representative) in vm.representatives track by representativeIndex\"><tr><td><input class=form-control ng-model=representative.full_name required></td><td><input type=email class=form-control ng-model=representative.email required></td><td style=\"text-align: center;\"><span class=delete-representative ng-click=vm.removeRepresentative(representativeIndex) ng-disabled=vm.isRepresentativesObjectCompletelyEmpty()>{{ 'sharedModules.core.components.billingRepresentatives.sakujo' | translate }}</span></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

var path = '/templates/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html';
var html = "<span class=increase-or-decrease ng-if=$ctrl.showValue ng-class=\"{ 'positive': $ctrl.percentage >= 0, 'negative': $ctrl.percentage < 0 }\">{{ $ctrl.showValue }}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

var path = '/templates/core/components/month_chooser/month_chooser.html';
var html = "<a class=\"btn btn-sm btn-default\" ng-click=$ctrl.goToPrev() ng-disabled=!$ctrl.prevMonth>{{ 'sharedModules.core.components.monthChooser.sengetsu' | translate }}</a> <a class=\"btn btn-sm btn-default\" ng-click=$ctrl.goToNext() ng-disabled=!$ctrl.nextMonth>{{ 'sharedModules.core.components.monthChooser.yokugetsu' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

var path = '/templates/core/components/session_prediction_distribution/session_prediction_distribution.html';
var html = "<div class=row><div class=col-md-11><h4 class=element_title ng-if=\"$ctrl.threshold === 'predictions_max_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_max_threshold === 0\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_ga translate-value-threshold=\"{{ $ctrl.campaign.predictions_max_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_max_threshold !== 0\"></span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.saito_houmon_kara' | translate }}\"></i></h4><h4 class=element_title ng-if=\"$ctrl.threshold === 'predictions_min_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_min_threshold === 100\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_ga_saitei' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_yori translate-value-threshold=\"{{ $ctrl.campaign.predictions_min_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_min_threshold !== 100\"></span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.saito_houmon_tokikara' | translate }}\"></i></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.kakudai' | translate }}\" ng-click=$ctrl.resizeFull()><i class=\"glyphicon glyphicon-resize-full\"></i></button></div></div><highchart config=$ctrl.chartConfig style=\"height: 150px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign[$ctrl.threshold] rz-slider-options=$ctrl.sliderConfig></rzslider><div id={{$ctrl.modalId}} class=\"modal fade\"><div class=modal-dialog><div class=modal-content><div class=\"modal-header row\"><div class=col-md-11><h4 class=\"modal-title element_title\" ng-if=\"$ctrl.threshold === 'predictions_max_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_max_threshold === 0\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_ga translate-value-threshold=\"{{ $ctrl.campaign.predictions_max_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_max_threshold !== 0\"></span></h4><h4 class=\"modal-title element_title\" ng-if=\"$ctrl.threshold === 'predictions_min_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_min_threshold === 100\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_ga_saitei' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_yori translate-value-threshold=\"{{ $ctrl.campaign.predictions_min_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_min_threshold !== 100\"></span></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.motonimodosu' | translate }}\" ng-click=$ctrl.resizeSmall()><i class=\"glyphicon glyphicon-resize-small\"></i></button></div></div><div class=modal-body><highchart config=$ctrl.chartConfig style=\"height: 450px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign[$ctrl.threshold] rz-slider-options=$ctrl.sliderConfig></rzslider></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

var path = '/templates/core/components/session_price_distribution/session_price_distribution.html';
var html = "<div class=row><div class=col-md-11><h4 class=element_title><span ng-if=\"$ctrl.campaign.price_max_threshold === $ctrl.campaign.price_min_threshold\">{{ 'sharedModules.core.components.sessionPriceDistribution.etsuran_shouhin' | translate }}</span> <span ng-if=\"$ctrl.campaign.price_max_threshold !== $ctrl.campaign.price_min_threshold\"><span ng-if=\"$ctrl.campaign.price_max_threshold !== 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMaxAndMinConditions translate-value-pricemaxthreshold=\"{{ $ctrl.campaign.price_max_threshold | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\" translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span> <span ng-if=\"$ctrl.campaign.price_max_threshold === 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMinConditionOnly translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span></span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionPriceDistribution.shiyou_kingaku_seigen' | translate }}\"></i></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPriceDistribution.kakudai' | translate }}\" ng-click=$ctrl.resizeFull()><i class=\"glyphicon glyphicon-resize-full\"></i></button></div></div><highchart config=$ctrl.chartConfig style=\"height: 150px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign.price_max_threshold rz-slider-high=$ctrl.campaign.price_min_threshold rz-slider-options=$ctrl.sliderConfig></rzslider><div id={{$ctrl.modalId}} class=\"modal fade\"><div class=modal-dialog><div class=modal-content><div class=\"modal-header row\"><div class=col-md-11><h4 class=\"modal-title element_title\"><span ng-if=\"$ctrl.campaign.price_max_threshold === $ctrl.campaign.price_min_threshold\">{{ 'sharedModules.core.components.sessionPriceDistribution.etsuran_shouhin' | translate }}</span> <span ng-if=\"$ctrl.campaign.price_max_threshold !== $ctrl.campaign.price_min_threshold\"><span ng-if=\"$ctrl.campaign.price_max_threshold !== 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMaxAndMinConditions translate-value-pricemaxthreshold=\"{{ $ctrl.campaign.price_max_threshold | number | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\" translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | number | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span> <span ng-if=\"$ctrl.campaign.price_max_threshold === 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMinConditionOnly translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | number | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span></span></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPriceDistribution.motonimodosu' | translate }}\" ng-click=$ctrl.resizeSmall()><i class=\"glyphicon glyphicon-resize-small\"></i></button></div></div><div class=modal-body><highchart config=$ctrl.chartConfig style=\"height: 450px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign.price_max_threshold rz-slider-high=$ctrl.campaign.price_min_threshold rz-slider-options=$ctrl.sliderConfig></rzslider></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

var path = '/templates/core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html';
var html = "<div><div class=\"panel panel-default\"><div class=panel-heading><h5 class=panel-title>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon_kabaa' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon_kabaa_ritsu' | translate }}\"></i></h5></div><div class=panel-body><div><table class=\"table table-bordered text-center\"><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.amanojaku_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.negativeImpactSessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.negativeImpactSessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.mukanshin_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.noConversionAnywaySessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.noConversionAnywaySessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td></tr><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.teppan_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.conversionAnywaySessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.conversionAnywaySessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td><td class=col-md-6 style=\"background: #f5f5f5;\"><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.haishin_taagetto' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.positiveImpactSessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.positiveImpactSessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td></tr></table><div translate=sharedModules.core.components.sessionUpliftModelingClassification.zentai_houmon translate-value-sessions=\"{{ $ctrl.totalSessionCount | number }}\" class=\"all_session_number text-muted\"></div></div></div></div></div><div><div class=\"panel panel-default\"><div class=panel-heading><h5 class=panel-title>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.konbaajonkabaa_ritsu' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionUpliftModelingClassification.konbaajonkabaa_ritsu_taishou' | translate }}\"></i></h5></div><div class=panel-body><div><table class=\"table table-bordered text-center\"><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.amanojaku_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.negativeImpactConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.negativeImpactConversionCount | number }} CV)</div></td><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.mukanshin_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.noConversionAnywayConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.noConversionAnywayConversionCount | number }} CV)</div></td></tr><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.teppan_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.conversionAnywayConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.conversionAnywayConversionCount | number }} CV)</div></td><td class=col-md-6 style=\"background: #f5f5f5;\"><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.haishin_taagetto' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.positiveImpactConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.positiveImpactConversionCount | number }} CV)</div></td></tr></table><div translate=sharedModules.core.components.sessionUpliftModelingClassification.all_session_number translate-value-conversions=\"{{ $ctrl.totalConversionCount | number }}\" class=\"all_session_number text-muted\"></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

var path = '/templates/core/components/sync_contract_info_button/sync_contract_info_button.html';
var html = "<p style=\"padding-top: 0; padding-bottom: 0.5em; font-size: 0.9em;\" translate=sharedModules.core.components.syncContractInfoButton.to_onaji_baai translate-value-target=\"{{ vm.syncTargetName }}\"></p><input type=button id=sync-contract-info-btn class=\"btn btn-sm btn-primary\" value=\"{{ 'sharedModules.core.components.syncContractInfoButton.douki_suru' | translate }}\" style=\"font-size: 0.8em;\" ng-click=vm.syncContractInfoWithBillingInfo()>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

var path = '/templates/core/components/tos_notification/tos_notification.html';
var html = "<div ng-if=!vm.isTosSigned class=\"alert alert-warning\" role=alert><div ng-class=\"{ 'text-center': vm.serviceName === 'AiDeal' || vm.user.lang === 'en', 'text-left': vm.serviceName !== 'AiDeal' && vm.user.lang === 'ja', }\" style=\"font-size: 1.4em;\"><span class=\"fa fa-warning\"></span> <strong><span ng-if=\"vm.serviceName === 'AiDeal'\" translate=sharedModules.core.components.tosNotification.tosHasBeenUpdatedSince translate-value-terms-of-service=\"<a href='{{ vm.tosUrl }}' style='color: white; text-decoration: underline;' >{{ 'sharedModules.core.components.tosNotification.termsOfService' | translate: { service: vm.serviceName } }}</a>\" translate-value-date=\"{{ vm.updatedAt }}\"></span> <span ng-if=\"vm.serviceName !== 'AiDeal'\" translate=sharedModules.core.components.liteTosNotification.tosHasBeenUpdatedSince translate-value-terms-of-service=\"<a href='{{ vm.tosUrl }}' style='color: white; text-decoration: underline;' >{{ 'sharedModules.core.components.liteTosNotification.termsOfService' | translate: { service: vm.serviceName } }}</a>\" translate-value-date=\"{{ vm.updatedAt }}\"></span> <button class=btn style=\"margin-left: 10px; background: #ec9924; border: 1px solid;\" ng-click=vm.signAgreements()>OK</button></strong></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

var path = '/templates/core/views/404.html';
var html = "<div id=error-page><div class=error-number>404</div><div class=error-message>{{ 'sharedModules.core.views.404.pageNotFound' | translate }}</div><a ui-sref=admin.home>{{ 'sharedModules.core.views.404.backToHome' | translate }}</a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

var path = '/templates/core/views/500.html';
var html = "<div id=error-page><div class=error-number>500</div><div class=error-message>{{ 'sharedModules.core.views.500.errorOccurred' | translate }}</div><a ui-sref=admin.home>{{ 'sharedModules.core.views.500.backToHome' | translate }}</a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

var path = '/templates/core/views/admin.html';
var html = "<div class=all-filter loading><div id=loader></div></div><div id=wrapper><header class=\"navbar navbar-inverse\" role=banner><div ui-view=header></div></header><div ui-view=mainnav></div><div ui-view=content></div></div><zc-footer></zc-footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

var path = '/templates/core/views/admin_header.html';
var html = "<div class=container ng-class=\"{notificationPadding: environment!='production' && notification}\"><div class=\"navbar-notification navbar-fixed-top {{environment}}\" ng-if=\"environment!='production' && notification\"><ng-container ng-if=\"environment === 'preprod'\">⚠️ {{ 'sharedModules.core.views.admin_header.preprodEnvironment'| translate }} ⚠️</ng-container><ng-container ng-if=\"environment !== 'preprod'\" translate=sharedModules.core.views.admin_header.currentEnvironment translate-value-environment={{environment}}></ng-container><span class=navbar-notification-remove ng-click=switchNotification()><i class=\"fa fa-times-circle\"></i></span></div><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>{{ 'sharedModules.core.views.admin_header.toggleNavigation' | translate }}</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-zc navbar-right\"><project-apikey-menu></project-apikey-menu><projects-menu></projects-menu><projects-menu-search></projects-menu-search><master-menu></master-menu><user-menu></user-menu></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

var path = '/templates/core/views/admin_header_logout_only.html';
var html = "<div class=container ng-class=\"{notificationPadding: environment!='production' && notification}\"><div class=\"navbar-notification navbar-fixed-top {{environment}}\" ng-if=\"environment!='production' && notification\" translate=sharedModules.core.views.admin_header.currentEnvironment translate-value-environment={{environment}}><span class=navbar-notification-remove ng-click=switchNotification()><i class=\"fa fa-times-circle\"></i></span></div><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>{{ 'sharedModules.core.views.admin_header.toggleNavigation' | translate }}</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-zc navbar-right\"><master-menu></master-menu><user-menu logout-only=true></user-menu></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/templates/core/views/data_processing_addendum.html';
var html = "<h1 class=text-center>Data Processing Addendum</h1><ol><li><p>To the extend that, under this Services Agreement, personal data is transferred outside of the European Economic Area or any European Commission approved country, the User hereby agree to and hereby enter in the Controller to Processor Standard Contractual Clauses (Commission Implementing Decision (EU) 2021/914) (“C2P SCCs”) with Appier, the terms of which are hereby incorporated into this Services Agreement. For the purposes of the C2P SCCs, the User is the data exporter and Appier is the data importer, and the governing law of the C2P SCCs is the law where the data exporter is established.</p></li><li><p>In addition to the foregoing, to the extend applicable, both Appier and User hereby agree the data protection scope as follows:</p><ol><li><p>Both parties shall comply with applicable data protection law which apply to it in respect of the performance of its obligations under this Services Agreement. The parties agree that (a) Appier is a data processor, and (b) Purchaser is a data controller. For the purpose of this Data Processing Addendum (“DPA”), (i) data controller refers to an entity that determines the purposes and means of the processing of personal data and (ii) data processor refers to an entity which processes personal data on behalf of the controller.</p></li><li><p>The User shall be responsible for obtaining the consent and providing privacy or transparency notices to each end user, on their website, in compliance with, and where required by, applicable data protection law. For the purpose of this DPA, end user shall include but not limited to Viewers.</p></li><li><p>The parties shall cooperate reasonably with each other in the fulfilment of their respective obligations in respect of data subject requests for third party notification, erasure or other requests under applicable data protection law.</p></li><li><p>Taking into account the nature of and risks associated with the type of personal data collected or used in connection with the Services (if any), each party shall use commercially reasonable effort to have in place appropriate technical and organizational measures to ensure a level of security appropriate to the risks that are presented by each party’s processing of personal data.</p></li><li><p>Appier ensures that all persons authorized by it to process the personal data are committed to confidentiality or are under a statutory obligation of confidentiality under applicable law.</p></li><li><p>To a commercially reasonable extend, Appier will make available to the User information which is reasonably necessary to demonstrate the compliance with the obligations set out in this Article 2.</p></li><li><p>Appier acknowledges that the User is under certain obligations under the applicable data protection law, such as recordkeeping, and agrees to make commercially reasonable efforts to provide the Purchaser with reasonable assistance and information required by the User to satisfy such obligations.</p></li><li><p>To the extent Appier becomes aware and determines that an incident shall be deemed as a personal data breach leading to the accidental or unlawful destruction, loss, alteration, unauthorized disclosure of, or access to, personal data transmitted, stored or otherwise processed by Appier, Appier will (a) notify the User of such incident without undue delay, (b) conduct investigation to a reasonable extend to comply with this Agreement and (c) provide necessary information and/or assistance for User to investigate and/or understand the incident.</p></li><li><p>The User grants a general authorization (a) to Appier to appoint any of its affiliates (Appier and any of its affiliates hereinafter collectively referred to as “<strong>Appier Group</strong>”) as sub-processors, and (b) to Appier Group to appoint third parties (including but not limited to outsourcing business, engineering and customer support providers) as sub-processors to support and/or improve the performance of the Services.</p></li><li><p>To the extend applicable, terms used under this Article 2 shall share the meaning within C2P SCCs.</p></li></ol></li></ol><p>Appendix to C2P SCCs</p><p>EXPLANATORY NOTE:</p><p>It must be possible to clearly distinguish the information applicable to each transfer or category of transfers and, in this regard, to determine the respective role(s) of the Parties as data exporter(s) and/or data importer(s). This does not necessarily require completing and signing separate appendices for each transfer/category of transfers and/or contractual relationship, where this transparency can achieved through one appendix. However, where necessary to ensure sufficient clarity, separate appendices should be used.</p><p>ANNEX I to C2P SCC</p><p>A. &nbsp; LIST OF PARTIES</p><span><strong>On behalf of the data exporter:</strong></span><table style=\"width: 100%; table-layout: fixed\"><tbody><tr><td colspan=1 rowspan=1><span>Name of the data exporting organization:</span></td><td colspan=2 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1><span>Address:</span></td><td colspan=2 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1><span>Tel: &nbsp; &nbsp; &nbsp;</span></td><td colspan=1 rowspan=1><span>Fax: &nbsp; &nbsp; &nbsp;</span></td><td colspan=1 rowspan=1><span>Email: &nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=3 rowspan=1><p>Other information needed to identify the organization:</p></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Signature:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Print Name:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Title:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Date:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr></tbody></table><p>&nbsp;</p><span><strong>On behalf of the data importer:</strong></span><table style=\"width: 100%; table-layout: fixed\"><tbody><tr><td colspan=1 rowspan=1><span>Name of the data importing organization:</span></td><td colspan=2 rowspan=1><span style=\"text-decoration: underline\">Appier Pte. Ltd.</span></td></tr><tr><td colspan=1 rowspan=1><span>Address:</span></td><td colspan=2 rowspan=1><span style=\"text-decoration: underline\">Wilkie Road, #03-01, Wilkie Edge, Singapore (228095)</span></td></tr><tr><td colspan=1 rowspan=1><span>Tel:</span> <span style=\"text-decoration: underline\">+886-2-87802800</span></td><td colspan=1 rowspan=1><span>Fax:</span> <span style=\"text-decoration: underline\">+886 2 87808809</span></td><td colspan=1 rowspan=1><span>Email:</span> <span style=\"text-decoration: underline\">legal.eu@appier.com</span></td></tr><tr><td colspan=3 rowspan=1><p>Other information needed to identify the organization:</p></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1 style=\"vertical-align: top\"><span style=\"padding-left: 55%\">Signature:</span></td><td colspan=1 rowspan=1><img src=" + __webpack_require__(819) + " width=84></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Print Name:</span></td><td colspan=1 rowspan=1><span style=\"text-decoration: underline\">Chih-Han Yu</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Title:</span></td><td colspan=1 rowspan=1><span style=\"text-decoration: underline\">CEO</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Date:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr></tbody></table><p>&nbsp;</p><p>B. &nbsp; DESCRIPTION OF TRANSFER</p><p><span style=\"font-style: italic\"><strong>Categories of data subjects whose personal data is transferred</strong></span></p><p>Please refer to Appier&rsquo;s privacy policy</p><ul><li><strong>&nbsp;</strong></li></ul><p><span style=\"font-style: italic\"><strong>Sensitive data transferred (if applicable) and applied restrictions or safeguards that fully take into consideration the nature of the data and the risks involved, such as for instance strict purpose limitation, access restrictions (including access only for staff having followed specialized training), keeping a record of access to the data, restrictions for onward transfers or additional security measures.</strong></span></p><p>The personal data that may be transferred would not normally concern any special categories of data, but data exporter is in control in this regard.</p><p>The restrictions and safeguards specified in Annex II apply to these categories of Customer Personal Data (if any).</p><p><span style=\"font-style: italic\"><strong>The frequency of the transfer (e.g. whether the data is transferred on a one-off or continuous basis).</strong></span></p><p>Customer Personal Data may be transferred on a continuous basis until it is deleted in accordance with the Terms of Service (as applicable).</p><p><span style=\"font-style: italic\"><strong>Nature of the processing</strong></span></p><p>The data importer will process Customer Personal Data to provide, secure and monitor the Services in accordance with the Agreement.</p><p><span style=\"font-style: italic\"><strong>Purpose(s) of the data transfer and further processing</strong></span></p><p>The data importer will transfer Customer Personal Data to provide, secure and monitor the Services in accordance with the Agreement.</p><p><span style=\"font-style: italic\"><strong>The period for which the personal data will be retained, or, if that is not possible, the criteria used to determine that period</strong></span></p><p>For the duration of the Agreement until deletion in accordance with the provisions of the Terms of Service (as applicable).</p><p><span style=\"font-style: italic\"><strong>For transfers to (sub-) processors, also specify subject matter, nature and duration of the processing</strong></span></p><p>As above.</p><p>C. &nbsp; COMPETENT SUPERVISORY AUTHORITY</p><p>ANNEX II to C2P SCC</p><p>&nbsp;</p><p>TECHNICAL AND ORGANISATIONAL MEASURES INCLUDING TECHNICAL AND ORGANISATIONAL MEASURES TO ENSURE THE SECURITY OF THE DATA</p><p>&nbsp;</p><h2><strong>1. Service providers</strong></h2><h3><strong>Infrastructure</strong></h3><p>Appier uses the Appier Cloud Platform (GCP) and Amazon Web Services (AWS) as its infrastructure providers.</p><p>Both GCP and AWS meet the most stringent data protection and security requirements.</p><p>Please refer to the following links for the security and privacy of our cloud service providers:</p><p><span style=\"font-style: italic\">GCP: <a href=\"https://www.google.com/url?q=https://cloud.google.com/security/compliance&amp;sa=D&amp;source=editors&amp;ust=1643278314580350&amp;usg=AOvVaw3fonrTyjHfd3oZsgK5sQRi\">https://cloud.Appier.com/security/compliance</a></span></p><p><span style=\"font-style: italic\">AWS: <a href=\"https://www.google.com/url?q=https://aws.amazon.com/tw/compliance/&amp;sa=D&amp;source=editors&amp;ust=1643278314580729&amp;usg=AOvVaw1LzFPErXt315RJQHIxYS24\">https://aws.amazon.com/tw/compliance/</a></span></p><p>&nbsp;</p><h2><span><strong>2. Data protection and encryption</strong></span></h2><h3><span><strong>Data handling after retention</strong></span></h3><p>Deletion of personal data is performed by the following principles:</p><ul><li>After the deletion is completed, the personal data files should not exist.</li><li>It is no longer possible to recover or backup personal data.</li><li>Certain employee is responsible for the deletion of the data.</li><li>The records of deletion are kept.</li></ul><h3><span><strong>Encryption</strong></span></h3><p>Appier complies ISO 27001 to implement compatible encryption for the transmission and the storage of personal data.</p><p>&nbsp;</p><h2><span><strong>3. Confidentiality and integrity</strong></span></h2><h3><span><strong>Equipment access control</strong></span></h3><p>Measures designed to deny unauthorized persons access to equipment used for processing personal data.</p><ul><li>Appier takes the following measures to ensure that unauthorized persons do not gain access to data processing systems in which data is processed:</li><li>Doors accessing Secure Area shall be equipped with access control mechanism, such as access cards or locks, to prevent unauthorized entry.</li><li>Access card to Secure Area can only be used as the application of its usage been submitted and approved. Access card shall be used in the manner that is consistent with the intended information processing activities.</li></ul><p>Clearly defined security concepts are in place for data processing and storage at AWS and GCP.</p><p>Except for the access options provided to administrators as agreed with the client, access to the data centers in which the client&#39;s data are stored is impossible for employees.</p><p>Access to the data centers is strictly controlled by the cloud service provider. The implemented measures include but not limited to:</p><ul><li>Video surveillance</li><li>Movement sensors, intruder alarm system and security for the premises</li><li>Division into safety zones / restricted areas</li><li>Identity check by the gatekeeper or security service</li><li>Full documentation and regular verification of any access granted</li></ul><p>&nbsp;</p><h3><span><strong>User access control</strong></span></h3><p>Appier follows strict policy to protect user access control including the follows:</p><ul><li>System Administrators shall be separated into different roles based on their characteristics, such as development, testing, release, maintenance and equipment management.</li><li>User accounts and passwords shall refrain from being shared among personnel.</li><li>The accounts and the corresponding permissions shall be adjusted, disabled or deleted when the personnel that uses them is no longer working in the same job capacity.</li><li>Accounts irrelevant to system operation or maintenance shall be deleted when the project or job is completed.</li><li>Access control through devices other than account (i.e. IC card, USB key) shall be treated to be the same as the account for its protection.</li><li>Account with the system&rsquo;s highest permission (i.e. administration account) shall be used as authorized while appropriate audit trails are retained.</li></ul><p>&nbsp;</p><h3><span><strong>Transfer control</strong></span></h3><p>Appier has designed measures to ensure that personal data cannot be read, copied, altered, or deleted without authorization during electronic transmission, transport or storage on data carriers. These measures include:</p><ul><li>Sign agreements with third parties before the third parties provide services to Appier, and ensure that the data duties of third parties are disclosed in the agreement.</li><li>When Appier shares data with the third parties, the contract between Appier and the third parties should include the data protection duties, data processing purposes and restrictions.</li><li>When transferring personal data due to business needs, encryption or other data security mechanisms should be implemented during the transfer.</li><li>Data sharing or transfer should comply with Appier&#39;s security policy.</li></ul><p>&nbsp;</p><h3><span><strong>Input control</strong></span></h3><p>Measures designed to ensure that it is subsequently possible to verify and establish whether and by whom personal data have been entered into, modified, or removed from data processing systems.</p><p>The client&rsquo;s transmitted data are recorded by the platform in an audit-proof manner. Any sub-sequent modification or deletion of the client&#39;s data is also recorded by the platform. The measures include the follows:</p><ul><li>When any application accessed by a user involves the collection, processing, and utilization of personal data, its additions, changes, deletions, and inquiries, regardless of the success or failure of the system&#39;s processing results, should record the user&#39;s access behavior.</li><li>The application system log storage location should be set up with an access authority control mechanism and read-only access for user accounts to prevent the log from being tampered with.</li></ul><p>&nbsp;</p><h3><span><strong>Processing control</strong></span></h3><p>Measures designed to ensure that personal data processed can only be processed in compliance with Appier&rsquo;s fundamental principles for personal data processing. These measures include:</p><ul><li>Personal data processing should be legal, fair and transparent.</li><li>The purpose of personal data collection must be specific, explicit and legal.</li><li>The collection and processing of personal data must comply with the principle of data minimization.</li><li>The accuracy of personal data should be ensured.</li><li>The retention time of personal data should not be longer than the time necessary for processing purposes.</li><li>Personal data should be processed in a safe manner to prevent unauthorized or illegal processing, maintaining the integrity and confidentiality of personal data.</li></ul><p>&nbsp;</p><h3><span><strong>Separability</strong></span></h3><p>Measures designed to ensure that personal data collected for different purposes can be processed separately (storage, modification, deletion, transmission). Among others, the following measures are implemented:</p><ul><li>Data will be imported into the system and displayed according to their intended use.</li><li>Separation of data by client / customer</li><li>Separation of functions / production environment / test environment</li><li>Creation of an authorization concept</li></ul><p>&nbsp;</p><h2><span><strong>4. Availability and recovery</strong></span></h2><p>Measures designed to ensure that personal data are available and protected against accidental loss and destruction and that systems may, in the case of malfunctions, be restored.</p><ul><li>Storage of data backup at a secure, external location</li><li>Regular checks on the functionality of the backup &amp; recovery concept</li></ul><p>In addition to the measures taken by Appier, the cloud service provider also take actions to serve the best of availability.</p><h2><span><strong>5. Data protection by default / Data protection by design</strong></span></h2><p>With regard to privacy by default and privacy by design, Appier has established the privacy by design policy to ensure data protection.</p><p>During the application, system, and product evaluation phase, the developer should incorporate the &quot;Privacy by Design Sheet&quot; question into the design to ensure that relevant requirements can be met.</p><p>During the application, system, and product testing phase, developers should test and complete the &quot;Privacy by Design Sheet&quot;, and provide the form to the Appier&rsquo;s Data Protection Office after the test is completed. If there is any inapplicability in the process of filling in, the reason for inapplicability should be written.</p><p>During the application, system, and product development, developers should ensure that application development is performed in accordance with the requirements of &quot;Privacy by Design Sheet&quot;.</p><p>&nbsp;</p><h2><span><strong>6. Regular verification procedures</strong></span></h2><h3><span><strong>Data protection office</strong></span></h3><p>Appier has created a corporate data protection office whose main tasks include the development, implementation, and monitoring of a data protection management system and the regular monitoring of processing activities and data protection measures.</p><h3><span><strong>Risk analysis</strong></span></h3><p>A risk analysis is regularly carried out by the information security team in to assess the current threat level and determine measures to be taken.</p><p>&nbsp;</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

var path = '/templates/core/views/directives/footer.html';
var html = "<footer class=\"footer zc-footer\"><div class=container><p class=pull-left ng-cloak>{{ thisYear }} Appier Japan, Inc. All rights reserved</p><div class=pull-right><a ui-sref=privacy_policy>{{ 'usersPages.views.directives.footerLinks.privacyPolicy' | translate }}</a> | <a ui-sref=terms_of_service>{{ 'usersPages.views.directives.footerLinks.zcTermsOfUse' | translate }}</a></div></div></footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

var path = '/templates/core/views/directives/zc_date_time_picker.html';
var html = "<div class=dropdown dropdown><a class=dropdown-toggle id={{pickerId}} role=button data-toggle=dropdown dropdown-toggle href=#><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> <input type=text class=form-control value=\"{{ data | date: ('sharedModules.dateTimeFormats.datetime' | translate) }}\"></div></a><ul class=dropdown-menu role=menu aria-labelledby=dLabel><datetimepicker data-ng-model=data data-datetimepicker-config=\"{ dropdownSelector: '#'+pickerId, minView: minView }\"></datetimepicker></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

var path = '/templates/core/views/emptynav.html';
var html = "<div class=mainnav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

var path = '/templates/core/views/mainnav.html';
var html = "<div class=mainnav><div ng-if=false class=\"navbar-notification status-waiting text-dark\"><ng-container ng-if=\"currentUser.lang === 'ja'\">現在、バナーは正常に配信されておりますが、データ集計に問題が発生しており、一部ダッシュボード上の数値が正しくない可能性があります。</ng-container><ng-container ng-if=\"currentUser.lang !== 'ja'\">We are having data aggregation issue at the moment, numbers on the dashboard might not be correct, please come back later</ng-container></div><zc-tos-notification tos-url=/admin/tos updated-at=2020/11/15 service-name=AiDeal></zc-tos-notification><div class=container><a class=mainnav-toggle data-toggle=collapse data-target=.mainnav-collapse><span class=sr-only>{{ 'sharedModules.core.views.mainnav.toggleNavigation' | translate }}</span> <i class=\"fa fa-bars\"></i></a><nav class=\"collapse mainnav-collapse\" role=navigation><ul class=mainnav-menu><li ui-sref-active=active zc-master-only><a ui-sref=admin.projects.dashboard({projectId:projectId})><i class=\"fa fa-lock\"></i> {{ 'sharedModules.core.views.mainnav.dashboard' | translate }}</a></li><li ui-sref-active=active><a ui-sref=admin.projects.campaigns.list({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.campaigns' | translate }}</a></li><li ui-sref-active=active ng-if=isMaster><a ui-sref=admin.projects.segments({projectId:projectId})><i class=\"fa fa-lock\"></i> {{ 'sharedModules.core.views.mainnav.segments' | translate }}</a></li><li ui-sref-active=active><a ui-sref=admin.projects.incentives({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.incentives' | translate }}</a></li><li ui-sref-active=active ng-if=\"isMaster || project.allow_app_access\"><a ng-href=\"{{ aiReportURL }}\" target=_blank><i class=\"fa fa-lock\"></i> {{ 'sharedModules.core.views.mainnav.aiReport' | translate }}</a></li><li ui-sref-active=active ng-if=\"isMaster || project.shows_site_report\"><a ui-sref=\"admin.projects.site_report.summary({projectId:projectId, month:thisMonth})\"><i class=\"fa fa-lock\" ng-if=!project.shows_site_report></i> {{ 'sharedModules.core.views.mainnav.newReport' | translate }}</a></li><li ui-sref-active=active ng-if=\"project.sales_entity_fullname === 'Appier Japan (JP)'\"><a ui-sref=admin.projects.reports({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.report' | translate }}</a></li><li ui-sref-active=active ng-if=\"project.iw_contracted_at || project.iw_trial_started_at\"><a ui-sref=admin.projects.iw.report({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.interestWidget' | translate }}</a></li><li ui-sref-active=active ng-if=\"isMaster || project.shows_site_data || isInternalUser\"><a ui-sref=admin.projects.analytics({projectId:projectId})><i class=\"fa fa-lock\" ng-if=!project.shows_site_data></i> {{ 'sharedModules.core.views.mainnav.siteData' | translate }}</a></li><li ui-sref-active=active ng-show=\"projectId === 1109\"><a ui-sref=admin.projects.heatmap({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.heatmap' | translate }}(β)</a></li><li ui-sref-active=active><a ui-sref=admin.projects.settings.basic({projectId:projectId})><i class=\"fa fa-cog\"></i> {{ 'sharedModules.core.views.mainnav.settings' | translate }}</a></li></ul></nav><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert zc-master-only>{{ 'sharedModules.core.views.mainnav.notification.aajsSettingsWarningMsg' | translate }}</div></div></div><zc-project-notification></zc-project-notification>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

var path = '/templates/core/views/privacy_policy.html';
var html = "<div class=document-wrapper><div class=row><div class=\"col-md-push-2 col-md-8\"><div ng-switch=currentLang class=\"document-wrapper privacy-policy\"><ng-container ng-switch-when=ja><h1 class=text-center>プライバシーポリシー</h1><ol><li>概要</li></ol><p>このプライバシー声明（以下「プライバシーポリシー」という）において情報の収集および利用方法を説明し、Appier Inc.、その子会社および関連会社（以下「Appier」、または「当社」という）はお客様のプライバシーを尊重し、お客様の個人情報を保護するほか、お客様の個人情報の収集、使用、共有を透明化することに取り込みます。このプライバシーポリシーは、Appierのオンラインサービス、ウェブサイト（<a href=\"https://www.google.com/url?q=https://www.appier.com//&amp;sa=D&amp;ust=1536048166950000\">www.appier.com</a>）またはこのプライバシーポリシーへのリンクあるいは関連するすべてのウェブサイト（以下併せて「ウェブサイト」という）に適用し、並びに当社がどのように個人情報を処理するか（詳細は後述）、およびお客様の個人情報の収集、使用、保存、および更新、訂正等に関してお客様によるご利用の選択肢を説明します。</p><ol><li>Appierのサービス</li></ol><p>Appierは、Cross X アドソリューション、アイコア（マーケティングオートメーションプラットフォーム）、アイソン（データサイエンスプラットフォーム）等企業の経営課題の解決を支援する人工知能（AI）搭載のプラットフォームを提供します。</p><ol><li>当社で収集した個人情報</li></ol><ul class=second-section><li>ウェブサイトを通じて</li></ul><p>当社は、当社のウェブサイトで又はウェブサイトの利用過程においてお客様が提供した個人情報をはじめとするデータを収集します。「個人情報」には、、直接的または間接的に、自然人として識別できる情報、特に当社が利用できる他の情報、例えば、個人番号（マイナンバー）、オンライン識別子、またはお客様を自然人として識別できる一つまたは複数の要素を結合した情報を含みますが、これらに限りません。</p><p>それ故、ウェブサイトで作成したフォームを使用する場合、当社も、次の情報を収集する可能性があります。</p><ul><li>連絡先情報、例えば氏名、住所、電話番号、メールアドレス等</li><li>人口統計情報、例えば国、会社、役職等</li><li>コメント</li></ul><p>Appierは、当社が有す個人情報が正確かつ最新であることの確保を目的としています。ご提供いただいた個人情報が正確且つ最新であることをご確認下さい。</p><p>もし、お客様はAppierに要請されても、特定の個人データが提供しなかった場合、当社はお客様と締結した契約（例えば製品またはサービスの提供）を履行できない可能性があるか、または当社が負うべき法的義務を遵守できないことがあります。</p><p>さらに、ウェブサイトでウェブサイト上の情報をブラウズ、閲覧、またはダウンロードするとき、お客様のウェブブラウザーは自動的に次の情報を当社に送信します（当社はこれを保有することができる）。</p><ul><li>インターネットにアクセスしているインターネットドメイン</li><li>使用しているコンピュータのプロトコルアドレス</li><li>使用しているブラウザソフトウェアおよびオペレーティングシステムの種類</li><li>ウェブサイトにアクセスした日付および時刻</li><li>ウェブサイトに直接リンクしたサイトのインターネットアドレス</li></ul><p>当社は、当社のクッキーポリシーに従い、ウェブサイトの維持に役立てるために、これらの情報を集計データとして利用します。例えば、ウェブサイト上のさまざまなセクションへの訪問者数の確定、ウェブサイトの正常な運営の確認およびウェブサイトへの簡単なアクセスまたは使用に役立てます。<br>また、当社も信頼できる第三者から個人情報の収集を行ない、且つ個人情報収集のために雇用した第三者の協力を受けます。</p><ul class=second-section><li>当社の各サービスを通じて</li></ul><p>また、当社のサービスを当社の取引先（以下「顧客」という）に提供するために、当社は、顧客が自らまたは協力会社に依頼し顧客のウェブサイトに当社のクッキーを設置することを通じて、個人情報を追加収集する可能性があります。<br>お客様の個人情報は、そのような広告目的のクッキーを受け入れた場合にのみ収集されます。</p><ul class=third-section><li>インターネット上で収集する個人情報：</li></ul><ul><li>Appier のクッキー識別子</li><li>IPアドレス</li><li>IPジオロケーション</li><li>訪問されたさまざまなサイトのページURL</li><li>さまざまなページでブラウシングした時刻</li><li>ネットでブラウスしたブラウザーのタイプとバージョン</li><li>同じ目標で収集されたパートナーのテクノロジープラットフォームのクッキー識別子</li><li>広告ID</li><li>広告ウェブページのURL</li><li>イベントID―例えば、エンドユーザーによる広告の「クリック」、インプレッションの「ビュー」</li></ul><ul class=third-section><li>モバイルアプリケーションを通じて収集する個人情報</li></ul><p>Appierは、モバイルアプリケーションを使用して個人情報を収集するために、さ信頼できるパートナーに依頼して次の個人情報を収集します。</p><ul><li>IPアドレス</li><li>広告主の携帯電話識別子（IOSデバイスのIDFAとAndroidのGAID）</li><li>GPSジオロケーションデータ</li><li>携帯電話の品番およびそのオペレーティングシステム（IOS、Android等）</li><li>ビューされた顧客ウェブサイトのページURL</li><li>時刻</li><li>広告ID</li><li>アプリケーション名</li></ul><ol><li>当社によるお客様の個人情報利用</li></ol><p>当社は次の目的でのみ、お客様の個人情報の収集、利用および保存をします。当社の業務経営、引き渡し処理、当社ウェブサイトおよび当社が提供する各種製品とサービスのカスタマイズおよび改善、当社業務に関わるマーケティングおよびその他通信、お客様の要求に基づき、お客様に情報、製品およびサービスの提供、並びに適用する法律で認められたその他合法的用途に用います。</p><p>具体的な状況により、前述合法的用途の基準において、当社は関連処理する前に基準事実発生時点で、お客様に告知します。</p><p>Appierによる各目的に基づく個人情報の収集は、次のものを含みます。</p><ul><li>お客様が当社に要求した情報の提供</li><li>お客様の問い合わせへの回答</li><li>マーケティングまたは顧客調査を含む目的とするお客様へのメッセージ発信：Appierから直接発送（具体状況による）またはお客様の同意を得た当社の第三者からの発信</li><li>お客様と契約を締結してお客様が購読済みまたは購読予定の各種サービスの提供</li><li>アカウント作成</li><li>詐欺、政策または条項違反ならび脅威あるいは損害の抑止および対応</li><li>特にチャットロボットを通じた、お客様へのサービスとサポートの提供</li><li>お客様の一般の地理的位置に対応したウェブサイトの運営改善および／またはウェブコンテンツ調整協力並びに通報の用途</li><li>ジョブアプリケーションの管理</li></ul><p>当社は、当社の顧客への各種サービスに個人情報を提供する場合があります。特に、次の場合です。</p><ul><li>もっともお客様のニーズおよび好みを満たす広告、マーケティングおよび販売優遇をお客様へ提供する</li><li>広告主およびパブリッシャー（メディア運営者）の現有および潜在顧客に対しロイヤリティの構築および商業開拓キャンペーンを目的とするターゲティングに協力する</li><li>企業による非侵襲性広告発信への協力</li><li>広告の発信頻度（マーケティングプレッシャ）の最適化</li><li>異なる産業の広告主（自動車産業、不動産業、販売店等）の研究開発に協力し、消費者ニーズおよび市場の更なる理解に協力するとともに、顧客ロイヤリティと商業宣伝を目標とした各種イベントのパフォーマンスを分析する</li><li>異なる端末のそれぞれの識別子を調整し、確率的な方法でプロファイルに近づける</li></ul><p>適用する法律規定または法律許可範囲において、且つ、(i)Appierにかかる法律義務(ii)当社と当事者と何らかの協議に基づく条件の執行目的に基づくもの、または(iii)Appier、Appierの顧客または他人の権利、財産または安全等の保護の目的に基づき、当社が誠実に合理的で、しかも必要性を認めた場合、お客様の個人情報を使用し、または特定範囲の第三者に開示する場合があります。</p><ol><li>当社によるお客様の個人情報の共有</li></ol><p>所在地が欧州連合（「EU」）または欧州経済領域（「EEA」）に所在するかを問わず、当社の業務経営、引き渡し処理、当社ウェブサイトの改善およびカスタマイズ、ならびに当社が提供する各種製品とサービスの改善、当社業務に関わるマーケティングおよびその他通信発信の目的かつ、お客様の同意を得た後、当社は当社と関連事業体およびその他第三者事業パートナー、プロバイダー、ベンダーまたは当社を代表して、当社の指示を執行する請負業者とお客様の個人情報を共有することがあります。</p><p>従って、当社は個人情報を次の方法で共有します。</p><ul><li>個人情報処理または保存の目的、かつ、前述した各項の用途に関連し、Appier内部および当社の所在地がEU/EEAの国内または海外にあるすべての関連実体内部での共有</li><li>当社製品およびサービス提供または取引実現を目的としたAppier事業パートナー、ベンダー、授権された第三者代理人または請負業者との共有例えば、オーダーを処理し、各ウェブサイトのタスク処理センターとしてのサポートの提供（これを含むがこれ等に限らない）</li><li>合併プロジェクト、会社資産売却、併合、組織改造、融資プロジェクトまたは他社による当社の全部もしくは一部業務の買収等の関連または交渉期間中</li><li>具体的状況により、お客様のプライバシーのより厳密な保護を図り、Appierはサマリー形式でお客様の個人情報を共有し、これらの情報は直接または間接的にお客様のアイデンティティ識別に用いる</li></ul><p>適用する法律、法規または法的手続きによって授権または認可された場合、当社はEU/EEA国内または海外の法執行官、政府主務機関またはその他第三者にお客様の個人情報を開示します。但し、このような開示は法律の正当な手続きに合致し、かつ、Appierに対して拘束力あり、しかも法的手続きの遵守または国家安全需要の必要範囲を超えない限度において、Appier、Appierの事業パートナー、お客様または他人の各権利、財産および安全も保護されることを前提とします。</p><ol><li>第三者のウェブサイトへのリンク</li></ol><p>ウェブサイトには、当社が管理していない会社が運営する第三者のウェブサイトへのリンクが含まれている場合があります。これらの第三者のウェブサイト上でのお客様の活動は、これらの第三者のプライバシーポリシーおよび手続きのみによって管理されます。このような第三者のコンテンツまたは情報実務について、Appierは一切の責任を負いません。また、これらのWebサイトで情報を開示する前に、これらの第三者のプライバシーポリシーをレビューすることをお勧めします。</p><ol><li>当社の情報保存期限および情報処分方法</li></ol><p>第4条の規定に従い収集したお客様の個人情報について、当社の保存期間は収集のための存続期間とし、且つ当社の業務、法的義務、争議解決、当社の資産保護およびAppierの当事者の各項協議ニーズの執行に限り、当該期間満了後は、お客様の個人情報を削除します。</p><p>いずれにしても、当社のサービスを1年間使用しない場合、当社はお客様の個人情報を削除します。</p><ol><li>個人情報のセキュリティと機密性</li></ol><p>お客様の個人情報の安全性と機密性は当社にとって非常に重要です。お客様の個人情報が紛失、盗難、誤用、改ざん、違法または不正アクセス、使用もしくは開示されないよう保護するために、当社は各種の適切な具体的、行政管理上、技術上の手段およびお客様の個人情報保護のため作成された保護手段を実施します。</p><p>Appierは同時に、当社が保有する個人情報を保護するために、各種の合理的な措置を実施しています。これには以下を含みます。</p><ul><li>個人情報の使用、セキュリティおよび守秘について、グループ全体のポリシーおよび手順の実施</li><li>厳格な管制について、知る必要があり且つ厳格な機密保持規定の拘束を受ける従業員および第三者のサービス提供者のみが個人情報へアクセスができる。</li><li>送信過程におけるデータ保護のために各種のテクノロジーを利用する。例えば、お客様がウェブサイトを通じて提供したデータの一部についてSSL暗号化を行い、且つ適切なセキュリティ手段を使用して当社が収集して保持するデータを保護する。</li><li>業界標準に対応する手段およびプロセスを使用し、コンピュータシステムおよびネットワークに違反する不適切な試みを検出し、且つ対応する。</li></ul><p>インターネットとその通信が常に安全であることを保証することはできません。また、お客様が本テクノロジーを通じて当社に提供した個人情報の安全性を当社は確保または保証することができません。これに対し、疑わしいデータセキュリティ違反について、当社は既存の手順により処理します。疑わしい違反事件が生じた場合、当社は法律規定によりお客様および主務機関に通知します。</p><p>電子通信、特に電子メールは、傍受に対して必ずしも安全ではないことにご注意ください。Appierは、業界標準に合致するデータ収集および暗号化システムを使用して、個人の識別可能な情報の安全な収集と送信を保証します。機密データ（ソーシャルセキュリティ、銀行口座、クレジットカードの番号など）をメールまたはウェブフォームで送信しないでください。</p><ol><li>お客様の権利</li></ol><p>お客様はご自身の個人情報の正確性を確認するために、当社が保管しているすべてご自身の個人情報のアクセス、紙または電子コピーの獲得、レビュー、修正、および更新する権利を有します。関連の法的要件や免除の対象に違反しない前提で、お客様はご自身の個人情報に対する処理について、反対、制限、またはお客様の特定の個人情報を当社のファイルから削除するよう要求することができます。</p><p>もしお客様がEU内に居住していて、且つ情報処理の合法的な基礎が（i）（a）契約または（b）お客様の同意、および（ⅱ）自動化手段である場合、お客様は個人情報のデータポータビリティ権を行使することができます。しかし当該要求は、お客様が当社に提供した個人情報について、その時点で保有していた場合に限り、且つ身元確認手続きを含む関連の法的要件や免除の対象に違反しないことを前提とします。</p><p>当該要求が法律で禁止されているか、またはAppierが合法的な目的でお客様の個人情報を保有する場合を除き、Appierは前述の要求に応じるために合理的な努力を行います。前記の場合、当社は不当な遅延がなくお客様に知らせます。お客様の個人情報に関する一切の要求を処理する前に、当社はお客様の身元を確認する権利を保留します。お客様の個人情報に関する質問がある場合、このプライバシーポリシーの最後に記載されている連絡先をご利用ください。</p><p>本プライバシーポリシーに基づき、もし当社がEUまたはスイスの自然人から直接関係がある個人情報を受取る場合、当社は当該個人に選択を提供し（場合によっては、オプトアウトまたはオプトインを選択する）個人情報を(1) 第三者に開示するかどうか、直接販売を目的とするものを含む、または(2) 最初に集められた目的とは異なる目的のための使用、または今後当該自然人の同意を得て且つ当初の目的と相反しないもの。但し(i) 当社を代表するかまたは当社の指示に従い直接業務を遂行する第三者によるデータの転送および(ii) お客様の事前承諾を必要とする新たな処理業務の場合はこの限りではありません。</p><p>オプトアウトを希望する個人は、このプライバシーポリシーの末尾に記載されている連絡情報の詳細を利用してAppierに連絡してオプトアウトするか、または新しい目的に関連する情報プロセスにいつでも自由にアクセスできます。</p><ol><li>子供のプライバシー</li></ol><p>Appierは両親および保護者による子供のオンライン活動への積極な参与を推奨します。 Appierは児童に対し、製品およびサービスを販売又は提供しません。従って、当社ウェブサイトは成人ユーザーの相互交流の為に設計してあるので、故意に18歲未満の子供から個人情報を収集することはありません。もしお客様が16歲以下の未成年者の両親又は法定後見人で、なお且つ当該未成年者が既に当社に個人情報を開示したことを確信している場合、本プライバシーポリシーで提供する連絡先から当社に連絡してください。</p><ol><li>個人情報の転送、処理および保存</li></ol><p>当社は国境を越えた業務運営を行うグローバル組織として、Appierを代表してAppierの管理を受けて行う情報処理又は保存を含む前述の「当社によるお客様の個人情報の共有」の一節で述べた目的により、お客様の個人情報を、台湾にあるAppierのサーバーおよび事業体、全世界のAppierの関連事業体又はEU/EEA内部あるいは外部の第三者事業パートナー、プロバイダー、ベンダー、又は請負業者に移転することがあります。</p><p>Appierは2016年4月27日可決のEU法規番号第2016/679号の一般データ保護規則 (即ち「GDPR」)を含む適用のあるプライバシーおよびデータ保護法規に基づき越境移転を実施します。法律規定の適用により、お客様の個人情報も十分な保護が得られ、Appierの適切な措置の実施によりお客様の個人情報はAppier関連事業体および上述第三者間において、プライバシーおよび情報保護法規適用が遵守並びに尊重された形式で処理されます。当該措置には、EU居留民関連情報を転送するためのAppierとAppier各事業体又はサービスプロバイダーとの情報処理/移転協議が含まれます。</p><ol><li>プライバシーポリシーの改訂</li></ol><p>当社製品又はサービスの何らかの変更を反映したり、又は当社法定および/又は主務機関の規制義務の変動に従うために当社は随時プライバシーポリシーを更新する権利を保有します。当社がプライバシーポリシーを改訂した場合は、ウェブサイトにおいて最新更新期日とともに改訂版を掲載します。重要な内容の変更がある場合、当社は各項変更の実施前に他の方法でお客様に通知しますが、例えば電子メール送信による通知です。もしお客様が前述の改訂実施三十日後に当社ウェブサイトの利用を継続していた場合は、各項改訂を受け入れて同意し、これを遵守しているものと見なします。</p><ol><li>APPIERの連絡先情報</li></ol><p>お客様の個人情報保護並びに個人情報に関する要望を受けるにあたり、Appierは以下の部署および人員を指定します。<br>プライバシー保護担当部署：</p><p>法務担当部署<br>所在地：110 台湾台北市信義区松仁路123号8F<br>電話：+886287802800<br>電子メール信箱：&nbsp;<a href=mailto:legal@appier.com>legal@appier.com</a></p><p>もし当社の対応又は当社によるプライバシーポリシーに基づく処理方法にご不満がある場合、お客様には情報保護主務機関又は管轄権を有する裁判所に告発又は提訴する権利があります。EU加盟国内にお住まいの方は、下記に各国情報保護主務機関リストをご参照ください。<br><a href=\"https://www.google.com/url?q=http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm&amp;sa=D&amp;ust=1536048166971000\">http//ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a></p></ng-container><ng-container ng-switch-default><h1 class=text-center>Privacy Policy</h1><ol><li>OVERVIEW</li></ol><p>This privacy statement (“Privacy Policy”) indicates the way information is collected and utilized by Appier Inc., its subsidiaries and affiliates (“Appier”, “we”, or “us”) respect your privacy and are committed to protecting your Personal Information and being transparent about how we collect, use, and share your Personal Information This privacy policy (“Privacy Policy”) applies to all Appier’s online services and website (<a href=\"https://www.google.com/url?q=https://www.appier.com//&amp;sa=D&amp;ust=1536048166950000\">www.appier.com</a>) or to any website that includes a link or reference to this Privacy Policy (together, the “Website”) and describes how we handle Personal Information (as described below) and the choices available to you regarding collection, use, access and how to update and correct your Personal Information.</p><ol><li>APPIER’S SERVICE</li></ol><p>Appier operates artificial intelligence platforms, such as Cross X Ad Solution, AIQUA (Marketing Automation Platform) and AIXON (Data Science Platform), to help enterprises solve their most challenging business problems.</p><ol><li>PERSONAL INFORMATION WE COLLECT</li></ol><ul class=second-section><li>THROUGH THE WEBSITE</li></ul><p>We collect data, including Personal Information that you provide on our Website and as you use the Website. “Personal Information” includes information that can be used to identify you as a natural person, directly or indirectly, in particular in combination with other information available to us such as an identification number, online identifier or one or more factors specific to your identity as a natural person and may include, but is not limited to, your:</p><p>As such, should you use the form made available on the Website, we may also collect the following information:</p><ul><li>Contact information, such as name, address, phone number, email address (etc.);</li><li>Demographic information, such as your country, company, &nbsp;job title;</li><li>Comments</li></ul><p>Appier aims at keeping the Personal Information we hold is accurate and up-to-date. Please ensure that the Personal Information you communicate to us is accurate and up-to-date.</p><p>If you fail to provide certain personal data when requested, we may not be able to perform the contract we have entered into with you (such as providing you with a product or service), or we may be prevented from complying with our legal obligations.<br>In addition, when you visit our website to browse, read, or download information on the Website, your web browser automatically sends us (and we may retain) information such as the:</p><ul><li>Internet domain through which you access the Internet</li><li>Internet Protocol address of the computer you are using</li><li>Type of browser software and operating system you are using</li><li>Date and time you access our site</li><li>The Internet address of the site from which you linked directly to our site</li></ul><p>We will use this information as aggregate data to help us maintain this site, e.g., to determine the number of visitors to different sections of our site, to ensure the site is working properly, and to help us make our site more accessible and useful and in accordance with our Cookie Policy.</p><p>We also collect Personal Information from trusted third-party sources and engage third parties to collect Personal Information to assist us.</p><ul class=second-section><li>THROUGH OUR SERVICES</li></ul><p>In addition, in order to provide our services to our customers, we may also collect additional Personal Information, through our cookies placed by our customers on their own websites or from website partners authorized to collect such Personal Information.</p><p>This Personal Information is collected only if you accept the cookies for such advertising purpose.</p><ul class=third-section><li>Personal Information collected on Internet:</li></ul><ul><li>Appier Cookie identifier,</li><li>IP address,</li><li>IP geolocation,</li><li>URLs of pages of the various sites visited,</li><li>The time of your browsing on the various pages,</li><li>The type and version of the browser with which you browse the Net,</li><li>Cookie identifiers of partner technological platforms, which share the same goals, for which this data has been collected.</li><li>Ad ID</li><li>Ad web page URL</li><li>Event ID -such as&nbsp;the&nbsp;end&nbsp;user “clicks” the&nbsp;Ad or “views” the&nbsp;impression</li></ul><ul class=third-section><li>Personal information collected via Mobile Application</li></ul><p>To collect Personal Information using a mobile application, Appier relies on various partners to collect the following Personal Information:</p><ul><li>The IP address,</li><li>The mobile phone’s identifier for advertisers (IDFA for IOS devices and GAID for Android),</li><li>GPS geolocation data,</li><li>The model of mobile phone as well as its operating system (IOS, Android, etc.).</li><li>URL of pages on the client website which have been&nbsp;viewed.</li><li>Time</li><li>Ad ID</li><li>App name.</li></ul><ol><li>HOW WE USE YOUR PERSONAL INFORMATION</li></ol><p>We only collect, use and store your Personal Information for the purposes of operating our business, delivering, improving, and customizing our Website as well as products and services we provide, sending marketing and other communications related to our business, providing you with information, products and services that you request from us, and for [other legitimate purposes permitted by applicable law].</p><p>As the case may be, we will provide you with the basis of such legitimate purposes upon its occurrence, prior to implementation of the related processing.</p><p>Appier collects Personal Information for a variety of purposes, including the following:</p><ul><li>Providing you with information you requested from us;</li><li>Respond to an inquiry from you;</li><li>Sending communications to you, including for marketing or customer survey purposes, either directly from Appier or, subject to your consent, as the case may be, from our third-party partners;</li><li>Contract with you for, and provide you with our services to which you have subscribed or considering subscribing;</li><li>Creating an account;</li><li>Prevent and address fraud, breach of policies or terms, and threats or harm.</li><li>Providing customer service and support, notably through chatbots;</li><li>Improving the operation of the Website and/or help adjust the content of the Website to the general geographic location of you and for reporting purposes;</li><li>Managing a job application.</li></ul><p>We may also use the Personal Information in connection with the services rendered to our customers, and notably:</p><ul><li>To deliver advertisements as well as marketing and sales offers to you that best correspond to your needs and preferences,</li><li>To help advertisers and publishers better target their current and future customers in their loyalty building and commercial prospecting campaigns,</li><li>To help businesses distribute non-intrusive advertising,</li><li>To optimise distribution frequency of advertisements (marketing pressure) with a view to avoiding saturation,</li><li>To develop studies for advertisers of various industries (automotive, real estate, distribution, etc.) in the interest, amongst others, of helping them to better understand consumers’ needs and their market as well as to analyse the performance of their loyalty building and commercial prospecting campaigns.</li><li>Reconcile the different identifiers of various terminals in order to bring them closer to a profile in a probabilistic way.</li></ul><p>Where required or permitted by applicable law, we also use or disclose your Personal Information to limited third parties when we believe, in good faith, that such use or disclosure is reasonably necessary to (i) comply with the legal obligation bearing on Appier, (ii) enforce or apply the terms of any agreement to which we are a party, or (iii) protect the rights, property or safety of Appier, Appier customers, or others.</p><ol><li>HOW WE SHARE YOUR PERSONAL INFORMATION</li></ol><p>We may share your personal Information with our affiliate entities and other third-party business partners, providers, vendors or contractors acting on our behalf and under our instructions, whether located within or outside of the European Union (“EU”) or the Economic Area (“EEA”), for the purposes of operating our business, delivering, improving, and customizing our Website as well as our products and services, sending marketing and other communications related to our business and when needed, with your consent.</p><p>Therefore, we may share Personal Information in the following ways:</p><ul><li>Within Appier and any of our affiliate entities located within or outside of the EU/EEA, for purposes of Personal Information processing or storage in connection with the aforementioned purposes;</li><li>With Appier’s business partners, vendors, authorized third-party agents or contractors to provide our products and services or facilitate transactions. Examples include, but are not limited to: processing or orders, hosting websites and providing support.</li><li>In connection with, or during negotiations of, any merger, sale of company assets, consolidation or restructuring, financing, or acquisition of all or a portion of our business by another company;</li><li>As the case may be, for further protection of your privacy, Appier will share your Personal Information in aggregated form which may be used to identify you direclty or indirectly;</li></ul><p>Where mandated or permitted by applicable law, regulation or legal process, we will disclose your Personal Information to law enforcement officials, government authorities or other third parties, located inside and outside of the EU/EEA, where such disclosure is in accordance with due process of law and binding upon Appier, to the extent necessary to comply with legal process or meet national security requirements, protect the rights, property, or safety of Appier, its business partners, you, or others.</p><ol><li>LINKS TO THIRD-PARTIES’ WEBSITES</li></ol><p>The Website may contain links to third-party websites that are operated by companies outside of our control. Your activities on those third-party websites will be solely governed by the privacy policies and procedures of those third parties. Appier takes no responsibility whatsoever for the content or information practices of such third parties and encourage you to review the privacy polices of these third parties before disclosing any information on their websites.</p><ol><li>HOW LONG WE KEEP INFORMATION AND THE METHOD OF DESTRUCTION</li></ol><p>We will retain your Personal Information only for the duration of the purpose for which it was collected in accordance with Section 4, as well as as necessary to comply with our business requirements, legal obligations, resolve disputes, protect our assets and enforce agreements to which Appier is a party and will delete your Personal information further to this period.</p><p>In any case, we will delete your Personal Information when you do not use our service for a period of one year</p><ol><li>SECURITY AND CONFIDENTIALITY OF YOUR PERSONAL INFORMATION</li></ol><p>The security and confidentiality of your Personal Information is important to us. We implement appropriate physical, administrative, and technical measures and safeguards designed to protect your Personal Information from loss, theft, misuse, alteration, unlawful or unauthorized access, use, or disclosure.</p><p>Appier also relies on reasonable measures to safeguard Personal Information in our possession, including:</p><ul><li>Enforcement of group-wide policies and procedures on Personal Information use, security and confidentiality;</li><li>Restricting access to Personal Information to only those employees and third-party service providers on a “need to know” basis and under strict confidentiality requirements;</li><li>Use of technologies to safeguard data during transmission, such as SSL encryption for some of the data that you provide via the Website and using appropriate security measures to safeguard the data we collect and possess;</li><li>Use of industry-standard measures and processes for detecting and responding to inappropriate attempts to breach our computer systems and networks.</li></ul><p>The Internet and any communication thereon cannot be guaranteed to be secure at all times, and we cannot ensure or warrant the security of any Personal Information you provide us through this technology. In this regard, we have procedures to deal with any suspected data security breach and will notify you and any regulator of a suspected breach, as mandated by law.</p><p>Please note that electronic communication, particularly email, is not necessarily secure against interception. Appier uses industry-standard data collection and encryption systems to ensure the secure collection and transmission of your personal identifiable information. Please do not send sensitive data (e.g., Social Security, bank account, or credit card numbers) by email or web form.</p><ol><li>YOUR RIGHTS</li></ol><p>You have the right to access, obtain a paper or electronic copy, review, correct, update or delete all your Personal Information stored by us, notably to confirm its accuracy. Subject to any relevant legal requirements and exemptions, you may also oppose to or limit the processing or your Personal Information or request that certain of your Personal Information be deleted from our files.</p><p>If you reside within the EU, you may also exercise you right to portability of your Personal Information where the lawful basis for the processing is (i) (a) a contract or (b) your consent and (ii) by automated means. Please note that such a request could be limited to the sole Personal Information you provided us with or that we hold at that given time and subject to any relevant legal requirements and exemptions, including identity verification procedures.</p><p>Appier will make reasonable efforts to comply with the aforementioned requests, unless such requests are prohibited by law, or there is a legitimate purpose to retain your Personal Information, in which case we will inform you without undue delay. We reserve the right to verify your identity before any request relating to your Personal Information processed by us. Please direct any questions about your Personal Information using the contact details provided at the end of this Privacy Policy.</p><p>In accordance with this Privacy Policy, but excluding (i) any transfers of data to third parties performing tasks directly on our behalf and pursuant to our instructions and (ii) new processing operation requiring your prior consent, where we receive Personal Information directly from an EU or Swiss individual to which such Personal Information relates, we will offer the individual the opportunity to choose (as the case may be, through opt-out or opt-in) whether his or her Personal Information is (1) disclosed to a third party, including for direct marketing purposes; or (2) used for a purpose that is different than the purpose it was originally collected or subsequently authorized by the individual and compatible with that original purpose.</p><p><b>Any individual who wishes to opt out&nbsp;or to delete Personal Information&nbsp;can do so freely and at any time by contacting&nbsp;Appier at privacy@appier.com or&nbsp;the contact details provided at the end of this Privacy Policy or further to the information process relating to the new purpose.</b></p><ol><li>CHILDREN’S PRIVACY</li></ol><p>Appier encourages parents and guardians to take an active role in their children’s online activities. Appier does not sell or offer its products and services to children. As such, our Website is designed for adult user interaction. We do not intentionally collect Personal Information from children under the age of 18. If you are a parent or legal guardian of a minor under the age of 16 and believe that the minor has disclosed personal information to us, please contact us using the contact details provided in this Privacy Policy.</p><ol><li>TRANSFER, PROCESSING AND STORAGE OF PERSONAL INFORMATION</li></ol><p>As a global organization with business processes in operation across borders, we may transfer your Personal Information to Appier’s servers and entities located in Taiwan, to any Appier affiliate entity worldwide or to third-party business partners, providers, vendors, or contractors, that are located inside or outside of the EU/EEA, for purposes described in the section “How We Share your Personal Information” above, including for the purpose of data processing or storage on behalf and under the control of Appier.</p><p>Appier implements cross-borders transfers in compliance with applicable privacy and data protection regulations, including Regulation (EU) 2016/679 of 27 April 2016 on the protection of personal data (the “GDPR”). Where mandated by applicable law, to ensure that your personal data does receive an adequate level of protection, Appier implements the appropriate measures to ensure that your Personal Information is treated across Appier affiliated entities and by the aforementioned third parties in a way that is consistent with and which respects the applicable privacy and data protection laws. Measures include the following: a data processing/transfer agreements between Appier and its entities or its service providers for onward transfers of data processing agreements for data relating to EU residents.</p><ol><li>CHANGES TO PRIVACY POLICY</li></ol><p>We reserve the right to update this Privacy Policy from time to time in order to reflect any changes to our products or services or to comply with changes in our legal and/or regulatory obligations. If we modify our Privacy Policy, we will post the revised version on the Website, with an updated revision date. Where such changes are substantial, we will also notify you by other means prior to the changes taking effect, such as by sending you an email notification. By continuing to use our website thirty days after such revisions are in effect, you will be deemed to accept and agree to the revisions and to abide by them.</p><ol><li>CONTACT INFORMATION AT APPIER</li></ol><p>The following department and personnel have been designated by Appier to protect your personal data and to receive your requests regarding your information.</p><p>Department responsible for privacy protection: Legal Department</p><p>Address: 8F, No.123, Songren Road, Xinyi District, Taipei 110, Taiwan</p><p>Tel: +886287802800</p><p>E-mail:&nbsp;<a href=mailto:legal@appier.com>legal@appier.com</a></p><p>If you are not satisfied with our answer or the way we process your Personal Information pursuant to this Privacy Policy, you may also have the right to lodge a complaint with a data protection authority or a Court of competent jurisdiction. If you reside within the European Union, a list of national data protection authorities can be found here: <a href=\"https://www.google.com/url?q=http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm&amp;sa=D&amp;ust=1536048166971000\">http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a>.</p></ng-container></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

var path = '/templates/core/views/terms_of_service_appier_inc.html';
var html = "<h1 class=text-center>AiDeal使用規約</h1><p>本使用規約（下稱「本規約」）之下列內容係關於使用Appier集團所屬公司（Appier之簽約主體應依AiDeal申請表單（詳第2條定義）所載為準。下稱「Appier」）提供之AiDeal服務時之應遵守事項、及使用者與Appier間之權利義務。擬申請使用本服務者，敬請於申請前詳閱全文。</p><ol><li><p><strong>適用範圍</strong></p></li></ol><ol><li><p>本規約係以規定Appier與使用者（詳第2條定義）間就使用本服務（詳第2條定義）之相關權利義務關係為目的，並適用於使用者與Appier間有關使用本服務之一切事務。又Appier之隱私權政策（ <a href=\"https://www.appier.com/privacy-policy/\">https://www.appier.com/privacy-policy/</a> ，包含所有日後隨時得變更之內容）亦經引用而應視為本規約之一部分。Appier得按其裁量，隨時變更、修改本規約，且無須為事前通知。使用者同意，使用者繼續使用本服務者，將視為使用者同意變更、修改後之本規約。</p></li><li><p>Appier隨時刊載於Appier網站（詳第2條定義）之關於本服務之規範、各項規定等，均為本規約之一部分（包含刊載於本公司網站之本服務相關規定、AiDeal收費標準、及其他各項規定等）。惟如AiDeal申請表單（詳第2條定義）另有約定，並與本規約有不一致之情形時，應以AiDeal申請表單之記載為準。</p></li></ol><ol class=article start=2><li><p><strong>定義</strong></p></li></ol><p>本規約中所使用之下列用語，應分別具有以下所定涵義：</p><ol><li><p>「瀏覽者」：指瀏覽指定網站及／或指定應用程式之消費者。</p></li><li><p>「服務費用」：指第6條第1項定義。</p></li><li><p>「指定應用程式」：指使用者之將利用本服務的行動應用程式，並該等行動應用程式應以與使用者所營運之公司事業相關者為限。</p></li><li><p>「指定網站」：指使用者之將利用本服務的網站，並該等網站應以與使用者所營運之公司事業相關者為限。</p></li><li><p>「智慧財產權」：指著作權、專利權、新型專利權、商標權、設計專利權及其他智慧財產權（包含取得或申請該等權利註冊之權利）。</p></li><li><p>「Appier網站」：指Appier所營運之主網域位址為「appier.com」之網站（不論任何理由，如本公司網站之網域位址或內容有變更時，包含變更後之網站）。</p></li><li><p>「本服務」：指由本公司及/或關係企業即Appier集團提供名稱含有「AiDeal」之服務（不論任何理由，如服務之名稱或內容有變更時，包含該變更後之服務）。又Appier得按其裁量，隨時變更本服務之服務範圍（包括但不限於變更或停止本服務之一部或全部），且無須為事前通知。</p></li><li><p>「申請資料」：指使用者依本公司所定之制式申請表單（下稱「AiDeal申請表單」）所填載並向本公司提出之資料。</p></li><li><p>「使用者」：指與本公司締結本服務之使用契約之個人或法人。</p></li><li><p>「使用契約」：指Appier及使用者簽署之AiDeal申請表單，並本規約亦經引用而應視為使用契約之一部分。如使用者擬於歐洲經濟區或任何經歐盟委員會核准之國家使用本服務，則附於本規約之後的資料處理增補合約（Data Processing Addendum）（僅提供英文版本）亦應視為使用契約之一部分。</p></li><li><p>「有效期間」：指AiDeal申請表單中所載自起始日起至結束日之期間（如有適用，亦包含自動更新期間）。</p></li></ol><ol class=article start=3><li><p><strong>資料變更</strong></p></li></ol><p>使用者應負責確保任何向Appier提供之資料都為最新之資料；如申請資料及／或其他向Appier提供之資料（例如：與使用者帳戶相關之資料）有任何變動時，應按Appier指定之方式立即通知Appier，並按Appier之要求提供必要之資訊。如Appier認為有任何使用者資料之變動導致違反本規約之情事時，Appier得將該等違約情事告知使用者，並立即終止使用契約，且Appier無須負任何責任。</p><ol class=article start=4><li><p><strong>使用者帳戶管理</strong></p></li></ol><ol><li><p>當使用者正式開始使用本服務時，使用者應按Appier之說明建立使用者之帳戶（下稱「<strong>使用者帳戶</strong>」），並設定ID及密碼。</p></li><li><p>使用者應負全責管理及保護其使用者帳戶，於任何情形下皆不得有讓第三人使用、或出借、轉讓、出售帳戶予第三人等行為。</p></li><li><p>使用者應就因不當使用使用者帳戶相關之行為（包括但不限於使用者之故意或過失行為，或未經授權之第三人之行為）所生之損害自負全責；Appier於該情況下皆無須向使用者及／或任何第三人負責。</p></li><li><p>不論使用者是否知悉，使用者應就其使用者帳戶之所有行為負責。使用者如發現其密碼或使用者帳戶受盗、遭第三人使用時，應立即通知本公司，並完全按本公司之指示辦理。</p></li></ol><ol class=article start=5><li><p><strong>關於程式碼（Tag）及軟體開發工具包（SDK）之使用</strong></p></li></ol><ol><li><p>為利使用者可使用本服務之目的，Appier已開發並將提供相關之程式碼（下稱「Tag」）及軟體開發工具包（下稱「SDK」）。使用者僅得按照Appier之所有指示使用各個Tag及SDK。又鑒於本服務之性質，Appier得隨時更新Tag及SDK。</p></li><li><p>使用者僅得於為使用本服務之範圍內，使用各Tag及SDK。使用者不得使用Tag及SDK構築與本服務競爭之任何產品或服務。</p></li></ol><ol class=article start=6><li><p><strong>服務費用及付款</strong></p></li></ol><ol><li><p>使用者應向Appier支付AiDeal申請表單中所載之費用（下稱「服務費用」）作為使用本服務之對價。Appier會於AiDeal申請表單中提供收款資訊供使用者作業，且，如經Appier要求，使用者應以書面將使用者之付款資訊（例如：銀行代碼、分行代碼、帳戶類別、帳戶號碼及銀行帳戶所有人之資訊）通知Appier。</p></li><li><p>除Appier及使用者間另有事前書面約定外，各月份之服務費用應於各日曆月之末日結算之（於本項範圍內，下稱「結算日」），且使用者應於翌日起五個工作日內確認並同意該等金額。又如使用契約於結算日後終止，但使用者尚未付款時，使用者仍應給付使用契約終止前所產生之服務費用。為避免疑義，如本服務之開始日距結算日未滿一個月（例如使用者於1月15日起使用本服務，而最初之結算日為1月31日），且使用者應適用固定月費時，服務費用將按比例計算之。</p></li><li><p>使用者延遲支付服務費用時，使用者應按年利率14.6%（或其他應適用之法律所允許之最高利率，取其高者）計算遲延利息作為對Appier之遲延損害賠償金。</p></li><li><p>使用者得依使用契約之約定終止合約，惟Appier於任何情況下皆無須向使用者返還使用者於使用契約終止前已支付之任何服務費用。</p></li></ol><ol class=article start=7><li><p><strong>智慧財產權歸屬</strong></p></li></ol><ol><li><p>與本服務相關之智慧財產權（包括但不限於Appier提供及開發之所有Tag及SDK）於任何時點均應歸屬Appier及/或Appier之授權人所有。除本規約另有明文約定者外，授權使用本服務，並不代表授權使用Appier或Appier之授權人之智慧財產權。使用者不得以任何方式（包括但不限於逆向分解、逆向編譯及逆向工程）侵害Appier或其授權人之智慧財產權。</p></li><li><p>使用者應就所有內容及素材（包括但不限於文字、設計、圖示、或使用者提供給Appier或使用者自行上傳至AiDeal平台之其他任何廣告素材、或Appier依照使用者指示準備之任何素材）（以下合稱「使用者內容」）負全責；且使用者在此保證其擁有於使用本服務之過程中利用、提供及上傳使用者內容之所有必要之權利。使用者並聲明及保證，經使用者所提供之使用者內容，及Appier利用該等使用者內容，均不會侵害、濫用第三人之智慧財產權，且不會違反任何應適用之法律。</p></li><li><p>Appier為使用者製作、及／或由使用者向Appier提供之使用者內容中之智慧財產權，於任何時點均應歸屬使用者及／或其授權人所有。使用者在此授予Appier一經限制、非專屬、不可撤回、不限地域、無權利金、可轉讓之權利，使Appier得於提供本服務所必要之範圍內、就該等使用者內容進行再授權、存取、瀏覽、使用、複製、變更、公開顯示及傳送。</p></li><li><p>使用者不得未經Appier事前書面同意，為了任何目的以任何方式使用或顯示Appier之名稱、商標、Logo或其他Appier專屬資訊。</p></li></ol><ol class=article start=8><li><p><strong>使用者之其他責任義務</strong></p></li></ol><ol><li><p>使用者為接受本服務所必要之電腦、軟體、其他機器、通訊線路及其他通訊環境等之準備及維護，由使用者負擔費用並自行處理。</p></li><li><p>基於Appier之合理請求，使用者應將Appier另以書面指定之事項（如有）列入指定網站及／或指定應用程式之隱私權政策中，並應使瀏覽者得易於閱覽該等隱私權政策。</p></li><li><p>使用者了解，其應以自己之責任，按應適用之法律（例如，關於個人資料保護相關之法律及規定）取得容許使用者利用本服務所必要之瀏覽者之同意。如Appier合理請求使用者變更於有效期間內應適用於瀏覽者之使用者自身的規約、政策以及其他規則等（下稱「使用者規約」）時，使用者應於Appier所定期間內配合處理。Appier就有關使用者與瀏覽者間所發生之交易、溝通、爭議等（包含但不限因使用者規約所生者）不負任何責任，使用者應以自己之責任及費用予以解決。</p></li><li><p>使用契約終止時，使用者應按Appier之指示，自指定網站及／或指定應用程式、及所有使用者之裝置（如適用）中刪除所有Tag及／或SDK。使用者在此確認，如使用者未能自指定網站及／或指定應用程式、及所有使用者之裝置（如適用）刪除所有Tag及／或SDK，而因Appier於使用契約終止後就Tag及／或SDK進行變更及／或使其失效，而導致使用者受有任何損害（包括但不限於指定網站及／或指定應用程式出現錯誤）時，Appier概不負責。</p></li></ol><ol class=article start=9><li><p><strong>機密資訊</strong></p></li></ol><ol><li><p>「機密資訊」包括與本服務相關，或對某一當事人 （下稱「揭露方」） 目前或未來之營運具有或可能具有商業價值或其他功用而向對方 （下稱「收受方」） 揭露之全部資訊或資料，包括但不限於財務狀況、顧客名單、市場開發、或技術資訊，且於揭露時經指定為機密、或按其揭露之情境或經揭漏之資訊之性質應被視為機密者。基於例示且非限制之原則，機密資訊包括 （但不限於） 以下各項：（i）雙方當事人間所交換，以任何形式或媒材存在之資訊，但該等資訊應於揭露時標示為「機密」；（ii）其揭露之情境應係一般理智人士會認為接受人應該會將該等資訊視為機密。</p></li><li><p>縱有前項約定，「機密資訊」不包括下列資訊：（i）該資訊係於揭露方提供前，收受方已合法知悉或取得者；（ii）於收受方受揭露之後因不可歸責於收受方之因素成為公開資訊者，或因不可歸責於收受方之事由為收受方所知悉者；（iii）收受方合法自無保密義務之第三人取得或知悉者；（iv）該資訊是由收受方於未參考機密資訊之情形下自行研發所得。</p></li><li><p>縱有前開約定，任一方當事人得依任何法院命令、法規或類似之調查或要求，於必要範圍內揭露他方當事人之機密資訊。惟收受方依本條揭露機密資訊之前，應以合理之努力（i）立刻以書面通知揭露方該等揭露機密資訊之要求，並（ii）配合揭露方保護或縮小揭露範圍，或取得保護令。</p></li><li><p>收受方了解，如其未經同意而揭露機密資訊，所導致之損害將難以單靠金錢賠償彌補之。基此，如收受方未經同意揭露方同意而揭露機密資訊，揭露方得按應適用之法律尋求禁制令或其他同等及所有可能之救濟。</p></li></ol><ol class=article start=10><li><p><strong>禁止行為</strong></p></li></ol><p>使用者使用本服務時，不得有該當下列任一款之行為。如經Appier按自己之裁量權判斷，使用者或指定網站／指定應用程式有該當下列任一事由、或有該當該等情形之虞時，Appier得於不負任何額外責任之情形下對該使用者暫停提供本服務或終止使用契約：</p><ol><li><p>侵害Appier或其他第三人之智慧財產權、肖像權、隱私權、名譽、其他權利或利益之行為（包含但不限於直接或間接之侵權行為)。</p></li><li><p>試圖針對Appier用於提供本服務之軟體進行逆向分解、破解、逆向編譯、逆向工程及／或其他推導原始碼之行為。</p></li><li><p>涉及違法、犯罪或違反公序良俗之行為。</p></li><li><p>傳送虛偽或其他不適當之內容，包括但不限於違法之色情、猥褻、及/或暴力相關之資訊。</p></li><li><p>傳送含有電腦病毒及其他有害電腦程式訊息之行為。</p></li><li><p>有妨礙Appier營運（包括但不限於本服務之營運）之行為。</p></li><li><p>利用本公司所提供之程式碼及／或SDK，逕自於指定網站及／或指定應用程式以外之網站／應用程式向瀏覽者提供購買回饋獎勵之行為（包含但不限發行優惠券、提供折扣及發放贈品等）。</p></li><li><p>其他經Appier判斷屬不適當之行為。</p></li></ol><ol class=article start=11><li><p><strong>本服務之停止</strong></p></li></ol><ol><li><p>於符合以下任一款事由時，Appier得不事前通知使用者，逕行停止或中斷本服務之一部或全部：</p><ol><li><p>緊急進行本服務相關電腦系統之檢查或維修作業時。</p></li><li><p>電腦、通訊線路等因事故而停止時。</p></li><li><p>因火災、停電、天災地變等不可抗力而無法營運本服務時。</p></li><li><p>其他經本公司判斷須停止或中斷時。</p></li></ol></li></ol><ol class=article start=2><li><p>Appier於任何情況下，均不就因採取本條所列之措施而對使用者造成之損害負責。</p></li></ol><ol class=article start=12><li><p><strong>終止</strong></p></li></ol><ol><li><p>下各款任一事由時，Appier得不經事前通知或催告即暫停該使用者對本服務之使用或終止使用契約。</p><ol><li><p>違反本規約任一條款時。</p></li><li><p>經確認AiDeal申請表單有虛偽陳述時。</p></li><li><p>依應適用之法律，使用者有停止付款或陷於無清償能力之情事，或有聲請開始進行破産程序、民事再生程序、公司重整程序、特別清算或類似之程序時。</p></li></ol></li><li><p>如使用者符合前項各款任一事由，使用者對Appier所負之一切債務將當然喪失期限利益，並應立即向Appier支付所有未付之款項。</p></li><li><p>Appier於任何情況下，均不就因採取本條所列之措施而對使用者造成之損害負責。</p></li><li><p>使用者得依AiDeal申請表單所載之方式（如適用），以事前書面通知Appier於指定之日曆月之末日終止使用契約。</p></li></ol><ol class=article start=13><li><p><strong>違約責任</strong></p></li></ol><p>如使用者未能履行或違反使用契約之義務，且導致Appier因此受有損害或遭第三人提出任何主張或請求，則使用者應提供Appier所有必要之協助，且賠償Appier因此所受之所有損害，包括但不限於訴訟費用及律師費用。</p><ol class=article start=14><li><p><strong>聲明與保證</strong></p></li></ol><ol><li><p>Appier茲聲明並保證：（a）Appier有充分權利與權限得締結使用契約，並履行使用契約之約定；（b）Appier按使用契約履行其應盡義務不會違反其所簽署之任何其他協議；（c）使用契約一經簽署與交付，即構成對Appier之有效、合法且具約束力義務。</p></li><li><p>使用者茲聲明並保證：（a）使用者有充分權利與權限得締結使用契約，並履行使用契約之約定；（b）使用者按使用契約履行其應盡義務不會違反其所簽署之任何其他協議；（c）使用契約一經簽署與交付，即構成對使用者之有效、合法且具約束力義務；（d）不得以任何病毒、蠕蟲、破解程式、自動機器人軟體、機械或電子設備、其他電腦程式或任何不正當手段介入、侵入、損害、更改、反解譯本服務；（e）不得進行逆向工程或變更本服務之原始碼；（f）其於任何時間點均不會遭認定為反社會勢力（定義如下）；（g）其於任何時間點均不會被列於美國海外資產控制辦公室（Office of Foreign Assets Control，下稱「OFAC」）之制裁名單。</p></li><li><p>使用者應以自己之責任及費用確認其使用本服務是否會違反任何應適用於使用者之法律或所屬產業組織之相關規範。Appier就使用者使用本服務是否符合任何應適用於使用者之法律或所屬產業組織之相關規範事，不為任何保證。使用者並應以自己之責任處理及解決任何使用者與第三方間之與本服務相關的交易、聯絡或爭議。Appier就前述事由概不負責。</p></li><li><p>就Appier暫停、停止、終止本服務、或使本服務無法被使用、或變更本服務內容，或使用者因使用本服務導致資料消滅、設備故障或損壞，或因其他與本服務相關之事由導致使用者所受之損害，Appier概不負責。</p></li></ol><ol class=article start=15><li><p><strong>免責條款</strong></p></li></ol><ol><li><p>本服務乃以「現況」及「以目前明示的條件下」的狀態提供。Appier就本服務，不提供任何明示或默示的擔保及保證，包括但不限於特定目的之適銷性、未侵害任何他人權利、針對特定目的之適用性、其他關於交易或履約過程之默示保證；Appier亦不保證本服務，或依本規約提供之任何服務或平台，將永久可得、可存取、不受干擾、即時、或無錯誤。</p></li><li><p>Appier無須為（I）使用者之作業或傳輸疏失、中斷、刪除、錯誤或延遲；（II）通訊傳輸中斷或網路壅塞；（III）竊盜或其他不法行為；（IV）未經授權之使用或修改本服務；或（V）其他不可歸責於Appier之行為或原因對使用者負責。</p></li><li><p>除與本規約第7條所相關之事由外，對於基於使用契約之履約或未履約或因其而生之任何衍生性、間接、隨附、懲罰性或任何類型之特殊損害賠償，無論對方所蒙受之相關損害是否係基於違約、侵權 （包括但不限於重大過失），或任何責任理論 （包括但不限於所失利益、營業中斷或其他經濟損失），且無論相關當事人是否已獲悉相關損失或損害之可能性，任一當事人均無須向他方當事人負責。</p></li><li><p>就因本服務、或因任何使用（或未能使用）本服務或使用者內容而產生、或與前述事由相關之原因而致Appier應負任何責任時，Appier對使用者之賠償責任應以自相關請求發生時起回遡3個月內Appier實際自使用者受領之本服務使用費用之總額為上限。</p></li></ol><ol class=article start=16><li><p><strong>其他合規要求</strong></p></li></ol><ol><li><p>於應適用之範圍內，如使用者經Appier判斷屬於反社會勢力（係指黑社會組織、黑社會組織成員、右翼團体、反社會勢力、及其他與之相當者；下同。），或透過提供資金或其他方式協助、參與反社會勢力之維持、營運及經營等方式，與反社會勢力進行任何交流或有所牽連時，Appier得不經事前通知立即終止使用契約。</p></li><li><p>除前項所定情形之外，如確認使用者之董事、監察人、員工或其他成員、股東、交易往來對象或顧問為反社會勢力，或透過提供資金或其他方式協助、參與反社會勢力之維持、營運及經營等方式，與反社會勢力進行任何交流或有所牽連，如受Appier通知要求停止該等關係惟於相當期間內仍未能停止者，Appier得以書面通知使用者立即終止使用契約。</p></li><li><p>於應適用之範圍內，如使用者經Appier確認被列於OFAC之制裁名單內，則Appier得不經事前通知立即終止使用契約。</p></li><li><p>如使用契約依第16條約定遭終止，而導致使用者受有任何損害時，Appier概不負責；又使用者應賠償Appier因此所受之一切損害。</p></li></ol><ol class=article start=17><li><p><strong>有效期間</strong></p></li></ol><p>除雙方另有約定外，使用契約之有效期間應自AiDeal申請表單所載之開始日起生效，直到（i）AiDeal申請表單所載之結束日止，或（ii）任一方依本規約或AiDeal申請表單所載之約定終止使用契約時為止。</p><ol class=article start=18><li><p><strong>聯絡／通知</strong></p></li></ol><p>本服務相關諮詢及其他使用者對Appier之聯絡或通知、及其他Appier對使用者之聯絡或通知，應依本公司另定之方法為之。</p><ol class=article start=19><li><p><strong>轉讓</strong></p></li></ol><ol><li><p>使用者未經Appier書面事前同意，不得將其於使用契約上之地位或依本規約所生之權利或義務轉讓、移轉、設定擔保、為其他處分予第三人。</p></li><li><p>如Appier將本服務相關事業轉讓予其他公司，Appier得隨該營業讓與將Appier於使用契約上之地位、依本規約所生之權利及義務暨使用者註冊資訊或其他顧客資訊轉讓予該營業讓與之受讓人，使用者在此就該等轉讓表示同意。此外，本項所稱營業讓與，除一般營業讓與外，應包含公司分割及其他營業移轉等任何情形。</p></li></ol><ol class=article start=20><li><p><strong>可分性</strong></p></li></ol><p>使用契約之任一條款或部分內容如依應適用之法令等經判斷為無效或無法執行，其餘規定仍繼續具完整效力。</p><ol class=article start=21><li><p><strong>存續規定</strong></p></li></ol><p>依其性質，於必要之範圍內，第4條第3項、第5條、第6條、第7條、第8條第3項及第4項、第9條、第12條第2項及第3項、第 13 條至第 16條、及第18條至第 23 條之規定於使用契約終止後仍應有效存續。又縱有前開約定，第9條於使用契約終止後3年內應繼續有效。</p><ol class=article start=22><li><p><strong>準據法及管轄法院</strong></p></li></ol><p>使用契約應以Appier簽約主體所在地之法律作為準據法，但不適用其法律衝突之規定。</p><ol><li><p>如使用契約應以新加坡法為準據法，任何因使用契約所生或與其相關之一切爭議，包括但不限於其存在、有效性或終止（下稱「爭議」），應按新加坡國際仲裁中心當時有效之仲裁規定於新加坡進行仲裁，且該等仲裁規定應視為使用契約之一部分。除雙方當事人另有約定外，仲裁庭應由3名仲裁人組成。仲裁程序應以英文進行，且仲裁判斷將為拘束雙方當事人之終局判斷。</p></li><li><p>如使用契約應以日本法為準據法，所有爭議應以東京地方法院為第一審管轄法院。</p></li><li><p>如使用契約應以中華民國法律為準據法，所有爭議應以台北地方法院為第一審管轄法院。</p></li></ol><ol class=article start=23><li><p><strong>爭議解決</strong></p></li></ol><p>如於對本規約未盡事項或本規約之解釋生有疑義，Appier及使用者應先行相互遵循誠信原則進行協議，並盡速謀求解決。</p><p>【修訂：2020年11月15日】</p><p>【初版：2019年10月15日】</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

var path = '/templates/core/views/terms_of_service_appier_jp.html';
var html = "<h1 class=text-center>AiDeal利用規約</h1><p>本利用規約（以下「本規約」といいます）には、当社Appierのグループ会社（Appier側の締約者は申込フォーマット（下記第2条に定義）の記載に準じます）が提供するAiDealサービスの内容、及び当該サービスの利用にあたり、当社とユーザーの皆様との間の権利義務関係が定められております。本サービスの利用をお申し込みいただく方は、お申し込み前に、必ず全文お読み下さい。</p><ol><li><p><strong>適用範囲</strong></p></li></ol><ol><li><p>本規約は、本サービス（第 2 条に定義）の利用に関する当社とユーザー（第 2 条に定義）との間の権利義務関係を定めることを目的とし、ユーザーと当社の間の本サービスの利用に関わる一切の関係に適用されます。なお、当社のプライバシーポリシー（ <a href=\"https://www.appier.com/privacy-policy/\">https://www.appier.com/privacy-policy/</a> ，今後随時修正するバージョンを含む）は本規約の一部とみなします。当社は、当社の独自の裁量で、事前通知なしで本規約を随時変更もしくは改正できるものとします。ユーザーは、本サービスを利用し続けることにより、改定後の本規約に同意するとみなします。</p></li><li><p>当社が当社ウェブサイト（第 2 条に定義）上で随時掲載する本サービスに関するルール、諸規定等は本規約の一部を構成するものとします（当社ウェブサイトに掲載する本サービスに関するルール、「AiDealシリーズ料金表」、その他の諸規定等を含みます）。前記にかかわらず、申込フォーマットにて別途の約定があり、且つ本規約と齟齬がある場合、申込フォーマットに記載する約定を優先適用します。</p></li></ol><ol class=article start=2><li><p><strong>定義</strong></p></li></ol><p>本規約において使用する以下の用語は各々以下に定める意味を有するものとします。</p><ol><li><p>「閲覧者」とは、対象サイトもしくは対象アプリを閲覧する者を意味します。</p></li><li><p>「サービス利用料金」とは、第6条第1項に定める「サービス利用料金」を意味します。</p></li><li><p>「対象アプリ」とは、本サービスを利用するユーザーが有するモバイルアプリケーションを意味します。ただし、当該モバイルアプリケーションはユーザーが運営するビジネスに関連するものに限ります。</p></li><li><p>「対象サイト」とは、本サービスを利用するユーザーが有するウェブサイトを意味します。ただし、当該ウェブサイトはユーザーが運営するビジネスに関連するものに限ります。</p></li><li><p>「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権(それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含む)を意味します。</p></li><li><p>「当社ウェブサイト」とは、当社が運営するメインドメイン「appier.com」に属するすべてのウェブサイトを意味します（理由を問わず、当社のウェブサイトのドメインもしくは内容が変更された場合は、当該変更後のウェブサイトを含みます)。</p></li><li><p>「本サービス」とは、当社が提供する“AiDeal”という名称が入っているサービスを意味します(理由を問わず、サービスの名称もしくは内容が変更された場合は、当該変更後のサービスを含みます)。当社は、当社の独自の裁量で、事前通知なしで本サービスの範囲や内容を随時変更できるものとします（本サービスの一部もしくは全部の機能変更もしくは提供中止を含むがこれらに限りません）。</p></li><li><p>「申込情報」とは、ユーザーが当社の定める様式の申込フォーマット（以下「申込フォーマット」といいます。）に記載し当社に提出した情報を指します。</p></li><li><p>「ユーザー」とは、当社との間で本サービスの利用契約を締結した個人又は法人を意味します。</p></li><li><p>「利用契約」とは、当社とユーザーの間で締結した申込フォーマット及び参照することにより組み込まれた本規約を指します。なお、ユーザーが欧州経済領域 （European Economic Area）またはいずれかの欧州委員会（European Commission）に認可された国に本サービスを利用する場合、本規約に添付されるデータ処理補足契約書 （Data Processing Addendum）（英語バージョンのみ）は利用契約の一部としてみなします。</p></li><li><p>「有効期間」とは、申込フォーマットに記載される開始日から終了日までの期間（自動更新期間（定めがある場合）を含む）を指します。</p></li></ol><ol class=article start=3><li><p><strong>申込情報の変更<br></strong></p></li></ol><p>ユーザーは責任をもって当社に提供する全ての情報が最新なものであることを保証すべきであり、申込情報もしくはそのほか本サービスのために提供した情報（例えば、アカウントに関するいかなる情報）に変更があった場合、ユーザーは滞りなく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された情報を提出するものとします。当該変更により、本規約に違反することとなると当社が判断した場合には、当社はいかなる責任も負わず、ユーザーとの本サービス利用契約を直ちに解約できるものとします。</p><ol class=article start=4><li><p><strong>ユーザーアカウントの管理</strong></p></li></ol><ol><li><p>ユーザーが正式に本サービスの利用を始める際に、ユーザーは当社の指示に従いユーザーアカウントを作る（ID及びパスワードの設定を含む）ものとします。</p></li><li><p>ユーザーはアカウントの管理及び保管に関する全責任を負うべきものとし、いかなる場合においても第三者にアカウントの利用を許し、またはアカウントを第三者に貸し、譲渡、売り渡すことをしてはなりません。</p></li><li><p>ユーザーは、ユーザーのアカウントに関する管理ミスもしくは過失（第三者による不正利用を含むがこれに限らない）により生じたすべての損害について責任を負うべきであり、且つ当社は前記の状況においてユーザーもしくはいかなる第三者に対し何らかの責任も負いません。</p></li><li><p>ユーザーの認識の有無を問わず、ユーザーは所有するアカウントのもとに行ったすべてのアクティビティについて全責任を負うものとします。アカウントの不正利用が発覚した場合、ユーザーは滞りなく当社に知らせるべきであり、且つ当社の指示に全面的に従うものとします。</p></li></ol><ol class=article start=5><li><p><strong>タグ及びSDKの利用</strong></p></li></ol><ol><li><p>ユーザーの本サービスへのアクセスを可能にするために、当社は関連するタグ及びソフトウエア開発キット（以下「SDK」という）を開発し、提供するものとします。ユーザーは各タグもしくはSDKを当社の指示に従い利用するものとします。本サービスの性質上、当社は随時各タグもしくはSDKを更新できるものとします。</p></li><li><p>ユーザーは本サービスを利用する目的のためにのみ各タグもしくはSDKを利用するものとします。ユーザーは各タグもしくはSDKを使って本サービスと競合するサービスまたは商品を作ってはなりません。</p></li></ol><ol class=article start=6><li><p><strong>サービス利用料金及び支払い</strong></p></li></ol><ol><li><p>ユーザーは、本サービス利用の対価として、申込フォーマットに記載された料金を（以下「サービス利用料金」といいます。）を負担し、当社に支払うものとします。当社は申込フォーマットにて振込情報をユーザーに提供します。ユーザーは、当社のリクエストに応じて、書面をもってユーザーの支払い情報（銀行口座の銀行コード、支店コード、口座の種別、口座番号および口座に記載された主たる口座保有者の氏名など）を当社に提供するものとします。</p></li><li><p>当社とユーザーの間に別途の書面による約定がある場合を除き、各月のサービス利用料金は各暦月の末日（本項のために「締め日」という）に基づき計算するものとし、ユーザーは締め日以降5営業日以内に支払額を確認し、同意しなければなりません。なお、利用契約が締め日以降、サービス利用料金の支払い前に解約された場合、ユーザーは解約前に発生したサービス利用料金を支払うべきものとします。疑義を避けるために明記すると、本サービスの開始日と最初の締め日の間の期間が一か月未満であり（例えばユーザーは1月15日より本サービスの利用を開始する場合、最初の締め日は1月31日になります）、且つユーザーがサービス利用料金の定額プランを適用する場合、当該月のサービス利用料金は比例計算されます。</p></li><li><p>ユーザーがサービス利用料金の支払を遅滞した場合、ユーザーは年14.6%の割合による遅延損害金を当社に支払うものとします。</p></li><li><p>ユーザーは利用契約の約定に基づき解約することができます。但し、当社はいかなる場合であっても、解約前に既にユーザーから当社へ支払われたサービス利用料金を返還する義務を負わないものとします。</p></li></ol><ol class=article start=7><li><p><strong>知的財産権の所有権について</strong></p></li></ol><ol><li><p>本サービスに関連する知的財産権（当社が開発しかつ発行するタグもしくはSDKに関連するものを含むがこれらに限らない）はいつでも当社または／及び当社のライセンサーが所有するものとします。本規約に定めがある場合を除き、本サービスの利用への承諾は、いかなる場合においても当社または当社のライセンサーが有する知的財産権に関するライセンスの許諾としてみなしてはなりません。ユーザーは当社または当社のライセンサーが有する知的財産権を侵害するまたは侵害する恐れがあるいかなる行為もしてはなりません（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません）。</p></li><li><p>ユーザーは全てのコンテンツ及び素材（テキスト、デザイン、画像、及び／またはいかなるユーザーが当社に提供する、またはユーザーが直接に本サービスのプラットフォームにアップロードする広告素材や、当社がユーザーの指示のもとに用意するいかなる素材を含むがこれらに限らない）（以下まとめて「コンテンツ」という）について全責任を負うものとします。ユーザーは、ユーザーが本サービスを利用する際に前記のコンテンツを活用、提供、アップロードするために要する全ての権利を有することを、当社に保証します。なお、ユーザーは、ユーザーがいかなるコンテンツを提供すること、及び当社がそれらを利用することは（1）いかなる第三者の知的財産権に対する侵害または濫用にならないこと、また（2）適用すべきいかなる法律にも違反しないことを、当社に対し保証します。</p></li><li><p>ユーザーのために当社が作るコンテンツ、及び／またはユーザーが当社に提供するコンテンツに関する知的財産権はいつでもユーザーおよびユーザーのライセンサーが所有するものとします。ユーザーは、当社に使用を限定する非専属的、撤回不能な、世界全域で有効な,ロイヤリティフリー、譲渡可能なライセンスを付与するとともに、当社に本サービを提供するための範囲内にコンテンツを再授権、アクセス、閲覧、複製、修正、公開表示、及び配布する権利も付与するものとします。</p></li><li><p>当社事前の書面による同意を得た場合を除き、ユーザーはいかなる方法で当社の社名、商標、ロゴ、またはそのほかの専有情報をいかなる目的のために利用または表示することはできません。</p></li></ol><ol class=article start=8><li><p><strong>ユーザーの責務</strong></p></li></ol><ol><li><p>ユーザーが本サービスの提供を受けるために必要な、コンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、ユーザーの費用と責任において行うものとします。</p></li><li><p>ユーザーは、当社が合理的な要請をした場合、当社が別途で書面をもって提供する事項（もしある場合）を対象サイトまたは対象アプリのプライバシーポリシーに記載し、閲覧者に対して当該プライバシーポリシーが容易に閲覧可能な状態にしなければなりません。</p></li><li><p>ユーザーは、ユーザーが本サービスを利用できるように、適用すべき法律（例えば、個人情報保護に関する法律や規定）において必要とする閲覧者の同意をユーザーの責任で取得すべきことを、理解しています。ユーザーは、当社が、有効期間内に閲覧者に対し適用するユーザーの規約及びポリシー（プライバシーポリシーを含む）その他の規則等（以下「ユーザー規約等」という）を変更するよう合理的に求める場合、当社が定める期間内にこれに応じるものとします。ユーザーと閲覧者との間で生じた取引、連絡、紛争等（ユーザー規約等に起因するものを含むが、これに限らない）について、当社はいかなる責任も負わないものとし、ユーザーは自己の責任と費用においてこれらを解決するものとします。</p></li><li><p>利用契約が解約された場合、ユーザーは、当社の指示に従い、対象サイト、対象アプリまたはユーザーの端末（もし適用であれば）からすべてのタグもしくはSDKを削除し、外さなければなりません。ユーザーが対象サイト、対象アプリまたはユーザーの端末（もし適用であれば）から全てのタグもしくはSDKを削除または外さなかったなどの場合、ユーザーは、当社が利用契約の解約以降に行ったタグもしくはSDKの変更及び／または無効化によりユーザーが被ったいかなる損害に対し、当社はいかなる責任も負わないものとします（対象サイトまたは対象アプリに生じるエラーを含みますがこれらに限りません）。</p></li></ol><ol class=article start=9><li><p><strong>機密情報</strong></p></li></ol><ol><li><p>「機密情報」とは、本サービに関連していずれか一方の当事者（以下「開示当事者」という）を他方当事者（以下「受領当事者」という）に開示するいかなる情報及び／または資料であり（開示当事者の現在または将来のビジネス運営計画、財務状況、マーケティング活動、または技術関連情報を含むがこれらに限らない）、且つ開示当時に機密情報であることを明記し、もしくは開示時の状況または開示された情報の性質を鑑み、受領当事者が当該情報を機密情報として認識することが合理的であると考えるものを指します。機密情報は、以下のものを含みますがこれらに限りません：（i）情報開示当時、情報を記載している媒体や形態を問わず、「機密」もしくは類似な文字を記載されているすべてのもの、及び（i i）実務上、善意的な情報受領者が機密として認識する全ての情報。</p></li><li><p>前項にかかわらず、次のいずれかに該当する場合、当該情報は機密情報に該当しません：（i）受領当事者が開示当事者から情報を受領する前にすでに公開情報となったもの、または受領当事者がすでに知悉しまたは取得したもの。（ii）開示当事者により情報開示を受けた以降、受領当事者の責に帰すべきではない事由により公開情報になったもの、または受領当事者の責に帰すべきでない事由により受領当事者が別途で知らされた情報。（iii）受領当事者が合法的に秘密保持義務を有しない第三者から知悉しまたは取得したもの。（iv）受領当事者が機密情報を参考することなく独自に開発したもの。</p></li><li><p>本規約の約定は、いずれか一方の当事者が、いかなる裁判所命令、法律規程、法執行や類似する要請や調査等に従って他方当事者の機密情報を開示することを妨げません。ただし、前記の約定に基づき機密情報を開示する前に、受領当事者は合理的な努力をもって（i）速やかに書面をもって開示当事者に開示要請について知らせるものとし、なお（ii）開示当事者に協力し、当該開示要請を拒否しもしくは最小限にとどまるようにつとめ、または秘密保持命令を取得するものします。</p></li><li><p>受領当事者は、機密情報の同意されていない開示は、開示当事者にとって金銭的損害賠償も補えない実質的な損害をもたらすことを理解しているものとします。従って、受領当事者が同意を得ることなく機密情報を開示した場合、開示当事者は適用すべき法律に基づき差し止めまたはそのほか公正とされる救済、及びすべて可能な賠償を受ける権利を有します。</p></li></ol><ol class=article start=10><li><p><strong>禁止行為</strong></p></li></ol><p>ユーザーは、本サービスを利用する際に、以下に定めた行為のいずれも行ってはなりません。当社の裁量で、ユーザー、対象サイトまたは対象アプリが下記条項のいずれかに該当する（または該当する恐れがある）と当社が認める場合、当社はユーザーに対し本サービスを一時停止し、及び／またはいかなる責任も負わず利用契約を解約する権利を有するものとします。</p><ol><li><p>当社またはいかなる第三者が有する知的財産権、肖像権、プライバシーに関する権利、名誉またはそのほかの権利や利益を侵害すること（直接的及び間接的な侵害行為を含みますがこれらに限りません）。</p></li><li><p>逆アセンブル、復号、逆コンパイル、リバースエンジニアリング及び／またはそのほかの方法で、当社が本サービスを提供するために使っているソフトウエアのソースコードの解明を試みること。</p></li><li><p>適用すべき法律または規定に違反し、犯罪を行い、または公序良俗に反する行為を行うこと。</p></li><li><p>虚偽の情報または不適切なコンテンツ（違法なセクシュアル、猥褻や暴力に関連する情報を含みますがこれらに限りません）を提供すること。</p></li><li><p>コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報を送信すること。</p></li><li><p>当社の運営（本サービスの提供を含むがこれに限らない）を妨害するおそれがある行為をすること。</p></li><li><p>当社が提供しているタグまたは／及びSDKを利用して、対象サイト／対象アプリ以外の特定サイト／アプリを閲覧する者に対し購買インセンティブ（クーポンの発行、割引の実施及び景品の配布を含むが、これらに限られない）を恣意に与えること。</p></li><li><p>その他、当社が当社の裁量で不適切であると判断する行為。</p></li></ol><ol class=article start=11><li><p><strong>本サービスの中止</strong></p></li></ol><ol><li><p>下記いずれかの状況に該当する場合、当社は本サービスの一部または全部を、ユーザーに対し事前に通知することなく、一時停止または中止できるものとします。</p><ol><li><p>本サービスに係るコンピューター・システムの点検又は保守作業を緊急に行う場合。</p></li><li><p>コンピューター、通信回線等が事故により一時停止した場合。</p></li><li><p>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合。</p></li><li><p>その他、当社が停止又は中止を必要と判断した場合。</p></li></ol></li><li><p>本条に基づき当社が行った措置によりユーザーに生じた損害について、当社は一切の責任を負わないものとします。</p></li></ol><ol class=article start=12><li><p><strong>解約</strong></p></li></ol><ol><li><p>ユーザーが下記いずれかの状況に該当する場合、当社は、事前通知なく、本サービスを一時停止しもしくは利用契約を解約できるものとします。</p><ol><li><p>本規約のいずれかの約定に違反した場合。</p></li><li><p>申込情報に虚偽の記述が含まれたことが判明した場合。</p></li><li><p>適用すべき法律に基づき、支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合。</p></li></ol></li><li><p>前項各号のいずれかの事由に該当した場合、ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</p></li><li><p>当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について一切の責任も負わないものとします。</p></li><li><p>ユーザーは、当社に対し事前に書面をもって通知することにより、申込フォーマットに記載された手順に従って（定めがある場合）各暦月の末日に利用契約を解約できるものとします。</p></li></ol><ol class=article start=13><li><p><strong>利用契約に関する違約責任</strong></p></li></ol><p>ユーザーが利用契約に定められた義務を履行しないまたは契約の約定に違反することにより、Appierに損害が生じ、または第三者からの請求を受けた場合、ユーザーはAppierにすべて必要な協力を提供し、Appierが被ったすべての損害（弁護士費用及び訴訟費用を含むがこれに限らない）を賠償するものとします。</p><ol class=article start=14><li><p><strong>保証</strong></p></li></ol><ol><li><p>当社はユーザーに対し下記の通りに声明し、保証します：(a) 当社は、利用契約を締結し、その義務を履行する十分な権利及び権限を有すること。(b)当社は、利用契約に基づきその義務を履行することは、当社が締結したほかの約定に違反しないこと。(c)利用契約は署名されることにより、当社に効力を生じ、合法的なかつ拘束力を有すること。</p></li><li><p>ユーザー当社に対し下記の通りに声明し、保証します：(a) ユーザーは、利用契約を締結し、その義務を履行する十分な権利及び権限を有すること。(b) ユーザーは、利用契約に基づきその義務を履行することは、当社が締結したほかの約定に違反しないこと。(c)利用契約は署名されることにより、ユーザーに効力を生じ、合法的なかつ拘束力を有すること。(d)ウイルス、ワーム、クラックプログラム、BOT、電子設備、コンピュータープログラムまたはそのほかの不正方法を利用し、本サービスに対しての妨げ、侵入、損害、変更または逆コンパイルをしないこと。(e)本サービスに対してのリバースエンジニアリング、もしくは本サービスのソースコードに対しての変更をしないこと。(f)いかなる時も反社会的勢力（以下に定義）に該当しないこと。(g)いかなる時も米国財務省外国資産管理局の制裁リスト（United States’ Office of Foreign Assets Control Sanctions List）に含まれないこと。</p></li><li><p>ユーザーは、本サービスを利用することが、ユーザーに適用のある法令、業界団体の内部 規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、ユーザーによる本サービスの利用が、ユーザーに適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。</p></li><li><p>本サービスに関連してユーザーと第三者との間において生じた取引、連絡、紛争等については、ユーザーの責任において処理及び解決するものとし、当社はかかる事項について一切責任を負いません。</p></li><li><p>当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、本サービスの利用によるデータの消失又は機器の故障若しくは損傷、その他本サービスに関連してユーザーが被った損害について、賠償する責任を一切負わないものとします。</p></li></ol><ol class=article start=15><li><p><strong>保証の否認及び免責</strong></p></li></ol><ol><li><p>本サービスは「現状」及び「現在明示的な条件の下」で提供するものとします。当社は、本サービスについて、いかなる明示的なまたは黙示的な担保及び保証（特定目的における商品性、侵害の不存在、特定目的への適合性、そのほかの取引または契約履行のプロセスに関する黙示的な保証を含むがそれらに限らない）も行わず、それらの保証を明示的に否認します。また、当社は、本規約により提供する本サービスまたはプラットフォームが常に利用可能であり、アクセス可能であり、中断されず、時宜にかなっており、安全であること、もしくはエラーなく運用されることを保証しない。</p></li><li><p>当社は、ユーザーに対し、次のいずれかの事由において一切の責任も負わないものとします：(I)ユーザーの作業または転送ミス、中断、削除、エラーまたは遅延。(II) 通信転送の中断またはネットワークの混雑。(III)窃盗またはそのほか違法行為。(IV) 許諾なく本サービスを使用し、または変更すること。(V) そのほか当社の責に帰すべきではない行為または事由。</p></li><li><p>本規約第7条を除き、利用契約に基づく契約の履行、不履行またはそれらにより生じるいかなる派生的、間接的、付随的、懲罰的またはいかなる性質の特殊損害賠償について、いずれかの当事者は、相手方に対し、相手方が被る関連の損害が契約違反、不法行為（重大過失を含むがそれに限らない）、またはいかなる責任理論（逸失利益、営業中断またはその他の経済的損失を含むがそれらに限らない）によるものか否かを問わず、且つ当該当事者が関連する損失または損害の可能性について知っているか否かも問わず、責任を負わないものとします。</p></li><li><p>いかなる場合においても、利用契約から生じたもしくは関連する損害、または本サービスやコンテンツを利用すること、利用できなかったことに関する争議について、当社が負う賠償責任は損害の事由が生じた時点から遡って3ヶ月以内にユーザーから現実に受領した本サービス利用料金の総額を上限とします。</p></li></ol><ol class=article start=16><li><p><strong>コンプライアンス</strong></p></li></ol><ol><li><p>適用される法律に従って、ユーザーが反社会的勢力等(暴力団、暴力団員、右翼団体、反社会的勢力、また適用すべき日本法律や規定に基づき、その他これに準ずる者を意味します。以下同じ。)であり、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合、当社は、ユーザーに対し事前通知することなく、直ちに利用契約を解約することができます。</p></li><li><p>前項の約定に加え、ユーザーの取締役、監査役、従業員その他の構成員、株主、取引先、若しくは顧問その他のアドバイザーが反社会的勢力等であること、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていることが判明した場合において、その解消を求める当社からの通知を受領後相当期間内にこれが解消されないときは、当社は、ユーザーに書面で通知することにより直ちに利用契約を解約できるものとします。</p></li><li><p>適用される法律に従って、ユーザーが米国財務省外国資産管理局の制裁リストに含まれたと当社が判断した場合、当社は、ユーザーに対し事前通知することなく、直ちに利用契約を解約することができます。</p></li><li><p>利用契約がこの第16条に従って解約された場合、当社は、ユーザーがこれにより被ったいかなる損害についても賠償責任を負わないものとし、ユーザーは当社がこれにより被られたいかなる損害について賠償しなければならないものとします。</p></li></ol><ol class=article start=17><li><p><strong>契約有効期間</strong></p></li></ol><p>双方当事者が別途で合意した場合を除き、利用契約の有効期間は、申込フォーマットに記載された開始日より、(i) 申込フォーマットに記載された終了日、または(ii)いずれかの当事者が本規約や申込フォーマットの約定に従って利用契約を解約した日（適用可能であれば）までとします。</p><ol class=article start=18><li><p><strong>連絡および通知</strong></p></li></ol><p>本サービスに関する問い合わせその他ユーザーから当社に対する連絡又は通知、及びその他当社からユーザーに対する連絡又は通知は、当社が別途での定める方法で行うものとします。</p><ol class=article start=19><li><p><strong>契約上の地位譲渡等</strong></p></li></ol><ol><li><p>ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</p></li><li><p>当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びにユーザーの登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。</p></li></ol><ol class=article start=20><li><p><strong>分離可能性</strong></p></li></ol><p>利用契約のいずれかの条項又はその一部が、適用すべき法律等により無効又は執行不能と判断された場合、 その残りの約定は、継続して完全に効力を有します。</p><ol class=article start=21><li><p><strong>存続規定</strong></p></li></ol><p>各条項の性質に応じて必要な範囲内に、第4条第3項、第5条、第6条、第7条、第8条第3項及び第4項、第9条、第12条第2項及び第3項、第13条から第16条、第18条から第23条までの規定は利用契約の終了後も有効に存続するものとします。前記にかかわらず、第9条は利用契約終了以降3年以内に効力を有するものとします。</p><ol class=article start=22><li><p><strong>準拠法及び管轄</strong></p></li></ol><p>利用契約は、当社の締約する法人の所在地の法律に準拠し、解釈されるものとします。ただし法の抵触の原則は適用しないものとします。</p><ol><li><p>利用契約がシンガポールの法律に準拠する場合、利用契約に起因もしくは関連して生じるいかなる問題もしくは争議（契約の存在、有効性または解約等を含む）（以下「<strong>争議</strong>」という）は、シンガポールにおける仲裁に付託され、最終的に同仲裁により解決されるものとします。なお同仲裁は、当該時点において効力を有しているシンガポール国際仲裁センター（Singapore International Arbitration Centre）の仲裁規則に従って行われるものとします。双方当事者が別途の書面による約定をした場合を除き、仲裁廷は3人の仲裁人により構成されるものとします。仲裁手続きは英語にて行います。当該仲裁裁定は、最終的なものとして両当事者を拘束します。</p></li><li><p>利用契約が日本の法律に準拠する場合、すべての争議について東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p></li><li><p>利用契約が台湾（中華民国）の法律に準拠する場合、すべての争議について台北地方裁判所を第一審の専属的合意管轄裁判所とします。</p></li></ol><ol class=article start=23><li><p><strong>紛争解決</strong></p></li></ol><p>当社及びユーザーは、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。</p><p>【改訂：2020年11月15日】</p><p>【初出：2019年10月15日】</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

var path = '/templates/core/views/terms_of_service_appier_others.html';
var html = "<h1 class=text-center>AiDeal Terms of Service</h1><p>These Terms of Service (hereafter referred to as these “Terms”) refer to the AiDeal service provided by Appier’s group entities (the contracting party from Appier shall be determined in the Application Form (as defined in Article 2)) and specify the rules to be complied as well as the rights and obligations between Appier and the user. The User shall read the content of these Terms thoroughly before applying to use the Services.</p><p class=article><strong>Article 1 Scope</strong></p><ol><li><p>The purpose of these Terms is to stipulate the rights and obligations related to the use of the Services (as defined in Article 2) between Appier and the User (as defined in Article 2) and shall be applicable to all relationship between the User and Appier with regard to the use of the Services. Appier’s Privacy Policy (<a href=\"https://www.appier.com/privacy-policy/\">https://www.appier.com/privacy-policy/</a>, including all the amendments made available at anytime as applicable in the future) is also incorporated as part of these Terms by reference. Appier may amend and revise these Terms from time to time without prior notice at Appier’s sole discretion. The User hereby agrees that, if the User continues its use of the Services, the User is indicating its agreement to the amended Terms.</p></li><li><p>All relevant rules and regulations related to the Services posted on Appier Website (as defined in Article 2) shall constitute part of these Terms (including relevant rules and regulations related to the Services posted on Appier’s Website, AiDeal Fee Schedule, and other relevant rules). However, if it is otherwise agreed in the Application Form and is inconsistent with these Terms, the terms provided in the Application Form shall prevail.</p></li></ol><p class=article><strong>Article 2 Definition</strong></p><p>The terms used in these Terms shall have the following meaning:</p><ol><li><p>“Viewers”: refers to the person(s) that browse the Designated Website and/or Designated Application.</p></li><li><p>“Service Fees”: refers to the “Service Fees” as defined in Paragraph 1 of Article 6.</p></li><li><p>“Designated Application”: refers to the User’s mobile application that uses the Services, provided that such mobile application shall be related to businesses operating by the Users.</p></li><li><p>“Designated Website”: refers to the User’s website that uses the Services, provided that such website shall be related to businesses operating by the Users.</p></li><li><p>“Intellectual Property Rights”: refers to copyrights, patents, utility model patents, trademarks, design patents as well as other intellectual property rights (including the rights to obtain or apply for registration of such rights).</p></li><li><p>“Appier Website”: refers to website(s) operated by Appier under the main domain “appier.com” (in the event that Appier changes the domain and/or contents in its website(s) for any reason, such website(s) shall also be included).</p></li><li><p>“Services”: refers to the services provided by Appier with the name of “AiDeal” (in the event that the Services changes its name or contents for any reason, such changed services shall also be included). Appier may change the scope of the Services (including but not limited to modify the functions or discontinue all or part of the Services) from time to time without prior notice, at Appier’s sole discretion.</p></li><li><p>“Application Information”: refers to the information filled in by the User in the standard application form (hereafter referred to as the “Application Form”) prepared by Appier and submitted to Appier thereafter.</p></li><li><p>“User”: refers to the individual or entity that entered into the Services Agreement with Appier for the Services.</p></li><li><p>“Services Agreement”: refers to the Application Form entered between Appier and the User which these Terms are incorporated by reference. If the User will use the Services in the European Economic Area or any European Commission approved country, the Data Processing Addendum attached to these Terms shall be deemed as a part of the Services Agreement.</p></li><li><p>“Effective Term”: refers to the period starts from the starting date to the end date (including the renewal period, as applicable) stated in the Application Form.</p></li></ol><p class=article><strong>Article 3 Change of Information</strong></p><p>The User shall be responsible to keep all the information provided to Appier up to date, and notify Appier of changes made to the Application Information and/or other information provided to the Service (e.g., any information relating to the Account) without delay via methods determined by Appier and submit necessary information as requested by Appier. In the event that Appier determines that any changes to User’s information will result in violating these Terms, Appier may notify the User regarding the violation and terminate the Services Agreement immediately without any liability.</p><p class=article><strong>Article 4 Management of User’s Account</strong></p><ol><li><p>Once the User successfully enrolled in the Services, the User shall follow Appier’s guidance to create User’s account (\"Account\") with ID and password.</p></li><li><p>The User shall be solely responsible for the management and safekeeping of the Account, and shall in no event authorize any third party to use, or lend, transfer, assign or sell the same to any third party.</p></li><li><p>The User shall be responsible for any damages caused by User’s mismanagement (including but not limited to intended or negligence conducts) relating to the Account (including but not limited to unauthorized use made by any third party), and Appier shall in no event be held liable to User and/or any third party under such event.</p></li><li><p>The User shall be responsible for all activities that occur under such Account, regardless that whether the User is aware about such activities. The User shall notify Appier without delay of any unauthorized use of the Account and fully comply with Appier’s instructions thereafter.</p></li></ol><p class=article><strong>Article 5 Use of Tags and SDK</strong></p><ol><li><p>For the purpose to allow the User to access the Service, Appier has developed and provides relevant tags (“<strong>Tags</strong>”) and software development kit (“<strong>SDK</strong>”). The User shall only use each Tag and/or SDK in accordance with Appier’s any and all instructions. Given the nature of the Services, Appier may update the Tags and/or SDK from time to time.</p></li><li><p>The User shall only use the Tags and/or SDK only for the purpose to use the Services. The User shall not use the Tags and/or SDK to build any service or product that will compete with the Services.</p></li></ol><p class=article><strong>Article 6 Service Fees and Payment</strong></p><ol><li><p>As consideration for the use of the Services, the User shall pay Appier the fees specified in the Application Form (hereafter referred as to the “Service Fees”). Appier will provide payment collecting information in the Application Form for User’s handling, and, as required by Appier, the User shall notify Appier in writing of User’s payment information (e.g., bank code, branch code, type of account, account number and name of the main account holder specified on the bank account).</p></li><li><p>Unless otherwise agreed by Appier and the User with prior writing, the monthly Service Fees shall be calculated at the last day of each calendar month (for the purpose of this paragraph, the “<strong>Record Date</strong>”), and the User shall confirm and agree with the payment amount within the next five (5) working days. In addition, in the event that the Services Agreement is terminated after the Record Date but prior to its payment of the Service Fees, the User shall still be obligated to pay the Service Fees incurred prior to the termination of the Services Agreement. For avoidance of doubt, when the period between the starting date of the Services to the first Record Date is less than one month (e.g., the User started to use the Services from 15 January, which the first Record Date is 31 January) and the User is subject to monthly fixed fee plan, then the Service Fee will be calculated on pro-rata basis.</p></li><li><p>In the event that the User delays payment of the Service Fees, the User shall borne an annual interest rate of 14.6% (or the highest rate allowed by applicable law, whichever is lower) as compensation to Appier for delay damages.</p></li><li><p>User may terminate the Services Agreement pursuant to the terms and conditions therein, providing that in no event shall Appier be obligated to refund the Service Fees paid by the User to Appier prior to the termination.</p></li></ol><p class=article><strong>Article 7 Ownership of Intellectual Property Rights</strong></p><ol><li><p>The ownership of the Intellectual Property Rights in the Services (including but not limited to Tags / SDK issued and developed by Appier) shall at all time belong to Appier and/or Appier’s licensor(s). Unless otherwise expressly provided in these Terms, the consent to allow the use of the Services does not constitute the grant of license regarding the Intellectual Property Rights of Appier or its licensor from any aspect. User shall not act in any way that infringes or may infringe the Intellectual Property Rights of Appier or its licensor (including but not limited to disassembly, de-compilation and reverse engineering).</p></li><li><p>User shall be fully responsible for all the content and material (including but not limited to text, designs, images, and/or any other advertising materials provided by User to Appier or uploaded to the Services’ platform directly by User, or any materials prepared by Appier under User’s instructions) (collectively, the “Contents”), and the User herby warrants that it has all rights that are required for User to utilize, provide, upload such Contents during its use of the Services. User shall also warrant and represent that any Content provided by User and Appier’s usage thereof will not infringe, misappropriate or violate any third party’s Intellectual Property Rights, or result in violating any applicable laws.</p></li><li><p>The Intellectual Property Rights in the Content created for the User by Appier, and/or provided by the User to Appier, shall at all time belong to the User and/or its licensor(s). User hereby grant to Appier a limited, non-exclusive, irrevocable, worldwide, royalty-free, transferable license, with the rights to sublicense, access, view, use, copy, modify, publicly display and distribute such Content to the extent required to provide the Services.</p></li><li><p>The User shall not in any way use or display Appier’s name, trademark, logo or other proprietary information for whatever purpose without Appier’s prior written notice.</p></li></ol><p class=article><strong>Article 8 Users’ other Responsibilities and Obligations</strong></p><ol><li><p>The User shall be responsible and at its own cost to prepare and maintain the computer, software, other equipment, communication lines as well as other internet environments which are necessary to receive the Services.</p></li><li><p>When reasonably requested by Appier, the User shall incorporate the matters provided by Appier in writing (if any) separately into its privacy policy applicable to the Designated Website and/or the Designated Application, and such privacy policy shall be made easily accessible to the Viewers.</p></li><li><p>User understands and acknowledges that, it shall be fully responsible to obtain Viewers’ consent as required under applicable laws (e.g., personal data protection relating laws and regulations) that will enable the User to use the Services. In the event that Appier reasonably requests the User to change User’s terms of service, policies (including privacy policy) or other rules of the User (hereafter referred to as the “User Rules”) applicable to the Viewers during the Effective Term, the User shall fulfill such request within the period as specified by Appier. In no event shall Appier be responsible for any transaction, communication or dispute (including but not limited to those arise from the User Rules) between the User and the Viewers. The User shall solve such issues with its own responsibility and at its own cost.</p></li><li><p>Upon the termination of the Services Agreement, the User shall delete and remove all the Tags and/or SDK from the Designated Website and/or Designated Application and all User’s devices (as applicable) per Appier’s instruction. The User hereby acknowledges that, including but not limited to the event that the User fails to delete and remove the Tags and/or SDK from the Designated Website and/or Designated Application and all User’s devices (as applicable), Appier in no event will be held liable for any damages suffered by the User in relation to or arise from Appier’s modification and/or invalidation of the Tags and/or SDK which take place after the termination for the Services Agreement (including but not limited to errors in the Designated Website and/or Designated Application).</p></li></ol><p class=article><strong>Article 9 Confidential Information</strong></p><ol><li><p>Confidential Information means all and any information and/or materials disclosed by a party (“Disclosing Party”) to the other party (“Receiving Party”) in relation with the Services, including but not limited to those relating to Disclosing Party’s current or future business operation, finance status, marketing activities or technical information, provided that such information is identified as confidential at the time of disclosure or should be reasonably known by the Receiving Party to be confidential or proprietary given the nature of the information disclosed and the circumstances relating to the disclosure. Confidential Information also includes, but not limited to, (i) all the information disclosed contained in material of whatever nature and/or formats of any kind, which is affixed with “confidential” or other wordings alike when being disclosed; and (ii) all the information which in practice a receiving party with good faith will consider it as confidential.</p></li><li><p>Notwithstanding the preceding paragraph, information which falls within any following scope shall not be viewed as Confidential Information: (i) information that is already in the public domain or already known to the Receiving Party at the time it is provided or disclosed by the Disclosing Party; (ii) information that becomes available in public domain through publication or other means after being disclosed by the Disclosing Party or being known by Receiving Party due to reasons not attributable to Receiving Party; (iii) information that is received lawfully from a third party who has the rights to provide or disclose such information without breach of confidentiality obligation; and (iv) information that is independently developed by the Receiving Party without reference to the Confidential Information.</p></li><li><p>Nothing herein shall prevent a party from disclosing the other party’s Confidential Information as necessary pursuant to any court order or any legal, regulatory, law enforcement or similar requirement or investigation; provided, prior to any such disclosure, the Receiving Party shall use reasonable efforts to (i) promptly notify the Disclosing Party in writing of such requirement to disclose and (ii) cooperate with the Disclosing Party in protecting against or minimizing any such disclosure or obtaining a protective order.</p></li><li><p>The Receiving Party acknowledges that unauthorized disclosure of Confidential Information would cause substantial harm for which monetary damage compensation alone would not be a sufficient remedy. Therefore, upon Receiving Party’s unauthorized disclosure of Confidential Information, the Disclosing Party will be entitled to injunctive or other equitable relief along with any available remedies under applicable laws.</p></li></ol><p class=article><strong>Article 10 Prohibited Action</strong></p><p>User is prohibited from taking any action as listed below when using the Services. If, at Appier’s sole discretion, it is determined that the User or the Designated Website / Designated Application falls within (or may fall within) any of the following scope, Appier has the right to suspend its Services to such User and/or terminate the Services Agreement without any liability.</p><ol><li><p>Infringement of Intellectual Property Rights, portrait rights, privacy rights, reputation or other rights or interests owned by Appier or any other third party (including but not limited to direct or indirect infringement);</p></li><li><p>Attempt to conduct disassembly, decipherment, de-compilation, reverse engineering and/or other methods to derive the source code regarding any software used by Appier to provide the Services.</p></li><li><p>Violation of applicable laws or regulations, conduct criminal acts or violation of public order or good morals.</p></li><li><p>Distribute untrue information or other inappropriate contents, including but not limited to illegal sexual, obscene and violence relating information.</p></li><li><p>Transmission of information containing computer virus or other harmful computer programs.</p></li><li><p>Actions which may possibly interfere Appier’s operation (including but not limited to the operation of the Services).</p></li><li><p>Use the Tags and/or SDK provided by Appier to arbitrary provide purchase incentives (including but not limited to issuance of coupons, discounts and provision of gifts) to viewers who browse a specific website / application other than the Designated Website / Designated Application.</p></li><li><p>Any other inappropriate action as determined by Appier at its sole discretion.</p></li></ol><p class=article><strong>Article 11 Suspension of the Services</strong></p><ol><li><p>Under any of the following events, Appier may suspend or cease the Services in whole or in part without prior notice to the User:</p><ol><li><p>Emergency inspection or maintenance of the computer systems related to the Services.</p></li><li><p>Suspension due to accidents relating to computer or communication lines.</p></li><li><p>The Services cannot be operated due to force majeure events such as fire, power failure, and natural disaster.</p></li><li><p>Other circumstances where suspension or cease of Services is necessary as determined by Appier.</p></li></ol></li><li><p>Appier shall not be held liable for any damages caused to the User by actions taken by Appier pursuant to this Article 11.</p></li></ol><p class=article><strong>Article 12 Termination</strong></p><ol><li><p>In the event that the User falls within the scope of any following events, Appier may suspend the Services and/or terminate the Services Agreement without any prior notice.</p><ol><li><p>Breach of any provision of these Terms.</p></li><li><p>False statement is found in the Application Information.</p></li><li><p>Under the applicable laws, the User suspends its payment or becomes insolvency, or is subjected to the commence of bankruptcy, civil rehabilitation, corporate reorganization, special liquidation or other similar procedures.</p></li></ol></li><li><p>In the event that the Users falls within the scope of any of the events provided in the preceding paragraph, the User shall lose its benefit of time with respect to all outstanding payments and shall pay Appier the full amount of all outstanding payment(s) immediately.</p></li><li><p>Appier shall in no event be held liable for the damages suffered by the User due to Appier’s action taken under this Article.</p></li><li><p>The User may terminate the Services Agreement on an end date of a calendar month with a prior written notice to Appier following the step designated in the Application Form (as applicable).</p></li></ol><p class=article><strong>Article 13 Liability for Breaching the Services Agreement</strong></p><p>If the User fails to perform or breaches its obligations under the Services Agreement, and thus cause damages to Appier or result in other third party’s claim against Appier, the User shall provide any and all necessary assistance to Appier, and be liable to compensate all the damages suffered by Appier, including but not limited to attorney fees and litigation fees.</p><p class=article><strong>Article 14 Warranties</strong></p><ol><li><p>Appier hereby warrants and represents that (a) it has full corporate right, power and authority to enter into the Services Agreement and to perform the acts required of it hereunder; (b) the execution of the Services Agreement by Appier, and the performance of its obligations and duties hereunder, do not and will not violate any agreement to which it is bound, and (c) it will be bound by the Services Agreement upon the execution of the same.</p></li><li><p>The User hereby warrants and represents that (a) it has full corporate right, power and authority to enter into the Services Agreement and to perform the acts required of it hereunder; (b) the execution of the Services Agreement by the User, and the performance of its obligations and duties hereunder, do not and will not violate any agreement to which it is bound, (c) it will be bound by the Services Agreement upon the execution of the same, (d) it will not use any virus, worm, crack programs, bot, electronic equipment, computer programs or any other inappropriate method to interfere, invade, damage, modify and decompile the Services, (e) it will not conduct reverse-engineering against the Services nor modify the source code of the Services; (f) it does not and will not fall within the scope of Anti-Social Forces (defined as follows) for all time and (g) it is not and will not be listed in the United States’ Office of Foreign Assets Control Sanctions List for all time.</p></li><li><p>The User shall assume the responsibility and expenses of confirming whether its use of the Services will violate any laws or internal rules of industry associations that are applicable to the User. Appier makes no warranty that the use of the Services by the User will comply with all laws or internal rules of industry associations that are applicable to the User.</p></li><li><p>The User shall be responsible for handling and resolving any transaction, contact or dispute arises between the User and any third party relating to the Services. Appier shall in no event be held liable for the foregoing events.</p></li><li><p>Appier shall not be held liable for the suspension, cease, termination, unavailability or change of the Services caused by Appier, or deletion of data, or malfunction or damage of equipment due to use of the Services, or any other damages suffered by the User in connection with the Services.</p></li></ol><p class=article><strong>Article 15 Disclaimer and Indemnification</strong></p><ol><li><p>THE SERVICES ARE PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. APPIER EXPRESSLY DISCLAIMS ALL WARRANTIES, REPRESENTATIONS AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES, REPRESENTATIONS AND CONDITIONS OF MERCHANTABILITY, NON-INFRINGEMENT, OR FITNESS FOR A PARTICULAR PURPOSE, AND IMPLIED WARRANTIES ARISING FROM COURSE OF DEALING OR PERFORMANCE. APPIER EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND THAT THE SERVICES WILL ALWAYS BE AVAILABLE, ACCESSIBLE, UNINTERRUPTED, TIMELY, AND SECURE OR OPERATE WITHOUT ERROR OR THAT ANY SERVICES OR PLATFORM PROVIDED HEREUNDER WILL OPERATE WITHOUT ERROR.</p></li><li><p>APPIER WILL IN NO EVENT BE HELD LIABLE FOR (I) USER’S NEGLIGENCE, INTERRUPTIONS, DELETIONS, ERRORS OR DELAY DURING USER’S OPERATION OR TRANSFERATION, (II) TRANSMISSION INTERRUPTION OR INTERNET CONGESTION, (III) THEFT OR ANY OTHER ILLEGAL CONDUCTS, (IV) UNAUTHORIZED USE OR MODIFICATION AGAINST THE SERVICE, OR (V) OTHER EVENTS NOT ATTRIBUTABLE TO APPIER.</p></li><li><p>EXCEPT FOR EVENTS RELATING TO ARTICLE 7 OF THESE TERMS, IN NO EVENT WILL EITHER PARTY BE LIABLE TO THE OTHER PARTY FOR ANY INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL, RELIANCE OR CONSEQUENTIAL DAMAGES OF ANY KIND OR NATURE WHATSOEVER, HOWEVER CAUSED, AND WHETHER BASED ON BREACH OF CONTRACT, TORT (INCLUDING WITHOUT LIMITATION GROSS NEGLIGENCE), OR ANY THEORY OF LIABILITY, SUFFERED BY THE OTHER PARTY, INCLUDING, WITHOUT LIMITATION, LOST PROFITS, BUSINESS INTERRUPTIONS OR OTHER ECONOMIC LOSS UNDER OR ARISING OUT OF THE PERFORMANCE OR NON-PERFORMANCE HEREUNDER, AND WHETHER OR NOT THE APPLICABLE PARTY WAS ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGES.</p></li><li><p>IN NO EVENT WILL APPIER’S TOTAL LIABILITY ARISING OUT OF OR IN CONNECTION WITH THE SERVICES AGREEMENT, ANY DISPUTE FROM THE USE OF OR INABILITY TO USE THE SERVICES OR CONTENT EXCEED THE AGGREGATED AMOUNT PAID BY THE USER TO APPIER IN THE THREE (3) MONTHS PRECEDING THE DATE THE CLAIM AROSE.</p></li></ol><p class=article><strong>Article 16 Additional compliance requirement</strong></p><ul><li><p>To the extent applicable, as determined by Appier, if the User belongs to anti-social forces (referring hereafter to organized crime group, organized crime group member, right-wing organization, anti-social forces or other equivalent organizations according to applicable Japanese laws and regulations, “<strong>Anti-Social Force</strong>”), or provides funds or uses other means to maintain, operate, or assist in or participate in the operation of Anti-Social Forces or has any interaction or involvement with Anti-Social Forces, Appier may terminate the Services Agreement immediately without prior notice to the User.</p></li><li><p>In addition to the provision of the preceding paragraph, in the event that any User’s director, supervisor, employee or other member, shareholder, client and/or supplier, or consultant or other expert advisor is confirmed to be Anti-Social Forces, or provides funds or uses other means to maintain, operate, or assist or participate in the operation of Anti-Social Forces or has any interaction or involvement with Anti-Social Forces, Appier may terminate the Services Agreement immediately by written notice to the User if the User fails comply with Appier’s request to eliminate such relationship within a reasonable period upon the User’s receipt of Appier’s notice.</p></li><li><p>To the extent applicable, as determined by Appier, if the User is confirmed to be listed in the United States’ Office of Foreign Assets Control Sanctions List, Appier may terminate the Services Agreement immediately without prior notice to the User.</p></li><li><p>In the event that the Services Agreement is terminated under this Article 16, Appier shall not be held liable for any damages suffered by the User due to such termination, while the User shall compensate Appier for any and all damages suffered by Appier.</p></li></ul><p class=article><strong>Article 17 Effective Term</strong></p><p>Unless otherwise agreed by both parties, the Services Agreement shall become effective from the starting date as stated in the Application Form, until (i) the expiration date as stated in the Application Form, or (ii) either party terminates the Services Agreement pursuant to any provisions provided in these Terms or the Application Form, as applicable.</p><p class=article><strong>Article 18 Communication/Notice</strong></p><p>The User’s queries about the Services and other communications or notices from the User to Appier, as well as other communications and notices from Appier to the User shall be given in the manner specified by Appier separately.</p><p class=article><strong>Article 19 Assignment</strong></p><ol><li><p>With respect to its status under the Services Agreement or the rights and obligations under these Terms, the User shall not assign, transfer, pledge or otherwise make any disposal to any third party without with the prior written consent of Appier.</p></li><li><p>If Appier assigns the business relating to the Services to another company, its status under the Services Agreement, rights and obligations under these Terms, as well as registration data of the User or other customer information may also be assigned to the assignee of such business assignment. The User shall hereby agree to such assignment in advance. Furthermore, assignment of business as referred to in this paragraph shall, in addition to general assignment of business, also include company split-ups and any other business transfer events.</p></li></ol><p class=article><strong>Article 20 Severability</strong></p><p>If any provision or part of the Services Agreement is determined to be invalid or unenforceable under applicable laws, the remainder of these Terms shall remain in full force and effect.</p><p class=article><strong>Article 21 Survival</strong></p><p>To the extent necessary by its nature, Paragraph 3 of Article 4, Article 5. Article 6, Article 7, Paragraphs 3 and 4 of Article 8, Article 9, Paragraphs 2 and 3 of Article 12, Articles 13 through 16, and Articles 18 through 23 shall survive the termination of the Services Agreement. Notwithstanding anything to the contrary, Article 9 shall remain effective until the third anniversary from the termination of the Services Agreement.</p><p class=article><strong>Article 22 Governing Law and Jurisdiction</strong></p><p>The Services Agreement shall be governed, construed and interpreted in accordance with the laws where the signing entity of Appier locates, without giving effect to principles of conflict of laws.</p><ol><li><p>If the Services Agreement shall be governed by laws of Singapore, any issues or disputes arising out of or in connection with the Services Agreement, including any question regarding its existence, validity or termination (“<strong>Disputes</strong>”), shall be referred to and finally resolved by arbitration in Singapore in accordance with the Arbitration Rules of the Singapore International Arbitration Centre for the time being in force, which rules are deemed to be incorporated by reference in this clause. The tribunal shall consist of 3 arbitrators unless otherwise agreed by the Parties in writing. The language of the arbitration shall be English. The arbitral award shall be final and binding upon both parties.</p></li><li><p>If the Services Agreement shall be governed by the laws of Japan, all the Disputes hall be brought in Tokyo District Court as the exclusive court of competent jurisdiction.</p></li><li><p>If the Services Agreement shall be governed by the laws of Taiwan, Republic of China, all the Disputes hall be brought in Taipei District Court as the exclusive court of competent jurisdiction.</p></li></ol><p class=article><strong>Article 23 Dispute Resolution</strong></p><p>For matters not stipulated in these Terms or in the event of any doubt regarding the interpretation of these Terms, Appier and the User shall first negotiate and resolve the issues in good faith.</p><p>【Revised: November 15, 2020】</p><p>【Original: October 15, 2019】</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

var path = '/templates/core/views/tos.html';
var html = "<div class=document-wrapper><div class=row><div class=\"col-md-push-2 col-md-8\"><div ng-switch=vm.selectedLanguage.id class=document-wrapper><ng-container ng-switch-when=zh><zc-terms-of-service-appier-inc></zc-terms-of-service-appier-inc></ng-container><ng-container ng-switch-when=ja><zc-terms-of-service-appier-jp></zc-terms-of-service-appier-jp></ng-container><ng-container ng-switch-default><zc-terms-of-service-appier-others></zc-terms-of-service-appier-others></ng-container></div><zc-data-processing-addendum></zc-data-processing-addendum></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

var path = '/templates/core/views/tos_header.html';
var html = "<div class=container><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>Toggle navigation</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-right\"><li class=dropdown dropdown><a class=dropdown-toggle dropdown-toggle><i class=\"fa fa-language\"></i> {{ vm.selectedLanguage.label }}</a><ul class=dropdown-menu role=menu><li ng-repeat=\"language in vm.languages\"><a ng-click=vm.selectLanguage(language)>{{ language.label }}</a></li></ul></li></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

var path = '/templates/agencies/settings/agency_settings.html';
var html = "<div class=\"container-fluid container-limited margin-y\"><div class=row><div class=\"col-md-8 col-md-offset-2 panel\"><h1>{{ 'agencies.settings.agencySettings.dairiten_kaisha_settei' | translate }}</h1><form class=\"form-horizontal padding-top\" ng-submit=$ctrl.save($ctrl.agency) name=form><h1>{{ 'agencies.settings.agencySettings.keiyaku_jouhou' | translate }}</h1><div class=row><div class=col-md-12><div class=form-group><label for=title class=col-md-3>{{ 'agencies.settings.agencySettings.kaishamei' | translate }}</label><div class=col-md-9><input class=form-control id=title name=title ng-model=$ctrl.agency.title required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=representative class=col-md-3>{{ 'agencies.settings.agencySettings.kaisha_daihyou_myoudai' | translate }}</label><div class=col-md-9><input class=form-control id=representative name=representative ng-model=$ctrl.agency.representative required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=postal_code class=col-md-3>{{ 'agencies.settings.agencySettings.yuubinbangou' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'agencies.settings.agencySettings.rei_postal' | translate }}\" id=postal_code name=postal_code ng-model=$ctrl.agency.postal_code required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=address class=col-md-3>{{ 'agencies.settings.agencySettings.juusho' | translate }}</label><div class=col-md-9><input class=form-control id=address name=address ng-model=$ctrl.agency.address required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=phone_number class=col-md-3>{{ 'agencies.settings.agencySettings.denwabangou' | translate }}</label><div class=col-md-9><input class=form-control id=phone_number name=phone_number ng-model=$ctrl.agency.phone_number required></div></div></div></div><section style=\"margin: 0; padding-bottom: 0;\"><h1>{{ 'agencies.settings.agencySettings.seikyuu_saki_jouhou' | translate }}</h1><div class=row><div class=\"col-md-9 col-md-push-3\"><div class=form-group><zc-sync-contract-info-button class=col-md-12 source=$ctrl.agency></zc-sync-contract-info-button></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_company_name class=col-md-3>{{ 'agencies.settings.agencySettings.kaishamei' | translate }}</label><div class=col-md-9><input class=form-control id=billing_company_name name=billing_company_name ng-model=$ctrl.agency.billing_company_name required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_postal_code class=col-md-3>{{ 'agencies.settings.agencySettings.yuubinbangou' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'agencies.settings.agencySettings.rei_postal' | translate }}\" id=billing_postal_code name=billing_postal_code ng-model=$ctrl.agency.billing_postal_code required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_address class=col-md-3>{{ 'agencies.settings.agencySettings.juusho' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'agencies.settings.agencySettings.rei_address' | translate }}\" id=billing_address name=billing_address ng-model=$ctrl.agency.billing_address required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_phone_number class=col-md-3>{{ 'agencies.settings.agencySettings.denwabangou' | translate }}</label><div class=col-md-9><input class=form-control id=billing_phone_number name=billing_phone_number ng-model=$ctrl.agency.billing_phone_number required></div></div></div></div><hr><h1 style=\"padding: 0 0 1em 0;\">{{ 'agencies.settings.agencySettings.seikyuu_tantousha_jouhou' | translate }}</h1><zc-billing-representatives representatives=$ctrl.agency.billing_representatives></zc-billing-representatives></section><hr><div class=row><label class=col-md-3>{{ 'agencies.settings.agencySettings.dairiten_tesuuryou_ritsu' | translate }}</label> {{$ctrl.agency.margin_percent}}%</div><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>{{ 'agencies.settings.agencySettings.hozon' | translate }}</button></div></form></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

var path = '/templates/projects.analytics/views/directives/main_chart.html';
var html = "<div class=maingraph><div class=row><div class=col-md-8><select id=chart_item1 ng-model=filters.chart_item1_value ng-change=update() ng-options=\"item.label for item in mainChartItems\"></select>&nbsp;{{ 'projectsAnalytics.views.directives.mainChart.tai' | translate }}&nbsp;<select id=chart_item2 ng-model=filters.chart_item2_value ng-change=update() ng-options=\"item.label for item in mainChartItems\"></select></div><div class=col-md-4><div id=dimension class=\"btn-toolbar pull-right\" role=toolbar><div class=btn-group><button type=button class=\"btn btn-default\" ng-class=\"{active: filters.chart_dimension == 'hourly'}\" ng-click=\"setDimension('hourly')\">{{ 'projectsAnalytics.views.directives.mainChart.jikan' | translate }}</button> <button type=button class=\"btn btn-default\" ng-class=\"{active: filters.chart_dimension == 'daily'}\" ng-click=\"setDimension('daily')\">{{ 'projectsAnalytics.views.directives.mainChart.hi' | translate }}</button></div><div class=btn-group><button type=button class=\"btn btn-default\" ng-class=\"{active: filters.chart_dimension == 'hour_of_day'}\" ng-click=\"setDimension('hour_of_day')\">{{ 'projectsAnalytics.views.directives.mainChart.jikantai' | translate }}</button> <button type=button class=\"btn btn-default\" ng-class=\"{active: filters.chart_dimension == 'day_of_week'}\" ng-click=\"setDimension('day_of_week')\">{{ 'projectsAnalytics.views.directives.mainChart.youbi' | translate }}</button></div></div></div></div><div class=row><div class=col-md-12><highchart config=chartConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

var path = '/templates/projects.analytics/views/directives/pie_chart.html';
var html = "<div class=userstats><h4>{{project.title}} / {{ 'projectsAnalytics.views.directives.pieChart.yuuzaajouhou' | translate }}</h4><div class=row><div class=col-md-6><highchart config=deviceConfig></highchart></div><div class=col-md-6><highchart config=newSessionConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

var path = '/templates/projects.analytics/views/directives/total_stats.html';
var html = "<div class=total-stats><h4>{{project.title}} / {{ 'projectsAnalytics.views.directives.totalStats.saito_jouhou_samarii' | translate }}</h4><div class=row><div class=col-md-5ths><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsAnalytics.views.directives.totalStats.houmon_kazu' | translate }}</div><div class=panel-body>{{stats.session_count || 0 | number:0}}<br><span>&nbsp;</span></div></div></div><div class=col-md-5ths><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsAnalytics.views.directives.totalStats.peejibyuu' | translate }}</div><div class=panel-body>{{stats.history_count || 0 | number:0}}<br><span translate=projectsAnalytics.views.directives.totalStats.heikin translate-value-number=\"{{stats.average_history_count || 0 | number:2}}\" class=text-sm style=\"color: gray\"></span></div></div></div><div class=col-md-5ths><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsAnalytics.views.directives.totalStats.konbaajon_ritsu' | translate }}</div><div class=panel-body>{{stats.conversion_rate * 100 || 0 | number:2}}%<br><span>&nbsp;</span></div></div></div><div class=col-md-5ths ng-if=!Devise.isMaster()><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsAnalytics.views.directives.totalStats.heikin_konbaajon_kingaku' | translate }}</div><div class=panel-body>{{stats.average_conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}<br><span>&nbsp;</span></div></div></div><div class=col-md-5ths ng-if=Devise.isMaster()><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsAnalytics.views.directives.totalStats.konbaajon_kingaku' | translate }}</div><div class=panel-body>{{stats.conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}<br><span translate=projectsAnalytics.views.directives.totalStats.heikin translate-value-number=\"{{stats.average_conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}\" class=text-sm style=\"color: gray\"></span></div></div></div><div class=col-md-5ths><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsAnalytics.views.directives.totalStats.heikin_taizai_jikan' | translate }}</div><div class=panel-body>{{stats.average_dwell || 0 | elapseTime}}<br><span>&nbsp;</span></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

var path = '/templates/projects.analytics/views/show.html';
var html = "<div class=content id=analytics><div class=container><campaign-filter-view filters=filters hide-search-term=true project=currentProject update=updateFilters() reset=resetFilters()></campaign-filter-view><total-stats filters=updatedFilters project=currentProject></total-stats><main-chart filters=updatedFilters project=currentProject></main-chart><pie-chart filters=updatedFilters project=currentProject></pie-chart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/add_coupons.html';
var html = "<div class=container><h1>{{ 'projectsCampaigns.addCoupons.koodo_wo_touroku' | translate }}</h1></div><div class=container><div class=setcode-table ng-repeat=\"campaign in activeCampaigns | orderBy :'-id'\"><div class=\"setcode-table-cell set-code-table-cell-1\"><div class=setcode-status><div class=setcode-status-success ng-if=\"campaign.current_incentive && campaign.current_status != 'blocked'\"><div class=setcode-status-label></div><div class=setcode-status-badge></div>{{ 'projectsCampaigns.addCoupons.haishin_uchi' | translate }}</div><div class=setcode-status-warning ng-if=\"!campaign.current_incentive && campaign.current_status != 'blocked'\"><div class=setcode-status-label></div><div class=setcode-status-badge></div>{{ 'projectsCampaigns.addCoupons.haishin_taiki_uchi' | translate }}</div><div class=setcode-status-danger ng-if=\"campaign.current_status == 'blocked'\"><div class=setcode-status-label></div><div class=setcode-status-badge></div>{{ 'projectsCampaigns.addCoupons.ichijiteishi_uchi' | translate }}</div></div><div class=setcode-img><img ng-src={{campaign.element.message.banner}}></div></div><div class=\"setcode-table-cell set-code-table-cell-2\"><a class=campaign-title ui-sref=\"admin.projects.campaigns.show.stats({projectId: campaign.project_id, campaignId: campaign.id})\">{{ campaign.name }} <span ng-if=!campaign.name>{{ 'projectsCampaigns.addCoupons.meishou_misetsu_kyoutei' | translate }}</span></a><div class=campaign-target><span class=campaign-table-subtitle>{{ 'projectsCampaigns.addCoupons.debaisu' | translate }}:</span><div campaign-device ng-model=campaign></div><zc-label-clearance campaign=campaign></zc-label-clearance></div><div class=campaign-segment><zc-campaign-segment-flag segment=campaign.segment ng-if=campaign.segment></zc-campaign-segment-flag></div></div><div class=\"setcode-table-cell set-code-table-cell-3\"><div class=setcode-incentive><div class=setconde-incentive-title>{{ 'projectsCampaigns.addCoupons.touroku_koodo' | translate }}</div><div class=incentive-belongings ng-repeat=\"incentive in campaign.incentives | filter: {'current_status':'!finished'} | orderBy: 'start_at'\"><div class=incentive-belongings-title><zc-incentive-status incentive=incentive></zc-incentive-status><span tooltip={{incentive.name}} ng-if=\"incentive.incentive_type !== 'generated_coupon_url'\">{{incentive.coupon_code}}</span> <span class=unique_coupon tooltip={{incentive.name}} ng-if=\"incentive.incentive_type === 'unique_coupon_code'\">{{ 'projectsCampaigns.addCoupons.yuniikukuupon_houshiki' | translate }}</span> <span tooltip={{incentive.name}} ng-if=\"incentive.incentive_type === 'generated_coupon_url'\">{{incentive.campaign_code}}</span></div><div class=incentive-belongings-date><span class=incentive-date>{{incentive.start_at | date:'M/d HH:mm'}} ~ {{incentive.end_at | date:'M/d HH:mm'}}</span></div><div class=incentive-belongings-remove><span class=incentive-trash><i class=\"fa fa-trash\" confirm-click=\"removeIncentive(campaign, incentive.id)\" confirm-modal></i></span></div></div><div ng-if=!campaign.incentives.length><span class=notset>{{ 'projectsCampaigns.addCoupons.misetsu_kyoutei' | translate }}</span></div><div class=setcode-incentive-footer><div class=zc-button ng-click=openModal(campaign)><i class=\"fa fa-plus-circle\"></i> {{ 'projectsCampaigns.addCoupons.koodo_wo_touroku' | translate }}</div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/add_coupons_modal.html';
var html = "<div class=setcode-modal><div class=setcode-modal-header>{{ 'projectsCampaigns.addCouponsModal.kyanpeennikoodo_wo_touroku' | translate }}</div><div class=setcode-modal-body><form ng-submit=createIncentive()><div class=display-table><div class=setcode-title>{{ 'projectsCampaigns.addCouponsModal.koodo_touroku_sakikyanpeen' | translate }}</div><div class=setcode-for-campaign><span class=campaign-title>{{ campaign.name }}</span> <span class=campaign-id>#{{campaign.id}}</span></div><div class=setcode-title>{{ 'projectsCampaigns.addCouponsModal.koodo_touroku' | translate }}</div><div class=set-code-modal-form><div class=row><div class=col-md-6><div class=form-group><label for=incentice_code>{{ 'projectsCampaigns.addCouponsModal.koodo' | translate }}</label><div><input type=text name=incentice_code class=form-control tabindex=2 ng-model=incentive.coupon_code placeholder=\"{{ 'projectsCampaigns.addCouponsModal.kuupon_no_hikikae' | translate }}\" required></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label for=incentice_start_at>{{ 'projectsCampaigns.addCouponsModal.kaishibi_toki' | translate }}</label><div><zc-date-time-picker picker-id=start ng-model=incentive.start_at is-required=true min-view=hour></zc-date-time-picker></div></div></div><div class=col-md-6><div class=form-group><label for=incentice_end_at>{{ 'projectsCampaigns.addCouponsModal.shuuryoubi_toki' | translate }}</label><div><zc-date-time-picker picker-id=end ng-model=incentive.end_at is-required=true min-view=hour></zc-date-time-picker></div></div></div></div><div class=well><strong>{{ 'projectsCampaigns.addCouponsModal.kuupon_no_yuukoukigen_nituite' | translate }}</strong><br>{{ 'projectsCampaigns.addCouponsModal.kuupon_no_yuukoukigen' | translate }}<br>{{ 'projectsCampaigns.addCouponsModal.rei_haishin_kikan' | translate }}<br><a href=https://zenclerkinfo.zendesk.com/hc/ja/articles/221881368 target=blank>{{ 'projectsCampaigns.addCouponsModal.kuwashiku_wa_kochira' | translate }}</a></div></div></div><div class=setcode-modal-footer><button type=submit class=zc-button><i class=\"fa fa-plus-circle\"></i> {{ 'projectsCampaigns.addCouponsModal.koodo_wo_touroku' | translate }}</button></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/campaign_bulk_edit_modal.html';
var html = "<div class=setcode-modal><div class=setcode-modal-header>{{ 'projectsCampaigns.list.bulk_edit' | translate }}</div><div class=setcode-modal-body><div class=row><div class=\"col-md-12 col-lg-6\"><div class=display-table><div class=setcode-title>{{ 'projectsCampaignsViews.campaignBulkEditModal.campaigns' | translate }}</div><div class=setcode-campaign-table><table class=\"table campaign-table table-bordered\"><thead><tr><th>{{ 'projectsCampaignsViews.directives.campaignTable.id' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignTable.suteetasu' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignTable.kyanpeen_na' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignTable.haishin_kikan' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignTable.insentibu' | translate }}</th></tr></thead><tbody ng-repeat=\"campaign in vm.campaigns | orderBy: ['campaign_status', '-id']\"><tr><td>{{ campaign.id }}</td><td class=text-center><zc-campaign-status campaign=campaign></zc-campaign-status></td><td class=report-detail-list-name><span campaign-device ng-model=campaign></span><zc-label-clearance campaign=campaign></zc-label-clearance><a ui-sref=\"admin.projects.campaigns.show.stats({projectId: campaign.project_id, campaignId: campaign.id})\">{{ campaign.name }} <span ng-if=!campaign.name>{{ 'projectsCampaignsViews.directives.campaignTableRow.meishou_misetsu_kyoutei' | translate }}</span></a></td><td><zc-date-range start-at=campaign.start_at end-at=campaign.end_at is-infinite=campaign.is_infinite display-time=true></zc-date-range></td><td><zc-campaign-incentive-list campaign=campaign project=vm.project></zc-campaign-incentive-list></td></tr></tbody></table></div></div></div><div class=\"col-md-12 col-lg-6\"><div class=display-table><div class=setcode-title>{{ 'projectsCampaignsViews.campaignBulkEditModal.incentives' | translate }} <span ng-if=\"vm.incentives.length == 0\" class=small translate=projectsCampaignsViews.directives.campaignIncentiveStep.registerIncentiveFromHere translate-value-link=\"<a href='{{ vm.incentiveRegistrationUrl }}' target='_blank'>{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.here' | translate }}</a>\"></span></div><div class=setcode-campaign-table><div class=selection><div class=row><div class=col-sm-5><div class=form-group><select class=form-control ng-options=\"incentive as incentive.name + incentive.example for incentive in vm.incentives\" ng-model=vm.selectedIncentive ng-disabled=\"vm.incentives.length == 0\"><option>{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.shitei_nashi' | translate }}</option></select></div></div><div class=col-sm-2><button type=button class=\"btn btn-default\" ng-disabled=!vm.selectedIncentive ng-click=vm.addIncentive(vm.selectedIncentive)>{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.insentibu_wo_tsuika' | translate }}</button></div></div><div class=\"alert alert-warning\" role=alert ng-if=!vm.isValid()><i class=\"fa fa-check\"></i> {{ 'projectsCampaignsViews.campaignBulkEditModal.warningMessage' | translate }}</div><div class=setcode-title>{{ 'projectsCampaignsViews.campaignBulkEditModal.end_date' | translate }}</div><div class=\"input-group input-group-lg\" style=\"margin: 20px;\"><span class=input-group-addon><i class=\"fa fa-calendar\"></i></span> <input class=form-control datepick size=37 type=text date=data.date ng-model=vm.endDate></div><div class=\"input-group input-group-lg\" style=\"margin: 20px;\"><span class=input-group-addon><i class=\"glyphicon glyphicon-time\"></i></span> <input class=form-control timepick size=25 type=text time=data.time interval=interval ng-model=vm.endTime> <span class=input-group-addon>{{ vm.gmtOffset }}</span></div><div class=table-responsive ng-show=vm.selectedIncentives.length><table class=\"table campaign-table table-bordered\"><thead><tr><th class=campaign-table-id>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.id' | translate }}</th><th class=campaign-table-status>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.suteetasu' | translate }}</th><th class=campaign-table-name>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.insentibu_na' | translate }}</th><th class=campaign-table-date>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.yuukoukigen' | translate }}</th><th class=campaign-table-action></th></tr></thead><tbody><tr ng-repeat=\"incentive in vm.selectedIncentives | orderBy:'-created_at'\"><td style=text-align:center>{{ incentive.id }}</td><td style=text-align:center><zc-incentive-status incentive=incentive></zc-incentive-status></td><td><a ui-sref=\"admin.projects.incentives.show({projectId: campaign.project_id, incentiveId: incentive.id})\">{{ incentive.name }}</a></td><td><zc-date-range start-at=incentive.start_at end-at=incentive.end_at is-infinite=incentive.is_infinite display-time=false></zc-date-range></td><td><input type=button class=\"btn btn-xs btn-danger\" value=\"{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.sakujo' | translate }}\" ng-click=vm.removeIncentive(incentive)></td></tr></tbody></table></div></div></div></div></div></div></div><div class=setcode-modal-footer><button class=zc-button style=\"background: #ffc107; margin-right: 20px;\" ng-click=vm.cancel()>{{ 'projectsCampaignsViews.campaignBulkEditModal.cancel' | translate }}</button> <button class=zc-button ng-click=vm.save() ng-disabled=\"vm.isSaving || !vm.enoughInput() || !vm.isValid()\">{{ 'projectsCampaignsViews.campaignBulkEditModal.save' | translate }}</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/components/campaign_arms_list.html';
var html = "<div ng-if=vm.isLoaded><i class=\"fa fa-lock\"></i> <a ng-href=\"{{ vm.timingSettingsURL }}\" target=_blank>[AI] {{ vm.isBanditActive ? 'auto' : 'manual-traffic' }}</a> <button ng-click=\"vm.isDisplayTable = !vm.isDisplayTable\">{{ vm.isDisplayTable ? 'close' : 'open' }}</button><table ng-if=vm.isDisplayTable class=\"table table-bordered\" style=\"margin-top: 2px; margin-bottom: 5px;\"><thead><th><span style=\"display: block;\">Ratio</span></th><th>Algo</th><th><span style=\"display: block;\">Threshold</span></th></thead><tbody ng-if=\"vm.activeCampaignArms.length === 0\"><tr><td colspan=3>No active models</td></tr></tbody><tbody ng-if=\"vm.activeCampaignArms.length > 0\"><tr ng-repeat=\"campaignArm in vm.activeCampaignArms\"><td>{{ campaignArm.ratio }}</td><td>{{ campaignArm.aiModel.algo || 'sampling' }}</td><td>{{ campaignArm.threshold | number: 2 }}</td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/components/campaign_summary.html';
var html = "<section><div class=row><div class=col-xs-12><h1>{{ 'campaignSummary.title' | translate }} <span translate=projectsCampaigns.list.de_deeta_shiborikomi translate-value-from=\"{{ vm.filters.start_at | zcDate: { smart: true } }}\" translate-value-to=\"{{ vm.filters.end_at | zcDate: { smart: true } }}\"></span></h1></div></div><div class=row><div class=\"col-sm-4 col-xs-5\" style=\"width: 16.66%\"><h5 style=\"display: inline;\">{{ 'campaignSummary.deliveryRate' | translate }} <i class=\"fa fa-info-circle\" style=\"font-size: 13px;\" tooltip=\"{{ ( (vm.isAb || vm.showHiddenAb) ? 'campaignSummary.displayDeliveryRateTooltip' : 'campaignSummary.deliveryRateTooltip' ) | translate }}\" tooltip-append-to-body=true tooltip-placement=right></i></h5><span style=\"font-size: 2em; display: block\">{{ !vm.siteSessionCount ? '-' : !vm.totalDeliveryCount ? 0 : (vm.totalDeliveryCount / vm.siteSessionCount * 100 | number : 1) }} %</span></div><div class=\"col-sm-4 col-xs-5\" style=\"width: 16.66%\" ng-show=\"(vm.isAb || vm.showHiddenAb) && vm.conversion_up_rate\"><h5 style=\"display: inline;\">{{ 'campaignSummary.cvrIncreaseRate' | translate }} <i class=\"fa fa-info-circle\" style=\"font-size: 13px;\" tooltip-html-unsafe=\"{{ 'campaignSummary.cvrIncreaseRateTooltip' | translate }}\" tooltip-append-to-body=true></i></h5><span style=\"font-size: 2em; display: block\">{{ vm.conversion_up_rate * 100 | number : 1 }} %</span></div><div class=\"col-sm-4 col-xs-5\" style=\"width: 16.66%\"><h5 style=\"display: inline;\">{{ vm.isAb || vm.showHiddenAb ? 'campaignSummary.totalDisplayConversionCount' : 'campaignSummary.totalConversionCount' | translate }}</h5><span style=\"font-size: 2em; display: block;\">{{ vm.totalConversionCount || 0 | number : 0 }}</span></div><div ng-if=\"vm.project.product_line !== 'zenclerk_lp'\" class=\"col-sm-4 col-xs-5\" style=\"width: 16.66%\"><h5 style=\"display: inline;\">{{ vm.isAb || vm.showHiddenAb ? 'campaignSummary.totalDisplayConversionValue' : 'campaignSummary.totalConversionValue' | translate }}</h5><span style=\"font-size: 2em; display: block;\">{{ vm.totalConversionValue || 0 | zcCurrency: vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</span></div><div ng-if=\"vm.project.product_line !== 'zenclerk_lp'\" class=\"col-sm-4 col-xs-5\" style=\"width: 16.66%\" ng-show=\"(vm.isAb || vm.showHiddenAb) && vm.conversion_up_rate\"><h5 style=\"display: inline;\">{{ 'campaignSummary.revenueGrowth' | translate }}</h5><span style=\"font-size: 2em; display: block\">{{ vm.totalRevenueGrowth || 0 | zcCurrency: vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</span></div><div ng-if=vm.project.enables_coupon_code_conversion_tag class=\"col-sm-4 col-xs-5\" style=\"width: 16.66%\"><div ng-if=\"vm.project.shows_coupon_code_usage_rate || vm.Devise.isMaster()\"><h5 style=\"display: inline;\"><i ng-if=!vm.project.shows_coupon_code_usage_rate class=\"fa fa-lock\"></i> {{ 'campaignSummary.totalCouponUsedRate' | translate }}</h5><span style=\"font-size: 2em; display: block; margin-left: 1em\">{{ vm.totalCouponUsedRate }}%</span></div></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/confirm.html';
var html = "<div class=container id=campaign_confirm><div class=row><div class=col-md-7><h3>{{ 'projects.campaignsConfirm.kurieitibu_kakunin' | translate }}</h3><campaign-dynamic-view campaign=campaign></campaign-dynamic-view></div><div class=col-md-5><section><h3>{{ 'projects.campaignsConfirm.settei_koumoku' | translate }}</h3><campaign-template-setting campaign=campaign></campaign-template-setting></section><section><table class=\"table table-bordered table-condenced table-hover\"><tbody><tr><td><a class=\"btn btn-primary btn-block\" href={{previewUrl}} target=_blank>{{ 'projects.campaignsConfirm.kyanpeen_no_dousa' | translate }}</a></td></tr><tr><td><h5>{{ 'projects.campaignsConfirm.kyanpeen_no_hyouji' | translate }}</h5><p class=text-mute>{{ 'projects.campaignsConfirm.jouki_no_botan' | translate }}</p><p class=text-mute>{{ 'projects.campaignsConfirm.ridairekuto_ga_arusaito' | translate }}</p><p><mark>{{previewUrl}}</mark></p></td></tr></tbody></table></section></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/edit.html';
var html = "<div class=container id=campaign_edit><div class=\"row campaign_header\"><div class=col-md-6><h1><p>{{campaign.name}} / {{campaign.template_type}}</p><span ng-if=campaign.is_coupon_campaign>{{ 'projectsCampaigns.edit.kuuponkyanpeen' | translate }}</span> <span ng-if=!campaign.is_coupon_campaign>{{ 'projectsCampaigns.edit.intaresutowijittokyanpeen' | translate }}</span></h1></div><div class=col-md-4><campaign-navigator campaign=campaign></campaign-navigator></div><div class=col-md-2><div class=\"btn-group pull-right\"><button class=\"btn btn-sm btn-default\" ng-click=saveCampaign() ng-disabled=\"!canSaveCampaign || campaign.current_status === 'terminated'\">{{ 'projectsCampaigns.edit.hozon' | translate }}</button> <button class=\"btn btn-sm btn-default\" ng-click=saveCampaignAndReturn() ng-disabled=\"!canSaveCampaign || campaign.current_status === 'terminated'\">{{ 'projectsCampaigns.edit.hozon_shite_shuuryou' | translate }}</button></div></div></div><div class=row><div class=col-md-12><campaign-steps all-valid=allValid basic-form=basicForm template-form=templateForm incentive-form=incentiveForm policy-form=policyForm botbonnie-form=botbonnieForm timing-form=timingForm schedule-form=scheduleForm></campaign-steps></div></div><div class=row><div class=col-sm-12><div class=\"campaignnew content\" style=height:100%><div class=\"step-content clearfix\"><div class=\"step-pane active\"><div class=\"panel panel-warning\" ng-if=showsExitPreventionNotification><div class=panel-heading>{{ 'projectsCampaigns.edit.modoru_botan' | translate }}<br>{{ 'projectsCampaigns.edit.yuuzaaga_hihyouji_guruupu' | translate }}<br>{{ 'projectsCampaigns.edit.giji_peeji_ga' | translate }}<br></div></div><div id=base class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.base'\"><campaign-base-step project=currentProject campaign=campaign basic-form=basicForm></campaign-base-step></div><div id=template class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.template'\"><campaign-template-step campaign=campaign templates=templates template-form=templateForm page-types=pageTypes></campaign-template-step></div><div id=botbonnie class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.botbonnie'\"><campaign-botbonnie-step campaign=campaign botbonnie-form=botbonnieForm></campaign-botbonnie-step></div><div id=incentive class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.incentive'\"><campaign-incentive-step campaign=campaign incentives=incentives incentive-form=incentiveForm></campaign-incentive-step></div><div id=policy class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.policy'\"><campaign-policy-step project=currentProject campaign=campaign policy-form=policyForm clearance-item-sets=clearanceItemSets></campaign-policy-step></div><div id=timing class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.timing'\"><campaign-timing-step project=currentProject campaign=campaign timing-form=timingForm configuration-types=configurationTypes></campaign-timing-step></div><div id=schedule class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.schedule'\"><campaign-schedule-step campaign=campaign schedule-form=scheduleForm></campaign-schedule-step></div><div id=confirm class=scrollable-step ng-show=\"$state.current.name === 'admin.projects.campaigns.edit.confirm'\"><campaign-confirm-step campaign=campaign all-valid=allValid basic-form=basicForm template-form=templateForm incentive-form=incentiveForm policy-form=policyForm botbonnie-form=botbonnieForm timing-form=timingForm schedule-form=scheduleForm change-status=changeStatus(status) change-interest-widget-status=changeInterestWidgetStatus(status)></campaign-confirm-step></div></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/list.html';
var html = "<div id=campaign-list class=content><div ng-if=::currentProject.is_terminated class=container zc-master-only><section><div class=\"alert alert-danger\"><i class=\"fa fa-exclamation-triangle\"></i> {{ 'projectsCampaigns.list.ochimashita_settei' | translate }}</div></section></div><div class=container><div class=row><div class=\"col-sm-12 alert alert-info\">{{ 'projectsCampaigns.list.zouzei_taisaku_ni' | translate }}</div></div><div class=row><div ng-if=loginBeforePR class=\"col-sm-12 alert alert-info\">お客様がご利用いただいている ZenClerk のサービス名称をAiDeal（アイディール）に変更いたします。 サービス名称変更にともなうご利用中の機能、サービスならびに契約内容の変更はございません。 本件に関する詳細は<a href=\"https://www.appier.com/ja/news/appier-acquires-japan-based-emin/\">こちら</a>をご覧ください。</div></div><div class=row><div class=col-sm-12><campaign-filter-view filters=filters project=currentProject update=filterCampaigns() reset=resetFilters()></campaign-filter-view></div></div><div ng-show=Devise.isMaster()><zc-cart-price-confirm show-alert-devices=multiIncentiveDevices apikey=currentProject.apikey></zc-cart-price-confirm><zc-item-price-confirm show-alert-devices=iwDevices apikey=currentProject.apikey></zc-item-price-confirm><zc-title-selector-confirm show-alert-devices=iwDevices apikey=currentProject.apikey></zc-title-selector-confirm><zc-thumbnail-selector-confirm show-alert-devices=iwDevices apikey=currentProject.apikey></zc-thumbnail-selector-confirm><zc-description-confirm show-alert-devices=iwDevices apikey=currentProject.apikey></zc-description-confirm><zc-interest-widget-tree-confirm show-alert-devices=iwDevices apikey=currentProject.apikey></zc-interest-widget-tree-confirm></div><zc-campaign-summary ng-if=currentProject.shows_campaign_summary campaigns=filteredCampaigns filters=updatedFilters show-hidden-ab=showHiddenAb is-ab=isAb project=currentProject></zc-campaign-summary><div ng-show=Devise.isMaster() class=\"row mb20\"><div class=\"col-md-12 text-right\"><button class=\"btn btn-default enable-tooltip\" style=\"display: inline-block;\" ng-click=openModal() ng-disabled=!isCampaignSelected tooltip=\"{{ 'projectsCampaigns.list.select_campaigns' | translate }}\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.list.bulk_edit' | translate }}</button> <a class=\"btn btn-default\" ng-click=newCampaign() tooltip=\"{{ 'projectsCampaigns.list.masutaa_senyou' | translate }}\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.list.kyanpeen_sakusei' | translate }}</a></div></div><section ng-if=\"incompleteCampaigns.length > 0 && Devise.isMaster()\" class=campaigns><h1><i class=\"fa fa-lock\" tooltip=\"{{ 'projectsCampaigns.list.masutaa_senyou' | translate }}\"></i>{{ 'projectsCampaigns.list.sakuseichuu_no_kyanpeen' | translate }}</h1><div class=campaign-under-setting campaign-table project=currentProject campaigns=incompleteCampaigns filters=updatedFilters show-actions=true show-campaign-detail=true show-stats=false show-control-percent=true is-report=false is-ab=isAb on-update=reload()></div></section><section ng-if=\"previewCampaigns.length > 0\" class=campaigns><h1>{{ 'projectsCampaigns.list.purebyuu_uchi_no' | translate }}</h1><div campaign-table project=currentProject campaigns=previewCampaigns filters=updatedFilters show-actions=true show-campaign-detail=true show-control-percent=true show-stats=false is-report=false is-ab=isAb can-show-invoice-amount=true on-update=reload()></div></section><section class=\"campaigns clearfix\"><div class=row><div class=col-md-7><h1>{{ 'projectsCampaigns.list.kyanpeen_ichiran' | translate }} <span translate=projectsCampaigns.list.de_deeta_shiborikomi translate-value-from=\"{{ filters.start_at | zcDate: { smart: true } }}\" translate-value-to=\"{{ filters.end_at | zcDate: { smart: true } }}\"></span> <span zc-master-only><a ng-if=\"currentProject.jira_link && currentProject.jira_link.length > 0\" ng-href={{currentProject.jira_link}} target=_blank><i class=\"fa fa-lock\" style=\"padding-right: 0px;\"></i> <img src=/assets/admin/jira.ico style=\"height: 16px; width: 16px;\"> {{ 'projectsCampaigns.list.open_jira_link' | translate }}</a></span></h1></div><div class=col-md-5><div class=\"btn-group pull-right\" ng-show=\"Devise.isMaster() && hasHiddenAb\" style=\"margin-left: 5px;\"><button class=\"btn btn-sm btn-default\" ng-click=\"showHiddenAb = !showHiddenAb\" ng-disabled=viewOptions.details><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.list.' + (showHiddenAb ? 'hide_hidden_ab_test' : 'show_hidden_ab_test') | translate }}</button></div><div class=\"btn-group pull-right\" ng-init=\"viewOptions = { details: false }\" style=\"margin-left: 5px;\"><div class=\"btn btn-sm btn-default\" ng-click=\"viewOptions.details = !viewOptions.details\">{{ 'projectsCampaigns.list.' + (viewOptions.details ? 'kekka_ichiran_wo' : 'settei_ichiran_wo') | translate }}</div></div><span><zc-download-campaign-data-button filters=filters project=currentProject campaigns=filteredCampaigns is-ab=isAb></zc-download-campaign-data-button></span></div></div><div campaign-table project=currentProject campaigns=filteredCampaigns filters=updatedFilters show-campaign-detail=viewOptions.details show-control-percent=viewOptions.details show-actions=true show-clearance-settings=true show-stats=!viewOptions.details show-hidden-ab=showHiddenAb has-hidden-ab=hasHiddenAb is-ab=isAb is-report=false can-show-invoice-amount=canShowInvoiceAmount on-update=reload()></div></section></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show.html';
var html = "<div class=container id=campaign-detail><div class=row><div class=col-md-8><campaign-filter-view filters=filters update=updateFilters() reset=resetFilters() project=currentProject hide-search-term=true hide-reset=true hide-device=true hide-campaign-segment-id=true hide-referrer=true></campaign-filter-view></div><div class=col-md-4><div class=\"btn-group pull-right mb20 dropdown\" dropdown zc-master-only><button type=button class=\"btn btn-default dropdown-toggle\" dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.control' | translate }} <span class=caret></span></button><ul class=dropdown-menu zc-master-only><li zc-master-only ng-if=isV1><a ng-click=\"goToEdit('confirm')\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.editCampaign' | translate }}</a></li><li zc-master-only ng-if=\"hasIw || githubUrl\" role=separator class=divider></li><li zc-master-only ng-if=hasIw><a confirm-modal confirm-click=\"updateIwStatus('incomplete_setting')\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.changeIwStatusToNotSet' | translate }}</a></li><li zc-master-only ng-if=hasIw><a confirm-modal confirm-click=\"updateIwStatus('preview')\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.changeIwStatusToPreview' | translate }}</a></li><li zc-master-only ng-if=hasIw><a confirm-modal confirm-click=\"updateIwStatus('enable')\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.changeIWStatusToDeliveryEnable' | translate }}</a></li><li zc-master-only ng-if=hasIw><a confirm-modal confirm-click=\"updateIwStatus('disable')\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.changeIWStatusToDeliveryCompleted' | translate }}</a></li><li zc-master-only ng-if=githubUrl><a href={{githubUrl}} target=_blank><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.campaignEditLog' | translate }}</a></li><li zc-master-only ng-if=campaign.is_secret_ab><a ng-click=toggleShowAB()><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.' + (isAb ? 'hideAbTest' : 'showAbTest') | translate }}</a></li></ul></div><a class=\"btn btn-primary pull-right\" style=margin-right:10px; ng-click=\"goToEdit('confirm')\" ng-if=Devise.isMaster() ng-show=\"campaign.status === 'preview' || campaign.status === 'incomplete'\" ng-disabled=\"campaign.status !== 'preview'\"><i class=\"fa fa-check\"></i> {{ 'projectsCampaigns.approveDelivery' | translate }}</a></div></div><section><ul class=\"campaign-container list-unstyled\"><li campaign-list-view ng-model=campaign filters=filters project=currentProject></li></ul></section><section><ul class=\"nav nav-tabs\"><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.stats')}\"><a ui-sref=\"admin.projects.campaigns.show.stats({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-bar-chart\"></i> {{ 'projectsCampaigns.stats.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.creative')}\"><a ui-sref=\"admin.projects.campaigns.show.creative({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-picture-o\"></i> {{ 'projectsCampaigns.creative.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.incentive')}\"><a ui-sref=\"admin.projects.campaigns.show.incentive({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-ticket\"></i> {{ 'projectsCampaigns.incentive.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.segment')}\"><a ui-sref=\"admin.projects.campaigns.show.segment({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-group\"></i> {{ 'projectsCampaigns.segment.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.clearance')}\" ng-if=campaign.clearance_item_set_id><a ui-sref=\"admin.projects.campaigns.show.clearance({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-list\"></i> {{ 'projectsCampaigns.clearance.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.moment')}\" zc-master-only><a ui-sref=\"admin.projects.campaigns.show.moment({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.moment.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.notes')}\" zc-master-only><a ui-sref=\"admin.projects.campaigns.show.notes({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.notes.title' | translate }}</a></li><li ng-class=\"{'active': isActiveState('admin.projects.campaigns.show.interestWidget')}\" ng-if=showInterestWidgetData zc-master-only><a ui-sref=\"admin.projects.campaigns.show.interestWidget({projectId: currentProject.id, campaignId: campaign.id})\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.interestWidget.title' | translate }}</a></li></ul></section><section ui-view=campaignView></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_clearance.html';
var html = "<div ng-if=!clearanceItemSet><div class=big_icon><i class=\"fa fa-list\"></i></div><div class=campaign_notset>{{ 'projectsCampaigns.clearance.notFound' | translate }}</div></div><div ng-if=clearanceItemSet><zc-clearance-item-list project=currentProject clearance-item-set=clearanceItemSet></zc-clearance-item-list></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_creative.html';
var html = "<div ng-if=!campaign.template.name><div class=big_icon><i class=\"fa fa-picture-o\"></i></div><div class=campaign_notset>{{ 'projectsCampaigns.creative.notFound' | translate }}</div></div><div id=campaign_confirm ng-if=campaign.template.name><div class=row><div class=col-md-4><section class=selected-template><h3>{{campaign.template.label | translate}}{{ 'projectsCampaigns.creative.template' | translate }}</h3><div class=template-img-wrapper><div class=template-img-wrapper-cell><img ng-src={{campaign.template.image}}></div></div></section></div><div class=col-md-8><section class=option-common ng-if=\"hasOptionType('common')\"><h3>{{ 'projectsCampaigns.creative.globalSettings' | translate }}</h3><div class=row><div ng-repeat=\"item in campaign.template.template\" ng-if=\"item.option_category === 'common'\" class=col-md-6><div class=option-item ng-init=\"viewOptions = { details: false }\"><label for={{item.name}} class=option-title ng-if=item.label>{{item.label | translate}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip=\"{{item.description | translate}}\" tooltip-trigger=mouseenter tooltip-placement=top></i></label><campaign-template-item campaign=campaign item=item disabled=true></campaign-template-item></div></div></div></section></div></div><section ng-repeat=\"view in campaign.template.views\" class=\"option-{{view.class}} zc\" ng-if=hasOptionType(view.class)><h3>{{view.name | translate}}: {{ 'projectsCampaigns.creative.settingItem' | translate }}</h3><div class=row><div class=col-md-8><campaign-dynamic-view campaign=campaign form=templateForm view-class={{view.class}}></campaign-dynamic-view></div><div class=col-md-4><div class=option-wrapper><div ng-repeat=\"item in campaign.template.template\" ng-if=\"item.option_category === view.class\" class=item-margin><div class=option-item ng-hide=\"hideCodeIncentiveConfigItem(item) || hideTimerConfigItem(item) || Campaign.hideBadgeConfigItem(item, campaign) || Campaign.hideCodeLabelConfigItem(item, campaign)\"><label for={{item.name}} class=option-title ng-if=item.label>{{item.label | translate}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip=\"{{item.description | translate}}\" tooltip-trigger=mouseenter tooltip-placement=top></i></label><campaign-template-item campaign=campaign item=item disabled=true></campaign-template-item></div></div></div></div></div></section><section class=custom-css ng-if=\"campaign.campaign_device !== 'app'\"><div class=\"memo custom-css\" ng-animate><div><h3>{{ 'projectsCampaigns.creative.customCSS' | translate }}</h3><textarea type=text class=form-control ng-model=campaign.custom_css ng-disabled=true>\n          </textarea></div></div></section><section><div class=row ng-if=\"campaign.iw_current_status !== 'enable'\"><div class=col-md-4><h3>{{ 'projectsCampaigns.creative.campaignPreview' | translate }}</h3></div><div class=col-md-8><div class=form-group><div class=\"input-group mb10\"><span class=input-group-btn><button class=\"btn btn-default\" ngclipboard data-clipboard-target=#previewUrl><i class=\"fa fa-clipboard\"></i></button></span> <input id=previewUrl type=text class=form-control ng-value=previewUrl> <span class=input-group-btn><a class=\"btn btn-primary\" href={{previewUrl}} target=_blank>{{ 'projectsCampaigns.creative.displayCampaign' | translate }}</a></span></div><p class=text-mute>{{ 'projectsCampaigns.creative.campaignPreviewExplanation' | translate }}</p></div></div></div><div class=row ng-if=\"campaign.iw_current_status === 'preview'\" ng-repeat=\"c in otherCampaigns\"><div class=row style=\"padding-left: 1em\"><div class=col-md-12><p class=text-mute>{{c.name}}</p></div></div><div class=col-md-4><h3><i class=\"fa fa-lock\"></i> <a ui-sref=\"admin.projects.campaigns.show.stats({projectId:c.project_id, campaignId:c.id})\">ID{{c.id}}</a>{{ 'projectsCampaigns.creative.runInParallelWith' | translate }}</h3></div><div class=col-md-8><div class=form-group><div class=\"input-group mb10\"><span class=input-group-btn><button class=\"btn btn-default\" ngclipboard data-clipboard-target=#previewUrl{{c.id}}><i class=\"fa fa-clipboard\"></i></button></span> <input id=previewUrl{{c.id}} type=text class=form-control ng-value=c.previewUrl></div></div></div></div><div ng-if=lpSegmentSet class=row><div class=col-md-4><h3>{{ 'projectsCampaigns.creative.lpPreview' | translate }}</h3></div><div class=col-md-8><div class=form-group><div class=\"input-group mb10\" ng-repeat=\"url in lpUrls\"><span class=input-group-btn><button class=\"btn btn-default\" ngclipboard data-clipboard-target=\".lpUrls{{ $index }}\"><i class=\"fa fa-clipboard\"></i></button></span> <input class=\"lpUrls{{ $index }} form-control\" type=text ng-value=url> <span class=input-group-btn><a class=\"btn btn-primary\" href={{url}} target=_blank>{{ 'projectsCampaigns.creative.displayCampaign' | translate }}</a></span></div><p ng-if=\"lpUrls.length > 0\" class=text-mute translate=projectsCampaigns.creative.lpPreviewExplanation translate-value-historysize=\"{{ historySize }}\" translate-value-historytime=\"{{ historyTime }}\"></p><p ng-if=\"lpUrls.length == 0\" class=text-mute>{{ 'projectsCampaigns.creative.lpNoMatch' | translate }}</p></div></div></div><div class=row zc-master-only><div class=col-md-4><h3><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.creative.clientAdminPanel' | translate }}</h3></div><div class=col-md-8><div class=form-group><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" ngclipboard data-clipboard-target=#adminUrl><i class=\"fa fa-clipboard\"></i></button></span> <input id=adminUrl type=text class=form-control ng-value=adminUrl></div></div></div></div><div class=row zc-master-only><div class=col-md-4><h3><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.creative.deliverToSpeficiedUSID' | translate }}</h3></div><div class=col-md-8><form name=publishForm ng-submit=publish(_usid)><div class=form-group><div class=\"input-group mb10\"><input type=text class=form-control ng-model=_usid placeholder=_usid ng-disabled=!campaign.campaign_policy_set_id required> <span class=input-group-btn><button type=submit class=\"btn btn-danger btn-block\" confirm-modal=\"{{ 'projectsCampaigns.creative.deliverCampaignConfirmation' | translate }}\" ng-disabled=publishForm.$invalid value=\"{{ 'projectsCampaigns.creative.deliverCampaign' | translate }}\">{{ 'projectsCampaigns.creative.deliverCampaign' | translate }}</button></span></div><p class=text-mute>{{ 'projectsCampaigns.creative.deliverToSpeficiedUSIDExplanation1' | translate }}<br>{{ 'projectsCampaigns.creative.deliverToSpeficiedUSIDExplanation2' | translate }}</p></div></form></div></div></section><section class=option-other ng-if=\"Devise.isMaster() && hasOptionType('other')\"><h3><i class=\"fa fa-lock\"></i> {{ 'projectsCampaigns.creative.advancedSettings' | translate }}</h3><div class=\"selected-template-options row parent\"><div ng-repeat=\"item in campaign.template.template\" ng-if=\"item.option_category === 'other'\" class=\"col-md-3 child\"><div class=option-item><label for={{item.name}} class=option-title ng-if=item.label>{{item.label | translate}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip=\"{{item.description | translate}}\" tooltip-trigger=mouseenter tooltip-placement=top></i></label><campaign-template-item campaign=campaign item=item disabled=true></campaign-template-item></div></div></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_incentive.html';
var html = "<zc-campaign-incentive-table campaign=campaign></zc-campaign-incentive-table><zc-campaign-incentive-error campaign=campaign form=incentiveForm></zc-campaign-incentive-error><zc-campaign-incentive-warning campaign=campaign></zc-campaign-incentive-warning><div ng-if=!campaign.incentives.length><div class=big_icon><i class=\"fa fa-ticket\"></i></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_interest_widget.html';
var html = "<div class=row><div class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsCampaigns.interestWidget.compareIWUserInterestLevel' | translate }}</h3></div><div class=panel-body><zc-campaign-interest-widget-item-graph project=currentProject campaign=campaign filters=updatedFilters></zc-campaign-interest-widget-item-graph></div></div></div><div class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsCampaigns.interestWidget.campaignEventsAmongIWUsers' | translate }}</h3></div><div class=panel-body><zc-campaign-interest-widget-event campaign=campaign filters=updatedFilters></zc-campaign-interest-widget-event></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_moment.html';
var html = "<h4>{{ 'projectsCampaigns.moment.deliveryResults' | translate }}</h4><section><zc-campaign-moment-graph project=currentProject campaign=campaign filters=updatedFilters></zc-campaign-moment-graph></section><h4 ng-if=\"campaign.configuration_type === 'conversion_prediction'\">{{ 'projectsCampaigns.moment.simulation' | translate }}</h4><section ng-if=\"campaign.configuration_type === 'conversion_prediction'\"><div class=row><div class=col-md-8><div>{{ 'projectsCampaigns.moment.simulationExplanation' | translate }}</div><br><div><label>{{ 'projectsCampaigns.moment.maximumSampleCount' | translate }}</label> &nbsp; <label class=radio-inline><input type=radio ng-model=$parent.sampleSessionSize ng-value=500 checked> 500</label> <label class=radio-inline><input type=radio ng-model=$parent.sampleSessionSize ng-value=5000> 5,000</label></div><br><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaigns.moment.excludeNoConversionAnyway' | translate }}</h4><zc-session-prediction-distribution campaign=campaign sessions=sessions disabled=true field=predictions_max_before_cart.global_conversion_rate></zc-session-prediction-distribution></div><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaigns.moment.excludeConversionAnyway' | translate }}</h4><zc-session-prediction-distribution campaign=campaign sessions=sessions disabled=true field=predictions_min_before_cart.global_conversion_rate></zc-session-prediction-distribution><br><br><div class=form-group><label><input ng-model=campaign.exclude_cart_button_click type=checkbox disabled> {{ 'projectsCampaigns.moment.excludeCartButtonClick' | translate }}</label></div></div><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaigns.moment.excludeNegativeImpact' | translate }}</h4><zc-session-price-distribution project=currentProject campaign=campaign sessions=sessions disabled=true field=average_recent5_item_price></zc-session-price-distribution><br><br><div class=form-group><label><input ng-model=campaign.exclude_no_price type=checkbox disabled> {{ 'projectsCampaigns.moment.excludeNegativeImpactExplanation' | translate }}</label></div></div></div><div class=col-md-4><zc-session-uplift-modeling-classification campaign=campaign sessions=sessions></zc-session-uplift-modeling-classification><zc-logistic-regression-coefficients apikey=campaign.apikey preferred-device=campaign.campaign_device></zc-logistic-regression-coefficients></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_notes.html';
var html = "<h4>{{ 'projectsCampaigns.notes.title' | translate }}</h4><section><zc-campaign-note note=all mode=list campaign=campaign></zc-campaign-note></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_segment.html';
var html = "<div ng-if=!campaign.segment.id><div class=big_icon><i class=\"fa fa-group\"></i></div><div class=campaign_notset>{{ 'projectsCampaigns.segment.notFound' | translate }}</div></div><section class=kpi-container ng-if=Devise.isMaster()><campaign-segment-panels project=currentProject campaign=campaign filters=updatedFilters></campaign-segment-panels><zc-campaign-segment-graph project=currentProject campaign=campaign filters=updatedFilters></zc-campaign-segment-graph><zc-campaign-segment-summary project=currentProject campaign=campaign filters=updatedFilters></zc-campaign-segment-summary></section><zc-campaign-segment-show segment-id=campaign.segment.id project=currentProject ng-if=campaign.segment.id></zc-campaign-segment-show>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/show_stats.html';
var html = "<div ng-if=\"campaign.current_status === 'incomplete' || campaign.current_status === 'preview'\"><div class=big_icon><i class=\"fa fa-bar-chart\"></i></div><div class=campaign_notset>{{ 'projectsCampaigns.stats.notFound' | translate }}</div></div><div ng-if=\"campaign.current_status !== 'incomplete' && campaign.current_status !== 'preview'\"><campaign-chisq-test project=currentProject campaign=campaign filters=updatedFilters ng-if=isAb zc-master-only></campaign-chisq-test><section class=kpi-container><campaign-panels project=currentProject campaign=campaign filters=updatedFilters is-ab=isAb></campaign-panels></section><campaign-graph project=currentProject campaign=campaign filters=filters is-ab=isAb></campaign-graph><section class=compare><div class=row><div ng-if=isAb class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsCampaigns.stats.compareKPI' | translate }}</div><ng-container ng-if=!currentProject.enable_direct_cv><div class=panel-body><campaign-groups project=currentProject campaign=campaign filters=updatedFilters></campaign-groups></div><div class=panel-footer>{{ 'projectsCampaigns.stats.compareKPIExplanation' | translate }}</div></ng-container><div ng-if=currentProject.enable_direct_cv class=panel-footer>{{ 'projectsCampaigns.stats.noComparisonDataForDirectCV' | translate }}</div></div></div><div class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsCampaigns.stats.campaignPriceDistribution' | translate }}</div><div class=panel-body><campaign-price-distribution campaign=campaign filters=updatedFilters></campaign-price-distribution></div><div ng-if=isAb class=panel-footer>{{ 'projectsCampaigns.stats.campaignPriceDistributionExplanation' | translate }}</div></div></div><div class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading>{{ 'projectsCampaigns.stats.behaviorData' | translate }}</div><div class=panel-body><campaign-events campaign=campaign campaign-event-order=campaignEventOrder campaign-event-notices=campaignEventNotices filters=updatedFilters></campaign-events></div><div class=panel-footer><p class=text-mute>{{ 'projectsCampaigns.stats.behaviorDataExplanation' | translate }}</p></div></div></div></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_base_step.html';
var html = "<form name=basicForm><fieldset ng-disabled=\"campaign.current_status === 'terminated'\"><div class=section ng-class=\"{'invalid': !campaign.name}\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBaseStep.kyanpeen_na' | translate }}</h4><div class=form-group><input type=text id=campaign_name class=\"form-control input-lg\" ng-model=campaign.name required auto-fill-sync></div></div><div class=\"section clearfix\" ng-if=\"project.product_line !== 'zenclerk_lp'\" ng-class=\"{'invalid': project.product_line === 'zenclerk'}\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBaseStep.kyanpeen_tesuuryou_ritsu' | translate }}</h4><div class=form-group><select class=form-control ng-model=campaign.fee_calculation_type><option value=contribution>{{ 'projectsCampaignsViews.directives.campaignBaseStep.kakutoku_kingaku_ni' | translate }}</option><option value=conversion>{{ 'projectsCampaignsViews.directives.campaignBaseStep.keiyu_uriage_ni' | translate }}</option></select></div><div class=form-group><input id=campaign_fee_rate class=\"form-control input-lg\" type=number step=0.001 min=0 max=1 placeholder=0.1 ng-model=campaign.fee_rate ng-required=\"project.product_line === 'zenclerk'\"></div><div class=element_discription>{{ 'projectsCampaignsViews.directives.campaignBaseStep.kyanpeen_wa_haishin' | translate }}</div></div><div class=\"section clearfix\" ng-class=\"{'invalid': !campaign.campaign_device}\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBaseStep.taagettodebaisu' | translate }}</h4><div class=form-group><select class=form-control ng-options=\"campaignDevice.name as campaignDevice.label for campaignDevice in campaignDevices\" ng-model=campaign.campaign_device></select></div><div class=element_discription>{{ 'projectsCampaignsViews.directives.campaignBaseStep.sumaatofon_wo_sentaku' | translate }}</div></div><div class=\"section clearfix\" ng-if=\"campaign.campaign_device !== 'app'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBaseStep.infomeeshon_haishin' | translate }}</h4><div class=form-group><label><input ng-model=campaign.is_information_campaign type=checkbox> {{ 'projectsCampaignsViews.directives.campaignBaseStep.infomeeshon_haishin_settei' | translate }}</label></div><div class=element_discription>{{ 'projectsCampaignsViews.directives.campaignBaseStep.haishin_intaabaru_wo' | translate }}<br>{{ 'projectsCampaignsViews.directives.campaignBaseStep.infomeeshon_haishin_kyanpeen' | translate }}<br>{{ 'projectsCampaignsViews.directives.campaignBaseStep.tadashi,infomeeshon_haishin_uchi' | translate }}</div></div><div class=section ng-class=\"{'invalid': !campaign.target_conversion_name}\" ng-if=project.is_target_conversion_name_supported><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBaseStep.taishou_konbaajon' | translate }}</h4><div class=form-group><div><input type=text id=campaign_target_conversion_name class=\"form-control input-lg\" ng-model=campaign.target_conversion_name auto-fill-sync></div></div><div class=element_discription>{{ 'projectsCampaignsViews.directives.campaignBaseStep.ni_shitei_sareteirukonbaajon' | translate }}<br>{{ 'projectsCampaignsViews.directives.campaignBaseStep.subete_no_konbaajon' | translate }}</div></div><div class=\"section clearfix\" ng-class=\"{'invalid': !campaign.cost_per_acquisition}\" ng-if=\"project.product_line === 'zenclerk_lp'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBaseStep.cpa_tanka' | translate }}</h4><div class=form-group><select class=form-control ng-model=campaign.fee_calculation_type><option value=contribution>{{ 'projectsCampaignsViews.directives.campaignBaseStep.kakutoku_ni_wo' | translate }}</option><option value=conversion>{{ 'projectsCampaignsViews.directives.campaignBaseStep.keiyu_ni_wo' | translate }}</option></select></div><div class=form-group><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=cost_per_acquisition min=0 type=number class=\"form-control input-lg\" style=\"border: 1px solid #ccc;\" ng-model=campaign.cost_per_acquisition required> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div><div class=element_discription>{{ 'projectsCampaignsViews.directives.campaignBaseStep.kyanpeen_wa_haishin' | translate }}</div></div><zc-campaign-note note=base campaign=campaign mode=edit></zc-campaign-note></fieldset></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_botbonnie_step.html';
var html = "<form name=botbonnieForm ng-submit=validateTriggerRules()><fieldset ng-disabled=\"campaign.current_status === 'terminated' || disableBotbonnieForm()\"><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.botbonnie_integration' | translate }}</h4><div class=form-group><label><input type=checkbox id=enable_botbonnie_integration ng-model=campaign.enable_botbonnie_integration> {{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.enable_botbonnie_integration' | translate }}</label></div></div><div class=section ng-hide=!campaign.enable_botbonnie_integration><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.botbonnie_module_triggers' | translate }}</h4><div class=form-group><label><input type=checkbox id=enable_botbonnie_open_chatroom ng-model=campaign.enable_botbonnie_open_chatroom> {{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.enable_botbonnie_open_chatroom' | translate }}</label></div><div ng-repeat=\"trigger in campaign.botbonnie_trigger_rules\"><span><select ng-model=trigger.trigger ng-change=validateTriggerRules() ng-options=\"trigger.value as trigger.name for trigger in triggers\"></select></span> <span ng-hide=\"trigger.trigger !== 'timing'\"><input type=number max=\"{{ campaign.element.message.limit }}\" min=0 ng-change=validateTriggerRules() ng-model=trigger.minutes> {{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.minutes_later' | translate }}</span> <span ng-hide=\"trigger.trigger == null\">{{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.trigger_module' | translate }} <input type=text ng-change=validateTriggerRules() ng-model=trigger.module></span> <span><button class=\"btn btn-default btn-xs btn-danger\" ng-click=deleteRule(trigger)><span class=\"glyphicon glyphicon-remove-sign\"></span></button></span></div><span><button class=\"btn btn-default btn-xs btn-success\" ng-click=addRule() ng-hide=\"campaign.botbonnie_trigger_rules.length >= triggerRulesMaxLength\"><span class=\"glyphicon glyphicon-plus-sign\"></span></button></span></div></fieldset><div ng-hide=\"triggerErrors.length == 0\"><h4>{{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.error' | translate }}</h4><div ng-repeat=\"error in triggerErrors\">{{ error.message }}</div></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_chisq_test.html';
var html = "<div class=zc-alert role=alert ng-if=!chisq_test><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignChisqTest.konogo_aida_no' | translate }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_confirm_step.html';
var html = "<div class=row><div class=col-md-12><div><div><div ng-if=\"campaign.current_status === 'terminated'\" class=\"alert alert-danger\" role=alert><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_kanryou_no' | translate }}</div><div ng-show=allValid><div class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.subete_settei_sareteimasu' | translate }}</div></div><div ng-show=!allValid><div style=\"font-size: 1.2em;\" class=\"alert alert-warning\" role=alert><i class=\"fa fa-check\"></i> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.settei_ga_kanryou' | translate }}</div></div><div style=\"font-size: 1.2em;\" class=\"alert alert-warning\" role=alert ng-if=\"project.product_line === 'zenclerk_lp' && campaign.campaign_policy_set.name === 'item_random'\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.tanpin_saito_de' | translate }}</div><div style=\"font-size: 1.2em;\" class=\"alert alert-warning\" role=alert ng-if=\"!campaign.incentives.length && !campaign.element.message.linkage_url && !campaign.element.message.linkage_url_offer\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.ko_no_kyanpeenhainsentibuoyobirinku' | translate }}</div><div style=\"font-size: 1.2em;\" ng-if=\"project.installed_at === null && campaign.segment !== null && campaign.segment.segment_type === 'new'\" class=\"alert alert-warning\" role=alert><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.dateNotSet' | translate }}</div><div style=\"font-size: 1.2em;\" ng-if=\"campaign.status === 'preview' && !campaign.was_activated_before && is_start_at_before_today\" class=\"alert alert-warning\" role=alert><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.cannotStartBeforeToday' | translate }}</div><zc-campaign-incentive-error campaign=campaign form=incentiveForm></zc-campaign-incentive-error><zc-campaign-incentive-warning campaign=campaign></zc-campaign-incentive-warning></div></div><div class=\"checklist clearfix line confirm-design\"><div class=checklist_mark><i ng-if=\"project.product_line === 'zenclerk_lp'\" class=glyphicon ng-class=\"{ 'glyphicon-ok-sign': basicForm.$valid, 'glyphicon-remove-sign': !basicForm.$valid, }\"></i> <i ng-if=\"project.product_line !== 'zenclerk_lp'\" class=glyphicon ng-class=\"{ 'glyphicon-ok-sign': templateForm.$valid, 'glyphicon-remove-sign': !templateForm.$valid, }\"></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.kihon_settei' | translate }}</h3><div><div ng-if=campaign.fee_rate><p>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.kyanpeen_tesuuryou_ritsu' | translate }}<b>{{ campaign.fee_rate }}</b> <span ng-if=\"campaign.fee_rate !== project.fee_rate\" translate=projectsCampaignsViews.directives.campaignConfirmStep.saito_tesuuryou_ritsu translate-value-feerate=\"{{ project.fee_rate }}\"></span></p></div><zc-campaign-note note=base campaign=campaign mode=display compact=true></zc-campaign-note><p ng-if=\"project.product_line === 'zenclerk_lp'\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.cpa_tanka' | translate }} <b ng-if=\"campaign.cost_per_acquisition !== null\"><span>{{ currency.symbol }}</span>{{ campaign.cost_per_acquisition | number }}<span>{{ currency.suffix }}</span></b></p></div></div><div class=checklist_edit><button class=\"btn btn-default\" ng-disabled=\"campaign.current_status === 'terminated'\" ui-sref=admin.projects.campaigns.edit.base>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.henshuu' | translate }}</button></div></div><div class=\"checklist clearfix line confirm-design\"><div class=checklist_mark><i class=\"glyphicon glyphicon-ok-sign\" ng-show=incentiveForm.$valid></i> <i class=\"glyphicon glyphicon-remove-sign\" ng-show=!incentiveForm.$valid></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.insentibu' | translate }}</h3><div><zc-campaign-note note=incentive campaign=campaign mode=display></zc-campaign-note><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.insentibu_settei' | translate }}</h4><p ng-if=!campaign.requires_incentives>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.insentibu_ga_riyou' | translate }}</p><zc-campaign-incentive-table campaign=campaign></zc-campaign-incentive-table></div></div></div><div class=\"checklist clearfix line confirm-design\"><div class=checklist_mark><i class=\"glyphicon glyphicon-ok-sign\" ng-show=templateForm.$valid></i> <i class=\"glyphicon glyphicon-remove-sign\" ng-show=!templateForm.$valid></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.kurieitibu' | translate }}</h3><div><zc-campaign-note note=template campaign=campaign mode=display compact=true></zc-campaign-note><p>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.tenpureeto_na' | translate }} <b>{{ campaign.template.label | translate }}</b> <span style=color:gray>({{campaign.template.name}})</span></p></div></div><div class=checklist_edit><button class=\"btn btn-default\" ng-disabled=\"campaign.current_status === 'terminated'\" ui-sref=admin.projects.campaigns.edit.template>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.henshuu' | translate }}</button></div></div><div class=\"checklist clearfix line confirm-design\"><div class=checklist_mark><i class=\"glyphicon glyphicon-ok-sign\" ng-show=botbonnieForm.$valid></i> <i class=\"glyphicon glyphicon-remove-sign\" ng-show=!botbonnieForm.$valid></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.botbonnie_integration' | translate }}</h3><div class=form-group><label><input type=checkbox ng-disabled=true id=confirm_enable_botbonnie_open_chatroom ng-model=campaign.enable_botbonnie_open_chatroom> {{ 'projectsCampaignsViews.directives.campaignBotbonnieStep.enable_botbonnie_open_chatroom' | translate }}</label></div><div><table class=\"table table-bordered table-striped table-condensed confirm-table\"><thead><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.botbonnie_trigger' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.botbonnie_minutes' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.botbonnie_module' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"trigger in campaign.botbonnie_trigger_rules\"><td>{{ trigger.trigger }}</td><td>{{ trigger.minutes }}</td><td>{{ trigger.module }}</td></tr></tbody></table></div></div><div class=checklist_edit><button class=\"btn btn-default\" ng-disabled=\"campaign.current_status === 'terminated'\" ui-sref=admin.projects.campaigns.edit.botbonnie>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.henshuu' | translate }}</button></div></div><div class=\"checklist clearfix line confirm-campaign-policy\"><div class=checklist_mark><i class=\"glyphicon glyphicon-ok-sign\" ng-show=policyForm.$valid></i> <i class=\"glyphicon glyphicon-remove-sign\" ng-show=!policyForm.$valid></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.segumento' | translate }}</h3><div><zc-campaign-note campaign=campaign note=policy mode=display></zc-campaign-note><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i></h4><span ng-if=\"campaign.template.campaign_type !== 'Widget'\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.hihyouji_ritsu' | translate }}<zc-campaign-control-percent-labels campaign=campaign></zc-campaign-control-percent-labels></span> <span ng-if=\"campaign.template.campaign_type !== 'Widget' && campaign.is_secret_ab\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.ab_tesuto_hihyouji' | translate }}<br>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.yuukou_kyanpeen_ichiran' | translate }}</span><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.debaisu_nakagurosegumento_settei' | translate }}</h4><table class=\"table table-bordered table-striped table-condensed confirm-table\"><tbody><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_debaisu' | translate }}</th><td><span campaign-device ng-model=campaign></span></td></tr><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.segumento' | translate }}</th><td><zc-campaign-segment-flag segment=campaign.segment></zc-campaign-segment-flag></td></tr></tbody></table><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_taishou_segumento' | translate }}</h4><table class=\"table table-bordered table-striped table-condensed confirm-table\"><tbody><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_intaabaru' | translate }}</th><td>{{campaign.days_since_last_received}} {{ 'projectsCampaignsViews.directives.campaignConfirmStep.hiai' | translate }}</td><td>{{campaign.days_since_last_received_conversion}} {{ 'projectsCampaignsViews.directives.campaignConfirmStep.conversion_period' | translate }}</td></tr><tr ng-show=campaign.exclude_logged_in><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.roguinyuuzaa_jogai' | translate }}</th><td><span class=confirm_highright ng-show=campaign.exclude_logged_in>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.roguinyuuzaani_wa_haishin' | translate }}</span> <span ng-show=!campaign.exclude_logged_in>-</span></td></tr><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.shousai_segumento' | translate }}</th><td><span ng-repeat=\"segment in campaign_segments | filter:{id:campaign.segment_id}:true\">{{segment.name}}</span></td></tr></tbody></table><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignConfirmStep.chokkin_ichi_jikan_no' | translate }}</h4><zc-campaign-recent-segment-table campaign=campaign></zc-campaign-recent-segment-table><table class=\"table table-condenced\"><tr ng-repeat=\"(key,value) in currentSegment\"><td>{{key}}</td><td>{{value}}</td></tr></table></div></div><div class=checklist_edit><button class=\"btn btn-default\" ng-disabled=\"campaign.current_status === 'terminated'\" ui-sref=admin.projects.campaigns.edit.policy>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.henshuu' | translate }}</button></div></div><div ng-if=\"campaign.configuration_type !== 'immediate'\" class=\"checklist clearfix line confirm-campaign-timing\"><div class=checklist_mark><i class=\"glyphicon glyphicon-ok-sign\" ng-show=timingForm.$valid></i> <i class=\"glyphicon glyphicon-remove-sign\" ng-show=!timingForm.$valid></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.taimingu' | translate }}</h3><div><zc-campaign-note note=timing campaign=campaign compact=true mode=display></zc-campaign-note><table class=\"table table-bordered table-striped table-condensed confirm-table\" ng-if=\"campaign.configuration_type === 'csv_upload'\"><tbody><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.shousai_taimingu' | translate }}</th><td><span ng-repeat=\"set in campaign_policy_sets | filter:{id:campaign.campaign_policy_set_id}:true\">{{set.name}}</span></td></tr></tbody></table><table class=\"table table-bordered table-striped table-condensed confirm-table\" ng-if=\"campaign.configuration_type === 'ai_model' || campaign.configuration_type === 'uplift_modeling'\"><tbody><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.score_threshold' | translate }}</th><td>{{ campaign.score_threshold }} <span ng-if=\"campaign.configuration_type === 'ai_model' && campaign.auto_configuration\">({{ 'projectsCampaignsViews.directives.campaignTimingStep.auto_configuration' | translate }})</span></td></tr></tbody></table><div ng-if=\"campaign.configuration_type === 'sampling'\"><p>{{ 'projectsCampaignsViews.directives.campaignTimingStep.sampling_rate' | translate }}: {{ campaign.sampling_range }}</p></div></div></div><div class=checklist_edit><button class=\"btn btn-default\" ng-disabled=\"campaign.current_status === 'terminated'\" ui-sref=admin.projects.campaigns.edit.timing>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.henshuu' | translate }}</button></div></div><div class=\"checklist clearfix line confirm-schedule\"><div class=checklist_mark><i class=\"glyphicon glyphicon-ok-sign\" ng-show=scheduleForm.$valid></i> <i class=\"glyphicon glyphicon-remove-sign\" ng-show=!scheduleForm.$valid></i></div><div class=checklist_body><h3>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.sukejuuru' | translate }}</h3><div><zc-campaign-note note=schedule campaign=campaign mode=display compact=true></zc-campaign-note><table class=\"table table-bordered table-striped table-condensed confirm-table\"><tbody><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_kaishibi_toki' | translate }}</th><td><span class=start_at ng-show=\"campaign.start_at_obj.date && campaign.start_at_obj.time !== undefined\">{{ campaign.start_at_obj | dateObjToDate | zcDate }} ({{ campaign.region | gmtNotation }})</span></td></tr><tr><th>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_shuuryoubi_toki' | translate }}</th><td><span class=end_at ng-show=campaign.is_infinite>{{ 'projectsCampaignsViews.directives.campaignRange.kigen_nashi' | translate }}</span> <span class=end_at ng-show=\"!campaign.is_infinite && campaign.end_at_obj.date && campaign.end_at_obj.time !== undefined\">{{ campaign.end_at_obj | dateObjToDate | zcDate }} ({{ campaign.region | gmtNotation }})</span></td></tr></tbody></table></div></div><div class=checklist_edit><button class=\"btn btn-default\" ng-disabled=\"campaign.current_status === 'terminated'\" ui-sref=admin.projects.campaigns.edit.schedule>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.henshuu' | translate }}</button></div></div><div ng-if=!campaign.interest_widget_id class=\"checklist clearfix line text-center\"><button class=\"btn btn-lg btn-primary\" ng-if=\"campaign.status == 'incomplete'\" ng-disabled=templateForm.$invalid ng-click=\"changeStatus({status: 'preview'})\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.purebyuu_ni_suru' | translate }}</button> <button class=\"btn btn-lg btn-success\" ng-if=\"campaign.status == 'preview'\" ng-disabled=!allValid confirm-modal=\"{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_ga_yoyaku' | translate }}\" confirm-click=\"changeStatus({status: 'activated'})\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_wo_shounin' | translate }}</button> <button class=\"btn btn-lg btn-primary\" ng-if=\"campaign.status == 'activated' && campaign.current_status !== 'terminated'\" ng-click=\"changeStatus({status: 'preview'})\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.purebyuu_ni_modosu' | translate }}</button></div><div ng-if=campaign.interest_widget_id class=\"checklist clearfix line text-center\"><button class=\"btn btn-lg btn-primary\" ng-if=\"campaign.iw_status == 'incomplete_setting' || !campaign.iw_status\" ng-disabled=\"templateForm.$invalid || !campaign.iw_status\" ng-click=\"changeInterestWidgetStatus({status: 'preview'})\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.purebyuu_zentai_haishin_ni_suru' | translate }}</button><div ng-if=!campaign.iw_status>{{ 'projectsCampaignsViews.directives.campaignConfirmStep.purebyuunisuru_maeni_ichido' | translate }}</div><button class=\"btn btn-lg btn-success\" ng-if=\"campaign.iw_status == 'preview'\" ng-disabled=!allValid confirm-modal=\"{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_ga_kaishi' | translate }}\" confirm-click=\"changeInterestWidgetStatus({status: 'enable'})\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.haishin_zentai_wo_shounin' | translate }}</button> <button class=\"btn btn-lg btn-primary\" ng-if=\"campaign.iw_status == 'enable'\" ng-click=\"changeInterestWidgetStatus({status: 'preview'})\">{{ 'projectsCampaignsViews.directives.campaignConfirmStep.purebyuu_zentai_haishin_ni_modosu' | translate }}</button></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_control_percent_labels.html';
var html = "<span ng-if=\"campaign.campaign_control_percent === null\" class=notset>{{ 'projectsCampaignsViews.directives.campaignControlPercentLabels.deforuto' | translate }}</span><div ng-if=\"campaign.campaign_control_percent !== null\"><span class=\"label label-info\" ng-bind=\"campaign.campaign_control_percent + '%'\"></span> <span ng-if=\"campaign.campaign_control_percent === 0\" class=\"label label-success\">{{ 'projectsCampaignsViews.directives.campaignControlPercentLabels.haishin' | translate:{ percentage: 100 } }}</span> <span ng-if=\"campaign.campaign_control_percent === 100\" class=\"label label-danger\">{{ 'projectsCampaignsViews.directives.campaignControlPercentLabels.haishin' | translate:{ percentage: 0 } }}</span></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_coupon_applicable_rate.html';
var html = "<div ng-show=\"Devise.isMaster() && coupon_applicable_rate != null\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignCouponApplicableRate.label' | translate: { campaign_coupon_applicable_rate: (coupon_applicable_rate * 100 || 0 | number:2) } }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_coupon_data.html';
var html = "<div ng-if=project.enables_coupon_code_conversion_tag><div ng-if=\"project.shows_coupon_code_usage_rate || Devise.isMaster()\"><i ng-if=!project.shows_coupon_code_usage_rate class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignCouponData.kuuponkoodo_shiyouritsu' | translate: { campaign_coupon_used_rate: rate_to_display } }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_creatives.html';
var html = "<table class=table><thead><tr><th class=campaign-detail-table-title></th><th>{{ 'projectsCampaignsViews.directives.campaignCreatives.kuupon_no_settei' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in template\"><th>{{v.label}}</th><td ng-bind-html=\"campaign.element.message | showElement : v\" class=campaign-setting-detail></td></tr><tr><th>{{ 'projectsCampaignsViews.directives.campaignCreatives.tsuika_css' | translate }}</th><td><code>\n          {{campaign.custom_css}}\n        </code></td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_dynamic_view.html';
var html = "<div ng-show=hasError><p></p><h3>{{ 'projectsCampaignsViews.directives.campaignDynamicView.tenpureeto_hyouji_uchi' | translate }}</h3><p></p></div><div ng-hide=hasError><div ng-hide=view><div class=big_icon><i class=\"fa fa-picture-o\"></i></div></div><div ng-show=view><div ng-hide=campaign.template.views.length><p></p><h3>{{ 'projectsCampaignsViews.directives.campaignDynamicView.taihen_moushiwakegozaimasen' | translate }}</h3><p></p><p></p><h3>{{ 'projectsCampaignsViews.directives.campaignDynamicView.ko_no_tenpureeto' | translate }}</h3><p></p></div><div ng-show=campaign.template.views.length><div class=\"{{template_view.class}} zc\" ng-repeat=\"template_view in campaign.template.views\" ng-if=\"template_view.class === viewClass\"><div id=zc-plugincontainer><div class=\"zc-wrapper zc-wrapper-campaign zc-wrapper-widget\" ng-bind-html=view></div></div></div><style ng-bind=\"css + campaign.custom_css\">\n      </style><div ng-bind-html=js></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_events.html';
var html = "<div class=campaign-event-list ng-show=campaign_events_by_id.show_offerview.count><div class=list-wrapper><table class=c-event-table-wrap><tr><td>{{ 'projectsCampaignsViews.directives.campaignEvents.ofaabyuu_wo_hyouji' | translate }}</td><td>{{campaign_events_by_id.show_offerview.count | number}}</td><td></td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.remove_modal_event_banner_offer.count ng-if=Devise.isMaster()><table class=c-event-table-wrap><tr><td><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.shokai_banaakurikku' | translate }}</td><td>{{campaign_events_by_id.remove_modal_event_banner_offer.count + campaign_events_by_id.click_offer_activate.count | number}}</td><td>{{(campaign_events_by_id.remove_modal_event_banner_offer.count + campaign_events_by_id.click_offer_activate.count) / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.remove_modal_event_filter.count ng-if=Devise.isMaster()><table class=c-event-table-wrap><tr><td><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.shokai_firutaakurikku' | translate }}</td><td>{{campaign_events_by_id.remove_modal_event_filter.count | number}}</td><td>{{campaign_events_by_id.remove_modal_event_filter.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.remove_modal_event_close.count ng-if=Devise.isMaster()><table class=c-event-table-wrap><tr><td><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.shokai_xbotankurikku' | translate }}</td><td>{{campaign_events_by_id.remove_modal_event_close.count | number}}</td><td>{{campaign_events_by_id.remove_modal_event_close.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.remove_modal_event_btn_offer.count ng-if=Devise.isMaster()><table class=c-event-table-wrap><tr><td><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.shokai_kabu_botankurikku' | translate }}</td><td>{{campaign_events_by_id.remove_modal_event_btn_offer.count | number}}</td><td>{{campaign_events_by_id.remove_modal_event_btn_offer.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=\"campaign_events_by_id.click_ccitem_show.count + campaign_events_by_id.click_ccitem_activate.count\"><table class=c-event-table-wrap><tr><td><i class=\"fa fa-hand-pointer-o\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.shouhin_rinku_wo' | translate }}</td><td>{{campaign_events_by_id.click_ccitem_show.count + campaign_events_by_id.click_ccitem_activate.count | number}}</td><td>{{(campaign_events_by_id.click_ccitem_show.count + campaign_events_by_id.click_ccitem_activate.count) / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=\"campaign_events_by_id.click_link_show.count + campaign_events_by_id.click_link_activate.count\"><table class=c-event-table-wrap><tr><td><i class=\"fa fa-hand-pointer-o\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.botanrinku_wo_kurikku' | translate }}</td><td>{{campaign_events_by_id.click_link_show.count + campaign_events_by_id.click_link_activate.count | number}}</td><td>{{(campaign_events_by_id.click_link_show.count + campaign_events_by_id.click_link_activate.count) / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.click_badge_activate.count><table class=c-event-table-wrap><tr><td><i class=\"fa fa-repeat\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.ofaabyuu_wo_sai' | translate }}</td><td>{{campaign_events_by_id.click_badge_activate.count + campaign_events_by_id.click_hint_activate.count | number}}</td><td>{{(campaign_events_by_id.click_badge_activate.count + campaign_events_by_id.click_hint_activate.count) / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.click_offer.count><table class=c-event-table-wrap><tr><td><i class=\"fa fa-mouse-pointer\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.click_offer' | translate }}</td><td>{{campaign_events_by_id.click_offer.count | number}}</td><td>{{campaign_events_by_id.click_offer.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=list-wrapper ng-show=campaign_events_by_id.show_presentview_activate.count><table class=c-event-table-wrap><tr><td>{{ 'projectsCampaignsViews.directives.campaignEvents.purezentobyuu_wo_hyouji' | translate }}</td><td>{{campaign_events_by_id.show_presentview_activate.count | number}}</td><td>{{campaign_events_by_id.show_presentview_activate.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_action.codebox.click><table class=c-event-table-wrap><tr><td><i class=\"fa fa-hand-pointer-o\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.kuuponkoodo_ran_wo' | translate }}</td><td>{{campaign_events_action.codebox.click}}</td><td>{{campaign_events_action.codebox.click / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.click_link_present.count><table class=c-event-table-wrap><tr><td><i class=\"fa fa-hand-pointer-o\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.botanrinku_wo_kurikku' | translate }}</td><td>{{campaign_events_by_id.click_link_present.count | number}}</td><td>{{campaign_events_by_id.click_link_present.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=\"list-wrapper list-second\" ng-show=campaign_events_by_id.click_badge_present.count><table class=c-event-table-wrap><tr><td><i class=\"fa fa-repeat\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.purezentobyuu_wo_sai' | translate }}</td><td>{{campaign_events_by_id.click_badge_present.count + campaign_events_by_id.click_hint_present.count | number}}</td><td>{{(campaign_events_by_id.click_badge_present.count + campaign_events_by_id.click_hint_present.count) / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div><div class=list-wrapper><table class=c-event-table-wrap><tr><td>{{ 'projectsCampaignsViews.directives.campaignEvents.jikangire' | translate }}</td><td>{{campaign_events_by_id.timeout.count | number}}</td><td>{{campaign_events_by_id.timeout.count / stats.experimental.delivery_count * 100 || 0 | number:2 }}%</td></tr></table></div></div><button ng-if=Devise.isMaster() class=\"btn btn-default btn-block\" ng-click=\"viewOptions.details = !viewOptions.details\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignEvents.shousai_ibento_wo' | translate }}</button><table class=table ng-if=Devise.isMaster() ng-show=viewOptions.details><thead><tr><th class=campaign-detail-table-title ng-click=\"setSortProp('predefined')\"></th><th class=sortable ng-click=\"setSortProp('count')\">{{ 'projectsCampaignsViews.directives.campaignEvents.sesshon_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('conversion_count')\">{{ 'projectsCampaignsViews.directives.campaignEvents.cv_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('conversion_rate')\">{{ 'projectsCampaignsViews.directives.campaignEvents.cvr' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"event in campaign_events\"><th>{{event.name}}</th><td>{{event.count | number}} <span class=\"badge badge-default\" ng-init=\"click_rate = event.count / stats.experimental.delivery_count\">{{ (click_rate > 1 ? 1 : click_rate) * 100 || 0 | number:2 }}%</span></td><td>{{event.conversion_count | number}} <span class=\"badge badge-default\" ng-init=\"conversion_rate = event.conversion_count / stats.experimental.conversion_count\">{{ (conversion_rate > 1 ? 1 : conversion_rate) * 100 || 0 | number:2 }}%</span></td><td>{{event.conversion_rate | number: 2}}%</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_filter.html';
var html = "<section class=\"controller campaign-filter\"><form name=campaignFilter><div class=controller-body><div class=\"controller-title controller-box\"><i class=\"fa fa-filter\"></i> <span>{{ 'projectsCampaignsViews.directives.campaignFilter.shiborikomi' | translate }}</span></div><div class=controller-box><input class=form_datepick datepick size=16 type=text max=selected.end_at date=selected.start_at required> <i class=\"fa fa-caret-down\" style=position:relative;right:9px></i></div><div class=controller-box style=color:#ccc>~</div><div class=controller-box><input class=form_datepick datepick size=16 type=text min=selected.start_at date=selected.end_at required> <i class=\"fa fa-caret-down\" style=position:relative;right:9px></i></div><div ng-hide=hideDevice class=controller-box><select id=device class=form-control style=\"width: 150px; margin: 5px;\" ng-model=selected.device ng-options=\"opt as opt.label for opt in devices\"></select></div><div ng-hide=hideCampaignSegmentId class=controller-box><select id=campaign_segment class=form-control style=\"width: 200px; margin: 5px;\" ng-model=selected.campaign_segment ng-options=\"opt as segmentNameFor(opt.id) for opt in campaign_segments\"></select></div><div ng-hide=hideSearchTerm class=controller-box><input type=text ng-model=selected.search_term style=\"width: 200px; margin: 5px;\" class=form-control placeholder=\"{{ 'projectsCampaignsViews.directives.campaignFilter.kyanpeen_na' | translate }}\"></div><div ng-show=showHiddenAbTestToggle class=\"controller-box btn-group\"><div class=\"btn btn-sm btn-default\" ng-class=\"{ 'active': !filters.include_hidden_ab_test }\" ng-click=\"filters.include_hidden_ab_test = !filters.include_hidden_ab_test\"><span>{{ 'projectsCampaignsViews.directives.campaignFilter.excludeHiddenABTest' | translate }}</span></div><div class=\"btn btn-sm btn-default\" ng-class=\"{ 'active': filters.include_hidden_ab_test }\" ng-click=\"filters.include_hidden_ab_test = !filters.include_hidden_ab_test\"><span>{{ 'projectsCampaignsViews.directives.campaignFilter.includeHiddenABTest' | translate }}</span></div></div><div class=\"btn-group controller-buttons\"><div class=\"btn btn-sm btn-primary filter\" ng-click=updateData()><span>{{ 'projectsCampaignsViews.directives.campaignFilter.oshibori_morikomu' | translate }}</span></div><div class=\"btn btn-sm btn-default\" ng-click=resetFilters()>{{ 'projectsCampaignsViews.directives.campaignFilter.risetto' | translate }}</div></div></div></form></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_graph.html';
var html = "<section class=graph ng-if=stats_for_chart.length><div class=row style=margin-bottom:10px;><div class=col-md-4><select ng-model=filters.campaign_graph_value style=\"min-width: 300px;\" ng-change=updateData() ng-options=\"opt as opt.label for opt in chartOptions track by opt.name\"></select></div><div class=col-md-8 graph-dimension-select dimension=filters.campaign_graph_dimension on-update=updateData()></div></div><div class=row ng-hide=stats_for_chart.length><div class=\"col-sm-12 text-center\"><h2>{{ 'projectsCampaignsViews.directives.campaignGraph.hyouji_surudeeta_ga' | translate }}</h2><p>{{ 'projectsCampaignsViews.directives.campaignGraph.taishou_kikan_ga' | translate }}</p></div></div><div id=chart3 ng-if=stats_for_chart.length><highchart id=chart1 config=chartConfig></highchart></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_groups.html';
var html = "<table class=table><thead><tr><th class=text-blue><span class=\"label group-exp\">{{ 'projectsCampaignsViews.directives.campaignGroups.hyouji_guruupu' | translate }}</span></th><th></th><th><span class=\"label group-ctl\">{{ 'projectsCampaignsViews.directives.campaignGroups.hihyouji_guruupu' | translate }}</span></th></tr></thead><tbody><tr><td class=text-blue>{{ stats.experimental.delivery_count || 0 | number:0 }} <span class=unit>{{ 'projectsCampaignsViews.directives.campaignGroups.sesshon' | translate }}</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.haishin_sesshon_kazu' | translate }}</th><td>{{ stats.control.delivery_count || 0 | number:0 }} <span class=unit>{{ 'projectsCampaignsViews.directives.campaignGroups.sesshon' | translate }}</span></td></tr><tr><td class=text-blue>{{ stats.experimental.average_dwell / 60000 || 0 | number:1 }} <span class=unit>{{ 'projectsCampaignsViews.directives.campaignGroups.fun' | translate }}</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.heikin_taizai_jikan' | translate }}</th><td>{{ stats.control.average_dwell / 60000 || 0 | number:1 }} <span class=unit>{{ 'projectsCampaignsViews.directives.campaignGroups.fun' | translate }}</span></td></tr><tr><td class=text-blue>{{ stats.experimental.average_history_count || 0 | number:2 }} <span class=unit>PV</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.heikin_peejibyuu' | translate }}</th><td>{{ stats.control.average_history_count || 0 | number:2 }} <span class=unit>PV</span></td></tr><tr><td class=text-blue>{{ stats.experimental.cart_through_rate * 100 || 0 | number:2 }} <span class=unit>%</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.kaatosuruu_ritsu' | translate }}</th><td>{{ stats.control.cart_through_rate * 100 || 0 | number:2 }} <span class=unit>%</span></td></tr><tr><td class=text-blue>{{ stats.experimental.cart_button_click_count }} <span class=\"badge badge-default\">{{ stats.experimental.cart_button_click_rate * 100 || 0 | number:2 }}%</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.kaatobotankurikku' | translate }}</th><td>{{ stats.control.cart_button_click_count }} <span class=\"badge badge-default\">{{ stats.control.cart_button_click_rate * 100 || 0 | number:2 }}%</span></td></tr><tr><td class=text-blue>{{ stats.experimental.conversion_count }} <span class=\"badge badge-default\">{{ stats.experimental.conversion_rate * 100 || 0 | number:2 }}%</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.konbaajon' | translate }}</th><td>{{ stats.control.conversion_count }} <span class=\"badge badge-default\">{{ stats.control.conversion_rate * 100 || 0 | number:2 }}%</span></td></tr><tr style=display:none><td class=text-blue>TODO</td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.kuupon_riyouritsu' | translate }}</th><td>-</td></tr><tr ng-if=!Project.isZenClerkLP()><td class=text-blue>{{ stats.experimental.average_conversion_price || 0 | zcCurrency : '' : currency.fractionSize }} <span class=unit>{{currency.suffix}}</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.heikin_konbaajon_kingaku' | translate }}</th><td>{{ stats.control.average_conversion_price || 0 | zcCurrency : '' : currency.fractionSize }} <span class=unit>{{currency.suffix}}</span></td></tr><tr ng-if=!Project.isZenClerkLP()><td class=text-blue>{{ stats.experimental.conversion_price || 0 | zcCurrency : '' : currency.fractionSize }} <span class=unit>{{currency.suffix}}</span></td><th>{{ 'projectsCampaignsViews.directives.campaignGroups.goukei_uriagekin_gaku' | translate }}</th><td>{{ stats.control.conversion_price || 0 | zcCurrency : '' : currency.fractionSize }} <span class=unit>{{currency.suffix}}</span></td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_incentive_list.html';
var html = "<div ng-repeat=\"incentive in campaign.incentives | filter: {'current_status':'!finished'}\"><span class=incentice-range><zc-date-range start-at=incentive.start_at end-at=incentive.end_at is-infinite=incentive.is_infinite display-time=false></zc-date-range></span><zc-incentive-status incentive=incentive></zc-incentive-status><span tooltip={{incentive.name}} ng-if=\"incentive.incentive_type === 'coupon_code'\">{{incentive.coupon_code}}</span> <span class=unique_coupon tooltip={{incentive.name}} ng-if=\"incentive.incentive_type === 'unique_coupon_code'\">{{ 'projectsCampaignsViews.directives.campaignIncentiveList.yuniikukuupon_houshiki' | translate }}</span> <span tooltip={{incentive.name}} ng-if=\"incentive.incentive_type === 'coupon_url'\">{{ 'projectsCampaignsViews.directives.campaignIncentiveList.rinku_shiki' | translate }}</span> <span tooltip={{incentive.name}} ng-if=\"incentive.incentive_type === 'generated_coupon_url'\">{{incentive.campaign_code}}</span> <a zc-master-only ui-sref=\"admin.projects.incentives.show({projectId: project.id, incentiveId: incentive.id})\"><i class=\"fa fa-external-link-square\" tooltip=\"{{ 'projectsCampaignsViews.directives.campaignIncentiveList.insentibumasutaa' | translate }}\"></i></a></div><div ng-if=\"!haveActiveIncentive(campaign) && campaign.incentives.length\" class=\"text-danger strong\"><i class=\"fa fa-exclamation-circle\"></i> {{ 'projectsCampaignsViews.directives.campaignIncentiveList.yuukou_nainsentibu_ga' | translate }}</div><div ng-if=!campaign.incentives.length><span class=notset>{{ 'projectsCampaignsViews.directives.campaignIncentiveList.misetsu_kyoutei' | translate }}</span></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_incentive_step.html';
var html = "<form name=incentiveForm><fieldset ng-disabled=\"campaign.current_status === 'terminated'\"><label style=\"margin-bottom: 16px;\" tooltip-html-unsafe=\"{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.insentibu_wo_riyou' | translate:{ br: '<br>' } }}\" tooltip-enable=\"campaign.requires_incentives && campaign.incentives.length > 0\" tooltip-append-to-body=true><input ng-model=campaign.requires_incentives ng-disabled=\"campaign.requires_incentives && campaign.incentives.length > 0\" type=checkbox> {{ 'projectsCampaignsViews.directives.campaignIncentiveStep.insentibu_wo_hissu' | translate }}</label><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignIncentiveStep.insentibu' | translate }} <span ng-if=\"filteredIncentives.length == 0\" class=small translate=projectsCampaignsViews.directives.campaignIncentiveStep.registerIncentiveFromHere translate-value-link=\"<a href='{{ incentiveRegistrationUrl }}' target='_blank'>{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.here' | translate }}</a>\"></span></h4><div class=row ng-if=\"campaign.delivery_type_option.id != 'complete_delivery'\"><div class=col-sm-8><div class=form-group><select class=form-control ng-options=\"incentive as incentive.name + incentive.example for incentive in filteredIncentives\" ng-model=selectedIncentive ng-disabled=\"filteredIncentives.length == 0\"><option>{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.shitei_nashi' | translate }}</option></select></div></div><div class=col-sm-2><button type=button class=\"btn btn-default\" ng-disabled=\"!selectedIncentive || filteredIncentives.length == 0 || !campaign.requires_incentives\" ng-click=add(selectedIncentive)><span tooltip-html-unsafe=\"{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.hidariue_no[insentibu_wo' | translate:{ br: '<br>' } }}\" tooltip-enable=!campaign.requires_incentives tooltip-append-to-body=true>{{ 'projectsCampaignsViews.directives.campaignIncentiveStep.insentibu_wo_tsuika' | translate }}</span></button></div></div><br><zc-campaign-incentive-table campaign=campaign shows-action=true></zc-campaign-incentive-table><zc-campaign-incentive-error campaign=campaign is-valid=isValid></zc-campaign-incentive-error><zc-campaign-incentive-warning campaign=campaign></zc-campaign-incentive-warning></div><zc-campaign-note note=incentive campaign=campaign mode=edit></zc-campaign-note></fieldset></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_incentive_table.html';
var html = "<div class=table-responsive ng-show=campaign.incentives.length><table class=\"table campaign-table table-bordered\"><thead><tr><th class=campaign-table-id>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.id' | translate }}</th><th class=campaign-table-status>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.suteetasu' | translate }}</th><th class=campaign-table-name>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.insentibu_na' | translate }}</th><th class=campaign-table-incentive>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.koodo' | translate }}</th><th class=campaign-table-date>{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.yuukoukigen' | translate }}</th><th class=campaign-table-action ng-if=showsAction></th></tr></thead><tbody><tr ng-repeat=\"incentive in campaign.incentives | orderBy:'-created_at'\"><td style=text-align:center>{{ incentive.id }}</td><td style=text-align:center><zc-incentive-status incentive=incentive></zc-incentive-status></td><td><a ui-sref=\"admin.projects.incentives.show({projectId: campaign.project_id, incentiveId: incentive.id})\">{{incentive.name}}</a></td><td><span ng-if=\"incentive.incentive_type === 'coupon_code'\"><zc-incentive-code incentive=incentive></zc-incentive-code></span> <span ng-if=\"incentive.incentive_type === 'coupon_url'\">pc: {{ incentive.pc_base_url }}<br>sp: {{ incentive.sp_base_url }}</span> <span ng-if=\"incentive.incentive_type === 'api_url'\">{{ incentive.api_url }}</span> <span ng-if=\"incentive.incentive_type === 'botbonnie_short_url'\">{{ incentive.botbonnie_short_url }}</span></td><td><zc-date-range start-at=incentive.start_at end-at=incentive.end_at is-infinite=incentive.is_infinite display-time=false></zc-date-range></td><td ng-if=showsAction><input type=button class=\"btn btn-xs btn-danger\" value=\"{{ 'projectsCampaignsViews.directives.campaignIncentiveTable.sakujo' | translate }}\" ng-click=remove(incentive)></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_interest_widget_event.html';
var html = "<table class=table zc-master-only><thead><tr><th class=campaign-detail-table-title ng-click=\"setSortProp('predefined')\"></th><th class=sortable ng-click=\"setSortProp('count')\">{{ 'projectsCampaignsViews.directives.campaignInterestWidgetEvent.sesshon_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('conversion_count')\">{{ 'projectsCampaignsViews.directives.campaignInterestWidgetEvent.cv_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('conversion_rate')\">{{ 'projectsCampaignsViews.directives.campaignInterestWidgetEvent.cvr' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"event in campaign_events\"><th>{{event.name}}</th><td>{{event.count | number}} <span class=\"badge badge-default\">{{ (iw_started_count ? event.count / iw_started_count : 0) * 100 || 0 | number:2 }}%</span></td><td>{{event.conversion_count | number}} <span class=\"badge badge-default\">{{ (iw_started_conversion_count ? event.conversion_count / iw_started_conversion_count : 0) * 100 || 0 | number:2 }}%</span></td><td>{{event.conversion_rate | number: 2}}%</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_list.html';
var html = "<div><table class=\"table campaign-table table-bordered\"><thead><tr><th class=campaign-table-id>{{ 'projectsCampaignsViews.directives.campaignList.id' | translate }}</th><th class=campaign-table-status>{{ 'projectsCampaignsViews.directives.campaignList.suteetasu' | translate }}</th><th style=width:350px>{{ 'projectsCampaignsViews.directives.campaignList.kyanpeen_na' | translate }}</th><th>{{ 'projectsCampaignsViews.directives.campaignList.segumento' | translate }}</th><th class=campaign-table-incentive>{{ 'projectsCampaignsViews.directives.campaignList.insentibu' | translate }}</th><th class=campaign-table-date>{{ 'projectsCampaignsViews.directives.campaignList.haishin_kikan' | translate }}</th></tr></thead><tbody><tr><td class=text-center>{{campaign.id}}</td><td><zc-campaign-status campaign=campaign></zc-campaign-status></td><td class=report-detail-list-name><div class=campaign-title><span campaign-device ng-model=campaign></span> {{ campaign.name }} <span ng-if=!campaign.name class=notset>{{ 'projectsCampaignsViews.directives.campaignList.meishou_misetsu_kyoutei' | translate }}</span> <span class=notset ng-show=Devise.isMaster()><i class=\"fa fa-lock\"></i> {{campaign.template_type}}</span></div></td><td><zc-campaign-segment-flag segment=campaign.segment ng-if=campaign.segment></zc-campaign-segment-flag><zc-label-clearance campaign=campaign></zc-label-clearance><span ng-if=!campaign.segment class=notset>{{ 'projectsCampaignsViews.directives.campaignList.misetsu_kyoutei' | translate }}</span><div ng-if=\"Devise.isMaster() && campaign.segment\" style=word-break:break-all;><a ui-sref=\"admin.projects.segments.show({projectId: project.id, segmentId: campaign.segment.id})\"><i class=\"fa fa-lock\"></i> {{campaign.segment.name}}</a></div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'conversion_prediction' && Devise.isMaster()\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignTableRow.conversion_prediction' | translate }}</div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'csv_upload' && Devise.isMaster()\"><span ng-if=!campaign.campaign_policy_set class=notset>{{ 'projectsCampaignsViews.directives.campaignTableRow.taimingu_misetsu_kyoutei' | translate }}</span> <a ui-sref=\"admin.master.projects.campaigns.segment({projectId: project.id, campaignId: campaign.id})\" ng-if=\"Devise.isMaster() && campaign.campaign_policy_set\"><i class=\"fa fa-lock\"></i> {{campaign.campaign_policy_set.name}}</a></div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'uplift_modeling' && Devise.isMaster()\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignTableRow.uplift_modeling' | translate }}</div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'immediate' && Devise.isMaster()\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignTableRow.immediate' | translate }}</div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'ai_model' && Devise.isMaster()\"><zc-campaign-arms-list campaign=campaign project=project></zc-campaign-arms-list></div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'sampling' && Devise.isMaster()\"><i class=\"fa fa-lock\"></i> {{ 'sampling_' + campaign.sampling_range.replace('%', '') }} ({{ campaign.sampling_score_threshold }})</div></td><td><zc-campaign-incentive-list campaign=campaign project=project></zc-campaign-incentive-list><zc-campaign-coupon-data filters=filters campaign=campaign project=project></zc-campaign-coupon-data></td><td><zc-campaign-range campaign=campaign></zc-campaign-range></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_moment_graph.html';
var html = "<div class=row><div class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsCampaignsViews.directives.campaignMomentGraph.moomento_ga_kenchisareru_made_no_jikan' | translate }}</h3></div><div class=panel-body><highchart config=campaignDwellConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsCampaignsViews.directives.campaignMomentGraph.yuuzaagasaito_ni_houmonsitekara_jikan' | translate }}</div></div></div><div class=col-md-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsCampaignsViews.directives.campaignMomentGraph.moomento_ga_kenchisareru_made_no_pv_suu' | translate }}</h3></div><div class=panel-body><highchart config=campaignHistoryCountConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsCampaignsViews.directives.campaignMomentGraph.yuuzaagasaito_ni_houmonsitekara_pv_suu' | translate }}</div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_navigator.html';
var html = "<div class=\"btn-group pull-right stepper\"><button class=\"btn btn-sm btn-primary pull-left\" ng-disabled=\"$state.current.name === 'admin.projects.campaigns.edit.base'\" ng-click=prevState()><i class=\"fa fa-chevron-circle-left\"></i> {{ 'projectsCampaignsViews.directives.campaignNavigator.modoru' | translate }}</button> <button class=\"btn btn-sm btn-primary pull-right\" ng-disabled=\"$state.current.name === 'admin.projects.campaigns.edit.confirm'\" ng-click=nextState()>{{ 'projectsCampaignsViews.directives.campaignNavigator.tsugi_e' | translate }} <i class=\"fa fa-chevron-circle-right\"></i></button></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_note.html';
var html = "<div style=\"margin-bottom: 15px\" ng-if=vm.campaign.notes_json[vm.note]><span ng-if=vm.compact ng-style=\"{ display: vm.isMultiline ? 'block' : 'inline', }\">{{ 'projectsCampaignsViews.directives.campaignNote.memo' | translate }}</span><h4 ng-if=!vm.compact class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignNote.memo' | translate }}</h4><b ng-if=\"vm.compact && !vm.isMultiline\">{{vm.campaign.notes_json[vm.note]}}</b><pre style=\"max-height: 400px; padding: 5px; white-space: pre-line;\" ng-if=\"!vm.compact || vm.isMultiline\">{{vm.campaign.notes_json[vm.note].slice(0, vm.maxCharacterLength)}}</pre></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_note_editor.html';
var html = "<div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignNoteEditor.memo' | translate }}</h4><div class=\"row clearfix\"><div class=form-group ng-class=vm.getTextareaClasses()><textarea ng-model-options=\"{allowInvalid: true}\" ng-maxlength=vm.maxCharacterLength class=form-control style=\"resize: vertical\" ng-model=vm.campaign.notes_json[vm.note]></textarea><div ng-if=vm.noteLength style=\"margin-top: 5px;\" class=element_discription><p ng-if=\"vm.noteLength <= vm.maxCharacterLength\" translate=projectsCampaignsViews.directives.campaignNoteEditor.noteLengthIndicator translate-value-notelength=\"{{ vm.noteLength }}\" translate-value-maxcharacterlength=\"{{ vm.maxCharacterLength }}\"></p><span ng-if=\"vm.noteLength > vm.maxCharacterLength\" translate=projectsCampaignsViews.directives.campaignNoteEditor.maximumNoteLengthExceeded translate-value-exceedsby=\"{{ vm.noteLength - vm.maxCharacterLength }}\"></span></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_notes.html';
var html = "<div class=col-md-12><div class=row style=\"margin-bottom: 20px;\" ng-repeat=\"(noteName, noteText) in vm.getNotes()\"><b>{{vm.translateNoteName(noteName)}}</b><pre ng-style=vm.textWrap style=\"max-height: 400px; padding: 5px; white-space: pre-line;\">{{noteText || '-'}}</pre></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_panels.html';
var html = "<div class=row><div ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\"><p class=text-center>{{ 'projectsCampaignsViews.directives.campaignPanels.haishin_sesshon_kazu' | translate }}</p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span class=text-blue>{{ stats.experimental.delivery_count || 0 | number:0 }}</span> <span class=unit>{{ 'projectsCampaignsViews.directives.campaignPanels.sesshon' | translate }}</span></p></div></div><div ng-if=isAb ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\"><p class=text-center>{{ 'projectsCampaignsViews.directives.campaignPanels.cvr_joushouritsu' | translate }}</p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span ng-if=\"stats.control.conversion_count > 0\" ng-class=\"{'text-blue': stats.conversion_up_rate > 0, 'text-bad': up_rate <= 0}\">{{ stats.conversion_up_rate * 100 || 0 | number:0 }}</span> <span ng-if=\"stats.control.conversion_count == 0\">-</span> <span class=unit>%</span></p></div></div><div ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\" ng-if=!isAb><p class=text-center><span>{{ 'projectsCampaignsViews.directives.campaignPanels.cvr' | translate }}</span></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span ng-if=\"stats.experimental.delivery_count > 0\" class=text-blue>{{ stats.experimental.conversion_rate * 100 || 0 | number: 1 }}</span> <span ng-if=\"stats.experimental.delivery_count == 0\">-</span> <span class=unit>%</span></p></div></div><div ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\" ng-if=\"!Project.isZenClerkLP() && !isAb\"><p class=text-center><span>{{ 'projectsCampaignsViews.directives.campaignPanels.cv_kingaku' | translate }}</span></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span class=text-blue>{{ stats.experimental.conversion_price || 0 | zcCurrency : '' : currency.fractionSize }}</span> <span class=unit>{{currency.suffix}}</span></p></div></div><div ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\" ng-if=\"Project.isZenClerkLP() && !isAb\"><p class=text-center><span>{{ 'projectsCampaignsViews.directives.campaignPanels.cv_kazu' | translate }}</span></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span class=text-blue>{{ stats.experimental.conversion_count || 0 | number : 0 }}</span> <span class=unit>CV</span></p></div></div><div ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\" ng-if=\"!Project.isZenClerkLP() && isAb\"><p class=text-center><span>{{ 'projectsCampaignsViews.directives.campaignPanels.kakutoku_kingaku' | translate }}</span> <i class=\"fa fa-question-circle\" tooltip=\"{{ 'projectsCampaignsViews.directives.campaignPanels.salesGeneratedAb' | translate }}\" tooltip-trigger=mouseenter></i></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span ng-class=\"{'text-blue': stats.contribution_price > 0, 'text-bad': contribution_price <= 0}\">{{ stats.contribution_price || 0 | zcCurrency : '' : currency.fractionSize }}</span> <span class=unit>{{currency.suffix}}</span></p></div></div><div ng-class=\"{'col-md-4': !Devise.isMaster(), 'col-md-3': Devise.isMaster() }\" ng-if=\"Project.isZenClerkLP() && isAb\"><p class=text-center><span>{{ 'projectsCampaignsViews.directives.campaignPanels.kakutoku_cv_suu' | translate }}</span> <i class=\"fa fa-question-circle\" tooltip=\"{{ 'projectsCampaignsViews.directives.campaignPanels.tesuto_ni_yori' | translate }}\" tooltip-trigger=mouseenter></i></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span ng-class=\"{'text-blue': stats.contribution_count > 0, 'text-bad': contribution_count <= 0}\">{{ stats.contribution_count || 0 | number : 0 }}</span> <span class=unit>CV</span></p></div></div><div class=col-md-3 ng-if=Devise.isMaster()><p class=text-center><span><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignPanels.seikyuu_kingaku' | translate }}</span> <span ng-if=\"campaign.cost_per_acquisition !== null\">{{ 'projectsCampaignsViews.directives.campaignPanels.cpa' | translate }} {{ campaign.cost_per_acquisition | number }} {{ currency.suffix }}</span></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span class=text-blue ng-if=\"campaign.cost_per_acquisition !== null\">{{ stats.invoice_amount || 0 | zcCurrency : '' : currency.fractionSize }}</span> <span ng-if=\"campaign.cost_per_acquisition === null\">-</span> <span class=unit>{{ currency.suffix }}</span></p></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_policy_step.html';
var html = "<form name=policyForm><fieldset ng-disabled=\"campaign.current_status === 'terminated'\"><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.haishin_shubetsu_wo' | translate }}</h4><div class=form-group><select class=form-control ng-options=\"delivery_type_option.name for delivery_type_option in campaign.available_delivery_type_options\" ng-model=campaign.delivery_type_option ng-disabled=\"campaign.is_coupon_campaign || isSavedInterestWidget\" required></select><div ng-if=campaign.is_coupon_campaign class=element_discription>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.kuuponkyanpeen_wa_haishin' | translate }}</div><div ng-if=isSavedInterestWidget class=element_discription>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.ichido_hozon_shita' | translate }}</div></div></div><div class=\"section clearfix\" ng-if=\"campaign.template.campaign_type !== 'Widget'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.kyanpeen_hihyouji_ritsu' | translate }}</h4><div class=\"panel panel-warning\" ng-show=campaign.was_activated_before><div class=panel-heading>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.sudeni_haishin_shitakotonoarukyanpeen' | translate }}</div></div><div class=form-group><div>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.hihyouji_ritsu' | translate }}: <input type=number min=0 max=100 required ng-model=campaign.campaign_control_percent> %<blockquote class=small><i>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.display' | translate }}: {{100 - campaign.campaign_control_percent}}%</i><br><i>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.non_display' | translate }}: {{campaign.campaign_control_percent || 0}}%</i></blockquote></div><div><button type=button class=\"btn btn-primary\" ng-click=setCampaignControlPercentToZero() ng-disabled=\"campaign.campaign_control_percent === 0\">{{ 'projectsCampaignsViews.directives.campaignPolicyStep.haishin_settei_ni' | translate }}</button></div></div><div class=form-group><div><label><input type=checkbox ng-model=campaign.is_secret_ab ng-disabled=\"campaign.campaign_control_percent === 0\"> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.tesuto_hihyouji' | translate }}</label></div></div><div class=element_discription><div ng-if=campaign.was_activated_before>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.kyanpeen_wa_haishin' | translate }}</div><div ng-if=campaign.is_secret_ab>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.kyanpeen_ichiran_nakaguro' | translate }}</div><div ng-if=\"campaign.campaign_control_percent === 0\">{{ 'projectsCampaignsViews.directives.campaignPolicyStep.konokyanpeenwahyakupaa' | translate }}</div><div ng-if=\"campaign.campaign_control_percent === 100\">{{ 'projectsCampaignsViews.directives.campaignPolicyStep.subete_no_yuuzaagakontorooruguruupu' | translate }}</div></div><div class=form-group ng-if=\"campaign.campaign_device !== 'app'\"><label>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.testingUnit' | translate }}</label><select class=form-control ng-options=\"testingUnit.name as testingUnit.label for testingUnit in availableTestingUnits\" ng-model=campaign.testing_unit ng-disabled=\"campaign.campaign_control_percent === 0\"></select></div></div><div class=\"section clearfix\" ng-if=\"campaign.delivery_type_option.id == 'ab_delivery'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.segumento_wo_sentaku' | translate }}</h4><div class=row><div class=col-md-5><section><div class=form-group><select class=form-control ng-options=\"cs.id as cs.id + ':' + cs.name for cs in campaign_segments\" ng-model=campaign.segment_id required></select></div></section></div><div class=col-md-7><div class=section ng-if=campaign.segment.id><zc-campaign-segment-table-brief segment=campaign.segment></zc-campaign-segment-table-brief></div></div></div><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.haishin_intaabaru_settei' | translate }}</h4><div class=form-group><span class=switch><input id=days_since_last_received_enabled ng-checked=days_since_last_received_enabled type=checkbox name=days_since_last_received_enabled ng-model=days_since_last_received_enabled ng-disabled=!campaign.is_coupon_campaign ng-click=toggleDaysSinceLastReceived()> <label for=days_since_last_received_enabled></label></span> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.do_not_deliver_again_received' | translate }} <input type=number min=1 ng-model=campaign.days_since_last_received ng-disabled=\"!campaign.is_coupon_campaign || !days_since_last_received_enabled\" auto-fill-sync>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.received_users' | translate }}</div><div class=form-group><span class=switch><input id=days_since_last_received_conversion_enabled ng-checked=days_since_last_received_conversion_enabled type=checkbox name=days_since_last_received_conversion_enabled ng-model=days_since_last_received_conversion_enabled ng-disabled=!campaign.is_coupon_campaign ng-click=toggleDaysSinceLastReceivedConversion()> <label for=days_since_last_received_conversion_enabled></label></span> {{ 'projectsCampaignsViews.directives.campaignPolicyStep.do_not_deliver_again_purchased' | translate }} <input type=number min=1 ng-model=campaign.days_since_last_received_conversion ng-disabled=\"!campaign.is_coupon_campaign || !days_since_last_received_conversion_enabled\" auto-fill-sync>{{ 'projectsCampaignsViews.directives.campaignPolicyStep.purchased_users' | translate }}</div><br></div><zc-campaign-note note=policy campaign=campaign mode=edit></zc-campaign-note></div></fieldset></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_range.html';
var html = "<span><span ng-if=campaign.start_at>{{ campaign.start_at | zcDate: { smart: true, dateOnly: dateOnly } }}</span> <span ng-if=!campaign.start_at>{{ 'projectsCampaignsViews.directives.campaignRange.misetsu_kyoutei' | translate }}</span><br>~ <span ng-if=campaign.end_at>{{ campaign.is_infinite ? ('projectsCampaignsViews.directives.campaignRange.kigen_nashi' | translate) : (campaign.end_at | zcDate: { smart: true, dateOnly: dateOnly }) }}</span> <span ng-if=!campaign.end_at>{{ 'projectsCampaignsViews.directives.campaignRange.misetsu_kyoutei' | translate }}</span></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_recent_segment_table.html';
var html = "<table class=\"table table-bordered table-striped table-condensed\"><tr><td>{{ 'projectsCampaignsViews.directives.campaignRecentSegmentTable.houmon_kazu' | translate }}</td><td>{{segment.session_count || 0}}</td></tr><tr><td>{{ 'projectsCampaignsViews.directives.campaignRecentSegmentTable.konbaajon_kazu' | translate }}</td><td>{{segment.conversion_count || 0}}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_schedule_step.html';
var html = "<form name=scheduleForm><fieldset ng-disabled=\"campaign.current_status === 'terminated'\"><section ng-if=\"campaign.delivery_type_option.id == 'complete_delivery'\"><div class=\"panel panel-warning\"><div class=panel-heading><div class=panel-title>{{ 'projectsCampaignsViews.directives.campaignScheduleStep.kono_iw_kyanpeen' | translate }}</div></div></div></section><section ng-if=is_start_at_before_today><div class=\"panel panel-warning\"><div class=panel-heading><div class=panel-title>{{ 'projectsCampaignsViews.directives.campaignScheduleStep.cannotStartBeforeToday' | translate }}</div></div></div></section><div class=row ng-if=\"campaign.delivery_type_option.id != 'complete_delivery'\"><div class=\"panel panel-warning\" ng-repeat=\"message in messages\"><div class=panel-heading><div class=panel-title>{{message}}</div></div></div><div class=col-md-12><div class=\"section schedule\"><h4><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignScheduleStep.haishin_kaishibi_toki' | translate }} <button class=\"btn btn-default\" ng-click=\"setToNow(campaign.start_at_obj, campaign.region)\">{{ 'projectsCampaignsViews.directives.campaignScheduleStep.ima' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"setToBeginningOfNextMonth(campaign.start_at_obj, campaign.region)\">{{ 'projectsCampaignsViews.directives.campaignScheduleStep.raigetsu_hatsu' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"setToBeginningOfNextNextMonth(campaign.start_at_obj, campaign.region)\">{{ 'projectsCampaignsViews.directives.campaignScheduleStep.saraigetsu_hatsu' | translate }}</button></h4><div date-time-picker ng-model=campaign.start_at_obj region=campaign.region product-line=campaign.project_product_line is-required=true></div></div><div class=section><h4><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignScheduleStep.tsugini_,_haishin' | translate }} <button class=\"btn btn-default\" ng-click=\"setToEndOfMonth(campaign.end_at_obj, campaign.region); setToFiniteCampaign()\">{{ 'projectsCampaignsViews.directives.campaignScheduleStep.getsumatsu' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"setToEndOfNextMonth(campaign.end_at_obj, campaign.region); setToFiniteCampaign()\">{{ 'projectsCampaignsViews.directives.campaignScheduleStep.raigetsumatsu' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"setToEndOfNextNextMonth(campaign.end_at_obj, campaign.region); setToFiniteCampaign()\">{{ 'projectsCampaignsViews.directives.campaignScheduleStep.saraigetsu_sue' | translate }}</button> <button class=\"btn btn-default\" style=\"display: inline-block\" ng-click=setToInfiniteCampaign() ng-disabled=!campaign.requires_incentives>{{ 'projectsCampaignsViews.directives.campaignScheduleStep.no_limit' | translate }}</button></h4><div ng-show=checkInfiniteCampaign()><h5>{{ 'projectsCampaignsViews.directives.campaignScheduleStep.no_limit' | translate }}</h5></div><div date-time-picker ng-show=!checkInfiniteCampaign() ng-model=campaign.end_at_obj region=campaign.region product-line=campaign.project_product_line is-required=true></div></div><zc-campaign-note note=schedule campaign=campaign mode=edit col-md=6></zc-campaign-note></div></div></fieldset></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_segment_flag.html';
var html = "<div class=zc-segment-flag><span class=\"badge label-segment-{{getSegmentType(segment)}}\"><i class=\"fa fa-user\"></i> {{typeText}}</span> <span ng-hide=short><span ng-if=hasExcludableConditions()>/</span> <span class=\"badge label-segment-custom\" ng-if=\"getSegmentType(segment) === 'custom_old' && Devise.isMaster()\" tooltip=\"{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.ko_no_segumento' | translate }}\">{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.kyuu_segumento_shiyou' | translate }}</span> <span class=\"badge label-segment-limit\" ng-if=\"segment.conditions_json.advertising == 'only'\">{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.koukoku_gentei' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=\"segment.conditions_json.advertising == 'exclude'\">{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.koukoku_jogai' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=segment.conditions_json.newsletter>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.merumaga_jogai' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=segment.conditions_json.logged_in>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.roguin_jogai' | translate }}</span> <span class=\"badge label-segment-limit\" ng-if=segment.conditions_json.target_regions>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.targetRegions' | translate }}</span> <span class=\"badge label-segment-limit\" ng-if=segment.conditions_json.limit_to_visitor_segments>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.limitToVisitorSegments' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=segment.conditions_json.exclude_visitor_segments>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.excludeVisitorSegments' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=segment.conditions_json.private_browsing>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.pb_jogai' | translate }}</span> <span class=\"badge label-segment-limit\" ng-if=hasValidLimitToLandingPageTypesCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.lp_gentei' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=hasValidExcludeLandingPageTypesCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.lp_jogai' | translate }}</span> <span class=\"badge label-segment-limit\" ng-if=hasValidLimitToSessionsWhoVisitCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.limitToSessionsWhoVisit' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=hasValidExcludeSessionsWhoVisitCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.excludeSessionsWhoVisit' | translate }}</span> <span class=\"badge label-segment-limit\" ng-if=hasValidLimitToOfferPageTypesCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.ofaa_gentei' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=hasValidExcludeOfferPageTypesCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.ofaa_jogai' | translate }}</span> <span class=\"badge label-segment-exclude\" ng-if=hasValidTriggersCondition()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.haishin_torigaa' | translate }}</span> <span class=\"badge label-segment-custom\" ng-if=hasAdditionalCustom()>{{ 'projectsCampaignsViews.directives.campaignSegmentFlag.sonohoka' | translate }}</span></span></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_segment_graph.html';
var html = "<div class=row><div class=col-md-6><div id=chart3><highchart config=sessionChartConfig></highchart></div></div><div class=col-md-6><div id=chart3><highchart config=conversionChartConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_segment_panels.html';
var html = "<div class=row><div class=col-md-6><p class=text-center><i class=\"fa fa-lock\"></i> <span>{{ 'projectsCampaignsViews.directives.campaignSegmentPanels.haishin_sesshon_kazusegumentosesshon' | translate }}</span></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span class=text-blue>{{campaign_stats.experimental.delivery_count || 0 | number:0}} / {{ access_stats.session_count || 0 | number:0 }}</span> <span class=unit>{{ 'projectsCampaignsViews.directives.campaignSegmentPanels.sesshon' | translate }}</span><br><span class=text-sm style=\"color: gray\">({{campaign_stats.experimental.delivery_count / access_stats.session_count * 100 || 0 | number : 2}} %)</span></p></div></div><div class=col-md-6><p class=text-center><i class=\"fa fa-lock\"></i> <span>{{ 'projectsCampaignsViews.directives.campaignSegmentPanels.haishin_taishou_uriage' | translate }}</span></p><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><span>{{campaign_stats.experimental.conversion_price || 0 | zcCurrency : '' : currency.fractionSize}} / {{ access_stats.conversion_price || 0 | zcCurrency : '' : currency.fractionSize }}</span> <span class=unit>{{currency.suffix}}</span><br><span class=text-sm style=\"color: gray\">({{campaign_stats.experimental.conversion_price / access_stats.conversion_price * 100 || 0 | number : 2}} %)</span></p></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_segment_summary.html';
var html = "<div class=row><div class=col-md-6><div><div class=col-md-4><div>{{ 'projectsCampaigns.directives.campaignSegmentSummary.deliverySegmentRate' | translate }}:</div><div><br></div><div>{{ 'projectsCampaigns.directives.campaignSegmentSummary.actualDeliveryRate' | translate }}:</div><div><br></div></div><div class=col-md-1><div>{{ campaign_segment_stats.session_count / access_stats.session_count * 100 || 0 | number:2 }}%</div><div><br></div><div>{{ campaign_stats.experimental.delivery_count / campaign_segment_stats.session_count * 100 || 0 | number:2 }}%</div><div><br></div></div><div class=col-md-7><div>({{ campaign_segment_stats.session_count || 0 | number:0 }} / {{ access_stats.session_count || 0 | number:0 }})</div><div>({{ 'projectsCampaigns.directives.campaignSegmentSummary.deliverySegmentRateExplain' | translate }})</div><div>({{ campaign_stats.experimental.delivery_count || 0 | number:0 }} / {{ campaign_segment_stats.session_count || 0 | number:0 }})</div><div>({{ 'projectsCampaigns.directives.campaignSegmentSummary.actualDeliveryRateExplain' | translate }})</div></div></div></div><div class=col-md-6></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_steps.html';
var html = "<ul class=\"nav nav-tabs nav-justified campaign-edit-nav\"><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.base'}\"><a ui-sref=admin.projects.campaigns.edit.base>{{ 'projectsCampaignsViews.directives.campaignSteps.kihon_settei' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=basicForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=basicForm.$valid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.incentive'}\"><a ui-sref=admin.projects.campaigns.edit.incentive>{{ 'projectsCampaignsViews.directives.campaignSteps.insentibu' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=incentiveForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-show=incentiveForm.$invalid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.template'}\"><a ui-sref=admin.projects.campaigns.edit.template>{{ 'projectsCampaignsViews.directives.campaignSteps.kurieitibu' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=templateForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=templateForm.$valid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.policy'}\"><a ui-sref=admin.projects.campaigns.edit.policy>{{ 'projectsCampaignsViews.directives.campaignSteps.segumento' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=policyForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=policyForm.$valid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.botbonnie'}\"><a ui-sref=admin.projects.campaigns.edit.botbonnie>{{ 'projectsCampaignsViews.directives.campaignSteps.bb_webchat' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=botbonnieForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=botbonnieForm.$valid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.timing'}\"><a ui-sref=admin.projects.campaigns.edit.timing>{{ 'projectsCampaignsViews.directives.campaignSteps.taimingu' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=timingForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=timingForm.$valid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.schedule'}\"><a ui-sref=admin.projects.campaigns.edit.schedule>{{ 'projectsCampaignsViews.directives.campaignSteps.sukejuuru' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=scheduleForm.$valid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=scheduleForm.$valid></i></a></li><li role=presentation ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.confirm'}\"><a ui-sref=admin.projects.campaigns.edit.confirm>{{ 'projectsCampaignsViews.directives.campaignSteps.settei_kakunin' | translate }} <i class=\"fa fa-check-circle step-complete\" ng-show=allValid></i> <i class=\"fa fa-check-circle step-incomplete\" ng-hide=allValid></i></a></li></ul><table class=\"table table-bordered hidden-xs hidden\"><tr><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.base'}\"><a ui-sref=admin.projects.campaigns.edit.base>{{ 'projectsCampaignsViews.directives.campaignSteps.kihon_settei' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=basicForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=basicForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.template'}\"><a ui-sref=admin.projects.campaigns.edit.template>{{ 'projectsCampaignsViews.directives.campaignSteps.kurieitibu' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=templateForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=templateForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.incentive'}\"><a ui-sref=admin.projects.campaigns.edit.incentive>{{ 'projectsCampaignsViews.directives.campaignSteps.insentibu' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=incentiveForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=incentiveForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.policy'}\"><a ui-sref=admin.projects.campaigns.edit.policy>{{ 'projectsCampaignsViews.directives.campaignSteps.segumento' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=policyForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=policyForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.timing'}\"><a ui-sref=admin.projects.campaigns.edit.timing>{{ 'projectsCampaignsViews.directives.campaignSteps.taimingu' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=timingForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=timingForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.schedule'}\"><a ui-sref=admin.projects.campaigns.edit.schedule>{{ 'projectsCampaignsViews.directives.campaignSteps.sukejuuru' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=scheduleForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=scheduleForm.$valid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td><td ng-class=\"{'active': $state.current.name == 'admin.projects.campaigns.edit.confirm'}\"><a ui-sref=admin.projects.campaigns.edit.confirm>{{ 'projectsCampaignsViews.directives.campaignSteps.settei_kakunin' | translate }}</a> <span class=\"label label-success pull-right\" ng-show=allValid>{{ 'projectsCampaignsViews.directives.campaignSteps.kanryou' | translate }}</span> <span class=\"label label-danger pull-right\" ng-hide=allValid>{{ 'projectsCampaignsViews.directives.campaignSteps.mikanryou' | translate }}</span></td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_table.html';
var html = "<table class=\"table campaign-table table-bordered\"><thead><tr><th style=\"width: 80px;\" class=campaign-table-id><label for=\"select-all-{{ vm.id }}\"><input id=\"select-all-{{ vm.id }}\" ng-if=canAddIncentive ng-model=vm.selected type=checkbox> {{ 'projectsCampaignsViews.directives.campaignTable.id' | translate }}</label></th><th ng-if=showActions class=campaign-table-status>{{ 'projectsCampaignsViews.directives.campaignTable.suteetasu' | translate }}</th><th class=campaign-table-name>{{ 'projectsCampaignsViews.directives.campaignTable.kyanpeen_na' | translate }}</th><th class=campaign-table-date>{{ 'projectsCampaignsViews.directives.campaignTable.haishin_kikan' | translate }}</th><th ng-if=showCampaignDetail class=campaign-table-segment>{{ 'projectsCampaignsViews.directives.campaignTable.segumento' | translate }}</th><th ng-if=showCampaignDetail class=campaign-table-incentive>{{ 'projectsCampaignsViews.directives.campaignTable.insentibu' | translate }}</th><th ng-if=\"showCampaignDetail && showClearanceSettings\">{{ 'projectsCampaignsViews.directives.campaignTable.kuriaransu' | translate }}</th><th ng-if=\"showStats && (isAb || hasHiddenAb && showHiddenAb)\">{{ 'projectsCampaignsViews.directives.campaignTable.guruupu' | translate }}</th><th ng-if=showStats class=text-right>{{ 'projectsCampaignsViews.directives.campaignTable.haishin_kazu' | translate }}</th><th ng-if=showStats class=campaign-table-cvrate>{{ 'projectsCampaignsViews.directives.campaignTable.cv_ritsu' | translate }} <i class=\"fa fa-info-circle\" style=\"font-size: 13px;\" tooltip-html-unsafe=\"{{ 'projectsCampaignsViews.directives.campaignTable.cvrTooltip' | translate }}\" tooltip-append-to-body=true></i></th><th ng-if=showStats>{{ 'projectsCampaignsViews.directives.campaignTable.cv_kazu' | translate }}</th><th ng-if=\"showStats && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa)\" translate=projectsCampaignsViews.directives.campaignTable.heikin_cv_kingaku translate-value-br=\"<br>\"></th><th ng-if=\"showStats && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa)\" translate=projectsCampaignsViews.directives.campaignTable.goukei_cv_kingaku translate-value-br=\"<br>\"></th><th ng-if=\"showStats && (isAb || hasHiddenAb && showHiddenAb)\" class=text-right translate=projectsCampaignsViews.directives.campaignTable.cv_joushouritsu translate-value-br=\"<br>\"></th><th ng-if=\"showStats && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa) && (isAb || hasHiddenAb && showHiddenAb)\" class=text-right>{{ 'projectsCampaignsViews.directives.campaignTable.kakutoku_kingaku' | translate }}</th><th ng-if=\"showStats && Project.isZenClerkLP() && (isAb || hasHiddenAb && showHiddenAb)\" class=text-right>{{ 'projectsCampaignsViews.directives.campaignTable.kakutoku_cv_suu' | translate }}</th><th ng-if=\"showControlPercent && (isAb || Devise.isMaster())\">{{ 'projectsCampaignsViews.directives.campaignTable.hihyouji_ritsu' | translate }}</th><th ng-if=\"showStats && canShowInvoiceAmount && Project.isZenClerkLP()\" class=text-right><i class=fa></i>{{ 'projectsCampaignsViews.directives.campaignTable.seikyuu_kingaku' | translate }}<br><small>({{ 'projectsCampaignsViews.directives.campaignTable.cpa' | translate }})</small></th><th ng-if=showActions class=campaign-table-action></th></tr></thead><tbody ng-repeat=\"campaign in pagedCampaigns | orderBy: ['campaign_status', '-id']\" campaign-table-row project=project campaign=campaign filters=filters show-actions=showActions show-list=showList show-stats=showStats show-campaign-detail=showCampaignDetail show-control-percent=showControlPercent show-clearance-settings=showClearanceSettings can-show-invoice-amount=canShowInvoiceAmount is-ab=isAb show-hidden-ab=showHiddenAb has-hidden-ab=hasHiddenAb on-update=onUpdate()></tbody><tbody ng-if=\"campaigns.length == 0\"><tr><td colspan=\"{{ isAb ? 13 : 10 }}\" class=text-center>{{ 'projectsCampaignsViews.directives.campaignTable.gaitou_surukyanpeen_ga' | translate }}</td></tr></tbody></table><pagination class=pull-right total-items=campaigns.length items-per-page=pagination.itemsPerPage ng-model=pagination.currentPage ng-change=pageChanged() ng-if=\"campaigns.length > pagination.itemsPerPage\"></pagination>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_table_row.html';
var html = "<tr><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\"><div ng-if=canAddIncentive><label for=\"checkbox-{{ campaign.id }}\"><input id=\"checkbox-{{ campaign.id }}\" type=checkbox ng-model=campaign.selected> {{ campaign.id }}</label></div><div ng-if=!canAddIncentive>{{ campaign.id }}</div></td><td class=text-center rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=showActions><zc-campaign-status campaign=campaign></zc-campaign-status><campaign-check-status campaign=campaign></campaign-check-status></td><td class=report-detail-list-name rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\"><span campaign-device ng-model=campaign></span><zc-label-clearance campaign=campaign></zc-label-clearance><a ui-sref=\"admin.projects.campaigns.show.stats({projectId: campaign.project_id, campaignId: campaign.id})\">{{ campaign.name }} <span ng-if=!campaign.name>{{ 'projectsCampaignsViews.directives.campaignTableRow.meishou_misetsu_kyoutei' | translate }}</span> <span class=notset ng-show=isMaster><i class=\"fa fa-lock\"></i> {{campaign.template_type}} ({{ campaign.element.id }})</span></a></td><td ng-if=showEnabledIw colspan=\"{{ showStats ? 9 : 4 }}\" rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\">{{ 'projectsCampaignsViews.directives.campaignTableRow.haishin_jisseki_no' | translate }}</td><td ng-if=!showEnabledIw rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\"><zc-campaign-range campaign=campaign></zc-campaign-range></td><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=\"showCampaignDetail && !showEnabledIw\"><zc-campaign-segment-flag segment=campaign.segment ng-if=campaign.segment></zc-campaign-segment-flag><span ng-if=!campaign.segment class=notset>{{ 'projectsCampaignsViews.directives.campaignTableRow.segumento_misetsu_kyoutei' | translate }}</span><div style=word-break:break-all;><a ui-sref=\"admin.projects.segments.show({projectId: project.id, segmentId: campaign.segment.id})\" ng-if=\"isMaster && campaign.segment\"><i class=\"fa fa-lock\"></i> {{campaign.segment.name}}</a></div><div style=word-break:break-all; ng-if=\"isMaster && campaign.configuration_type === 'conversion_prediction'\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignTableRow.conversion_prediction' | translate }}</div><div style=word-break:break-all; ng-if=\"campaign.configuration_type === 'csv_upload'\"><span ng-if=!campaign.campaign_policy_set class=notset>{{ 'projectsCampaignsViews.directives.campaignTableRow.taimingu_misetsu_kyoutei' | translate }}</span> <a ui-sref=\"admin.master.projects.campaigns.segment({projectId: project.id, campaignId: campaign.id})\" ng-if=\"isMaster && campaign.campaign_policy_set\"><i class=\"fa fa-lock\"></i> {{campaign.campaign_policy_set.name}}</a></div><div style=word-break:break-all; ng-if=\"isMaster && campaign.configuration_type === 'uplift_modeling'\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignTableRow.uplift_modeling' | translate }}</div><div style=word-break:break-all; ng-if=\"isMaster && campaign.configuration_type === 'immediate'\"><i class=\"fa fa-lock\"></i> {{ 'projectsCampaignsViews.directives.campaignTableRow.immediate' | translate }}</div><div style=word-break:break-all; ng-if=\"isMaster && campaign.configuration_type === 'ai_model'\"><zc-campaign-arms-list campaign=campaign project=project></zc-campaign-arms-list></div><div style=word-break:break-all; ng-if=\"isMaster && campaign.configuration_type === 'sampling'\"><i class=\"fa fa-lock\"></i> {{ 'sampling_' + campaign.sampling_range.replace('%', '') }} ({{ campaign.sampling_score_threshold }})</div></td><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=\"showCampaignDetail && !showEnabledIw\"><zc-campaign-incentive-list campaign=campaign project=project></zc-campaign-incentive-list><zc-campaign-coupon-data filters=filters campaign=campaign project=project></zc-campaign-coupon-data><zc-campaign-coupon-applicable-rate filters=filters campaign=campaign project=project></zc-campaign-coupon-applicable-rate></td><td ng-if=\"showClearanceSettings && showCampaignDetail && !showEnabledIw\"><span ng-if=!clearanceItemSet.name class=notset>{{ 'projectsCampaignsViews.directives.campaignTableRow.misetsu_kyoutei' | translate }}</span> <a ng-if=clearanceItemSet.name ui-sref=\"admin.projects.campaigns.show.clearance({projectId: project.id, campaignId: campaign.id})\">{{ clearanceItemSet.name }}</a></td><td ng-if=\"showStats && !showEnabledIw && (isAb || hasHiddenAb && showHiddenAb)\" class=campaign-table-stats><span class=\"label group-exp\">{{ 'projectsCampaignsViews.directives.campaignTableRow.hyouji' | translate }}<span ng-if=\"campaign.campaign_control_percent && (!campaign.is_secret_ab || showHiddenAb)\">: {{ 100 - campaign.campaign_control_percent }}%</span></span> <i tooltip=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.subete_no_haishin' | translate }}\" class=\"fa fa-info-circle\" ng-if=\"campaign.campaign_control_percent == 0 || campaign.is_secret_ab && !showHiddenAb\"></i></td><td class=\"text-right text-blue campaign-table-stats\" ng-if=\"showStats && !showEnabledIw\">{{ campaign.stats.experimental.delivery_count || 0 | number:0 }}</td><td class=\"text-right text-blue campaign-table-stats\" ng-if=\"showStats && !showEnabledIw\">{{ campaign.stats.experimental.conversion_rate * 100 || 0 | number:1 }} <span class=unit>%</span></td><td class=\"text-right text-blue campaign-table-stats\" ng-if=\"showStats && !showEnabledIw\">{{ campaign.stats.experimental.conversion_count || 0 | number:0 }} <i ng-if=\"campaign.campaign_control_percent && (!campaign.is_secret_ab || showHiddenAb)\" class=\"fa fa-info-circle\" aria-hidden=true tooltip=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.estimatedCvForNonDisplayGroup' | translate: { displayDeliveryCount: (campaign.stats.experimental.delivery_count || 0 | number: 0), nonDisplayCvr: (campaign.stats.control.conversion_rate * 100 || 0 | number: 1), result: (campaign.stats.control.conversion_rate * campaign.stats.experimental.delivery_count || 0 | number: 0), } }}\" tooltip-placement=right></i></td><td class=\"text-right text-blue\" ng-if=\"showStats && !showEnabledIw && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa)\">{{ campaign.stats.experimental.average_conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</td><td class=\"text-right text-blue\" ng-if=\"showStats && !showEnabledIw && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa)\">{{ campaign.stats.experimental.conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }} <i ng-if=project.enable_multiple_currencies class=\"fa fa-info-circle\" tooltip=\"{{ campaign.stats.experimental.original_conversions_string }}\"></i></td><td ng-if=\"showStats && !showEnabledIw && (isAb || hasHiddenAb && showHiddenAb)\" rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" class=campaign-table-stats><span class=contribution><span ng-if=\"campaign.campaign_control_percent == 0 || campaign.campaign_control_percent && campaign.is_secret_ab && !showHiddenAb\">-</span> <span ng-if=\"campaign.stats.control.conversion_count > 0 && (!isNoControlGroupCampaign || campaign.campaign_control_percent && campaign.is_secret_ab && showHiddenAb)\" ng-class=\"{'text-blue': campaign.stats.conversion_up_rate > 1,'text-bad':campaign.stats.conversion_up_rate < 1}\">{{ campaign.stats.conversion_up_rate * 100 || 0 | number:0 }}</span> <span class=unit>%</span><div ng-if=\"!chisq_test && !isNoControlGroupCampaign\" class=chisq><i tooltip=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.haishin_kazu_ga' | translate }}\" class=\"fa fa-exclamation-circle\"></i></div></span></td><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=\"showStats && !showEnabledIw && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa) && (isAb || hasHiddenAb && showHiddenAb)\"><span class=contribution><span ng-class=\"{'text-blue': campaign.stats.contribution_price > 1,'text-bad':campaign.stats.contribution_price < 1}\" ng-if=\"!isNoControlGroupCampaign || campaign.campaign_control_percent && campaign.is_secret_ab && showHiddenAb\">{{ campaign.stats.contribution_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</span> <span class=text-bad ng-if=\"campaign.campaign_control_percent == 0 || campaign.campaign_control_percent && campaign.is_secret_ab && !showHiddenAb\">-</span> <span style=\"display: block;\" ng-show=isMaster ng-if=\"project.fee_rate !== campaign.fee_rate\"><i tooltip-html-unsafe=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_no_tesuuryou' | translate:{ campaignfeerate: campaign.fee_rate, projectfeerate: project.fee_rate, br: '<br>' } }}\" class=\"fa fa-exclamation-circle\" style=color:#ffbb8f;></i></span></span></td><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=\"showStats && Project.isZenClerkLP() && !showEnabledIw && (isAb || hasHiddenAb && showHiddenAb)\"><span><span class=contribution><span ng-if=\"campaign.campaign_control_percent !== 0 && (!campaign.is_secret_ab || showHiddenAb)\" ng-class=\"{'text-blue': campaign.stats.contribution_count,'text-bad': !campaign.stats.contribution_count}\">{{ campaign.stats.contribution_count || 0 | number:0 }}</span> <span ng-if=\"campaign.campaign_control_percent == 0 || campaign.is_secret_ab && !showHiddenAb\" class=text-bad>-</span> <span class=unit>CV</span></span></span></td><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=\"showControlPercent && (isAb || Devise.isMaster())\"><zc-campaign-control-percent-labels ng-if=!isNoControlGroupCampaign campaign=campaign></zc-campaign-control-percent-labels><span zc-master-only ng-if=campaign.is_secret_ab class=\"label label-success\"><span class=\"fa fa-lock\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.ab_tesuto_hihyouji' | translate }}</span></td><td rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\" ng-if=\"showStats && canShowInvoiceAmount && Project.isZenClerkLP() && !showEnabledIw\"><span class=contribution><span class=text-blue ng-if=\"campaign.cost_per_acquisition !== null\">{{ campaign.stats.invoice_amount || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</span> <span ng-if=\"campaign.cost_per_acquisition === null\">-</span><br><small ng-if=\"campaign.cost_per_acquisition !== null\">({{ campaign.cost_per_acquisition | number | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}})</small></span></td><td ng-if=showActions class=campaign-table-actions rowspan=\"{{ isAb || campaign.campaign_control_percent && showHiddenAb ? 2 : 1 }}\"><div class=\"btn-group btn-group-sm\" dropdown><button ng-if=isV1 zc-master-only tooltip=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wo_henshuu_masutaa' | translate }}\" tooltip-append-to-body=true type=button class=\"btn btn-xs btn-default\" ng-click=\"goToEdit('confirm')\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=!isV1 zc-master-only tooltip=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wo_henshuu_dekinai' | translate }}\" tooltip-append-to-body=true type=button ng-class=\"{ 'disabled': !isV1 }\" class=\"btn btn-xs btn-default\"><span class=\"fa fa-pencil\"></span></button><button ng-if=!isMaster tooltip=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.cv_data_wo_daunroodo' | translate }}\" tooltip-append-to-body=true type=button class=\"btn btn-xs btn-default\" ng-csv=getCSV() filename={{getFileName()}} add-bom=true charset=utf-16 field-separator=\\t><span class=\"fa fa-download\"></span></button> <button type=button class=\"btn btn-xs btn-default dropdown-toggle\" dropdown-toggle ng-click=fetchGithubUrl()><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"admin.projects.campaigns.show.creative({projectId: campaign.project_id, campaignId: campaign.id })\"><span class=\"fa fa-picture-o\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.kurieitibu_e_idou' | translate }}</a></li><li><a ui-sref=\"admin.projects.campaigns.show.segment({projectId: campaign.project_id, campaignId: campaign.id })\"><span class=\"fa fa-users\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.segumento_e_idou' | translate }}</a></li><li zc-master-only><a href=# ng-csv=getCSV() filename={{getFileName()}} add-bom=true charset=utf-16 field-separator=\\t><span class=\"fa fa-download\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.cv_data_wo_daunroodo' | translate }}</a></li><li><a href={{previewUrl}} target=_blank><span class=\"fa fa-chrome\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.campaignPreview' | translate }}</a></li><li ng-if=canGoPreview><a href=# confirm-click=goPreview() confirm-modal><span class=\"fa fa-lock\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.purebyuuni_modosu' | translate }}</a></li><li ng-if=canGoIncomplete><a href=# confirm-click=goIncomplete() confirm-modal><span class=\"fa fa-lock\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.misetsu_kyoutei_ni' | translate }}</a></li><li role=separator class=divider></li><li zc-master-only tooltip=\"{{ 'projectsCampaigns.campaignEditLogTooltip' | translate }}\" tooltip-enable=\"{{ !githubUrl }}\" append-to-body><a href=\"{{ githubUrl || '#' }}\" ng-class=\"{ 'disabled': !githubUrl }\" target=\"{{ githubUrl ? '_blank' : '_self' }}\"><span class=\"fa fa-lock\"></span> {{ 'projectsCampaigns.campaignEditLog' | translate }}</a></li><li zc-master-only><a href=# ng-click=copy()><span class=\"fa fa-lock\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wo_kopii' | translate }}</a></li><li><a href=# ng-class=\"{'disabled': !canToggleActive}\" tooltip-enable={{!canToggleActive}} tooltip-html-unsafe=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wa_haishinchuu_dewanaitame_pause' | translate:{ br: '<br>' } }}\" tooltip-append-to-body=true confirm-click=toggleActive() confirm-modal><span class=fa ng-class=\"{ 'fa-ban': !canToggleActive, 'fa-pause-circle': campaign.current_status == 'active', 'fa-play-circle': campaign.current_status == 'blocked' }\"></span> <span ng-if=\"campaign.current_status == 'active' || !canToggleActive\">{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wo_ichijiteishi' | translate }}</span> <span ng-if=\"campaign.current_status == 'blocked'\">{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wo_saikai' | translate }}</span></a></li><li><a href=# ng-class=\"{'disabled': !canFinish}\" tooltip-enable={{!canFinish}} tooltip-html-unsafe=\"{{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wa_haishinchuu_dewanaitame_terminate' | translate:{ br: '<br>' } }}\" tooltip-append-to-body=true confirm-click=finish() confirm-modal><span class=fa ng-class=\"{ 'fa-ban': !canToggleActive, 'fa-stop-circle': canToggleActive, }\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.kyanpeen_wo_tsuujou' | translate }}</a></li><li ng-if=canDestroy><a href=# confirm-click=destroy() confirm-modal={{destroyConfirmMessage}}><span class=\"fa fa-lock\"></span> {{ 'projectsCampaignsViews.directives.campaignTableRow.sakujo' | translate }}</a></li></ul></div></td></tr><tr ng-if=\"showStats && !showEnabledIw && campaign.campaign_control_percent && (!campaign.is_secret_ab || showHiddenAb)\"><td class=campaign-table-stats><span class=\"label group-ctl\">{{ 'projectsCampaignsViews.directives.campaignTableRow.hihyouji' | translate }}<span ng-if=\"campaign.campaign_control_percent && (!campaign.is_secret_ab || showHiddenAb)\">: {{ campaign.campaign_control_percent }}%</span></span></td><td class=\"text-right campaign-table-stats\" ng-if=showStats>{{ campaign.stats.control.delivery_count || 0 | number:0 }}</td><td class=\"text-right campaign-table-stats\" ng-if=showStats>{{ campaign.stats.control.conversion_rate * 100 || 0 | number:1 }} <span class=unit>%</span></td><td class=\"text-right campaign-table-stats\" ng-if=showStats>{{ campaign.stats.control.conversion_count || 0 | number:0 }}</td><td class=text-right ng-if=\"showStats && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa)\">{{ campaign.stats.control.average_conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</td><td class=text-right ng-if=\"showStats && (!Project.isZenClerkLP() || project.show_contribution_price_on_cpa)\">{{ campaign.stats.control.conversion_price || 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }} <i ng-if=project.enable_multiple_currencies class=\"fa fa-info-circle\" tooltip=\"{{ campaign.stats.control.original_conversions_string }}\"></i></td></tr>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_template_item.html';
var html = "<div ng-if=\"item.type === 'image'\" ng-controller=NewImageCtrl ng-init=\"message = campaign.element.message; itemName = item.name\" flow-init=\"{target: '/upload'}\" flow-files-submitted=$flow.upload() flow-file-success=\"$file.msg = $message\" flow-drop flow-file-added=!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()] flow-attrs=\"{accept:'image/*'}\" ng-style=style><div class=mb10><img ng-src={{campaign.element.message[item.name]}} class=campaign-element-item-image></div><button type=button class=\"btn btn-default btn-sm btn-default col-sm-4\" flow-btn ng-disabled={{disabled}}><i class=\"glyphicon glyphicon-upload\"></i> <span class=\"hidden-sm hidden-xs\">{{ 'projectsCampaignsViews.directives.campaignTemplateItem.upload' | translate }}</span></button><input type=file style=\"visibility:hidden; position:absolute;\"> <button type=button class=\"btn btn-default btn-sm btn-default col-sm-offset-1 col-sm-7\" ng-click=browseImages(item.name) ng-disabled={{disabled}}><i class=\"glyphicon glyphicon-th\"></i> <span class=\"hidden-sm hidden-xs\">{{ 'projectsCampaignsViews.directives.campaignTemplateItem.browse' | translate }}</span></button> <input type=hidden name=elements.{{item.name}} ng-model=campaign.element.message[item.name] ng-required=item.required ng-disabled={{disabled}}><br><br><span class=\"small notset\">{{ 'projectsCampaignsViews.directives.campaignTemplateItem.sizeHint' | translate: { width: campaign.campaign_device == 'pc' ? 800 : 560, height: campaign.campaign_device == 'devicefree' ? 560 : 400, size: 100, } }}</span></div><div ng-if=\"item.type === 'string'\"><input class=form-control type=text name={{item.name}} placeholder=\"{{item.placeholder | translate}}\" ng-required=item.required ng-model=campaign.element.message[item.name] ng-model-options=\"{debounce: 500}\" auto-fill-sync ng-disabled={{disabled}}></div><div ng-if=\"item.type === 'page-type-selector'\"><page-type-selector page-types=campaign.element.message[item.name] item=item disabled=disabled></page-type-selector></div><div ng-if=\"item.type === 'color'\"><div class=row><div class=col-sm-12><div class=input-group><input class=\"form-control u-color-picker\" type={{item.type}} ng-model=campaign.element.message[item.name] ng-model-options=\"{ debounce: 500 }\" auto-fill-sync ng-disabled={{disabled}}> <input class=form-control colorpicker=hex type=text name={{item.name}} style=\"display: table-cell; width: 174px;\" ng-model=campaign.element.message[item.name] ng-required=item.required ng-model-options=\"{debounce: 500}\" auto-fill-sync ng-disabled={{disabled}}></div></div></div></div><div ng-if=\"item.type === 'textarea'\"><textarea name={{item.name}} class=form-control ng-model=campaign.element.message[item.name] ng-required=item.required ng-model-options=\"{debounce: 500}\" ng-disabled={{disabled}}>\n  </textarea></div><div ng-if=\"item.type === 'boolean'\"><div class=switch><input id=cb-{{item.name}} checked type=checkbox name={{item.name}} ng-model=campaign.element.message[item.name] ng-disabled={{disabled}}> <label for=cb-{{item.name}}></label></div></div><div ng-if=\"item.type === 'select'\"><select class=form-control ng-options=\"option.value as option.label | translate for option in item.options\" ng-model=campaign.element.message[item.name] ng-disabled={{disabled}}></select></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_template_setting.html';
var html = "<h4>{{ 'projectsCampaignsViews.directives.campaignTemplateSetting.tenpureeto_settei' | translate }}</h4><table class=\"table table-bordered campaign-settings-table\"><tbody><tr ng-repeat=\"item in campaign.template.template\"><th ng-if=!item.hidden>{{item.label}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip={{item.description}} tooltip-trigger=mouseenter tooltip-placement=top></i></th><td ng-if=!item.hidden class=wordbreak><div ng-if=\"item.type === 'color'\"><span class=color-block style=background-color:{{campaign.element.message[item.name]}}></span> {{campaign.element.message[item.name]}}</div><img ng-src={{campaign.element.message[item.name]}} ng-if=\"item.type === 'image'\" class=\"img-responsive img-bordered\"> <span ng-if=\"item.type !== 'image' && item.type !== 'color'\">{{campaign.element.message[item.name]}}</span></td></tr></tbody></table><div><a ng-click=\"viewOptions.details = !viewOptions.details\" class=campaign-settings-detail-show><i class=\"fa fa-bars\"></i> {{ 'projectsCampaignsViews.directives.campaignTemplateSetting.shousai_na_settei' | translate }}</a><table class=\"table table-bordered campaign-settings-table\" ng-if=viewOptions.details><tbody><tr ng-repeat=\"item in campaign.template.template\"><th ng-if=item.hidden>{{item.label}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip={{item.description}} tooltip-trigger=mouseenter tooltip-placement=top></i></th><td ng-if=item.hidden><img ng-src={{campaign.element.message[item.name]}} ng-if=\"item.type === 'image'\"> <span ng-if=\"item.type !== 'image'\">{{campaign.element.message[item.name]}}</span></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_template_step.html';
var html = "<form name=templateForm class=form-height-100><fieldset ng-disabled=\"campaign.current_status === 'terminated'\"><div class=row><input type=hidden required ng-model=campaign.template><div class=\"template-chooser col-md-12\" ng-hide=\"campaign.template && !choosingTemplate\"><h3>{{ 'projectsCampaignsViews.directives.campaignTemplateStep.tenpureeto_wo_sentaku' | translate }}</h3><ul class=templates><li ng-repeat=\"template in templates | device:campaign.campaign_device track by $index\" ng-click=chooseTemplate(template) class=list-unstyled><div class=template-title>{{template.label | translate}}</div><div class=template-img-wrapper><div class=template-img-wrapper-cell><img ng-src={{template.image}}></div></div><div class=template-description>{{template.description | translate}}</div></li></ul></div></div><div class=selected-template-outer ng-hide=choosingTemplate><div class=row><div class=col-md-4><section class=selected-template><h3>{{campaign.template.label | translate}}{{ 'projectsCampaignsViews.directives.campaignTemplateStep.tenpureeto' | translate }}</h3><div class=template-img-wrapper><div class=template-img-wrapper-cell><img ng-src={{campaign.template.image}}></div><button class=\"btn btn-default btn-sm reselect-template\" ng-click=\"choosingTemplate=true\">{{ 'projectsCampaignsViews.directives.campaignTemplateStep.tenpureeto_wo_henkou' | translate }}</button></div></section></div><div class=col-md-8><section class=option-common ng-if=\"hasOptionType('common')\"><h3>{{ 'projectsCampaignsViews.directives.campaignTemplateStep.zentai_settei' | translate }} <button class=\"btn btn-danger pull-right\" ng-click=setDefault()>{{ 'projectsCampaignsViews.directives.campaignTemplateStep.kurieitibu_settei_wo' | translate }}</button></h3><div class=row><div ng-repeat=\"item in campaign.template.template\" ng-if=\"item.option_category === 'common'\" class=col-md-6><div class=option-item ng-init=\"viewOptions = { details: false }\"><label for={{item.name}} class=option-title ng-if=item.label>{{item.label | translate}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip=\"{{ item.description | translate }}\" tooltip-trigger=mouseenter tooltip-placement=top></i></label><campaign-template-item campaign=campaign item=item disabled=false></campaign-template-item></div></div></div></section></div></div><section ng-repeat=\"view in campaign.template.views\" class=\"option-{{view.class}} zc\" ng-if=hasOptionType(view.class)><h3>{{view.name | translate}}: {{ 'projectsCampaignsViews.directives.campaignTemplateStep.settei_koumoku' | translate }}</h3><div class=row><div class=col-md-8><campaign-dynamic-view campaign=campaign form=templateForm view-class={{view.class}}></campaign-dynamic-view></div><div class=col-md-4><div class=option-wrapper><div ng-repeat=\"item in campaign.template.template\" ng-if=\"item.option_category === view.class\" class=item-margin><div ng-hide=\"hideModalTemplateConfigItem(item) || hideCodeIncentiveConfigItem(item) || hideTimerConfigItem(item) || Campaign.hideBadgeConfigItem(item, campaign) || Campaign.hideCodeLabelConfigItem(item, campaign)\" class=option-item><label for={{item.name}} class=option-title ng-if=item.label>{{item.label | translate}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip=\"{{item.description | translate}}\" tooltip-trigger=mouseenter tooltip-placement=top></i></label><p ng-if=showCouponBaseUrlHint(item) class=\"small notset\">{{ 'projectsCampaignsViews.directives.campaignTemplateItem.couponBaseUrlHint' | translate: { placeholder: '\\{\\{coupon_base_url\\}\\}' } }}</p><campaign-template-item campaign=campaign item=item disabled=false></campaign-template-item></div></div></div></div></div></section><section class=custom-css ng-if=\"campaign.campaign_device !== 'app'\"><div class=\"memo custom-css\" ng-animate><div><h3>{{ 'projectsCampaignsViews.directives.campaignTemplateStep.kasutamu' | translate }}</h3><textarea type=text class=form-control ng-model=campaign.custom_css>\n            </textarea></div></div></section><section class=option-other ng-if=\"hasOptionType('other')\"><h3>{{ 'projectsCampaignsViews.directives.campaignTemplateStep.shousaisettei' | translate }}</h3><div class=\"selected-template-options row parent\"><div ng-repeat=\"item in campaign.template.template\" ng-if=\"item.option_category === 'other'\" class=\"child col-md-3\"><div class=option-item><label for={{item.name}} class=option-title ng-if=item.label>{{item.label | translate}} <i class=\"fa fa-question-circle\" ng-if=item.description tooltip=\"{{item.description | translate}}\" tooltip-trigger=mouseenter tooltip-placement=top></i></label><campaign-template-item campaign=campaign item=item disabled=false></campaign-template-item></div></div></div><zc-campaign-note note=template campaign=campaign mode=edit></zc-campaign-note></section></div></fieldset></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/campaign_timing_step.html';
var html = "<form name=timingForm><fieldset ng-disabled=\"campaign.current_status === 'terminated'\"><section ng-if=\"campaign.delivery_type_option.id === 'complete_delivery'\"><div class=\"panel panel-warning\"><div class=panel-heading><div class=panel-title>{{ 'projectsCampaignsViews.directives.campaignTimingStep.ko_no_iw_kyanpeen' | translate }}</div></div></div></section><section ng-if=\"campaign.delivery_type_option.id === 'ab_delivery' && !campaign.segment_id\"><div class=\"panel panel-warning\"><div class=panel-heading><div class=panel-title>{{ 'projectsCampaignsViews.directives.campaignTimingStep.segumento_ga_sentaku' | translate }}</div></div></div></section><section ng-if=\"campaign.delivery_type_option.id === 'ab_delivery' && campaign.segment_id\"><div class=row><div class=col-md-8><div class=section><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignTimingStep.configuration_type' | translate }}</h4><div class=form-group><select class=form-control ng-options=\"configurationType.name as configurationType.label for configurationType in configurationTypes\" ng-model=campaign.configuration_type></select></div></div><div class=section ng-if=\"campaign.configuration_type === 'ai_model'\"><a href=\"{{ timingSettingsURL }}\" target=_blank>{{ 'projectsCampaignsViews.directives.campaignTimingStep.aiModelLink' | translate }}</a></div><div class=section ng-if=\"campaign.configuration_type === 'uplift_modeling'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignTimingStep.score_setting' | translate }}</h4><div class=form-group><input id=score_threshold class=\"form-control input-lg\" type=number step=0.01 min=0 max=1 placeholder=0.5 ng-model=campaign.score_threshold></div></div><div class=section ng-if=\"campaign.configuration_type === 'csv_upload'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignTimingStep.shousai_taimingu_settei' | translate }}</h4><div class=form-group><div class=\"alert alert-warning\" role=alert ng-if=\"project.product_line === 'zenclerk_lp' && campaign.campaign_policy_set.name === 'item_random'\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignTimingStep.tanpin_saito_de' | translate }}</div><div class=\"alert alert-danger\" role=alert ng-if=campaign_policy_has_errors><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignTimingStep.taimingu_ni_mondai' | translate }}</div><div class=\"alert alert-warning\" role=alert ng-if=timing_overrides_segment><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> {{ 'projectsCampaignsViews.directives.campaignTimingStep.timingOverridesSegment' | translate }}</div><select class=form-control ng-options=\"cps.id as cps.name for cps in campaign_policy_sets\" ng-model=campaign.campaign_policy_set_id required></select></div>{{campaign.campaign_policy_set.description}}<div ng-repeat=\"policy in campaign.campaign_policy_set.campaign_policies\"><segment-condition-table segments=policy multiple=false show-title=true vertical=true></segment-condition-table></div></div><div class=section ng-if=\"campaign.configuration_type === 'sampling'\"><h4 class=element_title><i class=\"glyphicon glyphicon-chevron-down\" style=font-size:15px;padding-right:7px;></i> {{ 'projectsCampaignsViews.directives.campaignTimingStep.sampling_rate' | translate }}</h4><div class=form-group><select class=form-control ng-options=\"range.name as range.name for range in sampling_ranges\" ng-model=campaign.sampling_range required></select></div>{{ 'projectsCampaignsViews.directives.campaignTimingStep.sampling_rate_help' | translate }}</div><zc-campaign-note note=timing campaign=campaign mode=edit></zc-campaign-note></div><div class=col-md-4><zc-session-uplift-modeling-classification campaign=campaign sessions=sessions></zc-session-uplift-modeling-classification><zc-logistic-regression-coefficients apikey=project.apikey preferred-device=campaign.campaign_device></zc-logistic-regression-coefficients></div></div></section></fieldset></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/graph_dimension_select.html';
var html = "<div class=\"dimension btn-toolbar pull-right\" role=toolbar><div class=btn-group><button type=button class=\"btn btn-default\" ng-class=\"{'active': dimension == 'hourly'}\" ng-click=\"setDimension('hourly')\">{{ 'projectsCampaignsViews.graphDimensionSelect.jikan' | translate }}</button> <button type=button class=\"btn btn-default\" ng-class=\"{'active': dimension == 'daily'}\" ng-click=\"setDimension('daily')\">{{ 'projectsCampaignsViews.graphDimensionSelect.hi' | translate }}</button> <button type=button class=\"btn btn-default\" ng-class=\"{'active': dimension == 'cumulative_hourly'}\" ng-click=\"setDimension('cumulative_hourly')\">{{ 'projectsCampaignsViews.graphDimensionSelect.jikan_ruikei' | translate }}</button> <button type=button class=\"btn btn-default\" ng-class=\"{'active': dimension == 'cumulative_daily'}\" ng-click=\"setDimension('cumulative_daily')\">{{ 'projectsCampaignsViews.graphDimensionSelect.hi_ruikei' | translate }}</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/label_campaign_status.html';
var html = "<div ng-class=statusClass ng-if=!errorMessage>{{text}}</div><div class=text-danger ng-if=errorMessage><i class=\"fa fa-exclamation-circle\"></i> {{errorMessage}}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/segment_condition_table.html';
var html = "<table class=\"table table-bordered master-table\" ng-if=segments><thead><tr><td ng-repeat=\"header in headers\"><span class=\"label label-success\" ng-if=\"header.indexOf('Session#') == 0\">Session</span> <span class=\"label label-danger\" ng-if=\"header.indexOf('Visitor#') == 0\">Visitor</span><div>{{header}}</div></td></tr></thead><tbody><tr ng-if=multiple ng-repeat=\"segment in segments\"><td ng-repeat=\"header in headers\">{{segment[header] | segmentValueFormat}}</td></tr><tr ng-if=!multiple><td ng-repeat=\"header in headers\">{{getSegmentHeader(segments, header) | segmentValueFormat}}</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/directives/segment_condition_table_vertical.html';
var html = "<span class=\"label label-default\" ng-if=showTitle>{{segments.name}}</span><table class=\"table table-condenced\"><tr ng-repeat=\"header in headers\"><td class=detail-box>{{header}}</td><td class=detail-box>{{getSegmentHeader(segments, header) | segmentValueFormat}}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

var path = '/templates/projects.campaigns/views/image_browser.html';
var html = "<div class=modal-header><div class=pull-right><button class=\"btn btn-primary\" ng-click=ok() ng-disabled=!selected.img>{{ 'projectsCampaignsViews.imageBrowser.gazou_wo_setto' | translate }}</button> <button class=\"btn btn-warning\" ng-click=cancel()>{{ 'projectsCampaignsViews.imageBrowser.kyanseru' | translate }}</button></div><h3 class=modal-title>{{ 'projectsCampaignsViews.imageBrowser.gazou_wo_sentaku' | translate }}</h3></div><div class=\"modal-body clearfix\"><ul class=image-browser><li class=img-cell ng-repeat=\"img in images | orderBy:'-created_at'\" ng-class=\"{'selected': selected.img === img}\"><div ng-click=selectImage(img)><div class=img-area><img ng-src={{img.image_url}}></div><div class=img-meta>{{img.id}} : {{img.image_file_name}}</div><div class=img-date><i class=\"fa fa-pencil\"></i> {{img.created_at | date: ('sharedModules.dateTimeFormats.datetime' | translate) }}</div><div class=img-remove confirm-modal=\"{{ 'projectsCampaignsViews.imageBrowser.gazou_ga_sentaku' | translate }}\" confirm-click=markAsUnselectable(img)><i class=\"fa fa-trash\"></i></div></div></li></ul></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok() ng-disabled=!selected.img>{{ 'projectsCampaignsViews.imageBrowser.gazou_wo_setto' | translate }}</button> <button class=\"btn btn-warning\" ng-click=cancel()>{{ 'projectsCampaignsViews.imageBrowser.kyanseru' | translate }}</button></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

var path = '/templates/projects.clearance/clearance_item_list.html';
var html = "<div><section><clearance-download-button clearance-item-set=clearanceItemSet clearance-item-set-items=clearanceItemSetItems></clearance-download-button><p translate=projectsClearance.clearanceItemList.touroku_shouhin_kazu translate-value-count=\"{{ clearanceItemSetItems.length }}\"></p></section><table class=\"table clearance-item-table table-bordered\"><tr><th>{{ 'projectsClearance.clearanceItemList.kuriaransu_id' | translate }}</th><th>{{ 'projectsClearance.clearanceItemList.namae' | translate }}</th><th>{{ 'projectsClearance.clearanceItemList.shousaijouhou' | translate }}</th><th>{{ 'projectsClearance.clearanceItemList.appuroodo_nichiji' | translate }}</th><th ng-if=\"clearanceItemSet.clearanceCampaigns.length > 0\">{{ 'projectsClearance.clearanceItemList.haishin_uchi_no' | translate }}</th></tr><tr><td>{{clearanceItemSet.id}}</td><td>{{clearanceItemSet.name}}</td><td>{{clearanceItemSet.description}}</td><td>{{clearanceItemSet.created_at | zcDate : {smart:true} }}</td><td ng-if=\"::clearanceItemSet.clearanceCampaigns.length > 0\"><span class=list-unstyled ng-repeat=\"campaign in clearanceItemSet.clearanceCampaigns\"><a ui-sref=\"admin.projects.campaigns.show.stats( {projectId:project.id, campaignId:campaign.id} )\" target=_blank>{{campaign.id}}</a></span></td></tr></table><div class=mb10><span class=\"label label-danger\">{{ 'projectsClearance.clearanceItemList.hissu' | translate }}</span>: {{ 'projectsClearance.clearanceItemList.hissu_koumoku' | translate }} <span class=\"label label-warning\">{{ 'projectsClearance.clearanceItemList.c_hitsu' | translate }}</span>: {{ 'projectsClearance.clearanceItemList.hitsuyouseikurieitibu_uchini' | translate }}</div><table class=\"table clearance-item-table table-bordered\"><tr><th>match type</th><th>path</th><th>title</th><th>base_price</th><th>text_base_price</th><th>sale_url</th><th>image_url</th></tr><tr><th><span class=\"label label-danger\">{{ 'projectsClearance.clearanceItemList.hissu' | translate }}</span> {{ 'projectsClearance.clearanceItemList.hantei_houhou' | translate }}</th><th><span class=\"label label-danger\">{{ 'projectsClearance.clearanceItemList.hissu' | translate }}</span> {{ 'projectsClearance.clearanceItemList.pasu' | translate }}</th><th><span class=\"label label-warning\">{{ 'projectsClearance.clearanceItemList.c_hitsu' | translate }}</span> {{ 'projectsClearance.clearanceItemList.shouhinmei' | translate }}</th><th><span class=\"label label-warning\">{{ 'projectsClearance.clearanceItemList.c_hitsu' | translate }}</span> {{ 'projectsClearance.clearanceItemList.shouhin_kakaku' | translate }}</th><th>{{ 'projectsClearance.clearanceItemList.shouhin_kakaku' | translate }}</th><th>{{ 'projectsClearance.clearanceItemList.seeru_url' | translate }}</th><th><span class=\"label label-warning\">{{ 'projectsClearance.clearanceItemList.c_hitsu' | translate }}</span> {{ 'projectsClearance.clearanceItemList.shouhin_gazou' | translate }}</th></tr><tr ng-repeat=\"item in clearanceItemSetItems | limitTo:visibleItemCount\"><td>{{item.match_type}}</td><td>{{item.path}}</td><td>{{item.title}}</td><td>{{item.base_price}}</td><td>{{item.text_base_price}}</td><td>{{item.sale_url}}</td><td><img style=\"max-height: 120px; width: auto;\" ng-src={{item.image_url}} ng-if=item.image_url tooltip={{item.image_url}}></td></tr></table><p class=\"text-center muted\">{{ 'projectsClearance.clearanceItemList.seeru_url' | translate:{ visibleitemcount: visibleItemCount } }}</p><button class=\"btn btn-default btn-block mb20\" ng-click=\"visibleItemCount = visibleItemCount + countPerLoad\">{{ 'projectsClearance.clearanceItemList.shouhin_wo_sarani' | translate:{ countperload: countPerLoad } }}</button></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

var path = '/templates/projects.clearance/clearance_set_show.html';
var html = "<div class=container><zc-clearance-item-list project=project clearance-item-set=clearanceItemSet></zc-clearance-item-list></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/campaign_count_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.campaignCountChart.campaignCount' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.campaigns class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/conversion_price_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.conversionPriceChart.keiyu_uriage_nakaguro' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.dailyReportStats class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/dashboard.html';
var html = "<div class=\"content site-dashboard\"><div class=row><div class=col-md-12><div ng-if=$ctrl.project.thisMonthStat class=gridster><ul><li id=\"{{ chart.name }}\" class=gs-w ng-init=\"$last && $ctrl.initGrid()\" ng-repeat=\"chart in $ctrl.chartPositions\" data-row=\"{{ chart.row }}\" data-col=\"{{ chart.col }}\" data-sizex=\"{{ chart.size_x }}\" data-sizey=\"{{ chart.size_y }}\"><zc-dashboard-chart-loader chart=chart project=$ctrl.project></zc-dashboard-chart-loader></li></ul></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/delivery_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.deliveryChart.haishin_kazu_nakaguro' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.dailyReportStats class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/device_distribution_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.deviceDistributionChart.debaisugoto_no_haishin' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.campaigns class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/invoice_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.invoiceChart.seikyuu_kingaku' | translate }}</h5></div><div class=widget-content><div class=\"row col-sm-12 text-center\" style=\"padding-top: 10px;\"><div class=col-sm-6>{{ 'projectsDashboard.invoiceChart.seikyuu_kingaku' | translate }}</div><div class=col-sm-6>{{ 'projectsDashboard.invoiceChart.yosou_seikyuu_kingaku' | translate }}</div></div><div class=\"row col-sm-12 text-center\" style=\"padding: 2px 0\"><div class=col-sm-6><span class=\"u-color-babyblue o-size-medium o-type-xl\">{{ $ctrl.project.thisMonthInvoice.invoice_price_tax_excluded | number: 0 }}</span> 円</div><div ng-if=$ctrl.simulation class=col-sm-6><span class=\"u-color-babyblue o-type-xl\">{{ $ctrl.project.thisMonthInvoice.invoice_price_tax_excluded * $ctrl.simulation | number: 0 }}</span> 円</div></div><div class=\"row col-sm-12 text-center\"><div class=col-sm-6><span ng-if=$ctrl.project.lastMonthInvoice.invoice_price_tax_excluded translate=projectsDashboard.invoiceChart.yosou_toutatsu_ritsu translate-value-rate=\"{{ $ctrl.predictionAchievementRate | number: 0 }}\"></span></div><div class=col-sm-6><span ng-if=$ctrl.simulation>{{ 'projectsDashboard.invoiceChart.saku_tsuki_hi' | translate }}<zc-increase-or-decrease-percentage from=$ctrl.project.lastMonthInvoice.invoice_price_tax_excluded to=\"$ctrl.project.thisMonthInvoice.invoice_price_tax_excluded * $ctrl.simulation\"></zc-increase-or-decrease-percentage></span></div></div><div ng-if=$ctrl.project.dailyReportStats class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

var path = '/templates/projects.dashboard/reaction_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.reactionChart.hannou_kazu_nakaguro' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.dailyReportStats class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

var path = '/templates/projects.heatmap/heatmap.html';
var html = "<div class=\"container container-limited\"><div class=row><div class=col-sm-12><h2>ヒートマップ</h2>URL: {{$ctrl.url}} <a ng-href={{$ctrl.url}} target=_blank><i class=\"fa fa-external-link\"></i></a><div class=\"form-inline row\"><div class=col-sm-2><input ng-model=$ctrl.showLayers.insights type=checkbox class=form-control> インサイトを表示</div></div></div></div></div><div class=row><div class=col-sm-12><div class=visualization-container><div class=row><div class=\"controls col-sm-2 col-sm-offset-10\"></div></div><div class=heatmap-scroll-container></div><div class=svg-container-main><div class=iframe-container><div class=insights ng-if=$ctrl.showLayers.insights><div class=insight ng-repeat=\"insight in $ctrl.insights\" ng-style=\"{top: insight.y + 'px', left: insight.x + 'px'}\"><span class=insight-number>{{$index + 1}}</span> <span class=insight-message>{{insight.message}}</span></div></div><img src=https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtg-onlineshop.jpeg></div><svg></svg></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

var path = '/templates/projects.heatmap/heatmap_list.html';
var html = "<div class=container><section><div class=row><div class=col-md-7><h3>ページ一覧</h3></div></div><div class=col-md-7><zc-heatmap-table pages=pages></zc-heatmap-table></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

var path = '/templates/projects.heatmap/views/directives/heatmap_table.html';
var html = "<div class=table-responsive><table class=\"table heatmap-table table-bordered\"><thead><tr><th class=heatmap-table-id>ID</th><th class=heatmap-table-status>URL</th></tr></thead><tbody><tr ng-repeat=\"page in pages\"><td style=text-align:center>{{ page.id }}</td><td><a ui-sref=\"admin.projects.heatmap.show({url: 1})\">{{page.name}}</a></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

var path = '/templates/projects.incentives/edit.html';
var html = "<div class=\"container incentive-maker\"><div class=section><h1 class=step_title>{{ 'projectsIncentives.edit.registerChangeInfo' | translate }}</h1><p ng-if=!incentive.used_in_campaigns_activated_before>{{ 'projectsIncentives.edit.requiredItems' | translate }}</p><div class=\"alert alert-warning\" ng-if=incentive.used_in_campaigns_activated_before><i class=\"fa fa-exclamation-triangle\"></i> {{ 'projectsIncentives.edit.modifyIncentives' | translate }}</div></div><div class=section><form name=incentiveEditForm zc-dirty-form-dialog><ul class=incentive_edit_list><li><div class=row><div class=col-md-2><label for=name class=control-label>{{ 'projectsIncentives.edit.registeredName' | translate }}</label></div><div class=col-md-5><input type=text class=form-control id=name ng-model=incentive.name placeholder=\"{{ 1000 | zcCurrency: currency.symbol:currency.fractionSize:currency.suffix}} OFF{{ 'projectsIncentives.edit.coupon' | translate }}\" required></div></div></li><li><div class=row><div class=col-md-2><label for=coupon_code class=control-label>{{ 'projectsIncentives.edit.type' | translate }}</label></div><div class=col-md-10><select id=incentive_type ng-model=incentive.incentive_type class=form-control style=width:350px ng-disabled=incentive.used_in_campaigns_activated_before><option value=coupon_code>{{ 'projectsIncentives.edit.couponCodeMethod' | translate }}</option><option value=coupon_url>{{ 'projectsIncentives.edit.linkMethod' | translate }}</option><option value=unique_coupon_code ng-if=Devise.isMaster()>{{ 'projectsIncentives.edit.masterCoupon' | translate }}</option><option value=generated_coupon_url ng-if=Devise.isMaster()>{{ 'projectsIncentives.edit.generateUrl' | translate }}</option><option value=giftee_api ng-if=\"environment !== 'production' && Devise.isMaster()\">{{ 'projectsIncentives.edit.integrateApi' | translate }}</option><option value=api_url>{{ 'projectsIncentives.edit.apiUrl' | translate }}</option><option value=botbonnie_short_url>{{ 'projectsIncentives.edit.botbonnieShortUrl' | translate }}</option></select><div ng-if=\"incentive.incentive_type === 'coupon_code'\" style=\"margin-top: 15px\">{{ 'projectsIncentives.edit.couponIncentive' | translate }}</div><div ng-if=\"incentive.incentive_type === 'coupon_url'\" style=\"margin-top: 15px\">{{ 'projectsIncentives.edit.incentiveForUrl' | translate }}</div><div ng-if=\"incentive.incentive_type === 'api_url'\" style=\"margin-top: 15px\">{{ 'projectsIncentives.edit.incentiveForAPI' | translate }}</div><div ng-if=\"incentive.incentive_type === 'botbonnie_short_url'\" style=\"margin-top: 15px\">{{ 'projectsIncentives.edit.botbonnieShortUrlMessage' | translate }}</div><div class=botbonnie_short_url_container ng-if=\"incentive.incentive_type === 'botbonnie_short_url'\"><div class=form-group><label for=botbonnie_short_url class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.botbonnieShortUrl' | translate }}*</label><div class=col-sm-8><input id=botbonnie_short_url type=text class=form-control style=width:250px ng-model=incentive.botbonnie_short_url required></div></div></div><div class=generated_coupun_url_container ng-if=\"incentive.incentive_type === 'coupon_url'\"><div class=form-group><label for=pc_base_url class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.pcCouponAcquisition' | translate }}</label><div class=col-sm-8><input id=pc_base_url type=text class=form-control style=width:250px ng-model=incentive.pc_base_url required></div></div><div class=form-group><label for=sp_base_url class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.spCouponAcquisition' | translate }}</label><div class=col-sm-8><input id=sp_base_url type=text class=form-control style=width:250px ng-model=incentive.sp_base_url required></div></div></div><div class=generated_coupun_url_container ng-if=\"Devise.isMaster() && incentive.incentive_type === 'generated_coupon_url'\"><div class=form-group><label for=campaign_code class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.campaignCode' | translate }}</label><div class=col-sm-8><input type=text class=form-control style=width:250px id=campaign_code placeholder=1jeTlq ng-model=incentive.campaign_code required></div></div><div class=form-group><label for=pc_base_url class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.pcAutoUrl' | translate }}<br><small class=text-danger>{{ 'projectsIncentives.edit.useDeviceFree' | translate }}</small></label><div class=col-sm-8><input id=pc_base_url type=text class=form-control style=width:250px ng-model=incentive.pc_base_url required></div></div><div class=form-group><label for=sp_base_url class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.spAutoUrl' | translate }}</label><div class=col-sm-8><input id=sp_base_url type=text class=form-control style=width:250px ng-model=incentive.sp_base_url required></div></div><div class=form-group><label for=secret_key class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.privateKey' | translate }}</label><div class=col-sm-8><input id=secret_key type=text class=form-control style=width:250px ng-model=incentive.secret_key required></div></div></div><div class=generated_coupun_url_container ng-if=\"Devise.isMaster() && incentive.incentive_type === 'giftee_api'\"><div class=form-group><label for=giftee_item_sku_id class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.productId' | translate }} <i class=\"glyphicon glyphicon-exclamation-sign\" tooltip=\"{{ 'projectsIncentives.edit.uniqueProductId' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-8><input type=number min=1 max=999999999 class=form-control style=width:250px id=giftee_item_sku_id ng-model=incentive.giftee_item_sku_id required></div></div><div class=form-group><label for=giftee_gift_frame_id class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.giftCard' | translate }} <i class=\"glyphicon glyphicon-exclamation-sign\" tooltip=\"{{ 'projectsIncentives.edit.coverDisplay' | translate }}\" tooltip-append-to-body=true></i><br><small translate=projectsIncentives.edit.listOfGiftCard translate-value-link=\"<a href='https://giftee.co/gift_frames' target='_blank'>{{ 'projectsIncentives.edit.here' | translate}}</a>\" class=text-danger></small></label><div class=col-sm-8><input type=number min=1 max=999999999 class=form-control style=width:250px id=giftee_gift_frame_id ng-model=incentive.giftee_gift_frame_id></div></div><div class=form-group><label for=gift_price class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.productPrice' | translate }} <i class=\"glyphicon glyphicon-exclamation-sign\" tooltip=\"{{ 'projectsIncentives.edit.enterTotalPrice' | translate }}\" tooltip-append-to-body=true></i><br><small class=text-danger>{{ 'projectsIncentives.edit.billing' | translate }}</small></label><div class=col-sm-8><input type=number min=1 max=999999999 class=form-control style=width:250px id=gift_price ng-model=incentive.gift_price required></div></div><div class=form-group><label for=gift_exchange_url_pc class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.pcPrepareUrl' | translate }} <i class=\"glyphicon glyphicon-exclamation-sign\" tooltip={{giftUrlParameter}} tooltip-append-to-body=true></i><br><small class=text-danger>{{ 'projectsIncentives.edit.useDeviceIfFree' | translate }}</small></label><div class=col-sm-8><input id=gift_exchange_url_pc type=text class=form-control style=width:250px ng-model=incentive.gift_exchange_url_pc required></div></div><div class=form-group><label for=gift_exchange_url_sp class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.spPrepareUrl' | translate }} <i class=\"glyphicon glyphicon-exclamation-sign\" tooltip={{giftUrlParameter}} tooltip-append-to-body=true></i></label><div class=col-sm-8><input id=gift_exchange_url_sp type=text class=form-control style=width:250px ng-model=incentive.gift_exchange_url_sp required></div></div><div class=form-group><label for=giftee_sender_name class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.nameOfRecipient' | translate }}<br><small class=text-danger>{{ 'projectsIncentives.edit.characterLimit20' | translate }}</small></label><div class=col-sm-8><input type=text class=form-control style=width:250px id=giftee_sender_name ng-model=incentive.giftee_sender_name ng-maxlength=20 required></div></div><div class=form-group style=\"padding-top: 10px;\"><label for=giftee_gift_message class=\"col-sm-3 control-label\">{{ 'projectsIncentives.edit.giftCardMessage' | translate }}<br><small class=text-danger>{{ 'projectsIncentives.edit.characterLimit100' | translate }}</small></label><div class=col-sm-8><textarea class=form-control style=width:250px id=giftee_gift_message ng-model=incentive.giftee_gift_message ng-maxlength=100 required>\n                    </textarea></div></div></div></div></div></li><li ng-if=\"incentive.incentive_type === 'coupon_code'\"><div class=row><div class=col-md-2><label for=coupon_code class=control-label>{{ 'projectsIncentives.edit.code' | translate }}</label></div><div class=col-md-10><input type=text class=form-control style=width:250px id=coupon_code placeholder=Lucky777 ng-model=incentive.coupon_code ng-maxlength=50 ng-minlength=2 ng-disabled=incentive.used_in_campaigns_activated_before ng-required=\"incentive.incentive_type === 'coupon_code'\"></div></div></li><li ng-if=\"incentive.incentive_type === 'api_url'\"><div class=row><div class=col-md-2><label for=api_url class=control-label>{{ 'projectsIncentives.edit.apiMust' | translate }}</label></div><div class=col-md-10><input type=text class=form-control style=width:250px id=api_url placeholder=https://example.com ng-model=incentive.api_url ng-minlength=7 ng-disabled=incentive.used_in_campaigns_activated_before ng-required=\"incentive.incentive_type === 'api_url'\"></div></div></li><li ng-if=\"incentive.incentive_type === 'api_url'\"><div class=row><div class=col-md-2><label for=api_error_message class=control-label>{{ 'projectsIncentives.edit.apiErrorMessageMust' | translate }}</label></div><div class=col-md-10><input type=text class=form-control style=width:250px id=api_error_message placeholder=\"Unexpected error occured\" ng-model=incentive.api_error_message ng-minlength=7 ng-disabled=incentive.used_in_campaigns_activated_before ng-required=\"incentive.incentive_type === 'api_url'\"></div></div></li><li ng-if=\"['giftee_api', 'botbonnie_short_url'].indexOf(incentive.incentive_type) === -1\"><div class=row><div class=col-md-2><label for=secret_key class=control-label>{{ 'projectsIncentives.edit.discountDetails' | translate }}</label></div><div class=col-md-10><div class=row><div class=col-md-3><div class=incentive_types ng-class=\"{incentive_types_active : incentive.discount_type ==='none'}\"><div class=incentive_types_title><label><input type=radio ng-model=incentive.discount_type name=discount_type value=none ng-disabled=incentive.used_in_campaigns_activated_before> &nbsp; {{ 'projectsIncentives.edit.noDiscount' | translate }}</label></div></div></div><div class=col-md-3><div class=incentive_types ng-class=\"{incentive_types_active : incentive.discount_type ==='price'}\"><div class=incentive_types_title><label><input type=radio ng-model=incentive.discount_type value=price ng-disabled=incentive.used_in_campaigns_activated_before> &nbsp;<ng-container translate=projectsIncentives.edit.flatRateDiscount translate-value-currency=\"{{ currency.symbol || currency.suffix }}\"></ng-container></label></div><div class=\"incentive_types_body form-inline\"><span>{{currency.symbol}}</span> <input type=number min=0 step={{currencyStep}} class=form-control style=width:70px placeholder=1000 ng-model=priceInputs.discount_price ng-change=\"updatePriceByApplyingCurrency('discount_price')\" ng-required=\"incentive.discount_type ==='price'\" ng-disabled=\"incentive.used_in_campaigns_activated_before || incentive.discount_type !=='price'\"> {{currency.suffix}} OFF</div></div></div><div class=col-md-3><div class=incentive_types ng-class=\"{incentive_types_active : incentive.discount_type ==='percent'}\"><div class=incentive_types_title><label><input type=radio ng-model=incentive.discount_type value=percent ng-required=\"incentive.discount_type ==='percent'\" ng-disabled=incentive.used_in_campaigns_activated_before> &nbsp; {{ 'projectsIncentives.edit.fixedRateDiscount' | translate }}</label></div><div class=\"incentive_types_body form-inline\"><input type=number min=0 class=form-control style=width:70px placeholder=10 ng-model=incentive.discount_percent ng-disabled=\"incentive.used_in_campaigns_activated_before || incentive.discount_type !=='percent'\"> %OFF</div></div></div></div></div></div></li><li ng-if=\"['giftee_api', 'botbonnie_short_url'].indexOf(incentive.incentive_type) === -1\"><div class=row><div class=col-md-2><label for=secret_key class=control-label>{{ 'projectsIncentives.edit.otherBenefits' | translate }}</label></div><div class=col-md-10><div class=\"row mb20\"><div class=col-md-3><div class=incentive_types ng-class=\"{incentive_types_active : incentive.is_free_shipping}\"><div class=incentive_types_title><label class=checkbox-inline><input type=checkbox ng-model=incentive.is_free_shipping ng-disabled=incentive.used_in_campaigns_activated_before> {{ 'projectsIncentives.edit.freeShipping' | translate }}</label></div></div></div><div class=col-md-3><div class=incentive_types ng-class=\"{incentive_types_active: incentive.is_novelty}\"><div class=incentive_types_title><label class=checkbox-inline><input type=checkbox ng-model=incentive.is_novelty ng-disabled=incentive.used_in_campaigns_activated_before> {{ 'projectsIncentives.edit.other' | translate }}</label></div><div class=incentive_types_body>{{ 'projectsIncentives.edit.specialDetails' | translate }}</div></div></div></div>{{ 'projectsIncentives.edit.multipleSelection' | translate }}</div></div></li><li ng-if=\"incentive.incentive_type !== 'botbonnie_short_url'\"><div class=row><div class=col-md-2><label for=coupon_code class=control-label>{{ 'projectsIncentives.edit.termsOfUse' | translate }}</label></div><div class=col-md-10><div class=mb20><label class=checkbox-inline><input type=checkbox ng-model=incentive.has_member_only_limit ng-disabled=incentive.used_in_campaigns_activated_before> {{ 'projectsIncentives.edit.membersUse' | translate }}</label></div><div class=mb20><label class=checkbox-inline><input type=checkbox id=has_usage_limit ng-model=incentive.has_usage_limit ng-disabled=incentive.used_in_campaigns_activated_before> {{ 'projectsIncentives.edit.oneMemberUse' | translate }}</label></div><div class=form-inline><label id=has_price_limit class=\"checkbox-inline form-inline\"><input type=checkbox ng-model=incentive.has_price_limit ng-disabled=incentive.used_in_campaigns_activated_before> {{ 'projectsIncentives.edit.usageAmountLimit' | translate }}</label> <span>{{currency.symbol}}</span> <input type=number min=0 step={{currencyStep}} placeholder=3000 class=form-control style=width:100px ng-model=priceInputs.minimum_price ng-change=\"updatePriceByApplyingCurrency('minimum_price')\" ng-required=incentive.has_price_limit ng-disabled=\"!incentive.has_price_limit || incentive.used_in_campaigns_activated_before\"> &nbsp;<ng-container translate=projectsIncentives.edit.forPurchasing translate-value-currency={{currency.suffix}}></ng-container></div></div></div></li><li><div class=row><div class=col-md-2><label for=coupon_code class=control-label>{{ 'projectsIncentives.edit.validityPeriod' | translate }}</label></div><div class=col-md-10><div class=\"row mb20\"><label class=\"col-sm-12 control-label\"><i class=\"glyphicon glyphicon-chevron-down\"></i> {{ 'projectsIncentives.edit.startDateTime' | translate }}</label><div class=col-sm-12><div date-time-picker ng-model=start_at_obj region=currentProject.region product-line=currentProject.product_line is-required=true></div></div></div><div class=\"row mb20\"><label class=\"col-sm-12 control-label\"><i class=\"glyphicon glyphicon-chevron-down\"></i> {{ 'projectsIncentives.edit.endDateTime' | translate }}</label><div class=col-sm-12><div date-time-picker ng-model=end_at_obj region=currentProject.region product-line=currentProject.product_line is-required=true></div></div></div></div></div></li><li><div class=row><div class=col-md-2><label for=coupon_code class=control-label>{{ 'projectsIncentives.edit.notices' | translate }}</label></div><div class=col-md-8><textarea type=textarea class=form-control ng-model=incentive.memo ng-required=incentive.is_novelty placeholder=\"{{ 'projectsIncentives.edit.productRestrictions' | translate }}\" rows=4>\n              </textarea></div></div></li></ul><div class=\"text-center notifications\"><b>{{ 'projectsIncentives.edit.securedInformation' | translate }}</b><br><b>{{ 'projectsIncentives.edit.confirmAgain' | translate }}</b></div><div class=text-center style=\"margin-top: 10px;\"><button class=\"btn zc-btn-style\" ng-disabled=incentiveEditForm.$invalid ng-click=save()>{{ 'projectsIncentives.edit.registerChangeIncentives' | translate }}</button></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

var path = '/templates/projects.incentives/incentive_detail.html';
var html = "<ul><li ng-if=incentive.has_member_only_limit>{{ 'projectsIncentives.incentiveDetail.membersRestricted' | translate }}</li><li ng-if=incentive.has_price_limit>{{ 'projectsIncentives.incentiveDetail.amountLimit' | translate }} <span ng-if=\"incentive.minimum_price != null\" translate=projectsIncentives.incentiveDetail.amountOrMore translate-value-amount=\"{{incentive.minimum_price | number : 0}}\"></span> <span ng-if=incentive.is_price_limit_tax_included>{{ 'projectsIncentives.incentiveDetail.taxIncludedPrice' | translate }}</span> <span ng-if=!incentive.is_price_limit_tax_included>{{ 'projectsIncentives.incentiveDetail.nonTaxPrice' | translate }}</span></li><li ng-if=incentive.has_usage_limit>{{ 'projectsIncentives.incentiveDetail.timeLimit' | translate }}<ng-container translate=projectsIncentives.incentiveDetail.numberOfTimes translate-value-amount={{incentive.maximum_usage}}></ng-container></li><li ng-if=incentive.item_limit_memo>{{ 'projectsIncentives.incentiveDetail.productRestrictions' | translate }}{{incentive.item_limit_memo}}</li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

var path = '/templates/projects.incentives/incentive_table.html';
var html = "<div class=table-responsive ng-show=incentives.length><table class=\"table campaign-table table-bordered\"><thead><tr><th class=campaign-table-id>ID</th><th class=campaign-table-status>{{ 'projectsIncentives.incentiveTable.status' | translate }}</th><th class=campaign-table-name>{{ 'projectsIncentives.incentiveTable.incentiveName' | translate }}</th><th class=campaign-table-incentive>{{ 'projectsIncentives.incentiveTable.incentive' | translate }}</th><th ng-if=\"stats && Devise.isMaster()\">{{ 'projectsIncentives.incentiveTable.couponUsageCount' | translate }}</th><th ng-if=showsDetail>{{ 'projectsIncentives.incentiveTable.linkedCampaignId' | translate }}</th><th class=campaign-table-date>{{ 'projectsIncentives.incentiveTable.expireDate' | translate }}</th><th class=campaign-table-action ng-if=\"showsDetail && (Devise.isMaster() || project.allow_incentive_edit)\"></th></tr></thead><tbody><tr data-href=insentive_new.html class=clickable ng-repeat=\"incentive in incentives | orderBy:'-created_at'\"><td style=text-align:center>{{ incentive.id }}</td><td style=text-align:center><zc-incentive-status incentive=incentive></zc-incentive-status></td><td><a ui-sref=\"admin.projects.incentives.show({projectId: project.id, incentiveId: incentive.id})\">{{incentive.name}}</a></td><td><div ng-if=\"incentive.incentive_type === 'coupon_code'\">{{ 'projectsIncentives.incentiveTable.couponCode' | translate }}:&nbsp;<zc-incentive-code incentive=incentive></zc-incentive-code></div><div ng-if=\"incentive.incentive_type === 'coupon_url'\">{{ 'projectsIncentives.incentiveTable.linkExpression' | translate }}</div><div ng-if=\"incentive.incentive_type === 'unique_coupon_code'\">{{ 'projectsIncentives.incentiveTable.uniqueCode' | translate }}</div><div ng-if=\"incentive.incentive_type === 'generated_coupon_url'\">{{ 'projectsIncentives.incentiveTable.campaignCode' | translate }}:&nbsp;{{incentive.campaign_code}}</div><div ng-if=\"incentive.incentive_type === 'giftee_api'\">{{ 'projectsIncentives.incentiveTable.productId' | translate }}:&nbsp;{{incentive.giftee_item_sku_id}}</div><div ng-if=\"incentive.incentive_type === 'api_url'\">{{ 'projectsIncentives.incentiveTable.api' | translate }}:&nbsp;{{incentive.api_url}}<br>{{ 'projectsIncentives.incentiveTable.apiErrorMessage' | translate }}:&nbsp;{{incentive.api_error_message}}<br></div><div ng-if=\"incentive.incentive_type === 'botbonnie_short_url'\">{{ 'projectsIncentives.incentiveTable.botbonnieShortUrl' | translate }}:&nbsp;{{incentive.botbonnie_short_url}}<br></div></td><td ng-if=\"stats && Devise.isMaster()\"><ng-container translate=projectsIncentives.incentiveTable.campaign_coupon_used_count translate-value-amount=\"{{ stats.experimental.campaign_coupon_used_count || 0 }}\"></ng-container>({{ stats.experimental.campaign_coupon_used_rate * 100 || 0 | number:2 }}%)</td><td ng-if=showsDetail><span style=\"margin-right: 3px\" ng-repeat=\"campaign in incentive.campaigns\"><a ui-sref=\"admin.projects.campaigns.show({projectId: project.id, campaignId: campaign.id})\" tooltip={{campaign.name}}>{{campaign.id}}</a></span></td><td><zc-date-range start-at=incentive.start_at end-at=incentive.end_at is-infinite=incentive.is_infinite display-time=false></zc-date-range></td><td ng-if=\"showsDetail && (Devise.isMaster() || project.allow_incentive_edit)\"><span ui-sref=\"admin.projects.incentives.edit({projectId: project.id, incentiveId: incentive.id})\"><i class=\"fa fa-pencil\" tooltip=\"{{ 'projectsIncentives.incentiveTable.editIncentives' | translate }}\"></i></span> <span ng-click=copy(incentive)><i class=\"fa fa-copy\" tooltip=\"{{ 'projectsIncentives.incentiveTable.copyIncentives' | translate }}\"></i></span> <span confirm-modal confirm-click=remove(incentive)><i class=\"glyphicon glyphicon-trash\" tooltip=\"{{ 'projectsIncentives.incentiveTable.deleteUnused' | translate }}\"></i></span></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

var path = '/templates/projects.incentives/list.html';
var html = "<div class=container><section class=campaigns><div class=row><div class=col-md-9><h1>{{ 'projectsIncentives.list.incentiveList' | translate }}</h1></div><div class=col-md-3 ng-if=\"isMaster || currentProject.allow_incentive_edit\"><a class=\"btn btn-default pull-right\" ui-sref=\"admin.projects.incentives.new({projectId: currentProject.id})\"><i class=\"fa fa-lock\" ng-if=!currentProject.allow_incentive_edit></i> {{ 'projectsIncentives.list.incentiveRegister' | translate }}</a></div></div><zc-incentive-table project=currentProject incentives=incentives on-update=getAllIncentives shows-detail=true></zc-incentive-table></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

var path = '/templates/projects.incentives/show.html';
var html = "<div class=\"container incentive-maker\"><a class=\"btn btn-default pull-right\" ui-sref=\"admin.projects.incentives.edit({projectId: currentProject.id, incentiveId: incentive.id})\"><i class=\"fa fa-pencil\"></i> {{ 'projectsIncentives.show.editRegistrationInfo' | translate }}</a><div class=section><h1 class=step_title>{{ 'projectsIncentives.show.incentiveDetails' | translate }}</h1></div><div class=row><div class=col-md-10><table class=\"table incentive_table\"><tbody><tr><th>{{ 'projectsIncentives.show.registeredName' | translate }}</th><td><zc-incentive-status incentive=incentive></zc-incentive-status>{{incentive.name}}</td></tr><tr zc-master-only><th><i class=\"fa fa-lock\"></i> {{ 'projectsIncentives.show.type' | translate }}</th><td><span class=incentive_strong ng-if=\"incentive.incentive_type=='coupon_code'\">{{ 'projectsIncentives.show.couponCodeMethod' | translate }}</span> <span class=incentive_strong ng-if=\"incentive.incentive_type=='coupon_url'\">{{ 'projectsIncentives.show.nkMethod' | translate }}</span> <span class=incentive_strong ng-if=\"incentive.incentive_type=='unique_coupon_code'\">{{ 'projectsIncentives.show.uniqueCouponMethod' | translate }}</span> <span class=incentive_strong ng-if=\"incentive.incentive_type=='generated_coupon_url'\">{{ 'projectsIncentives.show.generateUrl' | translate }}</span> <span class=incentive_strong ng-if=\"incentive.incentive_type=='giftee_api'\">{{ 'projectsIncentives.show.integrateApi' | translate }}</span> <span class=incentive_strong ng-if=\"incentive.incentive_type=='api_url'\">{{ 'projectsIncentives.show.apiUrl' | translate }}</span> <span class=incentive_strong ng-if=\"incentive.incentive_type=='botbonnie_short_url'\">{{ 'projectsIncentives.show.botbonnieShortUrl' | translate }}</span><ul ng-if=\"incentive.incentive_type=='coupon_url'\"><br><li>{{ 'projectsIncentives.show.pcCouponAcquisition' | translate }}:&nbsp;{{incentive.pc_base_url}}</li><li>{{ 'projectsIncentives.show.spCouponAcquisition' | translate }}:&nbsp;{{incentive.sp_base_url}}</li></ul><ul ng-if=\"incentive.incentive_type=='generated_coupon_url'\"><br><li>{{ 'projectsIncentives.show.campaignCode' | translate }}:&nbsp;{{incentive.campaign_code}}</li><li>{{ 'projectsIncentives.show.pcCouponAcquisition' | translate }}:&nbsp;{{incentive.pc_base_url}}</li><li>{{ 'projectsIncentives.show.spCouponAcquisition' | translate }}:&nbsp;{{incentive.sp_base_url}}</li><li>{{ 'projectsIncentives.show.privateKey' | translate }}:&nbsp;{{incentive.secret_key}}</li></ul><ul ng-if=\"incentive.incentive_type=='api_url'\"><br><li>[URL] {{incentive.api_url}}<br>[{{ 'projectsIncentives.show.apiErrorMessage' | translate }}] {{incentive.api_error_message}}</li></ul><ul ng-if=\"incentive.incentive_type=='botbonnie_short_url'\"><br><li>[URL] {{incentive.botbonnie_short_url}}<br></li></ul><ul ng-if=\"incentive.incentive_type=='giftee_api'\"><br><li>{{ 'projectsIncentives.show.productId' | translate }}:&nbsp;{{incentive.giftee_item_sku_id}}</li><li>{{ 'projectsIncentives.show.giftCardCover' | translate }}:&nbsp;{{incentive.giftee_gift_frame_id}}<ng-container translate=projectsIncentives.show.listOfGiftCard translate-value-link=\"<a href='https://giftee.co/gift_frames' target='_blank'>{{ 'projectsIncentives.show.here' | translate}}</a>\" class=text-danger></ng-container></li><li>{{ 'projectsIncentives.show.productPrice' | translate }}:&nbsp;{{incentive.gift_price | zcCurrency: currency.symbol:currency.fractionSize:currency.suffix}}</li><li>{{ 'projectsIncentives.show.redeemPreparePc' | translate }}:&nbsp;{{incentive.gift_exchange_url_pc}}</li><li>{{ 'projectsIncentives.show.redeemSpUrl' | translate }}:&nbsp;{{incentive.gift_exchange_url_sp}}</li><li>{{ 'projectsIncentives.show.recepientName' | translate }}:&nbsp;{{incentive.giftee_sender_name}}</li><li>{{ 'projectsIncentives.show.giftCardMessage' | translate }}:<br>{{incentive.giftee_gift_message}}</li></ul></td></tr><tr ng-if=\"incentive.incentive_type=='coupon_code' ||incentive.incentive_type=='unique_coupon_code'\"><th>{{ 'projectsIncentives.show.code' | translate }}</th><td><div ng-if=\"incentive.incentive_type=='unique_coupon_code'\"><zc-incentive-code incentive=incentive></zc-incentive-code><br><ul><li>{{ 'projectsIncentives.show.numberOfRegisterCode' | translate }}:&nbsp;{{totalUniqueCouponCodeCount}}</li><li>{{ 'projectsIncentives.show.numberOfDeliverCode' | translate }}:&nbsp;{{assignedUniqueCouponCodeCount}}</li><li>{{ 'projectsIncentives.show.numberOfRemainCode' | translate }}:&nbsp;{{totalUniqueCouponCodeCount - assignedUniqueCouponCodeCount}}</li></ul><div zc-master-only class=btn-margin-top><div flow-init ng-controller=uniqueCouponCodeCSVUploadController><button flow-btn class=\"btn btn-default\"><i class=\"fa fa-upload\"></i> {{ 'projectsIncentives.show.batchRegisterCsv' | translate }}</button></div><div>* <span><a target=_self href=/assets/csv/unique_coupon_code_sample.csv download=/assets/csv/unique_coupon_code_sample.csv><i class=\"fa fa-download\"></i> {{ 'projectsIncentives.show.sampleCsvFile' | translate }}</a></span><br>* <span>{{ 'projectsIncentives.show.characterEncoding' | translate }}</span><br>* <span>{{ 'projectsIncentives.show.uploadLimit' | translate }}</span></div></div></div><span class=incentive_strong>{{incentive.coupon_code}}</span></td></tr><tr ng-if=\"incentive.incentive_type !== 'botbonnie_short_url'\"><th>{{ 'projectsIncentives.show.discountDetails' | translate }}</th><td><ul><li ng-if=\"incentive.discount_type === 'price'\"><span translate=projectsIncentives.show.flatRateDiscount translate-value-amount=\"{{discount_price | zcCurrency: currency.symbol:currency.fractionSize:currency.suffix}}\" class=incentive_strong></span></li><li ng-if=\"incentive.discount_type === 'percent'\"><span translate=projectsIncentives.show.fixedRateDiscount translate-value-amount={{incentive.discount_percent}} class=incentive_strong></span></li><li ng-if=\"incentive.discount_type === 'none'\">{{ 'projectsIncentives.show.noDiscount' | translate }}</li></ul></td></tr><tr ng-if=\"(incentive.is_free_shipping || incentive.is_novelty) && incentive.incentive_type !== 'botbonnie_short_url'\"><th>{{ 'projectsIncentives.show.otherBenefits' | translate }}</th><td><ul><li ng-if=incentive.is_free_shipping><span class=incentive_strong>{{ 'projectsIncentives.show.freeShipping' | translate }}</span></li><li ng-if=incentive.is_novelty>{{ 'projectsIncentives.show.others' | translate }}</li></ul></td></tr><tr ng-if=\"incentive.incentive_type !== 'botbonnie_short_url'\"><th>{{ 'projectsIncentives.show.termsOfUse' | translate }}</th><td><ul><li translate=projectsIncentives.show.memberOnlyLimit translate-value-strong=\"<span class='incentive_strong'>{{ 'projectsIncentives.show.memberOnlyLimitStrong' | translate }}</span>\" ng-if=incentive.has_member_only_limit></li><li translate=projectsIncentives.show.hasUsageLimit translate-value-strong=\"<span class='incentive_strong'>{{ 'projectsIncentives.show.hasUsageLimitStrong' | translate }}</span>\" ng-if=incentive.has_usage_limit></li><li translate=projectsIncentives.show.hasPriceLimit translate-value-strong=\"<span class='incentive_strong'>{{currency.symbol}}{{minimum_price | number}}{{currency.suffix}}{{ 'projectsIncentives.show.purchaseTaxInclude' | translate }}</span>\" ng-if=incentive.has_price_limit></li></ul></td></tr><tr><th>{{ 'projectsIncentives.show.expireDate' | translate }}</th><td><zc-date-range start-at=incentive.start_at end-at=incentive.end_at is-infinite=incentive.is_infinite display-time=false></zc-date-range></td></tr><tr><th>{{ 'projectsIncentives.show.otherNotes' | translate }}</th><td><span ng-if=!incentive.memo>{{ 'projectsIncentives.show.noSpecialNotes' | translate }}</span> {{incentive.memo}}</td></tr></tbody></table></div></div><div class=section><zc-unique-coupon-code-list project=currentProject incentive=incentive ng-if=\"incentive.incentive_type=='unique_coupon_code'\"></zc-unique-coupon-code-list></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

var path = '/templates/projects.incentives/unique_coupon_code_list.html';
var html = "<div class=row><div class=\"text-center muted\" ng-if=!uniqueCouponCodes.length>{{ 'projectsIncentives.uniqueCouponCodeList.couponNotRegister' | translate }}</div><div class=col-md-10 ng-if=uniqueCouponCodes.length><h3>{{ 'projectsIncentives.uniqueCouponCodeList.codeList' | translate }} <button ng-disabled=!uniqueCouponCodes.length ng-csv=getCSV filename={{csvFileName}} class=\"btn btn-default\">{{ 'projectsIncentives.uniqueCouponCodeList.couponCodeCsvDownload' | translate }}</button></h3><p><ng-container translate=projectsIncentives.uniqueCouponCodeList.couponList translate-value-total={{uniqueCouponCodes.length}} translate-value-visible=\"{{visibleItemCount < uniqueCouponCodes.length ? visibleItemCount : uniqueCouponCodes.length}}\"></ng-container></p><table class=\"table clearance-item-table table-bordered\"><tr><th>{{ 'projectsIncentives.uniqueCouponCodeList.code' | translate }}</th><th>{{ 'projectsIncentives.uniqueCouponCodeList.delivered' | translate }}</th><th>{{ 'projectsIncentives.uniqueCouponCodeList.deliveryDate' | translate }}</th></tr><tr ng-repeat=\"uniqueCouponCode in uniqueCouponCodes | limitTo:visibleItemCount\"><td>{{uniqueCouponCode.coupon_code}}</td><td><i class=\"fa fa-check-circle text-success\" ng-if=uniqueCouponCode.assigned_at></i></td><td><span ng-if=uniqueCouponCode.assigned_at>{{uniqueCouponCode.assigned_at | zcDate : {smart: true} }}</span></td></tr></table><button class=\"btn btn-default btn-block mb20\" ng-click=\"visibleItemCount = visibleItemCount + countPerLoad\" ng-show=\"visibleItemCount < uniqueCouponCodes.length\"><span translate=projectsIncentives.uniqueCouponCodeList.moreCode translate-value-count=\"{{ countPerLoad }}\"></span></button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_conversion_price.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsIw.conversionPrice.ruikei_keiyu_uriage' | translate }}</h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-5 col-md-offset-1\"><dl><dt><span class=text-blue>{{ 'projectsIw.conversionPrice.conversionPriceData' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.conversionPrice.ue_de_aitemu' | translate }}\"></i></dt><dd class=text-blue>{{ $ctrl.total.iw_click_item.conversion_price | number }} <span class=unit>円</span></dd><dt translate=projectsIw.conversionPrice.saito_zentai_no translate-value-rate=\"{{ $ctrl.total.sales_rate | number : 1 }}\"></dt></dl></div><div class=col-md-6><dl><dt>{{ 'projectsIw.conversionPrice.kuupon_hyouji_no' | translate }} <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.conversionPrice.nokuupon_ga_uchi' | translate }}\"></i></dt><dd class=text-bad>{{ $ctrl.total.iw_click_item.conversion_price_with_campaign_rate | number : 1 }} <span class=unit>%</span></dd><dt>{{ $ctrl.total.iw_click_item.conversion_price_with_campaign | number }} {{ 'projectsIw.conversionPrice.sesshon' | translate }}</dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsIw.conversionPrice.ue_no_aitemu' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_conversion_rate.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsIw.conversionRate.conversionUpRate' | translate }}</h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-11 col-md-offset-1\"><dl><dt class=text-blue>{{ 'projectsIw.conversionRate.conversionUpRate' | translate }}</dt><dd class=text-blue>{{ $ctrl.total.conversion_up_rate | number : 0 }} <span class=unit>%</span></dd><dt>{{ $ctrl.total.iw_use.conversion_rate | number : 1 }} % {{ 'projectsIw.conversionRate.iwUseCvr' | translate }} / {{ $ctrl.total.no_iw_use.conversion_rate | number : 1 }} % {{ 'projectsIw.conversionRate.noIwUseCvr' | translate }}</dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsIw.conversionRate.footNote' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_items.html';
var html = "<div class=container id=campaign-detail><section><campaign-filter-view filters=$ctrl.filters project=$ctrl.project update=$ctrl.updateFilters() reset=$ctrl.resetFilters() hide-search-term=true hide-campaign-segment-id=true></campaign-filter-view></section><section><zc-iw-navigation project=$ctrl.project></zc-iw-navigation></section><section><div class=row ng-if=\"$ctrl.items && $ctrl.items.length === 0\"><div class=col-sm-12><p>{{ 'projectsIw.items.noData' | translate }}</p></div></div><div class=campaign-detail-items ng-if=\"$ctrl.items && $ctrl.items.length >= 1\"><div class=row><div class=col-md-6><h6>{{ 'projectsIw.items.highInterestItems' | translate }}</h6></div><div class=col-md-6><button type=button class=\"btn btn-sm btn-default pull-right\" ng-csv=$ctrl.getCSV() csv-header=$ctrl.csvHeaders filename=interest_widget_report.csv add-bom=true charset=utf-16 field-separator=\\t><i class=\"fa fa-cloud-download\"></i> {{ 'projectsIw.items.csvDownload' | translate }}</button></div></div><div class=row><div class=col-md-12><ul class=\"list-unstyled campaign-detail-items-list\"><li><div class=\"row text-bad\"><div class=\"col-md-8 col-md-offset-1\">{{ 'projectsIw.items.title' | translate }}<br>{{ 'projectsIw.items.url' | translate }}</div><div class=\"col-md-1 text-center\">{{ 'projectsIw.items.price' | translate }}</div><div class=\"col-md-2 text-center\">{{ 'projectsIw.items.interestBrowsingRate' | translate }}<br>{{ 'projectsIw.items.interestsOverViews' | translate }}</div></div></li><li ng-repeat=\"item in $ctrl.items | limitTo : $ctrl.itemsPerPage : $ctrl.beginItem\"><div class=row><div class=col-md-1><img ng-src=\"{{ item.thumbnail_url }}\"></div><div class=col-md-8>{{ item.title }}<br><a class=text-bad target=_blank ng-href={{item.url}}>{{ item.url }}</a></div><div class=\"col-md-1 text-center\">{{ item.price | number : 0 }} 円</div><div class=\"col-md-2 text-center\">{{ item.iw_item_rate * 100 | number : 1 }} %<br><span class=text-bad>({{ item.iw_item_count | number }}/{{ item.item_count | number }} PV)</span></div></div></li></ul></div></div><div class=row><div class=\"col-md-12 text-center\"><ul class=campaign-detail-items-pagination pagination total-items=$ctrl.items.length max-size=3 previous-text=&lsaquo; next-text=&rsaquo; ng-model=$ctrl.page ng-change=$ctrl.pageChanged()></ul></div></div></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_main_comparison.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title><div class=row><div class=col-md-3><select class=form-control ng-model=$ctrl.filters.iw_graph_option_value ng-change=$ctrl.updateData() ng-options=\"opt as opt.label for opt in $ctrl.iwGraphOptions\"></select></div></div></h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-3 col-md-offset-3\"><dl><dt><span class=text-blue>{{ 'projectsIw.mainComparison.iwUseData' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.mainComparison.popOver' | translate }}\"></i></dt><dd class=text-blue>{{ $ctrl.total.iw_use[$ctrl.filters.iw_graph_option_value.name] | number : $ctrl.filters.iw_graph_option_value.decimal }} <span class=unit>{{ $ctrl.filters.iw_graph_option_value.unit }}</span></dd></dl></div><div class=col-md-3><dl><dt>{{ 'projectsIw.mainComparison.noIwUseData' | translate }}</dt><dd class=text-bad>{{ $ctrl.total.no_iw_use[$ctrl.filters.iw_graph_option_value.name] | number : $ctrl.filters.iw_graph_option_value.decimal }} <span class=unit>{{ $ctrl.filters.iw_graph_option_value.unit }}</span></dd></dl></div></div><div><highchart config=$ctrl.chartConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_navigation.html';
var html = "<ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=\"admin.projects.iw.report({projectId: $ctrl.project.id})\"><i class=\"fa fa-bar-chart\"></i> {{ 'projectsIw.navigation.deliveryReport' | translate }}</a></li><li ui-sref-active=active><a ui-sref=\"admin.projects.iw.items({projectId: $ctrl.project.id})\"><i class=\"fa fa-barcode\"></i> {{ 'projectsIw.navigation.itemReport' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_report.html';
var html = "<div class=container id=campaign-detail><section><campaign-filter-view filters=$ctrl.filters project=$ctrl.project update=$ctrl.updateFilters() reset=$ctrl.resetFilters() hide-search-term=true hide-campaign-segment-id=true></campaign-filter-view></section><section><zc-iw-navigation project=$ctrl.project></zc-iw-navigation></section><section><div class=row ng-if=\"$ctrl.total && !$ctrl.total.iw_started.session_count\"><div class=col-sm-12><p>{{ 'projectsIw.report.noData' | translate }}</p></div></div><div class=campaign-detail-report ng-if=\"$ctrl.total && $ctrl.total.iw_started.session_count\"><div class=kpi-container ng-show=\"$ctrl.project.iw_fixed_monthly_invoice_amount_for_sp || $ctrl.project.iw_fixed_monthly_invoice_amount_for_pc\"><div class=\"kpi-container-box text-center\"><p class=kpi-container-box-title><div class=row><div class=col-md-3><dl><dt>{{ 'projectsIw.report.conversionPriceData' | translate }} <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.report.conversionPriceDataNote' | translate }}\"></i></dt><dd>{{ $ctrl.total.iw_click_item.conversion_price | number : 0 }} <span class=unit>円</span></dd><dt translate=projectsIw.report.allSiteSalesRate translate-value-rate=\"{{ $ctrl.total.sales_rate | number : 1 }}\"></dt></dl></div><div class=col-md-1><dl><dt>&nbsp;</dt><dd>÷</dd><dt>&nbsp;</dt></dl></div><div class=col-md-3><dl><dt>{{ 'projectsIw.report.approximateUsageFee' | translate }} <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.report.approximateUsageFeeNote' | translate }}\"></i></dt><dd>{{ $ctrl.current_billing | number : 0 }} <span class=unit>円</span></dd><dt translate=projectsIw.report.iwFixedMonthlyInvoiceAmount translate-value-amount=\"{{ $ctrl.iwFixedMonthlyInvoiceAmount || 0 | number : 0 }} 円\"></dt></dl></div><div class=col-md-1><dl><dt>&nbsp;</dt><dd>=</dd><dt>&nbsp;</dt></dl></div><div class=col-md-3><dl><dt>{{ 'projectsIw.report.costEffectiveness' | translate }} <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.report.costEffectivenessNote' | translate }}\"></i></dt><dd>{{ $ctrl.costEffectiveness | number : 0 }} <span class=unit>%</span></dd><dt translate=projectsIw.report.costRate translate-value-rate=\"{{ $ctrl.costRate | number : 1 }} %\"></dt></dl></div></div></p></div></div><div class=\"alert alert-warning\" ng-if=$ctrl.showBetaAlert><i class=\"fa fa-exclamation-triangle\"></i> {{ 'projectsIw.report.beta' | translate }}</div><div class=row><div class=col-md-12><zc-iw-main-comparison project=$ctrl.project filters=$ctrl.filters></zc-iw-main-comparison></div></div><div class=row><div class=col-md-6><zc-iw-conversion-rate project=$ctrl.project filters=$ctrl.filters></zc-iw-conversion-rate></div><div class=col-md-6><zc-iw-conversion-price project=$ctrl.project filters=$ctrl.filters></zc-iw-conversion-price></div></div><div class=row><div class=col-md-6><zc-iw-started-rate project=$ctrl.project filters=$ctrl.filters></zc-iw-started-rate></div><div class=col-md-6><zc-iw-use-rate project=$ctrl.project filters=$ctrl.filters></zc-iw-use-rate></div></div><div class=row><div class=col-md-6><zc-iw-segment-rate project=$ctrl.project filters=$ctrl.filters></zc-iw-segment-rate></div><div class=col-md-6><zc-iw-utm-medium-rate project=$ctrl.project filters=$ctrl.filters></zc-iw-utm-medium-rate></div></div><div class=notifications><h2>{{ 'projectsIw.report.userSalesDifference' | translate }}</h2><p>{{ 'projectsIw.report.userSalesDifference1' | translate }}<br>{{ 'projectsIw.report.userSalesDifference2' | translate }}</p></div></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_segment_rate.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsIw.segmentRate.userSegmentRate' | translate }}</h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=col-md-4><dl><dt class=text-blue>{{ 'projectsIw.segmentRate.nocvSessionRate' | translate }}</dt><dd class=text-blue>{{ $ctrl.total.iw_use.nocv_session_rate | number : 1 }} <span class=unit>%</span></dd><dt>{{ $ctrl.total.iw_use.nocv_session_count | number }} {{ 'projectsIw.segmentRate.session' | translate }}</dt></dl></div><div class=col-md-4><dl><dt>{{ 'projectsIw.segmentRate.onecvSessionRate' | translate }}</dt><dd class=text-bad>{{ $ctrl.total.iw_use.onecv_session_rate | number : 1 }} <span class=unit>%</span></dd><dt>{{ $ctrl.total.iw_use.onecv_session_count | number }} {{ 'projectsIw.segmentRate.session' | translate }}</dt></dl></div><div class=col-md-4><dl><dt class=text-success>{{ 'projectsIw.segmentRate.loyalSessionRate' | translate }}</dt><dd class=text-success>{{ $ctrl.total.iw_use.loyal_session_rate | number : 1 }} <span class=unit>%</span></dd><dt>{{ $ctrl.total.iw_use.loyal_session_count | number }} {{ 'projectsIw.segmentRate.session' | translate }}</dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsIw.segmentRate.footNote' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_started_rate.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsIw.startedRate.userSessionAndRate' | translate }}</h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-5 col-md-offset-1\"><dl><dt><span class=text-blue>{{ 'projectsIw.startedRate.deliverySessionCount' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.startedRate.deliverySessionCountNote' | translate }}\"></i></dt><dd class=text-blue>{{ $ctrl.total.iw_started.session_count | number }} <span class=unit>{{ 'projectsIw.startedRate.session' | translate }}</span></dd></dl></div><div class=col-md-6><dl><dt>{{ 'projectsIw.startedRate.deliveryRate' | translate }}</dt><dd class=text-bad>{{ $ctrl.total.iw_started_rate | number : 1 }} <span class=unit>%</span></dd></dl></div></div><div class=row style=margin-bottom:10px;><div class=\"col-md-11 col-md-offset-1\"><dl><dt>{{ $ctrl.total.all.session_count | number }} {{ 'projectsIw.startedRate.sessionInProgress' | translate }}</dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsIw.startedRate.footNote' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_use_rate.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsIw.useRate.userSession' | translate }}</h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-5 col-md-offset-1\"><dl><dt><span class=text-blue>{{ 'projectsIw.useRate.sessionCount' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" popover=\"{{ 'projectsIw.useRate.sessionCountNote' | translate }}\"></i></dt><dd class=text-blue>{{ $ctrl.total.iw_use.session_count | number }} <span class=unit>{{ 'projectsIw.useRate.session' | translate }}</span></dd></dl></div><div class=col-md-6><dl><dt>{{ 'projectsIw.useRate.deliveryRate' | translate }}</dt><dd class=text-bad>{{ $ctrl.total.iw_use_rate | number : 1 }} <span class=unit>%</span></dd></dl></div></div><div class=row style=margin-bottom:10px;><div class=\"col-md-11 col-md-offset-1\"><dl><dt>{{ $ctrl.total.iw_started.session_count | number }} {{ 'projectsIw.useRate.sessionInProgress' | translate }}</dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsIw.useRate.footNote' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

var path = '/templates/projects.iw/iw_utm_medium_rate.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projectsIw.utmMediumRate.utnMediumParameter' | translate }}</h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div ng-class=\"{'col-md-4': ($ctrl.utmMediumData.length >= 3), 'col-md-6': ($ctrl.utmMediumData.length === 2), 'col-md-12': ($ctrl.utmMediumData.length === 1)}\" ng-repeat=\"d in $ctrl.utmMediumData.slice(0, 3) track by $index\"><dl><dt ng-class=\"{'text-blue': ($index === 0), 'text-bad': ($index === 1), 'text-success': ($index === 2)}\">{{ d.key }}</dt><dd ng-class=\"{'text-blue': ($index === 0), 'text-bad': ($index === 1), 'text-success': ($index === 2)}\">{{ d.rate | number : 1 }} <span class=unit>%</span></dd><dt>{{ d.count }} {{ 'projectsIw.utmMediumRate.session' | translate }}</dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div><div class=\"panel-footer text-small\">{{ 'projectsIw.utmMediumRate.footNote' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

var path = '/templates/projects.reports/list.html';
var html = "<div class=content id=report-list><div class=container><h1>{{ 'projectsReports.list.tsukibetsu_repooto_ichiran' | translate }}</h1><section class=report-container><div class=text-center ng-if=\"reports.length == 0\"><h1 class=\"text-bad text-center\">{{ 'projectsReports.list.gaitou_sururepooto_ga' | translate }}</h1></div><table class=\"table table-bordered campaign-table\"><thead><tr><th style=width:100px>{{ 'sharedModules.dateTimeFormats.yearAndMonth' | translate }}</th><th style=width:100px>{{ 'projectsReports.list.keiyaku_joukyou' | translate }}</th><th style=width:170px>{{ 'projectsReports.list.shuukei_joukyou' | translate }}</th><th class=text-right>{{ 'projectsReports.list.jisshi_kyanpeen_kazu' | translate }}</th><th class=text-right>{{ 'projectsReports.list.kyanpeen_haishin_kazu' | translate }}</th><th class=text-right ng-if=\"!Project.isZenClerkLP() && isAb\">{{ 'projectsReports.list.kakutoku_kingaku' | translate }}</th><th class=text-right ng-if=\"Project.isZenClerkLP() && isAb\">{{ 'projectsReports.list.kakutoku_cv_kazu' | translate }}</th><th class=text-right ng-if=!Project.isZenClerkLP()>{{ 'projectsReports.list.keiyu_uriage' | translate }}</th><th class=text-right ng-if=Project.isZenClerkLP()>{{ 'projectsReports.list.keiyu_cv_kazu' | translate }}</th><th class=text-right>{{ 'projectsReports.list.seikyuu_kingaku' | translate }}</th><th>{{ 'projectsReports.list.shousai' | translate }}</th></tr></thead><tbody ng-if=\"daily_reports.contracted || daily_reports.trial\" ng-repeat=\"status in ['contracted', 'trial']\" ng-init=\"report = daily_reports[status]\"><tr class=warning ng-if=report><td>{{ report.begin_at | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</td><td><zc-label-report-status report=report></zc-label-report-status></td><td><span class=\"label label-segment-all\">{{ 'projectsReports.list.sokuhou' | translate }}</span> ({{ report.start_at | zcDate: { format: 'MM/dd' } }}{{ 'projectsReports.list.jiten' | translate }})</td><td class=text-right><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.campaign_count | number:0}}</span> <span class=unit>{{ 'projectsReports.list.kyanpeen' | translate }}</span></td><td class=text-right><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.delivery_count | number:0}}</span> <span class=unit>{{ 'projectsReports.list.sesshon' | translate }}</span></td><td class=text-right ng-if=\"!Project.isZenClerkLP() && isAb\"><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.contribution_price | zcCurrency : '' : currency.fractionSize}}</span> <span class=unit>{{currency.suffix}}</span></td><td class=text-right ng-if=\"Project.isZenClerkLP() && isAb\"><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.contribution_count}}</span> <span class=unit>{{ 'projectsReports.list.cv' | translate }}</span></td><td class=text-right ng-if=!Project.isZenClerkLP()><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{ report.all_experimental.conversion_price | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</span></td><td class=text-right ng-if=Project.isZenClerkLP()><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{ report.all_experimental.conversion_count | number : 0 }}</span> <span class=unit>{{ 'projectsReports.list.cv' | translate }}</span></td><td class=text-right><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.invoice_amount | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</span></td><td><button type=button class=\"btn btn-sm btn-default pull-right btn-block\" ng-click=showReport(report)>{{ 'projectsReports.list.shousai' | translate }}</button></td></tr></tbody><tbody ng-repeat=\"status in ['contracted', 'trial']\"><tr ng-repeat=\"report in monthly_reports[status]\" ng-class=\"{'active' : report.status == 'trial'}\"><td>{{ report.begin_at | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</td><td><zc-label-report-status report=report></zc-label-report-status></td><td><span class=\"label label-segment-new\">{{ 'projectsReports.list.kakutei' | translate }}</span></td><td class=text-right><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.campaign_count | number:0}}</span> <span class=unit>{{ 'projectsReports.list.kyanpeen' | translate }}</span></td><td class=text-right><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.delivery_count | number:0}}</span> <span class=unit>{{ 'projectsReports.list.sesshon' | translate }}</span></td><td class=text-right ng-if=\"!Project.isZenClerkLP() && isAb\"><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.contribution_price | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</span></td><td class=text-right ng-if=\"Project.isZenClerkLP() && isAb\"><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{report.contribution_count}}</span> <span class=unit>{{ 'projectsReports.list.cv' | translate }}</span></td><td class=text-right ng-if=!Project.isZenClerkLP()><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{ report.all_experimental.conversion_price | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</span></td><td class=text-right ng-if=Project.isZenClerkLP()><span ng-class=\"{'text-blue': report.campaign_count > 0}\">{{ report.all_experimental.conversion_count | number : 0 }}</span> <span class=unit>{{ 'projectsReports.list.cv' | translate }}</span></td><td class=text-right><span ng-class=\"{'text-blue': report.campaign_count > 0}\" ng-if=canShowInvoiceAmount(report.begin_at)>{{ report.invoice_amount | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</span> <span ng-if=!canShowInvoiceAmount(report.begin_at)>-</span></td><td><button type=button class=\"btn btn-sm btn-default pull-right btn-block\" ng-click=showReport(report)>{{ 'projectsReports.list.shousai' | translate }}</button></td></tr></tbody></table></section></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

var path = '/templates/projects.reports/report_graph.html';
var html = "<section ng-if=chartConfig.series[0].data.length><h1>{{ 'projectsReports.reportGraph.kakutoku_uriage_suii' | translate }}</h1><highchart config=chartConfig></highchart></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

var path = '/templates/projects.reports/show.html';
var html = "<div class=content id=report-detail><div class=container><section class=controller><div class=pull-right><a ng-click=showList()>{{ 'projectsReports.show.ichiran_ni_modoru' | translate }}</a> <a ng-click=showPrevMonth() ng-disabled=!report><i class=\"fa fa-angle-double-left\"></i> {{ prevMonth | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</a> | <a ng-click=showNextMonth() ng-if=!isLatest>{{ nextMonth | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }} <i class=\"fa fa-angle-double-right\"></i></a></div></section><div ng-if=report><div></div><div class=row><div class=col-md-12><h1><span class=\"label label-danger\" ng-if=isLatest>{{ 'projectsReports.show.sokuhouchi' | translate }}</span><zc-label-report-status report=report></zc-label-report-status>{{currentProject.title}} - {{ report.begin_at | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }} {{ 'projectsReports.show.repooto' | translate }} <span ng-if=isLatest>({{ report.start_at | zcDate: { format: 'MM/dd' } }}{{ 'projectsReports.show.made_no_deeta' | translate }})</span></h1></div></div><section class=\"kpi-container kpi-bordered\"><div class=row><div class=\"col-xs-6 border-right\" ng-class=\"{'col-sm-2': isAb, 'col-sm-3': !isAb}\"><dl><dt>{{ 'projectsReports.show.jisshi_kyanpeen_kazu' | translate }}</dt><dd>{{report.campaign_count}}<span class=unit>{{ 'projectsReports.show.kyanpeen' | translate }}</span></dd></dl></div><div class=\"col-sm-3 col-xs-6 border-right\"><dl><dt>{{ 'projectsReports.show.haishin_mono_kazu' | translate }}</dt><dd>{{report.delivery_count | number:0}}<span class=unit>{{ 'projectsReports.show.sesshon' | translate }}</span></dd></dl></div><div class=\"col-sm-3 col-xs-6 border-right\" ng-if=\"!Project.isZenClerkLP() && isAb\"><dl><dt>{{ 'projectsReports.show.kakutoku_kingaku' | translate }}</dt><dd>{{report.contribution_price | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</dd></dl></div><div class=\"col-sm-3 col-xs-6 border-right\" ng-if=\"Project.isZenClerkLP() && isAb\"><dl><dt>{{ 'projectsReports.show.kakutoku_cv_kazu' | translate }}</dt><dd>{{report.contribution_count }} <span class=unit>{{ 'projectsReports.show.cv' | translate }}</span></dd></dl></div><div ng-if=!Project.isZenClerkLP() class=\"col-xs-6 border-right\" ng-class=\"{'col-sm-2': isAb, 'col-sm-3': !isAb}\"><dl><dt>{{ 'projectsReports.show.keiyu_uriage' | translate }}</dt><dd>{{ report.all_experimental.conversion_price | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</dd></dl></div><div ng-if=Project.isZenClerkLP() class=\"col-xs-6 border-right\" ng-class=\"{'col-sm-2': isAb, 'col-sm-3': !isAb}\"><dl><dt>{{ 'projectsReports.show.keiyu_cv_kazu' | translate }}</dt><dd>{{ report.all_experimental.conversion_count | number : 0 }} <span class=unit>{{ 'projectsReports.show.cv' | translate }}</span></dd></dl></div><div class=col-xs-6 ng-class=\"{'col-sm-2': isAb, 'col-sm-3': !isAb}\" ng-if=\"!Project.isZenClerkLP() || can_show_zenclerk_lp_invoice_amount\"><dl><dt><i class=\"fa fa-lock\" ng-if=Project.isZenClerkLP()></i> {{ 'projectsReports.show.seikyuu_kingaku' | translate }}</dt><dd>{{report.invoice_amount | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix }}</dd></dl></div></div></section><section class=report-detail-list><div class=row><div class=col-md-6><h1>{{ 'projectsReports.show.taishou_kyanpeen_ichiran' | translate }}</h1></div><div class=col-md-6><zc-download-monthly-report-button project=currentProject campaigns=campaigns filters=filters status=status class=pull-right is-latest=isLatest is-ab=isAb></zc-download-monthly-report-button></div></div><div class=table-responsive campaign-table project=currentProject campaigns=campaigns filters=filters show-stats=true is-report=true is-ab=isAb can-show-invoice-amount=can_show_zenclerk_lp_invoice_amount status=status></div><p class=\"text-mute text-center\" ng-if=\"currentProject.apikey !== 'giftmall' && isAb\">[ <span ng-if=!Project.isZenClerkLP()>{{ 'projectsReports.show.kakutoku_kingaku' | translate }}</span> <span ng-if=Project.isZenClerkLP()>{{ 'projectsReports.show.kakutoku_cv_kazu' | translate }}</span> {{ 'projectsReports.show.no_keisanshiki_hyouji' | translate }} <span ng-if=!Project.isZenClerkLP()>{{ 'projectsReports.show.hyouji_guruupu_no_kingaku' | translate }}</span> <span ng-if=Project.isZenClerkLP()>{{ 'projectsReports.show.hyouji_guruupu_no_kazu' | translate }}</span> ]</p><p class=\"text-mute text-center\" ng-if=\"currentProject.apikey !== 'giftmall' && isAb\">{{ 'projectsReports.show.jouki_no_tsu' | translate }}</p></section><zc-report-graph project=currentProject filters=filters is-latest=isLatest ng-if=isAb></zc-report-graph></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_all.html';
var html = "<section class=form-horizontal></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_common.html';
var html = "<div class=segment-maker><div class=\"section mb20\"><h1>{{ 'projectsSegments.campaignSegmentEditCommon.pageTitle' | translate: { segmenttype: getPageTitle(segment.segment_type) } }}</h1></div><h4>{{ 'projectsSegments.campaignSegmentEditCommon.segumento_na_no' | translate }}</h4><div class=row><div class=col-md-8><div class=form-horizontal><div class=form-group><div class=col-sm-12><input type=text class=form-control required ng-model=segment.name></div></div></div><ng-include src=getTemplateUrl()></ng-include><section><zc-campaign-segment-options segment=segment project=project></zc-campaign-segment-options></section><section zc-master-only><h4><i class=\"fa fa-lock\"></i> {{ 'projectsSegments.campaignSegmentEditCommon.kasutamukuerii' | translate }}</h4><div><zc-campaign-segment-editor project=project campaign-segment=segment></zc-campaign-segment-editor></div></section><section class=form-horizontal><div class=form-group><label class=\"col-sm-3 control-label\">{{ 'projectsSegments.campaignSegmentEditCommon.bikou' | translate }}</label><div class=col-sm-9><textarea class=form-control ng-model=segment.description ng-required=segment.ruleView>\n            </textarea><p ng-if=\"segment.ruleView && !segment.description\" class=text-danger>{{ 'projectsSegments.campaignSegmentEditCommon.noteWarning' | translate }}</p></div></div></section></div><div class=col-md-4><zc-segment-estimated-visitors fixed-on-scroll segment=segment project=project></zc-segment-estimated-visitors></div></div><div class=row><div class=col-sm-8><div class=\"panel panel-warning\" ng-if=\"segment.segment_type != 'custom_old'\"><div class=panel-heading><div class=panel-title>{{ 'projectsSegments.campaignSegmentEditCommon.chuui_shiborikomi' | translate }}</div></div></div></div></div><div class=row ng-show=Devise.isMaster()><div class=col-sm-8><div class=\"btn btn-default pull-right\" ng-click=\"detailsVisible = !detailsVisible\"><i class=fa ng-class=\"{ 'fa-arrow-up': detailsVisible, 'fa-arrow-down': !detailsVisible, }\"></i> {{ 'projectsSegments.campaignSegmentEditCommon.jouken' | translate }}</div></div><div class=col-md-12 ng-show=detailsVisible><h4>{{ 'projectsSegments.campaignSegmentEditCommon.kuerii' | translate }}</h4><segment-condition-table segments=segment multiple=false show-nulls=true></segment-condition-table></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_custom.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_cv_users.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentEditCvUsers.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td>{{ 'projectsSegments.campaignSegmentEditCvUsers.kako_no_kounyuu' | translate }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_inactive.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentEditInactive.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td>{{ 'projectsSegments.campaignSegmentEditInactive.kai_ijou_kounyuu' | translate }}) <input type=number ng-model=segment.conditions_json.days_since_last_conversion ng-min=30 style=width:50px required> {{ 'projectsSegments.campaignSegmentEditInactive.hi_ijou_saki' | translate }})</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_new.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentEditNew.kihonjouken' | translate }}</h4><input type=hidden ng-model=project.installed_at name=installed_at required> <input type=hidden ng-model=project.session_count_evaluator name=session_count_evaluator required><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td ng-show=\"project.installed_at && project.session_count_evaluator\"><div>{{ 'projectsSegments.campaignSegmentEditNew.hitsuji_kounyuu_yuuzaa' | translate: { installedat: (project.installed_at | zcDate) } }}</div><p class=form-description>{{ 'projectsSegments.campaignSegmentEditNew.jouki_nichiji_wa' | translate }}</p><p class=form-description>{{ 'projectsSegments.campaignSegmentEditNew.houmon_kaisuu_hantei' | translate: { sessioncountevaluator: project.session_count_evaluator } }}</p></td><td ng-hide=\"project.installed_at && project.session_count_evaluator\" class=danger><div ng-hide=project.installed_at>{{ 'projectsSegments.campaignSegmentEditNew.dounyuu_kanryou_nichiji' | translate }} <a ui-sref=\"admin.projects.settings.initialization({projectId: project.id})\" target=_blank class=\"btn btn-xs btn-primary\">{{ 'projectsSegments.campaignSegmentEditNew.tagu_no_setchi' | translate }}</a></div><div ng-hide=project.session_count_evaluator>{{ 'projectsSegments.campaignSegmentEditNew.houmon_kaisuu_hantei' | translate }} <a ui-sref=\"admin.projects.settings.initialization.session_count_evaluator({projectId: project.id})\" target=_blank class=\"btn btn-xs btn-primary\">{{ 'projectsSegments.campaignSegmentEditNew.houmon_kaisuu_hantei' | translate }}</a></div></td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_edit_new_inverse.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentEditNewInverse.kihonjouken' | translate }}</h4><input type=hidden ng-model=project.installed_at name=installed_at required> <input type=hidden ng-model=project.session_count_evaluator name=session_count_evaluator required><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td ng-show=\"project.installed_at && project.session_count_evaluator\">{{ 'projectsSegments.campaignSegmentEditNewInverse.ikkai_ijou_kounyuu' | translate:{ installedat: (project.installed_at | zcDate) } }}<p class=form-description>{{ 'projectsSegments.campaignSegmentEditNewInverse.jouki_nichiji_wa' | translate }}</p><p class=form-description>{{ 'projectsSegments.campaignSegmentEditNewInverse.houmon_kaisuu_hantei' | translate: { sessioncountevaluator: project.session_count_evaluator } }}</p></td><td ng-hide=\"project.installed_at && project.session_count_evaluator\" class=danger><div ng-hide=project.installed_at>{{ 'projectsSegments.campaignSegmentEditNewInverse.dounyuu_kanryou_nichiji' | translate }} <a ui-sref=\"admin.projects.settings.initialization{projectId: project.id})\" target=_blank class=\"btn btn-xs btn-primary\">{{ 'projectsSegments.campaignSegmentEditNewInverse.tagu_no_setchi' | translate }}</a></div><div ng-hide=project.session_count_evaluator>{{ 'projectsSegments.campaignSegmentEditNewInverse.houmon_kaisuu_hantei' | translate }} <a ui-sref=\"admin.projects.settings.initialization.session_count_evaluator({projectId: project.id})\" target=_blank class=\"btn btn-xs btn-primary\">{{ 'projectsSegments.campaignSegmentEditNewInverse.houmon_kaisuu_hantei' | translate }}</a></div></td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_editor.html';
var html = "<div><div class=row><div class=col-sm-4><label>{{ 'projectsSegments.campaignSegmentEditor.visitor_deeta_e_nokuerii' | translate }}</label> <textarea class=\"form-control json-area\" ng-model=campaignSegment.visitor ng-readonly=readOnly ng-change=CampaignSegment.checkZcRule(campaignSegment)>\n      </textarea></div><div class=col-sm-4><label>{{ 'projectsSegments.campaignSegmentEditor.session_deeta_e_nokuerii' | translate }}</label> <textarea class=\"form-control json-area\" ng-model=campaignSegment.session ng-readonly=readOnly ng-change=CampaignSegment.checkZcRule(campaignSegment)>\n      </textarea></div><div class=col-sm-4><label>{{ 'projectsSegments.campaignSegmentEditor.shutsuryoku_sareru_jouken' | translate }}</label><p class=text-danger ng-if=campaignSegment.message>{{campaignSegment.message}}</p><textarea class=\"form-control json-area\" readonly ng-model=campaignSegment.ruleView>\n      </textarea></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_list.html';
var html = "<div class=table-responsive><table class=\"table campaign-table table-bordered\"><thead><tr><th class=campaign-table-id>ID</th><th>{{ 'projectsSegments.campaignSegmentList.segumento_na' | translate }}</th><th>{{ 'projectsSegments.campaignSegmentList.shiborikomi_jouken' | translate }}</th><th>{{ 'projectsSegments.campaignSegmentList.bikou' | translate }}</th><th class=campaign-table-date>{{ 'projectsSegments.campaignSegmentList.himotsuki_kyanpeen' | translate }}ID</th><th class=campaign-table-action></th></tr></thead><tbody><tr ng-repeat=\"campaign_segment in campaign_segments\"><td>{{campaign_segment.id}}</td><td><div><a ui-sref=\"admin.projects.segments.show({projectId: currentProject.id, segmentId: campaign_segment.id})\">{{campaign_segment.name}}</a><br><span class=text-small>{{ 'projectsSegments.campaignSegmentList.sakuseinichiji' | translate }}: {{campaign_segment.created_at | zcDate : { smart: true, dateOnly: true } }}</span> <span class=text-small ng-if=\"campaign_segment.created_at !== campaign_segment.updated_at\">{{ 'projectsSegments.campaignSegmentList.saishuukoushin_nichiji' | translate }}: {{campaign_segment.updated_at | zcDate : { smart: true, dateOnly: true } }}</span></div></td><td><zc-campaign-segment-flag segment=campaign_segment></zc-campaign-segment-flag></td><td class=text-small>{{campaign_segment.description}}</td><td>{{campaign_segment.campaign_ids.length}} <i class=\"fa pull-right\" style=\"cursor: pointer\" ng-if=\"::campaign_segment.campaign_ids.length > 0\" ng-init=\"campaign_segment._show_campaigns = false\" ng-click=\"campaign_segment._show_campaigns = !campaign_segment._show_campaigns\" ng-class=\"{'fa-chevron-down': !campaign_segment._show_campaigns, 'fa-chevron-up': campaign_segment._show_campaigns}\"></i><div class=text-small ng-show=campaign_segment._show_campaigns><a style=\"display: block;\" ng-repeat=\"campaign_id in ::campaign_segment.campaign_ids\" ui-sref=\"admin.projects.campaigns.show.stats({projectId: currentProject.id, campaignId: campaign_id})\">{{::campaign_id}}</a></div></td><td class=campaign-table-actions><span ng-show=masterFeaturesAllowed ng-if=\"masterFeaturesAllowed && campaign_segment.campaign_ids.length === 0 && campaign_segment.segment_type != 'custom_old'\" ui-sref=\"admin.projects.segments.edit({projectId: currentProject.id, segmentId: campaign_segment.id})\"><i class=\"fa fa-pencil\" tooltip=\"{{ 'projectsSegments.campaignSegmentList.segumento_wo_henshuu' | translate }}\"></i></span> <span ng-show=\"masterFeaturesAllowed && campaign_segment.segment_type != 'new_inverse'\" ng-click=copySegment(campaign_segment)><i class=\"fa fa-copy\" tooltip=\"{{ 'projectsSegments.campaignSegmentList.segumento_wo_kopiimasutaa' | translate }}\"></i></span> <span ng-if=\"masterFeaturesAllowed && !campaign_segment.campaign_ids.length === 0 && !campaign_segment.deprecated && campaign_segment.live_campaign_ids.length === 0\" confirm-modal confirm-click=invalidateSegment(campaign_segment)><i class=\"glyphicon glyphicon-trash\" tooltip=\"{{ 'projectsSegments.campaignSegmentList.segumento_wo_mukou' | translate }}\"></i></span> <span ng-if=\"masterFeaturesAllowed && campaign_segment.campaign_ids.length === 0\" confirm-modal confirm-click=removeSegment(campaign_segment)><i class=\"glyphicon glyphicon-trash\" tooltip=\"{{ 'projectsSegments.campaignSegmentList.sakujo_mishiyou_no' | translate }}\"></i></span></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_options.html';
var html = "<section ng-show=\"::segment.segment_type != 'custom_old'\"><div class=segment-omit><h4 ng-show=\"!showOnly || hasDetails()\">{{ 'projectsSegments.campaignSegmentOptions.shiborikomi_shousai_jouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\" ng-show=showOnly><tr ng-if=\"isAllowedCondition('advertising') && segment.conditions_json.advertising\"><th><span class=\"badge label-segment-exclude\" ng-show=\"segment.conditions_json.advertising == 'exclude'\">{{ 'projectsSegments.campaignSegmentOptions.koukoku_jogai' | translate }}</span><br><span class=\"badge label-segment-limit\" ng-show=\"segment.conditions_json.advertising == 'only'\">{{ 'projectsSegments.campaignSegmentOptions.koukoku_gentei' | translate }}</span></th><td><div class=segment-option-detail><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.koukoku_ryuunyuu_hantei' | translate }}</p><zc-advertisings-list project=project></zc-advertisings-list></div></td></tr><tr ng-if=\"isAllowedCondition('newsletter') && segment.conditions_json.newsletter\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.merumaga_jogai' | translate }}</span></th><td><div class=segment-option-detail><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.merumaga_ryuunyuu_no' | translate }}</p><zc-newsletter-parameters-list project=project></zc-newsletter-parameters-list></div></td></tr><tr ng-if=\"isAllowedCondition('logged_in') && segment.conditions_json.logged_in\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.roguin_jogai' | translate }}</span></th><td><div class=segment-option-detail><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.roguin_hantei' | translate }}</p><zc-login-evaluators-list project=project></zc-login-evaluators-list></div></td></tr><tr ng-if=\"isAllowedCondition('target_regions') && segment.conditions_json.target_regions\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.targetRegions' | translate }}</span></th><td><country-code-selector country-codes=segment.conditions_json.target_regions disabled=true></country-code-selector></td></tr><tr ng-if=\"isAllowedCondition('private_browsing') && segment.conditions_json.private_browsing\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.pb_jogai' | translate }}</span></th><td>{{ 'projectsSegments.campaignSegmentOptions.puraibeetoburaujingumoododeaku' | translate }}</td></tr><tr ng-if=\"isAllowedCondition('limit_to_landing_page_types') && segment.conditions_json.limit_to_landing_page_types[0] && segment.conditions_json.limit_to_landing_page_types[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.lp_gentei' | translate }}</span></th><td><p>{{ 'projectsSegments.campaignSegmentOptions.pataan_ni_settei_include' | translate: { pattern: segment.conditions_json.limit_to_landing_page_types[0] } }}</p><div><div ng-show=\"!currentLimitPageTypes.length && segment.conditions_json.limit_to_landing_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentLimitPageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.limit_to_landing_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentLimitPageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('exclude_landing_page_types') && segment.conditions_json.exclude_landing_page_types[0] && segment.conditions_json.exclude_landing_page_types[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.lp_jogai' | translate }}</span></th><td><p>{{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_landing_page_types[0] } }}</p><div><div ng-show=\"!currentExcludePageTypes.length && segment.conditions_json.exclude_landing_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentExcludePageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_landing_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentExcludePageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('limit_to_sessions_who_visit') && segment.conditions_json.limit_to_sessions_who_visit[0] && segment.conditions_json.limit_to_sessions_who_visit[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.limitToSessionsWhoVisit' | translate }}</span></th><td><p>{{ 'projectsSegments.campaignSegmentOptions.limitToSessionsWhoVisitPattern' | translate: { pattern: segment.conditions_json.limit_to_sessions_who_visit[0] } }}</p><div><div ng-show=\"!currentLimitToSessionsWhoVisit.length && segment.conditions_json.limit_to_sessions_who_visit[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentLimitToSessionsWhoVisit.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.limit_to_sessions_who_visit[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentLimitToSessionsWhoVisit\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('exclude_sessions_who_visit') && segment.conditions_json.exclude_sessions_who_visit[0] && segment.conditions_json.exclude_sessions_who_visit[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.excludeSessionsWhoVisit' | translate }}</span></th><td><p>{{ 'projectsSegments.campaignSegmentOptions.excludeSessionsWhoVisitPattern' | translate: { pattern: segment.conditions_json.exclude_sessions_who_visit[0] } }}</p><div><div ng-show=\"!currentExcludeSessionsWhoVisit.length && segment.conditions_json.exclude_sessions_who_visit[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentExcludeSessionsWhoVisit.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_sessions_who_visit[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentExcludeSessionsWhoVisit\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('limit_to_offer_page_types') && segment.conditions_json.limit_to_offer_page_types[0] && segment.conditions_json.limit_to_offer_page_types[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.ofaa_gentei' | translate }}</span></th><td><p>{{ 'projectsSegments.campaignSegmentOptions.pataan_ni_settei_offermodal_hyoujisuru' | translate: { pattern: segment.conditions_json.limit_to_offer_page_types[0] } }}</p><div><div ng-show=\"!currentLimitOfferPageTypes.length && segment.conditions_json.limit_to_offer_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentLimitOfferPageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.limit_to_offer_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentLimitOfferPageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('exclude_offer_page_types') && segment.conditions_json.exclude_offer_page_types[0] && segment.conditions_json.exclude_offer_page_types[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.ofaa_jogai' | translate }}</span></th><td><p>{{ 'projectsSegments.campaignSegmentOptions.pataan_ni_settei_offermodal_hyoujishinai' | translate: { pattern: segment.conditions_json.exclude_offer_page_types[0] } }}</p><div><div ng-show=\"!currentExcludeOfferPageTypes.length && segment.conditions_json.exclude_offer_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentExcludeOfferPageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_offer_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentExcludeOfferPageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('limit_to_visitor_segments') && segment.conditions_json.limit_to_visitor_segments\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.limitToVisitorSegments' | translate }}</span></th><td><visitor-segment-selector visitor-segment-ids=segment.conditions_json.limit_to_visitor_segments disabled=true></visitor-segment-selector></td></tr><tr ng-if=\"isAllowedCondition('exclude_visitor_segments') && segment.conditions_json.exclude_visitor_segments\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.excludeVisitorSegments' | translate }}</span></th><td><visitor-segment-selector visitor-segment-ids=segment.conditions_json.exclude_visitor_segments disabled=true></visitor-segment-selector></td></tr><tr ng-if=\"isAllowedCondition('triggers') && segment.conditions_json.triggers[0] && segment.conditions_json.triggers[0] != 'NOT_SELECTED'\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.haishin_torigaa' | translate }}</span></th><td><div ng-if=\"segment.conditions_json.triggers.indexOf('swipedown') >= 0\">{{ 'projectsSegments.campaignSegmentOptions.nakaguro_kahou_mukattehidari' | translate }}</div><div ng-if=\"segment.conditions_json.triggers.indexOf('history_back') >= 0\">{{ 'projectsSegments.campaignSegmentOptions.nakaguro_modoru_botannokurikku' | translate }} <span ng-if=\"segment.conditions_json.history_back_trigger_option === 'any_domain'\">({{ 'projectsSegments.campaignSegmentOptions.anyDomain' | translate }})</span> <span ng-if=\"segment.conditions_json.history_back_trigger_option === 'different_domain'\">({{ 'projectsSegments.campaignSegmentOptions.differentDomain' | translate }})</span></div><div ng-if=\"segment.conditions_json.triggers.indexOf('visibilitychange') >= 0\">{{ 'projectsSegments.campaignSegmentOptions.nakaguropeeji_ga_saido' | translate }}</div><div ng-if=\"segment.conditions_json.triggers.indexOf('inactive') >= 0\">{{ 'projectsSegments.campaignSegmentOptions.user_inactive_show' | translate }} {{ segment.conditions_json.inactive_trigger_duration_seconds || '' }} {{ 'projectsSegments.campaignSegmentOptions.for_seconds_show' | translate }}</div></td></tr></table><section class=form-horizontal ng-show=!showOnly><table class=\"table table-bordered segment-detail-table\"><tr ng-if=\"isAllowedCondition('advertising')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.koukoku_jogai' | translate }}</span><br><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.koukoku_gentei' | translate }}</span></th><td ng-if=\"advertisings.length > 0\"><select class=form-control ng-model=segment.conditions_json.advertising><option>-</option><option value=exclude>{{ 'projectsSegments.campaignSegmentOptions.koukoku_ryuunyuu_wo' | translate }}</option><option value=only>{{ 'projectsSegments.campaignSegmentOptions.koukoku_ryuunyuu_ni' | translate }}</option></select><div class=segment-option-detail><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.koukoku_ryuunyuu_hantei' | translate }}</p><zc-advertisings-list project=project></zc-advertisings-list></div></td><td ng-if=\"advertisings.length == 0\"><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.koukoku_ryuunyuu_settei' | translate }}</p><p class=form-description><a ui-sref=\"admin.projects.settings.campaign.advertising({projectId: project.id})\" target=_blank>{{ 'projectsSegments.campaignSegmentOptions.koukoku_ryuunyuu_no' | translate }}</a></p></td></tr><tr ng-if=\"isAllowedCondition('newsletter')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.merumaga_jogai' | translate }}</span></th><td ng-if=\"newsletterParameters.length > 0\"><label class=form-control-label><input type=checkbox ng-true-value=\"'exclude'\" ng-false-value=\"''\" ng-model=segment.conditions_json.newsletter> {{ 'projectsSegments.campaignSegmentOptions.meerumagajinkara_no_ryuunyuu' | translate }}</label><div class=segment-option-detail><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.merumaga_ryuunyuu_no' | translate }}</p><zc-newsletter-parameters-list project=project></zc-newsletter-parameters-list></div></td><td ng-if=\"newsletterParameters.length == 0\"><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.meerumagajin_ryuunyuu_no' | translate }}</p></td></tr><tr ng-if=\"isAllowedCondition('logged_in')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.roguin_jogai' | translate }}</span></th><td ng-if=\"loginEvaluators.length > 0\"><label class=form-control-label><input type=checkbox ng-true-value=\"'exclude'\" ng-false-value=\"''\" ng-model=segment.conditions_json.logged_in> {{ 'projectsSegments.campaignSegmentOptions.roguin_keiken_ga' | translate }}</label><div class=segment-option-detail><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.roguin_hantei' | translate }}</p><zc-login-evaluators-list project=project></zc-login-evaluators-list></div></td><td ng-if=\"loginEvaluators.length == 0\"><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.roguin_hantei_settei' | translate }}</p><p class=form-description><a ui-sref=\"admin.projects.settings.initialization.login_evaluator({projectId: project.id})\" target=_blank>{{ 'projectsSegments.campaignSegmentOptions.roguin_hantei_settei' | translate }}</a></p></td></tr><tr ng-if=\"isAllowedCondition('target_regions')\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.targetRegions' | translate }}</span></th><td><country-code-selector country-codes=segment.conditions_json.target_regions disabled=false></country-code-selector></td></tr><tr ng-if=\"isAllowedCondition('private_browsing')\"><th><span class=\"badge label-segment-exclude\">PB{{ 'projectsSegments.campaignSegmentOptions.jogai' | translate }}</span></th><td><label class=form-control-label><input type=checkbox ng-true-value=\"'exclude'\" ng-false-value=\"''\" ng-model=segment.conditions_json.private_browsing> {{ 'projectsSegments.campaignSegmentOptions.puraibeetoburaujinguyuuzaa_wo_jogai' | translate }}</label></td></tr><tr ng-if=\"isAllowedCondition('limit_to_landing_page_types')\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.lp_gentei' | translate }}</span></th><td><div class=row><div class=col-sm-5><label class=form-control-label><select class=form-control ng-model=segment.conditions_json.limit_to_landing_page_types[0]><option value=NOT_SELECTED>{{ 'projectsSegments.campaignSegmentOptions.nashi' | translate }}</option><option value={{pageType.name}} ng-selected=\"{{pageType.name == segment.conditions_json.limit_to_landing_page_types[0]}}\" ng-repeat=\"pageType in pageTypes\">{{pageType.label}}</option></select></label></div></div><div><div ng-show=\"!currentLimitPageTypes.length && segment.conditions_json.limit_to_landing_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentLimitPageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.limit_to_landing_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentLimitPageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('exclude_landing_page_types')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.lp_jogai' | translate }}</span></th><td><div class=row><div class=col-sm-5><label class=form-control-label><select class=form-control ng-model=segment.conditions_json.exclude_landing_page_types[0]><option value=NOT_SELECTED>{{ 'projectsSegments.campaignSegmentOptions.nashi' | translate }}</option><option value={{pageType.name}} ng-selected=\"{{pageType.name == segment.conditions_json.exclude_landing_page_types[0]}}\" ng-repeat=\"pageType in pageTypes\">{{pageType.label}}</option></select></label></div></div><div><div ng-show=\"!currentExcludePageTypes.length && segment.conditions_json.exclude_landing_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentExcludePageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_landing_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentExcludePageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('limit_to_sessions_who_visit')\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.limitToSessionsWhoVisit' | translate }}</span></th><td><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.limitToSessionsWhoVisitDescription' | translate }}</p><div class=row><div class=col-sm-5><label class=form-control-label><select class=form-control ng-model=segment.conditions_json.limit_to_sessions_who_visit[0]><option value=NOT_SELECTED>{{ 'projectsSegments.campaignSegmentOptions.nashi' | translate }}</option><option value={{pageType.name}} ng-disabled=\"['cart_form', 'conversion'].indexOf(pageType.name) !== -1\" ng-selected=\"{{pageType.name == segment.conditions_json.limit_to_sessions_who_visit[0]}}\" ng-repeat=\"pageType in pageTypes\">{{pageType.label}}</option></select></label></div></div><div><div ng-show=\"!currentLimitPageTypes.length && segment.conditions_json.limit_to_sessions_who_visit[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentLimitToSessionsWhoVisit.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.limit_to_sessions_who_visit[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentLimitToSessionsWhoVisit\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('exclude_sessions_who_visit')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.excludeSessionsWhoVisit' | translate }}</span></th><td><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.excludeSessionsWhoVisitDescription' | translate }}</p><div class=row><div class=col-sm-5><label class=form-control-label><select class=form-control ng-model=segment.conditions_json.exclude_sessions_who_visit[0]><option value=NOT_SELECTED>{{ 'projectsSegments.campaignSegmentOptions.nashi' | translate }}</option><option value={{pageType.name}} ng-disabled=\"['cart_form', 'conversion'].indexOf(pageType.name) !== -1\" ng-selected=\"{{pageType.name == segment.conditions_json.exclude_sessions_who_visit[0]}}\" ng-repeat=\"pageType in pageTypes\">{{pageType.label}}</option></select></label></div></div><div><div ng-show=\"!currentExcludePageTypes.length && segment.conditions_json.exclude_sessions_who_visit[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentExcludeSessionsWhoVisit.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_sessions_who_visit[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentExcludeSessionsWhoVisit\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('limit_to_offer_page_types')\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.ofaa_gentei' | translate }}</span></th><td><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.shitei_shitapeejitaipu_igai' | translate }}<br>{{ 'projectsSegments.campaignSegmentOptions.saitodeetayasegumento_no_shuukei' | translate }}</p><div class=row><div class=col-sm-5><label class=form-control-label><select class=form-control ng-model=segment.conditions_json.limit_to_offer_page_types[0]><option value=NOT_SELECTED>{{ 'projectsSegments.campaignSegmentOptions.nashi' | translate }}</option><option value={{pageType.name}} ng-selected=\"{{pageType.name == segment.conditions_json.limit_to_offer_page_types[0]}}\" ng-repeat=\"pageType in pageTypes\">{{pageType.label}}</option></select></label></div></div><div><div ng-show=\"!currentLimitOfferPageTypes.length && segment.conditions_json.limit_to_offer_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentLimitOfferPageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.limit_to_offer_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentLimitOfferPageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('exclude_offer_page_types')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.ofaa_jogai' | translate }}</span></th><td><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.shitei_shitapeejitaipu_de' | translate }}<br>{{ 'projectsSegments.campaignSegmentOptions.saitodeetayasegumento_no_shuukei' | translate }}</p><div class=row><div class=col-sm-5><label class=form-control-label><select class=form-control ng-model=segment.conditions_json.exclude_offer_page_types[0]><option value=NOT_SELECTED>{{ 'projectsSegments.campaignSegmentOptions.nashi' | translate }}</option><option value={{pageType.name}} ng-selected=\"{{pageType.name == segment.conditions_json.exclude_offer_page_types[0]}}\" ng-repeat=\"pageType in pageTypes\">{{pageType.label}}</option></select></label></div></div><div><div ng-show=\"!currentExcludeOfferPageTypes.length && segment.conditions_json.exclude_offer_page_types[0] != 'NOT_SELECTED'\">{{ 'projectsSegments.campaignSegmentOptions.gaitou_no_peejitaipu' | translate }}</div><div ng-if=currentExcludeOfferPageTypes.length><p><i class=\"glyphicon glyphicon-list-alt\"></i> {{ 'projectsSegments.campaignSegmentOptions.pataannopeeji_hantei' | translate: { pattern: segment.conditions_json.exclude_offer_page_types[0] } }}</p><table class=\"table table-bordered table-condensed table-striped\"><thead><tr><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.debaisu' | translate }}</th><th style=\"width: 80px\">{{ 'projectsSegments.campaignSegmentOptions.hantei_houshiki' | translate }}</th><th style=\"word-break: break-all\">{{ 'projectsSegments.campaignSegmentOptions.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"pageType in currentExcludeOfferPageTypes\"><td>{{pageType.required_device}}</td><td>{{pageType.match_type}}</td><td>{{pageType.match_pattern}}</td></tr></tbody></table></div></div></td></tr><tr ng-if=\"isAllowedCondition('limit_to_visitor_segments')\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.limitToVisitorSegments' | translate }}</span></th><td><visitor-segment-selector visitor-segment-ids=segment.conditions_json.limit_to_visitor_segments disabled=false></visitor-segment-selector></td></tr><tr ng-if=\"isAllowedCondition('exclude_visitor_segments')\"><th><span class=\"badge label-segment-exclude\">{{ 'projectsSegments.campaignSegmentOptions.excludeVisitorSegments' | translate }}</span></th><td><visitor-segment-selector visitor-segment-ids=segment.conditions_json.exclude_visitor_segments disabled=false></visitor-segment-selector></td></tr><tr ng-if=\"isAllowedCondition('triggers')\"><th><span class=\"badge label-segment-limit\">{{ 'projectsSegments.campaignSegmentOptions.haishin_torigaa' | translate }}</span></th><td><p class=form-description>{{ 'projectsSegments.campaignSegmentOptions.shitei_shitatorigaa_hassei' | translate }}<br>{{ 'projectsSegments.campaignSegmentOptions.izure_mo_sentaku' | translate }}</p><div class=row><div class=col-sm-12><label><input type=checkbox ng-click=\"toggleTrigger('swipedown')\" ng-checked=\"{{ segment.conditions_json.triggers.indexOf('swipedown') >= 0 }}\"> {{ 'projectsSegments.campaignSegmentOptions.kahou_mukattehidarisuwaipu' | translate }}</label><br><label><input type=checkbox ng-click=\"toggleTrigger('history_back')\" ng-checked=\"{{ segment.conditions_json.triggers.indexOf('history_back') >= 0 }}\"> {{ 'projectsSegments.campaignSegmentOptions.modoru_botankurikku' | translate }}</label><br><label style=\"padding-left: 1em;\"><input type=radio ng-model=segment.conditions_json.history_back_trigger_option name=history_back_trigger_option value=any_domain ng-disabled=\"segment.conditions_json.triggers.indexOf('history_back') === -1\"> {{ 'projectsSegments.campaignSegmentOptions.anyDomain' | translate }}</label><br><label style=\"padding-left: 1em;\"><input type=radio ng-model=segment.conditions_json.history_back_trigger_option name=history_back_trigger_option value=different_domain ng-disabled=\"segment.conditions_json.triggers.indexOf('history_back') === -1\"> {{ 'projectsSegments.campaignSegmentOptions.differentDomain' | translate }} {{ 'projectsSegments.campaignSegmentOptions.differentDomainAnnotation' | translate }}<br></label><br><label><input type=checkbox ng-click=\"toggleTrigger('visibilitychange')\" ng-checked=\"{{ segment.conditions_json.triggers.indexOf('visibilitychange') >= 0 }}\"> {{ 'projectsSegments.campaignSegmentOptions.peeji_ga_saido' | translate }}</label><br><label><input type=checkbox ng-click=\"toggleTrigger('inactive')\" ng-checked=\"{{ segment.conditions_json.triggers.indexOf('inactive') >= 0 }}\"> {{ 'projectsSegments.campaignSegmentOptions.user_inactive_edit' | translate }} <input type=number min=5 max=100 ng-model=segment.conditions_json.inactive_trigger_duration_seconds ng-required=\"segment.conditions_json.triggers.indexOf('inactive') >= 0\" ng-disabled=\"segment.conditions_json.triggers.indexOf('inactive') == -1\"> {{ 'projectsSegments.campaignSegmentOptions.for_seconds_edit' | translate }}</label></div></div></td></tr></table></section></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_row.html';
var html = "<table class=\"table campaign-table table-bordered\"><thead><tr><th>{{ 'projectsSegments.campaignSegmentRow.id' | translate }}</th><th>{{ 'projectsSegments.campaignSegmentRow.taipu' | translate }}</th><th>{{ 'projectsSegments.campaignSegmentRow.segumento_na' | translate }}</th><th class=col-sm-6>{{ 'projectsSegments.campaignSegmentRow.setsumei' | translate }}</th></tr></thead><tbody><tr><td>{{campaign.segment.id}}</td><td><zc-campaign-segment-flag segment=campaign.segment></zc-campaign-segment-flag></td><td>{{campaign.segment.name}}</td><td>{{campaign.segment.description}}</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show.html';
var html = "<section class=\"segments container\"><div class=row><div class=col-md-12><ng-include src=\"'/templates/projects.segments/campaign_segment_show_common.html'\"></ng-include></div></div><div class=row ng-show=Devise.isMaster()><div class=\"btn btn-default pull-right\" ng-show=detailsVisible ng-click=\"detailsVisible = !detailsVisible\"><i class=\"fa fa-arrow-up\"></i> {{ 'projectsSegments.campaignSegmentShow.jouken' | translate }}</div><div class=\"btn btn-default pull-right\" ng-hide=detailsVisible ng-click=\"detailsVisible = !detailsVisible\"><i class=\"fa fa-arrow-down\"></i> {{ 'projectsSegments.campaignSegmentShow.jouken' | translate }}</div><div class=col-md-12 ng-show=detailsVisible><h4>{{ 'projectsSegments.campaignSegmentShow.kuerii' | translate }}</h4><segment-condition-table segments=segment multiple=false show-nulls=true></segment-condition-table></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_all.html';
var html = "<div class=row></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_common.html';
var html = "<div class=segment-show><div class=section><h1>{{ 'projectsSegments.campaignSegmentShowCommon.segumento_shousai' | translate }}</h1></div><div class=row><div class=col-md-8><h4>{{ 'projectsSegments.campaignSegmentShowCommon.segumento_settei' | translate }}</h4><zc-campaign-segment-table-brief segment=segment></zc-campaign-segment-table-brief><ng-include src=getTemplateUrl()></ng-include><zc-campaign-segment-options segment=segment show-only=true project=project></zc-campaign-segment-options></div><div class=col-md-4><zc-segment-estimated-visitors fixed-on-scroll segment=segment project=project></zc-segment-estimated-visitors></div></div><div class=row zc-master-only><div class=col-md-8><h4><i class=\"fa fa-lock\"></i> {{ 'projectsSegments.campaignSegmentShowCommon.kasutamukuerii' | translate }}</h4><div><zc-campaign-segment-editor read-only=true campaign-segment=segment project=project></zc-campaign-segment-editor></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_custom.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_cv_users.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentShowCvUsers.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td>{{ 'projectsSegments.campaignSegmentShowCvUsers.kako_no_kounyuu' | translate }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_inactive.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentShowInactive.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td ng-show=project.installed_at>{{ 'projectsSegments.campaignSegmentShowInactive' | translate: { dayssincelastconversion: segment.conditions_json.days_since_last_conversion } }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_new.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentShowNew.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td ng-show=project.installed_at>{{ 'projectsSegments.campaignSegmentShowNew.hitsuji_kounyuu_yuuzaa' | translate: { installedat: (project.installed_at | zcDate) } }}<p class=form-description>{{ 'projectsSegments.campaignSegmentShowNew.jouki_nichiji_wa' | translate }}</p></td><td ng-hide=project.installed_at>{{ 'projectsSegments.campaignSegmentShowNew.dounyuu_kanryou_nichiji' | translate }} <button class=\"btn btn-primary\" ui-sref=\"admin.projects.settings.initialization({projectId: project.id})\" ng-if=Devise.isMaster()>{{ 'projectsSegments.campaignSegmentShowNew.setteiga_tsura_e' | translate }}</button></td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_show_new_inverse.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentShowNewInverse.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td ng-show=project.installed_at>{{ 'projectsSegments.campaignSegmentShowNewInverse.ikkai_ijou_kounyuu' | translate: { installedat: (project.installed_at | zcDate) } }}<p class=form-description>{{ 'projectsSegments.campaignSegmentShowNewInverse.jouki_nichiji_wa' | translate }}</p></td><td ng-hide=project.installed_at>{{ 'projectsSegments.campaignSegmentShowNewInverse.dounyuu_kanryou_nichiji' | translate }} <button class=\"btn btn-primary\" ui-sref=\"admin.projects.settings.initialization({projectId: project.id})\" ng-if=Devise.isMaster()>{{ 'projectsSegments.campaignSegmentShowNewInverse.setteiga_tsura_e' | translate }}</button></td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/campaign_segment_table_brief.html';
var html = "<table class=\"table table-bordered segment-detail-table\"><tr><th>{{ 'projectsSegments.campaignSegmentTableBrief.id' | translate }}</th><td>{{segment.id}}</td></tr><tr><th>{{ 'projectsSegments.campaignSegmentTableBrief.segumento_na' | translate }}</th><td>{{segment.name}}</td></tr><tr><th>{{ 'projectsSegments.campaignSegmentTableBrief.shiborikomi_jouken_ichiran' | translate }}</th><td><zc-campaign-segment-flag segment=segment></zc-campaign-segment-flag><div ng-show=\"segment.segment_type === 'new_inverse'\" class=form-description style=color:#F4796F;>{{ 'projectsSegments.campaignSegmentTableBrief.new_inverse_deprecated_msg' | translate }}</div></td></tr><tr><th>{{ 'projectsSegments.campaignSegmentTableBrief.bikou' | translate }}</th><td>{{segment.description}}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/edit.html';
var html = "<section class=\"segments container\"><form name=campaignSegmentEditForm><div class=row><div class=col-md-8><div class=container><ng-include src=\"'/templates/projects.segments/campaign_segment_edit_common.html'\"></ng-include><section><div class=\"panel panel-danger\" ng-show=\"segment.campaign_ids.length > 0\"><div class=panel-heading><div class=panel-title>{{ 'projectsSegments.edit.riyou_uchi_no' | translate }}</div></div><div class=panel-body>{{ 'projectsSegments.edit.ko_no_segumento' | translate }} {{ 'projectsSegments.edit.tochuu_de_no' | translate }}</div></div><a ng-show=\"segment.campaign_ids.length > 0\" ng-disabled=campaignSegmentEditForm.$invalid confirm-modal confirm-click=save() class=\"btn btn-primary\">{{ 'projectsSegments.edit.hozon' | translate }}</a> <a ng-show=\"!segment.campaign_ids || segment.campaign_ids.length == 0\" ng-disabled=campaignSegmentEditForm.$invalid ng-click=\"!campaignSegmentEditForm.$invalid && save()\" class=\"btn btn-primary\">{{ 'projectsSegments.edit.hozon' | translate }}</a></section></div></div></div></form></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/list.html';
var html = "<section class=\"segments container\"><div class=row><div class=col-md-10><h1>{{ 'projectsSegments.list.segumento_ichiran' | translate }}</h1></div><div class=col-md-2><div class=\"btn-group pull-right dropdown\" dropdown><button type=button class=\"btn btn-default dropdown-toggle\" dropdown-toggle data-toggle=dropdown aria-expanded=false><i class=\"glyphicon glyphicon-plus\"></i> {{ 'projectsSegments.list.segumento_wo_sakusei' | translate }}</button><ul class=dropdown-menu role=menu><li><a href=# ui-sref=\"admin.projects.segments.new({projectId: currentProject.id, segmentType: 'new'})\">{{ 'projectsSegments.list.hitsuji_kounyuu' | translate }}</a></li><li><a href=# ui-sref=\"admin.projects.segments.new({projectId: currentProject.id, segmentType: 'cv_users'})\">{{ 'projectsSegments.list.ikkai_ijou_kounyuu' | translate }}</a></li><li><a href=# ui-sref=\"admin.projects.segments.new({projectId: currentProject.id, segmentType: 'inactive'})\">{{ 'projectsSegments.list.kyuumin_yuuzaa' | translate }}</a></li><li><a href=# ui-sref=\"admin.projects.segments.new({projectId: currentProject.id, segmentType: 'all'})\">{{ 'projectsSegments.list.zentai' | translate }}</a></li><li class=divider></li><li><a href=# ui-sref=\"admin.projects.segments.new({projectId: currentProject.id, segmentType: 'custom'})\">{{ 'projectsSegments.list.kasutamu' | translate }}</a></li></ul></div></div></div><div class=row><div class=col-md-12><zc-campaign-segment-list current-project=currentProject></zc-campaign-segment-list></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

var path = '/templates/projects.segments/show.html';
var html = "<zc-campaign-segment-show segment-id=segment.id project=project></zc-campaign-segment-show>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/base_project_confirm.html';
var html = "<div class=row><div class=col-md-6 ng-if=showPC><label for=selectService class=col-sm-3>PC</label><div class=\"status-checked col-sm-9\" ng-if=foundPC tooltip-placement=bottom tooltip-html-unsafe=\"{{itemsPC.join('<br>')}}\"><i class=\"fa fa-check-circle\"></i> {{resourceName}}{{ 'projectsSettings.baseProjectConfirm.ga_kakunin_de' | translate }}</div><div class=\"status-failed col-sm-9\" ng-if=!foundPC><i class=\"fa fa-times\"></i> {{resourceName}}{{ 'projectsSettings.baseProjectConfirm.ga_kakunin_de' | translate }}</div></div><div class=col-md-6 ng-if=showSP><label for=selectService class=col-sm-3>SP</label><div class=\"status-checked col-sm-9\" ng-if=foundSP tooltip-placement=bottom tooltip-html-unsafe=\"{{itemsSP.join('<br>')}}\"><i class=\"fa fa-check-circle\"></i> {{resourceName}}{{ 'projectsSettings.baseProjectConfirm.ga_kakunin_de' | translate }}</div><div class=\"status-failed col-sm-9\" ng-if=!foundSP><i class=\"fa fa-times\"></i> {{resourceName}}{{ 'projectsSettings.baseProjectConfirm.ga_kakunin_de' | translate }}</div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/basic.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.basic.basic.saito_no_kihon' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group zc-master-only><label for=select-service class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.saabisu_wo_sentaku' | translate }}</label><div class=col-sm-9><label class=radio-inline ng-repeat=\"productLine in productLines\"><input id=select-service type=radio ng-model=project.product_line ng-value=productLine.name ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\"> {{productLine.label}}</label></div><div class=col-sm-9 ng-if=\"project.product_line === 'zenclerk_lp'\"><input type=checkbox ng-model=project.show_contribution_price_on_cpa> <label>{{ 'projectsSettings.basic.basic.heikin_kingaku_nakaguro' | translate }}</label></div></div><div class=form-group zc-master-only><label for=is_direct_cv class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.directCV' | translate }}</label><div class=col-sm-9><label class=radio-inline ng-repeat=\"value in [true, false]\"><input type=radio name=is_direct_cv ng-model=project.is_direct_cv ng-value=value ng-disabled=\"project.product_line !== 'zenclerk_lp'\"> {{value ? \"Yes\" : \"No\"}}</label></div></div><div class=form-group zc-master-only><label class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> Is OEM?</label><div class=col-sm-9 ng-show=project.is_oem>{{ 'projectsSettings.basic.basic.purojekuto_de_su' | translate }}</div><div class=col-sm-9 ng-hide=project.is_oem>{{ 'projectsSettings.basic.basic.purojekuto_de_wa' | translate }}</div></div><div class=form-group zc-master-only><label for=company-name class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.uneigaisha_na' | translate }}</label><div class=col-sm-6><input type=text class=form-control id=company-name ng-model=project.company_name placeholder=\"{{ 'projectsSettings.basic.basic.kabushikigaisha' | translate }}\" ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\" required></div></div><div class=form-group zc-master-only><label for=apikey class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> APIKEY<div class=\"badge badge-danger\" tooltip=\"{{ 'projectsSettings.basic.basic.henkou_suruno_wa' | translate }}\">?</div></label><div class=col-sm-6><input id=apikey type=text class=form-control ng-model=project.apikey placeholder=testtest disabled required></div></div><div class=form-group zc-master-only><label for=slack_channel_name class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.channeru_na' | translate }}<div class=\"badge badge-danger\" tooltip-html-unsafe=\"{{ 'projectsSettings.basic.basic.channeru_na_no' | translate }}<br> {{ 'projectsSettings.basic.basic.soba_de_channeru' | translate }}<br> {{ 'projectsSettings.basic.basic.channeru_na_wo' | translate }}\" tooltip-append-to-body=true>?</div></label><div class=col-sm-6><input id=slack_channel_name type=text class=form-control ng-model=project.slack_channel_name maxlength=\"{{ maximumApikeyLength }}\" placeholder=\"{{ project.apikey.slice(0, maximumApikeyLength) }}\" ng-required=\"project.product_line !== 'zenclerk_s' && !project.sales_entity_fullname !== 'Appier Japan (JP)'\" ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\"></div></div><div class=form-group zc-master-only><label for=currency class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.tsuukatani' | translate }}</label><div class=col-sm-6><select id=currency class=form-control ng-options=\"item.name as item.label | uppercase for item in currencies\" ng-model=project.currency ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\"></select></div></div><div class=form-group zc-master-only><label class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.chiiki' | translate }}<div ng-if=!project.is_region_set class=\"badge badge-danger\" tooltip=\"{{ 'projectsSettings.basic.basic.cannotChangeAfterSet' | translate }}\">?</div></label><div class=col-sm-6><span ng-if=project.is_region_set style=\"cursor: not-allowed; display: table-cell; vertical-align: middle; background-color: #eee; border: 1px solid #ccc; border-radius: 4px; padding: 7px;\">{{ project.region | gmtNotation }}</span><select ng-if=!project.is_region_set class=form-control id=region ng-model=project.region ng-options=\"item.name as item.name | gmtNotation for item in regions\" ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\" required></select></div></div><div class=form-group zc-master-only><label class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.basic.salesEntity' | translate }}</label><div class=col-sm-6><span style=\"cursor: not-allowed; display: table-cell; vertical-align: middle; background-color: #eee; border: 1px solid #ccc; border-radius: 4px; padding: 7px;\">{{ project.sales_entity_fullname }}</span></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.basic.basic.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/control_percent.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.basic.controlPercent.hihyouji_ritsu_no' | translate }}</h1><p translate=projectsSettings.basic.controlPercent.kyanpeen_de_haishin translate-value-groupratio=\"<span class='text-danger'>{{ 'projectsSettings.basic.controlPercent.hidden_group_ratio' | translate }}</span>\" class=config-lead></p><div class=\"alert alert-warning\" role=alert><strong>{{ 'projectsSettings.basic.controlPercent.note' | translate }}</strong> {{ 'projectsSettings.basic.controlPercent.chuui_kyanpeen_haishin' | translate }} {{ 'projectsSettings.basic.controlPercent.henkou_suru_maeni' | translate }}</div><div class=\"alert alert-warning\" role=alert><strong>{{ 'projectsSettings.basic.controlPercent.note' | translate }}</strong> {{ 'projectsSettings.basic.controlPercent.chuui_hihyouji_hiritsu' | translate }}</div><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=pc_control_percent class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.controlPercent.no_hihyouji_hiritsu_pc' | translate }}</label><div class=col-sm-6><div class=input-group><input id=pc_control_percent type=number class=form-control ng-model=project.pc_control_percent min=0 max=50 ng-disabled=!project.can_change_control_percentage required> <span class=input-group-addon>{{ 'projectsSettings.basic.controlPercent.hihyouji' | translate }}</span></div></div></div><div class=form-group><label for=sp_control_percent class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.controlPercent.no_hihyouji_hiritsu_sp' | translate }}</label><div class=col-sm-6><div class=input-group><input id=sp_control_percent type=number class=form-control ng-model=project.sp_control_percent min=0 max=50 ng-disabled=!project.can_change_control_percentage required> <span class=input-group-addon>{{ 'projectsSettings.basic.controlPercent.hihyouji' | translate }}</span></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.basic.controlPercent.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/index.html';
var html = "<div id=projectSettingsBase><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/general' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.basic.index.saito_no_keiyaku' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=title class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.index.saito_na' | translate }}</label><div class=col-sm-6><input id=title type=text class=form-control ng-model=project.title placeholder=\"AiDeal Online Store\" ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\" required></div></div><div class=form-group><label for=base-url class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.index.toppupeeji' | translate }}</label><div class=col-sm-9><input id=base-url type=url class=form-control ng-model=project.base_url placeholder=https://www.zenclerk.com ng-disabled=\"project.sales_entity_fullname !== 'Appier Japan (JP)'\" required></div></div><div class=form-group><label class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.index.zenclerk_moto_kakin_kaishibi' | translate }}</label><div class=col-sm-6><div style=\"cursor: not-allowed;\" class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><span style=\"display: table-cell; vertical-align: middle; background-color: #eee; border: 1px solid #ccc; border-radius: 4px; border-top-left-radius: 0; border-bottom-left-radius: 0; padding: 7px;\">{{ project.contracted_at | zcDate: { dateOnly: true } }}</span></div></div></div><div ng-if=project.iw_contracted_at class=form-group><label class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.index.interest_widget_moto_kakin_kaishibi' | translate }}</label><div class=col-sm-6><div style=\"cursor: not-allowed;\" class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><span style=\"display: table-cell; vertical-align: middle; background-color: #eee; border: 1px solid #ccc; border-radius: 4px; border-top-left-radius: 0; border-bottom-left-radius: 0; padding: 7px;\">{{ project.iw_contracted_at | zcDate: { dateOnly: true } }}</span></div></div></div><div ng-if=project.lens_contracted_at class=form-group><label class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.index.lens_kakin_kaishibi' | translate }}</label><div class=col-sm-6><div style=\"cursor: not-allowed;\" class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><span style=\"display: table-cell; vertical-align: middle; background-color: #eee; border: 1px solid #ccc; border-radius: 4px; border-top-left-radius: 0; border-bottom-left-radius: 0; padding: 7px;\">{{ project.lens_contracted_at | zcDate: { dateOnly: true } }}</span></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=\"form.$invalid || project.sales_entity_fullname !== 'Appier Japan (JP)'\">{{ 'projectsSettings.basic.index.henkou_suru' | translate }}</button></form></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/project_status.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.basic.projectStatus.suteetasu_no_kanri' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.basic.projectStatus.purojekutonosuteetasu_wo_henkou' | translate }}<br></p><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=allow_incentive_edit class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.projectStatus.insentibu_touroku_nakaguro' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.yuukouka_suruto,_ippanyuuza' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=allow_incentive_edit ng-options=\"option for option in [true, false]\" ng-model=project.allow_incentive_edit class=form-control></select></div></div><div class=form-group><label for=shows_no_publish_page_type class=\"col-sm-3 control-label\"><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.basic.projectStatus.haishin_jogai_settei' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.yuukouka_suruto,_ippanyuuza' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=shows_no_publish_page_type ng-options=\"option for option in [true, false]\" ng-model=project.shows_no_publish_page_type class=form-control></select></div></div><div class=form-group><label for=is_maintenance class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.projectStatus.repootomenyuu_hyouji' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.mukou_ka_suru' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=shows_site_report ng-options=\"option for option in [true, false]\" ng-model=project.shows_site_report class=form-control></select></div></div><div class=form-group><label for=is_maintenance class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.projectStatus.mentenansumoodo' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.yuukouka_suruto,_ippanyuuza' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=is_maintenance ng-options=\"option for option in [true, false]\" ng-model=project.is_maintenance class=form-control></select></div></div><div class=row><div class=col-md-12><div class=form-group><label for=is_secret_ab class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.deforutotesuto_hihyouji' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.tesuto_wo_okonatte' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=is_secret_ab ng-options=\"option for option in [true, false]\" ng-model=project.is_secret_ab class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=enable_app class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.enableApp' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.enableAppTip' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=enable_app ng-options=\"option for option in [true, false]\" ng-model=project.enable_app class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=shows_site_data class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.showsSiteData' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.showsSiteDataTip' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=shows_site_data ng-options=\"option for option in [true, false]\" ng-model=project.shows_site_data class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=shows_campaign_summary class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.showsCampaignSummary' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.showsCampaignSummaryTip' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=shows_campaign_summary ng-options=\"option for option in [true, false]\" ng-model=project.shows_campaign_summary class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=enable_aajs class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.displayAajsCodeSnippet' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.displayAajsCodeSnippetTip' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=enable_aajs ng-options=\"option for option in [true, false]\" ng-model=project.enable_aajs class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=is_wevnal class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.wevnalSite' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.wevnalSiteTip' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=is_wevnal ng-options=\"option for option in [true, false]\" ng-model=project.is_wevnal class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=multiple_currencies class=\"col-md-3 control-label\">{{ 'projectsSettings.basic.projectStatus.multipleCurrencies' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.projectStatus.multipleCurrenciesTip' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-sm-6><select id=multiple_currencies ng-options=\"option for option in [true, false]\" ng-model=project.enable_multiple_currencies class=form-control></select></div></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.basic.projectStatus.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/remove_apikey.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.basic.removeApikey.purojekuto_no_sakujo' | translate }}</h1><div class=\"alert alert-warning\" role=alert><strong>{{ 'projectsSettings.basic.removeApikey.note' | translate }}</strong> {{ 'projectsSettings.basic.removeApikey.chuui_ichido_purojekuto' | translate }}</div><p class=config-lead>{{ 'projectsSettings.basic.removeApikey.kaki_no_foomu' | translate }}</p><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=remove(project)><div class=form-group><label for=remove_apikey class=\"col-sm-3 control-label\">APIKEY</label><div class=col-sm-6><input type=text id=remove_apikey class=form-control ng-model=project.remove_apikey placeholder={{project.apikey}} required></div></div><button class=\"btn btn-config\" type=submit confirm-modal=\"{{ 'projectsSettings.basic.removeApikey.ko_no_purojekuto' | translate }}\" ng-disabled=form.$invalid value=\"{{ 'projectsSettings.basic.removeApikey.purojekuto_wo_sakujo' | translate }}\">{{ 'projectsSettings.basic.removeApikey.purojekuto_wo_sakujo' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/sales_management.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.basic.salesManagement.eigyou_kanrijouhou' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.basic.salesManagement.purojekuto_no_kibo' | translate }}<br>{{ 'projectsSettings.basic.salesManagement.mokuhyou_mokuhyou' | translate }}<br><span translate=projectsSettings.basic.salesManagement.getsugaku_jougen_yosan_ni translate-value-strong=\"<strong>{{ 'projectsSettings.basic.salesManagement.jidouteki_ni_haishin' | translate }}</strong>\"></span><br>(<strong class=text-danger>{{ 'projectsSettings.basic.salesManagement.tsuki_no_kawarime' | translate }}</strong>)</p><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=cs_am_in_charge class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.cs_am_in_charge' | translate }}</label><div class=col-sm-6><select id=cs_am_in_charge class=form-control ng-options=\"user.id as user.email for user in masterUsers\" ng-model=project.cs_am_in_charge_id></select></div></div><div class=form-group><label for=ds_cm_in_charge class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.ds_cm_in_charge' | translate }}</label><div class=col-sm-6><select id=ds_cm_in_charge class=form-control ng-options=\"user.id as user.email for user in masterUsers\" ng-model=project.ds_cm_in_charge_id></select></div></div><div class=form-group><label for=project_rank class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.purojekuto_kibo' | translate }}</label><div class=col-sm-6><select id=project_rank class=form-control ng-options=\"item.name as item.label for item in projectRanks\" ng-model=project.project_rank></select></div></div><div class=form-group><label for=budget class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.getsugaku_jougen_yosan' | translate }}</label><div class=col-sm-6><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=budget min=0 type=number class=form-control ng-model=project.budget> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div><div class=form-group><label for=monthly_conversion_price_limit class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.monthly_conversion_price_limit' | translate }}</label><div class=col-sm-6><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=monthly_conversion_price_limit min=0 type=number class=form-control ng-model=project.monthly_conversion_price_limit zc-currency-formatter> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div><div ng-if=\"project.product_line !== 'zenclerk_s'\" class=form-group><label for=opt_target class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.optTarget' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.salesManagement.optTargetDesc' | translate }}\"></i></label><div class=col-sm-6><select id=opt_target class=form-control ng-options=\"item.name as item.label for item in optTargets\" ng-model=project.opt_target></select></div></div><div class=form-group><label for=conversion_up_rate_threshold class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.hitsuyou_joushouritsu_araato' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.salesManagement.joushouritsu_hyouji_guruupu' | translate }}\"></i></label><div class=col-sm-6><div class=input-group><input id=conversion_up_rate_threshold min=0 type=number class=form-control ng-model=project.conversion_up_rate_threshold> <span class=input-group-addon>{{ 'projectsSettings.basic.salesManagement.ijou' | translate }}</span></div></div></div><div class=form-group><label for=invoice_amount_threshold class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.hitsuyou_seikyuu_kingaku' | translate }} <i ng-if=\"project.pricing_type === 'tiered'\" class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.salesManagement.billing_amount_alert_not_supported' | translate }}\"></i></label><div class=col-sm-6><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input ng-disabled=\"project.pricing_type === 'tiered'\" id=invoice_amount_threshold min=0 type=number class=form-control ng-model=project.invoice_amount_threshold> <span class=input-group-addon><ng-container ng-if=currency.suffix translate=projectsSettings.basic.salesManagement.en_ijou translate-value-currency=\"{{ currency.suffix }}\"></ng-container><ng-container ng-if=!currency.suffix translate=projectsSettings.basic.salesManagement.en_ijou translate-value-currency></ng-container></span></div></div></div><div class=form-group><label for=coupon_applicable_rate_threshold class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.coupon_applicable_rate_threshold' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.salesManagement.coupon_applicable_rate_threshold_desc' | translate }}\"></i></label><div class=col-sm-6><div class=input-group><input id=coupon_applicable_rate_threshold type=number class=form-control ng-model=project.coupon_applicable_rate_threshold> <span class=input-group-addon>{{ 'projectsSettings.basic.salesManagement.ijou' | translate }}</span></div></div></div><div class=form-group><label for=invoice_amount_upper_threshold class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.chouka_seikyuu_kingaku' | translate }} <i ng-if=\"project.pricing_type === 'tiered'\" class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.salesManagement.billing_amount_alert_not_supported' | translate }}\"></i></label><div class=col-sm-6><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input ng-disabled=\"project.pricing_type === 'tiered'\" id=invoice_amount_upper_threshold min=0 type=number class=form-control ng-model=project.invoice_amount_upper_threshold> <span class=input-group-addon><ng-container ng-if=currency.suffix translate=projectsSettings.basic.salesManagement.enmade translate-value-currency=\"{{ currency.suffix }}\"></ng-container><ng-container ng-if=!currency.suffix translate=projectsSettings.basic.salesManagement.enmade translate-value-currency></ng-container></span></div></div></div><div class=form-group><label for=revenue_min_threshold class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.revenue_min_threshold' | translate }}</label><div class=col-sm-6><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=revenue_min_threshold min=0 type=number class=form-control ng-model=project.revenue_min_threshold> <span class=input-group-addon><ng-container ng-if=currency.suffix translate=projectsSettings.basic.salesManagement.en_ijou translate-value-currency=\"{{ currency.suffix }}\"></ng-container><ng-container ng-if=!currency.suffix translate=projectsSettings.basic.salesManagement.en_ijou translate-value-currency></ng-container></span></div></div></div><div class=form-group><label for=revenue_max_threshold class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.revenue_max_threshold' | translate }}</label><div class=col-sm-6><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=revenue_max_threshold min=0 type=number class=form-control ng-min=\"{{ project.revenue_min_threshold + 1 }}\" ng-model=project.revenue_max_threshold> <span class=input-group-addon><ng-container ng-if=currency.suffix translate=projectsSettings.basic.salesManagement.enmade translate-value-currency=\"{{ currency.suffix }}\"></ng-container><ng-container ng-if=!currency.suffix translate=projectsSettings.basic.salesManagement.enmade translate-value-currency></ng-container></span></div></div></div><div class=form-group><label for=campaign_coupon_used_rate class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.kuuponkoodo_shiyouritsu' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.basic.salesManagement.kuuponkosuto_waribikiritsu_kuuponkoodo' | translate }}\"></i></label><div class=col-sm-6><div class=input-group><input id=campaign_coupon_used_rate min=0 type=number class=form-control ng-model=project.campaign_coupon_used_rate> <span class=input-group-addon>%</span></div></div></div><div class=form-group><label for=jira_link class=\"col-sm-3 control-label\">{{ 'projectsSettings.basic.salesManagement.jira_link' | translate }}</label><div class=col-sm-6><input id=jira_link type=text class=form-control ng-model=project.jira_link></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.basic.salesManagement.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/basic/submenu.html';
var html = "<ul ng-if=isCommon class=config-submenu-list><li ui-sref=admin.projects.settings.basic() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><a>{{ 'projectsSettings.basic.submenu.saito_no_keiyaku' | translate }}</a></li><li ui-sref=admin.projects.settings.basic.basic() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.basic.submenu.saito_no_kihon' | translate }}</a></li><li ui-sref=admin.projects.settings.basic.sales_management() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.basic.submenu.eigyou_kanrijouhou' | translate }}</a></li><li ui-sref=admin.projects.settings.basic.project_status() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.basic.submenu.suteetasu_no_kanri' | translate }}</a></li><li ui-sref=admin.projects.settings.basic.control_percent() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.basic.submenu.hihyouji_ritsu_no' | translate }}</a></li><li ui-sref=admin.projects.settings.basic.remove_apikey() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.basic.submenu.purojekuto_no_sakujo' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/billing_information.html';
var html = "<div id=projectSettingsBase class=col-md-10><h1 class=config-title>{{ 'projectsSettings.billing.billing_information.seikyuu_saki_jouhou' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row><div class=\"col-md-9 col-md-push-3\"><div class=form-group><zc-sync-contract-info-button class=col-md-12 sync-target-name=\"{{ 'projectsSettings.billing.billing_information.keiyaku_jouhou' | translate }}\" source=project></zc-sync-contract-info-button></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_company_name class=col-md-3>{{ 'projectsSettings.billing.billing_information.kaishamei' | translate }}</label><div class=col-md-9><input class=form-control id=billing_company_name name=billing_company_name ng-model=project.billing_company_name required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_postal_code class=col-md-3>{{ 'projectsSettings.billing.billing_information.yuubinbangou' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'projectsSettings.billing.billing_information.rei' | translate }}\" id=billing_postal_code name=billing_postal_code ng-model=project.billing_postal_code required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_address class=col-md-3>{{ 'projectsSettings.billing.billing_information.juusho' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'projectsSettings.billing.billing_information.rei_toukyouto_shina' | translate }}\" id=billing_address name=billing_address ng-model=project.billing_address required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_phone_number class=col-md-3>{{ 'projectsSettings.billing.billing_information.denwabangou' | translate }}</label><div class=col-md-9><input class=form-control id=billing_phone_number name=billing_phone_number ng-model=project.billing_phone_number required></div></div></div></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.billing.billing_information.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/billing_representatives.html';
var html = "<div id=projectSettingsBase class=col-md-10><h1 class=config-title>{{ 'projectsSettings.billing.billing_representatives.seikyuu_tantousha' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row><div class=col-md-9><div class=form-group><zc-billing-representatives class=col-md-12 representatives=project.billing_representatives></zc-billing-representatives></div></div></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.billing.billing_representatives.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/index.html';
var html = "<div id=projectSettingsBase class=col-md-10><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/general/invoice' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.billing.index.keiyaku_jouhou' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row zc-master-only><div class=col-md-12><div class=form-group><label for=salesforce_com_id class=col-md-4><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.billing.zc_information.salesforce_com_id' | translate }}</label><div class=col-md-8><input id=salesforce_com_id class=form-control ng-model=project.salesforce_com_id ng-pattern=\"/^([0-9A-z]{18}|[0-9A-z]{22})$/\"></div></div></div></div><div class=row zc-master-only><div class=col-md-12><div class=form-group><label for=salesforce_opp_id class=col-md-4><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.billing.zc_information.salesforce_opp_id' | translate }}</label><div class=col-md-8><input id=salesforce_opp_id class=form-control ng-model=project.salesforce_opp_id ng-pattern=\"/^([0-9A-z]{18})$/\"></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=company_name class=col-md-4>{{ 'projectsSettings.billing.index.kaishamei' | translate }}</label><div class=col-md-8><input class=form-control id=company_name name=company_name ng-model=project.company_name ng-disabled=!isMaster required></div></div></div></div><div ng-if=\"project.sales_entity_fullname === 'Appier Japan (JP)'\"><div class=row><div class=col-md-12><div class=form-group><label for=representative class=col-md-4>{{ 'projectsSettings.billing.index.kaisha_daihyou_myoudai' | translate }}</label><div class=col-md-8><input class=form-control id=representative name=representative ng-model=project.representative required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=postal_code class=col-md-4>{{ 'projectsSettings.billing.index.yuubinbangou' | translate }}</label><div class=col-md-8><input class=form-control placeholder=\"{{ 'projectsSettings.billing.index.rei' | translate }}\" id=postal_code name=postal_code ng-model=project.postal_code required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=address class=col-md-4>{{ 'projectsSettings.billing.index.juusho' | translate }}</label><div class=col-md-8><input class=form-control id=address name=address ng-model=project.address required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=phone_number class=col-md-4>{{ 'projectsSettings.billing.index.denwabangou' | translate }}</label><div class=col-md-8><input class=form-control id=phone_number name=phone_number ng-model=project.phone_number required></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=invoice_currency class=col-md-4>{{ 'projectsSettings.billing.index.invoice_currency' | translate }}</label><div class=col-md-8><select class=form-control id=invoice_currency name=invoice_currency ng-model=project.invoice_currency ng-options=\"item | uppercase for item in [project] | billable_currencies | unique\" required></select></div></div></div></div></section><button class=\"btn btn-config\" type=submit>{{ 'projectsSettings.billing.index.henkou_suru' | translate }}</button></form></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/invoice_information.html';
var html = "<div id=projectSettingsBase class=col-md-12><h1 class=config-title>{{ 'projectsSettings.billing.invoice_information.seikyuusho_jouhou' | translate }}</h1><div class=\"alert alert-warning\" role=alert ng-if=!project.is_direct_selling><ng-container translate=projectsSettings.billing.invoice_information.chuui_hakkoubi translate-value-note=\"<strong>{{ 'projectsSettings.billing.invoice_information.note' | translate }}</strong>\"></ng-container></div><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row><div class=col-md-12><div class=form-group><label for=payment_method class=\"control-label col-md-3\">{{ 'projectsSettings.billing.invoice_information.paymentMethod' | translate }}</label><div class=col-md-7><select id=payment_method class=form-control ng-options=\"item.name as item.label for item in paymentMethods\" ng-model=project.payment_method></select></div></div></div></div><div ng-if=\"project.sales_entity === 'appier_jp'\" class=row><div class=col-md-12><div class=form-group><label for=invoice_issue_day class=\"control-label col-md-3\">{{ 'projectsSettings.billing.invoice_information.hakkoubi' | translate }}</label><div class=col-md-7><select id=invoice_issue_day class=form-control ng-options=\"item.name as item.label for item in invoiceIssueDays\" ng-model=project.invoice_issue_day ng-disabled=!project.is_direct_selling ng-required=project.is_direct_selling></select></div></div></div></div><div ng-if=\"project.sales_entity === 'appier_jp'\" class=row><div class=col-md-12><div class=form-group><label for=invoice_due_day class=\"control-label col-md-3\">{{ 'projectsSettings.billing.invoice_information.shimebi' | translate }}</label><div class=col-md-7><select id=invoice_due_day class=form-control ng-options=\"item.name as item.label for item in invoiceDueDays\" ng-model=project.invoice_due_day required></select></div></div></div></div><div ng-if=\"project.sales_entity === 'appier_jp'\" class=row><div class=col-md-12><div class=form-group><label for=invoice_payment_month class=\"control-label col-md-3\">{{ 'projectsSettings.billing.invoice_information.shiharai_tsuki' | translate }}</label><div class=col-md-7><select id=invoice_payment_month class=form-control ng-options=\"item.name as item.label for item in invoicePaymentMonths\" ng-model=project.invoice_payment_month ng-disabled=!project.is_direct_selling ng-required=project.is_direct_selling></select></div></div></div></div><div ng-if=\"project.sales_entity === 'appier_jp'\" class=row><div class=col-md-12><div class=form-group><label for=invoice_payment_day class=\"control-label col-md-3\">{{ 'projectsSettings.billing.invoice_information.shiharaibi' | translate }}</label><div class=col-md-7><select id=invoice_payment_day class=form-control ng-options=\"item.name as item.label for item in invoicePaymentDays\" ng-model=project.invoice_payment_day ng-disabled=!project.is_direct_selling ng-required=project.is_direct_selling></select></div></div></div></div><div ng-if=\"project.sales_entity === 'appier_jp'\" class=row><div class=col-md-12><div class=form-group><label for=is_invoice_automated class=col-md-3>{{ 'projectsSettings.billing.invoice_information.seikyuu_jidouka_kahi' | translate }}</label><div class=col-md-7><input id=is_invoice_automated class=form-check-input type=checkbox ng-model=project.is_invoice_automated></div></div></div></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.billing.invoice_information.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/iw_information.html';
var html = "<div id=projectSettingsBase class=col-md-12><h1 class=config-title>{{ 'projectsSettings.billing.iw_information.jouhou' | translate }}</h1><div class=\"alert alert-warning\" role=alert><ng-container translate=projectsSettings.billing.iw_information.chuui_seikyuu_settei translate-value-note=\"<strong>{{ 'projectsSettings.billing.iw_information.note' | translate }}</strong>\"></ng-container></div><div class=\"alert alert-warning\" role=alert><ng-container translate=projectsSettings.billing.iw_information.chuui_shuuryoubi_kanren translate-value-note=\"<strong>{{ 'projectsSettings.billing.iw_information.note' | translate }}</strong>\"></ng-container><br><br>{{ 'projectsSettings.billing.iw_information.reitoraiaru_shuuryoubi_wa' | translate }}</div><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row><div class=col-md-12><div class=form-group><label for=iw_trial_started_at class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.iw_information.toraiaru_kaishibi' | translate }}</label><div class=col-md-7><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick id=iw_trial_started_at class=form-control date=project.iw_trial_started_at max=project.iw_contracted_at></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=iw_trial_started_at class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.iw_information.toraiaru_shuuryoubi' | translate }}</label><div class=col-md-7><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick id=iw_trial_started_at class=form-control date=project.iw_trial_end_at min=project.iw_trial_started_at ng-class=\"{ 'ng-invalid': project.iw_trial_started_at && !project.iw_trial_end_at, }\"></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=iw_trial_invoice_fixed_price class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.iw_information.toraiaru_kotei_gaku' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.billing.iw_information.seikyuu_ni_youiraremasu' | translate }}\"></i></label><div class=col-md-7><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=iw_trial_invoice_fixed_price class=form-control type=number placeholder=10000 ng-model=project.iw_trial_invoice_fixed_price ng-required=project.iw_trial_started_at ng-disabled=!project.iw_trial_started_at ng-class=\"{ 'ng-invalid': !project.iw_trial_invoice_fixed_price, }\"> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=iw_contracted_at class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.iw_information.moto_kakin_kaishibi' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.billing.iw_information.hizuke_wo_nyuuryoku' | translate }}\"></i></label><div class=col-md-7><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick type=text id=iw_contracted_at class=form-control date=project.iw_contracted_at min=project.iw_trial_started_at></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=iw_cancelled_at class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.iw_information.kaiyaku_hi' | translate }}</label><div class=col-md-7><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick id=iw_cancelled_at class=form-control date=project.iw_cancelled_at min=project.iw_contracted_at></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=iw_invoice_fixed_price class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.iw_information.getsugaku_kotei_riyouryoukin' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.billing.iw_information.seikyuu_ni_youiraremasu' | translate }}\"></i></label><div class=col-md-7><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=iw_invoice_fixed_price class=form-control type=number placeholder=10000 ng-model=project.iw_invoice_fixed_price ng-disabled=!project.iw_contracted_at ng-required=project.iw_contracted_at> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.billing.iw_information.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/lens_information.html';
var html = "<div id=projectSettingsBase class=col-md-12><h1 class=config-title>{{ 'projectsSettings.billing.lens_information.jouhou' | translate }}</h1><div class=\"alert alert-warning\" role=alert><ng-container translate=projectsSettings.billing.lens_information.chuui_seikyuu_settei translate-value-note=\"<strong>{{ 'projectsSettings.billing.lens_information.note' | translate }}</strong>\"></ng-container></div><div class=\"alert alert-warning\" role=alert><ng-container translate=projectsSettings.billing.lens_information.chuui_shuuryoubi_kanren translate-value-note=\"<strong>{{ 'projectsSettings.billing.lens_information.note' | translate }}</strong>\"></ng-container><br><br>{{ 'projectsSettings.billing.lens_information.reikai_yaku_hi' | translate }}</div><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row><div class=col-md-12><div class=form-group><label for=lens_contracted_at class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.lens_information.kakin_kaishibi' | translate }}</label><div class=col-md-7><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick type=text id=lens_contracted_at class=form-control date=project.lens_contracted_at min=project.lens_trial_started_at></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=lens_cancelled_at class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.lens_information.kaiyaku_hi' | translate }}</label><div class=col-md-7><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick id=lens_cancelled_at class=form-control date=project.lens_cancelled_at min=project.lens_contracted_at></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=lens_invoice_fixed_price class=\"col-md-3 control-label\">{{ 'projectsSettings.billing.lens_information.getsugaku_kotei_riyouryoukin' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.billing.lens_information.seikyuu_ni_youiraremasu' | translate }}\"></i></label><div class=col-md-7><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=lens_invoice_fixed_price class=form-control type=number placeholder=10000 ng-model=project.lens_invoice_fixed_price ng-disabled=!project.lens_contracted_at ng-required=project.lens_contracted_at> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.billing.lens_information.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/submenu.html';
var html = "<ul ng-if=isCommon class=config-submenu-list><li ui-sref=admin.projects.settings.billing() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=billingContractInformation></zc-setting-status>&nbsp;<a>{{ 'projectsSettings.billing.submenu.keiyaku_jouhou' | translate }}</a></li><li ng-if=\"project.is_direct_selling && project.sales_entity_fullname === 'Appier Japan (JP)'\" ui-sref=admin.projects.settings.billing.billing_information() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=billingInformation></zc-setting-status>&nbsp;<a>{{ 'projectsSettings.billing.submenu.seikyuu_jouhou' | translate }}</a></li><li ng-if=\"project.is_direct_selling && project.sales_entity_fullname === 'Appier Japan (JP)'\" ui-sref=admin.projects.settings.billing.representative_information() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=billingRepresentativeInformation></zc-setting-status>&nbsp;<a>{{ 'projectsSettings.billing.submenu.seikyuu_tantousha_jouhou' | translate }}</a></li><li class=submenu-list-heading zc-master-only>{{ 'projectsSettings.billing.submenu.settei' | translate }}</li><li ui-sref=admin.projects.settings.billing.zc_information() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><i class=\"fa fa-lock\"></i> &nbsp;<a>{{ 'projectsSettings.billing.submenu.info_zenclerk' | translate }}</a></li><li ui-sref=admin.projects.settings.billing.iw_information() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><i class=\"fa fa-lock\"></i> &nbsp;<a>{{ 'projectsSettings.billing.submenu.info_iw' | translate }}</a></li><li ui-sref=admin.projects.settings.billing.lens_information() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><i class=\"fa fa-lock\"></i> &nbsp;<a>{{ 'projectsSettings.billing.submenu.info_lens' | translate }}</a></li><li ng-if=\"project.sales_entity === 'appier_jp' || project.region === 'asia_taipei'\" ui-sref=admin.projects.settings.billing.invoice_information() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><i class=\"fa fa-lock\"></i> &nbsp;<a>{{ 'projectsSettings.billing.submenu.seikyuusho_jouhou' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/billing/zc_information.html';
var html = "<div id=projectSettingsBase class=col-md-12><h1 class=config-title>{{ 'projectsSettings.billing.zc_information.jouhou' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.billing.zc_information.toraiaru_kaishibi_to' | translate }}</p><div class=\"alert alert-warning\" role=alert><ng-container translate=projectsSettings.billing.zc_information.chuui_seikyuu_settei translate-value-note=\"<strong>{{ 'projectsSettings.billing.zc_information.note' | translate }}</strong>\"></ng-container></div><div class=\"alert alert-warning\" role=alert><ng-container translate=projectsSettings.billing.zc_information.chuui_shuuryoubi_kanren translate-value-note=\"<strong>{{ 'projectsSettings.billing.zc_information.note' | translate }}</strong>\"></ng-container><br><br>{{ 'projectsSettings.billing.zc_information.reitoraiaru_shuuryoubi_wa' | translate }}</div><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><div class=row><div class=col-md-12><div class=form-group><label for=contracted_at class=\"col-md-4 control-label\">{{ 'projectsSettings.billing.zc_information.moto_kakin_kaishibi' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.billing.zc_information.henkou_suru_to' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-md-8><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick type=text id=contracted_at class=form-control date=project.contracted_at is-required=false></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=terminated_at class=\"col-md-4 control-label\">{{ 'projectsSettings.billing.zc_information.kaiyaku_hi' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.billing.zc_information.hizuke_wo_nyuuryoku' | translate }}\" tooltip-append-to-body=true></i></label><div class=col-md-8><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick type=text id=terminated_at class=form-control date=project.terminated_at is-required=false></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=select-pricing-type class=\"col-md-4 control-label\">{{ 'projectsSettings.billing.zc_information.pricingType' | translate }}</label><div class=col-md-8><label class=radio-inline ng-repeat=\"pricingType in pricingTypes\" ng-if=\"(pricingType.name == 'tiered' && project.product_line == 'zenclerk') || pricingType.name != 'tiered'\"><input id=select-pricing-type type=radio ng-model=project.pricing_type ng-value=pricingType.name> {{ pricingType.label }}</label></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=invoice_calculation_type class=col-md-4>{{ 'projectsSettings.billing.zc_information.seikyuu_keisan_houhou' | translate }}</label><div class=col-md-8><select id=invoice_calculation_type class=form-control ng-options=\"item.name as item.label for item in invoiceCalculationTypes\" ng-model=project.invoice_calculation_type ng-disabled=!project.contracted_at ng-required=project.contracted_at></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=fixed_invoice_amount class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.kotei_seikyuugaku' | translate }}</label><div class=col-md-8><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=fixed_invoice_amount class=form-control type=number min=0 ng-disabled=\"project.product_line !== 'zenclerk_s' && project.invoice_calculation_type !== 'fixed'\" ng-required=\"project.invoice_calculation_type === 'fixed'\" ng-model=project.fixed_invoice_amount> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=max_invoice class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.seikyuu_jougen' | translate }}</label><div class=col-md-8><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=max_invoice class=form-control type=number min=0 ng-model=project.max_invoice ng-disabled=\"project.product_line === 'zenclerk_s'\"> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=warm_up_end_date class=\"col-md-4 control-label\">{{ 'projectsSettings.billing.zc_information.warm_up_end_date' | translate }}</label><div class=col-md-8><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input datepick type=text id=warm_up_end_date class=form-control date=project.warm_up_end_date ng-disabled=\"project.pricing_type !== 'minimum_charge'\" is-required=\"project.pricing_type == 'minimum_charge'\"></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=base_cpa class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.base_cpa' | translate }}</label><div class=col-md-8><div class=input-group><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=base_cpa class=form-control type=\"number:'1.0-2'\" min=0 step=1 ng-model=project.base_cpa ng-pattern=\"/^(\\d)*(\\.[\\d]?[\\d]?)?$/\" ng-disabled=\"project.pricing_type !== 'minimum_charge'\" is-required=\"project.pricing_type == 'minimum_charge'\"> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=minimum_charge class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.minimamuchaaji' | translate }}</label><div class=col-md-8><div class=input-group tooltip=\"{{ 'projectsSettings.billing.zc_information.minimamuchaaji_wa_saitei' | translate }}\" tooltip-enable=\"project.product_line !== 'zenclerk_s' && project.minimal_invoice !== null\" tooltip-append-to-body=true><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=minimum_charge class=form-control type=number min=0 ng-disabled=\"project.product_line === 'zenclerk_s' || project.minimal_invoice !== null\" ng-model=project.minimum_charge is-required=\"project.pricing_type == 'minimum_charge'\"> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=minimum_usage class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.minimum_usage' | translate }}</label><div class=col-md-8><div class=input-group><input id=minimum_usage class=form-control type=number min=0 ng-model=project.minimum_usage ng-disabled=\"project.pricing_type !== 'minimum_charge'\" is-required=\"project.pricing_type == 'minimum_charge'\"></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=minimal_invoice class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.saitei_riyou_tesuuryou' | translate }}</label><div class=col-md-8><div class=input-group tooltip=\"{{ 'projectsSettings.billing.zc_information.saitei_tesuuryou_wa' | translate }}\" tooltip-enable=\"project.product_line !== 'zenclerk_s' && project.minimum_charge !== null\" tooltip-append-to-body=true><span ng-if=currency.symbol class=input-group-addon>{{ currency.symbol }}</span> <input id=minimal_invoice class=form-control type=number min=0 ng-disabled=\"project.product_line === 'zenclerk_s' || project.minimum_charge !== null\" ng-model=project.minimal_invoice> <span ng-if=currency.suffix class=input-group-addon>{{ currency.suffix }}</span></div></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=fee_rate class=\"control-label col-md-4\">{{ 'projectsSettings.billing.zc_information.tesuuryou_ritsu' | translate }}</label><div class=col-md-8><input id=fee_rate class=form-control type=number min=0 max=1 step=0.001 placeholder=0.1 ng-model=project.fee_rate ng-required=\"project.product_line === 'zenclerk'\"></div></div></div></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.billing.zc_information.henkou_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/advertising.html';
var html = "<div id=projectSettingsBase><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/general' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.campaign.advertising.title' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.campaign.advertising.description' | translate }}</p><section><zc-advertising-editor project-id=project.id></zc-advertising-editor></section></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/advertising_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.advertisingEditor.urlParameter' | translate }}</label> <input type=text class=form-control ng-model=newItem.parameter required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.advertisingEditor.matchType' | translate }}</label><select class=form-control ng-options=\"t.name as t.label for t in matchTypes\" ng-model=newItem.match_type required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.advertisingEditor.matchPattern' | translate }}</label> <input type=text class=form-control ng-model=newItem.match_pattern required></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!(newItem.parameter && newItem.match_type && newItem.match_pattern )\">{{ 'projectsSettings.campaign.advertisingEditor.save' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.campaign.advertisingEditor.adjustmentList' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.campaign.advertisingEditor.adjustmentNotSet' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.campaign.advertisingEditor.parameter' | translate }}</th><th>{{ 'projectsSettings.campaign.advertisingEditor.matchType' | translate }}</th><th>{{ 'projectsSettings.campaign.advertisingEditor.matchPattern' | translate }}</th><th>{{ 'projectsSettings.campaign.advertisingEditor.creationDate' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.parameter}}</td><td>{{item.match_type}}</td><td>{{item.match_pattern}}</td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.campaign.advertisingEditor.delete' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/dm_upload.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.campaign.dmUpload.title' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.campaign.dmUpload.uploadingLimitCampaign' | translate }}<br>{{ 'projectsSettings.campaign.dmUpload.campaignsDistributedOnlyUsers' | translate }}</p><section><h2 class=config-subtitle>{{ 'projectsSettings.campaign.dmUpload.beforeUse' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.campaign.dmUpload.trackingTagSetting' | translate }}</p><div hljs hljs-language=html no-escape>&lt;script type=&quot;text/javascript&quot;&gt; __zc.setVisitorIdForDM(&quot;*****&quot;); &lt;/script&gt;</div></section><section><h2 class=config-subtitle>{{ 'projectsSettings.campaign.dmUpload.userIdList' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.campaign.dmUpload.uploadWarning' | translate }}</p><div class=form-group ng-controller=VisitorIdForDMUploadCtrl flow-init><input type=file flow-btn style=display:none> <button type=button class=\"btn btn-config\" flow-btn><i class=\"fa fa-upload\"></i> {{ 'projectsSettings.campaign.dmUpload.userListUpload' | translate }}</button></div><div><ul><li>{{ 'projectsSettings.campaign.dmUpload.downloadTemplate' | translate }}:&nbsp; <a target=_self href=/csvs/visitor_id_for_dm_sample.csv download=csvs/visitor_id_for_dm_sample.csv><i class=\"fa fa-download\"></i> visitor_id_for_dm_sample.csv</a></li><li>{{ 'projectsSettings.campaign.dmUpload.fileEncoding' | translate }}</li><li translate=projectsSettings.campaign.dmUpload.fileLimit translate-value-limit=2,000,000></li></ul></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/newsletter.html';
var html = "<div id=projectSettingsBase><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/general' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.campaign.newsletter.title' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.campaign.newsletter.description' | translate }}</p><section><zc-newsletter-parameter-editor project-id=project.id></zc-newsletter-parameter-editor></section></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/newsletter_parameter_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.newsletterParameterEditor.parameterName' | translate }}</label> <input type=text class=form-control ng-model=newItem.name required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.newsletterParameterEditor.matchType' | translate }}</label><select class=form-control ng-options=\"t.name as t.label for t in matchTypes\" ng-model=newItem.match_type required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.newsletterParameterEditor.matchPattern' | translate }}</label> <input type=text class=form-control ng-model=newItem.match_pattern required></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!(newItem.name && newItem.match_type && newItem.match_pattern )\">{{ 'projectsSettings.campaign.newsletterParameterEditor.save' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.campaign.newsletterParameterEditor.newsletterList' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.campaign.newsletterParameterEditor.newsletterNotSet' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.campaign.newsletterParameterEditor.parameterName' | translate }}</th><th>{{ 'projectsSettings.campaign.newsletterParameterEditor.matchType' | translate }}</th><th>{{ 'projectsSettings.campaign.newsletterParameterEditor.matchPattern' | translate }}</th><th>{{ 'projectsSettings.campaign.newsletterParameterEditor.creationDate' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.name}}</td><td>{{item.match_type}}</td><td>{{item.match_pattern}}</td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.campaign.newsletterParameterEditor.delete' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/no_publish_page_type.html';
var html = "<div id=projectSettingsBase><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/campaign' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.campaign.noPublishPageType.haishin_jogai_peeji' | translate }}</h1><p translate=projectsSettings.campaign.noPublishPageType.kaki_de_shitei translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.kyanpeen_haishin' | translate }}</strong>\"></p><p translate=projectsSettings.campaign.noPublishPageType.seeru_shouhin_wo translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.seeru_shouhin_strong' | translate }}</strong>\"></p><p>{{ 'projectsSettings.campaign.noPublishPageType.kyanpeen_wo_uketotte' | translate }}<br><ng-container translate=projectsSettings.campaign.noPublishPageType.touroku_kanou_kensuu translate-value-limit=\"<strong>{{ noPublishPageTypeLimit | number : 0 }}</strong>\"></ng-container></p><h2 class=config-subtitle>{{ 'projectsSettings.campaign.noPublishPageType.chokusetsu_settei_houhou' | translate }}</h2><p><ng-container translate=projectsSettings.campaign.noPublishPageType.kaki_no_jogai translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.kaki_no_jogai_strong' | translate }}</strong>\"></ng-container><br><ng-container translate=projectsSettings.campaign.noPublishPageType.jogai_shitaipeejino_domein_ikou translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.jogai_shitaipeejino_domein_ikou_strong' | translate }}</strong>\"></ng-container></p><p><ng-container translate=projectsSettings.campaign.noPublishPageType.peeji_no_itchihantei translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.peeji_no_itchihantei_strong' | translate }}</strong>\"></ng-container></p><h2 class=config-subtitle>{{ 'projectsSettings.campaign.noPublishPageType.rei' | translate }}</h2><p><ng-container translate=projectsSettings.campaign.noPublishPageType.tatoeba_toiu_wo translate-value-code=\"<code>{{ baseUrl }}/item/1234</code>\"></ng-container><br><ng-container translate=projectsSettings.campaign.noPublishPageType.hantei_jouken_ha translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.hantei_jouken_ha_strong' | translate }}</strong>\" translate-value-code=\"<code>/item/1234</code>\"></ng-container><br></p><p><ng-container translate=projectsSettings.campaign.noPublishPageType.mata_toitta_mo_jogai translate-value-code=\"<code>{{ baseUrl }}/item/1234/?ad_click</code>\"></ng-container><br><ng-container translate=projectsSettings.campaign.noPublishPageType.hantei_jouken_ni translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.hantei_jouken_ni_strong' | translate }}</strong>\"></ng-container><br></p><p><ng-container translate=projectsSettings.campaign.noPublishPageType.hantei_jouken_no translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.hantei_jouken_no_strong' | translate }}</strong>\"></ng-container><br>{{ 'projectsSettings.campaign.noPublishPageType.ayamatte_yokishinai_wo' | translate }}</p><h2 class=config-subtitle>{{ 'projectsSettings.campaign.noPublishPageType.de_ikkatsu_touroku' | translate }}</h2><p><ng-container translate=projectsSettings.campaign.noPublishPageType.kaki_no_fairu_de translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.kaki_no_fairu_de_strong' | translate }}</strong>\"></ng-container><br>{{ 'projectsSettings.campaign.noPublishPageType.hantei_jouken_ga' | translate }}<br><ng-container translate=projectsSettings.campaign.noPublishPageType.touroku_kensuu_ga translate-value-limit=\"{{ noPublishPageTypeLimit | number : 0 }}\"></ng-container></p><p><ng-container translate=projectsSettings.campaign.noPublishPageType.nao_niha_kaki_no translate-value-strong=\"<strong>{{ 'projectsSettings.campaign.noPublishPageType.nao_niha_kaki_no_strong' | translate }}</strong>\"></ng-container><ul><li>{{ 'projectsSettings.campaign.noPublishPageType.prefix' | translate }}<strong>{{ 'projectsSettings.campaign.noPublishPageType.zenpouitchi' | translate }}</strong></li><li>{{ 'projectsSettings.campaign.noPublishPageType.full' | translate }}<strong>{{ 'projectsSettings.campaign.noPublishPageType.kanzen_itchi' | translate }}</strong></li><li>{{ 'projectsSettings.campaign.noPublishPageType.partial' | translate }}<strong>{{ 'projectsSettings.campaign.noPublishPageType.bubunitchi' | translate }}</strong></li></ul></p><p><a target=_self href=/assets/csv/no_publish_page_sample.csv download=/assets/csv/no_publish_page_sample.csv><i class=\"fa fa-download\"></i> {{ 'projectsSettings.campaign.noPublishPageType.sanpurufairu_wa_kochira' | translate }}</a></p><div class=col-sm-12 ng-if=\"noPublishPageTypes.length > 0\"><div ng-repeat=\"pageType in noPublishPageTypes | limitTo : noPublishPageTypesVisibleLimit\" page-type=pageType><zc-no-publish-page-form project=project page-type=pageType on-destroy=onDestroyNoPublishPageType(pageType)></zc-no-publish-page-form></div></div><div class=\"col-sm-12 text-center\" style=\"margin-top: 15px;\"><button class=\"btn btn-success\" ng-click=setNoPublishPageTypesVisibleLimit(noPublishPageTypeLimit) ng-if=\"noPublishPageTypes.length > noPublishPageTypesVisibleLimit\" translate=projectsSettings.campaign.noPublishPageType.subete_no_haishin translate-value-type=\"{{ noPublishPageTypes.length | number : 0 }}\"></button></div><div class=\"col-sm-12 text-center\" style=\"margin-top: 15px;\"><button class=\"btn btn-success\" ng-disabled=\"noPublishPageTypes.length > noPublishPageTypesVisibleLimit\" ng-click=addNoPublishPageType()><i class=\"fa fa-plus\"></i> {{ 'projectsSettings.campaign.noPublishPageType.jogai_peeji_wo' | translate }}</button> <span flow-init ng-controller=zcNoPublishPageTypeCsvController><button flow-btn ng-disabled=\"noPublishPageTypes.length > noPublishPageTypeLimit\" class=\"btn btn-success\">{{ 'projectsSettings.campaign.noPublishPageType.fairu_de_ikkatsu' | translate }}</button></span> <button class=\"btn btn-danger\" confirm-click=removePageTypes() confirm-modal>{{ 'projectsSettings.campaign.noPublishPageType.subete_sakujo_suru' | translate }}</button></div></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/no_publish_page_type_form.html';
var html = "<form name=noPublishPageForm ng-submit=vm.savePageType()><div class=\"col-sm-3 base-url\"><select class=form-control ng-model=vm.pageType.match_type ng-options=\"pt.value as pt.name for pt in vm.matchTypes\" required></select></div><div class=col-sm-5><input type=text class=form-control name=match_pattern required ng-model=vm.pageType.match_pattern></div><div class=col-sm-4><span style=\"width: 50%\"><div class=\"btn btn-danger\" confirm-click=vm.destroyPageType() confirm-modal ng-disabled=vm.isDestroying>{{ 'projectsSettings.campaign.noPublishPageTypeForm.sakujo' | translate }}</div></span> <span style=\"width: 50%\"><button ng-disabled=\"noPublishPageForm.$invalid || !noPublishPageForm.$dirty || vm.isSaving\" class=\"btn btn-success\">{{ 'projectsSettings.campaign.noPublishPageTypeForm.hozon' | translate }}</button></span></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/segment_cookie.html';
var html = "<div id=projectSettingsBase><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/general' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.campaign.segmentCookie.title' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.campaign.segmentCookie.description' | translate }}</p><section><zc-segment-cookie-editor project-id=project.id></zc-segment-cookie-editor></section></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/segment_cookie_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.segmentCookieEditor.cookieName' | translate }}</label> <input type=text class=form-control ng-model=newItem.name required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.segmentCookieEditor.segment' | translate }}</label> <input type=text class=form-control ng-model=newItem.segment required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.campaign.segmentCookieEditor.matchPattern' | translate }}</label> <input type=text class=form-control ng-model=newItem.match_pattern required></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=form.$invalid>{{ 'projectsSettings.campaign.segmentCookieEditor.save' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.campaign.segmentCookieEditor.segmentCookieList' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.campaign.segmentCookieEditor.segmentCookieNotSet' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.campaign.segmentCookieEditor.cookieName' | translate }}</th><th>{{ 'projectsSettings.campaign.segmentCookieEditor.segment' | translate }}</th><th>{{ 'projectsSettings.campaign.segmentCookieEditor.matchPattern' | translate }}</th><th>{{ 'projectsSettings.campaign.segmentCookieEditor.creationDate' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.name}}</td><td>{{item.segment}}</td><td>{{item.match_pattern}}</td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.campaign.segmentCookieEditor.delete' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/submenu.html';
var html = "<ul class=config-submenu-list><li ui-sref=admin.projects.settings.campaign() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active ng-if=\"isMaster || project.shows_no_publish_page_type\"><div class=config-locked ng-if=!project.shows_no_publish_page_type><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.campaign.submenu.haishin_jogai_peeji' | translate }}</a></li><li ui-sref=admin.projects.settings.campaign.timing() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.campaign.submenu.taimingu_touroku' | translate }}</a></li><li ui-sref=admin.projects.settings.campaign.advertising() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.campaign.submenu.koukoku_parameeta_touroku' | translate }}</a></li><li ui-sref=admin.projects.settings.campaign.newsletter() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.campaign.submenu.merumagaparameeta_touroku' | translate }}</a></li><li ui-sref=admin.projects.settings.campaign.segment_cookie() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.campaign.submenu.kukkii_riyou_segumento' | translate }}</a></li><li ui-sref=admin.projects.settings.campaign.dm_upload() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.campaign.submenu.jarangorufu_you_yuuzaa_gentei' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/campaign/timing.html';
var html = "<div flow-init=\"{target: campaignPolicySetUploadUrl}\" flow-files-submitted=$flow.upload() flow-file-success=\"$file.msg = $message\" ng-controller=CampaignPolicySetCtrl><h1 class=config-title>{{ 'projectsSettings.campaign.timing.title' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.campaign.timing.description' | translate }}</p><section><form name=pocicy><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label for=campaign-policy-set-name>{{ 'projectsSettings.campaign.timing.timingName' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.campaign.timing.timingNameTooltip' | translate }}\"></i></label> <input id=campaign-policy-set-name type=text class=form-control ng-model=campaignPolicySet.name></div></div><div class=config-form-table-cell><div class=form-group><label for=campaign-policy-set-description>{{ 'projectsSettings.campaign.timing.explanation' | translate }}</label> <input id=campaign-policy-set-description type=text class=form-control ng-model=campaignPolicySet.description required></div></div><div class=config-form-table-cell><input type=file flow-btn style=display:none> <button type=button class=\"btn btn-config\" flow-btn ng-disabled=!campaignPolicySet.description><i class=\"fa fa-file\"></i> {{ 'projectsSettings.campaign.timing.selectAndUpload' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.campaign.timing.csvList' | translate }}</h2><div class=config-no-data ng-if=!campaignPolicySets.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.campaign.timing.noFileUploaded' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=campaignPolicySets.length><tr><th>ID</th><th>{{ 'projectsSettings.campaign.timing.csvName' | translate }}</th><th>{{ 'projectsSettings.campaign.timing.creationDate' | translate }}</th><th>{{ 'projectsSettings.campaign.timing.action' | translate }}</th></tr><tr ng-repeat=\"set in campaignPolicySets | orderBy:'-created_at'\"><td>{{set.id}}</td><td><strong>{{set.name}}</strong><div class=config-table-description>{{set.description}}</div></td><td>{{set.created_at | zcDate : {smart:true} }}</td><td><div class=config-table-download><i class=\"fa fa-download\" ng-hide=\"set.name === 'no_condition'\" ng-click=downloadCampaignPolicySet(set.id)></i></div><div class=config-table-remove><i class=\"fa fa-times\" confirm-modal confirm-click=removeCampaignPolicySet(set.id)></i></div></td></tr></table></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/index.html';
var html = "<div id=installation><div class=container><div class=config-wrapper><div class=config-menu><div ui-view=menu></div></div><div class=config-submenu><div ui-view=submenu></div></div><div class=config-content><div class=config-content-wrapper><div ui-view=content></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cart_button.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.cartButton.kaatobotankurikku' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.cartButton.kaatobotankurikku_ritsu' | translate }}\" indicator=cart_button_click_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.cartButton.kaatobotannoserekutaa_wo_nyuuryoku' | translate }}<br>{{ 'projectsSettings.initialization.cartButton.serekutaaha_kaatobotanga_uchi_ni' | translate }}</p><zc-cart-button-editor project-id=project.id></zc-cart-button-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cart_button_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.cartButtonEditor.peejitaipu' | translate }}</label><select class=form-control ng-options=\"pt.name as pt.label for pt in cartButtonPageTypes\" ng-model=newItem.page_type></select></div></div><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.cartButtonEditor.serekutaa' | translate }}</label> <input id=cartButtonSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.cartButtonEditor.iframeSelector' | translate }}</label> <input id=cartButtonIframe type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.iframe_selector></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!form.$valid || !form.$dirty\">{{ 'projectsSettings.initialization.cartButtonEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.cartButtonEditor.kaatobotanrisuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.cartButtonEditor.kaatobotan_ga_settei' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.cartButtonEditor.peejitaipu' | translate }}</th><th>{{ 'projectsSettings.initialization.cartButtonEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.initialization.cartButtonEditor.iframeSelector' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.page_type}}</td><td>{{item.selector}}</td><td>{{item.iframe_selector}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.cartButtonEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cart_price.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.cartPrice.kaato_goukei_kingaku' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.cartPrice.kaato_goukei_kingaku' | translate }}\" indicator=cart_price_found_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.cartPrice.okyakusama_ga_genzai' | translate }}<br>{{ 'projectsSettings.initialization.cartPrice.settei_shitapeejitaipu_de' | translate }}</p><zc-cart-price-editor project-id=project.id></zc-cart-price-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cart_price_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.cartPriceEditor.peejitaipu' | translate }}</label><select class=form-control ng-options=\"pt.name as pt.label for pt in cartPricePageTypes\" ng-model=newItem.page_type></select></div></div><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.cartPriceEditor.serekutaa' | translate }}</label> <input type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!(newItem.page_type && newItem.selector )\">{{ 'projectsSettings.initialization.cartPriceEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.cartPriceEditor.cartTotalPriceList' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.cartPriceEditor.kaato_goukei_kingaku_arimasen' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.cartPriceEditor.peejitaipu' | translate }}</th><th>{{ 'projectsSettings.initialization.cartPriceEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.initialization.cartPriceEditor.sakusei_hizuke' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.page_type}}</td><td>{{item.selector}}</td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.cartPriceEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cookie_editor.html';
var html = "<section><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.cookieEditor.domain' | translate }}</label> <input id=cookieDomain name=cookieDomain type=text class=form-control ng-model=newItem.domain ng-disabled=\"domainLinkType !== 'auto'\" ng-required=\"domainLinkType === 'auto' && items.length < 2\"><p class=text-danger ng-if=\"domainLinkType === 'auto' && items.length < 2\">{{ 'projectsSettings.initialization.cookieEditor.domein_wo_tsu' | translate }}</p></div></div><div class=config-form-table-cell><button type=button class=\"btn btn-config\" ng-click=add() ng-disabled=\"!newItem.domain || domainLinkType !== 'auto'\"><i class=\"fa fa-plus\"></i> {{ 'projectsSettings.initialization.cookieEditor.tsuika' | translate }}</button></div></div></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.cookieEditor.domainList' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.cookieEditor.domein_ga_settei' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.cookieEditor.domain' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.domain}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.cookieEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cookie_server_setting.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.cookie_server_setting.title' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=row><div class=col-md-12><div class=form-group><label for=cookie_server_enabled class=\"col-md-3 control-label\">{{ 'projectsSettings.initialization.cookie_server_setting.cookie_server_enabled' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.initialization.cookie_server_setting.description' | translate }}\"></i></label><div class=col-sm-6><select id=cookie_server_enabled ng-options=\"option for option in [true, false]\" ng-model=project.cookie_server_enabled class=form-control></select></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=cookie_server_client_fqdn class=\"col-md-3 control-label\">{{ 'projectsSettings.initialization.cookie_server_setting.cookie_server_client_fqdn' | translate }}</label><div class=col-sm-6><input id=cookie_server_client_fqdn class=form-control ng-model=project.cookie_server_client_fqdn ng-required=project.cookie_server_enabled ng-disabled=!project.cookie_server_enabled></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=cookie_server_aiqua_fqdn class=\"col-md-3 control-label\">{{ 'projectsSettings.initialization.cookie_server_setting.cookie_server_aiqua_fqdn' | translate }}</label><div class=col-sm-6><input id=cookie_server_aiqua_fqdn class=form-control ng-model=project.cookie_server_aiqua_fqdn ng-required=project.cookie_server_enabled ng-disabled=!project.cookie_server_enabled></div></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.initialization.cookie_server_setting.save' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/cross_domain.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.crossDomain.kurosudomein_settei' | translate }}</h1><zc-domain-sampler project=project></zc-domain-sampler><p class=config-lead>{{ 'projectsSettings.initialization.crossDomain.dounyuu_saki_no' | translate }}</p><section><form name=form class=form-condenced zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.crossDomain.rookarusutoreeji_no_riyou' | translate }} <i class=\"fa fa-question-circle\" tooltip=\"{{ 'projectsSettings.initialization.crossDomain.riyou_suru_to' | translate }}\" tooltip-trigger=mouseenter tooltip-placement=top></i></h2><div class=\"form-group checkbox\"><label><input ng-model=project.use_local_storage_for_cross_domain_tracking type=checkbox> {{ 'projectsSettings.initialization.crossDomain.rookarusutoreeji_wo_riyou' | translate }}</label></div><h2 class=config-subtitle>{{ 'projectsSettings.initialization.crossDomain.kurosudomein_settei_no' | translate }} <i class=\"fa fa-question-circle\" tooltip=\"{{ 'projectsSettings.initialization.crossDomain.wakaranai_pataan_ga' | translate }}\" tooltip-trigger=mouseenter tooltip-placement=top></i></h2><div class=form-group><select id=domainLinkType class=form-control ng-options=\"item.name as item.label for item in domainLinkTypes\" ng-model=project.domain_link_type></select></div></section><section ng-show=\"project.domain_link_type =='cookie'\" class=config-sub-section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.crossDomain.kurosudomein_you_no' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.initialization.crossDomain.yuuzaa_wo_ichii' | translate }}</p><div class=\"alert alert-warning\" role=alert><strong>{{ 'projectsSettings.initialization.crossDomain.note' | translate }}:</strong> {{ 'projectsSettings.initialization.crossDomain.chuui_kukkii_shutoku' | translate }}</div><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.crossDomain.kukkii_na' | translate }}</label> <input name=systemSessionCookie id=systemSessionCookie type=text class=form-control ng-model=project.system_session_cookie ng-required=\"project.domain_link_type === 'cookie'\"></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.crossDomain.kukkii_shutoku_seikihyougen' | translate }}</label> <input type=text class=form-control ng-model=project.system_session_cookie_match_pattern></div></div><div class=config-form-table-cell><button type=button class=\"btn btn-config\" ng-click=\"save(project); form.$setPristine()\" ng-disabled=editCookieForm.systemSessionCookie.$error.required><i class=\"fa fa-plus\"></i> {{ 'projectsSettings.initialization.crossDomain.tsuika' | translate }}</button></div></div></section><section ng-show=\"project.domain_link_type =='auto'\" class=config-sub-section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.crossDomain.shiyou_domein_no' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.initialization.crossDomain.shiyou_shiteirudomein_wo' | translate }}</p><zc-cookie-editor project-id=project.id domain-link-type=project.domain_link_type></zc-cookie-editor></section><button class=\"btn btn-config\" type=submit>{{ 'projectsSettings.initialization.crossDomain.settei_wo_hozon' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/distinguish_direct_indirect_cv.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.distinguish_direct_indirect_cv.title' | translate }}</h1><div class=config-lead><p>{{ 'projectsSettings.initialization.distinguish_direct_indirect_cv.description' | translate }}</p></div><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=row><div class=col-md-12><div class=form-group><div class=col-sm-6><select id=distinguish_direct_indirect_cv ng-options=\"option for option in [true, false]\" ng-disabled=\"project.product_line !== 'zenclerk_lp'\" ng-model=project.enable_direct_cv class=form-control></select></div></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.initialization.distinguish_direct_indirect_cv.save' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/exclude_ip.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.initialization.excludeIp.jogai_e_no' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.initialization.excludeIp.kaki_no_chekkubokkusu' | translate }}</p><section><form name=form class=\"form-horizontal form-condenced\" zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><section><div class=checkbox><label><input ng-model=project.is_publish_for_exclude_ips type=checkbox> {{ 'projectsSettings.initialization.excludeIp.shuukei_kara_wa' | translate }}</label></div></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.initialization.excludeIp.hozon_suru' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/exclude_ip_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\" novalidate><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.excludeIpEditor.guroobaruadoresu' | translate }}</label><div class=row><div class=col-sm-3><select type class=form-control name=matchType ng-model=newItem.match_type><option value=full>{{ 'projectsSettings.initialization.excludeIpEditor.kanzen_itchi' | translate }}</option><option value=prefix>{{ 'projectsSettings.initialization.excludeIpEditor.zenpouitchi' | translate }}</option><option value=regexp ng-if=isMaster>{{ 'projectsSettings.initialization.excludeIpEditor.seikihyougen_masutaanomi' | translate }}</option></select></div><div class=col-sm-9 ng-if=\"newItem.match_type === 'full'\"><input type=text class=form-control name=ipAddress placeholder=120.222.123.132 ng-model=newItem.ip ng-pattern=\"/^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$/\" required><p class=config-description ng-if=\"newItem.match_type === 'full'\"><ng-container translate=projectsSettings.initialization.excludeIpEditor.rei_hankaku_nyuuryoku translate-value-ip=120.222.123.132></ng-container></p></div><div class=col-sm-9 ng-if=\"newItem.match_type === 'prefix'\"><input type=text class=form-control name=ipAddress placeholder=120.222. ng-model=newItem.ip ng-pattern=\"/^\\d{1,3}\\.\\d{1,3}\\.(\\d{1,3}\\.)?$/\" required><p ng-if=\"newItem.match_type === 'prefix'\" translate=projectsSettings.initialization.excludeIpEditor.rei_hankaku_nyuuryoku translate-value-ip=120.222. class=config-description></p></div><div class=col-sm-9 ng-if=\"newItem.match_type === 'regexp'\"><input type=text class=form-control name=ipAddress placeholder=^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.$ ng-model=newItem.ip required><p ng-if=\"newItem.match_type === 'regexp'\" translate=projectsSettings.initialization.excludeIpEditor.rei_hankaku_nyuuryoku translate-value-ip=^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.$ class=config-description></p></div></div></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=form.$invalid>{{ 'projectsSettings.initialization.excludeIpEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.excludeIpEditor.guroobaruadoresu_risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.excludeIpEditor.guroobaru_ga_settei' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.excludeIpEditor.guroobaruadoresu' | translate }}</th><th>{{ 'projectsSettings.initialization.excludeIpEditor.matchitaipu' | translate }}</th><th></th></tr><tr ng-repeat=\"item in items\"><td>{{item.ip}}</td><td><span ng-if=\"item.match_type === 'full'\">{{ 'projectsSettings.initialization.excludeIpEditor.kanzen_itchi' | translate }}</span> <span ng-if=\"item.match_type === 'prefix'\">{{ 'projectsSettings.initialization.excludeIpEditor.zenpouitchi' | translate }}</span> <span ng-if=\"item.match_type === 'regexp'\">{{ 'projectsSettings.initialization.excludeIpEditor.seikihyougen' | translate }}</span></td><td><div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.excludeIpEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/ga_tag_tracking.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.gaTagTracking.title' | translate }}</h1><div class=config-lead><p>{{ 'projectsSettings.initialization.gaTagTracking.gaLibrary' | translate }}<code>analytics.js</code></p><div class=\"alert alert-warning\" role=alert>{{ 'projectsSettings.initialization.gaTagTracking.libraryNote' | translate }}</div></div><section><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><h2 class=config-subtitle>{{ 'projectsSettings.initialization.gaTagTracking.parameterSetting' | translate }}</h2><fieldset ng-disabled=project.google_analytics_event_enable><div class=form-group><label class=\"col-sm-4 control-label\" for=trackingID>{{ 'projectsSettings.initialization.gaTagTracking.trackingID' | translate }}</label><div class=col-sm-4><input class=form-control ng-model=project.google_analytics_tracking_id placeholder=UA-XXXXXXXX-X id=trackingID type=text ng-pattern=/^ua-\\d{4,9}-\\d{1,4}$/i></div></div><div class=form-group><label class=\"col-sm-4 control-label\" for=eventCategory>{{ 'projectsSettings.initialization.gaTagTracking.eventCategory' | translate }}</label><div class=col-sm-4><input class=form-control ng-model=project.google_analytics_event_category placeholder=AiDeal id=eventCategory type=text></div></div><div class=form-group><label class=\"col-sm-4 control-label\">{{ 'projectsSettings.initialization.gaTagTracking.eventAction' | translate }}</label><div class=col-sm-8><div class=\"row form-group\"><label class=\"control-label col-sm-2\" for=experiment>experiment</label><div class=col-sm-4><input class=form-control ng-model=project.google_analytics_event_action placeholder=display id=experiment type=text></div></div><div class=\"row form-group\"><label class=\"control-label col-sm-2\" for=control>control</label><div class=col-sm-4><input class=form-control ng-model=project.google_analytics_event_action_control ng-disabled=!project.google_analytics_event_action_control_enable id=control type=text></div><div class=\"checkbox-inline col-sm-6\"><label class=control-label for=controlEvent><input id=controlEvent ng-model=project.google_analytics_event_action_control_enable type=checkbox> <span class=word-break>{{ 'projectsSettings.initialization.gaTagTracking.controlEvent' | translate }}</span></label></div></div></div></div><div class=form-group><label class=\"col-sm-4 control-label\" for=eventLabel>{{ 'projectsSettings.initialization.gaTagTracking.eventLabel' | translate }}</label><div class=col-sm-4><select class=form-control ng-model=project.google_analytics_event_label ng-options=\"item.name as item.label for item in googleAnalyticsEventLabels\" id=eventLabel></select></div></div></fieldset><button ng-disabled=!project.google_analytics_tracking_id class=\"btn btn-config\" type=submit ng-class=\"{'btn-config-success': project.google_analytics_event_enable}\"><i class=\"fa fa-check-circle\" ng-if=project.google_analytics_event_enable></i> <span ng-if=project.google_analytics_event_enable>{{ 'projectsSettings.initialization.gaTagTracking.enabledButton' | translate }}</span> <span ng-if=!project.google_analytics_event_enable>{{ 'projectsSettings.initialization.gaTagTracking.enableButton' | translate }}</span></button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/index.html';
var html = "<div id=projectSettingsBase><h1 class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/setup' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/item_list_price.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.itemListPrice.shouhin_risuto_kakaku' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.itemListPrice.shouhin_risuto_kakaku' | translate }}\" indicator=item_list_price_found_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.itemListPrice.okyakusama_ga_mite' | translate }}</p><zc-item-list-price-editor project-id=project.id></zc-item-list-price-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/item_list_price_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.itemListPriceEditor.serekutaa' | translate }}</label> <input type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!(newItem.selector)>{{ 'projectsSettings.initialization.itemListPriceEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.itemListPriceEditor.shouhin_ichiran_kingaku_risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.itemListPriceEditor.shouhin_ichiran_kingaku_ga_setteisaretemasen' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.itemListPriceEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.initialization.itemListPriceEditor.sakusei_hizuke' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}}</td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.itemListPriceEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/item_price.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.itemPrice.shouhin_kakaku_no' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.itemPrice.shouhin_kakaku_shutoku' | translate }}\" indicator=item_price_found_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.itemPrice.okyakusama_ga_mite' | translate }}<br>{{ 'projectsSettings.initialization.itemPrice.touroku_no_saiha' | translate }}<br>{{ 'projectsSettings.initialization.itemPrice.seeru_kakaku_no' | translate }}<br><br>{{ 'projectsSettings.initialization.itemPrice.fukusuu_no_serekutagamatchisuru' | translate }}</p><zc-item-price-editor project-id=project.id></zc-item-price-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/item_price_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label for=cartButtonSelector>{{ 'projectsSettings.initialization.itemPriceEditor.serekutaa' | translate }}</label> <input type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector></div><div class=form-group><label><input type=checkbox ng-model=newItem.is_sale> {{ 'projectsSettings.initialization.itemPriceEditor.seeru_shouhin' | translate }}</label></div><div class=form-group><label><input type=checkbox ng-model=newItem.is_text> {{ 'projectsSettings.initialization.itemPriceEditor.tekisuto_senyou_settei' | translate }}</label></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!(newItem.selector)>{{ 'projectsSettings.initialization.itemPriceEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.itemPriceEditor.shouhin_kingaku_risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.itemPriceEditor.shouhin_kingaku_ga' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.itemPriceEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.initialization.itemPriceEditor.seeru_shouhin' | translate }}</th><th>{{ 'projectsSettings.initialization.itemPriceEditor.tekisuto_senyou_settei' | translate }}</th><th>{{ 'projectsSettings.initialization.itemPriceEditor.sakusei_hizuke' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}}</td><td><i class=\"fa fa-check\" ng-if=item.is_sale></i></td><td><i class=\"fa fa-check\" ng-if=item.is_text></i></td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.itemPriceEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/login_evaluator.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.loginEvaluator.roguin_hantei' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.loginEvaluator.roguin_ritsu' | translate }}\" indicator=login_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.loginEvaluator.roguinshitakadouka_no_hantei' | translate }}</p><zc-login-evaluator-editor project-id=project.id></zc-login-evaluator-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/login_evaluator_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.loginEvaluatorEditor.kentai_taipu' | translate }}</label><select class=form-control ng-options=\"t.name as t.label for t in evaluationTypes\" ng-model=newItem.evaluation_type required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.loginEvaluatorEditor.namae' | translate }}</label> <input type=text class=form-control ng-model=newItem.name required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.loginEvaluatorEditor.matchitaipu' | translate }}</label><select class=form-control ng-options=\"t.name as t.label for t in matchTypes\" ng-model=newItem.match_type required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.initialization.loginEvaluatorEditor.matchipataan' | translate }}</label><div class=form-inline><input type=text class=form-control ng-model=newItem.match_pattern required></div></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!(newItem.evaluation_type && newItem.name && newItem.match_type && newItem.match_pattern )\">{{ 'projectsSettings.initialization.loginEvaluatorEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.initialization.loginEvaluatorEditor.roguin_hantei_risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.initialization.loginEvaluatorEditor.roguin_hantei_ga' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.initialization.loginEvaluatorEditor.kenchi_taipu' | translate }}</th><th>{{ 'projectsSettings.initialization.loginEvaluatorEditor.serekutaa_nakagurokukkii_na' | translate }}</th><th>{{ 'projectsSettings.initialization.loginEvaluatorEditor.matchitaipu' | translate }}</th><th>{{ 'projectsSettings.initialization.loginEvaluatorEditor.matchipataan' | translate }}</th><th>{{ 'projectsSettings.initialization.loginEvaluatorEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.initialization.loginEvaluatorEditor.sakuseinichiji' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.evaluation_type}}</td><td>{{item.name}}</td><td>{{item.match_type}}</td><td>{{item.match_pattern}}</td><td>{{item.iframe_selector}}</td><td>{{item.created_at | date}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.initialization.loginEvaluatorEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/page_type.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.pageType.peejitaipu' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.pageType.peejitaipukabaa_ritsu' | translate }}\" indicator=page_types_cover_rate></zc-session-sampler><zc-page-type-editor project-id=project.id></zc-page-type-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/page_type_editor.html';
var html = "<label>{{ 'projectsSettings.initialization.pageTypeEditor.sanpuru_settei' | translate }}:</label><div class=pagetype_box><div ng-repeat=\"pageTypeSampleUrl in pageTypeSampleUrls\" class=page-type-edit-wrapper zc-page-type-sample page-types=pageTypes page-type-sample-url=pageTypeSampleUrl project-id=projectId check-sample-matches-pattern=checkSampleMatchesPattern(pageTypeSampleUrl) on-destroy-sample-url=onDestroySampleUrl(pageTypeSampleUrl)></div><button class=\"btn btn-lg btn-success col-sm-12\" ng-click=addPageTypeSampleUrl()>{{ 'projectsSettings.initialization.pageTypeEditor.tsuika' | translate }}</button></div><label>{{ 'projectsSettings.initialization.pageTypeEditor.peejitaipu_settei' | translate }}:</label><div class=pagetype_box><div ng-repeat=\"pageType in pageTypes\" class=page-type-edit-wrapper zc-page-type-single page-type=pageType project-id=projectId check-all-sample-matches-pattern=checkAllSampleMatchesPattern() on-destroy=onDestroy(pageType)></div><button class=\"btn btn-lg btn-success col-sm-12\" ng-click=addPageType()>{{ 'projectsSettings.initialization.pageTypeEditor.tsuika' | translate }}</button></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/page_type_sample.html';
var html = "<form name=form class=\"page-type-edit col-xs-12\"><div class=pagetype-table><div class=pagetype-table-cell><select style=\"max-width: 140px;\" ng-model=pageTypeSampleUrl.page_type ng-options=\"pt.value as pt.name for pt in pageTypeOptions\" ng-change=checkSampleMatchesPattern() required></select></div><div class=pagetype-table-cell><input type=text name=url style=\"font-size: smaller\" ng-model=pageTypeSampleUrl.url ng-maxlength=255 class=pagetype-table-url ng-change=checkSampleMatchesPattern() placeholder=\"{{ 'projectsSettings.initialization.pageTypeSample.urlExample' | translate }}\" required><div ng-messages=form.url.$error><div ng-message=maxlength class=\"label label-danger\">{{ 'projectsSettings.initialization.pageTypeSample.moji_ika_no' | translate }}</div></div></div><div class=\"pagetype-table-cell pagetype-table-sign\"><span ng-show=pageTypeSampleUrl.isOk class=\"label label-success\">◯</span> <span ng-hide=pageTypeSampleUrl.isOk class=\"label label-danger\">✗</span> {{pageTypeSampleUrl.page_types.join(', ')}}</div><div class=pagetype-table-cell><div class=text-right><button type=button class=\"btn btn-danger btn-xs\" aria-hidden=true confirm-click=remove(pageTypeSampleUrl) confirm-modal ng-disabled=isDestroying>{{ 'projectsSettings.initialization.pageTypeSample.sakujo' | translate }}</button> <button type=button class=\"btn btn-success btn-xs\" aria-hidden=true ng-disabled=\"!form.$valid || !form.$dirty\" ng-click=update(pageTypeSampleUrl)>{{ 'projectsSettings.initialization.pageTypeSample.hozon' | translate }}</button></div></div></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/page_type_single.html';
var html = "<form name=form class=\"page-type-edit col-xs-12\"><div class=pagetype-table><div class=pagetype-table-cell><select style=\"max-width: 140px;\" ng-model=pageType.page_type ng-options=\"pt.value as pt.name for pt in pageTypeOptions\" ng-change=checkAllSampleMatchesPattern() required></select><div><input type=text name=custom_name class=pagetype-table-custom-name style=\"font-size: smaller\" ng-model=pageType.custom_name ng-maxlength=32 ng-minlength=1 ng-change=checkAllSampleMatchesPattern() ng-if=isCustomPageType(pageType) placeholder=\"custom name\"></div></div><div class=pagetype-table-cell><select ng-model=pageType.match_type ng-options=\"pt.value as pt.name for pt in matchTypes\" ng-change=checkAllSampleMatchesPattern() required></select></div><div class=pagetype-table-cell><input type=text name=match_pattern class=pagetype-table-regexp style=\"font-size: smaller\" ng-model=pageType.match_pattern ng-maxlength=512 ng-change=checkAllSampleMatchesPattern() placeholder=\"{{ 'projectsSettings.initialization.pageTypeSingle.pataan' | translate }}\" required><div ng-messages=form.match_pattern.$error><div ng-message=maxlength class=\"label label-danger\">{{ 'projectsSettings.initialization.pageTypeSingle.matchipataan_ga_nagasugimasu' | translate }}</div></div></div><div class=pagetype-table-cell><div class=text-right><button type=button class=\"btn btn-danger btn-xs\" aria-hidden=true confirm-click=remove(pageType) confirm-modal ng-disabled=isDestroying>{{ 'projectsSettings.initialization.pageTypeSingle.sakujo' | translate }}</button> <button type=button class=\"btn btn-success btn-xs\" aria-hidden=true ng-disabled=\"!form.$valid || !form.$dirty\" ng-click=update(pageType)>{{ 'projectsSettings.initialization.pageTypeSingle.hozon' | translate }}</button></div></div></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/session_count_evaluator.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.sessionCountEvaluator.no_shiyou_umu' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.sessionCountEvaluator.shiyouritsu' | translate }}\" indicator=google_analytics_cover_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.sessionCountEvaluator.okyakusama_ga_wo' | translate }}<br>{{ 'projectsSettings.initialization.sessionCountEvaluator.nokukkiini_nokotte_iru' | translate }}</p><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><select id=domainLinkType class=form-control ng-options=\"item.name as item.label for item in sessionCountEvaluators\" ng-model=project.session_count_evaluator required></select></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.initialization.sessionCountEvaluator.settei_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/initialization/submenu.html';
var html = "<ul ng-hide=true class=config-submenu-list><li ui-sref=admin.projects.settings.initialization() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.shokisettei_no_kanryou' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.session_count_evaluator() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.no_shiyou_umu' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.page_type() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.peejitaipu' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.exclude_ip() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.jogai_e_no' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.cross_domain() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.kurosudomein_settei' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.ga_tag_tracking() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.gaTagTracking' | translate }}</a> <span class=\"badge badge-warning\">beta</span></li><li ui-sref=admin.projects.settings.initialization.cart_button() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.kaatobotankurikku' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.login_evaluator() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.roguin_hantei' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.item_price() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.shouhin_kakaku_shutoku' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.item_list_price() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.shouhin_risuto_kakaku' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.cart_price() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.kaato_goukei_kingaku' | translate }}</a></li><li ui-sref=admin.projects.settings.initialization.distinguish_direct_indirect_cv() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.distinguish_direct_indirect_cv' | translate }}</a></li><li class=submenu-list-heading>{{ 'projectsSettings.initialization.submenu.settings_for_appier_retargeting' | translate }}</li><li ui-sref=admin.projects.settings.initialization.cookie_server_setting() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.initialization.submenu.cookie_server_setting' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/conversion_tag.html';
var html = "<div id=installationConversionTag><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/setup/tags' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.installation.conversionTag.konbaajontagu_no_setchi' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.conversionTag.instruction' | translate }}<br><br>{{ 'projectsSettings.installation.conversionTag.detail1' | translate }}<br><br>{{ 'projectsSettings.installation.conversionTag.detail2' | translate }}<br><br><ng-container translate=projectsSettings.installation.conversionTag.detail3 translate-value-tag=\"<span class='text-danger'>{{ 'projectsSettings.installation.conversionTag.tag' | translate }}</span>\"></ng-container></p><section><h2 class=config-subtitle>{{ 'projectsSettings.installation.conversionTag.konbaajontagu' | translate }}</h2><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert>{{ 'projectsSettings.installation.conversionTag.aajsSettingsWarningMsg' | translate }}</div><div ng-if=!isDisplayAajsWarningMsg class=mb20 hljs hljs-language=html source=conversionCode></div><p ng-if=currentProject.enable_aajs class=config-lead>{{ 'projectsSettings.installation.conversionTag.aajsConversionTagNote1' | translate }}<br>{{ 'projectsSettings.installation.conversionTag.aajsConversionTagNote2' | translate }}<br>{{ 'projectsSettings.installation.conversionTag.aajsConversionTagNote3' | translate }}</p><p ng-if=!currentProject.enable_aajs class=config-lead>{{ 'projectsSettings.installation.conversionTag.konbaajon_konbaajon_kingaku' | translate }}<br>{{ 'projectsSettings.installation.conversionTag.ika_no_shouhin' | translate }}<br>{{ 'projectsSettings.installation.conversionTag.nyuuryoku_suishou' | translate }}</p><h2 class=config-subtitle>{{ 'projectsSettings.installation.conversionTag.konbaajontagu_no_shutsuryoku' | translate }}</h2><p ng-if=currentProject.enable_direct_cv>{{ aideal_cv_var_description1 }}<br>{{ aideal_cv_var_description2 }}</p><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert>{{ 'projectsSettings.installation.conversionTag.aajsSettingsWarningMsg' | translate }}</div><div ng-if=!isDisplayAajsWarningMsg class=mb20 hljs hljs-language=html source=conversionOutputCode></div></section><section><h2 class=config-subtitle>{{ 'projectsSettings.installation.conversionTag.konbaajondeetasuteetasu' | translate }}</h2><div class=tag-status-table><div class=tag-status-table-cell><button class=\"btn btn-config btn-tag-check\" ng-click=refresh()><i class=\"fa fa-refresh\"></i> {{ 'projectsSettings.installation.conversionTag.tagu_setchi_joukyou' | translate }}</button></div><div class=tag-status-table-cell><div class=\"tag-check status-checked\" ng-if=\"foundPC == true\"><i class=\"fa fa-check-circle\"></i> {{ 'projectsSettings.installation.conversionTag.notorakkingudeeta_ga_kakunin_dekita_pc' | translate }}</div><div class=\"tag-check status-undefined\" ng-if=\"foundPC == false\"><i class=\"fa fa-times\"></i> {{ 'projectsSettings.installation.conversionTag.notorakkingudeeta_ga_kakunin_dekinai_pc' | translate }}</div><div class=\"tag-check status-checked\" ng-if=\"foundSP == true\"><i class=\"fa fa-check-circle\"></i> {{ 'projectsSettings.installation.conversionTag.notorakkingudeeta_ga_kakunin_dekita_sp' | translate }}</div><div class=\"tag-check status-undefined\" ng-if=\"foundSP == false\"><i class=\"fa fa-times\"></i> {{ 'projectsSettings.installation.conversionTag.notorakkingudeeta_ga_kakunin_dekinai_sp' | translate }}</div></div></div><table class=\"table config-table table-bordered\" ng-if=\"conversions.length > 0\"><tr><th>{{ 'projectsSettings.installation.conversionTag.hassei_nichiji' | translate }}</th><th>{{ 'projectsSettings.installation.conversionTag.debaisu' | translate }}</th><th>conversion.id {{ 'projectsSettings.installation.conversionTag.no_atai' | translate }}</th><th>conversion.price {{ 'projectsSettings.installation.conversionTag.no_atai' | translate }}</th><th>conversion.coupon_code {{ 'projectsSettings.installation.conversionTag.no_atai' | translate }}</th><th ng-if=currentProject.enable_direct_cv>conversion.name {{ 'projectsSettings.installation.conversionTag.no_atai' | translate }}</th><th>{{ 'projectsSettings.installation.conversionTag.ta' | translate }}</th></tr><tr ng-repeat=\"conversion in conversions\"><td>{{conversion.created_at | zcDate : {smart:true} }}</td><td>{{conversion.device | uppercase}}</td><td>{{conversion.id}}</td><td>{{conversion.original_price | number}}</td><td>{{conversion.coupon_code}}</td><td ng-if=currentProject.enable_direct_cv>{{conversion.name}}</td><td class=conversion-url-table><div class=conversion-url>{{conversion.url}}</div><table style=width:100% ng-if=\"conversion.items.length > 0\"><tr><th>id</th><th>name</th><th>price</th><th>count</th><th>url</th></tr><tr ng-repeat=\"item in conversion.items\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.price | number}}</td><td>{{item.count| number}}</td><td><a href={{item.url}} ng-if=item.url><i class=\"fa fa-link\"></i></a></td></tr></table></td></tr></table></section><button class=\"btn btn-config\" ng-click=updateStatus() ng-disabled=\"!foundPC && !foundSP\">{{ 'projectsSettings.installation.conversionTag.konbaajontagu_no_setchi_houzon' | translate }}</button></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/conversion_url.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.installation.conversionUrl.kounyuu_kanryou_peeji' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.conversionUrl.konbaajon_jouhou_wo' | translate }}<br>{{ 'projectsSettings.installation.conversionUrl.kinyuu_naiyou_wo' | translate }}</p><section><form name=form zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><ul class=config-case><li><div class=config-case-title>{{ 'projectsSettings.installation.conversionUrl.subete_no_okyakusama' | translate }}</div>https://www.example.com/cart/complete</li><li><div class=config-case-title>{{ 'projectsSettings.installation.conversionUrl.to_de_kotonaru' | translate }}</div>https://www.example.com/cart/complete<br>https://www.example.com/cart/preordercomplete</li><li><div class=config-case-title>{{ 'projectsSettings.installation.conversionUrl.kounyuu_kanryou_no' | translate }}</div>https://www.example.com/{{ 'projectsSettings.installation.conversionUrl.kounyuu_ga_hairimasu' | translate }}/cart/complete</li></ul><div class=form-group><textarea class=form-control rows=3 placeholder=\"{{ 'projectsSettings.installation.conversionUrl.koko_ni_kounyuu' | translate }}\" ng-model=project.conversion_urls_memo required></textarea></div><button class=\"btn btn-config\" ng-disabled=form.$invalid>{{ 'projectsSettings.installation.conversionUrl.hozon_suru' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/domain.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.installation.domain.shiyou_domein_no' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.domain.notaguga,_masashiku_jouhou' | translate }}</p><form name=form zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><section><ul class=config-case><li><div class=config-case-title>{{ 'projectsSettings.installation.domain.torakkingutaguga_subete_onaji' | translate }}</div>{{ 'projectsSettings.installation.domain.fukusuu_no' | translate }}</li><li><div class=config-case-title>{{ 'projectsSettings.installation.domain.torakkingutaguga_fukusuu_no' | translate }}</div>{{ 'projectsSettings.installation.domain.shiyou_domein_wo' | translate }}<br><ng-container translate=projectsSettings.installation.domain.rei translate-value-firstdomain=samplesite.com translate-value-seconddomain=sampleform.com></ng-container></li></ul><div class=form-group><textarea class=form-control ng-model=project.multiple_domains_memo rows=3 placeholder=\"samplesite.com sampleform.com\" ng-disabled=!project.has_multiple_domains></textarea></div><div class=checkbox><label><input type=checkbox ng-model=project.has_multiple_domains ng-true-value=false ng-false-value=true> {{ 'projectsSettings.installation.domain.fukusuu_no_domein' | translate }}</label></div></section><button class=\"btn btn-config\" ng-disabled=\"project.has_multiple_domains && !project.multiple_domains_memo\">{{ 'projectsSettings.installation.domain.hozon_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/exclude_ip.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.installation.excludeIp.guroobaruadoresu_nyuuryoku' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.excludeIp.jisha_uchikara_no' | translate }}<br>{{ 'projectsSettings.installation.excludeIp.shanai_de_fukusuu' | translate }}<br><ng-container translate=projectsSettings.installation.excludeIp.fukusuu_jogai translate-value-firstip=12.34.56.1 translate-value-secondip=12.34.56.255></ng-container><br>{{ 'projectsSettings.installation.excludeIp.go_kanzen_itchi' | translate }}12.34.56.0<br>{{ 'projectsSettings.installation.excludeIp.sei_zenpouitchi' | translate }}12.34.56.<br></p><section><h2 class=config-subtitle>{{ 'projectsSettings.installation.excludeIp.genzai_akusesu_uchi' | translate }}</h2><p class=ip-self>{{ip}}</p><p class=config-description>{{ 'projectsSettings.installation.excludeIp.mobairu_kankyou_nado' | translate }}</p></section><zc-exclude-ip-editor project-id=project.id></zc-exclude-ip-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/index.html';
var html = "<div id=installationTop><h1 class=config-title>{{ 'projectsSettings.installation.index.dounyuu_settei_toppu' | translate }}</h1><section><h1 class=config-lead>{{ 'projectsSettings.installation.index.konotabi_ha_noakaunto_wo' | translate }}</h1></section><section><h1 class=config-lead><ng-container translate=projectsSettings.installation.index.nogo_riyou_wo translate-value-tagsetting=\"<strong>{{ 'projectsSettings.installation.index.tagSetting' | translate }}</strong>\" translate-value-datainput=\"<strong>{{ 'projectsSettings.installation.index.dataInput' | translate }}</strong>\"></ng-container>{{ 'projectsSettings.installation.index.koumoku_wa_hidarimenyuukaraakusesu' | translate }}</h1></section><section><h1 class=config-lead>{{ 'projectsSettings.installation.index.subete_no_koumoku' | translate }}<br><ng-container translate=projectsSettings.installation.index.hidarimenyuuno_shokisettei_kanryou translate-value-notificationcomplete=\"<strong>{{ 'projectsSettings.installation.index.notificationComplet' | translate }}</strong>\"></ng-container><br><br>{{ 'projectsSettings.installation.index.kanryou_renraku_ga' | translate }}</h1></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/login_evaluator_memo.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.installation.loginEvaluatorMemo.roguin_hantei_houhou' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.loginEvaluatorMemo.yuuzaagaroguinsareta_saini_no' | translate }}<br>{{ 'projectsSettings.installation.loginEvaluatorMemo.kyanpeen_haishin_wo' | translate }}<br></p><form name=form zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><section><ul class=config-case><li><div class=config-case-title>{{ 'projectsSettings.installation.loginEvaluatorMemo.parameeta_de_hantei' | translate }}<br></div>{{ 'projectsSettings.installation.loginEvaluatorMemo.yuuzaagaroguinsareta_chokugo' | translate }}<br>{{ 'projectsSettings.installation.loginEvaluatorMemo.parameeta_ni_kaki' | translate }}<br>https://www.example.com/top?is_login=1<br></li><li><div class=config-case-title>{{ 'projectsSettings.installation.loginEvaluatorMemo.kukkiide_hantei_kanou' | translate }}</div>{{ 'projectsSettings.installation.loginEvaluatorMemo.yuuzaagaroguinsareta_saini' | translate }}<br>{{ 'projectsSettings.installation.loginEvaluatorMemo.kukkiigasettosareru' | translate }}<br></li><li>{{ 'projectsSettings.installation.loginEvaluatorMemo.hantei_houhou_kanai' | translate }}</li></ul><div class=checkbox><label><input type=checkbox ng-model=project.has_login_evaluator ng-true-value=false ng-false-value=true> {{ 'projectsSettings.installation.loginEvaluatorMemo.roguin_hantei_houhou_nashi' | translate }}</label></div><div class=form-group><textarea name=loginEvaluatorMemo class=form-control ng-model=project.login_evaluator_memo rows=3 placeholder=\"{{ 'projectsSettings.installation.loginEvaluatorMemo.koko_ni_roguin' | translate }}\" ng-disabled=!project.has_login_evaluator ng-hide=!project.has_login_evaluator>\n        </textarea></div></section><button class=\"btn btn-config\" ng-disabled=\"project.has_login_evaluator && !project.login_evaluator_memo\">{{ 'projectsSettings.installation.loginEvaluatorMemo.hozon_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/newsletter_parameter_memo.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.installation.newsletterParameterMemo.merumaga_ryuunyuu_hantei' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.newsletterParameterMemo.yuuza_no_ryuunyuu' | translate }}<br>{{ 'projectsSettings.installation.newsletterParameterMemo.kyanpeen_haishin_wo' | translate }}<br></p><form name=form zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><section>{{ 'projectsSettings.installation.newsletterParameterMemo.hantei_houhou_ga' | translate }}<div class=checkbox><label><input type=checkbox ng-model=project.has_newsletter_parameter ng-true-value=false ng-false-value=true> {{ 'projectsSettings.installation.newsletterParameterMemo.merumaga_hantei_houhou' | translate }}</label></div><div class=form-group><textarea name=newsletterParameterMemo class=form-control ng-model=project.newsletter_parameter_memo rows=3 placeholder=\"{{ 'projectsSettings.installation.newsletterParameterMemo.koko_ni_merumagakara' | translate }}\" ng-disabled=!project.has_newsletter_parameter ng-hide=!project.has_newsletter_parameter>\n        </textarea></div></section><button class=\"btn btn-config\" ng-disabled=\"project.has_newsletter_parameter && !project.newsletter_parameter_memo\">{{ 'projectsSettings.installation.newsletterParameterMemo.hozon_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/submenu.html';
var html = "<ul class=config-submenu-list><li ui-sref=admin.projects.settings.installation() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><a>{{ 'projectsSettings.installation.submenu.dounyuu_settei_toppu' | translate }}</a></li><li class=submenu-list-heading>{{ 'projectsSettings.installation.submenu.tagu_no_setchi' | translate }}</li><li ui-sref=admin.projects.settings.installation.tracking_tag() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=trackingTag></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.torakkingutagu_no_setchi' | translate }}</a></li><li ng-if=!project.is_wevnal ui-sref=admin.projects.settings.installation.conversion_tag() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=conversionTag></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.konbaajontagu_no_setchi' | translate }}</a></li><li class=submenu-list-heading>{{ 'projectsSettings.installation.submenu.jouhou_nyuuryoku' | translate }}</li><li ui-sref=admin.projects.settings.installation.conversion_url() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=conversionUrl></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.kounyuu_kanryou_peeji' | translate }}</a></li><li ui-sref=admin.projects.settings.installation.test_conversion() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=testConversion></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.tesuto_kounyuu_houhou' | translate }}</a></li><li ui-sref=admin.projects.settings.installation.exclude_ip() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=excludeIp></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.guroobaruadoresu_nyuuryoku' | translate }}</a></li><li ui-sref=admin.projects.settings.installation.domain() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=domain></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.shiyou_domein_no' | translate }}</a></li><li ui-sref=admin.projects.settings.installation.login_evaluator_memo() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=loginEvaluator></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.roguin_hantei_houhou' | translate }}</a></li><li ui-sref=admin.projects.settings.installation.newsletter_parameter_memo() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><zc-setting-status status=newsletterParameter></zc-setting-status><a>{{ 'projectsSettings.installation.submenu.merumaga_ryuunyuu_hantei' | translate }}</a></li></ul><div class=text-center ng-if=\"project.campaign_status != 'completed'\"><button ng-if=!SettingStatus.statuses.installationReady class=\"btn btn-config\" disabled><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.installation.submenu.shokisettei_kanryou_no' | translate }}</button> <button class=\"btn btn-config\" ng-if=SettingStatus.statuses.installationReady ng-click=completeInstallation(project)><i class=\"fa fa-envelope\"></i> {{ 'projectsSettings.installation.submenu.shokisettei_kanryou_no' | translate }}</button></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/test_conversion.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.installation.testConversion.tesuto_kounyuu_houhou' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.testConversion.tagu_no_setchi' | translate }}<br>{{ 'projectsSettings.installation.testConversion.tesuto_kounyuu_no' | translate }}<br>{{ 'projectsSettings.installation.testConversion.tesuto_kounyuu_houhou_ga' | translate }}<br><br>{{ 'projectsSettings.installation.testConversion.tesuto_kounyuu_houhou_ga_nai' | translate }}</p><form name=form zc-dirty-form-dialog ng-submit=\"save(project); form.$setPristine()\"><section><div class=form-group><textarea name=testCV class=form-control ng-model=project.test_conversion_memo rows=3 placeholder=\"{{ 'projectsSettings.installation.testConversion.koko_ni_tesuto' | translate }}\" ng-disabled=!project.has_test_conversion></textarea></div><div class=checkbox><label><input type=checkbox name=noTestCV ng-model=project.has_test_conversion ng-true-value=false ng-false-value=true> {{ 'projectsSettings.installation.testConversion.tesuto_kounyuu_houhou_nashi' | translate }}</label></div></section><button class=\"btn btn-config\" ng-disabled=\"project.has_test_conversion && !project.test_conversion_memo\">{{ 'projectsSettings.installation.testConversion.hozon_suru' | translate }}</button></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/installation/tracking_tag.html';
var html = "<div id=installationTrackingTag><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/setup/tags' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.installation.trackingTag.torakkingutagu_no_setchi' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.installation.trackingTag.instruction' | translate }}<br><br>{{ 'projectsSettings.installation.trackingTag.detail1' | translate }}<br>{{ 'projectsSettings.installation.trackingTag.detail2' | translate }}<br>{{ 'projectsSettings.installation.trackingTag.detail3' | translate }}<br>{{ 'projectsSettings.installation.trackingTag.detail4' | translate }}<br><ng-container translate=projectsSettings.installation.trackingTag.detail5 translate-value-tag=\"<code>&#60; body &#62;</code>{{ 'projectsSettings.installation.trackingTag.tag' | translate }}<code>&#60; /body &#62;</code>\"></ng-container></p><section><h2 class=config-subtitle>{{ 'projectsSettings.installation.trackingTag.torakkingutagu' | translate }}</h2><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert>{{ 'projectsSettings.installation.trackingTag.aajsSettingsWarningMsg' | translate }}</div><div ng-if=!isDisplayAajsWarningMsg hljs hljs-language=html no-escape compile=true source=tracking_tag_code></div></section><section><h2 class=config-subtitle>{{ 'projectsSettings.installation.trackingTag.torakkingudeetasuteetasu' | translate }}</h2><div class=tag-status-table><div class=tag-status-table-cell><button class=\"btn btn-config btn-tag-check\" ng-click=refresh()><i class=\"fa fa-refresh\"></i> {{ 'projectsSettings.installation.trackingTag.tagu_setchi_joukyou' | translate }}</button></div><div class=tag-status-table-cell><div class=\"tag-check status-checked\" ng-if=\"foundPC == true\"><i class=\"fa fa-check-circle\"></i> {{ 'projectsSettings.installation.trackingTag.notorakkingudeeta_ga_kakunin_dekita_pc' | translate }}</div><div class=\"tag-check status-undefined\" ng-if=\"foundPC == false\"><i class=\"fa fa-times\"></i> {{ 'projectsSettings.installation.trackingTag.notorakkingudeeta_ga_kakunin_dekinai_pc' | translate }}</div><div class=\"tag-check status-checked\" ng-if=\"foundSP == true\"><i class=\"fa fa-check-circle\"></i> {{ 'projectsSettings.installation.trackingTag.notorakkingudeeta_ga_kakunin_dekita_sp' | translate }}</div><div class=\"tag-check status-undefined\" ng-if=\"foundSP == false\"><i class=\"fa fa-times\"></i> {{ 'projectsSettings.installation.trackingTag.notorakkingudeeta_ga_kakunin_dekinai_sp' | translate }}</div></div></div><table class=\"table config-table table-bordered\" ng-if=\"histories.length > 0\"><tr><th>{{ 'projectsSettings.installation.trackingTag.hassei_nichiji' | translate }}</th><th>{{ 'projectsSettings.installation.trackingTag.debaisu' | translate }}</th><th>URL</th><th>{{ 'projectsSettings.installation.trackingTag.page_types' | translate }}</th></tr><tr ng-repeat=\"history in histories\"><td>{{history.opened_at | zcDate : {smart:true} }}</td><td>{{history.device | uppercase}}</td><td><div tooltip={{history.url}}>{{history.url | limitTo:60}} <span ng-show=\"history.url.length > 60\">...</span></div></td><td>{{history.page_types.join(',')}}</td></tr></table></section><section><h2 class=config-subtitle>{{ 'projectsSettings.installation.trackingTag.tagu_nuke_no' | translate }}</h2><table class=\"table config-table table-bordered\"><tr><th>URL</th><th>{{ 'projectsSettings.installation.trackingTag.count' | translate }}</th></tr><tr ng-repeat=\"url_items in tag_non_existing_url_items | orderBy:'-count'\"><td>{{url_items.url}}</td><td>{{url_items.count}}</td></tr></table></section><section><button class=\"btn btn-config\" ng-click=updateStatus() ng-disabled=\"!foundPC && !foundSP\">{{ 'projectsSettings.installation.trackingTag.torakkingutagu_no_setchi_hozon_suru' | translate }}</button></section><section><div class=notifications><h2>{{ 'projectsSettings.installation.trackingTag.saitorinyuuaru_no_go' | translate }}</h2><p>{{ 'projectsSettings.installation.trackingTag.ha_saito_no_to' | translate }} {{ 'projectsSettings.installation.trackingTag.rinyuuaru_ni_yotte' | translate }} {{ 'projectsSettings.installation.trackingTag.rinyuuaru_no_go' | translate }}</p></div></section></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/menu.html';
var html = "<ul class=config-menu-list><li ui-sref=admin.projects.settings.basic() ui-sref-opts=\"{reload: true}\" ui-sref-active=active><a><i class=\"fa fa-wrench menu-icon\"></i> {{ 'projectsSettings.menu.kihonjouhou' | translate }}</a></li><li ui-sref=admin.projects.settings.billing() ui-sref-opts=\"{reload: true}\" ui-sref-active=active><a><i class=\"fa fa-money menu-icon\"></i> {{ 'projectsSettings.menu.seikyuu' | translate }}</a><zc-setting-status status=billingSettingsCompleted></zc-setting-status></li><li ui-sref=admin.projects.settings.installation() ui-sref-opts=\"{reload: true}\" ui-sref-active=active><a><i class=\"fa fa-compass menu-icon\"></i> {{ 'projectsSettings.menu.dounyuu_settei' | translate }}</a><zc-setting-status status=installationCompleted></zc-setting-status></li><li ui-sref=admin.projects.settings.users() ui-sref-opts=\"{reload: true}\" ui-sref-active=active ng-if=\"$ctrl.isMaster || !$ctrl.enableServiceLens\"><a><i class=\"fa fa-users menu-icon\"></i> {{ 'projectsSettings.menu.menbaa' | translate }}</a><div class=config-locked><i ng-if=$ctrl.enableServiceLens class=\"fa fa-lock\"></i></div></li><li ui-sref=admin.projects.settings.initialization() ui-sref-opts=\"{reload: true}\" ui-sref-active=active zc-master-only><a><i class=\"fa fa-cubes menu-icon\"></i> {{ 'projectsSettings.menu.shokisettei' | translate }}</a><div class=config-locked><i class=\"fa fa-lock\"></i></div></li><li ui-sref=admin.projects.settings.campaign() ui-sref-opts=\"{reload: true}\" ui-sref-active=active ng-if=\"$ctrl.isMaster || $ctrl.showsExcludePageType\"><a><i class=\"fa fa-gift menu-icon\"></i> {{ 'projectsSettings.menu.kyanpeen' | translate }}</a><div class=config-locked><i class=\"fa fa-lock\" ng-if=!$ctrl.showsExcludePageType></i></div></li><li ui-sref=admin.projects.settings.other() ui-sref-opts=\"{reload: true}\" ui-sref-active=active zc-master-only><a><i class=\"fa fa-archive menu-icon\"></i> {{ 'projectsSettings.menu.sonohoka' | translate }}</a><div class=config-locked><i class=\"fa fa-lock\"></i></div></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/app.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.app.you_settei' | translate }}</h1><section><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=allow_app_access><input type=checkbox id=enable_service_lens ng-model=project.enable_service_lens> {{ 'projectsSettings.other.app.saabisu_wo_yuukouka' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.app.ko_no_saitogasaabisu' | translate }}\"></i></label></div><div class=form-group><label for=allow_app_access><input type=checkbox id=allow_app_access ng-model=project.allow_app_access> {{ 'projectsSettings.other.app.no_akusesukyoka_suru' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.app.ko_no_saitonomenbaa' | translate }}\"></i></label></div><div class=form-group><label for=use_proxy_for_lens_iframe><input type=checkbox id=use_proxy_for_lens_iframe ng-model=project.use_proxy_for_lens_iframe> {{ 'projectsSettings.other.app.de_wo_tsukau' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.app.ga_hyouji_sarenai' | translate }}\"></i></label></div><div class=form-group><label for=enable_lens_conversion_mail_notifier><input type=checkbox id=enable_lens_conversion_mail_notifier ng-model=project.enable_lens_conversion_mail_notifier> {{ 'projectsSettings.other.app.tsuuchi_meeru_yuukouka' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.app.gaattara_tsuuchi_meeru' | translate }}\"></i></label></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.other.app.hozon_suru' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/badge_position_adjustment_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.debaisu' | translate }}</label><select id=device class=form-control ng-options=\"device.name as device.label for device in devices\" ng-model=newItem.device required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.takasa_chousei' | translate }}</label> <input id=position type=number class=form-control ng-model=newItem.position required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.serekutaa' | translate }}</label> <input id=particularEventSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.iframeSelector' | translate }}</label> <input id=particularIframe type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.iframe_selector></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!(newItem.position && newItem.device)\">{{ 'projectsSettings.other.badgePositionAdjustmentEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.bajji_no_takasa' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.badgePositionAdjustmentEditor.bajji_no_takasa' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.debaisu' | translate }}</th><th>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.takasa_chousei' | translate }} (px)</th><th>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.badgePositionAdjustmentEditor.iframeSelector' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.device}}</td><td>{{item.position}}</td><td>{{item.selector}}</td><td>{{item.iframe_selector}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.badgePositionAdjustmentEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/breadcrumb.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.breadcrumb.breadcrumbs' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.breadcrumb.description' | translate }}</p><section><zc-breadcrumb-selector project-id=project.id></zc-breadcrumb-selector></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/breadcrumb_selector.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.breadcrumbSelector.serekutaa' | translate }}</label> <input id=breadcrumb_selector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.breadcrumbSelector.peejitaipu' | translate }}</label><select id=breadcrumbPageType class=form-control ng-options=\"page_type for page_type in page_types\" ng-model=newItem.page_type required></select></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!newItem.selector>{{ 'projectsSettings.other.breadcrumbSelector.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.breadcrumbSelector.pankuzurisuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.breadcrumbSelector.pankuzu_ga_settei' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.breadcrumbSelector.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.breadcrumbSelector.peejitaipu' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}}</td><td>{{item.page_type}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.breadcrumbSelector.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/data_management.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.dataManagement.deetabunseki_kanren' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.dataManagement.deetamausu_no_ugoki' | translate }}</p><div class=\"alert alert-warning\" role=alert><strong>{{ 'projectsSettings.other.dataManagement.note' | translate }}:</strong> {{ 'projectsSettings.other.dataManagement.chuui_no_hozon' | translate }}</div><section><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=isRawPercent class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.dataManagement.hozon_wariai' | translate }}</label><div class=col-md-6><div class=input-group><input id=isRawPercent type=text class=form-control ng-model=project.raw_percent> <span class=input-group-addon>{{ 'projectsSettings.other.dataManagement.hozon' | translate }}</span></div></div></div><div class=form-group><label for=retain_raws class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.dataManagement.deeta_wo_nenkan' | translate }}</label><div class=col-md-6><input id=retain_raws type=checkbox class=form-check-input ng-model=project.retain_raws></div></div><div class=form-group><label for=sandboxPercent class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.dataManagement.shiyou' | translate }}</label><div class=col-md-6><div class=input-group><input id=sandboxPercent type=text class=form-control ng-model=project.sandbox_percent> <span class=input-group-addon>%({{ 'projectsSettings.other.dataManagement.taishou_yuuza' | translate }})</span></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.other.dataManagement.settei_suru' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/deleted_item_detector.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"newItem.page_type='item'; add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.deletedItemDetector.serekutaa' | translate }}</label> <input id=thumbnailSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!newItem.selector>{{ 'projectsSettings.other.deletedItemDetector.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.deletedItemDetector.zaikogire_aitemu_shitei' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.deletedItemDetector.zaikogire_aitemu_ga' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.deletedItemDetector.serekutaa' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}} {{item.capture_pattern}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.deletedItemDetector.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/index.html';
var html = "<div id=projectSettingsBase><h1 ng-if=!isCommon class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/general/other' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1><ng-container ng-if=isCommon><h1 class=config-title>{{ 'projectsSettings.other.index.shousaisettei' | translate }}</h1><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=isSinglepageSite class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.index.shingurupeeji' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.index.saito_ga_no' | translate }}\"></i></label><div class=col-sm-6><select id=isSinglepageSite ng-options=\"option for option in [true, false]\" ng-model=project.is_singlepage_site class=form-control></select></div></div><div class=form-group><label for=isUglify class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.index.no_nandokuka' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.index.haishin_wo_nandokuka' | translate }}\"></i></label><div class=col-sm-6><select id=isUglify ng-options=\"option for option in [true, false]\" ng-model=project.is_uglify class=form-control></select></div></div><div class=form-group><label for=isUglify class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.index.haishin_yuukouka' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.index.ichijiteki_na_mondai' | translate }}\"></i></label><div class=col-sm-6><select id=isPublish ng-options=\"option for option in [true, false]\" ng-model=project.is_publish class=form-control></select></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.other.index.henkou_suru' | translate }}</button></form></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/iw.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.iw.you_settei' | translate }}</h1><section><h2 class=config-title>{{ 'projectsSettings.other.iw.repooto_settei' | translate }}</h2><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><p class=config-lead>{{ 'projectsSettings.other.iw.repooto_gamenjou_de' | translate }}<br>{{ 'projectsSettings.other.iw.okyakusama_ni_wa' | translate }}<br>{{ 'projectsSettings.other.iw.ko_no_suuji' | translate }}</p><label for=iw_fixed_monthly_invoice_amount_for_sp>{{ 'projectsSettings.other.iw.sp_getsugaku_koteihiyou' | translate }} ({{ currency.symbol || currency.suffix }}) <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.iw.seikyuu_ni_youiraremasen' | translate }}\"></i></label><div class=row><div class=col-sm-8><input type=number id=iw_fixed_monthly_invoice_amount_for_sp ng-model=project.iw_fixed_monthly_invoice_amount_for_sp class=form-control min=0 is-required=false></div></div><br><label for=iw_fixed_monthly_invoice_amount_for_pc>{{ 'projectsSettings.other.iw.pc_getsugaku_koteihiyou' | translate }} ({{ currency.symbol || currency.suffix }}) <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.iw.seikyuu_ni_youiraremasen' | translate }}\"></i></label><div class=row><div class=col-sm-8><input type=number id=iw_fixed_monthly_invoice_amount_for_pc ng-model=project.iw_fixed_monthly_invoice_amount_for_pc class=form-control min=0 is-required=false></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.other.iw.henkou_suru' | translate }}</button></form></section><section><h2 class=config-title>{{ 'projectsSettings.other.iw.shouhin_kakaku' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.shouhin_kingaku_no' | translate }}<br>{{ 'projectsSettings.other.iw.tekisuto_senyou_settei' | translate }}<br>{{ 'projectsSettings.other.iw.fukusuu_no_serekutagamatchisuru' | translate }}<br>{{ 'projectsSettings.other.iw.tekisuto_senyou_settei_no' | translate }}</p><zc-item-price-editor project-id=project.id></zc-item-price-editor><zc-item-price-confirm apikey=project.apikey></zc-item-price-confirm></section><hr><section><h2 class=config-title>{{ 'projectsSettings.other.iw.peejitaitoru' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.you_no_peejitaitoru' | translate }} {{ 'projectsSettings.other.iw.settei_sareteinai_baai' | translate }}</p><zc-title-selector project-id=project.id></zc-title-selector><zc-title-selector-confirm apikey=project.apikey></zc-title-selector-confirm></section><hr><section><h2 class=config-title>{{ 'projectsSettings.other.iw.samuneiru_gazou' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.samuneiru_gazou_no' | translate }}</p><zc-thumbnail-selector project-id=project.id></zc-thumbnail-selector><zc-thumbnail-selector-confirm apikey=project.apikey></zc-thumbnail-selector-confirm></section><hr><section><h2 class=config-title>{{ 'projectsSettings.other.iw.shouhin_setsumei' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.shouhin_setsumei_ga' | translate }}</p><zc-page-description project-id=project.id></zc-page-description><zc-description-confirm apikey=project.apikey></zc-description-confirm></section><hr><section><h2 class=config-title>{{ 'projectsSettings.other.iw.youintaresutotsurii' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.youintaresutotsuriiga_settei_sareteiruka' | translate }}</p><zc-interest-widget-tree-confirm apikey=project.apikey></zc-interest-widget-tree-confirm></section><hr><section><h2 class=config-title>{{ 'projectsSettings.other.iw.bajji_no_takasa' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.debaisugotoni_bajji_ga_hyouji' | translate }}<br>{{ 'projectsSettings.other.iw.youso_no_serekuta' | translate }}<br>{{ 'projectsSettings.other.iw.fukusuu_no_serekutanihittosuru' | translate }}</p><zc-badge-position-adjustment-editor project-id=project.id></zc-badge-position-adjustment-editor></section><hr><section><h2 class=config-title>{{ 'projectsSettings.other.iw.zaikogire_aitemu_shitei' | translate }}</h2><p class=config-lead>{{ 'projectsSettings.other.iw.zaikogire_aitemu_no' | translate }}</p><zc-deleted-item-detector project-id=project.id></zc-deleted-item-detector></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/page_description.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"newItem.page_type = 'item'; add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.pageDescription.serekutaa' | translate }}</label> <input id=thumbnailSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!newItem.selector>{{ 'projectsSettings.other.pageDescription.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.pageDescription.shouhin_setsumeibun_risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.pageDescription.shouhin_setsumeibun_ga' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.pageDescription.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.pageDescription.peejitaipu' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}}</td><td>{{item.page_type}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.pageDescription.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/particular_event.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.particularEvent.particularEvent' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.particularEvent.description' | translate }}</p><section><zc-particular-event-editor project-id=project.id></zc-particular-event-editor></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/particular_event_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.particularEventEditor.ibento_na' | translate }}</label><select id=particularEventName class=form-control ng-options=\"pen.name as pen.label for pen in particularEventNames\" ng-model=newItem.name required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.particularEventEditor.peejitaipu' | translate }}</label><select id=particularEventPageType class=form-control ng-options=\"ppt.name as ppt.label for ppt in particularEventPageTypes\" ng-model=newItem.page_type required></select></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.particularEventEditor.serekutaa' | translate }}</label> <input id=particularEventSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.particularEventEditor.iframeSelector' | translate }}</label> <input id=particularIframe type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.iframe_selector></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=\"!(newItem.page_type && newItem.name && (newItem.selector || newItem.iframe_selector) )\">{{ 'projectsSettings.other.particularEventEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.particularEventEditor.risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.particularEventEditor.ga_settei_sareteimasen' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.particularEventEditor.ibento_na' | translate }}</th><th>{{ 'projectsSettings.other.particularEventEditor.peejitaipu' | translate }}</th><th>{{ 'projectsSettings.other.particularEventEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.particularEventEditor.iframeSelector' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.name}}</td><td>{{item.page_type}}</td><td>{{item.selector}}</td><td>{{item.iframe_selector}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.particularEventEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/publish_domain.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.publishDomain.haishin_no_domein' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.publishDomain.haishin_no_sabudomein' | translate }}</p><section><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><div class=form-group><label for=publishDomain class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.publishDomain.haishin_domein' | translate }}</label><div class=col-sm-6><div class=input-group><input id=publishDomain type=text class=form-control ng-model=project.publish_domain required> <span class=input-group-addon>.zenclerk.com</span></div></div></div><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.other.publishDomain.settei_suru' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/review_link_editor.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"newItem.name = 'review_link'; newItem.page_type = 'item'; add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.reviewLinkEditor.serekutaa' | translate }}</label> <input id=particularEventSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.reviewLinkEditor.iframeSelector' | translate }}</label> <input id=particularIframe type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.iframe_selector></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!newItem.selector>{{ 'projectsSettings.other.reviewLinkEditor.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.reviewLinkEditor.rebyuurinku' | translate }}</h2><div class=config-no-data ng-if=!filteredItems.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.reviewLinkEditor.rebyuurinku_ga_settei' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=filteredItems.length><tr><th>{{ 'projectsSettings.other.reviewLinkEditor.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.reviewLinkEditor.iframeSelector' | translate }}</th></tr><tr ng-repeat=\"item in filteredItems\"><td>{{item.selector}}</td><td>{{item.iframe_selector}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.reviewLinkEditor.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/submenu.html';
var html = "<ul ng-hide=true class=config-submenu-list><li ui-sref=admin.projects.settings.other() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.shousaisettei' | translate }}</a></li><li ui-sref=admin.projects.settings.other.publish_domain() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.haishin_no_domein' | translate }}</a></li><li ui-sref=admin.projects.settings.other.data_management() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.deetabunseki_kankei' | translate }}</a></li><li ui-sref=admin.projects.settings.other.particular_event() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.particularEvent' | translate }}</a></li><li ui-sref=admin.projects.settings.other.breadcrumb_selector() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.breadcrumbs' | translate }}</a></li><li ui-sref=admin.projects.settings.other.zcs() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active ng-if=\"project.product_line == 'zenclerk_s'\" zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.lite_kanren_no_settei' | translate }}</a></li><li ui-sref=admin.projects.settings.other.iw() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.iw_kanren_no_settei' | translate }}</a></li><li ui-sref=admin.projects.settings.other.app() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active zc-master-only><div class=config-locked><i class=\"fa fa-lock\"></i></div><a>{{ 'projectsSettings.other.submenu.app_kanren_no_settei' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/thumbnail_selector.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"newItem.page_type='item'; add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.thumbnailSelector.serekutaa' | translate }}</label> <input id=thumbnailSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.thumbnailSelector.iframeSelector' | translate }}</label> <input id=thumbnailIframe type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.iframe_selector> <input type=hidden ng-model=newItem.page_type></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.thumbnailSelector.attribute' | translate }}</label> <input id=attribute_name type=text class=form-control ng-model=newItem.attribute_name ng-value=\"'src'\"></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.thumbnailSelector.pataan' | translate }}</label> <input id=capture_pattern type=text class=form-control ng-model=newItem.capture_pattern ng-value=\"'(.*)'\"></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!newItem.selector>{{ 'projectsSettings.other.thumbnailSelector.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.thumbnailSelector.samuneiru_gazou_risuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.thumbnailSelector.samuneiru_gazou_ga' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.thumbnailSelector.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.thumbnailSelector.iframeSelector' | translate }}</th><th>{{ 'projectsSettings.other.thumbnailSelector.attribute' | translate }}</th><th>{{ 'projectsSettings.other.thumbnailSelector.pataan' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}}</td><td>{{item.iframe_selector}}</td><td>{{item.attribute_name}}</td><td>{{item.capture_pattern}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.thumbnailSelector.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/title_selector.html';
var html = "<section><form name=form zc-dirty-form-dialog ng-submit=\"add(); form.$setPristine()\"><div class=config-form-table><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.titleSelector.serekutaa' | translate }}</label> <input id=titleSelector type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.selector required></div></div><div class=config-form-table-cell><div class=form-group><label>{{ 'projectsSettings.other.titleSelector.iframeSelector' | translate }}</label> <input id=titleIframe type=text class=form-control placeholder=\"#selector, .class-name\" ng-model=newItem.iframe_selector> <input type=hidden ng-model=newItem.page_type ng-init=\"newItem.page_type='item'\"></div></div><div class=config-form-table-cell><button type=submit class=\"btn btn-config\" ng-disabled=!newItem.selector>{{ 'projectsSettings.other.titleSelector.hozon_suru' | translate }}</button></div></div></form></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.titleSelector.peejitaitorurisuto' | translate }}</h2><div class=config-no-data ng-if=!items.length><i class=\"fa fa-file-o\"></i> {{ 'projectsSettings.other.titleSelector.peejitaitoru_ga_settei' | translate }}</div><table class=\"table config-table table-bordered\" ng-if=items.length><tr><th>{{ 'projectsSettings.other.titleSelector.serekutaa' | translate }}</th><th>{{ 'projectsSettings.other.titleSelector.iframeSelector' | translate }}</th></tr><tr ng-repeat=\"item in items\"><td>{{item.selector}}</td><td>{{item.iframe_selector}}<div class=config-table-remove><i type=button class=\"fa fa-times\" value=\"{{ 'projectsSettings.other.titleSelector.sakujo' | translate }}\" confirm-modal confirm-click=remove(item.id)></i></div></td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/other/zcs.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.zcs.you_settei' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.zcs.nikanshite_no_settei' | translate }}</p><section><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"save(project); form.$setPristine()\"><section><h2 class=config-subtitle>{{ 'projectsSettings.other.zcs.beesu_settei' | translate }}</h2><div class=form-group><label for=is_reviewed class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.kakunin_hi' | translate }}</label><div class=col-sm-3><div>{{ 'projectsSettings.other.zcs.saito_jouhou' | translate }}: <span ng-if=!project.siteinfo_confirmed_at>{{ 'projectsSettings.other.zcs.mikakunin' | translate }}</span> <span ng-if=project.siteinfo_confirmed_at>{{project.siteinfo_confirmed_at | zcDate}}</span><br>{{ 'projectsSettings.other.zcs.kaishajouhou' | translate }}: <span ng-if=!project.companyinfo_confirmed_at>{{ 'projectsSettings.other.zcs.mikakunin' | translate }}</span> <span ng-if=project.companyinfo_confirmed_at>{{project.companyinfo_confirmed_at | zcDate}}</span><br>{{ 'projectsSettings.other.zcs.trackingTag' | translate }}: <span ng-if=!project.tracking_tag_confirmed_at>{{ 'projectsSettings.other.zcs.mikakunin' | translate }}</span> <span ng-if=project.tracking_tag_confirmed_at>{{project.tracking_tag_confirmed_at | zcDate}}</span><br>{{ 'projectsSettings.other.zcs.cvTag' | translate }}: <span ng-if=!project.conversion_tag_confirmed_at>{{ 'projectsSettings.other.zcs.mikakunin' | translate }}</span> <span ng-if=project.conversion_tag_confirmed_at>{{project.conversion_tag_confirmed_at | zcDate}}</span><br></div></div></div><div class=form-group zc-master-only><label for=show_item_stats class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.shouhin_jouhou_kanren' | translate }}</label><div class=col-sm-6><input type=checkbox id=show_item_stats ng-model=project.show_item_stats></div></div><div class=form-group><label for=is_reviewed class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.han_shakai_seiryoku' | translate }}</label><div class=col-sm-3><input name=is_reviewed type=checkbox class=form-control ng-model=project.is_reviewed><div ng-if=\"project.is_reviewed && project.reviewed_at\">{{ 'projectsSettings.other.zcs.kakunin_hi' | translate }}: {{project.reviewed_at | zcDate}}</div></div></div><div class=form-group><label for=invoice_calculation_type class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.seikyuu_taipu' | translate }}</label><div class=col-sm-3><input name=invoice_calculation_type type=text disabled class=form-control ng-model=project.invoice_calculation_type></div></div><div class=form-group><label for=fee_rate class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.tesuuryou_ritsu' | translate }}</label><div class=col-sm-3><input name=fee_rate type=number disabled class=form-control ng-model=project.fee_rate></div></div><div class=form-group><label for=disable_minimal_fee class=\"col-sm-5 control-label\">disable_minimal_fee</label><div class=col-sm-3><input name=disable_minimal_fee type=checkbox ng-model=project.disable_minimal_fee></div></div><div class=form-group><label for=is_test class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.tesuto_youpurojekutofuragu' | translate }}(is_test)</label><div class=col-sm-3><input name=is_test type=checkbox ng-model=project.is_test></div></div><div class=form-group><label translate=projectsSettings.other.zcs.kabaa_ritsudeforuto translate-value-rate=0.5 for=estimated_cv_cover_rate class=\"col-sm-5 control-label\"></label><div class=col-sm-3><input name=estimated_cv_cover_rate type=number min=0 max=1 step=0.01 class=form-control ng-model=project.estimated_cv_cover_rate></div></div><div class=form-group><label translate=projectsSettings.other.zcs.haishin_yosou_rifuto translate-value-rate=1.35 for=estimated_ai_coupon_multiplier class=\"col-sm-5 control-label\"></label><div class=col-sm-3><input name=estimated_ai_coupon_multiplier type=number min=1 max=3 step=0.01 class=form-control ng-model=project.estimated_ai_coupon_multiplier></div></div><div class=form-group><label for=is_suspended class=\"col-sm-5 control-label\">{{ 'projectsSettings.other.zcs.kyousei_teishi' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'projectsSettings.other.zcs.shinki_kyanpeen_haishin' | translate }}\"></i></label><div class=col-sm-3><input name=is_suspended type=checkbox class=form-control ng-model=project.is_suspended ng-change=updateSuspendedAt()><div ng-if=\"project.is_suspended && project.suspended_at\">{{ 'projectsSettings.other.zcs.kyousei_teishi_hi' | translate }}: {{project.suspended_at | zcDate}}</div></div></div></section><section><h2 class=config-subtitle>{{ 'projectsSettings.other.zcs.ikkagetsu_no_yosou' | translate }}</h2><div class=form-group><label class=\"col-sm-3 control-label\">{{ 'projectsSettings.other.zcs.segumento_gesshou' | translate }}</label><div class=col-sm-4><div class=input-group><span class=input-group-addon>¥</span> <input type=number class=form-control ng-model=zcsSimulation.monthlySegmentRevenue></div></div></div><table class=\"table config-table table-bordered\"><tr><th>{{ 'projectsSettings.other.zcs.wariai' | translate }}</th><th>{{ 'projectsSettings.other.zcs.cvCoverRate' | translate }}</th><th>{{ 'projectsSettings.other.zcs.haishin' | translate }}</th><th>{{ 'projectsSettings.other.zcs.tootaru' | translate }}</th></tr><tr><td>{{(100 - project.pc_control_percent) / 100}} x</td><td>{{project.estimated_cv_cover_rate}} x</td><td>{{project.estimated_ai_coupon_multiplier}} x</td><td>{{zcsSimulation.monthlySegmentRevenue * ((100 - project.pc_control_percent) / 100) * project.estimated_cv_cover_rate * project.estimated_ai_coupon_multiplier | zcCurrency:'¥':0}}</td></tr></table></section><button class=\"btn btn-config\" type=submit ng-disabled=form.$invalid>{{ 'projectsSettings.other.zcs.henkou_suru' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/users/index.html';
var html = "<div id=installationConversionTag><ng-container><h1 class=config-title>{{ 'projectsSettings.users.menbaa_kanri' | translate }}</h1><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert>{{ 'projectsSettings.users.aajsSettingsWarningMsg' | translate }}</div><p translate=projectsSettings.users.purojekuto_nani_akusesukanou class=config-lead></p><section ng-if=users.length><table class=\"table config-table table-bordered\"><tr><th>{{ 'projectsSettings.users.menbaa_na' | translate }}</th><th>{{ 'projectsSettings.users.meeruadoresu' | translate }}</th></tr><tr ng-repeat=\"user in users\"><td>{{user.full_name}}<zc-label-user-invitation user=user></zc-label-user-invitation></td><td>{{user.email}} <a class=config-table-remove confirm-modal confirm-click=remove(user.id)><i class=\"fa fa-times\"></i></a></td></tr></table></section><zc-internal-user-table project=project><a class=\"btn btn-config\" ui-sref=admin.projects.settings.users.invite()>{{ 'projectsSettings.users.menbaa_wo_tsuika' | translate }}</a></zc-internal-user-table></ng-container></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/users/internal_user_table.html';
var html = "<section ng-if=!vm.isCommonUser><h1 class=config-title><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.users.internalUsers' | translate }}</h1><table class=\"table config-table table-bordered\"><tr><th>{{ 'projectsSettings.users.menbaa_na' | translate }}</th><th>{{ 'projectsSettings.users.meeruadoresu' | translate }}</th></tr><tr ng-repeat=\"user in vm.internalUsers\"><td>{{ user.full_name }}</td><td>{{ user.email }}</td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/users/invite.html';
var html = "<div id=installationConversionTag><h1 class=config-title>{{ 'projectsSettings.users.invite.menbaa_wo_shoutai' | translate }}</h1><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert>{{ 'projectsSettings.users.aajsSettingsWarningMsg' | translate }}</div><p class=config-lead><span translate=projectsSettings.users.invite.purojekuto_nani_shoutai translate-value-project={{project.title}}></span> <span class=text-danger>{{ 'projectsSettings.users.invite.send_invitation_mail' | translate }}</span></p><section><form name=form zc-dirty-form-dialog class=\"form-horizontal form-condenced\" ng-submit=\"invite(project, user); form.$setPristine()\"><section><h2 class=config-subtitle>{{ 'projectsSettings.users.invite.tantousha_na' | translate }}</h2><div class=\"row form-group\"><div class=col-sm-6><input type=text class=form-control ng-model=user.full_name placeholder=\"{{ 'projectsSettings.users.invite.zenkuraaku_futo_puutaroo' | translate }}\" required></div></div><h2 class=config-subtitle>{{ 'projectsSettings.users.invite.meeruadoresu' | translate }}</h2><div class=\"row form-group\"><div class=col-sm-6><input type=mail class=form-control ng-model=user.email placeholder=user@example.com required></div></div><h2 class=config-subtitle>{{ 'projectsSettings.users.invite.language' | translate }}</h2><div class=\"row form-group\"><div class=col-sm-6><select id=lang name=lang class=form-control ng-options=\"'sharedModules.common.i18n.code.' + language | translate for language in availableLanguages\" ng-model=user.lang></select></div></div></section><button class=\"btn btn-config\" ng-disabled=\"form.$invalid || isDisplayAajsWarningMsg\"><i class=\"fa fa-envelope\"></i> {{ 'projectsSettings.users.invite.shoutai_meeru_wo' | translate }}</button></form></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

var path = '/templates/projects.settings/users/submenu.html';
var html = "<ul class=config-submenu-list><li ui-sref=admin.projects.settings.users() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><a>{{ 'projectsSettings.users.submenu.menbaa_kanri' | translate }}</a></li><li ui-sref=admin.projects.settings.users.invite() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><a>{{ 'projectsSettings.users.submenu.menbaa_wo_shoutai' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/campaign_segment.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.thisMonthStat><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.campaign_segment.kyanpeengoto_no_haishin' | translate }}</h3></div><div class=panel-body><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/campaign_table.html';
var html = "<table class=\"campaign-table table table-bordered\" ng-if=$ctrl.project.campaigns><thead><tr><th>ID</th><th>{{ 'projectsSiteReports.campaign_table.kyanpeen' | translate }}</th><th style=\"min-width: 300px\">{{ 'projectsSiteReports.campaign_table.haishin_jisseki' | translate }}</th><th>{{ 'projectsSiteReports.campaign_table.mokuhyou_toutatsu_purosesu' | translate }} <a class=pull-right href=# ng-csv=$ctrl.getCSV() filename=\"{{ $ctrl.filename }}\" add-bom=true charset=utf-16 field-separator=\\t><i class=\"glyphicon glyphicon-download-alt\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"campaign in $ctrl.project.campaigns\"><td>{{ campaign.id }}<div ng-if=\"campaign.control_percent >= 1\"><span class=\"label label-success\">A&nbsp;/&nbsp;B</span></div></td><td><a class=media ui-sref=\"admin.projects.campaigns.show.creative({projectId: $ctrl.project.id, campaignId: campaign.id})\"><div class=media-left><a ui-sref=\"admin.projects.campaigns.show.creative({projectId: $ctrl.project.id, campaignId: campaign.id})\"><img class=campaign-banner-avatar style=\"max-width: 135px\" ng-src=\"{{ campaign.banner }}\"></a></div><div class=media-body><div class=site-report__table-mb><div campaign-device ng-model=campaign></div><a ui-sref=\"admin.projects.campaigns.show.stats({projectId: $ctrl.project.id, campaignId: campaign.id})\">{{ campaign.name }} <i class=\"glyphicon glyphicon-link\"></i></a></div><div ng-if=campaign.segment class=site-report__table-mb><a class=\"label label-warning\" ui-sref=\"admin.projects.segments.show({projectId: $ctrl.project.id, segmentId: campaign.segment.id})\">{{ campaign.segment.name }} <i class=\"glyphicon glyphicon-link\"></i></a></div><div>{{ campaign.start_at | zcDate : { smart: true } }} ~ {{ campaign.end_at | zcDate : { smart: true } }}</div></div></a></td><td><div class=site-report__table-row>{{ 'projectsSiteReports.campaign_table.haishin_kazu' | translate }}<div class=pull-right><span ng-if=\"campaign.control_percent >= 1\" translate=projectsSiteReports.campaign_table.hihyouji_ritsu translate-value-percent=\"{{ campaign.control_percent | number : 0 }}\"></span> {{ campaign.session_count | number : 0 }}</div></div><div class=site-report__table-row>{{ 'projectsSiteReports.campaign_table.konbaajon_ritsu' | translate }}<div class=pull-right><span ng-if=\"campaign.conversion_up_rate !== null\" translate=projectsSiteReports.campaign_table.joushouritsu translate-value-percent=\"{{ campaign.conversion_up_rate * 100 | number : 1 }}\"></span> {{ campaign.conversion_rate * 100 | number : 2 }}%</div></div><div class=site-report__table-row>{{ 'projectsSiteReports.campaign_table.heikin_tanka' | translate }}<div class=pull-right><span ng-if=\"campaign.conversion_up_rate !== null\" translate=projectsSiteReports.campaign_table.joushouritsu translate-value-percent=\"{{ campaign.conversion_up_rate * 100 | number : 1 }}\"></span> {{ campaign.average_conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div></div><div class=site-report__table-row>{{ 'projectsSiteReports.campaign_table.keiyu_uriage' | translate }}<div class=pull-right><span ng-if=\"campaign.contribution_price !== null\" translate=kakutoku_kingaku translate-value-currency=\"campaign.contribution_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix\"></span> {{ campaign.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div></div></td><td><highchart config=campaign.chartConfig></highchart></td></tr></tbody><tbody ng-if=\"$ctrl.project.campaigns.length === 0\"><tr><td colspan=4 class=text-center>{{ 'projectsSiteReports.campaign_table.kyanpeen_ga_haishin' | translate }}</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/conversion_cover.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.dailyStats><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.conversion_cover.kyanpeen_keiyu_uriage' | translate }} <a class=pull-right href=# ng-csv=$ctrl.getCSV() filename=\"{{ $ctrl.filename }}\" add-bom=true charset=utf-16 field-separator=\\t><i class=\"glyphicon glyphicon-download-alt\"></i></a></h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-5 col-md-offset-1\"><dl><dt><span class=text-blue>{{ 'projectsSiteReports.conversion_cover.keiyu_uriage' | translate }}</span></dt><dd class=text-blue>{{ $ctrl.project.thisMonthStat.all_campaign.conversion_price | number }} <span class=unit>{{ currency.symbol || currency.suffix }}</span></dd></dl></div><div class=col-md-6><dl><dt>{{ 'projectsSiteReports.conversion_cover.uriage_kabaa_ritsu' | translate }}</dt><dd class=text-bad>{{ $ctrl.project.thisMonthStat.conversion_cover_rate * 100 | number : 1 }} <span class=unit>%</span></dd></dl></div></div><div class=row style=margin-bottom:10px;><div class=\"col-md-11 col-md-offset-1\"><dl><dt translate=projectsSiteReports.conversion_cover.saito_gesshou_en translate-value-currency=\"{{ $ctrl.project.thisMonthStat.all_access.conversion_price | number | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}\"></dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/conversion_price.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.cumulativeDailyStats><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.conversion_price.saito_zentaini_tai' | translate }}<span ng-if=\"$ctrl.project.is_abtest >= 1\">{{ 'projectsSiteReports.conversion_price.nobashita_uriage' | translate }}</span> <a class=pull-right href=# ng-csv=$ctrl.getCSV() filename=\"{{ $ctrl.filename }}\" add-bom=true charset=utf-16 field-separator=\\t><i class=\"glyphicon glyphicon-download-alt\"></i></a></h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><dl ng-class=\"{'col-md-offset-3 col-md-3': $ctrl.project.is_abtest >= 1}\"><dt class=text-blue>{{ 'projectsSiteReports.conversion_price.keiyu_uriage' | translate }}</dt><dd class=text-blue>{{ $ctrl.project.thisMonthStat.all_campaign.conversion_price | number : 0 }} <span class=unit>{{ currency.symbol || currency.suffix }}</span></dd><dt translate=projectsSiteReports.conversion_price.saito_zentai_no translate-value-percent=\"{{ $ctrl.project.thisMonthStat.conversion_cover_rate * 100 | number : 1 }}\"></dt></dl><dl class=col-md-3 ng-if=\"$ctrl.project.is_abtest >= 1\"><dt class=text-blue>{{ 'projectsSiteReports.conversion_price.nobashita_uriage' | translate }}</dt><dd class=text-blue>{{ $ctrl.project.thisMonthStat.contribution_price | number : 0 }} <span class=unit>{{ currency.symbol || currency.suffix }}</span></dd><dt translate=projectsSiteReports.conversion_price.saito_zentai_no translate-value-percent=\"{{ $ctrl.project.thisMonthStat.contribution_rate * 100 | number : 1 }}\"></dt></dl></div><div><highchart config=$ctrl.chartConfig></highchart></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/conversion_segment.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.thisMonthStat><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.conversion_segment.kounyuu_kaisuu_goto' | translate }}</h3></div><div class=panel-body><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/device_segment.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.thisMonthStat><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.device_segment.debaisugoto_no_haishin' | translate }}</h3></div><div class=panel-body><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/glossary.html';
var html = "<table class=\"table table-bordered\"><thead><tr><th>{{ 'projectsSiteReports.glossary.yougo' | translate }}</th><th>{{ 'projectsSiteReports.glossary.kaisetsu' | translate }}</th></tr></thead><tbody><tr><td>{{ 'projectsSiteReports.glossary.keiyu_uriage' | translate }}</td><td>{{ 'projectsSiteReports.glossary.kyanpeen_ga_hyouji' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.minashi_kakutoku_kingaku' | translate }}</td><td>{{ 'projectsSiteReports.glossary.keiyu_uriage_ni' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.kaatokurikku_ritsu' | translate }}</td><td>{{ 'projectsSiteReports.glossary.kyanpeen_wo_uketotta' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.kaatosuruu_ritsu' | translate }}</td><td>{{ 'projectsSiteReports.glossary.shouhin_wo_kaato' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.kyoumi_shouhin_etsuran' | translate }}</td><td>{{ 'projectsSiteReports.glossary.noarugorizumu_ni_yotte,mausu' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.henka_ritsu' | translate }}</td><td>{{ 'projectsSiteReports.glossary.tesuto_wo_itta' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.hyouji_guruupu_hihyouji' | translate }}</td><td>{{ 'projectsSiteReports.glossary.mattaku_onaji_jouken' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.haishin_kabaa_ritsu' | translate }}</td><td>{{ 'projectsSiteReports.glossary.delivery_cover_rate_description' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.uriage_kabaa_ritsu' | translate }}</td><td>{{ 'projectsSiteReports.glossary.saito_zentai_no' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.ryuunyuu_segumento' | translate }}</td><td>{{ 'projectsSiteReports.glossary.randingupeejinoparameeta_ni_fuyo' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.kasutamusegumento' | translate }}</td><td>{{ 'projectsSiteReports.glossary.kasutamusegumento_kinou_wo' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.emotion_io' | translate }}</td><td>{{ 'projectsSiteReports.glossary.no_jinkouchinou_enjinmausu' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.teppanyuuzaa' | translate }}</td><td>{{ 'projectsSiteReports.glossary.immediate_buyer_description' | translate }}</td></tr><tr><td>{{ 'projectsSiteReports.glossary.mikomi_nashiyuuzaa' | translate }}</td><td>{{ 'projectsSiteReports.glossary.kounyuu_no_iyoku' | translate }}</td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/kpi_box.html';
var html = "<div class=\"kpi-box text-center\" ng-if=$ctrl.budget><div class=row><div class=col-md-3><dl><dt>{{ 'projectsSiteReports.kpi_box.go_seikyuu' | translate }}</dt><dd>{{ $ctrl.invoicePrice | number : 0 }} <span class=unit>円</span></dd></dl></div><div class=col-md-1><dl><dt>&nbsp;</dt><dd>÷</dd></dl></div><div class=col-md-3><dl><dt>{{ 'projectsSiteReports.kpi_box.go_yosan' | translate }}</dt><dd>{{ $ctrl.budget | number : 0 }} <span class=unit>円</span></dd></dl></div><div class=col-md-1><dl><dt>&nbsp;</dt><dd>=</dd></dl></div><div class=col-md-3><dl><dt>{{ 'projectsSiteReports.kpi_box.yosan_tassei_ritsu' | translate }}</dt><dd>{{ $ctrl.achievementRate * 100 | number : 1 }} <span class=unit>%</span></dd></dl></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/kpi_summary.html';
var html = "<div class=\"row site-report__table\"><div class=\"col-sm-10 col-sm-offset-1\"><div class=\"kpi-comparison text-center\" ng-if=$ctrl.project.thisMonthStat><div class=\"row site-report__table-row site-report__table-secondary\"><div class=col-sm-2>&nbsp;</div><div class=col-sm-2>{{ 'projectsSiteReports.kpi_summary.saito_zentai_no' | translate }}</div><div class=col-sm-2>{{ 'projectsSiteReports.kpi_summary.haishin_kazu' | translate }}</div><div class=col-sm-2>{{ 'projectsSiteReports.kpi_summary.keiyu_uriage' | translate }}</div><div class=col-sm-2>{{ 'projectsSiteReports.kpi_summary.seikyuu_kingaku' | translate }}</div></div><div ng-if=$ctrl.simulation class=\"row site-report__table-row\"><div class=\"col-sm-2 site-report__table-secondary text-left\" translate=projectsSiteReports.kpi_summary.toshitsuki_getsumatsu_yosoku translate-value-date=\"{{ $ctrl.project.thisMonthStat.start_at | date : ('sharedModules.dateTimeFormats.yearMonth' | translate) }}\"></div><div class=col-sm-2><div class=site-report__summary-large>{{ $ctrl.project.thisMonthStat.all_access.conversion_price * $ctrl.simulation | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><span ng-if=$ctrl.project.lastMonthStat.all_access.conversion_price class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.saku_tsuki_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthStat.all_access.conversion_price * $ctrl.simulation\" from=$ctrl.project.lastMonthStat.all_access.conversion_price></zc-increase-or-decrease-percentage>)</span> <span ng-if=$ctrl.project.lastYearStat.all_access.conversion_price class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.sakunen_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthStat.all_access.conversion_price * $ctrl.simulation\" from=$ctrl.project.lastYearStat.all_access.conversion_price></zc-increase-or-decrease-percentage>)</span></div><div class=col-sm-2><div class=site-report__summary-large>{{ $ctrl.project.thisMonthStat.all_campaign.session_count * $ctrl.simulation | number : 0 }}</div><span ng-if=$ctrl.project.lastMonthStat.all_campaign.session_count class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.saku_tsuki_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthStat.all_campaign.session_count * $ctrl.simulation\" from=$ctrl.project.lastMonthStat.all_campaign.session_count></zc-increase-or-decrease-percentage>)</span> <span ng-if=$ctrl.project.lastYearStat.all_campaign.session_count class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.sakunen_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthStat.all_campaign.session_count * $ctrl.simulation\" from=$ctrl.project.lastYearStat.all_campaign.session_count></zc-increase-or-decrease-percentage>)</span></div><div class=col-sm-2><div class=site-report__summary-large>{{ $ctrl.project.thisMonthStat.all_campaign.conversion_price * $ctrl.simulation | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><span ng-if=$ctrl.project.lastMonthStat.all_campaign.conversion_price class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.saku_tsuki_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthStat.all_campaign.conversion_price * $ctrl.simulation\" from=$ctrl.project.lastMonthStat.all_campaign.conversion_price></zc-increase-or-decrease-percentage>)</span> <span ng-if=$ctrl.project.lastYearStat.all_campaign.conversion_price class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.sakunen_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthStat.all_campaign.conversion_price * $ctrl.simulation\" from=$ctrl.project.lastYearStat.all_campaign.conversion_price></zc-increase-or-decrease-percentage>)</span></div><div class=col-sm-2><div class=site-report__summary-large>{{ $ctrl.project.thisMonthInvoice.invoice_price_tax_excluded * $ctrl.simulation | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><span ng-if=$ctrl.project.lastMonthInvoice.invoice_price_tax_excluded class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.saku_tsuki_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthInvoice.invoice_price_tax_excluded * $ctrl.simulation\" from=$ctrl.project.lastMonthInvoice.invoice_price_tax_excluded></zc-increase-or-decrease-percentage>)</span> <span ng-if=$ctrl.project.lastYearInvoice.invoice_price_tax_excluded class=site-report__table-small>{{ 'projectsSiteReports.kpi_summary.sakunen_hi' | translate }} (<zc-increase-or-decrease-percentage to=\"$ctrl.project.thisMonthInvoice.invoice_price_tax_excluded * $ctrl.simulation\" from=$ctrl.project.lastYearInvoice.invoice_price_tax_excluded></zc-increase-or-decrease-percentage>)</span></div></div><div class=\"row site-report__table-row\"><div class=\"col-sm-2 site-report__table-secondary text-left\">{{ $ctrl.project.thisMonthStat.start_at | date : ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</div><div class=col-sm-2>{{ $ctrl.project.thisMonthStat.all_access.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><div class=col-sm-2>{{ $ctrl.project.thisMonthStat.all_campaign.session_count | number : 0 }}</div><div class=col-sm-2>{{ $ctrl.project.thisMonthStat.all_campaign.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><div class=col-sm-2>{{ $ctrl.project.thisMonthInvoice.invoice_price_tax_excluded | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div></div><div ng-if=$ctrl.project.lastMonthStat class=\"row site-report__table-row\"><div class=\"col-sm-2 site-report__table-secondary text-left\">{{ $ctrl.project.lastMonthStat.start_at | date : ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</div><div class=col-sm-2>{{ $ctrl.project.lastMonthStat.all_access.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><div class=col-sm-2>{{ $ctrl.project.lastMonthStat.all_campaign.session_count | number : 0 }}</div><div class=col-sm-2>{{ $ctrl.project.lastMonthStat.all_campaign.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><div class=col-sm-2>{{ $ctrl.project.lastMonthInvoice.invoice_price_tax_excluded | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div></div><div ng-if=$ctrl.project.lastYearStat class=\"row site-report__table-row\"><div class=\"col-sm-2 site-report__table-secondary text-left\">{{ $ctrl.project.lastYearStat.start_at | date : ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</div><div class=col-sm-2>{{ $ctrl.project.lastYearStat.all_access.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><div class=col-sm-2>{{ $ctrl.project.lastYearStat.all_campaign.session_count | number : 0 }}</div><div class=col-sm-2>{{ $ctrl.project.lastYearStat.all_campaign.conversion_price | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div><div class=col-sm-2>{{ $ctrl.project.lastYearInvoice.invoice_price_tax_excluded | number : 0 | zcCurrency : currency.symbol:currency.fractionSize:currency.suffix}}</div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/navigation.html';
var html = "<div class=\"container-fluid site-report__navigation\"><div class=row><div class=col-md-6><a class=site-report__navigation-title ui-sref=\"admin.projects.site_report.summary({projectId: $ctrl.project.id, month: $ctrl.thisMonth})\">{{ 'projectsSiteReports.navigation.samariirepooto' | translate }}</a></div><div class=\"col-md-6 text-right\"><nav><ul class=pagination><li><a class=\"btn btn-sm\" ng-click=$ctrl.goBack() ng-disabled=$ctrl.isOldest()>{{ 'projectsSiteReports.navigation.sengetsu' | translate }}</a></li><li><span>{{ $ctrl.startAt | date : ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</span></li><li><a class=\"btn btn-sm\" ng-click=$ctrl.goNext() ng-disabled=$ctrl.isLatest()>{{ 'projectsSiteReports.navigation.yokugetsu' | translate }}</a></li></ul></nav></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/session_cover.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.dailyStats><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.session_cover.kyanpeen_haishin_kazu' | translate }} <a class=pull-right href=# ng-csv=$ctrl.getCSV() filename=\"{{ $ctrl.filename }}\" add-bom=true charset=utf-16 field-separator=\\t><i class=\"glyphicon glyphicon-download-alt\"></i></a></h3></div><div class=panel-body><div class=row style=margin-bottom:10px;><div class=\"col-md-5 col-md-offset-1\"><dl><dt><span class=text-blue>{{ 'projectsSiteReports.session_cover.haishin_kazu' | translate }}</span></dt><dd class=text-blue>{{ $ctrl.project.thisMonthStat.all_campaign.session_count | number : 0}} <span class=unit>{{ 'projectsSiteReports.session_cover.sesshon' | translate }}</span></dd></dl></div><div class=col-md-6><dl><dt>{{ 'projectsSiteReports.session_cover.haishin_kabaa_ritsu' | translate }}</dt><dd class=text-bad>{{ $ctrl.project.thisMonthStat.session_cover_rate * 100 | number : 1 }} <span class=unit>%</span></dd></dl></div></div><div class=row style=margin-bottom:10px;><div class=\"col-md-11 col-md-offset-1\"><dl><dt translate=saito_houmon_kazusesshon translate-value-count=\"{{ $ctrl.project.thisMonthStat.all_access.session_count | number }}\"></dt></dl></div></div><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/summary.html';
var html = "<zc-site-report-navigation project=$ctrl.project></zc-site-report-navigation><div id=site-report class=content ng-if=$ctrl.project.thisMonthStat><div class=container><h2>{{ 'projectsSiteReports.summary.samarii' | translate }}</h2><zc-site-report-kpi-box project=$ctrl.project></zc-site-report-kpi-box><zc-site-report-kpi-summary project=$ctrl.project></zc-site-report-kpi-summary><h2 ng-if=$ctrl.project.campaigns>{{ 'projectsSiteReports.summary.kyanpeen' | translate }}</h2><zc-site-report-campaign-table project=$ctrl.project></zc-site-report-campaign-table><h2 ng-if=$ctrl.project.cumulativeDailyStats>{{ 'projectsSiteReports.summary.haishin_kibo' | translate }}</h2><zc-site-report-conversion-price project=$ctrl.project></zc-site-report-conversion-price><div class=row><div class=col-md-6><zc-site-report-session-cover project=$ctrl.project></zc-site-report-session-cover></div><div class=col-md-6><zc-site-report-conversion-cover project=$ctrl.project></zc-site-report-conversion-cover></div></div><h2>{{ 'projectsSiteReports.summary.segumento' | translate }}</h2><div class=row><div class=col-md-6><zc-site-report-device-segment project=$ctrl.project></zc-site-report-device-segment></div><div class=col-md-6><zc-site-report-campaign-segment project=$ctrl.project></zc-site-report-campaign-segment></div></div><div class=row><div class=col-md-6><zc-site-report-conversion-segment project=$ctrl.project></zc-site-report-conversion-segment></div><div class=col-md-6><zc-site-report-utm-medium-segment project=$ctrl.project></zc-site-report-utm-medium-segment></div></div><h2>{{ 'projectsSiteReports.summary.yougoshuu' | translate }}</h2><zc-site-report-glossary></zc-site-report-glossary></div></div><div id=site-report class=content ng-if=\"$ctrl.project.is_loaded && !$ctrl.project.thisMonthStat\"><div class=container>{{ 'projectsSiteReports.summary.repooto_ga_mitsukarimasen' | translate }}<br>{{ 'projectsSiteReports.summary.shibarakushitekara_mouichido_o' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

var path = '/templates/projects.site_reports/utm_medium_segment.html';
var html = "<div class=\"panel panel-default\" ng-if=$ctrl.project.thisMonthStat><div class=panel-heading><h3 class=panel-title>{{ 'projectsSiteReports.utm_medium_segment.ryuunyuu_motogoto_no' | translate }}</h3></div><div class=panel-body><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

var path = '/templates/projects/components/domain_sampler/domain_sampler.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'projects.components.domainSampler.trackingDomainList' | translate }} <span translate=projects.components.domainSampler.estimatedValueSampled translate-value-period=\"{{ $ctrl.from | zcDate : { smart: true } }} - {{ $ctrl.to | zcDate : { smart: true } }}\" class=\"small text-muted\"></span></h3></div><div class=panel-body><table class=\"table table-bordered\"><thead><tr><th>{{ 'projects.components.domainSampler.domain' | translate }}</th><th>{{ 'projects.components.domainSampler.visits' | translate }}</th><th>{{ 'projects.components.domainSampler.coverageRate' | translate }}</th></tr></thead><tbody ng-if=\"$ctrl.tableRows.length === 0\"><tr><td colspan=3>{{ 'projects.components.domainSampler.noDataFound' | translate }}</td></tr></tbody><tbody ng-if=$ctrl.tableRows.length><tr ng-repeat=\"tableRow in $ctrl.tableRows\"><td>{{ tableRow.domain }}</td><td>{{ tableRow.matchCount | number : 0 }}</td><td>{{ tableRow.matchRate | number : 0 }}%</td></tr></tbody></table><br><div><select class=form-control style=\"width: 150px\" ng-model=$ctrl.device ng-options=\"device as device.name for device in $ctrl.devices\"></select></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

var path = '/templates/projects/components/session_sampler/session_sampler.html';
var html = "<div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ $ctrl.title }} <span translate=projects.components.sessionSampler.estimatedValueSampled translate-value-period=\"{{ $ctrl.from | zcDate : { smart: true } }} - {{ $ctrl.to | zcDate : { smart: true } }}\" class=\"small text-muted\"></span></h3></div><div class=panel-body><div><div class=segment_session_number>{{ $ctrl.matchedCount | number : 0 }} <span class=unit>{{ 'sharedModules.common.unit.session' | translate }}</span></div><progressbar value=$ctrl.matchedPercentage type=info>{{ $ctrl.matchedPercentage | number : 1 }}%</progressbar><div translate=projects.components.sessionSampler.allSessions translate-value-session=\"{{ $ctrl.totalCount | number : 0 }}\" class=\"text-center text-muted\"></div></div><br><div><select class=form-control style=\"width: 150px\" ng-model=$ctrl.device ng-options=\"device as device.name for device in $ctrl.devices\"></select></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

var path = '/templates/projects/directives/project_notification.html';
var html = "<div class=notice-area ng-if=\"(project.is_maintenance || showTimezoneAlert) && isAlert\"><div ng-if=showTimezoneAlert class=alert ng-class=\"{'alert-warning': !isCriticalTimezoneAlert, 'alert-danger': isCriticalTimezoneAlert}\" role=alert ng-click=removeAlert()><div><span class=\"fa fa-warning\"></span> <strong><span translate=projects.directives.projects.projectNotification.timezoneDifferenceWarning translate-value-timezone=\"{{ project.region | gmtNotation }}\"></span></strong></div></div><div ng-if=project.is_maintenance class=\"alert alert-warning\" role=alert ng-click=removeAlert()><div><span class=\"fa fa-wrench\"></span> <strong>{{ 'projects.directives.projects.projectNotification.shisutemumentenansumoodo' | translate }}</strong></div><p>{{ 'projects.directives.projects.projectNotification.genzai_ippanyuuza_nihako' | translate }}</p><p>{{ 'projects.directives.projects.projectNotification.mentenansumoodoha_kihonjouhou_suteetasu' | translate }}</p></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

var path = '/templates/projects/directives/projects/advertisings_list.html';
var html = "<div><div ng-show=\"advertisings.length == 0\">{{ 'projects.directives.projects.advertisingsList.koukoku_parameetaaga_settei' | translate }}</div><table class=\"table table-bordered table-condensed table-striped\" ng-if=\"advertisings.length > 0\"><thead><tr><th>{{ 'projects.directives.projects.advertisingsList.parameetaa' | translate }}</th><th>{{ 'projects.directives.projects.advertisingsList.hantei_houshiki' | translate }}</th><th>{{ 'projects.directives.projects.advertisingsList.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"advertising in advertisings\"><td>{{advertising.parameter}}</td><td>{{advertising.match_type}}</td><td>{{advertising.match_pattern}}</td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

var path = '/templates/projects/directives/projects/login_evaluators_list.html';
var html = "<div><div ng-show=\"login_evaluators.length == 0\">{{ 'projects.directives.projects.loginEvaluatorsList.roguin_hantei_houhou' | translate }}</div><table class=\"table table-bordered table-condensed table-striped\" ng-if=\"login_evaluators.length > 0\"><thead><tr><th>{{ 'projects.directives.projects.loginEvaluatorsList.taipu' | translate }}</th><th>{{ 'projects.directives.projects.loginEvaluatorsList.namae' | translate }}</th><th>{{ 'projects.directives.projects.loginEvaluatorsList.hantei_houshiki' | translate }}</th><th>{{ 'projects.directives.projects.loginEvaluatorsList.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"login_evaluator in login_evaluators\"><td>{{login_evaluator.evaluation_type}}</td><td>{{login_evaluator.name}}</td><td>{{login_evaluator.match_type}}</td><td>{{login_evaluator.match_pattern}}</td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

var path = '/templates/projects/directives/projects/newsletter_parameters_list.html';
var html = "<div><div ng-show=\"newsletter_parameters.length == 0\">{{ 'projects.directives.projects.newsletterParametersList.meerumagajin_hantei_parameeta' | translate }}</div><table class=\"table table-bordered table-condensed table-striped\" ng-if=\"newsletter_parameters.length > 0\"><thead><tr><th>{{ 'projects.directives.projects.newsletterParametersList.parameeta_na' | translate }}</th><th>{{ 'projects.directives.projects.newsletterParametersList.hantei_houshiki' | translate }}</th><th>{{ 'projects.directives.projects.newsletterParametersList.hantei_pataan' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"newsletter_parameter in newsletter_parameters\"><td>{{newsletter_parameter.name}}</td><td>{{newsletter_parameter.match_type}}</td><td>{{newsletter_parameter.match_pattern}}</td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/detail.html';
var html = "<div class=container><h3>{{ 'projects.views.detail.koudo_na_settei' | translate }}</h3><accordion close-others=false><accordion-group heading=\"{{ 'projects.views.detail.kuriaransu_haishin_settei' | translate }}\" is-open=true><p>{{ 'projects.views.detail.kuriaransu_taishou_shouhin' | translate }}<br>{{ 'projects.views.detail.appuroodoshitarisuto_wo_kyanpeen' | translate }}</p><hr><div class=row><div class=col-sm-6><h4>{{ 'projects.views.detail.appuroodo' | translate }}</h4><div ng-controller=ClearanceItemSetUploadCtrl flow-init><div class=form-group><label>{{ 'projects.views.detail.namae_hissu' | translate }}</label> <input type=text class=form-control ng-model=clearance_item_set.name required> <label>{{ 'projects.views.detail.hosokusetsumei' | translate }}</label> <textarea class=form-control ng-model=clearance_item_set.description required>\n              </textarea><br><input type=file flow-btn style=display:none> <span class=\"btn btn-primary\" flow-btn>{{ 'projects.views.detail.appuroodo' | translate }}</span></div></div><div><ul><li>{{ 'projects.views.detail.example_one' | translate }}<br>{{ 'projects.views.detail.example_two' | translate }}</li><li>{{ 'projects.views.detail.example_three' | translate }}</li><li>{{ 'projects.views.detail.example_four' | translate }}</li><li>{{ 'projects.views.detail.example_five' | translate }}</li></ul></div></div><div class=col-sm-6><h4>{{ 'projects.views.detail.nofoomatto_rei' | translate }}</h4><br><table class=table><thead><tr><th>path</th></tr></thead><tbody><tr><td>/products/1</td></tr><tr><td>/products/2</td></tr><tr><td>/products?sku=3</td></tr><tr><td>/products?sku=4&amp;group=123</td></tr><tr><td>/products?sku=5&amp;fashion</td></tr></tbody></table><zc-api-public-file-downloader text=\"'{{ 'projects.views.detail.fairunofoomatto_sanpuru_wa' | translate }}'\" filepath=\"'/clearance_sample.csv'\"></zc-api-public-file-downloader></div></div><div class=row ng-if=project.clearance_item_sets.length><hr><div class=col-sm-12><div><h4>{{ 'projects.views.detail.appuroodosaretarisuto' | translate }}</h4><table class=\"table campaign-table table-bordered\"><tr><th>{{ 'projects.views.detail.kuriaransu' | translate }}</th><th>{{ 'projects.views.detail.namae' | translate }}</th><th>{{ 'projects.views.detail.shousaisetsumei' | translate }}</th><th>{{ 'projects.views.detail.appuroodo_nichiji' | translate }}</th><th>{{ 'projects.views.detail.haishin_uchi_no' | translate }}</th><td></td></tr><tr ng-repeat=\"set in project.clearance_item_sets\" ng-init=getClearanceCampaigns(set)><td>{{set.id}}</td><td><a ui-sref=\"admin.projects.clearanceSet.show({projectId: project.id, clearanceItemSetId: set.id})\">{{set.name}}</a></td><td>{{set.description}}</td><td>{{set.created_at | zcDate : {smart:true} }}</td><td><ul class=list-unstyled ng-repeat=\"campaign in set.clearanceCampaigns\"><li><a ui-sref=\"admin.projects.campaigns.show.stats({projectId:project.id, campaignId:campaign.id})\" target=_blank>{{campaign.name}}</a></li></ul></td><td><div class=\"btn-group pull-right\" role=group><i class=\"glyphicon glyphicon-trash\" confirm-click=removeClearanceItemSet(set) tooltip=\"{{ 'projects.views.detail.sakujo_masutaa' | translate }}\" confirm-modal></i></div></td></tr></table></div><div><ul><li>{{ 'projects.views.detail.risuto_wa_saidai' | translate }}</li><li>{{ 'projects.views.detail.haishin_uchi_no' | translate }}</li><li>{{ 'projects.views.detail.kyanpeen_sakusei_gamen' | translate }}</li><li>{{ 'projects.views.detail.hitotsu_no_shouhin' | translate }}<br>{{ 'projects.views.detail.dochiraka_katahou_shika' | translate }}</li></ul></div></div></div></accordion-group></accordion></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/kpi_view.html';
var html = "<section class=kpi-container><div class=row><div class=\"col-sm-2 col-xs-6 border-right\"><dl><dt>{{ 'projects.views.directives.kpiView.houmonsha_kazu' | translate }}</dt><dd>{{cumulativeData['totalSessionCount'] | number:0}}</dd></dl></div><div class=\"col-sm-2 col-xs-6 border-right\"><dl><dt>{{ 'projects.views.directives.kpiView.konbaajon_kazu' | translate }}</dt><dd>{{cumulativeData['totalConversionCount'] | number:0}} <span style=font-size:small>({{cumulativeData['conversionRate']*100 | number:2}}%)</span></dd></dl></div><div class=\"col-sm-2 col-xs-6 border-right\"><dl><dt>{{ 'projects.views.directives.kpiView.uriagedaka' | translate }}</dt><dd>¥{{cumulativeData['totalConversionPrice'] | number:0}}</dd></dl></div><div class=\"col-sm-2 col-xs-6 border-right\"><dl class=light-blue><dt>{{ 'projects.views.directives.kpiView.haishin_mono_kazu' | translate }}</dt><dd>{{cumulativeData['totalDeliveryCount'] | number:0}}</dd></dl></div><div class=\"col-sm-2 col-xs-6 border-right\"><dl class=light-blue><dt>{{ 'projects.views.directives.kpiView.kakutoku' | translate }}CV</dt><dd>{{cumulativeData['liftedConversionCount'] | number:0}} <span style=font-size:small>(<span ng-if=\"cumulativeData['liftRate'] >= 0\">+</span> <span ng-if=\"cumulativeData['liftRate'] < 0\">-</span>{{cumulativeData['liftRate']*100 | number:2}}%)</span></dd></dl></div><div class=\"col-sm-2 col-xs-6\"><dl class=light-blue style=margin-right:10px><dt>{{ 'projects.views.directives.kpiView.kakutoku_uriage' | translate }}</dt><dd>¥{{cumulativeData['liftedConversionPrice'] | number:0}} <span style=font-size:small>(<span ng-if=\"cumulativeData['liftRate'] >= 0\">+</span> <span ng-if=\"cumulativeData['liftRate'] < 0\">-</span>{{cumulativeData['liftRate']*100 | number:2}}%)</span></dd></dl></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/project_apikey_menu.html';
var html = "<li ng-if=Project.currentProject><span style=\"color: #fff\"><i class=\"fa fa-product-hunt\"></i> <span style=\"user-select: all; cursor: pointer;\">{{ Project.currentProject.apikey }}</span></span></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/project_list.html';
var html = "<div class=project-list-box ng-repeat=\"project in projects\"><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\"><div class=\"project-list-box-cell project-list-label\" tooltip=\"{{project.product_line | uppercase}}\"><div class=\"project-label project-zenclerk\" ng-if=\"project.product_line =='zenclerk'\">{{project.apikey | limitTo:1 | uppercase}}</div><div class=\"project-label project-zenclerks\" ng-if=\"project.product_line =='zenclerk_s'\">{{project.apikey | limitTo:1 | uppercase}}</div><div class=\"project-label project-zenclerklp\" ng-if=\"project.product_line =='zenclerk_lp'\">{{project.apikey | limitTo:1 | uppercase}}</div></div><div class=\"project-list-box-cell project-list-detail\"><div class=project-list-title>{{project.title}}</div><span class=project-list-apikey>{{project.apikey}}</span><div class=project-list-base_url>{{project.base_url}}</div><div class=project-list-arrow><i class=\"fa fa-arrow-right\"></i></div></div></a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/project_search.html';
var html = "<input type=text ng-model=selectedProject class=\"form-control project-search\" typeahead=\"project as project.title for project in projects | filter:$viewValue | limitTo:8\" typeahead-min-length=0 typeahead-on-select=\"selectProject($item, $model, $label)\" typeahead-template-url=/templates/projects/views/directives/project_search_single.html typeahead-append-to-body=true placeholder=\"{{ 'projects.views.directives.projectSearch.purojekuto_namataha_de' | translate }}\">";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/project_search_single.html';
var html = "<a><span bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></span></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/projects_menu.html';
var html = "<li class=\"dropdown project-name-menu\" dropdown><a class=\"dropdown-toggle project-name-menu-link\" dropdown-toggle ng-click=focusOnSearch()><i class=\"fa fa-bars\"></i> {{ currentProject.title || ('projects.views.directives.projectsMenu.saito_sentaku' | translate) | limitTo : 20 }} <span ng-if=::currentProject.is_terminated class=text-danger zc-master-only><i class=\"fa fa-exclamation-triangle\"></i></span></a><ul class=dropdown-menu role=menu ng-if=\"projects.length > 0\"><li ng-repeat=\"project in projects\"><a ng-click=Project.goHome(project)>{{::project.title | limitTo: 20 }}{{::project.title.length > 20 ? '...' : ''}} <span ng-if=::project.is_terminated class=text-danger zc-master-only><i class=\"fa fa-exclamation-triangle\"></i> {{ 'projects.views.directives.projectsMenu.ochimashita' | translate }}</span></a></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/directives/projects_menu_search.html';
var html = "<li class=\"dropdown navbar-profile\" dropdown ng-show=Devise.isMaster()><a class=dropdown-toggle dropdown-toggle ng-click=focusOnSearch()><i class=\"glyphicon glyphicon-search\"></i></a><ul class=dropdown-menu role=menu><li><project-search on-select=goHome(project)></project-search></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/edit.html';
var html = "<div class=content><div class=container id=project_edit><div class=\"layout layout-main-right layout-stack-sm\"><div ng-include=\"'/templates/users/user_sidebar.html'\" ng-controller=UserSidebarCtrl></div><div class=\"col-md-9 col-sm-8 layout-main\"><div id=settings-content class=\"tab-content stacked-content\"><div class=\"tab-pane fade in active\" id=site-edit><h3 class=content-title><u>{{ 'projects.views.edit.saito_jouhou_henkou' | translate }}</u></h3><form class=form-horizontal name=form ng-submit=save()><div class=form-group><label class=col-md-3 for=title>{{ 'projects.views.edit.saito_na' | translate }}</label><div class=col-md-7><input type=text class=form-control id=title placeholder=\"{{ 'projects.views.edit.saito_na' | translate }}\" tabindex=1 ng-model=project.title required></div></div><div class=form-group><div class=\"col-md-7 col-md-push-3\"><button type=submit class=\"btn btn-primary\" tabindex=4 ng-disabled=form.$invalid>{{ 'projects.views.edit.henkou_suru' | translate }}</button></div></div><div class=row ng-if=project.can_control_publish><div class=col-md-6 ng-show=project.is_publish><button class=\"btn btn-primary btn-block\" confirm-modal=\"{{ 'projects.views.edit.torakkingutagu_wo_teishi' | translate }}\" confirm-click=updatePublish(false)>{{ 'projects.views.edit.torakkingutagu_wo_kinkyuuteishi' | translate }}</button></div><div class=col-md-6 ng-hide=project.is_publish><button class=\"btn btn-success btn-block\" ng-click=updatePublish(true)>{{ 'projects.views.edit.torakkingutagu_no_haishin' | translate }}</button></div><div class=\"col-md-8 text-muted\">{{ 'projects.views.edit.torakkingutagugasaito_houmonsha_no' | translate }}<br>{{ 'projects.views.edit.hakushi_no_wo' | translate }}</div></div></form></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/home.html';
var html = "<div id=wrapper class=zenclerk-home><div class=content ng-if=!$ctrl.Devise.isMaster()><div class=container ng-if=\"$ctrl.projects.length === 0\"><div class=error-container><div class=error-code><i class=\"fa fa-ban\"></i></div><div class=error-details><h4>{{ 'projects.views.home.purojekuto_ga_mitsukarimasen' | translate }}</h4><div><a ui-sref=admin.users.inquiry()>{{ 'projects.views.home.otoiawase_wa_kochira' | translate }}</a></div></div></div></div><div class=container ng-if=\"$ctrl.projects.length >= 1\"><h3>{{ 'projects.views.home.saito_ichiran' | translate }}</h3><zc-project-list projects=$ctrl.projects></zc-project-list></div></div><div class=content ng-if=$ctrl.Devise.isMaster()><div id=campaign-detail class=container><section><div class=row><div class=\"project-search col-sm-4\"><project-search on-select=$ctrl.goToProject(project)></project-search></div></div></section><zc-master-home projects=$ctrl.projects></zc-master-home><section><h4>{{ 'projects.views.home.saikin_sakuraretasaito' | translate }}</h4><zc-project-list projects=$ctrl.recentProjects></zc-project-list><div class=clearfix></div></section></div><div id=campaign-detail class=container><section><h4>{{ 'projects.views.home.dairiten_risuto' | translate }}</h4><div ng-repeat=\"agency in $ctrl.agencies | orderBy: 'created_at' : true\" class=project-list-box><a ui-sref=\"admin.agencies.settings({agencyName: agency.name})\"><div class=\"project-list-box-cell project-list-label\"><div class=\"project-label project-label-agency\">{{agency.name | limitTo: 1 | uppercase}}</div></div><div class=\"project-list-box-cell project-list-detail\"><div class=project-list-title>{{agency.title}}</div><span class=project-list-apikey>{{agency.name}}</span><div class=project-list-details><div>{{ 'projects.views.home.seikyuu_saki_kaishamei' | translate }}: {{agency.billing_company_name}}</div></div><div class=project-list-arrow><i class=\"fa fa-arrow-right\"></i></div></div></a></div></section></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/images/index.html';
var html = "<div class=content id=campaign-list><div class=container><div class=\"row header\"><div class=col-md-6><h3>{{ 'projects.views.images.gazou_kanri' | translate }}</h3></div><div class=\"col-md-6 addnew\"><div class=pull-right><button class=\"btn btn-primary\" data-toggle=modal href=#image-modal><span class=\"glyphicon glyphicon-plus-sign\"></span>{{ 'projects.views.images.gazou_wo_shinki' | translate }}</button></div></div></div>{{images | json}}<div class=gallery-wrapper><div class=\"row gallery-row\"><div class=\"col-md-3 img-container\" ng-repeat=\"image in images\"><div class=\"panel panel-default\"><div class=panel-heading>{{image.image_file_name}} <a class=close ng-click=deleteImage(image.id)><span class=\"glyphicon glyphicon-remove-circle\"></span></a></div><div class=\"img-box panel-body\"><img ng-src={{image.image_url}} alt={{image.image_file_name}} class=img-responsive></div><div class=panel-footer>{{image.width}}x{{image.height}} | {{image.image_file_size | byteFormat}}</div></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

var path = '/templates/projects/views/maintenance.html';
var html = "<div id=wrapper><div class=content><div class=\"container text-center\"><br><br><i class=\"fa fa-wrench\" style=\"font-size:180px;color:rgb(228, 228, 228)\"></i><br><br><br><br><h2>{{ 'projects.views.maintenance.shisutemumentenansu_uchi_de' | translate }}</h2><p>{{ 'projects.views.maintenance.go_riyou_no' | translate }}<br>{{ 'projects.views.maintenance.mentenansu_shuuryou_made' | translate }}</p><p>{{ 'projects.views.maintenance.o_isogi_no' | translate }}</p></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

var path = '/templates/users.pages/views/pricing.html';
var html = "<div class=document-wrapper><div class=row><div class=\"col-md-push-2 col-md-8\"><h1 class=text-center>{{ 'usersPages.views.pricing.zcFeesSystem' | translate }}</h1><div><section><p translate=usersPages.views.pricing.zcUsageFees translate-value-strong1=\"<strong>{{ 'usersPages.views.pricing.strong1' | translate }}</strong>\" translate-value-strong2=\"<strong>{{ 'usersPages.views.pricing.strong2' | translate }}</strong>\"></p><div class=text-center><div class=price-container>{{ 'usersPages.views.pricing.zcCharges' | translate }}<span>{{ 'usersPages.views.pricing.sales' | translate }}</span></div></div></section><section><h2 class=tile-title>{{ 'usersPages.views.pricing.couponDeliveryEffect' | translate }}</h2><p>{{ 'usersPages.views.pricing.zcFirstVisitUser' | translate }}</p><p>{{ 'usersPages.views.pricing.zcEffectCalculate' | translate }}</p><p>{{ 'usersPages.views.pricing.distributionRatio' | translate }}</p><p class=text-center><img src=/assets/price/price.png class=img-responsive style=\"margin:30px 0px\"></p></section><section><h2 class=tile-title>{{ 'usersPages.views.pricing.conceptOfAcquiredSales' | translate }}</h2><p>{{ 'usersPages.views.pricing.acquiredSalesRate' | translate }}</p><p>{{ 'usersPages.views.pricing.specificCalculationFormula' | translate }}</p><p class=text-center><img src=/assets/price/liftrate.png class=img-responsive style=\"margin:30px 5px\"></p></section></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

var path = '/templates/users/inquiry.html';
var html = "<div class=content><div class=container><div class=\"layout layout-main-right layout-stack-sm\"><div ng-include=\"'/templates/users/user_sidebar.html'\" ng-controller=UserSidebarCtrl></div><div class=\"col-md-9 col-sm-8 layout-main\"><div id=settings-content class=\"tab-content stacked-content\"><div class=\"tab-pane fade in active\" id=contact><h3 class=content-title><u>{{ 'users.inquiry.otoiawase' | translate }}</u></h3><form class=form-horizontal name=form ng-submit=submit(inquiry) zc-dirty-form-dialog><div class=form-group><label class=col-md-3 for=message>{{ 'users.inquiry.shousai' | translate }}</label><div class=col-md-7><textarea id=message class=form-control rows=6 ng-model=inquiry.message required></textarea></div></div><div class=form-group><label class=col-md-3 for=reason>{{ 'users.inquiry.otoiawase_riyuu' | translate }}</label><div class=col-md-7><select class=\"form-control selectpicker\" id=reason ng-model=inquiry.reason ng-options=\"reason[1] as reason[0] for reason in reasons\" required></select></div></div><div class=form-group><div class=\"col-md-7 col-md-push-3\"><button type=submit class=\"btn btn-primary\" ng-disabled=\"form.$invalid || form.$pristine || isSaving\">{{ 'users.inquiry.soushin_suru' | translate }}</button></div></div></form></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

var path = '/templates/users/user_sidebar.html';
var html = "<div class=\"col-md-3 col-sm-4 layout-sidebar\"><ul id=myTab class=\"nav nav-layout-sidebar nav-stacked\"><li ng-class=\"{active:isActive('admin.users.edit')}\"><a data-toggle=tab data-target=# ui-sref=admin.users.edit()><i class=\"fa fa-user\"></i>{{ 'users.user_sidebar.yuzajohohenko' | translate }}</a></li><li ng-class=\"{active:isActive('admin.users.password.edit')}\"><a data-toggle=tab data-target=# ui-sref=admin.users.password.edit()><i class=\"fa fa-lock\"></i>{{ 'users.user_sidebar.pasuwaadohenko' | translate }}</a></li><li ng-class=\"{active:isActive('admin.users.inquiry')}\"><a data-toggle=tab data-target=# ui-sref=admin.users.inquiry()><i class=\"fa fa-envelope-o\"></i>{{ 'users.user_sidebar.otoiawase' | translate }}</a></li></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

var path = '/templates/users/views/devise_header.html';
var html = "<div class=container><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>Toggle navigation</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-right\"><language-select-header></language-select-header></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

var path = '/templates/users/views/directives/language_select_header.html';
var html = "<li class=dropdown dropdown><a class=dropdown-toggle dropdown-toggle><i class=\"fa fa-language\"></i> {{ getLanguageLabel() }}</a><ul class=dropdown-menu role=menu><li ng-repeat=\"lang in availableLanguages\"><a ng-click=setLanguage(lang)>{{ getLanguageLabel(lang, lang) }}</a></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

var path = '/templates/users/views/directives/user_menu.html';
var html = "<li class=\"dropdown navbar-profile\" dropdown><a class=dropdown-toggle id=user-id dropdown-toggle>{{currentUser.email}} <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu user_menu\" role=menu><li ng-if=!logoutOnly><a ui-sref=admin.users.edit()><i class=\"fa fa-user\"></i> {{ 'users.views.directives.user_menu.yuzajohohenko' | translate }}</a></li><li ng-if=agency><a ui-sref=\"admin.agencies.settings({agencyName: agency.name})\"><i class=\"fa fa-building\"></i> {{ 'users.views.directives.user_menu.dairitensettei' | translate }}</a></li><li ng-if=!logoutOnly><a ui-sref=admin.users.password.edit()><i class=\"fa fa-key\"></i> {{ 'users.views.directives.user_menu.pasuwaadohenko' | translate }}</a></li><li ng-if=!logoutOnly><a ui-sref=admin.users.inquiry()><i class=\"fa fa-envelope-o\"></i> {{ 'users.views.directives.user_menu.otoiawase' | translate }}</a></li><li><a href=\"https://docs.aideal.appier.com/\" target=_blank><i class=\"fa fa-question\"></i> {{ 'users.views.directives.user_menu.manyuaru' | translate }}</a></li><li class=divider ng-if=!logoutOnly></li><li><a ng-click=signOut()><i class=\"fa fa-sign-out\"></i> Logout</a></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

var path = '/templates/users/views/edit.html';
var html = "<div class=content><div class=container><div class=\"layout layout-main-right layout-stack-sm\"><div ng-include=\"'/templates/users/user_sidebar.html'\" ng-controller=UserSidebarCtrl></div><div class=\"col-md-9 col-sm-8 layout-main\"><div id=settings-content class=\"tab-content stacked-content\"><div class=\"tab-pane fade in active\" id=site-edit><h3 class=content-title><u>{{ 'users.views.edit.changeUserInformation' | translate }}</u></h3><form class=form-horizontal ng-submit=\"save({ full_name: user.full_name, email: user.email, lang: user.lang, })\" name=form id=form><div class=form-group><label class=col-md-3 for=user_full_name>{{ 'users.views.edit.fullName' | translate }}</label><div class=col-md-7><input type=text class=form-control id=user_full_name name=user_full_name ng-model=user.full_name required></div></div><div class=form-group><label class=col-md-3 for=user_email>{{ 'users.views.edit.email' | translate }}</label><div class=col-md-7><input type=email class=form-control id=user_email name=user_email ng-model=user.email required></div></div><div class=form-group><label class=col-md-3 for=lang>{{ 'users.views.edit.selectLanguage' | translate }}</label><div class=col-md-3><select id=lang name=lang class=form-control ng-options=\"'sharedModules.common.i18n.code.' + language | translate for language in availableLanguages\" ng-model=user.lang></select></div></div><div class=form-group><div class=\"col-md-7 col-md-push-3\"><button type=submit class=\"btn btn-primary\" ng-disabled=\"form.$invalid || form.$pristine || isSaving\">{{ 'users.views.edit.update' | translate }}</button></div></div></form></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

var path = '/templates/users/views/invitation/accept.html';
var html = "<section id=generateUser><div class=\"container text-center\"><h1 class=config-title>{{ 'users.views.invitation.accept.akaunto_wo_sakusei' | translate }}</h1><div class=config-lead>{{ 'users.views.invitation.accept.noyuuzaaakaunto_wo_sakusei' | translate }}</div><div class=row><div class=\"col-md-6 col-md-offset-3\"><form class=form-horizontal name=form ng-submit=submit(user)><div class=form-group><label for=full_name class=\"col-sm-4 control-label\">{{ 'users.views.invitation.accept.tantousha_you_na' | translate }}</label><div class=col-sm-8><input id=full_name type=text class=form-control placeholder=\"{{ 'users.views.invitation.accept.tantousha_you_na' | translate }}\" tabindex=1 ng-model=user.full_name required></div></div><div class=form-group><label for=email class=\"col-sm-4 control-label\">{{ 'users.views.invitation.accept.meeruadoresu' | translate }}</label><div class=col-sm-8><input id=email type=email class=form-control placeholder=user@example.com ng-model=user.email tabindex=2 required></div></div><div class=form-group><label for=password class=\"col-sm-4 control-label\">{{ 'users.views.invitation.accept.pasuwaado' | translate }}</label><div class=col-sm-8><input type=password class=form-control id=password placeholder=\"{{ 'users.views.invitation.accept.pasuwaado' | translate }}\" tabindex=3 ng-model=user.password ng-minlength=8 required></div></div><div class=form-group><label for=password_confirmation class=\"col-sm-4 control-label\">{{ 'users.views.invitation.accept.password_confirmation' | translate }}</label><div class=col-sm-8><input type=password class=form-control id=password_confirmation placeholder=\"{{ 'users.views.invitation.accept.password_confirmation' | translate }}\" tabindex=4 ng-model=user.password_confirmation ng-minlength=8 required></div></div><div class=form-group><div class=text-center><input id=isAgreeToTosAndPrivacyPolicy ng-model=isAgreeToTosAndPrivacyPolicy type=checkbox required> <label for=isAgreeToTosAndPrivacyPolicy translate=users.views.invitation.accept.agree_to_tos_and_privacy_policy translate-value-terms-of-service=\"<a href='/admin/tos?lang={{selectedLanguage}}' target='_blank'>{{ 'users.views.invitation.accept.tos' | translate }}</a>\" translate-value-privacy-policy=\"<a href='/admin/privacy_policy?lang={{selectedLanguage}}' target='_blank'>{{ 'users.views.invitation.accept.privacy_policy' | translate }}</a>\"></label></div></div><button type=submit class=\"btn btn-config\" ng-disabled=form.$invalid>{{ 'users.views.invitation.accept.akaunto_wo_sakusei' | translate }}</button></form></div></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

var path = '/templates/users/views/password/edit.html';
var html = "<div class=content><div class=container><div class=\"layout layout-main-right layout-stack-sm\"><div ng-include=\"'/templates/users/user_sidebar.html'\" ng-controller=UserSidebarCtrl></div><div class=\"col-md-9 col-sm-8 layout-main\"><div id=settings-content class=\"tab-content stacked-content\"><div class=\"tab-pane fade in active\" id=site-edit><h3 class=content-title><u>{{ 'users.views.password.edit.resetPassword' | translate }}</u></h3><form class=form-horizontal name=form autocomplete=off ng-submit=save(user) zc-dirty-form-dialog><div class=form-group><label class=col-md-3 for=user_current_password>{{ 'users.views.password.edit.genzainopasuwado' | translate }}</label><div class=col-md-7><input type=password id=user_current_password name=user_current_password class=form-control ng-model=user.current_password required ng-minlength=8></div></div><div class=form-group><label class=col-md-3 for=user_password>{{ 'users.views.password.edit.pasuwado' | translate }}</label><div class=col-md-7><input type=password id=user_password name=user_password class=form-control ng-model=user.password required ng-minlength=8></div></div><div class=form-group><label class=col-md-3 for=user_password_confirmation>{{ 'users.views.password.edit.pasuwado_kakunin' | translate }}</label><div class=col-md-7><input type=password id=user_password_confirmation name=user_password_confirmation class=form-control ng-model=user.password_confirmation required ng-minlength=8></div></div><div class=form-group><div class=\"col-md-7 col-md-push-3\"><button type=submit class=\"btn btn-primary\" ng-disabled=\"form.$invalid || form.$pristine || isSaving\">{{ 'users.views.password.edit.henkosuru' | translate }}</button></div></div></form></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

var path = '/templates/users/views/password/forgot.html';
var html = "<div class=account-wrapper><div class=account-body><h2>{{ 'users.views.password.forgot.resetPassword' | translate }}</h2><h5>{{ 'users.views.password.forgot.enterEmail' | translate }}</h5><form name=form class=\"form account-form\" ng-submit=submit(user)><div class=form-group><label for=user_email class=placeholder-hidden>{{ 'users.views.password.forgot.email' | translate }}</label> <input type=email class=form-control id=user_email placeholder=\"{{ 'users.views.password.forgot.email' | translate }}\" tabindex=1 ng-model=user.email required></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\" tabindex=2 ng-disabled=form.$invalid>{{ 'users.views.password.forgot.sendRecoveryLink' | translate }} &nbsp; <i class=\"fa fa-refresh\"></i></button></div><div class=form-group><a ui-sref=users.signIn><i class=\"fa fa-angle-double-left\"></i> &nbsp;{{ 'users.views.password.forgot.backToLogin' | translate }}</a></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

var path = '/templates/users/views/password/reset.html';
var html = "<div class=account-wrapper><div class=account-body><h2>{{ 'users.views.password.reset.enterPassword' | translate }}</h2><h5>{{ 'users.views.password.reset.enternewPassword' | translate }}</h5><form class=\"form account-form\" name=form ng-submit=submit(user)><div class=form-group><label for=user_email class=placeholder-hidden>{{ 'users.views.password.reset.pasuwado' | translate }}</label> <input type=password class=form-control id=user_email placeholder=\"{{ 'users.views.password.reset.pasuwado' | translate }}\" tabindex=1 ng-model=user.password required ng-minlength=8></div><div class=form-group><label for=user_email_confirmation class=placeholder-hidden>{{ 'users.views.password.reset.pasuwado_kakunin' | translate }}</label> <input type=password class=form-control id=user_email_confirmation placeholder=\"{{ 'users.views.password.reset.pasuwado_kakunin' | translate }}\" tabindex=2 ng-model=user.password_confirmation required ng-minlength=8></div><div class=form-group><button type=submit class=\"btn btn-secondary btn-block btn-lg\" tabindex=3 ng-disabled=form.$invalid>{{ 'users.views.password.reset.resetPassword' | translate }}&nbsp; <i class=\"fa fa-refresh\"></i></button></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

var path = '/templates/users/views/sign_in.html';
var html = "<div ng-if=!enableAuth0 class=account-wrapper><div class=account-body><h3>{{ 'users.views.signIn.login' | translate }}</h3><form name=form class=\"form account-form\" ng-submit=login(user)><div class=form-group><label for=user_email class=placeholder-hidden>{{ 'users.views.signIn.email' | translate }}</label> <input auto-fill-sync type=email class=form-control id=user_email placeholder=\"{{ 'users.views.signIn.email' | translate }}\" tabindex=1 ng-model=user.email required></div><div class=form-group><label for=login-password class=placeholder-hidden>{{ 'users.views.signIn.password' | translate }}</label> <input auto-fill-sync type=password class=form-control id=login-password placeholder=\"{{ 'users.views.signIn.password' | translate }}\" tabindex=2 ng-model=user.password required ng-minlength=8></div><div class=\"form-group clearfix\"><div class=pull-left><label class=checkbox-inline><input type=checkbox tabindex=3 ng-model=user.remember_me> <small>{{ 'users.views.signIn.rememberMe' | translate }}</small></label></div><div class=pull-right><small><a ui-sref=users.password.forgot>{{ 'users.views.signIn.forgotPassword' | translate }}</a></small></div></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\" tabindex=4 ng-disabled=form.$invalid>{{ 'users.views.signIn.login' | translate }} &nbsp; <i class=\"fa fa-play-circle\"></i></button></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

var path = '/templates/master.agencies/edit.html';
var html = "<section id=generateProject><div class=\"container text-center\"><h1 class=config-title>{{ 'masterAgencies.edit.editAgencies' | translate }}</h1><div class=row><div class=\"col-md-10 col-md-offset-1\"><form name=form class=form-horizontal ng-submit=save(agency)><div class=form-group><label for=name class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.name' | translate }} <span style=\"color: lightgrey; display: block; font-size: 0.8em;\">{{ 'masterAgencies.edit.shou_moji_no' | translate }}</span></label><div class=col-sm-6><input id=name name=name ng-model=agency.name ng-pattern=\"/^[a-z]+[a-z0-9-]+?$/\" class=form-control placeholder=emin-10 required></div></div><div class=form-group><label for=title class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.kaishamei' | translate }}</label><div class=col-sm-6><input class=form-control id=title name=title ng-model=agency.title placeholder=\"Appier Japan, Inc.\" required></div></div><div class=form-group><label for=representative class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.kaisha_daihyou_myoudai' | translate }}</label><div class=col-sm-6><input class=form-control id=representative name=representative ng-model=agency.representative required></div></div><div class=form-group><label for=postal_code class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.yuubinbangou' | translate }}</label><div class=col-sm-6><input class=form-control id=postal_code name=postal_code ng-model=agency.postal_code placeholder=\"{{ 'masterAgencies.edit.addressExample' | translate }}\" required></div></div><div class=form-group><label for=address class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.juusho' | translate }}</label><div class=col-sm-6><input class=form-control id=address name=address ng-model=agency.address placeholder=\"{{ 'masterAgencies.edit.toukyouto_shibu_tani' | translate }}\" required></div></div><div class=form-group><label for=phone_number class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.denwabangou' | translate }}</label><div class=col-sm-6><input class=form-control id=phone_number name=phone_number ng-model=agency.phone_number placeholder=03-3000-3000 required></div></div><hr><section><h4>{{ 'masterAgencies.edit.seikyuu_saki_jouhou' | translate }}</h4><div class=form-group><div class=col-md-12 style=\"font-size: 1.3em;\"><zc-sync-contract-info-button source=agency></zc-sync-contract-info-button></div></div><div class=form-group><label for=billing_company_name class=col-sm-3>{{ 'masterAgencies.edit.kaishamei' | translate }}</label><div class=col-sm-6><input class=form-control id=billing_company_name name=billing_company_name ng-model=agency.billing_company_name placeholder=\"{{ 'masterAgencies.edit.kabushikigaisha_yuugengaisha_nado' | translate }}\" required></div></div><div class=form-group><label for=billing_postal_code class=col-sm-3>{{ 'masterAgencies.edit.yuubinbangou' | translate }}</label><div class=col-sm-6><input class=form-control id=billing_postal_code name=billing_postal_code ng-model=agency.billing_postal_code placeholder=\"{{ 'masterAgencies.edit.addressExample' | translate }}\" required></div></div><div class=form-group><label for=billing_address class=col-sm-3>{{ 'masterAgencies.edit.juusho' | translate }}</label><div class=col-sm-6><input class=form-control id=billing_address name=billing_address ng-model=agency.billing_address placeholder=\"{{ 'masterAgencies.edit.rei_toukyouto_shina' | translate }}\" required></div></div><div class=form-group><label for=billing_phone_number class=col-sm-3>{{ 'masterAgencies.edit.denwabangou' | translate }}</label><div class=col-sm-6><input class=form-control id=billing_phone_number name=billing_phone_number ng-model=agency.billing_phone_number required></div></div><div class=form-group><label for=invoice_issue_day class=\"control-label col-sm-3\">{{ 'masterAgencies.edit.hakkoubi' | translate }}</label><div class=col-sm-6><select id=invoice_issue_day class=form-control ng-options=\"item.name as item.label for item in invoiceIssueDays\" ng-model=agency.invoice_issue_day required></select></div></div><div class=form-group><label for=invoice_payment_month class=\"control-label col-sm-3\">{{ 'masterAgencies.edit.shiharai_tsuki' | translate }}</label><div class=col-sm-6><select id=invoice_payment_month class=form-control ng-options=\"item.name as item.label for item in invoicePaymentMonths\" ng-model=agency.invoice_payment_month required></select></div></div><div class=form-group><label for=invoice_payment_day class=\"control-label col-sm-3\">{{ 'masterAgencies.edit.shiharaibi' | translate }}</label><div class=col-sm-6><select id=invoice_payment_day class=form-control ng-options=\"item.name as item.label for item in invoicePaymentDays\" ng-model=agency.invoice_payment_day required></select></div></div><div class=form-group><label for=is_billing_mail class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.seikyuusho_soufu_houhou' | translate }}</label><div class=col-sm-6><label><input type=radio ng-model=agency.is_billing_mail name=is_billing_mail ng-value=true> {{ 'masterAgencies.edit.meeru_soufu' | translate }}</label> <label><input type=radio ng-model=agency.is_billing_mail name=is_billing_mail ng-value=false> {{ 'masterAgencies.edit.meeru_soufu_yuusou' | translate }}</label></div></div><div class=form-group><label for=is_invoice_automated class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.seikyuu_jidouka_kahi' | translate }}</label><div class=col-sm-6><input id=is_invoice_automated type=checkbox ng-model=agency.is_invoice_automated ng-checked=agency.is_invoice_automated name=is_invoice_automated></div></div><div class=form-group ng-if=!!users.length><label for=billing_user_id class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.seikyuu_tantou_yuuzaa' | translate }}</label><div class=col-sm-6><select class=form-control id=billing_user_id ng-model=agency.billing_user_id ng-options=\"user.id as user.email for user in users\"></select></div></div><div class=form-group><label for=billing_user_ids class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.seikyuu_yuuzaa' | translate }}</label><div class=col-sm-6><select id=billing_user_ids class=\"form-control selectpicker\" ng-model=agency.billing_user_ids ng-options=\"user.id as user.email for user in users\" multiple></select></div></div><hr><h4 style=\"padding: 0 0 1em 0;\">{{ 'masterAgencies.edit.seikyuu_tantousha_jouhou' | translate }}</h4><div class=form-group><div class=col-sm-12><zc-billing-representatives style=\"display: block; font-size: 1.3em;\" representatives=agency.billing_representatives></zc-billing-representatives></div></div></section><hr><h4>{{ 'masterAgencies.edit.koumoku' | translate }}</h4><div class=form-group><label for=default_shopping_cart_asp class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.deforutokaato' | translate }}</label><div class=col-sm-6><select class=form-control id=default_shopping_cart_asp ng-model=agency.default_shopping_cart_asp ng-options=\"asp.name as asp.label for asp in shoppingCartAsps\"></select></div></div><div class=form-group><label for=default_fee_rate class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.deforuto_seika_houshuu' | translate }}</label><div class=col-sm-6><input type=number class=form-control id=default_fee_rate name=default_fee_rate ng-model=agency.default_fee_rate placeholder=0.049 min=0.001 max=0.999 step=0.001></div></div><div class=form-group><label for=sales_entity class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.salesEntity' | translate }}</label><div class=col-sm-6><select class=form-control id=sales_entity ng-model=agency.sales_entity ng-options=\"item.name as item.label for item in salesEntities\" required></select></div></div><hr><h4>{{ 'masterAgencies.edit.dairiten_tesuuryou_ritsu' | translate }}</h4><div class=form-group><label for=margin_percent class=\"col-sm-3 control-label\">{{ 'masterAgencies.edit.dairiten_tesuuryou_ritsu_percentage' | translate }}</label><div class=col-sm-6><input type=number class=form-control id=margin_percent name=margin_percent ng-model=agency.margin_percent placeholder=20 min=0 max=100></div></div><hr><button type=submit class=\"btn btn-primary\">{{ 'masterAgencies.edit.hozon_suru' | translate }}</button></form></div></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

var path = '/templates/master.agencies/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterAgencies.list.agenciesList' | translate }}</h1></div><div class=col-md-9><button class=\"btn btn-success pull-right\" ui-sref=admin.master.agencies.new()><i class=\"glyphicon glyphicon-plus\"></i> {{ 'masterAgencies.list.dairiten_tsuika' | translate }}</button></div></div></div><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table\"><thead><tr><th class=sortable ng-click=\"setSortProp('name')\">{{ 'masterAgencies.list.name' | translate }}</th><th class=sortable ng-click=\"setSortProp('title')\">{{ 'masterAgencies.list.kaishamei' | translate }}</th><th class=sortable ng-click=\"setSortProp('representative')\">{{ 'masterAgencies.list.kaisha_daihyou_na' | translate }}</th><th class=sortable ng-click=\"setSortProp('address')\">{{ 'masterAgencies.list.juusho' | translate }}</th><th class=sortable ng-click=\"setSortProp('phone_number')\">{{ 'masterAgencies.list.denwabangou' | translate }}</th><th class=sortable ng-click=\"setSortProp('default_shopping_cart_asp')\">{{ 'masterAgencies.list.deforutokaato' | translate }}ASP</th><th class=sortable ng-click=\"setSortProp('default_fee_rate')\">{{ 'masterAgencies.list.deforuto_seika_houshuu' | translate }}</th><th class=sortable ng-click=\"setSortProp('margin_percent')\">{{ 'masterAgencies.list.dairiten_tesuuryou_ritsu' | translate }}</th><th class=sortable ng-click=\"setSortProp('is_invoice_automated')\">{{ 'masterAgencies.list.seikyuu_jidouka_kahi' | translate }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"agency in agencies\"><td>{{agency.name}}</td><td>{{agency.title}}</td><td>{{agency.representative}}</td><td>{{agency.address}}</td><td>{{agency.phone_number}}</td><td>{{agency.default_shopping_cart_asp}}</td><td>{{ agency.default_fee_rate * 100 || 0 | number : 1 }}%</td><td>{{agency.margin_percent}}<span ng-if=!!agency.margin_percent>%</span></td><td>{{ ( agency.is_invoice_automated ? 'masterAgencies.list.ok' : 'masterAgencies.list.no' ) | translate }}</td><td><div class=\"btn-group pull-right\"><button class=\"btn btn-sm btn-default\" ui-sref=\"admin.master.agencies.edit({ id: agency.id })\">{{ 'masterAgencies.list.henshuu' | translate }}</button></div></td></tr></tbody></table></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

var path = '/templates/master.campaigns/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterCampaigns.list.campaignList' | translate }}</h1></div><div class=col-md-6><div class=btn-group><button class=\"btn btn-default\" ng-model=filters.visible_group value=stats ng-class=\"{'active': filters.visible_group == 'stats'}\" ng-click=\"setVisibleGroup('stats')\">{{ 'masterCampaigns.list.haishin_kekka' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=segment ng-class=\"{'active': filters.visible_group == 'segment'}\" ng-click=\"setVisibleGroup('segment')\">{{ 'masterCampaigns.list.segumento' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=incentive ng-class=\"{'active': filters.visible_group == 'incentive'}\" ng-click=\"setVisibleGroup('incentive')\">{{ 'masterCampaigns.list.insentibu' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=creative ng-class=\"{'active': filters.visible_group == 'creative'}\" ng-click=\"setVisibleGroup('creative')\">{{ 'masterCampaigns.list.kurieitibu' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=analytics ng-class=\"{'active': filters.visible_group == 'analytics'}\" ng-click=\"setVisibleGroup('analytics')\">{{ 'masterCampaigns.list.bunseki_deeta' | translate }}</button></div></div></div></div><div class=master-search><div class=master-search-header ng-click=\"table = !table\"><i class=\"fa fa-bars\"></i> {{ 'masterCampaigns.list.deeta_shiborikomi' | translate }}</div><div class=master-search-body ng-show=table><div class=row><div class=col-sm-3><h1>{{ 'masterCampaigns.list.suteetasu' | translate }}</h1><select class=form-control ng-model=filters.campaign_scope><option value=all>{{ 'masterCampaigns.list.shiborikomi_nashi' | translate }}</option><option value=incomplete>{{ 'masterCampaigns.list.misetsu_kyoutei' | translate }}</option><option value=preview>{{ 'masterCampaigns.list.purebyuu_uchi' | translate }}</option><option value=active>{{ 'masterCampaigns.list.haishin_uchi' | translate }}</option></select></div><div class=col-sm-3><h1>{{ 'masterCampaigns.list.seihinrain' | translate }}</h1><select class=form-control ng-model=filters.product_line><option value=all>{{ 'masterCampaigns.list.shiborikomi_nashi' | translate }}</option><option value=zenclerk>{{ 'masterCampaigns.list.tsuujou_kakin' | translate }}</option><option value=zenclerk_s>zenclerk lite</option><option value=zenclerk_lp>{{ 'masterCampaigns.list.kakin' | translate }}</option></select></div><div class=col-sm-4><h1>{{ 'masterCampaigns.list.kikan_shiborikomi' | translate }}</h1><div class=row><div class=col-sm-6><input class=\"form-control form_datepick\" datepick size=16 type=text ng-model=filters.start_at_raw date=filters.start_at required></div><div class=col-sm-6><input class=\"form-control form_datepick\" datepick size=16 type=text ng-model=filters.end_at_raw date=filters.end_at required></div></div></div><div class=col-sm-2><h1>{{ 'masterCampaigns.list.kiiwaado_shiborikomi' | translate }}</h1><div class=master-search-box><input type=text class=form-control ng-model=filters.search_term ng-model-options=\"{debounce: { 'default': 500, 'blur': 0}}\" ng-change=filterCampaigns() placeholder=\"{{ 'masterCampaigns.list.kiiwaadokensaku' | translate }}\"> <i class=\"fa fa-times-circle\" ng-click=resetSearchTerm() ng-if=filters.search_term></i></div></div></div><div class=row><div class=col-sm-3><h1>{{ 'masterCampaigns.list.tantou_shiborikomi' | translate }}</h1><input id=assigned type=checkbox ng-model=filters.assigned> <label for=assigned>{{ 'masterCampaigns.list.tantou_purojekuto_no' | translate }}</label></div><div class=col-sm-3><h1>{{ 'masterCampaigns.list.intaresutowijetto_no_mi' | translate }}</h1><input id=is_widget type=checkbox ng-model=filters.is_widget> <label for=is_widget>{{ 'masterCampaigns.list.haishin_uchi_no' | translate }}</label></div><div class=col-sm-3><h1>{{ 'masterCampaigns.list.peeji_no_hyouji' | translate }}</h1><input type=text class=form-control ng-model=pagination.itemsPerPage></div></div><div class=master-search-footer><button class=\"btn btn-primary master-search-button\" ng-click=filterClicked()>{{ 'masterCampaigns.list.koushin' | translate }}</button></div></div></div><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table\"><thead><tr><th class=\"sortable campaign-sitename\" ng-click=\"setSortProp('apikey')\">APIKEY</th><th class=\"sortable campaign-ids\" ng-click=\"setSortProp('id')\">CID</th><th class=sortable ng-click=\"setSortProp('current_status')\">Status</th><th class=sortable ng-click=\"setSortProp('campaign_device')\">Device</th><th class=\"sortable campaign-name\" ng-click=\"setSortProp('name')\">Name</th><th class=sortable ng-click=\"setSortProp('stats.experimental.delivery_count')\" ng-show=\"filters.visible_group == 'stats'\">DeliveryCount</th><th class=sortable ng-click=\"setSortProp('stats.experimental.conversion_count')\" ng-show=\"filters.visible_group == 'stats'\">CVCount</th><th class=sortable ng-click=\"setSortProp('segment_cover_percentage')\" ng-show=\"filters.visible_group == 'stats'\"><span tooltip=\"{{ 'masterCampaigns.list.segmentCoverPercentage' | translate }}\">SegSize%</span></th><th class=sortable ng-click=\"setSortProp('experimental_delivery_percentage')\" ng-show=\"filters.visible_group == 'stats'\"><span tooltip=\"{{ 'masterCampaigns.list.saito_zentaini_tai' | translate }}\">ExpDelivery%</span></th><th class=sortable ng-click=\"setSortProp('experimental_conversion_price_percentage')\" ng-show=\"filters.visible_group == 'stats'\"><span tooltip=\"{{ 'masterCampaigns.list.saito_zentaini_tai' | translate }}\">ExpCVPrice%</span></th><th class=sortable ng-click=\"setSortProp('stats.experimental.conversion_rate')\" ng-show=\"filters.visible_group == 'stats'\">CVR</th><th class=sortable ng-click=\"setSortProp('stats.experimental.conversion_price')\" ng-show=\"filters.visible_group == 'stats'\">CVPrice</th><th class=sortable ng-click=\"setSortProp('stats.price_up_rate')\" ng-show=\"filters.visible_group == 'analytics'\">CVPrice UpR</th><th class=sortable ng-click=\"setSortProp('stats.conversion_lift_rate')\" ng-show=\"filters.visible_group == 'stats'\">LiftR</th><th class=sortable ng-click=\"setSortProp('stats.contribution_price')\" ng-show=\"filters.visible_group == 'stats'\">Contribution</th><th class=sortable ng-click=\"setSortProp('stolen_conversion_rate')\" ng-show=\"filters.visible_group == 'analytics'\">{{ 'masterCampaigns.list.saki_kui' | translate }}</th><th class=sortable ng-click=\"setSortProp('stolen_conversion_rate')\" ng-show=\"filters.visible_group == 'analytics'\">SPS <i class=\"fa fa-exclamation-circle\" tooltip-html-unsafe=\"{{ 'masterCampaigns.list.segumentonosesshonatari_no_uriage' | translate }}\"></i></th><th class=sortable ng-click=\"setSortProp('stolen_conversion_rate')\" ng-show=\"filters.visible_group == 'analytics'\">SPD <i class=\"fa fa-exclamation-circle\" tooltip-html-unsafe=\"Sales/Deliver 1{{ 'masterCampaigns.list.haishin_atari_no' | translate }}\"></i></th><th class=sortable ng-click=\"setSortProp('stats.experimental.campaign_coupon_used_rate')\" ng-show=\"filters.visible_group == 'analytics'\">{{ 'masterCampaigns.list.shiyouritsu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.chisq_p')\" ng-show=\"filters.visible_group == 'stats'\">P</th><th class=sortable ng-click=\"setSortProp('template_type')\" ng-show=\"filters.visible_group == 'creative'\">Template</th><th class=sortable ng-show=\"filters.visible_group == 'segment'\" ng-click=\"setSortProp('campaign_target')\">Segment</th><th class=\"sortable segment-list\" ng-show=\"filters.visible_group == 'segment'\" ng-click=\"setSortProp('segment.name')\">Detail segment</th><th ng-show=\"filters.visible_group == 'segment'\" ng-click=\"setSortProp('days_since_last_received')\">Interval</th><th class=sortable ng-show=\"filters.visible_group == 'analytics'\">Seg</th><th class=sortable ng-show=\"filters.visible_group == 'analytics'\">SegCV</th><th class=sortable ng-show=\"filters.visible_group == 'analytics'\">SegCVP</th><th class=\"sortable campaign-segment\" ng-click=\"setSortProp('campaign_policy_set.name')\" ng-show=\"filters.visible_group == 'segment'\">Timing</th><th class=sortable ng-click=\"setSortProp('incentives.length')\" ng-show=\"filters.visible_group == 'incentive'\">Incentive</th><th ng-show=\"filters.visible_group == 'stats'\" class=sortable ng-click=\"setSortProp('start_at')\">Start</th><th ng-show=\"filters.visible_group == 'stats'\" class=sortable ng-click=\"setSortProp('end_at')\">End</th><td ng-show=\"filters.visible_group == 'creative'\" class=sortable>Creative</td><th>Edit</th></tr></thead><tbody><tr ng-repeat=\"campaign in pagedCampaigns\"><td><a ui-sref=\"admin.projects.campaigns.list({projectId: campaign.project_id})\" target=_blank>{{campaign.apikey}}</a></td><td class=text-center>{{campaign.id}}</td><td><zc-campaign-status campaign=campaign show-icon=false></zc-campaign-status></td><td><span campaign-device ng-model=campaign></span></td><td><a ui-sref=\"admin.projects.campaigns.show.stats({projectId: campaign.project_id,campaignId: campaign.id})\" target=_blank>{{campaign.name}}</a></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><div><span positive-or-negative value=\"campaign.last_stats.experimental.delivery_count || 0\"></span> {{campaign.stats.experimental.delivery_count || 0}}</div><div><span positive-or-negative value=\"campaign.last_stats.control.delivery_count || 0\"></span> {{campaign.stats.control.delivery_count || 0}}</div></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><div><span positive-or-negative value=\"campaign.last_stats.experimental.conversion_count || 0\"></span> {{campaign.stats.experimental.conversion_count || 0}}</div><div><span positive-or-negative value=\"campaign.last_stats.control.conversion_count || 0\"></span> {{campaign.stats.control.conversion_count || 0}}</div></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><span tooltip-html-unsafe=\"{{ 'masterCampaigns.list.kouryo_saito_zentai' | translate }}<br> {{campaign.access_stats.session_count || 0 | number:0}} / {{campaign.total_stats.session_count || 0 | number:0}} <br> {{ 'masterCampaigns.list.no_ni_haishin' | translate:'{ percent: (100 - campaign.control_percent) }' }}\">{{campaign.segment_cover_percentage || 0 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><span tooltip-html-unsafe=\"{{ 'masterCampaigns.list.saito_zentai_houmonsha' | translate }}<br> {{campaign.stats.experimental.delivery_count || 0 | number:0}} / {{campaign.total_stats.session_count || 0 | number:0}}\">{{campaign.experimental_delivery_percentage || 0 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><span tooltip-html-unsafe=\"{{ 'masterCampaigns.list.saito_zentai_no' | translate }}<br> {{campaign.stats.experimental.conversion_price || 0 | number: campaign.currency.fractionSize}} / {{campaign.total_stats.conversion_price || 0 | number: campaign.currency.fractionSize}} ({{ campaign.currency.symbol || campaign.currency.suffix }})\">{{campaign.experimental_conversion_price_percentage || 0 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><div>{{campaign.stats.experimental.conversion_rate*100 || 0 | number:2}}%</div>{{campaign.stats.control.conversion_rate*100 || 0 | number:2}}%</td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right>{{ campaign.currency.symbol }}{{ campaign.stats.experimental.conversion_price || 0 | number: campaign.currency.fractionSize }}{{ campaign.currency.suffix }}<br>{{ campaign.currency.symbol }}{{ campaign.stats.control.conversion_price || 0 | number: campaign.currency.fractionSize }}{{ campaign.currency.suffix }}</td><td ng-show=\"filters.visible_group == 'analytics'\" class=text-right>{{campaign.stats.price_up_rate*100 || 0 | number:2}}%</td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right>{{campaign.stats.conversion_up_rate || 0 | number:2}} <span positive-or-negative value=campaign.stats.conversion_lift_rate type=percentage></span></td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right>{{ campaign.currency.symbol }}{{ campaign.stats.contribution_price || 0 | number: campaign.currency.fractionSize }}{{ campaign.currency.suffix }}</td><td ng-show=\"filters.visible_group == 'analytics'\" class=text-right><span class=\"label label-success\" ng-show=campaign.stolen_conversion_rate ng-class=\"{'label label-danger': campaign.stolen_conversion_rate.value > 0.2}\" tooltip-html-unsafe=\"EXP-CV:{{campaign.stolen_conversion_rate.exp_cv || 0}}<br>EXP-NOCV:{{campaign.stolen_conversion_rate.exp_nocv || 0}}<br>CTR-CV:{{campaign.stolen_conversion_rate.ctr_cv || 0}}<br>CTR-NOCV:{{campaign.stolen_conversion_rate.ctr_nocv || 0}}<br>CTR-RATE:{{campaign.stolen_conversion_rate.ctr_rate || 0 | number:3}}\">{{campaign.stolen_conversion_rate.value*100 || 0 | number:2}}% (100% -> {{100 - (campaign.stolen_conversion_rate.value*100) || 100 | number:2}}%)</span></td><td ng-show=\"filters.visible_group == 'analytics'\" class=text-right>{{ campaign.currency.symbol }}{{ campaign.stats.experimental.conversion_price / campaign.stats.experimental.delivery_count || 0 | number: campaign.currency.fractionSize }}{{ campaign.currency.suffix }}</td><td ng-show=\"filters.visible_group == 'analytics'\" class=text-right>{{ campaign.currency.symbol }}{{ campaign.access_stats.conversion_price / campaign.access_stats.session_count || 0 | number: campaign.currency.fractionSize }}{{ campaign.currency.suffix }}</td><td ng-show=\"filters.visible_group == 'analytics'\" class=text-right>{{campaign.stats.experimental.campaign_coupon_used_rate*100 || 0 | number:2}}%</td><td ng-show=\"filters.visible_group == 'stats'\" class=text-right><span ng-class=\"{'label label-danger': campaign.stats.chisq_p < 0.1}\">{{campaign.stats.chisq_p | number: 4}}</span></td><td ng-show=\"filters.visible_group == 'creative'\">{{campaign.template_type}}</td><td ng-show=\"filters.visible_group == 'segment'\"><zc-campaign-segment-flag segment=campaign.segment></zc-campaign-segment-flag><zc-label-clearance campaign=campaign></zc-label-clearance></td><td ng-show=\"filters.visible_group == 'segment'\"><segment-condition-table segments=campaign.segment multiple=false show-title=true vertical=true></segment-condition-table></td><td ng-show=\"filters.visible_group == 'segment'\" class=text-right>{{campaign.days_since_last_received}}</td><td ng-show=\"filters.visible_group == 'analytics'\"><div>{{campaign.access_stats.session_count || 0 | number: 0}}</div><span class=\"label label-success\">{{campaign.stats.experimental.delivery_count / campaign.access_stats.session_count * 100 || 0 | number:2}} %{{ 'masterCampaigns.list.ni_haishin' | translate }}</span></td><td ng-show=\"filters.visible_group == 'analytics'\"><div>{{campaign.access_stats.conversion_count || 0 | number: 0}}</div><span class=\"label label-success\">{{(campaign.stats.experimental.conversion_count + campaign.stats.control.conversion_count ) / campaign.access_stats.conversion_count * 100 || 0 | number:0}}%{{ 'masterCampaigns.list.kabaa' | translate }}</span></td><td ng-show=\"filters.visible_group == 'analytics'\"><div><div>{{campaign.access_stats.conversion_price || 0 | number: 0}}</div><span class=\"label label-success\">{{campaign.stats.contribution_price / campaign.access_stats.conversion_price * 100 || 0 | number:2}}%{{ 'masterCampaigns.list.uriage_zou' | translate }}</span></div></td><td ng-show=\"filters.visible_group == 'segment'\"><a ui-sref=\"admin.master.projects.campaigns.segment({projectId: campaign.project_id, campaignId: campaign.id})\" target=blank>{{campaign.campaign_policy_set.name}}</a></td><td ng-show=\"filters.visible_group == 'incentive'\"><div ng-repeat=\"incentive in campaign.incentives\"><span><zc-incentive-status incentive=incentive></zc-incentive-status><a ui-sref=\"admin.master.projects.campaigns.incentives({projectId: campaign.project_id, incentiveId: incentive.id})\" target=_blank><zc-incentive-code incentive=incentive></zc-incentive-code>{{incentive.name}} (<zc-date-range start-at=incentive.start_at end-at=incentive.end_at is-infinite=incentive.is_infinite display-time=false></zc-date-range>)</a></span></div></td><td ng-show=\"filters.visible_group == 'stats'\"><span tooltip=\"({{ campaign.region | gmtNotation }})\">{{ campaign.start_at | zcDate }}</span></td><td ng-show=\"filters.visible_group == 'stats'\"><span tooltip=\"({{ campaign.region | gmtNotation }})\">{{ campaign.end_at | zcDate }}</span></td><td class=campaign-creative style=width:500px ng-show=\"filters.visible_group == 'creative'\"><table class=table><tr ng-repeat=\"(key,value) in getTemplate(campaign.template_type)\"><th style=width:250px;>{{value.label}}</th><td><span editable-textarea=campaign.element.message[value.name] blur=submit buttons=no><div ng-bind-html=\"campaign.element.message | showElement : value\"></div></span></td></tr><tr><th>{{ 'masterCampaigns.list.tsuika' | translate }}</th><td><code tooltip={{campaign.custom_css}}>\n                        {{campaign.custom_css |limitTo:30}}\n                      </code></td></tr></table></td><td><div class=dropdown dropdown><button class=\"btn btn-default btn-sm dropdown-toggle\" type=button id=dropdownMenu1 dropdown-toggle data-toggle=dropdown aria-expanded=true>{{ 'masterCampaigns.list.sousa' | translate }} <span class=caret></span></button><ul class=\"dropdown-menu pull-right\" role=menu aria-labelledby=dropdownMenu1><li role=presentation><a role=menuitem tabindex=-1 ui-sref=\"admin.projects.campaigns.edit({projectId: campaign.project_id, campaignId: campaign.id})\">{{ 'masterCampaigns.list.henshuu' | translate }}</a></li><li role=presentation><a role=menuitem tabindex=-1 ui-sref=\"admin.projects.campaigns.confirm({projectId: campaign.project_id, campaignId: campaign.id})\">{{ 'masterCampaigns.list.settei_kakunin' | translate }}</a></li><li role=presentation><a role=menuitem tabindex=-1 ng-href={{Camp.previewUrl(campaign.project_base_url,campaign)}} target=_blank>{{ 'masterCampaigns.list.saito_ue_de' | translate }}</a></li><li role=presentation><a role=menuitem tabindex=-1 confirm-click=saveCampaign(campaign) confirm-modal href=#>{{ 'masterCampaigns.list.hozon' | translate }}</a></li></ul></div></td></tr></tbody></table></div><pagination class=pull-right total-items=filteredCampaigns.length items-per-page=pagination.itemsPerPage ng-model=pagination.currentPage ng-change=pageChanged() ng-if=\"campaigns.length > pagination.itemsPerPage\"></pagination><br><br><br class=clearfix></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

var path = '/templates/master.projects/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterProjects.list.purojekuto_ichiran' | translate }}</h1></div><div class=col-md-9><button class=\"btn btn-success pull-right\" ui-sref=admin.master.projects.new()><i class=\"glyphicon glyphicon-plus\"></i> {{ 'masterProjects.list.purojekuto_tsuika' | translate }}</button><div class=\"btn-group pull-right\" style=margin-right:5px><button class=\"btn btn-default\" ng-model=filters.visible_group value=settings ng-class=\"{'active': filters.visible_group == 'settings'}\" ng-click=\"setVisibleGroup('settings')\">{{ 'masterProjects.list.kihonjouhou_ichiran' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=stats ng-class=\"{'active': filters.visible_group == 'stats'}\" ng-click=\"setVisibleGroup('stats')\">{{ 'masterProjects.list.saito_akusesujouhou' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=users ng-class=\"{'active': filters.visible_group == 'users'}\" ng-click=\"setVisibleGroup('users')\">{{ 'masterProjects.list.yuuzaa' | translate }}</button></div></div></div></div><div class=master-search><div class=master-search-header ng-click=\"table = !table\"><i class=\"fa fa-bars\"></i> {{ 'masterProjects.list.deeta_shiborikomi' | translate }}</div><div class=master-search-body ng-show=table><div class=row><div class=col-sm-3><h1>{{ 'masterProjects.list.saabisu' | translate }}</h1><select class=form-control ng-model=filters.product_line><option value=all>{{ 'masterProjects.list.shiborikomi_nashi' | translate }}</option><option value=zenclerk>{{ 'masterProjects.list.tsuujou_kakin' | translate }}</option><option value=zenclerk_lp>{{ 'masterProjects.list.kakin' | translate }}</option></select></div><div class=col-sm-3><h1>{{ 'masterProjects.list.suteetasu' | translate }}</h1><select class=form-control ng-model=filters.contract_status ng-options=\"key as val for (key, val) in project_status\"></select></div><div class=col-sm-4><h1>{{ 'masterProjects.list.kikan_shiborikomi' | translate }}</h1><div class=row><div class=col-sm-6><input class=\"form-control form_datepick\" datepick size=16 type=text ng-model=filters.start_at_raw date=filters.start_at required></div><div class=col-sm-6><input class=\"form-control form_datepick\" datepick size=16 type=text ng-model=filters.end_at_raw date=filters.end_at required></div></div></div><div class=col-sm-2><h1>{{ 'masterProjects.list.kiiwaado_shiborikomi' | translate }}</h1><div class=master-search-box><input type=text class=form-control ng-model=filters.search_term ng-model-options=\"{debounce: { 'default': 500, 'blur': 0}}\" ng-change=filterProjects() placeholder=\"{{ 'masterProjects.list.kiiwaadokensaku' | translate }}\"> <i class=\"fa fa-times-circle\" ng-click=resetSearchTerm() ng-if=filters.search_term></i></div></div></div><div class=master-search-footer><button class=\"btn btn-primary master-search-button\" ng-click=updateData()>{{ 'masterProjects.list.koushin' | translate }}</button></div></div></div><div><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table project-list\"><thead><tr><th class=sortable ng-click=\"setSortProp('id')\">ID</th><th class=sortable style=width:200px ng-click=\"setSortProp('apikey')\">APIKEY</th><th class=sortable style=width:200px ng-click=\"setSortProp('company_name')\">{{ 'masterProjects.list.kaishamei' | translate }}</th><th class=sortable ng-click=\"setSortProp('product_line')\">{{ 'masterProjects.list.saabisu' | translate }}</th><th class=sortable ng-click=\"setSortProp('project_rank')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterProjects.list.kibo' | translate }}</th><th class=sortable ng-click=\"setSortProp('budget')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterProjects.list.tsukinami_yosan' | translate }}</th><th class=sortable ng-click=\"setSortProp('contract_status')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterProjects.list.suteetasu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.total_conversion_price')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterProjects.list.uriage' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.session_count')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterProjects.list.houmon_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.avg_history_count')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterProjects.list.heikin' | translate }}PV</th><th class=sortable ng-click=\"setSortProp('stats.avg_interest_count')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterProjects.list.heikin_kyoumi_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.exp_cart_button_click_rate')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterProjects.list.cartClickRate' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.exp_conversion_rate')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterProjects.list.cvRate' | translate }}</th><th class=sortable ng-click=\"setSortProp('session_count_evaluator')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterProjects.list.houmon_kaisuu_hantei' | translate }}</th><th class=sortable ng-click=\"setSortProp('installed_at')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterProjects.list.tagu_setchi_hi' | translate }}</th><th class=sortable ng-click=\"setSortProp('siteinfo_confirmed_at')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterProjects.list.saito_jouhou_kakunin' | translate }}</th><th class=sortable ng-click=\"setSortProp('users.length')\" ng-show=\"filters.visible_group == 'users'\">{{ 'masterProjects.list.kuraianto_tantousha' | translate }}</th><th class=sortable ng-click=\"setSortProp('users.length')\" ng-show=\"filters.visible_group == 'users'\">{{ 'masterProjects.list.masutaa_tantousha' | translate }}</th><th ng-show=\"filters.visible_group == 'users'\">{{ 'masterProjects.list.tantou_kara_hazureru' | translate }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"project in filteredProjects\"><td>{{::project.id}}</td><td><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\">{{::project.apikey}}</a></td><td>{{::project.company_name}}</td><td><zc-product-line-label project=project></zc-product-line-label></td><td class=text-center ng-show=\"filters.visible_group == 'settings'\"><span ng-show=\"::project.project_rank != 'unknown'\">{{project.project_rank | uppercase}}</span></td><td class=text-right ng-show=\"filters.visible_group == 'settings'\">{{project.currencyObj.symbol}}{{project.budget | number: project.currencyObj.fractionSize}}{{project.currencyObj.suffix}}</td><td ng-show=\"filters.visible_group == 'settings'\"><zc-label-project-status project=project range=filters></zc-label-project-status></td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.currencyObj.symbol}}{{project.stats.total_conversion_price | number: project.currencyObj.fractionSize}}{{project.currencyObj.suffix}}</td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.session_count | number:0}}</td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.avg_history_count | number: 2}}</td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.avg_interest_count | number: 2}}</td><td ng-show=\"filters.visible_group == 'stats'\"><span class=\"label group-exp\" ng-show=project.stats.exp_cart_button_click_rate>A: {{project.stats.exp_cart_button_click_rate*100 | number: 2}}%</span><br><span class=\"label group-ctl\" ng-show=project.stats.ctl_cart_button_click_rate>B: {{project.stats.ctl_cart_button_click_rate*100 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'stats'\"><span class=\"label group-exp\" ng-show=project.stats.exp_conversion_rate>A: {{project.stats.exp_conversion_rate*100 | number: 2}}%</span><br><span class=\"label group-ctl\" ng-show=project.stats.ctl_conversion_rate>B: {{project.stats.ctl_conversion_rate*100 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=\"project.session_count_evaluator === 'google_analytics'\"><span class=\"label label-success\">GA</span></div><div ng-if=\"project.session_count_evaluator === 'site_catalyst'\"><span class=\"label label-info\">SC</span></div><div ng-if=\"project.session_count_evaluator === 'visitor'\"><span class=\"label label-secondary\">ZC</span></div></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=project.installed_at><span class=\"label label-success\" tooltip=\"{{ project.region | gmtNotation }}\">{{ project.installed_at | date: 'yyyy/MM/dd' }}</span></div><div ng-if=!project.installed_at><span class=\"label label-danger\">{{ 'masterProjects.list.misetsu_kyoutei' | translate }}</span></div></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=project.siteinfo_confirmed_at><span class=\"label label-success\">{{project.siteinfo_confirmed_at | date:'yyyy/MM/dd'}}</span><br><small ng-if=project.siteinfo_confirmed_by>by {{project.siteinfo_confirmed_by.email}}</small></div><div ng-if=!project.siteinfo_confirmed_at><span class=\"label label-danger\">{{ 'masterProjects.list.misetsu_kyoutei' | translate }}</span></div></td><td ng-show=\"filters.visible_group == 'users'\"><ul class=list-inline ng-repeat=\"user in project.users | filter: {'role': 'common'}\"><li>{{user.email}}</li></ul></td><td ng-show=\"filters.visible_group == 'users'\"><ul class=list-inline ng-repeat=\"user in project.users | filter: {'role': 'master'}\"><li>{{user.email}}</li></ul></td><td ng-show=\"filters.visible_group == 'users'\" ng-init=\"project.isAssignee = checkIsAssignee(project)\"><button class=\"btn btn-sm btn-default\" ng-click=unassignCurrentUser(project) ng-if=project.isAssignee>{{ 'masterProjects.list.ko_no_tantou' | translate }}</button> <button class=\"btn btn-sm btn-default\" ng-click=assignCurrentUser(project) ng-if=!project.isAssignee>{{ 'masterProjects.list.ko_no_saito' | translate }}</button></td><td><div class=\"btn-group pull-right\"><button class=\"btn btn-sm btn-default\" ui-sref=\"admin.projects.settings.basic({ projectId: project.id })\">{{ 'masterProjects.list.henshuu' | translate }}</button><div dropdown class=\"btn-group dropdown\"><button dropdown-toggle type=button class=\"btn btn-sm btn-default dropdown-toggle actions-dropdown\"><span class=caret></span></button><ul class=\"dropdown-menu pull-right\" role=menu><li><a ng-href={{project.base_url}} target=_blank>{{ 'masterProjects.list.saito_wo_miru' | translate }}</a></li><li><a ng-href=\"{{project.base_url}}?zc_dump=1\" target=_blank>{{ 'masterProjects.list.saito_wo_miru_kaiseki' | translate }}</a></li></ul></div></div></td></tr></tbody></table></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

var path = '/templates/master.projects/master_campaign_segment_detail.html';
var html = "<div class=content><div class=no-container><div class=master-header><h4>{{ 'masterProjects.masterCampaignSegmentDetail.listDeliveryConditionSettings' | translate }}</h4><table class=\"table table-bordered master-table\"><thead><tr><th>{{ 'masterProjects.masterCampaignSegmentDetail.kyanpeen_na' | translate }}</th><th>campaign_id</th><th>element_id</th></tr></thead><tbody><tr><td>{{currentCampaign.name}}</td><td>{{currentCampaign.id}}</td><td>{{currentCampaign.elements[0].id}}</td></tr></tbody></table></div><div class=master-header><table class=\"table table-bordered master-table\"><thead><tr><th>{{ 'masterProjects.masterCampaignSegmentDetail.debaisu' | translate }}</th><th ng-if=::isOldCampaign()>{{ 'masterProjects.masterCampaignSegmentDetail.segumento' | translate }}</th><th ng-if=::isOldCampaign()>{{ 'masterProjects.masterCampaignSegmentDetail.haishin_intaabaru' | translate }}</th><th ng-if=::isOldCampaign()>{{ 'masterProjects.masterCampaignSegmentDetail.roguin_hantei' | translate }}</th><th>{{ 'masterProjects.masterCampaignSegmentDetail.kuriaransu_haishin' | translate }}</th></tr></thead><tbody><tr><td>{{currentCampaign.campaign_device}}</td><td ng-if=::isOldCampaign()>{{currentCampaign.campaign_target}}</td><td ng-if=::isOldCampaign()>{{currentCampaign.days_since_last_received}}</td><td ng-if=::isOldCampaign()><span class=\"label label-warning\" ng-if=currentCampaign.exclude_logged_in>ON</span> <span class=\"label label-default\" ng-if=!currentCampaign.exclude_logged_in>OFF</span></td><td>{{currentCampaign.clearance_item_set_id}}</td></tr></tbody></table></div><div class=master-header><h4>{{ 'masterProjects.masterCampaignSegmentDetail.shousai_segumento' | translate }}: {{currentCampaign.segment.name}}</h4><segment-condition-table segments=currentCampaign.segment multiple=false></segment-condition-table></div><div class=master-header><h4>{{ 'masterProjects.masterCampaignSegmentDetail.taimingu' | translate }}: {{currentCampaign.campaign_policy_set.name}}</h4><div ng-if=\"currentCampaign.campaign_policy_set.name === 'zcs_timing_ai'\"><div class=row><div class=\"col-sm-8 col-sm-offset-4\">{{ 'masterProjects.masterCampaignSegmentDetail.sumaatorandamuchuuningu' | translate }} (default 1)</div></div><div class=row><div class=\"col-sm-4 col-sm-offset-4\"><input type=number step=0.1 class=\"form-control text-right\" ng-model=currentProject.smart_random_tuning_multiplier></div><div class=col-sm-2><button class=\"btn btn-default\" ng-click=tuneSmartRandom()>{{ 'masterProjects.masterCampaignSegmentDetail.koushin' | translate }}</button></div></div><br></div><segment-condition-table segments=currentCampaign.campaign_policy_set.campaign_policies multiple=true></segment-condition-table></div><br><div class=master-header><h4 class=text-danger>{{ 'masterProjects.masterCampaignSegmentDetail.seisei_sareta_haishin' | translate }}</h4><segment-condition-table segments=currentCampaign.public_api_json multiple=true></segment-condition-table></div><br><div class=master-header><h4 class=text-danger>{{ 'masterProjects.masterCampaignSegmentDetail.segumento_settei_to' | translate }}</h4><zc-segment-estimated-visitors project=currentProject segment=currentCampaign.segment timing-segment=currentCampaign.campaign_policy_set.campaign_policies session-only=true time-delta-hour=3></zc-segment-estimated-visitors></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

var path = '/templates/master.projects/master_projects_policies.html';
var html = "<div class=content><div class=row><div class=col-sm-4><select class=form-control ng-model=currentPolicySetId ng-options=\"set.id as set.name for set in campaignPolicySets\" ng-change=goto()></select></div></div><div class=row><div class=\"col-sm-12 text-center\">{{ 'masterProjects.masterProjectsPolicies.confirmDeliveryConditions' | translate }}: {{currentPolicySet.name}} ({{currentPolicySet.id}})</div></div><div class=row><table class=\"table master-table\" ng-if=currentPolicySet><thead><tr><td ng-repeat=\"header in headers\">{{header}}</td></tr></thead><tbody><tr ng-repeat=\"policy in currentPolicySet.campaign_policies\"><td ng-repeat=\"header in headers\">{{policy[header]}}</td></tr></tbody></table></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

var path = '/templates/master.projects/new.html';
var html = "<section id=generateProject><div class=\"container text-center\"><h1 class=config-title>{{ 'masterProjects.new.addSite' | translate }}</h1><div class=row><div class=\"col-md-10 col-md-offset-1\"><form name=projectNew class=form-horizontal ng-submit=save(project)><div class=form-group><label for=base_url class=\"col-sm-3 control-label\">{{ 'masterProjects.new.toppupeeji' | translate }}</label><div class=col-sm-9><input type=url class=form-control id=base_url name=base_url placeholder=\"https://www.appier.com/\" ng-model=project.base_url ng-blur=updateApikey() required><div class=config-description>{{ 'masterProjects.new.saitoniakusesushita_toki_no' | translate }}</div><div ng-if=\"existingProjects.length > 0\" class=\"alert alert-warning\" role=alert>{{ 'masterProjects.new.existingProject' | translate }}<p ng-repeat=\"existingProject in existingProjects\"><a ui-sref=\"admin.projects.settings.basic({projectId: existingProject.id})\" class=text-dark><i class=\"fa fa-arrow-right\"></i> {{ existingProject.title }} (apikey: {{ existingProject.apikey }}) - {{ existingProject.base_url }}</a></p></div></div></div><div class=form-group><label for=apikey class=\"col-sm-3 control-label\">APIKEY</label><div class=col-sm-6><input type=text class=form-control id=apikey name=apikey ng-model=project.apikey ng-change=\"project.slack_channel_name = project.sales_entity !== 'appier_jp' ? null : project.apikey\" placeholder=aideal disabled required></div></div><div class=form-group><label for=direct-selling class=\"col-sm-3 control-label\">{{ 'masterProjects.new.chokuhan_saito' | translate }}</label><div class=col-sm-9><input id=direct-selling type=checkbox ng-true-value=\"{{ directSellingAgencyId }}\" ng-false-value=null ng-model=project.agency_id></div></div><div class=form-group><label for=agency class=\"col-sm-3 control-label\">{{ 'masterProjects.new.dairiten' | translate }}</label><div class=col-sm-9><select class=form-control id=agency ng-model=project.agency_id ng-options=\"agency.id as (agency.name + ' - ' + agency.title) for agency in agencies\" required></select></div></div><div class=form-group><label for=selectService class=\"col-sm-3 control-label\">{{ 'masterProjects.new.saabisu_wo_sentaku' | translate }}</label><div class=col-sm-9><label class=radio-inline ng-repeat=\"productLine in productLines\"><input type=radio ng-model=project.product_line ng-value=productLine.name> {{productLine.label}}</label></div></div><div class=form-group><label for=pricingType class=\"col-sm-3 control-label\">{{ 'masterProjects.new.pricingType' | translate }}</label><div class=col-sm-9><label class=radio-inline ng-repeat=\"pricingType in pricingTypes\" ng-if=\"(pricingType.name == 'tiered' && project.product_line == 'zenclerk') || pricingType.name != 'tiered'\"><input type=radio name=pricingType ng-model=project.pricing_type ng-value=pricingType.name> {{pricingType.label}}</label></div></div><div class=form-group><label class=\"col-sm-3 control-label\">{{ 'masterProjects.new.haishin_houhou' | translate }}</label><div class=col-sm-9><label class=radio-inline><input type=radio ng-model=control_percent ng-value=null> {{ 'masterProjects.new.abTest' | translate }}</label> <label class=radio-inline><input type=radio ng-model=control_percent ng-value=0> {{ 'masterProjects.new.allDelivery' | translate }}</label></div></div><div class=form-group><label for=currency class=\"col-sm-3 control-label\">{{ 'masterProjects.new.tsuukatani' | translate }}</label><div class=col-sm-2><select class=form-control id=currency ng-model=project.currency ng-options=\"item.name as item.label | uppercase for item in currencies\" required></select></div></div><div class=form-group><label for=invoice_currency class=\"col-sm-3 control-label\">{{ 'masterProjects.new.invoice_currency' | translate }}</label><div class=col-sm-2><select class=form-control id=invoice_currency ng-model=project.invoice_currency ng-options=\"item | uppercase for item in invoiceCurrencies\" required></select></div></div><div class=form-group><label for=multiple_currencies class=\"col-sm-3 control-label\">{{ 'masterProjects.new.multiple_currencies' | translate }}</label><div class=col-md-6><input id=multiple_currencies type=checkbox class=form-check-input ng-model=project.enable_multiple_currencies></div></div><div class=form-group><label for=region class=\"col-sm-3 control-label\">{{ 'masterProjects.new.chiiki' | translate }}</label><div class=col-sm-2><select class=form-control id=region ng-model=project.region ng-options=\"item.name as item.name | gmtNotation for item in regions\" required></select></div></div><div class=form-group><label for=sales_entity class=\"col-sm-3 control-label\">{{ 'masterProjects.new.salesEntity' | translate }}</label><div class=col-sm-6><select class=form-control id=sales_entity ng-model=project.sales_entity ng-options=\"item.name as item.label for item in salesEntities\" required></select><div class=config-description>{{ 'masterProjects.new.salesEntityNotice' | translate }}</div></div></div><div class=form-group><label for=company_name class=\"col-sm-3 control-label\">{{ 'masterProjects.new.uneigaisha_na' | translate }}</label><div class=col-sm-6><input type=text id=company_name name=company_name class=form-control placeholder=\"Appier Japan, Inc.\" ng-model=project.company_name required></div></div><div class=form-group><label for=title class=\"col-sm-3 control-label\">{{ 'masterProjects.new.saito_na' | translate }}</label><div class=col-sm-6><input type=text class=form-control id=title name=title placeholder=\"AiDeal Online Store\" ng-model=project.title required></div></div><div class=form-group><label for=slack_channel_name class=\"col-sm-3 control-label\">{{ 'masterProjects.new.slackChannel' | translate }}</label><div class=col-sm-6><input type=text class=form-control id=slack_channel_name name=slack_channel_name maxlength=\"{{ maximumApikeyLength }}\" ng-model=project.slack_channel_name placeholder=aideal ng-required=\"project.sales_entity === 'appier_jp'\"><div class=config-description>{{ 'masterProjects.new.channeru_na_no' | translate }}</div></div></div><div class=form-group><label for=enable-app class=\"col-sm-3 control-label\">{{ 'masterProjects.new.enableApp' | translate }}</label><div class=col-sm-9><input class=checkbox-inline id=enable-app type=checkbox ng-model=project.enable_app></div></div><div class=config-lead>{{ 'masterProjects.new.kaki_no_botan' | translate }}<br><span class=text-danger>{{ 'masterProjects.new.ni_eigyou_kanri' | translate }}</span><br>{{ 'masterProjects.new.yoroshiidesuka' | translate }}<br></div><button type=submit class=\"btn btn-config\" translate=masterProjects.new.registerProject translate-value-icon=\"<i class='fa fa-github-alt'></i>\"></button></form></div></div></div></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

var path = '/templates/master.reports/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1 translate=masterReports.list.currentReportList translate-value-period=\"{{ currentPeriod | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}\"></h1></div><div class=col-md-9><report-download-button current-period=currentPeriod projects=filteredProjects></report-download-button><div class=\"btn-group pull-right\" style=\"margin-right: 5px;\"><button class=\"btn btn-default\" ng-click=prevMonth()>{{ 'masterReports.list.zengetsu_fun_hyouji' | translate }}</button> <button class=\"btn btn-default\" ng-disabled=isTailPeriod ng-click=nextMonth()>{{ 'masterReports.list.tsugi_tsuki_fun' | translate }}</button></div></div></div></div><div class=master-search><div class=master-search-header ng-click=\"table = !table\"><i class=\"fa fa-bars\"></i> {{ 'masterReports.list.deeta_shiborikomi' | translate }}</div><div class=master-search-body ng-show=table><div class=row><div class=col-sm-3><h1>{{ 'masterReports.list.saabisu' | translate }}</h1><select class=form-control ng-model=filters.product_line><option value=all>{{ 'masterReports.list.shiborikomi_nashi' | translate }}</option><option value=zenclerk>{{ 'masterReports.list.tsuujou_kakin' | translate }}</option><option value=zenclerk_lp>{{ 'masterReports.list.zcLpkakin' | translate }}</option><option value=zenclerk_s>lite</option></select></div><div class=col-sm-3><h1>{{ 'masterReports.list.suteetasu' | translate }}</h1><select class=form-control ng-model=filters.contract_status ng-options=\"key as val for (key, val) in project_status\"></select></div><div class=col-sm-2><h1>{{ 'masterReports.list.kiiwaado_shiborikomi' | translate }}</h1><div class=master-search-box><input type=text class=form-control ng-model=filters.search_term ng-model-options=\"{debounce: { 'default': 500, 'blur': 0}}\" ng-change=filterProjects() placeholder=\"{{ 'masterReports.list.kiiwaadokensaku' | translate }}\"> <i class=\"fa fa-times-circle\" ng-click=resetSearchTerm() ng-if=filters.search_term></i></div></div></div><div class=master-search-footer><button class=\"btn btn-primary master-search-button\" ng-click=updateData()>{{ 'masterReports.list.koushin' | translate }}</button> <button class=\"btn btn-default master-search-button\" ng-click=resetData()>{{ 'masterReports.list.risetto' | translate }}</button></div></div></div></div><div class=full-width-container><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed master-table\"><thead><tr><td class=sortable ng-click=\"setSortProp('title')\">Title</td><td class=sortable ng-click=\"setSortProp('apikey')\">Apikey</td><td class=sortable ng-click=\"setSortProp('product_line')\">{{ 'masterReports.list.saabisu' | translate }}</td><td class=sortable ng-click=\"setSortProp('contracted_at')\">{{ 'masterReports.list.suteetasu' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.access_conversion_price')\">{{ 'masterReports.list.gesshou_ryuutsuu' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.contribution_count')\">{{ 'masterReports.list.kakutoku' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.contribution_price')\">{{ 'masterReports.list.kakutoku_uriage' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.invoice_amount')\">{{ 'masterReports.list.seikyuu_kingaku' | translate }}</td><td class=sortable ng-click=\"setSortProp('day_before_invoice_amount_difference')\" ng-if=isUnfinishedPeriod>{{ 'masterReports.list.zenjitsu_kara_no' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.budget')\">{{ 'masterReports.list.yosanjou_kiri_kingaku' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.invoice_amount_rate')\">{{ 'masterReports.list.seikyuu_kingaku_gesshou' | translate }}</td><td class=sortable ng-click=\"setSortProp('project_rank_number')\">{{ 'masterReports.list.kibo' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.goal_percentage')\">{{ 'masterReports.list.mokuhyoutassei_ritsu' | translate }}</td><td class=sortable ng-click=\"setSortProp('report.campaign_ids.length')\">{{ 'masterReports.list.campaignCount' | translate }}</td></tr></thead><tbody><tr ng-repeat=\"project in filteredProjects\"><td><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\">{{project.title}}</a></td><td>{{project.apikey}}</td><td><zc-product-line-label project=project></zc-product-line-label></td><td><zc-label-project-status project=project range=range></zc-label-project-status></td><td class=text-right><span ng-if=project.report>{{project.report.access_conversion_price | number:0}}</span></td><td class=text-right><span ng-if=project.report>{{project.report.contribution_count | number:0}}</span></td><td class=text-right><span ng-if=project.report>{{project.currencyObj.symbol}}{{project.report.contribution_price | number:0}}{{project.currencyObj.suffix}}</span></td><td class=text-right><div ng-if=project.report><span class=\"label label-warning\" ng-if=\"project.trial.invoice_amount === project.report.invoice_amount\" tooltip=\"{{ 'masterReports.list.toraiaru_seikyuu_kingaku' | translate }}\">T</span> {{project.currencyObj.symbol}}{{project.report.invoice_amount | number:0}}{{project.currencyObj.suffix}}</div><div class=\"text small\" ng-if=\"project.trial && project.trial.invoice_amount !== project.report.invoice_amount\"><span class=\"label label-warning\" tooltip=\"{{ 'masterReports.list.toraiaru_seikyuu_kingaku' | translate }}\">T</span> ({{project.currencyObj.symbol}}{{project.trial.invoice_amount | number:0}}{{project.currencyObj.suffix}})</div><div class=\"text small\" ng-if=\"project.contracted && project.contracted.invoice_amount !== project.report.invoice_amount\" tooltip=\"{{ 'masterReports.list.moto_kakin_taishou' | translate }}\"><span class=\"label label-success\" tooltip=\"{{ 'masterReports.list.moto_kakin_taishou' | translate }}\">本</span> ({{project.currencyObj.symbol}}{{project.contracted.invoice_amount | number:0}}{{project.currencyObj.suffix}})</div></td><td class=text-right ng-if=isUnfinishedPeriod><span class=\"pull-left label label-danger\" ng-show=\"project.day_before_invoice_amount_difference < 0\">!</span> <span ng-if=project.day_before_report>{{project.currencyObj.symbol}}{{project.day_before_invoice_amount_difference | number:0}}{{project.currencyObj.suffix}}</span></td><td class=text-right><span ng-if=\"project.report && project.report.budget\">{{project.currencyObj.symbol}}{{project.report.budget | number:0}}{{project.currencyObj.suffix}}</span></td><td class=text-right><span ng-if=project.report>{{project.report.invoice_amount_rate*100 | number:2}}%</span></td><td><span ng-if=\"project.project_rank != 'unknown'\">{{MasterProject.projectRanks[project.project_rank].name}} ({{MasterProject.projectRanks[project.project_rank].goal*100 | number:2}}%)</span></td><td class=text-right><span ng-if=\"project.report && project.project_rank != 'unknown'\" class=\"label label-default\" ng-class=\"{'label-danger': project.report.goal_percentage < 25, 'label-info': project.report.goal_percentage > 75 && project.report.goal_percentage < 100, 'label-success': project.report.goal_percentage >= 100}\">{{project.report.goal_percentage | number: 1}}%</span></td><td><span ng-if=project.report>{{project.report.campaign_ids.length}}</span></td></tr></tbody></table></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

var path = '/templates/master.segments/segment_estimated_visitors.html';
var html = "<div class=segment-visitors><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ 'masterSegments.segmentEstimatedVisitors.soutei_segumento_kibo' | translate }}<div class=\"btn-group pull-right\" ng-if=!sessionOnly><div class=\"btn btn-xs btn-default\" ng-class=\"{'active': mode == 'sessions'}\" ng-click=\"switchMode('sessions')\">{{ 'masterSegments.segmentEstimatedVisitors.namadeeta' | translate }}</div><div class=\"btn btn-xs btn-default\" tooltip ng-class=\"{'active': mode == 'access_stats'}\" ng-click=\"switchMode('access_stats')\">{{ 'masterSegments.segmentEstimatedVisitors.shuukei' | translate }}</div></div></h3></div><div class=\"panel-body segment-progress\"><div ng-hide=\"mode == 'access_stats' && matchedSessionCount == 0\"><div class=segment_session_number>{{matchedSessionCount | number:0}} <span class=unit>{{ 'masterSegments.segmentEstimatedVisitors.session' | translate }}</span></div><progressbar value=matchedPercentage type=info>{{matchedPercentage | number:1}}%</progressbar><div translate=masterSegments.segmentEstimatedVisitors.allSessionCount translate-value-count=\"{{totalSessionCount | number:0}}\" class=\"all_session_number text-muted\"></div></div><div ng-show=\"mode == 'access_stats' && matchedSessionCount == 0\">{{ 'masterSegments.segmentEstimatedVisitors.deeta_ga_arimasensegumento' | translate }}<div class=\"all_session_number text-muted\" translate=masterSegments.segmentEstimatedVisitors.allSessionCount translate-value-count=\"{{totalSessionCount | number:0}}\"></div></div><br><div class=\"device-selector text-muted\">{{ 'masterSegments.segmentEstimatedVisitors.debaisu_shitei' | translate }}<select class=form-control style=\"width: 150px\" ng-model=filters.device ng-options=\"opt as opt.name for opt in devices\"></select></div></div><div class=\"panel-footer text-muted\">{{ 'masterSegments.segmentEstimatedVisitors.jouki_atai_wa' | translate }}<div ng-if=\"mode == 'sessions'\"><div class=text-small>{{ 'masterSegments.segmentEstimatedVisitors.sesshonnosanpuru_kikan' | translate }}:{{sessions[sessions.length-1].opened_at | zcDate}} ~ {{sessions[0].opened_at | zcDate}}</div></div><div ng-if=\"mode == 'access_stats'\" ng-hide=\"mode == 'access_stats' && matchedSessionCount == 0\"><ng-container translate=masterSegments.segmentEstimatedVisitors.saigo_no_ichinichi translate-value-date=\"<span class='text-small'>({{accessStatsStart | zcDate}} ~ {{accessStatsEnd | zcDate}})</span>\"></ng-container><br><div class=\"zc-red1-fg text-small\" ng-if=isRecentlyUpdated(segment)>{{ 'masterSegments.segmentEstimatedVisitors.shuukei_deeta_ga' | translate }}<br>{{ 'masterSegments.segmentEstimatedVisitors.saishin_henkou_hizuke' | translate }}: {{segment.updated_at | zcDate}}</div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

var path = '/templates/master.users/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterUsers.list.usersList' | translate }}</h1></div><div class=col-md-6><div class=btn-group><button class=\"btn btn-default\" ng-model=filters.visible_group value=settings ng-class=\"{'active': filters.visible_group == 'settings'}\" ng-click=\"setVisibleGroup('settings')\">{{ 'masterUsers.list.kihonjouhou_ichiran' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=business ng-class=\"{'active': filters.visible_group == 'business'}\" ng-click=\"setVisibleGroup('business')\">{{ 'masterUsers.list.shozoku_jouhou' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=stats ng-class=\"{'active': filters.visible_group == 'stats'}\" ng-click=\"setVisibleGroup('stats')\">{{ 'masterUsers.list.akusesujouhou' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=makerepeater ng-class=\"{'active': filters.visible_group == 'makerepeater'}\" ng-click=\"setVisibleGroup('makerepeater')\">MakeRepeater</button></div></div></div></div><div class=master-search><div class=master-search-header ng-click=\"table = !table\"><i class=\"fa fa-bars\"></i> {{ 'masterUsers.list.deeta_shiborikomi' | translate }}</div><div class=master-search-body ng-show=table><div class=row><div class=col-sm-2><h1>{{ 'masterUsers.list.kiiwaado_shiborikomi' | translate }}</h1><div class=master-search-box><input type=text class=form-control ng-model=filters.search_term> <i class=\"fa fa-times-circle\" ng-click=resetSearchTerm() ng-if=filters.search_term></i></div></div></div><div class=master-search-footer><button class=\"btn btn-primary master-search-button\" ng-click=updateData()>{{ 'masterUsers.list.koushin' | translate }}</button></div></div></div><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><td class=sortable ng-click=\"setSortProp('id')\">id</td><td class=sortable ng-click=\"setSortProp('full_name')\">{{ 'masterUsers.list.shimei' | translate }}</td><td class=sortable ng-click=\"setSortProp('email')\" ng-show=\"filters.visible_group == 'settings'\">Email</td><td class=sortable ng-click=\"setSortProp('role')\">Role</td><td class=sortable ng-click=\"setSortProp('agency_id')\" ng-show=\"filters.visible_group == 'business'\">{{ 'masterUsers.list.dairiten' | translate }}</td><td class=sortable ng-click=\"setSortProp('makerepeater_user_id')\" ng-show=\"filters.visible_group == 'makerepeater'\">MakeRepeater ID</td><td class=sortable ng-click=\"setSortProp('makerepeater_is_admin')\" ng-show=\"filters.visible_group == 'makerepeater'\">{{ 'masterUsers.list.kengen' | translate }}</td><td class=sortable ng-click=\"setSortProp('sign_in_count')\" ng-show=\"filters.visible_group == 'stats'\">Sign in count</td><td class=sortable ng-click=\"setSortProp('current_sign_in_at')\" ng-show=\"filters.visible_group == 'stats'\">Current sign_in</td><td class=sortable ng-click=\"setSortProp('last_sign_in_at')\" ng-show=\"filters.visible_group == 'stats'\">Last sign_in</td><td class=sortable ng-click=\"setSortProp('department')\" ng-show=\"filters.visible_group == 'business'\">{{ 'masterUsers.list.busho_na' | translate }}</td><td class=sortable ng-click=\"setSortProp('position')\" ng-show=\"filters.visible_group == 'business'\">{{ 'masterUsers.list.yakushoku' | translate }}</td><td class=sortable ng-click=\"setSortProp('agreement_signed_at')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterUsers.list.riyoukiyaku_doui_nichiji' | translate }}</td><td ng-show=\"filters.visible_group == 'settings'\">{{ 'masterUsers.list.himotsuki_purojekuto' | translate }}</td><td ng-show=\"filters.visible_group == 'settings'\"></td></tr></thead><tbody><tr ng-repeat=\"user in filteredUsers\"><td>{{user.id}}</td><td>{{user.full_name}}<br><small ng-if=user.full_name_furigana>{{user.full_name_furigana}}</small></td><td ng-show=\"filters.visible_group == 'settings'\">{{user.email}}</td><td><zc-label-user-role user=user></zc-label-user-role></td><td ng-show=\"filters.visible_group == 'business'\"><zc-label-user-agency user=user></zc-label-user-agency></td><td ng-show=\"filters.visible_group == 'makerepeater'\">{{user.makerepeater_user_id}}</td><td ng-show=\"filters.visible_group == 'makerepeater'\"><span ng-if=\"user.makerepeater_user_id && user.makerepeater_is_admin\">{{ 'masterUsers.list.kanrisha' | translate }}</span> <span ng-if=\"user.makerepeater_user_id && !user.makerepeater_is_admin\">{{ 'masterUsers.list.ippan' | translate }}</span></td><td ng-show=\"filters.visible_group == 'stats'\">{{user.sign_in_count}}</td><td ng-show=\"filters.visible_group == 'stats'\">{{user.current_sign_in_at | date: ('sharedModules.dateTimeFormats.datetime' | translate) }}<br><span style=\"font-size:small; color:gray\">({{user.current_sign_in_ip}})</span></td><td ng-show=\"filters.visible_group == 'stats'\">{{user.last_sign_in_at | date: ('sharedModules.dateTimeFormats.datetime' | translate) }}<br><span style=\"font-size:small; color:gray\">({{user.last_sign_in_ip}})</span></td><td ng-show=\"filters.visible_group == 'business'\">{{user.department}}</td><td ng-show=\"filters.visible_group == 'business'\">{{user.position}}</td><td ng-show=\"filters.visible_group == 'settings'\">{{user.agreement_signed_at | zcDate}}</td><td ng-show=\"filters.visible_group == 'settings'\"><b ng-show=\"user.projects.length > 1\">{{user.projects.length}} projects</b><ul><li ng-repeat=\"project in user.projects | limitTo:5\">{{project.title}}</li></ul><div ng-if=\"user.projects.length>5\"><a ng-click=\"openProject=!openProject\"><span ng-if=openProject><i class=\"fa fa-minus-square\"></i> {{ 'masterUsers.list.tojiru' | translate }}</span> <span ng-if=!openProject><i class=\"fa fa-plus-square\"></i> {{ 'masterUsers.list.motto_miru' | translate }}</span></a><ul ng-show=openProject><li ng-repeat=\"project in user.projects.slice(5, user.projects.length)\">{{project.title}}</li></ul></div></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=\"user.role !== 'master'\" class=\"btn btn-sm btn-default\" confirm-modal confirm-click=becomeUser(user.id)>{{ 'masterUsers.list.ko_no_yuuzaaninaru' | translate }}</div></td></tr></tbody></table></div><pagination class=pull-right total-items=filters.total_count items-per-page=filters.per_page ng-model=filters.page ng-change=filterUsers() ng-if=\"filters.total_count > filters.per_page\"></pagination></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

var path = '/templates/master.zclite_agency_invoices/list.html';
var html = "<div class=content><div class=\"container-fluid master-button-group\"><div class=row><div class=col-sm-6><h1 translate=masterZclite.agencyInvoices.list.currentMonthLiteAgencyList translate-value-date={{$ctrl.filters.current_month}}></h1></div><div class=col-sm-6><div class=\"btn-group pull-right\" style=\"margin-right: 5px;\"><button class=\"btn btn-default\" ng-click=$ctrl.prevMonth()>{{ 'masterZclite.agencyInvoices.list.zengetsu_fun_hyouji' | translate }}</button> <button class=\"btn btn-default\" ng-disabled=$ctrl.isViewingLatestMonth() ng-click=$ctrl.nextMonth()>{{ 'masterZclite.agencyInvoices.list.tsugi_tsuki_fun' | translate }}</button></div></div><div class=col-sm-12 style=\"margin-top: 1em;\"><table class=\"table table-responsive\"><thead><tr><td>#</td><td ng-click=\"$ctrl.setSortProp('title')\">{{ 'masterZclite.agencyInvoices.list.dairiten' | translate }}</td><td class=text-right>{{ 'masterZclite.agencyInvoices.list.seikyuu_saito_kazu' | translate }}</td><td class=text-right ng-click=\"$ctrl.setSortProp('currentMonthInvoice.sites.length')\">{{ 'masterZclite.agencyInvoices.list.touroku_saito_kazu' | translate }}</td><td class=text-right ng-click=\"$ctrl.setSortProp('currentMonthInvoice.invoice_price_tax_excluded')\">{{ 'masterZclite.agencyInvoices.list.seikyuu_kingaku_zeinuki' | translate }}</td><td class=text-right ng-click=\"$ctrl.setSortProp('currentMonthInvoice.invoice_price')\">{{ 'masterZclite.agencyInvoices.list.seikyuu_kingaku_zeikomi' | translate }}</td><td class=text-right ng-if=$ctrl.isViewingLatestMonth()>{{ 'masterZclite.agencyInvoices.list.yosoku_saishuu_seikyuu' | translate }}</td></tr></thead><tbody><tr ng-repeat=\"agency in $ctrl.agencies\"><td>{{$index + 1}}</td><td><a ng-if=$ctrl.isCreatedBeforeCurrentMonth(agency) ng-href=https://lite.zenclerk.com/agencies/{{agency.name}}/invoices/{{$ctrl.filters.current_month}}>{{agency.title}}</a> <span ng-if=!$ctrl.isCreatedBeforeCurrentMonth(agency)>{{agency.title}}</span></td><td class=text-right>{{$ctrl.getInvoiceSites(agency.currentMonthInvoice.sites).length | number: 0}}</td><td class=text-right>{{agency.currentMonthInvoice.sites.length | number: 0}}</td><td class=text-right>{{agency.currentMonthInvoice.invoice_price_tax_excluded | number: 0}}</td><td class=text-right>{{agency.currentMonthInvoice.invoice_price | number: 0}}円</td><td class=text-right ng-if=$ctrl.isViewingLatestMonth()>{{agency.currentMonthInvoice.projectedInvoicePrice | number: 0}}円</td></tr><tr><td>TOTAL</td><td></td><td class=text-right>{{$ctrl.totalInvoiceSites | number: 0}}</td><td class=text-right>{{$ctrl.totalSites | number: 0}}</td><td class=text-right>{{$ctrl.totalInvoicePriceTaxExcluded | number: 0}}円</td><td class=text-right>{{$ctrl.totalInvoicePrice | number: 0}}円</td><td class=text-right ng-if=$ctrl.isViewingLatestMonth()>{{$ctrl.projectedInvoicePrice | number: 0}}円</td></tr></tbody></table></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

var path = '/templates/master.zclite_invoices/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1 translate=masterZclite.invoices.list.currentLiteBillingList translate-value-period=\"{{ filters.current_period | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}\"></h1></div><div class=col-sm-4><h1>{{ 'masterZclite.invoices.list.seikyuu_kei_saitei' | translate }}: <span class=pull-right style=\"margin-right: 5px;\">{{totalInvoiceAmountTaxExcluded - totalMinimalAmount | number:0}}円</span><br>{{ 'masterZclite.invoices.list.seikyuu_kei_zeinuki' | translate }}: <span class=pull-right style=\"margin-right: 5px;\">{{totalInvoiceAmountTaxExcluded | number:0}}円</span><br>{{ 'masterZclite.invoices.list.seikyuu_kei_zeikomi' | translate }}: <span class=pull-right style=\"margin-right: 5px;\">{{totalInvoiceAmount | number:0}}円</span></h1><table class=\"table table-condensed\"><tr><th>{{ 'masterZclite.invoices.list.shoki_hiyou' | translate }}</th><td class=text-right>{{totalInitialAmount | number:0}}円</td></tr><tr><th>{{ 'masterZclite.invoices.list.saitei_riyouryoukin' | translate }}</th><td class=text-right>{{totalMinimalAmount | number:0}}円</td></tr><tr><th>{{ 'masterZclite.invoices.list.kotei_seikyuu' | translate }}</th><td class=text-right>{{totalFixedAmount | number:0}}円</td></tr><tr><th>{{ 'masterZclite.invoices.list.kyanpeen' | translate }}</th><td class=text-right>{{totalCampaignAmount | number:0}}円</td></tr></table></div><div class=col-md-5><button class=\"btn btn-default pull-right\" ng-csv=getCSV() csv-header=csvHeader add-bom=true charset=utf-16 field-separator=\\t filename=invoices.csv><i class=\"fa fa-download\"></i> {{ 'masterZclite.invoices.list.daunroodo' | translate }}</button><div class=\"btn-group pull-right\" style=\"margin-right: 5px;\"><button class=\"btn btn-default\" ng-click=prevMonth()>{{ 'masterZclite.invoices.list.zengetsu_fun_hyouji' | translate }}</button> <button class=\"btn btn-default\" ng-disabled=isTailPeriod ng-click=nextMonth()>{{ 'masterZclite.invoices.list.tsugi_tsuki_fun' | translate }}</button></div></div></div></div><div class=master-search><div class=master-search-header ng-click=\"table = !table\"><i class=\"fa fa-bars\"></i> {{ 'masterZclite.invoices.list.deeta_shiborikomi' | translate }}</div><div class=master-search-body ng-show=table><div class=row><div class=col-sm-3><h1>{{ 'masterZclite.invoices.list.shiborikomi' | translate }}</h1><select ng-model=filters.agency_name class=form-control ng-options=\"agency_names for agency_names in agency_names\"></select></div><div class=col-sm-2><h1>{{ 'masterZclite.invoices.list.kiiwaado_shiborikomi' | translate }}</h1><div class=master-search-box><input type=text class=form-control ng-model=filters.search_term ng-model-options=\"{debounce: { 'default': 500, 'blur': 0}}\" ng-change=filterProjects() placeholder=\"{{ 'masterZclite.invoices.list.kiiwaadokensaku' | translate }}\"> <i class=\"fa fa-times-circle\" ng-click=resetSearchTerm() ng-if=filters.search_term></i></div></div></div><div class=master-search-footer><button class=\"btn btn-primary master-search-button\" ng-click=updateData()>{{ 'masterZclite.invoices.list.koushin' | translate }}</button> <button class=\"btn btn-default master-search-button\" ng-click=resetData()>{{ 'masterZclite.invoices.list.risetto' | translate }}</button></div></div></div></div><div class=full-width-container><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed master-table\"><thead><tr><td class=sortable>#</td><td class=sortable ng-click=\"setSortProp('title')\" style=\"width: 250px\">Title</td><td class=sortable ng-click=\"setSortProp('apikey')\">Apikey</td><td class=sortable ng-click=\"setSortProp('contracted_at')\">Status</td><td class=sortable ng-click=\"setSortProp('agency_id')\">Agency</td><td>{{ 'masterZclite.invoices.list.shoki_hiyou' | translate }}</td><td>{{ 'masterZclite.invoices.list.saitei_riyouryou' | translate }}</td><td>{{ 'masterZclite.invoices.list.kotei' | translate }}</td><td>{{ 'masterZclite.invoices.list.haishin_hiyou' | translate }}</td><td>{{ 'masterZclite.invoices.list.jougen_kingaku' | translate }}</td><td class=sortable ng-click=\"setSortProp('invoice.invoice_price_tax_excluded')\">{{ 'masterZclite.invoices.list.seikyuu_kei_zeinuki' | translate }}</td></tr></thead><tbody><tr ng-repeat=\"project in filteredProjects\"><td>{{$index+1}}</td><td><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\">{{project.title}}</a> <a class=pull-right target=_blank ng-href=https://lite.zenclerk.com/sites/{{project.apikey}}><i class=\"fa fa-external-link\"></i> lite</a></td><td>{{project.apikey}}</td><td><zc-label-project-status project=project range=range></zc-label-project-status></td><td>{{project.agency.title}}</td><td class=text-right>{{getAdjustmentPrice(project.invoice.adjustments, 'initial') + getAdjustmentPrice(project.invoice.adjustments, 'initial_discount') | number:0}}円</td><td class=text-right>{{getAdjustmentPrice(project.invoice.adjustments, 'minimal') + getAdjustmentPrice(project.invoice.adjustments, 'minimal_discount') | number:0}}円 <span class=\"label label-danger\" ng-if=\"getAdjustmentPrice(project.invoice.adjustments, 'minimal') > 0\">{{ 'masterZclite.invoices.list.haishin_shitemasen' | translate }}</span></td><td class=text-right>{{getAdjustmentPrice(project.invoice.adjustments, 'fixed') | number:0}}円</td><td class=text-right>{{project.invoice.sum_details_invoice_price | number:0}}円</td><td class=text-right>{{project.invoice.max_invoice | number:0}}円</td><td class=text-right>{{project.invoice.invoice_price_tax_excluded | number:0}}円</td></tr></tbody></table></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

var path = '/templates/master.zclite_kpi/list.html';
var html = "<div id=master-zclite-kpi class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterZclite.kpi.list.liteKpiManagement' | translate }}</h1><h1>{{ 'masterZclite.kpi.list.kikan' | translate }}:{{current_period | date: ('sharedModules.dateTimeFormats.yearMonth' | translate)}}</h1><h1>{{ 'masterZclite.kpi.list.touroku_saito_kazu' | translate }}:{{total.current.projects.length | number: 0}}</h1><h1>{{ 'masterZclite.kpi.list.gesshou' | translate }}:{{total.current.project_performance.conversion_price | number:0}}円</h1><h1>{{ 'masterZclite.kpi.list.zcliteUriage' | translate }}:{{total.invoice_price_tax_excluded | number:0}}円</h1><h1>{{ 'masterZclite.kpi.list.takeRate' | translate }}:{{total.take_rate * 100 | number:2}}%</h1><h1>{{ 'masterZclite.kpi.list.keizoku_ritsu' | translate }}:{{total.retention_rate * 100 | number:2}}%</h1><div class=btn-group><button class=\"btn btn-default\" ng-click=prevMonth()>{{ 'masterZclite.kpi.list.zengetsu_fun_hyouji' | translate }}</button> <button class=\"btn btn-default\" ng-disabled=is_tail_period ng-click=nextMonth()>{{ 'masterZclite.kpi.list.yokugetsu_fun_hyouji' | translate }}</button></div><button class=\"btn btn-default\" ng-csv=getCSV() add-bom=true charset=utf-16 field-separator=\\t filename={{filename}}><i class=\"fa fa-cloud-download\"></i> {{ 'masterZclite.kpi.list.keishiki_de_daunroodo' | translate }}</button></div><div class=\"col-sm-3 installation-completion-rates\"><project-link-tooltip current-projects=total.current.registered_projects previous-projects=[] placement=bottom><a style=\"padding-left: 5px;\">{{ 'masterZclite.kpi.list.shinki_touroku_saito' | translate }}:{{total.current.registered_projects.length | number: 0}}</a></project-link-tooltip><span class=pull-right style=margin-right:5px positive-or-negative value=\"total.diff['registered_projects.length']\" shows-zero=false ng-click=\"setSortProp('current.registered_projects.length')\"></span><br><project-link-tooltip current-projects=total.current.registered_projects previous-projects=[] placement=bottom><a style=\"padding-left: 5px;\">{{ 'masterZclite.kpi.list.shinki_touroku_saito_current' | translate }}:{{total.current.corrected_registered_projects_count | number: 0}}</a></project-link-tooltip><span class=pull-right style=margin-right:5px positive-or-negative value=\"total.diff['corrected_registered_projects_count']\" shows-zero=false ng-click=\"setSortProp('current.corrected_registered_projects_count')\"></span><br><table class=\"table table-condensed\"><tr ng-click=\"setSortProp('current.installation_completion_rates.siteinfo_confirmed')\"><th>{{ 'masterZclite.kpi.list.saito_jouhou_nyuuryoku' | translate }}</th><td class=text-right>{{total.current.installation_completion_rates.siteinfo_confirmed * 100 | number:0}}% <span positive-or-negative value=\"total.diff['installation_completion_rates.siteinfo_confirmed']\" type=percentage shows-zero=false></span></td></tr><tr ng-click=\"setSortProp('current.installation_completion_rates.conversion_tag_confirmed')\"><th>{{ 'masterZclite.kpi.list.tagu_setchi_tassei' | translate }}</th><td class=text-right>{{total.current.installation_completion_rates.conversion_tag_confirmed * 100 | number:0}}% <span positive-or-negative value=\"total.diff['installation_completion_rates.conversion_tag_confirmed']\" type=percentage shows-zero=false></span></td></tr><tr ng-click=\"setSortProp('current.installation_completion_rates.first_campaign_start')\"><th>{{ 'masterZclite.kpi.list.shokai_touroku_tassei' | translate }}</th><td class=text-right>{{total.current.installation_completion_rates.first_campaign_start * 100 | number:0}}% <span positive-or-negative value=\"total.diff['installation_completion_rates.first_campaign_start']\" type=percentage shows-zero=false></span></td></tr></table></div><div class=\"col-sm-3 campaign-delivery-rates\"><project-link-tooltip current-projects=total.current.campaign_started_projects previous-projects=total.previous.campaign_started_projects placement=bottom><a style=\"padding-left: 5px;\">{{ 'masterZclite.kpi.list.numberOfSitesCPDeliveryExperience' | translate }}:{{total.current.campaign_started_projects.length | number: 0}}</a></project-link-tooltip><span class=pull-right style=margin-right:5px positive-or-negative value=\"total.diff['campaign_started_projects']\" shows-zero=false ng-click=\"setSortProp('current.campaign_started_projects.length')\"></span><br><project-link-tooltip current-projects=total.current.campaign_setting_projects previous-projects=total.previous.campaign_setting_projects placement=bottom><a style=\"padding-left: 5px;\">{{ 'masterZclite.kpi.list.haishin_settei_saito' | translate }}:{{total.current.campaign_setting_projects.length | number: 0}}</a></project-link-tooltip><span class=pull-right style=margin-right:5px positive-or-negative value=\"total.diff['campaign_setting_projects']\" shows-zero=false ng-click=\"setSortProp('current.campaign_setting_projects.length')\"></span><br><table class=\"table table-condensed\"><tr ng-click=\"setSortProp('current.campaign_delivery_rates.setting')\"><th><span tooltip=\"{{ 'masterZclite.kpi.list.campaignDeliveryRatesTooltip' | translate }}\">{{ 'masterZclite.kpi.list.haishin_settei_no' | translate }}</span></th><td class=text-right>{{total.current.campaign_delivery_rates.setting * 100 | number:0}}% <span positive-or-negative value=\"total.diff['campaign_delivery_rates.setting']\" type=percentage shows-zero=false></span></td></tr><tr ng-click=\"setSortProp('current.campaign_delivery_rates.term')\"><th><span tooltip=\"{{ 'masterZclite.kpi.list.campaignDeliveryRatesTermsTooltip' | translate }}\">CP{{ 'masterZclite.kpi.list.haishin_nissuu_no' | translate }}</span></th><td class=text-right>{{total.current.campaign_delivery_rates.term * 100 | number:0}}% <span positive-or-negative value=\"total.diff['campaign_delivery_rates.term']\" type=percentage shows-zero=false></span></td></tr></table></div><div class=\"col-md-3 campaign-performance\"><project-link-tooltip current-projects=total.current.campaign_current_projects previous-projects=total.previous.campaign_current_projects placement=bottom><a style=\"padding-left: 5px;\">{{ 'masterZclite.kpi.list.tougetsu_haishin_saito' | translate }}：{{total.current.campaign_current_projects.length | number: 0}}</a></project-link-tooltip><span class=pull-right style=margin-right:5px positive-or-negative value=\"total.diff['campaign_current_projects']\" shows-zero=false ng-click=\"setSortProp('current.campaign_current_projects.length')\"></span><br><br><table class=\"table table-condensed\"><tr ng-click=\"setSortProp('current.campaign_performance.session_cover_rate')\"><th>{{ 'masterZclite.kpi.list.haishin_kabaa_ritsu' | translate }}</th><td class=text-right>{{total.current.campaign_performance.session_cover_rate * 100 | number:0}}% <span positive-or-negative value=\"total.diff['campaign_performance.session_cover_rate']\" type=percentage shows-zero=false></span></td></tr><tr ng-click=\"setSortProp('current.campaign_performance.conversion_cover_rate')\"><th>{{ 'masterZclite.kpi.list.conversionCoverRate' | translate }}</th><td class=text-right>{{total.current.campaign_performance.conversion_cover_rate * 100 | number:0}}% <span positive-or-negative value=\"total.diff['campaign_performance.conversion_cover_rate']\" type=percentage shows-zero=false></span></td></tr><tr ng-click=\"setSortProp('current.campaign_performance.conversion_up_rate')\"><th>{{ 'masterZclite.kpi.list.joushouritsu' | translate }}</th><td class=text-right>{{total.current.campaign_performance.conversion_up_rate * 100 | number:0}}% <span positive-or-negative value=\"total.diff['campaign_performance.conversion_up_rate']\" type=percentage shows-zero=false></span></td></tr><tr ng-click=\"setSortProp('current.campaign_performance.campaign_coupon_used_rate')\"><th><span tooltip=\"{{ 'masterZclite.kpi.list.kyanpeen_wo_uketotte' | translate }}\">{{ 'masterZclite.kpi.list.koodo_suitei_shiyouritsu' | translate }}</span></th><td class=text-right>{{total.current.campaign_performance.campaign_coupon_used_rate * 100 | number:0}}% <span positive-or-negative value=\"total.diff['campaign_performance.campaign_coupon_used_rate']\" type=percentage shows-zero=false></span></td></tr></table></div></div></div></div><div class=full-width-container><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table\"><thead><tr><th colspan=6 ng-click=\"setSortProp('current.projects.length')\">{{ 'masterZclite.kpi.list.zen_touroku_saito' | translate }}</th><th colspan=5 class=installation-completion-rates ng-click=\"setSortProp('current.campaign_started_projects.length')\">{{ 'masterZclite.kpi.list.shinki_touroku_saito' | translate }}</th><th colspan=4 class=campaign-delivery-rates ng-click=\"setSortProp('current.campaign_started_projects.length')\">{{ 'masterZclite.kpi.list.sitesCPDeliveryExperience' | translate }}</th><th colspan=5 class=campaign-performance ng-click=\"setSortProp('current.campaign_current_projects.length')\">{{ 'masterZclite.kpi.list.cpDeliverySites' | translate }}</th></tr><tr><th class=sortable ng-click=\"setSortProp('title')\">{{ 'masterZclite.kpi.list.dairiten' | translate }}</th><th class=sortable ng-click=\"setSortProp('current.projects.length')\">{{ 'masterZclite.kpi.list.saito_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('current.project_performance.conversion_price')\">{{ 'masterZclite.kpi.list.gesshou' | translate }}</th><th class=sortable ng-click=\"setSortProp('project_performance.invoice_price_tax_excluded')\">zclite<br>{{ 'masterZclite.kpi.list.uriage' | translate }}</th><th class=sortable ng-click=\"setSortProp('take_rate')\">Take<br>Rate</th><th class=sortable ng-click=\"setSortProp('retention_rate')\">{{ 'masterZclite.kpi.list.keizoku_ritsu' | translate }}</th><th class=\"sortable installation-completion-rates\" ng-click=\"setSortProp('current.registered_projects.length')\">{{ 'masterZclite.kpi.list.saito_kazu' | translate }}</th><th class=\"sortable installation-completion-rates\" ng-click=\"setSortProp('current.corrected_registered_projects_count')\">{{ 'masterZclite.kpi.list.saito_kazu' | translate }}<br>{{ 'masterZclite.kpi.list.endOfMonthAdjustment' | translate }}</th><th class=\"sortable installation-completion-rates\" ng-click=\"setSortProp('current.installation_completion_rates.siteinfo_confirmed')\">{{ 'masterZclite.kpi.list.siteInformation' | translate }}<br>{{ 'masterZclite.kpi.list.achievementRate' | translate }}</th><th class=\"sortable installation-completion-rates\" ng-click=\"setSortProp('current.installation_completion_rates.conversion_tag_confirmed')\">{{ 'masterZclite.kpi.list.tagSetting' | translate }}<br>{{ 'masterZclite.kpi.list.achievementRate' | translate }}</th><th class=\"sortable installation-completion-rates\" ng-click=\"setSortProp('current.installation_completion_rates.first_campaign_start')\">{{ 'masterZclite.kpi.list.cpInitialRegistration' | translate }}<br>{{ 'masterZclite.kpi.list.achievementRate' | translate }}</th><th class=\"sortable campaign-delivery-rates\" ng-click=\"setSortProp('current.campaign_started_projects.length')\">{{ 'masterZclite.kpi.list.saito_kazu' | translate }}</th><th class=\"sortable campaign-delivery-rates\" ng-click=\"setSortProp('current.campaign_setting_projects.length')\"><span tooltip=\"{{ 'masterZclite.kpi.list.campaignSettingProjectsTooltip' | translate }}\">{{ 'masterZclite.kpi.list.cpDeliverySetting' | translate }}<br>{{ 'masterZclite.kpi.list.siteList' | translate }}</span></th><th class=\"sortable campaign-delivery-rates\" ng-click=\"setSortProp('current.campaign_delivery_rates.setting')\"><span tooltip=\"{{ 'masterZclite.kpi.list.campaignDeliveryRatesTooltip' | translate }}\">{{ 'masterZclite.kpi.list.cpDeliverySetting' | translate }}<br>{{ 'masterZclite.kpi.list.percentageOf' | translate }}</span></th><th class=\"sortable campaign-delivery-rates\" ng-click=\"setSortProp('current.campaign_delivery_rates.term')\"><span tooltip=\"{{ 'masterZclite.kpi.list.campaignDeliveryRatesTermsTooltip' | translate }}\">{{ 'masterZclite.kpi.list.cpDeliveryDays' | translate }}<br>{{ 'masterZclite.kpi.list.percentageOf' | translate }}</span></th><th class=\"sortable campaign-performance\" ng-click=\"setSortProp('current.campaign_current_projects.length')\">{{ 'masterZclite.kpi.list.saito_kazu' | translate }}</th><th class=\"sortable campaign-performance\" ng-click=\"setSortProp('current.campaign_performance.session_cover_rate')\">{{ 'masterZclite.kpi.list.delivery' | translate }}<br>{{ 'masterZclite.kpi.list.coverRate' | translate }}</th><th class=\"sortable campaign-performance\" ng-click=\"setSortProp('current.campaign_performance.conversion_cover_rate')\">CV<br>{{ 'masterZclite.kpi.list.coverRate' | translate }}</th><th class=\"sortable campaign-performance\" ng-click=\"setSortProp('current.campaign_performance.conversion_up_rate')\">CV<br>{{ 'masterZclite.kpi.list.joushouritsu' | translate }}</th><th class=\"sortable campaign-performance\" ng-click=\"setSortProp('current.campaign_performance.campaign_coupon_used_rate')\"><span tooltip=\"{{ 'masterZclite.kpi.list.kyanpeen_wo_uketotte' | translate }}\">{{ 'masterZclite.kpi.list.codeEstimation' | translate }}<br>{{ 'masterZclite.kpi.list.useRate' | translate }}</span></th></tr></thead><tbody><tr ng-repeat=\"agency in agencies\"><td><a target=_blank ng-href=https://lite.zenclerk.com/agencies/{{agency.current.name}}>{{agency.title}}</a></td><td>{{agency.current.projects.length | number: 0}}</td><td class=text-right><span ng-hide=\"agency.current.project_performance.conversion_price == null\">{{agency.current.project_performance.conversion_price | number:0}}円</span></td><td class=text-right><span ng-hide=\"agency.invoice_price_tax_excluded == null\">{{agency.invoice_price_tax_excluded | number:0}}円</span></td><td class=text-right><span ng-hide=\"agency.take_rate == null\">{{agency.take_rate * 100 | number:2}}%</span></td><td class=text-right><span ng-hide=\"agency.retention_rate == null\">{{agency.retention_rate * 100 | number:2}}%</span></td><td><project-link-tooltip current-projects=agency.current.registered_projects previous-projects=[] placement=right>{{agency.current.registered_projects.length | number: 0}}</project-link-tooltip><span positive-or-negative value=\"agency.diff['registered_projects']\" shows-zero=false></span></td><td>{{agency.current.corrected_registered_projects_count | number : 0}} <span positive-or-negative value=\"agency.diff['corrected_registered_projects_count']\" shows-zero=false></span></td><td><span ng-hide=\"agency.current.installation_completion_rates.siteinfo_confirmed == null\">{{agency.current.installation_completion_rates.siteinfo_confirmed * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['installation_completion_rates.siteinfo_confirmed']\" type=percentage shows-zero=false></span></span></td><td><span ng-hide=\"agency.current.installation_completion_rates.conversion_tag_confirmed == null\">{{agency.current.installation_completion_rates.conversion_tag_confirmed * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['installation_completion_rates.conversion_tag_confirmed']\" type=percentage shows-zero=false></span></span></td><td><span ng-hide=\"agency.current.installation_completion_rates.first_campaign_start == null\">{{agency.current.installation_completion_rates.first_campaign_start * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['installation_completion_rates.first_campaign_start']\" type=percentage shows-zero=false></span></span></td><td><project-link-tooltip current-projects=agency.current.campaign_started_projects previous-projects=agency.previous.campaign_started_projects placement=right>{{agency.current.campaign_started_projects.length | number: 0}}</project-link-tooltip><span positive-or-negative value=\"agency.diff['campaign_started_projects']\" shows-zero=false></span></td><td><project-link-tooltip current-projects=agency.current.campaign_setting_projects previous-projects=agency.previous.campaign_setting_projects placement=right>{{agency.current.campaign_setting_projects.length | number: 0}}</project-link-tooltip><span positive-or-negative value=\"agency.diff['campaign_setting_projects']\" shows-zero=false></span></td><td><span ng-hide=\"agency.current.campaign_delivery_rates.setting == null\">{{agency.current.campaign_delivery_rates.setting * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['campaign_delivery_rates.setting']\" type=percentage shows-zero=false></span></span></td><td><span ng-hide=\"agency.current.campaign_delivery_rates.term == null\">{{agency.current.campaign_delivery_rates.term * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['campaign_delivery_rates.term']\" type=percentage shows-zero=false></span></span></td><td><project-link-tooltip current-projects=agency.current.campaign_current_projects previous-projects=agency.previous.campaign_current_projects placement=right>{{agency.current.campaign_current_projects.length | number: 0}}</project-link-tooltip><span positive-or-negative value=\"agency.diff['campaign_current_projects']\" shows-zero=false></span></td><td><span ng-hide=\"agency.current.campaign_performance.session_cover_rate == null\">{{agency.current.campaign_performance.session_cover_rate * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['campaign_performance.session_cover_rate']\" type=percentage shows-zero=false></span></span></td><td><span ng-hide=\"agency.current.campaign_performance.conversion_cover_rate == null\">{{agency.current.campaign_performance.conversion_cover_rate * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['campaign_performance.conversion_cover_rate']\" type=percentage shows-zero=false></span></span></td><td><span ng-hide=\"agency.current.campaign_performance.conversion_up_rate == 0\">{{agency.current.campaign_performance.conversion_up_rate * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['campaign_performance.conversion_up_rate']\" type=percentage ng-if=agency.previous.campaign_performance.conversion_up_rate shows-zero=false></span></span></td><td><span ng-hide=\"agency.current.campaign_performance.campaign_coupon_used_rate == 0\">{{agency.current.campaign_performance.campaign_coupon_used_rate * 100 | number:0}}% <span positive-or-negative value=\"agency.diff['campaign_performance.campaign_coupon_used_rate']\" type=percentage ng-if=agency.previous.campaign_performance.campaign_coupon_used_rate shows-zero=false></span></span></td></tr></tbody></table></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

var path = '/templates/master.zclite_projects/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterZclite.projects.list.purojekuto_ichiran' | translate }}</h1></div><div class=col-md-9><div class=\"btn-group pull-right\" style=\"margin-right: 5px;\"><button class=\"btn btn-default\" ng-model=filters.visible_group value=settings ng-class=\"{'active': filters.visible_group == 'settings'}\" ng-click=\"setVisibleGroup('settings')\">{{ 'masterZclite.projects.list.kihonjouhou_ichiran' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=stats ng-class=\"{'active': filters.visible_group == 'stats'}\" ng-click=\"setVisibleGroup('stats')\">{{ 'masterZclite.projects.list.saito_akusesujouhou' | translate }}</button> <button class=\"btn btn-default\" ng-model=filters.visible_group value=users ng-class=\"{'active': filters.visible_group == 'users'}\" ng-click=\"setVisibleGroup('users')\">{{ 'masterZclite.projects.list.yuuzaa' | translate }}</button></div></div></div></div><div class=master-search><div class=master-search-header ng-click=\"table = !table\"><i class=\"fa fa-bars\"></i> {{ 'masterZclite.projects.list.deeta_shiborikomi' | translate }}</div><div class=master-search-body ng-show=table><div class=row><div class=col-md-2><h1>{{ 'masterZclite.projects.list.tokushu_purojekuto_wo' | translate }}</h1><input id=checkbox_for_terminated type=checkbox ng-model=filters.show_terminated> <label for=checkbox_for_terminated>{{ 'masterZclite.projects.list.ochi_purojekuto' | translate }}</label><br><input id=checkbox_for_test type=checkbox ng-model=filters.show_test> <label for=checkbox_for_test>{{ 'masterZclite.projects.list.test_purojekuto_wo_hyouji' | translate }}</label><br><input id=checkbox_for_demo type=checkbox ng-model=filters.show_demo> <label for=checkbox_for_demo>{{ 'masterZclite.projects.list.demo_purojekuto_wo_hyouji' | translate }}</label></div><div class=col-md-1><h1>{{ 'masterZclite.projects.list.dairiten_kankei' | translate }}</h1><select ng-model=filters.selling_method class=form-control ng-options=\"param as method for (param,method) in selling_methods\"></select></div><div class=\"col-md-2 col-sm-3\"><h1>{{ 'masterZclite.projects.list.dounyuu_suteetasu' | translate }}</h1><select ng-model=filters.install_status class=form-control ng-options=\"param as name for (param,name) in install_status\"></select></div><div class=col-sm-2><h1>{{ 'masterZclite.projects.list.kiiwaado_shiborikomi' | translate }}</h1><input type=text class=form-control ng-model=filters.search_term ng-model-options=\"{debounce: { 'default': 500, 'blur': 0 }}\" ng-change=filterProjects() placeholder=\"{{ 'masterZclite.projects.list.kiiwaadokensaku' | translate }}\"></div><div class=col-sm-4><h1>{{ 'masterZclite.projects.list.kikan_shiborikomi' | translate }}</h1><div class=row><div class=col-sm-6><input class=\"form-control form_datepick\" datepick size=16 type=text ng-model=filters.start_at_raw date=filters.start_at required></div><div class=col-sm-6><input class=\"form-control form_datepick\" datepick size=16 type=text ng-model=filters.end_at_raw date=filters.end_at required></div></div></div></div><div class=master-search-footer><button class=\"btn btn-primary master-search-button\" ng-click=updateData()>{{ 'masterZclite.projects.list.koushin' | translate }}</button></div></div></div><div><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table project-list\"><thead><tr><th class=sortable ng-click=\"setSortProp('id')\">ID</th><th class=sortable style=width:100px ng-click=\"setSortProp('id')\">{{ 'masterZclite.projects.list.purojekuto_na' | translate }} (ZC link)</th><th class=sortable style=width:100px ng-click=\"setSortProp('apikey')\">Apikey (ZCLite link)</th><th class=sortable style=width:100px ng-click=\"setSortProp('company_name')\">{{ 'masterZclite.projects.list.kaishamei' | translate }}</th><th class=sortable style=width:100px ng-click=\"setSortProp('shopping_cart_asp')\">Cart asp</th><th class=sortable style=width:100px ng-click=\"setSortProp('cart_id')\">Cart id</th><th class=sortable style=width:100px ng-click=\"setSortProp('makerepeater_shop_id')\">makerepeater</th><th class=sortable ng-click=\"setSortProp('contract_status')\">{{ 'masterZclite.projects.list.keiyaku_suteetasu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.total_conversion_price')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterZclite.projects.list.uriage' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.session_count')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterZclite.projects.list.houmon_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.avg_history_count')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterZclite.projects.list.heikin' | translate }}PV</th><th class=sortable ng-click=\"setSortProp('stats.avg_interest_count')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterZclite.projects.list.heikin_kyoumi_kazu' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.exp_cart_button_click_rate')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterZclite.projects.list.cartClickRate' | translate }}</th><th class=sortable ng-click=\"setSortProp('stats.exp_conversion_rate')\" ng-show=\"filters.visible_group == 'stats'\">{{ 'masterZclite.projects.list.cvRate' | translate }}</th><th class=sortable ng-click=\"setSortProp('session_count_evaluator')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.houmon_kaisuu_hantei' | translate }}</th><th class=sortable ng-click=\"setSortProp('pricing_confirmed_at')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.ryoukin_doui' | translate }}</th><th class=sortable ng-click=\"setSortProp('install_status')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.dounyuu_suteetasu' | translate }}</th><th class=sortable ng-click=\"setSortProp('install_status_pending_time')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.keika_hi' | translate }}</th><th class=sortable ng-click=\"setSortProp('operation_status')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.haishin_suteetasu' | translate }}</th><th class=sortable ng-click=\"setSortProp('operation_status_pending_time')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.hitsuji_haishin_hi' | translate }}</th><th class=sortable ng-click=\"setSortProp('reviewed_at')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.han_yashirochekku' | translate }}</th><th class=sortable ng-click=\"setSortProp('installed_at')\" ng-show=\"filters.visible_group == 'settings'\">{{ 'masterZclite.projects.list.dounyuu_kanryou_nichiji' | translate }}</th><th class=sortable ng-click=\"setSortProp('users.length')\" ng-show=\"filters.visible_group == 'users'\">{{ 'masterZclite.projects.list.kuraianto_tantousha' | translate }}</th><th class=sortable ng-click=\"setSortProp('users.length')\" ng-show=\"filters.visible_group == 'users'\">{{ 'masterZclite.projects.list.masutaa_tantousha' | translate }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"project in filteredProjects\"><td>{{::project.id}}</td><td><div class=\"label label-danger\" ng-if=project.is_test>TEST</div><div class=\"label label-warning\" ng-if=project.is_demo>DEMO</div><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\">{{::project.title}}</a></td><td><a ng-href=https://lite.zenclerk.com/sites/{{project.apikey}} target=_blank>{{::project.apikey}}</a></td><td>{{::project.company_name}}</td><td>{{project.shopping_cart_asp}}</td><td>{{project.cart_id}}</td><td>{{project.makerepeater_shop_id}}</td><td><zc-label-project-status project=project range=filters></zc-label-project-status></td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.total_conversion_price | number:0}}円</td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.session_count | number:0}}</td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.avg_history_count | number: 2}}</td><td class=text-right ng-show=\"filters.visible_group == 'stats'\">{{project.stats.avg_interest_count | number: 2}}</td><td ng-show=\"filters.visible_group == 'stats'\"><span class=\"label group-exp\" ng-show=project.stats.exp_cart_button_click_rate>A: {{project.stats.exp_cart_button_click_rate*100 | number: 2}}%</span><br><span class=\"label group-ctl\" ng-show=project.stats.ctl_cart_button_click_rate>B: {{project.stats.ctl_cart_button_click_rate*100 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'stats'\"><span class=\"label group-exp\" ng-show=project.stats.exp_conversion_rate>A: {{project.stats.exp_conversion_rate*100 | number: 2}}%</span><br><span class=\"label group-ctl\" ng-show=project.stats.ctl_conversion_rate>B: {{project.stats.ctl_conversion_rate*100 | number: 2}}%</span></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=\"project.session_count_evaluator === 'google_analytics'\"><span>GA</span></div><div ng-if=\"project.session_count_evaluator === 'site_catalyst'\"><span class=\"label label-info\">SC</span></div><div ng-if=\"project.session_count_evaluator === 'visitor'\"><span class=\"label label-secondary\">ZC</span></div></td><td ng-show=\"filters.visible_group == 'settings'\"><span ng-if=project.pricing_confirmed_at>{{project.pricing_confirmed_at | zcDate}}</span> <span ng-if=!project.pricing_confirmed_at class=\"label label-danger\">{{ 'masterZclite.projects.list.misetsu_kyoutei' | translate }}</span></td><td ng-show=\"filters.visible_group == 'settings'\"><span ng-if=\"project.install_status=='b_companyinfo_confirmed_at'\"><div class=\"label zc-blue2-bg\">{{ 'masterZclite.projects.list.companyinfoConfirmedAt' | translate }}</div></span> <span ng-if=\"project.install_status=='c_siteinfo_confirmed_at'\"><div class=\"label zc-purple2-bg\">{{ 'masterZclite.projects.list.siteinfoConfirmedAt' | translate }}</div></span> <span ng-if=\"project.install_status=='d_tracking_tag_confirmed_at'\"><div class=\"label zc-yellow1-bg\">{{ 'masterZclite.projects.list.trackingTagConfirmedAt' | translate }}</div></span> <span ng-if=\"project.install_status=='e_conversion_tag_confirmed_at'\"><div class=\"label zc-red2-bg\">{{ 'masterZclite.projects.list.conversionTagConfirmedAt' | translate }}</div></span> <span ng-if=\"project.install_status=='f_complete'\"><div class=\"label label-success\">{{ 'masterZclite.projects.list.complete' | translate }}</div></span></td><td ng-show=\"filters.visible_group == 'settings'\"><span ng-show=project.install_status_pending_time ng-class=\"{'zc-red1-fg':checkPendingDate(project.install_status_pending_time)}\">{{project.install_status_pending_time}}{{ 'masterZclite.projects.list.hi' | translate }}</span></td><td ng-show=\"filters.visible_group == 'settings'\"><span ng-if=\"project.operation_status=='a_before_first_campaign_start'\"><div class=\"label zc-blue2-bg\">{{ 'masterZclite.projects.list.hitsuji_haishin' | translate }}</div></span> <span ng-if=\"project.operation_status=='b_after_last_campaign_end'\"><div class=\"label zc-purple2-bg\">{{ 'masterZclite.projects.list.haishin_zumi' | translate }}</div></span> <span ng-if=\"project.operation_status=='c_current_campaign_in_delivery'\"><div class=\"label zc-yellow1-bg\">{{ 'masterZclite.projects.list.haishin_uchi' | translate }}</div></span></td><td ng-show=\"filters.visible_group == 'settings'\"><span ng-show=project.operation_status_pending_time ng-class=\"{'zc-red1-fg':checkPendingDate(project.operation_status_pending_time)}\">{{project.operation_status_pending_time}}{{ 'masterZclite.projects.list.hi' | translate }}</span></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=project.reviewed_at><span class=\"label label-success\">{{project.reviewed_at | zcDate}}</span></div><div ng-if=!project.reviewed_at><span class=\"label label-danger\">{{ 'masterZclite.projects.list.misetsu_kyoutei' | translate }}</span></div></td><td ng-show=\"filters.visible_group == 'settings'\"><div ng-if=project.installed_at><span tooltip=\"{{ project.region | gmtNotation }}\">{{project.installed_at | date: 'yyyy/MM/dd' }}</span></div><div ng-if=!project.installed_at><span>{{ 'masterZclite.projects.list.misetsu_kyoutei' | translate }}</span></div></td><td ng-show=\"filters.visible_group == 'users'\"><ul class=list-inline ng-repeat=\"user in project.users | filter: {'role': 'common'}\"><li>{{user.email}}</li></ul></td><td ng-show=\"filters.visible_group == 'users'\"><ul class=list-inline ng-repeat=\"user in project.users | filter: {'role': 'master'}\"><li>{{user.email}}</li></ul></td><td ng-show=\"filters.visible_group == 'users'\" ng-init=\"project.isAssignee = checkIsAssignee(project)\"><button class=\"btn btn-sm btn-default\" ng-click=unassignCurrentUser(project) ng-if=project.isAssignee>{{ 'masterZclite.projects.list.ko_no_tantou' | translate }}</button> <button class=\"btn btn-sm btn-default\" ng-click=assignCurrentUser(project) ng-if=!project.isAssignee>{{ 'masterZclite.projects.list.ko_no_saito' | translate }}</button></td><td><div class=\"btn-group pull-right\"><button class=\"btn btn-sm btn-default\" ui-sref=\"admin.projects.settings.basic({ projectId: project.id })\">{{ 'masterZclite.projects.list.henshuu' | translate }}</button><div dropdown class=\"btn-group dropdown\"><button dropdown-toggle type=button class=\"btn btn-sm btn-default dropdown-toggle actions-dropdown\"><span class=caret></span></button><ul class=\"dropdown-menu pull-right\" role=menu><li><a ng-href={{project.base_url}} target=_blank>{{ 'masterZclite.projects.list.saito_wo_miru' | translate }}</a></li><li><a ng-href=\"{{project.base_url}}?zc_dump=1\" target=_blank>{{ 'masterZclite.projects.list.saito_wo_miru_analysis' | translate }}</a></li></ul></div></div></td></tr></tbody></table></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

var path = '/templates/master.zclite_projects_for_review/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-3><h1>{{ 'masterZclite.projectsForReview.list.han_yashiro_nakaguro' | translate }}</h1></div></div></div><div><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table project-list\"><thead><tr><th class=sortable ng-click=\"setSortProp('id')\">ID</th><th class=sortable ng-click=\"setSortProp('id')\">{{ 'masterZclite.projectsForReview.list.purojekuto_na' | translate }}</th><th class=sortable ng-click=\"setSortProp('apikey')\">{{ 'masterZclite.projectsForReview.list.kanri_gamen' | translate }}</th><th class=sortable ng-click=\"setSortProp('agency.title')\">Agency</th><th class=sortable ng-click=\"setSortProp('shopping_cart_asp')\">Cart asp</th><td>{{ 'masterZclite.projectsForReview.list.saito' | translate }}</td><th class=sortable ng-click=\"setSortProp('company_name')\">{{ 'masterZclite.projectsForReview.list.shamei' | translate }}</th><th class=sortable ng-click=\"setSortProp('representative')\">{{ 'masterZclite.projectsForReview.list.shachou_na' | translate }}</th><th class=sortable ng-click=\"setSortProp('reviewed_at')\">{{ 'masterZclite.projectsForReview.list.han_yashirochekku' | translate }}</th><th></th><th class=sortable ng-click=\"setSortProp('reviewed_at')\">{{ 'masterZclite.projectsForReview.list.yoshin_chekku' | translate }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"project in filteredProjects\"><td>{{::project.id}}</td><td><div class=\"label label-danger\" ng-if=project.is_test>TEST</div><div class=\"label label-warning\" ng-if=project.is_demo>DEMO</div><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\">{{::project.title}}</a></td><td><a ng-href=https://lite.zenclerk.com/sites/{{project.apikey}} target=_blank>[admin]</a></td><td>{{project.agency.title}}</td><td>{{project.shopping_cart_asp}}</td><td><a href={{project.base_url}} target=_blank>{{ 'masterZclite.projectsForReview.list.saitohe' | translate }}</a></td><td>{{project.company_name}}</td><td>{{project.representative}}</td><td><div ng-if=project.reviewed_at><span class=\"label label-success\">{{project.reviewed_at | zcDate}}</span><div ng-if=project.reviewed_by>by {{project.reviewed_by.full_name}}</div></div><div ng-if=!project.reviewed_at><span class=\"label label-danger\">{{ 'masterZclite.projectsForReview.list.misetsu_kyoutei' | translate }}</span></div></td><td><div class=\"btn-group pull-right\"><button class=\"btn btn-sm btn-default\" ng-click=completeReview(project.id) ng-disabled=project.reviewed_at>{{ 'masterZclite.projectsForReview.list.han_yashiro' | translate }}</button></div></td><td><div ng-if=project.credit_at><span class=\"label label-success\">{{project.credit_at | zcDate}}</span><div ng-if=project.credit_by>by {{project.credit_by.full_name}}</div></div><div ng-if=!project.credit_at><span class=\"label label-danger\">{{ 'masterZclite.projectsForReview.list.misetsu_kyoutei' | translate }}</span></div></td><td><div class=\"btn-group pull-right\"><button class=\"btn btn-sm btn-default\" ng-click=completeCredit(project.id) ng-disabled=project.credit_at>{{ 'masterZclite.projectsForReview.list.yoshin' | translate }}</button></div></td></tr></tbody></table></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

var path = '/templates/master.zclite_reports/list.html';
var html = "<div class=content><div class=container-fluid><div class=master-button-group><div class=row><div class=col-md-6><h1 translate=masterZclite.reports.list.amountAdjustmentList translate-value-period=\"{{ currentPeriod | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}\"></h1></div><div class=col-md-6><div class=\"btn-group pull-right\"><button class=\"btn btn-default\" ng-click=prevMonth()>{{ 'masterZclite.reports.list.zengetsu_fun_hyouji' | translate }}</button> <button class=\"btn btn-default\" ng-disabled=isTailPeriod ng-click=nextMonth()>{{ 'masterZclite.reports.list.tsugi_tsuki_fun' | translate }}</button></div></div></div></div><div><div class=table-responsive><table class=\"table table-striped table-hover table-bordered table-condensed master-table project-list\"><thead><tr><th style=\"min-width: 40px\" class=sortable ng-click=\"setSortProp('id')\">ID</th><th style=\"min-width: 110px\" class=sortable ng-click=\"setSortProp('project.id')\">{{ 'masterZclite.reports.list.purojekuto_na' | translate }}<br>(ZC link)</th><th style=\"min-width: 200px\" class=sortable ng-click=\"setSortProp('project.apikey')\">Apikey<br>(ZCLite link)</th><th style=\"min-width: 80px\" class=sortable ng-click=\"setSortProp('project.product_line')\">{{ 'masterZclite.reports.list.puran' | translate }}</th><th style=\"min-width: 80px\" class=sortable ng-click=\"setSortProp('adjustment_date')\">{{ 'masterZclite.reports.list.tekiyou_tsuki' | translate }}</th><th style=\"min-width: 100px\" class=sortable ng-click=\"setSortProp('adjustment_name')\">{{ 'masterZclite.reports.list.himoku_kategori' | translate }}</th><th style=\"min-width: 80px\" class=sortable ng-click=\"setSortProp('title}')\">{{ 'masterZclite.reports.list.himoku' | translate }}</th><th style=\"min-width: 80px\" class=sortable ng-click=\"setSortProp('adjustment_type')\">{{ 'masterZclite.reports.list.himoku_kategori' | translate }}</th><th style=\"min-width: 105px\" class=sortable ng-click=\"setSortProp('price')\">{{ 'masterZclite.reports.list.chousei_kingaku_wariai' | translate }}</th><th style=\"width: 400px\" class=sortable ng-click=\"setSortProp('apply_to_future')\">{{ 'masterZclite.reports.list.apply_to_future' | translate }}</th><th style=\"width: 400px\" class=sortable ng-click=\"setSortProp('description')\">{{ 'masterZclite.reports.list.bikou' | translate }}</th><th style=\"min-width: 100px\" class=sortable ng-click=\"setSortProp('created_at')\">{{ 'masterZclite.reports.list.sakuseinichiji' | translate }}</th><th style=\"min-width: 100px\" class=sortable ng-click=\"setSortProp('audited_by')\">{{ 'masterZclite.reports.list.chekku_nichiji' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"invoiceAdjustment in filteredInvoiceAdjustments\"><td>{{::invoiceAdjustment.id}}</td><td><div class=\"label label-danger\" ng-if=invoiceAdjustment.project.is_test>TEST</div><div class=\"label label-warning\" ng-if=invoiceAdjustment.project.is_demo>DEMO</div><a ui-sref=\"admin.projects.campaigns.list({projectId: invoiceAdjustment.project.id})\">{{::invoiceAdjustment.project.title}}</a></td><td><a ng-href=https://lite.zenclerk.com/sites/{{invoiceAdjustment.project.apikey}} target=_blank>{{::invoiceAdjustment.project.apikey}}</a></td><td>{{invoiceAdjustment.project.product_line}}</td><td>{{invoiceAdjustment.adjustment_date | date :\"yyyy年MM月\"}}</td><td>{{invoiceAdjustment.adjustment_name}}</td><td>{{invoiceAdjustment.title}}</td><td>{{invoiceAdjustment.adjustment_type}}</td><td ng-if=\"invoiceAdjustment.adjustment_name !== 'monthly_percent_discount'\">{{invoiceAdjustment.price}} 円</td><td ng-if=\"invoiceAdjustment.adjustment_name === 'monthly_percent_discount'\">{{invoiceAdjustment.percent}} %</td><td>{{ invoiceAdjustment.apply_to_future ? 'Yes' : 'No' }}</td><td>{{invoiceAdjustment.description}}</td><td><span class=\"label label-default\">{{ 'masterZclite.reports.list.sakusei_hi' | translate }}: {{invoiceAdjustment.created_at | date :\"yyyy-MM-dd\"}}</span><br>{{invoiceAdjustment.created_by.full_name}}</td><td><button class=\"btn btn-xs btn-default\" ng-click=completeAudit(invoiceAdjustment.id) ng-hide=invoiceAdjustment.audited_by>Check</button> <button class=\"btn btn-xs btn-default\" confirm-modal confirm-click=deleteInvoiceAdjustment(invoiceAdjustment.id) ng-hide=invoiceAdjustment.audited_by>{{ 'masterZclite.reports.list.sakujo' | translate }}</button> <span class=\"label label-success\" ng-show=invoiceAdjustment.audited_by>{{ 'masterZclite.reports.list.zumi' | translate }}: {{invoiceAdjustment.audited_at | date :\"yyyy-MM-dd\"}}</span><div ng-show=invoiceAdjustment.audited_by>by {{invoiceAdjustment.audited_by.full_name}}</div></td></tr></tbody></table></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

var path = '/templates/master/components/campaign_badges.html';
var html = "<span ng-repeat=\"(campaignStatus, campaignStatusCount) in vm.campaignCountByStatus\" ng-show=\"campaignStatusCount > 0\" style=\"margin-left: 2px; margin-right: 2px;\" tooltip=\"{{ vm.campaignStatuses[campaignStatus].text }}\" class=\"badge {{ vm.campaignStatuses[campaignStatus].statusClass }}\">{{ campaignStatusCount }}</span> <span ng-if=\"vm.undeliveredCampaignCount > 0\" tooltip=\"{{ 'master.components.masterHomeReport.notDeliveredTooltip' | translate: { count: vm.undeliveredCampaignCount } }}\" style=\"margin-right: 2px;\" class=\"badge label-primary\">{{ 'master.components.masterHomeReport.notDelivered' | translate }} <span ng-if=\"vm.undeliveredCampaignCount < vm.unfinishedCampaigns.length\">({{ vm.undeliveredCampaignCount }}/{{ vm.unfinishedCampaigns.length }})</span></span> <span ng-if=vm.secretAbCampaignCount style=\"margin-right: 2px;\" class=\"badge badge-success\">{{ 'master.components.masterHomeReport.tesuto_hihyouji' | translate }} <span ng-if=\"vm.secretAbCampaignCount < vm.campaigns.length\">({{ vm.secretAbCampaignCount }}/{{ vm.campaigns.length }})</span></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

var path = '/templates/master/components/logistic_regression_coefficients/logistic_regression_coefficients.html';
var html = "<div class=logistic-regression-coefficients><div class=\"panel panel-default\"><div class=panel-heading><h5 class=panel-title><i class=\"fa fa-lock\"></i> {{ 'master.components.logisticRegressionCoefficients.featureValue' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.logisticRegressionCoefficients.featureValueTooltip' | translate }}\"></i><div class=\"btn-group pull-right\"><div class=\"btn btn-xs btn-default\" ng-class=\"{'active': $ctrl.device == 'pc'}\" ng-click=\"$ctrl.device = 'pc'\">{{ 'master.components.logisticRegressionCoefficients.pc' | translate }}</div><div class=\"btn btn-xs btn-default\" ng-class=\"{'active': $ctrl.device == 'sp'}\" ng-click=\"$ctrl.device = 'sp'\">{{ 'master.components.logisticRegressionCoefficients.sp' | translate }}</div></div></h5></div><div class=panel-body ng-if=\"$ctrl.createdAt && $ctrl.partials\"><table class=\"table table-bordered text-center\" style=\"word-break: break-all;\"><thead><th class=\"col-md-9 text-center\"><a class=text-muted ng-click=\"$ctrl.sortBy('key')\">{{ 'master.components.logisticRegressionCoefficients.variableName' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.sortProp === 'key' && $ctrl.sortDirection === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.sortProp === 'key' && $ctrl.sortDirection === 'desc'\"></i></a></th><th class=\"col-md-3 text-center\"><a class=text-muted ng-click=\"$ctrl.sortBy('value')\">{{ 'master.components.logisticRegressionCoefficients.coefficient' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.sortProp === 'value' && $ctrl.sortDirection === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.sortProp === 'value' && $ctrl.sortDirection === 'desc'\"></i></a></th></thead><tbody><tr ng-repeat=\"partial in $ctrl.partials\"><td class=\"col-md-9 text-left\"><span tooltip=\"{{ partial.key }}\">{{ partial.label }}</span></td><td class=\"col-md-3 text-center\">{{ partial.value | number : 2 }}</td></tr></tbody></table><button type=button class=\"btn btn-default col-md-12\" style=\"margin-bottom: 10px;\" ng-click=$ctrl.changeLimit(100) ng-if=\"$ctrl.limit === 10\">{{ 'master.components.logisticRegressionCoefficients.showAll' | translate }}</button> <button type=button class=\"btn btn-default col-md-12\" style=\"margin-bottom: 10px;\" ng-click=$ctrl.changeLimit(10) ng-if=\"$ctrl.limit === 100\" translate=master.components.logisticRegressionCoefficients.showOnlyTop translate-value-number=10></button><div translate=master.components.logisticRegressionCoefficients.allSessionNumber translate-value-date=\"{{ $ctrl.createdAt | zcDate : {smart: true, dateOnly: true} }}\" class=\"all_session_number text-muted\"></div></div><div class=panel-body ng-if=\"!$ctrl.createdAt || !$ctrl.partials\"><p ng-if=\"['pc', 'sp'].includes($ctrl.device)\" translate=master.components.logisticRegressionCoefficients.noModelYet translate-value-device=\"{{ 'master.components.logisticRegressionCoefficients.' + $ctrl.device | translate }}\"></p><p>{{ 'master.components.logisticRegressionCoefficients.buildingModelNote' | translate }}</p></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

var path = '/templates/master/components/master_home/master_home.html';
var html = "<campaign-filter-view filters=$ctrl.filters hide-search-term=true hide-device=true hide-campaign-segment-id=true show-hidden-ab-test-toggle=true update=$ctrl.updateFilters() reset=$ctrl.resetFilters()></campaign-filter-view><h4>{{ 'master.components.masterHome.kgiAlert' | translate }} <small translate=master.components.masterHome.filteringData translate-value-date=\"{{$ctrl.filters.start_at | zcDate : {smart: true, dateOnly: true} }} - {{$ctrl.filters.end_at | zcDate : {smart: true, dateOnly: true} }}\"></small></h4><zc-master-home-alert projects=$ctrl.alertProjects filters=$ctrl.filters></zc-master-home-alert><p class=text-mute>{{ 'master.components.masterHome.noteAlert' | translate }}<br></p><br><h4>{{ 'master.components.masterHome.report' | translate }} <small translate=master.components.masterHome.filteringData translate-value-date=\"{{$ctrl.filters.start_at | zcDate : {smart: true, dateOnly: true} }} - {{$ctrl.filters.end_at | zcDate : {smart: true, dateOnly: true} }}\"></small></h4><zc-master-home-report projects=$ctrl.reportProjects campaigns=$ctrl.reportCampaigns filters=$ctrl.filters sort-reports=$ctrl.sortReports()></zc-master-home-report><p class=text-mute>{{ 'master.components.masterHome.noteReport' | translate }}</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

var path = '/templates/master/components/master_home_alert/master_home_alert.html';
var html = "<table class=\"table campaign-table master-home\"><thead><tr><th colspan=8><div class=btn-group role=group><button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleExpandedAlert() ng-class=\"{ 'active' : !$ctrl.filters.expanded_alert }\"><span class=\"glyphicon glyphicon-menu-up\"></span></button> <button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleExpandedAlert() ng-class=\"{ 'active' : $ctrl.filters.expanded_alert }\"><span class=\"glyphicon glyphicon-menu-down\"></span></button></div><div class=pull-right><div class=btn-group role=group><button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleAllAlert() ng-class=\"{ 'active' : !$ctrl.filters.all_alert }\"><span class=\"glyphicon glyphicon-star zc-yellow1-fg\"></span></button> <button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleAllAlert() ng-class=\"{ 'active' : $ctrl.filters.all_alert }\">{{ 'master.components.masterHomeAlert.all' | translate }}</button></div>&nbsp;<div style=\"display: inline-block;\"><input type=search class=\"form-control input-sm\" ng-model=$ctrl.searchTerm></div></div></th></tr></thead><tbody><tr ng-if=!filteredProjects.length><td colspan=8 class=text-center>{{ 'master.components.masterHomeAlert.noKgiAlert' | translate }}</td></tr><tr ng-if=filteredProjects.length><td colspan=3></td><td colspan=2><a class=text-muted ng-click=\"$ctrl.sortBy('id')\">{{ 'master.components.masterHomeAlert.siteName' | translate }}</a></td><td class=text-right><span class=text-muted>{{ 'master.components.masterHomeAlert.kgi' | translate }}</span></td><td class=text-right><span class=text-muted>{{ 'master.components.masterHomeAlert.value' | translate }}</span></td><td class=text-right><span class=text-muted>{{ 'master.components.masterHomeAlert.threshold' | translate }}</span></td></tr></tbody><tbody ng-repeat=\"project in filteredProjects = ($ctrl.projects | filter : $ctrl.filterProjects) track by $index\"><tr ng-click=\"project.expanded_alert = !project.expanded_alert\"><th><a class=\"glyphicon glyphicon-star zc-yellow1-fg\" ng-if=project.starred ng-click=\"$ctrl.unstar(project); $event.stopPropagation()\"></a> <a class=\"glyphicon glyphicon-star-empty\" ng-if=!project.starred ng-click=\"$ctrl.star(project); $event.stopPropagation()\"></a></th><th><a ng-if=\"project.jira_link && project.jira_link.length > 0\" ng-href={{project.jira_link}} ng-click=$event.stopPropagation() target=_blank><img src=/assets/admin/jira.ico alt=Jira style=\"height: 16px; width: 16px;\"></a></th><th><span class=\"glyphicon glyphicon-folder-open\" ng-if=project.expanded_alert></span> <span class=\"glyphicon glyphicon-folder-close\" ng-if=!project.expanded_alert></span></th><th colspan=2><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\" style=\"margin-right: 4px;\" ng-click=$event.stopPropagation()>{{ project.title }}</a><zc-campaign-badges campaigns=project.campaigns></zc-campaign-badges></th><th class=text-right ng-switch=project.alert><span class=text-danger ng-switch-when=conversion_up_rate>{{ 'master.components.masterHomeAlert.cvrIncreaseRate' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeAlert.cvrIncreaseRateNote' | translate }}\" ng-switch-when=conversion_up_rate ng-click=$event.stopPropagation()></i> <span class=text-danger ng-switch-when=invoice_amount_simulation|invoice_amount_upper_simulation ng-switch-when-separator=|>{{ 'master.components.masterHomeAlert.expectedInvoiceAmount' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeAlert.expectedInvoiceAmountNote' | translate }}\" ng-switch-when=invoice_amount_simulation|invoice_amount_upper_simulation ng-switch-when-separator=| ng-click=$event.stopPropagation()></i> <span class=text-danger ng-switch-when=revenue_min_threshold|revenue_max_threshold ng-switch-when-separator=|>{{ 'master.components.masterHomeAlert.expectedRevenue' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeAlert.expectedRevenueNote' | translate }}\" ng-switch-when=revenue_min_threshold|revenue_max_threshold ng-switch-when-separator=| ng-click=$event.stopPropagation()></i> <span class=text-danger ng-switch-when=coupon_applicable_rate>{{ 'master.components.masterHomeAlert.couponApplicableRate' | translate }}</span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeAlert.couponApplicableRateDesc' | translate }}\" ng-switch-when=coupon_applicable_rate ng-click=$event.stopPropagation()></i></th><th class=text-right ng-switch=project.alert><span class=text-danger ng-switch-when=conversion_up_rate>{{ project.stats.conversion_up_rate * 100 | number : 1 }}%</span> <span class=text-danger ng-switch-when=invoice_amount_simulation|invoice_amount_upper_simulation ng-switch-when-separator=|>{{ project.currencyObj.symbol }}{{ project.stats.invoice_amount_simulation | number : 0 }}{{ project.currencyObj.suffix }}</span> <span class=text-danger ng-switch-when=revenue_min_threshold|revenue_max_threshold ng-switch-when-separator=|>{{ project.currencyObj.symbol }}{{ project.stats.revenue_simulation | number : 0 }}{{ project.currencyObj.suffix }}</span> <span class=text-danger ng-switch-when=coupon_applicable_rate></span></th><th class=text-right ng-switch=project.alert><span translate=master.components.masterHomeAlert.moreThan translate-value-threshold=\"{{ project.conversion_up_rate_threshold | number : 0 }}%\" class=text-danger ng-switch-when=conversion_up_rate></span> <span translate=master.components.masterHomeAlert.moreThan translate-value-threshold=\"{{ project.currencyObj.symbol }}{{ project.invoice_amount_threshold | number : 0 }}{{ project.currencyObj.suffix }}\" class=text-danger ng-switch-when=invoice_amount_simulation></span> <span translate=master.components.masterHomeAlert.until translate-value-threshold=\"{{ project.currencyObj.symbol }}{{ project.invoice_amount_upper_threshold | number : 0 }}{{ project.currencyObj.suffix }}\" class=text-danger ng-switch-when=invoice_amount_upper_simulation></span> <span translate=master.components.masterHomeAlert.moreThan translate-value-threshold=\"{{ project.currencyObj.symbol }}{{ project.revenue_min_threshold | number : 0 }}{{ project.currencyObj.suffix }}\" class=text-danger ng-switch-when=revenue_min_threshold></span> <span translate=master.components.masterHomeAlert.until translate-value-threshold=\"{{ project.currencyObj.symbol }}{{ project.revenue_max_threshold | number : 0 }}{{ project.currencyObj.suffix }}\" class=text-danger ng-switch-when=revenue_max_threshold></span> <span translate=master.components.masterHomeAlert.moreThan translate-value-threshold=\"{{ project.coupon_applicable_rate_threshold | number : 0 }}%\" class=text-danger ng-switch-when=coupon_applicable_rate></span></th></tr><tr ng-repeat=\"campaign in project.campaigns\" ng-if=\"project.expanded_alert && ( project.alert !== 'coupon_applicable_rate' || (project.alert === 'coupon_applicable_rate' && campaign.alerts.includes('coupon_applicable_rate') ) )\"><td colspan=3></td><td><zc-campaign-status campaign=campaign suppress-error-message=true></zc-campaign-status>&nbsp; <span campaign-device ng-model=campaign></span></td><td><a ui-sref=\"admin.projects.campaigns.show({projectId: project.id, campaignId: campaign.id})\" ng-click=$event.stopPropagation()>{{ campaign.name }}</a> &nbsp;[<zc-date-range start-at=campaign.start_at end-at=campaign.end_at is-infinite=campaign.is_infinite display-time=false></zc-date-range>]&nbsp; <span ng-if=campaign.is_secret_ab class=\"badge badge-success\">{{ 'master.components.masterHomeReport.tesuto_hihyouji' | translate }}</span> <span ng-if=\"!campaign.is_fired && !['finished', 'terminated'].includes(campaign.current_status)\" class=\"badge label-primary\">{{ 'master.components.masterHomeReport.notDelivered' | translate }}</span></td><td></td><td class=text-right ng-switch=project.alert><small ng-switch-when=conversion_up_rate ng-class=\"{'text-danger': campaign.alerts.includes('conversion_up_rate')}\">{{ campaign.stats.conversion_up_rate * 100 | number : 1 }}%</small> <small ng-switch-when=invoice_amount_simulation ng-class=\"{'text-danger': campaign.alerts.includes('invoice_amount_simulation')}\">{{ project.currencyObj.symbol }}{{ campaign.stats.invoice_amount_simulation | number : 0 }}{{ project.currencyObj.suffix }}</small> <small ng-switch-when=invoice_amount_upper_simulation ng-class=\"{'text-danger': campaign.alerts.includes('invoice_amount_upper_simulation')}\">{{ project.currencyObj.symbol }}{{ campaign.stats.invoice_amount_simulation | number : 0 }}{{ project.currencyObj.suffix }}</small> <small ng-switch-when=revenue_min_threshold ng-class=\"{'text-danger': campaign.alerts.includes('revenue_min_threshold') }\">{{ project.currencyObj.symbol }}{{ campaign.stats.revenue_simulation | number : 0 }}{{ project.currencyObj.suffix }}</small> <small ng-switch-when=revenue_max_threshold ng-class=\"{'text-danger': campaign.alerts.includes('revenue_max_threshold') }\">{{ project.currencyObj.symbol }}{{ campaign.stats.revenue_simulation | number : 0 }}{{ project.currencyObj.suffix }}</small> <small ng-switch-when=coupon_applicable_rate ng-class=\"{'text-danger': campaign.alerts.includes('coupon_applicable_rate')}\">{{ campaign.stats.coupon_applicable_rate * 100 | number : 1 }}%</small></td><td></td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

var path = '/templates/master/components/master_home_report/master_home_report.html';
var html = "<table class=\"table campaign-table master-home\"><thead><tr><th colspan=12><div class=btn-group role=group ng-if=!$ctrl.filters.flat_report><button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleExpandedReport() ng-class=\"{ 'active' : !$ctrl.filters.expanded_report }\"><span class=\"glyphicon glyphicon-menu-up\"></span></button> <button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleExpandedReport() ng-class=\"{ 'active' : $ctrl.filters.expanded_report }\"><span class=\"glyphicon glyphicon-menu-down\"></span></button></div><div class=pull-right><small>{{ 'master.components.masterHomeReport.moodo' | translate }}</small> &nbsp;<div class=btn-group role=group><button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleFlatReport() ng-class=\"{ 'active' : !$ctrl.filters.flat_report }\"><span class=\"glyphicon glyphicon-align-right\"></span></button> <button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleFlatReport() ng-class=\"{ 'active' : $ctrl.filters.flat_report }\"><span class=\"glyphicon glyphicon-list\"></span></button></div>&nbsp; <small>{{ 'master.components.masterHomeReport.koumoku' | translate }}</small> &nbsp;<div class=btn-group role=group><button type=button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.setColumnReport('kgi')\" ng-class=\"{ 'active' : $ctrl.filters.column_report === 'kgi' }\">KGI</button> <button type=button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.setColumnReport('delivery')\" ng-class=\"{ 'active' : $ctrl.filters.column_report === 'delivery' }\">{{ 'master.components.masterHomeReport.haishin_jisseki' | translate }}</button></div>&nbsp; <small>{{ 'master.components.masterHomeReport.hyouji' | translate }}</small> &nbsp;<div class=btn-group role=group><button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleAllReport() ng-class=\"{ 'active' : !$ctrl.filters.all_report }\"><span class=\"glyphicon glyphicon-star zc-yellow1-fg\"></span></button> <button type=button class=\"btn btn-sm btn-default\" ng-click=$ctrl.toggleAllReport() ng-class=\"{ 'active' : $ctrl.filters.all_report }\">{{ 'master.components.masterHomeReport.subete' | translate }}</button></div>&nbsp;<div style=\"display: inline-block;\"><input type=search class=\"form-control input-sm\" ng-model=$ctrl.searchTerm></div></div></th></tr></thead><tbody ng-if=!$ctrl.filters.flat_report><tr ng-if=!filteredProjects.length><td colspan=8 class=text-center>{{ 'master.components.masterHomeReport.gaitou_sururepooto_ga' | translate }}</td></tr><tr ng-if=filteredProjects.length><td colspan=3></td><td colspan=2><a class=text-muted ng-click=\"$ctrl.sortBy('id')\">{{ 'master.components.masterHomeReport.saito_na' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'id' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'id' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.coupon_applicable_rate')\">{{ 'master.components.masterHomeReport.couponApplicableRate' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.coupon_applicable_rate' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.coupon_applicable_rate' && $ctrl.filters.sort_direction === 'desc'\"></i></a> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeReport.couponApplicableRateDesc' | translate }}\" ng-click=$event.stopPropagation()></i></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.conversion_cover_rate')\">{{ 'master.components.masterHomeReport.kabaa_ritsu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_cover_rate' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_cover_rate' && $ctrl.filters.sort_direction === 'desc'\"></i></a> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeReport.kabaa_ritsu_hyouji' | translate }}\" ng-click=$event.stopPropagation()></i></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.conversion_up_rate')\"><small>({{ 'master.components.masterHomeReport.mokuhyou' | translate }})</small> {{ 'master.components.masterHomeReport.joushouritsu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_up_rate' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_up_rate' && $ctrl.filters.sort_direction === 'desc'\"></i></a> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeReport.joushouritsu_hyouji_guruupu' | translate }}\" ng-click=$event.stopPropagation()></i></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.experimental.delivery_count')\"><small>({{ 'master.components.masterHomeReport.hihyouji' | translate }})</small> {{ 'master.components.masterHomeReport.haishin_kazu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.delivery_count' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.delivery_count' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.experimental.conversion_count')\"><small>({{ 'master.components.masterHomeReport.hihyouji' | translate }})</small> {{ 'master.components.masterHomeReport.cv_kazu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.conversion_count' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.conversion_count' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.invoice_amount')\">{{ 'master.components.masterHomeReport.seikyuu_kingaku' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.total_conversion_value')\">{{ 'master.components.masterHomeReport.totalDisplayConversionValue' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.total_conversion_value' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.total_conversion_value' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.invoice_amount_simulation')\">{{ 'master.components.masterHomeReport.yosou_seikyuu_kingaku' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount_simulation' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount_simulation' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td></tr></tbody><tbody ng-repeat=\"project in filteredProjects = ($ctrl.projects | filter : $ctrl.filterProjects)\" ng-if=!$ctrl.filters.flat_report><tr ng-click=\"project.expanded_report = !project.expanded_report\"><th><a class=\"glyphicon glyphicon-star zc-yellow1-fg\" ng-if=project.starred ng-click=\"$ctrl.unstar(project); $event.stopPropagation()\"></a> <a class=\"glyphicon glyphicon-star-empty\" ng-if=!project.starred ng-click=\"$ctrl.star(project); $event.stopPropagation()\"></a></th><th><a ng-if=\"project.jira_link && project.jira_link.length > 0\" ng-href={{project.jira_link}} ng-click=$event.stopPropagation() target=_blank><img src=/assets/admin/jira.ico alt=Jira style=\"height: 16px; width: 16px;\"></a></th><th><span class=\"glyphicon glyphicon-folder-open\" ng-if=project.expanded_report></span> <span class=\"glyphicon glyphicon-folder-close\" ng-if=!project.expanded_report></span></th><th colspan=2><a ui-sref=\"admin.projects.campaigns.list({projectId: project.id})\" style=\"margin-right: 4px;\" ng-click=$event.stopPropagation()>{{ project.title }}</a><zc-campaign-badges campaigns=project.campaigns></zc-campaign-badges></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><span ng-if=\"project.stats.conversion_cover_rate !== null\">{{ project.stats.conversion_cover_rate * 100 | number : 0 }}%</span> <span ng-if=\"project.stats.conversion_cover_rate === null\">-</span></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=project.conversion_up_rate_threshold>({{ project.conversion_up_rate_threshold }}%)</small> <span ng-if=\"project.stats.conversion_up_rate !== null\" ng-class=\"{'text-danger': project.alerts && project.alerts.includes('conversion_up_rate')}\">{{ project.stats.conversion_up_rate * 100 | number : 1 }}%</span> <span ng-if=\"project.stats.conversion_up_rate === null\">-</span></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><small ng-if=project.stats.control.delivery_count>({{ project.stats.control.delivery_count | number : 0 }})</small> <span>{{ project.stats.experimental.delivery_count || 0 | number : 0 }}</span></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><small ng-if=project.stats.control.conversion_count>({{ project.stats.control.conversion_count | number : 0 }})</small> <span>{{ project.stats.experimental.conversion_count || 0 | number : 0 }}</span></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><span>{{ project.currencyObj.symbol }}{{ project.stats.invoice_amount | number : 0 }}{{ project.currencyObj.suffix }}</span></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><span>{{ project.currencyObj.symbol }}{{ project.stats.total_conversion_value | number : 0 }}{{ project.currencyObj.suffix }}</span></th><th class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=project.invoice_amount_threshold>({{ project.currencyObj.symbol }}{{ project.invoice_amount_threshold }}{{ project.currencyObj.suffix }})</small> <span ng-if=\"project.invoice_amount_threshold && project.invoice_amount_upper_threshold\">~</span> <small ng-if=project.invoice_amount_upper_threshold>({{ project.currencyObj.symbol }}{{ project.invoice_amount_upper_threshold }}{{ project.currencyObj.suffix }})</small> <span ng-class=\"{'text-danger': project.alerts && (project.alerts.includes('invoice_amount_simulation') || project.alerts.includes('invoice_amount_upper_simulation'))}\">{{ project.currencyObj.symbol }}{{ project.stats.invoice_amount_simulation | number : 0 }}{{ project.currencyObj.suffix }}</span></th></tr><tr ng-repeat=\"campaign in project.campaigns\" ng-if=project.expanded_report><td colspan=3></td><td colspan=1><zc-campaign-status campaign=campaign suppress-error-message=true></zc-campaign-status>&nbsp; <span campaign-device ng-model=campaign></span></td><td><a ui-sref=\"admin.projects.campaigns.show({projectId: project.id, campaignId: campaign.id})\" ng-click=$event.stopPropagation()>{{ campaign.name }}</a> &nbsp;[<zc-date-range start-at=campaign.start_at end-at=campaign.end_at is-infinite=campaign.is_infinite display-time=false></zc-date-range>]&nbsp; <span ng-if=campaign.is_secret_ab class=\"badge badge-success\">{{ 'master.components.masterHomeReport.tesuto_hihyouji' | translate }}</span> <span ng-if=\"!campaign.is_fired && !['finished', 'terminated'].includes(campaign.current_status)\" class=\"badge label-primary\">{{ 'master.components.masterHomeReport.notDelivered' | translate }}</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=\"campaign.stats.coupon_applicable_rate !== null\" ng-class=\"{'text-danger': campaign.alerts.includes('coupon_applicable_rate')}\">{{ campaign.stats.coupon_applicable_rate * 100 | number : 1 }}%</small> <small ng-if=\"campaign.stats.coupon_applicable_rate === null\">-</small></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=\"campaign.stats.conversion_cover_rate !== null\">{{ campaign.stats.conversion_cover_rate * 100 | number : 0 }}%</small> <small ng-if=\"campaign.stats.conversion_cover_rate === null\">-</small></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=\"campaign.stats.conversion_up_rate !== null\" ng-class=\"{'text-danger': campaign.alerts.includes('conversion_up_rate')}\">{{ campaign.stats.conversion_up_rate * 100 | number : 1 }}%</small> <small ng-if=\"campaign.stats.conversion_up_rate === null\">-</small></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><small ng-if=campaign.stats.control.delivery_count>({{ campaign.stats.control.delivery_count | number : 0 }})</small> <small>{{ campaign.stats.experimental.delivery_count || 0 | number : 0 }}</small></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><small ng-if=campaign.stats.control.conversion_count>({{ campaign.stats.control.conversion_count | number : 0 }})</small> <small>{{ campaign.stats.experimental.conversion_count || 0 | number : 0 }}</small></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><small>{{ project.currencyObj.symbol }}{{ campaign.stats.invoice_amount || 0 | number : 0 }}{{ project.currencyObj.suffix }}</small></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><span>{{ project.currencyObj.symbol }}{{ campaign.stats.conversion_price || 0 | number : 0 }}{{ project.currencyObj.suffix }}</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-class=\"{'text-danger': campaign.alerts.includes('invoice_amount_simulation') || campaign.alerts.includes('invoice_amount_upper_simulation')}\">{{ project.currencyObj.symbol }}{{ campaign.stats.invoice_amount_simulation || 0 | number : 0 }}{{ project.currencyObj.suffix }}</small></td></tr></tbody><tbody ng-if=$ctrl.filters.flat_report><tr ng-if=!filteredCampaigns.length><td colspan=8 class=text-center>{{ 'master.components.masterHomeReport.gaitou_sururepooto_ga' | translate }}</td></tr><tr ng-if=filteredCampaigns.length><td></td><td><a class=text-muted ng-click=\"$ctrl.sortBy('project.id')\">{{ 'master.components.masterHomeReport.saito_na' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'project.id' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'project.id' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td><a class=text-muted ng-click=\"$ctrl.sortBy('current_status')\">{{ 'master.components.masterHomeReport.suteetasu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'current_status' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'current_status' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td><a class=text-muted ng-click=\"$ctrl.sortBy('campaign_device')\">{{ 'master.components.masterHomeReport.debaisu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'campaign_device' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'campaign_device' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td><a class=text-muted ng-click=\"$ctrl.sortBy('id')\">{{ 'master.components.masterHomeReport.kyanpeen_na' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'id' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'id' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.coupon_applicable_rate')\">{{ 'master.components.masterHomeReport.couponApplicableRate' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.coupon_applicable_rate' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.coupon_applicable_rate' && $ctrl.filters.sort_direction === 'desc'\"></i></a> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeReport.couponApplicableRateDesc' | translate }}\" ng-click=$event.stopPropagation()></i></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.conversion_cover_rate')\">{{ 'master.components.masterHomeReport.kabaa_ritsu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_cover_rate' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_cover_rate' && $ctrl.filters.sort_direction === 'desc'\"></i></a> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeReport.kabaa_ritsu_hyouji' | translate }}\" ng-click=$event.stopPropagation()></i></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.conversion_up_rate')\"><small>({{ 'master.components.masterHomeReport.mokuhyou' | translate }})</small> {{ 'master.components.masterHomeReport.joushouritsu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_up_rate' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.conversion_up_rate' && $ctrl.filters.sort_direction === 'desc'\"></i></a> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'master.components.masterHomeReport.joushouritsu_hyouji_guruupu' | translate }}\" ng-click=$event.stopPropagation()></i></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.experimental.delivery_count')\"><small>({{ 'master.components.masterHomeReport.hihyouji' | translate }})</small> {{ 'master.components.masterHomeReport.haishin_kazu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.delivery_count' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.delivery_count' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.experimental.conversion_count')\"><small>({{ 'master.components.masterHomeReport.hihyouji' | translate }})</small> {{ 'master.components.masterHomeReport.cv_kazu' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.conversion_count' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.experimental.conversion_count' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.invoice_amount')\">{{ 'master.components.masterHomeReport.seikyuu_kingaku' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><a class=text-muted ng-click=\"$ctrl.sortBy('stats.invoice_amount_simulation')\"><small>({{ 'master.components.masterHomeReport.mokuhyou' | translate }}))</small> {{ 'master.components.masterHomeReport.yosou_seikyuu_kingaku' | translate }} <i class=\"glyphicon glyphicon-arrow-up\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount_simulation' && $ctrl.filters.sort_direction === 'asc'\"></i> <i class=\"glyphicon glyphicon-arrow-down\" ng-if=\"$ctrl.filters.sort_prop === 'stats.invoice_amount_simulation' && $ctrl.filters.sort_direction === 'desc'\"></i></a></td></tr></tbody><tbody ng-repeat=\"campaign in filteredCampaigns = ($ctrl.campaigns | filter : $ctrl.filterCampaigns)\" ng-if=$ctrl.filters.flat_report><tr><td><a class=\"glyphicon glyphicon-star zc-yellow1-fg\" ng-if=campaign.project.starred ng-click=$ctrl.unstar(campaign.project)></a> <a class=\"glyphicon glyphicon-star-empty\" ng-if=!campaign.project.starred ng-click=$ctrl.star(campaign.project)></a></td><td><a ui-sref=\"admin.projects.campaigns.list({projectId: campaign.project.id})\" ng-click=$event.stopPropagation()>{{ campaign.project.title }}</a></td><td><zc-campaign-status campaign=campaign suppress-error-message=true></zc-campaign-status><campaign-check-status campaign=campaign></campaign-check-status></td><td><span campaign-device ng-model=campaign></span></td><td><a ui-sref=\"admin.projects.campaigns.show({projectId: campaign.project.id, campaignId: campaign.id})\" ng-click=$event.stopPropagation()>{{ campaign.name }}</a> &nbsp;[<zc-date-range start-at=campaign.start_at end-at=campaign.end_at is-infinite=campaign.is_infinite display-time=false></zc-date-range>]</td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=campaign.project.coupon_applicable_rate_threshold>({{ campaign.project.coupon_applicable_rate_threshold }}%)</small> <span ng-class=\"{'text-danger': campaign.alerts.includes('coupon_applicable_rate')}\" ng-if=\"campaign.stats.coupon_applicable_rate !== null\">{{ campaign.stats.coupon_applicable_rate * 100 | number : 1 }}%</span> <span ng-if=\"campaign.stats.coupon_applicable_rate === null\">-</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><span ng-if=\"campaign.stats.conversion_cover_rate !== null\">{{ campaign.stats.conversion_cover_rate * 100 | number : 0 }}%</span> <span ng-if=\"campaign.stats.conversion_cover_rate === null\">-</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=campaign.project.conversion_up_rate_threshold>({{ campaign.project.conversion_up_rate_threshold }}%)</small> <span ng-class=\"{'text-danger': campaign.alerts.includes('conversion_up_rate')}\" ng-if=\"campaign.stats.conversion_up_rate !== null\">{{ campaign.stats.conversion_up_rate * 100 | number : 1 }}%</span> <span ng-if=\"campaign.stats.conversion_up_rate === null\">-</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><span>{{ campaign.stats.experimental.delivery_count || 0 | number : 0 }}</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><span>{{ campaign.stats.experimental.conversion_count || 0 | number : 0 }}</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'delivery'\"><span>{{ campaign.project.currencyObj.symbol }}{{ campaign.stats.invoice_amount || 0 | number : 0 }}{{ campaign.project.currencyObj.suffix }}</span></td><td class=text-right ng-if=\"$ctrl.filters.column_report === 'kgi'\"><small ng-if=campaign.project.invoice_amount_threshold>({{ campaign.project.currencyObj.symbol }}{{ campaign.project.invoice_amount_threshold }}{{ campaign.project.currencyObj.suffix }})</small> <span ng-if=\"campaign.project.invoice_amount_threshold && campaign.project.invoice_amount_upper_threshold\">~</span> <small ng-if=campaign.project.invoice_amount_upper_threshold>({{ campaign.project.currencyObj.symbol }}{{ campaign.project.invoice_amount_upper_threshold }}{{ campaign.project.currencyObj.suffix }})</small> <span ng-class=\"{'text-danger': campaign.alerts.includes('invoice_amount_simulation') || campaign.alerts.includes('invoice_amount_upper_simulation')}\">{{ campaign.project.currencyObj.symbol }}{{ campaign.stats.invoice_amount_simulation || 0 | number : 0 }}{{ campaign.project.currencyObj.suffix }}</span></td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

var path = '/templates/master/views/directives/master_menu.html';
var html = "<li class=\"dropdown navbar-profile\" dropdown ng-show=Devise.isMaster()><a class=dropdown-toggle dropdown-toggle><i class=\"fa fa-lock\"></i> {{ 'master.views.directives.masterMenu.masutaa_muke' | translate }}</a><ul class=dropdown-menu role=menu><li><a ui-sref=admin.master.projects()>{{ 'master.views.directives.masterMenu.zenpurojekuto_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.reports()>{{ 'master.views.directives.masterMenu.repooto_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.campaigns()>{{ 'master.views.directives.masterMenu.kyanpeen_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.users()>{{ 'master.views.directives.masterMenu.yuuzaa_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.agencies()>{{ 'master.views.directives.masterMenu.dairiten_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.zcliteReports()>{{ 'master.views.directives.masterMenu.kingaku_chousei_chekku' | translate }}</a></li><li class=separator><hr></li><li><a ui-sref=admin.master.zcliteProjects()>{{ 'master.views.directives.masterMenu.purojekuto_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.zcliteProjectsForReview()>{{ 'master.views.directives.masterMenu.han_yashiro_nakaguro' | translate }}</a></li><li><a ui-sref=admin.master.zcliteKpi()>{{ 'master.views.directives.masterMenu.lite_kanri' | translate }}</a></li><li><a href=https://app.zenclerk.com/master/invoices/lite rel=\"noopener noreferrer\" target=_blank>{{ 'master.views.directives.masterMenu.seikyuu_ichiran' | translate }}</a></li><li><a ui-sref=admin.master.zcliteAgencyInvoices()>{{ 'master.views.directives.masterMenu.dairiten_seikyuu_ichiran' | translate }}</a></li><li class=separator><hr></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./master.agencies/edit.controller.coffee": 1302,
	"./master.agencies/edit.html": 1628,
	"./master.agencies/list.controller.coffee": 1303,
	"./master.agencies/list.html": 1629,
	"./master.agencies/routes.coffee": 1304,
	"./master.campaigns/data_script_campaign_results.service.coffee": 1305,
	"./master.campaigns/index.js.coffee": 450,
	"./master.campaigns/list.controller.js.coffee": 1306,
	"./master.campaigns/list.html": 1630,
	"./master.campaigns/routes.js.coffee": 1307,
	"./master.projects/index.js.coffee": 451,
	"./master.projects/list.controller.js.coffee": 1308,
	"./master.projects/list.html": 1631,
	"./master.projects/master_campaign_segment_detail.controller.js.coffee": 1309,
	"./master.projects/master_campaign_segment_detail.html": 1632,
	"./master.projects/master_projects_policies.controller.js.coffee": 1310,
	"./master.projects/master_projects_policies.html": 1633,
	"./master.projects/new.controller.coffee": 1311,
	"./master.projects/new.html": 1634,
	"./master.projects/product_line_label.directive.coffee": 1312,
	"./master.projects/routes.js.coffee": 1313,
	"./master.reports/index.js.coffee": 452,
	"./master.reports/list.controller.js.coffee": 1314,
	"./master.reports/list.html": 1635,
	"./master.reports/master_reports_csv_headers.coffee": 1315,
	"./master.reports/report_download_button.directive.coffee": 1316,
	"./master.reports/routes.js.coffee": 1317,
	"./master.segments/segment_estimated_visitors.directive.coffee": 1318,
	"./master.segments/segment_estimated_visitors.html": 1636,
	"./master.users/index.js.coffee": 453,
	"./master.users/list.controller.js.coffee": 1319,
	"./master.users/list.html": 1637,
	"./master.users/routes.js.coffee": 1320,
	"./master.zclite_agency_invoices/index": 112,
	"./master.zclite_agency_invoices/index.js": 112,
	"./master.zclite_agency_invoices/list": 256,
	"./master.zclite_agency_invoices/list.html": 1638,
	"./master.zclite_agency_invoices/list.js": 256,
	"./master.zclite_agency_invoices/routes": 257,
	"./master.zclite_agency_invoices/routes.js": 257,
	"./master.zclite_invoices/index.coffee": 454,
	"./master.zclite_invoices/list.coffee": 1321,
	"./master.zclite_invoices/list.html": 1639,
	"./master.zclite_invoices/routes.coffee": 1322,
	"./master.zclite_invoices/zcs_invoice.service.coffee": 1323,
	"./master.zclite_kpi/index.coffee": 455,
	"./master.zclite_kpi/list.coffee": 1324,
	"./master.zclite_kpi/list.html": 1640,
	"./master.zclite_kpi/routes.coffee": 1325,
	"./master.zclite_projects/index.coffee": 456,
	"./master.zclite_projects/list.coffee": 1326,
	"./master.zclite_projects/list.html": 1641,
	"./master.zclite_projects/routes.coffee": 1327,
	"./master.zclite_projects_for_review/index.coffee": 457,
	"./master.zclite_projects_for_review/list.coffee": 1328,
	"./master.zclite_projects_for_review/list.html": 1642,
	"./master.zclite_projects_for_review/routes.coffee": 1329,
	"./master.zclite_reports/index.coffee": 458,
	"./master.zclite_reports/list.coffee": 1330,
	"./master.zclite_reports/list.html": 1643,
	"./master.zclite_reports/routes.coffee": 1331,
	"./master/components/campaign_badges": 258,
	"./master/components/campaign_badges.html": 1644,
	"./master/components/campaign_badges.js": 258,
	"./master/components/logistic_regression_coefficients/logistic_regression_coefficients": 259,
	"./master/components/logistic_regression_coefficients/logistic_regression_coefficients.html": 1645,
	"./master/components/logistic_regression_coefficients/logistic_regression_coefficients.js": 259,
	"./master/components/master_home/master_home": 260,
	"./master/components/master_home/master_home.html": 1646,
	"./master/components/master_home/master_home.js": 260,
	"./master/components/master_home_alert/master_home_alert": 261,
	"./master/components/master_home_alert/master_home_alert.css.scss": 803,
	"./master/components/master_home_alert/master_home_alert.html": 1647,
	"./master/components/master_home_alert/master_home_alert.js": 261,
	"./master/components/master_home_report/master_home_report": 262,
	"./master/components/master_home_report/master_home_report.css.scss": 804,
	"./master/components/master_home_report/master_home_report.html": 1648,
	"./master/components/master_home_report/master_home_report.js": 262,
	"./master/directives/label_user_agency.directive.coffee": 1332,
	"./master/directives/label_user_role.directive.coffee": 1333,
	"./master/directives/master_menu_directive.js.coffee": 1334,
	"./master/directives/projects_link_tooltip.coffee": 1335,
	"./master/index.js.coffee": 459,
	"./master/routes.js.coffee": 1336,
	"./master/views/directives/master_menu.html": 1649,
	"./master_api/api/invoice_adjustments.service.js.coffee": 1337,
	"./master_api/api/master_agency.service.js.coffee": 1338,
	"./master_api/api/master_agency_user.service.coffee": 1339,
	"./master_api/api/master_campaign.service.coffee": 1340,
	"./master_api/api/master_campaign_policy_sets.service.js.coffee": 1341,
	"./master_api/api/master_project.service.js.coffee": 1342,
	"./master_api/api/master_user.service.js.coffee": 1343,
	"./master_api/api/particular_event.service.js.coffee": 1344,
	"./master_api/api/segment_cookie.service.coffee": 1345,
	"./master_api/facade/master_access_stats.service.coffee": 1346,
	"./master_api/facade/master_campaign_segment_stats.service.coffee": 1347,
	"./master_api/facade/master_campaign_stats.service.coffee": 1348,
	"./master_api/facade/master_mongo_logistic_regression_coefficients.service": 263,
	"./master_api/facade/master_mongo_logistic_regression_coefficients.service.js": 263,
	"./master_api/facade/master_mongo_session.service.coffee": 1349,
	"./master_api/facade/master_mongo_visitor.service.coffee": 1350,
	"./master_api/facade/master_report_stats.service.coffee": 1351,
	"./master_api/index.coffee": 460,
	"./master_api/zcs_kpi.service.coffee": 1352
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1662;

/***/ }),
/* 1663 */,
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(462);


/***/ })
]),[1664]);


// WEBPACK FOOTER //
// master_admin.bundle.js